(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 38111:
/***/ (function(module) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 81260:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 58527:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 97111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(40742);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 14859:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 25782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(81260);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 78834:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 40742:
/***/ (function(module) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 30957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ CacheProvider; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ ThemeContext; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* reexport */ css_browser_esm; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "withEmotionCache": function() { return /* reexport */ withEmotionCache; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@emotion/sheet/dist/sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



// EXTERNAL MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
var stylis_browser_esm = __webpack_require__(52274);
;// CONCATENATED MODULE: ../../node_modules/@emotion/core/node_modules/@emotion/cache/dist/cache.browser.esm.js




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_browser_esm/* default */.Z(stylisOptions);

  if (false) {}

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) { var map; }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) { var commentEnd, commentStart; }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ var cache_browser_esm = (createCache);

;// CONCATENATED MODULE: ../../node_modules/@emotion/utils/dist/utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

// EXTERNAL MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(31938);
;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/serialize/dist/serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {}

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ../../node_modules/@emotion/core/dist/emotion-element-04d85134.browser.esm.js






var emotion_element_04d85134_browser_esm_hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? cache_browser_esm() : null);
var ThemeContext = /*#__PURE__*/(0,react.createContext)({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/(0,react.createElement)(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/(0,react.forwardRef)(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) { var match, error; }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (false) { var labelFromStack; }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {}



;// CONCATENATED MODULE: ../../node_modules/@emotion/css/dist/css.browser.esm.js


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

/* harmony default export */ var css_browser_esm = (css);

;// CONCATENATED MODULE: ../../node_modules/@emotion/core/dist/core.browser.esm.js











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_04d85134_browser_esm_hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = serializeStyles([styles]);
  return /*#__PURE__*/(0,react.createElement)(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(react.Component);

var keyframes = function keyframes() {
  var insertable = css_browser_esm.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var core_browser_esm_Noop = function Noop() {
  return null;
};

var ClassNames = withEmotionCache(function (props, context) {
  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      {
        insertStyles(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {}

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(core_browser_esm_Noop, null);


    return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
  });
});




/***/ }),

/***/ 1888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);


/***/ }),

/***/ 79977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CacheProvider; },
  "E": function() { return /* binding */ Emotion; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ emotion_element_6a883da9_browser_esm_hasOwnProperty; }
});

// UNUSED EXPORTS: T, _, a, b, u, w

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(9100);
;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



// EXTERNAL MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 3 modules
var emotion_serialize_browser_esm = __webpack_require__(81275);
// EXTERNAL MODULE: ../../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(82668);
;// CONCATENATED MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js









var emotion_element_6a883da9_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = useContext(ThemeContext);
    return /*#__PURE__*/createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(registeredStyles, undefined, (0,react.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_6a883da9_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/(0,react.createElement)(WrappedComponent, newProps));
});

if (false) {}




/***/ }),

/***/ 28165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* unused harmony exports ClassNames, Global, createElement */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9100);
/* harmony import */ var _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79977);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73463);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81275);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82668);












var pkg = {
	name: "@emotion/react",
	version: "11.10.5",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": "./macro.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.10.5",
		"@emotion/cache": "^11.10.5",
		"@emotion/serialize": "^1.1.1",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
		"@emotion/utils": "^1.2.0",
		"@emotion/weak-memoize": "^0.3.0",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.18.5",
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.10.5",
		"@emotion/css-prettifier": "1.1.1",
		"@emotion/server": "11.10.0",
		"@emotion/styled": "11.10.5",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": "./macro.js"
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    // $FlowFixMe
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E;
  createElementArgArray[1] = (0,_emotion_element_6a883da9_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, useContext(ThemeContext));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
})));

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_3__/* .serializeStyles */ .O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));

if (false) {}

if (false) { var globalKey, globalContext, isTestEnv, isBrowser; }




/***/ }),

/***/ 9100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 81275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var emotion_hash_esm = (murmur2);

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var emotion_unitless_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ../../node_modules/@emotion/react/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = emotion_hash_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 52274:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["Z"] = (stylis_min);


/***/ }),

/***/ 31938:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 82668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; }
/* harmony export */ });
/* unused harmony export useInsertionEffectWithLayoutFallback */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback =  useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 83395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$s": function() { return /* binding */ calculateBackoffMillis; },
/* harmony export */   "BH": function() { return /* binding */ Deferred; },
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "L": function() { return /* binding */ base64urlEncodeWithoutPadding; },
/* harmony export */   "LL": function() { return /* binding */ ErrorFactory; },
/* harmony export */   "P0": function() { return /* binding */ getDefaultEmulatorHostnameAndPort; },
/* harmony export */   "Sg": function() { return /* binding */ createMockUserToken; },
/* harmony export */   "ZR": function() { return /* binding */ FirebaseError; },
/* harmony export */   "aH": function() { return /* binding */ getDefaultAppConfig; },
/* harmony export */   "eu": function() { return /* binding */ validateIndexedDBOpenable; },
/* harmony export */   "hl": function() { return /* binding */ isIndexedDBAvailable; },
/* harmony export */   "m9": function() { return /* binding */ getModularInstance; },
/* harmony export */   "vZ": function() { return /* binding */ deepEqual; },
/* harmony export */   "z$": function() { return /* binding */ getUA; }
/* harmony export */ });
/* unused harmony exports CONSTANTS, DecodeBase64StringError, MAX_VALUE_MILLIS, RANDOM_FACTOR, Sha1, areCookiesEnabled, assert, assertionError, async, base64, base64Decode, base64Encode, contains, createSubscribe, decode, deepCopy, deepExtend, errorPrefix, extractQuerystring, getDefaultEmulatorHost, getDefaults, getExperimentalSetting, getGlobal, isAdmin, isBrowser, isBrowserExtension, isCloudflareWorker, isElectron, isEmpty, isIE, isMobileCordova, isNode, isNodeSdk, isReactNative, isUWP, isValidFormat, isValidTimestamp, isWebWorker, issuedAtTime, jsonEval, map, ordinal, promiseWithTimeout, querystring, querystringDecode, safeGet, stringLength, stringToByteArray, stringify, uuidv4, validateArgCount, validateCallback, validateContextObject, validateNamespace */
/* provided dependency */ var process = __webpack_require__(34406);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
const assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
const assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const stringToByteArray$1 = function (str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
const byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while (pos < bytes.length) {
        const c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        const byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        const output = [];
        for (let i = 0; i < input.length; i += 3) {
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            let outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray(input, webSafe) {
        this.init_();
        const charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        const output = [];
        for (let i = 0; i < input.length;) {
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw new DecodeBase64StringError();
            }
            const outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (let i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */
class DecodeBase64StringError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */
const base64Encode = function (str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
const base64urlEncodeWithoutPadding = function (str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
const base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (const prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const getDefaultsFromGlobal = () => getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */
const getDefaultsFromEnvVariable = () => {
    if (typeof process === 'undefined' || typeof process.env === 'undefined') {
        return;
    }
    const defaultsJsonString = process.env.__FIREBASE_DEFAULTS__;
    if (defaultsJsonString) {
        return JSON.parse(defaultsJsonString);
    }
};
const getDefaultsFromCookie = () => {
    if (typeof document === 'undefined') {
        return;
    }
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    }
    catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */
const getDefaults = () => {
    try {
        return (getDefaultsFromGlobal() ||
            getDefaultsFromEnvVariable() ||
            getDefaultsFromCookie());
    }
    catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */
        console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */
const getDefaultEmulatorHost = (productName) => { var _a, _b; return (_b = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName]; };
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */
const getDefaultEmulatorHostnameAndPort = (productName) => {
    const host = getDefaultEmulatorHost(productName);
    if (!host) {
        return undefined;
    }
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) {
        throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    }
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') {
        // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
        return [host.substring(1, separatorIndex - 1), port];
    }
    else {
        return [host.substring(0, separatorIndex), port];
    }
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */
const getDefaultAppConfig = () => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.config; };
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */
const getExperimentalSetting = (name) => { var _a; return (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a[`_${name}`]; };

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Deferred {
    constructor() {
        this.reject = () => { };
        this.resolve = () => { };
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    wrapCallback(callback) {
        return (error, value) => {
            if (error) {
                this.reject(error);
            }
            else {
                this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(() => { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    const payload = Object.assign({ 
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`, aud: project, iat, exp: iat + 3600, auth_time: iat, sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    var _a;
    const forceEnvironment = (_a = getDefaults()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') {
        return true;
    }
    else if (forceEnvironment === 'browser') {
        return false;
    }
    try {
        return (Object.prototype.toString.call(__webpack_require__.g.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */
function isBrowser() {
    return typeof window !== 'undefined' || isWebWorker();
}
/**
 * Detect Web Worker context.
 */
function isWebWorker() {
    return (typeof WorkerGlobalScope !== 'undefined' &&
        typeof self !== 'undefined' &&
        self instanceof WorkerGlobalScope);
}
/**
 * Detect Cloudflare Worker context.
 */
function isCloudflareWorker() {
    return (typeof navigator !== 'undefined' &&
        navigator.userAgent === 'Cloudflare-Workers');
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object'
        ? chrome.runtime
        : typeof browser === 'object'
            ? browser.runtime
            : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return (!isNode() &&
        !!navigator.userAgent &&
        navigator.userAgent.includes('Safari') &&
        !navigator.userAgent.includes('Chrome'));
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    }
    catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise((resolve, reject) => {
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = () => {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = () => {
                preExist = false;
            };
            request.onerror = () => {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        }
        catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(
    /** The error code for this error. */
    code, message, 
    /** Custom data for this error. */
    customData) {
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */
        this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ErrorFactory.prototype.create);
        }
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key) => {
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const decode = function (token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidTimestamp = function (token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const issuedAtTime = function (token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isValidFormat = function (token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
const isAdmin = function (token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys) {
        if (!bKeys.includes(k)) {
            return false;
        }
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) {
                return false;
            }
        }
        else if (aProp !== bProp) {
            return false;
        }
    }
    for (const k of bKeys) {
        if (!aKeys.includes(k)) {
            return false;
        }
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */
function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(() => deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams)) {
        if (Array.isArray(value)) {
            value.forEach(arrayVal => {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(token => {
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
class Sha1 {
    constructor() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (let i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    compress_(buf, offset) {
        if (!offset) {
            offset = 0;
        }
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (let i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (let i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (let i = 16; i < 80; i++) {
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (let i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            const t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */
    digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (let i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for (let i = 0; i < 5; i++) {
            for (let j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    }
}

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    constructor(executor, onNoObservers) {
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(() => {
            executor(this);
        })
            .catch(e => {
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer) => {
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer) => {
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer) => {
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */
    subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error,
                complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(() => {
                try {
                    if (this.finalError) {
                        observer.error(this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    }
    forEachObserver(fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (let i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            if (this.observers !== undefined && this.observers[i] !== undefined) {
                try {
                    fn(this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    }
    close(err) {
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(() => {
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args) => {
        Promise.resolve(true)
            .then(() => {
            fn(...args);
        })
            .catch((error) => {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const method of methods) {
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
const validateArgCount = function (fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        const error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName, 
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
const stringToByteArray = function (str) {
    const out = [];
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
const stringLength = function (str) {
    let p = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */
const uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
const MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return `${i}`;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    const dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    }
    else {
        return service;
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 18672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(8051);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(45982);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {}

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports["default"] = createReactContext;
module.exports = exports['default'];

/***/ }),

/***/ 22241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(18672);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),

/***/ 68718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25049);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return ((0,_node__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
    var global = (obj || getGlobalObject());
    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
//# sourceMappingURL=global.js.map

/***/ }),

/***/ 25049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; }
});

// UNUSED EXPORTS: loadModule

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
//# sourceMappingURL=env.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(34406);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!isBrowserBundle() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}
//# sourceMappingURL=node.js.map

/***/ }),

/***/ 88271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports timestampWithMs, usingPerformanceAPI, _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin */
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68718);
/* harmony import */ var _node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25049);
/* module decorator */ module = __webpack_require__.hmd(module);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0,_global__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        }
        else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();
//# sourceMappingURL=time.js.map

/***/ }),

/***/ 42425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAngleLeftGray(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    viewBox: "0 0 7.554 13.125"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.238 5.839L1.68.291A.983.983 0 00.286 1.675l4.861 4.91-4.861 4.861a.983.983 0 101.394 1.385l5.558-5.548a.982.982 0 000-1.444z",
    fill: "#80868b"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgAngleLeftGray);

/***/ }),

/***/ 27335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCallCtaBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3,
    fill: "#EEF5FE",
    stroke: "#2355FC",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.642 19.376v1.957a1.303 1.303 0 01-1.424 1.305 12.95 12.95 0 01-5.641-2.003 12.731 12.731 0 01-3.922-3.914 12.893 12.893 0 01-2.007-5.656 1.303 1.303 0 011.3-1.422h1.962a1.309 1.309 0 011.307 1.122c.083.626.236 1.241.458 1.833a1.303 1.303 0 01-.295 1.376l-.83.829a10.448 10.448 0 003.922 3.914l.83-.828a1.308 1.308 0 011.38-.294c.593.22 1.209.374 1.836.457a1.308 1.308 0 011.124 1.324z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCallCtaBlue);

/***/ }),

/***/ 66740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGstVerified(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.062 13.355a10.094 10.094 0 01-2.4 3.764 12.548 12.548 0 01-4.692 2.8c-.147.05-.3.077-.456.078h-.017a1.448 1.448 0 01-.472-.08 12.546 12.546 0 01-4.697-2.8 10.075 10.075 0 01-2.395-3.759 21.806 21.806 0 01-.874-7.91v-.035c.009-.194.015-.4.018-.622.01-.535.22-1.046.588-1.43a2.1 2.1 0 011.398-.647A8.143 8.143 0 007.625.355l.008-.01a1.268 1.268 0 011.727 0l.015.011a8.145 8.145 0 005.563 2.36 2.1 2.1 0 011.397.645c.369.385.579.896.589 1.43 0 .227.009.43.018.623v.015a21.841 21.841 0 01-.88 7.926z",
    fill: "#84F2C5"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.062 13.356a10.095 10.095 0 01-2.4 3.764 12.548 12.548 0 01-4.692 2.799c-.146.052-.3.079-.456.081V0c.314.004.616.126.847.34l.012.012a8.145 8.145 0 005.563 2.36 2.1 2.1 0 011.398.645c.368.385.578.896.588 1.43 0 .226.009.43.018.622v.02a21.844 21.844 0 01-.878 7.927z",
    fill: "#1CBB7A"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.25 10.002a5.817 5.817 0 01-1.68 4.085 5.742 5.742 0 01-4.054 1.705h-.02a5.735 5.735 0 01-4.068-1.696 5.81 5.81 0 01-1.685-4.095 5.81 5.81 0 011.685-4.094A5.735 5.735 0 018.496 4.21h.02a5.742 5.742 0 014.053 1.705 5.817 5.817 0 011.68 4.086z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.25 10.002a5.817 5.817 0 01-1.68 4.085 5.742 5.742 0 01-4.054 1.705V4.212a5.742 5.742 0 014.053 1.706 5.817 5.817 0 011.68 4.084z",
    fill: "#E0E9FF"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.46 8.99l-2.928 2.948-.632.637a.763.763 0 01-1.083 0l-1.36-1.37a.774.774 0 01.545-1.301c.2-.003.392.073.537.212l.82.825 3.02-3.04a.763.763 0 011.293.549.773.773 0 01-.21.54h-.002z",
    fill: "#1CBB7A"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgGstVerified);

/***/ }),

/***/ 95825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGreenBackgroundSolidWhiteTick(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14A7 7 0 107 0a7 7 0 000 14z",
    fill: "#0EA546"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9.455 4.764a.906.906 0 011.28 0 .903.903 0 010 1.279L7.037 9.735a.906.906 0 01-1.28 0L3.764 7.747a.903.903 0 010-1.278.906.906 0 011.28 0l1.352 1.349 3.058-3.054z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgGreenBackgroundSolidWhiteTick);

/***/ }),

/***/ 49749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMarketplaceNavActiveIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.901 5.892l-1.05-4.372c-.22-.9-1-1.52-1.91-1.52H3.045c-.9 0-1.69.63-1.901 1.52L.095 5.892c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29v6.943c0 1.1.9 2 2 2H17c1.1 0 2-.9 2-2V9.063c.09-.09.2-.18.28-.28.641-.82.871-1.87.621-2.891zm-2.99-3.901l1.05 4.371c.1.42.01.84-.25 1.17-.14.18-.44.47-.941.47-.61 0-1.14-.49-1.21-1.14l-.58-4.861 1.93-.01zM10.997 2h1.96l.541 4.521c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V2.001zM6.487 6.522l.55-4.521h1.96v4.691c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.452-.16l1.01-4.361h1.971l-.58 4.861c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgMarketplaceNavActiveIcon);

/***/ }),

/***/ 58463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMarketplaceNavDeadIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.901 5.892l-1.05-4.372c-.22-.9-1-1.52-1.91-1.52H3.045c-.9 0-1.69.63-1.901 1.52L.095 5.892c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29v6.943c0 1.1.9 2 2 2H17c1.1 0 2-.9 2-2V9.063c.09-.09.2-.18.28-.28.641-.82.871-1.87.621-2.891zm-2.99-3.901l1.05 4.371c.1.42.01.84-.25 1.17-.14.18-.44.47-.941.47-.61 0-1.14-.49-1.21-1.14l-.58-4.861 1.93-.01zM10.997 2h1.96l.541 4.521c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V2.001zM6.487 6.522l.55-4.521h1.96v4.691c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.452-.16l1.01-4.361h1.971l-.58 4.861c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17z",
    fill: "#AFC5FF"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgMarketplaceNavDeadIcon);

/***/ }),

/***/ 67843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMinus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 1.75,
    viewBox: "0 0 14 1.75"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.125 0H.875a.875.875 0 000 1.75h12.25a.875.875 0 000-1.75z",
    fill: "#08123b",
    opacity: 0.3
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgMinus);

/***/ }),

/***/ 98703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPlaystoreBadge(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 202.5 60"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__a",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__b",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__c",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "PlaystoreBadge_svg__d",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M195 60H7.5A7.427 7.427 0 010 52.5v-45A7.427 7.427 0 017.5 0H195a7.427 7.427 0 017.5 7.5v45A7.427 7.427 0 01195 60z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M195 1.2a6.338 6.338 0 016.3 6.3v45a6.338 6.338 0 01-6.3 6.3H7.5a6.338 6.338 0 01-6.3-6.3v-45a6.338 6.338 0 016.3-6.3zm0-1.2H7.5A7.522 7.522 0 000 7.5v45A7.427 7.427 0 007.5 60H195a7.427 7.427 0 007.5-7.5v-45A7.522 7.522 0 00195 0z",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M71.1 15.3a4.086 4.086 0 01-1.05 3 4.708 4.708 0 01-6.6 0A4.41 4.41 0 0162.1 15a4.41 4.41 0 011.35-3.3 4.41 4.41 0 013.3-1.35 3.994 3.994 0 011.8.45 3.266 3.266 0 011.35 1.05l-.75.75a2.8 2.8 0 00-2.4-1.05 2.985 2.985 0 00-2.4 1.05 3.09 3.09 0 00-1.05 2.55 3.09 3.09 0 001.05 2.55 3.862 3.862 0 002.4 1.05 3.29 3.29 0 002.55-1.05 2.484 2.484 0 00.75-1.8h-3.3v-1.2h4.35zm6.9-3.75h-4.05v2.85h3.75v1.05h-3.75v2.85H78v1.2h-5.25v-9H78zm4.95 7.95h-1.2v-7.95H79.2V10.5h6.3v1.05h-2.55zm6.9 0v-9h1.2v9zm6.3 0h-1.2v-7.95H92.4V10.5h6.15v1.05H96v7.95zm14.25-1.2a4.708 4.708 0 01-6.6 0 4.41 4.41 0 01-1.35-3.3 4.41 4.41 0 011.35-3.3 4.708 4.708 0 016.6 0 4.41 4.41 0 011.35 3.3 4.41 4.41 0 01-1.35 3.3zm-5.7-.75a3.54 3.54 0 002.4 1.05 2.985 2.985 0 002.4-1.05 3.619 3.619 0 001.05-2.55 3.09 3.09 0 00-1.05-2.55 3.54 3.54 0 00-2.4-1.05 2.985 2.985 0 00-2.4 1.05 3.619 3.619 0 00-1.05 2.55 3.09 3.09 0 001.05 2.55zm8.7 1.95v-9h1.35l4.35 7.05V10.5h1.2v9h-1.2l-4.65-7.35v7.35z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M102.15 32.7a6.311 6.311 0 00-6.45 6.45 6.4 6.4 0 006.45 6.45 6.311 6.311 0 006.45-6.45 6.223 6.223 0 00-6.45-6.45zm0 10.2a3.723 3.723 0 01-3.6-3.9 3.723 3.723 0 013.6-3.9 3.634 3.634 0 013.6 3.9 3.723 3.723 0 01-3.6 3.9zM88.2 32.7a6.311 6.311 0 00-6.45 6.45 6.4 6.4 0 006.45 6.45 6.311 6.311 0 006.45-6.45 6.223 6.223 0 00-6.45-6.45zm0 10.2a3.723 3.723 0 01-3.6-3.9 3.723 3.723 0 013.6-3.9 3.634 3.634 0 013.6 3.9 3.723 3.723 0 01-3.6 3.9zm-16.65-8.25v2.7H78a5.672 5.672 0 01-1.5 3.45 6.639 6.639 0 01-4.95 1.95 6.984 6.984 0 01-7.05-7.2 7.076 7.076 0 017.05-7.2 7.437 7.437 0 014.95 1.95l1.95-1.95a9.612 9.612 0 00-6.75-2.7 10.119 10.119 0 00-10.05 9.9 10.119 10.119 0 0010.05 9.9 8.632 8.632 0 006.9-2.85 9.03 9.03 0 002.4-6.3 5.625 5.625 0 00-.15-1.65zm68.1 2.1a5.828 5.828 0 00-5.4-4.05c-3.3 0-6 2.55-6 6.45a6.277 6.277 0 006.3 6.45 6.153 6.153 0 005.25-2.85l-2.1-1.5a3.656 3.656 0 01-3.15 1.8 3.254 3.254 0 01-3.15-1.95l8.55-3.6zm-8.7 2.1a3.644 3.644 0 013.3-3.75 2.653 2.653 0 012.4 1.35zM123.9 45h2.85V26.25h-2.85zm-4.5-10.95a4.939 4.939 0 00-3.45-1.5A6.445 6.445 0 00109.8 39a6.211 6.211 0 006.15 6.3 4.307 4.307 0 003.3-1.5h.15v.9c0 2.4-1.35 3.75-3.45 3.75a3.333 3.333 0 01-3.15-2.25l-2.4 1.05a6.188 6.188 0 005.7 3.75c3.3 0 6-1.95 6-6.6V33h-2.7zm-3.3 8.85a3.723 3.723 0 01-3.6-3.9 3.723 3.723 0 013.6-3.9 3.609 3.609 0 013.45 3.9 3.609 3.609 0 01-3.45 3.9zm36.6-16.65h-6.75V45h2.85v-7.05h3.9a5.857 5.857 0 100-11.7zm.15 9h-4.05V28.8h4.05a3.3 3.3 0 013.3 3.15 3.433 3.433 0 01-3.3 3.3zm17.25-2.7c-2.1 0-4.2.9-4.95 2.85l2.55 1.05a2.65 2.65 0 012.55-1.35 2.819 2.819 0 013 2.4v.15a5.95 5.95 0 00-2.85-.75c-2.7 0-5.4 1.5-5.4 4.2a4.394 4.394 0 004.65 4.2 4.221 4.221 0 003.6-1.8h.15V45h2.7v-7.2a5.677 5.677 0 00-6-5.25zm-.3 10.35c-.9 0-2.25-.45-2.25-1.65 0-1.5 1.65-1.95 3-1.95a5.8 5.8 0 012.55.6 3.493 3.493 0 01-3.3 3zm15.75-9.9l-3.15 8.1h-.15l-3.3-8.1h-3l4.95 11.4-2.85 6.3h2.85l7.65-17.7zm-25.2 12h2.85V26.25h-2.85z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10.6 7.5a2.933 2.933 0 00-.6 2.1v33.15a2.967 2.967 0 00.75 2.1l.15.15 18.6-18.6v-.3z",
    transform: "translate(5 3.75)",
    fill: "url(#PlaystoreBadge_svg__a)"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M29.05 28.55L22.9 22.4v-.45l6.15-6.15.15.15 7.35 4.2c2.1 1.2 2.1 3.15 0 4.35z",
    transform: "translate(11.45 7.9)",
    fill: "url(#PlaystoreBadge_svg__b)"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M35.45 26.3l-6.3-6.3L10.4 38.75c.75.75 1.8.75 3.15.15z",
    transform: "translate(5.2 10)",
    fill: "url(#PlaystoreBadge_svg__c)"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M35.45 20.114l-21.9-12.45c-1.35-.75-2.4-.6-3.15.15l18.75 18.6z",
    transform: "translate(5.2 3.586)",
    fill: "url(#PlaystoreBadge_svg__d)"
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M40.5 36.15l-21.75 12.3a2.453 2.453 0 01-3 0l-.15.15.15.15a2.453 2.453 0 003 0z",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.6 48.45a2.933 2.933 0 01-.6-2.1v.15a2.967 2.967 0 00.75 2.1v-.15zM48 31.95l-7.5 4.2.15.15L48 32.1a2.493 2.493 0 001.5-2.1c0 .75-.6 1.35-1.5 1.95z",
    opacity: 0.12
  })), _path11 || (_path11 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.75 11.4L48 28.05c.9.6 1.5 1.2 1.5 1.95a2.493 2.493 0 00-1.5-2.1L18.75 11.25c-2.1-1.2-3.75-.3-3.75 2.1v.15c0-2.25 1.65-3.3 3.75-2.1z",
    opacity: 0.25,
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgPlaystoreBadge);

/***/ }),

/***/ 57692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPlus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#Plus_svg__clip0)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.125 6.125h-5.25V.875a.875.875 0 00-1.75 0v5.25H.875a.875.875 0 000 1.75h5.25v5.25a.875.875 0 101.75 0v-5.25h5.25a.875.875 0 100-1.75z",
    fill: "#D1D1D1",
    stroke: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "Plus_svg__clip0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgPlus);

/***/ }),

/***/ 38772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVahakLogoLightBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 111,
    height: 43,
    viewBox: "0 0 111 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.634 17.952a7.108 7.108 0 01-.703 3.302c-.146.221-.306.433-.478.637.186-.033.366-.09.535-.167.433-.26.769-.64.961-1.086.193-.446.233-.938.115-1.406a4.367 4.367 0 00-.432-1.28h.002zm12.939-3.124h-.864c.35 1.291.954 2.51 1.782 3.593.633.92 1.296 1.818 1.863 2.774a16.475 16.475 0 012.354 6.707 8.386 8.386 0 01-1.273 5.412c-1.032 1.63-2.597 2.907-4.464 3.643-2.459 1.105-4.681 1.642-6.619 2.968A11.437 11.437 0 0018.455 43c.207-4.287 4.61-5.182 8.104-6.774 4.014-1.833 5.763-4.808 5.269-8.741-.578-3.405-2.042-5.675-3.75-8.31a20.258 20.258 0 01-2.109-3.737 6.925 6.925 0 01-.441-2.11 28.744 28.744 0 00-15.411 0 6.976 6.976 0 01-.442 2.11 20.641 20.641 0 01-2.108 3.737c-1.712 2.63-3.176 4.906-3.75 8.31-.496 3.932 1.255 6.908 5.268 8.74 3.491 1.593 7.899 2.488 8.103 6.775a11.456 11.456 0 00-2.895-3.075c-1.943-1.327-4.17-1.869-6.624-2.968-1.867-.736-3.432-2.013-4.464-3.643a8.388 8.388 0 01-1.273-5.412 16.61 16.61 0 012.353-6.707c.567-.956 1.229-1.858 1.864-2.774a10.356 10.356 0 001.783-3.593h-.86a10.22 10.22 0 01-1.291 2.541C3.62 20.665 1.14 23.54.961 27.663c-.014.935.05 1.869.191 2.794A5.5 5.5 0 01.076 27.83a8.249 8.249 0 01.212-3.28c.647-2.506 2.161-4.66 3.458-6.883a9.325 9.325 0 001.44-3.32 1.698 1.698 0 00-.213-1.113 1.876 1.876 0 00-.88-.774c.335-.206.72-.33 1.12-.36.277-.015.554.03.81.133.254.102.48.259.66.457a29.447 29.447 0 00-.806-3.538 24.593 24.593 0 00-.907-2.607 29.317 29.317 0 00-.591-1.382h-.154a1.383 1.383 0 01-.957-.299 1.212 1.212 0 01-.453-.843c.048-.318.218-.61.478-.82.26-.21.593-.325.936-.324.344 0 .676.118.935.33.259.21.427.503.474.821-.006.19-.063.375-.167.537-.104.163-.251.298-.427.392A24.791 24.791 0 008.841 8.88a3.754 3.754 0 001.793-1.546 3.394 3.394 0 00.436-2.244 1.356 1.356 0 01-.88-.333 1.192 1.192 0 01-.406-.802c.049-.318.219-.61.479-.82.26-.21.592-.325.936-.325.344.001.676.118.935.33.258.212.427.504.473.822-.017.27-.131.527-.324.728a1.305 1.305 0 01-.74.38c.793 1.184 2.02 2.058 3.45 2.457a6.473 6.473 0 01-1.342 1.759 17.29 17.29 0 00-3.606 1.173c-.61.02-1.221-.036-1.816-.165a1.424 1.424 0 00-.415-.07c.38.578.676 1.2.883 1.849 4.558-1.725 13.679-1.716 18.268.013.2-.653.482-1.281.84-1.872a1.43 1.43 0 00-.414.07 7.446 7.446 0 01-1.816.165 17.268 17.268 0 00-3.616-1.163 6.468 6.468 0 01-1.343-1.766c1.435-.4 2.664-1.277 3.457-2.465a1.295 1.295 0 01-.742-.378 1.147 1.147 0 01-.323-.73c.05-.318.22-.608.48-.818.26-.21.592-.325.936-.324.343 0 .674.118.933.329.259.21.428.502.475.82a1.193 1.193 0 01-.407.802c-.238.21-.552.329-.88.333-.118.773.035 1.56.437 2.244a3.755 3.755 0 001.792 1.546 26.325 26.325 0 003.82-3.92 1.146 1.146 0 01-.428-.392 1.05 1.05 0 01-.167-.538c.049-.318.219-.61.479-.82.26-.21.592-.325.936-.324.344 0 .675.118.934.33.259.211.427.503.474.822a1.211 1.211 0 01-.452.848c-.264.215-.61.324-.96.301h-.161c-.146.319-.36.802-.591 1.382a25.303 25.303 0 00-.893 2.607 31.966 31.966 0 00-.905 3.633c.175-.236.411-.426.687-.552a1.9 1.9 0 01.887-.17c.4.03.785.153 1.12.36a1.874 1.874 0 00-.88.773c-.197.34-.272.73-.213 1.113a9.272 9.272 0 001.44 3.32c1.298 2.223 2.81 4.377 3.46 6.883a8.277 8.277 0 01.211 3.281 5.519 5.519 0 01-1.075 2.625c.141-.925.206-1.859.193-2.793-.181-4.128-2.662-6.998-4.821-10.294a10.25 10.25 0 01-1.292-2.542l-.004.017zM18.145 2.298c.29-.047.553-.185.749-.39.195-.205.31-.466.327-.74a1.344 1.344 0 00-.49-.836A1.521 1.521 0 0017.776 0c-.35 0-.69.118-.955.332-.266.215-.44.512-.49.836a1.2 1.2 0 00.352.766c.208.21.487.345.79.384a15.447 15.447 0 01-3.039 6.76l-.01.025h6.772l-.01-.025a15.445 15.445 0 01-3.04-6.777v-.003zm4.366 29.112c-1.057 1.725-1.963 1.473-2.88 1.09a4.144 4.144 0 00-1.797-.416 4.148 4.148 0 00-1.801.4c-.931.391-1.845.682-2.92-1.075-.197.253-.294.56-.275.872.018.312.151.608.376.839 1.271.999 3.476 1.262 4.393 3.302.044.484.367.484.412 0 .922-2.038 3.123-2.3 4.391-3.302.226-.23.359-.527.377-.839a1.293 1.293 0 00-.275-.872l-.001.001zm-7.82-14.447a6.263 6.263 0 01-.712 4.23c-.461.673-.981 1.304-1.448 1.924-1.816 2.413-1.73 4.874-.38 6.612a8.804 8.804 0 013.166-1.87c.5-.194 1.013-.357 1.537-.488.391-1.26-.999-3.256-1.998-3.65a6.808 6.808 0 00-1.346-.299s.066-.238 1.016-.862a2.415 2.415 0 012.122-.095c.356.127.732.2 1.112.214h.099c.38-.012.756-.085 1.11-.214a2.442 2.442 0 012.124.095c.95.619 1.016.862 1.016.862-.459.054-.91.155-1.346.3-1.006.392-2.396 2.388-1.998 3.65.525.127 1.04.29 1.54.486a8.959 8.959 0 013.166 1.869c1.35-1.738 1.435-4.199-.38-6.612-.461-.62-.982-1.25-1.448-1.923a6.255 6.255 0 01-.711-4.231 11.434 11.434 0 013.401-.358c.394 0 .782.084 1.136.246.353.163.662.4.903.69 0 0-1.146.096-1.463.575-.317.48-.552.381-.922.381-2.842 0-1.169-.619-2.343-1.15-.032.54-.005 1.08.078 1.615a9.064 9.064 0 002.357 3.993c2.201 2.63 3.278 7.062-.251 9.366-1.374-1.857-3.523-3.818-5.943-3.84h-.153c-2.42.02-4.569 1.983-5.943 3.84-3.53-2.3-2.46-6.735-.252-9.366a9.057 9.057 0 002.359-3.993 7.833 7.833 0 00.078-1.614c-1.177.536.497 1.15-2.345 1.15-.368 0-.606.094-.922-.381-.317-.476-1.463-.575-1.463-.575.241-.293.55-.53.905-.692a2.73 2.73 0 011.139-.248 11.408 11.408 0 013.402.358v.005zm-5.343 8.41c-.73 2.42-1.435 5.031 2.196 7.619.22.155.476.319.758.482a31.199 31.199 0 013.31 1.74 3.811 3.811 0 011.39 1.588c.296.64.395 1.345.286 2.035a2.525 2.525 0 00-.281-.634 7.87 7.87 0 00-2.42-2.558 33.956 33.956 0 00-3.035-1.438c-3.398-1.65-4.927-4.273-3.885-7.976.705-2.505 1.506-3.967.028-6.294 2.92.654 2.228 3.534 1.655 5.449l-.002-.012zm-1.984-4.496s.042.113.085.277c.16.67.172 1.362.034 2.035-.29 1.562-1.037 2.96-1.184 4.571a6.42 6.42 0 001.141 4.626 8.414 8.414 0 002.655 2.156c1.065.56 2.198.951 3.296 1.506 1.75.886 4.066 2.477 3.88 4.644-.864-1.444-2.17-2.612-3.751-3.355-1.247-.655-2.717-1.197-4.057-1.833a8.165 8.165 0 01-2.772-1.91 7.528 7.528 0 01-1.684-2.81 9.517 9.517 0 01.36-5.428 18.632 18.632 0 012.006-4.48h-.009zm8.928-6.734c-.87-.334-1.83-.4-2.743-.19.406.099.802.226 1.187.38.674.319 1.289.737 1.82 1.239.369.252.813.389 1.27.389.456 0 .9-.137 1.268-.39a6.879 6.879 0 011.82-1.237c.384-.155.78-.282 1.185-.381a4.75 4.75 0 00-2.742.19c-.2.19-.437.343-.7.446a2.263 2.263 0 01-1.66 0 2.145 2.145 0 01-.7-.446h-.005zm9.994 11.234c.73 2.418 1.434 5.03-2.198 7.618-.22.155-.476.319-.756.482a30.887 30.887 0 00-3.31 1.74 3.815 3.815 0 00-1.389 1.588 3.529 3.529 0 00-.288 2.035c.064-.222.159-.435.282-.634a7.809 7.809 0 012.42-2.565 34.315 34.315 0 013.034-1.438c3.398-1.65 4.928-4.273 3.885-7.976-.705-2.505-1.505-3.968-.027-6.294-2.929.654-2.228 3.534-1.654 5.449v-.005zm1.996-4.504s-.041.113-.084.277a4.735 4.735 0 00-.035 2.035c.29 1.562 1.037 2.96 1.185 4.571a6.42 6.42 0 01-1.14 4.626 8.43 8.43 0 01-2.656 2.156c-1.067.559-2.197.951-3.295 1.506-1.752.886-4.068 2.477-3.88 4.644.864-1.444 2.17-2.613 3.75-3.355 1.247-.655 2.719-1.197 4.06-1.833a8.169 8.169 0 002.771-1.91 7.53 7.53 0 001.685-2.81 9.53 9.53 0 00-.36-5.428 18.636 18.636 0 00-2.008-4.48h.008zm-8.281-2.92c-.21.405-.356.837-.43 1.281-.117.468-.077.96.116 1.405.192.446.527.826.96 1.087.169.078.349.134.534.167a6.666 6.666 0 01-.48-.637 7.168 7.168 0 01-.704-3.302",
    fill: "#becdf7"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M58.214 16.667l-7.584 16.8h-2.064l-7.992-16.8h3.144l5.904 12.6 5.52-12.6h3.072zm.777 7.896l-1.344-2.016c.592-.576 1.352-1.024 2.28-1.344a8.738 8.738 0 012.952-.504c1.632 0 2.888.448 3.768 1.344.896.896 1.344 2.16 1.344 3.792v7.632h-2.736v-1.368c-.912 1.008-2.2 1.512-3.864 1.512-1.376 0-2.48-.352-3.312-1.056-.816-.72-1.224-1.68-1.224-2.88 0-1.328.528-2.32 1.584-2.976 1.072-.656 2.488-.984 4.248-.984 1.04 0 1.896.112 2.568.336.016-.944-.184-1.648-.6-2.112-.416-.464-1.112-.696-2.088-.696-1.232 0-2.424.44-3.576 1.32zm3 6.672c1.424 0 2.512-.568 3.264-1.704v-1.2c-.672-.224-1.432-.336-2.28-.336-2.192 0-3.288.552-3.288 1.656 0 .496.208.888.624 1.176.416.272.976.408 1.68.408zm8.476 2.232v-17.52h2.736v6.12c.896-.896 2.104-1.344 3.624-1.344 3.456 0 5.184 1.904 5.184 5.712v7.032h-2.736v-6.864c0-1.168-.248-2.016-.744-2.544-.48-.528-1.24-.792-2.28-.792-.656 0-1.256.184-1.8.552-.528.368-.944.872-1.248 1.512v8.136h-2.736zm15.36-8.904l-1.344-2.016c.592-.576 1.352-1.024 2.28-1.344a8.738 8.738 0 012.952-.504c1.632 0 2.888.448 3.768 1.344.896.896 1.344 2.16 1.344 3.792v7.632H92.09v-1.368c-.912 1.008-2.2 1.512-3.864 1.512-1.376 0-2.48-.352-3.312-1.056-.816-.72-1.224-1.68-1.224-2.88 0-1.328.528-2.32 1.584-2.976 1.072-.656 2.488-.984 4.248-.984 1.04 0 1.896.112 2.568.336.016-.944-.184-1.648-.6-2.112-.416-.464-1.112-.696-2.088-.696-1.232 0-2.424.44-3.576 1.32zm3 6.672c1.424 0 2.512-.568 3.264-1.704v-1.2c-.672-.224-1.432-.336-2.28-.336-2.192 0-3.288.552-3.288 1.656 0 .496.208.888.624 1.176.416.272.976.408 1.68.408zm8.476 2.232v-17.52h2.736v9.96l5.04-4.92h3.528l-5.688 5.496 5.976 6.984h-3.48l-4.584-5.184-.792.624v4.56h-2.736z",
    fill: "#becdf7"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgVahakLogoLightBlue);

/***/ }),

/***/ 4269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVahakMember(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9 18.5a9 9 0 100-18 9 9 0 000 18z",
    fill: "#223D8D"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M9 .5c4.963 0 9 4.037 9 9s-4.037 9-9 9V.5z",
    fill: "#223D8D"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.77 13.975H5.23a.704.704 0 01-.684-.533L3.038 7.408a.704.704 0 01.998-.8l2.433 1.216 1.927-3.211a.704.704 0 011.208 0l1.927 3.211 2.433-1.216a.704.704 0 01.998.8l-1.508 6.034a.704.704 0 01-.683.533z",
    fill: "#FFD71B"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.77 13.975c.324 0 .606-.22.684-.533l1.508-6.034a.704.704 0 00-.998-.8l-2.433 1.216-1.927-3.211A.704.704 0 009 4.27v9.704h3.77z",
    fill: "#D4AF37"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgVahakMember);

/***/ }),

/***/ 72020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCallCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#fff",
    stroke: "#2355FC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M26.5 23.233v1.957a1.304 1.304 0 01-1.425 1.305 12.95 12.95 0 01-5.641-2.003 12.733 12.733 0 01-3.922-3.914 12.894 12.894 0 01-2.007-5.656 1.304 1.304 0 011.301-1.422h1.961a1.308 1.308 0 011.307 1.122c.083.626.236 1.241.458 1.833a1.303 1.303 0 01-.294 1.377l-.83.828a10.447 10.447 0 003.921 3.914l.83-.828a1.307 1.307 0 011.38-.294c.593.221 1.209.374 1.836.457a1.308 1.308 0 011.125 1.324z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCallCircle);

/***/ }),

/***/ 49853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCloseGrey(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28.222 26.792l-4.667-4.667 4.667-4.667a1.1 1.1 0 10-1.555-1.556L22 20.57l-4.667-4.667a1.1 1.1 0 10-1.556 1.556l4.667 4.667-4.667 4.667a1.1 1.1 0 101.556 1.555L22 23.68l4.667 4.667a1.1 1.1 0 101.555-1.555z",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 0.6
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCloseGrey);

/***/ }),

/***/ 54171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCloseOdc(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 0a10 10 0 1010 10A10.011 10.011 0 0010 0zm4.045 12.866a.417.417 0 010 .589l-.589.589a.417.417 0 01-.589 0L10 11.178l-2.866 2.867a.417.417 0 01-.589 0l-.589-.589a.417.417 0 010-.589L8.822 10 5.955 7.134a.417.417 0 010-.589l.589-.589a.417.417 0 01.589 0L10 8.822l2.866-2.866a.417.417 0 01.589 0l.589.589a.417.417 0 010 .589L11.178 10z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCloseOdc);

/***/ }),

/***/ 77000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCross(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.59 7.368c.512-.506.55-1.367.084-1.923-.465-.556-1.257-.597-1.768-.091L15 13.164l-7.905-7.81c-.512-.506-1.304-.465-1.77.091-.465.556-.427 1.417.085 1.923L13.136 15 5.41 22.633c-.512.505-.55 1.366-.084 1.922.465.556 1.257.597 1.769.091L15 16.836l7.905 7.81c.512.506 1.304.465 1.77-.091.465-.556.427-1.417-.085-1.922L16.864 15l7.726-7.632z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M24.674 5.445l.384-.32-.384.32zm-.084 1.923l.352.355-.352-.355zm-1.684-2.014l-.352-.356.352.356zM15 13.164l-.351.355a.5.5 0 00.702 0L15 13.163zm-7.905-7.81l.35-.356-.35.356zm-1.77.091l-.383-.32.384.32zm.085 1.923l-.351.355.35-.355zM13.136 15l.352.356a.5.5 0 000-.712l-.352.356zM5.41 22.633l.351.355-.351-.355zm-.084 1.922l-.384.32.384-.32zm1.769.091l-.352-.356.352.356zM15 16.836l.351-.355a.5.5 0 00-.702 0l.351.356zm7.905 7.81l-.35.356.35-.356zm1.77-.091l.383.32-.384-.32zm-.085-1.922l.352-.356-.352.355zM16.864 15l-.352-.356a.5.5 0 000 .712l.352-.356zm7.427-9.234c.3.36.272.925-.052 1.246l.703.711c.699-.69.746-1.845.116-2.598l-.767.641zm-1.034-.056c.3-.297.754-.279 1.034.056l.767-.641a1.683 1.683 0 00-2.504-.127l.703.712zm-7.906 7.809l7.906-7.81-.703-.71-7.905 7.809.702.711zm0-.711l-7.905-7.81-.703.712 7.906 7.809.702-.711zm-7.905-7.81a1.683 1.683 0 00-2.504.127l.767.641c.28-.335.733-.353 1.034-.056l.703-.712zm-2.504.127c-.63.753-.583 1.908.117 2.598l.702-.711a.945.945 0 01-.052-1.246l-.767-.641zm.117 2.598l7.726 7.633.703-.712L5.76 7.012l-.702.711zm7.726 6.921l-7.726 7.633.702.711 7.727-7.632-.703-.712zm-7.726 7.633c-.7.69-.747 1.845-.117 2.598l.767-.641a.945.945 0 01.052-1.246l-.702-.711zm-.117 2.598c.65.777 1.781.84 2.504.127l-.703-.712c-.3.297-.754.279-1.034-.056l-.767.641zm2.504.127l7.905-7.81-.702-.711-7.906 7.81.703.71zm15.81-.712l-7.905-7.809-.702.711 7.905 7.81.703-.712zm1.035-.056c-.28.335-.733.353-1.034.056l-.703.712c.723.714 1.854.65 2.504-.127l-.767-.641zm-.052-1.246c.324.32.352.887.052 1.246l.767.641c.63-.753.583-1.908-.116-2.598l-.703.711zm-7.727-7.632l7.727 7.632.703-.711-7.727-7.633-.703.712zm7.727-8.344l-7.727 7.632.703.712 7.727-7.633-.703-.711z",
    fill: "#515151"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgCross);

/***/ }),

/***/ 2602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgHomeIconDisabled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.982 8.348a3.607 3.607 0 01-.296 1.539 3.242 3.242 0 01-.201.295.86.86 0 00.225-.077c.182-.122.323-.299.404-.507.08-.208.097-.436.046-.654a2.184 2.184 0 00-.181-.596h.003zm5.44-1.453h-.363c.147.6.402 1.168.75 1.671.266.428.545.846.784 1.29.535.959.872 2.02.99 3.12.176 1.872-.775 3.397-2.412 4.213-1.035.513-1.97.763-2.785 1.38-.488.395-.901.88-1.22 1.43.088-1.994 1.94-2.41 3.41-3.151 1.69-.85 2.425-2.235 2.217-4.065-.242-1.584-.859-2.643-1.577-3.865a9.751 9.751 0 01-.887-1.739 3.515 3.515 0 01-.186-.982 10.978 10.978 0 00-6.483 0 3.535 3.535 0 01-.186.982 9.923 9.923 0 01-.887 1.74c-.723 1.224-1.34 2.28-1.581 3.864-.209 1.83.528 3.213 2.216 4.066 1.47.74 3.323 1.156 3.409 3.151a5.14 5.14 0 00-1.218-1.43c-.817-.618-1.755-.87-2.784-1.38-1.636-.817-2.592-2.342-2.413-4.213a8.27 8.27 0 01.99-3.12c.238-.444.517-.864.784-1.29.348-.504.603-1.07.75-1.671h-.362c-.13.418-.313.816-.545 1.184-.909 1.532-1.952 2.868-2.03 4.787-.005.435.022.869.082 1.3a2.71 2.71 0 01-.453-1.222 4.24 4.24 0 01.089-1.525c.27-1.165.909-2.168 1.454-3.2.293-.472.499-.996.606-1.545a.861.861 0 00-.09-.517.82.82 0 00-.37-.36.98.98 0 01.473-.166.728.728 0 01.619.274 14.812 14.812 0 00-.34-1.646 12.242 12.242 0 00-.378-1.213 13.992 13.992 0 00-.249-.643h-.065a.545.545 0 01-.402-.14.583.583 0 01-.19-.394.626.626 0 01.201-.38.588.588 0 01.787.001c.109.099.18.235.2.383a.528.528 0 01-.25.432 11.112 11.112 0 001.597 1.823c.32-.148.585-.4.754-.718a1.72 1.72 0 00.184-1.042.54.54 0 01-.37-.155.577.577 0 01-.172-.373.626.626 0 01.201-.382.588.588 0 01.787.003c.11.098.18.234.2.382a.566.566 0 01-.137.339.533.533 0 01-.31.177c.332.55.848.957 1.45 1.142a2.993 2.993 0 01-.565.821c-.525.12-1.035.3-1.52.541a2.846 2.846 0 01-.764-.077.54.54 0 00-.174-.031c.16.268.284.557.37.86 1.918-.803 5.755-.8 7.687.005.086-.304.207-.595.36-.87a.54.54 0 00-.174.033c-.25.06-.508.086-.765.077a6.794 6.794 0 00-1.52-.544 3.001 3.001 0 01-.566-.821 2.601 2.601 0 001.452-1.143.53.53 0 01-.311-.174.562.562 0 01-.137-.338.627.627 0 01.201-.382.588.588 0 01.788.002c.108.098.18.234.2.383a.578.578 0 01-.172.373.541.541 0 01-.37.154c-.05.36.014.726.183 1.044.169.318.433.57.754.72a11.764 11.764 0 001.606-1.824.504.504 0 01-.18-.182.528.528 0 01-.07-.25.626.626 0 01.201-.381.588.588 0 01.787.002c.109.098.18.234.2.382a.584.584 0 01-.19.394.545.545 0 01-.404.14h-.068c-.062.149-.152.374-.25.643-.144.398-.27.802-.375 1.213-.157.556-.284 1.12-.38 1.69a.763.763 0 01.288-.257.734.734 0 01.373-.079c.168.014.33.072.472.168a.819.819 0 00-.37.36.86.86 0 00-.09.517c.107.55.312 1.074.606 1.545.546 1.033 1.182 2.035 1.455 3.2.122.499.152 1.017.09 1.527-.051.44-.207.859-.453 1.22.06-.43.087-.864.081-1.299-.077-1.92-1.12-3.255-2.027-4.788a4.944 4.944 0 01-.544-1.182l-.004.001zM8.04 1.068a.543.543 0 00.313-.18.576.576 0 00.138-.343.642.642 0 00-.205-.39.603.603 0 00-.805 0 .642.642 0 00-.206.39c.008.133.06.26.148.357a.551.551 0 00.333.179 7.57 7.57 0 01-1.279 3.143l-.004.012H9.32l-.004-.012a7.574 7.574 0 01-1.28-3.155l.002-.001zm1.835 13.543c-.445.803-.825.686-1.212.508a1.607 1.607 0 00-1.514-.008c-.391.182-.775.318-1.228-.5a.646.646 0 00.042.797c.535.464 1.463.587 1.849 1.535.018.226.155.226.173 0 .387-.948 1.315-1.07 1.848-1.535a.641.641 0 00.042-.796zm-3.29-6.718a3.181 3.181 0 01-.3 1.968c-.193.313-.412.606-.608.894-.765 1.123-.728 2.268-.161 3.076a3.64 3.64 0 011.333-.87c.21-.09.426-.165.646-.226.165-.586-.42-1.515-.84-1.697a2.588 2.588 0 00-.567-.14s.028-.11.426-.4a.937.937 0 01.892-.044c.15.06.308.093.468.1h.041c.16-.006.319-.04.468-.1a.94.94 0 01.893.044c.4.288.426.4.426.4a2.598 2.598 0 00-.567.14c-.423.182-1.007 1.11-.84 1.697.22.06.436.136.646.227.5.188.954.485 1.333.87.568-.81.603-1.954-.16-3.076-.193-.288-.413-.582-.609-.895a3.178 3.178 0 01-.3-1.968c.466-.134.95-.19 1.432-.166.166 0 .33.04.48.115.148.076.279.186.38.322 0 0-.483.044-.616.268-.133.224-.232.177-.387.177-1.195 0-.49-.288-.986-.535-.013.251-.002.503.033.751.175.695.516 1.334.992 1.857.926 1.224 1.38 3.285-.106 4.357-.578-.863-1.482-1.775-2.5-1.786h-.064c-1.018.009-1.922.922-2.5 1.787-1.485-1.07-1.034-3.134-.106-4.358a4.322 4.322 0 00.992-1.857c.035-.248.046-.5.033-.75-.495.245.209.533-.986.533-.155 0-.255.044-.387-.177-.132-.222-.616-.268-.616-.268.101-.136.232-.246.38-.322.15-.076.314-.115.48-.115.482-.025.965.031 1.43.166l.002.001zm-2.249 3.914c-.307 1.125-.603 2.34.924 3.543.093.073.2.149.319.225.48.24.944.51 1.392.81.257.184.46.44.584.738.125.298.166.625.12.946a1.214 1.214 0 00-.118-.294 3.526 3.526 0 00-1.018-1.19c-.414-.246-.84-.47-1.276-.67-1.431-.77-2.073-1.987-1.634-3.71.296-1.165.633-1.845.011-2.927 1.229.304.937 1.644.696 2.535v-.006zM3.5 9.712s.017.053.035.13a2.4 2.4 0 01.015.946c-.123.727-.437 1.375-.498 2.126a3.23 3.23 0 00.479 2.151c.301.411.682.753 1.117 1.004.448.26.925.442 1.386.7.735.412 1.71 1.153 1.632 2.16-.259-.637-.982-1.212-1.577-1.56-.525-.305-1.143-.557-1.707-.852a3.449 3.449 0 01-1.167-.89 3.592 3.592 0 01-.71-1.308 4.868 4.868 0 01.154-2.524 9.131 9.131 0 01.842-2.084v.001zm3.753-3.134C6.888 6.31 6.1 6.489 6.1 6.489c.17.046.337.105.499.177.283.148.542.343.766.576a.883.883 0 001.067 0c.223-.234.481-.429.766-.576.161-.072.328-.13.498-.177 0 0-.788-.177-1.154.089-.51.374-.77.374-1.287 0h-.002zm4.204 5.225c.307 1.126.603 2.341-.924 3.544-.093.073-.2.148-.318.224-.48.24-.945.51-1.392.81-.257.185-.46.44-.585.739a1.798 1.798 0 00-.12.946c.026-.103.066-.202.118-.295.248-.472.596-.88 1.018-1.193.414-.246.84-.469 1.276-.669 1.432-.77 2.073-1.988 1.635-3.71-.297-1.165-.633-1.845-.011-2.93-1.233.304-.938 1.644-.696 2.535zm.842-2.096s-.018.052-.036.129a2.436 2.436 0 00-.014.947c.122.726.436 1.376.498 2.126a3.232 3.232 0 01-.482 2.151c-.302.41-.682.752-1.117 1.003-.45.26-.925.443-1.389.703-.737.413-1.711 1.152-1.632 2.16.258-.638.982-1.213 1.577-1.56.524-.305 1.144-.558 1.707-.853.446-.208.843-.51 1.166-.89.324-.378.565-.823.71-1.306.172-.84.12-1.713-.152-2.525a9.142 9.142 0 00-.845-2.084l.009-.001zM8.81 8.35a2.17 2.17 0 00-.18.596 1.12 1.12 0 00.047.654c.081.208.223.384.405.506a.877.877 0 00.225.078 3.194 3.194 0 01-.202-.296 3.638 3.638 0 01-.296-1.536",
    fill: "#AFC4FF"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgHomeIconDisabled);

/***/ }),

/***/ 16661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgHomeIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.982 8.348a3.607 3.607 0 01-.296 1.539 3.242 3.242 0 01-.201.295.86.86 0 00.225-.077c.182-.122.323-.299.404-.507.08-.208.097-.436.046-.654a2.184 2.184 0 00-.181-.596h.003zm5.44-1.453h-.363c.147.6.402 1.168.75 1.671.266.428.545.846.784 1.29.535.959.872 2.02.99 3.12.176 1.872-.775 3.397-2.412 4.213-1.035.513-1.97.763-2.785 1.38-.488.395-.901.88-1.22 1.43.088-1.994 1.94-2.41 3.41-3.151 1.69-.85 2.425-2.235 2.217-4.065-.242-1.584-.859-2.643-1.577-3.865a9.751 9.751 0 01-.887-1.739 3.515 3.515 0 01-.186-.982 10.978 10.978 0 00-6.483 0 3.535 3.535 0 01-.186.982 9.923 9.923 0 01-.887 1.74c-.723 1.224-1.34 2.28-1.581 3.864-.209 1.83.528 3.213 2.216 4.066 1.47.74 3.323 1.156 3.409 3.151a5.14 5.14 0 00-1.218-1.43c-.817-.618-1.755-.87-2.784-1.38-1.636-.817-2.592-2.342-2.413-4.213a8.27 8.27 0 01.99-3.12c.238-.444.517-.864.784-1.29.348-.504.603-1.07.75-1.671h-.362c-.13.418-.313.816-.545 1.184-.909 1.532-1.952 2.868-2.03 4.787-.005.435.022.869.082 1.3a2.71 2.71 0 01-.453-1.222 4.24 4.24 0 01.089-1.525c.27-1.165.909-2.168 1.454-3.2.293-.472.499-.996.606-1.545a.861.861 0 00-.09-.517.82.82 0 00-.37-.36.98.98 0 01.473-.166.728.728 0 01.619.274 14.812 14.812 0 00-.34-1.646 12.242 12.242 0 00-.378-1.213 13.992 13.992 0 00-.249-.643h-.065a.545.545 0 01-.402-.14.583.583 0 01-.19-.394.626.626 0 01.201-.38.588.588 0 01.787.001c.109.099.18.235.2.383a.528.528 0 01-.25.432 11.112 11.112 0 001.597 1.823c.32-.148.585-.4.754-.718a1.72 1.72 0 00.184-1.042.54.54 0 01-.37-.155.577.577 0 01-.172-.373.626.626 0 01.201-.382.588.588 0 01.787.003c.11.098.18.234.2.382a.566.566 0 01-.137.339.533.533 0 01-.31.177c.332.55.848.957 1.45 1.142a2.993 2.993 0 01-.565.821c-.525.12-1.035.3-1.52.541a2.846 2.846 0 01-.764-.077.54.54 0 00-.174-.031c.16.268.284.557.37.86 1.918-.803 5.755-.8 7.687.005.086-.304.207-.595.36-.87a.54.54 0 00-.174.033c-.25.06-.508.086-.765.077a6.794 6.794 0 00-1.52-.544 3.001 3.001 0 01-.566-.821 2.601 2.601 0 001.452-1.143.53.53 0 01-.311-.174.562.562 0 01-.137-.338.627.627 0 01.201-.382.588.588 0 01.788.002c.108.098.18.234.2.383a.578.578 0 01-.172.373.541.541 0 01-.37.154c-.05.36.014.726.183 1.044.169.318.433.57.754.72a11.764 11.764 0 001.606-1.824.504.504 0 01-.18-.182.528.528 0 01-.07-.25.626.626 0 01.201-.381.588.588 0 01.787.002c.109.098.18.234.2.382a.584.584 0 01-.19.394.545.545 0 01-.404.14h-.068c-.062.149-.152.374-.25.643-.144.398-.27.802-.375 1.213-.157.556-.284 1.12-.38 1.69a.763.763 0 01.288-.257.734.734 0 01.373-.079c.168.014.33.072.472.168a.819.819 0 00-.37.36.86.86 0 00-.09.517c.107.55.312 1.074.606 1.545.546 1.033 1.182 2.035 1.455 3.2.122.499.152 1.017.09 1.527-.051.44-.207.859-.453 1.22.06-.43.087-.864.081-1.299-.077-1.92-1.12-3.255-2.027-4.788a4.944 4.944 0 01-.544-1.182l-.004.001zM8.04 1.068a.543.543 0 00.313-.18.576.576 0 00.138-.343.642.642 0 00-.205-.39.603.603 0 00-.805 0 .642.642 0 00-.206.39c.008.133.06.26.148.357a.551.551 0 00.333.179 7.57 7.57 0 01-1.279 3.143l-.004.012H9.32l-.004-.012a7.574 7.574 0 01-1.28-3.155l.002-.001zm1.835 13.543c-.445.803-.825.686-1.212.508a1.607 1.607 0 00-1.514-.008c-.391.182-.775.318-1.228-.5a.646.646 0 00.042.797c.535.464 1.463.587 1.849 1.535.018.226.155.226.173 0 .387-.948 1.315-1.07 1.848-1.535a.641.641 0 00.042-.796zm-3.29-6.718a3.181 3.181 0 01-.3 1.968c-.193.313-.412.606-.608.894-.765 1.123-.728 2.268-.161 3.076a3.64 3.64 0 011.333-.87c.21-.09.426-.165.646-.226.165-.586-.42-1.515-.84-1.697a2.588 2.588 0 00-.567-.14s.028-.11.426-.4a.937.937 0 01.892-.044c.15.06.308.093.468.1h.041c.16-.006.319-.04.468-.1a.94.94 0 01.893.044c.4.288.426.4.426.4a2.598 2.598 0 00-.567.14c-.423.182-1.007 1.11-.84 1.697.22.06.436.136.646.227.5.188.954.485 1.333.87.568-.81.603-1.954-.16-3.076-.193-.288-.413-.582-.609-.895a3.178 3.178 0 01-.3-1.968c.466-.134.95-.19 1.432-.166.166 0 .33.04.48.115.148.076.279.186.38.322 0 0-.483.044-.616.268-.133.224-.232.177-.387.177-1.195 0-.49-.288-.986-.535-.013.251-.002.503.033.751.175.695.516 1.334.992 1.857.926 1.224 1.38 3.285-.106 4.357-.578-.863-1.482-1.775-2.5-1.786h-.064c-1.018.009-1.922.922-2.5 1.787-1.485-1.07-1.034-3.134-.106-4.358a4.322 4.322 0 00.992-1.857c.035-.248.046-.5.033-.75-.495.245.209.533-.986.533-.155 0-.255.044-.387-.177-.132-.222-.616-.268-.616-.268.101-.136.232-.246.38-.322.15-.076.314-.115.48-.115.482-.025.965.031 1.43.166l.002.001zm-2.249 3.914c-.307 1.125-.603 2.34.924 3.543.093.073.2.149.319.225.48.24.944.51 1.392.81.257.184.46.44.584.738.125.298.166.625.12.946a1.214 1.214 0 00-.118-.294 3.526 3.526 0 00-1.018-1.19c-.414-.246-.84-.47-1.276-.67-1.431-.77-2.073-1.987-1.634-3.71.296-1.165.633-1.845.011-2.927 1.229.304.937 1.644.696 2.535v-.006zM3.5 9.712s.017.053.035.13a2.4 2.4 0 01.015.946c-.123.727-.437 1.375-.498 2.126a3.23 3.23 0 00.479 2.151c.301.411.682.753 1.117 1.004.448.26.925.442 1.386.7.735.412 1.71 1.153 1.632 2.16-.259-.637-.982-1.212-1.577-1.56-.525-.305-1.143-.557-1.707-.852a3.449 3.449 0 01-1.167-.89 3.592 3.592 0 01-.71-1.308 4.868 4.868 0 01.154-2.524 9.131 9.131 0 01.842-2.084v.001zm3.753-3.134C6.888 6.31 6.1 6.489 6.1 6.489c.17.046.337.105.499.177.283.148.542.343.766.576a.883.883 0 001.067 0c.223-.234.481-.429.766-.576.161-.072.328-.13.498-.177 0 0-.788-.177-1.154.089-.51.374-.77.374-1.287 0h-.002zm4.204 5.225c.307 1.126.603 2.341-.924 3.544-.093.073-.2.148-.318.224-.48.24-.945.51-1.392.81-.257.185-.46.44-.585.739a1.798 1.798 0 00-.12.946c.026-.103.066-.202.118-.295.248-.472.596-.88 1.018-1.193.414-.246.84-.469 1.276-.669 1.432-.77 2.073-1.988 1.635-3.71-.297-1.165-.633-1.845-.011-2.93-1.233.304-.938 1.644-.696 2.535zm.842-2.096s-.018.052-.036.129a2.436 2.436 0 00-.014.947c.122.726.436 1.376.498 2.126a3.232 3.232 0 01-.482 2.151c-.302.41-.682.752-1.117 1.003-.45.26-.925.443-1.389.703-.737.413-1.711 1.152-1.632 2.16.258-.638.982-1.213 1.577-1.56.524-.305 1.144-.558 1.707-.853.446-.208.843-.51 1.166-.89.324-.378.565-.823.71-1.306.172-.84.12-1.713-.152-2.525a9.142 9.142 0 00-.845-2.084l.009-.001zM8.81 8.35a2.17 2.17 0 00-.18.596 1.12 1.12 0 00.047.654c.081.208.223.384.405.506a.877.877 0 00.225.078 3.194 3.194 0 01-.202-.296 3.638 3.638 0 01-.296-1.536",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgHomeIcon);

/***/ }),

/***/ 23045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgInfoGrey(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-9-.75a1 1 0 012 0v4.25a1 1 0 11-2 0V7.25zm1-4a1 1 0 100 2 1 1 0 000-2z",
    fill: "#999"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgInfoGrey);

/***/ }),

/***/ 67032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLoadListingDisabled(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 8.428V19.67c0 .493-.134.977-.388 1.404a2.852 2.852 0 01-1.056 1.027l-10.112 5.621a2.933 2.933 0 01-.694.28v-13.52l12.042-7.098c.136.33.208.685.208 1.044zm-1.142-2.235a2.903 2.903 0 00-.302-.196L14.444.377a2.95 2.95 0 00-2.888 0L7.81 2.458 19.503 9.35l5.355-3.157zm-6.832 4.028L6.29 3.303 1.444 5.997c-.105.06-.206.125-.302.196L13 13.183l5.026-2.962zM.208 7.384l12.042 7.098v13.52a2.937 2.937 0 01-.694-.28l-10.112-5.62a2.852 2.852 0 01-1.056-1.028A2.752 2.752 0 010 19.67V8.428c0-.359.071-.713.208-1.044z",
    fill: "#AFC4FF"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLoadListingDisabled);

/***/ }),

/***/ 64353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLoadListingWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 8.428V19.67c0 .493-.134.977-.388 1.404a2.852 2.852 0 01-1.056 1.027l-10.112 5.621a2.933 2.933 0 01-.694.28v-13.52l12.042-7.098c.136.33.208.685.208 1.044zm-1.142-2.235a2.903 2.903 0 00-.302-.196L14.444.377a2.95 2.95 0 00-2.888 0L7.81 2.458 19.503 9.35l5.355-3.157zm-6.832 4.028L6.29 3.303 1.444 5.997c-.105.06-.206.125-.302.196L13 13.183l5.026-2.962zM.208 7.384l12.042 7.098v13.52a2.937 2.937 0 01-.694-.28l-10.112-5.62a2.852 2.852 0 01-1.056-1.028A2.752 2.752 0 010 19.67V8.428c0-.359.071-.713.208-1.044z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLoadListingWhite);

/***/ }),

/***/ 33194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMyLorriesActive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.111 19.8h4.444V21a1 1 0 01-1 1H2.111a1 1 0 01-1-1v-1.2zm13.334 0h4.445V21a1 1 0 01-1 1h-2.445a1 1 0 01-1-1v-1.2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.225 12.1h15.554V5.3a2 2 0 00-2-2H4.225a2 2 0 00-2 2v6.8zM3.52 9.9h12.962V6.5a1 1 0 00-1-1H4.52a1 1 0 00-1 1v3.4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.111 4.4H1a1 1 0 00-1 1v2.4a1 1 0 001 1h.111V4.4zM20 7.8a1 1 0 01-1 1h-.11V4.4H19a1 1 0 011 1v2.4z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.946 0a2 2 0 012 2v.2H1.053V2a2 2 0 012-2h13.893zM0 11.9a2 2 0 012-2h16a2 2 0 012 2v5.8a1 1 0 01-1 1H1a1 1 0 01-1-1v-5.8zm6.666 2.3a1 1 0 011-1h4.666a1 1 0 011 1v3.4H6.666v-3.4zm9.99-2.1a1.1 1.1 0 100 2.2h1.132a1.1 1.1 0 000-2.2h-1.133zM1.11 13.2a1.1 1.1 0 011.1-1.1h1.133a1.1 1.1 0 010 2.2H2.211a1.1 1.1 0 01-1.1-1.1zm17.776 5.5v1.1H1.111v-1.1h17.776z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgMyLorriesActive);

/***/ }),

/***/ 35900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgMyLorriesInactive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.111 19.8h4.444V21a1 1 0 01-1 1H2.111a1 1 0 01-1-1v-1.2zm13.334 0h4.445V21a1 1 0 01-1 1h-2.445a1 1 0 01-1-1v-1.2z",
    fill: "#AFC4FF"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.225 12.1h15.554V5.3a2 2 0 00-2-2H4.225a2 2 0 00-2 2v6.8zM3.52 9.9h12.962V6.5a1 1 0 00-1-1H4.52a1 1 0 00-1 1v3.4z",
    fill: "#AFC4FF"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M1.111 4.4H1a1 1 0 00-1 1v2.4a1 1 0 001 1h.111V4.4zM20 7.8a1 1 0 01-1 1h-.11V4.4H19a1 1 0 011 1v2.4z",
    fill: "#AFC4FF"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.946 0a2 2 0 012 2v.2H1.053V2a2 2 0 012-2h13.893zM0 11.9a2 2 0 012-2h16a2 2 0 012 2v5.8a1 1 0 01-1 1H1a1 1 0 01-1-1v-5.8zm6.666 2.3a1 1 0 011-1h4.666a1 1 0 011 1v3.4H6.666v-3.4zm9.99-2.1a1.1 1.1 0 100 2.2h1.132a1.1 1.1 0 000-2.2h-1.133zM1.11 13.2a1.1 1.1 0 011.1-1.1h1.133a1.1 1.1 0 010 2.2H2.211a1.1 1.1 0 01-1.1-1.1zm17.776 5.5v1.1H1.111v-1.1h17.776z",
    fill: "#AFC4FF"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgMyLorriesInactive);

/***/ }),

/***/ 58352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgShareBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.97 2.333a1.896 1.896 0 11-3.792 0 1.896 1.896 0 013.792 0z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.074 4.667a2.336 2.336 0 01-2.333-2.334A2.336 2.336 0 0111.074 0a2.336 2.336 0 012.334 2.333 2.336 2.336 0 01-2.334 2.334zm0-3.792a1.46 1.46 0 00-1.458 1.458 1.46 1.46 0 001.458 1.459 1.46 1.46 0 001.459-1.459A1.46 1.46 0 0011.074.875zm1.896 10.792a1.896 1.896 0 11-3.792 0 1.896 1.896 0 013.792 0z",
    fill: "#2355FC"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.074 14a2.336 2.336 0 01-2.333-2.333 2.336 2.336 0 012.333-2.334 2.336 2.336 0 012.334 2.334A2.336 2.336 0 0111.074 14zm0-3.792a1.46 1.46 0 00-1.458 1.459 1.46 1.46 0 001.458 1.458 1.46 1.46 0 001.459-1.458 1.46 1.46 0 00-1.459-1.459zM4.803 7a1.896 1.896 0 11-3.791 0 1.896 1.896 0 013.791 0z",
    fill: "#2355FC"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M2.908 9.333A2.336 2.336 0 01.574 7a2.336 2.336 0 012.334-2.333A2.336 2.336 0 015.24 7a2.336 2.336 0 01-2.333 2.333zm0-3.791A1.46 1.46 0 001.449 7a1.46 1.46 0 001.459 1.458A1.46 1.46 0 004.366 7a1.46 1.46 0 00-1.458-1.458z",
    fill: "#2355FC"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4.285 6.72a.582.582 0 01-.29-1.09l5.413-3.086a.582.582 0 11.578 1.014L4.573 6.643a.58.58 0 01-.288.077zm5.412 4.813a.579.579 0 01-.288-.077L3.996 8.37a.584.584 0 01.577-1.014l5.413 3.086a.584.584 0 01-.29 1.09z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgShareBlue);

/***/ }),

/***/ 99292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTickBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.074 10a1.22 1.22 0 01-.861-.352l-3.856-3.8a1.187 1.187 0 010-1.697 1.229 1.229 0 011.722 0l2.995 2.95L11.92.35a1.229 1.229 0 011.722 0c.476.47.476 1.229 0 1.698L5.935 9.648a1.218 1.218 0 01-.861.352z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgTickBlue);

/***/ }),

/***/ 48384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTimer(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8 .688A7.312 7.312 0 1015.313 8 7.32 7.32 0 008 .688zm3.938 7.875H8A.562.562 0 017.437 8V4.063a.563.563 0 011.125 0v3.375h3.376a.563.563 0 010 1.125z",
    fill: "inherit"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgTimer);

/***/ }),

/***/ 78888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgUpVerifiedProfile(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#up_verified_profile_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.103 13.356a10.092 10.092 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.441 1.441 0 01-.459.08h-.016a1.462 1.462 0 01-.476-.082 12.622 12.622 0 01-4.72-2.8 10.073 10.073 0 01-2.407-3.76A21.717 21.717 0 01.02 5.447v-.036c.009-.194.015-.4.018-.622a2.122 2.122 0 011.996-2.077 8.203 8.203 0 005.59-2.36l.008-.01a1.277 1.277 0 011.736 0l.015.011a8.205 8.205 0 005.59 2.36 2.114 2.114 0 011.996 2.077c0 .226.01.43.018.622v.015a21.753 21.753 0 01-.884 7.93z",
    fill: "#3177F5"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.103 13.356a10.091 10.091 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.44 1.44 0 01-.458.081V-.004c.315.004.618.126.85.34l.013.012a8.205 8.205 0 005.59 2.36 2.115 2.115 0 011.996 2.077c0 .226.01.429.018.622v.019a21.755 21.755 0 01-.882 7.93z",
    fill: "#0B42F7"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.282 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.073 1.706H8.5a5.777 5.777 0 01-4.088-1.697 5.798 5.798 0 010-8.191A5.777 5.777 0 018.5 4.207h.02c1.53.007 2.994.62 4.074 1.706A5.805 5.805 0 0114.282 10z",
    fill: "#fff"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.281 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.072 1.706V4.209a5.78 5.78 0 014.072 1.705A5.805 5.805 0 0114.281 10z",
    fill: "#E0E9FF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.478 8.989l-2.942 2.949-.636.637a.769.769 0 01-1.088 0l-1.368-1.37a.772.772 0 01.548-1.302.77.77 0 01.54.212l.824.825 3.035-3.041a.769.769 0 011.3.55.772.772 0 01-.212.54z",
    fill: "#2355FC"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "up_verified_profile_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v20H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgUpVerifiedProfile);

/***/ }),

/***/ 69007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVahakHomeIconMobActive(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.982 8.348a3.607 3.607 0 01-.296 1.539 3.242 3.242 0 01-.201.295.86.86 0 00.225-.077c.182-.122.323-.299.404-.507.08-.208.097-.436.046-.654a2.184 2.184 0 00-.181-.596h.003zm5.44-1.453h-.363c.147.6.402 1.168.75 1.671.266.428.545.846.784 1.29.535.959.872 2.02.99 3.12.176 1.872-.775 3.397-2.412 4.213-1.035.513-1.97.763-2.785 1.38-.488.395-.901.88-1.22 1.43.088-1.994 1.94-2.41 3.41-3.151 1.69-.85 2.425-2.235 2.217-4.065-.242-1.584-.859-2.643-1.577-3.865a9.751 9.751 0 01-.887-1.739 3.515 3.515 0 01-.186-.982 10.978 10.978 0 00-6.483 0 3.535 3.535 0 01-.186.982 9.923 9.923 0 01-.887 1.74c-.723 1.224-1.34 2.28-1.581 3.864-.209 1.83.528 3.213 2.216 4.066 1.47.74 3.323 1.156 3.409 3.151a5.14 5.14 0 00-1.218-1.43c-.817-.618-1.755-.87-2.784-1.38-1.636-.817-2.592-2.342-2.413-4.213a8.27 8.27 0 01.99-3.12c.238-.444.517-.864.784-1.29.348-.504.603-1.07.75-1.671h-.362c-.13.418-.313.816-.545 1.184-.909 1.532-1.952 2.868-2.03 4.787-.005.435.022.869.082 1.3a2.71 2.71 0 01-.453-1.222 4.24 4.24 0 01.089-1.525c.27-1.165.909-2.168 1.454-3.2.293-.472.499-.996.606-1.545a.861.861 0 00-.09-.517.82.82 0 00-.37-.36.98.98 0 01.473-.166.728.728 0 01.619.274 14.812 14.812 0 00-.34-1.646 12.242 12.242 0 00-.378-1.213 13.992 13.992 0 00-.249-.643h-.065a.545.545 0 01-.402-.14.583.583 0 01-.19-.394.626.626 0 01.201-.38.588.588 0 01.787.001c.109.099.18.235.2.383a.528.528 0 01-.25.432 11.112 11.112 0 001.597 1.823c.32-.148.585-.4.754-.718a1.72 1.72 0 00.184-1.042.54.54 0 01-.37-.155.577.577 0 01-.172-.373.626.626 0 01.201-.382.588.588 0 01.787.003c.11.098.18.234.2.382a.566.566 0 01-.137.339.533.533 0 01-.31.177c.332.55.848.957 1.45 1.142a2.993 2.993 0 01-.565.821c-.525.12-1.035.3-1.52.541a2.846 2.846 0 01-.764-.077.54.54 0 00-.174-.031c.16.268.284.557.37.86 1.918-.803 5.755-.8 7.687.005.086-.304.207-.595.36-.87a.54.54 0 00-.174.033c-.25.06-.508.086-.765.077a6.794 6.794 0 00-1.52-.544 3.001 3.001 0 01-.566-.821 2.601 2.601 0 001.452-1.143.53.53 0 01-.311-.174.562.562 0 01-.137-.338.627.627 0 01.201-.382.588.588 0 01.788.002c.108.098.18.234.2.383a.578.578 0 01-.172.373.541.541 0 01-.37.154c-.05.36.014.726.183 1.044.169.318.433.57.754.72a11.764 11.764 0 001.606-1.824.504.504 0 01-.18-.182.528.528 0 01-.07-.25.626.626 0 01.201-.381.588.588 0 01.787.002c.109.098.18.234.2.382a.584.584 0 01-.19.394.545.545 0 01-.404.14h-.068c-.062.149-.152.374-.25.643-.144.398-.27.802-.375 1.213-.157.556-.284 1.12-.38 1.69a.763.763 0 01.288-.257.734.734 0 01.373-.079c.168.014.33.072.472.168a.819.819 0 00-.37.36.86.86 0 00-.09.517c.107.55.312 1.074.606 1.545.546 1.033 1.182 2.035 1.455 3.2.122.499.152 1.017.09 1.527-.051.44-.207.859-.453 1.22.06-.43.087-.864.081-1.299-.077-1.92-1.12-3.255-2.027-4.788a4.944 4.944 0 01-.544-1.182l-.004.001zM8.04 1.068a.543.543 0 00.313-.18.576.576 0 00.138-.343.642.642 0 00-.205-.39.603.603 0 00-.805 0 .642.642 0 00-.206.39c.008.133.06.26.148.357a.551.551 0 00.333.179 7.57 7.57 0 01-1.279 3.143l-.004.012H9.32l-.004-.012a7.574 7.574 0 01-1.28-3.155l.002-.001zm1.835 13.543c-.445.803-.825.686-1.212.508a1.607 1.607 0 00-1.514-.008c-.391.182-.775.318-1.228-.5a.646.646 0 00.042.797c.535.464 1.463.587 1.849 1.535.018.226.155.226.173 0 .387-.948 1.315-1.07 1.848-1.535a.641.641 0 00.042-.796zm-3.29-6.718a3.181 3.181 0 01-.3 1.968c-.193.313-.412.606-.608.894-.765 1.123-.728 2.268-.161 3.076a3.64 3.64 0 011.333-.87c.21-.09.426-.165.646-.226.165-.586-.42-1.515-.84-1.697a2.588 2.588 0 00-.567-.14s.028-.11.426-.4a.937.937 0 01.892-.044c.15.06.308.093.468.1h.041c.16-.006.319-.04.468-.1a.94.94 0 01.893.044c.4.288.426.4.426.4a2.598 2.598 0 00-.567.14c-.423.182-1.007 1.11-.84 1.697.22.06.436.136.646.227.5.188.954.485 1.333.87.568-.81.603-1.954-.16-3.076-.193-.288-.413-.582-.609-.895a3.178 3.178 0 01-.3-1.968c.466-.134.95-.19 1.432-.166.166 0 .33.04.48.115.148.076.279.186.38.322 0 0-.483.044-.616.268-.133.224-.232.177-.387.177-1.195 0-.49-.288-.986-.535-.013.251-.002.503.033.751.175.695.516 1.334.992 1.857.926 1.224 1.38 3.285-.106 4.357-.578-.863-1.482-1.775-2.5-1.786h-.064c-1.018.009-1.922.922-2.5 1.787-1.485-1.07-1.034-3.134-.106-4.358a4.322 4.322 0 00.992-1.857c.035-.248.046-.5.033-.75-.495.245.209.533-.986.533-.155 0-.255.044-.387-.177-.132-.222-.616-.268-.616-.268.101-.136.232-.246.38-.322.15-.076.314-.115.48-.115.482-.025.965.031 1.43.166l.002.001zm-2.249 3.914c-.307 1.125-.603 2.34.924 3.543.093.073.2.149.319.225.48.24.944.51 1.392.81.257.184.46.44.584.738.125.298.166.625.12.946a1.214 1.214 0 00-.118-.294 3.526 3.526 0 00-1.018-1.19c-.414-.246-.84-.47-1.276-.67-1.431-.77-2.073-1.987-1.634-3.71.296-1.165.633-1.845.011-2.927 1.229.304.937 1.644.696 2.535v-.006zM3.5 9.712s.017.053.035.13a2.4 2.4 0 01.015.946c-.123.727-.437 1.375-.498 2.126a3.23 3.23 0 00.479 2.151c.301.411.682.753 1.117 1.004.448.26.925.442 1.386.7.735.412 1.71 1.153 1.632 2.16-.259-.637-.982-1.212-1.577-1.56-.525-.305-1.143-.557-1.707-.852a3.449 3.449 0 01-1.167-.89 3.592 3.592 0 01-.71-1.308 4.868 4.868 0 01.154-2.524 9.131 9.131 0 01.842-2.084v.001zm3.753-3.134C6.888 6.31 6.1 6.489 6.1 6.489c.17.046.337.105.499.177.283.148.542.343.766.576a.883.883 0 001.067 0c.223-.234.481-.429.766-.576.161-.072.328-.13.498-.177 0 0-.788-.177-1.154.089-.51.374-.77.374-1.287 0h-.002zm4.204 5.225c.307 1.126.603 2.341-.924 3.544-.093.073-.2.148-.318.224-.48.24-.945.51-1.392.81-.257.185-.46.44-.585.739a1.798 1.798 0 00-.12.946c.026-.103.066-.202.118-.295.248-.472.596-.88 1.018-1.193.414-.246.84-.469 1.276-.669 1.432-.77 2.073-1.988 1.635-3.71-.297-1.165-.633-1.845-.011-2.93-1.233.304-.938 1.644-.696 2.535zm.842-2.096s-.018.052-.036.129a2.436 2.436 0 00-.014.947c.122.726.436 1.376.498 2.126a3.232 3.232 0 01-.482 2.151c-.302.41-.682.752-1.117 1.003-.45.26-.925.443-1.389.703-.737.413-1.711 1.152-1.632 2.16.258-.638.982-1.213 1.577-1.56.524-.305 1.144-.558 1.707-.853.446-.208.843-.51 1.166-.89.324-.378.565-.823.71-1.306.172-.84.12-1.713-.152-2.525a9.142 9.142 0 00-.845-2.084l.009-.001zM8.81 8.35a2.17 2.17 0 00-.18.596 1.12 1.12 0 00.047.654c.081.208.223.384.405.506a.877.877 0 00.225.078 3.194 3.194 0 01-.202-.296 3.638 3.638 0 01-.296-1.536",
    fill: "#2355FC"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgVahakHomeIconMobActive);

/***/ }),

/***/ 59644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgWhatsappIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#E0E0E0",
    d: "M27.337 4.65A15.868 15.868 0 0016.067 0C7.285 0 .138 7.113.135 15.856a15.77 15.77 0 002.126 7.927L.001 32l8.446-2.205a15.958 15.958 0 007.613 1.93h.007c8.78 0 15.928-7.114 15.932-15.856A15.725 15.725 0 0027.337 4.65zm-11.27 24.397h-.005c-2.377 0-4.707-.636-6.74-1.837l-.484-.286-5.012 1.309 1.338-4.864-.315-.498a13.11 13.11 0 01-2.024-7.014C2.828 8.59 8.768 2.678 16.072 2.678c3.537.002 6.862 1.374 9.362 3.865s3.876 5.803 3.875 9.325c-.003 7.267-5.943 13.18-13.242 13.18z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "url(#whatsapp_icon_svg__whatsapp)",
    d: "M.732 31.088l2.157-7.841A15.081 15.081 0 01.86 15.68C.864 7.338 7.685.551 16.065.551a15.136 15.136 0 0110.754 4.437 15.006 15.006 0 014.45 10.705c-.004 8.344-6.825 15.132-15.204 15.132h-.006c-2.545 0-5.045-.636-7.266-1.841l-8.06 2.104z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.13 9.125c-.295-.653-.605-.666-.886-.677-.229-.01-.492-.01-.754-.01s-.689.099-1.05.49c-.36.393-1.377 1.34-1.377 3.268 0 1.928 1.41 3.79 1.607 4.052.197.261 2.723 4.343 6.722 5.913 3.325 1.306 4.001 1.046 4.723.98.721-.065 2.328-.947 2.656-1.862.328-.915.328-1.698.23-1.862-.1-.164-.361-.262-.755-.458-.394-.195-2.328-1.143-2.689-1.274-.36-.13-.623-.196-.885.196-.263.392-1.017 1.274-1.246 1.536-.23.261-.46.294-.853.098-.393-.196-1.66-.61-3.164-1.944-1.17-1.039-1.96-2.321-2.19-2.713-.23-.392-.024-.604.173-.8.177-.175.394-.457.59-.686.197-.229.263-.392.394-.653.13-.262.065-.49-.033-.686-.098-.196-.863-2.134-1.213-2.908z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M27.206 4.6A15.69 15.69 0 0016.066.003C7.383.003.318 7.035.315 15.677a15.594 15.594 0 002.102 7.837L.184 31.636l8.349-2.18c2.3 1.25 4.89 1.907 7.525 1.908h.007c8.68 0 15.746-7.032 15.75-15.674a15.55 15.55 0 00-4.61-11.09zm-11.14 24.117h-.006a13.112 13.112 0 01-6.662-1.816l-.479-.282-4.954 1.293 1.323-4.808-.312-.492a12.958 12.958 0 01-2.001-6.934C2.978 8.495 8.85 2.651 16.07 2.651a13.034 13.034 0 019.255 3.82 12.923 12.923 0 013.83 9.218c-.003 7.183-5.875 13.028-13.09 13.028z"
  })), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "whatsapp_icon_svg__whatsapp",
    x1: 16,
    x2: 16,
    y1: 31.088,
    y2: 0.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "whatsapp_icon_svg__clip0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgWhatsappIcon);

/***/ }),

/***/ 52783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAppleStoreMark(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.046 20.275c-.98.95-2.05.8-3.08.35-1.09-.46-2.089-.48-3.239 0-1.44.62-2.2.44-3.059-.35C2.79 15.246 3.51 7.698 9.048 7.398c1.35.07 2.29.74 3.079.8 1.18-.24 2.31-.93 3.57-.84 1.509.12 2.649.72 3.398 1.8-3.119 1.87-2.38 5.978.48 7.128-.57 1.39-1.32 2.76-2.54 3.989h.01zM12.027 7.248c-.15-2.23 1.66-4.069 3.74-4.249.29 2.58-2.34 4.5-3.74 4.25z",
    fill: "#fff"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgAppleStoreMark);

/***/ }),

/***/ 43510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGooglePlayMark(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "30 10 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M30.4 10.6c-.3.3-.4.8-.4 1.4v22.1c0 .6.2 1.1.5 1.4l.1.1L43 23.2V23L30.4 10.6z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientA)"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47 27.4l-4.1-4.1V23l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientB)"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.1 27.3l-4.2-4.2-12.5 12.5c.5.5 1.2.5 2.1.1l14.6-8.4z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientC)"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.1 18.9l-14.6-8.3c-.9-.5-1.6-.4-2.1.1l12.5 12.4 4.2-4.2z",
    fill: "url(#google-play-mark_svg__googlePlayMarkGradientD)"
  })), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientA",
    x1: 41.8,
    y1: 11.81,
    x2: 25.017,
    y2: 28.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientB",
    x1: 53.834,
    y1: 23.101,
    x2: 29.637,
    y2: 23.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientC",
    x1: 44.826,
    y1: 25.396,
    x2: 22.068,
    y2: 48.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("linearGradient", {
    id: "google-play-mark_svg__googlePlayMarkGradientD",
    x1: 27.296,
    y1: 3.276,
    x2: 37.459,
    y2: 13.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgGooglePlayMark);

/***/ }),

/***/ 53272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgOptions(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 7a2 2 0 100-4 2 2 0 000 4zM12 13.5a2 2 0 100-4 2 2 0 000 4zM14 18a2 2 0 11-4 0 2 2 0 014 0z",
    fill: "#818181"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgOptions);

/***/ }),

/***/ 95211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPaymentCoin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5zM6.488 6.3c0-.27.218-.487.487-.487h4.05a.487.487 0 110 .974H9.637a2.513 2.513 0 01.478 1.05h.91a.487.487 0 110 .976h-.91a2.514 2.514 0 01-2.005 1.982l1.235 1.235a.487.487 0 11-.69.69L6.63 10.695a.488.488 0 01.345-.832h.675a1.537 1.537 0 001.458-1.05H6.975a.488.488 0 010-.976h2.133a1.54 1.54 0 00-1.458-1.05h-.675a.488.488 0 01-.487-.487z",
    fill: "#A4A4A4"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgPaymentCoin);

/***/ }),

/***/ 73099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPlusCircleWhite(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    transform: "rotate(-90 12 12)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.335 11.381h-3.716V7.666a.62.62 0 00-1.238 0v3.715H7.666a.619.619 0 100 1.239h3.715v3.715a.62.62 0 001.238 0V12.62h3.716a.62.62 0 000-1.239z",
    fill: "#2355FC",
    stroke: "#2355FC",
    strokeWidth: 0.6
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgPlusCircleWhite);

/***/ }),

/***/ 89821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgProfile(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.125 11.25a4.125 4.125 0 11-8.25 0 4.125 4.125 0 018.25 0zM21 4.5v15a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19.5v-15A1.5 1.5 0 014.5 3h15A1.5 1.5 0 0121 4.5zm-1.5 15v-15h-15v15h.344a7.554 7.554 0 012.444-3.586c.193-.155.391-.3.596-.433a.375.375 0 01.451.03 5.608 5.608 0 007.33 0 .375.375 0 01.45-.03 7.7 7.7 0 01.597.433 7.554 7.554 0 012.444 3.586h.344z",
    fill: "#818181"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgProfile);

/***/ }),

/***/ 73205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgWarningRed(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-11.25-.938a1.25 1.25 0 112.5 0v5.313a1.25 1.25 0 11-2.5 0v-5.313zm1.25-5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z",
    fill: "#DC2626"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgWarningRed);

/***/ }),

/***/ 30195:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 95766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 77160:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),

/***/ 48834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(95766)
var ieee754 = __webpack_require__(62333)
var isArray = __webpack_require__(77906)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = __webpack_require__.g.TYPED_ARRAY_SUPPORT !== undefined
  ? __webpack_require__.g.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


/***/ }),

/***/ 62680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(76672);

var callBind = __webpack_require__(89429);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 89429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(4090);
var GetIntrinsic = __webpack_require__(76672);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 76672:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(32636)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(4090);
var hasOwn = __webpack_require__(23198);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 72779:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 13421:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
exports.q = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 77452:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(8139), __webpack_require__(79174), __webpack_require__(96844), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            var t;

	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),

/***/ 9951:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(96844));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            var block;

	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            var modeCreator;

	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            var finalProcessedBlocks;

	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            var wordArray;

	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            var salt;

	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),

/***/ 57359:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(50633);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 8139:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 49950:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64url encoding strategy.
	     */
	    var Base64url = C_enc.Base64url = {
	        /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */
	        stringify: function (wordArray, urlSafe=true) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = urlSafe ? this._safe_map : this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */
	        parse: function (base64Str, urlSafe=true) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = urlSafe ? this._safe_map : this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                reverseMap = this._reverseMap = [];
	                for (var j = 0; j < map.length; j++) {
	                    reverseMap[map.charCodeAt(j)] = j;
	                }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	        _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	        var words = [];
	        var nBytes = 0;
	        for (var i = 0; i < base64StrLength; i++) {
	            if (i % 4) {
	                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	                var bitsCombined = bits1 | bits2;
	                words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	                nBytes++;
	            }
	        }
	        return WordArray.create(words, nBytes);
	    }
	}());

	return CryptoJS.enc.Base64url;

}));

/***/ }),

/***/ 66164:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),

/***/ 96844:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(81637), __webpack_require__(66423));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            var block;

	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),

/***/ 87333:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),

/***/ 66423:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 36023:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(66467), __webpack_require__(21816), __webpack_require__(66164), __webpack_require__(8139), __webpack_require__(49950), __webpack_require__(79174), __webpack_require__(81637), __webpack_require__(11093), __webpack_require__(83640), __webpack_require__(11834), __webpack_require__(91716), __webpack_require__(7140), __webpack_require__(25293), __webpack_require__(66423), __webpack_require__(89414), __webpack_require__(96844), __webpack_require__(9951), __webpack_require__(23173), __webpack_require__(4782), __webpack_require__(28655), __webpack_require__(32957), __webpack_require__(32129), __webpack_require__(52994), __webpack_require__(49236), __webpack_require__(41476), __webpack_require__(27921), __webpack_require__(50181), __webpack_require__(87333), __webpack_require__(77452), __webpack_require__(60567), __webpack_require__(10830), __webpack_require__(13480), __webpack_require__(94730));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),

/***/ 21816:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),

/***/ 79174:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ 23173:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        var keystream;

	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),

/***/ 28655:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),

/***/ 4782:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),

/***/ 32129:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),

/***/ 32957:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),

/***/ 52994:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),

/***/ 49236:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),

/***/ 41476:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),

/***/ 50181:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),

/***/ 27921:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        for (var i = data.sigBytes - 1; i >= 0; i--) {
	            if (((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	                data.sigBytes = i + 1;
	                break;
	            }
	        }
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),

/***/ 89414:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(81637), __webpack_require__(66423));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),

/***/ 94730:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(8139), __webpack_require__(79174), __webpack_require__(96844), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),

/***/ 13480:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(8139), __webpack_require__(79174), __webpack_require__(96844), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),

/***/ 10830:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(8139), __webpack_require__(79174), __webpack_require__(96844), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),

/***/ 25293:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),

/***/ 81637:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 83640:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(11093));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),

/***/ 11093:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 7140:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(66467));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    var tMsw;
	                    var tLsw;

	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),

/***/ 91716:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(66467), __webpack_require__(11834));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),

/***/ 11834:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(66467));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                var Wil;
	                var Wih;

	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    Wih = Wi.high = M[offset + i * 2]     | 0;
	                    Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    Wil = gamma0l + Wi7l;
	                    Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    Wil = Wil + gamma1l;
	                    Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    Wil = Wil + Wi16l;
	                    Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),

/***/ 60567:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359), __webpack_require__(8139), __webpack_require__(79174), __webpack_require__(96844), __webpack_require__(9951));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            // Make sure the key length is valid (64, 128 or >= 192 bit)
	            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
	                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
	            }

	            // Extend the key according to the keying options defined in 3DES standard
	            var key1 = keyWords.slice(0, 2);
	            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
	            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(key1));
	            this._des2 = DES.createEncryptor(WordArray.create(key2));
	            this._des3 = DES.createEncryptor(WordArray.create(key3));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),

/***/ 66467:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(57359));
	}
	else {}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),

/***/ 14926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(33464);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(81181)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 85978:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 69378:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 63397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l0": function() { return /* binding */ Form; },
  "J9": function() { return /* binding */ Formik; },
  "E9": function() { return /* binding */ setNestedObjectValues; },
  "TA": function() { return /* binding */ useFormik; }
});

// UNUSED EXPORTS: ErrorMessage, FastField, Field, FieldArray, FormikConsumer, FormikContext, FormikProvider, connect, getActiveElement, getIn, insert, isEmptyArray, isEmptyChildren, isFunction, isInputEvent, isInteger, isNaN, isObject, isPromise, isString, move, prepareDataForValidation, replace, setIn, swap, useField, useFormikContext, validateYupSchema, withFormik, yupToFormErrors

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/formik/node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(59969);
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);
;// CONCATENATED MODULE: ../../node_modules/formik/node_modules/deepmerge/dist/es.js
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ var es = (deepmerge_1);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_freeGlobal.js
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ var _freeGlobal = (freeGlobal);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var _Symbol_Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (_Symbol_Symbol);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isFunction.js



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!lodash_es_isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ var lodash_es_isFunction = (isFunction);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_coreJsData.js


/** Used to detect overreaching core-js shims. */
var coreJsData = _root["__core-js_shared__"];

/* harmony default export */ var _coreJsData = (coreJsData);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_toSource.js
/** Used for built-in method references. */
var _toSource_funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var _toSource_funcToString = _toSource_funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return _toSource_funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ var _toSource = (toSource);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var _baseIsNative_funcProto = Function.prototype,
    _baseIsNative_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var _baseIsNative_funcToString = _baseIsNative_funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = _baseIsNative_objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  _baseIsNative_funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!lodash_es_isObject(value) || _isMasked(value)) {
    return false;
  }
  var pattern = lodash_es_isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

/* harmony default export */ var _baseIsNative = (baseIsNative);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

/* harmony default export */ var _getNative = (getNative);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

/* harmony default export */ var _Map = (Map);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var _defineProperty = (defineProperty);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return lodash_es_isObjectLike(value) && _baseGetTag(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var isArguments_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = isArguments_objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = isArguments_objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return lodash_es_isObjectLike(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/stubFalse.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var lodash_es_stubFalse = (stubFalse);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isBuffer.js



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || lodash_es_stubFalse;

/* harmony default export */ var lodash_es_isBuffer = (isBuffer);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isIndex.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ var _isIndex = (isIndex);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var isLength_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= isLength_MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    _baseIsTypedArray_funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseIsTypedArray_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[_baseIsTypedArray_funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[_baseIsTypedArray_objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return lodash_es_isObjectLike(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nodeUtil.js


/** Detect free variable `exports`. */
var _nodeUtil_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var _nodeUtil_freeModule = _nodeUtil_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var _nodeUtil_moduleExports = _nodeUtil_freeModule && _nodeUtil_freeModule.exports === _nodeUtil_freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = _nodeUtil_moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = _nodeUtil_freeModule && _nodeUtil_freeModule.require && _nodeUtil_freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ var _nodeUtil = (nodeUtil);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = lodash_es_isArray(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && lodash_es_isBuffer(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !lodash_es_isFunction(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, lodash_es_keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!lodash_es_isObject(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, lodash_es_keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneBuffer.js


/** Detect free variable `exports`. */
var _cloneBuffer_freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var _cloneBuffer_freeModule = _cloneBuffer_freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var _cloneBuffer_moduleExports = _cloneBuffer_freeModule && _cloneBuffer_freeModule.exports === _cloneBuffer_freeExports;

/** Built-in value references. */
var _cloneBuffer_Buffer = _cloneBuffer_moduleExports ? _root.Buffer : undefined,
    allocUnsafe = _cloneBuffer_Buffer ? _cloneBuffer_Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ var _cloneBuffer = (cloneBuffer);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (arrayPush);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getSymbolsIn.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var _getSymbolsIn_nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !_getSymbolsIn_nativeGetSymbols ? lodash_es_stubArray : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

/* harmony default export */ var _getSymbolsIn = (getSymbolsIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return lodash_es_isArray(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getAllKeysIn.js




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, lodash_es_keysIn, _getSymbolsIn);
}

/* harmony default export */ var _getAllKeysIn = (getAllKeysIn);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

/* harmony default export */ var _DataView = (DataView);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = _getNative(_root, 'Promise');

/* harmony default export */ var _Promise = (_Promise_Promise);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

/* harmony default export */ var _Set = (Set);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_WeakMap.js



/* Built-in method references that are verified to be native. */
var _WeakMap_WeakMap = _getNative(_root, 'WeakMap');

/* harmony default export */ var _WeakMap = (_WeakMap_WeakMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map && getTag(new _Map) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap && getTag(new _WeakMap) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

/* harmony default export */ var _Uint8Array = (Uint8Array);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneDataView.js


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ var _cloneDataView = (cloneDataView);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneRegExp.js
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ var _cloneRegExp = (cloneRegExp);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneSymbol.js


/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ var _cloneSymbol = (cloneSymbol);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_initCloneByTag.js






/** `Object#toString` result references. */
var _initCloneByTag_boolTag = '[object Boolean]',
    _initCloneByTag_dateTag = '[object Date]',
    _initCloneByTag_mapTag = '[object Map]',
    _initCloneByTag_numberTag = '[object Number]',
    _initCloneByTag_regexpTag = '[object RegExp]',
    _initCloneByTag_setTag = '[object Set]',
    _initCloneByTag_stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var _initCloneByTag_arrayBufferTag = '[object ArrayBuffer]',
    _initCloneByTag_dataViewTag = '[object DataView]',
    _initCloneByTag_float32Tag = '[object Float32Array]',
    _initCloneByTag_float64Tag = '[object Float64Array]',
    _initCloneByTag_int8Tag = '[object Int8Array]',
    _initCloneByTag_int16Tag = '[object Int16Array]',
    _initCloneByTag_int32Tag = '[object Int32Array]',
    _initCloneByTag_uint8Tag = '[object Uint8Array]',
    _initCloneByTag_uint8ClampedTag = '[object Uint8ClampedArray]',
    _initCloneByTag_uint16Tag = '[object Uint16Array]',
    _initCloneByTag_uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case _initCloneByTag_arrayBufferTag:
      return _cloneArrayBuffer(object);

    case _initCloneByTag_boolTag:
    case _initCloneByTag_dateTag:
      return new Ctor(+object);

    case _initCloneByTag_dataViewTag:
      return _cloneDataView(object, isDeep);

    case _initCloneByTag_float32Tag: case _initCloneByTag_float64Tag:
    case _initCloneByTag_int8Tag: case _initCloneByTag_int16Tag: case _initCloneByTag_int32Tag:
    case _initCloneByTag_uint8Tag: case _initCloneByTag_uint8ClampedTag: case _initCloneByTag_uint16Tag: case _initCloneByTag_uint32Tag:
      return _cloneTypedArray(object, isDeep);

    case _initCloneByTag_mapTag:
      return new Ctor;

    case _initCloneByTag_numberTag:
    case _initCloneByTag_stringTag:
      return new Ctor(object);

    case _initCloneByTag_regexpTag:
      return _cloneRegExp(object);

    case _initCloneByTag_setTag:
      return new Ctor;

    case symbolTag:
      return _cloneSymbol(object);
  }
}

/* harmony default export */ var _initCloneByTag = (initCloneByTag);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsMap.js



/** `Object#toString` result references. */
var _baseIsMap_mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == _baseIsMap_mapTag;
}

/* harmony default export */ var _baseIsMap = (baseIsMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isMap.js




/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

/* harmony default export */ var lodash_es_isMap = (isMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseIsSet.js



/** `Object#toString` result references. */
var _baseIsSet_setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return lodash_es_isObjectLike(value) && _getTag(value) == _baseIsSet_setTag;
}

/* harmony default export */ var _baseIsSet = (baseIsSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isSet.js




/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

/* harmony default export */ var lodash_es_isSet = (isSet);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseClone.js























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var _baseClone_argsTag = '[object Arguments]',
    _baseClone_arrayTag = '[object Array]',
    _baseClone_boolTag = '[object Boolean]',
    _baseClone_dateTag = '[object Date]',
    _baseClone_errorTag = '[object Error]',
    _baseClone_funcTag = '[object Function]',
    _baseClone_genTag = '[object GeneratorFunction]',
    _baseClone_mapTag = '[object Map]',
    _baseClone_numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    _baseClone_regexpTag = '[object RegExp]',
    _baseClone_setTag = '[object Set]',
    _baseClone_stringTag = '[object String]',
    _baseClone_symbolTag = '[object Symbol]',
    _baseClone_weakMapTag = '[object WeakMap]';

var _baseClone_arrayBufferTag = '[object ArrayBuffer]',
    _baseClone_dataViewTag = '[object DataView]',
    _baseClone_float32Tag = '[object Float32Array]',
    _baseClone_float64Tag = '[object Float64Array]',
    _baseClone_int8Tag = '[object Int8Array]',
    _baseClone_int16Tag = '[object Int16Array]',
    _baseClone_int32Tag = '[object Int32Array]',
    _baseClone_uint8Tag = '[object Uint8Array]',
    _baseClone_uint8ClampedTag = '[object Uint8ClampedArray]',
    _baseClone_uint16Tag = '[object Uint16Array]',
    _baseClone_uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[_baseClone_argsTag] = cloneableTags[_baseClone_arrayTag] =
cloneableTags[_baseClone_arrayBufferTag] = cloneableTags[_baseClone_dataViewTag] =
cloneableTags[_baseClone_boolTag] = cloneableTags[_baseClone_dateTag] =
cloneableTags[_baseClone_float32Tag] = cloneableTags[_baseClone_float64Tag] =
cloneableTags[_baseClone_int8Tag] = cloneableTags[_baseClone_int16Tag] =
cloneableTags[_baseClone_int32Tag] = cloneableTags[_baseClone_mapTag] =
cloneableTags[_baseClone_numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[_baseClone_regexpTag] = cloneableTags[_baseClone_setTag] =
cloneableTags[_baseClone_stringTag] = cloneableTags[_baseClone_symbolTag] =
cloneableTags[_baseClone_uint8Tag] = cloneableTags[_baseClone_uint8ClampedTag] =
cloneableTags[_baseClone_uint16Tag] = cloneableTags[_baseClone_uint32Tag] = true;
cloneableTags[_baseClone_errorTag] = cloneableTags[_baseClone_funcTag] =
cloneableTags[_baseClone_weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!lodash_es_isObject(value)) {
    return value;
  }
  var isArr = lodash_es_isArray(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == _baseClone_funcTag || tag == _baseClone_genTag;

    if (lodash_es_isBuffer(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == _baseClone_argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (lodash_es_isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (lodash_es_isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? lodash_es_keysIn : lodash_es_keys);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/isSymbol.js



/** `Object#toString` result references. */
var isSymbol_symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (lodash_es_isObjectLike(value) && _baseGetTag(value) == isSymbol_symbolTag);
}

/* harmony default export */ var lodash_es_isSymbol = (isSymbol);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_toKey.js


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || lodash_es_isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ var _toKey = (toKey);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/_baseToString.js





/** Used as references for various `Number` constants. */
var _baseToString_INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var _baseToString_symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = _baseToString_symbolProto ? _baseToString_symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (lodash_es_isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (lodash_es_isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -_baseToString_INFINITY) ? '-0' : result;
}

/* harmony default export */ var _baseToString = (baseToString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/toString.js


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString_toString(value) {
  return value == null ? '' : _baseToString(value);
}

/* harmony default export */ var lodash_es_toString = (toString_toString);

;// CONCATENATED MODULE: ../../node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return lodash_es_isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

;// CONCATENATED MODULE: ../../node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
;// CONCATENATED MODULE: ../../node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

;// CONCATENATED MODULE: ../../node_modules/formik/dist/formik.esm.js










function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var formik_esm_isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var formik_esm_isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return react.Children.count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return formik_esm_isObject(value) && formik_esm_isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && formik_esm_isObject(value) && formik_esm_isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = lodash_es_toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = lodash_es_clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = lodash_es_toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (formik_esm_isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = lodash_es_clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (formik_esm_isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/(0,react.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = (0,react.useContext)(FormikContext);
  !!!formik ?  false ? 0 : tiny_warning_esm(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (react_fast_compare_default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = (0,react.useRef)(props.initialValues);
  var initialErrors = (0,react.useRef)(props.initialErrors || emptyErrors);
  var initialTouched = (0,react.useRef)(props.initialTouched || emptyTouched);
  var initialStatus = (0,react.useRef)(props.initialStatus);
  var isMounted = (0,react.useRef)(false);
  var fieldRegistry = (0,react.useRef)({});

  if (false) {}

  (0,react.useEffect)(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = (0,react.useReducer)(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = (0,react.useCallback)(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {}

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = (0,react.useCallback)(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = formik_esm_isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {}

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = (0,react.useCallback)(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = (0,react.useCallback)(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return formik_esm_isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = (0,react.useCallback)(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = es.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  (0,react.useEffect)(function () {
    if (validateOnMount && isMounted.current === true && react_fast_compare_default()(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = (0,react.useCallback)(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  (0,react.useEffect)(function () {
    if (isMounted.current === true && !react_fast_compare_default()(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  (0,react.useEffect)(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  (0,react.useEffect)(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  (0,react.useEffect)(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && formik_esm_isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = (0,react.useCallback)(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = (0,react.useCallback)(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = (0,react.useCallback)(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = formik_esm_isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = (0,react.useCallback)(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = (0,react.useCallback)(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {}

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = (0,react.useCallback)(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {}

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = (0,react.useCallback)(function (stateOrCb) {
    if (formik_esm_isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = (0,react.useCallback)(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = (0,react.useCallback)(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && formik_esm_isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && formik_esm_isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) { var activeElement; }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && formik_esm_isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && formik_esm_isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = (0,react.useCallback)(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = (0,react.useCallback)(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = (0,react.useCallback)(function (nameOrOptions) {
    var isAnObject = formik_esm_isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = (0,react.useMemo)(function () {
    return !react_fast_compare_default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = (0,react.useMemo)(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && formik_esm_isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  (0,react.useImperativeHandle)(innerRef, function () {
    return formikbag;
  });

  if (false) {}

  return (0,react.createElement)(FormikProvider, {
    value: formikbag
  }, component ? (0,react.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? formik_esm_isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? react.Children.only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || lodash_es_isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (lodash_es_isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? es(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = es(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;

function useEventCallback(fn) {
  var ref = (0,react.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return (0,react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = formik_esm_isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  useEffect(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {}

  !fieldName ?  false ? 0 : invariant(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {} // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  useEffect(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (formik_esm_isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return createElement(component, _extends({
        ref: innerRef
      }, field, rest), children);
    } // We don't pass `meta` for backwards compat


    return createElement(component, _extends({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return createElement(asElement, _extends({
      ref: _innerRef
    }, field, _rest), children);
  }

  return createElement(asElement, _extends({}, field, props), children);
}

var Form = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return (0,react.createElement)("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        _this = _React$Component.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return formik_esm_isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };
        /**
         * Just avoiding a render callback for perf here
         */


        _this.renderFormComponent = function (formikProps) {
          return createElement(Component$1, Object.assign({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return createElement(Formik, Object.assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(Component);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return hoistNonReactStatics(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return createElement(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? 0 : invariant(false) : void 0;
      return createElement(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return hoistNonReactStatics(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [lodash_es_cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !react_fast_compare_default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (formik_esm_isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? (0,react.createElement)(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? react.Children.only(children) : null : null;
  };

  return FieldArrayInner;
}(react.Component);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray = /*#__PURE__*/(/* unused pure expression or super */ null && (connect(FieldArrayInner)));

var ErrorMessageImpl = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? formik_esm_isFunction(render) ? render(error) : null : children ? formik_esm_isFunction(children) ? children(error) : null : component ? (0,react.createElement)(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(react.Component);

var ErrorMessage = /*#__PURE__*/(/* unused pure expression or super */ null && (connect(ErrorMessageImpl)));

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var FastFieldInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? 0 : tiny_warning_esm(false) : void 0;
    !!(component && render) ?  false ? 0 : tiny_warning_esm(false) : void 0;
    !!(is && children && formik_esm_isFunction(children)) ?  false ? 0 : tiny_warning_esm(false) : void 0;
    !!(component && children && formik_esm_isFunction(children)) ?  false ? 0 : tiny_warning_esm(false) : void 0;
    !!(render && children && !isEmptyChildren(children)) ?  false ? 0 : tiny_warning_esm(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = formik.getFieldProps(_extends({
      name: name
    }, props));
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (formik_esm_isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return (0,react.createElement)(component, _extends({
          ref: innerRef
        }, field, rest), children);
      } // We don't pass `meta` for backwards compat


      return (0,react.createElement)(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return (0,react.createElement)(asElement, _extends({
        ref: _innerRef
      }, field, _rest), children);
    }

    return (0,react.createElement)(asElement, _extends({}, field, props), children);
  };

  return FastFieldInner;
}(react.Component);

var FastField = /*#__PURE__*/(/* unused pure expression or super */ null && (connect(FastFieldInner)));


//# sourceMappingURL=formik.esm.js.map


/***/ }),

/***/ 59969:
/***/ (function(module) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 37795:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 4090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(37795);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 8462:
/***/ (function(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),

/***/ 8051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return __webpack_require__.g[key] = (__webpack_require__.g[key] || 0) + 1;
};


/***/ }),

/***/ 81181:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(32177);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 32177:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(32636)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(4090);
var hasOwn = __webpack_require__(23198);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 32636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(66679);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 66679:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 67226:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(66679);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 23198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(4090);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(48570);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 62333:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 47677:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {}

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ 52635:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(67226)();
var callBound = __webpack_require__(62680);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 54277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(67226)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 58786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(62680);
var hasToStringTag = __webpack_require__(67226)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 77906:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 80594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 33958:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 18169:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 34679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(14926);
var callBind = __webpack_require__(89429);

var implementation = __webpack_require__(18169);
var getPolyfill = __webpack_require__(68070);
var shim = __webpack_require__(20191);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 68070:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(18169);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 20191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(68070);
var define = __webpack_require__(14926);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 75691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(30801); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 33464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(30801);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(75691);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 30801:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 34406:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 17296:
/***/ (function(module) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ 36908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75969);

/* harmony default export */ __webpack_exports__["Z"] = (universal_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 83029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export Consumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _Cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36908);


var CookiesContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(new _Cookies__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ __webpack_exports__["ZP"] = (CookiesContext);


/***/ }),

/***/ 47004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/CookiesContext.js
var CookiesContext = __webpack_require__(83029);
;// CONCATENATED MODULE: ../../node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ../../node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(CookiesContext/* default */.ZP);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 28304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ react_drag_drop_files_esm_E; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
// EXTERNAL MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
var stylis_browser_esm = __webpack_require__(52274);
// EXTERNAL MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(31938);
// EXTERNAL MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js + 1 modules
var emotion_is_prop_valid_browser_esm = __webpack_require__(1888);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/react-drag-drop-files/node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34406);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.5",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.5"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return"undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.5");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.5"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new stylis_browser_esm/* default */.Z(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react.createContext(),le=ue.Consumer,de=react.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react.useContext)(ue)||he}function me(){return (0,react.useContext)(de)||pe}function ye(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ue.Provider,{value:u},react.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm/* default */.Z?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react.createContext(),Le=Ge.Consumer;function Fe(e){var t=s(Ge),n=i((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.5"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,emotion_is_prop_valid_browser_esm/* default */.Z,_):!N||(0,emotion_is_prop_valid_browser_esm/* default */.Z)(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics_cjs_default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=s(Ge),l=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),d((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.5"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.5",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map

;// CONCATENATED MODULE: ../../node_modules/react-drag-drop-files/dist/react-drag-drop-files.esm.js

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var p=function(){return p=Object.assign||function(n){for(var e,r=1,t=arguments.length;r<t;r++)for(var o in e=arguments[r])Object.prototype.hasOwnProperty.call(e,o)&&(n[o]=e[o]);return n},p.apply(this,arguments)};function react_drag_drop_files_esm_d(n,e){return Object.defineProperty?Object.defineProperty(n,"raw",{value:e}):n.raw=e,n}var react_drag_drop_files_esm_c,u,f,react_drag_drop_files_esm_v,h,react_drag_drop_files_esm_x=Ce(react_drag_drop_files_esm_c||(react_drag_drop_files_esm_c=react_drag_drop_files_esm_d(["\n  display: flex;\n  align-items: center;\n  min-width: 322px;\n  max-width: 508px;\n  height: 48px;\n  border: dashed 2px ",";\n  padding: 8px 16px 8px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  flex-grow: 0;\n\n  &.is-disabled {\n    border: dashed 2px ",";\n    cursor: no-drop;\n    svg {\n      fill: ",";\n      color: ",";\n      path {\n        fill: ",";\n        color: ",";\n      }\n    }\n  }\n"],["\n  display: flex;\n  align-items: center;\n  min-width: 322px;\n  max-width: 508px;\n  height: 48px;\n  border: dashed 2px ",";\n  padding: 8px 16px 8px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  flex-grow: 0;\n\n  &.is-disabled {\n    border: dashed 2px ",";\n    cursor: no-drop;\n    svg {\n      fill: ",";\n      color: ",";\n      path {\n        fill: ",";\n        color: ",";\n      }\n    }\n  }\n"])),"#0658c2","#666","#666","#666","#666","#666"),react_drag_drop_files_esm_g=styled_components_browser_esm.label(u||(u=react_drag_drop_files_esm_d(["\n  position: relative;\n  ",";\n  &:focus-within {\n    outline: 2px solid black;\n  }\n  & > input {\n    display: block;\n    opacity: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n"],["\n  position: relative;\n  ",";\n  &:focus-within {\n    outline: 2px solid black;\n  }\n  & > input {\n    display: block;\n    opacity: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n"])),(function(n){return n.overRide?"":react_drag_drop_files_esm_x})),m=styled_components_browser_esm.div(f||(f=react_drag_drop_files_esm_d(["\n  border: dashed 2px ",";\n  border-radius: 5px;\n  background-color: ",";\n  opacity: 0.5;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  & > span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n  }\n"],["\n  border: dashed 2px ",";\n  border-radius: 5px;\n  background-color: ",";\n  opacity: 0.5;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  & > span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n  }\n"])),"#666","#999"),react_drag_drop_files_esm_b=styled_components_browser_esm.div(react_drag_drop_files_esm_v||(react_drag_drop_files_esm_v=react_drag_drop_files_esm_d(["\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n  & > span {\n    font-size: 12px;\n    color: ",";\n  }\n  .file-types {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100px;\n  }\n"],["\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n  & > span {\n    font-size: 12px;\n    color: ",";\n  }\n  .file-types {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100px;\n  }\n"])),(function(n){return n.error?"red":"#666"})),react_drag_drop_files_esm_w=styled_components_browser_esm.span(h||(h=react_drag_drop_files_esm_d(["\n  font-size: 14px;\n  color: ",";\n  span {\n    text-decoration: underline;\n  }\n"],["\n  font-size: 14px;\n  color: ",";\n  span {\n    text-decoration: underline;\n  }\n"])),"#666"),react_drag_drop_files_esm_y=function(n){return n/1e3/1e3},react_drag_drop_files_esm_z=function(n){return void 0===n?"":n.map((function(n){return".".concat(n.toLowerCase())})).join(",")};function react_drag_drop_files_esm_L(e){var r=e.types,t=e.minSize,o=e.maxSize;if(r){var i=r.toString(),a="";return o&&(a+="size >= ".concat(o,", ")),t&&(a+="size <= ".concat(t,", ")),(0,jsx_runtime.jsx)("span",p({title:"".concat(a,"types: ").concat(i),className:"file-types"},{children:i}),void 0)}return null}function react_drag_drop_files_esm_C(){return (0,jsx_runtime.jsxs)("svg",p({width:"32",height:"32",viewBox:"0 0 32 32",fill:"none",xmlns:"http://www.w3.org/2000/svg"},{children:[(0,jsx_runtime.jsx)("path",{d:"M5.33317 6.66667H22.6665V16H25.3332V6.66667C25.3332 5.196 24.1372 4 22.6665 4H5.33317C3.8625 4 2.6665 5.196 2.6665 6.66667V22.6667C2.6665 24.1373 3.8625 25.3333 5.33317 25.3333H15.9998V22.6667H5.33317V6.66667Z",fill:"#0658C2"},void 0),(0,jsx_runtime.jsx)("path",{d:"M10.6665 14.6667L6.6665 20H21.3332L15.9998 12L11.9998 17.3333L10.6665 14.6667Z",fill:"#0658C2"},void 0),(0,jsx_runtime.jsx)("path",{d:"M25.3332 18.6667H22.6665V22.6667H18.6665V25.3333H22.6665V29.3333H25.3332V25.3333H29.3332V22.6667H25.3332V18.6667Z",fill:"#0658C2"},void 0)]}),void 0)}var react_drag_drop_files_esm_H=0;var react_drag_drop_files_esm_k=function(t,o,i,a,l){return i?(0,jsx_runtime.jsx)("span",{children:"File type/size error, Hovered on types!"},void 0):(0,jsx_runtime.jsx)(react_drag_drop_files_esm_w,{children:a?(0,jsx_runtime.jsx)("span",{children:"Upload disabled"},void 0):t||o?(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[(0,jsx_runtime.jsx)("span",{children:"Uploaded Successfully!"},void 0)," Upload another?"]},void 0):(0,jsx_runtime.jsx)(jsx_runtime.Fragment,{children:(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,l?{children:[(0,jsx_runtime.jsx)("span",{children:l.split(" ")[0]},void 0)," ",l.substr(l.indexOf(" ")+1)]}:{children:[(0,jsx_runtime.jsx)("span",{children:"Upload"},void 0)," or drop a file right here"]},void 0)},void 0)},void 0)},react_drag_drop_files_esm_E=function(t){var o=t.name,d=t.hoverTitle,c=t.types,u=t.handleChange,f=t.classes,v=t.children,h=t.maxSize,x=t.minSize,w=t.fileOrFiles,E=t.onSizeError,S=t.onTypeError,V=t.onSelect,D=t.onDrop,P=t.disabled,j=t.label,F=t.multiple,O=t.required,R=t.onDraggingStateChange,T=t.dropMessageStyle,M=(0,react.useRef)(null),U=(0,react.useRef)(null),Z=(0,react.useState)(!1),q=Z[0],N=Z[1],X=(0,react.useState)(null),Y=X[0],B=X[1],A=(0,react.useState)(!1),G=A[0],I=A[1],J=function(n){return c&&!function(n,e){var r=n.name.split(".").pop();return e.map((function(n){return n.toLowerCase()})).includes(r.toLowerCase())}(n,c)?(I(!0),S&&S("File type is not supported"),!1):h&&react_drag_drop_files_esm_y(n.size)>h?(I(!0),E&&E("File size is too big"),!1):!(x&&react_drag_drop_files_esm_y(n.size)<x)||(I(!0),E&&E("File size is too small"),!1)},K=function(n){var e=!1;if(n){if(n instanceof File)e=!J(n);else for(var r=0;r<n.length;r++){var t=n[r];e=!J(t)||e}return!e&&(u&&u(n),B(n),N(!0),I(!1),!0)}return!1},Q=function(n){var e=n.labelRef,r=n.inputRef,t=n.multiple,o=n.handleChanges,s=n.onDrop,p=(0,react.useState)(!1),d=p[0],c=p[1],u=(0,react.useCallback)((function(){r.current.click()}),[r]),f=(0,react.useCallback)((function(n){n.preventDefault(),n.stopPropagation(),react_drag_drop_files_esm_H++,n.dataTransfer.items&&0!==n.dataTransfer.items.length&&c(!0)}),[]),v=(0,react.useCallback)((function(n){n.preventDefault(),n.stopPropagation(),--react_drag_drop_files_esm_H>0||c(!1)}),[]),h=(0,react.useCallback)((function(n){n.preventDefault(),n.stopPropagation()}),[]),x=(0,react.useCallback)((function(n){n.preventDefault(),n.stopPropagation(),c(!1),react_drag_drop_files_esm_H=0;var e=n.dataTransfer.files;if(e&&e.length>0){var r=t?e:e[0],i=o(r);s&&i&&s(r)}}),[o]);return (0,react.useEffect)((function(){var n=e.current;return n.addEventListener("click",u),n.addEventListener("dragenter",f),n.addEventListener("dragleave",v),n.addEventListener("dragover",h),n.addEventListener("drop",x),function(){n.removeEventListener("click",u),n.removeEventListener("dragenter",f),n.removeEventListener("dragleave",v),n.removeEventListener("dragover",h),n.removeEventListener("drop",x)}}),[u,f,v,h,x,e]),d}({labelRef:M,inputRef:U,multiple:F,handleChanges:K,onDrop:D});return (0,react.useEffect)((function(){null==R||R(Q)}),[Q]),(0,react.useEffect)((function(){w?(N(!0),B(w)):(U.current&&(U.current.value=""),N(!1),B(null))}),[w]),(0,jsx_runtime.jsxs)(react_drag_drop_files_esm_g,p({overRide:v,className:"".concat(f||""," ").concat(P?"is-disabled":""),ref:M,htmlFor:o,onClick:function(n){n.preventDefault(),n.stopPropagation()}},{children:[(0,jsx_runtime.jsx)("input",{onClick:function(n){n.stopPropagation(),U&&U.current&&(U.current.value="",U.current.click())},onChange:function(n){var e=n.target.files,r=F?e:e[0],t=K(r);V&&t&&V(r)},accept:react_drag_drop_files_esm_z(c),ref:U,type:"file",name:o,disabled:P,multiple:F,required:O},void 0),Q&&(0,jsx_runtime.jsx)(m,p({style:T},{children:(0,jsx_runtime.jsx)("span",{children:d||"Drop Here"},void 0)}),void 0),!v&&(0,jsx_runtime.jsxs)(jsx_runtime.Fragment,{children:[(0,jsx_runtime.jsx)(react_drag_drop_files_esm_C,{},void 0),(0,jsx_runtime.jsxs)(react_drag_drop_files_esm_b,p({error:G},{children:[react_drag_drop_files_esm_k(Y,q,G,P,j),(0,jsx_runtime.jsx)(react_drag_drop_files_esm_L,{types:c,minSize:x,maxSize:h},void 0)]}),void 0)]},void 0),v]}),void 0)};


/***/ }),

/***/ 71648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JP": function() { return /* binding */ getDefaults; },
/* harmony export */   "OO": function() { return /* binding */ I18nContext; },
/* harmony export */   "nI": function() { return /* binding */ getI18n; },
/* harmony export */   "zv": function() { return /* binding */ ReportNamespaces; }
/* harmony export */ });
/* unused harmony exports setDefaults, setI18n, initReactI18next, composeInitialProps, getInitialProps */
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9249);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87371);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56666);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true
};
var i18nInstance;
var I18nContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),

/***/ 29463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ useTranslation; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/context.js
var context = __webpack_require__(71648);
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/utils.js
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context/* I18nContext */.OO) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || (0,context/* getI18n */.nI)();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new context/* ReportNamespaces */.zv();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, (0,context/* getDefaults */.JP)()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 46847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "ZP", ({
  enumerable: true,
  get: function get() {
    return _skeleton.default;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _skeletonTheme.default;
  }
});

var _skeleton = _interopRequireDefault(__webpack_require__(68334));

var _skeletonTheme = _interopRequireDefault(__webpack_require__(98432));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 98432:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _core = __webpack_require__(30957);

var _skeleton = __webpack_require__(68334);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SkeletonTheme =
/*#__PURE__*/
function (_Component) {
  _inherits(SkeletonTheme, _Component);

  function SkeletonTheme() {
    _classCallCheck(this, SkeletonTheme);

    return _possibleConstructorReturn(this, _getPrototypeOf(SkeletonTheme).apply(this, arguments));
  }

  _createClass(SkeletonTheme, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          highlightColor = _this$props.highlightColor,
          children = _this$props.children;
      var themeStyles =
      /*#__PURE__*/
      (0, _core.css)(".react-loading-skeleton{background-color:", color, ";background-image:linear-gradient( 90deg,", color, ",", highlightColor, ",", color, " );};label:SkeletonTheme;" + ( true ? "" : 0));
      return (0, _core.jsx)("div", {
        css: themeStyles
      }, children);
    }
  }]);

  return SkeletonTheme;
}(_react.Component);

exports["default"] = SkeletonTheme;

_defineProperty(SkeletonTheme, "defaultProps", {
  color: _skeleton.defaultBaseColor,
  highlightColor: _skeleton.defaultHighlightColor
});

/***/ }),

/***/ 68334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = Skeleton;
exports.skeletonStyles = exports.skeletonKeyframes = exports.defaultHighlightColor = exports.defaultBaseColor = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _core = __webpack_require__(30957);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200px 0;\n  }\n  ", "\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultBaseColor = "#eee";
exports.defaultBaseColor = defaultBaseColor;
var defaultHighlightColor = "#f5f5f5";
exports.defaultHighlightColor = defaultHighlightColor;

var skeletonKeyframes = function skeletonKeyframes(duration, delay) {
  return (0, _core.keyframes)(_templateObject(), delay > 0 ? "".concat(Math.floor(1 / (duration + delay) * duration * 100), "% {\n    background-position: calc(200px + 100%) 0;\n  }") : undefined);
};

exports.skeletonKeyframes = skeletonKeyframes;
var skeletonStyles =
/*#__PURE__*/
(0, _core.css)("background-color:", defaultBaseColor, ";background-image:linear-gradient( 90deg,", defaultBaseColor, ",", defaultHighlightColor, ",", defaultBaseColor, " );background-size:200px 100%;background-repeat:no-repeat;border-radius:4px;display:inline-block;line-height:1;width:100%;;label:skeletonStyles;" + ( true ? "" : 0));
exports.skeletonStyles = skeletonStyles;

function Skeleton(_ref) {
  var count = _ref.count,
      duration = _ref.duration,
      width = _ref.width,
      Wrapper = _ref.wrapper,
      height = _ref.height,
      circle = _ref.circle,
      delay = _ref.delay,
      customStyle = _ref.style,
      customClassName = _ref.className;
  var elements = [];

  for (var i = 0; i < count; i++) {
    var style = {};

    if (width !== null) {
      style.width = width;
    }

    if (height !== null) {
      style.height = height;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = "50%";
    }

    var className = "react-loading-skeleton";

    if (customClassName) {
      className += " " + customClassName;
    }

    elements.push((0, _core.jsx)("span", {
      key: i,
      className: className,
      css:
      /*#__PURE__*/
      (0, _core.css)(skeletonStyles, " animation:", skeletonKeyframes(duration, delay), " ", duration + delay, "s ease-in-out infinite;label:Skeleton;" + ( true ? "" : 0)),
      style: _objectSpread({}, customStyle, {}, style)
    }, "\u200C"));
  }

  return (0, _core.jsx)("span", null, Wrapper ? elements.map(function (element, i) {
    return (0, _core.jsx)(Wrapper, {
      key: i
    }, element, "\u200C");
  }) : elements);
}

Skeleton.defaultProps = {
  count: 1,
  duration: 1.2,
  width: null,
  wrapper: null,
  height: null,
  circle: false,
  delay: 0
};

/***/ }),

/***/ 42901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28316);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(10742);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(66941);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(6259);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46847);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 10742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2784);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(77194);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(90026);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(66941);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(95853);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(6259);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(66638);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(26736);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 66941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(45982);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(6259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 26736:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(66638);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 95853:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 77194:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(93970);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 66638:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 6259:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(85978);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 90026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(93970);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 93970:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 37149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(42901);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 90934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ ManagerReferenceNodeContext; },
/* harmony export */   "ZP": function() { return /* binding */ Manager; },
/* harmony export */   "mq": function() { return /* binding */ ManagerReferenceNodeSetterContext; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81665);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80753);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56666);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _hypnosphi_create_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22241);
/* harmony import */ var _hypnosphi_create_react_context__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_hypnosphi_create_react_context__WEBPACK_IMPORTED_MODULE_1__);





var ManagerReferenceNodeContext = _hypnosphi_create_react_context__WEBPACK_IMPORTED_MODULE_1___default()();
var ManagerReferenceNodeSetterContext = _hypnosphi_create_react_context__WEBPACK_IMPORTED_MODULE_1___default()();

var Manager =
/*#__PURE__*/
function (_React$Component) {
  (0,_babel_runtime_helpers_inheritsLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Manager, _React$Component);

  function Manager() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_this)), "referenceNode", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_this)), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;

        _this.forceUpdate();
      }
    });

    return _this;
  }

  var _proto = Manager.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };

  _proto.render = function render() {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, react__WEBPACK_IMPORTED_MODULE_0__.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };

  return Manager;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);



/***/ }),

/***/ 56885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Popper_Popper; },
  "Ct": function() { return /* binding */ Popper_placements; }
});

// UNUSED EXPORTS: InnerPopper

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react-popper/node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(41388);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/popper.js/dist/esm/popper.js
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var popper_defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, popper_defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), popper_defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return popper_defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return popper_defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: popper_defineProperty({}, side, reference[side]),
      end: popper_defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ var popper = (Popper);
//# sourceMappingURL=popper.js.map

// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/Manager.js
var Manager = __webpack_require__(90934);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/utils.js
var utils = __webpack_require__(60855);
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/Popper.js










var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "state", {
      data: undefined,
      placement: undefined
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "popperInstance", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "popperNode", null);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "arrowNode", null);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      (0,utils/* setRef */.k$)(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: (0,esm_extends/* default */.Z)({}, _this.props.modifiers, {
          arrow: (0,esm_extends/* default */.Z)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : (0,esm_extends/* default */.Z)({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = (0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new popper(referenceElement, popperNode, _this.getOptions());
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deep_equal_default()(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      if (false) {}

      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    (0,utils/* setRef */.k$)(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return (0,utils/* unwrapArray */.$p)(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(react.Component);

(0,defineProperty/* default */.Z)(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var Popper_placements = popper.placements;

function Popper_Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["referenceElement"]);

  return react.createElement(Manager/* ManagerReferenceNodeContext.Consumer */.C8.Consumer, null, function (referenceNode) {
    return react.createElement(InnerPopper, (0,esm_extends/* default */.Z)({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),

/***/ 42397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Manager": function() { return /* reexport */ Manager/* default */.ZP; },
  "Popper": function() { return /* reexport */ Popper/* default */.ZP; },
  "Reference": function() { return /* reexport */ Reference; },
  "placements": function() { return /* reexport */ Popper/* placements */.Ct; }
});

// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/Popper.js + 1 modules
var Popper = __webpack_require__(56885);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/Manager.js
var Manager = __webpack_require__(90934);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(45982);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/utils.js
var utils = __webpack_require__(60855);
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/Reference.js









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this)), "refHandler", function (node) {
      (0,utils/* setRef */.k$)(_this.props.innerRef, node);
      (0,utils/* safeInvoke */.DL)(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    (0,utils/* setRef */.k$)(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return (0,utils/* unwrapArray */.$p)(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(react.Component);

function Reference(props) {
  return react.createElement(Manager/* ManagerReferenceNodeSetterContext.Consumer */.mq.Consumer, null, function (setReferenceNode) {
    return react.createElement(InnerReference, (0,esm_extends/* default */.Z)({
      setReferenceNode: setReferenceNode
    }, props));
  });
}
;// CONCATENATED MODULE: ../../node_modules/react-popper/lib/esm/index.js
// Public components



 // Public types

/***/ }),

/***/ 60855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ unwrapArray; },
/* harmony export */   "DL": function() { return /* binding */ safeInvoke; },
/* harmony export */   "k$": function() { return /* binding */ setRef; }
/* harmony export */ });
/* unused harmony export shallowEqual */
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (bKeys.length !== aKeys.length) {
    return false;
  }

  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];

    if (objA[key] !== objB[key]) {
      return false;
    }
  }

  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};

/***/ }),

/***/ 41388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectKeys = __webpack_require__(33464);
var isArguments = __webpack_require__(52635);
var is = __webpack_require__(34679);
var isRegex = __webpack_require__(58786);
var flags = __webpack_require__(82201);
var isDate = __webpack_require__(54277);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),

/***/ 17783:
/***/ (function(module) {

if (true) {
  module.exports = {
    ReactQueryDevtools: function () {
      return null
    },
    ReactQueryDevtoolsPanel: function () {
      return null
    },
  }
} else {}


/***/ }),

/***/ 27483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81665);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92693);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10774);



var FocusManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var focusManager = new FocusManager();

/***/ }),

/***/ 60002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _queryClient__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _queryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92982);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77820);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types__WEBPACK_IMPORTED_MODULE_1__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _types__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; } });














 // Types



/***/ }),

/***/ 20560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22348);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10774);


function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getAbortController */ .G9)();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if ((0,_retryer__WEBPACK_IMPORTED_MODULE_1__/* .isCancelable */ .LE)(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    var nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    var previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}

/***/ }),

/***/ 53579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ setLogger; },
/* harmony export */   "j": function() { return /* binding */ getLogger; }
/* harmony export */ });
// TYPES
// FUNCTIONS
var logger = console;
function getLogger() {
  return logger;
}
function setLogger(newLogger) {
  logger = newLogger;
}

/***/ }),

/***/ 3284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);
/* harmony import */ var _logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53579);
/* harmony import */ var _notifyManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50667);
/* harmony import */ var _retryer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22348);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10774);




 // TYPES

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT).catch(_utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      (0,_logger__WEBPACK_IMPORTED_MODULE_2__/* .getLogger */ .j)().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new _retryer__WEBPACK_IMPORTED_MODULE_3__/* .Retryer */ .m4({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer(this.state, action);
    _notifyManager__WEBPACK_IMPORTED_MODULE_4__/* .notifyManager.batch */ .V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'failed':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: true
      });

    case 'continue':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        isPaused: false
      });

    case 'loading':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, state, action.state);

    default:
      return state;
  }
}

/***/ }),

/***/ 50667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export NotifyManager */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10774);
 // TYPES

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

/***/ }),

/***/ 58927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81665);
/* harmony import */ var _subscribable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92693);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10774);



var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(_subscribable__WEBPACK_IMPORTED_MODULE_2__/* .Subscribable */ .l);
var onlineManager = new OnlineManager();

/***/ }),

/***/ 92982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(10774);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(50667);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(53579);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(22348);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/query.js




 // TYPES

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = (0,esm_extends/* default */.Z)({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if ((0,utils/* isValidTimeout */.PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = (0,utils/* functionalUpdate */.SE)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = (0,utils/* replaceEqualDeep */.Q$)(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = (0,utils/* ensureQueryKeyArray */.mc)(this.queryKey);
    var abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new retryer/* Retryer */.m4({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!(0,retryer/* isCancelledError */.DV)(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          (0,logger/* getLogger */.j)().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: true
        });

      case 'continue':
        return (0,esm_extends/* default */.Z)({}, state, {
          isPaused: false
        });

      case 'fetch':
        return (0,esm_extends/* default */.Z)({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return (0,esm_extends/* default */.Z)({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
          return (0,esm_extends/* default */.Z)({}, this.revertState);
        }

        return (0,esm_extends/* default */.Z)({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return (0,esm_extends/* default */.Z)({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return (0,esm_extends/* default */.Z)({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(92693);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/queryCache.js





// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return (0,utils/* matchQuery */._x)(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/mutation.js
var core_mutation = __webpack_require__(3284);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/mutationCache.js




 // TYPES

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new core_mutation/* Mutation */.m({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return (0,utils/* matchMutation */.X7)(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(utils/* noop */.ZT);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(subscribable/* Subscribable */.l);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(27483);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/onlineManager.js
var onlineManager = __webpack_require__(58927);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(20560);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/queryClient.js








// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(function () {
      if (focusManager/* focusManager.isFocused */.j.isFocused() && onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll((0,esm_extends/* default */.Z)({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      active: true
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = (0,esm_extends/* default */.Z)({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager/* notifyManager.batch */.V.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, (0,esm_extends/* default */.Z)({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager/* notifyManager.batch */.V.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = (0,esm_extends/* default */.Z)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return (0,esm_extends/* default */.Z)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

/***/ }),

/***/ 22348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "LE": function() { return /* binding */ isCancelable; },
/* harmony export */   "m4": function() { return /* binding */ Retryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27483);
/* harmony import */ var _onlineManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58927);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10774);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!_focusManager__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || !_onlineManager__WEBPACK_IMPORTED_MODULE_2__/* .onlineManager.isOnline */ .N.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

/***/ }),

/***/ 92693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

/***/ }),

/***/ 77820:
/***/ (function() {



/***/ }),

/***/ 10774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Q$": function() { return /* binding */ replaceEqualDeep; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "mc": function() { return /* binding */ ensureQueryKeyArray; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, replaceAt, parseMutationFilterArgs, mapQueryStatusFilter, stableValueHash, partialDeepEqual, isPlainObject, isQueryKey, isError */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7896);

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function difference(array1, array2) {
  return array1.filter(function (x) {
    return array2.indexOf(x) === -1;
  });
}
function replaceAt(array, index, value) {
  var copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  });
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg3, {
        mutationKey: arg1,
        mutationFn: arg2
      });
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationKey: arg1
    });
  }

  if (typeof arg1 === 'function') {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
      mutationFn: arg1
    });
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2) {
  return isQueryKey(arg1) ? _extends({}, arg2, {
    mutationKey: arg1
  }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

/***/ }),

/***/ 82066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QueryClient": function() { return /* reexport safe */ _core__WEBPACK_IMPORTED_MODULE_0__.QueryClient; },
/* harmony export */   "QueryClientProvider": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider; },
/* harmony export */   "useInfiniteQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useInfiniteQuery; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useQueryClient": function() { return /* reexport safe */ _react__WEBPACK_IMPORTED_MODULE_1__.useQueryClient; }
/* harmony export */ });
/* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60002);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "QueryClientProvider")) __webpack_require__.d(__webpack_exports__, { "QueryClientProvider": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.QueryClientProvider; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useInfiniteQuery")) __webpack_require__.d(__webpack_exports__, { "useInfiniteQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core__WEBPACK_IMPORTED_MODULE_0__, "useQueryClient")) __webpack_require__.d(__webpack_exports__, { "useQueryClient": function() { return _core__WEBPACK_IMPORTED_MODULE_0__.useQueryClient; } });
/* harmony import */ var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73973);



/***/ }),

/***/ 73973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "QueryClientProvider": function() { return /* reexport */ QueryClientProvider; },
  "useInfiniteQuery": function() { return /* reexport */ useInfiniteQuery; },
  "useMutation": function() { return /* reexport */ useMutation; },
  "useQuery": function() { return /* reexport */ useQuery; },
  "useQueryClient": function() { return /* reexport */ useQueryClient; }
});

// UNUSED EXPORTS: Hydrate, QueryErrorResetBoundary, useHydrate, useIsFetching, useIsMutating, useQueries, useQueryErrorResetBoundary

// EXTERNAL MODULE: ../../node_modules/react-query/es/core/notifyManager.js
var notifyManager = __webpack_require__(50667);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/reactBatchedUpdates.js

var unstable_batchedUpdates = react_dom.unstable_batchedUpdates;
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/setBatchUpdatesFn.js


notifyManager/* notifyManager.setBatchNotifyFunction */.V.setBatchNotifyFunction(unstable_batchedUpdates);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/logger.js
var logger = __webpack_require__(53579);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/logger.js
var logger_logger = console;
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/setLogger.js


(0,logger/* setLogger */.E)(logger_logger);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/QueryClientProvider.js

var defaultContext = /*#__PURE__*/react.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/react.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = react.useContext(getQueryClientContext(react.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  react.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/react.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/react.createElement(Context.Provider, {
    value: client
  }, children));
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/utils.js
var utils = __webpack_require__(10774);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/mutation.js
var mutation = __webpack_require__(3284);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/subscribable.js
var subscribable = __webpack_require__(92693);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/mutationObserver.js





// CLASS
var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(MutationObserver, _Subscribable);

  function MutationObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;

    _this.setOptions(options);

    _this.bindMethods();

    _this.updateResult();

    return _this;
  }

  var _proto = MutationObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  };

  _proto.setOptions = function setOptions(options) {
    this.options = this.client.defaultMutationOptions(options);
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  };

  _proto.onMutationUpdate = function onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    var notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.reset = function reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  };

  _proto.mutate = function mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, (0,esm_extends/* default */.Z)({}, this.options, {
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    }));
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  };

  _proto.updateResult = function updateResult() {
    var state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();

    var result = (0,esm_extends/* default */.Z)({}, state, {
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    });

    this.currentResult = result;
  };

  _proto.notify = function notify(options) {
    var _this2 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the mutate callbacks
      if (_this2.mutateOptions) {
        if (options.onSuccess) {
          _this2.mutateOptions.onSuccess == null ? void 0 : _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
        } else if (options.onError) {
          _this2.mutateOptions.onError == null ? void 0 : _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
          _this2.mutateOptions.onSettled == null ? void 0 : _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        _this2.listeners.forEach(function (listener) {
          listener(_this2.currentResult);
        });
      }
    });
  };

  return MutationObserver;
}(subscribable/* Subscribable */.l);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/utils.js
function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/useMutation.js






 // HOOK

function useMutation(arg1, arg2, arg3) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  var queryClient = useQueryClient();
  var obsRef = react.useRef();

  if (!obsRef.current) {
    obsRef.current = new MutationObserver(queryClient, options);
  } else {
    obsRef.current.setOptions(options);
  }

  var currentResult = obsRef.current.getCurrentResult();
  react.useEffect(function () {
    mountedRef.current = true;
    var unsubscribe = obsRef.current.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    }));
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, []);
  var mutate = react.useCallback(function (variables, mutateOptions) {
    obsRef.current.mutate(variables, mutateOptions).catch(utils/* noop */.ZT);
  }, []);

  if (currentResult.error && shouldThrowError(undefined, obsRef.current.options.useErrorBoundary, [currentResult.error])) {
    throw currentResult.error;
  }

  return (0,esm_extends/* default */.Z)({}, currentResult, {
    mutate: mutate,
    mutateAsync: currentResult.mutate
  });
}
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/focusManager.js
var focusManager = __webpack_require__(27483);
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/retryer.js
var retryer = __webpack_require__(22348);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/queryObserver.js








var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  (0,inheritsLoose/* default */.Z)(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.previousSelectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch((0,esm_extends/* default */.Z)({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    var time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        var _this$previousSelect;

        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === ((_this$previousSelect = this.previousSelect) == null ? void 0 : _this$previousSelect.fn) && !this.previousSelectError) {
          data = this.previousSelect.result;
        } else {
          try {
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.previousSelect = {
              fn: options.select,
              result: data
            };
            this.previousSelectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = (0,utils/* replaceEqualDeep */.Q$)(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.previousSelectError = null;
          } catch (selectError) {
            (0,logger/* getLogger */.j)().error(selectError);
            error = selectError;
            this.previousSelectError = selectError;
            errorUpdatedAt = Date.now();
            status = 'error';
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify((0,esm_extends/* default */.Z)({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager/* notifyManager.batch */.V.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(subscribable/* Subscribable */.l);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/QueryErrorResetBoundary.js
 // CONTEXT

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return react.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
  var children = _ref.children;
  var value = React.useMemo(function () {
    return createValue();
  }, []);
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/useBaseQuery.js





function useBaseQuery(options, Observer) {
  var mountedRef = react.useRef(false);

  var _React$useState = react.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = react.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  react.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  react.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/useQuery.js


 // HOOK

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}
// EXTERNAL MODULE: ../../node_modules/react-query/es/core/infiniteQueryBehavior.js
var infiniteQueryBehavior = __webpack_require__(20560);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/core/infiniteQueryObserver.js




var InfiniteQueryObserver = /*#__PURE__*/function (_QueryObserver) {
  (0,inheritsLoose/* default */.Z)(InfiniteQueryObserver, _QueryObserver);

  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function InfiniteQueryObserver(client, options) {
    return _QueryObserver.call(this, client, options) || this;
  }

  var _proto = InfiniteQueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    _QueryObserver.prototype.bindMethods.call(this);

    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    _QueryObserver.prototype.setOptions.call(this, (0,esm_extends/* default */.Z)({}, options, {
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }), notifyOptions);
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return _QueryObserver.prototype.getOptimisticResult.call(this, options);
  };

  _proto.fetchNextPage = function fetchNextPage(options) {
    var _options$cancelRefetc;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.fetchPreviousPage = function fetchPreviousPage(options) {
    var _options$cancelRefetc2;

    return this.fetch({
      // TODO consider removing `?? true` in future breaking change, to be consistent with `refetch` API (see https://github.com/tannerlinsley/react-query/issues/2617)
      cancelRefetch: (_options$cancelRefetc2 = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc2 : true,
      throwOnError: options == null ? void 0 : options.throwOnError,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam: options == null ? void 0 : options.pageParam
        }
      }
    });
  };

  _proto.createResult = function createResult(query, options) {
    var _state$data, _state$data2, _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet;

    var state = query.state;

    var result = _QueryObserver.prototype.createResult.call(this, query, options);

    return (0,esm_extends/* default */.Z)({}, result, {
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage: state.isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward',
      isFetchingPreviousPage: state.isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward'
    });
  };

  return InfiniteQueryObserver;
}(QueryObserver);
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/useInfiniteQuery.js


 // HOOK

function useInfiniteQuery(arg1, arg2, arg3) {
  var options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(options, InfiniteQueryObserver);
}
;// CONCATENATED MODULE: ../../node_modules/react-query/es/react/index.js
// Side effects










 // Types



/***/ }),

/***/ 99438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ isMobileDevice; },
  "B": function() { return /* binding */ multiValueAsValue; },
  "C": function() { return /* binding */ singleValueAsValue; },
  "D": function() { return /* binding */ valueTernary; },
  "E": function() { return /* binding */ classNames; },
  "F": function() { return /* binding */ defaultComponents; },
  "G": function() { return /* binding */ isDocumentElement; },
  "H": function() { return /* binding */ cleanValue; },
  "I": function() { return /* binding */ scrollIntoView; },
  "J": function() { return /* binding */ noop; },
  "K": function() { return /* binding */ notNullish; },
  "L": function() { return /* binding */ handleInputChange; },
  "M": function() { return /* binding */ MenuPlacer; },
  "a": function() { return /* binding */ clearIndicatorCSS; },
  "b": function() { return /* binding */ containerCSS; },
  "c": function() { return /* binding */ components; },
  "d": function() { return /* binding */ css$1; },
  "e": function() { return /* binding */ dropdownIndicatorCSS; },
  "f": function() { return /* binding */ groupHeadingCSS; },
  "g": function() { return /* binding */ groupCSS; },
  "h": function() { return /* binding */ indicatorSeparatorCSS; },
  "i": function() { return /* binding */ indicatorsContainerCSS; },
  "j": function() { return /* binding */ inputCSS; },
  "k": function() { return /* binding */ loadingMessageCSS; },
  "l": function() { return /* binding */ loadingIndicatorCSS; },
  "m": function() { return /* binding */ menuCSS; },
  "n": function() { return /* binding */ menuListCSS; },
  "o": function() { return /* binding */ menuPortalCSS; },
  "p": function() { return /* binding */ multiValueCSS; },
  "q": function() { return /* binding */ multiValueLabelCSS; },
  "r": function() { return /* binding */ removeProps; },
  "s": function() { return /* binding */ supportsPassiveEvents; },
  "t": function() { return /* binding */ multiValueRemoveCSS; },
  "u": function() { return /* binding */ noOptionsMessageCSS; },
  "v": function() { return /* binding */ optionCSS; },
  "w": function() { return /* binding */ placeholderCSS; },
  "x": function() { return /* binding */ css; },
  "y": function() { return /* binding */ valueContainerCSS; },
  "z": function() { return /* binding */ isTouchCapable; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(33028);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t){return t.split("-")[1]}function floating_ui_core_browser_min_e(t){return"y"===t?"height":"width"}function n(t){return t.split("-")[0]}function o(t){return["top","bottom"].includes(n(t))?"x":"y"}function r(r,i,a){let{reference:l,floating:s}=r;const c=l.x+l.width/2-s.width/2,f=l.y+l.height/2-s.height/2,u=o(i),m=floating_ui_core_browser_min_e(u),g=l[m]/2-s[m]/2,d="x"===u;let p;switch(n(i)){case"top":p={x:c,y:l.y-s.height};break;case"bottom":p={x:c,y:l.y+l.height};break;case"right":p={x:l.x+l.width,y:f};break;case"left":p={x:l.x-s.width,y:f};break;default:p={x:l.x,y:l.y}}switch(t(i)){case"start":p[u]-=g*(a&&d?-1:1);break;case"end":p[u]+=g*(a&&d?-1:1)}return p}const i=async(t,e,n)=>{const{placement:o="bottom",strategy:i="absolute",middleware:a=[],platform:l}=n,s=a.filter(Boolean),c=await(null==l.isRTL?void 0:l.isRTL(e));let f=await l.getElementRects({reference:t,floating:e,strategy:i}),{x:u,y:m}=r(f,o,c),g=o,d={},p=0;for(let n=0;n<s.length;n++){const{name:a,fn:h}=s[n],{x:y,y:x,data:w,reset:v}=await h({x:u,y:m,initialPlacement:o,placement:g,strategy:i,middlewareData:d,rects:f,platform:l,elements:{reference:t,floating:e}});u=null!=y?y:u,m=null!=x?x:m,d={...d,[a]:{...d[a],...w}},v&&p<=50&&(p++,"object"==typeof v&&(v.placement&&(g=v.placement),v.rects&&(f=!0===v.rects?await l.getElementRects({reference:t,floating:e,strategy:i}):v.rects),({x:u,y:m}=r(f,g,c))),n=-1)}return{x:u,y:m,placement:g,strategy:i,middlewareData:d}};function a(t){return"number"!=typeof t?function(t){return{top:0,right:0,bottom:0,left:0,...t}}(t):{top:t,right:t,bottom:t,left:t}}function floating_ui_core_browser_min_l(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}async function s(t,e){var n;void 0===e&&(e={});const{x:o,y:r,platform:i,rects:s,elements:c,strategy:f}=t,{boundary:u="clippingAncestors",rootBoundary:m="viewport",elementContext:g="floating",altBoundary:d=!1,padding:p=0}=e,h=a(p),y=c[d?"floating"===g?"reference":"floating":g],x=floating_ui_core_browser_min_l(await i.getClippingRect({element:null==(n=await(null==i.isElement?void 0:i.isElement(y)))||n?y:y.contextElement||await(null==i.getDocumentElement?void 0:i.getDocumentElement(c.floating)),boundary:u,rootBoundary:m,strategy:f})),w="floating"===g?{...s.floating,x:o,y:r}:s.reference,v=await(null==i.getOffsetParent?void 0:i.getOffsetParent(c.floating)),b=await(null==i.isElement?void 0:i.isElement(v))&&await(null==i.getScale?void 0:i.getScale(v))||{x:1,y:1},R=floating_ui_core_browser_min_l(i.convertOffsetParentRelativeRectToViewportRelativeRect?await i.convertOffsetParentRelativeRectToViewportRelativeRect({rect:w,offsetParent:v,strategy:f}):w);return{top:(x.top-R.top+h.top)/b.y,bottom:(R.bottom-x.bottom+h.bottom)/b.y,left:(x.left-R.left+h.left)/b.x,right:(R.right-x.right+h.right)/b.x}}const c=Math.min,f=Math.max;function u(t,e,n){return f(t,c(e,n))}const m=n=>({name:"arrow",options:n,async fn(r){const{element:i,padding:l=0}=n||{},{x:s,y:c,placement:f,rects:m,platform:g}=r;if(null==i)return{};const d=a(l),p={x:s,y:c},h=o(f),y=floating_ui_core_browser_min_e(h),x=await g.getDimensions(i),w="y"===h?"top":"left",v="y"===h?"bottom":"right",b=m.reference[y]+m.reference[h]-p[h]-m.floating[y],R=p[h]-m.reference[h],A=await(null==g.getOffsetParent?void 0:g.getOffsetParent(i));let P=A?"y"===h?A.clientHeight||0:A.clientWidth||0:0;0===P&&(P=m.floating[y]);const T=b/2-R/2,O=d[w],D=P-x[y]-d[v],E=P/2-x[y]/2+T,L=u(O,E,D),k=null!=t(f)&&E!=L&&m.reference[y]/2-(E<O?d[w]:d[v])-x[y]/2<0;return{[h]:p[h]-(k?E<O?O-E:D-E:0),data:{[h]:L,centerOffset:E-L}}}}),g=["top","right","bottom","left"],d=g.reduce(((t,e)=>t.concat(e,e+"-start",e+"-end")),[]),p={left:"right",right:"left",bottom:"top",top:"bottom"};function h(t){return t.replace(/left|right|bottom|top/g,(t=>p[t]))}function y(n,r,i){void 0===i&&(i=!1);const a=t(n),l=o(n),s=floating_ui_core_browser_min_e(l);let c="x"===l?a===(i?"end":"start")?"right":"left":"start"===a?"bottom":"top";return r.reference[s]>r.floating[s]&&(c=h(c)),{main:c,cross:h(c)}}const x={start:"end",end:"start"};function w(t){return t.replace(/start|end/g,(t=>x[t]))}const v=function(e){return void 0===e&&(e={}),{name:"autoPlacement",options:e,async fn(o){var r,i,a;const{rects:l,middlewareData:c,placement:f,platform:u,elements:m}=o,{crossAxis:g=!1,alignment:p,allowedPlacements:h=d,autoAlignment:x=!0,...v}=e,b=void 0!==p||h===d?function(e,o,r){return(e?[...r.filter((n=>t(n)===e)),...r.filter((n=>t(n)!==e))]:r.filter((t=>n(t)===t))).filter((n=>!e||t(n)===e||!!o&&w(n)!==n))}(p||null,x,h):h,R=await s(o,v),A=(null==(r=c.autoPlacement)?void 0:r.index)||0,P=b[A];if(null==P)return{};const{main:T,cross:O}=y(P,l,await(null==u.isRTL?void 0:u.isRTL(m.floating)));if(f!==P)return{reset:{placement:b[0]}};const D=[R[n(P)],R[T],R[O]],E=[...(null==(i=c.autoPlacement)?void 0:i.overflows)||[],{placement:P,overflows:D}],L=b[A+1];if(L)return{data:{index:A+1,overflows:E},reset:{placement:L}};const k=E.map((e=>{const n=t(e.placement);return[e.placement,n&&g?e.overflows.slice(0,2).reduce(((t,e)=>t+e),0):e.overflows[0],e.overflows]})).sort(((t,e)=>t[1]-e[1])),B=(null==(a=k.filter((e=>e[2].slice(0,t(e[0])?2:3).every((t=>t<=0))))[0])?void 0:a[0])||k[0][0];return B!==f?{data:{index:A+1,overflows:E},reset:{placement:B}}:{}}}};const b=function(e){return void 0===e&&(e={}),{name:"flip",options:e,async fn(o){var r;const{placement:i,middlewareData:a,rects:l,initialPlacement:c,platform:f,elements:u}=o,{mainAxis:m=!0,crossAxis:g=!0,fallbackPlacements:d,fallbackStrategy:p="bestFit",fallbackAxisSideDirection:x="none",flipAlignment:v=!0,...b}=e,R=n(i),A=n(c)===c,P=await(null==f.isRTL?void 0:f.isRTL(u.floating)),T=d||(A||!v?[h(c)]:function(t){const e=h(t);return[w(t),e,w(e)]}(c));d||"none"===x||T.push(...function(e,o,r,i){const a=t(e);let l=function(t,e,n){const o=["left","right"],r=["right","left"],i=["top","bottom"],a=["bottom","top"];switch(t){case"top":case"bottom":return n?e?r:o:e?o:r;case"left":case"right":return e?i:a;default:return[]}}(n(e),"start"===r,i);return a&&(l=l.map((t=>t+"-"+a)),o&&(l=l.concat(l.map(w)))),l}(c,v,x,P));const O=[c,...T],D=await s(o,b),E=[];let L=(null==(r=a.flip)?void 0:r.overflows)||[];if(m&&E.push(D[R]),g){const{main:t,cross:e}=y(i,l,P);E.push(D[t],D[e])}if(L=[...L,{placement:i,overflows:E}],!E.every((t=>t<=0))){var k,B;const t=((null==(k=a.flip)?void 0:k.index)||0)+1,e=O[t];if(e)return{data:{index:t,overflows:L},reset:{placement:e}};let n=null==(B=L.filter((t=>t.overflows[0]<=0)).sort(((t,e)=>t.overflows[1]-e.overflows[1]))[0])?void 0:B.placement;if(!n)switch(p){case"bestFit":{var C;const t=null==(C=L.map((t=>[t.placement,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:C[0];t&&(n=t);break}case"initialPlacement":n=c}if(i!==n)return{reset:{placement:n}}}return{}}}};function R(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function A(t){return g.some((e=>t[e]>=0))}const P=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{strategy:n="referenceHidden",...o}=t,{rects:r}=e;switch(n){case"referenceHidden":{const t=R(await s(e,{...o,elementContext:"reference"}),r.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:A(t)}}}case"escaped":{const t=R(await s(e,{...o,altBoundary:!0}),r.floating);return{data:{escapedOffsets:t,escaped:A(t)}}}default:return{}}}}},T=function(t){return void 0===t&&(t={}),{name:"inline",options:t,async fn(e){const{placement:r,elements:i,rects:s,platform:u,strategy:m}=e,{padding:g=2,x:d,y:p}=t,h=floating_ui_core_browser_min_l(u.convertOffsetParentRelativeRectToViewportRelativeRect?await u.convertOffsetParentRelativeRectToViewportRelativeRect({rect:s.reference,offsetParent:await(null==u.getOffsetParent?void 0:u.getOffsetParent(i.floating)),strategy:m}):s.reference),y=await(null==u.getClientRects?void 0:u.getClientRects(i.reference))||[],x=a(g);const w=await u.getElementRects({reference:{getBoundingClientRect:function(){if(2===y.length&&y[0].left>y[1].right&&null!=d&&null!=p)return y.find((t=>d>t.left-x.left&&d<t.right+x.right&&p>t.top-x.top&&p<t.bottom+x.bottom))||h;if(y.length>=2){if("x"===o(r)){const t=y[0],e=y[y.length-1],o="top"===n(r),i=t.top,a=e.bottom,l=o?t.left:e.left,s=o?t.right:e.right;return{top:i,bottom:a,left:l,right:s,width:s-l,height:a-i,x:l,y:i}}const t="left"===n(r),e=f(...y.map((t=>t.right))),i=c(...y.map((t=>t.left))),a=y.filter((n=>t?n.left===i:n.right===e)),l=a[0].top,s=a[a.length-1].bottom;return{top:l,bottom:s,left:i,right:e,width:e-i,height:s-l,x:i,y:l}}return h}},floating:i.floating,strategy:m});return s.reference.x!==w.reference.x||s.reference.y!==w.reference.y||s.reference.width!==w.reference.width||s.reference.height!==w.reference.height?{reset:{rects:w}}:{}}}};const O=function(e){return void 0===e&&(e=0),{name:"offset",options:e,async fn(r){const{x:i,y:a}=r,l=await async function(e,r){const{placement:i,platform:a,elements:l}=e,s=await(null==a.isRTL?void 0:a.isRTL(l.floating)),c=n(i),f=t(i),u="x"===o(i),m=["left","top"].includes(c)?-1:1,g=s&&u?-1:1,d="function"==typeof r?r(e):r;let{mainAxis:p,crossAxis:h,alignmentAxis:y}="number"==typeof d?{mainAxis:d,crossAxis:0,alignmentAxis:null}:{mainAxis:0,crossAxis:0,alignmentAxis:null,...d};return f&&"number"==typeof y&&(h="end"===f?-1*y:y),u?{x:h*g,y:p*m}:{x:p*m,y:h*g}}(r,e);return{x:i+l.x,y:a+l.y,data:l}}}};function D(t){return"x"===t?"y":"x"}const E=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:r,y:i,placement:a}=e,{mainAxis:l=!0,crossAxis:c=!1,limiter:f={fn:t=>{let{x:e,y:n}=t;return{x:e,y:n}}},...m}=t,g={x:r,y:i},d=await s(e,m),p=o(n(a)),h=D(p);let y=g[p],x=g[h];if(l){const t="y"===p?"bottom":"right";y=u(y+d["y"===p?"top":"left"],y,y-d[t])}if(c){const t="y"===h?"bottom":"right";x=u(x+d["y"===h?"top":"left"],x,x-d[t])}const w=f.fn({...e,[p]:y,[h]:x});return{...w,data:{x:w.x-r,y:w.y-i}}}}},L=function(t){return void 0===t&&(t={}),{options:t,fn(e){const{x:r,y:i,placement:a,rects:l,middlewareData:s}=e,{offset:c=0,mainAxis:f=!0,crossAxis:u=!0}=t,m={x:r,y:i},g=o(a),d=D(g);let p=m[g],h=m[d];const y="function"==typeof c?c(e):c,x="number"==typeof y?{mainAxis:y,crossAxis:0}:{mainAxis:0,crossAxis:0,...y};if(f){const t="y"===g?"height":"width",e=l.reference[g]-l.floating[t]+x.mainAxis,n=l.reference[g]+l.reference[t]-x.mainAxis;p<e?p=e:p>n&&(p=n)}if(u){var w,v;const t="y"===g?"width":"height",e=["top","left"].includes(n(a)),o=l.reference[d]-l.floating[t]+(e&&(null==(w=s.offset)?void 0:w[d])||0)+(e?0:x.crossAxis),r=l.reference[d]+l.reference[t]+(e?0:(null==(v=s.offset)?void 0:v[d])||0)-(e?x.crossAxis:0);h<o?h=o:h>r&&(h=r)}return{[g]:p,[d]:h}}}},k=function(e){return void 0===e&&(e={}),{name:"size",options:e,async fn(r){const{placement:i,rects:a,platform:l,elements:u}=r,{apply:m=(()=>{}),...g}=e,d=await s(r,g),p=n(i),h=t(i),y="x"===o(i),{width:x,height:w}=a.floating;let v,b;"top"===p||"bottom"===p?(v=p,b=h===(await(null==l.isRTL?void 0:l.isRTL(u.floating))?"start":"end")?"left":"right"):(b=p,v="end"===h?"top":"bottom");const R=w-d[v],A=x-d[b];let P=R,T=A;if(y?T=c(x-d.right-d.left,A):P=c(w-d.bottom-d.top,R),!r.middlewareData.shift&&!h){const t=f(d.left,0),e=f(d.right,0),n=f(d.top,0),o=f(d.bottom,0);y?T=x-2*(0!==t||0!==e?t+e:f(d.left,d.right)):P=w-2*(0!==n||0!==o?n+o:f(d.top,d.bottom))}await m({...r,availableWidth:T,availableHeight:P});const O=await l.getDimensions(u.floating);return x!==O.width||w!==O.height?{reset:{rects:!0}}:{}}}};

;// CONCATENATED MODULE: ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function floating_ui_dom_browser_min_n(t){var e;return(null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function floating_ui_dom_browser_min_o(t){return floating_ui_dom_browser_min_n(t).getComputedStyle(t)}const floating_ui_dom_browser_min_i=Math.min,floating_ui_dom_browser_min_r=Math.max,l=Math.round;function floating_ui_dom_browser_min_c(t){const e=floating_ui_dom_browser_min_o(t);let n=parseFloat(e.width),i=parseFloat(e.height);const r=t.offsetWidth,c=t.offsetHeight,s=l(n)!==r||l(i)!==c;return s&&(n=r,i=c),{width:n,height:i,fallback:s}}function floating_ui_dom_browser_min_s(t){return floating_ui_dom_browser_min_h(t)?(t.nodeName||"").toLowerCase():""}let floating_ui_dom_browser_min_f;function floating_ui_dom_browser_min_u(){if(floating_ui_dom_browser_min_f)return floating_ui_dom_browser_min_f;const t=navigator.userAgentData;return t&&Array.isArray(t.brands)?(floating_ui_dom_browser_min_f=t.brands.map((t=>t.brand+"/"+t.version)).join(" "),floating_ui_dom_browser_min_f):navigator.userAgent}function floating_ui_dom_browser_min_a(t){return t instanceof floating_ui_dom_browser_min_n(t).HTMLElement}function floating_ui_dom_browser_min_d(t){return t instanceof floating_ui_dom_browser_min_n(t).Element}function floating_ui_dom_browser_min_h(t){return t instanceof floating_ui_dom_browser_min_n(t).Node}function floating_ui_dom_browser_min_p(t){if("undefined"==typeof ShadowRoot)return!1;return t instanceof floating_ui_dom_browser_min_n(t).ShadowRoot||t instanceof ShadowRoot}function floating_ui_dom_browser_min_g(t){const{overflow:e,overflowX:n,overflowY:i,display:r}=floating_ui_dom_browser_min_o(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+n)&&!["inline","contents"].includes(r)}function floating_ui_dom_browser_min_m(t){return["table","td","th"].includes(floating_ui_dom_browser_min_s(t))}function floating_ui_dom_browser_min_y(t){const e=/firefox/i.test(floating_ui_dom_browser_min_u()),n=floating_ui_dom_browser_min_o(t),i=n.backdropFilter||n.WebkitBackdropFilter;return"none"!==n.transform||"none"!==n.perspective||!!i&&"none"!==i||e&&"filter"===n.willChange||e&&!!n.filter&&"none"!==n.filter||["transform","perspective"].some((t=>n.willChange.includes(t)))||["paint","layout","strict","content"].some((t=>{const e=n.contain;return null!=e&&e.includes(t)}))}function floating_ui_dom_browser_min_x(){return/^((?!chrome|android).)*safari/i.test(floating_ui_dom_browser_min_u())}function floating_ui_dom_browser_min_w(t){return["html","body","#document"].includes(floating_ui_dom_browser_min_s(t))}function floating_ui_dom_browser_min_v(t){return floating_ui_dom_browser_min_d(t)?t:t.contextElement}const floating_ui_dom_browser_min_b={x:1,y:1};function floating_ui_dom_browser_min_L(t){const e=floating_ui_dom_browser_min_v(t);if(!floating_ui_dom_browser_min_a(e))return floating_ui_dom_browser_min_b;const n=e.getBoundingClientRect(),{width:o,height:i,fallback:r}=floating_ui_dom_browser_min_c(e);let s=(r?l(n.width):n.width)/o,f=(r?l(n.height):n.height)/i;return s&&Number.isFinite(s)||(s=1),f&&Number.isFinite(f)||(f=1),{x:s,y:f}}function floating_ui_dom_browser_min_E(t,e,o,i){var r,l;void 0===e&&(e=!1),void 0===o&&(o=!1);const c=t.getBoundingClientRect(),s=floating_ui_dom_browser_min_v(t);let f=floating_ui_dom_browser_min_b;e&&(i?floating_ui_dom_browser_min_d(i)&&(f=floating_ui_dom_browser_min_L(i)):f=floating_ui_dom_browser_min_L(t));const u=s?floating_ui_dom_browser_min_n(s):window,a=floating_ui_dom_browser_min_x()&&o;let h=(c.left+(a&&(null==(r=u.visualViewport)?void 0:r.offsetLeft)||0))/f.x,p=(c.top+(a&&(null==(l=u.visualViewport)?void 0:l.offsetTop)||0))/f.y,g=c.width/f.x,m=c.height/f.y;if(s){const t=floating_ui_dom_browser_min_n(s),e=i&&floating_ui_dom_browser_min_d(i)?floating_ui_dom_browser_min_n(i):i;let o=t.frameElement;for(;o&&i&&e!==t;){const t=floating_ui_dom_browser_min_L(o),e=o.getBoundingClientRect(),i=getComputedStyle(o);e.x+=(o.clientLeft+parseFloat(i.paddingLeft))*t.x,e.y+=(o.clientTop+parseFloat(i.paddingTop))*t.y,h*=t.x,p*=t.y,g*=t.x,m*=t.y,h+=e.x,p+=e.y,o=floating_ui_dom_browser_min_n(o).frameElement}}return{width:g,height:m,top:p,right:h+g,bottom:p+m,left:h,x:h,y:p}}function floating_ui_dom_browser_min_R(t){return((floating_ui_dom_browser_min_h(t)?t.ownerDocument:t.document)||window.document).documentElement}function floating_ui_dom_browser_min_T(t){return floating_ui_dom_browser_min_d(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function C(t){return floating_ui_dom_browser_min_E(floating_ui_dom_browser_min_R(t)).left+floating_ui_dom_browser_min_T(t).scrollLeft}function F(t){if("html"===floating_ui_dom_browser_min_s(t))return t;const e=t.assignedSlot||t.parentNode||floating_ui_dom_browser_min_p(t)&&t.host||floating_ui_dom_browser_min_R(t);return floating_ui_dom_browser_min_p(e)?e.host:e}function W(t){const e=F(t);return floating_ui_dom_browser_min_w(e)?e.ownerDocument.body:floating_ui_dom_browser_min_a(e)&&floating_ui_dom_browser_min_g(e)?e:W(e)}function floating_ui_dom_browser_min_D(t,e){var o;void 0===e&&(e=[]);const i=W(t),r=i===(null==(o=t.ownerDocument)?void 0:o.body),l=floating_ui_dom_browser_min_n(i);return r?e.concat(l,l.visualViewport||[],floating_ui_dom_browser_min_g(i)?i:[]):e.concat(i,floating_ui_dom_browser_min_D(i))}function S(e,i,l){let c;if("viewport"===i)c=function(t,e){const o=floating_ui_dom_browser_min_n(t),i=floating_ui_dom_browser_min_R(t),r=o.visualViewport;let l=i.clientWidth,c=i.clientHeight,s=0,f=0;if(r){l=r.width,c=r.height;const t=floating_ui_dom_browser_min_x();(!t||t&&"fixed"===e)&&(s=r.offsetLeft,f=r.offsetTop)}return{width:l,height:c,x:s,y:f}}(e,l);else if("document"===i)c=function(t){const e=floating_ui_dom_browser_min_R(t),n=floating_ui_dom_browser_min_T(t),i=t.ownerDocument.body,l=floating_ui_dom_browser_min_r(e.scrollWidth,e.clientWidth,i.scrollWidth,i.clientWidth),c=floating_ui_dom_browser_min_r(e.scrollHeight,e.clientHeight,i.scrollHeight,i.clientHeight);let s=-n.scrollLeft+C(t);const f=-n.scrollTop;return"rtl"===floating_ui_dom_browser_min_o(i).direction&&(s+=floating_ui_dom_browser_min_r(e.clientWidth,i.clientWidth)-l),{width:l,height:c,x:s,y:f}}(floating_ui_dom_browser_min_R(e));else if(floating_ui_dom_browser_min_d(i))c=function(t,e){const n=floating_ui_dom_browser_min_E(t,!0,"fixed"===e),o=n.top+t.clientTop,i=n.left+t.clientLeft,r=floating_ui_dom_browser_min_a(t)?floating_ui_dom_browser_min_L(t):{x:1,y:1};return{width:t.clientWidth*r.x,height:t.clientHeight*r.y,x:i*r.x,y:o*r.y}}(i,l);else{const t={...i};if(floating_ui_dom_browser_min_x()){var s,f;const o=floating_ui_dom_browser_min_n(e);t.x-=(null==(s=o.visualViewport)?void 0:s.offsetLeft)||0,t.y-=(null==(f=o.visualViewport)?void 0:f.offsetTop)||0}c=t}return floating_ui_core_browser_min_l(c)}function floating_ui_dom_browser_min_A(t,e){return floating_ui_dom_browser_min_a(t)&&"fixed"!==floating_ui_dom_browser_min_o(t).position?e?e(t):t.offsetParent:null}function H(t,e){const i=floating_ui_dom_browser_min_n(t);let r=floating_ui_dom_browser_min_A(t,e);for(;r&&floating_ui_dom_browser_min_m(r)&&"static"===floating_ui_dom_browser_min_o(r).position;)r=floating_ui_dom_browser_min_A(r,e);return r&&("html"===floating_ui_dom_browser_min_s(r)||"body"===floating_ui_dom_browser_min_s(r)&&"static"===floating_ui_dom_browser_min_o(r).position&&!floating_ui_dom_browser_min_y(r))?i:r||function(t){let e=F(t);for(;floating_ui_dom_browser_min_a(e)&&!floating_ui_dom_browser_min_w(e);){if(floating_ui_dom_browser_min_y(e))return e;e=F(e)}return null}(t)||i}function V(t,e,n){const o=floating_ui_dom_browser_min_a(e),i=floating_ui_dom_browser_min_R(e),r=floating_ui_dom_browser_min_E(t,!0,"fixed"===n,e);let l={scrollLeft:0,scrollTop:0};const c={x:0,y:0};if(o||!o&&"fixed"!==n)if(("body"!==floating_ui_dom_browser_min_s(e)||floating_ui_dom_browser_min_g(i))&&(l=floating_ui_dom_browser_min_T(e)),floating_ui_dom_browser_min_a(e)){const t=floating_ui_dom_browser_min_E(e,!0);c.x=t.x+e.clientLeft,c.y=t.y+e.clientTop}else i&&(c.x=C(i));return{x:r.left+l.scrollLeft-c.x,y:r.top+l.scrollTop-c.y,width:r.width,height:r.height}}const floating_ui_dom_browser_min_O={getClippingRect:function(t){let{element:e,boundary:n,rootBoundary:l,strategy:c}=t;const f="clippingAncestors"===n?function(t,e){const n=e.get(t);if(n)return n;let i=floating_ui_dom_browser_min_D(t).filter((t=>floating_ui_dom_browser_min_d(t)&&"body"!==floating_ui_dom_browser_min_s(t))),r=null;const l="fixed"===floating_ui_dom_browser_min_o(t).position;let c=l?F(t):t;for(;floating_ui_dom_browser_min_d(c)&&!floating_ui_dom_browser_min_w(c);){const t=floating_ui_dom_browser_min_o(c),e=floating_ui_dom_browser_min_y(c);"fixed"===t.position?r=null:(l?e||r:e||"static"!==t.position||!r||!["absolute","fixed"].includes(r.position))?r=t:i=i.filter((t=>t!==c)),c=F(c)}return e.set(t,i),i}(e,this._c):[].concat(n),u=[...f,l],a=u[0],h=u.reduce(((t,n)=>{const o=S(e,n,c);return t.top=floating_ui_dom_browser_min_r(o.top,t.top),t.right=floating_ui_dom_browser_min_i(o.right,t.right),t.bottom=floating_ui_dom_browser_min_i(o.bottom,t.bottom),t.left=floating_ui_dom_browser_min_r(o.left,t.left),t}),S(e,a,c));return{width:h.right-h.left,height:h.bottom-h.top,x:h.left,y:h.top}},convertOffsetParentRelativeRectToViewportRelativeRect:function(t){let{rect:e,offsetParent:n,strategy:o}=t;const i=floating_ui_dom_browser_min_a(n),r=floating_ui_dom_browser_min_R(n);if(n===r)return e;let l={scrollLeft:0,scrollTop:0},c={x:1,y:1};const f={x:0,y:0};if((i||!i&&"fixed"!==o)&&(("body"!==floating_ui_dom_browser_min_s(n)||floating_ui_dom_browser_min_g(r))&&(l=floating_ui_dom_browser_min_T(n)),floating_ui_dom_browser_min_a(n))){const t=floating_ui_dom_browser_min_E(n);c=floating_ui_dom_browser_min_L(n),f.x=t.x+n.clientLeft,f.y=t.y+n.clientTop}return{width:e.width*c.x,height:e.height*c.y,x:e.x*c.x-l.scrollLeft*c.x+f.x,y:e.y*c.y-l.scrollTop*c.y+f.y}},isElement:floating_ui_dom_browser_min_d,getDimensions:function(t){return floating_ui_dom_browser_min_a(t)?floating_ui_dom_browser_min_c(t):t.getBoundingClientRect()},getOffsetParent:H,getDocumentElement:floating_ui_dom_browser_min_R,getScale:floating_ui_dom_browser_min_L,async getElementRects(t){let{reference:e,floating:n,strategy:o}=t;const i=this.getOffsetParent||H,r=this.getDimensions;return{reference:V(e,await i(n),o),floating:{x:0,y:0,...await r(n)}}},getClientRects:t=>Array.from(t.getClientRects()),isRTL:t=>"rtl"===floating_ui_dom_browser_min_o(t).direction};function floating_ui_dom_browser_min_P(t,e,n,o){void 0===o&&(o={});const{ancestorScroll:i=!0,ancestorResize:r=!0,elementResize:l=!0,animationFrame:c=!1}=o,s=i&&!c,f=s||r?[...floating_ui_dom_browser_min_d(t)?floating_ui_dom_browser_min_D(t):t.contextElement?floating_ui_dom_browser_min_D(t.contextElement):[],...floating_ui_dom_browser_min_D(e)]:[];f.forEach((t=>{s&&t.addEventListener("scroll",n,{passive:!0}),r&&t.addEventListener("resize",n)}));let u,a=null;if(l){let o=!0;a=new ResizeObserver((()=>{o||n(),o=!1})),floating_ui_dom_browser_min_d(t)&&!c&&a.observe(t),floating_ui_dom_browser_min_d(t)||!t.contextElement||c||a.observe(t.contextElement),a.observe(e)}let h=c?floating_ui_dom_browser_min_E(t):null;return c&&function e(){const o=floating_ui_dom_browser_min_E(t);!h||o.x===h.x&&o.y===h.y&&o.width===h.width&&o.height===h.height||n();h=o,u=requestAnimationFrame(e)}(),n(),()=>{var t;f.forEach((t=>{s&&t.removeEventListener("scroll",n),r&&t.removeEventListener("resize",n)})),null==(t=a)||t.disconnect(),a=null,c&&cancelAnimationFrame(u)}}const z=(t,n,o)=>{const i=new Map,r={platform:floating_ui_dom_browser_min_O,...o},l={...r.platform,_c:i};return e(t,n,{...r,platform:l})};

// EXTERNAL MODULE: ../../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
var use_isomorphic_layout_effect_browser_esm = __webpack_require__(84337);
;// CONCATENATED MODULE: ../../node_modules/react-select/dist/index-641ee5b8.esm.js













var _excluded$4 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}
function classNames(prefix, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (isArray(value)) return value.filter(Boolean);
  if ((0,esm_typeof/* default */.Z)(value) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Clean Common Props
// ==============================

var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0,objectWithoutProperties/* default */.Z)(props, _excluded$4);
  return (0,objectSpread2/* default */.Z)({}, innerProps);
};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var _newValue = onInputChange(inputValue, actionMeta);
    if (typeof _newValue === 'string') return _newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized Scroll Top
// ------------------------------

function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

// ==============================
// Passive Event Detector
// ==============================

// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
// check for SSR
var index_641ee5b8_esm_w = typeof window !== 'undefined' ? window : {};
if (index_641ee5b8_esm_w.addEventListener && index_641ee5b8_esm_w.removeEventListener) {
  index_641ee5b8_esm_w.addEventListener('p', noop, options);
  index_641ee5b8_esm_w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
      key = _ref2[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};

var _excluded$3 = ["children", "innerProps"],
  _excluded2$1 = ["children", "innerProps"];
function getMenuPlacement(_ref) {
  var preferredMaxHeight = _ref.maxHeight,
    menuEl = _ref.menuEl,
    minHeight = _ref.minHeight,
    preferredPlacement = _ref.placement,
    shouldScroll = _ref.shouldScroll,
    isFixedPosition = _ref.isFixedPosition,
    controlHeight = _ref.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: preferredMaxHeight
  };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (preferredPlacement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (preferredPlacement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: 'bottom',
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: preferredMaxHeight
        };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
  }
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
  var _objectSpread2;
  var placement = _ref2.placement,
    _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    spacing = _ref2$theme.spacing,
    colors = _ref2$theme.colors;
  return (0,objectSpread2/* default */.Z)((_objectSpread2 = {
    label: 'menu'
  }, (0,defineProperty/* default */.Z)(_objectSpread2, alignToControl(placement), '100%'), (0,defineProperty/* default */.Z)(_objectSpread2, "position", 'absolute'), (0,defineProperty/* default */.Z)(_objectSpread2, "width", '100%'), (0,defineProperty/* default */.Z)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
    backgroundColor: colors.neutral0,
    borderRadius: borderRadius,
    boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
    marginBottom: spacing.menuGutter,
    marginTop: spacing.menuGutter
  });
};
var PortalPlacementContext = /*#__PURE__*/(0,react.createContext)(null);

// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme = props.theme;
  var _ref3 = (0,react.useContext)(PortalPlacementContext) || {},
    setPortalPlacement = _ref3.setPortalPlacement;
  var ref = (0,react.useRef)(null);
  var _useState = (0,react.useState)(maxMenuHeight),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = (0,react.useState)(null),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight = theme.spacing.controlHeight;
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    var menuEl = ref.current;
    if (!menuEl) return;

    // DO NOT scroll if position is fixed
    var isFixedPosition = menuPosition === 'fixed';
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl: menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll: shouldScroll,
      isFixedPosition: isFixedPosition,
      controlHeight: controlHeight
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight]);
  return children({
    ref: ref,
    placerProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight: maxHeight
    })
  });
};
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight,
    baseUnit = _ref4.theme.spacing.baseUnit;
  return (0,objectSpread2/* default */.Z)({
    maxHeight: maxHeight,
    overflowY: 'auto',
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  }, unstyled ? {} : {
    paddingBottom: baseUnit,
    paddingTop: baseUnit
  });
};
var MenuList = function MenuList(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'menuList', {
    'menu-list': true,
    'menu-list--is-multi': isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme,
    baseUnit = _ref5$theme.spacing.baseUnit,
    colors = _ref5$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    textAlign: 'center'
  }, unstyled ? {} : {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
  var _ref6$children = _ref6.children,
    children = _ref6$children === void 0 ? 'No options' : _ref6$children,
    innerProps = _ref6.innerProps,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded$3);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'noOptionsMessage', {
    'menu-notice': true,
    'menu-notice--no-options': true
  }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
  var _ref7$children = _ref7.children,
    children = _ref7$children === void 0 ? 'Loading...' : _ref7$children,
    innerProps = _ref7.innerProps,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded2$1);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    children: children,
    innerProps: innerProps
  }), 'loadingMessage', {
    'menu-notice': true,
    'menu-notice--loading': true
  }), innerProps), children);
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref8) {
  var rect = _ref8.rect,
    offset = _ref8.offset,
    position = _ref8.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal(props) {
  var appendTo = props.appendTo,
    children = props.children,
    controlElement = props.controlElement,
    innerProps = props.innerProps,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition;
  var menuPortalRef = (0,react.useRef)(null);
  var cleanupRef = (0,react.useRef)(null);
  var _useState5 = (0,react.useState)(coercePlacement(menuPlacement)),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = (0,react.useMemo)(function () {
    return {
      setPortalPlacement: setPortalPlacement
    };
  }, []);
  var _useState7 = (0,react.useState)(null),
    _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = (0,react.useCallback)(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset,
        rect: rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = (0,react.useCallback)(function () {
    if (typeof cleanupRef.current === 'function') {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = floating_ui_dom_browser_min_P(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: 'ResizeObserver' in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  (0,use_isomorphic_layout_effect_browser_esm/* default */.Z)(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = (0,react.useCallback)(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);

  // bail early if required elements aren't present
  if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;

  // same wrapper element whether fixed or portalled
  var menuWrapper = (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    ref: setMenuPortalElement
  }, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), 'menuPortal', {
    'menu-portal': true
  }), innerProps), children);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /*#__PURE__*/(0,react_dom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
    isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'container', {
    '--is-disabled': isDisabled,
    '--is-rtl': isRtl
  }), innerProps), children);
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
  var spacing = _ref2.theme.spacing,
    isMulti = _ref2.isMulti,
    hasValue = _ref2.hasValue,
    controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return (0,objectSpread2/* default */.Z)({
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  }, unstyled ? {} : {
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'valueContainer', {
    'value-container': true,
    'value-container--is-multi': isMulti,
    'value-container--has-value': hasValue
  }), innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'indicatorsContainer', {
    indicators: true
  }), innerProps), children);
};

var _templateObject;
var _excluded$2 = ["size"],
  _excluded2 = ["innerProps", "isRtl", "size"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 =  true ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : 0;
var Svg = function Svg(_ref) {
  var size = _ref.size,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded$2);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", (0,esm_extends/* default */.Z)({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};
var CrossIcon = function CrossIcon(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Svg, (0,esm_extends/* default */.Z)({
    size: 20
  }, props), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3, unstyled) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit = _ref3$theme.spacing.baseUnit,
    colors = _ref3$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'indicatorContainer',
    display: 'flex',
    transition: 'color 150ms'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2,
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'dropdownIndicator', {
    indicator: true,
    'dropdown-indicator': true
  }), innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'clearIndicator', {
    indicator: true,
    'clear-indicator': true
  }), innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, null));
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit = _ref4$theme.spacing.baseUnit,
    colors = _ref4$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", (0,esm_extends/* default */.Z)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
    'indicator-separator': true
  })));
};

// ==============================
// Loading
// ==============================

var loadingDotAnimations = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors = _ref5$theme.colors,
    baseUnit = _ref5$theme.spacing.baseUnit;
  return (0,objectSpread2/* default */.Z)({
    label: 'loadingIndicator',
    display: 'flex',
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  }, unstyled ? {} : {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    padding: baseUnit * 2
  });
};
var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
    offset = _ref6.offset;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : 0,  true ? "" : 0)
  });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
  var innerProps = _ref7.innerProps,
    isRtl = _ref7.isRtl,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 4 : _ref7$size,
    restProps = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded2);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, restProps), {}, {
    innerProps: innerProps,
    isRtl: isRtl,
    size: size
  }), 'loadingIndicator', {
    indicator: true,
    'loading-indicator': true
  }), innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 160,
    offset: true
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};

var css$1 = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    _ref$theme = _ref.theme,
    colors = _ref$theme.colors,
    borderRadius = _ref$theme.borderRadius,
    spacing = _ref$theme.spacing;
  return (0,objectSpread2/* default */.Z)({
    label: 'control',
    alignItems: 'center',
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms'
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  });
};
var Control = function Control(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    ref: innerRef
  }, getStyleProps(props, 'control', {
    control: true,
    'control--is-disabled': isDisabled,
    'control--is-focused': isFocused,
    'control--menu-is-open': menuIsOpen
  }), innerProps, {
    "aria-disabled": isDisabled || undefined
  }), children);
};
var Control$1 = Control;

var _excluded$1 = ["data"];
var groupCSS = function groupCSS(_ref, unstyled) {
  var spacing = _ref.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};
var Group = function Group(props) {
  var children = props.children,
    cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme = props.theme,
    selectProps = props.selectProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), (0,emotion_react_browser_esm/* jsx */.tZ)(Heading, (0,esm_extends/* default */.Z)({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    colors = _ref2$theme.colors,
    spacing = _ref2$theme.spacing;
  return (0,objectSpread2/* default */.Z)({
    label: 'group',
    cursor: 'default',
    display: 'block'
  }, unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  });
};
var GroupHeading = function GroupHeading(props) {
  var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded$1);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};
var Group$1 = Group;

var _excluded = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    value = _ref.value,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
    visibility: isDisabled ? 'hidden' : 'visible',
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle), unstyled ? {} : {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    color: colors.neutral80
  });
};
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': (0,objectSpread2/* default */.Z)({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
  return (0,objectSpread2/* default */.Z)({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};
var Input = function Input(props) {
  var cx = props.cx,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = (0,objectWithoutProperties/* default */.Z)(_cleanCommonProps, _excluded);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'input', {
    'input-container': true
  }), {
    "data-value": value || ''
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("input", (0,esm_extends/* default */.Z)({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var Input$1 = Input;

var multiValueCSS = function multiValueCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    borderRadius = _ref$theme.borderRadius,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'multiValue',
    display: 'flex',
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    margin: spacing.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
  var _ref2$theme = _ref2.theme,
    borderRadius = _ref2$theme.borderRadius,
    colors = _ref2$theme.colors,
    cropWithEllipsis = _ref2.cropWithEllipsis;
  return (0,objectSpread2/* default */.Z)({
    overflow: 'hidden',
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme,
    spacing = _ref3$theme.spacing,
    borderRadius = _ref3$theme.borderRadius,
    colors = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return (0,objectSpread2/* default */.Z)({
    alignItems: 'center',
    display: 'flex'
  }, unstyled ? {} : {
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({
    role: "button"
  }, innerProps), children || (0,emotion_react_browser_esm/* jsx */.tZ)(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue(props) {
  var children = props.children,
    components = props.components,
    data = props.data,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps = props.removeProps,
    selectProps = props.selectProps;
  var Container = components.Container,
    Label = components.Label,
    Remove = components.Remove;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, {
    data: data,
    innerProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getStyleProps(props, 'multiValue', {
      'multi-value': true,
      'multi-value--is-disabled': isDisabled
    })), innerProps),
    selectProps: selectProps
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Label, {
    data: data,
    innerProps: (0,objectSpread2/* default */.Z)({}, getStyleProps(props, 'multiValueLabel', {
      'multi-value__label': true
    })),
    selectProps: selectProps
  }, children), (0,emotion_react_browser_esm/* jsx */.tZ)(Remove, {
    data: data,
    innerProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, getStyleProps(props, 'multiValueRemove', {
      'multi-value__remove': true
    })), {}, {
      'aria-label': "Remove ".concat(children || 'option')
    }, removeProps),
    selectProps: selectProps
  }));
};
var MultiValue$1 = MultiValue;

var optionCSS = function optionCSS(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'option',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  });
};
var Option = function Option(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'option', {
    option: true,
    'option--is-disabled': isDisabled,
    'option--is-focused': isFocused,
    'option--is-selected': isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var Option$1 = Option;

var placeholderCSS = function placeholderCSS(_ref, unstyled) {
  var _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'placeholder',
    gridArea: '1 / 1 / 2 / 3'
  }, unstyled ? {} : {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var Placeholder = function Placeholder(props) {
  var children = props.children,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'placeholder', {
    placeholder: true
  }), innerProps), children);
};
var Placeholder$1 = Placeholder;

var css = function css(_ref, unstyled) {
  var isDisabled = _ref.isDisabled,
    _ref$theme = _ref.theme,
    spacing = _ref$theme.spacing,
    colors = _ref$theme.colors;
  return (0,objectSpread2/* default */.Z)({
    label: 'singleValue',
    gridArea: '1 / 1 / 2 / 3',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, unstyled ? {} : {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  });
};
var SingleValue = function SingleValue(props) {
  var children = props.children,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", (0,esm_extends/* default */.Z)({}, getStyleProps(props, 'singleValue', {
    'single-value': true,
    'single-value--is-disabled': isDisabled
  }), innerProps), children);
};
var SingleValue$1 = SingleValue;

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control$1,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group$1,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu$1,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue$1,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option$1,
  Placeholder: Placeholder$1,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue$1,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, components), props.components);
};




/***/ }),

/***/ 16356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var HeightUpdater = (function (_Component) {
	_inherits(HeightUpdater, _Component);

	function HeightUpdater(props) {
		_classCallCheck(this, HeightUpdater);

		_get(Object.getPrototypeOf(HeightUpdater.prototype), 'constructor', this).call(this, props);

		this.onWindowResize = this.onWindowResize.bind(this);
	}

	_createClass(HeightUpdater, [{
		key: 'onWindowResize',
		value: function onWindowResize() {
			var height = window.innerHeight;
			if (height !== this.props.height) {
				this.props.onHeightChange(height);
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			window.addEventListener('resize', this.onWindowResize);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('resize', this.onWindowResize);
		}
	}, {
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return HeightUpdater;
})(_react.Component);

HeightUpdater.propTypes = {
	height: _propTypes2['default'].number,
	onHeightChange: _propTypes2['default'].func
};

exports["default"] = HeightUpdater;
module.exports = exports['default'];

/***/ }),

/***/ 49142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var ScrollToTop = (function (_Component) {
	_inherits(ScrollToTop, _Component);

	function ScrollToTop() {
		_classCallCheck(this, ScrollToTop);

		_get(Object.getPrototypeOf(ScrollToTop.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(ScrollToTop, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.element().scrollTop = 0;
		}
	}, {
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return ScrollToTop;
})(_react.Component);

ScrollToTop.propTypes = {
	element: _propTypes2['default'].func.isRequired
};

exports["default"] = ScrollToTop;
module.exports = exports['default'];

/***/ }),

/***/ 92429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
	value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(2784);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13980);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSwipeableViews = __webpack_require__(9069);

var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);

var _HeightUpdater = __webpack_require__(16356);

var _HeightUpdater2 = _interopRequireDefault(_HeightUpdater);

var _ScrollToTop = __webpack_require__(49142);

var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);

var SwipeableBottomSheet = (function (_Component) {
	_inherits(SwipeableBottomSheet, _Component);

	function SwipeableBottomSheet(props) {
		_classCallCheck(this, SwipeableBottomSheet);

		_get(Object.getPrototypeOf(SwipeableBottomSheet.prototype), 'constructor', this).call(this, props);

		this.onHeightChange = this.onHeightChange.bind(this);
		this.onChangeIndex = this.onChangeIndex.bind(this);
		this.onTransitionEnd = this.onTransitionEnd.bind(this);

		this.state = {
			open: props.defaultOpen,
			height: window.innerHeight
		};
	}

	_createClass(SwipeableBottomSheet, [{
		key: 'onHeightChange',
		value: function onHeightChange(height) {
			this.setState({ height: height });
		}
	}, {
		key: 'onChangeIndex',
		value: function onChangeIndex(index) {
			var open = index === 1;
			if (this.props.open === undefined) {
				this.setState({ open: open });
			}
			if (this.props.onChange !== undefined) {
				this.props.onChange(open);
			}
		}
	}, {
		key: 'onTransitionEnd',
		value: function onTransitionEnd() {
			var _props = this.props;
			var overflowHeight = _props.overflowHeight;
			var swipeableViewsProps = _props.swipeableViewsProps;

			if (overflowHeight === 0) {
				this.bodyElt.scrollTop = 0;
			}
			if (swipeableViewsProps.onTransitionEnd) {
				swipeableViewsProps.onTransitionEnd();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this = this;

			var _props2 = this.props;
			var overflowHeight = _props2.overflowHeight;
			var fullScreen = _props2.fullScreen;
			var marginTop = _props2.marginTop;
			var open = _props2.open;
			var topShadow = _props2.topShadow;
			var shadowTip = _props2.shadowTip;
			var overlay = _props2.overlay;
			var swipeableViewsProps = _props2.swipeableViewsProps;
			var scrollTopAtClose = _props2.scrollTopAtClose;

			var hiddenWhenClosed = overflowHeight === 0;
			var isControlled = open !== undefined;
			var isOpen = isControlled ? open : this.state.open;
			var hideShadows = hiddenWhenClosed && !isOpen;
			var index = isOpen ? 1 : 0;
			var maxHeight = this.state.height - marginTop;

			var styles = {
				root: _extends({
					height: overflowHeight,
					position: 'fixed',
					bottom: 0,
					right: 0,
					left: 0
				}, this.props.style),
				swiper: {
					root: _extends({
						overflowY: 'initial',
						boxSizing: 'border-box'
					}, swipeableViewsProps.style),
					container: _extends({
						boxSizing: 'border-box'
					}, topShadow && !hideShadows && {
						boxShadow: 'rgba(0, 0, 0, 0.156863) 0px -6px 5px'
					}, swipeableViewsProps.containerStyle),
					slide: _extends({
						boxSizing: 'border-box',
						overflow: 'visible',
						marginBottom: -overflowHeight
					}, swipeableViewsProps.slideStyle),
					bottomSlide: {
						marginBottom: overflowHeight
					},
					body: _extends({
						overflow: isOpen ? 'auto' : 'hidden',
						backgroundColor: 'white',
						height: fullScreen ? maxHeight : 'initial',
						maxHeight: maxHeight
					}, this.props.bodyStyle)
				},
				overlay: _extends({
					position: 'fixed',
					top: 0,
					right: 0,
					left: 0,
					height: this.state.height,
					transition: 'opacity 450ms',
					pointerEvents: 'none',
					backgroundColor: 'black',
					opacity: 0
				}, isOpen && {
					opacity: 0.54,
					pointerEvents: 'auto'
				}, this.props.overlayStyle),
				shadowTip: {
					position: 'fixed',
					height: 60,
					width: '200%',
					bottom: -60,
					left: '-50%',
					boxShadow: 'rgba(0, 0, 0, 0.7) 0px 0px 30px',
					transition: 'transform 450ms',
					transform: isOpen ? 'translateY(50px)' : 'translateY(0)'
				}
			};

			return _react2['default'].createElement(
				'div',
				{ style: styles.root },
				_react2['default'].createElement(_HeightUpdater2['default'], {
					height: this.state.height,
					onHeightChange: this.onHeightChange
				}),
				overlay && _react2['default'].createElement('div', { style: styles.overlay, onClick: function () {
						return _this.onChangeIndex(0);
					} }),
				_react2['default'].createElement(
					_reactSwipeableViews2['default'],
					_extends({
						index: index,
						axis: 'y',
						enableMouseEvents: true,
						onChangeIndex: this.onChangeIndex
					}, this.props.swipeableViewsProps, {
						onTransitionEnd: this.onTransitionEnd,
						style: styles.swiper.root,
						containerStyle: styles.swiper.container,
						slideStyle: styles.swiper.slide
					}),
					_react2['default'].createElement(
						'div',
						{
							ref: function (elt) {
								return _this.bodyElt = elt;
							},
							style: styles.swiper.body,
							className: 'ReactSwipeableBottomSheet--' + (isOpen ? 'open' : 'closed')
						},
						this.props.children
					),
					_react2['default'].createElement('div', { style: styles.swiper.bottomSlide })
				),
				shadowTip && !hideShadows && _react2['default'].createElement('div', { style: styles.shadowTip }),
				!isOpen && scrollTopAtClose && !hiddenWhenClosed && _react2['default'].createElement(_ScrollToTop2['default'], { element: function () {
						return _this.bodyElt;
					} })
			);
		}
	}]);

	return SwipeableBottomSheet;
})(_react.Component);

;

SwipeableBottomSheet.propTypes = {
	bodyStyle: _propTypes2['default'].object,
	children: _propTypes2['default'].node.isRequired,
	defaultOpen: _propTypes2['default'].bool,
	fullScreen: _propTypes2['default'].bool,
	marginTop: _propTypes2['default'].number,
	onChange: _propTypes2['default'].func,
	onTransitionEnd: _propTypes2['default'].func,
	open: _propTypes2['default'].bool,
	overflowHeight: _propTypes2['default'].number,
	overlay: _propTypes2['default'].bool,
	overlayStyle: _propTypes2['default'].object,
	scrollTopAtClose: _propTypes2['default'].bool,
	shadowTip: _propTypes2['default'].bool,
	style: _propTypes2['default'].object,
	swipeableViewsProps: _propTypes2['default'].object,
	topShadow: _propTypes2['default'].bool
};

SwipeableBottomSheet.defaultProps = {
	defaultOpen: false,
	fullScreen: false,
	marginTop: 0,
	overflowHeight: 0,
	overlay: true,
	scrollTopAtClose: true,
	shadowTip: true,
	swipeableViewsProps: {},
	topShadow: true
};

exports["default"] = SwipeableBottomSheet;
module.exports = exports['default'];

/***/ }),

/***/ 81134:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36163);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _warning = _interopRequireDefault(__webpack_require__(45982));

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;

  var childrenCount = _react.default.Children.count(children);

   false ? 0 : void 0;
};

var _default = checkIndexBounds;
exports["default"] = _default;

/***/ }),

/***/ 10800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36163);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = computeIndex;

var _react = _interopRequireDefault(__webpack_require__(2784));

var _constant = _interopRequireDefault(__webpack_require__(91277));

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;
  var indexMax = _react.default.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),

/***/ 91277:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
exports["default"] = _default;

/***/ }),

/***/ 1385:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36163);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  var getChildrenKey = function getChildrenKey(child) {
    return child ? child.key : 'empty';
  };

  if (props.children.length && nextProps.children.length) {
    var oldKeys = _react.default.Children.map(props.children, getChildrenKey);

    var oldKey = oldKeys[props.index];

    if (oldKey !== null && oldKey !== undefined) {
      var newKeys = _react.default.Children.map(nextProps.children, getChildrenKey);

      var newKey = newKeys[nextProps.index];

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

var _default = getDisplaySameSlide;
exports["default"] = _default;

/***/ }),

/***/ 16980:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(36163);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "checkIndexBounds", ({
  enumerable: true,
  get: function get() {
    return _checkIndexBounds.default;
  }
}));
Object.defineProperty(exports, "computeIndex", ({
  enumerable: true,
  get: function get() {
    return _computeIndex.default;
  }
}));
Object.defineProperty(exports, "constant", ({
  enumerable: true,
  get: function get() {
    return _constant.default;
  }
}));
Object.defineProperty(exports, "getDisplaySameSlide", ({
  enumerable: true,
  get: function get() {
    return _getDisplaySameSlide.default;
  }
}));
Object.defineProperty(exports, "mod", ({
  enumerable: true,
  get: function get() {
    return _mod.default;
  }
}));

var _checkIndexBounds = _interopRequireDefault(__webpack_require__(81134));

var _computeIndex = _interopRequireDefault(__webpack_require__(10800));

var _constant = _interopRequireDefault(__webpack_require__(91277));

var _getDisplaySameSlide = _interopRequireDefault(__webpack_require__(1385));

var _mod = _interopRequireDefault(__webpack_require__(59529));

/***/ }),

/***/ 59529:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

var _default = mod;
exports["default"] = _default;

/***/ }),

/***/ 36163:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ 62349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(69671);

var _interopRequireDefault = __webpack_require__(69909);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;
exports["default"] = exports.SwipeableViewsContext = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(38887));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(89026));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(87977));

var _createClass2 = _interopRequireDefault(__webpack_require__(12334));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(44374));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(35663));

var _inherits2 = _interopRequireDefault(__webpack_require__(10112));

var React = _interopRequireWildcard(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _warning = _interopRequireDefault(__webpack_require__(45982));

var _reactSwipeableViewsCore = __webpack_require__(16980);

function addEventListener(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, options);
    }
  };
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};
var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return "translate(".concat(-translate, "%, 0)");
    },
    'x-reverse': function xReverse(translate) {
      return "translate(".concat(translate, "%, 0)");
    },
    y: function y(translate) {
      return "translate(0, ".concat(-translate, "%)");
    },
    'y-reverse': function yReverse(translate) {
      return "translate(0, ".concat(translate, "%)");
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;
  return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.


function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];
  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{
    pageX: event.pageX,
    pageY: event.pageY
  }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode && element !== document.body) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.


var nodeWhoClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;

    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    } // scrollTop is not always be an integer.
    // https://github.com/jquery/api.jquery.com/issues/608


    var scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeWhoClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViewsContext = React.createContext();
exports.SwipeableViewsContext = SwipeableViewsContext;

if (false) {}

var SwipeableViews =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableViews, _React$Component);

  function SwipeableViews(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwipeableViews);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwipeableViews).call(this, props));
    _this.rootNode = null;
    _this.containerNode = null;
    _this.ignoreNextScrollEvents = false;
    _this.viewLength = 0;
    _this.startX = 0;
    _this.lastX = 0;
    _this.vx = 0;
    _this.startY = 0;
    _this.isSwiping = undefined;
    _this.started = false;
    _this.startIndex = 0;
    _this.transitionListener = null;
    _this.touchMoveListener = null;
    _this.activeSlide = null;
    _this.indexCurrent = null;
    _this.firstRenderTimeout = null;

    _this.setRootNode = function (node) {
      _this.rootNode = node;
    };

    _this.setContainerNode = function (node) {
      _this.containerNode = node;
    };

    _this.setActiveSlide = function (node) {
      _this.activeSlide = node;

      _this.updateHeight();
    };

    _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;
      var touch = applyRotationMatrix(event.touches[0], axis);
      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;
      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);
        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);
        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
      }
    };

    _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);

        return;
      } // We are not supposed to hanlde this touch move.


      if (nodeWhoClaimedTheScroll !== null && nodeWhoClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;
      var touch = applyRotationMatrix(event.touches[0], axis); // We don't know yet.

      if (_this.isSwiping === undefined) {
        var dx = Math.abs(touch.pageX - _this.startX);
        var dy = Math.abs(touch.pageY - _this.startY);
        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.

        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === React.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        } // We are likely to be swiping, let's prevent the scroll event.


        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      } // We are swiping, let's prevent the scroll event.


      event.preventDefault(); // Low Pass filter.

      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX; // Add support for native scroll elements.


      if (nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        }); // We abort the touch move handler.

        if (hasFoundNativeHandler) {
          return;
        }
      } // We are moving toward the edges.


      if (startX) {
        _this.startX = startX;
      } else if (nodeWhoClaimedTheScroll === null) {
        nodeWhoClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    };

    _this.handleSwipeEnd = function () {
      nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
      // Makes sure that a starting point is set.

      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;
      var indexNew; // Quick movement

      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = React.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);

      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        } // Manually calling handleTransitionEnd in that case as isn't otherwise.


        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    };

    _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }

      _this.handleSwipeStart(event);
    };

    _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }

      _this.handleSwipeEnd(event);
    };

    _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }

      event.persist();

      _this.handleSwipeStart(adaptMouse(event));
    };

    _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }

      _this.handleSwipeEnd(adaptMouse(event));
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    };

    _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    };

    _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      } // Ignore events bubbling up.


      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
      _this.ignoreNextScrollEvents = true; // Reset the scroll position.

      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    };

    _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];

        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    };

    if (false) {}

    _this.state = {
      indexLatest: props.index,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      renderOnlyActive: !props.disableLazyLoading,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    };

    _this.setIndexCurrent(props.index);

    return _this;
  }

  (0, _createClass2.default)(SwipeableViews, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListener(this.containerNode, 'transitionend', function (event) {
        if (event.target !== _this2.containerNode) {
          return;
        }

        _this2.handleTransitionEnd();
      }); // Block the thread to handle that event.

      this.touchMoveListener = addEventListener(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this2.props.disabled) {
          return;
        }

        _this2.handleSwipeMove(event);
      }, {
        passive: false
      });

      if (!this.props.disableLazyLoading) {
        this.firstRenderTimeout = setTimeout(function () {
          _this2.setState({
            renderOnlyActive: false
          });
        }, 0);
      } // Send all functions in an object if action param is set.


      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    } // eslint-disable-next-line camelcase,react/sort-comp

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var index = nextProps.index;

      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {}

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
      clearTimeout(this.firstRenderTimeout);
    }
  }, {
    key: "getSwipeableViewsContext",
    value: function getSwipeableViewsContext() {
      var _this3 = this;

      return {
        slideUpdateHeight: function slideUpdateHeight() {
          _this3.updateHeight();
        }
      };
    }
  }, {
    key: "setIndexCurrent",
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;
        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      } // Filters out when changing the children


      if (this.state.displaySameSlide) {
        return;
      } // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.


      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          action = _this$props2.action,
          animateHeight = _this$props2.animateHeight,
          animateTransitions = _this$props2.animateTransitions,
          axis = _this$props2.axis,
          children = _this$props2.children,
          containerStyleProp = _this$props2.containerStyle,
          disabled = _this$props2.disabled,
          disableLazyLoading = _this$props2.disableLazyLoading,
          enableMouseEvents = _this$props2.enableMouseEvents,
          hysteresis = _this$props2.hysteresis,
          ignoreNativeScroll = _this$props2.ignoreNativeScroll,
          index = _this$props2.index,
          onChangeIndex = _this$props2.onChangeIndex,
          onSwitching = _this$props2.onSwitching,
          onTransitionEnd = _this$props2.onTransitionEnd,
          resistance = _this$props2.resistance,
          slideStyleProp = _this$props2.slideStyle,
          slideClassName = _this$props2.slideClassName,
          springConfig = _this$props2.springConfig,
          style = _this$props2.style,
          threshold = _this$props2.threshold,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"]);
      var _this$state = this.state,
          displaySameSlide = _this$state.displaySameSlide,
          heightLatest = _this$state.heightLatest,
          indexLatest = _this$state.indexLatest,
          isDragging = _this$state.isDragging,
          renderOnlyActive = _this$state.renderOnlyActive;
      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {}; // There is no point to animate if we are already providing a height.

       false ? 0 : void 0;
      var slideStyle = (0, _extends2.default)({}, styles.slide, slideStyleProp);
      var transition;
      var WebkitTransition;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ", ".concat(createTransition('height', springConfig));
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      }; // Apply the styles for SSR considerations

      if (!renderOnlyActive) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return React.createElement(SwipeableViewsContext.Provider, {
        value: this.getSwipeableViewsContext()
      }, React.createElement("div", (0, _extends2.default)({
        ref: this.setRootNode,
        style: (0, _extends2.default)({}, axisProperties.root[axis], style)
      }, other, touchEvents, mouseEvents, {
        onScroll: this.handleScroll
      }), React.createElement("div", {
        ref: this.setContainerNode,
        style: (0, _extends2.default)({}, containerStyle, styles.container, containerStyleProp),
        className: "react-swipeable-view-container"
      }, React.Children.map(children, function (child, indexChild) {
        if (renderOnlyActive && indexChild !== indexLatest) {
          return null;
        }

         false ? 0 : void 0;
        var ref;
        var hidden = true;

        if (indexChild === indexLatest) {
          hidden = false;

          if (animateHeight) {
            ref = _this4.setActiveSlide;
            slideStyle.overflowY = 'hidden';
          }
        }

        return React.createElement("div", {
          ref: ref,
          style: slideStyle,
          className: slideClassName,
          "aria-hidden": hidden,
          "data-swipeable": "true"
        }, child);
      }))));
    }
  }]);
  return SwipeableViews;
}(React.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';
SwipeableViews.propTypes =  false ? 0 : {};
SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};
var _default = SwipeableViews;
exports["default"] = _default;

/***/ }),

/***/ 9069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(69671);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function get() {
    return _SwipeableViews.default;
  }
}));
Object.defineProperty(exports, "SwipeableViewsContext", ({
  enumerable: true,
  get: function get() {
    return _SwipeableViews.SwipeableViewsContext;
  }
}));

var _SwipeableViews = _interopRequireWildcard(__webpack_require__(62349));

/***/ }),

/***/ 80216:
/***/ (function(module) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ 87977:
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),

/***/ 12334:
/***/ (function(module) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),

/***/ 38887:
/***/ (function(module) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ 35663:
/***/ (function(module) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ 10112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(43593);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ 69909:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ 69671:
/***/ (function(module) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),

/***/ 89026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(69919);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),

/***/ 69919:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ 44374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = __webpack_require__(95285);

var assertThisInitialized = __webpack_require__(80216);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ 43593:
/***/ (function(module) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),

/***/ 95285:
/***/ (function(module) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),

/***/ 56203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ix": function() { return /* binding */ ToastContainer; },
  "LG": function() { return /* binding */ Zoom; },
  "Am": function() { return /* binding */ toast; }
});

// UNUSED EXPORTS: Bounce, Flip, Icons, Slide, collapseToast, cssTransition, useToast, useToastContainer

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-toastify/node_modules/clsx/dist/clsx.m.js
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function clsx_m() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}

// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.js




function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function isNum(v) {
  return typeof v === 'number' && !isNaN(v);
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isStr(v) {
  return typeof v === 'string';
}
function isFn(v) {
  return typeof v === 'function';
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function canBeRendered(content) {
  return (0,react.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}

var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};

/**
 * Used to collapse toast after exit animation
 */
function collapseToast(node, done, duration
/* COLLAPSE_DURATION */
) {
  if (duration === void 0) {
    duration = 300;
  }

  var scrollHeight = node.scrollHeight,
      style = node.style;
  requestAnimationFrame(function () {
    style.minHeight = 'initial';
    style.height = scrollHeight + 'px';
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function () {
      style.height = '0';
      style.padding = '0';
      style.margin = '0';
      setTimeout(done, duration);
    });
  });
}

/**
 * Css animation that just work.
 * You could use animate.css for instance
 *
 *
 * ```
 * cssTransition({
 *   enter: "animate__animated animate__bounceIn",
 *   exit: "animate__animated animate__bounceOut"
 * })
 * ```
 *
 */

function cssTransition(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === void 0 ? true : _ref$collapse,
      _ref$collapseDuration = _ref.collapseDuration,
      collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        done = _ref2.done,
        nodeRef = _ref2.nodeRef,
        isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = (0,react.useRef)();
    var animationStep = (0,react.useRef)(0
    /* Enter */
    );
    (0,react.useLayoutEffect)(function () {
      onEnter();
    }, []);
    (0,react.useEffect)(function () {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);

    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener('animationend', onEntered);
      node.addEventListener('animationcancel', onEntered);
    }

    function onEntered(e) {
      if (e.target !== nodeRef.current) return;
      var node = nodeRef.current;
      node.dispatchEvent(new Event("d"
      /* ENTRANCE_ANIMATION_END */
      ));
      node.removeEventListener('animationend', onEntered);
      node.removeEventListener('animationcancel', onEntered);

      if (animationStep.current === 0
      /* Enter */
      ) {
          node.className = baseClassName.current;
        }
    }

    function onExit() {
      animationStep.current = 1
      /* Exit */
      ;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener('animationend', onExited);
    }

    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener('animationend', onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }

    return react.createElement(react.Fragment, null, children);
  };
}

var eventManager = {
  list: /*#__PURE__*/new Map(),
  emitQueue: /*#__PURE__*/new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function (cb) {
        return cb !== callback;
      });
      this.list.set(event, cb);
      return this;
    }

    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);

    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }

    return this;
  },

  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.list.has(event) && this.list.get(event).forEach(function (callback) {
      var timer = setTimeout(function () {
        // @ts-ignore
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

      _this.emitQueue.get(event).push(timer);
    });
  }
};

var _excluded = ["delay", "staleId"];
function useToastContainer(props) {
  var _useReducer = (0,react.useReducer)(function (x) {
    return x + 1;
  }, 0),
      forceUpdate = _useReducer[1];

  var _useState = (0,react.useState)([]),
      toastIds = _useState[0],
      setToastIds = _useState[1];

  var containerRef = (0,react.useRef)(null);
  var toastToRender = (0,react.useRef)(new Map()).current;

  var isToastActive = function isToastActive(id) {
    return toastIds.indexOf(id) !== -1;
  };

  var instance = (0,react.useRef)({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props: props,
    containerId: null,
    isToastActive: isToastActive,
    getToast: function getToast(id) {
      return toastToRender.get(id);
    }
  }).current;
  (0,react.useEffect)(function () {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(3
    /* WillUnmount */
    ).on(0
    /* Show */
    , buildToast).on(1
    /* Clear */
    , function (toastId) {
      return containerRef.current && removeToast(toastId);
    }).on(5
    /* ClearWaitingQueue */
    , clearWaitingQueue).emit(2
    /* DidMount */
    , instance);
    return function () {
      return eventManager.emit(3
      /* WillUnmount */
      , instance);
    };
  }, []);
  (0,react.useEffect)(function () {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toastIds.length;
    eventManager.emit(4
    /* Change */
    , toastIds.length, props.containerId);
  }, [toastIds]);
  (0,react.useEffect)(function () {
    instance.props = props;
  });

  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;

    if (limit && (!containerId || instance.containerId === containerId)) {
      instance.count -= instance.queue.length;
      instance.queue = [];
    }
  }

  function removeToast(toastId) {
    setToastIds(function (state) {
      return isToastIdValid(toastId) ? state.filter(function (id) {
        return id !== toastId;
      }) : [];
    });
  }

  function dequeueToast() {
    var _instance$queue$shift = instance.queue.shift(),
        toastContent = _instance$queue$shift.toastContent,
        toastProps = _instance$queue$shift.toastProps,
        staleId = _instance$queue$shift.staleId;

    appendToast(toastContent, toastProps, staleId);
  }
  /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */


  function isNotValid(options) {
    return !containerRef.current || instance.props.enableMultiContainer && options.containerId !== instance.props.containerId || toastToRender.has(options.toastId) && options.updateId == null;
  } // this function and all the function called inside needs to rely on refs


  function buildToast(content, _ref2) {
    var delay = _ref2.delay,
        staleId = _ref2.staleId,
        options = _objectWithoutPropertiesLoose(_ref2, _excluded);

    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId,
        updateId = options.updateId,
        data = options.data;
    var props = instance.props;

    var closeToast = function closeToast() {
      return removeToast(toastId);
    };

    var isNotAnUpdate = updateId == null;
    if (isNotAnUpdate) instance.count++;
    var toastProps = {
      toastId: toastId,
      updateId: updateId,
      isLoading: options.isLoading,
      theme: options.theme || props.theme,
      icon: options.icon != null ? options.icon : props.icon,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast: closeToast,
      closeButton: options.closeButton,
      rtl: props.rtl,
      position: options.position || props.position,
      transition: options.transition || props.transition,
      className: parseClassName(options.className || props.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props.bodyClassName),
      style: options.style || props.toastStyle,
      bodyStyle: options.bodyStyle || props.bodyStyle,
      onClick: options.onClick || props.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props.draggable,
      draggablePercent: options.draggablePercent || props.draggablePercent,
      draggableDirection: options.draggableDirection || props.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props.progressClassName),
      progressStyle: options.progressStyle || props.progressStyle,
      autoClose: options.isLoading ? false : getAutoCloseDelay(options.autoClose, props.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
      progress: options.progress,
      role: options.role || props.role,
      deleteToast: function deleteToast() {
        toastToRender["delete"](toastId);
        var queueLen = instance.queue.length;
        instance.count = isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
        if (instance.count < 0) instance.count = 0;

        if (queueLen > 0) {
          var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;

          if (queueLen === 1 || freeSlot === 1) {
            instance.displayedToast++;
            dequeueToast();
          } else {
            var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
            instance.displayedToast = toDequeue;

            for (var i = 0; i < toDequeue; i++) {
              dequeueToast();
            }
          }
        } else {
          forceUpdate();
        }
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    toastProps.closeButton = props.closeButton;

    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      toastProps.closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      toastProps.closeButton = canBeRendered(props.closeButton) ? props.closeButton : true;
    }

    var toastContent = content;

    if ((0,react.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react.cloneElement)(content, {
        closeToast: closeToast,
        toastProps: toastProps,
        data: data
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast: closeToast,
        toastProps: toastProps,
        data: data
      });
    } // not handling limit + delay by design. Waiting for user feedback first


    if (props.limit && props.limit > 0 && instance.count > props.limit && isNotAnUpdate) {
      instance.queue.push({
        toastContent: toastContent,
        toastProps: toastProps,
        staleId: staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function () {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }

  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) toastToRender["delete"](staleId);
    toastToRender.set(toastId, {
      content: content,
      props: toastProps
    });
    setToastIds(function (state) {
      return [].concat(state, [toastId]).filter(function (id) {
        return id !== staleId;
      });
    });
  }

  function getToastToRender(cb) {
    var toRender = new Map();
    var collection = Array.from(toastToRender.values());
    if (props.newestOnTop) collection.reverse();
    collection.forEach(function (toast) {
      var position = toast.props.position;
      toRender.has(position) || toRender.set(position, []);
      toRender.get(position).push(toast);
    });
    return Array.from(toRender, function (p) {
      return cb(p[0], p[1]);
    });
  }

  return {
    getToastToRender: getToastToRender,
    containerRef: containerRef,
    isToastActive: isToastActive
  };
}

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

function useToast(props) {
  var _useState = (0,react.useState)(false),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var _useState2 = (0,react.useState)(false),
      preventExitTransition = _useState2[0],
      setPreventExitTransition = _useState2[1];

  var toastRef = (0,react.useRef)(null);
  var drag = (0,react.useRef)({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null,
    didMove: false
  }).current;
  var syncProps = (0,react.useRef)(props);
  var autoClose = props.autoClose,
      pauseOnHover = props.pauseOnHover,
      closeToast = props.closeToast,
      onClick = props.onClick,
      closeOnClick = props.closeOnClick;
  (0,react.useEffect)(function () {
    syncProps.current = props;
  });
  (0,react.useEffect)(function () {
    if (toastRef.current) toastRef.current.addEventListener("d"
    /* ENTRANCE_ANIMATION_END */
    , playToast, {
      once: true
    });
    if (isFn(props.onOpen)) props.onOpen((0,react.isValidElement)(props.children) && props.children.props);
    return function () {
      var props = syncProps.current;
      if (isFn(props.onClose)) props.onClose((0,react.isValidElement)(props.children) && props.children.props);
    };
  }, []);
  (0,react.useEffect)(function () {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function () {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);

  function onDragStart(e) {
    if (props.draggable) {
      bindDragEvents();
      var toast = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast.getBoundingClientRect();
      toast.style.transition = '';
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.start = drag.x;
          drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
        } else {
        drag.start = drag.y;
        drag.removalDistance = toast.offsetHeight * (props.draggablePercent === 80
        /* DRAGGABLE_PERCENT */
        ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
      }
    }
  }

  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect,
          top = _drag$boundingRect.top,
          bottom = _drag$boundingRect.bottom,
          left = _drag$boundingRect.left,
          right = _drag$boundingRect.right;

      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }

  function playToast() {
    setIsRunning(true);
  }

  function pauseToast() {
    setIsRunning(false);
  }

  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener('focus', playToast);
    window.addEventListener('blur', pauseToast);
  }

  function unbindFocusEvents() {
    window.removeEventListener('focus', playToast);
    window.removeEventListener('blur', pauseToast);
  }

  function bindDragEvents() {
    drag.didMove = false;
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchmove', onDragMove);
    document.addEventListener('touchend', onDragEnd);
  }

  function unbindDragEvents() {
    document.removeEventListener('mousemove', onDragMove);
    document.removeEventListener('mouseup', onDragEnd);
    document.removeEventListener('touchmove', onDragMove);
    document.removeEventListener('touchend', onDragEnd);
  }

  function onDragMove(e) {
    var toast = toastRef.current;

    if (drag.canDrag && toast) {
      drag.didMove = true;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);

      if (props.draggableDirection === "x"
      /* X */
      ) {
          drag.delta = drag.x - drag.start;
        } else {
        drag.delta = drag.y - drag.start;
      } // prevent false positif during a toast click


      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }

  function onDragEnd() {
    unbindDragEvents();
    var toast = toastRef.current;

    if (drag.canDrag && drag.didMove && toast) {
      drag.canDrag = false;

      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }

      toast.style.transition = 'transform 0.2s, opacity 0.2s';
      toast.style.transform = "translate" + props.draggableDirection + "(0)";
      toast.style.opacity = '1';
    }
  }

  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };

  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  } // prevent toast from closing when user drags the toast


  if (closeOnClick) {
    eventHandlers.onClick = function (e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }

  return {
    playToast: playToast,
    pauseToast: pauseToast,
    isRunning: isRunning,
    preventExitTransition: preventExitTransition,
    toastRef: toastRef,
    eventHandlers: eventHandlers
  };
}

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      theme = _ref.theme,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? 'close' : _ref$ariaLabel;
  return (0,react.createElement)("button", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button " + "Toastify"
    /* CSS_NAMESPACE */
    + "__close-button--" + theme,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, (0,react.createElement)("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, (0,react.createElement)("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}

function ProgressBar(_ref) {
  var _cx, _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      rtl = _ref.rtl,
      isIn = _ref.isIn,
      theme = _ref.theme;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1
  });

  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar", controlledProgress ? "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--controlled" : "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--animated", "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar-theme--" + theme, "Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl: rtl,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className); // 🧐 controlledProgress is derived from progress
  // so if controlledProgress is set
  // it means that this is also the case for progress

  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : function () {
    isIn && closeToast();
  }, _animationEvent); // TODO: add aria-valuenow, aria-valuemax, aria-valuemin

  return (0,react.createElement)("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? 'true' : 'false',
    "aria-label": "notification timer",
    className: classNames,
    style: style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};

var _excluded$1 = ["theme", "type"];

var Svg = function Svg(_ref) {
  var theme = _ref.theme,
      type = _ref.type,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  return (0,react.createElement)("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: theme === 'colored' ? 'currentColor' : "var(--toastify-icon-color-" + type + ")"
  }, rest));
};

function Warning(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}

function Info(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}

function Success(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}

function Error(props) {
  return (0,react.createElement)(Svg, Object.assign({}, props), (0,react.createElement)("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}

function Spinner() {
  return (0,react.createElement)("div", {
    className: "Toastify"
    /* CSS_NAMESPACE */
    + "__spinner"
  });
}

var Icons = {
  info: Info,
  warning: Warning,
  success: Success,
  error: Error,
  spinner: Spinner
};

var Toast = function Toast(props) {
  var _cx, _cx2;

  var _useToast = useToast(props),
      isRunning = _useToast.isRunning,
      preventExitTransition = _useToast.preventExitTransition,
      toastRef = _useToast.toastRef,
      eventHandlers = _useToast.eventHandlers;

  var closeButton = props.closeButton,
      children = props.children,
      autoClose = props.autoClose,
      onClick = props.onClick,
      type = props.type,
      hideProgressBar = props.hideProgressBar,
      closeToast = props.closeToast,
      Transition = props.transition,
      position = props.position,
      className = props.className,
      style = props.style,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      progressClassName = props.progressClassName,
      progressStyle = props.progressStyle,
      updateId = props.updateId,
      role = props.role,
      progress = props.progress,
      rtl = props.rtl,
      toastId = props.toastId,
      deleteToast = props.deleteToast,
      isIn = props.isIn,
      isLoading = props.isLoading,
      icon = props.icon,
      theme = props.theme;
  var defaultClassName = clsx_m("Toastify"
  /* CSS_NAMESPACE */
  + "__toast", "Toastify"
  /* CSS_NAMESPACE */
  + "__toast-theme--" + theme, "Toastify"
  /* CSS_NAMESPACE */
  + "__toast--" + type, (_cx = {}, _cx["Toastify"
  /* CSS_NAMESPACE */
  + "__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl: rtl,
    position: position,
    type: type,
    defaultClassName: defaultClassName
  }) : clsx_m(defaultClassName, className);
  var isProgressControlled = !!progress;
  var maybeIcon = Icons[type];
  var iconProps = {
    theme: theme,
    type: type
  };
  var Icon = maybeIcon && maybeIcon(iconProps);

  if (icon === false) {
    Icon = void 0;
  } else if (isFn(icon)) {
    Icon = icon(iconProps);
  } else if ((0,react.isValidElement)(icon)) {
    Icon = (0,react.cloneElement)(icon, iconProps);
  } else if (isStr(icon)) {
    Icon = icon;
  } else if (isLoading) {
    Icon = Icons.spinner();
  }

  function renderCloseButton(closeButton) {
    if (!closeButton) return;
    var props = {
      closeToast: closeToast,
      type: type,
      theme: theme
    };
    if (isFn(closeButton)) return closeButton(props);
    if ((0,react.isValidElement)(closeButton)) return (0,react.cloneElement)(closeButton, props);
  }

  return (0,react.createElement)(Transition, {
    isIn: isIn,
    done: deleteToast,
    position: position,
    preventExitTransition: preventExitTransition,
    nodeRef: toastRef
  }, (0,react.createElement)("div", Object.assign({
    id: toastId,
    onClick: onClick,
    className: cssClasses
  }, eventHandlers, {
    style: style,
    ref: toastRef
  }), (0,react.createElement)("div", Object.assign({}, isIn && {
    role: role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type: type
    }) : clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-body", bodyClassName),
    style: bodyStyle
  }), Icon && (0,react.createElement)("div", {
    className: clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-icon", (_cx2 = {}, _cx2["Toastify"
    /* CSS_NAMESPACE */
    + "--animate-icon " + "Toastify"
    /* CSS_NAMESPACE */
    + "__zoom-enter"] = !isLoading, _cx2))
  }, Icon), (0,react.createElement)("div", null, children)), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0,react.createElement)(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl: rtl,
    theme: theme,
    delay: autoClose,
    isRunning: isRunning,
    isIn: isIn,
    closeToast: closeToast,
    hide: hideProgressBar,
    type: type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress: progress
  }))));
};

var Bounce = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__bounce-exit",
  appendPosition: true
});
var Slide = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__slide-exit",
  appendPosition: true
});
var Zoom = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__zoom-exit"
});
var Flip = /*#__PURE__*/cssTransition({
  enter: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-enter",
  exit: "Toastify"
  /* CSS_NAMESPACE */
  + "--animate " + "Toastify"
  /* CSS_NAMESPACE */
  + "__flip-exit"
});

var ToastContainer = function ToastContainer(props) {
  var _useToastContainer = useToastContainer(props),
      getToastToRender = _useToastContainer.getToastToRender,
      containerRef = _useToastContainer.containerRef,
      isToastActive = _useToastContainer.isToastActive;

  var className = props.className,
      style = props.style,
      rtl = props.rtl,
      containerId = props.containerId;

  function getClassName(position) {
    var _cx;

    var defaultClassName = clsx_m("Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container", "Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--" + position, (_cx = {}, _cx["Toastify"
    /* CSS_NAMESPACE */
    + "__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position: position,
      rtl: rtl,
      defaultClassName: defaultClassName
    }) : clsx_m(defaultClassName, parseClassName(className));
  }

  return (0,react.createElement)("div", {
    ref: containerRef,
    className: "Toastify"
    /* CSS_NAMESPACE */
    ,
    id: containerId
  }, getToastToRender(function (position, toastList) {
    var containerStyle = !toastList.length ? _extends({}, style, {
      pointerEvents: 'none'
    }) : _extends({}, style);
    return (0,react.createElement)("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function (_ref) {
      var content = _ref.content,
          toastProps = _ref.props;
      return (0,react.createElement)(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80
  /* DRAGGABLE_PERCENT */
  ,
  draggableDirection: "x"
  /* X */
  ,
  role: 'alert',
  theme: 'light'
};

var containers = /*#__PURE__*/new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */

function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return Math.random().toString(36).substring(2, 9);
}
/**
 * Generate a toastId or use the one provided
 */


function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */


function dispatchToast(content, options) {
  if (containers.size > 0) {
    eventManager.emit(0
    /* Show */
    , content, options);
  } else {
    queue.push({
      content: content,
      options: options
    });

    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement('div');
      document.body.appendChild(containerDomNode);
      (0,react_dom.render)((0,react.createElement)(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }

  return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}

function createToastByType(type) {
  return function (content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
}

function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
}

toast.loading = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends({
    isLoading: true,
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    draggable: false
  }, options)));
};

function handlePromise(promise, _ref2, options) {
  var pending = _ref2.pending,
      error = _ref2.error,
      success = _ref2.success;
  var id;

  if (pending) {
    id = isStr(pending) ? toast.loading(pending, options) : toast.loading(pending.render, _extends({}, options, pending));
  }

  var resetParams = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  };

  var resolver = function resolver(type, input, result) {
    // Remove the toast if the input has not been provided. This prevents the toast from hanging
    // in the pending state if a success/error toast has not been provided.
    if (input == null) {
      toast.dismiss(id);
      return;
    }

    var baseParams = _extends({
      type: type
    }, resetParams, options, {
      data: result
    });

    var params = isStr(input) ? {
      render: input
    } : input; // if the id is set we know that it's an update

    if (id) {
      toast.update(id, _extends({}, baseParams, params));
    } else {
      // using toast.promise without loading
      toast(params.render, _extends({}, baseParams, params));
    }

    return result;
  };

  var p = isFn(promise) ? promise() : promise; //call the resolvers only when needed

  p.then(function (result) {
    return resolver('success', success, result);
  })["catch"](function (err) {
    return resolver('error', error, err);
  });
  return p;
}

toast.promise = handlePromise;
toast.success = /*#__PURE__*/createToastByType(TYPE.SUCCESS);
toast.info = /*#__PURE__*/createToastByType(TYPE.INFO);
toast.error = /*#__PURE__*/createToastByType(TYPE.ERROR);
toast.warning = /*#__PURE__*/createToastByType(TYPE.WARNING);
toast.warn = toast.warning;

toast.dark = function (content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends({
    theme: 'dark'
  }, options)));
};
/**
 * Remove toast programmaticaly
 */


toast.dismiss = function (id) {
  return eventManager.emit(1
  /* Clear */
  , id);
};
/**
 * Clear waiting queue when limit is used
 */


toast.clearWaitingQueue = function (params) {
  if (params === void 0) {
    params = {};
  }

  return eventManager.emit(5
  /* ClearWaitingQueue */
  , params);
};
/**
 * return true if one container is displaying the toast
 */


toast.isActive = function (id) {
  var isToastActive = false;
  containers.forEach(function (container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};

toast.update = function (toastId, options) {
  if (options === void 0) {
    options = {};
  }

  // if you call toast and toast.update directly nothing will be displayed
  // this is why I defered the update
  setTimeout(function () {
    var toast = getToast(toastId, options);

    if (toast) {
      var oldOptions = toast.props,
          oldContent = toast.content;

      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });

      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
/**
 * Used for controlled progress bar.
 */


toast.done = function (id) {
  toast.update(id, {
    progress: 1
  });
};
/**
 * @deprecated
 * API will change in the next major release
 *
 * Track changes. The callback get the number of toast displayed
 */


toast.onChange = function (callback) {
  if (isFn(callback)) {
    eventManager.on(4
    /* Change */
    , callback);
  }

  return function () {
    isFn(callback) && eventManager.off(4
    /* Change */
    , callback);
  };
};
/**
 * @deprecated
 * will be removed in the next major release
 *
 * Configure the ToastContainer when lazy mounted
 * Prefer ToastContainer over this one
 */


toast.configure = function (config) {
  if (config === void 0) {
    config = {};
  }

  lazy = true;
  containerConfig = config;
};

toast.POSITION = POSITION;
toast.TYPE = TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */

eventManager.on(2
/* DidMount */
, function (containerInstance) {
  latestInstance = containerInstance.containerId || containerInstance;
  containers.set(latestInstance, containerInstance);
  queue.forEach(function (item) {
    eventManager.emit(0
    /* Show */
    , item.content, item.options);
  });
  queue = [];
}).on(3
/* WillUnmount */
, function (containerInstance) {
  containers["delete"](containerInstance.containerId || containerInstance);

  if (containers.size === 0) {
    eventManager.off(0
    /* Show */
    ).off(1
    /* Clear */
    ).off(5
    /* ClearWaitingQueue */
    );
  }

  if (canUseDom && containerDomNode) {
    document.body.removeChild(containerDomNode);
  }
});


//# sourceMappingURL=react-toastify.esm.js.map


/***/ }),

/***/ 47317:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14859);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38111));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(97111));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _utils = __webpack_require__(13418);

var propTypes = {
  active: _propTypes.default.bool,
  'aria-label': _propTypes.default.string,
  block: _propTypes.default.bool,
  color: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  outline: _propTypes.default.bool,
  tag: _utils.tagPropType,
  innerRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
  onClick: _propTypes.default.func,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  cssModule: _propTypes.default.object,
  close: _propTypes.default.bool
};
var defaultProps = {
  color: 'secondary',
  tag: 'button'
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Button, _React$Component);

  function Button(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = Button.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        ariaLabel = _this$props['aria-label'],
        block = _this$props.block,
        className = _this$props.className,
        close = _this$props.close,
        cssModule = _this$props.cssModule,
        color = _this$props.color,
        outline = _this$props.outline,
        size = _this$props.size,
        Tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        attributes = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["active", "aria-label", "block", "className", "close", "cssModule", "color", "outline", "size", "tag", "innerRef"]);

    if (close && typeof attributes.children === 'undefined') {
      attributes.children = _react.default.createElement("span", {
        "aria-hidden": true
      }, "\xD7");
    }

    var btnOutlineColor = "btn" + (outline ? '-outline' : '') + "-" + color;
    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
      close: close
    }, close || 'btn', close || btnOutlineColor, size ? "btn-" + size : false, block ? 'btn-block' : false, {
      active: active,
      disabled: this.props.disabled
    }), cssModule);

    if (attributes.href && Tag === 'button') {
      Tag = 'a';
    }

    var defaultAriaLabel = close ? 'Close' : null;
    return _react.default.createElement(Tag, (0, _extends2.default)({
      type: Tag === 'button' && attributes.onClick ? 'button' : undefined
    }, attributes, {
      className: classes,
      ref: innerRef,
      onClick: this.onClick,
      "aria-label": ariaLabel || defaultAriaLabel
    }));
  };

  return Button;
}(_react.default.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;

/***/ }),

/***/ 28261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _utils = __webpack_require__(13418);

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);

var columnProps = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
  size: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes = {
  tag: _utils.tagPropType,
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: _propTypes.default.string,
  cssModule: _propTypes.default.object,
  widths: _propTypes.default.array
};
var defaultProps = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : "col-" + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : "col-" + colWidth + "-auto";
  }

  return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "widths", "tag"]);
  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];
    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if ((0, _utils.isObject)(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-" + colWidth + "-";
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);
      colClasses.push((0, _utils.mapToCssModules)((0, _classnames.default)((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === '', _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);

      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, colClasses), cssModule);
  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
    className: classes
  }));
};

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
var _default = Col;
exports.Z = _default;

/***/ }),

/***/ 42916:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38111));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(97111));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _reactPopper = __webpack_require__(42397);

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _DropdownContext = __webpack_require__(62684);

var _utils = __webpack_require__(13418);

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md
var propTypes = {
  a11y: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  direction: _propTypes.default.oneOf(['up', 'down', 'left', 'right']),
  group: _propTypes.default.bool,
  isOpen: _propTypes.default.bool,
  nav: _propTypes.default.bool,
  active: _propTypes.default.bool,
  addonType: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['prepend', 'append'])]),
  size: _propTypes.default.string,
  tag: _utils.tagPropType,
  toggle: _propTypes.default.func,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  cssModule: _propTypes.default.object,
  inNavbar: _propTypes.default.bool,
  setActiveFromChild: _propTypes.default.bool
};
var defaultProps = {
  a11y: true,
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false,
  setActiveFromChild: false
};
var preventDefaultKeys = [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down, _utils.keyCodes.end, _utils.keyCodes.home];

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Dropdown, _React$Component);

  function Dropdown(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.addEvents = _this.addEvents.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDocumentClick = _this.handleDocumentClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeEvents = _this.removeEvents.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggle = _this.toggle.bind((0, _assertThisInitialized2.default)(_this));
    _this.containerRef = _react.default.createRef();
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.getContextValue = function getContextValue() {
    return {
      toggle: this.toggle,
      isOpen: this.props.isOpen,
      direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
      inNavbar: this.props.inNavbar,
      disabled: this.props.disabled
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.handleProps();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.handleProps();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeEvents();
  };

  _proto.getContainer = function getContainer() {
    return this.containerRef.current;
  };

  _proto.getMenuCtrl = function getMenuCtrl() {
    if (this._$menuCtrl) return this._$menuCtrl;
    this._$menuCtrl = this.getContainer().querySelector('[aria-expanded]');
    return this._$menuCtrl;
  };

  _proto.getMenuItems = function getMenuItems() {
    return [].slice.call(this.getContainer().querySelectorAll('[role="menuitem"]'));
  };

  _proto.addEvents = function addEvents() {
    var _this2 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.addEventListener(event, _this2.handleDocumentClick, true);
    });
  };

  _proto.removeEvents = function removeEvents() {
    var _this3 = this;

    ['click', 'touchstart', 'keyup'].forEach(function (event) {
      return document.removeEventListener(event, _this3.handleDocumentClick, true);
    });
  };

  _proto.handleDocumentClick = function handleDocumentClick(e) {
    if (e && (e.which === 3 || e.type === 'keyup' && e.which !== _utils.keyCodes.tab)) return;
    var container = this.getContainer();

    if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === _utils.keyCodes.tab)) {
      return;
    }

    this.toggle(e);
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    var _this4 = this;

    if (/input|textarea/i.test(e.target.tagName) || _utils.keyCodes.tab === e.which && (e.target.getAttribute('role') !== 'menuitem' || !this.props.a11y)) {
      return;
    }

    if (preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) {
      e.preventDefault();
    }

    if (this.props.disabled) return;

    if (this.getMenuCtrl() === e.target) {
      if (!this.props.isOpen && [_utils.keyCodes.space, _utils.keyCodes.enter, _utils.keyCodes.up, _utils.keyCodes.down].indexOf(e.which) > -1) {
        this.toggle(e);
        setTimeout(function () {
          return _this4.getMenuItems()[0].focus();
        });
      } else if (this.props.isOpen && e.which === _utils.keyCodes.esc) {
        this.toggle(e);
      }
    }

    if (this.props.isOpen && e.target.getAttribute('role') === 'menuitem') {
      if ([_utils.keyCodes.tab, _utils.keyCodes.esc].indexOf(e.which) > -1) {
        this.toggle(e);
        this.getMenuCtrl().focus();
      } else if ([_utils.keyCodes.space, _utils.keyCodes.enter].indexOf(e.which) > -1) {
        e.target.click();
        this.getMenuCtrl().focus();
      } else if ([_utils.keyCodes.down, _utils.keyCodes.up].indexOf(e.which) > -1 || [_utils.keyCodes.n, _utils.keyCodes.p].indexOf(e.which) > -1 && e.ctrlKey) {
        var $menuitems = this.getMenuItems();
        var index = $menuitems.indexOf(e.target);

        if (_utils.keyCodes.up === e.which || _utils.keyCodes.p === e.which && e.ctrlKey) {
          index = index !== 0 ? index - 1 : $menuitems.length - 1;
        } else if (_utils.keyCodes.down === e.which || _utils.keyCodes.n === e.which && e.ctrlKey) {
          index = index === $menuitems.length - 1 ? 0 : index + 1;
        }

        $menuitems[index].focus();
      } else if (_utils.keyCodes.end === e.which) {
        var _$menuitems = this.getMenuItems();

        _$menuitems[_$menuitems.length - 1].focus();
      } else if (_utils.keyCodes.home === e.which) {
        var _$menuitems2 = this.getMenuItems();

        _$menuitems2[0].focus();
      } else if (e.which >= 48 && e.which <= 90) {
        var _$menuitems3 = this.getMenuItems();

        var charPressed = String.fromCharCode(e.which).toLowerCase();

        for (var i = 0; i < _$menuitems3.length; i += 1) {
          var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();

          if (firstLetter === charPressed) {
            _$menuitems3[i].focus();

            break;
          }
        }
      }
    }
  };

  _proto.handleProps = function handleProps() {
    if (this.props.isOpen) {
      this.addEvents();
    } else {
      this.removeEvents();
    }
  };

  _proto.toggle = function toggle(e) {
    if (this.props.disabled) {
      return e && e.preventDefault();
    }

    return this.props.toggle(e);
  };

  _proto.render = function render() {
    var _classNames, _ref;

    var _omit = (0, _utils.omit)(this.props, ['toggle', 'disabled', 'inNavbar', 'a11y']),
        className = _omit.className,
        cssModule = _omit.cssModule,
        direction = _omit.direction,
        isOpen = _omit.isOpen,
        group = _omit.group,
        size = _omit.size,
        nav = _omit.nav,
        setActiveFromChild = _omit.setActiveFromChild,
        active = _omit.active,
        addonType = _omit.addonType,
        tag = _omit.tag,
        attrs = (0, _objectWithoutPropertiesLoose2.default)(_omit, ["className", "cssModule", "direction", "isOpen", "group", "size", "nav", "setActiveFromChild", "active", "addonType", "tag"]);

    var Tag = tag || (nav ? 'li' : 'div');
    var subItemIsActive = false;

    if (setActiveFromChild) {
      _react.default.Children.map(this.props.children[1].props.children, function (dropdownItem) {
        if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
      });
    }

    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, direction !== 'down' && "drop" + direction, nav && active ? 'active' : false, setActiveFromChild && subItemIsActive ? 'active' : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames['btn-group'] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames['nav-item'] = nav, _classNames)), cssModule);
    return _react.default.createElement(_DropdownContext.DropdownContext.Provider, {
      value: this.getContextValue()
    }, _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(Tag, (0, _extends2.default)({}, attrs, (_ref = {}, _ref[typeof Tag === 'string' ? 'ref' : 'innerRef'] = this.containerRef, _ref), {
      onKeyDown: this.handleKeyDown,
      className: classes
    }))));
  };

  return Dropdown;
}(_react.default.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
var _default = Dropdown;
exports.Z = _default;

/***/ }),

/***/ 62684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14859);

exports.__esModule = true;
exports.DropdownContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(2784));

/**
 * DropdownContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  isOpen: PropTypes.bool.isRequired,
 *  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
 *  inNavbar: PropTypes.bool.isRequired,
 *  disabled: PropTypes.bool
 * }
 */
var DropdownContext = _react.default.createContext({});

exports.DropdownContext = DropdownContext;

/***/ }),

/***/ 83483:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectSpread3 = _interopRequireDefault(__webpack_require__(25782));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(97111));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _reactPopper = __webpack_require__(42397);

var _DropdownContext = __webpack_require__(62684);

var _utils = __webpack_require__(13418);

var propTypes = {
  tag: _utils.tagPropType,
  children: _propTypes.default.node.isRequired,
  right: _propTypes.default.bool,
  flip: _propTypes.default.bool,
  modifiers: _propTypes.default.object,
  className: _propTypes.default.string,
  cssModule: _propTypes.default.object,
  persist: _propTypes.default.bool,
  positionFixed: _propTypes.default.bool
};
var defaultProps = {
  tag: 'div',
  flip: true
};
var noFlipModifier = {
  flip: {
    enabled: false
  }
};
var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DropdownMenu, _React$Component);

  function DropdownMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        cssModule = _this$props.cssModule,
        right = _this$props.right,
        tag = _this$props.tag,
        flip = _this$props.flip,
        modifiers = _this$props.modifiers,
        persist = _this$props.persist,
        positionFixed = _this$props.positionFixed,
        attrs = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "cssModule", "right", "tag", "flip", "modifiers", "persist", "positionFixed"]);
    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, 'dropdown-menu', {
      'dropdown-menu-right': right,
      show: this.context.isOpen
    }), cssModule);
    var Tag = tag;

    if (persist || this.context.isOpen && !this.context.inNavbar) {
      var position1 = directionPositionMap[this.context.direction] || 'bottom';
      var position2 = right ? 'end' : 'start';
      var poperPlacement = position1 + "-" + position2;
      var poperModifiers = !flip ? (0, _objectSpread3.default)({}, modifiers, {}, noFlipModifier) : modifiers;
      var popperPositionFixed = !!positionFixed;
      return _react.default.createElement(_reactPopper.Popper, {
        placement: poperPlacement,
        modifiers: poperModifiers,
        positionFixed: popperPositionFixed
      }, function (_ref) {
        var ref = _ref.ref,
            style = _ref.style,
            placement = _ref.placement;
        return _react.default.createElement(Tag, (0, _extends2.default)({
          tabIndex: "-1",
          role: "menu",
          ref: ref,
          style: style
        }, attrs, {
          "aria-hidden": !_this.context.isOpen,
          className: classes,
          "x-placement": placement
        }));
      });
    }

    return _react.default.createElement(Tag, (0, _extends2.default)({
      tabIndex: "-1",
      role: "menu"
    }, attrs, {
      "aria-hidden": !this.context.isOpen,
      className: classes,
      "x-placement": attrs.placement
    }));
  };

  return DropdownMenu;
}(_react.default.Component);

;
DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
DropdownMenu.contextType = _DropdownContext.DropdownContext;
var _default = DropdownMenu;
exports.Z = _default;

/***/ }),

/***/ 89166:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38111));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(97111));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _reactPopper = __webpack_require__(42397);

var _DropdownContext = __webpack_require__(62684);

var _utils = __webpack_require__(13418);

var _Button = _interopRequireDefault(__webpack_require__(47317));

var propTypes = {
  caret: _propTypes.default.bool,
  color: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  cssModule: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  'aria-haspopup': _propTypes.default.bool,
  split: _propTypes.default.bool,
  tag: _utils.tagPropType,
  nav: _propTypes.default.bool
};
var defaultProps = {
  'aria-haspopup': true,
  color: 'secondary'
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.onClick = function onClick(e) {
    if (this.props.disabled || this.context.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.nav && !this.props.tag) {
      e.preventDefault();
    }

    if (this.props.onClick) {
      this.props.onClick(e);
    }

    this.context.toggle(e);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        color = _this$props.color,
        cssModule = _this$props.cssModule,
        caret = _this$props.caret,
        split = _this$props.split,
        nav = _this$props.nav,
        tag = _this$props.tag,
        innerRef = _this$props.innerRef,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["className", "color", "cssModule", "caret", "split", "nav", "tag", "innerRef"]);
    var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
    var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, {
      'dropdown-toggle': caret || split,
      'dropdown-toggle-split': split,
      'nav-link': nav
    }), cssModule);
    var children = typeof props.children !== 'undefined' ? props.children : _react.default.createElement("span", {
      className: "sr-only"
    }, ariaLabel);
    var Tag;

    if (nav && !tag) {
      Tag = 'a';
      props.href = '#';
    } else if (!tag) {
      Tag = _Button.default;
      props.color = color;
      props.cssModule = cssModule;
    } else {
      Tag = tag;
    }

    if (this.context.inNavbar) {
      return _react.default.createElement(Tag, (0, _extends2.default)({}, props, {
        className: classes,
        onClick: this.onClick,
        "aria-expanded": this.context.isOpen,
        children: children
      }));
    }

    return _react.default.createElement(_reactPopper.Reference, {
      innerRef: innerRef
    }, function (_ref) {
      var _ref2;

      var ref = _ref.ref;
      return _react.default.createElement(Tag, (0, _extends2.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === 'string' ? 'ref' : 'innerRef'] = ref, _ref2), {
        className: classes,
        onClick: _this2.onClick,
        "aria-expanded": _this2.context.isOpen,
        children: children
      }));
    });
  };

  return DropdownToggle;
}(_react.default.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
DropdownToggle.contextType = _DropdownContext.DropdownContext;
var _default = DropdownToggle;
exports.Z = _default;

/***/ }),

/***/ 50157:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _react = _interopRequireDefault(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _utils = __webpack_require__(13418);

var rowColWidths = ['xs', 'sm', 'md', 'lg', 'xl'];

var rowColsPropType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]);

var propTypes = {
  tag: _utils.tagPropType,
  noGutters: _propTypes.default.bool,
  className: _propTypes.default.string,
  cssModule: _propTypes.default.object,
  form: _propTypes.default.bool,
  xs: rowColsPropType,
  sm: rowColsPropType,
  md: rowColsPropType,
  lg: rowColsPropType,
  xl: rowColsPropType
};
var defaultProps = {
  tag: 'div',
  widths: rowColWidths
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      form = props.form,
      widths = props.widths,
      attributes = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "cssModule", "noGutters", "tag", "form", "widths"]);
  var colClasses = [];
  widths.forEach(function (colWidth, i) {
    var colSize = props[colWidth];
    delete attributes[colWidth];

    if (!colSize) {
      return;
    }

    var isXs = !i;
    colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
  });
  var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, noGutters ? 'no-gutters' : null, form ? 'form-row' : 'row', colClasses), cssModule);
  return _react.default.createElement(Tag, (0, _extends2.default)({}, attributes, {
    className: classes
  }));
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
var _default = Row;
exports.Z = _default;

/***/ }),

/***/ 13418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14859);

exports.__esModule = true;
exports.getScrollbarWidth = getScrollbarWidth;
exports.setScrollbarWidth = setScrollbarWidth;
exports.isBodyOverflowing = isBodyOverflowing;
exports.getOriginalBodyPadding = getOriginalBodyPadding;
exports.conditionallyUpdateScrollbar = conditionallyUpdateScrollbar;
exports.setGlobalCssModule = setGlobalCssModule;
exports.mapToCssModules = mapToCssModules;
exports.omit = omit;
exports.pick = pick;
exports.warnOnce = warnOnce;
exports.deprecated = deprecated;
exports.DOMElement = DOMElement;
exports.isReactRefObj = isReactRefObj;
exports.toNumber = toNumber;
exports.isObject = isObject;
exports.isFunction = isFunction;
exports.findDOMElements = findDOMElements;
exports.isArrayOrNodeList = isArrayOrNodeList;
exports.getTarget = getTarget;
exports.addMultipleEventListeners = addMultipleEventListeners;
exports.focusableElements = exports.defaultToggleEvents = exports.canUseDOM = exports.PopperPlacements = exports.keyCodes = exports.TransitionStatuses = exports.TransitionPropTypeKeys = exports.TransitionTimeouts = exports.tagPropType = exports.targetPropType = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div'); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);
  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433

  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules(className, cssModule) {
  if (className === void 0) {
    className = '';
  }

  if (cssModule === void 0) {
    cssModule = globalCssModule;
  }

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */


function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */


function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }

  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
} // Shim Element if needed (e.g. in Node environment)


var Element = typeof window === 'object' && window.Element || function () {};

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

var targetPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, DOMElement, _propTypes.default.shape({
  current: _propTypes.default.any
})]);

exports.targetPropType = targetPropType;

var tagPropType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
  $$typeof: _propTypes.default.symbol,
  render: _propTypes.default.func
}), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.shape({
  $$typeof: _propTypes.default.symbol,
  render: _propTypes.default.func
})]))]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss


exports.tagPropType = tagPropType;
var TransitionTimeouts = {
  Fade: 150,
  // $transition-fade
  Collapse: 350,
  // $transition-collapse
  Modal: 300,
  // $modal-transition
  Carousel: 600 // $carousel-transition

}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.

exports.TransitionTimeouts = TransitionTimeouts;
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];
exports.TransitionPropTypeKeys = TransitionPropTypeKeys;
var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};
exports.TransitionStatuses = TransitionStatuses;
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};
exports.keyCodes = keyCodes;
var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
exports.PopperPlacements = PopperPlacements;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;

function isReactRefObj(target) {
  if (target && typeof target === 'object') {
    return 'current' in target;
  }

  return false;
}

function getTag(value) {
  if (value == null) {
    return value === undefined ? '[object Undefined]' : '[object Null]';
  }

  return Object.prototype.toString.call(value);
}

function toNumber(value) {
  var type = typeof value;
  var NAN = 0 / 0;

  if (type === 'number') {
    return value;
  }

  if (type === 'symbol' || type === 'object' && getTag(value) === '[object Symbol]') {
    return NAN;
  }

  if (isObject(value)) {
    var other = typeof value.valueOf === 'function' ? value.valueOf() : value;
    value = isObject(other) ? "" + other : other;
  }

  if (type !== 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(/^\s+|\s+$/g, '');
  var isBinary = /^0b[01]+$/i.test(value);
  return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}

function isObject(value) {
  var type = typeof value;
  return value != null && (type === 'object' || type === 'function');
}

function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }

  var tag = getTag(value);
  return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
}

function findDOMElements(target) {
  if (isReactRefObj(target)) {
    return target.current;
  }

  if (isFunction(target)) {
    return target();
  }

  if (typeof target === 'string' && canUseDOM) {
    var selection = document.querySelectorAll(target);

    if (!selection.length) {
      selection = document.querySelectorAll("#" + target);
    }

    if (!selection.length) {
      throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
    }

    return selection;
  }

  return target;
}

function isArrayOrNodeList(els) {
  if (els === null) {
    return false;
  }

  return Array.isArray(els) || canUseDOM && typeof els.length === 'number';
}

function getTarget(target, allElements) {
  var els = findDOMElements(target);

  if (allElements) {
    if (isArrayOrNodeList(els)) {
      return els;
    }

    if (els === null) {
      return [];
    }

    return [els];
  } else {
    if (isArrayOrNodeList(els)) {
      return els[0];
    }

    return els;
  }
}

var defaultToggleEvents = ['touchstart', 'click'];
exports.defaultToggleEvents = defaultToggleEvents;

function addMultipleEventListeners(_els, handler, _events, useCapture) {
  var els = _els;

  if (!isArrayOrNodeList(els)) {
    els = [els];
  }

  var events = _events;

  if (typeof events === 'string') {
    events = events.split(/\s+/);
  }

  if (!isArrayOrNodeList(els) || typeof handler !== 'function' || !Array.isArray(events)) {
    throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
  }

  Array.prototype.forEach.call(events, function (event) {
    Array.prototype.forEach.call(els, function (el) {
      el.addEventListener(event, handler, useCapture);
    });
  });
  return function removeEvents() {
    Array.prototype.forEach.call(events, function (event) {
      Array.prototype.forEach.call(els, function (el) {
        el.removeEventListener(event, handler, useCapture);
      });
    });
  };
}

var focusableElements = ['a[href]', 'area[href]', 'input:not([disabled]):not([type=hidden])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'object', 'embed', '[tabindex]:not(.modal)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'];
exports.focusableElements = focusableElements;

/***/ }),

/***/ 10961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var functionsHaveConfigurableNames = (__webpack_require__(8462).functionsHaveConfigurableNames)();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, "name", ({ value: 'get flags' }));
}


/***/ }),

/***/ 82201:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(14926);
var callBind = __webpack_require__(89429);

var implementation = __webpack_require__(10961);
var getPolyfill = __webpack_require__(54366);
var shim = __webpack_require__(60698);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),

/***/ 54366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(10961);

var supportsDescriptors = (__webpack_require__(14926).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),

/***/ 60698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(14926).supportsDescriptors);
var getPolyfill = __webpack_require__(54366);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 82740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iv": function() { return /* binding */ Ce; }
/* harmony export */ });
/* unused harmony exports ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, createGlobalStyle, isStyledComponent, keyframes, useTheme, version, withTheme */
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var shallowequal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88665);
/* harmony import */ var shallowequal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shallowequal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_stylis__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52274);
/* harmony import */ var _emotion_unitless__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31938);
/* harmony import */ var _emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1888);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73463);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);
/* provided dependency */ var process = __webpack_require__(34406);
function v(){return(v=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var g=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},S=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is__WEBPACK_IMPORTED_MODULE_0__.typeOf)(t)},w=Object.freeze([]),E=Object.freeze({});function b(e){return"function"==typeof e}function _(e){return false||e.displayName||e.name||"Component"}function N(e){return e&&"string"==typeof e.styledComponentId}var A="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="5.3.6",I="undefined"!=typeof window&&"HTMLElement"in window,P=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production"),O={},R= false?0:{};function D(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function j(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var T=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&j(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),x=new Map,k=new Map,V=1,B=function(e){if(x.has(e))return x.get(e);for(;k.has(V);)V++;var t=V++;return false&&0,x.set(e,t),k.set(t,e),t},z=function(e){return k.get(e)},M=function(e,t){t>=V&&(V=t+1),x.set(e,t),k.set(t,e)},G="style["+A+'][data-styled-version="5.3.6"]',L=new RegExp("^"+A+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),F=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},Y=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(L);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(M(u,c),F(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},q=function(){return true?__webpack_require__.nc:0},H=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(A))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(A,"active"),r.setAttribute("data-styled-version","5.3.6");var i=q();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},$=function(){function e(e){var t=this.element=H(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}j(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),W=function(){function e(e){var t=this.element=H(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),U=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),J=I,X={isServer:!I,useCSSOMInjection:!P},Z=function(){function e(e,t,n){void 0===e&&(e=E),void 0===t&&(t={}),this.options=v({},X,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&I&&J&&(J=!1,function(e){for(var t=document.querySelectorAll(G),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(A)&&(Y(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return B(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(v({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new U(o):r?new $(o):new W(o),new T(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(B(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(B(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(B(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=A+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),K=/(a)(d)/gi,Q=function(e){return String.fromCharCode(e+(e>25?39:97))};function ee(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=Q(t%52)+n;return(Q(t%52)+n).replace(K,"$1-$2")}var te=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},ne=function(e){return te(5381,e)};function re(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(b(n)&&!N(n))return!1}return!0}var oe=ne("5.3.6"),se=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&re(e),this.componentId=t,this.baseHash=te(oe,t),this.baseStyle=n,Z.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=Ne(this.rules,e,t,n).join(""),i=ee(te(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=te(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=Ne(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=te(u,f+d),l+=f}}if(l){var m=ee(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),ie=/^\s*\/\/.*$/gm,ae=[":","[",".","#"];function ce(e){var t,n,r,o,s=void 0===e?E:e,i=s.options,a=void 0===i?E:i,c=s.plugins,u=void 0===c?w:c,l=new _emotion_stylis__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z(a),d=[],h=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ae.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(ie,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},h,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||j(15),te(e,t.name)}),5381).toString():"",m}var ue=react__WEBPACK_IMPORTED_MODULE_1__.createContext(),le=ue.Consumer,de=react__WEBPACK_IMPORTED_MODULE_1__.createContext(),he=(de.Consumer,new Z),pe=ce();function fe(){return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ue)||he}function me(){return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(de)||pe}function ye(e){var t=(0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(e.stylisPlugins),n=t[0],s=t[1],c=fe(),u=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((function(){return ce({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((function(){shallowequal__WEBPACK_IMPORTED_MODULE_2___default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react__WEBPACK_IMPORTED_MODULE_1__.createElement(ue.Provider,{value:u},react__WEBPACK_IMPORTED_MODULE_1__.createElement(de.Provider,{value:l}, false?0:e.children))}var ve=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=pe);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return j(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=pe),this.name+e.hash},e}(),ge=/([A-Z])/,Se=/([A-Z])/g,we=/^ms-/,Ee=function(e){return"-"+e.toLowerCase()};function be(e){return ge.test(e)?e.replace(Se,Ee).replace(we,"-ms-"):e}var _e=function(e){return null==e||!1===e||""===e};function Ne(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=Ne(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(_e(e))return"";if(N(e))return"."+e.styledComponentId;if(b(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,Ne(u,n,r,o)}var l;return e instanceof ve?r?(e.inject(r,o),e.getName(o)):e:S(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!_e(t[i])&&(Array.isArray(t[i])&&t[i].isCss||b(t[i])?s.push(be(i)+":",t[i],";"):S(t[i])?s.push.apply(s,e(t[i],i)):s.push(be(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in _emotion_unitless__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ae=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ce(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return b(e)||S(e)?Ae(Ne(g(w,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ae(Ne(g(e,n)))}var Ie=/invalid hook call/i,Pe=new Set,Oe=function(e,t){if(false){ var o, n, r; }},Re=function(e,t,n){return void 0===n&&(n=E),e.theme!==n.theme&&e.theme||t||n.theme},De=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,je=/(^-|-$)/g;function Te(e){return e.replace(De,"-").replace(je,"")}var xe=function(e){return ee(ne(e)>>>0)};function ke(e){return"string"==typeof e&&( true||0)}var Ve=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Be=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];Ve(t)&&Ve(r)?Me(r,t):e[n]=t}function Me(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(Ve(i))for(var a in i)Be(a)&&ze(e,i[a],a)}return e}var Ge=react__WEBPACK_IMPORTED_MODULE_1__.createContext(),Le=Ge.Consumer;function Fe(e){var t=s(Ge),n=i((function(){return function(e,t){if(!e)return j(14);if(b(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?j(8):t?v({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Ge.Provider,{value:n},e.children):null}var Ye={};function qe(e,t,n){var o=N(e),i=!ke(e),a=t.attrs,c=void 0===a?w:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":Te(e);Ye[n]=(Ye[n]||0)+1;var r=n+"-"+xe("5.3.6"+n+Ye[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,f=void 0===p?function(e){return ke(e)?"styled."+e:"Styled("+_(e)+")"}(e):p,g=t.displayName&&t.componentId?Te(t.displayName)+"-"+t.componentId:t.componentId||h,S=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new se(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target; false&&0;var f=function(e,t,n){void 0===e&&(e=E);var r=v({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in b(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Re(t,(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Ge),a)||E,t,o),y=f[0],g=f[1],S=function(e,t,n,r){var o=fe(),s=me(),i=t?e.generateAndInjectStyles(E,o,s):e.generateAndInjectStyles(n,o,s);return false&&0, false&&0,i}(i,r,y, false?0:void 0),w=n,_=g.$as||t.$as||g.as||t.as||p,N=ke(_),A=g!==t?v({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,_emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,_):!N||(0,_emotion_is_prop_valid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=v({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=w,(0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_,C)}(C,e,t,P)};return O.displayName=f,(C=react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(O)).attrs=S,C.componentStyle=I,C.displayName=f,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):w,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(ke(e)?e:Te(_(e)));return qe(e,v({},o,{attrs:S,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Me({},e.defaultProps,t):t}}), false&&(0),C.toString=function(){return"."+C.styledComponentId},i&&hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default()(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var He=function(e){return function e(t,r,o){if(void 0===o&&(o=E),!(0,react_is__WEBPACK_IMPORTED_MODULE_0__.isValidElementType)(r))return j(1,String(r));var s=function(){return t(r,o,Ce.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,v({},o,{},n))},s.attrs=function(n){return e(t,r,v({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(qe,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){He[e]=He(e)}));var $e=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=re(e),Z.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(Ne(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&Z.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function We(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ce.apply(void 0,[e].concat(n)),a="sc-global-"+xe(JSON.stringify(i)),u=new $e(i,a);function l(e){var t=fe(),n=me(),o=s(Ge),l=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(l,e,t,o,n),d((function(){if(!t.server)return h(l,e,t,o,n),function(){return u.removeStyles(l,t)}}),[l,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,O,n,o);else{var s=v({},t,{theme:Re(t,r,l.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(l)}function Ue(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ce.apply(void 0,[e].concat(n)).join(""),s=xe(o);return new ve(s,o)}var Je=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=q();return"<style "+[n&&'nonce="'+n+'"',A+'="true"','data-styled-version="5.3.6"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?j(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return j(2);var n=((t={})[A]="",t["data-styled-version"]="5.3.6",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=q();return o&&(n.nonce=o),[react__WEBPACK_IMPORTED_MODULE_1__.createElement("style",v({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new Z({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?j(2):react__WEBPACK_IMPORTED_MODULE_1__.createElement(ye,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return j(3)},e}(),Xe=function(e){var t=r.forwardRef((function(t,n){var o=s(Ge),i=e.defaultProps,a=Re(t,o,i);return false&&0,r.createElement(e,v({},t,{theme:a,ref:n}))}));return y(t,e),t.displayName="WithTheme("+_(e)+")",t},Ze=function(){return s(Ge)},Ke={StyleSheet:Z,masterSheet:he}; false&&0, false&&(0);/* harmony default export */ __webpack_exports__["ZP"] = (He);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 83671:
/***/ (function(module) {

const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g

const words = (str) => str.match(reWords) || []

const upperFirst = (str) => str[0].toUpperCase() + str.slice(1)

const join = (str, d) => words(str).join(d).toLowerCase()

const camelCase = (str) =>
  words(str).reduce(
    (acc, next) =>
      `${acc}${
        !acc
          ? next.toLowerCase()
          : next[0].toUpperCase() + next.slice(1).toLowerCase()
      }`,
    '',
  )

const pascalCase = (str) => upperFirst(camelCase(str))

const snakeCase = (str) => join(str, '_')

const kebabCase = (str) => join(str, '-')

const sentenceCase = (str) => upperFirst(join(str, ' '))

const titleCase = (str) => words(str).map(upperFirst).join(' ')

module.exports = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase,
}


/***/ }),

/***/ 95159:
/***/ (function(module) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ 75969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es6; }
});

// EXTERNAL MODULE: ../../node_modules/cookie/index.js
var cookie = __webpack_require__(13421);
;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie/* parse */.Q(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie/* parse */.Q(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie/* serialize */.q(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ../../node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);


/***/ }),

/***/ 84337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var index = react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect ;




/***/ }),

/***/ 20452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20452);
} else {}


/***/ }),

/***/ 45982:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 48601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ create$2; },
/* harmony export */   "O7": function() { return /* binding */ create$7; },
/* harmony export */   "Rx": function() { return /* binding */ create$5; },
/* harmony export */   "Ry": function() { return /* binding */ create$3; },
/* harmony export */   "Vo": function() { return /* binding */ create; },
/* harmony export */   "Z_": function() { return /* binding */ create$6; },
/* harmony export */   "hT": function() { return /* binding */ create$4; },
/* harmony export */   "nK": function() { return /* binding */ create$8; },
/* harmony export */   "p8": function() { return /* binding */ ValidationError; }
/* harmony export */ });
/* unused harmony exports ArraySchema, BooleanSchema, DateSchema, LazySchema, MixedSchema, NumberSchema, ObjectSchema, Schema, StringSchema, TupleSchema, addMethod, bool, defaultLocale, getIn, isSchema, printValue, reach, ref, setLocale, tuple */
/* harmony import */ var property_expr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17296);
/* harmony import */ var property_expr__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(property_expr__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var tiny_case__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83671);
/* harmony import */ var tiny_case__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tiny_case__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var toposort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95159);
/* harmony import */ var toposort__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(toposort__WEBPACK_IMPORTED_MODULE_2__);




const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = 'Error';
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    // Attempt to make the path more friendly for error message interpolation.
    const path = params.label || params.path || 'this';
    // Store the original path under `originalPath` so it isn't lost to custom
    // message functions; e.g., ones provided in `setLocale()` calls.
    params = Object.assign({}, params, {
      path,
      originalPath: params.path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = 'Error';
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.';
    return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
let tuple = {
  notType: params => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
var locale = Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}

const prefixes = {
  context: '$',
  value: '.'
};
function create$9(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0,property_expr__WEBPACK_IMPORTED_MODULE_0__.getter)(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;

const isAbsent = value => value == null;

function createValidation(config) {
  function validate({
    value,
    path = '',
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    const resolveOptions = {
      value,
      parent,
      context
    };
    function createError(overrides = {}) {
      const nextParams = resolveParams(Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params), resolveOptions);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve(item) {
        return resolveMaybeRef(item, resolveOptions);
      },
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}

// Warning: mutates the input
function resolveParams(params, options) {
  if (!params) return params;
  for (const key of Object.keys(params)) {
    params[key] = resolveMaybeRef(params[key], options);
  }
  return params;
}
function resolveMaybeRef(item, options) {
  return Reference.isRef(item) ? item.getValue(options.value, options.parent, options.context) : item;
}

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  (0,property_expr__WEBPACK_IMPORTED_MODULE_0__.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}
function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
}

class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src, seen = new Map()) {
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}

/**
 * Copied from @standard-schema/spec to avoid having a dependency on it.
 * https://github.com/standard-schema/standard-schema/blob/main/packages/spec/src/index.ts
 */

function createStandardPath(path) {
  if (!(path != null && path.length)) {
    return undefined;
  }

  // Array to store the final path segments
  const segments = [];
  // Buffer for building the current segment
  let currentSegment = '';
  // Track if we're inside square brackets (array/property access)
  let inBrackets = false;
  // Track if we're inside quotes (for property names with special chars)
  let inQuotes = false;
  for (let i = 0; i < path.length; i++) {
    const char = path[i];
    if (char === '[' && !inQuotes) {
      // When entering brackets, push any accumulated segment after splitting on dots
      if (currentSegment) {
        segments.push(...currentSegment.split('.').filter(Boolean));
        currentSegment = '';
      }
      inBrackets = true;
      continue;
    }
    if (char === ']' && !inQuotes) {
      if (currentSegment) {
        // Handle numeric indices (e.g. arr[0])
        if (/^\d+$/.test(currentSegment)) {
          segments.push(currentSegment);
        } else {
          // Handle quoted property names (e.g. obj["foo.bar"])
          segments.push(currentSegment.replace(/^"|"$/g, ''));
        }
        currentSegment = '';
      }
      inBrackets = false;
      continue;
    }
    if (char === '"') {
      // Toggle quote state for handling quoted property names
      inQuotes = !inQuotes;
      continue;
    }
    if (char === '.' && !inBrackets && !inQuotes) {
      // On dots outside brackets/quotes, push current segment
      if (currentSegment) {
        segments.push(currentSegment);
        currentSegment = '';
      }
      continue;
    }
    currentSegment += char;
  }

  // Push any remaining segment after splitting on dots
  if (currentSegment) {
    segments.push(...currentSegment.split('.').filter(Boolean));
  }
  return segments;
}
function createStandardIssues(error, parentPath) {
  const path = parentPath ? `${parentPath}.${error.path}` : error.path;
  return error.errors.map(err => ({
    message: err,
    path: createStandardPath(path)
  }));
}
function issuesFromValidationError(error, parentPath) {
  var _error$inner;
  if (!((_error$inner = error.inner) != null && _error$inner.length) && error.errors.length) {
    return createStandardIssues(error, parentPath);
  }
  const path = parentPath ? `${parentPath}.${error.path}` : error.path;
  return error.inner.flatMap(err => issuesFromValidationError(err, path));
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({}, options, {
      value
      // parent: options.parent,
      // context: options.context,
    }));

    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this, options), rawValue);
    if (value === undefined) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent,
    parentPath,
    originalParent,
    options
  }) {
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.filter((n, idx, list) => list.findIndex(c => c.OPTIONS.name === n.OPTIONS.name) === idx).map(fn => {
        const params = fn.OPTIONS.params && options ? resolveParams(Object.assign({}, fn.OPTIONS.params), options) : fn.OPTIONS.params;
        return {
          name: fn.OPTIONS.name,
          params
        };
      })
    };
    return description;
  }
  get ['~standard']() {
    const schema = this;
    const standard = {
      version: 1,
      vendor: 'yup',
      async validate(value) {
        try {
          const result = await schema.validate(value, {
            abortEarly: false
          });
          return {
            value: result
          };
        } catch (err) {
          if (err instanceof ValidationError) {
            return {
              issues: issuesFromValidationError(err)
            };
          }
          throw err;
        }
      }
    };
    return standard;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;

const returnsTrue = () => true;
function create$8(spec) {
  return new MixedSchema(spec);
}
class MixedSchema extends Schema {
  constructor(spec) {
    super(typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec));
  }
}
create$8.prototype = MixedSchema.prototype;

function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: 'boolean',
      check(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw) => {
        if (this.spec.coerce && !this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
  }
  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
  default(def) {
    return super.default(def);
  }
  defined(msg) {
    return super.defined(msg);
  }
  optional() {
    return super.optional();
  }
  required(msg) {
    return super.required(msg);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(msg) {
    return super.nonNullable(msg);
  }
  strip(v) {
    return super.strip(v);
  }
}
create$7.prototype = BooleanSchema.prototype;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  const struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}

// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let rEmail =
// eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let rUrl =
// eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

// eslint-disable-next-line
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`);
let isTrimmed = value => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: 'string',
      check(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw) => {
        if (!this.spec.coerce || this.isType(value)) return value;

        // don't ever convert arrays
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;

        // no one wants plain objects converted to [Object object]
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation(schema => schema.test({
      message: message || mixed.required,
      name: 'required',
      skipAbsent: true,
      test: value => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation(schema => {
      schema.tests = schema.tests.filter(t => t.OPTIONS.name !== 'required');
      return schema;
    });
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: value => value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  }
  datetime(options) {
    let message = '';
    let allowOffset;
    let precision;
    if (options) {
      if (typeof options === 'object') {
        ({
          message = '',
          allowOffset = false,
          precision = undefined
        } = options);
      } else {
        message = options;
      }
    }
    return this.matches(rIsoDateTime, {
      name: 'datetime',
      message: message || string.datetime,
      excludeEmptyString: true
    }).test({
      name: 'datetime_offset',
      message: message || string.datetime_offset,
      params: {
        allowOffset
      },
      skipAbsent: true,
      test: value => {
        if (!value || allowOffset) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return !!struct.z;
      }
    }).test({
      name: 'datetime_precision',
      message: message || string.datetime_precision,
      params: {
        precision
      },
      skipAbsent: true,
      test: value => {
        if (!value || precision == undefined) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return struct.precision === precision;
      }
    });
  }

  //-- transforms --
  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }
  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;

//
// String Interfaces
//

let isNaN$1 = value => value != +value;
function create$5() {
  return new NumberSchema();
}
class NumberSchema extends Schema {
  constructor() {
    super({
      type: 'number',
      check(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !isNaN$1(value);
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw) => {
        if (!this.spec.coerce) return value;
        let parsed = value;
        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN;
          // don't use parseFloat to avoid positives on alpha-numeric strings
          parsed = +parsed;
        }

        // null -> NaN isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (this.isType(parsed) || parsed === null) return parsed;
        return parseFloat(parsed);
      });
    });
  }
  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(min);
      }
    });
  }
  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(max);
      }
    });
  }
  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },
      skipAbsent: true,
      test(value) {
        return value < this.resolve(less);
      }
    });
  }
  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },
      skipAbsent: true,
      test(value) {
        return value > this.resolve(more);
      }
    });
  }
  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }
  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }
  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      skipAbsent: true,
      test: val => Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform(value => !isAbsent(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';

    // this exists for symemtry with the new Math.trunc
    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !isAbsent(value) ? Math[method](value) : value);
  }
}
create$5.prototype = NumberSchema.prototype;

//
// Number Interfaces
//

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
function create$4() {
  return new DateSchema();
}
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw) => {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!this.spec.coerce || this.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
create$4.prototype = DateSchema.prototype;
create$4.INVALID_DATE = invalidDate;

// @ts-expect-error
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = (0,property_expr__WEBPACK_IMPORTED_MODULE_0__.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort__WEBPACK_IMPORTED_MODULE_2___default().array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

const parseJson = (value, _, schema) => {
  if (typeof value !== 'string') {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return schema.isType(parsed) ? parsed : value;
};

// @ts-ignore
function deepPartial(schema) {
  if ('fields' in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    const nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...(0,property_expr__WEBPACK_IMPORTED_MODULE_0__.normalizePath)(p)];
  if (path.length === 1) return path[0] in obj;
  let last = path.pop();
  let parent = (0,property_expr__WEBPACK_IMPORTED_MODULE_0__.getter)((0,property_expr__WEBPACK_IMPORTED_MODULE_0__.join)(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: 'object',
      check(value) {
        return isObject(value) || typeof value === 'function';
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);

    //should ignore nulls here
    if (value === undefined) return this.getDefault(options);
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
    let intermediateValue = {}; // is filled during the transform below
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = (prop in value);
      let inputValue = value[prop];
      if (field) {
        let fieldValue;

        // safe to mutate since this is fired in sequence
        innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ? field.cast(inputValue, innerOptions) : inputValue;
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = inputValue;
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== inputValue) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, fieldErrors => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === undefined ? schemaOrRef : target;
    }
    return next.withMutation(s =>
    // XXX: excludes here is wrong
    s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
  }
  _getDefault(options) {
    if ('default' in this.spec) {
      return super._getDefault(options);
    }

    // if there is no default set invent one
    if (!this._nodes.length) {
      return undefined;
    }
    let dft = {};
    this._nodes.forEach(key => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    // XXX: this carries over edges which may not be what you want
    if (excludedEdges) next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation(next => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }

      // XXX: excludes here is wrong
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(([a, b]) => keys.includes(a) && keys.includes(b)));
  }
  omit(keys) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys.includes(key)) continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from, to, alias) {
    let fromGetter = (0,property_expr__WEBPACK_IMPORTED_MODULE_0__.getter)(from, true);
    return this.transform(obj => {
      if (!obj) return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }

  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(message) {
    return this.test({
      name: 'exact',
      exclusive: true,
      message: message || object.exact,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return unknownKeys.length === 0 || this.createError({
          params: {
            properties: unknownKeys.join(', ')
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: true
    });
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== 'boolean') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => {
      if (!obj) return obj;
      const result = {};
      for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tiny_case__WEBPACK_IMPORTED_MODULE_1__.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tiny_case__WEBPACK_IMPORTED_MODULE_1__.snakeCase);
  }
  constantCase() {
    return this.transformKeys(key => (0,tiny_case__WEBPACK_IMPORTED_MODULE_1__.snakeCase)(key).toUpperCase());
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(next.fields)) {
      var _innerOptions2;
      let innerOptions = options;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;

function create$2(type) {
  return new ArraySchema(type);
}
class ArraySchema extends Schema {
  constructor(type) {
    super({
      type: 'array',
      spec: {
        types: type
      },
      check(v) {
        return Array.isArray(v);
      }
    });

    // `undefined` specifically means uninitialized, as opposed to "no subtype"
    this.innerType = void 0;
    this.innerType = type;
  }
  _cast(_value, _opts) {
    const value = super._cast(_value, _opts);

    // should ignore nulls here
    if (!this._typeCheck(value) || !this.innerType) {
      return value;
    }
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`,
        parent: value,
        originalValue: v,
        value: v,
        index: idx
      }));
      if (castElement !== v) {
        isChanged = true;
      }
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value, options = {}, panic, next) {
    var _options$recursive;
    // let sync = options.sync;
    // let path = options.path;
    let innerType = this.innerType;
    // let endEarly = options.abortEarly ?? this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    options.originalValue != null ? options.originalValue : _value;
    super._validate(_value, options, panic, (arrayErrors, value) => {
      var _options$originalValu2;
      if (!recursive || !innerType || !this._typeCheck(value)) {
        next(arrayErrors, value);
        return;
      }

      // #950 Ensure that sparse array empty slots are validated
      let tests = new Array(value.length);
      for (let index = 0; index < value.length; index++) {
        var _options$originalValu;
        tests[index] = innerType.asNestedTest({
          options,
          index,
          parent: value,
          parentPath: options.path,
          originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
        });
      }
      this.runTests({
        value,
        tests,
        originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
        options
      }, panic, innerTypeErrors => next(innerTypeErrors.concat(arrayErrors), value));
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    // @ts-expect-error readonly
    next.innerType = this.innerType;
    return next;
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  concat(schema) {
    let next = super.concat(schema);

    // @ts-expect-error readonly
    next.innerType = this.innerType;
    if (schema.innerType)
      // @ts-expect-error readonly
      next.innerType = next.innerType ?
      // @ts-expect-error Lazy doesn't have concat and will break
      next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }
  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema));

    // @ts-expect-error readonly
    next.innerType = schema;
    next.spec = Object.assign({}, next.spec, {
      types: schema
    });
    return next;
  }
  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      // FIXME(ts): Array<typeof T>
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }
  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    if (next.innerType) {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[0]
        });
      }
      base.innerType = next.innerType.describe(innerOptions);
    }
    return base;
  }
}
create$2.prototype = ArraySchema.prototype;

// @ts-ignore
function create$1(schemas) {
  return new TupleSchema(schemas);
}
class TupleSchema extends Schema {
  constructor(schemas) {
    super({
      type: 'tuple',
      spec: {
        types: schemas
      },
      check(v) {
        const types = this.spec.types;
        return Array.isArray(v) && v.length === types.length;
      }
    });
    this.withMutation(() => {
      this.typeError(tuple.notType);
    });
  }
  _cast(inputValue, options) {
    const {
      types
    } = this.spec;
    const value = super._cast(inputValue, options);
    if (!this._typeCheck(value)) {
      return value;
    }
    let isChanged = false;
    const castArray = types.map((type, idx) => {
      const castElement = type.cast(value[idx], Object.assign({}, options, {
        path: `${options.path || ''}[${idx}]`,
        parent: value,
        originalValue: value[idx],
        value: value[idx],
        index: idx
      }));
      if (castElement !== value[idx]) isChanged = true;
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value, options = {}, panic, next) {
    let itemTypes = this.spec.types;
    super._validate(_value, options, panic, (tupleErrors, value) => {
      var _options$originalValu2;
      // intentionally not respecting recursive
      if (!this._typeCheck(value)) {
        next(tupleErrors, value);
        return;
      }
      let tests = [];
      for (let [index, itemSchema] of itemTypes.entries()) {
        var _options$originalValu;
        tests[index] = itemSchema.asNestedTest({
          options,
          index,
          parent: value,
          parentPath: options.path,
          originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
        });
      }
      this.runTests({
        value,
        tests,
        originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
        options
      }, panic, innerTypeErrors => next(innerTypeErrors.concat(tupleErrors), value));
    });
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.innerType = next.spec.types.map((schema, index) => {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[index]
        });
      }
      return schema.describe(innerOptions);
    });
    return base;
  }
}
create$1.prototype = TupleSchema.prototype;

function create(builder) {
  return new Lazy(builder);
}
function catchValidationError(fn) {
  try {
    return fn();
  } catch (err) {
    if (ValidationError.isError(err)) return Promise.reject(err);
    throw err;
  }
}
class Lazy {
  constructor(builder) {
    this.type = 'lazy';
    this.__isYupSchema__ = true;
    this.spec = void 0;
    this._resolve = (value, options = {}) => {
      let schema = this.builder(value, options);
      if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
      if (this.spec.optional) schema = schema.optional();
      return schema.resolve(options);
    };
    this.builder = builder;
    this.spec = {
      meta: undefined,
      optional: false
    };
  }
  clone(spec) {
    const next = new Lazy(this.builder);
    next.spec = Object.assign({}, this.spec, spec);
    return next;
  }
  optionality(optional) {
    const next = this.clone({
      optional
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  resolve(options) {
    return this._resolve(options.value, options);
  }
  cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  }
  asNestedTest(config) {
    let {
      key,
      index,
      parent,
      options
    } = config;
    let value = parent[index != null ? index : key];
    return this._resolve(value, Object.assign({}, options, {
      value,
      parent
    })).asNestedTest(config);
  }
  validate(value, options) {
    return catchValidationError(() => this._resolve(value, options).validate(value, options));
  }
  validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  }
  validateAt(path, value, options) {
    return catchValidationError(() => this._resolve(value, options).validateAt(path, value, options));
  }
  validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  }
  isValid(value, options) {
    try {
      return this._resolve(value, options).isValid(value, options);
    } catch (err) {
      if (ValidationError.isError(err)) {
        return Promise.resolve(false);
      }
      throw err;
    }
  }
  isValidSync(value, options) {
    return this._resolve(value, options).isValidSync(value, options);
  }
  describe(options) {
    return options ? this.resolve(options).describe(options) : {
      type: 'lazy',
      meta: this.spec.meta,
      label: undefined
    };
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  get ['~standard']() {
    const schema = this;
    const standard = {
      version: 1,
      vendor: 'yup',
      async validate(value) {
        try {
          const result = await schema.validate(value, {
            abortEarly: false
          });
          return {
            value: result
          };
        } catch (err) {
          if (ValidationError.isError(err)) {
            return {
              issues: issuesFromValidationError(err)
            };
          }
          throw err;
        }
      }
    };
    return standard;
  }
}

function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}

function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}




/***/ }),

/***/ 29216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ __rest; },
/* harmony export */   "m": function() { return /* binding */ __awaiter; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}


//# sourceMappingURL=_tslib.js.map


/***/ }),

/***/ 52468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgCross; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "#191919",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.833.918a1.02 1.02 0 0 1 1.444 0L7 5.641 11.723.918a1.02 1.02 0 1 1 1.444 1.444L8.444 7.085l4.723 4.723a1.02 1.02 0 1 1-1.444 1.444L7 8.53l-4.723 4.723a1.021 1.021 0 0 1-1.444-1.444l4.723-4.723L.833 2.362a1.02 1.02 0 0 1 0-1.444Z"
  })));
};


//# sourceMappingURL=cross.svg.js.map


/***/ }),

/***/ 20221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/breakpoint.js
var breakpoint = __webpack_require__(91818);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
;// CONCATENATED MODULE: ../core-ui/dist/components/Badge/Badge.styles.js














const getBadgeStyle = (type) => {
    switch (type) {
        case "active": {
            return {
                primary: colors/* default.GREEN_600 */.Z.GREEN_600,
                secondary: colors/* default.GREEN_200 */.Z.GREEN_200,
            };
        }
        case "progress": {
            return {
                primary: colors/* default.ORANGE_500 */.Z.ORANGE_500,
                secondary: colors/* default.ORANGE_100 */.Z.ORANGE_100,
            };
        }
        case "warning": {
            return {
                primary: colors/* default.RED */.Z.RED,
                secondary: colors/* default.RED_100 */.Z.RED_100,
            };
        }
        case "info": {
            return {
                primary: colors/* default.PURPLE */.Z.PURPLE,
                secondary: colors/* default.PURPLE_LIGHT */.Z.PURPLE_LIGHT,
            };
        }
        case "default":
        default: {
            return {
                primary: colors/* default.GREY_600 */.Z.GREY_600,
                secondary: colors/* default.GREY_200 */.Z.GREY_200,
            };
        }
    }
};
const BadgeDot = styled_components_browser_esm/* default.span */.ZP.span `
    width: 8px;
    height: 8px;
    border-radius: 50%;
`;
const BadgeWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    ${style_mixins/* flexCenter */._}
    display: inline-flex;
    gap: 10px;
    padding: 4px 16px;

    ${({ type, onClick, fillType, borderRadius, transparent }) => {
    const { primary, secondary } = getBadgeStyle(type);
    return styled_components_browser_esm/* css */.iv `
            cursor: ${!!onClick ? "pointer" : "text"};
            border-radius: ${(0,common/* isValidValue */.YI)(borderRadius)
        ? (0,common/* getSizeInPx */.tf)(borderRadius)
        : "16px"};
            color: ${primary};
            background-color: ${secondary};

            ${() => {
        switch (fillType) {
            case "grey-outline":
                return styled_components_browser_esm/* css */.iv `
                            background-color: ${colors/* default.WHITE */.Z.WHITE};
                            border: 2px solid ${colors/* default.GREY_200 */.Z.GREY_200};
                        `;
            case "outline":
                return styled_components_browser_esm/* css */.iv `
                            background-color: ${colors/* default.WHITE */.Z.WHITE};
                            border: 2px solid ${primary};
                        `;
            case "filled-outline":
                return styled_components_browser_esm/* css */.iv `
                            background-color: ${secondary};
                            border: 2px solid ${primary};
                        `;
        }
    }}

            ${BadgeDot} {
                background-color: ${primary};
            }

            background-color: ${transparent ? "transparent" : ""};
        `;
}}

    @media (max-width: ${breakpoint/* Breakpoint.mobileBreakpointMaxWidth */.U.mobileBreakpointMaxWidth}) {
        gap: 5px;
        padding: 2px 10px;
    }
`;


//# sourceMappingURL=Badge.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
;// CONCATENATED MODULE: ../core-ui/dist/components/Badge/Badge.js





const Badge = (0,react.forwardRef)((props, ref) => {
    const { text, id, onClick, type = "default", showDot = false, borderRadius, fillType = "contained", transparent, underline = false, fontSize, mFontSize, leftNode = null, } = props;
    return ((0,jsx_runtime.jsxs)(BadgeWrapper, Object.assign({ onClick: onClick, type: type, id: id, borderRadius: borderRadius, fillType: fillType, transparent: transparent }, { children: [showDot ? (0,jsx_runtime.jsx)(BadgeDot, {}) : null, leftNode, (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "medium", size: fontSize || "s", mSize: mFontSize || "xs", align: "center", noWrap: true, underline: underline }, { children: text }))] })));
});


//# sourceMappingURL=Badge.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Badge/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 30012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BottomSheet; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-swipeable-bottom-sheet/lib/SwipeableBottomSheet.js
var SwipeableBottomSheet = __webpack_require__(92429);
var SwipeableBottomSheet_default = /*#__PURE__*/__webpack_require__.n(SwipeableBottomSheet);
;// CONCATENATED MODULE: ../core-ui/dist/components/BottomSheet/SwipeableBottomSheet.js



const ReactSwipeableBottomSheet = (props) => {
    return (0,jsx_runtime.jsx)((SwipeableBottomSheet_default()), Object.assign({}, props));
};


//# sourceMappingURL=SwipeableBottomSheet.js.map

// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/components/BottomSheet/BottomSheet.styles.js
var BottomSheet_styles = __webpack_require__(41079);
// EXTERNAL MODULE: ../core-ui/dist/assets/icons/sign/cross.svg.js
var cross_svg = __webpack_require__(52468);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useViewportSheetDomSync.js
var useViewportSheetDomSync = __webpack_require__(1150);
// EXTERNAL MODULE: ../core-ui/dist/methods/viewportSheet.js
var viewportSheet = __webpack_require__(99624);
;// CONCATENATED MODULE: ../core-ui/dist/components/BottomSheet/BottomSheet.js











const BottomSheet = (0,react.forwardRef)((props, ref) => {
    const { isOpen = false, id, overflowHeight, defaultOpen, marginTop, paddingBottom, onToggle, children, renderTitle, titleText, titleTextSize = "l", renderFooter, bodyHeight, bodyMinHeight, bodyMaxHeight = "70vh", fullScreen = false, overlay = true, showCloseIcon = true, showHeader = true, padded = true, disableOverlayClick = true, disableSwipe = false, backgroundColor = colors/* default.WHITE */.Z.WHITE, borderRadius = 8, showBottomSheetOverlay = true, hideBodyScrollbar = false, blurBackground = false, disableSheetZoom = false, bodyStyle, } = props;
    const useViewportLayout = (0,viewportSheet/* usesViewportSheetLayout */.XQ)(disableSheetZoom, fullScreen);
    const viewportContainerStyle = useViewportLayout
        ? (0,viewportSheet/* getViewportSheetContainerStyle */.RL)()
        : undefined;
    (0,useViewportSheetDomSync/* useViewportSheetDomSync */.s)(isOpen && useViewportLayout);
    const handleOnClickClose = () => {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
    };
    const handleOnChange = (isOpen) => {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(isOpen);
    };
    const Header = ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: renderTitle ? (renderTitle) : ((0,jsx_runtime.jsxs)(BottomSheet_styles/* BottomSheetSectionWrapper */.v8, Object.assign({ "data-popup-header": true }, { children: [titleText ? ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "bold", size: titleTextSize }, { children: titleText }))) : null, showCloseIcon ? ((0,jsx_runtime.jsx)(BottomSheet_styles/* BottomSheetCrossIconWrapper */.DJ, Object.assign({ onClick: handleOnClickClose, id: id ? `${id}--closeBtn` : "" }, { children: (0,jsx_runtime.jsx)(cross_svg/* ReactComponent */.r, { fill: colors/* default.GREY_900 */.Z.GREY_900 }) }))) : null] }))) }));
    const Body = ((0,jsx_runtime.jsx)(BottomSheet_styles/* BottomSheetSectionWrapper */.v8, Object.assign({ "data-popup-body": true, style: Object.assign({ height: fullScreen
                ? "100%"
                : useViewportLayout
                    ? "auto"
                    : bodyHeight, minHeight: useViewportLayout ? 0 : bodyMinHeight, maxHeight: fullScreen
                ? "unset"
                : useViewportLayout
                    ? "none"
                    : bodyMaxHeight, flex: useViewportLayout ? "1 1 auto" : undefined }, bodyStyle) }, { children: children })));
    const Footer = ((0,jsx_runtime.jsx)(BottomSheet_styles/* BottomSheetSectionWrapper */.v8, Object.assign({ "data-popup-footer": true }, { children: renderFooter })));
    return isOpen ? ((0,jsx_runtime.jsx)(BottomSheet_styles/* BottomSheetWrapper */.Io, Object.assign({ borderRadius: borderRadius }, { children: (0,jsx_runtime.jsx)(ReactSwipeableBottomSheet, Object.assign({ overflowHeight: overflowHeight, open: isOpen, defaultOpen: defaultOpen, marginTop: marginTop, shadowTip: false, topShadow: false, onChange: handleOnChange, fullScreen: fullScreen, overlay: showBottomSheetOverlay, style: { zIndex: zIndexList/* default.bottomSheet */.Z.bottomSheet }, bodyStyle: viewportContainerStyle, swipeableViewsProps: {
                disabled: fullScreen || disableSwipe,
                animateHeight: false,
                containerStyle: viewportContainerStyle,
            }, overlayStyle: Object.assign(Object.assign({ pointerEvents: "all" }, (blurBackground
                ? {
                    backgroundColor: "rgba(10, 15, 30, 0.35)",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                }
                : {})), (disableSheetZoom ? { touchAction: "none" } : {})) }, { children: (0,jsx_runtime.jsxs)(BottomSheet_styles/* BottomSheetContentWrapper */.AB, Object.assign({ style: { paddingBottom: paddingBottom }, padded: padded, backgroundColor: backgroundColor, hideBodyScrollbar: hideBodyScrollbar, disableSheetZoom: disableSheetZoom }, { children: [showHeader ? Header : null, Body, renderFooter ? Footer : null] })) })) }))) : ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
});


//# sourceMappingURL=BottomSheet.js.map


/***/ }),

/***/ 41079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AB": function() { return /* binding */ BottomSheetContentWrapper; },
/* harmony export */   "DJ": function() { return /* binding */ BottomSheetCrossIconWrapper; },
/* harmony export */   "Io": function() { return /* binding */ BottomSheetWrapper; },
/* harmony export */   "v8": function() { return /* binding */ BottomSheetSectionWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82740);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _mixins_style_mixins_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13261);
/* harmony import */ var _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47755);
/* harmony import */ var _mixins_cursor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27106);
/* harmony import */ var _mixins_font_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79047);







const BottomSheetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZP.div `
    .ReactSwipeableBottomSheet--open {
        ${({ borderRadius }) => borderRadius || borderRadius === 0
    ? styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv `
                      border-top-left-radius: ${borderRadius}px;
                      border-top-right-radius: ${borderRadius}px;
                  `
    : styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv `
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                  `}

        ${({ fullScreen }) => fullScreen
    ? styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv `
                      border-top-left-radius: 0px;
                      border-top-right-radius: 0px;
                  `
    : ""}

        position: relative;
        ${_mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_2__/* .scrollBarStyle__hidden */ .a}
    }
`;
const BottomSheetContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZP.div `
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
    max-height: var(--viewport-height-full, 100dvh);
    height: 100%;
    background-color: ${({ backgroundColor }) => backgroundColor};
    ${({ disableSheetZoom }) => disableSheetZoom
    ? styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv `
                  touch-action: pan-y;
              `
    : ""}
    [data-popup-header] {
        padding: ${({ padded }) => padded && "20px 20px 10px 20px"} !important;
        display: flex;
        justify-content: space-between;
        gap: 5px;
        width: 100%;
    }
    [data-popup-body] {
        ${({ hideBodyScrollbar }) => hideBodyScrollbar ? _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_2__/* .scrollBarStyle__hidden */ .a : _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_2__/* .scrollBarStyle */ .X}
        overflow: ${({ disableSheetZoom }) => disableSheetZoom ? "hidden" : "hidden auto"};
        padding: ${({ padded }) => padded && "20px"};
        flex-grow: 1;
        ${({ disableSheetZoom }) => disableSheetZoom
    ? styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv `
                      flex: 1 1 auto;
                      min-height: 0;
                  `
    : ""}
    }
    [data-popup-footer] {
        padding: ${({ padded }) => padded && "10px 20px"};
        ${({ disableSheetZoom }) => disableSheetZoom
    ? styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv `
                      flex-shrink: 0;
                  `
    : ""}
    }
`;
const BottomSheetCrossIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZP.div `
    ${_mixins_style_mixins_js__WEBPACK_IMPORTED_MODULE_1__/* .flexCenter */ ._}
    background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin-left: auto;
    min-width: 36px;
`;
const BottomSheetSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZP.div ``;


//# sourceMappingURL=BottomSheet.styles.js.map


/***/ }),

/***/ 84287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _BottomSheet_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _BottomSheet_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30012);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 48126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/fontSize.js
var fontSize = __webpack_require__(99420);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
;// CONCATENATED MODULE: ../core-ui/dist/components/Button/Button.styles.js





const getFillTypeStyleFromColor = (fillType, colors) => {
    const { primary, primaryDisabled, secondary, tertiary } = colors;
    switch (fillType) {
        case "contained": {
            return styled_components_browser_esm/* css */.iv `
                background-color: ${primary};
                color: ${secondary};
                &:disabled {
                    background-color: ${primaryDisabled};
                }
            `;
        }
        case "outlined": {
            return styled_components_browser_esm/* css */.iv `
                background-color: ${secondary};
                border: 2px solid ${primary};
                color: ${primary};
                &:disabled {
                    border: 2px solid ${primaryDisabled};
                    color: ${primaryDisabled};
                }
            `;
        }
        case "text": {
            return styled_components_browser_esm/* css */.iv `
                background-color: unset;
                color: ${primary};
                height: unset;
                padding: 0;
                &:disabled {
                    color: ${primaryDisabled};
                }
            `;
        }
        case "tonal": {
            return styled_components_browser_esm/* css */.iv `
                background-color: ${tertiary};
                color: ${primary};
                height: unset;
                padding: 0.5em;
                &:disabled {
                    color: ${primaryDisabled};
                }
            `;
        }
    }
};
const getBtnStyle = (color, fillType) => {
    switch (color) {
        case "primary": {
            return getFillTypeStyleFromColor(fillType, {
                primary: colors/* default.BLUE */.Z.BLUE,
                primaryDisabled: colors/* default.BLUE_300 */.Z.BLUE_300,
                secondary: colors/* default.WHITE */.Z.WHITE,
                tertiary: colors/* default.BLUE_200 */.Z.BLUE_200,
            });
        }
        case "secondary": {
            return getFillTypeStyleFromColor(fillType, {
                primary: colors/* default.GREY_1000 */.Z.GREY_1000,
                primaryDisabled: colors/* default.GREY_400 */.Z.GREY_400,
                secondary: colors/* default.WHITE */.Z.WHITE,
                tertiary: colors/* default.GREY_900 */.Z.GREY_900,
            });
        }
        case "danger": {
            return getFillTypeStyleFromColor(fillType, {
                primary: colors/* default.RED */.Z.RED,
                primaryDisabled: colors/* default.RED_100 */.Z.RED_100,
                secondary: colors/* default.WHITE */.Z.WHITE,
                tertiary: colors/* default.RED_100 */.Z.RED_100,
            });
        }
        case "success": {
            return getFillTypeStyleFromColor(fillType, {
                primary: colors/* default.GREEN_700 */.Z.GREEN_700,
                primaryDisabled: colors/* default.GREEN_300 */.Z.GREEN_300,
                secondary: colors/* default.WHITE */.Z.WHITE,
                tertiary: colors/* default.GREEN_200 */.Z.GREEN_200,
            });
        }
        case "warning": {
            return getFillTypeStyleFromColor(fillType, {
                primary: colors/* default.ORANGE_500 */.Z.ORANGE_500,
                primaryDisabled: colors/* default.ORANGE_100 */.Z.ORANGE_100,
                secondary: colors/* default.WHITE */.Z.WHITE,
                tertiary: colors/* default.ORANGE_100 */.Z.ORANGE_100,
            });
        }
    }
};
const StyledButton = styled_components_browser_esm/* default.button */.ZP.button `
    border: none;
    cursor: pointer;
    overflow: hidden;
    transition: all 500ms;

    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    text-align: center;

    font-size: ${({ size }) => `${fontSize/* default */.Z[size !== null && size !== void 0 ? size : "m"]}rem`};

    width: ${({ width, blockBtn }) => blockBtn ? "100%" : width ? (0,common/* getSizeInRem */.$X)(width) : "fit-content"};
    border-radius: ${({ isRounded }) => (isRounded ? "2em" : "4px")};
    padding: 0.75rem 1rem;

    ${({ color = "primary", fillType = "contained" }) => getBtnStyle(color, fillType)};

    &:disabled {
        cursor: not-allowed;
    }
`;


//# sourceMappingURL=Button.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Button/Button.js






const Button = (0,react.forwardRef)((props, ref) => {
    const { children, fillType = "contained", color = "primary", disableColor, disabled: _disabled = false, onClick, startIcon, endIcon, size = "m", mSize } = props, restProps = (0,_tslib/* __rest */._)(props, ["children", "fillType", "color", "disableColor", "disabled", "onClick", "startIcon", "endIcon", "size", "mSize"]);
    const [isExecuting, setIsExecuting] = (0,react.useState)(false);
    const disable = _disabled || isExecuting;
    const _onClick = (e) => (0,_tslib/* __awaiter */.m)(void 0, void 0, void 0, function* () {
        setIsExecuting(true);
        try {
            yield (onClick === null || onClick === void 0 ? void 0 : onClick(e));
        }
        finally {
            setIsExecuting(false);
        }
    });
    return ((0,jsx_runtime.jsxs)(StyledButton, Object.assign({}, restProps, { ref: ref, color: disable && disableColor ? disableColor : color, fillType: fillType, disabled: disable, onClick: _onClick, size: size }, { children: [startIcon, (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ size: size, mSize: mSize, weight: "medium" }, { children: children })), endIcon] })));
});


//# sourceMappingURL=Button.js.map


/***/ }),

/***/ 32450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Button_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48126);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 94072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Checkbox; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
;// CONCATENATED MODULE: ../core-ui/dist/components/Checkbox/Checkbox.styles.js







const getSizeDimensions = {
    sm: 16,
    md: 20,
};
const CheckboxInput = styled_components_browser_esm/* default.input */.ZP.input `
    appearance: none;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    ${({ size = "sm" }) => {
    return styled_components_browser_esm/* css */.iv `
            min-width: ${getSizeDimensions[size]}px;
            min-height: ${getSizeDimensions[size]}px;
            width: ${getSizeDimensions[size]}px;
            height: ${getSizeDimensions[size]}px;
        `;
}}

    border-radius: 3px;
    border: 2px solid ${colors/* default.GREY_300 */.Z.GREY_300};
    background-color: ${colors/* default.WHITE */.Z.WHITE};
    outline: none;
    box-shadow: none;

    &:disabled {
        background-color: ${colors/* default.GREY_100 */.Z.GREY_100};

        &,
        & + label {
            cursor: not-allowed;
        }
    }

    &:checked {
        background-color: ${({ fillColor }) => fillColor};
        border: none;
        &::before {
            content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDExIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjI1IDRMMy41IDYuNTcxNDNMOS41IDEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
        }
    }

    &,
    & + label {
        cursor: pointer;
    }
`;
const CheckboxInputLabel = styled_components_browser_esm/* default.label */.ZP.label `
    line-height: 150%;
    margin: 0;
    ${({ size, mSize, weight }) => (0,font/* getCommonFontStyleMixin */.d)({ size, mSize, weight })}
`;
const CheckboxWrapper = styled_components_browser_esm/* default.span */.ZP.span `
    display: inline-flex;
    align-items: ${({ alignItems }) => alignItems};
    gap: 10px;
`;


//# sourceMappingURL=Checkbox.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Checkbox/Checkbox.js





const Checkbox = (0,react.forwardRef)((props, ref) => {
    const { id = `radio-${props.name}-${props.index}`, fillColor = colors/* default.BLUE */.Z.BLUE, label, name, value, disabled, index, onChange, checkboxWrapperClass, checkBoxClass, checkBoxLabelClass, size = "sm", alignItems = "flex-start", labelProps, } = props;
    return ((0,jsx_runtime.jsxs)(CheckboxWrapper, Object.assign({ className: checkboxWrapperClass, alignItems: alignItems }, { children: [(0,jsx_runtime.jsx)(CheckboxInput, { type: "checkbox", id: id, checked: value, disabled: disabled, name: name, onChange: onChange, 
                // SC Props
                fillColor: fillColor, className: checkBoxClass, size: size }), (0,jsx_runtime.jsx)(CheckboxInputLabel, Object.assign({}, labelProps, { className: checkBoxLabelClass, htmlFor: id }, { children: label }))] })));
});


//# sourceMappingURL=Checkbox.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Checkbox/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 12111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chip; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
;// CONCATENATED MODULE: ../core-ui/dist/components/Chip/Chip.styles.js







const sizeBasedStyle = {
    medium: {
        padding: "0px 20px",
        fontSize: "0.875rem",
        height: "44px",
    },
    small: {
        padding: "0 16px",
        fontSize: "0.875rem",
        height: "40px",
        gap: "5px",
    },
    xs: {
        padding: "0 20px",
        fontSize: "0.875rem",
        height: "36px",
        gap: "5px",
    },
    auto: {
        padding: "0 8px",
        fontSize: "0.875rem",
        height: "auto",
        gap: "5px",
    },
    dot: {},
};
const StyledChip = styled_components_browser_esm/* default.div */.ZP.div `
    ${font/* fontWeightMixin */.e};
    display: inline-flex;
    gap: 10px;
    line-height: 1.5;
    white-space: nowrap;
    align-items: center;

    ${({ outlined, filled, color, fillColor, faceColor, outlineColor, fontColor, showHoverEffect, }) => {
    var _a, _b;
    const { primary, secondary } = (_a = color_variant/* COLOR_VARIANT */.Q[color]) !== null && _a !== void 0 ? _a : {};
    return (0,styled_components_browser_esm/* css */.iv)(Object.assign({ color: fontColor ? fontColor : faceColor !== null && faceColor !== void 0 ? faceColor : primary, backgroundColor: filled ? fillColor !== null && fillColor !== void 0 ? fillColor : secondary : "white", borderStyle: "solid", borderWidth: outlined ? 2 : 0, borderColor: outlined
            ? (_b = outlineColor !== null && outlineColor !== void 0 ? outlineColor : faceColor) !== null && _b !== void 0 ? _b : primary
            : "unset" }, (showHoverEffect && {
        "&:hover": {
            backgroundColor: fillColor !== null && fillColor !== void 0 ? fillColor : secondary,
        },
    })));
}}

    ${({ radius = 4, blockWidth = false, size = "medium", dotSize = 2 }) => {
    return (0,styled_components_browser_esm/* css */.iv)(Object.assign(Object.assign(Object.assign({}, sizeBasedStyle[size]), (size === "dot" && {
        minWidth: dotSize * 4,
        width: dotSize * 4,
        height: dotSize * 4,
    })), { borderRadius: radius, width: blockWidth ? "100%" : "unset" }));
}}

    ${({ padded }) => {
    return padded
        ? ""
        : (0,styled_components_browser_esm/* css */.iv)({
            padding: 0,
        });
}}

    ${({ justifyContent }) => {
    return (0,styled_components_browser_esm/* css */.iv)({
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start",
    });
}}

    ${({ onClick }) => onClick && cursor/* clickableCursorStyle */.gn}
    ${({ disabled }) => disabled && cursor/* disabledCursorStyle */.So}
`;


//# sourceMappingURL=Chip.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Chip/Chip.js





const Chip = (0,react.forwardRef)((props, ref) => {
    const { id = "", blockWidth = false, disabled = false, 
    // elevation = false,
    leftNode = null, rightNode = null, size = "medium", onClick, children, padded = true } = props, restProps = (0,_tslib/* __rest */._)(props, ["id", "blockWidth", "disabled", "leftNode", "rightNode", "size", "onClick", "children", "padded"]);
    const chipRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, () => chipRef.current);
    return ((0,jsx_runtime.jsxs)(StyledChip, Object.assign({}, restProps, { ref: chipRef, id: id, blockWidth: blockWidth, disabled: disabled, 
        // elevation={elevation}
        leftNode: leftNode, rightNode: rightNode, size: size, onClick: disabled ? undefined : onClick, padded: padded }, { children: [leftNode, " ", children, " ", rightNode] })));
});


//# sourceMappingURL=Chip.js.map


/***/ }),

/***/ 93834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Chip_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Chip_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12111);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 76304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Dropdown; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-641ee5b8.esm.js + 3 modules
var index_641ee5b8_esm = __webpack_require__(99438);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
;// CONCATENATED MODULE: ../core-ui/dist/components/Dropdown/Dropdown.styles.js













const BorderRadius = (0,common/* getSizeInRem */.$X)(12);
const DropdownWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    .dropdown-main {
        display: inline-block;
    }
    .dropdown__control {
        ${cursor/* clickableCursorStyle */.gn};
        direction: ltr;
    }

    .dropdown__menu {
        display: inline-block;
        width: auto;

        .dropdown__menu-list {
            padding: ${BorderRadius};
            .dropdown__option {
                ${cursor/* clickableCursorStyle */.gn}
                background-color: white;
                display: inline-flex;
                padding: ${(0,common/* getSizeInRem */.$X)(14)} ${(0,common/* getSizeInRem */.$X)(18)};
                border: 1px solid #e3e3e3;
                display: inline-flex;
                align-items: center;
                justify-content: flex-start;
                gap: 10px;
                min-width: max-content;

                ${(0,font/* getCommonFontStyleMixin */.d)({
    weight: "medium",
})}
                &:first-of-type {
                    border-radius: ${BorderRadius} ${BorderRadius} 0 0;
                }
                &:last-of-type {
                    border-radius: 0 0 ${BorderRadius} ${BorderRadius};
                }
            }
        }
    }
`;


//# sourceMappingURL=Dropdown.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/components/Select/RSelectDerived.js + 1 modules
var RSelectDerived = __webpack_require__(11350);
;// CONCATENATED MODULE: ../core-ui/dist/components/Dropdown/Dropdown.js







const ReactSelect = react.lazy(() => Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(4800)]).then(__webpack_require__.bind(__webpack_require__, 74800)));
const Dropdown = (0,react.forwardRef)((props, ref) => {
    const { onClick, options, toggleNode, externalProps } = props;
    return ((0,jsx_runtime.jsx)(react.Suspense, Object.assign({ fallback: null }, { children: (0,jsx_runtime.jsx)(DropdownWrapper, { children: (0,jsx_runtime.jsx)(ReactSelect, Object.assign({}, externalProps, { options: options, unstyled: true, isSearchable: false, classNamePrefix: "dropdown", className: "dropdown-main", onChange: (newOption) => {
                    (newOption === null || newOption === void 0 ? void 0 : newOption.onClick)
                        ? newOption === null || newOption === void 0 ? void 0 : newOption.onClick(newOption)
                        : onClick === null || onClick === void 0 ? void 0 : onClick(newOption);
                }, components: {
                    DropdownIndicator: (_a) => {
                        var localProps = (0,_tslib/* __rest */._)(_a, ["children"]);
                        return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.DropdownIndicator, Object.assign({}, localProps, { children: toggleNode })));
                    },
                    Option: RSelectDerived/* OptionComponent */.x8,
                }, controlShouldRenderValue: false, ref: ref, placeholder: "" })) }) })));
});


//# sourceMappingURL=Dropdown.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Dropdown/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 33647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FileInput; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/Button.js + 1 modules
var Button = __webpack_require__(48126);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../../node_modules/react-drag-drop-files/dist/react-drag-drop-files.esm.js + 1 modules
var react_drag_drop_files_esm = __webpack_require__(28304);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../core-ui/dist/components/FileInput/FileInput.styles.js



const FileInputWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    border: 2px dashed ${colors/* default.GREY_400 */.Z.GREY_400};
    border-radius: 4px;

    label {
        cursor: pointer;
        margin: 0;
        display: block;
        &:focus-within {
            outline: none;
        }
    }
`;
const FileInputPreviewer = styled_components_browser_esm/* default.img */.ZP.img `
    max-width: 100%;
    max-height: 240px;
`;


//# sourceMappingURL=FileInput.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/FileInput/FileInput.js










const defaultFileTypes = ["JPG", "PNG", "JPEG"];
const FileInput = (0,react.forwardRef)((props, ref) => {
    const { selectedFile, fileTypes = defaultFileTypes, onChange, name = "file", hoverTitle, id = "", label = "Drop file here to start uploading", ctaText = "Upload", maxSize, minSize, multiple, onDrop, onSelect, disabled, onSizeError, onTypeError, onClick, } = props;
    const isMobileScreen = (0,useMediaQuery/* default */.Z)({ queryType: "mobile" });
    const handleChange = (f) => {
        onChange(f);
    };
    return ((0,jsx_runtime.jsx)(FileInputWrapper, { children: (0,jsx_runtime.jsx)(react_drag_drop_files_esm/* FileUploader */.b, Object.assign({ handleChange: handleChange, name: name, multiple: multiple, types: fileTypes, label: label, disabled: disabled, maxSize: maxSize, minSize: minSize, onDrop: onDrop, onSelect: onSelect, hoverTitle: hoverTitle, ref: ref, onSizeError: onSizeError, onTypeError: onTypeError }, { children: (0,jsx_runtime.jsx)(Flex/* Flex */.kC, Object.assign({ flexDirection: "column", gap: 20, alignItems: "center", padding: 30 }, { children: selectedFile ? ((0,jsx_runtime.jsx)(FileInputPreviewer, { src: URL.createObjectURL(selectedFile), alt: name })) : ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [!isMobileScreen && label ? ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "medium", size: "l" }, { children: label })), (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "medium" }, { children: "OR" }))] })) : null, (0,jsx_runtime.jsx)(Button/* default */.Z, Object.assign({ fillType: "outlined", id: id, onClick: onClick }, { children: ctaText })), maxSize ? ((0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ alignItems: "center", justifyContent: "center", gap: 5 }, { children: [(0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: colors/* default.RED */.Z.RED, size: "s" }, { children: "*" })), (0,jsx_runtime.jsxs)(Typography/* default */.Z, Object.assign({ size: "s", weight: "medium" }, { children: ["Max size ", maxSize, " MB"] }))] }))) : null] })) })) })) }));
});


//# sourceMappingURL=FileInput.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/FileInput/index.js


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 2709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/IconWrapper/IconWrapper.styles.js













const StyledIconWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    ${style_mixins/* cssReset */.D}
    ${style_mixins/* flexCenter */._}
    display: inline-flex;
    min-width: fit-content;
    text-decoration: inherit;

    ${({ gap }) => {
    return styled_components_browser_esm/* css */.iv `
            gap: ${typeof gap === "number" ? `${gap}px` : gap};
        `;
}}
    img,
    svg {
        ${({ height, width, onClick }) => {
    return styled_components_browser_esm/* css */.iv `
                height: ${(0,common/* getSizeInRem */.$X)(height)};
                width: ${(0,common/* getSizeInRem */.$X)(width)};
                cursor: ${!!onClick ? "pointer" : "inherit"};
            `;
}}
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        object-position: center;
        ${({ rotate }) => rotate &&
    styled_components_browser_esm/* css */.iv `
                transform: rotate(${rotate});
            `}
    }

    ${({ svgFillColor }) => svgFillColor
    ? styled_components_browser_esm/* css */.iv `
                  svg,
                  svg path {
                      fill: ${svgFillColor};
                  }
              `
    : ""}

    ${({ strokeColor }) => strokeColor
    ? styled_components_browser_esm/* css */.iv `
                  svg,
                  svg path {
                      stroke: ${strokeColor};
                  }
              `
    : ""}
`;


//# sourceMappingURL=IconWrapper.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/IconWrapper/IconWrapper.js




const IconWrapper = (0,react.forwardRef)((props, ref) => {
    const { children, id, title, height, width, onClick, svgFillColor, strokeColor, gap, rotate, } = props;
    return ((0,jsx_runtime.jsx)(StyledIconWrapper, Object.assign({ title: title, id: id, height: height, width: width, onClick: onClick, svgFillColor: svgFillColor, gap: gap, rotate: rotate, strokeColor: strokeColor }, { children: children })));
});


//# sourceMappingURL=IconWrapper.js.map


/***/ }),

/***/ 60054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _IconWrapper_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _IconWrapper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2709);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 53435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../core-ui/dist/assets/icons/BlueEyeDisabled.svg.js


var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgBlueEyeDisabled = function SvgBlueEyeDisabled(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M9 11.769a2.771 2.771 0 1 0 0-5.542 2.771 2.771 0 0 0 0 5.542z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M17.724 8.231C15.594 5.657 12.369 3.18 9 3.18c-3.37 0-6.595 2.48-8.724 5.05a1.205 1.205 0 0 0 0 1.536c.535.646 1.657 1.895 3.156 2.986 3.774 2.747 7.354 2.753 11.136 0 1.499-1.091 2.62-2.34 3.156-2.986a1.205 1.205 0 0 0 0-1.536zM9 5.12c2.14 0 3.88 1.74 3.88 3.88 0 2.14-1.74 3.88-3.88 3.88-2.14 0-3.88-1.74-3.88-3.88 0-2.14 1.74-3.88 3.88-3.88z",
    fill: "#000"
  })));
};


//# sourceMappingURL=BlueEyeDisabled.svg.js.map

// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/methods/convertHexToRGBA.js
var convertHexToRGBA = __webpack_require__(62028);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/Input/Input.styles.js










const hZSpacing = "12px";
const vTSpacing = "12px";
const inputCommonSpace = styled_components_browser_esm/* css */.iv `
    padding: ${vTSpacing} 0px;
`;
const affixInitialStyle = styled_components_browser_esm/* css */.iv `
    display: none;
    line-height: 18px;
    font-size: inherit;
    color: ${colors/* default.GREY_400 */.Z.GREY_400};
    cursor: inherit;
`;
const InputAffixWrapper = styled_components_browser_esm/* default.span */.ZP.span `
    ${({ children }) => (children ? inputCommonSpace : ``)};
    ${affixInitialStyle}
`;
const inputAffixVisibleStyle = styled_components_browser_esm/* css */.iv `
    ${InputAffixWrapper} {
        display: inline-flex;
    }
`;
const InputPrefixWrapper = (0,styled_components_browser_esm/* default */.ZP)(InputAffixWrapper) `
    padding: 0 ${hZSpacing};
`;
const InputSuffixWrapper = (0,styled_components_browser_esm/* default */.ZP)(InputAffixWrapper) `
    padding: 0 ${hZSpacing};
`;
const InputLabel = styled_components_browser_esm/* default.span */.ZP.span `
    ${inputCommonSpace}
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.5s ease all;
    pointer-events: none;
    color: ${colors/* default.GREY_600 */.Z.GREY_600};
`;
const floatingLabelUnderlineInput = styled_components_browser_esm/* css */.iv `
    font-size: 13px;
    top: 0;
    left: 0;
`;
const inputUnderlineStyle = styled_components_browser_esm/* css */.iv `
    border-bottom: 2px solid ${colors/* default.GREY_300 */.Z.GREY_300};
    background-color: transparent;

    ${InputLabel} {
        ${({ filled }) => (filled ? floatingLabelUnderlineInput : ``)}
    }
    &:focus-within ${InputLabel} {
        ${floatingLabelUnderlineInput}
    }
`;
const floatingLabelBorderInput = styled_components_browser_esm/* css */.iv `
    color: ${colors/* default.BLUE */.Z.BLUE};
    background-color: ${colors/* default.WHITE */.Z.WHITE};
    font-size: 13px;
    border-radius: 2px;
    /* box-shadow: 2px 2px 2px 2px ${(0,convertHexToRGBA/* convertHexToRGBA */.f)(colors/* default.GREY_1000 */.Z.GREY_1000, 0.2)}; */
    top: 0;
    left: 5px;
    padding: 0 1em;
    padding-top: 2px;
`;
const getBorderColorAccordingToState = (state) => {
    switch (state) {
        case "success":
            return colors/* default.GREEN_600 */.Z.GREEN_600;
        case "error":
            return colors/* default.RED */.Z.RED;
    }
};
// border: 2px solid ${COLORS.GREY_200};
const inputBorderStyle = styled_components_browser_esm/* css */.iv `
    border-radius: 3px;
    border: ${({ borderSize }) => `${borderSize ? borderSize : 2}px solid ${colors/* default.GREY_200 */.Z.GREY_200}`};
    ${({ state }) => state
    ? styled_components_browser_esm/* css */.iv `
                  border-color: ${getBorderColorAccordingToState(state)} !important;
              `
    : null}
    background-color: ${colors/* default.WHITE */.Z.WHITE};
    padding: 0 20px;

    ${InputLabel} {
        ${({ filled }) => (filled ? floatingLabelBorderInput : ``)}
    }
    &:focus-within ${InputLabel} {
        ${floatingLabelBorderInput}
    }
`;
const InputWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    display: flex;
    align-items: center;
    position: relative;
    cursor: text;
    ${({ outline }) => {
    switch (outline) {
        case "underline":
            return inputUnderlineStyle;
        case "border":
            return inputBorderStyle;
    }
}}
    &:focus-within {
        border-color: ${colors/* default.BLUE */.Z.BLUE};
    }
    ${inputAffixVisibleStyle}
    ${({ disabled }) => disabled
    ? styled_components_browser_esm/* css */.iv `
                  background-color: ${colors/* default.GREY_100 */.Z.GREY_100};
                  cursor: not-allowed;
              `
    : null}
`;
const StyledInput = styled_components_browser_esm/* default.input */.ZP.input `
    ${inputCommonSpace}
    font-size: 18px;
    width: 100%;
    outline: none;
    border: none;
    background-color: inherit;
    line-height: 100%;
    font-family: ${({ weight }) => weight && fonts/* default */.Z[weight.toUpperCase()]};

    &::placeholder {
        opacity: ${({ label }) => ((0,common/* isValidValue */.YI)(label) ? 0 : 1)};
        color: ${colors/* default.GREY_400 */.Z.GREY_400};
        font-family: ${fonts/* default.REGULAR */.Z.REGULAR};
        font-size: 13px;
        line-height: 18px;
        vertical-align: middle;
    }

    &:disabled {
        cursor: not-allowed;
    }

    &:disabled {
        cursor: not-allowed;
    }

    &[type="number"]::-webkit-inner-spin-button,
    &[type="number"]::-webkit-outer-spin-button {
        appearance: none;
    }
    &:disabled {
        cursor: not-allowed;
    }
`;


//# sourceMappingURL=Input.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
;// CONCATENATED MODULE: ../core-ui/dist/components/common/InputHelperLabel/InputHelperLabel.styles.js


const Wrapper = styled_components_browser_esm/* default.div */.ZP.div `
    display: inline-flex;
    gap: 7px;
`;


//# sourceMappingURL=InputHelperLabel.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/IconWrapper.js + 1 modules
var IconWrapper = __webpack_require__(2709);
;// CONCATENATED MODULE: ../core-ui/dist/components/common/InputHelperLabel/InputHelperLabel.js







const InputHelperLabel = (0,react.forwardRef)((props, ref) => {
    const { children, type, showIcon = true, id } = props;
    const getIconAccordingToType = () => {
        switch (type) {
            case "desc": {
                return {
                    textColor: colors/* default.GREY_500 */.Z.GREY_500,
                    icon: null,
                };
            }
            case "error":
                return {
                    textColor: colors/* default.RED */.Z.RED,
                    // icon: (
                    //     <ErrorInfoIcon
                    //         fill={COLORS.RED}
                    //         width={20}
                    //         height={20}
                    //     />
                    // ),
                    icon: null,
                };
        }
    };
    const { icon, textColor } = getIconAccordingToType();
    return ((0,jsx_runtime.jsxs)(Wrapper, Object.assign({ id: id }, { children: [showIcon && children && icon ? ((0,jsx_runtime.jsx)(IconWrapper/* default */.Z, Object.assign({ width: 16, height: 16 }, { children: icon }))) : null, (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ size: "s", color: textColor }, { children: children }))] })));
});


//# sourceMappingURL=InputHelperLabel.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Input/Input.js
















const getAdditionalPropsBasedOnType = (props) => {
    var _a, _b;
    let LeftNode;
    let RightNode;
    let countMsg;
    let maxLength;
    let maxValue;
    let minValue;
    let step;
    switch (props.type) {
        case "text":
            {
                const { prefixNode, suffixNode, showCharacterCount, value, length = 100, } = props;
                LeftNode = prefixNode;
                RightNode = suffixNode;
                maxLength = length;
                countMsg = showCharacterCount
                    ? `${(_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0} / ${length}`
                    : "";
            }
            break;
        case "number":
            {
                const { prefixNode, suffixNode, max, min } = props;
                LeftNode = prefixNode;
                RightNode = suffixNode;
                maxValue = max;
                minValue = min;
                step = props === null || props === void 0 ? void 0 : props.step;
                countMsg = `${(0,common/* isValidValue */.YI)(min) ? `min: ${min}` : ""} ${(0,common/* isValidValue */.YI)(max) ? `max: ${max}` : ""}`.trim();
            }
            break;
        case "password":
            {
                const { showCharacterCount, value, length = 100 } = props;
                RightNode = (0,jsx_runtime.jsx)(SvgBlueEyeDisabled, {});
                maxLength = length;
                countMsg = showCharacterCount
                    ? `${(_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0} / ${length}`
                    : "";
            }
            break;
    }
    return {
        LeftNode,
        RightNode,
        countMsg,
        maxLength,
        minValue,
        maxValue,
        step,
    };
};
const Input = (0,react.forwardRef)((props, ref) => {
    const { type, name, label, headingLabel, headingLabelStyleProps, value = "", onChange, onBlur, outline = "border", disabled = false, required = false, helpMsg, errorMsg, onFocus, onPaste, autoFocus = false, id, placeholder, state, inputMode, enableDebounce, debounceInterval = 500, debounceValidationFunction, borderSize, weight, readOnly, } = props;
    const inputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, () => inputRef.current);
    const { LeftNode, RightNode, countMsg, maxLength, maxValue, minValue, step, } = getAdditionalPropsBasedOnType(props);
    const handleTogglePassword = () => {
        if (type === "password") {
            const isPassword = inputRef.current.type === "password";
            inputRef.current.type = isPassword ? "text" : "password";
        }
    };
    const onClickLeftNode = () => { };
    const onClickRightNode = type === "password" ? handleTogglePassword : () => { };
    /**
     * Debounce functionality start
     */
    const [inputValue, setInputValue] = (0,react.useState)("");
    const [timerId, setTimerId] = (0,react.useState)();
    const debounce = (value, delay) => {
        if (timerId)
            clearTimeout(timerId);
        const TimeoutId = setTimeout(() => {
            onChange(value);
        }, delay);
        setTimerId(TimeoutId);
    };
    (0,react.useEffect)(() => {
        if (inputValue !== "" && enableDebounce)
            debounce(inputValue, debounceInterval);
    }, [inputValue, enableDebounce]);
    /**
     * The below useEffect is added to clear the input field with this scenario
     * When debounce is enabled this component will use inner state for input field and then passes it to outside
     * so even if the value is change from outside state it'll not reflect in UI since the inner state is not cleared or modified
     * so the below condition will work if the outside value is cleared from outside
     */
    (0,react.useEffect)(() => {
        if (enableDebounce && inputValue !== "" && !Boolean(value)) {
            setInputValue("");
        }
    }, [value]);
    const _onChange = (e) => {
        if (enableDebounce && e.target.value === "") {
            setInputValue("");
            onChange(e.target.value);
        }
        else if (enableDebounce) {
            setInputValue(debounceValidationFunction
                ? debounceValidationFunction === null || debounceValidationFunction === void 0 ? void 0 : debounceValidationFunction(e.target.value)
                : e.target.value);
        }
        else
            onChange(e);
    };
    /**
     * Debounce functionality end
     */
    return ((0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ flexDirection: "column", gap: 10 }, { children: [(0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ "data-input-heading-label": true, color: colors/* default.GREY_900 */.Z.GREY_900, required: required }, headingLabelStyleProps, { children: headingLabel })), (0,jsx_runtime.jsxs)(InputWrapper, Object.assign({ outline: outline, filled: (0,common/* isValidValue */.YI)(value), disabled: disabled, state: state, "data-input-wrapper": true, borderSize: borderSize }, { children: [LeftNode ? ((0,jsx_runtime.jsx)(InputPrefixWrapper, { children: LeftNode, onClick: onClickLeftNode, "data-input-affix": true, "data-input-prefix": true })) : null, (0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ flex: 1, flexDirection: "column" }, { children: [label ? ((0,jsx_runtime.jsx)(InputLabel, { children: (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ required: required }, { children: label })) })) : null, (0,jsx_runtime.jsx)(StyledInput
                            // type={type}
                            , Object.assign({ 
                                // type={type}
                                placeholder: placeholder, name: name, id: id, label: label, ref: inputRef, disabled: disabled, required: required, value: enableDebounce
                                    ? String(inputValue)
                                    : String(value), maxLength: maxLength, autoFocus: autoFocus, onChange: _onChange, onFocus: onFocus, onBlur: onBlur, max: maxValue, min: minValue, onPaste: onPaste, autoComplete: "off", inputMode: inputMode, weight: weight, readOnly: readOnly, step: step, onWheel: (e) => e.target instanceof HTMLElement &&
                                    e.target.blur() }, props === null || props === void 0 ? void 0 : props.__experimental__props))] })), RightNode ? ((0,jsx_runtime.jsx)(InputSuffixWrapper, { children: RightNode, onClick: onClickRightNode, "data-input-affix": true, "data-input-suffix": true })) : null] })), helpMsg || errorMsg || countMsg ? ((0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ justifyContent: "space-between" }, { children: [(0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ flexDirection: "column", gap: 10 }, { children: [helpMsg ? ((0,jsx_runtime.jsx)(InputHelperLabel, Object.assign({ type: "desc" }, { children: helpMsg }))) : ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})), errorMsg ? ((0,jsx_runtime.jsx)(InputHelperLabel, Object.assign({ type: "error", id: id + "_error" }, { children: errorMsg }))) : ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}))] })), (0,jsx_runtime.jsx)(InputHelperLabel, Object.assign({ type: "desc" }, { children: countMsg }))] }))) : null] })));
});


//# sourceMappingURL=Input.js.map


/***/ }),

/***/ 7100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Input_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Input_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53435);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 48953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ModalCrossIcon; },
  "Z": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/assets/icons/sign/cross.svg.js
var cross_svg = __webpack_require__(52468);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/IconWrapper.js + 1 modules
var IconWrapper = __webpack_require__(2709);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
;// CONCATENATED MODULE: ../core-ui/dist/components/Modal/CloseButton.js










const CloseIconWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    ${style_mixins/* flexCenter */._}
    display: inline-flex;
    background-color: ${colors/* default.GREY_200 */.Z.GREY_200};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
`;
const CloseButton = ({ onClick }) => {
    return ((0,jsx_runtime.jsx)(CloseIconWrapper, Object.assign({ onClick: onClick }, { children: (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, { children: (0,jsx_runtime.jsx)(cross_svg/* ReactComponent */.r, { fill: colors/* default.GREY_900 */.Z.GREY_900 }) }) })));
};


//# sourceMappingURL=CloseButton.js.map

// EXTERNAL MODULE: ../core-ui/dist/methods/convertHexToRGBA.js
var convertHexToRGBA = __webpack_require__(62028);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/Modal/Modal.styles.js













const getModalSize = {
    "extra-wide": "968px",
    wide: "800px",
    compact: "600px",
    fit: "fit-content",
    viewport: "90dvw",
};
const ModalOverlayWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    ${style_mixins/* flexCenter */._}
    background-color: ${(0,convertHexToRGBA/* convertHexToRGBA */.f)(colors/* default.GREY_1000 */.Z.GREY_1000, 0.6)} !important;
`;
const ModalContentWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    padding: 0 !important;

    position: static !important;
    background: ${colors/* default.WHITE */.Z.WHITE} !important;
    box-shadow: 4px 4px 24px ${(0,convertHexToRGBA/* convertHexToRGBA */.f)(colors/* default.GREY_1000 */.Z.GREY_1000, 0.2)};
    height: fit-content;
    max-height: var(--viewport-height-p90, calc(100dvh - 10dvh));
    max-width: ${({ size }) => (size === "viewport" ? "90dvw" : "calc(100dvw - 10vw)")};
    width: ${({ size }) => getModalSize[size !== null && size !== void 0 ? size : "wide"]} !important;

    display: flex;
    flex-direction: column;
    border: none !important;
    [data-popup-header] {
        display: flex;
        gap: 5px;
        justify-content: space-between;
        padding: ${({ padded }) => padded && "20px 20px 20px 20px"} !important;
    }
    [data-popup-body] {
        padding: ${({ padded }) => padded && "20px"} !important;
        overflow-y: auto;
        overflow-x: hidden;
        ${({ hideBodyScrollbar }) => hideBodyScrollbar ? scrollbar/* scrollBarStyle__hidden */.a : scrollbar/* scrollBarStyle */.X}
        flex-grow: 1;
    }
    [data-popup-footer] {
        padding: ${({ padded }) => padded && "20px 20px 20px 20px"} !important;
    }
    ${({ fullScreenModal }) => fullScreenModal &&
    styled_components_browser_esm/* css */.iv `
            max-height: none !important;
            max-width: none !important;
            width: 100% !important;
            height: 100% !important;
            padding: 0 !important;
            inset: 0 !important;
        `}
`;
const ModalSectionWrapper = styled_components_browser_esm/* default.div */.ZP.div ``;
const ModalCrossIconWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    ${style_mixins/* flexCenter */._}
    background-color: ${colors/* default.GREY_200 */.Z.GREY_200};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin-left: auto;
`;


//# sourceMappingURL=Modal.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Modal/Modal.js













var _a;
if (typeof document !== "undefined") {
    lib_default().setAppElement((_a = document.getElementById("__next")) !== null && _a !== void 0 ? _a : document.body);
}
const ModalCrossIcon = ({ onClick, id }) => {
    return ((0,jsx_runtime.jsx)(ModalCrossIconWrapper, Object.assign({ onClick: onClick, id: id ? `${id}--closeBtn` : "" }, { children: (0,jsx_runtime.jsx)(CloseButton, {}) })));
};
const Modal = (0,react.forwardRef)((props, ref) => {
    const { children, onAfterClose, onToggle, id, isOpen = false, onAfterOpen, preventScroll, shouldCloseOnEsc = true, shouldCloseOnOverlayClick = true, showCloseIcon = true, renderFooter, renderTitle = null, size = "wide", titleText, bodyHeight = "75vh", bodyMinHeight, showHeader = true, padded = true, modalSeparationGap = 20, blurBackground = false, borderRadius, fullScreenModal, zIndex, hideBodyScrollbar = false, bodyStyle } = props;
    const handleOnClickClose = () => {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
    };
    return isOpen ? ((0,jsx_runtime.jsxs)((lib_default()), Object.assign({ id: id, onAfterClose: onAfterClose, onAfterOpen: onAfterOpen, onRequestClose: () => onToggle === null || onToggle === void 0 ? void 0 : onToggle(!isOpen), preventScroll: preventScroll !== null && preventScroll !== void 0 ? preventScroll : false, shouldCloseOnEsc: shouldCloseOnEsc, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, isOpen: isOpen, style: {
            overlay: {
                zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : zIndexList/* default.modal */.Z.modal,
                backdropFilter: `blur(${blurBackground ? 10 : 0}px)`
            },
            content: Object.assign({ zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : zIndexList/* default.modal */.Z.modal }, (borderRadius && {
                borderRadius: borderRadius
            }))
        }, overlayElement: (htmlProps, contentElement) => ((0,jsx_runtime.jsx)(ModalOverlayWrapper, Object.assign({}, htmlProps, { children: contentElement }))), contentElement: (htmlProps, children) => ((0,jsx_runtime.jsx)(ModalContentWrapper, Object.assign({}, htmlProps, { size: size, padded: padded, fullScreenModal: fullScreenModal, hideBodyScrollbar: hideBodyScrollbar }, { children: children }))) }, { children: [showHeader ? ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: renderTitle ? (renderTitle) : ((0,jsx_runtime.jsxs)(ModalSectionWrapper, Object.assign({ "data-popup-header": true, padded: padded }, { children: [titleText ? ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "bold", size: "l" }, { children: titleText }))) : null, showCloseIcon ? (0,jsx_runtime.jsx)(ModalCrossIcon, { onClick: handleOnClickClose, id: id }) : null] }))) })) : null, (0,jsx_runtime.jsx)(ModalSectionWrapper, Object.assign({ "data-popup-body": true, style: Object.assign({ maxHeight: fullScreenModal ? "unset" : bodyHeight, minHeight: bodyMinHeight }, bodyStyle), padded: padded }, { children: children })), renderFooter ? ((0,jsx_runtime.jsx)(ModalSectionWrapper
            // data-popup-footer
            , { children: renderFooter })) : null] }))) : ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
});


//# sourceMappingURL=Modal.js.map


/***/ }),

/***/ 83147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalOrBottomSheetWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/components/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(48953);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMobileSheetViewportLock.js
var useMobileSheetViewportLock = __webpack_require__(27635);
// EXTERNAL MODULE: ../core-ui/dist/components/BottomSheet/BottomSheet.js + 1 modules
var BottomSheet = __webpack_require__(30012);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/components/BottomSheet/BottomSheet.styles.js
var BottomSheet_styles = __webpack_require__(41079);
// EXTERNAL MODULE: ../core-ui/dist/assets/icons/sign/cross.svg.js
var cross_svg = __webpack_require__(52468);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useViewportSheetDomSync.js
var useViewportSheetDomSync = __webpack_require__(1150);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
// EXTERNAL MODULE: ../core-ui/dist/methods/viewportSheet.js
var viewportSheet = __webpack_require__(99624);
;// CONCATENATED MODULE: ../core-ui/dist/components/FullViewportBottomSheet/FullViewportBottomSheet.styles.js





const FullViewportSheetStack = styled_components_browser_esm/* default.div */.ZP.div `
    position: fixed;
    inset: 0;
    z-index: ${zIndexList/* default.bottomSheet */.Z.bottomSheet};
    pointer-events: none;
`;
const FullViewportSheetOverlay = styled_components_browser_esm/* default.div */.ZP.div `
    position: absolute;
    inset: 0;
    pointer-events: auto;
    touch-action: none;
    background-color: rgba(10, 15, 30, 0.35);

    ${({ blurBackground }) => blurBackground
    ? styled_components_browser_esm/* css */.iv `
                  backdrop-filter: blur(10px);
                  -webkit-backdrop-filter: blur(10px);
              `
    : ""}
`;
const FullViewportSheetPanel = styled_components_browser_esm/* default.div */.ZP.div `
    position: absolute;
    left: 0;
    right: 0;
    /**
     * Both edges anchored, so the sheet fills the viewport whatever its content height.
     * The bottom stops at the keyboard rather than the screen, which keeps the sticky footer
     * on screen in browsers that leave the layout viewport full-height when the keyboard opens.
     */
    top: ${viewportSheet/* VIEWPORT_OFFSET_TOP_CSS */.oI};
    bottom: ${viewportSheet/* VIEWPORT_KEYBOARD_INSET_CSS */.Tm};
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    ${({ borderRadius }) => borderRadius || borderRadius === 0
    ? styled_components_browser_esm/* css */.iv `
                  border-top-left-radius: ${borderRadius}px;
                  border-top-right-radius: ${borderRadius}px;
              `
    : styled_components_browser_esm/* css */.iv `
                  border-top-left-radius: 8px;
                  border-top-right-radius: 8px;
              `}
`;
const FullViewportSheetCrossIconWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors/* default.GREY_200 */.Z.GREY_200};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin-left: auto;
    min-width: 36px;
`;
const FullViewportSheetSectionWrapper = styled_components_browser_esm/* default.div */.ZP.div ``;


//# sourceMappingURL=FullViewportBottomSheet.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/FullViewportBottomSheet/FullViewportBottomSheet.js










const FullViewportBottomSheet = (0,react.forwardRef)((props, ref) => {
    const { isOpen = false, id, onToggle, children, renderTitle, titleText, titleTextSize = "l", renderFooter, showCloseIcon = true, showHeader = true, padded = true, paddingBottom, backgroundColor = colors/* default.WHITE */.Z.WHITE, borderRadius = 8, showBottomSheetOverlay = true, hideBodyScrollbar = false, blurBackground = false, disableOverlayClick = true, bodyStyle, } = props;
    (0,useViewportSheetDomSync/* useViewportSheetDomSync */.s)(isOpen);
    const handleOnClickClose = () => {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
    };
    const handleOverlayClick = () => {
        if (!disableOverlayClick) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(false);
        }
    };
    if (!isOpen || typeof document === "undefined") {
        return null;
    }
    const Header = ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: renderTitle ? (renderTitle) : ((0,jsx_runtime.jsxs)(FullViewportSheetSectionWrapper, Object.assign({ "data-popup-header": true }, { children: [titleText ? ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "bold", size: titleTextSize }, { children: titleText }))) : null, showCloseIcon ? ((0,jsx_runtime.jsx)(FullViewportSheetCrossIconWrapper, Object.assign({ onClick: handleOnClickClose, id: id ? `${id}--closeBtn` : "" }, { children: (0,jsx_runtime.jsx)(cross_svg/* ReactComponent */.r, { fill: colors/* default.GREY_900 */.Z.GREY_900 }) }))) : null] }))) }));
    const content = ((0,jsx_runtime.jsxs)(FullViewportSheetStack, Object.assign({ ref: ref, id: id }, { children: [showBottomSheetOverlay ? ((0,jsx_runtime.jsx)(FullViewportSheetOverlay, { blurBackground: blurBackground, onClick: handleOverlayClick, "aria-hidden": true })) : null, (0,jsx_runtime.jsx)(FullViewportSheetPanel, Object.assign({ borderRadius: borderRadius }, { children: (0,jsx_runtime.jsxs)(BottomSheet_styles/* BottomSheetContentWrapper */.AB, Object.assign({ style: {
                        paddingBottom,
                        height: "100%",
                        maxHeight: "100%",
                    }, padded: padded, backgroundColor: backgroundColor, hideBodyScrollbar: hideBodyScrollbar, disableSheetZoom: true }, { children: [showHeader ? Header : null, (0,jsx_runtime.jsx)(FullViewportSheetSectionWrapper, Object.assign({ "data-popup-body": true, style: Object.assign({ height: "auto", minHeight: 0, maxHeight: "none", flex: "1 1 auto" }, bodyStyle) }, { children: children })), renderFooter ? ((0,jsx_runtime.jsx)(FullViewportSheetSectionWrapper, Object.assign({ "data-popup-footer": true }, { children: renderFooter }))) : null] })) }))] })));
    return (0,react_dom.createPortal)(content, document.body);
});


//# sourceMappingURL=FullViewportBottomSheet.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/ModalOrBottomSheetWrapper.js








const ModalOrBottomSheetWrapper = (0,react.forwardRef)((props, ref) => {
    const { id, children, fullScreenSheet, isOpen, onToggle, renderFooter, renderTitle, showCloseIcon, showHeader, titleText, paddedModal, modalSeparationGap, blurBackground, fullScreenModal, modalShouldCloseOnOverlayClick, modalShouldCloseOnEsc, } = props;
    const { modalBodyHeight, modalSize, modalBodyMinHeight } = props;
    const { sheetBodyHeight, sheetBodyMinHeight, sheetBodyMaxHeight, sheetMarginTop, sheetPaddingBottom, sheetOverflowHeight, paddedSheet, disableSheetOverlayClick, disableSheetSwipe, sheetBackgroundColor, borderRadius, sheetBorderRadius, sheetTitleTextSize, showBottomSheetOverlay, hideSheetBodyScrollbar, hideModalBodyScrollbar, disableSheetZoom, viewportSheet, bodyStyle, } = props;
    const mobileScreen = (0,useMediaQuery/* default */.Z)({ queryType: "mobile" });
    (0,useMobileSheetViewportLock/* useMobileSheetViewportLock */.J)({
        isOpen: Boolean(isOpen),
        freezeOnMobile: mobileScreen,
        disableZoom: disableSheetZoom,
    });
    if (isOpen) {
        return ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: mobileScreen ? (viewportSheet ? ((0,jsx_runtime.jsx)(FullViewportBottomSheet, Object.assign({ id: id, isOpen: isOpen, renderFooter: renderFooter, renderTitle: renderTitle, titleText: titleText, onToggle: onToggle, showCloseIcon: showCloseIcon, showHeader: showHeader, paddingBottom: sheetPaddingBottom, padded: paddedSheet, backgroundColor: sheetBackgroundColor, borderRadius: sheetBorderRadius, titleTextSize: sheetTitleTextSize, showBottomSheetOverlay: showBottomSheetOverlay, hideBodyScrollbar: hideSheetBodyScrollbar, blurBackground: blurBackground, disableOverlayClick: disableSheetOverlayClick, bodyStyle: bodyStyle }, { children: children }))) : ((0,jsx_runtime.jsx)(BottomSheet/* default */.Z, Object.assign({ bodyHeight: sheetBodyHeight, fullScreen: fullScreenSheet, isOpen: isOpen, id: id, marginTop: sheetMarginTop, overflowHeight: sheetOverflowHeight, renderFooter: renderFooter, renderTitle: renderTitle, titleText: titleText, onToggle: onToggle, showCloseIcon: showCloseIcon, bodyMinHeight: sheetBodyMinHeight, bodyMaxHeight: sheetBodyMaxHeight, showHeader: showHeader, paddingBottom: sheetPaddingBottom, padded: paddedSheet, disableOverlayClick: disableSheetOverlayClick, disableSwipe: disableSheetSwipe, backgroundColor: sheetBackgroundColor, borderRadius: sheetBorderRadius, titleTextSize: sheetTitleTextSize, showBottomSheetOverlay: showBottomSheetOverlay, hideBodyScrollbar: hideSheetBodyScrollbar, blurBackground: blurBackground, disableSheetZoom: disableSheetZoom, bodyStyle: bodyStyle }, { children: children })))) : ((0,jsx_runtime.jsx)(Modal/* default */.Z, Object.assign({ bodyHeight: modalBodyHeight, bodyMinHeight: modalBodyMinHeight, size: modalSize, onToggle: onToggle, showCloseIcon: showCloseIcon, isOpen: isOpen, id: id, renderFooter: renderFooter, renderTitle: renderTitle, titleText: titleText, showHeader: showHeader, padded: paddedModal, modalSeparationGap: modalSeparationGap, blurBackground: blurBackground, borderRadius: borderRadius, fullScreenModal: fullScreenModal, shouldCloseOnOverlayClick: modalShouldCloseOnOverlayClick, shouldCloseOnEsc: modalShouldCloseOnEsc, hideBodyScrollbar: hideModalBodyScrollbar, bodyStyle: bodyStyle }, { children: children }))) }));
    }
    else {
        return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
});


//# sourceMappingURL=ModalOrBottomSheetWrapper.js.map


/***/ }),

/***/ 9937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _ModalOrBottomSheetWrapper_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ModalOrBottomSheetWrapper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83147);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 84789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
;// CONCATENATED MODULE: ../core-ui/dist/components/Radio/Radio.styles.js




const StyledRadioWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.kC) `
    gap: 10px;
    align-items: flex-start;
    padding: 8px;

    ${({ diskPosition }) => {
    if (diskPosition === "end") {
        return styled_components_browser_esm/* css */.iv `
                justify-content: space-between;
            `;
    }
}}
    label {
        cursor: pointer;
        ${({ disabled }) => (disabled ? `cursor: default;` : ``)}
    }
`;
const StyledRadioTextWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* Flex */.kC) `
    gap: 0.5em;
`;
const StyledRadio = styled_components_browser_esm/* default.input */.ZP.input `
    appearance: none;
    -webkit-appearance: none;
    border-radius: 50%;
    border: 2px solid ${colors/* default.WHITE */.Z.WHITE};
    background-color: ${colors/* default.WHITE */.Z.WHITE};
    box-shadow: 0 0 0 2px ${colors/* default.GREY_300 */.Z.GREY_300};
    min-height: 14px;
    min-width: 14px;
    margin: 2px 0;
    margin-top: 4px;

    ${({ diskPosition }) => {
    if (diskPosition === "end") {
        return styled_components_browser_esm/* css */.iv `
                order: 1;
            `;
    }
}}

    &:checked {
        box-shadow: 0 0 0 2px ${({ fillColor }) => fillColor};
        background-color: ${({ fillColor }) => fillColor};
    }

    ${({ actionable }) => actionable &&
    styled_components_browser_esm/* css */.iv `
            cursor: pointer;
            &:checked:disabled {
                background-color: ${colors/* default.GREY_600 */.Z.GREY_600};
            }
            &:disabled {
                box-shadow: 0 0 0 2px ${colors/* default.GREY_600 */.Z.GREY_600};
                cursor: not-allowed;
            }
        `}
`;


//# sourceMappingURL=Radio.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Radio/Radio.js






const Radio = (0,react.forwardRef)((props, ref) => {
    var _a, _b;
    const { id = `radio-${(_a = props.name) !== null && _a !== void 0 ? _a : ""}-${(_b = props.index) !== null && _b !== void 0 ? _b : 0}`, index = "", description, label = "", value = "", name = "", onChange, errorMsg, diskPosition = "start", checked = false, disabled = false, labelColor, descriptionColor, fillColor = colors/* default.BLUE */.Z.BLUE, actionable = true, } = props;
    return ((0,jsx_runtime.jsxs)(StyledRadioWrapper, Object.assign({ disabled: disabled, diskPosition: diskPosition }, { children: [(0,jsx_runtime.jsx)(StyledRadio, { type: "radio", name: name, ref: ref, id: id, disabled: disabled, checked: checked, onChange: onChange, value: value, fillColor: fillColor, actionable: actionable, diskPosition: diskPosition }), (0,jsx_runtime.jsxs)(StyledRadioTextWrapper, Object.assign({ flexDirection: "column", alignItems: "flex-start", justifyContent: "center" }, { children: [!!label && ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "medium", as: "label", htmlFor: id, color: labelColor, size: "m" }, { children: label }))), !!description && ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: descriptionColor, size: "s" }, { children: description }))), !!errorMsg && ((0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: colors/* default.RED */.Z.RED, size: "s" }, { children: errorMsg })))] }))] })));
});


//# sourceMappingURL=Radio.js.map


/***/ }),

/***/ 50116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RadioGroup; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/Radio/Radio.js + 1 modules
var Radio = __webpack_require__(84789);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../core-ui/dist/components/RadioGroup/RadioGroup.styles.js


const StyledRadioGroupWrapper = styled_components_browser_esm/* default.div */.ZP.div `
    display: flex;
    flex-direction: column;
    gap: 10px;
`;


//# sourceMappingURL=RadioGroup.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/RadioGroup/RadioGroup.js









const RadioGroup = (0,react.forwardRef)((props, ref) => {
    const { groupDescription, groupLabel, name, onChange, option = [], value, descriptionColor, diskPosition, errorMsg, fillColor, labelColor, direction = "row", wrap = "", gap = 10, rowGap = props.gap, required, id, dividerNode, } = props;
    return ((0,jsx_runtime.jsxs)(StyledRadioGroupWrapper, { children: [(0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ size: "m", required: required }, { children: groupLabel })), (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ size: "sm" }, { children: groupDescription })), (0,jsx_runtime.jsx)(Flex/* Flex */.kC, Object.assign({ flexWrap: wrap ? "wrap" : "initial", flexDirection: direction, gap: gap, style: { rowGap: rowGap } }, { children: option.map((_a, index) => {
                    var { id: optionId } = _a, restOption = (0,_tslib/* __rest */._)(_a, ["id"]);
                    return ((0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [(0,jsx_runtime.jsx)(Radio/* default */.Z, Object.assign({ id: id ? `${id}-${index}` : optionId }, restOption, { index: index, name: name, onChange: onChange, checked: value === restOption.value, fillColor: fillColor, labelColor: labelColor, descriptionColor: descriptionColor, diskPosition: diskPosition })), index < (option === null || option === void 0 ? void 0 : option.length) - 1 && dividerNode] }));
                }) })), (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: colors/* default.RED */.Z.RED, size: "sm" }, { children: errorMsg }))] }));
});


//# sourceMappingURL=RadioGroup.js.map


/***/ }),

/***/ 11350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OD": function() { return /* binding */ ClearIconComponent; },
  "e$": function() { return /* binding */ ContainerComponent; },
  "Fr": function() { return /* binding */ ControlComponent; },
  "fz": function() { return /* binding */ DropdownIndicatorComponent; },
  "uy": function() { return /* binding */ DropdownIndicatorComponentWrapper; },
  "am": function() { return /* binding */ InputComponent; },
  "c1": function() { return /* binding */ NoOptionsMessageComponent; },
  "x8": function() { return /* binding */ OptionComponent; },
  "WB": function() { return /* binding */ PlaceholderComponent; },
  "G$": function() { return /* binding */ SingleValueComponent; },
  "u$": function() { return /* binding */ ValueComponent; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-select/dist/index-641ee5b8.esm.js + 3 modules
var index_641ee5b8_esm = __webpack_require__(99438);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../core-ui/dist/assets/icons/sign/AngleLeftGray.svg.js


function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgAngleLeftGray = function SvgAngleLeftGray(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.554,
    height: 13.125
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M15.407 11.183 9.849 5.635a.983.983 0 0 0-1.394 1.384l4.861 4.91-4.861 4.861a.983.983 0 1 0 1.394 1.385l5.558-5.548a.982.982 0 0 0 0-1.444Z",
    transform: "translate(-8.169 -5.344)",
    style: {
      fill: "#80868b",
      opacity: 1
    }
  }));
};


//# sourceMappingURL=AngleLeftGray.svg.js.map

// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
;// CONCATENATED MODULE: ../core-ui/dist/components/Select/RSelectDerived.js







const ContainerComponent = (_a) => {
    var { children } = _a, props = (0,_tslib/* __rest */._)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.SelectContainer, Object.assign({}, props, { className: "select-container" }, { children: children })));
};
const ControlComponent = (_a) => {
    var _b;
    var { children, className } = _a, props = (0,_tslib/* __rest */._)(_a, ["children", "className"]);
    const { selectProps } = props;
    const customLabel = (_b = selectProps["aria-label"]) !== null && _b !== void 0 ? _b : "";
    return ((0,jsx_runtime.jsxs)(index_641ee5b8_esm.c.Control, Object.assign({}, props, { className: [
            className,
            "select-control",
            selectProps.isSearchable ? "select-control--searchable" : null,
        ]
            .filter(Boolean)
            .join(" ") }, { children: [(0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ weight: "medium", color: colors/* default.GREY_600 */.Z.GREY_600 }, { children: customLabel })), children] })));
};
const DropdownIndicatorComponentWrapper = (_a) => {
    var { children } = _a, props = (0,_tslib/* __rest */._)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.DropdownIndicator, Object.assign({}, props, { className: "select-customDropDownIndicator" }, { children: children })));
};
const DropdownIndicatorComponent = (_a) => {
    var props = (0,_tslib/* __rest */._)(_a, ["children"]);
    return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.DropdownIndicator, Object.assign({}, props, { className: "select-dropDownIndicator" }, { children: (0,jsx_runtime.jsx)(SvgAngleLeftGray, {}) })));
};
const SingleValueComponent = (_a) => {
    var { children } = _a, props = (0,_tslib/* __rest */._)(_a, ["children"]);
    const { data: { leftNode, rightNode }, } = props;
    return ((0,jsx_runtime.jsxs)(index_641ee5b8_esm.c.SingleValue, Object.assign({}, props, { className: "select-singleValue" }, { children: [leftNode, (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ "data-select-value-label": true, size: "m" }, { children: children })), rightNode] })));
};
const InputComponent = (props) => {
    return (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Input, Object.assign({}, props, { className: "select-input" }));
};
const PlaceholderComponent = (props) => {
    return (0,jsx_runtime.jsx)(index_641ee5b8_esm.c.Placeholder, Object.assign({}, props, { className: "select-placeholder" }));
};
const ValueComponent = (props) => {
    return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.ValueContainer, Object.assign({}, props, { className: "select-value-container" })));
};
const OptionComponent = (props) => {
    const { isDisabled, isSelected, isFocused, children, data: { leftNode, rightNode }, } = props;
    let state = "";
    if (isSelected) {
        state = "selected";
    }
    else if (isDisabled) {
        state = "disabled";
    }
    else if (isFocused) {
        state = "focused";
    }
    return ((0,jsx_runtime.jsxs)(index_641ee5b8_esm.c.Option, Object.assign({}, props, { className: `select-option ${state}` }, { children: [leftNode, " ", children, " ", rightNode] })));
};
const NoOptionsMessageComponent = (props) => {
    return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.NoOptionsMessage, Object.assign({}, props, { className: "select-noOptionMessage" })));
};
const ClearIconComponent = (props) => {
    const { innerProps, selectProps: { instanceId }, } = props;
    return ((0,jsx_runtime.jsx)(index_641ee5b8_esm.c.ClearIndicator, Object.assign({}, props, { className: "select-clear", innerProps: Object.assign(Object.assign({}, innerProps), { id: `${instanceId}__clearBtn` }) })));
};


//# sourceMappingURL=RSelectDerived.js.map


/***/ }),

/***/ 79057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextArea; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/layout/Container.js
var Container = __webpack_require__(40936);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
// EXTERNAL MODULE: ../core-ui/dist/mixins/style-mixins.js
var style_mixins = __webpack_require__(13261);
// EXTERNAL MODULE: ../core-ui/dist/mixins/scrollbar.js
var scrollbar = __webpack_require__(47755);
// EXTERNAL MODULE: ../core-ui/dist/mixins/cursor.js
var cursor = __webpack_require__(27106);
// EXTERNAL MODULE: ../core-ui/dist/mixins/font.js
var font = __webpack_require__(79047);
;// CONCATENATED MODULE: ../core-ui/dist/components/TextArea/TextArea.styles.js













const StyledTextAreaInput = styled_components_browser_esm/* default.textarea */.ZP.textarea `
    font-size: 1rem;
    border: 2px solid ${colors/* default.GREY_200 */.Z.GREY_200};
    color: ${colors/* default.GREY_1000 */.Z.GREY_1000};
    border-radius: 4px;
    padding: 0.8em;
    outline: none;
    width: ${({ width }) => (width ? (0,common/* getSizeInRem */.$X)(width) : "100%")};
    resize: vertical;
    &:focus {
        border: 2px solid ${colors/* default.BLUE */.Z.BLUE};
    }

    &::placeholder {
        color: ${colors/* default.GREY_400 */.Z.GREY_400};
    }

    ${({ size }) => {
    switch (size) {
        case "sm":
            return styled_components_browser_esm/* css */.iv `
                    ${(0,font/* getCommonFontStyleMixin */.d)({ size })};
                `;
        default:
            return styled_components_browser_esm/* css */.iv ``;
    }
}};
`;


//# sourceMappingURL=TextArea.styles.js.map

// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
;// CONCATENATED MODULE: ../core-ui/dist/components/TextArea/TextArea.js








const TextArea = (0,react.forwardRef)((props, ref) => {
    var _a;
    const { label, name, onChange, autoFocus, disabled, errorMsg, helpMsg, id, length, onBlur, onFocus, required, showCharacterCount, value, placeholder, width, rows, cols, headingLabelStyleProps, size = "md", } = props;
    const inputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, () => inputRef.current);
    const countMsg = showCharacterCount
        ? `${(_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0} / ${length}`
        : "";
    return ((0,jsx_runtime.jsx)(Container/* default */.Z, Object.assign({ margin: 0, padding: 0 }, { children: (0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ flexDirection: "column", gap: 10 }, { children: [(0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ required: required, size: "m" }, headingLabelStyleProps, { children: label })), (0,jsx_runtime.jsx)(StyledTextAreaInput, { placeholder: placeholder, id: id, value: value, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus, disabled: disabled, name: name, maxLength: length, autoCorrect: "false", autoCapitalize: "false", autoComplete: "false", width: width, rows: rows, cols: cols, size: size }), (0,jsx_runtime.jsxs)(Flex/* Flex */.kC, Object.assign({ justifyContent: "space-between" }, { children: [(0,jsx_runtime.jsx)(Flex/* Flex */.kC, { children: (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: colors/* default.GREY_400 */.Z.GREY_400, size: "sm" }, { children: helpMsg })) }), (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: colors/* default.GREY_400 */.Z.GREY_400, size: "sm" }, { children: countMsg }))] })), (0,jsx_runtime.jsx)(Typography/* default */.Z, Object.assign({ color: colors/* default.RED */.Z.RED, size: "sm" }, { children: errorMsg }))] })) })));
});


//# sourceMappingURL=TextArea.js.map


/***/ }),

/***/ 50951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TextArea_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TextArea_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79057);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 53796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/fontSize.js
var fontSize = __webpack_require__(99420);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/breakpoint.js
var breakpoint = __webpack_require__(91818);
;// CONCATENATED MODULE: ../core-ui/dist/components/Typography/Typography.styles.js






const StyledRequiredSymbol = styled_components_browser_esm/* default.span */.ZP.span `
    color: ${colors/* default.RED_800 */.Z.RED_800};
`;
const StyledTypography = styled_components_browser_esm/* default.span */.ZP.span `
    /* min-width: fit-content; */
    padding: 0;
    margin: 0;
    font-size: ${({ size }) => (size ? `${fontSize/* default */.Z[size]}rem` : "inherit")};
    text-align: ${({ align }) => align};
    color: ${({ color }) => color};
    font-family: ${({ weight }) => weight && fonts/* default */.Z[weight.toUpperCase()]};
    font-style: ${({ italic }) => italic && "italic"};
    text-decoration: ${({ underline }) => underline && "underline"};
    text-transform: ${({ textTransform }) => textTransform};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "1.5em")};
    white-space: ${({ preWrap }) => (preWrap ? "pre-wrap" : "inherit")};
    cursor: ${({ onClick }) => (onClick ? "pointer" : "inherit")};

    ${({ noWrap }) => noWrap &&
    styled_components_browser_esm/* css */.iv `
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `};

    ${({ preventSelect }) => preventSelect &&
    styled_components_browser_esm/* css */.iv `
            -webkit-user-select: none; /* Safari */
            -ms-user-select: none; /* IE 10 and IE 11 */
            user-select: none; /* Standard syntax */
        `};

    ${({ strike }) => strike &&
    styled_components_browser_esm/* css */.iv `
            text-decoration: line-through;
            /* optional */
            text-decoration-thickness: 2px;
            text-decoration-color: currentColor;
            text-decoration-style: solid;
        `};

    @media (max-width: ${breakpoint/* Breakpoint.mobileBreakpointMaxWidth */.U.mobileBreakpointMaxWidth}) {
        ${({ mSize }) => (mSize ? `font-size:  ${fontSize/* default */.Z[mSize]}rem` : ``)}
    }
`;


//# sourceMappingURL=Typography.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/Typography/Typography.js





const Typography = (0,react.forwardRef)((props, ref) => {
    const { children, as = "span" } = props, restProps = (0,_tslib/* __rest */._)(props, ["children", "as"]);
    if (!children)
        return null;
    return ((0,jsx_runtime.jsxs)(StyledTypography, Object.assign({}, restProps, { as: as, ref: ref }, { children: [children, (props === null || props === void 0 ? void 0 : props.required) ? ((0,jsx_runtime.jsx)(StyledRequiredSymbol, { children: "*" })) : null] })));
});


//# sourceMappingURL=Typography.js.map


/***/ }),

/***/ 71960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Typography_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Typography_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53796);


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 56832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BordererCard; }
});

// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/components/common/BordererCard/BordererCard.styles.js









const StyledBorderedCard = styled_components_browser_esm/* default.div */.ZP.div `
    padding: ${({ padded = true }) => (padded ? "1rem" : undefined)};
    border-radius: ${({ borderRadius = "8px" }) => borderRadius};
    border: 1px solid ${({ borderColor = colors/* default.GREY_200 */.Z.GREY_200 }) => borderColor};
    background-color: ${({ backgroundColor = "white" }) => backgroundColor};
    box-shadow: 0px 0px 24px -4px rgba(16, 24, 40, 0.1);
    width: ${(props) => (0,common/* getSizeInRem */.$X)(props.width)};
    overflow: ${({ overflow = "hidden" }) => overflow};
`;


//# sourceMappingURL=BordererCard.styles.js.map

;// CONCATENATED MODULE: ../core-ui/dist/components/common/BordererCard/BordererCard.js




const BordererCard = (_a) => {
    var { children } = _a, restProp = (0,_tslib/* __rest */._)(_a, ["children"]);
    return (0,jsx_runtime.jsx)(StyledBorderedCard, Object.assign({}, restProp, { children: children }));
};


//# sourceMappingURL=BordererCard.js.map


/***/ }),

/***/ 91818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Breakpoint; }
/* harmony export */ });
const Breakpoint = {
    mobileBreakpointMaxWidth: "991px",
    desktopBreakpointMinWidth: "992px",
    desktopBreakpoint: "992px",
    mediumScreenBreakpoint: "768px",
    mobileBreakpoint: "576px",
};


//# sourceMappingURL=breakpoint.js.map


/***/ }),

/***/ 60603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ COLOR_VARIANT; }
/* harmony export */ });
/* harmony import */ var _colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);


const COLOR_VARIANT = {
    green: {
        primary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREEN_600 */ .Z.GREEN_600,
        secondary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREEN_200 */ .Z.GREEN_200,
    },
    orange: {
        primary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ORANGE_500 */ .Z.ORANGE_500,
        secondary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ORANGE_100 */ .Z.ORANGE_100,
    },
    red: {
        primary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RED */ .Z.RED,
        secondary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RED_100 */ .Z.RED_100,
    },
    purple: {
        primary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PURPLE */ .Z.PURPLE,
        secondary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PURPLE_LIGHT */ .Z.PURPLE_LIGHT,
    },
    grey: {
        primary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_600 */ .Z.GREY_600,
        secondary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200,
    },
    blue: {
        primary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE,
        secondary: _colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE_100 */ .Z.BLUE_100,
    },
};


//# sourceMappingURL=color-variant.js.map


/***/ }),

/***/ 94897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ COLORS$1; }
/* harmony export */ });
var COLORS;
(function (COLORS) {
    // Blue
    COLORS["BLUE_1100"] = "#304FAE";
    COLORS["BLUE_1000"] = "#182B63";
    COLORS["BLUE_900"] = "#223D8D";
    COLORS["BLUE_700"] = "#1F41B4";
    COLORS["BLUE"] = "#2355FC";
    COLORS["BLUE_500"] = "#4E85FF";
    COLORS["BLUE_400"] = "#70A7FF";
    COLORS["BLUE_300"] = "#98CAFF";
    COLORS["BLUE_200"] = "#BFDFFF";
    COLORS["BLUE_100"] = "#DBEFFF";
    COLORS["BLUE_50"] = "#E9F5FF";
    // Red
    COLORS["RED_800"] = "#B91C1C";
    COLORS["RED_700"] = "#991B1B";
    COLORS["RED_600"] = "#B91C1C";
    COLORS["RED"] = "#DC2626";
    COLORS["RED_400"] = "#EF4444";
    COLORS["RED_300"] = "#F87171";
    COLORS["RED_200"] = "#FCA5A5";
    COLORS["RED_100"] = "#FECACA";
    // Green
    COLORS["GREEN_700"] = "#0F863C";
    COLORS["GREEN_600"] = "#0EA546";
    COLORS["GREEN_500"] = "#19CE5C";
    COLORS["GREEN_400"] = "#42E67E";
    COLORS["GREEN_300"] = "#80F5AA";
    COLORS["GREEN_200"] = "#B8FACF";
    COLORS["GREEN_100"] = "#DAFEE6";
    // Yellow
    COLORS["YELLOW"] = "#FFB700";
    COLORS["YELLOW_500"] = "#FFD71B";
    COLORS["YELLOW_400"] = "#FFE846";
    COLORS["YELLOW_300"] = "#FFF485";
    COLORS["YELLOW_200"] = "#FFF9C5";
    COLORS["YELLOW_100"] = "#FFFEEA";
    // Orange
    COLORS["ORANGE"] = "#F56700";
    COLORS["ORANGE_500"] = "#FF840A";
    COLORS["ORANGE_400"] = "#FFA132";
    COLORS["ORANGE_300"] = "#FFC56D";
    COLORS["ORANGE_200"] = "#FFDEA5";
    COLORS["ORANGE_100"] = "#FFF0D3";
    // PURPLE
    COLORS["PURPLE"] = "#5938FB";
    COLORS["PURPLE_LIGHT"] = "#DCD4FF";
    // GREY
    COLORS["GREY_1000"] = "#191919";
    COLORS["GREY_900"] = "#383838";
    COLORS["GREY_800"] = "#434343";
    COLORS["GREY_700"] = "#515151";
    COLORS["GREY_600"] = "#666666";
    COLORS["GREY_500"] = "#818181";
    COLORS["GREY_450"] = "#978E8E";
    COLORS["GREY_400"] = "#A4A4A4";
    COLORS["GREY_300"] = "#C8C8C8";
    COLORS["GREY_200"] = "#E3E3E3";
    COLORS["GREY_150"] = "#EDEDED";
    COLORS["GREY_100"] = "#F7F7F7";
    COLORS["GREY_50"] = "#F6F6F6";
    // COMMON
    COLORS["WHITE"] = "#FFFFFF";
    COLORS["BLACK"] = "#000000";
})(COLORS || (COLORS = {}));
var COLORS$1 = COLORS;


//# sourceMappingURL=colors.js.map


/***/ }),

/***/ 65357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ FileMimeCategories; },
/* harmony export */   "p": function() { return /* binding */ FileCategories; }
/* harmony export */ });
var FileCategories;
(function (FileCategories) {
    FileCategories["JPG"] = "jpg";
    FileCategories["JPEG"] = "jpeg";
    FileCategories["PNG"] = "png";
    FileCategories["GIF"] = "gif";
    FileCategories["PDF"] = "pdf";
})(FileCategories || (FileCategories = {}));
var FileMimeCategories;
(function (FileMimeCategories) {
    FileMimeCategories["JPG"] = "image/jpg";
    FileMimeCategories["JPEG"] = "image/jpeg";
    FileMimeCategories["PNG"] = "image/png";
    FileMimeCategories["GIF"] = "image/gif";
    FileMimeCategories["PDF"] = "application/pdf";
})(FileMimeCategories || (FileMimeCategories = {}));


//# sourceMappingURL=files.js.map


/***/ }),

/***/ 99420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FontSize; }
/* harmony export */ });
const FontSize = {
    xxs: 0.625,
    xs: 0.75,
    s: 0.81,
    sm: 0.875,
    m: 1,
    md: 1.125,
    l: 1.5,
    xl: 1.75,
    xxl: 2.25,
    xxxl: 3, //48px
};


//# sourceMappingURL=fontSize.js.map


/***/ }),

/***/ 12308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FONTS$1; }
/* harmony export */ });
var FONTS;
(function (FONTS) {
    FONTS["REGULAR"] = "Inter-Regular";
    FONTS["MEDIUM"] = "Inter-Medium";
    FONTS["SEMIBOLD"] = "Inter-SemiBold";
    FONTS["BOLD"] = "Inter-Bold";
})(FONTS || (FONTS = {}));
var FONTS$1 = FONTS;


//# sourceMappingURL=fonts.js.map


/***/ }),

/***/ 73242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* reexport safe */ _color_variant_js__WEBPACK_IMPORTED_MODULE_7__.Q; },
/* harmony export */   "_s": function() { return /* reexport safe */ _files_js__WEBPACK_IMPORTED_MODULE_5__._; },
/* harmony export */   "m7": function() { return /* reexport safe */ _zIndexList_js__WEBPACK_IMPORTED_MODULE_8__.Z; },
/* harmony export */   "nh": function() { return /* reexport safe */ _symbol_js__WEBPACK_IMPORTED_MODULE_6__.n; },
/* harmony export */   "ud": function() { return /* reexport safe */ _symbol_js__WEBPACK_IMPORTED_MODULE_6__.u; },
/* harmony export */   "wL": function() { return /* reexport safe */ _colors_js__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);
/* harmony import */ var _fontSize_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99420);
/* harmony import */ var _breakpoint_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91818);
/* harmony import */ var _theme_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63298);
/* harmony import */ var _files_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65357);
/* harmony import */ var _symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40423);
/* harmony import */ var _color_variant_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60603);
/* harmony import */ var _zIndexList_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94069);
/* harmony import */ var _ui_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10193);












//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Rupee; },
/* harmony export */   "u": function() { return /* binding */ DotSymbol; }
/* harmony export */ });
const DotSymbol = "•";
const Rupee = "₹";


//# sourceMappingURL=symbol.js.map


/***/ }),

/***/ 63298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports THEMES, darkTheme, lightTheme */
const lightTheme = {
    colors: {
        background: "#F6F9FC",
        backgroundInverse: "#7A8997",
        positive: "#E1FFD4",
        negative: "#FEDED2",
        primary: "#FF4785",
        secondary: "#1EA7FD",
        tertiary: "#DDDDDD",
        text: "#222222",
    },
    spacing: {
        padding: {
            small: 10,
            medium: 20,
            large: 30,
        },
        borderRadius: {
            small: 5,
            default: 10,
        },
    },
    typography: {
        type: {
            primary: '"Nunito Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
            code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace',
        },
        weight: {
            regular: "400",
            bold: "700",
            extrabold: "800",
            black: "900",
        },
        size: {
            s1: 12,
            s2: 14,
            s3: 16,
            m1: 20,
            m2: 24,
            m3: 28,
            l1: 32,
            l2: 40,
            l3: 48,
        },
    },
};
const darkTheme = Object.assign(Object.assign({}, lightTheme), { colors: {
        background: "#1b1c1d",
        backgroundInverse: "#333333",
        positive: "#9fd986",
        negative: "#df987d",
        primary: "#d43369",
        secondary: "#1b8bd0",
        tertiary: "#DDDDDD",
        text: "#FFFFFF",
    } });
const THEMES = {
    LIGHT: lightTheme,
    DARK: darkTheme,
};


//# sourceMappingURL=theme.js.map


/***/ }),

/***/ 10193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CommonElementSizeMap; }
/* harmony export */ });
const CommonElementSizeMap = {
    sm: "32px",
    md: "48px",
    lg: "64px",
    auto: undefined,
};


//# sourceMappingURL=ui.js.map


/***/ }),

/***/ 94069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ zIndexList$1; }
/* harmony export */ });
/**
 * zIndex
 * use zIndex wisely, try not to add z index unnecessarily
 */
var zIndexList;
(function (zIndexList) {
    zIndexList[zIndexList["ToastContainer"] = 2147483647] = "ToastContainer";
    zIndexList[zIndexList["bottomSheet"] = 99999999] = "bottomSheet";
    zIndexList[zIndexList["modal"] = 1100] = "modal";
})(zIndexList || (zIndexList = {}));
/**
 * SCSS variables
 */
/**
 * file - dashboard.module.scss
 * .topSection - zIndex: 100
 * Used in advance filter bottom sheet - listing page
 * reason sticky filter header has zindex 1 but bottom and top nav has 100 so need to match it
 */
var zIndexList$1 = zIndexList;


//# sourceMappingURL=zIndexList.js.map


/***/ }),

/***/ 95385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o9": function() { return /* reexport */ useGetBlobUrlFromUrl; },
  "A$": function() { return /* reexport */ useToggleModalWithLocalState/* useToggleModalWithLocalState */.A; }
});

// UNUSED EXPORTS: useActionState, useGenericAsyncHandler, useKeyboardAwareField, useMobileSheetViewportLock, useToggleState, useViewportSheetDomSync

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useKeyboardAwareField.js
var useKeyboardAwareField = __webpack_require__(94344);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useToggleModalWithLocalState.js
var useToggleModalWithLocalState = __webpack_require__(8779);
// EXTERNAL MODULE: ../core-ui/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(29216);
;// CONCATENATED MODULE: ../core-ui/dist/hooks/useGetBlobUrlFromUrl.js



function useGetBlobUrlFromUrl(url = "") {
    const [blobUrl, setBlobUrl] = (0,react.useState)("");
    (0,react.useEffect)(() => {
        (() => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
            if (url) {
                try {
                    const response = yield fetch(url);
                    const blob = yield response.blob();
                    const fileURL = URL.createObjectURL(blob);
                    setBlobUrl(fileURL);
                }
                catch (error) {
                    console.error("Failed to fetch blob:", error);
                }
            }
        }))();
    }, [url]);
    return { blobUrl };
}


//# sourceMappingURL=useGetBlobUrlFromUrl.js.map

// EXTERNAL MODULE: ../core-ui/dist/hooks/useGenericAsyncHandler.js
var useGenericAsyncHandler = __webpack_require__(20475);
;// CONCATENATED MODULE: ../core-ui/dist/hooks/useActionState.js


function useActionState(init) {
    const initialState = Object.assign({ isIdle: true, isLoading: false, isError: false, isSuccess: false, isCompleted: false, errorMsg: undefined, data: undefined }, init);
    const [state, setState] = useState(initialState);
    const updateField = (key, value) => {
        setState((prev) => (Object.assign(Object.assign({}, prev), { [key]: value })));
    };
    return {
        value: state,
        updateValue: setState,
        updateField: updateField,
    };
}


//# sourceMappingURL=useActionState.js.map

;// CONCATENATED MODULE: ../core-ui/dist/hooks/useToggleState.js


function useToggleState(initialState = false) {
    const [value, setValue] = useState(initialState);
    const enable = () => {
        setValue(true);
    };
    const disable = () => {
        setValue(false);
    };
    const toggleValue = () => {
        setValue((prevState) => !prevState);
    };
    return {
        value,
        enable,
        disable,
        toggleValue,
    };
}


//# sourceMappingURL=useToggleState.js.map

// EXTERNAL MODULE: ../core-ui/dist/hooks/useMobileSheetViewportLock.js
var useMobileSheetViewportLock = __webpack_require__(27635);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useViewportSheetDomSync.js
var useViewportSheetDomSync = __webpack_require__(1150);
;// CONCATENATED MODULE: ../core-ui/dist/hooks/index.js









//# sourceMappingURL=index.js.map


/***/ }),

/***/ 20475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useGenericAsyncHandler; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29216);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);



function useGenericAsyncHandler(asyncFn) {
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const isMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    const execute = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const result = yield asyncFn(...args);
            return result;
        }
        finally {
            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    }), [asyncFn]);
    return { execute, loading };
}


//# sourceMappingURL=useGenericAsyncHandler.js.map


/***/ }),

/***/ 94344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useKeyboardAwareField; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _methods_keyboardViewport_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69849);



const FIELD_INPUT_SELECTOR = 'input:not([type="hidden"])';
const noopFocus = () => { };
/**
 * iOS: keeps a focused field above the keyboard and resolves dropdown direction
 * from the visible viewport.
 *
 * Android: returns inert handlers — the browser already handles keyboard scroll.
 */
function useKeyboardAwareField(anchorRef, { enabled = true, scrollOnFocus = true, menuMaxHeight, defaultMenuPlacement = "bottom", clearance, } = {}) {
    const active = enabled && (0,_methods_keyboardViewport_js__WEBPACK_IMPORTED_MODULE_1__/* .needsKeyboardViewportCompensation */ .hP)();
    const [menuPlacement, setMenuPlacement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultMenuPlacement);
    const cleanupRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const getFieldElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        var _a, _b;
        const anchor = anchorRef.current;
        return ((_b = (_a = anchor === null || anchor === void 0 ? void 0 : anchor.querySelector(FIELD_INPUT_SELECTOR)) !== null && _a !== void 0 ? _a : anchor) !== null && _b !== void 0 ? _b : null);
    }, [anchorRef]);
    const syncPlacement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        const element = getFieldElement();
        if (!active || !menuMaxHeight || !element) {
            return;
        }
        setMenuPlacement((0,_methods_keyboardViewport_js__WEBPACK_IMPORTED_MODULE_1__/* .resolveKeyboardMenuPlacement */ .Ih)(element, {
            maxHeight: menuMaxHeight,
            clearance,
        }));
    }, [active, clearance, getFieldElement, menuMaxHeight]);
    const stopTracking = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        var _a;
        (_a = cleanupRef.current) === null || _a === void 0 ? void 0 : _a.call(cleanupRef);
        cleanupRef.current = null;
    }, []);
    const onFieldFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event) => {
        if (!active || !(event.target instanceof Element)) {
            return;
        }
        const target = event.target;
        syncPlacement();
        stopTracking();
        cleanupRef.current = (0,_methods_keyboardViewport_js__WEBPACK_IMPORTED_MODULE_1__/* .onKeyboardSettle */ .K7)(() => {
            if (scrollOnFocus) {
                (0,_methods_keyboardViewport_js__WEBPACK_IMPORTED_MODULE_1__/* .scrollIntoKeyboardView */ ._k)(target, { clearance });
            }
            syncPlacement();
        });
    }, [active, clearance, scrollOnFocus, stopTracking, syncPlacement]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => stopTracking, [stopTracking]);
    if (!active) {
        return {
            menuPlacement: defaultMenuPlacement,
            onFieldFocus: noopFocus,
            onFieldBlur: noopFocus,
            syncPlacement: noopFocus,
        };
    }
    return {
        menuPlacement,
        onFieldFocus,
        onFieldBlur: stopTracking,
        syncPlacement,
    };
}


//# sourceMappingURL=useKeyboardAwareField.js.map


/***/ }),

/***/ 26513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29216);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _methods_browser_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82238);




const useMediaQuery = (_a) => {
    var { queryType, initialState = false } = _a, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["queryType", "initialState"]);
    const { sizePx } = props;
    let query = "";
    switch (queryType) {
        case "max-width":
            query = `(max-width: ${sizePx}px)`;
            break;
        case "min-width":
            query = `(min-width: ${sizePx}px)`;
            break;
        case "max-height":
            query = `(max-height: ${sizePx}px)`;
            break;
        case "min-height":
            query = `(min-height: ${sizePx}px)`;
            break;
        case "mobile":
            query = `(max-width: 576px)`;
            break;
        case "medium-screen":
            query = `(max-width: 991px)`;
            break;
        case "desktop":
            query = `(min-width: 992px)`;
            break;
    }
    // Keep SSR and first client render aligned — read viewport only after mount.
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (!query || typeof window === "undefined") {
            return;
        }
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);
        setMatches(media.matches);
        return (0,_methods_browser_js__WEBPACK_IMPORTED_MODULE_2__/* .subscribeMatchMedia */ .uY)(media, listener);
    }, [query]);
    return matches;
};


//# sourceMappingURL=useMediaQuery.js.map


/***/ }),

/***/ 27635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useMobileSheetViewportLock; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _methods_dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97163);
/* harmony import */ var _methods_viewportSheet_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99624);




const useMobileSheetViewportLock = ({ isOpen, freezeOnMobile, disableZoom, }) => {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
        if (!isOpen || typeof document === "undefined") {
            return;
        }
        const shouldDisableZoom = freezeOnMobile && disableZoom;
        const unlockScroll = (0,_methods_dom_js__WEBPACK_IMPORTED_MODULE_1__/* .lockBodyScroll */ .IM)({
            freezeOnMobile,
            disableZoom: shouldDisableZoom,
        });
        const unsyncViewport = freezeOnMobile
            ? (0,_methods_viewportSheet_js__WEBPACK_IMPORTED_MODULE_2__/* .syncVisualViewportHeightVar */ .qc)({
                deferSessionStart: shouldDisableZoom,
            })
            : () => { };
        return () => {
            unlockScroll();
            unsyncViewport();
        };
    }, [disableZoom, freezeOnMobile, isOpen]);
};


//# sourceMappingURL=useMobileSheetViewportLock.js.map


/***/ }),

/***/ 8779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useToggleModalWithLocalState; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useToggleModalWithLocalState(initialState = false) {
    const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const toggleModal = () => {
        setIsModalOpen((prevState) => !prevState);
    };
    return {
        isModalOpen,
        openModal,
        closeModal,
        toggleModal,
    };
}


//# sourceMappingURL=useToggleModalWithLocalState.js.map


/***/ }),

/***/ 1150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useViewportSheetDomSync; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _methods_viewportSheet_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99624);



/** Re-measure sheet viewport after mount (swipeable library + full-viewport sheet). */
const useViewportSheetDomSync = (isActive) => {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
        if (!isActive) {
            return;
        }
        (0,_methods_viewportSheet_js__WEBPACK_IMPORTED_MODULE_1__/* .syncViewportHeightNow */ .Tx)();
        const frameId = requestAnimationFrame(_methods_viewportSheet_js__WEBPACK_IMPORTED_MODULE_1__/* .syncViewportHeightNow */ .Tx);
        return () => cancelAnimationFrame(frameId);
    }, [isActive]);
};


//# sourceMappingURL=useViewportSheetDomSync.js.map


/***/ }),

/***/ 40936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82740);
/* harmony import */ var _methods_common_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28052);
/* harmony import */ var _mixins_style_mixins_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13261);
/* harmony import */ var _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47755);
/* harmony import */ var _mixins_cursor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27106);
/* harmony import */ var _mixins_font_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79047);







const Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div `
    display: ${({ display }) => display};
    gap: ${({ gap }) => (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_5__/* .getSizeInPx */ .tf)(gap)};

    margin: ${({ margin }) => { var _a; return (_a = (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_5__/* .getSizeInRem */ .$X)(margin)) !== null && _a !== void 0 ? _a : "0"; }};
    padding: ${({ padding }) => { var _a; return (_a = (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_5__/* .getSizeInRem */ .$X)(padding)) !== null && _a !== void 0 ? _a : "0"; }};
    border: ${({ border }) => border};

    ${({ width, height, borderRadius }) => (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
    width: (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_5__/* .getSizeInRem */ .$X)(width),
    height: (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_5__/* .getSizeInRem */ .$X)(height),
    borderRadius: (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_5__/* .getSizeInRem */ .$X)(borderRadius),
})};

    ${({ gridAutoFlow, gridTemplateColumns, gridTemplateRows, alignItems, justifyContent, }) => (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
    gridAutoFlow,
    gridTemplateColumns,
    gridTemplateRows,
    alignItems,
    justifyContent,
})};

    ${({ hideScrollBar }) => hideScrollBar && _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_1__/* .scrollBarStyle__hidden */ .a};
`;


//# sourceMappingURL=Container.js.map


/***/ }),

/***/ 31013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Flex; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "vs": function() { return /* binding */ VerticalFlex; }
/* harmony export */ });
/* harmony import */ var styled_components___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);
/* harmony import */ var _methods_common_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28052);



const flexStyle = styled_components___WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    margin: ${({ margin }) => (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_1__/* .getSizeInRem */ .$X)(margin)};
    padding: ${({ padding }) => (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_1__/* .getSizeInRem */ .$X)(padding)};
    display: ${({ display }) => (display ? display : "flex")};
    flex-direction: ${({ flexDirection }) => flexDirection !== null && flexDirection !== void 0 ? flexDirection : "row"};
    justify-content: ${({ justifyContent }) => justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start"};
    align-items: ${({ alignItems }) => alignItems};
    align-self: ${({ alignSelf }) => alignSelf};
    gap: ${({ gap }) => (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_1__/* .getSizeInPx */ .tf)(gap)};
    row-gap: ${({ rowGap }) => (0,_methods_common_js__WEBPACK_IMPORTED_MODULE_1__/* .getSizeInPx */ .tf)(rowGap)};
    flex-wrap: ${({ flexWrap }) => flexWrap !== null && flexWrap !== void 0 ? flexWrap : "nowrap"};
    flex: ${({ flex }) => flex};
`;
const Flex = styled_components___WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div `
    ${flexStyle}
`;
const VerticalFlex = (0,styled_components___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(Flex) `
    ${flexStyle}
    flex-direction: column;
`;


//# sourceMappingURL=Flex.js.map


/***/ }),

/***/ 21131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ arrayAddIf; },
/* harmony export */   "D$": function() { return /* binding */ getJoinedStringFromArray; },
/* harmony export */   "V3": function() { return /* binding */ filteredArray; },
/* harmony export */   "cQ": function() { return /* binding */ getUniqueArray; }
/* harmony export */ });
/* unused harmony exports getArraysDifference, mapToLabelValue, toggleArrayValue */
const getArraysDifference = (arr1, arr2) => {
    return arr1
        .filter((x) => !arr2.includes(x))
        .concat(arr2.filter((x) => !arr1.includes(x)));
};
const arrayAddIf = (condition, value) => {
    if (condition) {
        return Array.isArray(value) ? value : [value];
    }
    return [];
};
const filteredArray = (arr, filterFalseValue = false) => {
    return arr.filter((val) => val !== undefined &&
        val !== null &&
        (filterFalseValue ? !!val : true));
};
const mapToLabelValue = (array) => {
    return array === null || array === void 0 ? void 0 : array.map((item) => ({
        label: item,
        value: item
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, ""),
    }));
};
const getJoinedStringFromArray = (arr, separator = ", ", filterItem = true) => {
    let _ = arr;
    if (filterItem) {
        _ = filteredArray(arr, filterItem);
    }
    return _.join(separator);
};
function toggleArrayValue(array, value) {
    const index = array.indexOf(value);
    if (index === -1) {
        // Value does not exist in array, add it
        return [...array, value];
    }
    else {
        // Value exists in array, remove it
        return array.filter((item) => item !== value);
    }
}
function getUniqueArray(arr) {
    return Array.from(new Set(arr));
}


//# sourceMappingURL=array.js.map


/***/ }),

/***/ 82238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ isIOSWebKit; },
/* harmony export */   "DR": function() { return /* binding */ replaceLocation; },
/* harmony export */   "HV": function() { return /* binding */ shouldUseFullPageNavigation; },
/* harmony export */   "UM": function() { return /* binding */ isMobileViewport; },
/* harmony export */   "uY": function() { return /* binding */ subscribeMatchMedia; }
/* harmony export */ });
function subscribeMatchMedia(media, listener) {
    if (typeof media.addEventListener === "function") {
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }
    media.addListener(listener);
    return () => media.removeListener(listener);
}
/** Matches app mobile breakpoint (`$mobileBreakpoint` / Bootstrap lg). */
function isMobileViewport() {
    if (typeof window === "undefined") {
        return false;
    }
    return window.matchMedia("(max-width: 991px)").matches;
}
/** iPhone, iPod, iPad (incl. iPadOS desktop UA). */
function isIOSWebKit() {
    if (typeof navigator === "undefined") {
        return false;
    }
    return (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
}
/** Prefer full navigation on iOS Safari — client-side transitions cancel in-flight fetches. */
function shouldUseFullPageNavigation() {
    return isIOSWebKit();
}
function replaceLocation(url) {
    window.location.replace(url);
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 28052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$X": function() { return /* binding */ getSizeInRem; },
/* harmony export */   "Et": function() { return /* binding */ calculateDiscount; },
/* harmony export */   "IV": function() { return /* binding */ clampNumber; },
/* harmony export */   "YI": function() { return /* binding */ isValidValue; },
/* harmony export */   "rD": function() { return /* binding */ getPriceString; },
/* harmony export */   "tf": function() { return /* binding */ getSizeInPx; }
/* harmony export */ });
const isValidValue = (val) => {
    return !!val || val === 0;
};
const getSizeInPx = (size) => {
    return typeof size === "number" ? `${size}px` : size;
};
const getSizeInRem = (size) => {
    // 1/16=0.0625, $sizeInPx/16=$sizeInPx*0.0625
    return typeof size === "number" ? `${size * 0.0625}rem` : size;
};
const clampNumber = (value, min, max) => {
    let result = value;
    if (isValidValue(max)) {
        result = Math.min(value, max);
    }
    if (isValidValue(min)) {
        result = Math.max(result, min);
    }
    return result;
};
const getPriceString = (price = 0, optionOveride) => {
    const defaultOption = {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    };
    return `${price.toLocaleString("en-IN", optionOveride || defaultOption)}`;
};
const calculateDiscount = (originalPrice, discountValue, discountType = "percentage") => {
    if (discountType === "percentage") {
        const discountAmount = (discountValue / 100) * originalPrice;
        const discountedPrice = originalPrice - discountAmount;
        return { discountAmount, discountedPrice, discountValue };
    }
    else if (discountType === "amount") {
        const discountPercentage = (discountValue / originalPrice) * 100;
        const discountedPrice = originalPrice - discountValue;
        return { discountValue, discountedPrice, discountPercentage };
    }
};


//# sourceMappingURL=common.js.map


/***/ }),

/***/ 62028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ convertHexToRGBA; }
/* harmony export */ });
const convertHexToRGBA = (hexCode = "", opacity = 1) => {
    let hex = hexCode.replace("#", "");
    if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    /* Backward compatibility for whole number based opacity values. */
    if (opacity > 1 && opacity <= 100) {
        opacity = opacity / 100;
    }
    return `rgba(${r},${g},${b},${opacity})`;
};


//# sourceMappingURL=convertHexToRGBA.js.map


/***/ }),

/***/ 97163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H5": function() { return /* binding */ scrollToElementById; },
/* harmony export */   "IM": function() { return /* binding */ lockBodyScroll; },
/* harmony export */   "iA": function() { return /* binding */ scrollToElementByIdFromHash; },
/* harmony export */   "lj": function() { return /* binding */ prepareMobileSheetOpen; }
/* harmony export */ });
/* unused harmony exports blurActiveFormControl, getRouteHash, getScrollbarWidth */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29216);
/* harmony import */ var _viewportSheet_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99624);
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82238);





const scrollToElementById = (elementId, { behavior = "smooth", block = "start", focus = true } = {}) => {
    const element = document.getElementById(elementId);
    if (!element) {
        return false;
    }
    element.scrollIntoView({ behavior, block });
    if (focus) {
        element.focus({ preventScroll: true });
    }
    return true;
};
const getRouteHash = (asPath) => asPath.split("#")[1];
/**
 * Zoom is pinned so focusing a field cannot scale the page under a sheet.
 *
 * `interactive-widget` must stay `resizes-content`: `overlays-content` leaves both the layout
 * and visual viewport at full height when the keyboard opens, which pins a sheet's sticky
 * footer under the keyboard and zeroes out every keyboard scroll measurement.
 */
const VIEWPORT_ZOOM_DISABLED_CONTENT = "width=device-width,minimum-scale=1,maximum-scale=1,initial-scale=1,user-scalable=no,interactive-widget=resizes-content";
const getScrollbarWidth = () => {
    if (typeof window === "undefined" || typeof document === "undefined") {
        return 0;
    }
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
};
/** Blur the focused control so iOS Safari can exit input-focus zoom before a sheet opens. */
const blurActiveFormControl = () => {
    if (typeof document === "undefined") {
        return;
    }
    const active = document.activeElement;
    if (active instanceof HTMLElement && active !== document.body && active !== document.documentElement) {
        active.blur();
    }
};
/** Blur + wait for iOS input-focus zoom reset before mounting a mobile full-viewport sheet. */
const prepareMobileSheetOpen = () => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(void 0, void 0, void 0, function* () {
    if (!(0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .isMobileViewport */ .UM)()) {
        return;
    }
    blurActiveFormControl();
    yield (0,_viewportSheet_js__WEBPACK_IMPORTED_MODULE_2__/* .waitForInputFocusZoomReset */ .iu)();
});
const lockBodyScroll = (options) => {
    var _a;
    const { style: bodyStyle } = document.body;
    const { style: htmlStyle } = document.documentElement;
    const scrollY = window.scrollY;
    const scrollbarWidth = getScrollbarWidth();
    const previous = {
        bodyOverflow: bodyStyle.overflow,
        bodyPaddingRight: bodyStyle.paddingRight,
        bodyPosition: bodyStyle.position,
        bodyTop: bodyStyle.top,
        bodyLeft: bodyStyle.left,
        bodyWidth: bodyStyle.width,
        htmlOverflow: htmlStyle.overflow,
        scrollY
    };
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    const previousViewportContent = (options === null || options === void 0 ? void 0 : options.disableZoom) ? (_a = viewportMeta === null || viewportMeta === void 0 ? void 0 : viewportMeta.getAttribute("content")) !== null && _a !== void 0 ? _a : null : null;
    if ((options === null || options === void 0 ? void 0 : options.disableZoom) && viewportMeta) {
        blurActiveFormControl();
        viewportMeta.setAttribute("content", VIEWPORT_ZOOM_DISABLED_CONTENT);
        const syncAfterMetaSwap = () => (0,_viewportSheet_js__WEBPACK_IMPORTED_MODULE_2__/* .syncViewportHeightNow */ .Tx)();
        requestAnimationFrame(syncAfterMetaSwap);
        [50, 150, 300, 500].forEach((delayMs) => {
            window.setTimeout(syncAfterMetaSwap, delayMs);
        });
    }
    if (options === null || options === void 0 ? void 0 : options.freezeOnMobile) {
        bodyStyle.position = "fixed";
        bodyStyle.top = `-${scrollY}px`;
        bodyStyle.left = "0";
        bodyStyle.width = "100%";
        bodyStyle.overflow = "hidden";
        htmlStyle.overflow = "hidden";
    }
    else {
        bodyStyle.overflow = "hidden";
        htmlStyle.overflow = "hidden";
        if (scrollbarWidth > 0) {
            bodyStyle.paddingRight = `${scrollbarWidth}px`;
        }
    }
    const restoreScrollPosition = () => {
        window.scrollTo(0, previous.scrollY);
        requestAnimationFrame(() => {
            window.scrollTo(0, previous.scrollY);
        });
    };
    return () => {
        bodyStyle.overflow = previous.bodyOverflow;
        bodyStyle.paddingRight = previous.bodyPaddingRight;
        bodyStyle.position = previous.bodyPosition;
        bodyStyle.top = previous.bodyTop;
        bodyStyle.left = previous.bodyLeft;
        bodyStyle.width = previous.bodyWidth;
        htmlStyle.overflow = previous.htmlOverflow;
        if (options === null || options === void 0 ? void 0 : options.freezeOnMobile) {
            restoreScrollPosition();
        }
        if ((options === null || options === void 0 ? void 0 : options.disableZoom) && viewportMeta && previousViewportContent) {
            viewportMeta.setAttribute("content", previousViewportContent);
        }
        if (options === null || options === void 0 ? void 0 : options.freezeOnMobile) {
            requestAnimationFrame(restoreScrollPosition);
        }
    };
};
const scrollToElementByIdFromHash = (asPath, elementId) => {
    if (getRouteHash(asPath) !== elementId) {
        return;
    }
    requestAnimationFrame(() => scrollToElementById(elementId));
};


//# sourceMappingURL=dom.js.map


/***/ }),

/***/ 98472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getMobileCSS; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82740);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);
/* harmony import */ var _constants_breakpoint_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91818);
/* harmony import */ var _constants_theme_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63298);
/* harmony import */ var _constants_files_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65357);
/* harmony import */ var _constants_color_variant_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60603);
/* harmony import */ var _constants_zIndexList_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94069);









const getMobileCSS = (template) => {
    return styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv `
        @media (max-width: ${_constants_breakpoint_js__WEBPACK_IMPORTED_MODULE_2__/* .Breakpoint.mobileBreakpointMaxWidth */ .U.mobileBreakpointMaxWidth}) {
            ${template}
        }
    `;
};


//# sourceMappingURL=getMobileCSS.js.map


/***/ }),

/***/ 38920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zJ": function() { return /* reexport */ time/* addDaysOnDate */.zJ; },
  "Av": function() { return /* reexport */ array/* arrayAddIf */.Av; },
  "pC": function() { return /* reexport */ time/* calculateDateDifferenceUnits */.pC; },
  "rR": function() { return /* reexport */ string/* compareString */.rR; },
  "yy": function() { return /* reexport */ string/* extractDigits */.yy; },
  "Un": function() { return /* reexport */ string/* extractPhoneNumber */.Un; },
  "V3": function() { return /* reexport */ array/* filteredArray */.V3; },
  "p6": function() { return /* reexport */ time/* formatDate */.p6; },
  "p3": function() { return /* reexport */ string/* formattedPhoneNumber */.p3; },
  "lX": function() { return /* reexport */ object/* generateObjectFromKeys */.lX; },
  "DO": function() { return /* reexport */ generateUUID; },
  "aT": function() { return /* reexport */ string/* getDotSeparatedStringFromStringArray */.aT; },
  "cm": function() { return /* reexport */ time/* getEndingTimeOfDate */.cm; },
  "VO": function() { return /* reexport */ getFileCategory; },
  "vo": function() { return /* reexport */ time/* getFilterMinMaxString */.vo; },
  "Y9": function() { return /* reexport */ time/* getFilterTimeString */.Y9; },
  "D$": function() { return /* reexport */ array/* getJoinedStringFromArray */.D$; },
  "Bn": function() { return /* reexport */ common/* getPriceString */.rD; },
  "qF": function() { return /* reexport */ time/* getRelativeTimeString */.qF; },
  "cQ": function() { return /* reexport */ array/* getUniqueArray */.cQ; },
  "Fo": function() { return /* reexport */ time/* isSameDate */.Fo; },
  "lj": function() { return /* reexport */ dom/* prepareMobileSheetOpen */.lj; },
  "Tc": function() { return /* reexport */ string/* removeNonAlphaNumeric */.Tc; },
  "bI": function() { return /* reexport */ string/* removeNonNumeric */.bI; },
  "H5": function() { return /* reexport */ dom/* scrollToElementById */.H5; },
  "iA": function() { return /* reexport */ dom/* scrollToElementByIdFromHash */.iA; },
  "$M": function() { return /* reexport */ string/* stringOperations */.$M; },
  "lR": function() { return /* reexport */ time/* toUnixTimeStamp */.lR; },
  "w0": function() { return /* reexport */ time/* toValidDate */.w0; },
  "In": function() { return /* reexport */ triggerScrollOnInputFocus; }
});

// UNUSED EXPORTS: CommonDateRange, CommonDateTime, SHEET_SCROLL_ROOT_ATTR, SHEET_SCROLL_ROOT_SELECTOR, VIEWPORT_HEIGHT_FULL_CSS, VIEWPORT_KEYBOARD_INSET_CSS, VIEWPORT_OFFSET_TOP_CSS, beep, blurActiveFormControl, calculateDiscount, camelCaseToSentenceCase, clampNumber, convertHexToRGBA, filterFalseObjValues, filteredObjValues, floatOperation, focusFormControl, focusKeyboardAware, formatDateDifferenceSelectedUnits, generateRandomNumber, generateRangeBreakup, generateUrlParams, getAerialDistanceInKm, getArraysDifference, getEnumKeyByEnumValue, getKeyByValue, getKeyboardSettleMs, getKeyboardViewportClearance, getKeyboardViewportRect, getKeyboardViewportSpace, getMobileCSS, getRouteHash, getScrollbarWidth, getSelectMenuAttachConfig, getSheetScrollRootProps, getSizeInPx, getSizeInRem, getStartingTimeOfDate, getUrlExtension, getViewportSheetContainerStyle, getVisualViewportHeight, isIOSWebKit, isMobileViewport, isPageInputFocusZoomActive, isValidValue, keepInKeyboardView, lockBodyScroll, mapToLabelValue, mergeKeyValue, mergeTimeUnits, milliseconds, needsKeyboardViewportCompensation, observeKeyboardViewport, onKeyboardSettle, playCallTerminatedTone, replaceLocation, resolveKeyboardMenuPlacement, scrollIntoKeyboardView, shouldPortalSelectMenuToBody, shouldUseFullPageNavigation, subscribeMatchMedia, syncViewportHeightNow, syncVisualViewportHeightVar, toValidUnixTimeStamp, toggleArrayValue, transformObjectValues, updateObjIf, usesViewportSheetLayout, waitForInputFocusZoomReset

// EXTERNAL MODULE: ../core-ui/dist/methods/common.js
var common = __webpack_require__(28052);
// EXTERNAL MODULE: ../core-ui/dist/methods/getMobileCSS.js
var getMobileCSS = __webpack_require__(98472);
// EXTERNAL MODULE: ../core-ui/dist/methods/time.js
var time = __webpack_require__(72);
// EXTERNAL MODULE: ../core-ui/dist/methods/string.js
var string = __webpack_require__(75905);
// EXTERNAL MODULE: ../core-ui/dist/methods/array.js
var array = __webpack_require__(21131);
// EXTERNAL MODULE: ../core-ui/dist/methods/object.js
var object = __webpack_require__(61282);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/constants/fonts.js
var fonts = __webpack_require__(12308);
// EXTERNAL MODULE: ../core-ui/dist/constants/theme.js
var theme = __webpack_require__(63298);
// EXTERNAL MODULE: ../core-ui/dist/constants/files.js
var files = __webpack_require__(65357);
// EXTERNAL MODULE: ../core-ui/dist/constants/color-variant.js
var color_variant = __webpack_require__(60603);
// EXTERNAL MODULE: ../core-ui/dist/constants/zIndexList.js
var zIndexList = __webpack_require__(94069);
;// CONCATENATED MODULE: ../core-ui/dist/methods/files.js







function getUrlExtension(url = "") {
    var _a, _b, _c, _d, _e;
    return (_e = (_d = (_c = (_b = (_a = url === null || url === void 0 ? void 0 : url.split(/[#?]/)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.split(".")) === null || _c === void 0 ? void 0 : _c.pop()) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : "";
}
function getFileCategory(url = "", file = null) {
    if (file instanceof File) {
        const extension = file === null || file === void 0 ? void 0 : file.type;
        switch (extension) {
            case files/* FileMimeCategories.JPG */._.JPG:
            case files/* FileMimeCategories.JPEG */._.JPEG:
            case files/* FileMimeCategories.PNG */._.PNG: {
                return "image";
            }
            case files/* FileMimeCategories.PDF */._.PDF: {
                return "pdf";
            }
        }
    }
    else if (!!url) {
        const extension = getUrlExtension(url === null || url === void 0 ? void 0 : url.toLowerCase());
        switch (extension) {
            case files/* FileCategories.JPG */.p.JPG:
            case files/* FileCategories.JPEG */.p.JPEG:
            case files/* FileCategories.PNG */.p.PNG: {
                return "image";
            }
            case files/* FileCategories.PDF */.p.PDF: {
                return "pdf";
            }
        }
    }
    return undefined;
}


//# sourceMappingURL=files.js.map

// EXTERNAL MODULE: ../core-ui/dist/methods/keyboardViewport.js
var keyboardViewport = __webpack_require__(69849);
;// CONCATENATED MODULE: ../core-ui/dist/methods/input.js


const triggerScrollOnInputFocus = (event, fit = {}) => {
    (0,keyboardViewport/* keepInKeyboardView */.uk)(event.target, fit);
};


//# sourceMappingURL=input.js.map

;// CONCATENATED MODULE: ../core-ui/dist/methods/random.js
/**
 * Generates a random number within the specified range.
 * @param min - The minimum value of the range (inclusive).
 * @param max - The maximum value of the range (inclusive).
 * @param isInteger - Whether the result should be an integer (default: true).
 * @returns A random number between min and max.
 */
function generateRandomNumber(min = 0, max = 1, isInteger = true) {
    const random = Math.random() * (max - min) + min;
    return isInteger ? Math.floor(random) : random;
}
const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function generateUUID(length = 12) {
    const array = crypto.getRandomValues(new Uint8Array(length));
    return Array.from(array, (byte) => CHARS[byte % CHARS.length]).join("");
}


//# sourceMappingURL=random.js.map

// EXTERNAL MODULE: ../core-ui/dist/methods/dom.js
var dom = __webpack_require__(97163);
;// CONCATENATED MODULE: ../core-ui/dist/methods/index.js



















//# sourceMappingURL=index.js.map


/***/ }),

/***/ 69849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ getSheetScrollRootProps; },
/* harmony export */   "Ih": function() { return /* binding */ resolveKeyboardMenuPlacement; },
/* harmony export */   "K7": function() { return /* binding */ onKeyboardSettle; },
/* harmony export */   "N_": function() { return /* binding */ getSelectMenuAttachConfig; },
/* harmony export */   "_k": function() { return /* binding */ scrollIntoKeyboardView; },
/* harmony export */   "e5": function() { return /* binding */ getKeyboardViewportClearance; },
/* harmony export */   "hP": function() { return /* binding */ needsKeyboardViewportCompensation; },
/* harmony export */   "lP": function() { return /* binding */ focusKeyboardAware; },
/* harmony export */   "uk": function() { return /* binding */ keepInKeyboardView; },
/* harmony export */   "zy": function() { return /* binding */ focusFormControl; }
/* harmony export */ });
/* unused harmony exports SHEET_SCROLL_ROOT_ATTR, SHEET_SCROLL_ROOT_SELECTOR, getKeyboardSettleMs, getKeyboardViewportRect, getKeyboardViewportSpace, observeKeyboardViewport, shouldPortalSelectMenuToBody */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29216);
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82238);



/**
 * Keyboard viewport compensation for browsers that do not resize/scroll correctly
 * when the soft keyboard opens (primarily iOS Safari inside locked-height sheets).
 *
 * Android Chrome resizes the viewport and scrolls focused inputs natively — every compose
 * helper below is a no-op there so we never fight the browser. That relies on the sheet's
 * viewport meta keeping `interactive-widget=resizes-content` (see methods/dom.ts); with
 * `overlays-content` nothing resizes and the native scroll silently stops happening.
 *
 * Layers: policy → measure → act → schedule → compose.
 */
// --- policy ------------------------------------------------------------------
/**
 * True only where the browser cannot keep focused fields / menus above the keyboard.
 * Gate all custom scroll + keyboard menu logic through this.
 */
function needsKeyboardViewportCompensation() {
    return (0,_browser_js__WEBPACK_IMPORTED_MODULE_0__/* .isIOSWebKit */ .B$)();
}
// --- sheet scroll root -------------------------------------------------------
/** Marks the scroll container inside a bottom sheet / modal body (nested scrollport). */
const SHEET_SCROLL_ROOT_ATTR = "data-sheet-scroll-root";
const SHEET_SCROLL_ROOT_SELECTOR = `[${SHEET_SCROLL_ROOT_ATTR}]`;
const POPUP_BODY_SELECTOR = "[data-popup-body]";
/** React props for a sheet/modal nested scroll root element. */
function getSheetScrollRootProps() {
    return { [SHEET_SCROLL_ROOT_ATTR]: "" };
}
// --- iOS clearance / timing --------------------------------------------------
/** Gap between focused field bottom and keyboard top (iOS only). */
const FIELD_CLEARANCE_PX = 8;
const MENU_MIN_SPACE_PX = 120;
const OBSERVE_MS = 900;
const OBSERVE_DEBOUNCE_MS = 100;
const SETTLE_MS = 300;
function getKeyboardViewportClearance(extraPx = 0) {
    return FIELD_CLEARANCE_PX + extraPx;
}
function resolveClearance(clearance) {
    return clearance !== null && clearance !== void 0 ? clearance : getKeyboardViewportClearance();
}
/** Visible area above the keyboard, in layout-viewport coordinates. */
function getKeyboardViewportRect() {
    const viewport = typeof window === "undefined" ? null : window.visualViewport;
    if (!viewport) {
        const height = typeof window === "undefined" ? 0 : window.innerHeight;
        return { top: 0, bottom: height, height };
    }
    return {
        top: viewport.offsetTop,
        bottom: viewport.offsetTop + viewport.height,
        height: viewport.height
    };
}
function getKeyboardViewportSpace(element, clearance) {
    const inset = resolveClearance(clearance);
    const rect = element.getBoundingClientRect();
    const view = getKeyboardViewportRect();
    return {
        above: Math.max(0, rect.top - (view.top + inset)),
        below: Math.max(0, view.bottom - inset - rect.bottom),
        gap: view.bottom - rect.bottom
    };
}
function getKeyboardScrollContainer(element) {
    const scrollRoot = element.closest(SHEET_SCROLL_ROOT_SELECTOR);
    if (scrollRoot instanceof HTMLElement) {
        return scrollRoot;
    }
    const popupBody = element.closest(POPUP_BODY_SELECTOR);
    if (popupBody instanceof HTMLElement) {
        return popupBody;
    }
    return null;
}
/** Smallest scroll that brings the element fully inside the visible area. */
function getKeyboardScrollDelta(element, clearance) {
    const rect = element.getBoundingClientRect();
    const view = getKeyboardViewportRect();
    if (rect.bottom > view.bottom - clearance) {
        return rect.bottom - (view.bottom - clearance);
    }
    if (rect.top < view.top + clearance) {
        return rect.top - (view.top + clearance);
    }
    return 0;
}
// --- act ---------------------------------------------------------------------
/**
 * Single, minimal scroll pass — no-ops when the element already clears the keyboard,
 * and no-ops entirely when the browser handles the keyboard natively (Android).
 */
function scrollIntoKeyboardView(element, { clearance } = {}) {
    if (!needsKeyboardViewportCompensation()) {
        return;
    }
    const delta = getKeyboardScrollDelta(element, resolveClearance(clearance));
    if (Math.abs(delta) < 1) {
        return;
    }
    const container = getKeyboardScrollContainer(element);
    if (container) {
        container.scrollTop += delta;
        return;
    }
    window.scrollBy({ top: delta, behavior: "auto" });
}
/**
 * Picks dropdown side from space in the visible viewport.
 * react-select `auto` measures the layout viewport — wrong inside locked-height sheets.
 */
function resolveKeyboardMenuPlacement(element, { maxHeight, minSpace = MENU_MIN_SPACE_PX, clearance }) {
    const { above, below } = getKeyboardViewportSpace(element, clearance);
    const required = Math.min(maxHeight, minSpace);
    if (below >= required) {
        return "bottom";
    }
    if (above >= required) {
        return "top";
    }
    return below >= above ? "bottom" : "top";
}
/**
 * Body-portaled `position: fixed` menus drift on iOS when the keyboard scrolls the
 * control. Prefer absolute attach there; Android portals are fine.
 */
function shouldPortalSelectMenuToBody() {
    return !needsKeyboardViewportCompensation();
}
/** Resolves react-select menu attach props from a portal preference. */
function getSelectMenuAttachConfig(preferPortalToBody) {
    if (preferPortalToBody && shouldPortalSelectMenuToBody()) {
        return {
            menuPosition: "fixed",
            menuPortalTarget: typeof document === "undefined" ? undefined : document.body
        };
    }
    return { menuPosition: "absolute" };
}
/** Debounced `visualViewport` listener that expires on its own. Returns an unsubscribe. */
function observeKeyboardViewport(onChange, { durationMs = OBSERVE_MS, debounceMs = OBSERVE_DEBOUNCE_MS } = {}) {
    const viewport = typeof window === "undefined" ? null : window.visualViewport;
    if (!viewport) {
        return () => { };
    }
    let debounceId = null;
    let expiryId = null;
    const stop = () => {
        if (debounceId !== null) {
            window.clearTimeout(debounceId);
            debounceId = null;
        }
        if (expiryId !== null) {
            window.clearTimeout(expiryId);
            expiryId = null;
        }
        viewport.removeEventListener("resize", handleChange);
        viewport.removeEventListener("scroll", handleChange);
    };
    function handleChange() {
        if (debounceId !== null) {
            window.clearTimeout(debounceId);
        }
        debounceId = window.setTimeout(onChange, debounceMs);
    }
    viewport.addEventListener("resize", handleChange);
    viewport.addEventListener("scroll", handleChange);
    expiryId = window.setTimeout(stop, durationMs);
    return stop;
}
/** Keyboard animation duration — measuring before this returns pre-keyboard geometry. */
function getKeyboardSettleMs() {
    return SETTLE_MS;
}
/**
 * Runs `apply` once the keyboard has settled, then again on each viewport change
 * until it stops moving. No-ops when compensation is not needed. `apply` must be idempotent.
 */
function onKeyboardSettle(apply, { settleMs = getKeyboardSettleMs(), observeMs } = {}) {
    if (!needsKeyboardViewportCompensation()) {
        return () => { };
    }
    const settleId = window.setTimeout(apply, settleMs);
    const stopObserving = observeKeyboardViewport(apply, {
        durationMs: observeMs
    });
    return () => {
        window.clearTimeout(settleId);
        stopObserving();
    };
}
// --- compose -----------------------------------------------------------------
/**
 * Newest pass wins. Only one element holds focus at a time, so only one pass is ever
 * relevant, and callers wire this to focus events and drop the disposer. Without this,
 * moving between fields — every digit of an OTP row — leaves the previous pass running
 * with its own visualViewport listeners, and they scroll against each other.
 */
let disposeActiveKeyboardPass = null;
/** Keeps a focused element above the keyboard. No-op on Android (native handles it). */
function keepInKeyboardView(element, _a = {}) {
    var { clearance } = _a, settle = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["clearance"]);
    if (!needsKeyboardViewportCompensation()) {
        return () => { };
    }
    disposeActiveKeyboardPass === null || disposeActiveKeyboardPass === void 0 ? void 0 : disposeActiveKeyboardPass();
    const stopSettling = onKeyboardSettle(() => scrollIntoKeyboardView(element, { clearance }), settle);
    const dispose = () => {
        stopSettling();
        if (disposeActiveKeyboardPass === dispose) {
            disposeActiveKeyboardPass = null;
        }
    };
    disposeActiveKeyboardPass = dispose;
    return dispose;
}
function resolveFocusTarget(candidateIds) {
    for (const id of candidateIds) {
        const element = document.getElementById(id);
        if (!element) {
            continue;
        }
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            return element;
        }
        const nestedInput = element.querySelector('input:not([type="hidden"])');
        if (nestedInput) {
            return nestedInput;
        }
    }
    return null;
}
/**
 * Focuses an element without letting the browser's scroll-into-view fight ours.
 * Native scroll is suppressed only where it is known to be wrong (iOS); elsewhere it runs
 * first and our settled pass corrects it only if the keyboard still covers the field.
 */
function focusKeyboardAware(element, { scrollIntoView = false, clearance } = {}) {
    element.focus({
        preventScroll: scrollIntoView && needsKeyboardViewportCompensation()
    });
    if (scrollIntoView) {
        keepInKeyboardView(element, { clearance });
    }
}
/** Focuses the first resolvable control by id, then keeps it above the keyboard. */
function focusFormControl({ candidateIds, delay = 0, scrollIntoView = false, clearance, maxRetries = needsKeyboardViewportCompensation() ? 2 : 1, retryIntervalMs = 120 }) {
    const attemptFocus = (attempt = 0) => {
        const focusTarget = resolveFocusTarget(candidateIds);
        if (!focusTarget) {
            if (attempt < maxRetries) {
                window.setTimeout(() => attemptFocus(attempt + 1), retryIntervalMs);
            }
            return;
        }
        focusKeyboardAware(focusTarget, { scrollIntoView, clearance });
    };
    if (delay > 0) {
        window.setTimeout(attemptFocus, delay);
        return;
    }
    requestAnimationFrame(attemptFocus);
}


//# sourceMappingURL=keyboardViewport.js.map


/***/ }),

/***/ 61282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tw": function() { return /* binding */ updateObjIf; },
/* harmony export */   "_n": function() { return /* binding */ filteredObjValues; },
/* harmony export */   "lX": function() { return /* binding */ generateObjectFromKeys; }
/* harmony export */ });
/* unused harmony exports filterFalseObjValues, getEnumKeyByEnumValue, getKeyByValue, mergeKeyValue, transformObjectValues */
const updateObjIf = (condition, value) => {
    return condition ? value : {};
};
const filteredObjValues = (obj) => {
    const final = {};
    for (const [key, value] of Object.entries(obj)) {
        const isEmptyArray = Array.isArray(value) && value.length === 0;
        if (value !== undefined && value !== Number.NaN && !isEmptyArray) {
            final[key] = value;
        }
    }
    return final;
};
const filterFalseObjValues = (obj) => {
    const final = {};
    for (const [key, value] of Object.entries(obj)) {
        if (!!value) {
            final[key] = value;
        }
    }
    return final;
};
function getKeyByValue(keyValuePairs, value) {
    return Object.keys(keyValuePairs).find((key) => keyValuePairs[key] === value);
}
function transformObjectValues(object, type) {
    const transformedObj = {};
    for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            const value = object[key];
            if (type === Date) {
                transformedObj[key] = new type(object[key]);
            }
            else if (type === Boolean) {
                transformedObj[key] =
                    value === "true"
                        ? true
                        : value === "false"
                            ? false
                            : undefined;
            }
            else {
                transformedObj[key] = type(value);
            }
        }
    }
    return transformedObj;
}
function getEnumKeyByEnumValue(enumObj, enumValue) {
    return Object.keys(enumObj).find((key) => enumObj[key] === enumValue);
}
function generateObjectFromKeys(keys) {
    return keys.reduce((obj, key) => {
        obj[key] = key;
        return obj;
    }, {});
}
function mergeKeyValue(obj, keyValSepator = " : ", options) {
    return Object.entries(obj)
        .filter(([, v]) => {
        if ((options === null || options === void 0 ? void 0 : options.skipNull) && (v === null || v === undefined))
            return false;
        if ((options === null || options === void 0 ? void 0 : options.skipEmpty) && v === "")
            return false;
        if ((options === null || options === void 0 ? void 0 : options.skipZero) && v === 0)
            return false;
        return true;
    })
        .map(([k, v]) => `${k}${keyValSepator}${v}`);
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 75905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$M": function() { return /* binding */ stringOperations; },
/* harmony export */   "Tc": function() { return /* binding */ removeNonAlphaNumeric; },
/* harmony export */   "Un": function() { return /* binding */ extractPhoneNumber; },
/* harmony export */   "aT": function() { return /* binding */ getDotSeparatedStringFromStringArray; },
/* harmony export */   "bI": function() { return /* binding */ removeNonNumeric; },
/* harmony export */   "p3": function() { return /* binding */ formattedPhoneNumber; },
/* harmony export */   "rR": function() { return /* binding */ compareString; },
/* harmony export */   "yy": function() { return /* binding */ extractDigits; }
/* harmony export */ });
/* unused harmony export camelCaseToSentenceCase */
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);
/* harmony import */ var _constants_theme_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63298);
/* harmony import */ var _constants_files_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65357);
/* harmony import */ var _constants_symbol_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40423);
/* harmony import */ var _constants_color_variant_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60603);
/* harmony import */ var _constants_zIndexList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94069);








const camelCaseToSentenceCase = (camelCase) => {
    if (camelCase) {
        let result = camelCase // "__ToGetYourGEDInTimeASongAboutThe26ABCsIsOfTheEssenceButAPersonalIDCardForUser_456InRoom26AContainingABC26TimesIsNotAsEasyAs123ForC3POOrR2D2Or2R2D"
            .replace(/(_)+/g, " ") // " ToGetYourGEDInTimeASongAboutThe26ABCsIsOfTheEssenceButAPersonalIDCardForUser 456InRoom26AContainingABC26TimesIsNotAsEasyAs123ForC3POOrR2D2Or2R2D"
            .replace(/([a-z])([A-Z][a-z])/g, "$1 $2") // " To Get YourGEDIn TimeASong About The26ABCs IsOf The Essence ButAPersonalIDCard For User456In Room26AContainingABC26Times IsNot AsEasy As123ForC3POOrR2D2Or2R2D"
            .replace(/([A-Z][a-z])([A-Z])/g, "$1 $2") // " To Get YourGEDIn TimeASong About The26ABCs Is Of The Essence ButAPersonalIDCard For User456In Room26AContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
            .replace(/([a-z])([A-Z]+[a-z])/g, "$1 $2") // " To Get Your GEDIn Time ASong About The26ABCs Is Of The Essence But APersonal IDCard For User456In Room26AContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
            .replace(/([A-Z]+)([A-Z][a-z][a-z])/g, "$1 $2") // " To Get Your GEDIn Time A Song About The26ABCs Is Of The Essence But A Personal ID Card For User456In Room26A ContainingABC26Times Is Not As Easy As123ForC3POOr R2D2Or2R2D"
            .replace(/([a-z]+)([A-Z0-9]+)/g, "$1 $2") // " To Get Your GEDIn Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC26Times Is Not As Easy As 123For C3POOr R2D2Or 2R2D"
            // Note: the next regex includes a special case to exclude plurals of acronyms, e.g. "ABCs"
            .replace(/([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, "$1 $2") // " To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC26Times Is Not As Easy As 123For C3PO Or R2D2Or 2R2D"
            .replace(/([0-9])([A-Z][a-z]+)/g, "$1 $2") // " To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456In Room 26A Containing ABC 26Times Is Not As Easy As 123For C3PO Or R2D2Or 2R2D"
            // Note: the next two regexes use {2,} instead of + to add space on phrases like Room26A and 26ABCs but not on phrases like R2D2 and C3PO"
            .replace(/([A-Z]{2,})([0-9]{2,})/g, "$1 $2") // " To Get Your GED In Time A Song About The 26ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
            .replace(/([0-9]{2,})([A-Z]{2,})/g, "$1 $2") // " To Get Your GED In Time A Song About The 26 ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
            .trim(); // "To Get Your GED In Time A Song About The 26 ABCs Is Of The Essence But A Personal ID Card For User 456 In Room 26A Containing ABC 26 Times Is Not As Easy As 123 For C3PO Or R2D2 Or 2R2D"
        // capitalize the first letter
        return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return "";
};
const removeNonAlphaNumeric = (str = "") => {
    return str.replace(/[^a-z0-9]/gi, "");
};
const removeNonNumeric = (str = "") => {
    return str.replace(/[^0-9]/g, "");
};
const extractDigits = (str = "") => str.replace(/\D+/g, "");
function compareString(str1, str2) {
    return (str1 === null || str1 === void 0 ? void 0 : str1.toLowerCase()) === (str2 === null || str2 === void 0 ? void 0 : str2.toLocaleLowerCase());
}
const stringOperations = (inputString, operations) => {
    let result = inputString !== null && inputString !== void 0 ? inputString : "";
    if (operations.includes("trim")) {
        result = result.trim();
    }
    if (operations.includes("toUpperCase")) {
        result = result.toUpperCase();
    }
    if (operations.includes("toLowerCase")) {
        result = result.toLowerCase();
    }
    if (operations.includes("replaceWhitespace")) {
        result = result.replace(/\s+/g, "");
    }
    if (operations.includes("replaceSpacesWithUnderscore")) {
        result = result.replace(/\s+/g, "_");
    }
    if (operations.includes("replaceUnderscoreWithSpace")) {
        result = result.replace(/_+/g, " ");
    }
    if (operations.includes("capitalizeEachWord")) {
        result = result
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    }
    if (operations.includes("removeNonAlphaNumeric")) {
        result = result.replace(/[^a-zA-Z0-9\s]/g, "");
    }
    if (operations.includes("removeNonNumeric")) {
        result = result.replace(/[^0-9]/g, "");
    }
    if (operations.includes("removeLeadingZero")) {
        result = result.replace(/^0+/, "");
    }
    if (operations.includes("removeSpecialCharacters")) {
        result = result.replace(/[^a-zA-Z ]/g, "");
    }
    const truncateOperation = operations.find((op) => op.startsWith("truncate:"));
    if (truncateOperation) {
        const maxLength = parseInt(truncateOperation.split(":")[1], 10);
        result =
            result.length > maxLength ? result.slice(0, maxLength) : result;
    }
    return result;
};
const getDotSeparatedStringFromStringArray = (arr) => {
    return arr.filter((v) => !!v).join(` ${_constants_symbol_js__WEBPACK_IMPORTED_MODULE_6__/* .DotSymbol */ .u} `);
};
const extractPhoneNumber = (input = "") => {
    if (typeof input === "string") {
        let digits = input.replace(/\D/g, ""); // Remove non-digits
        if (digits.length > 10) {
            digits = digits.slice(-10);
        }
        digits = digits.replace(/^0+/, ""); // Remove leading zeros
        if (digits.length === 10) {
            return digits;
        }
    }
    return "";
};
const formattedPhoneNumber = (input = "", format = "+91-") => {
    const result = extractPhoneNumber(input);
    return result ? format + result : "";
};


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 72:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ isSameDate; },
/* harmony export */   "Y9": function() { return /* binding */ getFilterTimeString; },
/* harmony export */   "cm": function() { return /* binding */ getEndingTimeOfDate; },
/* harmony export */   "lR": function() { return /* binding */ toUnixTimeStamp; },
/* harmony export */   "m": function() { return /* binding */ milliseconds; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "pC": function() { return /* binding */ calculateDateDifferenceUnits; },
/* harmony export */   "qF": function() { return /* binding */ getRelativeTimeString; },
/* harmony export */   "vo": function() { return /* binding */ getFilterMinMaxString; },
/* harmony export */   "w0": function() { return /* binding */ toValidDate; },
/* harmony export */   "zJ": function() { return /* binding */ addDaysOnDate; }
/* harmony export */ });
/* unused harmony exports CommonDateRange, CommonDateTime, formatDateDifferenceSelectedUnits, getStartingTimeOfDate, mergeTimeUnits, toValidUnixTimeStamp */
const toUnixTimeStamp = (date) => Math.round(date.valueOf() / 1000);
const toValidUnixTimeStamp = (date) => {
    return date ? Math.round(date.valueOf() / 1000) : undefined;
};
const addDaysOnDate = (currentDate = new Date(), daysToAdd = 1, hoursToAdd = 0, minsToAdd = 0, secsToAdd = 0) => {
    const nextDay = new Date(currentDate);
    nextDay.setDate(nextDay.getDate() + daysToAdd);
    if (hoursToAdd) {
        nextDay.setHours(nextDay.getHours() + hoursToAdd);
    }
    if (minsToAdd) {
        nextDay.setMinutes(nextDay.getMinutes() + minsToAdd);
    }
    if (secsToAdd) {
        nextDay.setSeconds(nextDay.getSeconds() + secsToAdd);
    }
    return nextDay;
};
const isSameDate = (date1, date2) => {
    return date1.getTime() === date2.getTime();
};
const getStartingTimeOfDate = (date) => {
    const dt = new Date(date);
    dt.setHours(0, 0, 0, 0);
    return dt;
};
const getEndingTimeOfDate = (date) => {
    const dt = new Date(date);
    dt.setHours(23, 59, 59, 999);
    return dt;
};
/**
 * Formats a date string according to the provided format.
 * @param {string} inputDate - The input date string to be formatted.
 * @param {string} format - The custom format specifying how the date should be formatted.
 * @returns {string} The formatted date string.
 */
const formatDate = (inputDate, format, fallback) => {
    /**
     * (2023-09-16,DD/MM/YYYY)=> 16/09/2023
     * (2022-03-05,MMMM DD, YYYY)=> March 05, 2022
     * (2021-12-25,"YYYY [is the year] MM [is the month] DD [is the day]")=> '2021 is the year 12 is the month 25 is the day'
     * ("2021-12-25T18:45:30.500Z","YYYY-MM-DD hh:mm:ss.SSS")=> 2021-12-25 18:45:30.500
     */
    // Parse the input date using JavaScript's Date object
    let date = undefined;
    if (typeof inputDate === "string" || typeof inputDate === "number") {
        date = new Date(inputDate);
    }
    if (inputDate instanceof Date) {
        date = inputDate;
    }
    // Check if the input date is valid
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return fallback !== null && fallback !== void 0 ? fallback : "Invalid Date";
    }
    const hours24 = date.getHours();
    const hours12 = hours24 % 12 || 12;
    const amOrPm = hours24 >= 12 ? "PM" : "AM";
    // Create a dictionary to replace format placeholders
    const formatOptions = {
        YYYY: date.getFullYear(),
        YY: date.getFullYear().toString().slice(-2),
        MMMM: new Intl.DateTimeFormat("en-US", { month: "long" }).format(date),
        MMM: new Intl.DateTimeFormat("en-US", { month: "short" }).format(date),
        MM: String(date.getMonth() + 1).padStart(2, "0"),
        M: String(date.getMonth() + 1),
        DDDD: new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date),
        DDD: new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date),
        DD: String(date.getDate()).padStart(2, "0"),
        D: String(date.getDate()),
        hh: String(hours12).padStart(2, "0"),
        h: String(hours12),
        hh24: String(hours24).padStart(2, "0"),
        h24: String(hours24),
        mm: String(date.getMinutes()).padStart(2, "0"),
        m: String(date.getMinutes()),
        ss: String(date.getSeconds()).padStart(2, "0"),
        s: String(date.getSeconds()),
        SSS: String(date.getMilliseconds()).padStart(3, "0"),
        S: String(date.getMilliseconds()).slice(0, 1),
        a: amOrPm,
        z: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    // Update the regular expression pattern to match placeholders as exact words
    const pattern = new RegExp("\\b(?:" + Object.keys(formatOptions).join("|") + ")\\b", "g");
    const formattedDate = format.replace(pattern, (match) => formatOptions[match]);
    return formattedDate;
};
function milliseconds(days = 0, hours = 0, minutes = 0, seconds = 0) {
    const totalSeconds = (days * 24 + hours) * 3600 + minutes * 60 + seconds;
    const milliseconds = totalSeconds * 1000;
    return milliseconds;
}
function getRelativeTimeString(date, units) {
    const timeUnitsInMs = Object.assign({ year: milliseconds(365), day: milliseconds(1), hour: milliseconds(0, 1), minute: milliseconds(0, 0, 1), second: milliseconds(0, 0, 0, 60) }, units);
    const rtf = new Intl.RelativeTimeFormat("en", { style: "narrow" });
    const timeMs = typeof date === "number" ? date : date.getTime();
    if (isNaN(timeMs)) {
        return "";
    }
    const delta = timeMs - Date.now();
    for (const [unit, amount] of Object.entries(timeUnitsInMs)) {
        if (Math.abs(delta) > amount) {
            return rtf.format(Math.round(delta / amount), unit);
        }
    }
    return "Just Now";
}
const getFilterTimeString = (start, end) => {
    if (start || end) {
        const f = {};
        if (start) {
            f["min"] = toUnixTimeStamp(start);
        }
        if (end) {
            f["max"] = toUnixTimeStamp(end);
        }
        return JSON.stringify(f);
    }
    return undefined;
};
const getFilterMinMaxString = (start, end) => {
    if (start || end) {
        const f = {};
        if (start) {
            f["min"] = toUnixTimeStamp(getStartingTimeOfDate(start));
        }
        if (end) {
            f["max"] = toUnixTimeStamp(getEndingTimeOfDate(end));
        }
        return JSON.stringify(f);
    }
    return undefined;
};
const offsetDate = (offsetDays) => addDaysOnDate(new Date(), offsetDays);
const offsetMonth = (offsetMonths) => {
    const dt = new Date();
    dt.setMonth(dt.getMonth() + offsetMonths);
    return dt;
};
const CommonDateTime = {
    yesterday: {
        min: () => getStartingTimeOfDate(addDaysOnDate(new Date(), -1)),
        max: () => getEndingTimeOfDate(addDaysOnDate(new Date(), -1)),
    },
    today: {
        min: () => getStartingTimeOfDate(new Date()),
        max: () => getEndingTimeOfDate(new Date()),
    },
    tomorrow: {
        min: () => getStartingTimeOfDate(addDaysOnDate(new Date(), 1)),
        max: () => getEndingTimeOfDate(addDaysOnDate(new Date(), 1)),
    },
    nthDate: {
        min: (n) => getStartingTimeOfDate(offsetDate(-n)),
        max: (n) => getEndingTimeOfDate(offsetDate(-n)),
    },
    nthMonth: {
        min: (n) => getStartingTimeOfDate(offsetMonth(-n)),
        max: (n) => getEndingTimeOfDate(offsetMonth(-n)),
    },
};
const CommonDateRange = {
    last7Days: {
        min: () => getStartingTimeOfDate(addDaysOnDate(new Date(), -7)),
        max: () => getEndingTimeOfDate(new Date()),
    },
    lastMonth: {
        min: () => getStartingTimeOfDate(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)),
        max: () => getEndingTimeOfDate(new Date(new Date().getFullYear(), new Date().getMonth(), 0)),
    },
    currentMonth: {
        min: () => getStartingTimeOfDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        max: () => getEndingTimeOfDate(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)),
    },
};
function toValidDate(input, fallback = undefined) {
    if (!input)
        return fallback;
    const date = new Date(input);
    return isNaN(date.getTime()) ? fallback : date;
}
function calculateDateDifferenceUnits(date1, date2, units = ["days", "hours", "mins", "secs"]) {
    let diffInMs = Math.abs(date1.getTime() - date2.getTime());
    const unitValues = {
        days: 0,
        hours: 0,
        mins: 0,
        secs: 0,
        milliseconds: 0,
    };
    if (units.includes("days")) {
        unitValues.days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        diffInMs -= unitValues.days * (1000 * 60 * 60 * 24);
    }
    if (units.includes("hours")) {
        unitValues.hours = Math.floor(diffInMs / (1000 * 60 * 60));
        diffInMs -= unitValues.hours * (1000 * 60 * 60);
    }
    if (units.includes("mins")) {
        unitValues.mins = Math.floor(diffInMs / (1000 * 60));
        diffInMs -= unitValues.mins * (1000 * 60);
    }
    if (units.includes("secs")) {
        unitValues.secs = Math.floor(diffInMs / 1000);
        diffInMs -= unitValues.secs * 1000;
    }
    if (units.includes("milliseconds")) {
        unitValues.milliseconds = diffInMs;
    }
    return unitValues;
}
function formatDateDifferenceSelectedUnits(date1, date2, units = ["days", "hours", "mins", "secs"]) {
    const unitValues = calculateDateDifferenceUnits(date1, date2, units);
    return mergeTimeUnits(unitValues, units);
}
const mergeTimeUnits = (record, units = ["days", "hours", "mins", "secs"]) => {
    const parts = [];
    for (const unit of units) {
        const value = record[unit];
        if (value > 0) {
            parts.push(`${value} ${unit.slice(0, -1)}${value > 1 ? "s" : ""}`);
        }
    }
    return parts.length ? parts.join(" ") : "";
};


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 99624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RL": function() { return /* binding */ getViewportSheetContainerStyle; },
/* harmony export */   "Tm": function() { return /* binding */ VIEWPORT_KEYBOARD_INSET_CSS; },
/* harmony export */   "Tx": function() { return /* binding */ syncViewportHeightNow; },
/* harmony export */   "XQ": function() { return /* binding */ usesViewportSheetLayout; },
/* harmony export */   "iu": function() { return /* binding */ waitForInputFocusZoomReset; },
/* harmony export */   "oI": function() { return /* binding */ VIEWPORT_OFFSET_TOP_CSS; },
/* harmony export */   "qc": function() { return /* binding */ syncVisualViewportHeightVar; }
/* harmony export */ });
/* unused harmony exports VIEWPORT_HEIGHT_FULL_CSS, getVisualViewportHeight, isPageInputFocusZoomActive */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82238);


/** CSS var synced from visualViewport while a mobile sheet is open (see syncViewportHeightNow). */
const VIEWPORT_HEIGHT_FULL_CSS = "var(--viewport-height-full, 100dvh)";
const VIEWPORT_OFFSET_TOP_CSS = "var(--viewport-offset-top, 0px)";
/** Gap the keyboard leaves at the bottom of the layout viewport (see measureKeyboardInset). */
const VIEWPORT_KEYBOARD_INSET_CSS = "var(--viewport-keyboard-inset, 0px)";
const SWIPEABLE_SHEET_OPEN_SELECTOR = ".ReactSwipeableBottomSheet--open";
const VIEWPORT_HEIGHT_CSS_VARS = ["--viewport-height-full", "--viewport-height-p95", "--viewport-height-p90"];
const VIEWPORT_OFFSET_TOP_VAR = "--viewport-offset-top";
const VIEWPORT_KEYBOARD_INSET_VAR = "--viewport-keyboard-inset";
/**
 * Shrink beyond which a viewport change is treated as the soft keyboard rather than
 * browser chrome or zoom, and the sheet is allowed to follow it down.
 *
 * ponytail: naive threshold — keyboards are ~250-350px, URL bars ~50-90px, so anything in
 * between is guesswork. Upgrade to `navigator.virtualKeyboard` (VirtualKeyboard API) once
 * Safari ships it and the geometry can be read directly instead of inferred.
 */
const KEYBOARD_MIN_INSET_PX = 120;
let sheetViewportSession = null;
let lastAppliedViewportHeight = 0;
let lastAppliedViewportOffsetTop = 0;
let lastAppliedKeyboardInset = -1;
let wasInputFocusZoomActive = false;
const getVisualViewportScale = () => {
    const vv = window.visualViewport;
    if (!vv) {
        return 1;
    }
    if (typeof vv.scale === "number" && vv.scale > 0) {
        return vv.scale;
    }
    return 1;
};
/** iOS Safari input-focus zoom — not URL-bar shrink (scale stays 1 there). */
const isPageInputFocusZoomActive = () => {
    if (typeof window === "undefined") {
        return false;
    }
    return getVisualViewportScale() > 1.01;
};
const isInputFocusZoomActive = isPageInputFocusZoomActive;
const measureViewportCandidate = () => {
    var _a;
    if (typeof window === "undefined") {
        return 0;
    }
    const vv = window.visualViewport;
    // Input-focus zoom shrinks visualViewport.height; innerHeight stays at layout size.
    // Locking the zoomed vv height crops the sheet after zoom resets (homepage → CTA).
    if (vv && isInputFocusZoomActive()) {
        return Math.round(window.innerHeight);
    }
    // Visible layout height — avoids sheet extending under the mobile browser top bar.
    return Math.round((_a = vv === null || vv === void 0 ? void 0 : vv.height) !== null && _a !== void 0 ? _a : window.innerHeight);
};
const measureViewportOffsetTop = () => {
    var _a, _b;
    if (typeof window === "undefined") {
        return 0;
    }
    if (isInputFocusZoomActive()) {
        return 0;
    }
    // Body scroll-lock uses position:fixed — offsetTop reflects page scroll, not sheet position.
    if (document.body.style.position === "fixed") {
        return 0;
    }
    return Math.round((_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0);
};
/** Read the visible viewport height (visualViewport on iOS, innerHeight fallback). */
const getVisualViewportHeight = () => {
    return measureViewportCandidate();
};
const resolveSheetSyncHeight = () => {
    const candidate = measureViewportCandidate();
    const zoomActive = isInputFocusZoomActive();
    if (!sheetViewportSession) {
        wasInputFocusZoomActive = zoomActive;
        return candidate;
    }
    // Re-lock when iOS input-focus zoom resets so a zoomed-small height cannot persist.
    if (wasInputFocusZoomActive && !zoomActive) {
        sheetViewportSession.lockedHeight = candidate;
    }
    else if (candidate > sheetViewportSession.lockedHeight) {
        sheetViewportSession.lockedHeight = candidate;
    }
    else if (sheetViewportSession.lockedHeight - candidate >= KEYBOARD_MIN_INSET_PX) {
        // A drop this large is the soft keyboard. The sheet has to follow it down, otherwise
        // the sticky footer stays pinned to the bottom of a full-height panel, under the keyboard.
        sheetViewportSession.lockedHeight = candidate;
    }
    wasInputFocusZoomActive = zoomActive;
    return sheetViewportSession.lockedHeight;
};
const beginSheetViewportSession = () => {
    sheetViewportSession = { lockedHeight: measureViewportCandidate() };
};
const endSheetViewportSession = () => {
    sheetViewportSession = null;
    lastAppliedViewportHeight = 0;
    lastAppliedViewportOffsetTop = 0;
    lastAppliedKeyboardInset = -1;
    wasInputFocusZoomActive = false;
};
const setViewportHeightCssVars = (height) => {
    const root = document.documentElement;
    root.style.setProperty("--viewport-height-full", `${height}px`);
    root.style.setProperty("--viewport-height-p95", `${Math.round(height * 0.95)}px`);
    root.style.setProperty("--viewport-height-p90", `${Math.round(height * 0.9)}px`);
};
const clearViewportHeightCssVars = () => {
    const root = document.documentElement;
    VIEWPORT_HEIGHT_CSS_VARS.forEach((name) => {
        root.style.removeProperty(name);
    });
    root.style.removeProperty(VIEWPORT_OFFSET_TOP_VAR);
    root.style.removeProperty(VIEWPORT_KEYBOARD_INSET_VAR);
};
const syncSwipeableSheetDomHeight = (height) => {
    document.querySelectorAll(SWIPEABLE_SHEET_OPEN_SELECTOR).forEach((node) => {
        if (!(node instanceof HTMLElement)) {
            return;
        }
        node.style.height = `${height}px`;
        node.style.maxHeight = `${height}px`;
    });
};
const clearSwipeableSheetDomHeight = () => {
    document.querySelectorAll(SWIPEABLE_SHEET_OPEN_SELECTOR).forEach((node) => {
        if (!(node instanceof HTMLElement)) {
            return;
        }
        node.style.removeProperty("height");
        node.style.removeProperty("maxHeight");
    });
};
/**
 * Bottom gap the keyboard occupies in the layout viewport.
 *
 * Browsers honouring `interactive-widget=resizes-content` shrink `innerHeight` with the
 * keyboard and report 0 here. iOS Safari ignores that token and only shrinks the visual
 * viewport, so a bottom-anchored sheet needs the gap spelled out to stay above the keyboard.
 */
const measureKeyboardInset = (height, offsetTop) => Math.max(0, Math.round(window.innerHeight - height - offsetTop));
const applySheetViewportGeometry = () => {
    const height = resolveSheetSyncHeight();
    const offsetTop = measureViewportOffsetTop();
    const keyboardInset = measureKeyboardInset(height, offsetTop);
    const heightChanged = height !== lastAppliedViewportHeight;
    const offsetChanged = offsetTop !== lastAppliedViewportOffsetTop;
    const keyboardInsetChanged = keyboardInset !== lastAppliedKeyboardInset;
    if (!heightChanged && !offsetChanged && !keyboardInsetChanged) {
        return;
    }
    if (keyboardInsetChanged) {
        lastAppliedKeyboardInset = keyboardInset;
        document.documentElement.style.setProperty(VIEWPORT_KEYBOARD_INSET_VAR, `${keyboardInset}px`);
    }
    if (heightChanged) {
        lastAppliedViewportHeight = height;
        setViewportHeightCssVars(height);
        syncSwipeableSheetDomHeight(height);
        window.dispatchEvent(new Event("resize"));
    }
    if (offsetChanged) {
        lastAppliedViewportOffsetTop = offsetTop;
        document.documentElement.style.setProperty(VIEWPORT_OFFSET_TOP_VAR, `${offsetTop}px`);
    }
};
/**
 * Push viewport height into CSS vars, react-swipeable-bottom-sheet inline styles,
 * and a synthetic window resize (library HeightUpdater only listens to resize).
 */
const syncViewportHeightNow = () => {
    if (typeof document === "undefined" || typeof window === "undefined") {
        return 0;
    }
    const height = resolveSheetSyncHeight();
    applySheetViewportGeometry();
    return height;
};
const delayMs = (ms) => new Promise((resolve) => {
    window.setTimeout(resolve, ms);
});
/**
 * On iOS Safari, wait for input-focus zoom to reset after blurring fields.
 * Use before opening a full-viewport bottom sheet from a page-level form.
 */
const waitForInputFocusZoomReset = (options = {}) => {
    if (typeof window === "undefined" || !(0,_browser_js__WEBPACK_IMPORTED_MODULE_0__/* .isIOSWebKit */ .B$)()) {
        return Promise.resolve();
    }
    const { timeoutMs = 900, minWaitMs = 320, pollIntervalMs = 40, stableSamplesRequired = 2 } = options;
    const startedAt = Date.now();
    const finishAfterMinWait = () => {
        const remaining = Math.max(0, minWaitMs - (Date.now() - startedAt));
        return remaining > 0 ? delayMs(remaining) : Promise.resolve();
    };
    if (!isInputFocusZoomActive()) {
        return finishAfterMinWait();
    }
    return new Promise((resolve) => {
        let settled = false;
        let stableSamples = 0;
        let pollId = 0;
        let timeoutId = 0;
        const vv = window.visualViewport;
        const cleanup = () => {
            window.clearInterval(pollId);
            window.clearTimeout(timeoutId);
            vv === null || vv === void 0 ? void 0 : vv.removeEventListener("resize", onViewportChange);
            vv === null || vv === void 0 ? void 0 : vv.removeEventListener("scroll", onViewportChange);
        };
        const finish = () => {
            if (settled) {
                return;
            }
            settled = true;
            cleanup();
            void finishAfterMinWait().then(resolve);
        };
        const sampleZoomState = () => {
            if (!isInputFocusZoomActive()) {
                stableSamples += 1;
                if (stableSamples >= stableSamplesRequired) {
                    finish();
                }
                return;
            }
            stableSamples = 0;
        };
        const onViewportChange = () => {
            sampleZoomState();
        };
        vv === null || vv === void 0 ? void 0 : vv.addEventListener("resize", onViewportChange);
        vv === null || vv === void 0 ? void 0 : vv.addEventListener("scroll", onViewportChange);
        pollId = window.setInterval(sampleZoomState, pollIntervalMs);
        timeoutId = window.setTimeout(finish, timeoutMs);
        sampleZoomState();
    });
};
const SHEET_OPEN_SYNC_BURST_MS = [50, 150, 300, 500, 700];
/**
 * iOS Safari input-focus zoom changes visualViewport; react-swipeable-bottom-sheet
 * caches window.innerHeight and only listens to window resize — not visualViewport.
 *
 * Sheet height uses a monotonic lock so OTP/keyboard focus does not shrink the sheet.
 */
const syncVisualViewportHeightVar = (options) => {
    if (typeof window === "undefined") {
        return () => { };
    }
    const vv = window.visualViewport;
    let syncBurstTimeoutIds = [];
    let deferredStartFrame = 0;
    let syncFrame = 0;
    let sessionStarted = false;
    let disposed = false;
    const clearSyncBurst = () => {
        syncBurstTimeoutIds.forEach((id) => window.clearTimeout(id));
        syncBurstTimeoutIds = [];
    };
    const sync = () => {
        syncViewportHeightNow();
    };
    const remeasureSessionLock = () => {
        if (!sheetViewportSession || isInputFocusZoomActive()) {
            return;
        }
        const fresh = measureViewportCandidate();
        if (fresh > sheetViewportSession.lockedHeight) {
            sheetViewportSession.lockedHeight = fresh;
        }
    };
    const startSession = () => {
        if (sessionStarted || disposed) {
            return;
        }
        sessionStarted = true;
        beginSheetViewportSession();
        remeasureSessionLock();
        sync();
        requestAnimationFrame(() => {
            remeasureSessionLock();
            sync();
        });
        syncBurstTimeoutIds = SHEET_OPEN_SYNC_BURST_MS.map((delayMs) => window.setTimeout(() => {
            remeasureSessionLock();
            sync();
        }, delayMs));
    };
    const waitForZoomResetThenStart = (frameBudget = 60) => {
        let frames = 0;
        const tick = () => {
            if (disposed || sessionStarted) {
                return;
            }
            if (!isInputFocusZoomActive() || frames >= frameBudget) {
                startSession();
                return;
            }
            frames += 1;
            deferredStartFrame = requestAnimationFrame(tick);
        };
        deferredStartFrame = requestAnimationFrame(tick);
    };
    if (options === null || options === void 0 ? void 0 : options.deferSessionStart) {
        // Apply full layout height immediately while zoom resets (see measureViewportCandidate).
        sync();
        waitForZoomResetThenStart();
    }
    else {
        startSession();
    }
    if (!vv) {
        return () => {
            disposed = true;
            cancelAnimationFrame(deferredStartFrame);
            clearSyncBurst();
            endSheetViewportSession();
        };
    }
    const scheduleSync = () => {
        cancelAnimationFrame(syncFrame);
        syncFrame = requestAnimationFrame(sync);
    };
    vv.addEventListener("resize", scheduleSync);
    vv.addEventListener("scroll", scheduleSync);
    return () => {
        disposed = true;
        cancelAnimationFrame(deferredStartFrame);
        cancelAnimationFrame(syncFrame);
        clearSyncBurst();
        vv.removeEventListener("resize", scheduleSync);
        vv.removeEventListener("scroll", scheduleSync);
        endSheetViewportSession();
        clearSwipeableSheetDomHeight();
        clearViewportHeightCssVars();
    };
};
const usesViewportSheetLayout = (disableSheetZoom, fullScreen) => Boolean(disableSheetZoom && !fullScreen);
const getViewportSheetContainerStyle = () => ({
    height: VIEWPORT_HEIGHT_FULL_CSS,
    maxHeight: VIEWPORT_HEIGHT_FULL_CSS,
    overflow: "hidden"
});


//# sourceMappingURL=viewportSheet.js.map


/***/ }),

/***/ 27106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "So": function() { return /* binding */ disabledCursorStyle; },
/* harmony export */   "gn": function() { return /* binding */ clickableCursorStyle; }
/* harmony export */ });
/* unused harmony export textCursorStyle */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);


const clickableCursorStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    cursor: pointer;
`;
const disabledCursorStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    cursor: not-allowed;
`;
const textCursorStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    cursor: vertical-text;
`;


//# sourceMappingURL=cursor.js.map


/***/ }),

/***/ 79047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getCommonFontStyleMixin; },
/* harmony export */   "e": function() { return /* binding */ fontWeightMixin; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82740);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12308);
/* harmony import */ var _constants_fontSize_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99420);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94897);
/* harmony import */ var _constants_breakpoint_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91818);
/* harmony import */ var _constants_theme_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63298);
/* harmony import */ var _constants_files_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65357);
/* harmony import */ var _constants_color_variant_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60603);
/* harmony import */ var _constants_zIndexList_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94069);










const fontWeightMixin = styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv `
    font-family: ${({ weight }) => weight && _constants_fonts_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[weight.toUpperCase()]};
`;
const getCommonFontStyleMixin = (props) => {
    const { size, mSize, weight } = props;
    return styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv `
        ${(0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(Object.assign(Object.assign({}, (weight && {
        fontFamily: _constants_fonts_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[weight.toUpperCase()],
    })), (size && {
        fontSize: `${_constants_fontSize_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[size]}rem`,
    })))}

        @media (max-width: ${_constants_breakpoint_js__WEBPACK_IMPORTED_MODULE_3__/* .Breakpoint.mobileBreakpointMaxWidth */ .U.mobileBreakpointMaxWidth}) {
            ${(0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(Object.assign({}, (mSize && {
        fontSize: `${_constants_fontSize_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[mSize]}rem`,
    })))}
        }
    `;
};


//# sourceMappingURL=font.js.map


/***/ }),

/***/ 47755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ scrollBarStyle; },
/* harmony export */   "a": function() { return /* binding */ scrollBarStyle__hidden; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);


const scrollBarStyle__hidden = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;
const scrollBarStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    &::-webkit-scrollbar {
        width: 18px;
    }
    &::-webkit-scrollbar-thumb {
        box-shadow: inset 0px 0px 10px 10px #e6e6e6;
        border: 5px solid transparent;
        border-radius: 16px;
    }
`;


//# sourceMappingURL=scrollbar.js.map


/***/ }),

/***/ 13261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ cssReset; },
/* harmony export */   "_": function() { return /* binding */ flexCenter; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82740);


const flexCenter = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    display: flex;
    align-items: center;
    justify-content: center;
`;
const cssReset = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv `
    * {
        margin: 0;
        padding: 0;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    a {
        text-decoration: none;
    }

    img,
    svg {
        display: block;
        max-width: 100%;
    }

    input,
    button,
    textarea,
    select {
        font: inherit;
    }
`;


//# sourceMappingURL=style-mixins.js.map


/***/ }),

/***/ 72207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dh": function() { return /* binding */ AuthServiceAdminConsole; },
/* harmony export */   "Eg": function() { return /* binding */ useSearchCompanyByPhoneNumber; }
/* harmony export */ });
/* unused harmony export useSearchCompanyByPhoneNumberMutation */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63118);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37528);
/* harmony import */ var _hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49352);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21928);
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2784);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(76705);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(52224);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(43298);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(91680);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(22391);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _auth_service_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(11663);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(96762);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_38__);
/* provided dependency */ var process = __webpack_require__(34406);










































function searchByPhone(customerMobile) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${_const_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].CUSTOMER_PROFILE_DETIALS_BY_PHONE */ .Z.CUSTOMER_PROFILE_DETIALS_BY_PHONE}p_n=${customerMobile}`, {
                method: "GET",
                headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json", key: process.env.NEXT_PUBLC_REACT_APP_KEY || "" }, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_6__/* .getAuthHeader */ .E)())
            }));
            if (call.status === 200) {
                const response = yield call.json();
                return response.data;
            }
            if (!call.ok) {
                throw yield call.json();
            }
        }
        catch (error) {
            /**
             * Uncomment the toast, after the backend stopsthrowing error for normal user roles.
             */
            // toast.error("An error occured, please try again after sometime", DefaultToastOptions);
        }
    });
}
function getUserRoles(userId) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${_const_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].GET_USER_ROLES */ .Z.GET_USER_ROLES}id=${userId}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                }
            }));
            if (call.status === 200) {
                const response = yield call.json();
                return response.data;
            }
            if (!call.ok) {
                throw yield call.json();
            }
        }
        catch (error) {
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .A.error("An error occured, please try again after sometime");
        }
    });
}
const AuthServiceAdminConsole = {
    searchByPhone,
    getUserRoles
};
function useSearchCompanyByPhoneNumber({ phoneNumber }, options) {
    const { GET } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const searchCompanyByPhoneNumber = () => {
        const queryObj = { p_n: phoneNumber };
        return GET(_const_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].CUSTOMER_PROFILE_DETIALS_BY_PHONE */ .Z.CUSTOMER_PROFILE_DETIALS_BY_PHONE, queryObj);
    };
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_4__/* .useVahakQuery */ .uE)([_hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_5__/* .QueryNames.searchCompanyByPhoneNumber */ ._.searchCompanyByPhoneNumber, phoneNumber], searchCompanyByPhoneNumber, options);
}
const useSearchCompanyByPhoneNumberMutation = () => {
    const { GET } = useVahakHttpClient();
    function method(params) {
        const { phoneNumber } = params;
        const payload = {
            p_n: phoneNumber
        };
        const urlString = generateQueryString(payload);
        return GET(`${API.CUSTOMER_PROFILE_DETIALS_BY_PHONE}${urlString}`);
    }
    return useVahakMutationQuery([QueryNames.searchCompanyByPhoneNumber], method);
};


//# sourceMappingURL=auth.adminConsole.service.js.map


/***/ }),

/***/ 68381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e8": function() { return /* binding */ AuthService; }
});

// UNUSED EXPORTS: logout, userAllDevicelogout

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../core/dist/methods/getDeviceInfo.js
var getDeviceInfo = __webpack_require__(38026);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(36908);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ../core/dist/_services/utils/saveAuthToken.js
/* provided dependency */ var process = __webpack_require__(34406);



function saveAuthToken(token) {
    const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    const cookies = new Cookies/* default */.Z();
    cookies.set(misc/* COOKIES.token */.E9.token, token, {
        secure: ENV === "production",
        sameSite: "strict",
        path: "/",
        maxAge: 24 * 60 * 60 * 30
    });
    return;
}


//# sourceMappingURL=saveAuthToken.js.map

// EXTERNAL MODULE: ../core/dist/_services/utils/getAuthHeader.js
var getAuthHeader = __webpack_require__(21928);
// EXTERNAL MODULE: ../core/dist/_services/utils/removeAuthToken.js
var removeAuthToken = __webpack_require__(886);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ../core/dist/_services/utils/validateAndConvertReqParamToNum.js + 38 modules
var validateAndConvertReqParamToNum = __webpack_require__(43464);
;// CONCATENATED MODULE: ../core/dist/_services/utils/get-null-api-response.js


function getNullApiResponse() {
    return (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        return new Promise((res) => res({ data: null, meta: null }));
    });
}


//# sourceMappingURL=get-null-api-response.js.map

;// CONCATENATED MODULE: ../core/dist/_services/auth.service.js













var LoginMode;
(function (LoginMode) {
    LoginMode[LoginMode["PASSWORD"] = 1] = "PASSWORD";
    LoginMode[LoginMode["OTP"] = 2] = "OTP";
    LoginMode[LoginMode["SSO"] = 3] = "SSO";
})(LoginMode || (LoginMode = {}));
function registerCompanyDetails({ userId, name, serviceType, placeId, referralCode, sessionId, user_joining_bonus_enabled }) {
    return (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(_services_const/* default.REGISTER_COMPANY_DETAILS */.Z.REGISTER_COMPANY_DETAILS, {
                method: "POST",
                headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (0,getAuthHeader/* getAuthHeader */.E)()),
                body: JSON.stringify({
                    user_id: parseInt(userId),
                    name,
                    service_type: serviceType,
                    place_id: placeId,
                    referral_code: referralCode,
                    session_id: sessionId,
                    user_joining_bonus_enabled: true
                })
            }));
            if (call.status === 200) {
                const response = yield call.json();
                saveAuthToken(response.data.access_token);
                return response.data;
            }
        }
        catch (error) {
            toast/* toast.error */.A.error("An error occured, please try again after sometime");
        }
        return null;
    });
}
const ErrorMap = {
    "User does not exist": "userNotFound",
    "Password is incorrect": "incorrectPassword"
};
function loginViaOtp({ phone_number, otp, is_wa_optin }) {
    return (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        try {
            const { browser, os, platform } = (0,getDeviceInfo/* getDeviceInfo */.d)();
            const rqst = new Request(_services_const/* default.LOGIN_VIA_OTP */.Z.LOGIN_VIA_OTP, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    // key: process.env.REACT_APP_KEY || ""
                },
                body: JSON.stringify({
                    phone_number: String(phone_number),
                    otp: (0,validateAndConvertReqParamToNum/* validateAndConvertReqParamToInt */.U)("otp", otp),
                    mode: LoginMode.OTP,
                    is_wa_optin: is_wa_optin || false,
                    device_information: JSON.stringify({
                        model: platform.model,
                        brand: platform.vendor,
                        type: platform.type,
                        os_name: os.name,
                        os_version: os.version,
                        browser: browser.name,
                        browser_version: browser.version
                    })
                })
            });
            const call = yield fetch(rqst);
            if (call.status === 200) {
                const { data } = yield call.json();
                saveAuthToken(data.access_token);
                return { data };
            }
            if (!call.ok) {
                const response = yield call.json();
                toast/* toast.error */.A.error(response.message);
                throw yield call.json();
            }
        }
        catch (e) {
            // @ts-ignore aa
            return { data: null, code: ErrorMap[e.title] };
        }
        return { data: null };
    });
}
function sessionLogout(phone_number) {
    return (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        const validatedPhoneNumber = (0,validateAndConvertReqParamToNum/* validateAndConvertReqParamToInt */.U)("phone_number", phone_number);
        const cookies = new Cookies/* default */.Z();
        const token = cookies.get(misc/* COOKIES.token */.E9.token);
        if (!validatedPhoneNumber || !token) {
            return getNullApiResponse();
        }
        try {
            const rqst = new Request(_services_const/* default.LOGOUT */.Z.LOGOUT, {
                method: "POST",
                headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (0,getAuthHeader/* getAuthHeader */.E)()),
                body: JSON.stringify({
                    phone_number: String(validatedPhoneNumber)
                })
            });
            const call = yield fetch(rqst);
            if (!call.ok) {
                const response = yield call.json();
                toast/* toast.error */.A.error(response.message);
                throw response;
            }
        }
        catch ({ data, message }) {
            return { data: null, message };
        }
        return { data: null };
    });
}
const logout = (phoneNum) => {
    (0,user_analytics_service/* ga4sendEvent */.zs)("Signup_logout_web", { value: 1 });
    sessionLogout(phoneNum).finally(removeAuthToken/* removeAuthToken */.H);
};
const userAllDevicelogout = (phoneNum) => (0,_tslib/* __awaiter */.m)(void 0, void 0, void 0, function* () {
    return sessionLogout(phoneNum).then(({ message }) => {
        !message && toast/* toast.success */.A.success("User logged out successfully from all the devices");
    });
});
const AuthService = {
    registerCompanyDetails,
    loginViaOtp,
    logout,
    userAllDevicelogout
};


//# sourceMappingURL=auth.service.js.map


/***/ }),

/***/ 22672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ newCustomer2CustomerCallbackRequest; }
/* harmony export */ });
/* unused harmony export sendCallbackRequest */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63118);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77370);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);





function sendCallbackRequest({ PhoneNumber, name, remarks }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(API.CALL_BACK_REQUEST, {
                method: "POST",
                body: JSON.stringify({
                    subject: `Call Me: ${PhoneNumber}: ${name ? name : "Guest"}`,
                    content: remarks,
                    owner_id: "84025938"
                })
            }));
            const { posts, meta } = yield call.json();
            if (call.status === 200) {
                window.localStorage.setItem(LOC_STORAGE.callbackRequestedTimestamp, new Date().toISOString().toString());
                return { posts, meta, status: call.status };
            }
        }
        catch (error) {
            toast.error("An error occured, please try again after sometime", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
        return { posts: null, meta: null, status: null };
    });
}
// export async function customer2CustomerCallbackRequest({
//     phoneNumber,
//     transporterCompanyId
// }: Customer2CustomerCallbackRequestProps) {
//     try {
//         const callbackResponse = await fetch(
//             new Request(API.C2C_CALLBACK, {
//                 method: "POST",
//                 body: JSON.stringify({
//                     company_id: String(transporterCompanyId),
//                     phone_number: String(phoneNumber),
//                     type: "2"
//                 })
//             })
//         );
//         const { data } = await callbackResponse.json();
//         if (data.status === "success") {
//             return true;
//         } else {
//             throw "";
//         }
//     } catch (error) {
//         toast.error("The transporter you are trying to call is no longer active");
//     }
//     return false;
// }
function newCustomer2CustomerCallbackRequest({ callerId, calleeId, referenceId, referenceType }) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            if (true) {
                throw { err: "Service Not Available" };
            }
            // if (!callerId || !calleeId || true) {
            //     throw { err: "Something went wrong!" };
            // }
            // const callbackResponse = await fetch(
            //     new Request(API.C2C_CALLBACK, {
            //         method: "POST",
            //         body: JSON.stringify({
            //             caller_id: callerId,
            //             callee_id: calleeId,
            //             reference_id: referenceId,
            //             reference_type: referenceType
            //         }),
            //         headers: {
            //             Accept: "application/json",
            //             "Content-Type": "application/json",
            //             ...getAuthHeader()
            //         }
            //     })
            // );
            // const { data } = await callbackResponse.json();
            // if (data?.virtual_number) {
            //     return data.virtual_number;
            // } else {
            //     throw "";
            // }
        }
        catch (error) {
            if (error === null || error === void 0 ? void 0 : error.err) {
                _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error(error.err);
                return;
            }
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("Please try after sometime.");
        }
        return false;
    });
}


//# sourceMappingURL=callBack.service.js.map


/***/ }),

/***/ 79890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CallMeBackScreen; }
/* harmony export */ });
/* unused harmony export useCallMeBackRequest */
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49352);





var CallMeBackScreen;
(function (CallMeBackScreen) {
    CallMeBackScreen["CONTACT_US"] = "Contact Us Page (Web)";
    CallMeBackScreen["SUPPORT_ICON"] = "Support Floating Icon (Web)";
    CallMeBackScreen["LOAD_BID"] = "Load Bid Form (Web)";
    CallMeBackScreen["LORRY_BID"] = "Lorry Bid Form (Web)";
    CallMeBackScreen["COMPANY_REGISTER"] = "Company Register (Web)";
})(CallMeBackScreen || (CallMeBackScreen = {}));
const useCallMeBackRequest = () => {
    const { POST } = useVahakHttpClient();
    function submitCallMeBackRequest(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(API.CALL_ME_BACK_REQUEST, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return useVahakMutationQuery(QueryNames.callMeBackMutate, submitCallMeBackRequest);
};


//# sourceMappingURL=callMeBack.service.js.map


/***/ }),

/***/ 66727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ CareersService; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63118);



const BASE_URL = "https://careers-app.vahak.in/ghost/api/v3/content";
const KEY = "b091acc60507a862fe7fc5719b" || 0;
const CATEGS_URL = `${BASE_URL}/tags`;
const JOBS_URL = `${BASE_URL}/posts`;
const JobDetailsFieldsQuery = `fields=title%2Chtml%2Cupdated_at%2Ccustom_excerpt%2Ccanonical_url`;
const AllJobsDetailsFieldsQuery = `fields=title%2Cslug%2Ccustom_excerpt`;
function getAllCategories() {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${CATEGS_URL}?key=${KEY}&fields=name%2Cslug`, {
                method: "GET"
            }));
            if (call.status === 200) {
                const { tags } = yield call.json();
                return { categs: tags };
            }
        }
        catch (e) {
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("An error occured, please try again after sometime");
        }
        return { categs: null };
    });
}
function getAllJobs({ page = 1, limit = 6 }) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${JOBS_URL}?key=${KEY}&${AllJobsDetailsFieldsQuery}&page=${page}&limit=${limit}`, {
                method: "GET"
            }));
            if (call.status === 200) {
                const { posts, meta } = yield call.json();
                return { jobs: posts, meta };
            }
        }
        catch (e) {
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("An error occured, please try again after sometime");
        }
        return { jobs: null, meta: null };
    });
}
function getJobsByCateg({ page = 1, limit = 6, categSlug }) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${JOBS_URL}?key=${KEY}&${AllJobsDetailsFieldsQuery}&page=${page}&limit=${limit}&filter=tag:${categSlug}`, { method: "GET" }));
            if (call.status === 200) {
                const { posts, meta } = yield call.json();
                return { jobs: posts, meta };
            }
        }
        catch (e) {
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("An error occured, please try again after sometime");
        }
        return { jobs: null, meta: null };
    });
}
function getJobBySlug({ slug }) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(`${JOBS_URL}/slug/${slug}?key=${KEY}&${JobDetailsFieldsQuery}`), {
                method: "GET"
            });
            if (call.status === 200) {
                return (yield call.json()).posts[0];
            }
        }
        catch (e) {
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("An error occured, please try again after sometime");
        }
        return null;
    });
}
const CareersService = { getAllCategories, getAllJobs, getJobsByCateg, getJobBySlug };


//# sourceMappingURL=careers.service.js.map


/***/ }),

/***/ 20803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Z": function() { return /* binding */ PLACE_SEARCH_QUERY_LENGTH; },
/* harmony export */   "PP": function() { return /* binding */ searchUsingPlacesAPI; },
/* harmony export */   "T5": function() { return /* binding */ LocationSearchSource; },
/* harmony export */   "ao": function() { return /* binding */ getPlaceIdForStringQuery; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63118);
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2784);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76705);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52224);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(43298);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91680);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(22391);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(41634);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _auth_service_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(11663);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(96762);
/* harmony import */ var _methods_generateQueryString_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(99073);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(21928);







































const PLACE_SEARCH_QUERY_LENGTH = 4;
function getPlacesApiFetchHeaders(option) {
    var _a;
    const headers = Object.assign({}, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_35__/* .getAuthHeader */ .E)());
    // SSR (getServerSideProps, etc.) — no CORS; backend may expect these headers.
    // Browser fetch must omit User-Agent/Origin/Referer — Safari preflights them.
    if (typeof window === "undefined") {
        const origin = (_a = option.origin) !== null && _a !== void 0 ? _a : "http://localhost:3000";
        headers.origin = origin;
        headers.referer = `${origin}/`;
        headers["user-agent"] = _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].VERCEL_USER_AGENT */ .Z.VERCEL_USER_AGENT;
    }
    return headers;
}
function searchUsingPlacesAPI(query, option) {
    var _a, _b;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        const { source, allowState: is_state_allowed, tag } = option !== null && option !== void 0 ? option : {};
        try {
            if (!query || query.length < PLACE_SEARCH_QUERY_LENGTH) {
                return [];
            }
            const queryParams = "&" +
                (0,_methods_generateQueryString_js__WEBPACK_IMPORTED_MODULE_36__/* .generateQueryString */ .T)({
                    tag,
                    source,
                    is_state_allowed,
                    session_token: option === null || option === void 0 ? void 0 : option.searchSessionToken
                });
            const call = yield fetch(encodeURI(_const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].PLACES_API_SEARCH */ .Z.PLACES_API_SEARCH + query + queryParams), {
                headers: getPlacesApiFetchHeaders(option)
            });
            if (call.status === 200) {
                return (_b = (_a = (yield call.json())) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
            }
            else {
                const errorBody = yield call.json().catch(() => ({}));
                throw new Error((errorBody === null || errorBody === void 0 ? void 0 : errorBody.message) || call.statusText || "Places search failed");
            }
        }
        catch (e) {
            if (!(option === null || option === void 0 ? void 0 : option.suppressErrorToast)) {
                _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("An error occured, please try again after sometime");
            }
            return [];
        }
    });
}
function getPlaceIdForStringQuery(...args) {
    var _a, _b;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        const [query] = args;
        if (query) {
            return (_b = (_a = (yield searchUsingPlacesAPI(...args))) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.place_id;
        }
        return undefined;
    });
}
var LocationSearchSource;
(function (LocationSearchSource) {
    LocationSearchSource["LoadSourcePosting"] = "load_source_posting";
    LocationSearchSource["LoadDestinationPosting"] = "load_destination_posting";
    LocationSearchSource["LoadWaypointPosting"] = "load_waypoint_posting";
    LocationSearchSource["LorryPostingSrc"] = "lorry_posting_src";
    LocationSearchSource["LorryPostingDest"] = "lorry_posting_dest";
    LocationSearchSource["LoadMarketPlaceSearchSource"] = "load_marketplace_search_source";
    LocationSearchSource["LoadMarketPlaceSearchDestination"] = "load_marketplace_search_destination";
    LocationSearchSource["LorryMarketPlaceSearchSource"] = "lorry_marketplace_search_source";
    LocationSearchSource["LorryMarketPlaceSearchDestination"] = "lorry_marketplace_search_destination";
    LocationSearchSource["CompanyRegistration"] = "company_registration";
    LocationSearchSource["LoadPickUpAddress"] = "load_pickup_address";
    LocationSearchSource["LoadDropAddress"] = "load_drop_address";
    LocationSearchSource["CompanyOfficeAddress"] = "company_office_address";
    LocationSearchSource["GpsAddition"] = "gps_addition";
    LocationSearchSource["CargoPurchase"] = "cargo_purchase";
    //
    LocationSearchSource["AdminNewCsUser"] = "admin_new_cs_user";
    LocationSearchSource["BulkLoad"] = "bulk_load";
    LocationSearchSource["TransporterProfile"] = "transporter_profile";
    LocationSearchSource["CityLoadSearchSource"] = "city_load_search_source";
    LocationSearchSource["CityLoadSearchDestination"] = "city_load_search_destination";
    LocationSearchSource["CityLorrySearchSource"] = "city_lorry_search_source";
    LocationSearchSource["CityLorrySearchDestination"] = "city_lorry_search_destination";
    LocationSearchSource["CompanyCurrentLocation"] = "company_current_location";
    LocationSearchSource["CompanyAddRoute"] = "company_add_route";
    LocationSearchSource["HomepageV2LoadSourcePosting"] = "homepage_v2_load_source_posting";
    LocationSearchSource["HomepageV2LoadDestinationPosting"] = "homepage_v2_load_destination_posting";
})(LocationSearchSource || (LocationSearchSource = {}));


//# sourceMappingURL=city-search.service.js.map


/***/ }),

/***/ 41634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ API; },
/* harmony export */   "c": function() { return /* binding */ IS_PROD_ENV; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(34406);
const PROD_API = "https://api.vahak.in";
const DEV_API = "https://dev.vahak.in";

const VERCEL_USER_AGENT = "Vercel";

const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
const IS_PROD_ENV = ENV === "production";

const API_URI = ENV === "production" ? PROD_API : DEV_API;

const API_V1 = API_URI + "/v1";
const API_V2 = API_URI + "/v2";
const NEXT_API = "/api";

// Transporters
const TRANSPORTER_SEARCH = API_V1 + "/c/ft?";
const TRANSPORTERS_BY_NAME = TRANSPORTER_SEARCH;
const TRANSPORTER_REVIEWS = API_V1 + "/c/rt/co";
const TRANSPORTER_FAQ = API_V1 + "/c/fq/id";

// Cities and places
const CITY_SEARCH = API_URI + "/s/city?q=";
const PLACES_API_SEARCH = API_V1 + "/s/p?q=";
const ROUTES_BY_COMPANY_ID = API_V1 + "/c/rt?";
const LAT_LONG_BY_PLACE_ID = API_V1 + "/s/details/place_id?";

// Loads
const POST_LOAD = API_V1 + "/ld/a?";
const ALL_LOADS = API_V1 + "/ld/all?";
const ALL_LOADS_V2 = API_V2 + "/ld/all?";
const LOAD_MARKET_V2 = API_V2 + "/mkt/web_ld?";
const LOAD_MARKET_V2_NEW = API_V2 + "/mkt/web_ld/new?";
const UPDATE_LOAD_DETAILS = API_V1 + "/ld/e";
const UPDATE_LOAD_ADDRESS = API_V1 + "/ld/adrs";

//TSO
const TAG_AGENT_CUSTOMER_LOADS_POSTED = API_V1 + "/adm/agent/ld?";
const TAG_AGENT_CUSTOMER_LORRIES_POSTED = API_V1 + "/adm/agent/lr?";
const LOADS_ENQUIRY_CARD = API_V1 + "/ld/filter/all";
const LORRY_ENQUIRY_CARD = API_V1 + "/lr/filter/all";
const ALL_CUSTOMERS_ENQUIRY_CARD = API_V1 + "/adm/agent/enquiry";

// Lorries
const ALL_LORRIES = API_V1 + "/lr/all?";
const ALL_LORRIES_V2 = API_V2 + "/lr/all?";
const EDIT_LORRY = API_V1 + "/lr/e";
const EDIT_LORRIES = API_V1 + "/lr/me";
const GET_LORRIES_BY_CATEGORY = API_V1 + "/s/lr?";
const POST_LORRY = API_V1 + "/lr/a?";
const REACTIVATE_LORRY = API_V1 + "/lr/reactivate?";
const LORRY_MARKET_V2 = API_V2 + "/mkt/web_lr?";
const UPDATE_LORRY_ROUTES = API_V1 + "/lr/ar/city";
const ADD_DRIVER_DETAILS = API_V1 + "/emp/a?";
const ATTACH_DRIVER_TO_LORRY = API_V1 + "/lr/add/driver?";
const REMOVE_DRIVER_FROM_LORRY = API_V1 + "/lr/remove/driver?";
const ENABLE_SIM_TRACK = API_V1 + "/lc/track/trip?";
const EDIT_SIM_TRACK = API_V1 + "/lc/track/edit-trip?";
const SEND_CONSENT_SIM_TRACK = API_V1 + "/lr/track/send-consent?";

// Lorry location
const GET_LORRY_LOCATION_HISTORY = API_V1 + "/lr/location/history";
const GET_LORRY_CURRENT_LOCATION_TRIPS_LIST = API_V1 + "/lc/trips/d";
const GET_REVERSE_GEO_POINT = API_V1 + "/lc/reverse/geopoint?";
const GET_LORRY_LOCATION_DETAILS = API_V1 + "/lr/loc/dtl?";

//Verify lorry from signzy
const VERIFY_LORRY_FROM_SIGNZY = API_V1 + "/lr/info/number?";

// Bidding
const SUBMIT_LOAD_BID = API_V1 + "/ld/bd?";
const SUBMIT_LORRY_BID = API_V1 + "/lr/bd?";
const BID_HISTORY = API_V1 + "/c/bh?";

// Register and Login
const OTP = API_V1 + "/u/o_w";
const OTP_VIA_WHATSAPP = API_URI + "/rotpws?number=";
const LOGIN_VIA_OTP = API_V1 + "/u/vo_w";
const VERIFY_OTP = API_V1 + "/u/just/vo?";
const VALIDATE_TOKEN = API_V1 + "/u/v";
const LOGOUT = API_V1 + "/u/lg";
const REGISTER_COMPANY_DETAILS = API_V1 + "/c/r";

// Trips
const GET_TRIP_DOCS = API_V1 + "/lr/s_docs";
const POST_TRIP_DOCS = API_V1 + "/lr/up";

// User Report
const GET_USER_REPORTS = API_V1 + "/c/report/reasons?";

// Call back request
const CALL_BACK_REQUEST = API_V1 + "/m/hs";

// KYC verification
const DIGILOCKER_AADHAAR_NUMBER_VERIFICATION = API_V1 + "/u/durl?";

// KYC verification - SurePass
const VERIFY_AADHAAR_NUMBER_AND_GET_OTP = API_V1 + "/u/ao?";
const VERIFY_AADHAAR_OTP = API_V1 + "/u/av?";
const VERIFY_PAN = API_V1 + "/c/pan";
const VERIFY_GST_NUMBER = API_V1 + "/c/go?";
const VERIFY_GST_OTP = API_V1 + "/c/gv?";

const GET_DOCUMENTS = API_V1 + "/misc/g_doc";
const UPLOAD_DOCUMENTS = API_V1 + "/misc/u_doc";
const DELETE_DOCUMENT = API_V1 + "/misc/d_doc";

// User profile and Company
const USER_PROFILE_DETAILS = API_V1 + "/c/d?";
const USER_CASHBACK_DETAILS = API_V1 + "/c/cb_d?";
const UPDATE_COMPANY_DETAILS = API_V1 + "/c/u?";
const UPDATE_COMPANY_META_DETAILS = API_V1 + "/c/u/c_m";
const USER_PROFILE_ADD_FAQ = API_V1 + "/c/fq?";
const USER_PROFILE_EDIT_FAQ = API_V1 + "/c/ufq?";
// const ALL_OFFICE_ADDRESS = API_V1 + "/adr/r?";
const ADD_EDIT_OFFICE_ADDRESS = API_V1 + "/adr/cu?";
const DELETE_OFFICE_ADDRESS = API_V1 + "/adr/d?";
const UPLOAD_IMAGE = API_V1 + "/c/up?";
const COMPANY_REVIEW_DETAILS = API_V1 + "/c/rv?";
const COMPANY_ROUTE_DETAILS = API_V1 + "/c/rt?";
const COMPANY_ROUTE_DETAILS_V2 = API_V2 + "/c/rt?";
const GET_NEAR_BY_CITIES = API_V1 + "/lc/nearby/cities?";
const UPDATE_COMPANY_ROUTES = API_V1 + "/c/ar?";
const COMPANIES_INFO = API_V1 + "/c/info?";
const ADD_PROFILE_DISPOSITION = API_V1 + "/c/dis/add";
const GET_PROFILE_DISPOSITION = API_V1 + "/c/dis?";

//Load Lorries posting and bidding counts
const GET_USER_LOAD_LORRY_POSTINGS_BIDS_COUNTS = API_V1 + "/ldlr/count";

// User Lorries
const USER_LORRY_INFO_BY_ID = API_V1 + "/lr/d?";
const USER_LORRY_RECEIVED_BIDS_BY_ID = API_V1 + "/lr/bds?";
const USER_LORRY_SENT_BIDS_BY_ID = API_V1 + "/lr/sbds?";
const USER_LORRY_ROUTES_BY_ID = API_V1 + "/lr/rts?";
const USER_DEACTIVATE_LORRY = API_V1 + "/lr/tg?";
const USER_DELETE_LORRY = API_V1 + "/lr/delete?";
const USER_LIVE_LOAD_BY_LORRY_ID = API_V1 + "/lr/ll?";
const USER_LIVE_LOAD_BY_LORRY_ID_V2 = API_V2 + "/lr/ll?";
const USER_LORRY_INCENTIVE_INFO = API_V1 + "/lr/incentive/trips?";

// User Load
const USER_LOAD_INFO_BY_ID = API_V1 + "/ld/d?";
const USER_LOAD_RECEIVED_BIDS_BY_ID = API_V1 + "/ld/bds?";
const USER_LOAD_SENT_BIDS_BY_ID = API_V1 + "/ld/sbds?";
const USER_LIVE_LORRY_BY_LOAD_ID = API_V1 + "/ld/ll?";
const USER_LIVE_LORRY_BY_LOAD_ID_V2 = API_V2 + "/ld/ll?";
const USER_LOAD_STOPS = API_V1 + "/ld/stops?";
const GET_PAST_TRANSACTORS = API_V2 + "/lr/p/txns?";
const PAST_DEPOSITORS = API_V2 + "/lr/past_depositors?";

// Load Transaction api
const LOAD_TRANSACTION_LIST = API_V1 + "/tx/ldd?";
const LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID = API_V1 + "/ld/bd/upd?";

// Lorry Transaction api
const LORRY_TRANSACTION_LIST = API_V1 + "/tx/lrd?";
const LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID = API_V1 + "/lr/bd/upd?";

// Transporters List
const TRANSPORTERS_BY_LOAD = API_V1 + "/ld/tr";
const TRANSPORTERS_BY_LORRY = API_V1 + "/lr/tr";
const CONNECT_REQUEST_API = API_V1 + "/nw/a";
const REMOVE_REQUEST_API = API_V1 + "/nw/u";

// Internal use
const BLOCK_USERS = API_V1 + "/u/block";
const UNBLOCK_USERS = API_V1 + "/u/unblock";
const SEND_WHATSAPP_MESSAGE = API_URI + "/cwm";

// Admin Console
const LOGIN_ADMIN_CONSOLE = API_V1 + "/u/t";
const RESET_PASSWORD_ADMIN_CONSOLE = API_V1 + "/u/r";
const GET_OTP_FOR_RESETPASSWORD = API_V1 + "/u/o";
const CUSTOMER_PROFILE_DETIALS_BY_PHONE = API_V1 + "/c/phnos?";
const GET_USER_ROLES = API_V1 + "/u/roles?";
const ADMIN_VERIFY_LOAD = API_V1 + "/ld/vr?";
const EDIT_LOAD = API_V1 + "/ld/mel";

//C2C - call api
const C2C_CALLBACK = API_V1 + "/c/c2c";

// Deactivate Load Lorry api
const DEACTIVATE_LOAD_BY_ID = API_V1 + "/ld/disable?";
const DEACTIVATE_LORRY_BY_ID = API_V1 + "/lr/deactivate?";

// Comments API's
const ADD_LORRY_COMMENT = API_V1 + "/lr/ac";
const ADD_LOAD_COMMENT = API_V1 + "/ld/ac";
const GET_LORRY_COMMENT = API_V1 + "/lr/gc";
const GET_LOAD_COMMENT = API_V1 + "/ld/gc";

//Premium Load
const PREMIUM_BULK_LOAD_EDIT = API_V1 + "/ld/mel";
const PREMIUM_BULK_LOAD_PUBLISH = API_V1 + "/ld/ma";
const PREMIUM_BID_ACCEPT_OR_REJECT = API_V1 + "/ld/bd/mupd";
const UPDATE_BID_BY_ID = API_V1 + "/ld/bd/mupd";
const PREMIUM_BULK_LOAD_DELETE = API_V1 + "/ld/mdlt";
const PREMIUM_CLIENT_LIST = API_V1 + "/p/list?kam_uid=";

//Trip
const PREMIUM_TRIP_GET_TRACKING_LOCATION = API_V1 + "/lr/loc?";
const PREMIUM_TRIP_GET_SIM_TRACK = API_V1 + "/lr/simtrack?";

//Payment and Cashback
const PREMIUM_REQUEST_PAYMENT_LINK = API_V1 + "/rzp/py/link";
const GET_PAYMENT_LINK_DETAILS = API_V1 + "/py/link/details?";
const PREMIUM_RELEASE_PAYMENT = API_V1 + "/py/release";
const PAYMENTS_INFORMATION = API_V1 + "/py/d";
const PREMIUM_PAYMENT_STATUS = API_V1 + "/rzp/py/link/upd";
const GET_TRANSACTION_DETAILS = API_V1 + "/py/txns";
const CHECK_ELIGIBILITY = API_V1 + "/py/check-eligibility?";
const ADD_CASHBACK_COIN = API_V1 + "/py/ad/cashback/add?";

// Bulk Loads
const POST_BULK_LOAD = API_V1 + "/ld/bulk";
const BULK_LOAD_POSTING_STATUS = API_V1 + "/bulk/records?";
const ALL_BULK_LOADS = API_V1 + "/ld/bulkall";

// My Bids
const LOAD_MY_BIDS = API_V1 + "/ld/mybids?";
const LORRY_MY_BIDS = API_V1 + "/lr/mybids?";
const LOAD_LORRY_GET_BID_INFO = API_V1 + "/ldlr/bidinfo?";

// Image Upload
const MISC_UPLOAD_IMAGE = API_URI + "/misc/upload_image";

// Attach Lorry to Bid
const ATTACH_LORRY_TO_BID = API_V1 + "/ld/mal";

//Get company status for posting and bidding Limit
const GET_COMPANY_POSTING_AND_BIDDING_LIMIT = API_V1 + "/c/status";
const GET_USER_ACTION_VALIDATION = API_V2 + "/c/status?";

// KAM Details By Company ID
const GET_KAM_DETAILS_BY_COMPANY_ID = API_V1 + "/p/kam/details?";

// Ticket System
const CREATE_TICKET = API_V1 + "/tkt/ct";
const GET_TICKETS = API_V1 + "/tkt/all";
const GET_LOAD_TICKETS = API_V1 + "/tkt/load";
const UPDATE_TICKET_STATUS = API_V1 + "/tkt/art";
const GET_TICKET_BY_ID = API_V1 + "/tkt/id";
const CALL_ME_BACK_REQUEST = API_V1 + "/tkt/cmb";
const TICKET_HELP_REQUEST = API_V1 + "/tkt/hr";
const ASSIGN_TICKET = API_V1 + "/tkt/assign/me";
const RE_ASSIGN_ALL_TICKET = API_V1 + "/tkt/auto_assign_ticket";
const LOAD_REASSIGN = API_V1 + "/tkt/load/e";
const LOAD_REASSIGN_V2 = API_V1 + "/tkt/assign_agent";

// Admin System journey
const TAG_USER = API_V1 + "/adm/ctag";
const UNTAG_USER = API_V1 + "/adm/utag";
const GET_TAGGED_USERS = API_V1 + "/adm/tagcom?";

// Admin Role Management
const GET_CS_USER_ROLES = API_V1 + "/adm/listroles?"; // fetch all roles name available
const GET_CS_USER_OPERATIONS = API_V1 + "/adm/operation?"; // fetch all operation name available
const GET_CS_USER_ROLE_OPERATIONS = API_V1 + "/adm/role/op?";
const UPDATE_CS_USER_ROLE_OPERATIONS = API_V1 + "/adm/ed/roleop?";

// Admin User Management
const GET_CS_USERS = API_V1 + "/adm/urole?"; // list cs user
const GET_CS_USER_DETAILS = API_V1 + "/adm/urole/id?";

const ADD_CS_USER = API_V1 + "/adm/reg/emp?";
const UPDATE_CS_USER = API_V1 + "/adm/ed/emp?";
const DELETE_CS_USER = API_V1 + "/adm/user/role?";

// VAS
const GET_VAS_PLANS = API_V1 + "/c/pl?";
const GET_VAS_PLAN_BY_ID = API_V1 + "/c/pid?";
const SEND_VAS_LINK = API_V1 + "/py/rzp/subscriptionpayment?";
const VAS_MEMBERSHIP_RECENT = API_V1 + "/c/msp/rplan?";
const VAS_MEMBERSHIP_HISTORY = API_V1 + "/c/msp/history?";
const VAS_ADD_GPS = API_V1 + "/c/vas/gps/add?";
const VAS_GPS_HISTORY = API_V1 + "/c/vas/gps/history?";
const VAS_GPS_STATE = API_V1 + "/c/gps/states?";
const VAS_CARGO_HISTORY = API_V1 + "/ins/history?";
const VAS_CARGO_HISTORY_ADMIN = API_V1 + "/ins/history/ad?";
const VAS_CARGO_PREMIUM = API_V1 + "/ins/gpp";
const VAS_ADD_CARGO = API_V1 + "/ins/gins";
const VAS_CARGO_MATERIAL_LIST = API_V1 + "/ti/mt";
const CREATE_VAS_TICKET = API_V1 + "/tkt/vas";

//Payment Link
const RAZORPAY_PAYMENT_LINK = API_V1 + "/py/cr-py-ord?";

// Admin Remarks Update
const UPDATE_REMARKS = API_V1 + "/ldlr/acd?";

// User Bank
const GET_BANK_DETAILS = API_V1 + "/py/rzp/vr/bnk?";
const ADD_BANK_DETAILS = API_V1 + "/py/rzp/bnk/add?";
const ADD_VPA_DETAILS = API_V1 + "/py/rzp/upi/add?";
const DEL_BANK_DETAILS = API_V1 + "/py/rzp/bnk/del";

// Bids Payment Info
const BIDS_PAYMENT_INFO = API_V1 + "/py/ad/bids?";

// Invoice Generate Bill of supply
const INVOICE_GENERATE_BILL = API_V1 + "/inv/genbill";

const POPULAR_LANE_FOR_CITY = API_V1 + "/lc/city/info?";
const POPULAR_CITIES = API_V1 + "/lc/top/cities?";
const POPULAR_LANE_FOR_COUNTRY = API_V1 + "/lc/country/info?";
const PRICE_RECOMMENDATION = API_V1 + "/ld/pr?";

const TRUE_CALLER_REGISTRATION = API_V1 + "/u/web/trc";
//Firebase
const GET_SHORT_LINK = "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?";

// Bulk Tag
const BULK_TAG = API_V1 + "/adm/ctag/bulk?";
const BULK_UNTAG = API_V1 + "/adm/utag/bulk?";

//Report system
const PAYMENT_REPORT = API_V1 + "/rs/report";
const REPORT_UPDATE_DISPOSITION = API_V1 + "/rs/report/disp";

// Update Load Expected Amount
const UPDATE_EXPECTED_AMOUNT = API_V1 + "/ld/uat";
const UPDATE_PREFERRED_AMOUNT = API_V1 + "/ld/e/prf/amt";
const ASSURED_LOAD_CANCEL = API_V1 + "/ld/tng/cl";

const GET_BOOKING_AMOUNT = API_V1 + "/py/booking-amount?";
const CALCULATE_PAYMENT_BREAKUP = API_V1 + "/py/calculate-payment-breakup?";
const GET_CASHBACK_USAGE_LIMIT = API_V1 + "/py/lmt/cshbk?";
const GET_PAYMENT_LEDGER = API_V1 + "/py/ledger?";

// Notifications
const ADMIN_NOTIFICATION = API_V1 + "/nf/notify";
const ADMIN_SEND_JOURNEY_FEEDBACK = API_V1 + "/lr/feedback/send_link";

// Load Ticket System
const GET_DISPOSITION_HISTORY = API_V1 + "/ldlr/disposition/history?";
const UPDATE_BID_TIME_INFO = API_V1 + "/ld/bd/inform/time";

// Call
const CALL_INITIATE = API_V1 + "/cl/a";
const CONFERENCE_INITIATE = API_V1 + "/c/conference/create";
const CONFERENCE_KICKOUT = API_V1 + "/c/conference/kickout";
const CONFERENCE_END = API_V1 + "/c/conference/end";

// TSO Lead Dashboard
const TSO_VISIT_CHECK_IN_AND_OUT = API_V1 + "/c/tso/s_a";
const TSO_SESSIONS = API_V1 + "/c/tso/history";
const CALCULATE_ROUTES_DISTANCE = NEXT_API + "/cd";

// CS Attendance
const UPDATE_CS_ATTENDANCE = API_V1 + "/emp/log_attendance";
const GET_CS_ATTENDANCE = API_V1 + "/emp/h_attendance";
const GET_CS_TEAM_ATTENDANCE = API_V1 + "/emp/team_attendance";

// Bid MISC
const UPDATE_BID_META_DETAILS = API_V1 + "/ld/u/bid_meta";
const GET_AGGREGATE_BID_BY_COMPANYID = API_V1 + "/ld/mybids_aggregated";

// agent status
const GET_AGENT_TEAM_STATUS = API_V2 + "/ld/agent_team_wise_loads";
const GET_EVENT_HISTORY = API_V1 + "/adm/events";
//
const UPDATE_LOAD_JOURNEY_INFO = API_V1 + "/ld/stage/event/a";
const GET_LOAD_JOURNEY_INFO = API_V1 + "/ld/stage/events?";
const UPDATE_ADMIN_NOTIFICATION_STATUS = API_V1 + "/tkt/ntf/seen?";
const GET_PAST_JOURNEY_COUNT = API_V1 + "/ld/trip/counts?";
const GET_LOAD_TRIP_SUMMARY = API_V1 + "/ld/trips/summary";

const API = {
    TRANSPORTER_SEARCH,
    TRANSPORTERS_BY_NAME,
    TRANSPORTER_REVIEWS,
    TRANSPORTER_FAQ,
    CITY_SEARCH,
    PLACES_API_SEARCH,
    GET_TRIP_DOCS,
    POST_TRIP_DOCS,
    OTP,
    ALL_LOADS,
    ALL_LOADS_V2,
    ALL_LORRIES,
    ALL_LORRIES_V2,
    EDIT_LORRY,
    EDIT_LORRIES,
    SUBMIT_LOAD_BID,
    SUBMIT_LORRY_BID,
    POST_LOAD,
    POST_LORRY,
    REACTIVATE_LORRY,
    ROUTES_BY_COMPANY_ID,
    LOGIN_VIA_OTP,
    VERIFY_OTP,
    OTP_VIA_WHATSAPP,
    VALIDATE_TOKEN,
    BID_HISTORY,
    REGISTER_COMPANY_DETAILS,
    CALL_BACK_REQUEST,
    GET_LORRIES_BY_CATEGORY,
    USER_PROFILE_DETAILS,
    USER_CASHBACK_DETAILS,
    USER_PROFILE_ADD_FAQ,
    USER_PROFILE_EDIT_FAQ,
    // ALL_OFFICE_ADDRESS,
    ADD_EDIT_OFFICE_ADDRESS,
    DELETE_OFFICE_ADDRESS,
    UPLOAD_IMAGE,
    COMPANY_REVIEW_DETAILS,
    COMPANY_ROUTE_DETAILS,
    COMPANY_ROUTE_DETAILS_V2,
    GET_NEAR_BY_CITIES,
    UPDATE_COMPANY_ROUTES,
    USER_LORRY_INFO_BY_ID,
    USER_LORRY_ROUTES_BY_ID,
    USER_DEACTIVATE_LORRY,
    USER_DELETE_LORRY,
    LOAD_TRANSACTION_LIST,
    LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID,
    ADMIN_VERIFY_LOAD,
    LORRY_TRANSACTION_LIST,
    LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID,
    UPDATE_COMPANY_DETAILS,
    UPDATE_COMPANY_META_DETAILS,
    USER_LOAD_INFO_BY_ID,
    USER_LOAD_RECEIVED_BIDS_BY_ID,
    USER_LOAD_SENT_BIDS_BY_ID,
    USER_LORRY_RECEIVED_BIDS_BY_ID,
    USER_LORRY_SENT_BIDS_BY_ID,
    USER_LIVE_LOAD_BY_LORRY_ID,
    USER_LIVE_LOAD_BY_LORRY_ID_V2,
    USER_LIVE_LORRY_BY_LOAD_ID,
    USER_LIVE_LORRY_BY_LOAD_ID_V2,
    USER_LOAD_STOPS,
    GET_PAST_TRANSACTORS,
    PAST_DEPOSITORS,
    TRANSPORTERS_BY_LOAD,
    TRANSPORTERS_BY_LORRY,
    CONNECT_REQUEST_API,
    REMOVE_REQUEST_API,
    BLOCK_USERS,
    UNBLOCK_USERS,
    SEND_WHATSAPP_MESSAGE,
    LOGIN_ADMIN_CONSOLE,
    RESET_PASSWORD_ADMIN_CONSOLE,
    GET_OTP_FOR_RESETPASSWORD,
    CUSTOMER_PROFILE_DETIALS_BY_PHONE,
    DIGILOCKER_AADHAAR_NUMBER_VERIFICATION,
    GET_USER_ROLES,
    C2C_CALLBACK,
    DEACTIVATE_LOAD_BY_ID,
    DEACTIVATE_LORRY_BY_ID,
    LOGOUT,
    ADD_LORRY_COMMENT,
    ADD_LOAD_COMMENT,
    GET_LORRY_COMMENT,
    GET_LOAD_COMMENT,
    PREMIUM_BULK_LOAD_EDIT,
    PREMIUM_BULK_LOAD_PUBLISH,
    PREMIUM_BID_ACCEPT_OR_REJECT,
    PREMIUM_BULK_LOAD_DELETE,
    PREMIUM_TRIP_GET_TRACKING_LOCATION,
    PREMIUM_TRIP_GET_SIM_TRACK,
    PREMIUM_CLIENT_LIST,
    PREMIUM_REQUEST_PAYMENT_LINK,
    GET_PAYMENT_LINK_DETAILS,
    PREMIUM_RELEASE_PAYMENT,
    PAYMENTS_INFORMATION,
    PREMIUM_PAYMENT_STATUS,
    POST_BULK_LOAD,
    BULK_LOAD_POSTING_STATUS,
    ALL_BULK_LOADS,
    EDIT_LOAD,
    ATTACH_LORRY_TO_BID,
    GET_TRANSACTION_DETAILS,
    LOAD_MY_BIDS,
    LORRY_MY_BIDS,
    LOAD_LORRY_GET_BID_INFO,
    VERCEL_USER_AGENT,
    MISC_UPLOAD_IMAGE,
    GET_USER_REPORTS,
    GET_COMPANY_POSTING_AND_BIDDING_LIMIT,
    GET_KAM_DETAILS_BY_COMPANY_ID,
    CREATE_TICKET,
    GET_TICKETS,
    GET_LOAD_TICKETS,
    UPDATE_TICKET_STATUS,
    GET_TICKET_BY_ID,
    CALL_ME_BACK_REQUEST,
    TICKET_HELP_REQUEST,
    ASSIGN_TICKET,
    RE_ASSIGN_ALL_TICKET,
    VERIFY_AADHAAR_NUMBER_AND_GET_OTP,
    VERIFY_AADHAAR_OTP,
    VERIFY_PAN,
    VERIFY_GST_NUMBER,
    VERIFY_GST_OTP,
    GET_DOCUMENTS,
    UPLOAD_DOCUMENTS,
    TAG_USER,
    UNTAG_USER,
    GET_TAGGED_USERS,
    GET_USER_ACTION_VALIDATION,
    GET_USER_LOAD_LORRY_POSTINGS_BIDS_COUNTS,
    GET_CS_USER_ROLES,
    GET_CS_USER_OPERATIONS,
    GET_CS_USERS,
    GET_CS_USER_DETAILS,
    GET_CS_USER_ROLE_OPERATIONS,
    UPDATE_CS_USER_ROLE_OPERATIONS,
    UPDATE_CS_USER,
    DELETE_CS_USER,
    ADD_CS_USER,
    GET_VAS_PLANS,
    GET_VAS_PLAN_BY_ID,
    SEND_VAS_LINK,
    RAZORPAY_PAYMENT_LINK,
    VAS_MEMBERSHIP_RECENT,
    VAS_MEMBERSHIP_HISTORY,
    VAS_ADD_GPS,
    VAS_GPS_HISTORY,
    VAS_GPS_STATE,
    VAS_CARGO_HISTORY,
    VAS_CARGO_HISTORY_ADMIN,
    VAS_CARGO_PREMIUM,
    VAS_ADD_CARGO,
    VAS_CARGO_MATERIAL_LIST,
    UPDATE_REMARKS,
    VERIFY_LORRY_FROM_SIGNZY,
    LOADS_ENQUIRY_CARD,
    LORRY_ENQUIRY_CARD,
    TAG_AGENT_CUSTOMER_LOADS_POSTED,
    TAG_AGENT_CUSTOMER_LORRIES_POSTED,
    ALL_CUSTOMERS_ENQUIRY_CARD,
    GET_BANK_DETAILS,
    ADD_BANK_DETAILS,
    ADD_VPA_DETAILS,
    DEL_BANK_DETAILS,
    BIDS_PAYMENT_INFO,
    INVOICE_GENERATE_BILL,
    LOAD_MARKET_V2,
    LOAD_MARKET_V2_NEW,
    COMPANIES_INFO,
    LAT_LONG_BY_PLACE_ID,
    LORRY_MARKET_V2,
    POPULAR_LANE_FOR_CITY,
    POPULAR_CITIES,
    POPULAR_LANE_FOR_COUNTRY,
    PRICE_RECOMMENDATION,
    GET_SHORT_LINK,
    PAYMENT_REPORT,
    LOAD_REASSIGN,
    LOAD_REASSIGN_V2,
    BULK_TAG,
    BULK_UNTAG,
    CREATE_VAS_TICKET,
    UPDATE_EXPECTED_AMOUNT,
    UPDATE_PREFERRED_AMOUNT,
    GET_BOOKING_AMOUNT,
    CALCULATE_PAYMENT_BREAKUP,
    GET_CASHBACK_USAGE_LIMIT,
    GET_PAYMENT_LEDGER,
    TRUE_CALLER_REGISTRATION,
    CREATE_VAS_TICKET,
    REPORT_UPDATE_DISPOSITION,
    ADD_PROFILE_DISPOSITION,
    GET_PROFILE_DISPOSITION,
    ADMIN_NOTIFICATION,
    ADMIN_SEND_JOURNEY_FEEDBACK,
    GET_DISPOSITION_HISTORY,
    UPDATE_BID_TIME_INFO,
    GET_LORRY_LOCATION_HISTORY,
    GET_LORRY_CURRENT_LOCATION_TRIPS_LIST,
    GET_REVERSE_GEO_POINT,
    GET_LORRY_LOCATION_DETAILS,
    UPDATE_LORRY_ROUTES,
    DELETE_DOCUMENT,
    ADD_DRIVER_DETAILS,
    ATTACH_DRIVER_TO_LORRY,
    REMOVE_DRIVER_FROM_LORRY,
    ENABLE_SIM_TRACK,
    EDIT_SIM_TRACK,
    SEND_CONSENT_SIM_TRACK,
    ASSURED_LOAD_CANCEL,
    UPDATE_BID_BY_ID,
    UPDATE_LOAD_DETAILS,
    UPDATE_LOAD_ADDRESS,
    USER_LORRY_INCENTIVE_INFO,
    CALL_INITIATE,
    CONFERENCE_INITIATE,
    CONFERENCE_KICKOUT,
    CONFERENCE_END,
    TSO_VISIT_CHECK_IN_AND_OUT,
    TSO_SESSIONS,
    UPDATE_CS_ATTENDANCE,
    GET_CS_ATTENDANCE,
    GET_CS_TEAM_ATTENDANCE,
    UPDATE_BID_META_DETAILS,
    CHECK_ELIGIBILITY,
    GET_AGGREGATE_BID_BY_COMPANYID,
    ADD_CASHBACK_COIN,
    GET_AGENT_TEAM_STATUS,
    GET_EVENT_HISTORY,
    UPDATE_LOAD_JOURNEY_INFO,
    GET_LOAD_JOURNEY_INFO,
    GET_LOAD_TRIP_SUMMARY,
    CALCULATE_ROUTES_DISTANCE,
    UPDATE_ADMIN_NOTIFICATION_STATUS,
    GET_PAST_JOURNEY_COUNT
};


//# sourceMappingURL=const.js.map


/***/ }),

/***/ 20798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_USER_BID_TYPES */
var GET_USER_BID_TYPES;
(function (GET_USER_BID_TYPES) {
    GET_USER_BID_TYPES[GET_USER_BID_TYPES["SENT"] = 0] = "SENT";
    GET_USER_BID_TYPES[GET_USER_BID_TYPES["RECEIVED"] = 1] = "RECEIVED";
})(GET_USER_BID_TYPES || (GET_USER_BID_TYPES = {}));


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 45017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useDeactivateLorry; },
/* harmony export */   "Q": function() { return /* binding */ useDeactivateLoad; }
/* harmony export */ });
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41634);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37528);
/* harmony import */ var _hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49352);





function useDeactivateLorry() {
    const { POST } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const deactivateLorry = ({ lorryId }) => {
        const payload = { lorry_id: lorryId };
        return POST(_const_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DEACTIVATE_LORRY_BY_ID */ .Z.DEACTIVATE_LORRY_BY_ID, payload);
    };
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useVahakMutationQuery */ .M8)(_hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.userLorries.deactivateLorry */ ._.userLorries.deactivateLorry, deactivateLorry);
}
const useDeactivateLoad = () => {
    const { POST } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const deactivateLoad = (data) => {
        const requestBody = {
            id: data.loadId,
            user_feedback: data.userFeedback
        };
        return POST(_const_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DEACTIVATE_LOAD_BY_ID */ .Z.DEACTIVATE_LOAD_BY_ID, Object.assign({}, requestBody));
    };
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useVahakMutationQuery */ .M8)(_hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.userLoads.deactivateLoadById */ ._.userLoads.deactivateLoadById, deactivateLoad);
};


//# sourceMappingURL=deactivateLoadLorry.service.js.map


/***/ }),

/***/ 99891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ FaqService; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80230);



function getAllCategories() {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        return { faqCategs: _constants_Faq_js__WEBPACK_IMPORTED_MODULE_1__/* .FaqCategories */ .og };
    });
}
function getFaqsByCateg({ categSlug }) {
    var _a;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        const Faqs = _constants_Faq_js__WEBPACK_IMPORTED_MODULE_1__/* .FaqQuestions.filter */ .DC.filter((faqQuestion) => faqQuestion.category === categSlug);
        return { faqs: Faqs, count: ((_a = Faqs[0]) === null || _a === void 0 ? void 0 : _a.faqQuestions.length) || 0 };
    });
}
const FaqService = { getAllCategories, getFaqsByCateg };


//# sourceMappingURL=faq.service.js.map


/***/ }),

/***/ 44681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "db": function() { return /* binding */ db; },
  "xS": function() { return /* reexport */ esm_index_esm/* fetchAndActivate */.xS; },
  "IN": function() { return /* binding */ readRemoteConfigValue; },
  "Sn": function() { return /* binding */ remoteConfig; }
});

// EXTERNAL MODULE: ../../node_modules/@firebase/app/dist/esm/index.esm2017.js
var index_esm2017 = __webpack_require__(85500);
;// CONCATENATED MODULE: ../../node_modules/firebase/app/dist/esm/index.esm.js



var index_esm_name = "firebase";
var version = "11.0.2";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(0,index_esm2017/* registerVersion */.KN)(index_esm_name, version, 'app');
//# sourceMappingURL=index.esm.js.map

// EXTERNAL MODULE: ../../node_modules/firebase/firestore/dist/esm/index.esm.js + 3 modules
var index_esm = __webpack_require__(97357);
// EXTERNAL MODULE: ../../node_modules/firebase/remote-config/dist/esm/index.esm.js + 2 modules
var esm_index_esm = __webpack_require__(57214);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
;// CONCATENATED MODULE: ../core/dist/_services/firebase.service.js






const firebaseConfig = {
    apiKey: "AIzaSyCP0_dpMdpG5BS2RzOLRnVMBVC2Mr9Bn6E",
    authDomain: "vahak-792f1.firebaseapp.com",
    databaseURL: "https://vahak-792f1.firebaseio.com",
    projectId: "vahak-792f1",
    storageBucket: "vahak-792f1.appspot.com",
    messagingSenderId: "904684158234",
    appId: "1:904684158234:web:13796dede6ee47308b40a3",
    measurementId: "G-TYVBD4J5WZ"
};
const app = !(0,index_esm2017/* getApps */.C6)().length ? (0,index_esm2017/* initializeApp */.ZF)(firebaseConfig) : (0,index_esm2017/* getApp */.Mq)();
const db = (0,index_esm/* getFirestore */.ad)(app);
let remoteConfig = null;
// Only load Remote Config on the client
if (typeof window !== "undefined") {
    remoteConfig = (0,esm_index_esm/* getRemoteConfig */.sN)(app);
    remoteConfig.settings = {
        minimumFetchIntervalMillis: 300000
    };
    remoteConfig.defaultConfig = {
        welcome_message: "Hello!"
    };
}
function readRemoteConfigValue(config, _keyName, format, fallback) {
    var _a, _b, _c;
    const keyName = _services_const/* IS_PROD_ENV */.c ? _keyName : `test_${_keyName}`;
    if (!config)
        return fallback;
    try {
        switch (format) {
            case "json": {
                const raw = (0,esm_index_esm/* getString */.KF)(config, keyName);
                return (raw ? JSON.parse(raw) : fallback);
            }
            case "string":
                return ((_a = (0,esm_index_esm/* getString */.KF)(config, keyName)) !== null && _a !== void 0 ? _a : fallback);
            case "number":
                return ((_b = (0,esm_index_esm/* getNumber */.Dx)(config, keyName)) !== null && _b !== void 0 ? _b : fallback);
            case "bool":
                return ((_c = (0,esm_index_esm/* getBoolean */.Pf)(config, keyName)) !== null && _c !== void 0 ? _c : fallback);
            default:
                return fallback;
        }
    }
    catch (err) {
        console.warn(`Failed to read remote config value for key "${keyName}"`, err);
        return fallback;
    }
}


//# sourceMappingURL=firebase.service.js.map


/***/ }),

/***/ 49352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ QueryNames; }
/* harmony export */ });
const QueryNames = {
    loadSearch: "loadSearch",
    lorrySearch: "lorrySearch",
    loadsForCurrentUser: "loadsForCurrentUser",
    lorriesForCurrentUser: "lorriesForCurrentUser",
    postLoad: "postLoad",
    postLorry: "postLorry",
    bidHistory: "bidHistory",
    validateToken: "validateToken",
    routesByCompanyId: "routesByCompanyId",
    userProfile: "userProfile",
    getDigilockerVerificationUrl: "getDigilockerVerificationUrl",
    businessCardDetails: "businessCardDetails",
    bidTransaction: "bidTransaction",
    companyAddressList: "companyAddressList",
    companyReviewList: "companyReviewList",
    companyRouteDetails: "companyRouteDetails",
    transporters: {
        getTransporterList: "getTransporterList"
    },
    userLorries: {
        getLorriesByCategory: "getLorriesByCategory",
        getLorryById: "lorryInfoById",
        getLorryRoutes: "lorryRoutes",
        getLorriesByCompanyId: "lorriesByCompanyId",
        getLorryBidsById: "lorryBidsById",
        getLorryInfoById: "lorryInfoById",
        getLiveLorries: "getLiveLorries",
        deactivateLorry: "deactivateLorry",
        deleteLorry: "deleteLorry",
        reactivateLorry: "reactivateLorry",
        verifyLorryFromSignzy: "verifyLorryFromSignzy"
    },
    userLoads: {
        getLoadsByCompanyId: "loadsByCompanyId",
        getLoadInfoById: "loadInfoById",
        getLoadBidsById: "loadBidsById",
        getLiveLoads: "getLiveLoads",
        getTransportersByLoadId: "getTransportersByLoadId",
        deactivateLoadById: "deactivateLoadById",
        adminVerifyLoad: "adminVerifyLoad",
        adminDeactivateLoad: "adminDeactivateLoad",
        getLoadStops: "getLoadStops",
        getAggregateBidByCompanyId: "getAggregateBidByCompanyId"
    },
    loadComments: {
        addLoadComment: "addLoadComment",
        getLoadComment: "getLoadComment"
    },
    lorryComments: {
        addLorryComment: "addLorryComment",
        getLorryComment: "getLorryComment"
    },
    premium: {
        editBulkLoad: "editBulkLoad",
        publishBulkLoad: "publishBulkLoad",
        updateBidStatus: "updateBidStatus",
        premiumLoadList: "premiumLoadList",
        deleteBulkLoad: "deleteBulkLoad",
        multipleBidNegotiation: "multipleBidNegotiation",
        getTrackingDetails: "getTrackingDetails",
        getPremiumClientList: "getPremiumClientList",
        requestPaymentLink: "requestPaymentLink",
        getPaymentLinkDetails: "getPaymentLinkDetails",
        getSimTrack: "getSimTrack",
        getPaymentReleased: "getPaymentReleased",
        getPaymentsInformation: "getPaymentsInformation",
        getPaymentStatus: "getPaymentStatus",
        bulkLoadList: "bulkLoadList",
        getKamDetails: "getKamDetails"
    },
    ticketSystem: {
        createTicket: "createTicket",
        getTickets: "getTickets",
        getLoadTicket: "getLoadTicket",
        updateTicketStatus: "updateTicketStatus",
        getTicketById: "getTicketById",
        tagUser: "tagUser",
        untagUser: "untagUser",
        getLoadByDisposition: "getLoadByDisposition",
        getDispositionHistory: "getDispositionHistory",
        assignTicket: "assignTicket"
    },
    bulkUpload: {
        load: "bulkLoad",
        bulkLoadStatus: "bulkLoadStatus"
    },
    blockUser: "blockUser",
    unBlockUser: "unBlockUser",
    sendWhatsAppMessage: "sendWhatsAppMessage",
    getCashbackStatus: "getCashbackStatus",
    editLorry: "editLorry",
    editLoad: "editLoad",
    auth: {
        sendOTP: "sendOTP",
        sendWaOTP: "sendWaOTP",
        verifyOtp: "verifyOtp"
    },
    searchCompanyByPhoneNumber: "searchCompanyByPhoneNumber",
    kyc: {
        getAadhaarOtp: "getAadhaarOtp",
        verifyAadhaarOtp: "verifyAadhaarOtp",
        verifyPanNumber: "verifyPanNumber",
        getGstOtp: "getGstOtp",
        verifyGstOtp: "verifyGstOtp"
    },
    getCompanyPostingAndBiddingLimit: "get-company-posting-and-bidding-limit",
    getDocuments: "getDocuments",
    deleteDocuments: "deleteDocuments",
    getDocumentsNonMutate: "getDocumentsNonMutate",
    callMeBackMutate: "callMeBackMutate",
    helpRequest: "helpRequest",
    userActionValidation: "userActionValidation",
    dashboardUser: {
        getCSUsers: "getCSUsers",
        getCSUserDetails: "getCSUserDetails",
        getCSRoles: "getCSRoles",
        getCSOperations: "getCSOperations",
        getCSRoleOperations: "getCSRoleOperations",
        updateCSRoleOperations: "updateCSRoleOperations",
        addCSUser: "addCSUser",
        editCSUser: "editCSUser",
        deleteCSUser: "deleteCSUser",
        getTaggedUserTSO: "getTaggedUserTSO",
        reassignLoad: "reassignLoad",
        getAttendance: "getAttendance",
        updateAttendance: "updateAttendance",
        getCSTeamStatus: "getCSTeamStatus"
    },
    GetLoadLorryPostingBiddingCounts: "GetLoadLorryPostingBiddingCounts",
    vas: {
        getVASPlans: "getVASPlans",
        getVASPlanById: "getVASPlanById",
        sendVasPaymentLink: "sendVasPaymentLink",
        buyVASPlans: "buyVASPlans",
        // membership
        membershipHistory: "membershipHistory",
        membershipRecent: "membershipRecent",
        // GPS
        getGpsHistory: "getGpsHistory",
        vasAddGPS: "vasAddGPS",
        vasGpsState: "vasGpsState",
        // cargo
        getCargoHistory: "getCargoHistory",
        getCargoPremium: "getCargoPremium",
        vasAddCargo: "vasAddCargo",
        vasCargoMaterialsList: "vasCargoMaterialsList"
    },
    updateRemarks: "updateRemarks",
    membership: {
        getMembershipPlans: "getMembershipPlans"
    },
    getMarketLoadList: "getMarketLoadList",
    getLoadAllData: "getLoadAllData",
    getLorryAllDataV2: "getLorryAllDataV2",
    getAllLorryDataInfinityQueryV2: "getAllLorryDataInfinityQueryV2",
    bank: {
        getBankDetails: "getBankDetails",
        addNew: "addNew"
    },
    generateBill: "generateBill",
    bidsPaymentsInfo: "bidsPaymentsInfo",
    pastLoads: "pastLoads",
    priceRecommendation: "priceRecommendation",
    popularLane: "popularLane",
    popularCities: "popularCities",
    companyRoutes: "companyRoutes",
    nearByCities: "nearByCities",
    reportSystem: {
        paymentReportSystem: "paymentReportSystem"
    },
    userProfileDisposition: "userProfileDisposition",
    getProfileDisposition: "getProfileDisposition",
    load: {
        updateExpectedAmount: "updateExpectedAmount",
        preferredAmount: "preferredAmount",
        cancel: "cancel"
    },
    bid: {
        bookingAmount: "bookingAmount"
    },
    adminDashboard: {
        notify: "notify"
    },
    generatePayment: "generatePayment",
    searchLocation: "searchLocation",
    payment: {
        cashBackLimit: "cashbackLimit",
        ledger: "ledger",
        calculatePaymentBreakup: "calculatePaymentBreakup"
    },
    tso: {
        checkInAndOut: "tso-check-in-and-out",
        sessions: "tso-sessions"
    },
    call: {
        initiate: "initiate",
        conferenceInitiate: "conferenceInitiate",
        conferenceEnd: "conferenceEnd",
        conferenceKick: "conferenceKick"
    }
};


//# sourceMappingURL=queryNames.js.map


/***/ }),

/***/ 26231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useValidateToken; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63118);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49352);






function useValidateToken({ token, refetchInterval, enabled }) {
    const { data } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([_queryNames_js__WEBPACK_IMPORTED_MODULE_4__/* .QueryNames.validateToken */ ._.validateToken, token], () => {
        if (!token) {
            return false;
        }
        return fetch(`${_const_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].VALIDATE_TOKEN */ .Z.VALIDATE_TOKEN}?t=Bearer ${token}`).then((res) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            if (res.status === 200) {
                return true;
            }
            else {
                if (res.status === 401) {
                    // Unauthorized
                    _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_2__/* .toast.dismiss */ .A.dismiss();
                    yield res.json();
                    // toast.error(message ? message : "Session Expired");
                }
                return false;
            }
        }));
    }, { refetchInterval, enabled, refetchOnWindowFocus: false });
    return { data };
}


//# sourceMappingURL=useAuthService.js.map


/***/ }),

/***/ 635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useUnBlockUsers; },
/* harmony export */   "w": function() { return /* binding */ useBlockUsers; }
/* harmony export */ });
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49352);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37528);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);





const useBlockUsers = () => {
    const { POST } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    function blockUser(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(_const_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BLOCK_USERS */ .Z.BLOCK_USERS, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useVahakMutationQuery */ .M8)(_queryNames_js__WEBPACK_IMPORTED_MODULE_0__/* .QueryNames.blockUser */ ._.blockUser, blockUser);
};
const useUnBlockUsers = () => {
    const { POST } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    function unBlockUser(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(_const_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UNBLOCK_USERS */ .Z.UNBLOCK_USERS, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useVahakMutationQuery */ .M8)(_queryNames_js__WEBPACK_IMPORTED_MODULE_0__/* .QueryNames.unBlockUser */ ._.unBlockUser, unBlockUser);
};


//# sourceMappingURL=useBlockUserService.js.map


/***/ }),

/***/ 10182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ WebsiteUserType; },
  "f": function() { return /* binding */ useEventTrackerService; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ../core/dist/methods/getABTestVariations.js
const getVwoABTestVariationsEventData = (campaignData) => {
    let eventData = {};
    for (const id in campaignData) {
        eventData[`campaign_${id}`] = campaignData[id];
    }
    return eventData;
};


//# sourceMappingURL=getABTestVariations.js.map

// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useEventTrackerService.js







var WebsiteUserType;
(function (WebsiteUserType) {
    WebsiteUserType["ADMIN"] = "Admin";
    WebsiteUserType["CLIENT"] = "Client";
    WebsiteUserType["TSO"] = "tso";
})(WebsiteUserType || (WebsiteUserType = {}));
function getDevice() {
    var _a;
    const userAgent = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
    if (/android/i.test(userAgent)) {
        return "Mobile (Android)";
    }
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "Mobile (iOS)";
    }
    if (/windows phone/i.test(userAgent)) {
        return "Mobile (Windows Phone)";
    }
    return "Desktop";
}
function useEventTrackerService() {
    const router = (0,next_router.useRouter)();
    const { globalData = {}, setGlobalData } = (0,react.useContext)(app_context/* AppContext */.Il);
    const { utm = {} } = globalData;
    const { utm_source, utm_medium, utm_campaign } = router.query;
    const { isTso } = (0,useCsDashboard/* useCsDashboard */.Z)();
    const utmFromQuery = {
        utm_source,
        utm_medium,
        utm_campaign
    };
    (0,react.useEffect)(() => {
        setGlobalData === null || setGlobalData === void 0 ? void 0 : setGlobalData(Object.assign(Object.assign({}, globalData), { utm: utmFromQuery }));
    }, []);
    const { name, userId, companyId, serviceType, companyLocation, customerName, customerCompanyId, customerCompanyLocation, customerServiceType, customerPhone, phoneNum, isCsDashboardUser, abTestVariations, thirdPartyCompanyName } = (0,react.useContext)(app_context/* AppContext */.Il);
    const NOT_APPLICABLE = "#N/A";
    const sendGAandMoEngageEvent = (eventData, trackGAEvent = true, trackMoengageEvent = true, trackFbCapiEvent = false) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        let data = Object.assign(Object.assign(Object.assign(Object.assign({ event_source: "web", user_id: userId !== null && userId !== void 0 ? userId : NOT_APPLICABLE, company_id: (_a = customerCompanyId !== null && customerCompanyId !== void 0 ? customerCompanyId : companyId) !== null && _a !== void 0 ? _a : NOT_APPLICABLE, company_location: (_b = customerCompanyLocation !== null && customerCompanyLocation !== void 0 ? customerCompanyLocation : companyLocation) !== null && _b !== void 0 ? _b : NOT_APPLICABLE, services: (_c = customerServiceType !== null && customerServiceType !== void 0 ? customerServiceType : serviceType) !== null && _c !== void 0 ? _c : NOT_APPLICABLE, user_type: isCsDashboardUser ? "Admin" : "Client", third_party_company_name: thirdPartyCompanyName !== null && thirdPartyCompanyName !== void 0 ? thirdPartyCompanyName : NOT_APPLICABLE, web_device: getDevice() }, (isTso && {
            user_type: "tso"
        })), getVwoABTestVariationsEventData(abTestVariations)), utm), eventData.data);
        if (trackGAEvent) {
            let keysToDelete = [
                ...[
                    "is_premium",
                    "is_insurance_activated",
                    "load_type",
                    "from_location",
                    "from_location_id",
                    "from_location_city_id",
                    "from_location_state_id",
                    "to_location",
                    "to_location_id",
                    "to_location_city_id",
                    "to_location_state_id",
                    "material",
                    "quantity",
                    "quantity_type",
                    "required_vehicle_type",
                    "required_body_type",
                    "required_tyres",
                    "loading_time",
                    "recommended_price",
                    "expected_price",
                    "expected_price_type",
                    "payment_type",
                    "advance_percentage",
                    "odc",
                    "odc_length",
                    "odc_breadth",
                    "odc_height"
                ],
                ...[
                    "vehicle_number",
                    "current_location",
                    "current_location_id",
                    "current_location_city_id",
                    "current_location_state_id",
                    "routes",
                    "total_route",
                    "lorry_type",
                    "lorry_capacity",
                    "capacity_type",
                    "total_tyres",
                    "body_type",
                    "vehicle_size",
                    "vehicle_size_type"
                ],
                ...["bid_amount", "submitted_by", "bid_type", "amount", "sent_bid_amount"],
                ...[
                    "profile_user_id",
                    "profile_user_name",
                    "profile_company_id",
                    "profile_company_name",
                    "profile_location",
                    "profile_service_type",
                    "profile_connections",
                    "profile_phone_number",
                    "total_connections"
                ]
            ];
            const dataCloned = Object.assign({}, data);
            keysToDelete.forEach((key) => delete dataCloned[key]);
            (0,user_analytics_service/* ga4sendEvent */.zs)(eventData.name, Object.assign({}, dataCloned));
        }
        if (trackMoengageEvent) {
            (0,user_analytics_service/* moEngageUserEventTrack */.Im)(eventData.name, Object.assign({ user_name: NOT_APPLICABLE, company_name: (_d = customerName !== null && customerName !== void 0 ? customerName : name) !== null && _d !== void 0 ? _d : NOT_APPLICABLE, phone_number: (_e = customerPhone !== null && customerPhone !== void 0 ? customerPhone : phoneNum) !== null && _e !== void 0 ? _e : NOT_APPLICABLE }, data));
        }
        if (trackFbCapiEvent) {
            const resolvedCompanyId = customerCompanyId !== null && customerCompanyId !== void 0 ? customerCompanyId : companyId;
            const eventID = (0,user_analytics_service/* getFBEventId */.$Y)((_g = (_f = eventData.data) === null || _f === void 0 ? void 0 : _f.load_id) !== null && _g !== void 0 ? _g : eventData.name, resolvedCompanyId);
            // Keep Meta payloads small so Pixel `eid` isn't dropped on long GET requests.
            // Full `data` is for GA/MoEngage only — passing it to fbq breaks deduplication.
            const metaCustomData = {};
            if (((_h = eventData.data) === null || _h === void 0 ? void 0 : _h.load_id) != null) {
                metaCustomData.load_id = eventData.data.load_id;
            }
            if (((_j = eventData.data) === null || _j === void 0 ? void 0 : _j.bid_id) != null) {
                metaCustomData.bid_id = eventData.data.bid_id;
            }
            (_k = window.fbq) === null || _k === void 0 ? void 0 : _k.call(window, "trackCustom", eventData.name, metaCustomData, { eventID });
            // void sendFbCapiEvent({
            //     event_id: eventID,
            //     event_name: eventData.name,
            //     phone_num: phone,
            //     custom_data: metaCustomData
            // });
        }
    };
    return { sendGAandMoEngageEvent };
}


//# sourceMappingURL=useEventTrackerService.js.map


/***/ }),

/***/ 28029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H8": function() { return /* binding */ handleGetDigilockerVerificationUrlResponse; },
/* harmony export */   "il": function() { return /* binding */ useGetDigilockerVerificationUrl; }
/* harmony export */ });
/* unused harmony exports handleAadharNumberVerificationResponse, handleAadharOtpVerificationResponse, handleGstNumberVerificationResponse, handleGstOtpVerificationResponse, useAadharOtpVerification, useGstNumberVerification, useGstOtpVerification */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4913);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21928);
/* harmony import */ var _utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88443);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49352);








function useGetDigilockerVerificationUrl() {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const { isLoading, isError, isSuccess, mutateAsync } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(({ companyId, redirectUrl }) => fetch(`${_const_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DIGILOCKER_AADHAAR_NUMBER_VERIFICATION */ .Z.DIGILOCKER_AADHAAR_NUMBER_VERIFICATION}${(0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_2__/* .getAuthIdParam */ .C)()}&c_i=${companyId}&r_u=${redirectUrl}`, {
        method: "GET",
        headers: Object.assign({}, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__/* .getAuthHeader */ .E)())
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_6__/* .QueryNames.validateToken */ ._.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleGetDigilockerVerificationUrlResponse(mutateFn, aadharNumberVerificationParams) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        return (0,_utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_5__/* .handleMutateResponse */ .u)(mutateFn, aadharNumberVerificationParams);
    });
}
function handleAadharNumberVerificationResponse(mutateFn, aadharNumberVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, aadharNumberVerificationParams);
    });
}
function useAadharOtpVerification() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ aadharClientId, companyId, otp }) => fetch(`${API.VERIFY_AADHAAR_OTP}${getAuthIdParam()}`, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: Number(companyId),
            client_id: aadharClientId,
            otp: Number(otp)
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleAadharOtpVerificationResponse(mutateFn, aadharOtpVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, aadharOtpVerificationParams);
    });
}
function useGstNumberVerification() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ gstNumber, companyId }) => fetch(`${API.VERIFY_GST_NUMBER}${getAuthIdParam()}&g_n=${gstNumber}&c_i=${companyId}`, {
        method: "GET",
        headers: Object.assign({}, getAuthHeader())
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleGstNumberVerificationResponse(mutateFn, gstNumberVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, gstNumberVerificationParams);
    });
}
function useGstOtpVerification() {
    const queryClient = useQueryClient();
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ gstClientId, companyId, otp }) => fetch(`${API.VERIFY_GST_OTP}${getAuthIdParam()}`, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: Number(companyId),
            client_id: gstClientId,
            otp: Number(otp)
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleGstOtpVerificationResponse(mutateFn, gstOtpVerificationParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, gstOtpVerificationParams);
    });
}


//# sourceMappingURL=useKYCService.js.map


/***/ }),

/***/ 29148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useGetLorryInfo; }
/* harmony export */ });
/* unused harmony export useGetLorryBidsService */
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82066);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49352);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4913);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21928);
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20798);







function useGetLorryInfo({ lorryId, companyId }, queryOptions) {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQueryClient)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([_queryNames_js__WEBPACK_IMPORTED_MODULE_2__/* .QueryNames.userLorries.getLorryInfoById */ ._.userLorries.getLorryInfoById, lorryId], () => fetch(_const_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].USER_LORRY_INFO_BY_ID */ .Z.USER_LORRY_INFO_BY_ID + (0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_3__/* .getAuthIdParam */ .C)(companyId) + `&l_i=${lorryId}&n_i=0`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__/* .getAuthHeader */ .E)())
    })
        .then((res) => {
        if (res.ok) {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
        else {
            if (res.status === 401)
                queryClient.invalidateQueries();
            throw new Error("LoadInfo API failed");
        }
    })
        .catch((error) => {
        throw new Error(error);
    }), Object.assign(Object.assign({}, queryOptions), { enabled: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.enabled, onError: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.onError }));
}
function useGetLorryBidsService({ lorryId, companyId, type }, queryOptions) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.userLorries.getLorryBidsById, lorryId, type], () => fetch((type === GET_USER_BID_TYPES.RECEIVED
        ? API.USER_LORRY_RECEIVED_BIDS_BY_ID
        : API.USER_LORRY_SENT_BIDS_BY_ID) +
        getAuthIdParam() +
        `&l_i=${lorryId}&c_i=${companyId}&preload=company_details&preload=load_details&preload=lorry_details`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    })
        .then((res) => {
        if (res.ok) {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
        else {
            if (res.status === 401)
                queryClient.invalidateQueries();
            throw new Error("LoadInfo API failed");
        }
    })
        .catch((error) => {
        throw new Error(error);
    }), {
        enabled: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.enabled,
        onError: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.onError,
        select: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.select
    });
}


//# sourceMappingURL=useLoadLorryService.js.map


/***/ }),

/***/ 53171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ useGetLorriesForCurrentUserQuery; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../core/dist/_services/utils/validateAndConvertReqParamToNum.js + 38 modules
var validateAndConvertReqParamToNum = __webpack_require__(43464);
// EXTERNAL MODULE: ../core/dist/methods/getAuthIdParam.js
var getAuthIdParam = __webpack_require__(4913);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/_services/utils/getAuthHeader.js
var getAuthHeader = __webpack_require__(21928);
;// CONCATENATED MODULE: ../core/dist/_services/utils/getInfiniteQueryCurrentDataLength.js
function getInfiniteQueryCurrentDataLength(data) {
    return ((data === null || data === void 0 ? void 0 : data.pages.reduce((counter, page) => {
        return counter + page.results.length;
    }, 0)) || 0);
}


//# sourceMappingURL=getInfiniteQueryCurrentDataLength.js.map

// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/methods/formatDate.js
var formatDate = __webpack_require__(11663);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useLorryMarketService.js










































function useGetLorriesForCurrentUserQuery({ companyId, type, status, request_type = api/* API_REQUEST_TYPE.ELASTIC_SEARCH */.wU.ELASTIC_SEARCH, created_at_string, id, preloads = [] }, { enabled, refetchInterval, onSuccess }) {
    const queryClient = (0,es.useQueryClient)();
    const { data, fetchNextPage, hasNextPage, isFetching, isLoading, refetch } = (0,es.useInfiniteQuery)([queryNames/* QueryNames.lorrySearch */._.lorrySearch, companyId, type, status, request_type, created_at_string, id], ({ pageParam = 1 }) => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
        const validatedCompanyId = (0,validateAndConvertReqParamToNum/* validateAndConvertReqParamToInt */.U)("companyId", companyId);
        if (!validatedCompanyId) {
            return { results: [], next: undefined };
        }
        const response = yield fetch(_services_const/* default.ALL_LORRIES */.Z.ALL_LORRIES + (0,getAuthIdParam/* getAuthIdParam */.C)(), {
            body: JSON.stringify({
                company_id: validatedCompanyId,
                page_number: pageParam,
                request_type,
                status,
                created_at_string,
                type,
                id,
                preload: ["bid_infos", "company_detail", "lorry_details", ...preloads]
            }),
            method: "POST",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (0,getAuthHeader/* getAuthHeader */.E)())
        });
        if (response.status === 401) {
            // this will cause the AuthVerifyComp to re-render and when token verification fails, logout the app
            queryClient.invalidateQueries(queryNames/* QueryNames.validateToken */._.validateToken);
        }
        if (!response.ok) {
            throw new Error("Problem fetching data");
        }
        const dataFromServer = yield response.json();
        const data = {
            results: dataFromServer.data.lorry_cards,
            totalCount: dataFromServer.data.total_records,
            next: pageParam < dataFromServer.data.total_pages ? pageParam + 1 : undefined
        };
        return data;
    }), {
        getNextPageParam: (lastPage) => lastPage.next,
        refetchInterval: refetchInterval || false,
        enabled,
        onSuccess: (data) => {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
        }
    });
    return {
        data,
        fetchNextPage,
        hasNextPage,
        currentDataLength: getInfiniteQueryCurrentDataLength(data),
        isFetching,
        isLoading,
        refetch
    };
}


//# sourceMappingURL=useLorryMarketService.js.map


/***/ }),

/***/ 86474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l4": function() { return /* binding */ useLorryRoutes; }
/* harmony export */ });
/* unused harmony exports handleLorryEdit, useDeleteLorry, useGetLorryById */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37528);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4913);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41634);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21928);
/* harmony import */ var _utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88443);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49352);










/**
 * Get Lorry by Id
 */
function useGetLorryById(lorryId, options) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.userLorries.getLorryById, lorryId], () => fetch(`${API.USER_LORRY_INFO_BY_ID}${getAuthIdParam()}&l_i=${lorryId}`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries();
            return;
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select
    });
}
/**
 * Get Routes of lorry
 */
function useLorryRoutes(lorryId, options) {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([_queryNames_js__WEBPACK_IMPORTED_MODULE_8__/* .QueryNames.userLorries.getLorryRoutes */ ._.userLorries.getLorryRoutes, lorryId], () => fetch(`${_const_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].USER_LORRY_ROUTES_BY_ID */ .Z.USER_LORRY_ROUTES_BY_ID}${(0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_4__/* .getAuthIdParam */ .C)()}&l_i=${lorryId}`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_6__/* .getAuthHeader */ .E)())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries();
            return;
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select
    });
}
function handleLorryEdit(mutateFn, EditLorryParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, EditLorryParams);
    });
}
function useDeleteLorry() {
    const { POST } = useVahakHttpClient();
    const deleteLorry = ({ lorryId }) => {
        const payload = { id: lorryId };
        return POST(API.USER_DELETE_LORRY, payload);
    };
    return useVahakMutationQuery(QueryNames.userLorries.deleteLorry, deleteLorry);
}


//# sourceMappingURL=useLorryService.js.map


/***/ }),

/***/ 7941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O5": function() { return /* binding */ handleLoadPostResponse; },
/* harmony export */   "Qc": function() { return /* binding */ usePostLoad; },
/* harmony export */   "Zd": function() { return /* binding */ useReactivateLorry; }
/* harmony export */ });
/* unused harmony exports handleLorryPostResponse, handleLorryReactivateResponse, usePostLorry */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49352);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21928);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56203);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4913);
/* harmony import */ var _hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36153);
/* harmony import */ var _hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37528);










function usePostLoad(hookParam) {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const { mutateAsync } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(({ companyId, loadVals, isReposted }) => fetch(_const_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].POST_LOAD */ .Z.POST_LOAD + (0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_6__/* .getAuthIdParam */ .C)(), {
        method: "POST",
        headers: Object.assign({}, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__/* .getAuthHeader */ .E)()),
        body: JSON.stringify({
            quantity: parseFloat(String(loadVals.qty)),
            capacity: parseFloat(String(loadVals.lorryCapacity)),
            length: parseFloat(String(loadVals.len || 0.0)),
            breadth: parseFloat(String(loadVals.breadth || 0.0)),
            height: parseFloat(String(loadVals.height || 0.0)),
            expected_amount: parseFloat(String(loadVals.amount)),
            material_type: loadVals.material,
            payment_type: Number(loadVals.paymentType),
            is_odc: !!loadVals.isOdc,
            remarks: loadVals.remarks,
            company_id: Number(companyId),
            lorry_id: loadVals.lorryTypeId,
            // source_id: loadVals.src,
            // destination_id: loadVals.dest,
            source_place_id: loadVals.srcPlaceId,
            destination_place_id: loadVals.destPlaceId,
            is_reposted: isReposted || null,
            expected_type: loadVals.isFixedPrice ? 0 : 0,
            total_tyres: loadVals.totalTyres || 0,
            body_type: loadVals.bodyType || 0,
            size: loadVals.size || 0,
            advance_payment_percentage: parseInt(String(loadVals.advancePaymentPercentage || 0), 10),
            size_text: loadVals.sizeText,
            loading_timestamp: loadVals.loadingTimestamp,
            load_ghosting_penalty_deduction: loadVals.loadGhostingPenaltyDeduction,
            spot_load_auction_enabled: true,
            do_dup_check: true,
            is_verified: loadVals === null || loadVals === void 0 ? void 0 : loadVals.isVerified,
            verification_source: loadVals === null || loadVals === void 0 ? void 0 : loadVals.verificationSource,
            stops: loadVals === null || loadVals === void 0 ? void 0 : loadVals.stops
        })
    }), {
        onError: (err) => {
            console.log("err posting", err);
        },
        onMutate: () => queryClient.cancelQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.loadsForCurrentUser */ ._.loadsForCurrentUser),
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.validateToken */ ._.validateToken);
            }
            (hookParam === null || hookParam === void 0 ? void 0 : hookParam.invalidateOnSuccess) && queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.loadsForCurrentUser */ ._.loadsForCurrentUser);
        }
    });
    return { mutateAsync };
}
function usePostLorry(hookParam) {
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutation(({ companyId, lorryVals }) => {
        var _a;
        return fetch(API.POST_LORRY + getAuthIdParam(), {
            method: "POST",
            headers: Object.assign({}, getAuthHeader()),
            body: JSON.stringify({
                company_id: Number(companyId),
                number: (_a = lorryVals.lorryNum) === null || _a === void 0 ? void 0 : _a.toLowerCase().replaceAll(" ", ""),
                capacity: lorryVals.lorryCapacity,
                type: lorryVals.lorryType,
                route_ids: lorryVals.routeIds,
                // documents: lorryVals.documents || null,
                current_place_id: lorryVals.currentPlaceID,
                current_city_id: lorryVals.currentCityId,
                size: lorryVals.lorrySize,
                total_tyres: lorryVals.lorryTyres,
                body_type: lorryVals.lorryBodyType
            })
        });
    }, {
        onMutate: () => queryClient.cancelQueries(QueryNames.lorriesForCurrentUser),
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            (hookParam === null || hookParam === void 0 ? void 0 : hookParam.invalidateOnSuccess) && queryClient.invalidateQueries(QueryNames.lorriesForCurrentUser);
        }
    });
    return { mutateAsync };
}
function useReactivateLorry() {
    const { POST } = (0,_hooks_useVahakHttpClient_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const reactivateLorry = ({ lorryId, currentPlaceID }) => {
        const payload = { lorry_id: lorryId, current_place_id: currentPlaceID };
        return POST(_const_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].REACTIVATE_LORRY */ .Z.REACTIVATE_LORRY, payload);
    };
    return (0,_hooks_useVahakQueryClient_js__WEBPACK_IMPORTED_MODULE_8__/* .useVahakMutationQuery */ .M8)(_queryNames_js__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.userLorries.reactivateLorry */ ._.userLorries.reactivateLorry, reactivateLorry);
}
function handlePostResponse(mutateFn, postingParams) {
    var _a;
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const postedItemRes = yield mutateFn(postingParams);
            if (postedItemRes.status === 200) {
                const postedLoadJson = yield postedItemRes.json();
                return { postedItemId: postedLoadJson.id, success: true, data: postedLoadJson };
            }
            else if (postedItemRes.status === 208) {
                const duplicateLoadJson = yield postedItemRes.json();
                return {
                    postedItemId: (_a = duplicateLoadJson.data) === null || _a === void 0 ? void 0 : _a.id,
                    success: false,
                    data: duplicateLoadJson
                };
            }
            else {
                const error = { message: "An Error Occurred. Please try again after some time." };
                throw error;
            }
        }
        catch (e) {
            react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error(e.message || "An error occurred, please try again");
        }
        return { success: false };
    });
}
function handleLorryPostResponse(mutateFn, postingParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { postedItemId, success } = yield handlePostResponse(mutateFn, postingParams);
        return { lorryId: postedItemId, success };
    });
}
function handleLorryReactivateResponse(mutateFn, postingParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { success } = yield handlePostResponse(mutateFn, postingParams);
        return { success };
    });
}
function handleLoadPostResponse(mutateFn, postingParams) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        const { postedItemId, success, data } = yield handlePostResponse(mutateFn, postingParams);
        return { loadId: postedItemId, success, data };
    });
}


//# sourceMappingURL=usePostingService.js.map


/***/ }),

/***/ 60433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ useUpdateBidService; },
/* harmony export */   "G0": function() { return /* binding */ handleAcceptOrRejectBidResponse; },
/* harmony export */   "Uq": function() { return /* binding */ useGetTransactionListService; },
/* harmony export */   "Vm": function() { return /* binding */ handleSubmitUpdateBidResponse; },
/* harmony export */   "yX": function() { return /* binding */ useReceiverAcceptBidService; }
/* harmony export */ });
/* unused harmony exports handleNegotiateBidResponse, useBidderRejectBidService */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43298);
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2784);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(76705);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52224);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91680);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(22391);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(41634);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _methods_sleep_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(37007);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(63118);
/* harmony import */ var _auth_service_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(11663);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(96762);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(21928);
/* harmony import */ var _utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(88443);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(49352);










































function useGetTransactionListService(mktType, queryParams, options) {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const { loadId, bidderId, companyId, lorryId, notificationId } = queryParams;
    const apiClient = mktType === "load"
        ? _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].LOAD_TRANSACTION_LIST */ .Z.LOAD_TRANSACTION_LIST +
            (0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_30__/* .getAuthIdParam */ .C)() +
            "&l_i=" +
            loadId +
            "&b_i=" +
            bidderId +
            "&c_i=" +
            companyId +
            "&lr_i=" +
            lorryId +
            "&n_i=" +
            notificationId
        : _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].LORRY_TRANSACTION_LIST */ .Z.LORRY_TRANSACTION_LIST +
            (0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_30__/* .getAuthIdParam */ .C)() +
            "&l_i=" +
            lorryId +
            "&b_i=" +
            bidderId +
            "&c_i=" +
            companyId +
            "&ld_i=" +
            loadId +
            "&n_i=" +
            notificationId;
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([_queryNames_js__WEBPACK_IMPORTED_MODULE_39__/* .QueryNames.bidTransaction */ ._.bidTransaction, ...Object.values(queryParams)], () => fetch(apiClient, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_37__/* .getAuthHeader */ .E)())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries();
            return;
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval
    });
}
// To Update Bid
function useUpdateBidService(mktType) {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const apiClient = (mktType === "load" ? _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID */ .Z.LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID : _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID */ .Z.LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID) +
        (0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_30__/* .getAuthIdParam */ .C)();
    // Removed data and error props to remove warning, can be added when need
    const { isLoading, isError, isSuccess, mutateAsync } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(({ lastBidId, amount, requestType }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_37__/* .getAuthHeader */ .E)()),
        body: JSON.stringify({
            bid_id: lastBidId,
            amount,
            type: requestType
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_39__/* .QueryNames.validateToken */ ._.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries([_queryNames_js__WEBPACK_IMPORTED_MODULE_39__/* .QueryNames.bidTransaction */ ._.bidTransaction]);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleSubmitUpdateBidResponse(mutateFn, updateBidParams) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        return (0,_utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_38__/* .handleMutateResponse */ .u)(mutateFn, updateBidParams);
    });
}
function useAcceptOrRejectBidService({ mktType }) {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const apiClient = (mktType === "load" ? _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID */ .Z.LOAD_TRANSACTION_ACCEPT_OR_REJECT_BID : _const_js__WEBPACK_IMPORTED_MODULE_25__/* ["default"].LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID */ .Z.LORRY_TRANSACTION_ACCEPT_OR_REJECT_BID) +
        (0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_30__/* .getAuthIdParam */ .C)();
    // Removed data and error props to remove warning, can be added when need
    const { isLoading, isError, isSuccess, mutateAsync } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(({ lastBidId, tenderer_comment }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_37__/* .getAuthHeader */ .E)()),
        body: JSON.stringify({
            bid_id: lastBidId,
            tenderer_comment: tenderer_comment || "",
            type: _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_2__/* .BID_UPDATE_TYPE.ACCEPT */ .M.ACCEPT
        })
    }), {
        onSuccess: (res) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            if (res.status === 401) {
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_39__/* .QueryNames.validateToken */ ._.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries([_queryNames_js__WEBPACK_IMPORTED_MODULE_39__/* .QueryNames.bidTransaction */ ._.bidTransaction]);
            }
        })
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
// Bidder reject receiver price - load transaction
function useBidderRejectBidService(mktType) {
    const { mutateAsync } = useAcceptOrRejectBidService({
        mktType
    });
    return { mutateAsync };
}
// Receiver accept bid - lorry transaction
function useReceiverAcceptBidService(mktType) {
    const { mutateAsync } = useAcceptOrRejectBidService({
        mktType
    });
    return { mutateAsync };
}
function handleAcceptOrRejectBidResponse(mutateFn, rejectBidParams) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        return (0,_utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_38__/* .handleMutateResponse */ .u)(mutateFn, rejectBidParams);
    });
}
function handleNegotiateBidResponse(mutateRejectBid, rejectBidParams, mutateSubmitBid, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { success } = yield handleMutateResponse(mutateRejectBid, rejectBidParams);
        if (success) {
            yield sleep(800);
            return yield handleMutateResponse(mutateSubmitBid, submitBidParams);
        }
        else {
            return { success };
        }
    });
}


//# sourceMappingURL=useTransactionService.js.map


/***/ }),

/***/ 84327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IP": function() { return /* binding */ handleUpdateCompanyDetails; },
/* harmony export */   "JK": function() { return /* binding */ useUpdateCompanyDetails; },
/* harmony export */   "SX": function() { return /* binding */ useGetUserProfileDetails; }
/* harmony export */ });
/* unused harmony exports handleAddFaq, handleAddOrEditOfficeAddress, handleDeleteOfficeAddress, handleEditFaq, handleUpdateCompanyRouteDetails, handleUploadImage, useAddFaq, useAddOrEditOfficeAddress, useDeleteOfficeAddress, useEditFaq, useGetCompanyReviewDetails, useGetCompanyRouteDetails, useGetLorryByCategory, useGetUserFaq, useUpdateCompanyRouteDetails, useUploadImage */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _const_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4913);
/* harmony import */ var _utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21928);
/* harmony import */ var _utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88443);
/* harmony import */ var _queryNames_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49352);
/* harmony import */ var _utils_validateAndConvertReqParamToNum_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43464);









function useGetUserProfileDetails({ companyId }, options) {
    const authHeader = (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__/* .getAuthHeader */ .E)();
    let preloads = (authHeader === null || authHeader === void 0 ? void 0 : authHeader.token) ? "&preload=agent_details&preload=material_types" : "";
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)([_queryNames_js__WEBPACK_IMPORTED_MODULE_6__/* .QueryNames.userProfile */ ._.userProfile, companyId], () => {
        const validatedCompanyId = (0,_utils_validateAndConvertReqParamToNum_js__WEBPACK_IMPORTED_MODULE_7__/* .validateAndConvertReqParamToInt */ .U)("companyId", companyId);
        if (!validatedCompanyId) {
            return new Promise((res) => res(undefined));
        }
        return fetch(`${_const_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].USER_PROFILE_DETAILS */ .Z.USER_PROFILE_DETAILS}&c_i=${validatedCompanyId}${preloads}`, {
            method: "GET",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, authHeader)
        })
            .then((res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_6__/* .QueryNames.validateToken */ ._.validateToken);
                throw new Error("Some Error Occurred");
            }
            if (res.status >= 400) {
                throw new Error("Some Error Occurred");
            }
            else {
                return res.json().then((jsonData) => {
                    const allData = jsonData.data;
                    return allData;
                });
            }
        })
            .catch(() => {
            throw new Error("Some Error Occurred");
        });
    }, {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select,
        refetchOnWindowFocus: options === null || options === void 0 ? void 0 : options.refetchOnWindowFocus
    });
}
// To Update Company Details
function useUpdateCompanyDetails() {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const apiClient = `${_const_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].UPDATE_COMPANY_DETAILS */ .Z.UPDATE_COMPANY_DETAILS}${(0,_methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_3__/* .getAuthIdParam */ .C)()}`;
    // Removed data and error props to remove warning, can be addded when need
    const { isLoading, isError, isSuccess, mutateAsync } = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useMutation)(({ companyId, languageCode, companyName, serviceType, placeId, logo, routeIds, is_wa_optin, coverPicture, companyBio, establishedIn, mandateKyc, aadhaarVerifiedStatus }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, (0,_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_4__/* .getAuthHeader */ .E)()),
        body: JSON.stringify({
            id: parseInt(companyId),
            language_code: languageCode,
            name: companyName === null || companyName === void 0 ? void 0 : companyName.trim(),
            service_type: serviceType,
            place_id: placeId,
            details: companyBio,
            logo,
            route_ids: routeIds,
            is_wa_optin,
            cover_picture: coverPicture,
            established_in: establishedIn ? Number(establishedIn) : undefined,
            kyc_mandate: mandateKyc,
            is_aadhaar_verified: aadhaarVerifiedStatus
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_6__/* .QueryNames.validateToken */ ._.validateToken);
            }
            if (res.status === 200) {
                // Need to find alternative way to update mutate function data locally
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_6__/* .QueryNames.userProfile */ ._.userProfile);
                queryClient.invalidateQueries(_queryNames_js__WEBPACK_IMPORTED_MODULE_6__/* .QueryNames.companyRouteDetails */ ._.companyRouteDetails);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleUpdateCompanyDetails(mutateFn, updateCompanyDetailsParams) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        return (0,_utils_handleMutateResponse_js__WEBPACK_IMPORTED_MODULE_5__/* .handleMutateResponse */ .u)(mutateFn, updateCompanyDetailsParams);
    });
}
function useGetUserFaq({ companyId }, options) {
    const newOptions = Object.assign(Object.assign({}, options), { select: (data) => data.faqs.map((question) => {
            return { question: question.title, response: question.response, editId: question.id };
        }), enabled: true, staleTime: Infinity, cacheTime: Infinity });
    return useGetUserProfileDetails({ companyId }, newOptions);
}
function useGetLorryByCategory({ params, options }) {
    const queryClient = useQueryClient();
    const { lorry_type, company_id } = params;
    const { enabled, onSuccess, onError, refetchInterval, staleTime, cacheTime, retry } = options;
    return useQuery([QueryNames.userLorries.getLorriesByCategory, company_id, lorry_type], () => {
        const validatedCompanyId = validateAndConvertReqParamToInt("company_id", company_id);
        const validatedLorryType = validateAndConvertReqParamToInt("lorry_type", lorry_type);
        if (!validatedCompanyId || !validatedLorryType) {
            return { data: [] };
        }
        return fetch(`${API.GET_LORRIES_BY_CATEGORY}${getAuthIdParam()}&c_i=${validatedCompanyId}&t=${validatedLorryType}`, {
            method: "GET",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
        })
            .then((res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
                throw new Error("Some Error Occurred");
            }
            if (res.status >= 400) {
                throw new Error("Some Error Occurred");
            }
            else {
                return res.json();
            }
        })
            .catch(() => {
            throw new Error("Service Unavailable");
        });
    }, {
        enabled,
        onSuccess,
        onError,
        refetchInterval,
        staleTime,
        cacheTime,
        retry
    });
}
// To Add Faq
function useAddFaq() {
    const queryClient = useQueryClient();
    const apiClient = `${API.USER_PROFILE_ADD_FAQ}${getAuthIdParam()}`;
    // Removed data and error props to remove warning, can be addded when need arises
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ companyId, questionId, response }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: companyId,
            queries: [
                {
                    id: questionId,
                    response
                }
            ]
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleAddFaq(mutateFn, addFaqBody) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, addFaqBody);
    });
}
// To Edit Faq
function useEditFaq() {
    const queryClient = useQueryClient();
    const apiClient = `${API.USER_PROFILE_EDIT_FAQ}${getAuthIdParam()}`;
    // Removed data and error props to remove warning, can be addded when need arises
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ companyId, questionId, response }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: companyId,
            id: questionId,
            response
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleEditFaq(mutateFn, addFaqBody) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, addFaqBody);
    });
}
// To Add or Update Company Address
function useAddOrEditOfficeAddress() {
    const queryClient = useQueryClient();
    const apiClient = `${API.ADD_EDIT_OFFICE_ADDRESS}${getAuthIdParam()}`;
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ companyId, formattedAddress, landmark, pincode, placeId, id, is_main }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            company_id: parseInt(companyId),
            place_id: placeId,
            formatted_address: formattedAddress,
            id,
            landmark,
            pincode,
            is_main
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries(QueryNames.companyAddressList);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleAddOrEditOfficeAddress(mutateFn, addOrEditOfficeAddressParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, addOrEditOfficeAddressParams);
    });
}
// To Delete Company Address
function useDeleteOfficeAddress() {
    const queryClient = useQueryClient();
    const apiClient = `${API.DELETE_OFFICE_ADDRESS}${getAuthIdParam()}&ad_i=`;
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ addressId }) => fetch(apiClient + addressId, {
        method: "DELETE",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries(QueryNames.companyAddressList);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleDeleteOfficeAddress(mutateFn, deleteOfficeAddressParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, deleteOfficeAddressParams);
    });
}
// Upload profile picture
function useUploadImage() {
    const queryClient = useQueryClient();
    const apiClient = `${API.UPLOAD_IMAGE}${getAuthIdParam()}`;
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ formData }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: formData
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries(QueryNames.userProfile);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleUploadImage(mutateFn, UploadImageParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, UploadImageParams);
    });
}
function useGetCompanyReviewDetails({ companyId }, options) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.companyReviewList], () => fetch(`${API.COMPANY_REVIEW_DETAILS}${getAuthIdParam()}&c_i=${companyId}`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    }).then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries(QueryNames.validateToken);
            throw new Error("Service not available");
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select
    });
}
function useGetCompanyRouteDetails({ companyId }, options) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.companyRouteDetails], () => fetch(`${API.COMPANY_ROUTE_DETAILS}${getAuthIdParam()}&c_i=${companyId}`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    })
        .then((res) => {
        if (res.status === 401) {
            queryClient.invalidateQueries(QueryNames.validateToken);
            throw new Error("Service Unavailable");
        }
        else if (res.status >= 400) {
            throw new Error("Service Unavailable");
        }
        else {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
    })
        .catch((err) => {
        throw new Error(err);
    }), {
        enabled: options === null || options === void 0 ? void 0 : options.enabled,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchInterval: options === null || options === void 0 ? void 0 : options.refetchInterval,
        staleTime: options === null || options === void 0 ? void 0 : options.staleTime,
        cacheTime: options === null || options === void 0 ? void 0 : options.cacheTime,
        select: options === null || options === void 0 ? void 0 : options.select,
        retry: options === null || options === void 0 ? void 0 : options.retry
    });
}
// Update company route
function useUpdateCompanyRouteDetails() {
    const queryClient = useQueryClient();
    const apiClient = `${API.UPDATE_COMPANY_ROUTES}${getAuthIdParam()}`;
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ routeIds, companyId }) => fetch(apiClient, {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            route_ids: routeIds,
            company_id: companyId
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries(QueryNames.companyRouteDetails);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleUpdateCompanyRouteDetails(mutateFn, UpdateCompanyRouteDetailsParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, UpdateCompanyRouteDetailsParams);
    });
}


//# sourceMappingURL=useUserProfileService.js.map


/***/ }),

/***/ 96122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e8": function() { return /* reexport */ auth_service/* AuthService */.e8; },
  "_9": function() { return /* reexport */ queryNames/* QueryNames */._; },
  "yG": function() { return /* reexport */ useEventTrackerService/* WebsiteUserType */.y; },
  "db": function() { return /* reexport */ firebase_service.db; },
  "av": function() { return /* reexport */ user_analytics_service/* moEngageUserAttributeTrack */.av; },
  "C0": function() { return /* reexport */ user_analytics_service/* moEngageUserLogIn */.C0; },
  "kM": function() { return /* reexport */ user_analytics_service/* moEngageUserPhoneNum */.kM; },
  "Qg": function() { return /* reexport */ deactivateLoadLorry_service/* useDeactivateLoad */.Q; },
  "fQ": function() { return /* reexport */ useEventTrackerService/* useEventTrackerService */.f; },
  "YK": function() { return /* reexport */ useHelpRequestTicket; }
});

// UNUSED EXPORTS: AuthServiceAdminConsole, CallMeBackScreen, CareersService, FaqService, GET_USER_BID_TYPES, HelpRequestScreen, LocationSearchSource, PLACE_SEARCH_QUERY_LENGTH, fetchAndActivate, ga4SetUser, ga4sendEvent, gaSendEvent, getBulkProgress, getFBEventId, getPlaceIdForStringQuery, handleAadharNumberVerificationResponse, handleAadharOtpVerificationResponse, handleAcceptOrRejectBidResponse, handleAddFaq, handleAddOrEditOfficeAddress, handleBulkUploadResponse, handleDeleteOfficeAddress, handleEditFaq, handleGetDigilockerVerificationUrlResponse, handleGstNumberVerificationResponse, handleGstOtpVerificationResponse, handleLoadPostResponse, handleLorryEdit, handleLorryPostResponse, handleLorryReactivateResponse, handleNegotiateBidResponse, handleSubmitLoadBidResponse, handleSubmitLorryBidResponse, handleSubmitUpdateBidResponse, handleUpdateCompanyDetails, handleUpdateCompanyRouteDetails, handleUploadImage, logout, moEngageUserEventTrack, moEngageUserLogOut, newCustomer2CustomerCallbackRequest, readRemoteConfigValue, remoteConfig, searchUsingPlacesAPI, sendCallbackRequest, sendFbCapiEvent, sendPageSenseEvent, useAadharOtpVerification, useAddFaq, useAddOrEditOfficeAddress, useBidderRejectBidService, useBlockUsers, useCallMeBackRequest, useDeactivateLorry, useDeleteLorry, useDeleteOfficeAddress, useEditFaq, useGetBulkLoadPostingStatus, useGetCompanyReviewDetails, useGetCompanyRouteDetails, useGetDigilockerVerificationUrl, useGetLoadsForCurrentUserQuery, useGetLorriesForCurrentUserQuery, useGetLorryBidsService, useGetLorryByCategory, useGetLorryById, useGetLorryInfo, useGetRoutesByCompanyId, useGetTransactionListService, useGetUserFaq, useGetUserProfileDetails, useGstNumberVerification, useGstOtpVerification, useLorryRoutes, usePostLoad, usePostLorry, useReactivateLorry, useReceiverAcceptBidService, useSearchCompanyByPhoneNumber, useSearchCompanyByPhoneNumberMutation, useSendWhatsappMessage, useSubmitBulkLoads, useSubmitLoadBid, useSubmitLorryBid, useUnBlockUsers, useUpdateBidService, useUpdateCompanyDetails, useUpdateCompanyRouteDetails, useUploadImage, useValidateToken, userAllDevicelogout

// EXTERNAL MODULE: ../core/dist/_services/city-search.service.js
var city_search_service = __webpack_require__(20803);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../core/dist/_services/callBack.service.js
var callBack_service = __webpack_require__(22672);
// EXTERNAL MODULE: ../core/dist/_services/callMeBack.service.js
var callMeBack_service = __webpack_require__(79890);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var hooks_useVahakHttpClient = __webpack_require__(36153);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
;// CONCATENATED MODULE: ../core/dist/_services/help.service.js





var HelpRequestScreen;
(function (HelpRequestScreen) {
    HelpRequestScreen["CONTACT_US"] = "Contact Us Page (Web)";
    HelpRequestScreen["SUPPORT_ICON"] = "Support Floating Icon (Web)";
    HelpRequestScreen["LOAD_BID"] = "Load Bid Form (Web)";
    HelpRequestScreen["LORRY_BID"] = "Lorry Bid Form (Web)";
    HelpRequestScreen["COMPANY_REGISTER"] = "Company Register (Web)";
})(HelpRequestScreen || (HelpRequestScreen = {}));
const useHelpRequestTicket = () => {
    const { POST } = (0,hooks_useVahakHttpClient/* default */.Z)();
    function method(data) {
        return POST(_services_const/* default.TICKET_HELP_REQUEST */.Z.TICKET_HELP_REQUEST, Object.assign({}, data));
    }
    return (0,useVahakQueryClient/* useVahakMutationQuery */.M8)(queryNames/* QueryNames.helpRequest */._.helpRequest, method);
};


//# sourceMappingURL=help.service.js.map

// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ../core/dist/_services/faq.service.js
var faq_service = __webpack_require__(99891);
// EXTERNAL MODULE: ../core/dist/_services/careers.service.js
var careers_service = __webpack_require__(66727);
// EXTERNAL MODULE: ../core/dist/_services/auth.adminConsole.service.js
var auth_adminConsole_service = __webpack_require__(72207);
// EXTERNAL MODULE: ../core/dist/_services/deactivateLoadLorry.service.js
var deactivateLoadLorry_service = __webpack_require__(45017);
// EXTERNAL MODULE: ../core/dist/_services/firebase.service.js + 1 modules
var firebase_service = __webpack_require__(44681);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useAuthService.js
var useAuthService = __webpack_require__(26231);
// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast_toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
// EXTERNAL MODULE: ../core/dist/methods/getAuthIdParam.js
var methods_getAuthIdParam = __webpack_require__(4913);
// EXTERNAL MODULE: ../core/dist/methods/formatDate.js
var formatDate = __webpack_require__(11663);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
// EXTERNAL MODULE: ../core/dist/_services/utils/getAuthHeader.js
var utils_getAuthHeader = __webpack_require__(21928);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useBidService.js








































function useSubmitLoadBid() {
    const queryClient = useQueryClient();
    // Removed data and error props to remove warning, can be addded when need
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ formData, loadId, companyId }) => fetch(API.SUBMIT_LOAD_BID + getAuthIdParam(), {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            amount: formData === null || formData === void 0 ? void 0 : formData.amount,
            type: (formData === null || formData === void 0 ? void 0 : formData.isFixedPrice) ? 0 : 1,
            is_negotiable: formData === null || formData === void 0 ? void 0 : formData.isNegotiable,
            is_vehicle_available: true,
            bidder_comment: formData === null || formData === void 0 ? void 0 : formData.remarks,
            load_id: loadId,
            bidder_id: Number(companyId),
            quantity: parseFloat(String(formData === null || formData === void 0 ? void 0 : formData.lorryCapacity)),
            lorry_id: formData === null || formData === void 0 ? void 0 : formData.lorryId
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries([QueryNames.bidHistory, "load"]);
                queryClient.invalidateQueries([QueryNames.loadSearch]);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function useSubmitLorryBid() {
    const queryClient = useQueryClient();
    // Removed data and error props to remove warning, can be addded when need
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ formData, lorryId, companyId }) => fetch(API.SUBMIT_LORRY_BID + getAuthIdParam(), {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            amount: parseFloat(String(formData === null || formData === void 0 ? void 0 : formData.amount)),
            type: (formData === null || formData === void 0 ? void 0 : formData.isFixedPrice) ? 0 : 1,
            is_negotiable: formData === null || formData === void 0 ? void 0 : formData.isNegotiable,
            load_id: formData === null || formData === void 0 ? void 0 : formData.loadId,
            lorry_id: lorryId,
            quantity: parseFloat(String(formData === null || formData === void 0 ? void 0 : formData.qty)),
            bidder_comment: (formData === null || formData === void 0 ? void 0 : formData.remarks) || "",
            bidder_id: Number(companyId)
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries("my-load-bids");
                queryClient.invalidateQueries("getLiveLorries");
                queryClient.invalidateQueries([QueryNames.bidHistory, "lorry"]);
                queryClient.invalidateQueries([QueryNames.lorrySearch]);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleSubmitBidResponse(mutateFn, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const bidRes = yield mutateFn(submitBidParams);
            if (bidRes.status === 200) {
                return { success: true };
                //sucess toast
            }
            if (!bidRes.ok) {
                const msg = (yield bidRes.json()).message;
                const error = { message: msg };
                throw error;
            }
        }
        catch (e) {
            toast.error(e.message || "An error occured, please try again");
            return { success: false };
        }
        return { success: false };
    });
}
function handleSubmitLoadBidResponse(mutateFn, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleSubmitBidResponse(mutateFn, submitBidParams);
    });
}
function handleSubmitLorryBidResponse(mutateFn, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleSubmitBidResponse(mutateFn, submitBidParams);
    });
}


//# sourceMappingURL=useBidService.js.map

// EXTERNAL MODULE: ../core/dist/_services/hooks/useLorryMarketService.js + 1 modules
var useLorryMarketService = __webpack_require__(53171);
// EXTERNAL MODULE: ../core/dist/_services/hooks/usePostingService.js
var usePostingService = __webpack_require__(7941);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useRoutesService.js








































function useGetRoutesByCompanyId({ companyId, options }) {
    const { data, isFetching } = useQuery([QueryNames.routesByCompanyId, companyId], () => fetch(`${API.ROUTES_BY_COMPANY_ID}${getAuthIdParam()}&c_i=${companyId}`, {
        headers: Object.assign({}, getAuthHeader())
    }).then((res) => res.json()), Object.assign({}, options));
    return { data: data === null || data === void 0 ? void 0 : data.data, isFetching };
}


//# sourceMappingURL=useRoutesService.js.map

// EXTERNAL MODULE: ../core/dist/_services/hooks/useTransactionService.js
var useTransactionService = __webpack_require__(60433);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useUserProfileService.js
var useUserProfileService = __webpack_require__(84327);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useLorryService.js
var useLorryService = __webpack_require__(86474);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useKYCService.js
var useKYCService = __webpack_require__(28029);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useLoadLorryService.js
var useLoadLorryService = __webpack_require__(29148);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useBlockUserService.js
var useBlockUserService = __webpack_require__(635);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useSendWhatsappMessageService.js





const useSendWhatsappMessage = () => {
    const { POST } = useVahakHttpClient();
    function sendWhatsAppMessage(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(API.SEND_WHATSAPP_MESSAGE, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return useVahakMutationQuery(QueryNames.sendWhatsAppMessage, sendWhatsAppMessage);
};


//# sourceMappingURL=useSendWhatsappMessageService.js.map

// EXTERNAL MODULE: ../core/dist/_services/utils/handleMutateResponse.js
var utils_handleMutateResponse = __webpack_require__(88443);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useBulkUploadService.js
/* provided dependency */ var process = __webpack_require__(34406);








function useSubmitBulkLoads() {
    // const queryClient = useQueryClient();
    const { POST } = useVahakHttpClient();
    const submitBulkUploadRequest = (payload) => {
        return POST(`${API.POST_BULK_LOAD}`, payload);
    };
    return useVahakMutationQuery(QueryNames.bulkUpload.load, submitBulkUploadRequest);
}
function handleBulkUploadResponse(mutateFn, bulkLoadPostRequest) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleMutateResponse(mutateFn, bulkLoadPostRequest);
    });
}
const getBulkProgress = (requestId, queryClient) => __awaiter(void 0, void 0, void 0, function* () {
    // Falsy requestId
    if (!requestId)
        throw new Error("Service Unavailable");
    try {
        const res = yield fetch(`${API.BULK_LOAD_POSTING_STATUS}req_id=${requestId}`, {
            method: "GET",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json", Key: process.env.NEXT_PUBLC_REACT_APP_KEY || "" }, getAuthHeader())
        });
        if (res.ok) {
            const resData = yield res.json();
            if (resData.data.company_id === 0) {
                // Wrong request id passed
                throw new Error("Service Unavailable");
            }
            const currentProcessedItemCount = resData.data.overall_progress.done;
            const totalItemCount = resData.data.total_items;
            const successfulLoadPostingCount = resData.data.records.filter((record) => record.status_code < 300).length;
            const failedRecords = resData.data.records.filter((record) => record.status_code >= 400);
            return {
                progress: Math.round((currentProcessedItemCount / totalItemCount) * 100) || 0,
                currentProcessedItemCount,
                totalItemCount,
                failedRecords,
                successfulLoadPostingCount
            };
        }
        else {
            // Error from server
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            throw new Error("Service Unavailable");
        }
    }
    catch (err) {
        // Network Error
        throw new Error("Service Unavailable");
    }
});
const useGetBulkLoadPostingStatus = ({ requestId }, options) => {
    const { GET } = useVahakHttpClient();
    const getBulkProgress = () => {
        return GET(`${API.BULK_LOAD_POSTING_STATUS}req_id=${requestId}`);
    };
    return useVahakQuery([QueryNames.bulkUpload.bulkLoadStatus, requestId], getBulkProgress, Object.assign(Object.assign({}, options), { select: (res) => {
            const { data } = res;
            const currentProcessedItemCount = data.overall_progress.done;
            const totalItemCount = data.total_items;
            const successfulLoadPostingCount = data.records.filter((record) => record.status_code < 300).length;
            const failedRecords = data.records.filter((record) => record.status_code >= 400);
            return {
                progress: Math.round((currentProcessedItemCount / totalItemCount) * 100) || 0,
                currentProcessedItemCount,
                totalItemCount,
                failedRecords,
                successfulLoadPostingCount
            };
        } }));
};


//# sourceMappingURL=useBulkUploadService.js.map

// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var hooks_useCsDashboard = __webpack_require__(68191);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ../core/dist/_services/hooks/useGetLoadsForCurrentUserQuery.js


















































function useGetLoadsForCurrentUserQuery({ companyId, status, lorryType, request_type, created_at_string, type, id, bulkId, preload = [] }, { enabled, refetchInterval, onSuccess }) {
    const queryClient = useQueryClient();
    const { isCsDashboardUser } = useCsDashboard();
    const { data, fetchNextPage, hasNextPage, isFetching, isLoading, refetch } = useInfiniteQuery([QueryNames.loadsForCurrentUser], ({ pageParam = 1 }) => __awaiter(this, void 0, void 0, function* () {
        const validatedCompanyId = validateAndConvertReqParamToInt("companyId", companyId);
        if (!validatedCompanyId) {
            return { results: [], next: undefined };
        }
        const response = yield fetch(API.ALL_LOADS + getAuthIdParam(), {
            body: JSON.stringify({
                company_id: validatedCompanyId,
                page_number: pageParam,
                status,
                request_type,
                created_at_string,
                type,
                id,
                bulk_id: bulkId,
                preload: ["load_details", ...preload],
                bid_status: getArrayWithType([
                    BID_STATUS.WAITING,
                    BID_STATUS.IN_TRANSIT,
                    BID_STATUS.UNVERIFIED,
                    BID_STATUS.COMPLETED,
                    BID_STATUS.STAND_BY,
                    BID_STATUS.PARTIALLY_ACCEPTED,
                    ...arrayAddIf(isCsDashboardUser, [BID_STATUS.EXPIRED])
                ], String)
            }),
            method: "POST",
            headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
        });
        if (response.status === 401) {
            // this will cause the AuthVerifyComp to re-render and when token verification fails, logout the app
            queryClient.invalidateQueries(QueryNames.validateToken);
        }
        if (!response.ok) {
            throw new Error("Problem fetching data");
        }
        const dataFromServer = (yield response.json()).data;
        const loads = lorryType
            ? dataFromServer.all.filter((d) => d.lorry_id === lorryType)
            : dataFromServer.all;
        const data = {
            results: loads,
            totalCount: dataFromServer.total_count,
            next: dataFromServer.page_number < dataFromServer.total_pages
                ? dataFromServer.page_number + 1
                : undefined
        };
        return data;
    }), {
        getNextPageParam: (lastPage) => lastPage.next,
        refetchInterval: refetchInterval || false,
        enabled,
        onSuccess
    });
    return {
        data,
        fetchNextPage,
        hasNextPage,
        currentDataLength: getInfiniteQueryCurrentDataLength(data),
        isFetching,
        isLoading,
        refetch
    };
}


//# sourceMappingURL=useGetLoadsForCurrentUserQuery.js.map

// EXTERNAL MODULE: ../core/dist/_services/constants/index.js
var constants = __webpack_require__(20798);
// EXTERNAL MODULE: ../../node_modules/firebase/remote-config/dist/esm/index.esm.js + 2 modules
var index_esm = __webpack_require__(57214);
;// CONCATENATED MODULE: ../core/dist/_services/index.js





























//# sourceMappingURL=index.js.map


/***/ }),

/***/ 8880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Y": function() { return /* binding */ getFBEventId; },
/* harmony export */   "C0": function() { return /* binding */ moEngageUserLogIn; },
/* harmony export */   "Im": function() { return /* binding */ moEngageUserEventTrack; },
/* harmony export */   "LS": function() { return /* binding */ ga4SetUser; },
/* harmony export */   "SR": function() { return /* binding */ moEngageUserLogOut; },
/* harmony export */   "av": function() { return /* binding */ moEngageUserAttributeTrack; },
/* harmony export */   "j5": function() { return /* binding */ sendPageSenseEvent; },
/* harmony export */   "kM": function() { return /* binding */ moEngageUserPhoneNum; },
/* harmony export */   "zs": function() { return /* binding */ ga4sendEvent; }
/* harmony export */ });
/* unused harmony exports gaSendEvent, sendFbCapiEvent */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36908);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77370);
/* provided dependency */ var process = __webpack_require__(34406);




function uaSendEvent(params) {
    var _a, _b, _c, _d;
    const ga = window.ga;
    if (!ga) {
        return;
    }
    const trackerName = (_d = (_c = (_b = (_a = ga.getAll) === null || _a === void 0 ? void 0 : _a.call(ga)) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.get) === null || _d === void 0 ? void 0 : _d.call(_c, "name");
    if (!trackerName) {
        return;
    }
    ga(`${trackerName}.send`, Object.assign({ hitType: "event" }, params));
}
function ga4sendEvent(eventName, params) {
    const { gtag } = window;
    if (!gtag) {
        return;
    }
    gtag("event", eventName, params);
}
function gaSendEvent(params) {
    uaSendEvent(params);
}
function ga4SetUser(userId) {
    const cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z();
    const { gtag } = window;
    if (!gtag) {
        return;
    }
    gtag("set", { user_id: cookies.get(_constants_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .COOKIES.userId */ .E9.userId) });
}
function moEngageUserAttributeTrack(attribute, value) {
    const moEngage = window["Moengage"];
    if (attribute && value && moEngage) {
        moEngage.add_user_attribute(attribute, value);
    }
}
function moEngageUserEventTrack(eventName, attributes) {
    const moEngage = window["Moengage"];
    if (eventName && attributes && moEngage) {
        moEngage.track_event(eventName, attributes);
    }
}
function moEngageUserLogIn(userId) {
    const moEngage = window["Moengage"];
    if (userId && moEngage) {
        moEngage.add_unique_user_id(userId);
    }
}
function moEngageUserLogOut() {
    const moEngage = window["Moengage"];
    if (moEngage) {
        moEngage.destroy_session();
    }
}
function moEngageUserPhoneNum(phoneNum) {
    const moEngage = window["Moengage"];
    if (phoneNum && moEngage) {
        moEngage.add_mobile(phoneNum);
    }
}
function sendPageSenseEvent(eventName) {
    window.pagesense = window.pagesense || [];
    const pagesense = window["pagesense"];
    if (pagesense) {
        window.pagesense.push(["trackEvent", eventName]);
    }
}
function getFBEventId(id, companyId) {
    const suffix = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    return [id, companyId, suffix].filter((part) => part != null && part !== "").join("_");
}
function sendFbCapiEvent(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const cookies = new Cookies();
        const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
        const sha256 = (yield Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 11093, 23))).default;
        const urlencoded = new URLSearchParams();
        if (ENV !== "production") {
            urlencoded.append("test_event_code", "TEST15638");
        }
        const currLocObj = cookies.get(COOKIES.currentLoc);
        let currCity;
        if (currLocObj) {
            currCity = currLocObj.name;
        }
        urlencoded.append("data", JSON.stringify([
            {
                event_id: params.event_id,
                event_name: params.event_name,
                event_time: Math.round(new Date().getTime() / 1000),
                action_source: "website",
                event_source_url: window.location.href,
                user_data: {
                    ph: params.phone_num ? sha256(String(params.phone_num)).toString() : undefined,
                    ct: currCity ? sha256(currCity).toString() : undefined,
                    country: sha256(String("in")).toString(),
                    fbp: cookies.get("_fbp") ? cookies.get("_fbp") : undefined,
                    fbc: cookies.get("_fbc") ? cookies.get("_fbc") : undefined
                },
                custom_data: params.custom_data
            }
        ]));
        fetch(`https://graph.facebook.com/v23.0/${FB_PIXEL_ID}/events?access_token=${FB_CAPI_TOKEN}`, {
            method: "POST",
            body: urlencoded,
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
        });
    });
}


//# sourceMappingURL=user-analytics.service.js.map


/***/ }),

/***/ 21928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getAuthHeader; }
/* harmony export */ });
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36908);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);



function getAuthHeader(bearerToken) {
    const cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    const token = bearerToken || cookies.get(_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.token */ .E9.token);
    if (!token)
        return;
    return { token: `Bearer ${token}` };
}


//# sourceMappingURL=getAuthHeader.js.map


/***/ }),

/***/ 88443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ handleMutateResponse; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);


function handleMutateResponse(mutateFn, handlerParams) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        try {
            const res = yield mutateFn(handlerParams);
            if (res.ok) {
                const response = yield res.json();
                return { success: true, data: response.data, response: response };
            }
            if (!res.ok) {
                const msg = (yield res.json()).message;
                const error = { message: msg };
                return { success: false, data: null, error };
            }
        }
        catch (e) {
            return { success: false };
        }
        return { success: false };
    });
}


//# sourceMappingURL=handleMutateResponse.js.map


/***/ }),

/***/ 886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ removeAuthToken; }
/* harmony export */ });
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36908);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);



function removeAuthToken() {
    const cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    cookies.remove(_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.token */ .E9.token, _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .DefaultCookieOptions */ .DL);
    cookies.remove(_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.companyId */ .E9.companyId, _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .DefaultCookieOptions */ .DL);
    cookies.remove(_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.newUser */ .E9.newUser, _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .DefaultCookieOptions */ .DL);
}


//# sourceMappingURL=removeAuthToken.js.map


/***/ }),

/***/ 43464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ validateAndConvertReqParamToInt; }
});

// NAMESPACE OBJECT: ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, {
  "FunctionToString": function() { return FunctionToString; },
  "InboundFilters": function() { return InboundFilters; }
});

// NAMESPACE OBJECT: ../../node_modules/@sentry/browser/esm/integrations/index.js
var esm_integrations_namespaceObject = {};
__webpack_require__.r(esm_integrations_namespaceObject);
__webpack_require__.d(esm_integrations_namespaceObject, {
  "Breadcrumbs": function() { return Breadcrumbs; },
  "Dedupe": function() { return Dedupe; },
  "GlobalHandlers": function() { return GlobalHandlers; },
  "LinkedErrors": function() { return LinkedErrors; },
  "TryCatch": function() { return TryCatch; },
  "UserAgent": function() { return UserAgent; }
});

// NAMESPACE OBJECT: ../../node_modules/@sentry/browser/esm/index.js
var browser_esm_namespaceObject = {};
__webpack_require__.r(browser_esm_namespaceObject);

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function tslib_es6_spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(68718);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/is.js
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function is_isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/browser.js


/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && isString(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = (0,esm_global/* getGlobalObject */.R)();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}
//# sourceMappingURL=browser.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/string.js

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function string_snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) {
        return newLine;
    }
    if (colno > lineLength) {
        // eslint-disable-next-line no-param-reassign
        colno = lineLength;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) {
        end = lineLength;
    }
    if (end === lineLength) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < lineLength) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!isString(value)) {
        return false;
    }
    if (isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
//# sourceMappingURL=string.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/object.js




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function object_addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    object_addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function convertToPlainObject(value) {
    var newObj = value;
    if (isError(value)) {
        newObj = tslib_es6_assign({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
    }
    else if (isEvent(value)) {
        var event_1 = value;
        newObj = tslib_es6_assign({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
            newObj.detail = event_1.detail;
        }
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
    try {
        return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
    var extractedProps = {};
    for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
            extractedProps[property] = obj[property];
        }
    }
    return extractedProps;
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (isPlainObject(val)) {
        var rv = {};
        try {
            for (var _b = __values(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof val[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(val[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
    var objectified;
    switch (true) {
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
//# sourceMappingURL=object.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/functiontostring.js

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = getOriginalFunction(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/logger.js



// TODO: Implement different loggers for different environments
var global = (0,esm_global/* getGlobalObject */.R)();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function (level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    }
    finally {
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function (level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function () {
            enabled = true;
        },
        disable: function () {
            enabled = false;
        },
    };
    if (flags_IS_DEBUG_BUILD) {
        CONSOLE_LEVELS.forEach(function (name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (enabled) {
                    consoleSandbox(function () {
                        var _a;
                        (_a = global.console)[name].apply(_a, tslib_es6_spread([PREFIX + "[" + name + "]:"], args));
                    });
                }
            };
        });
    }
    else {
        CONSOLE_LEVELS.forEach(function (name) {
            logger[name] = function () { return undefined; };
        });
    }
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger_logger;
if (flags_IS_DEBUG_BUILD) {
    logger_logger = (0,esm_global/* getGlobalSingleton */.Y)('logger', makeLogger);
}
else {
    logger_logger = makeLogger();
}

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/misc.js




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function misc_addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = tslib_es6_assign(tslib_es6_assign({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return snipLine(line, 0); });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return snipLine(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        addNonEnumerableProperty(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
//# sourceMappingURL=misc.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var esm_flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/inboundfilters.js



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = _mergeOptions(self_1._options, clientOptions);
                    return _shouldDropEvent(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

/** JSDoc */
function _mergeOptions(internalOptions, clientOptions) {
    if (internalOptions === void 0) { internalOptions = {}; }
    if (clientOptions === void 0) { clientOptions = {}; }
    return {
        allowUrls: tslib_es6_spread((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
        denyUrls: tslib_es6_spread((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
        ignoreErrors: tslib_es6_spread((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
    };
}
/** JSDoc */
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        esm_flags_IS_DEBUG_BUILD &&
            logger_logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + getEventDescription(event));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        esm_flags_IS_DEBUG_BUILD &&
            logger_logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + getEventDescription(event));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        esm_flags_IS_DEBUG_BUILD &&
            logger_logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        esm_flags_IS_DEBUG_BUILD &&
            logger_logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function (message) {
        return ignoreErrors.some(function (pattern) { return isMatchingPattern(message, pattern); });
    });
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
}
function _getPossibleEventMessages(event) {
    if (event.message) {
        return [event.message];
    }
    if (event.exception) {
        try {
            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
            return ["" + value, type + ": " + value];
        }
        catch (oO) {
            esm_flags_IS_DEBUG_BUILD && logger_logger.error("Cannot extract message for event " + getEventDescription(event));
            return [];
        }
    }
    return [];
}
function _isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    }
    catch (e) {
        // ignore
    }
    return false;
}
function _getLastValidUrl(frames) {
    if (frames === void 0) { frames = []; }
    for (var i = frames.length - 1; i >= 0; i--) {
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        if (event.stacktrace) {
            return _getLastValidUrl(event.stacktrace.frames);
        }
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        }
        catch (e) {
            // ignore
        }
        return frames_1 ? _getLastValidUrl(frames_1) : null;
    }
    catch (oO) {
        esm_flags_IS_DEBUG_BUILD && logger_logger.error("Cannot extract url for event " + getEventDescription(event));
        return null;
    }
}
//# sourceMappingURL=inboundfilters.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/index.js


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(88271);
// EXTERNAL MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(25049);
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/hub/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var hub_esm_flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/syncpromise.js
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function syncpromise_resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if (isThenable(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/hub/esm/scope.js


/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = tslib_es6_spread(scope._breadcrumbs);
            newScope._tags = tslib_es6_assign({}, scope._tags);
            newScope._extra = tslib_es6_assign({}, scope._extra);
            newScope._contexts = tslib_es6_assign({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = tslib_es6_spread(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = tslib_es6_assign(tslib_es6_assign({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = tslib_es6_assign(tslib_es6_assign({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = tslib_es6_assign(tslib_es6_assign({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = tslib_es6_assign(tslib_es6_assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = tslib_es6_assign(tslib_es6_assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = tslib_es6_assign(tslib_es6_assign({}, this._tags), captureContext._tags);
            this._extra = tslib_es6_assign(tslib_es6_assign({}, this._extra), captureContext._extra);
            this._contexts = tslib_es6_assign(tslib_es6_assign({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if (isPlainObject(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = tslib_es6_assign(tslib_es6_assign({}, this._tags), captureContext.tags);
            this._extra = tslib_es6_assign(tslib_es6_assign({}, this._extra), captureContext.extra);
            this._contexts = tslib_es6_assign(tslib_es6_assign({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = tslib_es6_assign({ timestamp: (0,time/* dateTimestampInSeconds */.yW)() }, breadcrumb);
        this._breadcrumbs = tslib_es6_spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = tslib_es6_assign(tslib_es6_assign({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = tslib_es6_assign(tslib_es6_assign({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = tslib_es6_assign(tslib_es6_assign({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = tslib_es6_assign(tslib_es6_assign({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = tslib_es6_assign({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = tslib_es6_assign({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = tslib_es6_spread((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors(tslib_es6_spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = tslib_es6_assign(tslib_es6_assign({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new SyncPromise(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(tslib_es6_assign({}, event), hint);
                if (isThenable(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    return (0,esm_global/* getGlobalSingleton */.Y)('globalEventProcessors', function () { return []; });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/hub/esm/session.js

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = uuid4();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0,time/* timestampInSeconds */.ph)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : uuid4();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return dropUndefinedKeys({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/hub/esm/hub.js





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new Scope(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = Scope.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, tslib_es6_assign(tslib_es6_assign({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, tslib_es6_assign(tslib_es6_assign({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : uuid4();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, tslib_es6_assign(tslib_es6_assign({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
        var mergedBreadcrumb = tslib_es6_assign({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            hub_esm_flags_IS_DEBUG_BUILD && logger_logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0,esm_global/* getGlobalObject */.R)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session(tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, tslib_es6_spread(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        hub_esm_flags_IS_DEBUG_BUILD && logger_logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = (0,esm_global/* getGlobalObject */.R)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0,node/* isNodeEnv */.KV)()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    IS_DEBUG_BUILD && logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    return (0,esm_global/* getGlobalSingleton */.Y)('hub', function () { return new Hub(); }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
    __SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/types/esm/severity.js
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var severity_Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(severity_Severity || (severity_Severity = {}));
// TODO: in v7, these can disappear, because they now also exist in `@sentry/utils`. (Having them there rather than here
// is nice because then it enforces the idea that only types are exported from `@sentry/types`.)
var SeverityLevels = (/* unused pure expression or super */ null && (['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical']));
//# sourceMappingURL=severity.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/stacktrace.js

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = __values(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var sortedParsers_1 = (e_2 = void 0, __values(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return (tslib_es6_assign(tslib_es6_assign({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/supports.js



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in (0,esm_global/* getGlobalObject */.R)())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = (0,esm_global/* getGlobalObject */.R)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            flags_IS_DEBUG_BUILD &&
                logger_logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in getGlobalObject();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0,esm_global/* getGlobalObject */.R)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/instrument.js








var instrument_global = (0,esm_global/* getGlobalObject */.R)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            flags_IS_DEBUG_BUILD && logger_logger.warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = __values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                flags_IS_DEBUG_BUILD &&
                    logger_logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + getFunctionName(handler) + "\nError:", e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in instrument_global)) {
        return;
    }
    CONSOLE_LEVELS.forEach(function (level) {
        if (!(level in instrument_global.console)) {
            return;
        }
        fill(instrument_global.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(instrument_global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    fill(instrument_global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', tslib_es6_assign({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(instrument_global, args).then(function (response) {
                triggerHandlers('fetch', tslib_es6_assign(tslib_es6_assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', tslib_es6_assign(tslib_es6_assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in instrument_global && isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in instrument_global && isInstanceOf(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in instrument_global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    fill(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: isString(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                fill(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    fill(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = instrument_global.onpopstate;
    instrument_global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = instrument_global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    fill(instrument_global.history, 'pushState', historyReplacementFunction);
    fill(instrument_global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = instrument_global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in instrument_global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    instrument_global.document.addEventListener('click', globalDOMEventHandler, false);
    instrument_global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = instrument_global[target] && instrument_global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        fill(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = instrument_global.onerror;
    instrument_global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = instrument_global.onunhandledrejection;
    instrument_global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}
//# sourceMappingURL=memo.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth, maxProperties) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    }
    catch (err) {
        return { ERROR: "**non-serializable** (" + err + ")" };
    }
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    var _a = __read(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
        try {
            return valueWithToJSON.toJSON();
        }
        catch (err) {
            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // Get the simple cases out of the way first
    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !is_isNaN(value))) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) {
        return stringified;
    }
    // We're also done if we've reached the max depth
    if (depth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace('object ', '');
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return '[Circular ~]';
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = (Array.isArray(value) ? [] : {});
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (isError(value) || isEvent(value) ? convertToPlainObject(value) : value);
    for (var visitKey in visitable) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
// TODO remove this in v7 (this means the method will no longer be exported, under any name)

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(key, 
// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) {
            return '[Domain]';
        }
        if (key === 'domainEmitter') {
            return '[DomainEmitter]';
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
            return '[Global]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) {
            return '[Window]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) {
            return '[Document]';
        }
        // React's SyntheticEvent thingy
        if (isSyntheticEvent(value)) {
            return '[SyntheticEvent]';
        }
        if (typeof value === 'number' && value !== value) {
            return '[NaN]';
        }
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) {
            return '[undefined]';
        }
        if (typeof value === 'function') {
            return "[Function: " + getFunctionName(value) + "]";
        }
        if (typeof value === 'symbol') {
            return "[" + String(value) + "]";
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') {
            return "[BigInt: " + String(value) + "]";
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    }
    catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
//# sourceMappingURL=normalize.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/stack-parsers.js

// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = __read(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [CHROME_PRIORITY, chrome];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = __read(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [GECKO_PRIORITY, gecko];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var winjsStackParser = [WINJS_PRIORITY, winjs];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [OPERA10_PRIORITY, opera10];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [OPERA11_PRIORITY, opera11];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};
//# sourceMappingURL=stack-parsers.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js




/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + extractExceptionKeysForMessage(exception),
                },
            ],
        },
        extra: {
            __serialized__: normalizeToSize(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return createStackParser(opera10StackParser, opera11StackParser, chromeStackParser, winjsStackParser, geckoStackParser)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if (isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if (isDOMError(exception) || isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || (isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            addExceptionTypeValue(event, message);
        }
        if ('code' in domException) {
            event.tags = tslib_es6_assign(tslib_es6_assign({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (isError(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if (isPlainObject(exception) || isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        misc_addExceptionMechanism(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    addExceptionTypeValue(event, "" + exception, undefined);
    misc_addExceptionMechanism(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input,
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) {
            event.stacktrace = { frames: frames_2 };
        }
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/flags.js
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var browser_esm_flags_IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
//# sourceMappingURL=flags.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/minimal/esm/index.js


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = getCurrentHub();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, tslib_es6_spread(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __assign({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __spread(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', __assign({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/helpers.js




var helpers_global = (0,esm_global/* getGlobalObject */.R)();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if (getOriginalFunction(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            withScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        addExceptionTypeValue(event, undefined, undefined);
                        misc_addExceptionMechanism(event, options.mechanism);
                    }
                    event.extra = tslib_es6_assign(tslib_es6_assign({}, event.extra), { arguments: args });
                    return event;
                });
                captureException(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    markFunctionWrapped(sentryWrapped, fn);
    object_addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!helpers_global.document) {
        return;
    }
    if (!options.eventId) {
        IS_DEBUG_BUILD && logger.error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        IS_DEBUG_BUILD && logger.error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = helpers_global.document.createElement('script');
    script.async = true;
    script.src = getReportDialogEndpoint(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = helpers_global.document.head || helpers_global.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = tslib_es6_assign({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

/** JSDoc */
function _installGlobalOnErrorHandler() {
    addInstrumentationHandler('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = __read(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && isString(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame(eventFromUnknownInput(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = severity_Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    addInstrumentationHandler('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = __read(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = is_isPrimitive(error)
            ? _eventFromRejectionWithPrimitive(error)
            : eventFromUnknownInput(error, undefined, attachStacktrace, true);
        event.level = severity_Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = isErrorEvent(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = isString(url) && url.length > 0 ? url : getLocationHref();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    browser_esm_flags_IS_DEBUG_BUILD && logger_logger.log("Global Handler attached: " + type);
}
function addMechanismAndCapture(hub, error, event, type) {
    misc_addExceptionMechanism(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = getCurrentHub();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}
//# sourceMappingURL=globalhandlers.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = tslib_es6_assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = (0,esm_global/* getGlobalObject */.R)();
        if (this._options.setTimeout) {
            fill(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            fill(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            fill(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: { function: getFunctionName(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            wrap(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }),
        ]);
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fill(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: getFunctionName(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = getOriginalFunction(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0,esm_global/* getGlobalObject */.R)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    fill(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: getFunctionName(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                wrap(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }),
                options,
            ]);
        };
    });
    fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
//# sourceMappingURL=trycatch.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/enums.js
var enums_SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/node_modules/@sentry/utils/esm/severity.js


function isSupportedSeverity(level) {
    return enums_SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return severity_Severity.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return severity_Severity.Log;
}
//# sourceMappingURL=severity.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = tslib_es6_assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        getCurrentHub().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: getEventDescription(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            addInstrumentationHandler('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            addInstrumentationHandler('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            addInstrumentationHandler('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            addInstrumentationHandler('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            addInstrumentationHandler('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? htmlTreeAsString(handlerData.event.target, keyAttrs)
                : htmlTreeAsString(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        getCurrentHub().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: safeJoin(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + (safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    getCurrentHub().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        getCurrentHub().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: severity_Severity.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: tslib_es6_assign(tslib_es6_assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = (0,esm_global/* getGlobalObject */.R)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = parseUrl(global.location.href);
    var parsedFrom = parseUrl(from);
    var parsedTo = parseUrl(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    getCurrentHub().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}
//# sourceMappingURL=breadcrumbs.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event, hint) {
            var self = getCurrentHub().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = tslib_es6_spread(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = exceptionFromError(error[key]);
    return _walkErrorTree(limit, error[key], key, tslib_es6_spread([exception], stack));
}
//# sourceMappingURL=linkederrors.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/useragent.js



var useragent_global = (0,esm_global/* getGlobalObject */.R)();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event) {
            if (getCurrentHub().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!useragent_global.navigator && !useragent_global.location && !useragent_global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (useragent_global.location && useragent_global.location.href);
                var referrer = (useragent_global.document || {}).referrer;
                var userAgent = (useragent_global.navigator || {}).userAgent;
                var headers = tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = tslib_es6_assign(tslib_es6_assign({}, (url && { url: url })), { headers: headers });
                return tslib_es6_assign(tslib_es6_assign({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
                        browser_esm_flags_IS_DEBUG_BUILD && logger_logger.warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}
//# sourceMappingURL=dedupe.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/index.js






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0,esm_global/* getGlobalObject */.R)();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = tslib_es6_assign(tslib_es6_assign(tslib_es6_assign({}, windowIntegrations), integrations_namespaceObject), esm_integrations_namespaceObject);

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../core/dist/_services/utils/validateAndConvertReqParamToNum.js


function convert(paramName, paramVal, intOrFloat) {
    if (paramVal === undefined || paramVal === null) {
        return undefined;
    }
    if (typeof paramVal === "number") {
        return paramVal;
    }
    if (paramVal.constructor === Array) {
        const x = [];
        for (let v of paramVal) {
            const numVal = intOrFloat === "int" ? parseInt(v) : parseFloat(v);
            if (isNaN(numVal)) {
                if (v) {
                    browser_esm_namespaceObject["default"].captureException(`invalid ${paramName}: ${v}`);
                }
                return undefined;
            }
            x.push(numVal);
        }
        return x;
    }
    const numVal = intOrFloat === "int" ? parseInt(paramVal) : parseFloat(paramVal);
    if (isNaN(numVal)) {
        if (paramVal) {
            browser_esm_namespaceObject["default"].captureException(`invalid ${paramName}: : ${paramVal}`);
        }
        return undefined;
    }
    return numVal;
}
function validateAndConvertReqParamToInt(paramName, paramVal) {
    return convert(paramName, paramVal, "int");
}


//# sourceMappingURL=validateAndConvertReqParamToNum.js.map


/***/ }),

/***/ 30116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ __rest; },
/* harmony export */   "m": function() { return /* binding */ __awaiter; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};


//# sourceMappingURL=_tslib.js.map


/***/ }),

/***/ 4628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": function() { return /* binding */ AppContext; },
/* harmony export */   "No": function() { return /* binding */ ServiceRequestType; }
/* harmony export */ });
/* unused harmony export DefaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var ServiceRequestType;
(function (ServiceRequestType) {
    ServiceRequestType["GPS"] = "gps";
    ServiceRequestType["CARGO_INSURANCE"] = "cargoInsurance";
    ServiceRequestType["VEHICLE_INSURANCE"] = "vehicleInsurance";
    ServiceRequestType["BUSINESS_LOAN"] = "businessLoan";
})(ServiceRequestType || (ServiceRequestType = {}));
const DefaultContext = {
    isMobile: true,
    currentLocation: { status: "notRequested" },
    // isPhoneVerified: false,
    profilesViewed: [],
    bulkRequestIds: [],
    isBulkUploadModalOpen: false,
    isProductionEnv: false,
    isMobileScreen: false,
    // numOfContactRqsts: 0,
    isLorryNotAllowedPopupOpen: false,
    toggleIsLorryNotAllowedPopupOpen: () => { },
    joinedOn: ""
};
const AppContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(DefaultContext);


//# sourceMappingURL=app-context.js.map


/***/ }),

/***/ 70561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ A; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



const A = (_a) => {
    var { openInNewTab, title, href, className, children } = _a, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._)(_a, ["openInNewTab", "title", "href", "className", "children"]);
    return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", Object.assign({ href: href, target: openInNewTab ? "_blank" : undefined, rel: "noopener noreferrer", title: title, className: className }, props), children));
};


//# sourceMappingURL=A.js.map


/***/ }),

/***/ 49995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppBtn; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/app-btn/AppBtn.module.scss.js


var css_248z = ".AppBtn-module_main__WdRNz {\n  border: none;\n  font-family: var(--font-medium);\n  cursor: pointer;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_hover__3UBB7, .AppBtn-module_main__WdRNz:hover {\n  transition: all 500ms;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_primary__iZxEV {\n  background-color: #2355fc;\n  color: #ffffff;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_secondary__19emv {\n  background-color: #eef5fe;\n  color: #2355fc;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_secondary__19emv.AppBtn-module_hover__3UBB7, .AppBtn-module_main__WdRNz.AppBtn-module_secondary__19emv:hover {\n  background-color: #1053ff;\n  color: #ffffff;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_danger__ET9tB {\n  background-color: #ffe3e3;\n  color: #ef4444;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_primary__iZxEV.AppBtn-module_outline__WgOig {\n  background-color: #ffffff;\n  border: 2px solid #1053ff;\n  color: #1053ff;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_loading__2MLBY {\n  padding: 0;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_warning__jzeVO {\n  background-color: #ffeed9;\n  color: #ff9c25;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_link__CDfxC {\n  color: #2355fc;\n  background-color: #fff;\n  cursor: pointer;\n  padding: 0;\n  height: unset;\n  text-decoration: underline;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_green__KA6Ox {\n  border: solid 2px #0EA546;\n  background-color: #0ea546;\n  color: #fff;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_green__KA6Ox.AppBtn-module_outline__WgOig {\n  border: solid 2px #0EA546;\n  color: #0ea546;\n  background-color: #fff;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_darkgray__0uJrf {\n  border: solid 2px #666666;\n  background-color: #666666;\n  color: #000;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_darkgray__0uJrf.AppBtn-module_outline__WgOig {\n  border: solid 2px #666666;\n  background-color: #fff;\n  color: #666666;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_lightgray__w1UDh {\n  border: solid 2px #f6f6f6;\n  background-color: #f6f6f6;\n  color: #999999;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_lightgray__w1UDh.AppBtn-module_outline__WgOig {\n  border: solid 2px #f6f6f6;\n  background-color: #fff;\n  color: #999999;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_lightred__ZfnPN {\n  border: solid 2px #ffe3e3;\n  background-color: #ffe3e3;\n  color: #ef4444;\n}\n.AppBtn-module_main__WdRNz.AppBtn-module_lightred__ZfnPN.AppBtn-module_outline__WgOig {\n  border: solid 2px #ef4444;\n  background-color: #fff;\n  color: #ef4444;\n}\n\n.AppBtn-module_disabled__VNXH9 {\n  cursor: not-allowed;\n  border: #edf0f7 !important;\n  background-color: #edf0f7 !important;\n  color: rgba(35, 85, 252, 0.3) !important;\n  box-shadow: none !important;\n}\n.AppBtn-module_disabled__VNXH9.AppBtn-module_primary__iZxEV {\n  color: #ffffff !important;\n  background-color: #afc4ff !important;\n}\n.AppBtn-module_disabled__VNXH9.AppBtn-module_secondary__19emv {\n  color: #afc4ff !important;\n  background-color: #eef5fe !important;\n}\n.AppBtn-module_disabled__VNXH9.AppBtn-module_danger__ET9tB {\n  color: #ff9090 !important;\n  background-color: #ffe3e3 !important;\n}\n.AppBtn-module_disabled__VNXH9.AppBtn-module_green__KA6Ox {\n  color: #999 !important;\n  background-color: #f6f6f6 !important;\n}\n.AppBtn-module_disabled__VNXH9.AppBtn-module_darkgray__0uJrf {\n  color: #999 !important;\n  background-color: #f6f6f6 !important;\n}\n\n@media (max-width: 991px) {\n  .AppBtn-module_main__WdRNz {\n    border-radius: 4px;\n    height: 36px;\n    font-size: 0.75rem;\n    padding: 0 16px;\n  }\n}\n@media (min-width: 992px) {\n  .AppBtn-module_main__WdRNz {\n    border-radius: 6px;\n    height: 48px;\n    font-size: 1rem;\n    padding: 0 20px;\n  }\n}";
var Styles = {"main":"AppBtn-module_main__WdRNz","hover":"AppBtn-module_hover__3UBB7","primary":"AppBtn-module_primary__iZxEV","secondary":"AppBtn-module_secondary__19emv","danger":"AppBtn-module_danger__ET9tB","outline":"AppBtn-module_outline__WgOig","loading":"AppBtn-module_loading__2MLBY","warning":"AppBtn-module_warning__jzeVO","link":"AppBtn-module_link__CDfxC","green":"AppBtn-module_green__KA6Ox","darkgray":"AppBtn-module_darkgray__0uJrf","lightgray":"AppBtn-module_lightgray__w1UDh","lightred":"AppBtn-module_lightred__ZfnPN","disabled":"AppBtn-module_disabled__VNXH9"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=AppBtn.module.scss.js.map

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/react-is/index.js
var react_is = __webpack_require__(48570);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/@loadable/component/dist/loadable.esm.js








/* eslint-disable import/prefer-default-export */
function invariant(condition, message) {
  if (condition) return;
  var error = new Error("loadable: " + message);
  error.framesToPop = 1;
  error.name = 'Invariant Violation';
  throw error;
}
function warn(message) {
  // eslint-disable-next-line no-console
  console.warn("loadable: " + message);
}

var Context = /*#__PURE__*/
react.createContext();

var LOADABLE_REQUIRED_CHUNKS_KEY = '__LOADABLE_REQUIRED_CHUNKS__';
function getRequiredChunkKey(namespace) {
  return "" + namespace + LOADABLE_REQUIRED_CHUNKS_KEY;
}

var sharedInternals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getRequiredChunkKey: getRequiredChunkKey,
  invariant: invariant,
  Context: Context
});

var LOADABLE_SHARED = {
  initialChunks: {}
};

var STATUS_PENDING = 'PENDING';
var STATUS_RESOLVED = 'RESOLVED';
var STATUS_REJECTED = 'REJECTED';

function resolveConstructor(ctor) {
  if (typeof ctor === 'function') {
    return {
      requireAsync: ctor,
      resolve: function resolve() {
        return undefined;
      },
      chunkName: function chunkName() {
        return undefined;
      }
    };
  }

  return ctor;
}

var withChunkExtractor = function withChunkExtractor(Component) {
  var LoadableWithChunkExtractor = function LoadableWithChunkExtractor(props) {
    return react.createElement(Context.Consumer, null, function (extractor) {
      return react.createElement(Component, Object.assign({
        __chunkExtractor: extractor
      }, props));
    });
  };

  if (Component.displayName) {
    LoadableWithChunkExtractor.displayName = Component.displayName + "WithChunkExtractor";
  }

  return LoadableWithChunkExtractor;
};

var identity = function identity(v) {
  return v;
};

function createLoadable(_ref) {
  var _ref$defaultResolveCo = _ref.defaultResolveComponent,
      defaultResolveComponent = _ref$defaultResolveCo === void 0 ? identity : _ref$defaultResolveCo,
      _render = _ref.render,
      onLoad = _ref.onLoad;

  function loadable(loadableConstructor, options) {
    if (options === void 0) {
      options = {};
    }

    var ctor = resolveConstructor(loadableConstructor);
    var cache = {};
    /**
     * Cachekey represents the component to be loaded
     * if key changes - component has to be reloaded
     * @param props
     * @returns {null|Component}
     */

    function _getCacheKey(props) {
      if (options.cacheKey) {
        return options.cacheKey(props);
      }

      if (ctor.resolve) {
        return ctor.resolve(props);
      }

      return 'static';
    }
    /**
     * Resolves loaded `module` to a specific `Component
     * @param module
     * @param props
     * @param Loadable
     * @returns Component
     */


    function resolve(module, props, Loadable) {
      var Component = options.resolveComponent ? options.resolveComponent(module, props) : defaultResolveComponent(module);

      if (options.resolveComponent && !(0,react_is.isValidElementType)(Component)) {
        throw new Error("resolveComponent returned something that is not a React component!");
      }

      hoist_non_react_statics_cjs_default()(Loadable, Component, {
        preload: true
      });
      return Component;
    }

    var cachedLoad = function cachedLoad(props) {
      var cacheKey = _getCacheKey(props);

      var promise = cache[cacheKey];

      if (!promise || promise.status === STATUS_REJECTED) {
        promise = ctor.requireAsync(props);
        promise.status = STATUS_PENDING;
        cache[cacheKey] = promise;
        promise.then(function () {
          promise.status = STATUS_RESOLVED;
        }, function (error) {
          console.error('loadable-components: failed to asynchronously load component', {
            fileName: ctor.resolve(props),
            chunkName: ctor.chunkName(props),
            error: error ? error.message : error
          });
          promise.status = STATUS_REJECTED;
        });
      }

      return promise;
    };

    var InnerLoadable =
    /*#__PURE__*/
    function (_React$Component) {
      (0,inheritsLoose/* default */.Z)(InnerLoadable, _React$Component);

      InnerLoadable.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var cacheKey = _getCacheKey(props);

        return (0,esm_extends/* default */.Z)({}, state, {
          cacheKey: cacheKey,
          // change of a key triggers loading state automatically
          loading: state.loading || state.cacheKey !== cacheKey
        });
      };

      function InnerLoadable(props) {
        var _this;

        _this = _React$Component.call(this, props) || this;
        _this.state = {
          result: null,
          error: null,
          loading: true,
          cacheKey: _getCacheKey(props)
        };
        invariant(!props.__chunkExtractor || ctor.requireSync, 'SSR requires `@loadable/babel-plugin`, please install it'); // Server-side

        if (props.__chunkExtractor) {
          // This module has been marked with no SSR
          if (options.ssr === false) {
            return (0,assertThisInitialized/* default */.Z)(_this);
          } // We run load function, we assume that it won't fail and that it
          // triggers a synchronous loading of the module


          ctor.requireAsync(props)["catch"](function () {
            return null;
          }); // So we can require now the module synchronously

          _this.loadSync();

          props.__chunkExtractor.addChunk(ctor.chunkName(props));

          return (0,assertThisInitialized/* default */.Z)(_this);
        } // Client-side with `isReady` method present (SSR probably)
        // If module is already loaded, we use a synchronous loading
        // Only perform this synchronous loading if the component has not
        // been marked with no SSR, else we risk hydration mismatches


        if (options.ssr !== false && ( // is ready - was loaded in this session
        ctor.isReady && ctor.isReady(props) || // is ready - was loaded during SSR process
        ctor.chunkName && LOADABLE_SHARED.initialChunks[ctor.chunkName(props)])) {
          _this.loadSync();
        }

        return _this;
      }

      var _proto = InnerLoadable.prototype;

      _proto.componentDidMount = function componentDidMount() {
        this.mounted = true; // retrieve loading promise from a global cache

        var cachedPromise = this.getCache(); // if promise exists, but rejected - clear cache

        if (cachedPromise && cachedPromise.status === STATUS_REJECTED) {
          this.setCache();
        } // component might be resolved synchronously in the constructor


        if (this.state.loading) {
          this.loadAsync();
        }
      };

      _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // Component has to be reloaded on cacheKey change
        if (prevState.cacheKey !== this.state.cacheKey) {
          this.loadAsync();
        }
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
      };

      _proto.safeSetState = function safeSetState(nextState, callback) {
        if (this.mounted) {
          this.setState(nextState, callback);
        }
      }
      /**
       * returns a cache key for the current props
       * @returns {Component|string}
       */
      ;

      _proto.getCacheKey = function getCacheKey() {
        return _getCacheKey(this.props);
      }
      /**
       * access the persistent cache
       */
      ;

      _proto.getCache = function getCache() {
        return cache[this.getCacheKey()];
      }
      /**
       * sets the cache value. If called without value sets it as undefined
       */
      ;

      _proto.setCache = function setCache(value) {
        if (value === void 0) {
          value = undefined;
        }

        cache[this.getCacheKey()] = value;
      };

      _proto.triggerOnLoad = function triggerOnLoad() {
        var _this2 = this;

        if (onLoad) {
          setTimeout(function () {
            onLoad(_this2.state.result, _this2.props);
          });
        }
      }
      /**
       * Synchronously loads component
       * target module is expected to already exists in the module cache
       * or be capable to resolve synchronously (webpack target=node)
       */
      ;

      _proto.loadSync = function loadSync() {
        // load sync is expecting component to be in the "loading" state already
        // sounds weird, but loading=true is the initial state of InnerLoadable
        if (!this.state.loading) return;

        try {
          var loadedModule = ctor.requireSync(this.props);
          var result = resolve(loadedModule, this.props, Loadable);
          this.state.result = result;
          this.state.loading = false;
        } catch (error) {
          console.error('loadable-components: failed to synchronously load component, which expected to be available', {
            fileName: ctor.resolve(this.props),
            chunkName: ctor.chunkName(this.props),
            error: error ? error.message : error
          });
          this.state.error = error;
        }
      }
      /**
       * Asynchronously loads a component.
       */
      ;

      _proto.loadAsync = function loadAsync() {
        var _this3 = this;

        var promise = this.resolveAsync();
        promise.then(function (loadedModule) {
          var result = resolve(loadedModule, _this3.props, Loadable);

          _this3.safeSetState({
            result: result,
            loading: false
          }, function () {
            return _this3.triggerOnLoad();
          });
        })["catch"](function (error) {
          return _this3.safeSetState({
            error: error,
            loading: false
          });
        });
        return promise;
      }
      /**
       * Asynchronously resolves(not loads) a component.
       * Note - this function does not change the state
       */
      ;

      _proto.resolveAsync = function resolveAsync() {
        var _this$props = this.props,
            __chunkExtractor = _this$props.__chunkExtractor,
            forwardedRef = _this$props.forwardedRef,
            props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["__chunkExtractor", "forwardedRef"]);

        return cachedLoad(props);
      };

      _proto.render = function render() {
        var _this$props2 = this.props,
            forwardedRef = _this$props2.forwardedRef,
            propFallback = _this$props2.fallback,
            __chunkExtractor = _this$props2.__chunkExtractor,
            props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props2, ["forwardedRef", "fallback", "__chunkExtractor"]);

        var _this$state = this.state,
            error = _this$state.error,
            loading = _this$state.loading,
            result = _this$state.result;

        if (options.suspense) {
          var cachedPromise = this.getCache() || this.loadAsync();

          if (cachedPromise.status === STATUS_PENDING) {
            throw this.loadAsync();
          }
        }

        if (error) {
          throw error;
        }

        var fallback = propFallback || options.fallback || null;

        if (loading) {
          return fallback;
        }

        return _render({
          fallback: fallback,
          result: result,
          options: options,
          props: (0,esm_extends/* default */.Z)({}, props, {
            ref: forwardedRef
          })
        });
      };

      return InnerLoadable;
    }(react.Component);

    var EnhancedInnerLoadable = withChunkExtractor(InnerLoadable);
    var Loadable = react.forwardRef(function (props, ref) {
      return react.createElement(EnhancedInnerLoadable, Object.assign({
        forwardedRef: ref
      }, props));
    });
    Loadable.displayName = 'Loadable'; // In future, preload could use `<link rel="preload">`

    Loadable.preload = function (props) {
      Loadable.load(props);
    };

    Loadable.load = function (props) {
      return cachedLoad(props);
    };

    return Loadable;
  }

  function lazy(ctor, options) {
    return loadable(ctor, (0,esm_extends/* default */.Z)({}, options, {
      suspense: true
    }));
  }

  return {
    loadable: loadable,
    lazy: lazy
  };
}

function defaultResolveComponent(loadedModule) {
  // eslint-disable-next-line no-underscore-dangle
  return loadedModule.__esModule ? loadedModule["default"] : loadedModule["default"] || loadedModule;
}

/* eslint-disable no-use-before-define, react/no-multi-comp */

var _createLoadable =
/*#__PURE__*/
createLoadable({
  defaultResolveComponent: defaultResolveComponent,
  render: function render(_ref) {
    var Component = _ref.result,
        props = _ref.props;
    return react.createElement(Component, props);
  }
}),
    loadable = _createLoadable.loadable,
    lazy = _createLoadable.lazy;

/* eslint-disable no-use-before-define, react/no-multi-comp */

var _createLoadable$1 =
/*#__PURE__*/
createLoadable({
  onLoad: function onLoad(result, props) {
    if (result && props.forwardedRef) {
      if (typeof props.forwardedRef === 'function') {
        props.forwardedRef(result);
      } else {
        props.forwardedRef.current = result;
      }
    }
  },
  render: function render(_ref) {
    var result = _ref.result,
        props = _ref.props;

    if (props.children) {
      return props.children(result);
    }

    return null;
  }
}),
    loadable$1 = _createLoadable$1.loadable,
    lazy$1 = _createLoadable$1.lazy;

/* eslint-disable no-underscore-dangle, camelcase */
var BROWSER = typeof window !== 'undefined';
function loadableReady(done, _temp) {
  if (done === void 0) {
    done = function done() {};
  }

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? '' : _ref$namespace,
      _ref$chunkLoadingGlob = _ref.chunkLoadingGlobal,
      chunkLoadingGlobal = _ref$chunkLoadingGlob === void 0 ? '__LOADABLE_LOADED_CHUNKS__' : _ref$chunkLoadingGlob;

  if (!BROWSER) {
    warn('`loadableReady()` must be called in browser only');
    done();
    return Promise.resolve();
  }

  var requiredChunks = null;

  if (BROWSER) {
    var id = getRequiredChunkKey(namespace);
    var dataElement = document.getElementById(id);

    if (dataElement) {
      requiredChunks = JSON.parse(dataElement.textContent);
      var extElement = document.getElementById(id + "_ext");

      if (extElement) {
        var _JSON$parse = JSON.parse(extElement.textContent),
            namedChunks = _JSON$parse.namedChunks;

        namedChunks.forEach(function (chunkName) {
          LOADABLE_SHARED.initialChunks[chunkName] = true;
        });
      } else {
        // version mismatch
        throw new Error('loadable-component: @loadable/server does not match @loadable/component');
      }
    }
  }

  if (!requiredChunks) {
    warn('`loadableReady()` requires state, please use `getScriptTags` or `getScriptElements` server-side');
    done();
    return Promise.resolve();
  }

  var resolved = false;
  return new Promise(function (resolve) {
    window[chunkLoadingGlobal] = window[chunkLoadingGlobal] || [];
    var loadedChunks = window[chunkLoadingGlobal];
    var originalPush = loadedChunks.push.bind(loadedChunks);

    function checkReadyState() {
      if (requiredChunks.every(function (chunk) {
        return loadedChunks.some(function (_ref2) {
          var chunks = _ref2[0];
          return chunks.indexOf(chunk) > -1;
        });
      })) {
        if (!resolved) {
          resolved = true;
          resolve();
        }
      }
    }

    loadedChunks.push = function () {
      originalPush.apply(void 0, arguments);
      checkReadyState();
    };

    checkReadyState();
  }).then(done);
}

/* eslint-disable no-underscore-dangle */
var loadable$2 = loadable;
loadable$2.lib = loadable$1;
var lazy$2 = lazy;
lazy$2.lib = lazy$1;
var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (/* unused pure expression or super */ null && (sharedInternals));

/* harmony default export */ var loadable_esm = (loadable$2);


;// CONCATENATED MODULE: ../core/dist/components/app-btn/AppBtn.js






// import Skeleton from "../skeleton/Skeleton";
const Skeleton = loadable_esm(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 71155)));
const AppBtn = (_a) => {
    var { onClick, type = "primary", fillType = "solid", className, classDisabled, isBlockBtn, width, style, isInHoverState = false, isMobile = false, disabled = false, btnType = "button", id } = _a, props = (0,_tslib/* __rest */._)(_a, ["onClick", "type", "fillType", "className", "classDisabled", "isBlockBtn", "width", "style", "isInHoverState", "isMobile", "disabled", "btnType", "id"]);
    return (react.createElement("button", Object.assign({ className: classnames_default()(Styles.main, Styles[type], Styles[fillType], isMobile ? Styles.mobile : Styles.desktop, isInHoverState ? Styles.hover : "", disabled ? Styles.disabled : "", disabled ? classDisabled : "", className), disabled: disabled, style: Object.assign({ width: isBlockBtn ? "100%" : width }, style), onClick: onClick, type: btnType, id: id, "data-testid": id }, props), type === "loading" ? react.createElement(Skeleton, { type: "button" }) : props.children));
};


//# sourceMappingURL=AppBtn.js.map


/***/ }),

/***/ 90650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46633);
/* harmony import */ var _scss_helper_module_scss_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47526);
/* harmony import */ var _validation_error_ValidationError_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3992);
/* harmony import */ var _methods_getSizeByViewPort_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98175);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);







// export default forwardRef(
//     <T extends string | number | readonly string[] | undefined>(props: AppInputProps<T>, ref: Ref<AppInputRef>) => (
//         <AppInput {...props} ref={ref} />
//     )
// );
const AppInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(({ name, type, isRequired = false, labelText, valuePrefix, valueSuffix, value, onChange, onBlur, onFocus, error, isActiveByDefault = false, labelStyles = {}, containerStyles = {}, inputWrapperStyles = {}, prefixStyles = {}, suffixStyles = {}, inputStyles = {}, isValid = true, placeholder, alwaysShowPrefix, alwaysShowSuffix, setFocus = 0, autoComplete = true, className, containerClassName, labelClassName, inputWrapperClassName, inputClassName, prefixClassName, suffixClassName, activeClassName, dirtyClassName, showValidationErrOnChange = true, disabled = false, errorClass, maxlength, id }, ref) => {
    const [isActive, setIsActive] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [isDirty, setIsDirty] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // const numField = useField({ name, type });
    const _onFocus = (e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        setIsActive(true);
    };
    const _onBlur = (e) => {
        e.persist();
        setIsDirty(!!e.target.value);
        setIsActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const _onChange = (e) => {
        e.persist();
        showValidationErrOnChange && setIsDirty(!!e.target.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (setFocus) {
            setTimeout(() => {
                var _a;
                // elem?.focus();
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 1);
        }
    }, [setFocus]);
    const focus = () => {
        setTimeout(() => {
            var _a;
            // elem?.focus();
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 1);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, () => ({
        focus
    }));
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        // isActiveByDefault &&
        //     setTimeout(() => {
        //         console.log("elem", elem);
        //         elem?.focus();
        //     }, 1);
        if (isActiveByDefault && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isActiveByDefault]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(disabled && _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].disabled */ .Z.disabled, className) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { 
            // className={classNames(
            //     containerClassName,
            //     HelperStyles.center_vertical +
            //         " " +
            //         AppInputStyles.field_group +
            //         " " +
            //         (isActive ? AppInputStyles.active : "") +
            //         " " +
            //         ((isDirty || value) && !isValid ? AppInputStyles.invalid : ""),
            //     containerClassName
            // )}
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_scss_helper_module_scss_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].center_vertical */ .Z.center_vertical, _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].field_group */ .Z.field_group, isActive && _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].active */ .Z.active, isActive && activeClassName, (isDirty || value) && error && _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].invalid */ .Z.invalid, containerClassName), style: containerStyles },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", { htmlFor: name, 
                // hidden={activeField !== "name" && !isDirty}
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(isActive
                    ? _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].active */ .Z.active + " " + activeClassName
                    : isDirty || value
                        ? _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dirty */ .Z.dirty + " " + dirtyClassName
                        : "", labelClassName), style: labelStyles },
                labelText,
                isRequired && react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: _AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].required */ .Z.required }, " *")),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: Object.assign({}, inputWrapperStyles), className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input_wrapper */ .Z.input_wrapper, inputWrapperClassName) },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: Object.assign({ marginRight: valuePrefix && "9px" }, inputStyles), hidden: !alwaysShowPrefix && !isActive && !(isDirty || value), className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].value_prefix */ .Z.value_prefix, inputClassName, prefixClassName) }, valuePrefix),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", { 
                    // ref={isActiveByDefault ? refFunc : null}
                    // ref={refFunc}
                    id: id, ref: inputRef, name: name, type: type, onChange: _onChange, onFocus: _onFocus, onBlur: _onBlur, className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input */ .Z.input, inputClassName), value: value, style: inputStyles, placeholder: placeholder, autoFocus: isActiveByDefault, autoComplete: !autoComplete ? "off" : undefined, disabled: disabled, maxLength: maxlength, onWheel: (event) => event.currentTarget.blur() }),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { style: Object.assign({ marginLeft: valueSuffix && "9px" }, suffixStyles), hidden: !alwaysShowSuffix && !isActive && !(isDirty || value), className: classnames__WEBPACK_IMPORTED_MODULE_5___default()(_AppInput_module_scss_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].value_suffix */ .Z.value_suffix, suffixClassName) }, valueSuffix))),
        error && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_validation_error_ValidationError_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { error: isDirty ? error : "", style: { marginTop: (0,_methods_getSizeByViewPort_js__WEBPACK_IMPORTED_MODULE_4__/* .getHeightByViewPort */ .J)(8) }, errorClass: classnames__WEBPACK_IMPORTED_MODULE_5___default()(errorClass) }))));
});


//# sourceMappingURL=AppInput.js.map


/***/ }),

/***/ 46633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppInputStyles; }
/* harmony export */ });
/* harmony import */ var _node_modules_style_inject_dist_style_inject_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36474);


var css_248z = ".AppInput-module_disabled__Jbksj,\n.AppInput-module_disabled__Jbksj * {\n  cursor: pointer;\n}\n\n.AppInput-module_field_group__abgCu {\n  position: relative;\n  border: 1px solid rgba(231, 235, 238, 0.7019607843);\n  height: 50px;\n  width: 100%;\n  border-radius: 4px;\n}\n.AppInput-module_field_group__abgCu.AppInput-module_active__1lf8g {\n  border-color: #1053ff !important;\n}\n.AppInput-module_field_group__abgCu.AppInput-module_invalid__wfoM2 {\n  border-color: #ff1224;\n}\n.AppInput-module_field_group__abgCu label {\n  position: absolute;\n  top: 15px;\n  left: 14px;\n  padding: 0 6px;\n  transition: 0.2s;\n  pointer-events: none;\n  background-color: white;\n  color: rgba(13, 13, 15, 0.5);\n  font-size: 0.875rem;\n  font-family: var(--font-regular);\n  letter-spacing: 0;\n  line-height: calc(0.0246305418 * var(--screen-height));\n  z-index: 1;\n}\n.AppInput-module_field_group__abgCu label.AppInput-module_active__1lf8g {\n  color: #1053ff;\n}\n.AppInput-module_field_group__abgCu label.AppInput-module_dirty__uFCZ7 {\n  color: #868687;\n}\n.AppInput-module_field_group__abgCu label.AppInput-module_active__1lf8g, .AppInput-module_field_group__abgCu label.AppInput-module_dirty__uFCZ7 {\n  top: -4px !important;\n  z-index: 100;\n  font-size: 0.75rem;\n  letter-spacing: -0.0075rem;\n  line-height: calc(0.0123152709 * var(--screen-height));\n}\n.AppInput-module_field_group__abgCu label .AppInput-module_required__mpNRz {\n  color: var(--red-color);\n}\n.AppInput-module_field_group__abgCu .AppInput-module_input_wrapper__ppBAL {\n  padding: 0 20px;\n  color: #0a2239;\n  font-size: 0.875rem;\n  font-family: var(--font-bold);\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.AppInput-module_field_group__abgCu .AppInput-module_value_prefix__NvE7T,\n.AppInput-module_field_group__abgCu .AppInput-module_value_suffix__38FZD {\n  flex-grow: 0;\n}\n.AppInput-module_field_group__abgCu input,\n.AppInput-module_field_group__abgCu .AppInput-module_input__rOFKz {\n  box-sizing: border-box;\n  box-shadow: none;\n  outline: none;\n  border: none;\n  color: #0a2239;\n  font-size: 0.875rem;\n  font-family: var(--font-bold);\n  flex-grow: 1;\n  caret-color: #1053ff;\n}\n.AppInput-module_field_group__abgCu input:disabled,\n.AppInput-module_field_group__abgCu .AppInput-module_input__rOFKz:disabled {\n  background-color: inherit;\n}\n\n::placeholder {\n  color: rgba(13, 45, 17, 0.12);\n}\n\n/* hide up down arrows */\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n@media (min-width: 992px) {\n  .AppInput-module_value_prefix__NvE7T,\n  .AppInput-module_input__rOFKz {\n    font-size: 1.375rem;\n  }\n}";
var AppInputStyles = {"disabled":"AppInput-module_disabled__Jbksj","field_group":"AppInput-module_field_group__abgCu","active":"AppInput-module_active__1lf8g","invalid":"AppInput-module_invalid__wfoM2","dirty":"AppInput-module_dirty__uFCZ7","required":"AppInput-module_required__mpNRz","input_wrapper":"AppInput-module_input_wrapper__ppBAL","value_prefix":"AppInput-module_value_prefix__NvE7T","value_suffix":"AppInput-module_value_suffix__38FZD","input":"AppInput-module_input__rOFKz"};
(0,_node_modules_style_inject_dist_style_inject_es_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(css_248z);


//# sourceMappingURL=AppInput.module.scss.js.map


/***/ }),

/***/ 49143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DotSeparated; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/dot-separated/DotSeparated.module.scss.js


var css_248z = ".DotSeparated-module_DotSeparated__i4x9r {\n  display: flex;\n}\n.DotSeparated-module_DotSeparated__i4x9r * {\n  margin: 0;\n  padding: 0;\n}\n.DotSeparated-module_DotSeparated__i4x9r .DotSeparated-module_nodes__CXWl4 {\n  display: flex;\n  align-items: center;\n}\n.DotSeparated-module_DotSeparated__i4x9r .DotSeparated-module_nodes__CXWl4 .DotSeparated-module_dot__0LtXO {\n  margin: 0 5px;\n  width: 5px;\n  height: 5px;\n  flex-grow: 0;\n  background-color: #999;\n  border-radius: 50%;\n}";
var Styles = {"DotSeparated":"DotSeparated-module_DotSeparated__i4x9r","nodes":"DotSeparated-module_nodes__CXWl4","dot":"DotSeparated-module_dot__0LtXO"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=DotSeparated.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/dot-separated/DotSeparated.js




const DotSeparated = ({ nodes, dotStyleClassName, nodesClassName, wrapperClassName }) => {
    return (react.createElement("div", { className: classnames_default()(Styles.DotSeparated, wrapperClassName) }, nodes.map((node, idx) => (react.createElement("div", { className: classnames_default()(Styles.nodes, nodesClassName), key: idx },
        node,
        " ",
        idx !== nodes.length - 1 ? (react.createElement("span", { className: classnames_default()(Styles.dot, dotStyleClassName) })) : (""))))));
};


//# sourceMappingURL=DotSeparated.js.map


/***/ }),

/***/ 92266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/reactstrap/lib/Dropdown.js
var Dropdown = __webpack_require__(42916);
// EXTERNAL MODULE: ../../node_modules/reactstrap/lib/DropdownMenu.js
var DropdownMenu = __webpack_require__(83483);
// EXTERNAL MODULE: ../../node_modules/reactstrap/lib/DropdownToggle.js
var DropdownToggle = __webpack_require__(89166);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/dropdown/Dropdown.module.scss.js


var css_248z = ".Dropdown-module_dropdownMenu__nW9YH {\n  transform: none !important;\n  top: 100% !important;\n}";
var Styles = {"dropdownMenu":"Dropdown-module_dropdownMenu__nW9YH"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=Dropdown.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/dropdown/Dropdown.js







const Dropdown_Dropdown = ({ id, children, DropdownToggleBtn, isOpen = false, handleToggle, containerClassName, dropdownClassName, dropdownToggleClassName, disabled, direction, onBlur }) => {
    return (react.createElement("div", { className: containerClassName },
        react.createElement(Dropdown/* default */.Z, { isOpen: isOpen, toggle: handleToggle, direction: direction, onBlur: onBlur, id: id },
            react.createElement(DropdownToggle/* default */.Z, { className: classnames_default()(`${isOpen ? "active" : ""}`, dropdownToggleClassName), disabled: disabled, tag: "span" }, DropdownToggleBtn),
            react.createElement(DropdownMenu/* default */.Z, { className: classnames_default()(Styles.dropdownMenu, dropdownClassName), style: { zIndex: 9999 }, translate: "no" }, children))));
};


//# sourceMappingURL=Dropdown.js.map


/***/ }),

/***/ 62945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EllipsisTooltip; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/ellipsis-tooltip/EllipsisTooltip.module.scss.js


var css_248z = ".EllipsisTooltip-module_ellipsisTooltip__ZhlnC {\n  overflow: hidden;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  position: relative;\n}\n\n.EllipsisTooltip-module_ellipsisTooltip__ZhlnC:hover {\n  overflow: visible;\n}\n.EllipsisTooltip-module_ellipsisTooltip__ZhlnC:hover .EllipsisTooltip-module_defaultValue__tVPUJ {\n  overflow: hidden;\n  display: block;\n  width: 100%;\n  text-overflow: ellipsis;\n}\n\n.EllipsisTooltip-module_noTooltip__qTdPs {\n  overflow: hidden;\n}\n\n.EllipsisTooltip-module_tooltip__qxJdi {\n  display: none;\n}\n\n.EllipsisTooltip-module_ellipsisTooltip__ZhlnC:hover .EllipsisTooltip-module_tooltip__qxJdi {\n  white-space: pre-wrap;\n  position: absolute;\n  top: -4px;\n  left: 0;\n  display: block;\n  background-color: white;\n  -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.24);\n  -moz-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.24);\n  box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.24);\n  border-radius: 3px;\n  padding: 4px 5px;\n  z-index: 2;\n  width: 105%;\n  line-height: 14px;\n  font-size: 10px;\n}";
var Styles = {"ellipsisTooltip":"EllipsisTooltip-module_ellipsisTooltip__ZhlnC","defaultValue":"EllipsisTooltip-module_defaultValue__tVPUJ","noTooltip":"EllipsisTooltip-module_noTooltip__qTdPs","tooltip":"EllipsisTooltip-module_tooltip__qxJdi"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=EllipsisTooltip.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/ellipsis-tooltip/EllipsisTooltip.js




const EllipsisTooltip = ({ textValue = "", greaterThanValue, styles, mainClass, defaultValueClassName, toolTipClassName }) => {
    return (react.createElement("span", { className: classnames_default()(mainClass, textValue.length > greaterThanValue ? Styles.ellipsisTooltip : Styles.noTooltip), style: styles },
        react.createElement("span", { className: classnames_default()(Styles.defaultValue, defaultValueClassName) }, textValue),
        react.createElement("span", { className: classnames_default()(Styles.tooltip, toolTipClassName) }, textValue)));
};


//# sourceMappingURL=EllipsisTooltip.js.map


/***/ }),

/***/ 93902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FlatInput; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _app_input_AppInput_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90650);
/* harmony import */ var _FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75544);






const FlatInput = (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((_a, forwardedRef) => {
    var { id, className, containerClassName, labelClassName, inputWrapperClassName, inputClassName, prefixClassName, suffixClassName, errorClass } = _a, props = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._)(_a, ["id", "className", "containerClassName", "labelClassName", "inputWrapperClassName", "inputClassName", "prefixClassName", "suffixClassName", "errorClass"]);
    const appInputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle)(forwardedRef, () => { var _a; return ({ focus: ((_a = appInputRef.current) === null || _a === void 0 ? void 0 : _a.focus) || (() => { }) }); });
    return (react__WEBPACK_IMPORTED_MODULE_2__.createElement(_app_input_AppInput_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, Object.assign({ id: id, className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className), containerClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].inputContainer */ .Z.inputContainer, containerClassName), inputWrapperClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].inputWrapper */ .Z.inputWrapper, inputWrapperClassName), labelClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].label */ .Z.label, labelClassName), inputClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].input */ .Z.input, inputClassName), prefixClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].prefix */ .Z.prefix, prefixClassName), suffixClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].suffix */ .Z.suffix, suffixClassName), activeClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].active */ .Z.active), dirtyClassName: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_FlatInput_module_scss_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dirty */ .Z.dirty), errorClass: errorClass }, props)));
});


//# sourceMappingURL=FlatInput.js.map


/***/ }),

/***/ 75544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FlatInputStyles; }
/* harmony export */ });
/* harmony import */ var _node_modules_style_inject_dist_style_inject_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36474);


var css_248z = ".FlatInput-module_inputContainer__tmeU9 {\n  border: none !important;\n  border-bottom: solid 2px #e9e9e9 !important;\n  border-radius: 0 !important;\n  height: unset !important;\n}\n\n.FlatInput-module_label__Ss11V {\n  left: 0 !important;\n  padding: 0 !important;\n  color: #666666 !important;\n  height: 1.25rem;\n  line-height: 1 !important;\n  opacity: 0.9;\n  top: unset !important;\n  bottom: 12px;\n  margin-bottom: 0;\n}\n.FlatInput-module_label__Ss11V.FlatInput-module_active__T5sUa.FlatInput-module_active__T5sUa, .FlatInput-module_label__Ss11V.FlatInput-module_dirty__DY087.FlatInput-module_dirty__DY087 {\n  color: #666666 !important;\n  font-size: 0.875rem !important;\n  height: 1rem;\n  top: unset !important;\n  bottom: calc(1.25rem + 2 * 12px);\n}\n\n.FlatInput-module_inputWrapper__kYDwX {\n  padding: 12px 0 !important;\n  font-family: var(--font-medium);\n  height: calc(1.25rem + 2 * 12px);\n  line-height: 1;\n}\n\n.FlatInput-module_input__O8rMs {\n  color: #333333;\n  padding: 15px 0;\n  height: calc(1.25rem + 2 * 12px);\n  line-height: 1;\n}\n\n.FlatInput-module_prefix__uz5s4 {\n  color: #999999;\n}\n\n@media (max-width: 991px) {\n  .FlatInput-module_label__Ss11V {\n    font-size: 0.875rem !important;\n  }\n  .FlatInput-module_prefix__uz5s4 {\n    font-size: 1rem !important;\n  }\n  .FlatInput-module_input__O8rMs {\n    font-size: 1rem !important;\n  }\n  .FlatInput-module_inputWrapper__kYDwX {\n    font-size: 1rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .FlatInput-module_label__Ss11V {\n    font-size: 1.25rem !important;\n  }\n  .FlatInput-module_label__Ss11V.FlatInput-module_active__T5sUa.FlatInput-module_active__T5sUa, .FlatInput-module_label__Ss11V.FlatInput-module_dirty__DY087.FlatInput-module_dirty__DY087 {\n    font-size: 1rem !important;\n  }\n  .FlatInput-module_input__O8rMs {\n    font-size: 1.25rem !important;\n    padding: 12px 0;\n  }\n  .FlatInput-module_inputWrapper__kYDwX {\n    font-size: 1.25rem !important;\n  }\n}";
var FlatInputStyles = {"inputContainer":"FlatInput-module_inputContainer__tmeU9","label":"FlatInput-module_label__Ss11V","active":"FlatInput-module_active__T5sUa","dirty":"FlatInput-module_dirty__DY087","inputWrapper":"FlatInput-module_inputWrapper__kYDwX","input":"FlatInput-module_input__O8rMs","prefix":"FlatInput-module_prefix__uz5s4"};
(0,_node_modules_style_inject_dist_style_inject_es_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(css_248z);


//# sourceMappingURL=FlatInput.module.scss.js.map


/***/ }),

/***/ 12215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var reactstrap_lib_Col__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28261);



const Col = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(reactstrap_lib_Col__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({}, props));
};


//# sourceMappingURL=Col.js.map


/***/ }),

/***/ 11758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var reactstrap_lib_Row__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50157);



const Row = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(reactstrap_lib_Row__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({}, props));
};


//# sourceMappingURL=Row.js.map


/***/ }),

/***/ 26415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


const Loader = ({ isFullPage = true }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: "pageLoader" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: "preloader", style: { position: isFullPage ? "fixed" : "inherit" } },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { id: "status" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "spinner" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "double-bounce1" }),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "double-bounce2" }))))));
};


//# sourceMappingURL=loader.js.map


/***/ }),

/***/ 87890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchFullScreenMobile; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../core/dist/methods/getRemValue.js
var getRemValue = __webpack_require__(89842);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../core/dist/methods/getAuthIdParam.js
var getAuthIdParam = __webpack_require__(4913);
// EXTERNAL MODULE: ../core/dist/methods/formatDate.js
var formatDate = __webpack_require__(11663);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/components/search/Search.js + 65 modules
var Search = __webpack_require__(81528);
;// CONCATENATED MODULE: ../core/dist/icons/BackBtn.svg.js


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBackBtn(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.98,
    height: 16,
    viewBox: "0 0 15.98 16"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M.1 7.493a1.332 1.332 0 01.28-.44L7.041.392a1.338 1.338 0 011.892 1.892l-4.4 4.383h10.115a1.332 1.332 0 110 2.664H4.536l4.4 4.383a1.338 1.338 0 11-1.895 1.89L.38 8.945A1.377 1.377 0 01.1 7.493z",
    fill: "#202124"
  })));
}


//# sourceMappingURL=BackBtn.svg.js.map

// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/search-full-screen-mobile/SearchFullScreenMobile.module.scss.js


var css_248z = ".SearchFullScreenMobile-module_container__I4mZT {\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n  position: fixed;\n  top: 0px;\n  left: 0;\n  z-index: 9999999999;\n  padding: 12px 16px 0;\n}\n\n.SearchFullScreenMobile-module_prefix_container__0DK8P {\n  display: flex;\n  width: 38px;\n  justify-content: center;\n}";
var Styles = {"container":"SearchFullScreenMobile-module_container__I4mZT","prefix_container":"SearchFullScreenMobile-module_prefix_container__0DK8P"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=SearchFullScreenMobile.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/search-full-screen-mobile/SearchFullScreenMobile.scss.js


var SearchFullScreenMobile_scss_css_248z = ".search_fullscreen_mobile .rbt-input-main.form-control.rbt-input {\n  font-family: var(--font-regular);\n  font-size: 1rem;\n  letter-spacing: -0.01rem;\n  color: #202124;\n}\n.search_fullscreen_mobile .rbt-input-main.form-control.rbt-input::placeholder {\n  font-family: var(--font-regular);\n  font-size: 1rem;\n  letter-spacing: -0.01rem;\n  color: #80868b;\n}\n.search_fullscreen_mobile .rbt-menu.dropdown-menu.show {\n  top: 17px !important;\n  padding: 0 !important;\n  left: -54px !important;\n  width: calc(100vw - 32px) !important;\n  max-width: unset !important;\n  min-width: unset !important;\n  height: 100vh !important;\n  max-height: 100vh !important;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n.search_fullscreen_mobile .rbt-menu.dropdown-menu.show .dropdown-item {\n  padding: 12px 0;\n}\n.search_fullscreen_mobile .destination-search_input-wrapper {\n  animation: paint 1s forwards;\n}\n\n@keyframes paint {\n  0% {\n    right: -260px;\n    width: 290px;\n    z-index: 1;\n    background-color: white;\n    display: none !important;\n  }\n  100% {\n    left: 0;\n    width: 732px;\n    opacity: 1;\n    display: unset !important;\n    background-color: white;\n    cursor: pointer;\n    z-index: 1;\n  }\n}";
(0,style_inject_es/* default */.Z)(SearchFullScreenMobile_scss_css_248z);


//# sourceMappingURL=SearchFullScreenMobile.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/search-full-screen-mobile/SearchFullScreenMobile.js











































const SearchFullScreenMobile = (_a) => {
    var { isVisible = false, onClickBackBtn, id, isLoading, onSearch, onSelectItem, onInputChange, onFocus, selectedItem, options, searchText, labelKey, labelText, placeholder } = _a, props = (0,_tslib/* __rest */._)(_a, ["isVisible", "onClickBackBtn", "id", "isLoading", "onSearch", "onSelectItem", "onInputChange", "onFocus", "selectedItem", "options", "searchText", "labelKey", "labelText", "placeholder"]);
    const searchRef = (0,react.useRef)(null);
    (0,react.useEffect)(() => {
        (() => (0,_tslib/* __awaiter */.m)(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (isVisible) {
                (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                document.body.style.overflow = "hidden";
                if (window.scrollY !== 0) {
                    window.scrollTo({ left: 0, top: 0, behavior: "auto" });
                }
                (_b = document.querySelector(".sticky-inner-wrapper")) === null || _b === void 0 ? void 0 : _b.classList.add("inactive");
            }
            else {
                document.body.style.overflow = "unset";
                (_c = document.querySelector(".sticky-inner-wrapper")) === null || _c === void 0 ? void 0 : _c.classList.remove("inactive");
            }
        }))();
    }, [isVisible]);
    return isVisible ? (react.createElement("div", { className: classnames_default()(Styles.container, "search_fullscreen_mobile") },
        react.createElement(Search/* default */.Z, Object.assign({ ref: searchRef, id: id, isLoading: isLoading, onSearch: onSearch, onSelectItem: onSelectItem, onInputChange: onInputChange, selectedItem: undefined, options: options, searchText: searchText, labelText: labelText, labelKey: labelKey, onFocus: onFocus, 
            // setFocus={1}
            placeholder: placeholder, containerStyles: {
                height: "58px",
                border: "none",
                borderBottom: "none",
                borderRadius: 0
            }, inputWrapperStyles: {
                padding: "0"
                // marginTop: "12px"
            }, inputStyles: {
                paddingLeft: "16px",
                fontSize: (0,getRemValue/* getRemValue */.T)(15),
                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.15),
                color: "#3B52FF",
                fontWeight: misc/* FONT_WEIGHTS.medium */.Xw.medium,
                lineHeight: "18px"
            }, prefix: react.createElement("span", { onClick: onClickBackBtn },
                react.createElement(SvgBackBtn, null)), prefixClassName: Styles.prefix_container, setFocus: 1, minLength: 0 }, props)))) : null;
};


//# sourceMappingURL=SearchFullScreenMobile.js.map


/***/ }),

/***/ 81528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Search; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(80594);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/@restart/hooks/esm/useForceUpdate.js

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */

function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are stricting equal to the last state value
  var _useReducer = (0,react.useReducer)(function (state) {
    return !state;
  }, false),
      dispatch = _useReducer[1];

  return dispatch;
}
;// CONCATENATED MODULE: ../../node_modules/@restart/hooks/esm/usePrevious.js

/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */

function usePrevious(value) {
  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(69378);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
// EXTERNAL MODULE: ../../node_modules/invariant/browser.js
var browser = __webpack_require__(47677);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/constants.js
/**
 * Common (non-printable) keycodes for `keydown` and `keyup` events. Note that
 * `keypress` handles things differently and may not return the same values.
 */
var BACKSPACE = 8;
var TAB = 9;
var RETURN = 13;
var ESC = 27;
var SPACE = 32;
var LEFT = 37;
var UP = 38;
var RIGHT = 39;
var DOWN = 40;
var DEFAULT_LABELKEY = 'label';
var ALIGN = {
  JUSTIFY: 'justify',
  LEFT: 'left',
  RIGHT: 'right'
};
var SIZE = {
  LARGE: 'large',
  LG: 'lg',
  SM: 'sm',
  SMALL: 'small'
};
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getStringLabelKey.js

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : DEFAULT_LABELKEY;
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/nodash.js
var idCounter = 0;
function head(arr) {
  return Array.isArray(arr) && arr.length ? arr[0] : undefined;
}
function isFunction(value) {
  return typeof value === 'function';
}
function isString(value) {
  return typeof value === 'string';
}
function noop() {}
function pick(obj, keys) {
  var result = {};
  keys.forEach(function (k) {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      result[k] = obj[k];
    }
  });
  return result;
}
function uniqueId(prefix) {
  idCounter += 1;
  return (prefix == null ? '' : String(prefix)) + idCounter;
} // Export for testing purposes.

function valuesPolyfill(obj) {
  return Object.keys(obj).reduce(function (accum, key) {
    if (Object.prototype.propertyIsEnumerable.call(obj, key)) {
      accum.push(obj[key]);
    }

    return accum;
  }, []);
}
function values(obj) {
  return isFunction(Object.values) ? Object.values(obj) : valuesPolyfill(obj);
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getOptionLabel.js




/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel(option, labelKey) {
  // Handle internally created options first.
  if (!isString(option) && (option.paginationOption || option.customOption)) {
    return option[getStringLabelKey(labelKey)];
  }

  var optionLabel;

  if (isFunction(labelKey)) {
    optionLabel = labelKey(option);
  } else if (isString(option)) {
    optionLabel = option;
  } else {
    // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
  }

  !isString(optionLabel) ?  false ? 0 : browser_default()(false) : void 0;
  return optionLabel;
}

/* harmony default export */ var utils_getOptionLabel = (getOptionLabel);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/addCustomOption.js


function addCustomOption(results, props) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey,
      text = props.text;

  if (!allowNew || !text.trim()) {
    return false;
  } // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.


  if (typeof allowNew === 'function') {
    return allowNew(results, props);
  } // By default, don't add the custom option if there is an exact text match
  // with an existing option.


  return !results.some(function (o) {
    return utils_getOptionLabel(o, labelKey) === text;
  });
}

/* harmony default export */ var utils_addCustomOption = (addCustomOption);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getOptionProperty.js

function getOptionProperty(option, key) {
  if (isString(option)) {
    return undefined;
  }

  return option[key];
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/stripDiacritics.js
/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Taken from: http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/18391901#18391901
 */

/* eslint-disable max-len */
var map = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'OE',
  letters: "\x8C\u0152"
}, {
  base: 'oe',
  letters: "\x9C\u0153"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
/* eslint-enable max-len */

var diacriticsMap = {};

for (var ii = 0; ii < map.length; ii++) {
  var letters = map[ii].letters;

  for (var jj = 0; jj < letters.length; jj++) {
    diacriticsMap[letters[jj]] = map[ii].base;
  }
} // "what?" version ... http://jsperf.com/diacritics/12


function stripDiacritics(str) {
  return str.replace(/[\u0300-\u036F]/g, '') // Remove combining diacritics

  /* eslint-disable-next-line no-control-regex */
  .replace(/[^\u0000-\u007E]/g, function (a) {
    return diacriticsMap[a] || a;
  });
}
// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(45982);
var warning_default = /*#__PURE__*/__webpack_require__.n(warning);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/warn.js

var warned = {};
/**
 * Copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
 */

function warn_warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  warning_default().apply(void 0, [falseToWarn, "[react-bootstrap-typeahead] " + message].concat(args));
}
function resetWarned() {
  warned = {};
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/defaultFilterBy.js






function isMatch(input, string, props) {
  var searchStr = input;
  var str = string;

  if (!props.caseSensitive) {
    searchStr = searchStr.toLowerCase();
    str = str.toLowerCase();
  }

  if (props.ignoreDiacritics) {
    searchStr = stripDiacritics(searchStr);
    str = stripDiacritics(str);
  }

  return str.indexOf(searchStr) !== -1;
}
/**
 * Default algorithm for filtering results.
 */


function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text; // Don't show selected options in the menu for the multi-select case.

  if (multiple && selected.some(function (o) {
    return fast_deep_equal_default()(o, option);
  })) {
    return false;
  }

  if (isFunction(labelKey) && isMatch(text, labelKey(option), props)) {
    return true;
  }

  var fields = filterBy.slice();

  if (isString(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }

  if (isString(option)) {
    warn_warn(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
    return isMatch(text, option, props);
  }

  return fields.some(function (field) {
    var value = getOptionProperty(option, field);

    if (!isString(value)) {
      warn_warn(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');
      value = String(value);
    }

    return isMatch(text, value, props);
  });
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getDisplayName.js
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getMatchBounds.js


var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;
// Export for testing.
function escapeStringRegexp(str) {
  !(typeof str === 'string') ?  false ? 0 : browser_default()(false) : void 0; // Escape characters with special meaning either inside or outside character
  // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
  // escape when the simpler form would be disallowed by Unicode patterns’
  // stricter grammar.

  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function getMatchBounds(subject, str) {
  var search = new RegExp(escapeStringRegexp(stripDiacritics(str)), CASE_INSENSITIVE);
  var matches = search.exec(stripDiacritics(subject));

  if (!matches) {
    return null;
  }

  var start = matches.index;
  var matchLength = matches[0].length; // Account for combining marks, which changes the indices.

  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start += 1;
      }
    } // Similarly, increment the length of the match string if it contains a
    // combining mark.


    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength += 1;
      }
    }
  }

  return {
    end: start + matchLength,
    start: start
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getHintText.js



function getHintText(props) {
  var activeIndex = props.activeIndex,
      initialItem = props.initialItem,
      isFocused = props.isFocused,
      isMenuShown = props.isMenuShown,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text; // Don't display a hint under the following conditions:

  if ( // No text entered.
  !text || // The input is not focused.
  !isFocused || // The menu is hidden.
  !isMenuShown || // No item in the menu.
  !initialItem || // The initial item is a custom option.
  initialItem.customOption || // One of the menu items is active.
  activeIndex > -1 || // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }

  var initialItemStr = utils_getOptionLabel(initialItem, labelKey);
  var bounds = getMatchBounds(initialItemStr.toLowerCase(), text.toLowerCase());

  if (!(bounds && bounds.start === 0)) {
    return '';
  } // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.


  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

/* harmony default export */ var utils_getHintText = (getHintText);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getMenuItemId.js
function getMenuItemId(id, position) {
  return (id || '') + "-item-" + position;
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getInputProps.js





var getInputProps = function getInputProps(_ref) {
  var activeIndex = _ref.activeIndex,
      id = _ref.id,
      isFocused = _ref.isFocused,
      isMenuShown = _ref.isMenuShown,
      multiple = _ref.multiple,
      onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["activeIndex", "id", "isFocused", "isMenuShown", "multiple", "onFocus", "placeholder"]);

  return function (_temp) {
    var _cx;

    var _ref2 = _temp === void 0 ? {} : _temp,
        className = _ref2.className,
        inputProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["className"]);

    var props = (0,esm_extends/* default */.Z)({
      /* eslint-disable sort-keys */
      // These props can be overridden by values in `inputProps`.
      autoComplete: 'off',
      placeholder: placeholder,
      type: 'text'
    }, inputProps, rest, {
      'aria-activedescendant': activeIndex >= 0 ? getMenuItemId(id, activeIndex) : undefined,
      'aria-autocomplete': 'both',
      'aria-expanded': isMenuShown,
      'aria-haspopup': 'listbox',
      'aria-owns': isMenuShown ? id : undefined,
      className: classnames_default()((_cx = {}, _cx[className || ''] = !multiple, _cx.focus = isFocused, _cx)),
      // Re-open the menu, eg: if it's closed via ESC.
      onClick: onFocus,
      onFocus: onFocus,
      // Comboboxes are single-select by definition:
      // https://www.w3.org/TR/wai-aria-practices-1.1/#combobox
      role: 'combobox'
      /* eslint-enable sort-keys */

    });

    if (!multiple) {
      return props;
    }

    return (0,esm_extends/* default */.Z)({}, props, {
      'aria-autocomplete': 'list',
      'aria-expanded': undefined,
      inputClassName: className,
      role: undefined
    });
  };
};

/* harmony default export */ var utils_getInputProps = (getInputProps);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getInputText.js



function getInputText(props) {
  var activeItem = props.activeItem,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text;

  if (activeItem) {
    // Display the input value if the pagination item is active.
    return utils_getOptionLabel(activeItem, labelKey);
  }

  var selectedItem = !multiple && !!selected.length && head(selected);

  if (selectedItem) {
    return utils_getOptionLabel(selectedItem, labelKey);
  }

  return text;
}

/* harmony default export */ var utils_getInputText = (getInputText);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getIsOnlyResult.js



function getIsOnlyResult(props) {
  var allowNew = props.allowNew,
      highlightOnlyResult = props.highlightOnlyResult,
      results = props.results;

  if (!highlightOnlyResult || allowNew) {
    return false;
  }

  return results.length === 1 && !getOptionProperty(head(results), 'disabled');
}

/* harmony default export */ var utils_getIsOnlyResult = (getIsOnlyResult);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getTruncatedOptions.js
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

/* harmony default export */ var utils_getTruncatedOptions = (getTruncatedOptions);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/getUpdatedActiveIndex.js


function skipDisabledOptions(currentIndex, keyCode, items) {
  var newIndex = currentIndex;

  while (items[newIndex] && items[newIndex].disabled) {
    newIndex += keyCode === UP ? -1 : 1;
  }

  return newIndex;
}

function getUpdatedActiveIndex(currentIndex, keyCode, items) {
  var newIndex = currentIndex; // Increment or decrement index based on user keystroke.

  newIndex += keyCode === UP ? -1 : 1; // Skip over any disabled options.

  newIndex = skipDisabledOptions(newIndex, keyCode, items); // If we've reached the end, go back to the beginning or vice-versa.

  if (newIndex === items.length) {
    newIndex = -1;
  } else if (newIndex === -2) {
    newIndex = items.length - 1; // Skip over any disabled options.

    newIndex = skipDisabledOptions(newIndex, keyCode, items);
  }

  return newIndex;
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/isSelectable.js
/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */
function isSelectable(inputNode) {
  return inputNode.selectionStart != null;
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/isShown.js
function isShown(props) {
  var open = props.open,
      minLength = props.minLength,
      showMenu = props.showMenu,
      text = props.text; // If menu visibility is controlled via props, that value takes precedence.

  if (open || open === false) {
    return open;
  }

  if (text.length < minLength) {
    return false;
  }

  return showMenu;
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/preventInputBlur.js
/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/size.js
function isSizeLarge(size) {
  return size === 'large' || size === 'lg';
}
function isSizeSmall(size) {
  return size === 'small' || size === 'sm';
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/validateSelectedPropChange.js

function validateSelectedPropChange(prevSelected, selected) {
  var uncontrolledToControlled = !prevSelected && selected;
  var controlledToUncontrolled = prevSelected && !selected;
  var from, to, precedent;

  if (uncontrolledToControlled) {
    from = 'uncontrolled';
    to = 'controlled';
    precedent = 'an';
  } else {
    from = 'controlled';
    to = 'uncontrolled';
    precedent = 'a';
  }

  var message = "You are changing " + precedent + " " + from + " typeahead to be " + to + ". " + ("Input elements should not switch from " + from + " to " + to + " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
  warn_warn(!(uncontrolledToControlled || controlledToUncontrolled), message);
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/utils/index.js











































;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/core/Context.js


var TypeaheadContext = /*#__PURE__*/(0,react.createContext)({
  activeIndex: -1,
  hintText: '',
  id: '',
  initialItem: null,
  inputNode: null,
  isOnlyResult: false,
  onActiveItemChange: noop,
  onAdd: noop,
  onInitialItemChange: noop,
  onMenuItemClick: noop,
  selectHintOnEnter: undefined,
  setItem: noop
});
var useTypeaheadContext = function useTypeaheadContext() {
  return (0,react.useContext)(TypeaheadContext);
};
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/core/TypeaheadManager.js






var inputPropKeys = ['activeIndex', 'disabled', 'id', 'inputRef', 'isFocused', 'isMenuShown', 'multiple', 'onBlur', 'onChange', 'onFocus', 'onKeyDown', 'placeholder'];
var propKeys = ['activeIndex', 'hideMenu', 'isMenuShown', 'labelKey', 'onClear', 'onHide', 'onRemove', 'results', 'selected', 'text', 'toggleMenu'];
var contextKeys = ['activeIndex', 'id', 'initialItem', 'inputNode', 'onActiveItemChange', 'onAdd', 'onInitialItemChange', 'onMenuItemClick', 'selectHintOnEnter', 'setItem'];

var TypeaheadManager = function TypeaheadManager(props) {
  var allowNew = props.allowNew,
      children = props.children,
      initialItem = props.initialItem,
      isMenuShown = props.isMenuShown,
      onAdd = props.onAdd,
      onInitialItemChange = props.onInitialItemChange,
      onKeyDown = props.onKeyDown,
      onMenuToggle = props.onMenuToggle,
      results = props.results;
  var prevProps = usePrevious(props);
  (0,react.useEffect)(function () {
    // Clear the initial item when there are no results.
    if (!(allowNew || results.length)) {
      onInitialItemChange(null);
    }
  });
  (0,react.useEffect)(function () {
    if (prevProps && prevProps.isMenuShown !== isMenuShown) {
      onMenuToggle(isMenuShown);
    }
  });

  var handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode) {
      case RETURN:
        if (initialItem && utils_getIsOnlyResult(props)) {
          onAdd(initialItem);
        }

        break;

      default:
        break;
    }

    onKeyDown(e);
  };

  var childProps = (0,esm_extends/* default */.Z)({}, pick(props, propKeys), {
    getInputProps: utils_getInputProps((0,esm_extends/* default */.Z)({}, pick(props, inputPropKeys), {
      onKeyDown: handleKeyDown,
      value: utils_getInputText(props)
    }))
  });

  var contextValue = (0,esm_extends/* default */.Z)({}, pick(props, contextKeys), {
    hintText: utils_getHintText(props),
    isOnlyResult: utils_getIsOnlyResult(props)
  });

  return /*#__PURE__*/react.createElement(TypeaheadContext.Provider, {
    value: contextValue
  }, children(childProps));
};

/* harmony default export */ var core_TypeaheadManager = (TypeaheadManager);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/propTypes.js



var INPUT_PROPS_BLACKLIST = [{
  alt: 'onBlur',
  prop: 'onBlur'
}, {
  alt: 'onInputChange',
  prop: 'onChange'
}, {
  alt: 'onFocus',
  prop: 'onFocus'
}, {
  alt: 'onKeyDown',
  prop: 'onKeyDown'
}];
var sizeType = prop_types_default().oneOf(values(SIZE));
/**
 * Allows additional warnings or messaging related to prop validation.
 */

function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    var _PropTypes$checkPropT;

    prop_types_default().checkPropTypes((_PropTypes$checkPropT = {}, _PropTypes$checkPropT[propName] = validator, _PropTypes$checkPropT), props, 'prop', componentName);
    isFunction(callback) && callback(props, propName, componentName);
  };
}
function caseSensitiveType(props, propName, componentName) {
  var caseSensitive = props.caseSensitive,
      filterBy = props.filterBy;
  warn_warn(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function deprecated(validator, reason) {
  return function (props, propName, componentName) {
    var _PropTypes$checkPropT2;

    if (props[propName] != null) {
      warn_warn(false, "The `" + propName + "` prop is deprecated. " + reason);
    }

    return prop_types_default().checkPropTypes((_PropTypes$checkPropT2 = {}, _PropTypes$checkPropT2[propName] = validator, _PropTypes$checkPropT2), props, 'prop', componentName);
  };
}
function defaultInputValueType(props, propName, componentName) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      multiple = props.multiple,
      selected = props.selected;
  var name = defaultSelected.length ? 'defaultSelected' : 'selected';
  warn_warn(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `" + name + "`.");
}
function defaultSelectedType(props, propName, componentName) {
  var defaultSelected = props.defaultSelected,
      multiple = props.multiple;
  warn_warn(multiple || defaultSelected.length <= 1, 'You are passing multiple options to the `defaultSelected` prop of a ' + 'Typeahead in single-select mode. The selections will be truncated to a ' + 'single selection.');
}
function highlightOnlyResultType(props, propName, componentName) {
  var allowNew = props.allowNew,
      highlightOnlyResult = props.highlightOnlyResult;
  warn_warn(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function ignoreDiacriticsType(props, propName, componentName) {
  var filterBy = props.filterBy,
      ignoreDiacritics = props.ignoreDiacritics;
  warn_warn(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function inputPropsType(props, propName, componentName) {
  var inputProps = props.inputProps;

  if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) {
    return;
  } // Blacklisted properties.


  INPUT_PROPS_BLACKLIST.forEach(function (_ref) {
    var alt = _ref.alt,
        prop = _ref.prop;
    var msg = alt ? " Use the top-level `" + alt + "` prop instead." : null;
    warn_warn(!inputProps[prop], "The `" + prop + "` property of `inputProps` will be ignored." + msg);
  });
}
function isRequiredForA11y(props, propName, componentName) {
  warn_warn(props[propName] != null, "The prop `" + propName + "` is required to make `" + componentName + "` " + 'accessible for users of assistive technologies such as screen readers.');
}
function labelKeyType(props, propName, componentName) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey;
  warn_warn(!(isFunction(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var optionType = prop_types_default().oneOfType([(prop_types_default()).object, (prop_types_default()).string]);
function selectedType(props, propName, componentName) {
  var multiple = props.multiple,
      onChange = props.onChange,
      selected = props.selected;
  warn_warn(multiple || !selected || selected.length <= 1, 'You are passing multiple options to the `selected` prop of a Typeahead ' + 'in single-select mode. This may lead to unexpected behaviors or errors.');
  warn_warn(!selected || selected && isFunction(onChange), 'You provided a `selected` prop without an `onChange` handler. If you ' + 'want the typeahead to be uncontrolled, use `defaultSelected`. ' + 'Otherwise, set `onChange`.');
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/core/Typeahead.js












var propTypes = {
  /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */
  allowNew: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).func]),

  /**
   * Autofocus the input when the component initially mounts.
   */
  autoFocus: (prop_types_default()).bool,

  /**
   * Whether or not filtering should be case-sensitive.
   */
  caseSensitive: checkPropType((prop_types_default()).bool, caseSensitiveType),

  /**
   * The initial value displayed in the text input.
   */
  defaultInputValue: checkPropType((prop_types_default()).string, defaultInputValueType),

  /**
   * Whether or not the menu is displayed upon initial render.
   */
  defaultOpen: (prop_types_default()).bool,

  /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */
  defaultSelected: checkPropType(prop_types_default().arrayOf(optionType), defaultSelectedType),

  /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */
  filterBy: prop_types_default().oneOfType([prop_types_default().arrayOf((prop_types_default()).string.isRequired), (prop_types_default()).func]),

  /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */
  highlightOnlyResult: checkPropType((prop_types_default()).bool, highlightOnlyResultType),

  /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */
  id: checkPropType(prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]), isRequiredForA11y),

  /**
   * Whether the filter should ignore accents and other diacritical marks.
   */
  ignoreDiacritics: checkPropType((prop_types_default()).bool, ignoreDiacriticsType),

  /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */
  labelKey: checkPropType(prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).func]), labelKeyType),

  /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */
  maxResults: (prop_types_default()).number,

  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: (prop_types_default()).number,

  /**
   * Whether or not multiple selections are allowed.
   */
  multiple: (prop_types_default()).bool,

  /**
   * Invoked when the input is blurred. Receives an event.
   */
  onBlur: (prop_types_default()).func,

  /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */
  onChange: (prop_types_default()).func,

  /**
   * Invoked when the input is focused. Receives an event.
   */
  onFocus: (prop_types_default()).func,

  /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */
  onInputChange: (prop_types_default()).func,

  /**
   * Invoked when a key is pressed. Receives an event.
   */
  onKeyDown: (prop_types_default()).func,

  /**
   * Invoked when menu visibility changes.
   */
  onMenuToggle: (prop_types_default()).func,

  /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */
  onPaginate: (prop_types_default()).func,

  /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */
  open: (prop_types_default()).bool,

  /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */
  options: prop_types_default().arrayOf(optionType).isRequired,

  /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */
  paginate: (prop_types_default()).bool,

  /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */
  selected: checkPropType(prop_types_default().arrayOf(optionType), selectedType),

  /**
   * Allows selecting the hinted result by pressing enter.
   */
  selectHintOnEnter: deprecated((prop_types_default()).bool, 'Use the `shouldSelect` prop on the `Hint` component to define which ' + 'keystrokes can select the hint.')
};
var defaultProps = {
  allowNew: false,
  autoFocus: false,
  caseSensitive: false,
  defaultInputValue: '',
  defaultOpen: false,
  defaultSelected: [],
  filterBy: [],
  highlightOnlyResult: false,
  ignoreDiacritics: true,
  labelKey: DEFAULT_LABELKEY,
  maxResults: 100,
  minLength: 0,
  multiple: false,
  onBlur: noop,
  onFocus: noop,
  onInputChange: noop,
  onKeyDown: noop,
  onMenuToggle: noop,
  onPaginate: noop,
  paginate: true
};
function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
      defaultOpen = props.defaultOpen,
      defaultSelected = props.defaultSelected,
      maxResults = props.maxResults,
      multiple = props.multiple;
  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
  var text = defaultInputValue;

  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = utils_getOptionLabel(head(selected), props.labelKey);

    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }

  return {
    activeIndex: -1,
    activeItem: null,
    initialItem: null,
    isFocused: false,
    selected: selected,
    showMenu: defaultOpen,
    shownResults: maxResults,
    text: text
  };
}
function clearTypeahead(state, props) {
  return (0,esm_extends/* default */.Z)({}, getInitialState(props), {
    isFocused: state.isFocused,
    selected: [],
    text: ''
  });
}
function hideMenu(state, props) {
  var _getInitialState = getInitialState(props),
      activeIndex = _getInitialState.activeIndex,
      activeItem = _getInitialState.activeItem,
      initialItem = _getInitialState.initialItem,
      shownResults = _getInitialState.shownResults;

  return {
    activeIndex: activeIndex,
    activeItem: activeItem,
    initialItem: initialItem,
    showMenu: false,
    shownResults: shownResults
  };
}
function toggleMenu(state, props) {
  return state.showMenu ? hideMenu(state, props) : {
    showMenu: true
  };
}

var Typeahead = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Typeahead, _React$Component);

  function Typeahead() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "state", getInitialState(_this.props));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "inputNode", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "isMenuShown", false);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "items", []);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "blur", function () {
      _this.inputNode && _this.inputNode.blur();

      _this.hideMenu();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "clear", function () {
      _this.setState(clearTypeahead);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "focus", function () {
      _this.inputNode && _this.inputNode.focus();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getInput", function () {
      return _this.inputNode;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "inputRef", function (inputNode) {
      _this.inputNode = inputNode;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "setItem", function (item, position) {
      _this.items[position] = item;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "hideMenu", function () {
      _this.setState(hideMenu);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "toggleMenu", function () {
      _this.setState(toggleMenu);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleActiveIndexChange", function (activeIndex) {
      _this.setState(function (state) {
        return {
          activeIndex: activeIndex,
          activeItem: activeIndex === -1 ? null : state.activeItem
        };
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleActiveItemChange", function (activeItem) {
      // Don't update the active item if it hasn't changed.
      if (!fast_deep_equal_default()(activeItem, _this.state.activeItem)) {
        _this.setState({
          activeItem: activeItem
        });
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleBlur", function (e) {
      e.persist();

      _this.setState({
        isFocused: false
      }, function () {
        return _this.props.onBlur(e);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleChange", function (selected) {
      _this.props.onChange && _this.props.onChange(selected);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleClear", function () {
      _this.setState(clearTypeahead, function () {
        return _this._handleChange([]);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleFocus", function (e) {
      e.persist();

      _this.setState({
        isFocused: true,
        showMenu: true
      }, function () {
        return _this.props.onFocus(e);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleInitialItemChange", function (initialItem) {
      // Don't update the initial item if it hasn't changed.
      if (!fast_deep_equal_default()(initialItem, _this.state.initialItem)) {
        _this.setState({
          initialItem: initialItem
        });
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleInputChange", function (e) {
      e.persist();
      var text = e.currentTarget.value;
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          onInputChange = _this$props.onInputChange; // Clear selections when the input value changes in single-select mode.

      var shouldClearSelections = _this.state.selected.length && !multiple;

      _this.setState(function (state, props) {
        var _getInitialState2 = getInitialState(props),
            activeIndex = _getInitialState2.activeIndex,
            activeItem = _getInitialState2.activeItem,
            shownResults = _getInitialState2.shownResults;

        return {
          activeIndex: activeIndex,
          activeItem: activeItem,
          selected: shouldClearSelections ? [] : state.selected,
          showMenu: true,
          shownResults: shownResults,
          text: text
        };
      }, function () {
        onInputChange(text, e);
        shouldClearSelections && _this._handleChange([]);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleKeyDown", function (e) {
      var activeItem = _this.state.activeItem; // Skip most actions when the menu is hidden.

      if (!_this.isMenuShown) {
        if (e.keyCode === UP || e.keyCode === DOWN) {
          _this.setState({
            showMenu: true
          });
        }

        _this.props.onKeyDown(e);

        return;
      }

      switch (e.keyCode) {
        case UP:
        case DOWN:
          // Prevent input cursor from going to the beginning when pressing up.
          e.preventDefault();

          _this._handleActiveIndexChange(getUpdatedActiveIndex(_this.state.activeIndex, e.keyCode, _this.items));

          break;

        case RETURN:
          // Prevent form submission while menu is open.
          e.preventDefault();
          activeItem && _this._handleMenuItemSelect(activeItem, e);
          break;

        case ESC:
        case TAB:
          // ESC simply hides the menu. TAB will blur the input and move focus to
          // the next item; hide the menu so it doesn't gain focus.
          _this.hideMenu();

          break;

        default:
          break;
      }

      _this.props.onKeyDown(e);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleMenuItemSelect", function (option, e) {
      if (option.paginationOption) {
        _this._handlePaginate(e);
      } else {
        _this._handleSelectionAdd(option);
      }
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handlePaginate", function (e) {
      e.persist();

      _this.setState(function (state, props) {
        return {
          shownResults: state.shownResults + props.maxResults
        };
      }, function () {
        return _this.props.onPaginate(e, _this.state.shownResults);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleSelectionAdd", function (option) {
      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          labelKey = _this$props2.labelKey;
      var selected;
      var selection = option;
      var text; // Add a unique id to the custom selection. Avoid doing this in `render` so
      // the id doesn't increment every time.

      if (!isString(selection) && selection.customOption) {
        selection = (0,esm_extends/* default */.Z)({}, selection, {
          id: uniqueId('new-id-')
        });
      }

      if (multiple) {
        // If multiple selections are allowed, add the new selection to the
        // existing selections.
        selected = _this.state.selected.concat(selection);
        text = '';
      } else {
        // If only a single selection is allowed, replace the existing selection
        // with the new one.
        selected = [selection];
        text = utils_getOptionLabel(selection, labelKey);
      }

      _this.setState(function (state, props) {
        return (0,esm_extends/* default */.Z)({}, hideMenu(state, props), {
          initialItem: selection,
          selected: selected,
          text: text
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleSelectionRemove", function (selection) {
      var selected = _this.state.selected.filter(function (option) {
        return !fast_deep_equal_default()(option, selection);
      }); // Make sure the input stays focused after the item is removed.


      _this.focus();

      _this.setState(function (state, props) {
        return (0,esm_extends/* default */.Z)({}, hideMenu(state, props), {
          selected: selected
        });
      }, function () {
        return _this._handleChange(selected);
      });
    });

    return _this;
  }

  var _proto = Typeahead.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.autoFocus && this.focus();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$props3 = this.props,
        labelKey = _this$props3.labelKey,
        multiple = _this$props3.multiple,
        selected = _this$props3.selected;
    validateSelectedPropChange(selected, prevProps.selected); // Sync selections in state with those in props.

    if (selected && !fast_deep_equal_default()(selected, prevState.selected)) {
      this.setState({
        selected: selected
      });

      if (!multiple) {
        this.setState({
          text: selected.length ? utils_getOptionLabel(head(selected), labelKey) : ''
        });
      }
    }
  };

  _proto.render = function render() {
    // Omit `onChange` so Flow doesn't complain.
    var _this$props4 = this.props,
        onChange = _this$props4.onChange,
        otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props4, ["onChange"]);

    var mergedPropsAndState = (0,esm_extends/* default */.Z)({}, otherProps, this.state);

    var filterBy = mergedPropsAndState.filterBy,
        labelKey = mergedPropsAndState.labelKey,
        options = mergedPropsAndState.options,
        paginate = mergedPropsAndState.paginate,
        shownResults = mergedPropsAndState.shownResults,
        text = mergedPropsAndState.text;
    this.isMenuShown = isShown(mergedPropsAndState);
    this.items = []; // Reset items on re-render.

    var results = [];

    if (this.isMenuShown) {
      var cb = typeof filterBy === 'function' ? filterBy : defaultFilterBy;
      results = options.filter(function (option) {
        return cb(option, mergedPropsAndState);
      }); // This must come before results are truncated.

      var shouldPaginate = paginate && results.length > shownResults; // Truncate results if necessary.

      results = utils_getTruncatedOptions(results, shownResults); // Add the custom option if necessary.

      if (utils_addCustomOption(results, mergedPropsAndState)) {
        var _results$push;

        results.push((_results$push = {
          customOption: true
        }, _results$push[getStringLabelKey(labelKey)] = text, _results$push));
      } // Add the pagination item if necessary.


      if (shouldPaginate) {
        var _results$push2;

        results.push((_results$push2 = {}, _results$push2[getStringLabelKey(labelKey)] = '', _results$push2.paginationOption = true, _results$push2));
      }
    }

    return /*#__PURE__*/react.createElement(core_TypeaheadManager, (0,esm_extends/* default */.Z)({}, mergedPropsAndState, {
      hideMenu: this.hideMenu,
      inputNode: this.inputNode,
      inputRef: this.inputRef,
      isMenuShown: this.isMenuShown,
      onActiveItemChange: this._handleActiveItemChange,
      onAdd: this._handleSelectionAdd,
      onBlur: this._handleBlur,
      onChange: this._handleInputChange,
      onClear: this._handleClear,
      onFocus: this._handleFocus,
      onHide: this.hideMenu,
      onInitialItemChange: this._handleInitialItemChange,
      onKeyDown: this._handleKeyDown,
      onMenuItemClick: this._handleMenuItemSelect,
      onRemove: this._handleSelectionRemove,
      results: results,
      setItem: this.setItem,
      toggleMenu: this.toggleMenu
    }));
  };

  return Typeahead;
}(react.Component);

(0,defineProperty/* default */.Z)(Typeahead, "propTypes", propTypes);

(0,defineProperty/* default */.Z)(Typeahead, "defaultProps", defaultProps);

/* harmony default export */ var core_Typeahead = (Typeahead);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/behaviors/async.js










var async_propTypes = {
  /**
   * Delay, in milliseconds, before performing search.
   */
  delay: (prop_types_default()).number,

  /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */
  isLoading: (prop_types_default()).bool.isRequired,

  /**
   * Number of input characters that must be entered before showing results.
   */
  minLength: (prop_types_default()).number,

  /**
   * Callback to perform when the search is executed.
   */
  onSearch: (prop_types_default()).func.isRequired,

  /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */
  options: prop_types_default().arrayOf(optionType),

  /**
   * Message displayed in the menu when there is no user input.
   */
  promptText: (prop_types_default()).node,

  /**
   * Message displayed in the menu while the request is pending.
   */
  searchText: (prop_types_default()).node,

  /**
   * Whether or not the component should cache query results.
   */
  useCache: (prop_types_default()).bool
};
var async_defaultProps = {
  delay: 200,
  minLength: 2,
  options: [],
  promptText: 'Type to search...',
  searchText: 'Searching...',
  useCache: true
};

/**
 * Logic that encapsulates common behavior and functionality around
 * asynchronous searches, including:
 *
 *  - Debouncing user input
 *  - Optional query caching
 *  - Search prompt and empty results behaviors
 */
function useAsync(props) {
  var allowNew = props.allowNew,
      delay = props.delay,
      emptyLabel = props.emptyLabel,
      isLoading = props.isLoading,
      minLength = props.minLength,
      onInputChange = props.onInputChange,
      onSearch = props.onSearch,
      options = props.options,
      promptText = props.promptText,
      searchText = props.searchText,
      useCache = props.useCache,
      otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["allowNew", "delay", "emptyLabel", "isLoading", "minLength", "onInputChange", "onSearch", "options", "promptText", "searchText", "useCache"]);

  var cacheRef = (0,react.useRef)({});
  var handleSearchDebouncedRef = (0,react.useRef)();
  var queryRef = (0,react.useRef)(props.defaultInputValue || '');
  var forceUpdate = useForceUpdate();
  var prevProps = usePrevious(props);
  var handleSearch = (0,react.useCallback)(function (query) {
    queryRef.current = query;

    if (!query || minLength && query.length < minLength) {
      return;
    } // Use cached results, if applicable.


    if (useCache && cacheRef.current[query]) {
      // Re-render the component with the cached results.
      forceUpdate();
      return;
    } // Perform the search.


    onSearch(query);
  }, [forceUpdate, minLength, onSearch, useCache]); // Set the debounced search function.

  (0,react.useEffect)(function () {
    handleSearchDebouncedRef.current = lodash_debounce_default()(handleSearch, delay);
    return function () {
      handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
    };
  }, [delay, handleSearch]);
  (0,react.useEffect)(function () {
    // Ensure that we've gone from a loading to a completed state. Otherwise
    // an empty response could get cached if the component updates during the
    // request (eg: if the parent re-renders for some reason).
    if (!isLoading && prevProps && prevProps.isLoading && useCache) {
      cacheRef.current[queryRef.current] = options;
    }
  });

  var getEmptyLabel = function getEmptyLabel() {
    if (!queryRef.current.length) {
      return promptText;
    }

    if (isLoading) {
      return searchText;
    }

    return emptyLabel;
  };

  var handleInputChange = (0,react.useCallback)(function (query, e) {
    onInputChange && onInputChange(query, e);
    handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
  }, [onInputChange]);
  var cachedQuery = cacheRef.current[queryRef.current];
  return (0,esm_extends/* default */.Z)({}, otherProps, {
    // Disable custom selections during a search if `allowNew` isn't a function.
    allowNew: isFunction(allowNew) ? allowNew : allowNew && !isLoading,
    emptyLabel: getEmptyLabel(),
    isLoading: isLoading,
    minLength: minLength,
    onInputChange: handleInputChange,
    options: useCache && cachedQuery ? cachedQuery : options
  });
}
function withAsync(Component) {
  var AsyncTypeahead = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, useAsync(props), {
      ref: ref
    }));
  });
  AsyncTypeahead.displayName = "withAsync(" + getDisplayName(Component) + ")"; // $FlowFixMe

  AsyncTypeahead.propTypes = async_propTypes; // $FlowFixMe

  AsyncTypeahead.defaultProps = async_defaultProps;
  return AsyncTypeahead;
}
function asyncContainer(Component) {
  /* istanbul ignore next */
  warn(false, 'The `asyncContainer` export is deprecated; use `withAsync` instead.');
  /* istanbul ignore next */

  return withAsync(Component);
}
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/contains.js
/* eslint-disable no-bitwise, no-cond-assign */

/**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */
function contains(context, node) {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  if (context.contains) return context.contains(node);
  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/canUseDOM.js
/* harmony default export */ var canUseDOM = (!!(typeof window !== 'undefined' && window.document && window.document.createElement));
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/addEventListener.js
/* eslint-disable no-return-assign */

var optionsSupported = false;
var onceSupported = false;

try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },

    get once() {
      // eslint-disable-next-line no-multi-assign
      return onceSupported = optionsSupported = true;
    }

  };

  if (canUseDOM) {
    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, true);
  }
} catch (e) {
  /* */
}

/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function addEventListener(node, eventName, handler, options) {
  if (options && typeof options !== 'boolean' && !onceSupported) {
    var once = options.once,
        capture = options.capture;
    var wrappedHandler = handler;

    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };

      handler.__once = wrappedHandler;
    }

    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }

  node.addEventListener(eventName, handler, options);
}

/* harmony default export */ var esm_addEventListener = (addEventListener);
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/removeEventListener.js
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */
function removeEventListener(node, eventName, handler, options) {
  var capture = options && typeof options !== 'boolean' ? options.capture : options;
  node.removeEventListener(eventName, handler, capture);

  if (handler.__once) {
    node.removeEventListener(eventName, handler.__once, capture);
  }
}

/* harmony default export */ var esm_removeEventListener = (removeEventListener);
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/listen.js



function listen(node, eventName, handler, options) {
  esm_addEventListener(node, eventName, handler, options);
  return function () {
    esm_removeEventListener(node, eventName, handler, options);
  };
}

/* harmony default export */ var esm_listen = (listen);
;// CONCATENATED MODULE: ../../node_modules/@restart/hooks/esm/useCommittedRef.js

/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = (0,react.useRef)(value);
  (0,react.useEffect)(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

/* harmony default export */ var esm_useCommittedRef = (useCommittedRef);
;// CONCATENATED MODULE: ../../node_modules/@restart/hooks/esm/useEventCallback.js


function useEventCallback(fn) {
  var ref = esm_useCommittedRef(fn);
  return (0,react.useCallback)(function () {
    return ref.current && ref.current.apply(ref, arguments);
  }, [ref]);
}
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/dom-helpers/esm/ownerDocument.js
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
;// CONCATENATED MODULE: ../../node_modules/react-overlays/esm/utils/ownerDocument.js


/* harmony default export */ function utils_ownerDocument(componentOrElement) {
  return ownerDocument(react_dom.findDOMNode(componentOrElement));
}
;// CONCATENATED MODULE: ../../node_modules/react-overlays/esm/useRootClose.js






var escapeKeyCode = 27;

var useRootClose_noop = function noop() {};

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>|HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object}  options
 * @param {boolean} options.disabled
 * @param {string}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */


function useRootClose(ref, onRootClose, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      disabled = _ref.disabled,
      _ref$clickTrigger = _ref.clickTrigger,
      clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;

  var preventMouseRootCloseRef = (0,react.useRef)(false);
  var onClose = onRootClose || useRootClose_noop;
  var handleMouseCapture = (0,react.useCallback)(function (e) {
    var currentTarget = ref && ('current' in ref ? ref.current : ref);
    warning_default()(!!currentTarget, 'RootClose captured a close event but does not have a ref to compare it to. ' + 'useRootClose(), should be passed a ref that resolves to a DOM node');
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e) || !isLeftClickEvent(e) || contains(currentTarget, e.target);
  }, [ref]);
  var handleMouse = useEventCallback(function (e) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e);
    }
  });
  var handleKeyUp = useEventCallback(function (e) {
    if (e.keyCode === escapeKeyCode) {
      onClose(e);
    }
  });
  (0,react.useEffect)(function () {
    if (disabled || ref == null) return undefined;
    var doc = utils_ownerDocument(ref.current); // Use capture for this listener so it fires before React's listener, to
    // avoid false positives in the contains() check below if the target DOM
    // element is removed in the React mouse callback.

    var removeMouseCaptureListener = esm_listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = esm_listen(doc, clickTrigger, handleMouse);
    var removeKeyupListener = esm_listen(doc, 'keyup', handleKeyUp);
    var mobileSafariHackListeners = [];

    if ('ontouchstart' in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function (el) {
        return esm_listen(el, 'mousemove', useRootClose_noop);
      });
    }

    return function () {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function (remove) {
        return remove();
      });
    };
  }, [ref, disabled, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}

/* harmony default export */ var esm_useRootClose = (useRootClose);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/ClearButton.js








var ClearButton_propTypes = {
  label: (prop_types_default()).string,
  onClick: (prop_types_default()).func,
  onKeyDown: (prop_types_default()).func,
  size: sizeType
};
var ClearButton_defaultProps = {
  label: 'Clear',
  onClick: noop,
  onKeyDown: noop
};

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      _onKeyDown = _ref.onKeyDown,
      size = _ref.size,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["className", "label", "onClick", "onKeyDown", "size"]);

  return /*#__PURE__*/react.createElement("button", (0,esm_extends/* default */.Z)({}, props, {
    "aria-label": label,
    className: classnames_default()('close', 'rbt-close', {
      'rbt-close-lg': isSizeLarge(size)
    }, className),
    onClick: function onClick(e) {
      e.stopPropagation();

      _onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      // Prevent browser from navigating back.
      if (e.keyCode === BACKSPACE) {
        e.preventDefault();
      }

      _onKeyDown(e);
    },
    type: "button"
  }), /*#__PURE__*/react.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"), /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, label));
};

ClearButton.propTypes = ClearButton_propTypes;
ClearButton.defaultProps = ClearButton_defaultProps;
/* harmony default export */ var components_ClearButton = (ClearButton);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Loader.js


var Loader_propTypes = {
  label: (prop_types_default()).string
};
var Loader_defaultProps = {
  label: 'Loading...'
};

var Loader = function Loader(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/react.createElement("div", {
    className: "rbt-loader spinner-border spinner-border-sm",
    role: "status"
  }, /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, label));
};

Loader.propTypes = Loader_propTypes;
Loader.defaultProps = Loader_defaultProps;
/* harmony default export */ var components_Loader = (Loader);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/Popper.js + 1 modules
var Popper = __webpack_require__(56885);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Overlay.js



/* eslint-disable react/no-unused-prop-types */





// `Element` is not defined during server-side rendering, so shim it here.

/* istanbul ignore next */
var SafeElement = typeof Element === 'undefined' ? function () {} : Element;
var Overlay_propTypes = {
  /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */
  align: prop_types_default().oneOf(values(ALIGN)),
  children: (prop_types_default()).func.isRequired,

  /**
   * Specify whether the menu should appear above the input.
   */
  dropup: (prop_types_default()).bool,

  /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */
  flip: (prop_types_default()).bool,
  isMenuShown: (prop_types_default()).bool,
  positionFixed: (prop_types_default()).bool,
  referenceElement: prop_types_default().instanceOf(SafeElement)
};
var Overlay_defaultProps = {
  align: ALIGN.JUSTIFY,
  dropup: false,
  flip: false,
  isMenuShown: false,
  positionFixed: false
};

function getModifiers(_ref) {
  var align = _ref.align,
      flip = _ref.flip;
  return {
    computeStyles: {
      enabled: true,
      fn: function fn(_ref2) {
        var styles = _ref2.styles,
            data = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["styles"]);

        return (0,esm_extends/* default */.Z)({}, data, {
          styles: (0,esm_extends/* default */.Z)({}, styles, {
            // Use the following condition instead of `align === 'justify'`
            // since it allows the component to fall back to justifying the
            // menu width if `align` is undefined.
            width: align !== ALIGN.RIGHT && align !== ALIGN.LEFT ? // Set the popper width to match the target width.
            data.offsets.reference.width : styles.width
          })
        });
      }
    },
    flip: {
      enabled: flip
    },
    preventOverflow: {
      escapeWithReference: true
    }
  };
} // Flow expects a string literal value for `placement`.


var PLACEMENT = {
  bottom: {
    end: 'bottom-end',
    start: 'bottom-start'
  },
  top: {
    end: 'top-end',
    start: 'top-start'
  }
};
function getPlacement(_ref3) {
  var align = _ref3.align,
      dropup = _ref3.dropup;
  var x = align === ALIGN.RIGHT ? 'end' : 'start';
  var y = dropup ? 'top' : 'bottom';
  return PLACEMENT[y][x];
}

var Overlay = function Overlay(props) {
  var children = props.children,
      isMenuShown = props.isMenuShown,
      positionFixed = props.positionFixed,
      referenceElement = props.referenceElement;

  if (!isMenuShown) {
    return null;
  }

  return /*#__PURE__*/react.createElement(Popper/* default */.ZP, {
    modifiers: getModifiers(props),
    placement: getPlacement(props),
    positionFixed: positionFixed,
    referenceElement: referenceElement
  }, function (_ref4) {
    var ref = _ref4.ref,
        popperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["ref"]);

    return children((0,esm_extends/* default */.Z)({}, popperProps, {
      innerRef: ref,
      inputHeight: referenceElement ? referenceElement.offsetHeight : 0
    }));
  });
};

Overlay.propTypes = Overlay_propTypes;
Overlay.defaultProps = Overlay_defaultProps;
/* harmony default export */ var components_Overlay = (Overlay);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/behaviors/token.js








var token_propTypes = {
  onBlur: (prop_types_default()).func,
  onClick: (prop_types_default()).func,
  onFocus: (prop_types_default()).func,
  onRemove: (prop_types_default()).func,
  option: optionType.isRequired
};
var useToken = function useToken(_ref) {
  var onBlur = _ref.onBlur,
      onClick = _ref.onClick,
      onFocus = _ref.onFocus,
      onRemove = _ref.onRemove,
      option = _ref.option,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onBlur", "onClick", "onFocus", "onRemove", "option"]);

  var _useState = (0,react.useState)(false),
      active = _useState[0],
      setActive = _useState[1];

  var _useState2 = (0,react.useState)(null),
      rootElement = _useState2[0],
      attachRef = _useState2[1];

  var handleActiveChange = function handleActiveChange(e, isActive, callback) {
    e.stopPropagation();
    setActive(isActive);
    typeof callback === 'function' && callback(e);
  };

  var handleBlur = function handleBlur(e) {
    handleActiveChange(e, false, onBlur);
  };

  var handleClick = function handleClick(e) {
    handleActiveChange(e, true, onClick);
  };

  var handleFocus = function handleFocus(e) {
    handleActiveChange(e, true, onFocus);
  };

  var handleRemove = function handleRemove() {
    onRemove && onRemove(option);
  };

  var handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode) {
      case BACKSPACE:
        if (active) {
          // Prevent backspace keypress from triggering the browser "back"
          // action.
          e.preventDefault();
          handleRemove();
        }

        break;

      default:
        break;
    }
  };

  esm_useRootClose(rootElement, handleBlur, (0,esm_extends/* default */.Z)({}, props, {
    disabled: !active
  }));
  return (0,esm_extends/* default */.Z)({}, props, {
    active: active,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onRemove: isFunction(onRemove) ? handleRemove : undefined,
    ref: attachRef
  });
};
var withToken = function withToken(Component) {
  var displayName = "withToken(" + getDisplayName(Component) + ")";

  var WrappedToken = function WrappedToken(props) {
    return /*#__PURE__*/react.createElement(Component, useToken(props));
  };

  WrappedToken.displayName = displayName;
  WrappedToken.propTypes = token_propTypes;
  return WrappedToken;
};
function tokenContainer(Component) {
  /* istanbul ignore next */
  warn(false, 'The `tokenContainer` export is deprecated; use `withToken` instead.');
  /* istanbul ignore next */

  return withToken(Component);
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Token.js







var InteractiveToken = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      onRemove = _ref.onRemove,
      tabIndex = _ref.tabIndex,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["active", "children", "className", "onRemove", "tabIndex"]);

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()('rbt-token', 'rbt-token-removeable', {
      'rbt-token-active': !!active
    }, className),
    ref: ref,
    tabIndex: tabIndex || 0
  }), children, /*#__PURE__*/react.createElement(components_ClearButton, {
    className: "rbt-token-remove-button",
    label: "Remove",
    onClick: onRemove,
    tabIndex: -1
  }));
});

var StaticToken = function StaticToken(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      disabled = _ref2.disabled,
      href = _ref2.href;
  var classnames = classnames_default()('rbt-token', {
    'rbt-token-disabled': disabled
  }, className);

  if (href && !disabled) {
    return /*#__PURE__*/react.createElement("a", {
      className: classnames,
      href: href
    }, children);
  }

  return /*#__PURE__*/react.createElement("div", {
    className: classnames
  }, children);
};
/**
 * Token
 *
 * Individual token component, generally displayed within the TokenizerInput
 * component, but can also be rendered on its own.
 */


var Token = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var disabled = props.disabled,
      onRemove = props.onRemove,
      readOnly = props.readOnly;
  return !disabled && !readOnly && isFunction(onRemove) ? /*#__PURE__*/react.createElement(InteractiveToken, (0,esm_extends/* default */.Z)({}, props, {
    ref: ref
  })) : /*#__PURE__*/react.createElement(StaticToken, props);
});
/* harmony default export */ var components_Token = (withToken(Token));
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Hint.js








// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function interpolateStyle(styles, attr, subattr) {
  if (subattr === void 0) {
    subattr = '';
  }

  // Title-case the sub-attribute.
  if (subattr) {
    /* eslint-disable-next-line no-param-reassign */
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }

  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles[attr + dir + subattr];
  }).join(' ');
}

function copyStyles(inputNode, hintNode) {
  if (!inputNode || !hintNode) {
    return;
  }

  var inputStyle = window.getComputedStyle(inputNode);
  /* eslint-disable no-param-reassign */

  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.height = inputStyle.height;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
  /* eslint-enable no-param-reassign */
}

function defaultShouldSelect(e, state) {
  var shouldSelectHint = false;
  var currentTarget = e.currentTarget,
      keyCode = e.keyCode;

  if (keyCode === RIGHT) {
    // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = isSelectable(currentTarget) ? currentTarget.selectionStart === currentTarget.value.length : true;
  }

  if (keyCode === TAB) {
    // Prevent input from blurring on TAB.
    e.preventDefault();
    shouldSelectHint = true;
  }

  if (keyCode === RETURN) {
    shouldSelectHint = !!state.selectHintOnEnter;
  }

  return typeof state.shouldSelect === 'function' ? state.shouldSelect(shouldSelectHint, e) : shouldSelectHint;
}
var useHint = function useHint(_ref) {
  var children = _ref.children,
      shouldSelect = _ref.shouldSelect;
  !(react.Children.count(children) === 1) ?  false ? 0 : browser_default()(false) : void 0;

  var _useTypeaheadContext = useTypeaheadContext(),
      hintText = _useTypeaheadContext.hintText,
      initialItem = _useTypeaheadContext.initialItem,
      inputNode = _useTypeaheadContext.inputNode,
      onAdd = _useTypeaheadContext.onAdd,
      selectHintOnEnter = _useTypeaheadContext.selectHintOnEnter;

  var hintRef = (0,react.useRef)(null);

  var onKeyDown = function onKeyDown(e) {
    if (hintText && initialItem && defaultShouldSelect(e, {
      selectHintOnEnter: selectHintOnEnter,
      shouldSelect: shouldSelect
    })) {
      onAdd(initialItem);
    }

    children.props.onKeyDown && children.props.onKeyDown(e);
  };

  (0,react.useEffect)(function () {
    copyStyles(inputNode, hintRef.current);
  });
  return {
    child: /*#__PURE__*/(0,react.cloneElement)(children, (0,esm_extends/* default */.Z)({}, children.props, {
      onKeyDown: onKeyDown
    })),
    hintRef: hintRef,
    hintText: hintText
  };
};

var Hint = function Hint(_ref2) {
  var className = _ref2.className,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["className"]);

  var _useHint = useHint(props),
      child = _useHint.child,
      hintRef = _useHint.hintRef,
      hintText = _useHint.hintText;

  return /*#__PURE__*/react.createElement("div", {
    className: className,
    style: {
      display: 'flex',
      flex: 1,
      height: '100%',
      position: 'relative'
    }
  }, child, /*#__PURE__*/react.createElement("input", {
    "aria-hidden": true,
    className: "rbt-input-hint",
    ref: hintRef,
    readOnly: true,
    style: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'rgba(0, 0, 0, 0.35)',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      width: '100%'
    },
    tabIndex: -1,
    value: hintText
  }));
};

/* harmony default export */ var components_Hint = (Hint);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Input.js



var Input = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/react.createElement("input", (0,esm_extends/* default */.Z)({}, props, {
    className: classnames_default()('rbt-input-main', props.className),
    ref: ref
  }));
});
/* harmony default export */ var components_Input = (Input);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/behaviors/classNames.js








function withClassNames(Component) {
  // Use a class instead of function component to support refs.

  /* eslint-disable-next-line react/prefer-stateless-function */
  var WrappedComponent = /*#__PURE__*/function (_React$Component) {
    (0,inheritsLoose/* default */.Z)(WrappedComponent, _React$Component);

    function WrappedComponent() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = WrappedComponent.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isInvalid = _this$props.isInvalid,
          isValid = _this$props.isValid,
          size = _this$props.size,
          props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["className", "isInvalid", "isValid", "size"]);

      return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({}, props, {
        className: classnames_default()('form-control', 'rbt-input', {
          'form-control-lg': isSizeLarge(size),
          'form-control-sm': isSizeSmall(size),
          'is-invalid': isInvalid,
          'is-valid': isValid
        }, className)
      }));
    };

    return WrappedComponent;
  }(react.Component);

  (0,defineProperty/* default */.Z)(WrappedComponent, "displayName", "withClassNames(" + getDisplayName(Component) + ")");

  return WrappedComponent;
}

/* harmony default export */ var classNames = (withClassNames);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputMulti.js






/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */








var TypeaheadInputMulti = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TypeaheadInputMulti, _React$Component);

  function TypeaheadInputMulti() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "wrapperRef", /*#__PURE__*/react.createRef());

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_input", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getInputRef", function (input) {
      _this._input = input;

      _this.props.inputRef(input);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleContainerClickOrFocus", function (e) {
      // Don't focus the input if it's disabled.
      if (_this.props.disabled) {
        e.currentTarget.blur();
        return;
      } // Move cursor to the end if the user clicks outside the actual input.


      var inputNode = _this._input;

      if (!inputNode) {
        return;
      }

      if (e.currentTarget !== inputNode && isSelectable(inputNode)) {
        inputNode.selectionStart = inputNode.value.length;
      }

      inputNode.focus();
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_handleKeyDown", function (e) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          selected = _this$props.selected,
          value = _this$props.value;

      switch (e.keyCode) {
        case BACKSPACE:
          if (e.currentTarget === _this._input && selected.length && !value) {
            // Prevent browser from going back.
            e.preventDefault(); // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.

            if (_this.wrapperRef.current) {
              var children = _this.wrapperRef.current.children;
              var lastToken = children[children.length - 2];
              lastToken && lastToken.focus();
            }
          }

          break;

        default:
          break;
      }

      onKeyDown(e);
    });

    return _this;
  }

  var _proto = TypeaheadInputMulti.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        inputClassName = _this$props2.inputClassName,
        inputRef = _this$props2.inputRef,
        placeholder = _this$props2.placeholder,
        referenceElementRef = _this$props2.referenceElementRef,
        selected = _this$props2.selected,
        shouldSelectHint = _this$props2.shouldSelectHint,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props2, ["children", "className", "inputClassName", "inputRef", "placeholder", "referenceElementRef", "selected", "shouldSelectHint"]);

    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()('rbt-input-multi', className),
      disabled: props.disabled,
      onClick: this._handleContainerClickOrFocus,
      onFocus: this._handleContainerClickOrFocus,
      ref: referenceElementRef,
      tabIndex: -1
    }, /*#__PURE__*/react.createElement("div", {
      className: "rbt-input-wrapper",
      ref: this.wrapperRef
    }, children, /*#__PURE__*/react.createElement(components_Hint, {
      shouldSelect: shouldSelectHint
    }, /*#__PURE__*/react.createElement(components_Input, (0,esm_extends/* default */.Z)({}, props, {
      className: inputClassName,
      onKeyDown: this._handleKeyDown,
      placeholder: selected.length ? '' : placeholder,
      ref: this.getInputRef,
      style: {
        backgroundColor: 'transparent',
        border: 0,
        boxShadow: 'none',
        cursor: 'inherit',
        outline: 'none',
        padding: 0,
        width: '100%',
        zIndex: 1
      }
    })))));
  };

  return TypeaheadInputMulti;
}(react.Component);

/* harmony default export */ var components_TypeaheadInputMulti = (classNames(TypeaheadInputMulti));
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/TypeaheadInputSingle.js






/* harmony default export */ var TypeaheadInputSingle = (classNames(function (_ref) {
  var inputRef = _ref.inputRef,
      referenceElementRef = _ref.referenceElementRef,
      shouldSelectHint = _ref.shouldSelectHint,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["inputRef", "referenceElementRef", "shouldSelectHint"]);

  return /*#__PURE__*/react.createElement(components_Hint, {
    shouldSelect: shouldSelectHint
  }, /*#__PURE__*/react.createElement(components_Input, (0,esm_extends/* default */.Z)({}, props, {
    ref: function ref(node) {
      inputRef(node);
      referenceElementRef(node);
    }
  })));
}));
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Highlighter.js





var Highlighter_propTypes = {
  children: (prop_types_default()).string.isRequired,
  highlightClassName: (prop_types_default()).string,
  search: (prop_types_default()).string.isRequired
};
var Highlighter_defaultProps = {
  highlightClassName: 'rbt-highlight-text'
};

/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = /*#__PURE__*/function (_React$PureComponent) {
  (0,inheritsLoose/* default */.Z)(Highlighter, _React$PureComponent);

  function Highlighter() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Highlighter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        highlightClassName = _this$props.highlightClassName,
        search = _this$props.search;

    if (!search || !children) {
      return children;
    }

    var matchCount = 0;
    var remaining = children;
    var highlighterChildren = [];

    while (remaining) {
      var bounds = getMatchBounds(remaining, search); // No match anywhere in the remaining string, stop.

      if (!bounds) {
        highlighterChildren.push(remaining);
        break;
      } // Capture the string that leads up to a match.


      var nonMatch = remaining.slice(0, bounds.start);

      if (nonMatch) {
        highlighterChildren.push(nonMatch);
      } // Capture the matching string.


      var match = remaining.slice(bounds.start, bounds.end);
      highlighterChildren.push( /*#__PURE__*/react.createElement("mark", {
        className: highlightClassName,
        key: matchCount
      }, match));
      matchCount += 1; // And if there's anything left over, continue the loop.

      remaining = remaining.slice(bounds.end);
    }

    return highlighterChildren;
  };

  return Highlighter;
}(react.PureComponent);

(0,defineProperty/* default */.Z)(Highlighter, "propTypes", Highlighter_propTypes);

(0,defineProperty/* default */.Z)(Highlighter, "defaultProps", Highlighter_defaultProps);

/* harmony default export */ var components_Highlighter = (Highlighter);
;// CONCATENATED MODULE: ../../node_modules/compute-scroll-into-view/dist/index.module.js
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ function index_module(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ../../node_modules/scroll-into-view-if-needed/es/index.js


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = ('scrollBehavior' in document.body.style);
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(isTargetAttached ? index_module(target, options) : []);
  }

  if (!isTargetAttached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(index_module(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ var es = (scrollIntoView);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/behaviors/item.js








var item_propTypes = {
  option: optionType.isRequired,
  position: (prop_types_default()).number
};
var useItem = function useItem(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      option = _ref.option,
      position = _ref.position,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["label", "onClick", "option", "position"]);

  var _useTypeaheadContext = useTypeaheadContext(),
      activeIndex = _useTypeaheadContext.activeIndex,
      id = _useTypeaheadContext.id,
      isOnlyResult = _useTypeaheadContext.isOnlyResult,
      onActiveItemChange = _useTypeaheadContext.onActiveItemChange,
      onInitialItemChange = _useTypeaheadContext.onInitialItemChange,
      onMenuItemClick = _useTypeaheadContext.onMenuItemClick,
      setItem = _useTypeaheadContext.setItem;

  var itemRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    if (position === 0) {
      onInitialItemChange(option);
    }
  });
  (0,react.useEffect)(function () {
    if (position === activeIndex) {
      onActiveItemChange(option); // Automatically scroll the menu as the user keys through it.

      var node = itemRef.current;
      node && es(node, {
        block: 'nearest',
        boundary: node.parentNode,
        inline: 'nearest',
        scrollMode: 'if-needed'
      });
    }
  });
  var handleClick = (0,react.useCallback)(function (e) {
    onMenuItemClick(option, e);
    onClick && onClick(e);
  }, [onClick, onMenuItemClick, option]);
  var active = isOnlyResult || activeIndex === position; // Update the item's position in the item stack.

  setItem(option, position);
  return (0,esm_extends/* default */.Z)({}, props, {
    active: active,
    'aria-label': label,
    'aria-selected': active,
    id: getMenuItemId(id, position),
    onClick: handleClick,
    onMouseDown: preventInputBlur,
    ref: itemRef,
    role: 'option'
  });
};
var withItem = function withItem(Component) {
  var displayName = "withItem(" + getDisplayName(Component) + ")";

  var WrappedMenuItem = function WrappedMenuItem(props) {
    return /*#__PURE__*/react.createElement(Component, useItem(props));
  };

  WrappedMenuItem.displayName = displayName;
  WrappedMenuItem.propTypes = item_propTypes;
  return WrappedMenuItem;
};
function menuItemContainer(Component) {
  /* istanbul ignore next */
  warn(false, 'The `menuItemContainer` export is deprecated; use `withItem` instead.');
  /* istanbul ignore next */

  return withItem(Component);
}
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/MenuItem.js





var BaseMenuItem = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["active", "children", "className", "disabled", "onClick", "onMouseDown"]);

  return (
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/anchor-is-valid */
    react.createElement("a", (0,esm_extends/* default */.Z)({}, props, {
      className: classnames_default()('dropdown-item', {
        active: active,
        disabled: disabled
      }, className),
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        !disabled && _onClick && _onClick(e);
      },
      onMouseDown: onMouseDown,
      ref: ref
    }), children)
    /* eslint-enable jsx-a11y/anchor-is-valid */

  );
});

/* harmony default export */ var MenuItem = (withItem(BaseMenuItem));
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Menu.js










var MenuDivider = function MenuDivider(props) {
  return /*#__PURE__*/react.createElement("div", {
    className: "dropdown-divider",
    role: "separator"
  });
};

var MenuHeader = function MenuHeader(props) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    react.createElement("div", (0,esm_extends/* default */.Z)({}, props, {
      className: "dropdown-header",
      role: "heading"
    }))
  );
};

var Menu_propTypes = {
  'aria-label': (prop_types_default()).string,

  /**
   * Message to display in the menu if there are no valid results.
   */
  emptyLabel: (prop_types_default()).node,

  /**
   * Needed for accessibility.
   */
  id: checkPropType(prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).string]), isRequiredForA11y),

  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: (prop_types_default()).string
};
var Menu_defaultProps = {
  'aria-label': 'menu-options',
  emptyLabel: 'No matches found.',
  maxHeight: '300px'
};

/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Menu, _React$Component);

  function Menu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Menu.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        inputHeight = _this$props.inputHeight,
        scheduleUpdate = _this$props.scheduleUpdate; // Update the menu position if the height of the input changes.

    if (inputHeight !== prevProps.inputHeight) {
      scheduleUpdate();
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        emptyLabel = _this$props2.emptyLabel,
        id = _this$props2.id,
        innerRef = _this$props2.innerRef,
        maxHeight = _this$props2.maxHeight,
        style = _this$props2.style,
        text = _this$props2.text;
    var contents = react.Children.count(children) === 0 ? /*#__PURE__*/react.createElement(BaseMenuItem, {
      disabled: true,
      role: "option"
    }, emptyLabel) : children;
    return (
      /*#__PURE__*/

      /* eslint-disable jsx-a11y/interactive-supports-focus */
      react.createElement("div", {
        "aria-label": this.props['aria-label'],
        className: classnames_default()('rbt-menu', 'dropdown-menu', 'show', className),
        id: id,
        key: // Force a re-render if the text changes to ensure that menu
        // positioning updates correctly.
        text,
        onMouseDown: // Prevent input from blurring when clicking on the menu scrollbar.
        preventInputBlur,
        ref: innerRef,
        role: "listbox",
        style: (0,esm_extends/* default */.Z)({}, style, {
          display: 'block',
          maxHeight: maxHeight,
          overflow: 'auto'
        })
      }, contents)
      /* eslint-enable jsx-a11y/interactive-supports-focus */

    );
  };

  return Menu;
}(react.Component);

(0,defineProperty/* default */.Z)(Menu, "propTypes", Menu_propTypes);

(0,defineProperty/* default */.Z)(Menu, "defaultProps", Menu_defaultProps);

(0,defineProperty/* default */.Z)(Menu, "Divider", MenuDivider);

(0,defineProperty/* default */.Z)(Menu, "Header", MenuHeader);

/* harmony default export */ var components_Menu = (Menu);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/TypeaheadMenu.js








var TypeaheadMenu_propTypes = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: (prop_types_default()).node,

  /**
   * Prompt displayed when large data sets are paginated.
   */
  paginationText: (prop_types_default()).node,

  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: (prop_types_default()).func
};
var TypeaheadMenu_defaultProps = {
  newSelectionPrefix: 'New selection: ',
  paginationText: 'Display additional results...',
  renderMenuItemChildren: function renderMenuItemChildren(option, props, idx) {
    return /*#__PURE__*/react.createElement(components_Highlighter, {
      search: props.text
    }, utils_getOptionLabel(option, props.labelKey));
  }
};

var TypeaheadMenu = function TypeaheadMenu(props) {
  var labelKey = props.labelKey,
      newSelectionPrefix = props.newSelectionPrefix,
      options = props.options,
      paginationText = props.paginationText,
      renderMenuItemChildren = props.renderMenuItemChildren,
      text = props.text,
      menuProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["labelKey", "newSelectionPrefix", "options", "paginationText", "renderMenuItemChildren", "text"]);

  var renderMenuItem = function renderMenuItem(option, position) {
    var label = utils_getOptionLabel(option, labelKey);
    var menuItemProps = {
      disabled: getOptionProperty(option, 'disabled'),
      label: label,
      option: option,
      position: position
    };

    if (option.customOption) {
      return /*#__PURE__*/react.createElement(MenuItem, (0,esm_extends/* default */.Z)({}, menuItemProps, {
        className: "rbt-menu-custom-option",
        key: position,
        label: label
      }), newSelectionPrefix, /*#__PURE__*/react.createElement(components_Highlighter, {
        search: text
      }, label));
    }

    if (option.paginationOption) {
      return /*#__PURE__*/react.createElement(react.Fragment, {
        key: "pagination-item"
      }, /*#__PURE__*/react.createElement(components_Menu.Divider, null), /*#__PURE__*/react.createElement(MenuItem, (0,esm_extends/* default */.Z)({}, menuItemProps, {
        className: "rbt-menu-pagination-option",
        label: paginationText
      }), paginationText));
    }

    return /*#__PURE__*/react.createElement(MenuItem, (0,esm_extends/* default */.Z)({}, menuItemProps, {
      key: position
    }), renderMenuItemChildren(option, props, position));
  };

  return (
    /*#__PURE__*/
    // Explictly pass `text` so Flow doesn't complain...
    react.createElement(components_Menu, (0,esm_extends/* default */.Z)({}, menuProps, {
      text: text
    }), options.map(renderMenuItem))
  );
};

TypeaheadMenu.propTypes = TypeaheadMenu_propTypes;
TypeaheadMenu.defaultProps = TypeaheadMenu_defaultProps;
/* harmony default export */ var components_TypeaheadMenu = (TypeaheadMenu);
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/Typeahead.js



















var Typeahead_propTypes = {
  /**
   * Displays a button to clear the input when there are selections.
   */
  clearButton: (prop_types_default()).bool,

  /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */
  inputProps: checkPropType((prop_types_default()).object, inputPropsType),

  /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */
  isInvalid: (prop_types_default()).bool,

  /**
   * Indicate whether an asynchronous data fetch is happening.
   */
  isLoading: (prop_types_default()).bool,

  /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */
  isValid: (prop_types_default()).bool,

  /**
   * Callback for custom input rendering.
   */
  renderInput: (prop_types_default()).func,

  /**
   * Callback for custom menu rendering.
   */
  renderMenu: (prop_types_default()).func,

  /**
   * Callback for custom menu rendering.
   */
  renderToken: (prop_types_default()).func,

  /**
   * Specifies the size of the input.
   */
  size: sizeType
};
var Typeahead_defaultProps = {
  clearButton: false,
  inputProps: {},
  isInvalid: false,
  isLoading: false,
  isValid: false,
  renderMenu: function renderMenu(results, menuProps, props) {
    return /*#__PURE__*/react.createElement(components_TypeaheadMenu, (0,esm_extends/* default */.Z)({}, menuProps, {
      labelKey: props.labelKey,
      options: results,
      text: props.text
    }));
  },
  renderToken: function renderToken(option, props, idx) {
    return /*#__PURE__*/react.createElement(components_Token, {
      disabled: props.disabled,
      key: idx,
      onRemove: props.onRemove,
      option: option,
      tabIndex: props.tabIndex
    }, utils_getOptionLabel(option, props.labelKey));
  }
};

function getOverlayProps(props) {
  return pick(props, ['align', 'dropup', 'flip', 'positionFixed']);
}

var RootClose = function RootClose(_ref) {
  var children = _ref.children,
      onRootClose = _ref.onRootClose,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "onRootClose"]);

  var _useState = (0,react.useState)(null),
      rootElement = _useState[0],
      attachRef = _useState[1];

  esm_useRootClose(rootElement, onRootClose, props);
  return children(attachRef);
};

var TypeaheadComponent = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TypeaheadComponent, _React$Component);

  function TypeaheadComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_referenceElement", void 0);

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "referenceElementRef", function (referenceElement) {
      _this._referenceElement = referenceElement;
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_renderInput", function (inputProps, props) {
      var _this$props = _this.props,
          isInvalid = _this$props.isInvalid,
          isValid = _this$props.isValid,
          multiple = _this$props.multiple,
          renderInput = _this$props.renderInput,
          renderToken = _this$props.renderToken,
          size = _this$props.size;

      if (isFunction(renderInput)) {
        return renderInput(inputProps, props);
      }

      var commonProps = (0,esm_extends/* default */.Z)({}, inputProps, {
        isInvalid: isInvalid,
        isValid: isValid,
        size: size
      });

      if (!multiple) {
        return /*#__PURE__*/react.createElement(TypeaheadInputSingle, commonProps);
      }

      var labelKey = props.labelKey,
          onRemove = props.onRemove,
          selected = props.selected;
      return /*#__PURE__*/react.createElement(components_TypeaheadInputMulti, (0,esm_extends/* default */.Z)({}, commonProps, {
        selected: selected
      }), selected.map(function (option, idx) {
        return renderToken(option, (0,esm_extends/* default */.Z)({}, commonProps, {
          labelKey: labelKey,
          onRemove: onRemove
        }), idx);
      }));
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_renderMenu", function (results, menuProps, props) {
      var _this$props2 = _this.props,
          emptyLabel = _this$props2.emptyLabel,
          id = _this$props2.id,
          maxHeight = _this$props2.maxHeight,
          newSelectionPrefix = _this$props2.newSelectionPrefix,
          paginationText = _this$props2.paginationText,
          renderMenu = _this$props2.renderMenu,
          renderMenuItemChildren = _this$props2.renderMenuItemChildren;
      return renderMenu(results, (0,esm_extends/* default */.Z)({}, menuProps, {
        emptyLabel: emptyLabel,
        id: id,
        maxHeight: maxHeight,
        newSelectionPrefix: newSelectionPrefix,
        paginationText: paginationText,
        renderMenuItemChildren: renderMenuItemChildren
      }), props);
    });

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "_renderAux", function (_ref2) {
      var onClear = _ref2.onClear,
          selected = _ref2.selected;
      var _this$props3 = _this.props,
          clearButton = _this$props3.clearButton,
          disabled = _this$props3.disabled,
          isLoading = _this$props3.isLoading,
          size = _this$props3.size;
      var content;

      if (isLoading) {
        content = /*#__PURE__*/react.createElement(components_Loader, null);
      } else if (clearButton && !disabled && selected.length) {
        content = /*#__PURE__*/react.createElement(components_ClearButton, {
          onClick: onClear,
          onFocus: function onFocus(e) {
            // Prevent the main input from auto-focusing again.
            e.stopPropagation();
          },
          onMouseDown: preventInputBlur,
          size: size
        });
      }

      return content ? /*#__PURE__*/react.createElement("div", {
        className: classnames_default()('rbt-aux', {
          'rbt-aux-lg': isSizeLarge(size)
        })
      }, content) : null;
    });

    return _this;
  }

  var _proto = TypeaheadComponent.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        children = _this$props4.children,
        className = _this$props4.className,
        instanceRef = _this$props4.instanceRef,
        open = _this$props4.open,
        options = _this$props4.options,
        style = _this$props4.style;
    return /*#__PURE__*/react.createElement(core_Typeahead, (0,esm_extends/* default */.Z)({}, this.props, {
      options: options,
      ref: instanceRef
    }), function (_ref3) {
      var getInputProps = _ref3.getInputProps,
          props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["getInputProps"]);

      var hideMenu = props.hideMenu,
          isMenuShown = props.isMenuShown,
          results = props.results;

      var auxContent = _this2._renderAux(props);

      return /*#__PURE__*/react.createElement(RootClose, {
        disabled: open || !isMenuShown,
        onRootClose: hideMenu
      }, function (ref) {
        return /*#__PURE__*/react.createElement("div", {
          className: classnames_default()('rbt', {
            'has-aux': !!auxContent
          }, className),
          ref: ref,
          style: (0,esm_extends/* default */.Z)({}, style, {
            outline: 'none',
            position: 'relative'
          }),
          tabIndex: -1
        }, _this2._renderInput((0,esm_extends/* default */.Z)({}, getInputProps(_this2.props.inputProps), {
          referenceElementRef: _this2.referenceElementRef
        }), props), /*#__PURE__*/react.createElement(components_Overlay, (0,esm_extends/* default */.Z)({}, getOverlayProps(_this2.props), {
          isMenuShown: isMenuShown,
          referenceElement: _this2._referenceElement
        }), function (menuProps) {
          return _this2._renderMenu(results, menuProps, props);
        }), auxContent, isFunction(children) ? children(props) : children);
      });
    });
  };

  return TypeaheadComponent;
}(react.Component);

(0,defineProperty/* default */.Z)(TypeaheadComponent, "propTypes", Typeahead_propTypes);

(0,defineProperty/* default */.Z)(TypeaheadComponent, "defaultProps", Typeahead_defaultProps);

/* harmony default export */ var components_Typeahead = (/*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/react.createElement(TypeaheadComponent, (0,esm_extends/* default */.Z)({}, props, {
    instanceRef: ref
  }));
}));
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/components/AsyncTypeahead.js


/* harmony default export */ var AsyncTypeahead = (withAsync(components_Typeahead));
;// CONCATENATED MODULE: ../../node_modules/react-bootstrap-typeahead/es/index.js
// Components


























 // HOCs + Hooks










// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/components/app-input/AppInput.module.scss.js
var AppInput_module_scss = __webpack_require__(46633);
// EXTERNAL MODULE: ../core/dist/components/flat-input/FlatInput.module.scss.js
var FlatInput_module_scss = __webpack_require__(75544);
// EXTERNAL MODULE: ../core/dist/scss/helper.module.scss.js
var helper_module_scss = __webpack_require__(47526);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/search/Search.scss.js


var css_248z = ".rbt {\n  display: flex;\n  align-items: center;\n}\n\n.rbt-input-main.form-control.rbt-input {\n  padding: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rbt-menu.dropdown-menu.show {\n  top: 12px !important;\n  left: -20px !important;\n  max-height: calc(0.192118226 * var(--screen-height)) !important;\n  min-width: calc(100% + 40px) !important;\n  max-width: 311.41px;\n  width: calc(100vw - 75px) !important;\n  border: 1px solid rgba(0, 0, 0, 0);\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);\n  border-radius: 6px;\n  margin: 0;\n  padding: calc(0.0098522167 * var(--screen-height)) 0;\n}\n.rbt-menu.dropdown-menu.show .dropdown-item {\n  padding: 8px 20px;\n  font-family: var(--font-medium);\n  font-size: 1rem;\n  letter-spacing: -0.01rem;\n  color: #d0d7db;\n}\n.rbt-menu.dropdown-menu.show .dropdown-item .rbt-highlight-text {\n  color: #0a2239;\n  background-color: white;\n  padding: 0;\n}\n\n.right_aligned .rbt-menu.dropdown-menu.show {\n  left: unset !important;\n  right: -20px !important;\n}\n\n.rbt-aux {\n  display: flex;\n  margin-left: 10px;\n}\n\n.required {\n  color: var(--red-color);\n  padding-left: 5px;\n}";
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=Search.scss.js.map

;// CONCATENATED MODULE: ../core/dist/icons/MapPinAlt.svg.js


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgMapPinAlt(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19.999,
    viewBox: "0 0 18 19.999"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M8 9.899v5.1a1 1 0 002 0v-5.1a5 5 0 10-2 0zm1-7.9a3 3 0 11-3 3 3 3 0 013-3zm4.21 10.42a1.022 1.022 0 00-.42 2c2.27.45 3.21 1.26 3.21 1.58 0 .58-2.45 2-7 2s-7-1.42-7-2c0-.32.94-1.13 3.21-1.62a1.022 1.022 0 10-.42-2c-3.04.7-4.79 2.01-4.79 3.62 0 2.63 4.53 4 9 4s9-1.37 9-4c0-1.61-1.75-2.92-4.79-3.58z",
    fill: "#fff"
  })));
}


//# sourceMappingURL=MapPinAlt.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/RecentGrey.svg.js


var _defs, _g;

function RecentGrey_svg_extends() { RecentGrey_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return RecentGrey_svg_extends.apply(this, arguments); }

function SvgRecentGrey(props) {
  return /*#__PURE__*/react.createElement("svg", RecentGrey_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.457,
    height: 18,
    viewBox: "0 0 18.457 18"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".RecentGrey_svg__recent-gray_b{fill:#08123b}"))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/react.createElement("path", {
    className: "RecentGrey_svg__recent-gray_b",
    d: "M9.45 0A8.882 8.882 0 001.8 4.392V2.7a.9.9 0 10-1.8 0v3.6a.9.9 0 00.9.9h4.05a.9.9 0 000-1.8H3.294A7.082 7.082 0 019.45 1.8a7.2 7.2 0 11-6.776 9.6.9.9 0 00-1.7.594A9 9 0 109.45 0z"
  }), /*#__PURE__*/react.createElement("path", {
    className: "RecentGrey_svg__recent-gray_b",
    d: "M12.824 12.6a.9.9 0 01-.54-.18l-3.6-2.7a.9.9 0 01-.36-.72V5.4a.9.9 0 111.8 0v3.15l3.24 2.43a.9.9 0 01-.54 1.62z"
  }))));
}


//# sourceMappingURL=RecentGrey.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/MapPinGrey.svg.js


var MapPinGrey_svg_defs, MapPinGrey_svg_g;

function MapPinGrey_svg_extends() { MapPinGrey_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return MapPinGrey_svg_extends.apply(this, arguments); }

function SvgMapPinGrey(props) {
  return /*#__PURE__*/react.createElement("svg", MapPinGrey_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.459,
    height: 16.05,
    viewBox: "0 0 13.459 16.05"
  }, props), MapPinGrey_svg_defs || (MapPinGrey_svg_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null, ".MapPinGrey_svg__map-pin-grey-b{fill:none;stroke:#08123b;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px}"))), MapPinGrey_svg_g || (MapPinGrey_svg_g = /*#__PURE__*/react.createElement("g", {
    transform: "translate(.9 .9)",
    opacity: 0.4
  }, /*#__PURE__*/react.createElement("path", {
    className: "MapPinGrey_svg__map-pin-grey-b",
    d: "M11.659 5.83c0 4.534-5.83 8.42-5.83 8.42S0 10.364 0 5.83a5.83 5.83 0 1111.659 0z"
  }), /*#__PURE__*/react.createElement("circle", {
    className: "MapPinGrey_svg__map-pin-grey-b",
    cx: 1.943,
    cy: 1.943,
    r: 1.943,
    transform: "translate(3.886 3.886)"
  }))));
}


//# sourceMappingURL=MapPinGrey.svg.js.map

// EXTERNAL MODULE: ../core/dist/icons/CloseCircle.svg.js
var CloseCircle_svg = __webpack_require__(9839);
// EXTERNAL MODULE: ../core/dist/methods/getRemValue.js
var getRemValue = __webpack_require__(89842);
// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
// EXTERNAL MODULE: ../core/dist/methods/groupBy.js
var groupBy = __webpack_require__(89170);
// EXTERNAL MODULE: ../core/dist/methods/getCurrentState.js
var getCurrentState = __webpack_require__(43221);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../core/dist/methods/getAuthIdParam.js
var getAuthIdParam = __webpack_require__(4913);
// EXTERNAL MODULE: ../core/dist/methods/formatDate.js
var formatDate = __webpack_require__(11663);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
;// CONCATENATED MODULE: ../core/dist/components/search/Search.js



















































const renderMenu = (results, menuProps, state) => {
    let index = menuProps.showClearOption ? 1 : 0;
    const groupedResults = (0,groupBy/* groupBy */.v)(results, "category");
    return (react.createElement(components_Menu, Object.assign({}, menuProps),
        menuProps.showClearOption && (react.createElement(MenuItem, { option: { name: "Clear Search", category: "clear" }, position: 0, style: {
                // color: "#1053FF",
                color: "#202124",
                fontSize: (0,getRemValue/* getRemValue */.T)(16),
                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.16),
                fontWeight: misc/* FONT_WEIGHTS.bold */.Xw.bold,
                display: "flex",
                alignItems: "center"
            } },
            react.createElement("span", { style: {
                    marginRight: "16px",
                    // backgroundColor: "#1053FF",
                    backgroundColor: "#F9FAFB",
                    borderRadius: "50%",
                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`
                    // height: "38px",
                    // width: "38.79px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0.5
                } },
                react.createElement(CloseCircle_svg/* ReactComponent */.r, { height: 38, width: 38 })),
            " ",
            "Clear Search")),
        groupedResults.map((res, i) => {
            switch (res.key) {
                case "currentLoc":
                    return (react.createElement(react.Fragment, { key: i }, res.items.map((item, j) => {
                        const menuItem = (react.createElement(MenuItem, { key: j, option: item, position: index, style: {
                                color: "#1053FF",
                                fontSize: (0,getRemValue/* getRemValue */.T)(16),
                                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.16),
                                fontWeight: misc/* FONT_WEIGHTS.bold */.Xw.bold,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            react.createElement("span", { style: {
                                    marginRight: "16px",
                                    backgroundColor: "#1053FF",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                react.createElement(SvgMapPinAlt, { height: 15.83, width: 14.25 })),
                            item.name));
                        index++;
                        return menuItem;
                    })));
                case "recent":
                    return (react.createElement(react.Fragment, { key: i }, res.items.map((item, i) => {
                        var _a;
                        const menuItem = (react.createElement(MenuItem, { key: i, option: item, position: index, style: {
                                color: "#202124",
                                width: "max-content",
                                fontSize: (0,getRemValue/* getRemValue */.T)(16),
                                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.16),
                                fontWeight: misc/* FONT_WEIGHTS.normal */.Xw.normal,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            res.key === "recent" && (react.createElement("span", { style: {
                                    marginRight: "16px",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E6E6E6",
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                react.createElement(SvgRecentGrey, { height: 14.25, width: 14.61 }))), (_a = menuProps.labelKey) === null || _a === void 0 ? void 0 :
                            _a.call(menuProps, item)));
                        index++;
                        return menuItem;
                    })));
                case "suggested":
                    return (react.createElement(react.Fragment, { key: i }, res.items.map((item, i) => {
                        var _a;
                        const menuItem = (react.createElement(MenuItem, { key: i, option: item, position: index, style: {
                                color: "#202124",
                                fontSize: (0,getRemValue/* getRemValue */.T)(16),
                                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.16),
                                fontWeight: misc/* FONT_WEIGHTS.normal */.Xw.normal,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            res.key === "suggested" && (react.createElement("span", { style: {
                                    marginRight: "16px",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E6E6E6",
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                react.createElement(SvgMapPinGrey, null))), (_a = menuProps.labelKey) === null || _a === void 0 ? void 0 :
                            _a.call(menuProps, item)));
                        index++;
                        return menuItem;
                    })));
                default:
                    return (react.createElement(react.Fragment, { key: i }, res.items.map((item, i) => {
                        var _a, _b;
                        const menuItem = (react.createElement(MenuItem, { key: i, option: item, position: index, style: {
                                // color: "#202124",
                                width: "max-content",
                                fontSize: (0,getRemValue/* getRemValue */.T)(16),
                                letterSpacing: (0,getRemValue/* getRemValue */.T)(-0.16),
                                fontWeight: misc/* FONT_WEIGHTS.normal */.Xw.normal,
                                display: "flex",
                                alignItems: "center"
                            }, onClick: menuProps._onClickItem },
                            react.createElement("span", { style: {
                                    marginRight: "16px",
                                    borderRadius: "50%",
                                    // padding: `0px ${(22 - (18 / 48) * 22) / 2}px`,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E6E6E6",
                                    height: "38px",
                                    width: "38.79px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                } },
                                react.createElement(SvgMapPinGrey, null)),
                            react.createElement(components_Highlighter, { search: state.text }, ((_a = menuProps.labelKey) === null || _a === void 0 ? void 0 : _a.call(menuProps, item)) ? (_b = menuProps.labelKey) === null || _b === void 0 ? void 0 : _b.call(menuProps, item) : item.name)));
                        index++;
                        return menuItem;
                    })));
            }
        })));
};
const Search = (0,react.forwardRef)(({ isLoading, options, onSearch, searchText, onSelectItem, selectedItem, onInputChange, id, onFocus, onBlur, labelText, containerStyles, containerClassName, labelStyles, inputWrapperStyles, inputWrapperClassName, inputStyles, isRequired = false, isValid = true, alignment, setFocus, labelKey, placeholder, clear, showClearBtn, showClearOption, prefix, prefixClassName, minLength = 1, labelClassName, inputClassName, activeClassName, dirtyClassName, isFlatInput, maxLength = 25, disabled }, forwardedRef) => {
    const typeaheadRef = (0,react.useRef)(null);
    const { isMobile } = (0,react.useContext)(app_context/* AppContext */.Il);
    const [isActive, setIsActive] = (0,react.useState)(false);
    const [isDirty, setIsDirty] = (0,react.useState)(false);
    const [currInputVal, setCurrInputVal] = (0,react.useState)("");
    const _onInputChange = (input, e) => {
        var _a;
        setCurrInputVal(input);
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(input, e);
        if (!input) {
            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem([]);
            (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.clear();
            // typeaheadRef.current?.blur();
        }
    };
    const _onFocus = () => {
        typeaheadRef.current.inputNode.select();
        setIsActive(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    };
    const _onBlur = (e) => {
        // e.persist();
        setIsDirty(!!e.target.value);
        setIsActive(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        setCurrInputVal("");
        typeaheadRef.current.toggleMenu();
        // typeaheadRef.current.getInput().value = searchText;
    };
    const _onSelectItem = (selected) => (0,_tslib/* __awaiter */.m)(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (((_a = selected[0]) === null || _a === void 0 ? void 0 : _a.category) === "clear") {
            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem([]);
            (_b = typeaheadRef.current) === null || _b === void 0 ? void 0 : _b.clear();
            return;
        }
        const currInputVal = yield (0,getCurrentState/* getCurrentState */.M)(setCurrInputVal);
        if (!currInputVal) {
            onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(selected);
            (_c = typeaheadRef.current) === null || _c === void 0 ? void 0 : _c.blur();
        }
    });
    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            setCurrInputVal("");
        }
    };
    const _onClickItem = () => {
        setCurrInputVal("");
    };
    const focus = () => {
        var _a;
        (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    (0,react.useImperativeHandle)(forwardedRef, () => ({
        focus
    }));
    (0,react.useEffect)(() => {
        var _a;
        if (setFocus) {
            (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [setFocus]);
    (0,react.useEffect)(() => {
        var _a;
        if (!clear) {
            return;
        }
        (_a = typeaheadRef.current) === null || _a === void 0 ? void 0 : _a.clear();
    }, [clear]);
    (0,react.useEffect)(() => {
        if (selectedItem) {
            setIsDirty(true);
        }
        else {
            setIsDirty(false);
        }
    }, [selectedItem]);
    return (react.createElement("div", { style: containerStyles, 
        // className={classNames(
        //     HelperStyles.center_vertical +
        //         " " +
        //         AppInputStyles.field_group +
        //         " " +
        //         (isActive ? AppInputStyles.active : "") +
        //         " " +
        //         (isDirty && !isValid ? AppInputStyles.invalid : ""),
        //     containerClassName
        // )}
        className: classnames_default()(helper_module_scss/* default.center_vertical */.Z.center_vertical, AppInput_module_scss/* default.field_group */.Z.field_group, isActive && AppInput_module_scss/* default.active */.Z.active, isActive && activeClassName, isDirty && !isValid && AppInput_module_scss/* default.invalid */.Z.invalid, containerClassName, isFlatInput && isActive && FlatInput_module_scss/* default.active */.Z.active, isFlatInput && FlatInput_module_scss/* default.inputContainer */.Z.inputContainer) },
        react.createElement("label", { htmlFor: id === null || id === void 0 ? void 0 : id.toString(), 
            // className={classNames(
            //     isActive ? AppInputStyles.active : isDirty ? AppInputStyles.dirty : "",
            //     labelClassName,
            // )}
            className: classnames_default()(isFlatInput && FlatInput_module_scss/* default.label */.Z.label, isActive
                ? AppInput_module_scss/* default.active */.Z.active +
                    " " +
                    (isFlatInput ? FlatInput_module_scss/* default.active */.Z.active : "") +
                    " " +
                    activeClassName
                : isDirty
                    ? AppInput_module_scss/* default.dirty */.Z.dirty +
                        " " +
                        (isFlatInput ? FlatInput_module_scss/* default.dirty */.Z.dirty : "") +
                        " " +
                        dirtyClassName
                    : "", labelClassName), style: labelStyles },
            labelText,
            isRequired && react.createElement("span", { className: "required" }, "*")),
        react.createElement("div", { style: Object.assign({}, inputWrapperStyles), className: AppInput_module_scss/* default.input_wrapper */.Z.input_wrapper +
                " " +
                (isFlatInput ? FlatInput_module_scss/* default.inputWrapper */.Z.inputWrapper : "") +
                " " +
                inputWrapperClassName },
            react.createElement("div", { className: prefixClassName }, prefix),
            react.createElement("div", { className: classnames_default()(AppInput_module_scss/* default.input */.Z.input +
                    " " +
                    (isFlatInput ? FlatInput_module_scss/* default.input */.Z.input : "") +
                    +(alignment === "right" && "right_aligned"), inputClassName), style: inputStyles },
                react.createElement(AsyncTypeahead, { disabled: disabled, open: isMobile ? true : undefined, ref: typeaheadRef, isLoading: isLoading, options: options, onSearch: onSearch, searchText: searchText, onChange: _onSelectItem, selected: selectedItem && !currInputVal ? [selectedItem] : [], delay: 400, minLength: minLength, useCache: true, 
                    // clearButton
                    id: id, onFocus: _onFocus, onInputChange: _onInputChange, onBlur: _onBlur, labelKey: labelKey, placeholder: placeholder, renderMenu: (results, menuProps, state) => {
                        return renderMenu === null || renderMenu === void 0 ? void 0 : renderMenu(currInputVal ? results : options, Object.assign(Object.assign({}, menuProps), { labelKey,
                            _onClickItem,
                            showClearOption }), state);
                    }, inputProps: {
                        autoComplete: "new-password",
                        shouldSelectHint: (shouldSelect, event) => event.key === "Enter" || shouldSelect,
                        maxLength: maxLength,
                        id: String(id !== null && id !== void 0 ? id : "")
                    }, caseSensitive: false, filterBy: () => true, onKeyDown: onKeyDown }, ({ onClear, selected }) => (react.createElement("div", { className: "rbt-aux" }, !!selected.length && showClearBtn && (react.createElement(CloseCircle_svg/* ReactComponent */.r, { onClick: onClear, style: { cursor: "pointer" } })))))))));
});


//# sourceMappingURL=Search.js.map


/***/ }),

/***/ 71155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Skeleton; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51992);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/skeleton/Skeleton.scss.js


var css_248z = ".skeleton-wrapper {\n  width: 100%;\n  height: 100%;\n}\n.skeleton-wrapper.button {\n  line-height: 1;\n  display: block;\n}\n.skeleton-wrapper.pill .react-loading-skeleton.react-loading-skeleton {\n  line-height: unset;\n  border-radius: 29px;\n}\n.skeleton-wrapper span {\n  width: 100%;\n  height: 100%;\n}\n.skeleton-wrapper span .react-loading-skeleton.react-loading-skeleton {\n  width: 100%;\n  height: 100%;\n}";
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=Skeleton.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/skeleton/Skeleton.js






const Skeleton = (_a) => {
    var { type } = _a, props = (0,_tslib/* __rest */._)(_a, ["type"]);
    return (react.createElement("span", { className: classnames_default()("skeleton-wrapper", type) },
        react.createElement(lib/* default */.ZP, Object.assign({}, props))));
};


//# sourceMappingURL=Skeleton.js.map


/***/ }),

/***/ 63118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ toast; }
});

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(56203);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/toast/_toastify-overrides.scss.js


var css_248z = ":root {\n  --toastify-color-light:#fff;\n  --toastify-color-dark:#121212;\n  --toastify-color-info:#3498db;\n  --toastify-color-success:#07bc0c;\n  --toastify-color-warning:#f1c40f;\n  --toastify-color-error:#e74c3c;\n  --toastify-color-transparent:hsla(0,0%,100%,.7);\n  --toastify-icon-color-info:var(--toastify-color-info);\n  --toastify-icon-color-success:var(--toastify-color-success);\n  --toastify-icon-color-warning:var(--toastify-color-warning);\n  --toastify-icon-color-error:var(--toastify-color-error);\n  --toastify-toast-width:320px;\n  --toastify-toast-background:#fff;\n  --toastify-toast-min-height:64px;\n  --toastify-toast-max-height:800px;\n  --toastify-font-family:sans-serif;\n  --toastify-z-index:9999;\n  --toastify-text-color-light:#757575;\n  --toastify-text-color-dark:#fff;\n  --toastify-text-color-info:#fff;\n  --toastify-text-color-success:#fff;\n  --toastify-text-color-warning:#fff;\n  --toastify-text-color-error:#fff;\n  --toastify-spinner-color:#616161;\n  --toastify-spinner-color-empty-area:#e0e0e0;\n  --toastify-color-progress-light:linear-gradient(90deg,#4cd964,#5ac8fa,#007aff,#34aadc,#5856d6,#ff2d55);\n  --toastify-color-progress-dark:#bb86fc;\n  --toastify-color-progress-info:var(--toastify-color-info);\n  --toastify-color-progress-success:var(--toastify-color-success);\n  --toastify-color-progress-warning:var(--toastify-color-warning);\n  --toastify-color-progress-error:var(--toastify-color-error);\n}\n\n.Toastify__toast-container {\n  z-index: var(--toastify-z-index);\n  -webkit-transform: translateZ(var(--toastify-z-index));\n  position: fixed;\n  padding: 4px;\n  width: var(--toastify-toast-width);\n  box-sizing: border-box;\n  color: #fff;\n}\n\n.Toastify__toast-container--top-left {\n  top: 1em;\n  left: 1em;\n}\n\n.Toastify__toast-container--top-center {\n  top: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.Toastify__toast-container--top-right {\n  top: 1em;\n  right: 1em;\n}\n\n.Toastify__toast-container--bottom-left {\n  bottom: 1em;\n  left: 1em;\n}\n\n.Toastify__toast-container--bottom-center {\n  bottom: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.Toastify__toast-container--bottom-right {\n  bottom: 1em;\n  right: 1em;\n}\n\n@media only screen and (max-width: 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-center, .Toastify__toast-container--top-left, .Toastify__toast-container--top-right {\n    top: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: auto;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: var(--toastify-toast-min-height);\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: 8px;\n  border-radius: 4px;\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  max-height: var(--toastify-toast-max-height);\n  overflow: hidden;\n  font-family: var(--toastify-font-family);\n  cursor: pointer;\n  direction: ltr;\n}\n\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n\n.Toastify__toast-body {\n  margin: auto 0;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  padding: 6px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.Toastify__toast-body > div:last-child {\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.Toastify__toast-icon {\n  -webkit-margin-end: 10px;\n  margin-inline-end: 10px;\n  width: 20px;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Toastify--animate {\n  animation-fill-mode: both;\n  animation-duration: 0.7s;\n}\n\n.Toastify--animate-icon {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n}\n\n@media only screen and (max-width: 480px) {\n  .Toastify__toast {\n    margin-bottom: 0;\n    border-radius: 0;\n  }\n}\n.Toastify__toast-theme--dark {\n  background: var(--toastify-color-dark);\n  color: var(--toastify-text-color-dark);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--default, .Toastify__toast-theme--light {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--info {\n  color: var(--toastify-text-color-info);\n  background: var(--toastify-color-info);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--success {\n  color: var(--toastify-text-color-success);\n  background: var(--toastify-color-success);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n  color: var(--toastify-text-color-warning);\n  background: var(--toastify-color-warning);\n}\n\n.Toastify__toast-theme--colored.Toastify__toast--error {\n  color: var(--toastify-text-color-error);\n  background: var(--toastify-color-error);\n}\n\n.Toastify__progress-bar-theme--light {\n  background: var(--toastify-color-progress-light);\n}\n\n.Toastify__progress-bar-theme--dark {\n  background: var(--toastify-color-progress-dark);\n}\n\n.Toastify__progress-bar--info {\n  background: var(--toastify-color-progress-info);\n}\n\n.Toastify__progress-bar--success {\n  background: var(--toastify-color-progress-success);\n}\n\n.Toastify__progress-bar--warning {\n  background: var(--toastify-color-progress-warning);\n}\n\n.Toastify__progress-bar--error {\n  background: var(--toastify-color-progress-error);\n}\n\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--info, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {\n  background: var(--toastify-color-transparent);\n}\n\n.Toastify__close-button {\n  color: #fff;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  -ms-flex-item-align: start;\n  align-self: flex-start;\n}\n\n.Toastify__close-button--light {\n  color: #000;\n  opacity: 0.3;\n}\n\n.Toastify__close-button > svg {\n  fill: currentColor;\n  height: 16px;\n  width: 14px;\n}\n\n.Toastify__close-button:focus, .Toastify__close-button:hover {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    transform: scaleX(1);\n  }\n  to {\n    transform: scaleX(0);\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  z-index: var(--toastify-z-index);\n  opacity: 0.7;\n  transform-origin: left;\n}\n\n.Toastify__progress-bar--animated {\n  animation: Toastify__trackProgress linear 1 forwards;\n}\n\n.Toastify__progress-bar--controlled {\n  transition: transform 0.2s;\n}\n\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: auto;\n  transform-origin: right;\n}\n\n.Toastify__spinner {\n  width: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: var(--toastify-spinner-color-empty-area);\n  border-right-color: var(--toastify-spinner-color);\n  animation: Toastify__spin 0.65s linear infinite;\n}\n\n@keyframes Toastify__bounceInRight {\n  0%, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  0%, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  0%, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  0%, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--bottom-left, .Toastify__bounce-enter--top-left {\n  animation-name: Toastify__bounceInLeft;\n}\n\n.Toastify__bounce-enter--bottom-right, .Toastify__bounce-enter--top-right {\n  animation-name: Toastify__bounceInRight;\n}\n\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--bottom-left, .Toastify__bounce-exit--top-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n\n.Toastify__bounce-exit--bottom-right, .Toastify__bounce-exit--top-right {\n  animation-name: Toastify__bounceOutRight;\n}\n\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  0% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  0% {\n    transform: perspective(400px) rotateX(90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotateX(-20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotateX(10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotateX(-5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  0% {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotateX(-20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotateX(90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  0% {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  0% {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  0% {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  0% {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translateZ(0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  0% {\n    transform: translateZ(0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--bottom-left, .Toastify__slide-enter--top-left {\n  animation-name: Toastify__slideInLeft;\n}\n\n.Toastify__slide-enter--bottom-right, .Toastify__slide-enter--top-right {\n  animation-name: Toastify__slideInRight;\n}\n\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--bottom-left, .Toastify__slide-exit--top-left {\n  animation-name: Toastify__slideOutLeft;\n}\n\n.Toastify__slide-exit--bottom-right, .Toastify__slide-exit--top-right {\n  animation-name: Toastify__slideOutRight;\n}\n\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n@keyframes Toastify__spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n.Toastify__toast-container {\n  width: max-content;\n  padding: 0;\n  max-width: unset;\n  bottom: 1em;\n  transform: unset !important;\n  left: 16px;\n}\n\n.Toastify__toast-icon {\n  display: none;\n}\n\n.Toastify__toast-container--top-center {\n  top: 74px;\n}\n\n.Toastify__toast-container--top-center .Toastify__close-button,\n.Toastify__toast-container--bottom-center .Toastify__close-button {\n  margin-left: 10px;\n  margin-top: 5px;\n}\n\n.Toastify__toast {\n  padding: 14px 18px;\n  border-radius: 6px;\n  font-family: var(--font-medium);\n  -webkit-backdrop-filter: blur(15px);\n  backdrop-filter: blur(15px);\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n}\n\n.Toastify__toast-body {\n  padding: 0;\n}\n\n@media (max-width: 480px) {\n  .Toastify__toast {\n    min-height: 32px;\n    padding: 10px 15px;\n  }\n  .Toastify__toast-container--bottom-center {\n    bottom: 60px;\n    transform: translateX(-50%) !important;\n    left: 50%;\n    max-width: calc(100% - 32px);\n  }\n  .Toastify__toast-container--top-center .Toastify__close-button,\n  .Toastify__toast-container--bottom-center .Toastify__close-button {\n    margin-left: 10px;\n    margin-top: 1px !important;\n    line-height: 1;\n  }\n}";
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=_toastify-overrides.scss.js.map

;// CONCATENATED MODULE: ../core/dist/icons/BidSuccessful.svg.js


var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBidSuccessful(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "#3CA300",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M8 15.5l4.014 4.5 9.486-9"
  })));
}


//# sourceMappingURL=BidSuccessful.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/Error.svg.js


var Error_svg_path, _path2;

function Error_svg_extends() { Error_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Error_svg_extends.apply(this, arguments); }

function SvgError(props) {
  return /*#__PURE__*/react.createElement("svg", Error_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), Error_svg_path || (Error_svg_path = /*#__PURE__*/react.createElement("path", {
    fill: "red",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M29 15c0 7.732-6.268 14-14 14S1 22.732 1 15 7.268 1 15 1s14 6.268 14 14z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M19.235 10.687a.64.64 0 01-.006.89l-3.371 3.399 3.456 3.444a.638.638 0 01.01.89.606.606 0 01-.871.011L14.98 15.86l-3.43 3.459a.608.608 0 01-.872-.006.638.638 0 01.005-.89l3.415-3.442-3.412-3.401a.638.638 0 01-.01-.89.606.606 0 01.871-.011l3.428 3.417 3.388-3.415a.608.608 0 01.872.006z",
    clipRule: "evenodd"
  })));
}


//# sourceMappingURL=Error.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/Info.svg.js


var Info_svg_path, _rect, _rect2;

function Info_svg_extends() { Info_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Info_svg_extends.apply(this, arguments); }

function SvgInfo(props) {
  return /*#__PURE__*/react.createElement("svg", Info_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), Info_svg_path || (Info_svg_path = /*#__PURE__*/react.createElement("path", {
    fill: "#275AE6",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M29 15c0 7.732-6.268 14-14 14S1 22.732 1 15 7.268 1 15 1s14 6.268 14 14z"
  })), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 2,
    height: 2,
    x: 14,
    y: 9,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/react.createElement("rect", {
    width: 2,
    height: 8,
    x: 14,
    y: 13,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 1
  })));
}


//# sourceMappingURL=Info.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/Warning.svg.js


var Warning_svg_path, Warning_svg_path2;

function Warning_svg_extends() { Warning_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Warning_svg_extends.apply(this, arguments); }

function SvgWarning(props) {
  return /*#__PURE__*/react.createElement("svg", Warning_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 30,
    fill: "none",
    viewBox: "0 0 36 30"
  }, props), Warning_svg_path || (Warning_svg_path = /*#__PURE__*/react.createElement("path", {
    fill: "#FFC700",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M19.885 2.077l13.82 23.692c.838 1.436-.21 3.231-1.884 3.231H4.179c-1.675 0-2.722-1.795-1.884-3.23l13.82-23.693c.838-1.436 2.932-1.436 3.77 0z",
    clipRule: "evenodd"
  })), Warning_svg_path2 || (Warning_svg_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M16.503 11.124C16.453 10.514 17.137 10 18 10c.862 0 1.547.513 1.497 1.122l-.587 7.275c-.027.338-.424.603-.903.603-.479 0-.874-.264-.902-.602l-.602-7.274zM17 21.766c0-.536.448-.971 1-.971s1 .434 1 .97v.059c0 .536-.448.97-1 .97s-1-.434-1-.97v-.058z"
  })));
}


//# sourceMappingURL=Warning.svg.js.map

;// CONCATENATED MODULE: ../core/dist/components/toast/Toast.module.scss.js


var Toast_module_scss_css_248z = ".Toast-module_main__yr1pq {\n  display: flex;\n  color: white;\n}\n.Toast-module_main__yr1pq .Toast-module_content__bPPq0 {\n  margin-left: 12px;\n  margin-top: 3px;\n}\n\n@media (max-width: 991px) {\n  .Toast-module_main__yr1pq {\n    display: flex;\n  }\n  .Toast-module_main__yr1pq .Toast-module_content__bPPq0 {\n    font-size: 13px;\n    font-family: var(--font-medium);\n    line-height: 16px;\n    margin-top: 2px;\n  }\n  .Toast-module_main__yr1pq .Toast-module_icon__jNo3c svg {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    top: -3px;\n  }\n}";
var Styles = {"main":"Toast-module_main__yr1pq","content":"Toast-module_content__bPPq0","icon":"Toast-module_icon__jNo3c"};
(0,style_inject_es/* default */.Z)(Toast_module_scss_css_248z);


//# sourceMappingURL=Toast.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/toast/toast.js










const DefaultToastOptions = {
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    draggable: false,
    closeButton: false,
    transition: react_toastify_esm/* Zoom */.LG,
    position: "bottom-center"
};
const IconMap = {
    success: SvgBidSuccessful,
    warning: SvgWarning,
    error: SvgError,
    info: SvgInfo
};
const MsgComp = ({ msg, className, contentClassName, type }) => {
    const Icon = IconMap[type];
    return (react.createElement("div", { className: classnames_default()(Styles.main, className) },
        react.createElement("div", { className: Styles.icon },
            react.createElement(Icon, null)),
        react.createElement("div", { className: classnames_default()(Styles.content, contentClassName) }, msg)));
};
const toast = (function () {
    function getComp(type, msg, options) {
        return (options === null || options === void 0 ? void 0 : options.shouldOverrideDefaultComp) ? (react.createElement(react.Fragment, null, msg)) : (react.createElement(MsgComp, { type: type, msg: msg, className: options === null || options === void 0 ? void 0 : options.className, contentClassName: options === null || options === void 0 ? void 0 : options.contentClassName }));
    }
    function toast(msg, options) {
        return react_toastify_esm/* toast.info */.Am.info(getComp("info", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    }
    toast.info = function (msg, options) {
        return toast(msg, options);
    };
    toast.success = function (msg, options) {
        return react_toastify_esm/* toast.success */.Am.success(getComp("success", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    };
    toast.error = function (msg, options) {
        return react_toastify_esm/* toast.error */.Am.error(getComp("error", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    };
    toast.warning = function (msg, options) {
        return react_toastify_esm/* toast.warning */.Am.warning(getComp("warning", msg), Object.assign(Object.assign({}, DefaultToastOptions), options));
    };
    toast.dismiss = function (id) {
        return react_toastify_esm/* toast.dismiss */.Am.dismiss(id);
    };
    return toast;
})();


//# sourceMappingURL=toast.js.map


/***/ }),

/***/ 3992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ValidationError; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _methods_getRemValue_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(89842);
/* harmony import */ var _methods_getSizeByViewPort_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98175);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30116);
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(52489);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(76705);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52224);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43298);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(91680);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(22391);
/* harmony import */ var _services_const_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(41634);
/* harmony import */ var _toast_toast_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(63118);
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(11663);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(96762);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_35__);







































const ValidationError = ({ errorClass, error, style = {} }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: Object.assign({ 
            // height: "11px",
            color: "#FF1224", fontSize: (0,_methods_getRemValue_js__WEBPACK_IMPORTED_MODULE_36__/* .getRemValue */ .T)(11), lineHeight: (0,_methods_getSizeByViewPort_js__WEBPACK_IMPORTED_MODULE_1__/* .getHeightByViewPort */ .J)(10) }, style), className: errorClass }, error));
};


//# sourceMappingURL=ValidationError.js.map


/***/ }),

/***/ 80230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DC": function() { return /* binding */ FaqQuestions; },
/* harmony export */   "GB": function() { return /* binding */ FaqSlugsConstant; },
/* harmony export */   "og": function() { return /* binding */ FaqCategories; },
/* harmony export */   "z6": function() { return /* binding */ useFaqQuestions; }
/* harmony export */ });
/* unused harmony export useFaqCategories */
/* harmony import */ var _platformStats_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28230);



var FaqSlugsConstant;
(function (FaqSlugsConstant) {
    FaqSlugsConstant["GENERAL"] = "general";
    FaqSlugsConstant["BOOKING_TRUCKS"] = "booking-trucks";
    FaqSlugsConstant["BOOKING_LOADS"] = "booking-loads";
    FaqSlugsConstant["GROWING_NETWORKS"] = "grow-networks";
    FaqSlugsConstant["FRAUD_PREVENTION"] = "fraud-prevention";
    FaqSlugsConstant["LOGISTICS_SERVICES"] = "logistics-services";
})(FaqSlugsConstant || (FaqSlugsConstant = {}));
const FaqCategories = [
    { name: "General FAQ’s", slug: FaqSlugsConstant.GENERAL },
    { name: "Booking Trucks", slug: FaqSlugsConstant.BOOKING_TRUCKS },
    { name: "Booking Loads", slug: FaqSlugsConstant.BOOKING_LOADS },
    { name: "Grow Network", slug: FaqSlugsConstant.GROWING_NETWORKS },
    { name: "Fraud Prevention", slug: FaqSlugsConstant.FRAUD_PREVENTION },
    { name: "Logistics Services", slug: FaqSlugsConstant.LOGISTICS_SERVICES }
];
const useFaqCategories = () => {
    const { t } = useTranslation("faq");
    const FaqCategories = [
        { name: t("faq:General_FAQ"), slug: FaqSlugsConstant.GENERAL },
        { name: t("faq:booking_trucks"), slug: FaqSlugsConstant.BOOKING_TRUCKS },
        { name: t("faq:booking_loads"), slug: FaqSlugsConstant.BOOKING_LOADS },
        { name: t("faq:grow_network"), slug: FaqSlugsConstant.GROWING_NETWORKS },
        { name: t("faq:fraud_prevention"), slug: FaqSlugsConstant.FRAUD_PREVENTION },
        { name: t("faq:logistics_services"), slug: FaqSlugsConstant.LOGISTICS_SERVICES }
    ];
    return FaqCategories;
};
const useFaqQuestions = (t) => {
    const FaqQuestions = [
        {
            category: FaqSlugsConstant.GENERAL,
            faqQuestions: [
                {
                    question: t("faq:general.question1.question"),
                    response: t("faq:general.question1.response"),
                    subContent: [
                        t("faq:general.question1.subcontent.point1"),
                        t("faq:general.question1.subcontent.point2"),
                        t("faq:general.question1.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:general.question2.question"),
                    response: t("faq:general.question2.response"),
                    link: "https://6r7cz.app.link/generalfaq2"
                },
                {
                    question: t("faq:general.question3.question"),
                    response: t("faq:general.question3.response"),
                    subContent: [
                        t("faq:general.question3.subcontent.point1"),
                        t("faq:general.question3.subcontent.point2"),
                        t("faq:general.question3.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:general.question4.question"),
                    response: t("faq:general.question4.response")
                },
                {
                    question: t("faq:general.question5.question"),
                    response: t("faq:general.question5.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.BOOKING_TRUCKS,
            faqQuestions: [
                {
                    question: t("faq:booking-trucks.question1.question"),
                    subContent: [
                        t("faq:booking-trucks.question1.subcontent.point1"),
                        t("faq:booking-trucks.question1.subcontent.point2"),
                        t("faq:booking-trucks.question1.subcontent.point3"),
                        t("faq:booking-trucks.question1.subcontent.point4"),
                        t("faq:booking-trucks.question1.subcontent.point5")
                    ]
                },
                {
                    question: t("faq:booking-trucks.question2.question"),
                    response: t("faq:booking-trucks.question2.response", (0,_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .getPlatformStatI18nLabels */ .E)()),
                    subContent: [
                        t("faq:booking-trucks.question2.subcontent.point1"),
                        t("faq:booking-trucks.question2.subcontent.point2"),
                        t("faq:booking-trucks.question2.subcontent.point3"),
                        t("faq:booking-trucks.question2.subcontent.point4"),
                        t("faq:booking-trucks.question2.subcontent.point5")
                    ]
                },
                {
                    question: t("faq:booking-trucks.question3.question"),
                    response: t("faq:booking-trucks.question3.response")
                },
                {
                    question: t("faq:booking-trucks.question4.question"),
                    response: t("faq:booking-trucks.question4.response")
                },
                {
                    question: t("faq:booking-trucks.question5.question"),
                    response: t("faq:booking-trucks.question5.response")
                },
                {
                    question: t("faq:booking-trucks.question6.question"),
                    response: t("faq:booking-trucks.question6.response")
                },
                {
                    question: t("faq:booking-trucks.question7.question"),
                    response: t("faq:booking-trucks.question7.response")
                },
                {
                    question: t("faq:booking-trucks.question8.question"),
                    response: t("faq:booking-trucks.question8.response")
                },
                {
                    question: t("faq:booking-trucks.question9.question"),
                    response: t("faq:booking-trucks.question9.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.BOOKING_LOADS,
            faqQuestions: [
                {
                    question: t("faq:booking-loads.question1.question"),
                    subContent: [
                        t("faq:booking-loads.question1.subcontent.point1"),
                        t("faq:booking-loads.question1.subcontent.point2"),
                        t("faq:booking-loads.question1.subcontent.point3"),
                        t("faq:booking-loads.question1.subcontent.point4")
                    ]
                },
                {
                    question: t("faq:booking-loads.question2.question"),
                    response: t("faq:booking-loads.question2.response", (0,_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .getPlatformStatI18nLabels */ .E)()),
                    subContent: [
                        t("faq:booking-loads.question2.subcontent.point1"),
                        t("faq:booking-loads.question2.subcontent.point2"),
                        t("faq:booking-loads.question2.subcontent.point3"),
                        t("faq:booking-loads.question2.subcontent.point4"),
                        t("faq:booking-loads.question2.subcontent.point5"),
                        t("faq:booking-loads.question2.subcontent.point6")
                    ]
                },
                {
                    question: t("faq:booking-loads.question3.question"),
                    response: t("faq:booking-loads.question3.response")
                },
                {
                    question: t("faq:booking-loads.question4.question"),
                    response: t("faq:booking-loads.question4.response")
                },
                {
                    question: t("faq:booking-loads.question5.question"),
                    response: t("faq:booking-loads.question5.response")
                },
                {
                    question: t("faq:booking-loads.question6.question"),
                    response: t("faq:booking-loads.question6.response")
                },
                {
                    question: t("faq:booking-loads.question7.question"),
                    response: t("faq:booking-loads.question7.response", (0,_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .getPlatformStatI18nLabels */ .E)())
                },
                {
                    question: t("faq:booking-loads.question8.question"),
                    response: t("faq:booking-loads.question8.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.GROWING_NETWORKS,
            faqQuestions: [
                {
                    question: t("faq:grow-networks.question1.question"),
                    response: t("faq:grow-networks.question1.response")
                },
                {
                    question: t("faq:grow-networks.question2.question"),
                    response: t("faq:grow-networks.question2.response")
                },
                {
                    question: t("faq:grow-networks.question3.question"),
                    response: t("faq:grow-networks.question3.response")
                }
            ]
        },
        {
            category: FaqSlugsConstant.FRAUD_PREVENTION,
            faqQuestions: [
                {
                    question: t("faq:fraud-prevention.question1.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question1.subcontent.point1"),
                        t("faq:fraud-prevention.question1.subcontent.point2"),
                        t("faq:fraud-prevention.question1.subcontent.point3"),
                        t("faq:fraud-prevention.question1.subcontent.point4"),
                        t("faq:fraud-prevention.question1.subcontent.point5"),
                        t("faq:fraud-prevention.question1.subcontent.point6"),
                        t("faq:fraud-prevention.question1.subcontent.point7")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question2.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question2.subcontent.point1"),
                        t("faq:fraud-prevention.question2.subcontent.point2"),
                        t("faq:fraud-prevention.question2.subcontent.point3"),
                        t("faq:fraud-prevention.question2.subcontent.point4")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question3.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question3.subcontent.point1"),
                        t("faq:fraud-prevention.question3.subcontent.point2"),
                        t("faq:fraud-prevention.question3.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question4.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question4.subcontent.point1"),
                        t("faq:fraud-prevention.question4.subcontent.point2"),
                        t("faq:fraud-prevention.question4.subcontent.point3")
                    ]
                },
                {
                    question: t("faq:fraud-prevention.question5.question"),
                    response: ``,
                    subContent: [
                        t("faq:fraud-prevention.question5.subcontent.point1"),
                        t("faq:fraud-prevention.question5.subcontent.point2"),
                        t("faq:fraud-prevention.question5.subcontent.point3"),
                        t("faq:fraud-prevention.question5.subcontent.point4")
                    ]
                }
            ]
        },
        {
            category: FaqSlugsConstant.LOGISTICS_SERVICES,
            faqQuestions: [
                {
                    question: t("faq:logistics-services.question1.question"),
                    response: t("faq:logistics-services.question1.response"),
                    subContent: [
                        t("faq:logistics-services.question1.subcontent.point1"),
                        t("faq:logistics-services.question1.subcontent.point2"),
                        t("faq:logistics-services.question1.subcontent.point3"),
                        t("faq:logistics-services.question1.subcontent.point4"),
                        t("faq:logistics-services.question1.subcontent.point5"),
                        t("faq:logistics-services.question1.subcontent.point6"),
                        t("faq:logistics-services.question1.subcontent.point7", (0,_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .getPlatformStatI18nLabels */ .E)()),
                        t("faq:logistics-services.question1.subcontent.point8")
                    ]
                },
                {
                    question: t("faq:logistics-services.question2.question"),
                    response: t("faq:logistics-services.question2.response")
                },
                {
                    question: t("faq:logistics-services.question3.question"),
                    response: t("faq:logistics-services.question3.response"),
                    subContent: [
                        t("faq:logistics-services.question3.subcontent.point1"),
                        t("faq:logistics-services.question3.subcontent.point2"),
                        t("faq:logistics-services.question3.subcontent.point3"),
                        t("faq:logistics-services.question3.subcontent.point4")
                    ]
                },
                {
                    question: t("faq:logistics-services.question4.question"),
                    response: t("faq:logistics-services.question4.response")
                },
                {
                    question: t("faq:logistics-services.question5.question"),
                    response: t("faq:logistics-services.question5.response")
                }
            ]
        }
    ];
    return FaqQuestions;
};
const FaqQuestions = [
    {
        category: FaqSlugsConstant.GENERAL,
        faqQuestions: [
            {
                question: "How do I get started on the Vahak Transport Marketplace?",
                response: `Join Vahak, India’s most trusted community of Transporters, Truck owners & Consignors. Follow these simple steps to get started:`,
                subContent: [
                    `Sign-up using your mobile number & choose your role: lorry provider or load provider.`,
                    `Attach your truck(s) or post your loads to get bids within 20 minutes. Approve the bids to complete deals.`,
                    `Use the ‘Load Market’ or ‘Lorry Market’ for quick bookings.`
                ]
            },
            {
                question: "Where can I download the Vahak app?",
                response: `You can download the Vahak app for free by clicking`,
                link: "https://6r7cz.app.link/generalfaq2"
            },
            {
                question: "Who can register on Vahak? What are the charges?",
                response: `Vahak is a completely free platform to find and book loads and lorries online. Users can register & choose their role as either “Lorry Provider” or “Load Provider”.`,
                subContent: [
                    `Lorry/Truck Provider: Transporters, Transportation Service Providers, Logistic Companies, Truck & Fleet Owners, Truck Brokers.`,
                    `Load Provider: Consignors & Factory Owners, Dispatch Departments, Freight Booking & Commission Agents, Transporters, Traders & Trading agents, Small & Medium Business Owners.`,
                    `Vahak is a 100% free app made for the Indian Transport Community with business-specific features to improve your brand, grow your professional transport network and save time on daily bookings.`
                ]
            },
            {
                question: "What makes Vahak a trusted platform?",
                response: "The trust gap currently present in the Indian road transport market highly limits the business potential and expansion for transporters, agents and lorry owners. Vahak is a platform for transport businesses and individuals to create a unique brand backed by user ratings, connections, document verification and user recommendations."
            },
            {
                question: "What are the benefits of ‘Connections’ on Vahak?",
                response: "The transport business in India is highly network-dependent. Vahak helps users connect and develop a trusted personal network. This network of ‘Connections’ can be leveraged for business growth."
            }
        ]
    },
    {
        category: FaqSlugsConstant.BOOKING_TRUCKS,
        faqQuestions: [
            {
                question: "How do I attach my loads on Vahak?",
                subContent: [
                    "Open the Vahak App",
                    "Go to “My Loads” tab and click “Post Load”",
                    "Enter your load details and select the truck type",
                    "Finalize the payment method",
                    "Now your load will be visible to all transporters on Vahak!"
                ]
            },
            {
                question: "How do I book trucks on Vahak?",
                response: `You can post your load details and get bids automatically from ${_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.lakhs */ .s.transporters.lakhs} transporters. Or you can pick a truck from the  <a href='/marketplace/lorry'> “Lorry Market”</a> tab. Follow these simple steps to find trucks:`,
                subContent: [
                    "Open the Vahak app",
                    "Go to the “Market” tab",
                    "Browse through the available live lorries",
                    "Press “Book Now” and attach your load",
                    "Enter your Bid and send it across!"
                ]
            },
            {
                question: "What is the cost of booking trucks on Vahak?",
                response: "Vahak is completely free! There are no commissions, brokerage fees or hidden costs. It is India’s first fully free road transport marketplace that lets users search lorries and loads online."
            },
            {
                question: "Can I track my booking status?",
                response: "Yes, you can track your booking status through the Vahak app. After booking a truck, you can check the trip details in your dashboard."
            },
            {
                question: "Why is “Lorry Market” empty?",
                response: `To see the available lorries, please select your routes (eg. Maharashtra, Rajasthan) from the ""Edit Profile"" section. Go to the updated  <a href='/marketplace/lorry'>“Lorry Market”</a> to see the available lorries. If it is still empty, then there are no available lorries in the market. You could try searching for lorries via the “Network” tab.`
            },
            {
                question: "How long does it take to book lorries on Vahak?",
                response: "Vahak is a free <a href='/marketplace/load'>transportation marketplace of load</a> & truck owners and enquiries are usually closed in under 48 hours. Once you post your lorry/load requirement, you'll get bids within 20 minutes!"
            },
            {
                question: "What type of trucks do transporters own on Vahak?",
                response: "<a href='/transporters'>Transport companies</a>, lorry owners and brokers have fleets including long haul vehicles like containers, full & half body trucks, and LCV. Hence, Vahak is the ideal platform for availing truck transportation services!"
            },
            {
                question: "How is Vahak helpful for a load owner?",
                response: "Vahak helps load owners find trucks online easily. With this truck booking app, load owners can connect with a network of over 2,00,000+ transporters, find the best truck for their needs and successfully complete trips."
            },
            {
                question: "How will payments happen on Vahak?",
                response: "Vahak connects load owners with lorry providers and the freight is calculated using rates exchanged and approved between two parties. Lorries are hired directly without any middlemen on the Vahak marketplace so the parties are liable to each other for the payments, safety & security of the consignments. Users can check out ratings, connections and recommendations for transporters & truck owners before making a decision."
            }
        ]
    },
    {
        category: FaqSlugsConstant.BOOKING_LOADS,
        faqQuestions: [
            {
                question: "How do I attach my lorry on Vahak?",
                subContent: [
                    "Open the Vahak app",
                    "Click on “Attach Lorry”",
                    "Enter your details and press “Attach Fleet”",
                    "Now your lorry will be visible to all transporters on Vahak!"
                ]
            },
            {
                question: "How do I book loads on Vahak?",
                response: `You can post your lorry details and get bids automatically from ${_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.lakhs */ .s.transporters.lakhs} transporters. Or you can pick a load from the  <a href='/marketplace/load'>“Load Market”</a> directory. Follow these simple steps to find trucks:`,
                subContent: [
                    "Open the Vahak app",
                    "Go to the “Market” section",
                    "Click on <a href='/marketplace/load'> Load Market</a>",
                    "Browse through the available live loads",
                    "Press “Book Now”",
                    "Enter your Bid and send it across!"
                ]
            },
            {
                question: "What is the cost of booking loads on Vahak?",
                response: "Vahak is completely free! There are no commissions, brokerage fees or hidden costs. It is India’s first fully free road transportation marketplace that lets users search lorries and loads online."
            },
            {
                question: "Can I track my truck's status?",
                response: "Yes. You can track the status of your truck(s) on the Vahak app. After attaching your lorry you can see the trip details in your dashboard."
            },
            {
                question: "How do I grow my transport business on Vahak?",
                response: "Transporters & truck owners can create business profiles and an online presence on the Vahak app. The business profile helps users attract business leads and connections which can be used for making deals. With branding features like Whatsapp Business Card, Branded enquiry cards that are sharable on Whatsapp, users can further promote their transport brand and online presence. If you are a truck driver looking for loads, Vahak is the best place to start!"
            },
            {
                question: "I am a lorry owner but don’t have a company, can I register on Vahak?",
                response: "Yes, lorry owners & lorry brokers can register on Vahak as ‘Lorry Provider’. If users don't have a company, they can enter their own name and sign-up!"
            },
            {
                question: "How is Vahak helpful for me?",
                response: `With Vahak, anyone who owns a lorry can register and find business. On the Vahak app, users can find ${_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.liveLoadsAndLorries.label */ .s.liveLoadsAndLorries.label} loads for free. By attaching their truck with Vahak, they will be able to <a href='/online-load-booking'>find loads</a> and increase their revenue without any commissions!`
            },
            {
                question: "How will payments happen on Vahak?",
                response: "Vahak connects lorry owners with load providers and the freight is calculated using rates exchanged and approved between two parties. Lorries are hired directly without any middlemen on <a href='/marketplace/lorry'> Vahak market </a> so the parties are liable to each other for the payments, safety & security of the consignments. Users can check out ratings, connections, recommendations for transporters & truck owners."
            }
        ]
    },
    {
        category: FaqSlugsConstant.GROWING_NETWORKS,
        faqQuestions: [
            {
                question: "How to connect with transporters on Vahak?",
                response: "On the bottom right corner of the app, you will find the “Network” tab that shows you all the different logistics services providers in your city. You can add them using the “Connect” button."
            },
            {
                question: "What is the benefit of networking on Vahak?",
                response: "You can connect with thousands of transporters on the Vahak app. Be it <a href='/online-truck-booking'>online truck booking </a>or <a href='/online-load-booking'>finding loads</a>, networking with these people will help you grow your business and increase your revenue."
            },
            {
                question: "Do I have to pay money to use this feature?",
                response: "No! Vahak is a completely free platform where you can do everything from availing truck transportation services to <a href='/online-load-booking'>finding loads</a> online without any commissions. You can use the Network feature for free and grow your business by connecting with similar businesses."
            }
        ]
    },
    {
        category: FaqSlugsConstant.FRAUD_PREVENTION,
        faqQuestions: [
            {
                question: "Posing as Defence Personnel",
                response: ``,
                subContent: [
                    `Never entertain or deal with Vendors/Load Owners/Transporters posing as officials from Indian Defense as these are fraudsters. If you come across anyone with profile names like <i>Indian Army, Army, IATA, Indian Air Force, Air Force, India Navy Force, India Navy</i> or similar, please avoid dealing with them and inform Vahak Customer Support immediately.`,
                    `Never deal with people who pose as <i>Indian Army officials by showing Army ID Cards, Army Canteen Cards, Aadhaar Cards or any other Defense ID Card</i>. These ID cards are always fake as the Indian Army never posts load/lorry requirements publically.`,
                    `Never deal with people/load owners/transporters who quote load bid rates much higher than the market rate. Fraudsters generally quote un-common bid rates to lure transporters in the name of higher profits.`,
                    `Never deal with anyone who identifies themselves as Indian Army officials or Army Canteen officials and talk about providing quick and genuine payments. <u><strong>Indian Defense organisations never post any requirements publicly but instead do so through tenders and contracts.</strong></u>`,
                    `Being a lorry owner, never deal with parties who ask for advance/token payment in the form of <i>Army Registration Fees/Contract Service Fees/Contract Charges/Army Fees, etc</i>.<u><strong>A lorry owner does not need to pay any type of advance amount.</strong></u> If you are asked to pay the amount, refuse the deal and inform Vahak Customer Support about the same.`,
                    `When in a deal and asked about load pick-up from an Army Base or Airport, never confirm the deal and instead ask the party to share their Live Location on WhatsApp. Being a lorry owner, you can also request them for a token amount before going to the load pick-up location. Fraudsters generally provide genuine army load pick-up points to lure lorry owners.`,
                    `Never scan or click on any QR Code or UPI Payments Link to receive payment or make advance/token payment before making sure of the deal details. <u><strong>Being a lorry owner, you should never make any payment whatsoever through any source of any amount.</strong></u>`
                ]
            },
            {
                question: "UPI Payment Request/Fake QR Codes",
                response: ``,
                subContent: [
                    `Always remember to use <strong>Vahak Payments</strong> feature to make any sort of payments related to deals done on <strong>Vahak</strong> platform. This ensures that you avoid frauds/scams and can be helped out immediately if you face any issue.`,
                    `Never scan or click any QR Code or UPI Payments Link to make or receive payment. Being a load owner, you are not required to scan a QR code to create a payment account or make payments. Being a lorry owner, never scan any QR code or link to receive any payment as QR codes are never used to receive payment.`,
                    `<strong>Vahak</strong> or any genuine load owner would never ask you to share any OTP/PIN/ or any other Bank Details for confirming transactions or booking deals. Never share your bank details with anyone for doing any deal on Vahak.`,
                    `If you ever face any difficulty in using the <strong>Vahak Payments</strong> feature or come in contact with anyone who you think is a fraudster, please contact Vahak Customer Support immediately.`
                ]
            },
            {
                question: "Making Advance Payments/ Token Amount Payment",
                response: ``,
                subContent: [
                    `Either you are a load owner or a lorry owner, always use <strong>Vahak Payments</strong> feature to request or make an advance/token payment for a confirmed deal. These payments are stored safely with <strong>Vahak</strong> and can be tracked through the <strong>Vahak Payments</strong> feature.`,
                    `As a load owner, always request the lorry owner to come to the load pick-up location, if they have requested for an advance/token payment. In case you are sure of the deal and would like to make a token/advance payment, please ensure to use the Vahak Payments feature to avoid any frauds.`
                ]
            },
            {
                question: "Confirming a Deal",
                response: ``,
                subContent: [
                    `To confirm a deal on Vahak, either of the parties (load/lorry owner) needs to bid on <strong>Vahak</strong> marketplace on the respective load or lorry. Once the bid is confirmed, the parties can then communicate directly and negotiate on the total payment amount or the advance/token payment.`,
                    `Once finalized, ensure to accept or receive the total payment or the advance/token payment only through the <strong>Vahak Payments</strong> feature. This ensures that the parties have genuine transaction proofs and invoices for the completed deal and are safe from frauds.`,
                    `In case you have any query or need help in using the <strong>Vahak Payments</strong> feature, please contact the Vahak Customer Support for immediate assistance.`
                ]
            },
            {
                question: "Receiving/Making Payments on Vahak",
                response: ``,
                subContent: [
                    `When completing a deal on <strong>Vahak</strong>, <u>always ensure to make or receive total payment or advance/token payment only through the <strong>Vahak Payments</strong> feature.</u>`,
                    `If you are a load owner, pay the lorry owner some advance/token amount through the <strong>Vahak Payments</strong> feature to show your genuineness. The final payment of the due amount can be done afterwards also through <strong>Vahak Payments</strong>.`,
                    `If you are a lorry owner, request some advance/token amount from the load owner, if they ask you to visit the load pick-up location. This advance/token amount is stored safely with <strong>Vahak</strong> to avoid fraud load owners.`,
                    `Always remember these points when using the Vahak Payments feature: <br/>
                <span>1. <strong>Vahak Payments</strong> feature will be available only when a bid is accepted on <strong>Vahak</strong> marketplace.<br/>
                2. To begin, either the load owner or the lorry owner can then raise a request for advance payment, while the other has to approve. Amount negotiations can also be carried out during this time.<br/>
                3. After the advance payment is done, the amount paid by the load owner will be received by the lorry owner once the loading is completed. Till then, the payment is stored safely with <strong>Vahak</strong> so as to avoid frauds by either parties.<br/>
                4. In between this time, either party can raise a refund request if a legitimate issue arises.<br/>
                5. In case a refund request is raised, Vahak Customer Support team will call both the parties to know the exact issue and also collect the necessary documents/proofs.<br/>
                6. Refund requests will be accepted or rejected based on the document proofs provided by the parties.<br/>
                7. The total amount to be paid on completion of the deal can also be paid in installments as per the mutual agreement between the parties.</span>`
                ]
            }
        ]
    },
    {
        category: FaqSlugsConstant.LOGISTICS_SERVICES,
        faqQuestions: [
            {
                question: "How do I book logistics services on Vahak?",
                response: "To book logistics services on Vahak,",
                subContent: [
                    `Go to our website, www.vahak.in`,
                    `Register & verify yourself if you do not have an account by providing basic ID details.`,
                    `Now, attach your load, by providing basic details about your load.`,
                    `Once done, go to the "Logistics Services" section by clicking on the "Services" tab.`,
                    `On the "Logistics Services" page, click on the "Book Logistics Services" button.`,
                    `You will be now re-directed to the Live Marketplace based on your default source location.`,
                    `Now, search, verify & select the best possible deal by choosing trucks from ${_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.lakhsLong */ .s.transporters.lakhsLong} logistics service providers.`,
                    `You can bid on the listed trucks according to your need & connect with them directly to confirm the booking.`
                ]
            },
            {
                question: "What is the cost of booking logistics services on Vahak?",
                response: "Vahak is completely FREE to use for any user. We do not charge any commission fees or any other hidden charges to use our platform. We are India's one & only free online transport marketplace to book loads or lorries."
            },
            {
                question: "How do I attach my loads on Vahak to book logistics services?",
                response: "To attach loads on Vahak,",
                subContent: [
                    `Go to our website, www.vahak.in`,
                    `Register & verify yourself if you do not have an account by providing basic ID details.`,
                    `Next go to the "My Loads" tab & click on "Post Load".`,
                    `Now, provide complete details about your load, destination city & truck type required. Also provide any ODC remarks if necessary.`,
                    `Once done, your load will become live on the "Load Marketplace" where users will be able to view your load and bid on it.`
                ]
            },
            {
                question: "Can I track my logistics services booking status?",
                response: `Yes, you can track your logistics services booking status easily through your user profile dashboard on the Vahak wesbsite. Once you book a logistic service, your booking details will be made available under the "Trip Details" dashboard.`
            },
            {
                question: "How do I make the payments for my logistics services booking?",
                response: `Once your booking is complete you can use the "Vahak Payments" feature to make payments for your booking. "Vahak Payments" is our own 100% safe & secure payment gateway that allows you to make hassle-free & secure payments through various payment modes like UPI, Bank Account, and Debit Card. After the booking is confirmed, use the "Vahak Payments" to make the advance payment decided mutually between you and the service provider. Once the booking is completed and you have received the Proof of Delivery (PoD) receipt from the service provider, pay the remaining amount also through the "Vahak Payments" feature.`
            }
        ]
    }
];


//# sourceMappingURL=Faq.js.map


/***/ }),

/***/ 52489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ PageTypes; },
/* harmony export */   "i": function() { return /* binding */ Pages; }
/* harmony export */ });
var Pages;
(function (Pages) {
    Pages[Pages["TRANSACTION"] = 0] = "TRANSACTION";
    Pages[Pages["BID_HISTORY"] = 1] = "BID_HISTORY";
    Pages[Pages["DETAILS_BID"] = 2] = "DETAILS_BID";
})(Pages || (Pages = {}));
var PageTypes;
(function (PageTypes) {
    PageTypes["HOMEPAGE"] = "homepage";
    PageTypes["MARKETPLACE"] = "marketplace";
    PageTypes["TRANSPORTERS"] = "transporters";
    PageTypes["GROW_NETWORK"] = "grow-network";
    PageTypes["ONLINE_LOAD_BOOKING"] = "online-load-booking";
    PageTypes["ONLINE_TRUCK_BOOKING"] = "online-truck-booking";
    PageTypes["LOGISTICS_SERVICE"] = "logistics-service";
    PageTypes["FULL_TRUCK_LOAD"] = "full-truck-load";
    PageTypes["PART_LOAD_BOOKING"] = "part-load-booking";
    PageTypes["BUSINESS_CARDS"] = "business-cards";
    PageTypes["ABOUT_US"] = "about-us";
    PageTypes["HOW_VAHAK_HELPS"] = "how-vahak-helps";
    PageTypes["WHY_CHOOSE_US"] = "why-choose-us";
    PageTypes["CAREERS"] = "careers";
    PageTypes["CONTACT_US"] = "contact-us";
    PageTypes["MY_LOADS"] = "my-loads";
    PageTypes["MY_LORRIES"] = "my-lorries";
    PageTypes["USER_PROFILE"] = "user-profile";
})(PageTypes || (PageTypes = {}));


//# sourceMappingURL=Pages.js.map


/***/ }),

/***/ 79109:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: SERVICE_TYPE_OPTIONS

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../core/dist/icons/Loads.svg.js


var _path, _path2, _path3, _path4, _path5, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLoads(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.425,
    height: 28.714,
    viewBox: "0 0 27.425 28.714"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.957 16.661v8.779l8.468-4.906v-8.849z",
    fill: "#ffd164"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18.967 16.661v8.779l-8.038-4.644v-8.849z",
    fill: "#f6b243"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M10.929 11.944l8.038 4.714 8.458-4.976-8.056-4.689z",
    fill: "#ffe17d"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M22.55 14.587v2.352l1.913-1.093v-2.425z",
    fill: "#e6646e"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M14.521 9.873l8.038 4.714 1.9-1.163-8.056-4.689z",
    fill: "#ff8087"
  })), _g || (_g = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    d: "M8.468 19.934v8.779L0 23.807v-8.849z",
    fill: "#f6b243"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M8.458 19.935v8.779l8.038-4.644v-8.849z",
    fill: "#ffd164"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.497 15.22l-8.038 4.714-8.458-4.976 8.056-4.689z",
    fill: "#ffe17d"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M4.876 17.86v2.355l-1.913-1.093v-2.425z",
    fill: "#e6646e"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.904 13.147l-8.038 4.714-1.9-1.163 8.056-4.689z",
    fill: "#ff8087"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", null, /*#__PURE__*/react.createElement("path", {
    d: "M12.46 8.153v7.406l-7.143-4.138V3.956z",
    fill: "#f6b243"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.452 8.154v7.406l6.781-3.918V4.177z",
    fill: "#ffd164"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M19.232 4.176l-6.781 3.977-7.135-4.2 6.8-3.956z",
    fill: "#ffe17d"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.429 6.404v1.987l-1.614-.922V5.423z",
    fill: "#e6646e"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.202 2.427L9.421 6.404l-1.605-.981 6.8-3.956z",
    fill: "#ff8087"
  }))));
}


//# sourceMappingURL=Loads.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/LorryFleetOwner.svg.js


var LorryFleetOwner_svg_path, LorryFleetOwner_svg_path2, LorryFleetOwner_svg_path3, LorryFleetOwner_svg_path4, LorryFleetOwner_svg_path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

function LorryFleetOwner_svg_extends() { LorryFleetOwner_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return LorryFleetOwner_svg_extends.apply(this, arguments); }

function SvgLorryFleetOwner(props) {
  return /*#__PURE__*/react.createElement("svg", LorryFleetOwner_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    fill: "none",
    viewBox: "0 0 54 53"
  }, props), LorryFleetOwner_svg_path || (LorryFleetOwner_svg_path = /*#__PURE__*/react.createElement("path", {
    fill: "#0040BF",
    d: "M26.38 37.97v-.78L0 21.06V6.21l13.13 7.93 13.38 8c-.1 2.53-.16 5.15-.18 7.84-.02 2.69 0 5.38.06 8l-.01-.01z"
  })), LorryFleetOwner_svg_path2 || (LorryFleetOwner_svg_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M51.83 29.51v5l-1.34.85v-5l1.34-.85z"
  })), LorryFleetOwner_svg_path3 || (LorryFleetOwner_svg_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M26.38 42.67l2.37-1.08-2.37-1.66v2.74z"
  })), LorryFleetOwner_svg_path4 || (LorryFleetOwner_svg_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M39 14.63l.06 15.31-12.67 8-.14-17.52L39 14.63z"
  })), LorryFleetOwner_svg_path5 || (LorryFleetOwner_svg_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#EEF5FE",
    d: "M26.83 25.34l11.55-6.85a1.21 1.21 0 01.55-.06c.193.029.378.1.54.21.38.26 3.88 2.35 8.73 5.25a7.295 7.295 0 012.11 2.62c.182.372.33.76.44 1.16.3 1.51.5 2.81.63 3.8.26 2 .39 3.64.49 5l.12 1.76-1.09 2.14-.87.82-5.91 3.49-1.09.14-2.37-.08c0-.36-.07-.91-.13-1.6 0-.49-.07-.68-.1-1-.07-.83-.09-1.43-.1-1.77a34.878 34.878 0 00-.54-4.78 9.657 9.657 0 00-.36-1.36 7.154 7.154 0 00-1-1.85 8.73 8.73 0 00-2-1.86l-.44-.31a18.802 18.802 0 00-1.78-1.06c-.49-.26-1-.58-2-1.22 0 0-2.21-1.37-4.26-2.45a1.231 1.231 0 00-.39-.14 1.37 1.37 0 00-.73 0z"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#004D82",
    d: "M26.382 37.19v.78c-8.78-5.247-17.57-10.49-26.37-15.73v-1.18l26.37 16.13zm-.122-15.12L0 6.21l26.25 14.21c0 .57.01 1.1.01 1.65z"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M26.38 42.67L0 26.93v-5.87l26.38 16.13v5.48z"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#DAE5EF",
    d: "M26.381 39.93V38.6c-.11-3.54-.06-12.65.41-13.18.47-.53 1.68.24 2.15.51l5.4 3.18a12.107 12.107 0 013.64 2.63 9.66 9.66 0 011.06 1.48 10.587 10.587 0 011.17 4.8c.19 3.24 1.13 12.56.9 13.67a.722.722 0 01-.29.51.59.59 0 01-.43 0c-.65-.13-6.41-3.82-7-4.19a7.43 7.43 0 00-.22-3.59 6.397 6.397 0 00-3-3.76 2.654 2.654 0 00-1.59-.32 2.378 2.378 0 00-1 .36l-1.2-.77z"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M27.062 36.3a.65.65 0 010-.31l.1-7.63c0-.55 0-1.32.61-1.5.61-.18 1.85.72 2.07.84l3.95 2.11a11.392 11.392 0 013.09 2.13 8.388 8.388 0 012 4.85c.19 1.78.73 3.89.54 5.67a.77.77 0 01-.81.63 2.163 2.163 0 01-1-.41c-3.18-2-7.08-4.25-10.26-6.21a.866.866 0 01-.29-.17zm23.988-1.51a4.216 4.216 0 01-.57.74 5.44 5.44 0 01-.66.6c-.55.42-3 2-6.3 4a2.1 2.1 0 01-1.37.45h-.27a1.932 1.932 0 01-1-.52c0 .24.05.45.08.68v.36a.206.206 0 000-.07v-.06a.215.215 0 010-.08c0-.17 0-.33-.06-.5-.06-.17 0-.24 0-.36v-.31c-.2-1.64-.39-3.28-.59-4.91a1.662 1.662 0 01.08-1c.206-.42.563-.745 1-.91.7-.32 2.12-1.15 3.58-2l4.13 3.25c.1.08.68.52 1 .3.32-.22.28-.54.29-.83-.1-1.915-.34-3.82-.72-5.7a.5.5 0 01.38 0 .803.803 0 01.321.57c.5 2.77.61 4.75.73 6-.07.06-.06.19-.05.3z"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFFDD2",
    d: "M39.621 44.81v2.85l.73 1.65.95.09 3.65-2.11-.78-1.82-1.16-.66h-2a.99.99 0 01-.36 0c-.28-.08-.36-.26-.54-.27-.18-.01-.28-.04-.49.27zm10.599-.76l.24-2.7.66-1.55.85-1.66.14 4.7-1.89 1.21z"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M39.38 49.62l-.13 2c.337.4.811.66 1.33.73.353.005.7-.093 1-.28.88-.53 5.34-3.22 11.43-7 .31-.186.56-.456.72-.78.14-.275.21-.581.2-.89a1.852 1.852 0 00-.48-1.13l-.47.83-11.38 7-1.34.1-.88-.58z"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    fill: "#6784A8",
    d: "M43.012 44.81l1.09-.14 5.91-3.49.87-.82-.42 1-.24 2.7c-1 .65-2.07 1.3-3.12 1.94l-2.15 1.3-.78-1.82-1.16-.67zM50.3 33.54c0 .29 0 .67-.29.83-.29.16-.93-.22-1-.3l-4.13-3.25c1.71-1 3.45-2.16 4.09-2.62.103-.08.21-.153.32-.22a2.37 2.37 0 00.24-.09h.06c.374 1.864.612 3.752.71 5.65z"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M51.08 36.17c-.027.08-.06.156-.1.23l-.06.11c-.06.1-.13.194-.21.28l-.12.12c-1.273.76-2.56 1.54-3.86 2.34l-3.72 2.33a1.259 1.259 0 01-1.33.21 1.438 1.438 0 01-.7-.77v-.36c0-.23-.05-.44-.08-.68.275.269.623.45 1 .52.09.01.18.01.27 0a2.1 2.1 0 001.37-.45c3.32-2 5.75-3.53 6.3-4 .236-.181.457-.382.66-.6.217-.225.408-.473.57-.74.015.164.039.328.07.49a.655.655 0 010 .14c.056.277.035.564-.06.83z"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    fill: "#CCD9F0",
    d: "M31.53 44.59c.54 1.33.28 2.73-.58 3.13-.86.4-2-.36-2.54-1.68-.54-1.32-.28-2.73.59-3.13.87-.4 1.99.36 2.53 1.68zm-2-.41c-.4.18-.53.83-.27 1.45s.78 1 1.18.79c.4-.21.52-.84.27-1.46s-.8-.97-1.2-.78h.02z"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M32.94 43.95c1.09 2.66.56 5.47-1.17 6.28-1.73.81-4-.71-5.09-3.37-1.09-2.66-.56-5.48 1.17-6.28 1.73-.8 4.01.71 5.09 3.37zm-3.94-1c-.87.4-1.13 1.8-.59 3.13.54 1.33 1.68 2.08 2.54 1.68.86-.4 1.12-1.8.58-3.13-.54-1.33-1.67-2.12-2.53-1.72v.04z"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "#6382AA",
    d: "M30.378 46.434c.415-.15.567-.782.338-1.41-.228-.628-.75-1.015-1.165-.864-.416.151-.567.783-.338 1.41.228.629.75 1.015 1.165.864z"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M31.91 50.15l2.52-1.46-1.08-.63a4.924 4.924 0 01-1.44 2.09z"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    fill: "#CCD9F0",
    d: "M8.59 30.27c.54 1.33.28 2.73-.58 3.13-.86.4-2-.35-2.54-1.68s-.28-2.72.59-3.12c.87-.4 1.99.35 2.53 1.67zm-2-.41c-.4.18-.53.84-.27 1.46s.78 1 1.18.78c.4-.22.52-.84.27-1.46s-.8-.97-1.2-.78h.02z"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M10.001 29.63c1.09 2.67.56 5.48-1.17 6.28-1.73.8-4-.71-5.09-3.37-1.09-2.66-.56-5.48 1.17-6.28 1.73-.8 4.01.71 5.09 3.37zm-3.94-1c-.87.4-1.13 1.79-.59 3.12.54 1.33 1.68 2.08 2.54 1.68.86-.4 1.12-1.8.58-3.13-.54-1.33-1.67-2.1-2.53-1.7v.03z"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    fill: "#6382AA",
    d: "M7.435 32.11c.415-.151.566-.783.338-1.411-.229-.628-.75-1.015-1.166-.864-.415.151-.566.783-.338 1.411.229.628.75 1.015 1.166.864z"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M8.97 35.83L12.19 34l-1.65-1a4.922 4.922 0 01-.92 2.14c-.19.254-.407.485-.65.69zm35.311 9.18l5.82-3.47-.2 2.07-.31.45-3.85 2.37-.73-.11-.73-1.31z"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    fill: "#0E53FB",
    d: "M39.01 14.63l-12.75 7.44L0 6.21 12.9 0l26.11 14.63z"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M39.38 49.62l.84-.52 1 .3 5.8-3.41 5-3.15v-1.4l1.45.89a.788.788 0 010 .42.654.654 0 01-.44.41l-11.38 7c-.192.175-.44.278-.7.29a1.095 1.095 0 01-.64-.19l-.93-.64z"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFA840",
    d: "M36.83 43.95v.55l1.66 1v-.53l-1.66-1.02z"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M39.82 37.98v5l-1.34.85v-5l1.34-.85z"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M40.54 41.01l-.71.13-.67-.13v-.39l.69.1.69-.1v.39z"
  })));
}


//# sourceMappingURL=LorryFleetOwner.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/LorryTransportContractor.svg.js


var LorryTransportContractor_svg_path, LorryTransportContractor_svg_path2, LorryTransportContractor_svg_path3, LorryTransportContractor_svg_path4, LorryTransportContractor_svg_path5, LorryTransportContractor_svg_path6, LorryTransportContractor_svg_path7, LorryTransportContractor_svg_path8, LorryTransportContractor_svg_path9, LorryTransportContractor_svg_path10, LorryTransportContractor_svg_path11, LorryTransportContractor_svg_path12, LorryTransportContractor_svg_path13, LorryTransportContractor_svg_path14, LorryTransportContractor_svg_path15, LorryTransportContractor_svg_path16, LorryTransportContractor_svg_path17, LorryTransportContractor_svg_path18, LorryTransportContractor_svg_path19, LorryTransportContractor_svg_path20, LorryTransportContractor_svg_path21, LorryTransportContractor_svg_path22, LorryTransportContractor_svg_path23, LorryTransportContractor_svg_path24, LorryTransportContractor_svg_path25, LorryTransportContractor_svg_path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;

function LorryTransportContractor_svg_extends() { LorryTransportContractor_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return LorryTransportContractor_svg_extends.apply(this, arguments); }

function SvgLorryTransportContractor(props) {
  return /*#__PURE__*/react.createElement("svg", LorryTransportContractor_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    fill: "none",
    viewBox: "0 0 54 53"
  }, props), LorryTransportContractor_svg_path || (LorryTransportContractor_svg_path = /*#__PURE__*/react.createElement("path", {
    fill: "#0040BF",
    d: "M26.4 37.97v-.78L0 21.06V6.21l13.13 7.93 13.38 8c-.1 2.53-.17 5.15-.19 7.84-.02 2.69 0 5.38.07 8l.01-.01z"
  })), LorryTransportContractor_svg_path2 || (LorryTransportContractor_svg_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M51.83 29.51v5l-1.35.85v-5l1.35-.85z"
  })), LorryTransportContractor_svg_path3 || (LorryTransportContractor_svg_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M26.4 42.67l2.37-1.08-2.43-1.66.06 2.74z"
  })), LorryTransportContractor_svg_path4 || (LorryTransportContractor_svg_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M39 14.63l.06 15.31-12.66 8.04-.15-17.56L39 14.63z"
  })), LorryTransportContractor_svg_path5 || (LorryTransportContractor_svg_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#EEF5FE",
    d: "M26.83 25.34l11.57-6.85c.16-.059.33-.083.5-.07.197.027.385.1.55.21.38.26 3.88 2.35 8.73 5.25a7.295 7.295 0 012.11 2.62c.182.372.33.76.44 1.16.3 1.51.49 2.81.63 3.8.26 2 .39 3.64.49 5 0 .72.09 1.32.12 1.76l-1.09 2.14-.87.82-5.92 3.49-1.08.14-2.37-.08c0-.36-.07-.91-.14-1.6 0-.49-.06-.68-.09-1-.07-.83-.09-1.43-.1-1.77a33.948 33.948 0 00-.55-4.78 8.523 8.523 0 00-.36-1.39 7.154 7.154 0 00-1-1.85 8.73 8.73 0 00-2-1.86l-.44-.31a18.802 18.802 0 00-1.78-1.06c-.49-.26-1-.58-2-1.22 0 0-2.21-1.37-4.26-2.45a1.215 1.215 0 00-.4-.14 1.347 1.347 0 00-.69.04z"
  })), LorryTransportContractor_svg_path6 || (LorryTransportContractor_svg_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#004D82",
    d: "M26.4 37.19v.78C17.6 32.723 8.8 27.48 0 22.24v-1.18l26.4 16.13zm-.14-15.12L0 6.21l26.25 14.21c0 .57.01 1.1.01 1.65z"
  })), LorryTransportContractor_svg_path7 || (LorryTransportContractor_svg_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M26.4 42.67L0 26.93v-5.87l26.4 16.13v5.48z"
  })), LorryTransportContractor_svg_path8 || (LorryTransportContractor_svg_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#DAE5EF",
    d: "M26.33 39.93V38.6c-.11-3.54-.06-12.65.41-13.18.47-.53 1.68.24 2.15.51l5.39 3.18c1.371.64 2.61 1.532 3.65 2.63a8.62 8.62 0 011 1.48 10.486 10.486 0 011.18 4.8c.18 3.24 1.13 12.56.9 13.67a.77.77 0 01-.29.51.59.59 0 01-.43 0c-.65-.13-6.41-3.82-7-4.19a7.417 7.417 0 00-.22-3.59 6.397 6.397 0 00-3-3.76 2.652 2.652 0 00-1.59-.32c-.355.046-.696.17-1 .36l-1.15-.77z"
  })), LorryTransportContractor_svg_path9 || (LorryTransportContractor_svg_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M27.05 36.3a.56.56 0 01-.05-.31l.1-7.63c0-.55 0-1.32.61-1.5.61-.18 1.84.72 2.07.84l4 2.11a11.346 11.346 0 013.09 2.13 8.375 8.375 0 012 4.85c.19 1.78.73 3.89.54 5.67a.77.77 0 01-.809.63 2.242 2.242 0 01-1-.41c-3.31-2.02-7.2-4.26-10.39-6.26a1.589 1.589 0 01-.16-.12zm24-1.51a4.216 4.216 0 01-.57.74 5.44 5.44 0 01-.66.6c-.55.42-3 2-6.31 4a2.062 2.062 0 01-1.36.45h-.27a2.009 2.009 0 01-1-.52c0 .24.06.45.09.68v.36a.273.273 0 000-.07v-.06a.215.215 0 010-.08 4.235 4.235 0 01-.06-.5V39.72c-.2-1.64-.39-3.28-.59-4.91a1.654 1.654 0 01.08-1c.206-.42.563-.745 1-.91.7-.32 2.12-1.15 3.58-2l4.12 3.25c.11.08.69.52 1 .3.31-.22.28-.54.29-.83a37.69 37.69 0 00-.73-5.7.526.526 0 01.39 0 .793.793 0 01.32.57c.49 2.77.61 4.75.73 6-.07.06-.07.19-.05.3z"
  })), LorryTransportContractor_svg_path10 || (LorryTransportContractor_svg_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFFDD2",
    d: "M39.611 44.81v2.85l.74 1.65 1 .09 3.64-2.11-.77-1.82-1.16-.66h-2a.99.99 0 01-.36 0c-.28-.08-.36-.26-.54-.27-.18-.01-.33-.04-.55.27zm10.609-.76l.24-2.7.66-1.55.85-1.66.14 4.7-1.89 1.21z"
  })), LorryTransportContractor_svg_path11 || (LorryTransportContractor_svg_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M39.401 49.62l-.12 2c.337.4.811.66 1.33.73.354.005.7-.093 1-.28.88-.53 5.34-3.22 11.43-7 .31-.186.56-.456.72-.78.141-.275.21-.581.2-.89a1.846 1.846 0 00-.48-1.13l-.47.83-11.39 7-1.33.1-.89-.58z"
  })), LorryTransportContractor_svg_path12 || (LorryTransportContractor_svg_path12 = /*#__PURE__*/react.createElement("path", {
    fill: "#6784A8",
    d: "M43.01 44.81l1.08-.14 5.92-3.49.87-.82-.42 1-.24 2.7c-1 .65-2.07 1.3-3.13 1.94-.72.44-1.43.88-2.15 1.3l-.77-1.82-1.16-.67zm7.29-11.27c0 .29-.05.67-.29.83-.24.16-.93-.22-1-.3l-4.12-3.25c1.71-1 3.45-2.16 4.09-2.62.103-.08.21-.153.32-.22.082-.026.162-.056.24-.09.396 1.862.65 3.75.76 5.65z"
  })), LorryTransportContractor_svg_path13 || (LorryTransportContractor_svg_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M51.08 36.17c-.027.08-.06.156-.1.23l-.06.11a2.377 2.377 0 01-.21.28l-.12.12c-1.28.76-2.56 1.54-3.86 2.34l-3.72 2.33a1.255 1.255 0 01-1.329.21 1.379 1.379 0 01-.7-.77v-.36c0-.23-.05-.44-.09-.68.276.266.623.446 1 .52.09.011.18.011.27 0 .492.017.975-.142 1.36-.45 3.33-2 5.76-3.53 6.31-4 .236-.181.456-.382.66-.6.216-.225.408-.473.57-.74.014.164.038.328.07.49a.818.818 0 010 .14c.044.277.027.56-.05.83z"
  })), LorryTransportContractor_svg_path14 || (LorryTransportContractor_svg_path14 = /*#__PURE__*/react.createElement("path", {
    fill: "#CCD9F0",
    d: "M31.53 44.59c.54 1.33.28 2.73-.58 3.13-.86.4-2-.36-2.54-1.68-.54-1.32-.28-2.73.58-3.13.86-.4 2 .36 2.54 1.68zm-2-.41c-.41.18-.53.83-.28 1.45s.79 1 1.19.79c.4-.21.52-.84.27-1.46s-.8-.97-1.2-.78h.02z"
  })), LorryTransportContractor_svg_path15 || (LorryTransportContractor_svg_path15 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M32.94 43.95c1.09 2.66.56 5.47-1.17 6.28-1.73.81-4-.71-5.1-3.37-1.1-2.66-.55-5.48 1.18-6.28 1.73-.8 4.01.71 5.09 3.37zm-4-1c-.86.4-1.12 1.8-.58 3.13.54 1.33 1.67 2.08 2.54 1.68.87-.4 1.12-1.8.58-3.13-.54-1.33-1.62-2.12-2.49-1.72l-.05.04z"
  })), LorryTransportContractor_svg_path16 || (LorryTransportContractor_svg_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "#6382AA",
    d: "M30.384 46.427c.415-.151.566-.783.338-1.41-.229-.629-.75-1.015-1.166-.864-.415.15-.566.782-.338 1.41.229.628.75 1.015 1.166.864z"
  })), LorryTransportContractor_svg_path17 || (LorryTransportContractor_svg_path17 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M31.91 50.15l2.49-1.46-1-.63a4.744 4.744 0 01-.8 1.42c-.203.25-.435.474-.69.67z"
  })), LorryTransportContractor_svg_path18 || (LorryTransportContractor_svg_path18 = /*#__PURE__*/react.createElement("path", {
    fill: "#CCD9F0",
    d: "M8.591 30.27c.54 1.33.28 2.73-.58 3.13-.86.4-2-.35-2.54-1.68s-.28-2.72.58-3.12c.86-.4 2 .35 2.54 1.67zm-2-.41c-.4.18-.53.84-.27 1.46s.78 1 1.18.78c.4-.22.52-.84.27-1.46s-.8-.97-1.2-.78h.02z"
  })), LorryTransportContractor_svg_path19 || (LorryTransportContractor_svg_path19 = /*#__PURE__*/react.createElement("path", {
    fill: "#2E3D53",
    d: "M10 29.63c1.09 2.67.56 5.48-1.17 6.28-1.73.8-4-.71-5.1-3.37-1.1-2.66-.55-5.48 1.18-6.28 1.73-.8 4.01.71 5.09 3.37zm-3.95-1c-.86.4-1.12 1.79-.58 3.12.54 1.33 1.68 2.08 2.54 1.68.86-.4 1.12-1.8.58-3.13-.54-1.33-1.67-2.1-2.54-1.7v.03z"
  })), LorryTransportContractor_svg_path20 || (LorryTransportContractor_svg_path20 = /*#__PURE__*/react.createElement("path", {
    fill: "#6382AA",
    d: "M7.44 32.112c.416-.151.567-.783.339-1.41-.229-.629-.75-1.015-1.166-.864-.415.15-.566.782-.338 1.41.228.628.75 1.015 1.165.864z"
  })), LorryTransportContractor_svg_path21 || (LorryTransportContractor_svg_path21 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M8.97 35.83L12.19 34l-1.65-1a4.833 4.833 0 01-.93 2.14 3.706 3.706 0 01-.64.69zm35.311 9.18l5.82-3.47-.2 2.07-.31.45-3.85 2.37-.73-.11-.73-1.31z"
  })), LorryTransportContractor_svg_path22 || (LorryTransportContractor_svg_path22 = /*#__PURE__*/react.createElement("path", {
    fill: "#0E53FB",
    d: "M39 14.63l-12.74 7.44L0 6.21 12.9 0 39 14.63z"
  })), LorryTransportContractor_svg_path23 || (LorryTransportContractor_svg_path23 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M39.4 49.62l.85-.52 1 .3 5.79-3.41 5-3.15v-1.4l1.45.89a.788.788 0 010 .42.667.667 0 01-.44.41l-11.39 7a1.051 1.051 0 01-1.33.1l-.93-.64z"
  })), LorryTransportContractor_svg_path24 || (LorryTransportContractor_svg_path24 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFA840",
    d: "M36.82 43.95v.55l1.66 1v-.53l-1.66-1.02z"
  })), LorryTransportContractor_svg_path25 || (LorryTransportContractor_svg_path25 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M39.82 37.98v5l-1.34.85v-5l1.34-.85z"
  })), LorryTransportContractor_svg_path26 || (LorryTransportContractor_svg_path26 = /*#__PURE__*/react.createElement("path", {
    fill: "#232E3E",
    d: "M40.54 41.01l-.71.13-.67-.13v-.39l.69.1.69-.1v.39z"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#LorryTransportContractor_svg__paint0_linear)",
    d: "M14.34 33.52l-5.62-1.61-7.39 1.93 4.66 2.03 8.35-2.35z"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFBA55",
    d: "M6.04 36.67l-.05-.8-4.66-2.03v.03l.12 9.19 4.63 2.11-.04-8.5z"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    fill: "#DB8C00",
    d: "M14.34 33.55v-.03l-8.35 2.35.05.8.04 8.5 8.31-2.63-.05-8.99z"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M3.57 34.82h-.01l-.6-.26v.03l.08 1.09.01-.01.05.13.05-.08.04.12.06-.06.04.26.09-.15.05.12.07-.06.06.11.05-.12.05.15-.09-1.24v-.03z"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    fill: "#CF9558",
    d: "M10.81 32.51l-7.85 2.04v.01l.6.26h.01l7.99-2.09-.75-.22z"
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M1.33 33.84l4.66 2s-2.84-1.35-4.66-2zm4.8 1.99l8.12-2.28s-5.85 1.51-8.12 2.28zm-.09 9.25v-8.94s-.14 6.42 0 8.94z",
    opacity: 0.7
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#LorryTransportContractor_svg__paint1_linear)",
    d: "M21.251 36.36l-5.06-1.45-6.66 1.74 4.2 1.83 7.52-2.12z"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFBA55",
    d: "M13.781 39.19l-.05-.71-4.2-1.83v.03l.11 8.27 4.18 1.9-.04-7.66z"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    fill: "#DB8C00",
    d: "M21.25 36.39v-.03l-7.52 2.12.05.71.04 7.66 7.47-2.37-.04-8.09z"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M11.55 37.53l-.54-.24v.03l.06.99.01-.02.05.12.04-.07.04.11.05-.06.04.24.08-.14.05.11.06-.06.05.1.05-.1.04.14-.08-1.12v-.03z"
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    fill: "#CF9558",
    d: "M18.07 35.45l-7.06 1.84.54.24 7.2-1.89-.68-.19z"
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M9.531 36.65l4.2 1.83s-2.56-1.25-4.2-1.83zm4.33 1.77l7.31-2s-5.28 1.32-7.31 2zm-.081 8.35v-8.06s-.13 5.79 0 8.06z",
    opacity: 0.7
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#LorryTransportContractor_svg__paint2_linear)",
    d: "M17.921 31.44l-3.04-.88-4.01 1.05 2.53 1.1 4.52-1.27z"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFBA55",
    d: "M13.431 33.14l-.03-.43-2.53-1.1v.02l.07 4.97 2.51 1.14-.02-4.6z"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    fill: "#DB8C00",
    d: "M17.92 31.45v-.01l-4.52 1.27.03.43.02 4.6 4.5-1.42-.03-4.87z"
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M12.09 32.14l-.33-.14v.01l.04.6.01-.01.03.07.02-.04.02.06.04-.03.02.14.04-.08.03.06.04-.03.03.06.03-.06.03.08-.05-.68v-.01z"
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    fill: "#CF9558",
    d: "M16.01 30.89L11.76 32l.33.14L16.42 31l-.41-.11z"
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M10.871 31.61l2.53 1.1s-1.54-.75-2.53-1.1zm2.609 1.08l4.4-1.27s-3.18.85-4.4 1.27z",
    opacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "LorryTransportContractor_svg__paint0_linear",
    x1: 794.29,
    x2: 1002.61,
    y1: 955.144,
    y2: 943.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.14,
    stopColor: "#E5B785"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEAE79"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBA975"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.95,
    stopColor: "#D29C67"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#CE9662"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "LorryTransportContractor_svg__paint1_linear",
    x1: 822.079,
    x2: 991.056,
    y1: 878.108,
    y2: 868.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.14,
    stopColor: "#E5B785"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEAE79"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBA975"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.95,
    stopColor: "#D29C67"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#CE9662"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "LorryTransportContractor_svg__paint2_linear",
    x1: 506.345,
    x2: 567.503,
    y1: 523.663,
    y2: 520.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    offset: 0.14,
    stopColor: "#E5B785"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEAE79"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBA975"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 0.95,
    stopColor: "#D29C67"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#CE9662"
  })))));
}


//# sourceMappingURL=LorryTransportContractor.svg.js.map

;// CONCATENATED MODULE: ../core/dist/icons/LorryAgentBroker.svg.js


var LorryAgentBroker_svg_path, LorryAgentBroker_svg_path2, LorryAgentBroker_svg_path3, LorryAgentBroker_svg_path4, LorryAgentBroker_svg_path5, LorryAgentBroker_svg_path6, LorryAgentBroker_svg_path7, LorryAgentBroker_svg_path8, LorryAgentBroker_svg_path9, LorryAgentBroker_svg_path10, LorryAgentBroker_svg_path11, LorryAgentBroker_svg_path12, LorryAgentBroker_svg_path13, LorryAgentBroker_svg_path14, LorryAgentBroker_svg_path15, LorryAgentBroker_svg_path16, LorryAgentBroker_svg_path17, LorryAgentBroker_svg_path18, LorryAgentBroker_svg_path19, LorryAgentBroker_svg_path20, LorryAgentBroker_svg_path21, LorryAgentBroker_svg_path22, LorryAgentBroker_svg_path23, LorryAgentBroker_svg_path24, LorryAgentBroker_svg_path25, LorryAgentBroker_svg_path26, LorryAgentBroker_svg_path27, LorryAgentBroker_svg_path28, LorryAgentBroker_svg_path29, LorryAgentBroker_svg_path30, LorryAgentBroker_svg_path31, LorryAgentBroker_svg_path32, LorryAgentBroker_svg_path33, LorryAgentBroker_svg_path34, LorryAgentBroker_svg_path35, LorryAgentBroker_svg_path36, LorryAgentBroker_svg_path37, LorryAgentBroker_svg_path38, LorryAgentBroker_svg_path39, LorryAgentBroker_svg_path40, LorryAgentBroker_svg_path41, LorryAgentBroker_svg_path42, LorryAgentBroker_svg_path43, LorryAgentBroker_svg_path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;

function LorryAgentBroker_svg_extends() { LorryAgentBroker_svg_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return LorryAgentBroker_svg_extends.apply(this, arguments); }

function SvgLorryAgentBroker(props) {
  return /*#__PURE__*/react.createElement("svg", LorryAgentBroker_svg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 57,
    fill: "none",
    viewBox: "0 0 49 57"
  }, props), LorryAgentBroker_svg_path || (LorryAgentBroker_svg_path = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M9.767 51.585l-.4.3 19.71-48.18.4-.3-19.71 48.18z"
  })), LorryAgentBroker_svg_path2 || (LorryAgentBroker_svg_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#0E53FB",
    d: "M25.858 3.925l3.61-.54-19.73 48.06-9.26-41.48a1.87 1.87 0 011.35-2.39l3.61-.55c-.011.265.012.53.07.79l.28 1.24a2.703 2.703 0 002.8 2.25l16.18-2.38a2.276 2.276 0 001.502-1.128 2.29 2.29 0 00.138-1.872l-.27-1.24a3.302 3.302 0 00-.28-.76z"
  })), LorryAgentBroker_svg_path3 || (LorryAgentBroker_svg_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#0040BF",
    d: "M29.477 3.405c.253-.031.51-.01.753.063.245.072.472.193.667.357.445.365.755.868.88 1.43l4.23 18.9-13.28 2 5.54 24.7-16.2 2.46a1.894 1.894 0 01-1.34-.36 2.625 2.625 0 01-.93-1.37l19.68-48.18z"
  })), LorryAgentBroker_svg_path4 || (LorryAgentBroker_svg_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#FAFAFA",
    d: "M30.168 5.355l9.51 40.15-28.07 3.94-9.51-40.15 28.07-3.94z"
  })), LorryAgentBroker_svg_path5 || (LorryAgentBroker_svg_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M26.408 5.955l-.39.3-20.62 3.13.39-.3 20.62-3.13z"
  })), LorryAgentBroker_svg_path6 || (LorryAgentBroker_svg_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#3E5166",
    d: "M9.367 4.605l-.39.29a3.375 3.375 0 011.59-3.11l.39-.29a3.401 3.401 0 00-1.59 3.11z"
  })), LorryAgentBroker_svg_path7 || (LorryAgentBroker_svg_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#2B3D51",
    d: "M24.767 8.875l-.4.3-16.17 2.46.39-.3 16.18-2.46z"
  })), LorryAgentBroker_svg_path8 || (LorryAgentBroker_svg_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M24.767 8.875l-.4.3-16.17 2.46.39-.3 16.18-2.46z"
  })), LorryAgentBroker_svg_path9 || (LorryAgentBroker_svg_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#3E5166",
    d: "M5.507 7.845l-.39.3a3.134 3.134 0 01-.07-.79 2.328 2.328 0 01.87-1.77l.39-.29a2.326 2.326 0 00-.869 1.76c-.012.265.012.53.07.79z"
  })), LorryAgentBroker_svg_path10 || (LorryAgentBroker_svg_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#3D4F64",
    d: "M5.787 9.085l-.39.3-.28-1.24.39-.3.28 1.24z"
  })), LorryAgentBroker_svg_path11 || (LorryAgentBroker_svg_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#2C3F54",
    d: "M8.587 11.335l-.39.3a2.701 2.701 0 01-2.81-2.25l.4-.3a2.703 2.703 0 002.8 2.25z"
  })), LorryAgentBroker_svg_path12 || (LorryAgentBroker_svg_path12 = /*#__PURE__*/react.createElement("path", {
    fill: "#3E5166",
    d: "M8.587 11.335l-.39.3a2.701 2.701 0 01-2.81-2.25l.4-.3a2.703 2.703 0 002.8 2.25z"
  })), LorryAgentBroker_svg_path13 || (LorryAgentBroker_svg_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M.477 9.995l-.4.3a1.998 1.998 0 01.66-2.1l.39-.3a2.002 2.002 0 00-.65 2.1z"
  })), LorryAgentBroker_svg_path14 || (LorryAgentBroker_svg_path14 = /*#__PURE__*/react.createElement("path", {
    fill: "#53789F",
    d: "M5.787 9.085l20.62-3.16a2.26 2.26 0 01-.139 1.872c-.155.284-.37.532-.628.727-.26.194-.557.33-.873.4l-16.18 2.46a2.694 2.694 0 01-1.843-.61 2.704 2.704 0 01-.957-1.69z"
  })), LorryAgentBroker_svg_path15 || (LorryAgentBroker_svg_path15 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M28.238 50.855l-.4.3-16.19 2.46.39-.3 16.2-2.46zm-16.201 2.46l-.39.3a1.882 1.882 0 01-1.34-.36l.39-.3c.385.285.864.414 1.34.36zm-2.299-1.84l-.4.3-9.26-41.48.4-.29 9.26 41.47zm.959 1.45l-.39.3a2.672 2.672 0 01-.94-1.37l.4-.3c.155.545.48 1.025.93 1.37z"
  })), LorryAgentBroker_svg_path16 || (LorryAgentBroker_svg_path16 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M10.517 52.815l-.39.3a2.524 2.524 0 01-.76-1.23l.4-.3c.122.476.383.904.75 1.23z"
  })), LorryAgentBroker_svg_path17 || (LorryAgentBroker_svg_path17 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M10.517 52.815l-.39.3a2.524 2.524 0 01-.76-1.23l.4-.3c.122.476.383.904.75 1.23z"
  })), LorryAgentBroker_svg_path18 || (LorryAgentBroker_svg_path18 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M10.518 52.815a2.448 2.448 0 01-.75-1.23c.124.474.385.902.75 1.23z"
  })), LorryAgentBroker_svg_path19 || (LorryAgentBroker_svg_path19 = /*#__PURE__*/react.createElement("path", {
    fill: "#6382AA",
    d: "M14.448.105c3.16-.48 6.08.73 6.68 2.71l2.21-.33a2.525 2.525 0 011.488.32c.451.259.812.65 1.032 1.12.125.24.218.496.28.76l.27 1.24-20.62 3.13a2.7 2.7 0 002.8 2.25l16.18-2.38a2.28 2.28 0 001.502-1.127 2.267 2.267 0 00-1.502 1.127l-16.18 2.46a2.697 2.697 0 01-2.8-2.25l-.28-1.24a3.134 3.134 0 01-.07-.79 2.138 2.138 0 011.72-2.18l2.21-.33c-.29-2.02 1.9-4.01 5.08-4.49z"
  })), LorryAgentBroker_svg_path20 || (LorryAgentBroker_svg_path20 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFBA55",
    d: "M7.867 19.615a16 16 0 015.68 5.72 31.55 31.55 0 012.55-3.65 59.905 59.905 0 015.26-5.44c.84-.83 2.14-2.11 3.74-3.72a27.193 27.193 0 00-5.21 3 27.613 27.613 0 00-6.44 6.57 5.434 5.434 0 00-5.58-2.43v-.05zm2.94 9.38a16.238 16.238 0 012.8 2.1c1.13 1.06 2.1 2.28 2.88 3.62a32.317 32.317 0 012.55-3.65 64.417 64.417 0 015.23-5.44c.85-.83 2.14-2.11 3.74-3.71a27.058 27.058 0 00-5.21 3 27.409 27.409 0 00-6.44 6.57 5.453 5.453 0 00-1.85-1.79 5.683 5.683 0 00-3.7-.7zm2.9 9.3a15.861 15.861 0 015.69 5.72 32.317 32.317 0 012.55-3.65 62.275 62.275 0 015.25-5.44c.85-.83 2.15-2.11 3.75-3.71a26.66 26.66 0 00-5.21 2.95 27.061 27.061 0 00-6.47 6.57 5.524 5.524 0 00-1.82-1.81 5.705 5.705 0 00-3.74-.63z"
  })), LorryAgentBroker_svg_path21 || (LorryAgentBroker_svg_path21 = /*#__PURE__*/react.createElement("path", {
    fill: "#FAB753",
    d: "M30.918 3.845z"
  })), LorryAgentBroker_svg_path22 || (LorryAgentBroker_svg_path22 = /*#__PURE__*/react.createElement("path", {
    fill: "#587981",
    d: "M39.747 27.795l-.39.3 1.67-4.47.39-.29-1.67 4.46z"
  })), LorryAgentBroker_svg_path23 || (LorryAgentBroker_svg_path23 = /*#__PURE__*/react.createElement("path", {
    fill: "#747F82",
    d: "M39.747 27.795l-.39.3-.06-.27.39-.3.06.27z"
  })), LorryAgentBroker_svg_path24 || (LorryAgentBroker_svg_path24 = /*#__PURE__*/react.createElement("path", {
    fill: "#597A82",
    d: "M40.007 28.965l-.39.3-.26-1.17.39-.3.26 1.17z"
  })), LorryAgentBroker_svg_path25 || (LorryAgentBroker_svg_path25 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M40.007 28.965l-.39.3-.74.11.4-.3.73-.11z"
  })), LorryAgentBroker_svg_path26 || (LorryAgentBroker_svg_path26 = /*#__PURE__*/react.createElement("path", {
    fill: "#2C3F54",
    d: "M25.617 8.525l-.4.29c-.247.192-.54.316-.85.36l.4-.3c.308-.045.6-.166.85-.35z"
  })), LorryAgentBroker_svg_path27 || (LorryAgentBroker_svg_path27 = /*#__PURE__*/react.createElement("path", {
    fill: "#3E5166",
    d: "M25.617 8.525l-.4.29c-.247.192-.54.316-.85.36l.4-.3c.308-.045.6-.166.85-.35z"
  })), LorryAgentBroker_svg_path28 || (LorryAgentBroker_svg_path28 = /*#__PURE__*/react.createElement("path", {
    fill: "#597A82",
    d: "M41.257 34.565l-.39.29-.32-1.42.4-.3.31 1.43zm1.26 5.6l-.4.3-.32-1.44.4-.3.32 1.44z"
  })), LorryAgentBroker_svg_path29 || (LorryAgentBroker_svg_path29 = /*#__PURE__*/react.createElement("path", {
    fill: "#577880",
    d: "M40.948 33.135l-.4.3-3.38.51.4-.3 3.38-.51z"
  })), LorryAgentBroker_svg_path30 || (LorryAgentBroker_svg_path30 = /*#__PURE__*/react.createElement("path", {
    fill: "#587981",
    d: "M37.568 33.645l-.4.3 1.71-4.57.4-.3-1.71 4.57z"
  })), LorryAgentBroker_svg_path31 || (LorryAgentBroker_svg_path31 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M41.258 34.565l-.39.29-4.28.65.39-.3 4.28-.64z"
  })), LorryAgentBroker_svg_path32 || (LorryAgentBroker_svg_path32 = /*#__PURE__*/react.createElement("path", {
    fill: "#597A82",
    d: "M43.767 45.765l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), LorryAgentBroker_svg_path33 || (LorryAgentBroker_svg_path33 = /*#__PURE__*/react.createElement("path", {
    fill: "#587981",
    d: "M35.277 39.775l-.4.3 1.71-4.57.39-.3-1.7 4.57z"
  })), LorryAgentBroker_svg_path34 || (LorryAgentBroker_svg_path34 = /*#__PURE__*/react.createElement("path", {
    fill: "#577880",
    d: "M42.197 38.725l-.4.3-6.92 1.05.4-.3 6.92-1.05z"
  })), LorryAgentBroker_svg_path35 || (LorryAgentBroker_svg_path35 = /*#__PURE__*/react.createElement("path", {
    fill: "#597A82",
    d: "M42.068 51.815l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), LorryAgentBroker_svg_path36 || (LorryAgentBroker_svg_path36 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M42.517 40.165l-.4.3-7.83 1.19.4-.3 7.83-1.19z"
  })), LorryAgentBroker_svg_path37 || (LorryAgentBroker_svg_path37 = /*#__PURE__*/react.createElement("path", {
    fill: "#727D80",
    d: "M39.688 27.525l-.39.3-13.54 2.05.4-.29 13.53-2.06z"
  })), LorryAgentBroker_svg_path38 || (LorryAgentBroker_svg_path38 = /*#__PURE__*/react.createElement("path", {
    fill: "#3D4F64",
    d: "M26.478 31.015l-.4.3-.32-1.44.4-.29.32 1.43z"
  })), LorryAgentBroker_svg_path39 || (LorryAgentBroker_svg_path39 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M39.278 29.075l-.4.3-12.8 1.94.4-.3 12.8-1.94zm-2.3 6.13l-.39.3-9.26 1.41.4-.3 9.25-1.41zm6.79 10.56l-.4.3-11.37 1.73.39-.3 11.38-1.73z"
  })), LorryAgentBroker_svg_path40 || (LorryAgentBroker_svg_path40 = /*#__PURE__*/react.createElement("path", {
    fill: "#587981",
    d: "M32.978 45.925l-.4.3 1.71-4.57.4-.3-1.71 4.57z"
  })), LorryAgentBroker_svg_path41 || (LorryAgentBroker_svg_path41 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M34.688 41.355l-.4.3-5.71.86.4-.3 5.71-.86z"
  })), LorryAgentBroker_svg_path42 || (LorryAgentBroker_svg_path42 = /*#__PURE__*/react.createElement("path", {
    fill: "#577880",
    d: "M41.748 50.385l-.4.3-7.62 1.16.39-.3 7.63-1.16z"
  })), LorryAgentBroker_svg_path43 || (LorryAgentBroker_svg_path43 = /*#__PURE__*/react.createElement("path", {
    fill: "#3D4F64",
    d: "M34.438 52.975l-.4.29-.31-1.42.39-.3.32 1.43z"
  })), LorryAgentBroker_svg_path44 || (LorryAgentBroker_svg_path44 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M42.067 51.815l-.4.3-7.63 1.15.4-.29 7.63-1.16z"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    fill: "#587981",
    d: "M29.318 55.705l-.39.3 3.07-8.21.39-.3-3.07 8.21z"
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    fill: "#577880",
    d: "M48.018 52.865l-.4.3-18.69 2.84.39-.3 18.7-2.84z"
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    fill: "#747F82",
    d: "M29.318 55.705l-.39.3-1.09-4.85.4-.3 1.08 4.85z"
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    fill: "#00334F",
    d: "M36.008 24.155l-.4.3-13.28 2.01.4-.3 13.28-2.01z"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    fill: "#727D80",
    d: "M37.568 33.645l-.4.3-10.16 1.54.4-.3 10.16-1.54z"
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    fill: "#3D4F64",
    d: "M27.728 36.615l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    fill: "#577880",
    d: "M43.448 44.335l-.4.3-10.47 1.59.4-.3 10.47-1.59z"
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    fill: "#727D80",
    d: "M35.278 39.775l-.4.3-6.62 1.01.4-.3 6.62-1.01z"
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    fill: "#3D4F64",
    d: "M28.978 42.215l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    fill: "#727D80",
    d: "M32.978 45.925l-.4.3-3.07.46.4-.3 3.07-.46z"
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    fill: "#3C4E62",
    d: "M32.388 47.495l-.39.3-2.17.33.4-.3 2.16-.33z"
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    fill: "#3D4F64",
    d: "M30.228 47.825l-.4.3-.32-1.44.4-.3.32 1.44z"
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    fill: "#B8E6FF",
    d: "M41.419 23.335l-1.67 4.46-.06-.27-13.53 2.06.32 1.43 12.8-1.94-1.71 4.57-10.16 1.54.32 1.43 9.25-1.41-1.7 4.57-6.62 1.01.32 1.43 5.71-.86-1.71 4.57-3.07.46.32 1.44 2.16-.33-3.07 8.21-1.08-4.85-5.51-24.69 13.28-2.01 5.41-.82z"
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    fill: "#97DDFC",
    d: "M41.418 23.335l-1.67 4.46.26 1.17-.73.11-1.71 4.57 3.38-.51.31 1.42-4.28.65-1.71 4.57 6.91-1 .33 1.44-7.83 1.19-1.7 4.52 10.47-1.59.32 1.44-11.38 1.72-3.07 8.21 18.7-2.84-6.6-29.53zm-7 29.64l-.32-1.43 7.63-1.16.32 1.43-7.63 1.16z"
  })), _path59 || (_path59 = /*#__PURE__*/react.createElement("path", {
    fill: "#7698C0",
    d: "M39.688 27.525l.06.27.26 1.17-.73.11-12.8 1.94-.32-1.43 13.53-2.06zm1.26 5.61l.31 1.43-4.28.64-9.25 1.41-.32-1.43 10.16-1.54 3.38-.51zm1.25 5.59l.32 1.44-7.83 1.19-5.71.86-.32-1.43 6.62-1.01 6.92-1.05zm-.451 11.66l.32 1.43-7.63 1.16-.32-1.43 7.63-1.16zm1.701-6.05l.32 1.43-11.38 1.73-2.16.33-.32-1.44 3.07-.46 10.47-1.59z"
  })), _path60 || (_path60 = /*#__PURE__*/react.createElement("path", {
    fill: "#747F82",
    d: "M28.238 50.855l-.4.3-5.51-24.69.4-.3 5.51 24.69z"
  })), _path61 || (_path61 = /*#__PURE__*/react.createElement("path", {
    fill: "#00324E",
    d: "M12.848 16.925a2.37 2.37 0 012.51 1.83l1.27 5a1.842 1.842 0 01-.178 1.536 1.844 1.844 0 01-1.282.864l-4.72.66a2.371 2.371 0 01-2.52-1.83l-1.27-5a1.859 1.859 0 01-.08-.787 1.852 1.852 0 011.54-1.613l4.73-.66zm2.89 7l-1.27-5a1.317 1.317 0 00-1.391-1l-4.72.67a.991.991 0 00-.717.468.991.991 0 00-.092.852l1.27 5a1.336 1.336 0 001.39 1l4.72-.67a.996.996 0 00.718-.468 1.006 1.006 0 00.092-.852zm-.011 2.62a2.385 2.385 0 012.54 1.84l1.27 5a1.832 1.832 0 01-.179 1.531 1.83 1.83 0 01-1.281.859l-4.73.67a2.392 2.392 0 01-2.51-1.84l-1.27-5a1.856 1.856 0 01.182-1.533c.139-.228.325-.423.545-.573.22-.15.47-.25.733-.294l4.7-.66zm2.9 7l-1.27-5a1.317 1.317 0 00-1.391-1l-4.72.66a.991.991 0 00-.41.153 1.001 1.001 0 00-.399 1.167l1.27 5a1.31 1.31 0 001.389 1l4.72-.66a1.006 1.006 0 00.864-.892.988.988 0 00-.053-.438m.152 2.61a2.385 2.385 0 012.49 1.83l1.27 5a1.877 1.877 0 01-.186 1.536 1.862 1.862 0 01-1.284.864l-4.72.66a2.386 2.386 0 01-2.52-1.83l-1.26-5a1.843 1.843 0 01.718-2.099c.22-.149.47-.248.731-.291l4.76-.67zm2.89 7l-1.26-5a1.338 1.338 0 00-1.4-1l-4.72.67a1 1 0 00-.81 1.32l1.27 5a1.334 1.334 0 001.39 1l4.72-.67a1 1 0 00.809-1.32z"
  })));
}


//# sourceMappingURL=LorryAgentBroker.svg.js.map

;// CONCATENATED MODULE: ../core/dist/constants/ServiceType.js





// Assets
const SERVICE_TYPE_OPTIONS = [
    {
        label: "I am a Shipper/Load Owner",
        value: "Shipper",
        description: "I have loads and I am searching for trucks",
        icon: SvgLoads
    },
    {
        label: "I am a Lorry Owner/Driver",
        value: "Fleet Owner",
        description: "I have truck(s) and I am looking for loads",
        icon: SvgLorryFleetOwner
    },
    {
        label: "I own/work for a Transport company",
        value: "Transport Contractor",
        description: "I am searching for both loads and lorries",
        icon: SvgLorryTransportContractor
    },
    {
        label: "I am an Agent/Broker",
        value: "Agent/Broker",
        description: "I don’t own loads or lorries but I act as a dealer between load and lorry owner",
        icon: SvgLorryAgentBroker
    }
];


//# sourceMappingURL=ServiceType.js.map


/***/ }),

/***/ 52224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t4": function() { return /* binding */ STATE_LIST; }
/* harmony export */ });
/* unused harmony exports STATE_ID_LIST, STATE_ID_LIST_NOT_FOR_TESTING, TEST_LOAD_STATE_ID */
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);


const STATE_LIST = [
    {
        id: 1,
        name: "Maharashtra",
        code: "MH",
        zone_id: 3,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/gateway_of_india_maharashtra_uggur8.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Maharashtra_ljdbv8.png`
    },
    {
        id: 2,
        name: "Delhi",
        code: "DL",
        zone_id: 1,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/lotus_temple_delhi_x7ahtk.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Delhi_fi1lnq.png`
    },
    {
        id: 3,
        name: "Karnataka",
        code: "KA",
        zone_id: 2,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/hampi_karnataka_j5avow.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Karnataka_ugrakh.png`
    },
    {
        id: 4,
        name: "Gujarat",
        code: "GJ",
        zone_id: 3,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/somanath_mandir_gujarat_m25axk.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Gujarat_ndcfp6.png`
    },
    {
        id: 5,
        name: "Telangana",
        code: "TG",
        zone_id: 2,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/charminar_telangana_trcbch.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Telangana_cl2zms.png`
    },
    {
        id: 6,
        name: "Tamil Nadu",
        code: "TN",
        zone_id: 2,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/mahabalipuram_temple_tamil_nadu_edplkn.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Tamil_Nadu_tu0b8o.png`
    },
    {
        id: 7,
        name: "West Bengal",
        code: "WB",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/victoria_palace_west_bengal_lragc4.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/West_Bengal_ilwmiz.png`
    },
    {
        id: 8,
        name: "Rajasthan",
        code: "RJ",
        zone_id: 3,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/hawa_mahal_rajasthan_nlqzlw.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Rajasthan_r2o6wp.png`
    },
    {
        id: 9,
        name: "Uttar Pradesh",
        code: "UP",
        zone_id: 3,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/taj_mahal_up_gckaue.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Uttar_Pradesh_jcmp3s.png`
    },
    {
        id: 10,
        name: "Bihar",
        code: "BR",
        zone_id: 5,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/bodh_gaya_bihar_wrpijx.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Bihar_hq1tz7.png`
    },
    {
        id: 11,
        name: "Madhya Pradesh",
        code: "MP",
        zone_id: 3,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/khajurao_mp_nigqvq.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Madhya_Pradesh_qbxzbx.png`
    },
    {
        id: 12,
        name: "Andhra Pradesh",
        code: "AP",
        zone_id: 2,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/srikodandaramaswamy_temple_vontimitta_andhra_pradesh_wezot0.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Andhra_Pradesh_fixb1v.png`
    },
    {
        id: 13,
        name: "Punjab",
        code: "PB",
        zone_id: 1,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/golden_temple_punjab_c9xnol.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Punjab_rufdm3.png`
    },
    {
        id: 14,
        name: "Haryana",
        code: "HR",
        zone_id: 1,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/sheikh_chilli_tomb_haryana_yztrpx.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Haryana_q4x7jr.png`
    },
    {
        id: 15,
        name: "Jammu And Kashmir",
        code: "JK",
        zone_id: 1,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Jammu_and_Kashmir_fptocu.png`
    },
    {
        id: 16,
        name: "Jharkhand",
        code: "JH",
        zone_id: 5,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/maluti_temples_jharkhand_rp5xya.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Jharkhand_tdz22q.png`
    },
    {
        id: 17,
        name: "Chhattisgarh",
        code: "CG",
        zone_id: 5,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/laxmantemple_sirpur_chhattisgarh_hzdam6.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Chhattisgarh_xou0vi.png`
    },
    {
        id: 18,
        name: "Assam",
        code: "AS",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/rangghar_assam_aexuir.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Assam_dgwsoi.png`
    },
    {
        id: 19,
        name: "Chandigarh",
        code: "Chandigarh",
        zone_id: 1,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Chandigarh_xpar8t.png`
    },
    {
        id: 20,
        name: "Odisha",
        code: "OD",
        zone_id: 5,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/konark_odisha_y68uv5.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Odisha_vlowwp.png`
    },
    {
        id: 21,
        name: "Kerala",
        code: "KL",
        zone_id: 2,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/kerala_ylkqkv.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Kerala_jlzpix.png`
    },
    {
        id: 22,
        name: "Uttarakhand",
        code: "UK",
        zone_id: 1,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/kedarnath_uttarakhand_yslyna.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Uttarakhand_kwgsxe.png`
    },
    {
        id: 23,
        name: "Puducherry",
        code: "PY",
        zone_id: 2,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Puducherry_warals.png`
    },
    {
        id: 24,
        name: "Tripura",
        code: "TR",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/rabdentse_palace_sikkim_lfxcam.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Tripura_mcjota.png`
    },
    {
        id: 25,
        name: "Mizoram",
        code: "MZ",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/aizawl_mizoram_xexevq.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Mizoram_tnzij9.png`
    },
    {
        id: 26,
        name: "Meghalaya",
        code: "ML",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Meghalaya_ccenvn.png`
    },
    {
        id: 27,
        name: "Manipur",
        code: "MN",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/kangla_fort_manipur_n047zh.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Manipur_wpj3sb.png`
    },
    {
        id: 28,
        name: "Himachal Pradesh",
        code: "HP",
        zone_id: 1,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/rashtrapati_niwas_shimla_himachal_pradesh_hxoiur.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Himachal_Pradesh_ylfxgz.png`
    },
    {
        id: 29,
        name: "Nagaland",
        code: "NL",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/kohima_cemetery_nagaland_awuzdd.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Nagaland_cdvqsn.png`
    },
    {
        id: 30,
        name: "Goa",
        code: "GA",
        zone_id: 2,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/bom_jesus_basilica_goa_blczvz.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Goa_hu1cwh.png`
    },
    {
        id: 31,
        name: "Andaman And Nicobar Islands",
        code: "AN",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Andaman_Nicobar_Islands_glqjjl.png`
    },
    {
        id: 32,
        name: "Arunachal Pradesh",
        code: "AR",
        zone_id: 4,
        state_cover_image: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/tawang_monastery_arunachal_pradesh_wj8aes.png`,
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Arunachal_Pradesh_e8zcuo.png`
    },
    {
        id: 33,
        name: "Dadra and Nagar Haveli and Daman and Diu",
        code: "DN",
        zone_id: 3,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Daman_Diu_pashu2.png`
    },
    {
        id: 34,
        name: "North Eastern",
        code: "NE",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Ladakh_hywqz4.png`
    },
    {
        id: 35,
        name: "Sikkim",
        code: "SK",
        zone_id: 4,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Sikkim.png`
    },
    {
        id: 36,
        name: "Ladakh",
        code: "LA",
        zone_id: 1,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Himachal_Pradesh_ylfxgz.png`
    },
    {
        id: 37,
        name: "Lakshadweep",
        code: "LD",
        zone_id: 2,
        state_cover_image: "",
        state_icon: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Andaman_Nicobar_Islands_glqjjl.png`
    }
];
const STATE_ID_LIST = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
    32, 33, 34, 35, 36, 37
];
const TEST_LOAD_STATE_ID = 31;
const STATE_ID_LIST_NOT_FOR_TESTING = STATE_ID_LIST.filter((st) => ![31].includes(st));


//# sourceMappingURL=StateList.js.map


/***/ }),

/***/ 22391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ ScreenId; }
/* harmony export */ });
/* unused harmony export ScreenNameMap */
//FulfillmentScreenIds + PostPlacementScreenIds merged into ScreenId
var ScreenId;
(function (ScreenId) {
    ScreenId["none"] = "none";
    // Fulfillment
    ScreenId["fullFillmentTicketSystem"] = "full-fulfillment-ticket-system";
    ScreenId["loadVerification"] = "load-verification";
    ScreenId["loadVerificationAdmin"] = "verification-admin";
    ScreenId["loadFulfillment"] = "load-fulfillment";
    ScreenId["assuredLoads"] = "load-assured-list";
    ScreenId["bidsWithDepositLead"] = "bids-with-deposit-lead";
    // Post Placement
    ScreenId["ppTicketSystem"] = "post-placement-ticket-system";
    ScreenId["ppAllLoad"] = "pp-all-load";
    ScreenId["ppPlacement"] = "pp-placement";
    ScreenId["ppLoading"] = "pp-loading";
    ScreenId["ppUnloading"] = "pp-unloading";
    ScreenId["ppCompleted"] = "pp-completed";
    ScreenId["ppCancelled"] = "pp-cancelled";
    // Others
    ScreenId["executives"] = "executives";
    ScreenId["allUsers"] = "all-users";
    ScreenId["userRoles"] = "user-roles";
    ScreenId["userAttendance"] = "cs-attendance";
    ScreenId["agentStatus"] = "agent-status";
    ScreenId["admin"] = "admin";
    ScreenId["customer"] = "customer";
    ScreenId["trackScreen"] = "track-screen";
    ScreenId["ticketSystem"] = "ticket-system";
    ScreenId["tsm"] = "tsm";
    ScreenId["loadEnquiryCards"] = "load-enquiry-cards";
    ScreenId["lorryEnquiryCards"] = "lorry-enquiry-cards";
    ScreenId["customerProfile"] = "customer-profile";
    ScreenId["customerLorries"] = "customer-lorries";
    ScreenId["customerMarketplace"] = "customer-marketplace";
    ScreenId["myLoads"] = "myloads";
    ScreenId["myLorries"] = "mylorries";
    ScreenId["bulkLoad"] = "bulk-load";
    ScreenId["paymentList"] = "payment-list";
    ScreenId["aadhaarVerification"] = "aadhaar-verification";
    ScreenId["panVerification"] = "pan-verification";
    ScreenId["ewayVerification"] = "eway-verification";
    ScreenId["businessVerification"] = "business-verification";
    ScreenId["rcVerification"] = "rc-verification";
    ScreenId["callMeBack"] = "call-me-back";
    ScreenId["membershipCallMeBack"] = "membership-call-me-back";
    ScreenId["loadPostSupport"] = "load-post-support";
    ScreenId["intransitCallMeBack"] = "intransit-call-me-back";
    ScreenId["refundRequest"] = "refund-request";
    ScreenId["cashbackStatus"] = "cashback-status";
    ScreenId["bidCancellation"] = "bid-cancellation";
    ScreenId["sendWhatsappMsg"] = "send-whatsapp-msg";
    ScreenId["blockUsers"] = "block-users";
    ScreenId["companyRegistrationLeads"] = "company-registration-leads";
    ScreenId["adsLeads"] = "ads-leads";
    ScreenId["companyDlVerification"] = "company-dl-verification";
    //TSO Common
    ScreenId["myReferrals"] = "my-referrals";
    ScreenId["newReferrals"] = "new-referrals";
    ScreenId["bulkTagging"] = "bulk-tagging";
    //TSO Load
    ScreenId["tsoLoadUser"] = "tsoLoadUser";
    ScreenId["tsoActiveLoadsPage"] = "tsoActiveLoadsPage";
    ScreenId["tsoInTransitLoadPage"] = "tsoInTransitLoadPage";
    ScreenId["tsoLoadEnquiryCard"] = "tsoLoadEnquiryCard";
    ScreenId["tsoLoadMarketPlace"] = "tso-load-marketplace";
    //TSO Lorry
    ScreenId["tsoLorryUser"] = "tsoLorryUser";
    ScreenId["tsoActiveLorryPage"] = "tsoActiveLorryPage";
    ScreenId["tsoInTransitLorryPage"] = "tsoInTransitLorryPage";
    ScreenId["tsoLorryEnquiryCard"] = "tsoLorryEnquiryCard";
    ScreenId["tsoLorryMarketPlace"] = "tso-lorry-marketplace";
    ScreenId["assuredAndSpotLoads"] = "assured-and-spot-loads";
    // Ticket System
    ScreenId["vasLeads"] = "vas-leads";
    ScreenId["help"] = "help";
    ScreenId["accountDeletion"] = "account-deletion";
    //Report groups
    ScreenId["reportSystem"] = "reportSystem";
    ScreenId["membershipReportSystem"] = "membershipReportSystem";
    ScreenId["cargoInsuranceReportSystem"] = "cargoInsuranceReportSystem";
    ScreenId["realTimeTransaction"] = "realTimeTransaction";
    ScreenId["tapNGoDepositRecord"] = "tapNGoDepositRecord";
    ScreenId["membershipPurchasedRecord"] = "membershipPurchasedRecord";
    ScreenId["membershipLead"] = "membershipLead";
    ScreenId["membershipLeadHistory"] = "membershipLeadHistory";
    ScreenId["cargoInsuranceLead"] = "cargoInsuranceLead";
    ScreenId["cargoInsuranceLeadHistory"] = "cargoInsuranceLeadHistory";
    // TSO New Screen
    ScreenId["tsoLeadSubmit"] = "tso-lead-submit";
    ScreenId["tsoLeadHistory"] = "tso-lead-history";
    ScreenId["tsoMyTaggedUser"] = "tso-my-tagged-users";
    // TSO new Screen For Admin
    ScreenId["tsoAdminScreens"] = "tso-admin";
    ScreenId["tsoAdminSessionsPage"] = "tso-admin-sessions";
    ScreenId["tsoAdminLeadsPage"] = "tso-admin-leads";
    ScreenId["tsoAdminLeadsDetailPage"] = "tso-admin-leads-details";
})(ScreenId || (ScreenId = {}));
/** Display names for Post Placement ticket screens (nav / page titles). */
const ScreenNameMap = {
    [ScreenId.ppAllLoad]: "PP All Loads",
    [ScreenId.ppPlacement]: "PP Placement",
    [ScreenId.ppLoading]: "PP Loading",
    [ScreenId.ppUnloading]: "PP Unloading",
    [ScreenId.ppCompleted]: "PP Completed",
    [ScreenId.ppCancelled]: "PP Cancelled"
};


//# sourceMappingURL=screenId.js.map


/***/ }),

/***/ 24966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": function() { return /* binding */ ApiKeyFilterToBooleanMap; },
/* harmony export */   "Yr": function() { return /* binding */ ApiKeyFilter; },
/* harmony export */   "jt": function() { return /* binding */ NoSuccessErrorHandler; },
/* harmony export */   "wU": function() { return /* binding */ API_REQUEST_TYPE; }
/* harmony export */ });
const NoSuccessErrorHandler = {
    onSuccess: () => { },
    onError: () => { }
};
var API_REQUEST_TYPE;
(function (API_REQUEST_TYPE) {
    API_REQUEST_TYPE[API_REQUEST_TYPE["DATABASE"] = 0] = "DATABASE";
    API_REQUEST_TYPE[API_REQUEST_TYPE["ELASTIC_SEARCH"] = 1] = "ELASTIC_SEARCH";
})(API_REQUEST_TYPE || (API_REQUEST_TYPE = {}));
var ApiKeyFilter;
(function (ApiKeyFilter) {
    ApiKeyFilter[ApiKeyFilter["ALL"] = 0] = "ALL";
    ApiKeyFilter[ApiKeyFilter["TRUE"] = 1] = "TRUE";
    ApiKeyFilter[ApiKeyFilter["FALSE"] = 2] = "FALSE";
})(ApiKeyFilter || (ApiKeyFilter = {}));
const ApiKeyFilterToBooleanMap = {
    [ApiKeyFilter.ALL]: undefined,
    [ApiKeyFilter.TRUE]: true,
    [ApiKeyFilter.FALSE]: false
};


//# sourceMappingURL=api.js.map


/***/ }),

/***/ 2390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FW": function() { return /* binding */ UserType; },
/* harmony export */   "hD": function() { return /* binding */ KAMUser; },
/* harmony export */   "pG": function() { return /* binding */ ALLOWED_ACTION_BY_ROLES; },
/* harmony export */   "tf": function() { return /* binding */ USER_GROUP; }
/* harmony export */ });
/* unused harmony exports ALL_ADMIN_ROLES, PlivoTeam */
const ALL_ADMIN_ROLES = (/* unused pure expression or super */ null && (["super_admin", "admin", "executive"]));
const KAMUser = ["kam"];
var UserType;
(function (UserType) {
    //
    UserType["VERIFICATION_ADMIN"] = "verification_admin";
    UserType["VERIFICATION_EXECUTIVE"] = "verification_executive";
    //
    UserType["FULLFILMENT_ADMIN"] = "fullfilment_admin";
    UserType["FULLFILMENT_EXECUTIVE"] = "fullfilment_executive";
    //
    UserType["IN_TRANSIT_ADMIN"] = "intransit_admin";
    UserType["IN_TRANSIT_EXECUTIVE"] = "intransit_executive";
    UserType["IN_TRANSIT_SUPPORT"] = "intransit_support";
    UserType["PP_PLACEMENT"] = "pp_placement_executive";
    UserType["PP_LOADING"] = "pp_loading_executive";
    UserType["PP_UNLOADING"] = "pp_unloading_executive";
})(UserType || (UserType = {}));
(function (UserType) {
    UserType["SUPER_ADMIN"] = "super_admin";
    UserType["INSIDER"] = "insider";
    UserType["DEVELOPER"] = "developer";
    UserType["USER"] = "user";
    UserType["KAM"] = "kam";
    UserType["ADMIN"] = "admin";
    UserType["TSM"] = "tsm";
    UserType["EXECUTIVE"] = "executive";
    UserType["RETENTION"] = "retention";
    UserType["TSO"] = "tso";
    UserType["TSO_DEMAND"] = "tso_demand";
    UserType["TSO_SUPPLY"] = "tso_supply";
    UserType["TSO_LORRY"] = "tso_lorry";
})(UserType || (UserType = {}));
var PlivoTeam;
(function (PlivoTeam) {
    PlivoTeam["VERIFICATION"] = "Verification";
    PlivoTeam["FULFILMENT"] = "Fulfilment";
    PlivoTeam["PP_PLACEMENT"] = "PP Placement";
    PlivoTeam["PP_LOADING"] = "PP Loading";
    PlivoTeam["PP_UNLOADING"] = "PP Unloading";
    // POST_PLACEMENT = "Post Placement",
    PlivoTeam["PP_SUPPORT"] = "PP Support";
    PlivoTeam["NIGHT_SHIFT"] = "Night Shift";
    PlivoTeam["CS_HELPDESK"] = "CS Helpdesk";
    PlivoTeam["RETENTION"] = "Retention";
    PlivoTeam["INSIDE_SALES_MEMBERSHIP"] = "Inside Sales Membership";
    PlivoTeam["INSIDE_SALES_CI"] = "Inside Sales CI";
})(PlivoTeam || (PlivoTeam = {}));
const SUPER_USER_LIST = [UserType.SUPER_ADMIN, UserType.INSIDER, UserType.DEVELOPER];
const USER_GROUP = {
    INTERNAL_USERS: [UserType.INSIDER, UserType.DEVELOPER],
    SUPER_USERS: SUPER_USER_LIST,
    ADMINS: [...SUPER_USER_LIST, UserType.ADMIN],
    TSO_V2: [UserType.TSO_SUPPLY, UserType.TSO_DEMAND]
};
const ALLOWED_ACTION_BY_ROLES = {
    CUSTOM_PREFERENCE_VISIBILTY: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.RETENTION],
    UNASSIGNED_TICKET_ACTION: USER_GROUP.ADMINS,
    DEACTIVATE_LOAD: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.VERIFICATION_EXECUTIVE],
    LOAD_TICKET_PROCESS_AGENT: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.VERIFICATION_EXECUTIVE],
    CANCEL_TRIP: [...USER_GROUP.ADMINS],
    CANCEL_TRIP_LIMITED_TIME: [...USER_GROUP.ADMINS, UserType.IN_TRANSIT_EXECUTIVE],
    ALLOW_QUICK_LOGOUT: [...USER_GROUP.ADMINS, UserType.TSO],
    PP_EDIT: [...USER_GROUP.ADMINS, UserType.IN_TRANSIT_ADMIN]
};


//# sourceMappingURL=authorizedUsers.js.map


/***/ }),

/***/ 46426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ IDs; }
/* harmony export */ });
const IDs = {
    myLorryBids: {
        attachLorry: "myLorryBids_btn_attachLorry"
    },
    updateDriverDetailsModal: {
        nameInput: "updateVehicleDetails_txtf_driverName",
        numberInput: "updateVehicleDetails_txtf_driverNumber",
        selectMenu: "updateVehicleDetails_drpd_lorryNumber",
        viewTrip: "updateVehicleDetails_lnk_view",
        updateDetails: "updateVehicleDetails_btn_updateDetails",
        modalClose: "updateVehicleDetails_btn_closeIcon",
        cancelBtn: "updateVehicleDetails_btn_cancelBtn"
    },
    postingForm: {
        selectAllState: "postingForm_btn_selectAllState",
        selectType: {
            body: "select_body",
            feet: "select_feet",
            capacity: "select_capacity",
            tyres: "select_tyres",
            lorry: "select_lorry"
        },
        src: "postingForm_txtf_src",
        dest: "postingForm_txtf_dest",
        location: "location",
        materialType: "postingForm_drpd_materialType",
        materialName: "postingForm_txtf_materialName",
        quantity: "postingForm_txtf_quantity",
        quantityChip: "postingForm_txtf_quantityChip",
        capacity: "postingForm_txtf_capacity",
        expectedAmount: "postingForm_expectedAmount",
        paymentToPay: "postingForm_btn_paymentToPay",
        paymentAdvance: "postingForm_btn_paymentAdvance",
        reportingTime: "postingForm_btn_reportingTime",
        submitBtn: "postingForm_btn_submit",
        closeBtn: "postingForm_btn_close",
        isOdc: "isOdc",
        bodyTypeFilter: "bodyTypeFilter"
    },
    bidForm: {
        bidPrice: "bidForm_price",
        bidRemarks: "bidForm_txtf_remarks",
        bidPriceTypeAsFixed: "bidForm_btn_fixedPrice",
        bidPriceTypeAsPerTonne: "bidForm_btn_perTonner",
        bidPriceIsNegotiable: "bidForm_btn_negotiable",
        bidPriceToBill: "bidForm_btn_toBill",
        bidPriceToPay: "bidForm_btn_toPay",
        bidFormVehicleNumber: "bidForm_txtf_vehicleNumber",
        bidFormVehicleNumberErrorMessage: "bidForm_txtf_vehicleNumberErrorMessage",
        bidFormBidNowButton: "mktplace_load_bid_final_submit_btn",
        bidForm_btn_close: "bidForm_btn_close",
        bidForm_companyName: "bidForm_companyName"
    },
    dashboard: {
        postLoadLorryBtn: "dashboard_btn_post",
        profileBtn: "dashboard_btn_profile",
        myProfile: "dashboard_btn_myProfile"
    },
    csDashboard: {
        sendWa: "dashboard_btn_sendWa",
        blockUser: "dashboard_btn_blockUser"
    },
    common: {
        navbar: "dashboard_nav",
        vahakLogo: "dashboard_link_vahakLogo"
    },
    header: {
        services: "header_nav_services",
        marketplace: "header_nav_marketplace",
        transportDirectory: "header_nav_transportDirectory",
        meetVahak: "header_nav_meetVahak",
        onlineLoadBooking: "header_nav_onlineLoadBooking",
        onlineLorryBooking: "header_nav_onlineLorryBooking",
        growNetwork: "header_nav_growNetwork",
        logisticsServices: "header_nav_logisticsServices",
        fullTruckLoad: "header_nav_fullTruckLoad",
        partLoadBooking: "header_nav_partLoadBooking",
        cargoInsurance: "header_nav_cargoInsurance",
        commercialVehicleInsurance: "header_nav_commercialVehicleInsurance",
        businessLoan: "header_nav_businessLoan",
        forum: "header_nav_forum",
        aboutUs: "header_nav_aboutUs",
        howVahakHelps: "header_nav_howVahakHelps",
        whyChooseUs: "header_nav_whyChooseUs",
        careers: "header_nav_careers",
        contactUs: "header_nav_contactUs",
        resources: "header_nav_resources",
        profileAvatar: "header_nav_profileAvatar",
        myProfile: "header_nav_myProfile",
        membership: "header_nav_membership",
        productsAndServices: "header_nav_productsAndServices",
        serviceSelection: "header_nav_serviceSelection",
        productsAndServicesSubMenu: {
            gps: "header_nav_productsAndServices_gps",
            cargoInsurance: "header_nav_productsAndServices_cargoInsurance",
            vehicleInsurance: "header_nav_productsAndServices_vehicleInsurance",
            businessLoan: "header_nav_productsAndServices_businessLoan"
        }
    },
    marketPlace: {
        marketPlaceCard: "marketPlaceCard",
        pageLeft: "pageLeft",
        pageRight: "pageRight"
    },
    auth: {
        loginModal: "auth_modal",
        submitBtn: "auth_btn_submit",
        crossBtn: "auth_btn_cross",
        helpDesk: "helpdesk__btn",
        phoneNumber: "auth_textf_phoneNumber",
        editPhoneNumber: "auth_textf_editPhoneNumber",
        otp: "auth_textf_otp",
        serviceType: "auth_ms_serviceType",
        userName: "auth_text_userName",
        locationInput: "auth_drpd_location",
        currentLocation: "auth_ms_currentLocation",
        referralToggleBtn: "auth_ms_referralToggleBtn",
        referralInput: "auth_text_referral",
        postLoad: "auth_btn_postLoad",
        postLorry: "auth_btn_postLorry",
        resendBtn: "auth_btn_resend",
        resendBtnSms: "auth_btn_resend-sms",
        resendBtnWa: "auth_btn_resend-wa",
        optWa: "auth_btn_optWa"
    },
    bidCard: {
        bidCard: "bidCard",
        viewDetailsCta: "viewDetailsCta"
    },
    profileDropDown: {
        profileLogout: "profile_logout",
        profileDropdownBtn: "profile_dropdown_btn",
        myProfileBtn: "my_profile_btn"
    }
};


//# sourceMappingURL=automation.js.map


/***/ }),

/***/ 71535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GR": function() { return /* binding */ AllBidStatusForCsDashboard; },
/* harmony export */   "QW": function() { return /* binding */ PostAcceptanceBidStatusList; },
/* harmony export */   "UE": function() { return /* binding */ BID_STATUS; }
/* harmony export */ });
/* unused harmony export BID_STATUS_TEXT */
/**
 * Premium
 * No Of Accepted Bid = COMPLETED + IN_TRANSIT
 */
var BID_STATUS;
(function (BID_STATUS) {
    BID_STATUS[BID_STATUS["WAITING"] = 0] = "WAITING";
    BID_STATUS[BID_STATUS["NEGOTIATED"] = 1] = "NEGOTIATED";
    BID_STATUS[BID_STATUS["ACCEPTED"] = 2] = "ACCEPTED";
    BID_STATUS[BID_STATUS["COMPLETED"] = 3] = "COMPLETED";
    BID_STATUS[BID_STATUS["IN_TRANSIT"] = 4] = "IN_TRANSIT";
    BID_STATUS[BID_STATUS["REJECTED"] = 5] = "REJECTED";
    BID_STATUS[BID_STATUS["EXPIRED"] = 6] = "EXPIRED";
    BID_STATUS[BID_STATUS["CANCELLED"] = 7] = "CANCELLED";
    BID_STATUS[BID_STATUS["STAND_BY"] = 8] = "STAND_BY";
    BID_STATUS[BID_STATUS["PARTIALLY_ACCEPTED"] = 9] = "PARTIALLY_ACCEPTED";
    BID_STATUS[BID_STATUS["UNVERIFIED"] = 999] = "UNVERIFIED";
})(BID_STATUS || (BID_STATUS = {}));
var BID_STATUS_TEXT;
(function (BID_STATUS_TEXT) {
    BID_STATUS_TEXT["WAITING"] = "Waiting";
    BID_STATUS_TEXT["REJECTED"] = "Rejected";
    BID_STATUS_TEXT["COMPLETED"] = "Completed";
    BID_STATUS_TEXT["IN_TRANSIT"] = "In Transit";
    BID_STATUS_TEXT["NEGOTIATED"] = "Negotiated";
    BID_STATUS_TEXT["EXPIRED"] = "Expired";
    BID_STATUS_TEXT["CANCELLED"] = "Cancelled";
    BID_STATUS_TEXT["UNVERIFIED"] = "Unverified";
    BID_STATUS_TEXT["ACCEPTED"] = "Accepted";
})(BID_STATUS_TEXT || (BID_STATUS_TEXT = {}));
const AllBidStatusForCsDashboard = [
    BID_STATUS.WAITING,
    BID_STATUS.NEGOTIATED,
    BID_STATUS.IN_TRANSIT,
    BID_STATUS.STAND_BY,
    BID_STATUS.PARTIALLY_ACCEPTED,
    BID_STATUS.EXPIRED,
    BID_STATUS.COMPLETED,
    BID_STATUS.CANCELLED
];
const PostAcceptanceBidStatusList = [BID_STATUS.IN_TRANSIT, BID_STATUS.CANCELLED, BID_STATUS.COMPLETED];


//# sourceMappingURL=bidStatus.js.map


/***/ }),

/***/ 43298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ BID_UPDATE_TYPE; }
/* harmony export */ });
var BID_UPDATE_TYPE;
(function (BID_UPDATE_TYPE) {
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["WAITING"] = 0] = "WAITING";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["NEGOTIATE"] = 1] = "NEGOTIATE";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["ACCEPT"] = 2] = "ACCEPT";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["EDIT"] = 3] = "EDIT";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["REJECT"] = 4] = "REJECT";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["VERIFY"] = 5] = "VERIFY";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["EXPIRE"] = 6] = "EXPIRE";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["DECLINE"] = 7] = "DECLINE";
})(BID_UPDATE_TYPE || (BID_UPDATE_TYPE = {}));


//# sourceMappingURL=bidUpdateType.js.map


/***/ }),

/***/ 47762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ BULK_LOAD_CARD_STATUS_TEXT; }
/* harmony export */ });
/**
 * BULK_LOAD_CARD_STATUS_TEXT
 *
 * This is to be derived from single load status
 */
var BULK_LOAD_CARD_STATUS_TEXT;
(function (BULK_LOAD_CARD_STATUS_TEXT) {
    BULK_LOAD_CARD_STATUS_TEXT["PUBLISHED"] = "Published";
    BULK_LOAD_CARD_STATUS_TEXT["UNDER_REVIEW"] = "Under Review";
    BULK_LOAD_CARD_STATUS_TEXT["FULFILLED"] = "Fulfilled";
    BULK_LOAD_CARD_STATUS_TEXT["PARTIAL_FULFILLED"] = "Partially Fulfilled";
    BULK_LOAD_CARD_STATUS_TEXT["CANCELLED"] = "Cancelled";
    BULK_LOAD_CARD_STATUS_TEXT["EXPIRED"] = "Expired";
})(BULK_LOAD_CARD_STATUS_TEXT || (BULK_LOAD_CARD_STATUS_TEXT = {}));


//# sourceMappingURL=bulkLoadCardStatus.js.map


/***/ }),

/***/ 51061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ COMPANY_DETAILS; }
/* harmony export */ });
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);


const COMPANY_DETAILS = {
    name: "Vahak",
    workspace: "Attic Space Trishul",
    address: "#12, 7th Cross Rd, Koramangala 1A Block, Koramangala 3 Block, Koramangala, Bengaluru, Karnataka 560034",
    addressLine1: "#12, 7th Cross Rd",
    addressLine2: "Koramangala 1A Block",
    addressLine3: "Koramangala 3 Block",
    addressLine4: "Bengaluru, Karnataka 560034",
    addressLocality: "Bengaluru",
    addressRegion: "KA",
    postalCode: "560034",
    addressCountry: "IN",
    telephone: "+91-8035738071",
    website: "https://www.vahak.in",
    stagingLink: "https://stagingapp.vahak.in",
    potentialActionTargetUrl: "https://www.vahak.in/marketplace/load",
    googleMapLink: "https://goo.gl/maps/oMThWRu6DvCui3uw8",
    googleMapEmbedLink: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15554.647223964115!2d77.6325878!3d12.9294447!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2ef61e2a187b7d36!2sVahak%20-%20Transport%20Marketplace%20App%20(Book%20Trucks%20%26%20Loads)!5e0!3m2!1sen!2sin!4v1643133299249!5m2!1sen!2sin",
    openHours: "Mon-Sat (9:00 AM - 9:00 PM)",
    logo: `${_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .IMG_BASE_URL */ .TS}/Vahak_Blue.png`
};


//# sourceMappingURL=companyDetails.js.map


/***/ }),

/***/ 69406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bz": function() { return /* binding */ GA4ContactUsClickSource; },
/* harmony export */   "E_": function() { return /* binding */ LoadPostingFormEvents; },
/* harmony export */   "GM": function() { return /* binding */ GA4ServicePageGrowNetworkEventValues; },
/* harmony export */   "Gf": function() { return /* binding */ BidCardEvents; },
/* harmony export */   "Iv": function() { return /* binding */ GA4ServicePageOnlineLoadBookingEventValues; },
/* harmony export */   "K4": function() { return /* binding */ GA4MembershipEventAttributes; },
/* harmony export */   "LE": function() { return /* binding */ NOT_APPLICABLE; },
/* harmony export */   "N9": function() { return /* binding */ GA4HomePageMeetTransportServiceProvidersEventValues; },
/* harmony export */   "O6": function() { return /* binding */ VWOEvents; },
/* harmony export */   "Oh": function() { return /* binding */ GA4LorryPostingSource; },
/* harmony export */   "T8": function() { return /* binding */ AdminMiscEvents; },
/* harmony export */   "UD": function() { return /* binding */ GA4LoginOrRegistrationModalEventAttributes; },
/* harmony export */   "Xw": function() { return /* binding */ GA4ServicePagePartTruckLoadEventValues; },
/* harmony export */   "ZM": function() { return /* binding */ WEB_V2_SOURCE_SCREENS; },
/* harmony export */   "aj": function() { return /* binding */ GA4HomepageOtherActivityEventValues; },
/* harmony export */   "bc": function() { return /* binding */ GA4ServicePageFullTruckLoadEventValues; },
/* harmony export */   "g6": function() { return /* binding */ GA4ServicePageLogisticsServicesEventValues; },
/* harmony export */   "kw": function() { return /* binding */ GA4AppClickSource; },
/* harmony export */   "n9": function() { return /* binding */ GA4ServicePageOnlineTruckBookingEventValues; },
/* harmony export */   "q7": function() { return /* binding */ GA4HeaderServiceEventValues; },
/* harmony export */   "rW": function() { return /* binding */ GA4EventNamesAdminConsole; },
/* harmony export */   "tj": function() { return /* binding */ LoadScreenEvents; },
/* harmony export */   "wQ": function() { return /* binding */ GA4EventNames; },
/* harmony export */   "xI": function() { return /* binding */ LorryScreenEvents; },
/* harmony export */   "zH": function() { return /* binding */ AssuredLoadEvents; }
/* harmony export */ });
/* unused harmony exports GA4BidNowClickSource, GA4BidSubmitSource, GA4BusinessCardSource, GA4CallBtnClickSource, GA4HomePageBtnClickEventValues, GA4HomePageBtnClickLocationEventValues, GA4HomePageWhatCanWeDoEventValues, GA4HomepageBookRightLoadAfterLorryCategorySelectionEventValues, GA4HomepageBookRightLoadEventValues, GA4HomepageFindTransporterAfterLorrySelectionEventValues, GA4HomepageFindTransporterEventValues, GA4HomepageVahakMediaSelectionEventValues, GA4LoadPostingSource, GA4MarketPlaceFilterClickSource, GA4PostLoadLorryInitClickSource, GA4ViewAllClickSource, moEngageLoadBidSource, moEngageLorryBidSource */
const GA4EventNames = {
    KYC_userclicked_verifyaadhar: "KYC_userclicked_verifyaadhar_web",
    KYC_useraadhar_verified: "KYC_useraadhar_verified_web",
    KYC_userclicked_verifygst: "KYC_userclicked_verifygst_web",
    KYC_usergst_verified: "KYC_usergst_verified_web",
    // Home page events
    Website_homepage_btn_click: "Website_homepage_btn_click_web",
    Website_homepage_btn_click_location: "Website_homepage_btn_click_location_web",
    Homepage_what_can_we_do: "Homepage_what_can_we_do_web",
    Homepage_meet_india_transporter_change_city_after_selection: "Homepage_meet_india_transporter_change_city_after_selection_web",
    Homepage_meet_india_book_right_load_for_you: "Homepage_meet_india_book_right_load_for_you_web",
    Homepage_meet_india_after_right_lorry_Category_selection: "Homepage_meet_india_after_right_lorry_Category_selection_web",
    Homepage_meet_india_find_transporter: "Homepage_meet_india_find_transporter_web",
    Homepage_meet_india_find_transporter_after_lorry_selection: "Homepage_meet_india_find_transporter_after_lorry_selection_web",
    Homepage_vahak_media_selection: "Homepage_vahak_media_selection_web",
    Homepage_other_Activity: "Homepage_other_Activity_web",
    // Services Page Events
    Servicepage_user_type_of_service_page: "Servicepage_user_type_of_service_page_web",
    Servicepage_online_load_booking: "Servicepage_online_load_booking_web",
    Servicepage_online_truck_booking: "Servicepage_online_truck_booking_web",
    Servicepage_grow_network: "Servicepage_grow_network_web",
    Servicepage_logistics_services: "Servicepage_logistics_services_web",
    Servicepage_full_truck_load: "Servicepage_full_truck_load_web",
    Servicepage_part_truck_load: "Servicepage_part_truck_load_web",
    // Post Lorry
    Post_lorry_success: "Post_lorry_success_web",
    // Post Load
    Post_load_success: "Post_load_success_web",
    // Submit Bid
    Bid_submit_success: "bid_submit_success_web",
    // Submit Load Bid
    Load_bid_submit_success: "load_bid_submit_success_web",
    // Submit Lorry Bid
    Lorry_bid_submit_success: "lorry_bid_submit_success_web",
    // Accept Load Bid
    Load_bid_accept_success: "load_bid_accept_success_web",
    // Accept Lorry Bid
    Lorry_bid_accept_success: "lorry_bid_accept_success_web",
    // Business Card
    Share_business_card_clicked_web: "share_business_card_clicked_web",
    Download_business_card_clicked_web: "download_business_card_clicked_web",
    // App Download
    Download_app_clicked_web: "download_app_clicked_web",
    // Footer Subscribe
    Subscribe_clicked_web: "subscribe_clicked_web",
    // Language Selected
    Language_selected_web: "language_selected_web",
    // Contact Us Clicked
    Contact_us_clicked_web: "contact_us_clicked_web",
    // Connect Us
    Connect_with_us_clicked_web: "connect_with_us_clicked_web",
    // Avail Service
    Avail_logistic_service_clicked_web: "avail_logistic_service_clicked_web",
    // Call Now Btn
    Call_now_clicked_web: "call_now_clicked_web",
    // View Profile
    View_profile_clicked_web: "view_profile_clicked_web",
    // My Profile Page Events
    My_profile_go_back_clicked_web: "my_profile_go_back_clicked_web",
    My_profile_clicked: "my_profile_clicked",
    Edit_profile_clicked_web: "edit_profile_clicked_web",
    Profile_save_clicked_web: "profile_save_clicked_web",
    Vehicle_share_clicked_web: "vehicle_share_clicked_web",
    // My Post Filter
    My_posting_status_filter_clicked_web: "my_posting_status_filter_clicked_web",
    My_posting_advance_filter_apply_clicked_web: "my_posting_advance_filter_apply_clicked_web",
    // Load Lorry details
    Load_details_clicked_web: "load_details_clicked_web",
    Lorry_details_clicked_web: "lorry_details_clicked_web",
    // Bids Sent Received
    Bid_sent_received_clicked_web: "bid_sent_received_clicked_web",
    // Load Lorry Bid Now
    Load_bid_now_clicked_web: "load_bid_now_clicked_web",
    Lorry_bid_now_clicked_web: "lorry_bid_now_clicked_web",
    // Market Place Filter
    Marketplace_truck_filter_selected_web: "marketplace_truck_filter_selected_web",
    Marketplace_capacity_filter_web: "marketplace_capacity_filter_web",
    // Market Place City Search
    marketplace_source_city_entered_web: "marketplace_source_city_entered_web",
    marketplace_destination_city_entered_web: "marketplace_destination_city_entered_web",
    // Load Lorry Post Init
    Post_load_initiated_web: "post_load_initiated_web",
    Post_lorry_initiated_web: "post_lorry_initiated_web",
    // View & Choose True
    View_your_truck_type_web: "view_your_truck_type_web",
    Choose_your_truck_type_web: "choose_your_truck_type_web",
    // Admin Console Event Names
    USER_LOGIN_WEB: "user_login_web",
    CLIENT_PORTAL_VIEW_WEB: "client_portal_view_web",
    CLIENT_PROFILE_LOGIN_WEB: "client_profile_login_web",
    CLIENT_PROFILE_LOGOUT_WEB: "client_profile_logout_web",
    POST_BULK_LOAD_WEB: "post_bulk_load_web",
    UPLOAD_BULK_LOAD_FILE_WEB: "upload_bulk_load_file_web",
    PREVIEW_BULK_LOAD_FORMAT_WEB: "preview_bulk_load_format_web",
    POST_LOAD_SUCCESS_WEB: "post_load_success_web",
    POST_ALL_BULK_LOADS_CANCEL_WEB: "post_all_bulk_loads_cancel_web",
    POST_BULK_LOAD_CLOSE_CLICKED_WEB: "post_bulk_load_close_clicked_web",
    POST_BULK_LOAD_CLOSE_CANCELED_WEB: "post_bulk_load_close_canceled_web",
    POST_BULK_LOAD_CLOSE_CONFIRMED_WEB: "post_bulk_load_close_confirmed_web",
    VIEW_BULK_LOAD_ROUTES_WEB: "view_bulk_load_routes_web",
    VIEW_BULK_LOAD_DETAILS_WEB: "view_bulk_load_details_web",
    BULK_LOAD_STATUS_VIEWED_WEB: "bulk_load_status_viewed_web",
    BULK_LOAD_FILTERS_SELECTED_WEB: "bulk_load_filters_selected_web",
    BULK_LOAD_FILTERS_CLEARED_WEB: "bulk_load_filters_cleared_web",
    BULK_LOAD_SELECTED_WEB: "bulk_load_selected_web",
    BULK_LOAD_SELECT_ALL_WEB: "bulk_load_select_all_web",
    BULK_LOAD_PUBLISH_TO_MARKETPLACE_WEB: "bulk_load_publish_to_marketplace_web",
    BULK_LOAD_DISABLE_FROM_MARKETPLACE_WEB: "bulk_load_disable_from_marketplace_web",
    BULK_LOAD_DELETE_FROM_LISTING_WEB: "bulk_load_delete_from_listing_web",
    SEND_TO_CLIENT_CLICKED_WEB: "send_to_client_clicked_web",
    BID_NEGOTIATE_START_WEB: "Bid_negotiate_start_web",
    BID_NEGOTIATED_WEB: "bid_negotiated_web",
    BID_NEGOTIATION_BROADCASTED_WEB: "bid_negotiation_broadcasted_web",
    LORRY_BID_ACCEPT_SUCCESS_WEB: "lorry_bid_accept_success_web",
    UPDATE_DRIVER_DETAILS_WEB: "update_driver_details_web",
    LOGIN_OR_SIGNUP_BUTTON_CLICK_WEB: "login_signup_clicked",
    /**
     * Login/Signup Modal
     */
    LOGIN_OR_SIGNUP_MODAL: {
        wa_optin_toggled: "wa_optin_toggled",
        help_clicked: "help_clicked",
        custom_number_entered: "custom_number_entered",
        get_otp_clicked: "get_otp_clicked",
        otp_screen_edit_phone_number_clicked: "otp_screen_edit_phone_number_clicked",
        otp_via_message: "otp_via_message",
        otp_via_whatsapp: "otp_via_whatsapp",
        otp_submit: "otp_submit",
        user_login: "user_login",
        user_signup: "user_signup",
        close_clicked: "close_clicked",
        request_call_back_canceled: "request_call_back_canceled",
        requested_call_back: "requested_call_back"
    },
    COMPANY_REGISTRATION: {
        service_type_selected: "service_type_selected",
        company_name_entered: "company_name_entered",
        company_location_selected: "company_location_selected",
        have_a_referral_code_clicked: "have_a_referral_code_clicked",
        referral_code_entered: "referral_code_entered",
        company_details_submitted: "company_details_submitted",
        user_registered: "user_registered",
        continue_signup_banner: "continue_signup_banner"
    },
    SPLASH_SCREEN: {
        post_load_button_click: "post_load_button_click",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn"
    },
    /**
     * Membership Entry Point Event
     */
    MEMBERSHIP_ENTRY_POINT: {
        BANNER_CLICKED: "banner_clicked",
        LIMITATION_CARD_SHOWN: "limitation_card_shown",
        MEMBERSHIP_LIMITATION_CARD_CLOSE_CLICKED: "membership_limitation_card_close_clicked",
        BUY_MEMBERSHIP_CLICKED: "buy_membership_clicked",
        BUY_MEMBERSHIP_CARD_CLOSE_CLICKED: "buy_membership_card_close_clicked"
    },
    MEMBERSHIP_MANAGE: {
        MEMBERSHIP_PLAN_SELECTED: "membership_plan_selected",
        PAYMENT_START_PAYMENT_CLICK: "payment_start_payment_click",
        PAYMENT_FAILED: "payment_failed",
        PAYMENT_FAILED_CARD_SHOWN: "payment_failed_card_shown",
        PAYMENT_FAILED_CARD_CLOSE_CLICKED: "payment_failed_card_close_clicked",
        PAYMENT_RETRY_BTN_CLICK: "payment_retry_btn_click",
        PAYMENT_SUCCESS: "payment_success",
        PAYMENT_SUCCESS_CARD_SHOWN: "payment_success_card_shown",
        PAYMENT_SUCCESS_CARD_CLOSE_CLICKED: "payment_success_card_close_clicked",
        GOT_IT_CLICKED: "got_it_clicked",
        VIEW_HISTORY_CLICKED: "view_history_clicked",
        TOP_UP_RENEW_PLAN_CLICKED: "top_up_renew_plan_clicked"
    },
    /**
     * Lorry posting modal
     */
    LORRY_POSTING_MODAL: {
        view_live_loads_clicked: "view_live_loads_clicked",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        //Not done
        enter_vehicle_no_attach_new_lorry_form: "enter_vehicle_no_attach_new_lorry_form",
        lorry_form_city_selected: "lorry_form_city_selected",
        // Not done
        verify_my_vehicle_clicked: "verify_my_vehicle_clicked",
        lorry_form_all_india_permit: "lorry_form_all_india_permit",
        lorry_form_see_more_route_click: "lorry_form_see_more_route_click",
        lorry_form_route_pop_up_save_click: "lorry_form_route_pop_up_save_click",
        lorry_form_next_click: "lorry_form_next_click",
        lorry_form_edit_click: "lorry_form_edit_click",
        // Not done
        lorry_form_update_click: "lorry_form_update_click",
        // Not done
        not_my_vehicle_clicked: "not_my_vehicle_clicked",
        lorry_form_vehicle_added: "lorry_form_vehicle_added",
        lorry_form_capacity_selection: "lorry_form_capacity_selection",
        lorry_form_body_type_selection: "lorry_form_body_type_selection",
        lorry_form_tyres_selection: "lorry_form_tyres_selection",
        document_upload_clicked: "document_upload_clicked",
        lorry_form_attach_post_click: "lorry_form_attach_post_click",
        lorry_attached_successfully: "lorry_attached_successfully",
        reactivated_lorry: "reactivated_lorry"
    },
    /**
     * lorry listing
     */
    LORRY_LISTING: {
        bs_close_clicked: "bs_close_clicked",
        lorry_form_city_selected: "lorry_form_city_selected",
        lorry_form_reactivate_click: "lorry_form_reactivate_click"
    },
    // Marketplace
    MARKET_PLACE: {
        marketplace_load_market_selected: "marketplace_load_market_selected",
        marketplace_lorry_market_selected: "marketplace_lorry_market_selected",
        marketplace_source_city_entered: "marketplace_source_city_entered",
        marketplace_destination_city_entered: "marketplace_destination_city_entered",
        filters_clicked: "filters_clicked",
        filters_selected: "filters_selected",
        change_preference_clicked: "change_preference_clicked",
        preference_selected: "preference_selected",
        filters_cleared: "filters_cleared",
        search_by_cities_clicked: "search_by_cities_clicked",
        book_now: "book_now",
        bs_close_clicked: "bs_close_clicked",
        continue_bidding: "continue_bidding",
        canceled_bidding: "canceled_bidding",
        request_call_back_clicked: "request_call_back_clicked",
        close_clicked: "close_clicked",
        request_call_back_canceled: "request_call_back_canceled",
        requested_call_back: "requested_call_back",
        connect_on_wa_clicked: "connect_on_wa_clicked",
        bid_amount_entered: "bid_amount_entered",
        remarks_entered: "remarks_entered",
        bid_submitted: "bid_submitted",
        load_bid_submitted: "load_bid_submitted",
        lorry_bid_submitted: "lorry_bid_submitted",
        post_load_button_click: "post_load_button_click",
        load_selected: "load_selected",
        reposted_load: "reposted_load",
        view_profile_clicked: "view_profile_clicked",
        verification_badge_clicked: "verification_badge_clicked",
        edit_operating_states: "edit_operating_states",
        edit_operating_states_saved: "edit_operating_states_saved",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        bid_ignored: "bid_ignored",
        marketplace_search_clicked: "marketplace_search_clicked",
        select_from_existing_clicked: "select_from_existing_clicked"
    },
    /**
     * Profile Events
     */
    PROFILE_PAGE: {
        help_clicked: "help_clicked",
        profile_add_dp_clicked: "profile_add_dp_clicked",
        view_business_card_clicked: "view_business_card_clicked",
        share_business_card: "share_business_card",
        banner_clicked: "banner_clicked",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        post_load_button_click: "post_load_button_click",
        view_verification_clicked: "view_verification_clicked",
        bs_close_clicked: "bs_close_clicked",
        got_it_clicked: "got_it_clicked",
        add_bank_account_clicked: "add_bank_account_clicked",
        request_call_back_canceled: "request_call_back_canceled",
        requested_call_back: "requested_call_back",
        bank_account_verify_using_clicked: "bank_account_verify_using_clicked",
        verify_bank_account_clicked: "verify_bank_account_clicked",
        bank_account_added: "bank_account_added",
        manage_account_clicked: "manage_account_clicked",
        delete_bank_account_clicked: "delete_bank_account_clicked",
        bank_account_deleted: "bank_account_deleted",
        edit_profile_clicked: "edit_profile_clicked",
        edit: {
            founding_year_selected: "founding_year_selected",
            languages_confirmed: "languages_confirmed",
            edit_operating_states: "edit_operating_states",
            about_us_saved: "about_us_saved",
            change_address_clicked: "change_address_clicked",
            office_location_selected: "office_location_selected",
            office_open_time_selected: "office_open_time_selected",
            working_days_selected: "working_days_selected",
            office_close_time_selected: "office_close_time_selected",
            profile_save_clicked: "profile_save_clicked"
        }
    },
    KYC: {
        verify_aadhar_clicked: "verify_aadhar_clicked",
        get_otp_clicked: "get_otp_clicked",
        otp_submit: "otp_submit",
        kyc_completed_aadhar: "kyc_completed_aadhar",
        kyc_aadhar_verification_failed: "kyc_aadhar_verification_failed",
        verify_pan_clicked: "verify_pan_clicked",
        submit_clicked: "submit_clicked",
        kyc_completed_pan: "kyc_completed_pan",
        kyc_pan_verification_failed: "kyc_pan_verification_failed",
        kyc_completed_gst: "kyc_completed_gst",
        kyc_gst_verification_failed: "kyc_gst_verification_failed"
    },
    TRANSPORTER_PROFILE: {
        call_initiated: "call_initiated",
        view_verification_clicked: "view_verification_clicked",
        got_it_clicked: "got_it_clicked",
        profile_banner_clicked: "profile_banner_clicked",
        profile_load_clicked: "profile_load_clicked",
        profile_lorry_clicked: "profile_lorry_clicked"
    },
    // Top nav events
    TOP_NAV: {
        manage_membership_clicked: "manage_membership_clicked",
        marketplace_icon_clicked: "marketplace_icon_clicked",
        transport_directory_clicked: "transport_directory_clicked",
        download_app_clicked_web: "download_app_clicked_web",
        login_signup_clicked: "login_signup_clicked"
    },
    /** Web v2 unified funnel events — use `WEB_V2_SOURCE_SCREENS` for source_screen attribute. */
    WEB_V2: {
        title_find_loads_clicked: "title_find_loads_clicked",
        title_find_lorry_clicked: "title_find_lorry_clicked",
        title_download_app_clicked: "title_download_app_clicked",
        title_membership_clicked: "title_membership_clicked",
        title_cargo_insurance_clicked: "title_cargo_insurance_clicked",
        title_login_signup: "title_login/signup",
        title_language_change: "title_language_change",
        marketplace_page_opened: "marketplace_page_opened",
        cargo_insurance_page_opened: "cargo_insurance_page_opened",
        membership_page_opened: "membership_page_opened",
        pick_up_entered: "pick_up_entered",
        drop_entered: "drop_entered",
        capacity_entered: "capacity_entered",
        lorry_type_selected: "lorry_type_selected",
        check_prices_clicked: "check_prices_clicked",
        load_form_location_page_opened: "load_form_location_page_opened",
        load_form_next_step_1_clicked: "load_form_next_step_1_clicked",
        load_form_spec_page_opened: "load_form_spec_page_opened",
        load_form_next_step_2_clicked: "load_form_next_step_2_clicked",
        load_form_price_page_opened: "load_form_price_page_opened",
        load_post_successfully: "load_post_successfully",
        load_post_successfully_priority: "load_post_successfully_priority",
        download_appstore: "download_appstore",
        download_playstore: "download_playstore",
        login_sign_up_form_opened: "login_sign_up_form_opened",
        phone_number_entered: "phone_number_entered",
        get_otp_clicked: "get_otp_clicked",
        otp_entered: "otp_entered",
        otp_submit: "otp_submit",
        user_signup: "user_signup",
        user_registered: "user_registered",
        book_now: "book_now",
        stop_clicked: "stop_clicked",
        bid_form_basic_opened: "bid_form_basic_opened",
        bid_form_show_route_clicked: "bid_form_show_route_clicked",
        bid_form_price_increased: "bid_form_price_increased",
        bid_form_disclaimer_checked: "bid_form_disclaimer_checked",
        bid_form_disclaimer_unchecked: "bid_form_disclaimer_unchecked",
        bid_form_basic_next: "bid_form_basic_next",
        bid_form_detailed_opened: "bid_form_detailed_opened",
        use_coins_toggled: "use_coins_toggled",
        payment_pay_now_btn: "payment_pay_now_btn",
        bid_submitted: "bid_submitted",
        bid_submitted_priority: "bid_submitted_priority",
        payment_success: "payment_success",
        bs_closed: "bs_closed",
        view_more_loads_clicked: "view_more_loads_clicked",
        cargo_form_name_entered: "cargo_form_name_entered",
        cargo_form_number_entered: "cargo_form_number_entered",
        cargo_form_submitted: "cargo_form_submitted",
        market_search_clicked: "market_search_clicked",
        buy_now_clicked: "Buy_now_clicked"
    },
    //Sidenav events
    SIDE_NAV: {
        post_btn_clicked: "post_btn_clicked",
        post_load_button_click: "post_load_button_click",
        add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
        homepage_icon_clicked: "homepage_icon_clicked",
        my_load_icon_clicked: "my_load_icon_clicked",
        my_lorry_icon_clicked: "my_lorry_icon_clicked",
        marketplace_icon_clicked: "marketplace_icon_clicked",
        transport_directory_clicked: "transport_directory_clicked",
        services_icon_clicked: "services_icon_clicked",
        meet_vahak_icon_clicked: "meet_vahak_icon_clicked",
        resource_icon_clicked: "resource_icon_clicked",
        manage_membership_clicked: "manage_membership_clicked",
        profile_menu_clicked: "profile_menu_clicked",
        profile_icon_clicked: "profile_icon_clicked",
        user_logout: "user_logout"
    },
    // Third party events
    THIRD_PARTY: {
        third_party_login: "third_party_login"
    },
    //Transporter directory
    TRANSPORT_DIRECTORY: {
        transport_directory_source_city_entered: "transport_directory_source_city_entered",
        transport_directory_destination_city_entered: "transport_directory_destination_city_entered",
        transport_directory_search_by_name_entered: "transport_directory_search_by_name_entered"
    }
};
const NOT_APPLICABLE = "#N/A";
/** Standard source_screen values for WEB_V2 funnel events. */
const WEB_V2_SOURCE_SCREENS = {
    HOME_PAGE: "home_page",
    LOAD_FORM: "load_form",
    ONB_FORM: "onb_form",
    BID_FORM: "bid_form",
    MARKETPLACE: "marketplace",
    CARGO_INSURANCE: "cargo_insurance",
    MEMBERSHIP: "membership",
    LCV_ROUTE_LANDING: "lcv_route_landing",
    LCV_CITY_LANDING: "lcv_city_landing"
};
// Home Page button click Event Values
const GA4HomePageBtnClickEventValues = {
    without_login: 0,
    after_login: 1
};
// Home Page button click Event Values
const GA4HomePageBtnClickLocationEventValues = {
    service_pages: 1,
    marketplace: 2,
    transport_directory: 3,
    company_pages: 5,
    business_card: 6
};
// Home Page what can we do Event Values
const GA4HomePageWhatCanWeDoEventValues = {
    search_load: 0,
    search_lorries: 1,
    browse_transporters: 2
};
// Home Page meet india transporter service providers change_city after selection Event Values
const GA4HomePageMeetTransportServiceProvidersEventValues = {
    get_contact_details: 0,
    view_profile: 1,
    next_in_same_page: 2,
    view_full_list: 3
};
// Home Page meet india book right load for you Event Values
const GA4HomepageBookRightLoadEventValues = {
    3: 0,
    5: 1,
    1: 2,
    4: 3,
    2: 4,
    6: 5
};
// Home Page meet india after book right load for you Event Values
const GA4HomepageBookRightLoadAfterLorryCategorySelectionEventValues = {
    view_profile: 0,
    bid_now: 1,
    view_full_list: 2
};
// Home Page Find top transport services near you Event Values
const GA4HomepageFindTransporterEventValues = {
    3: 0,
    5: 1,
    1: 2,
    4: 3,
    2: 4,
    6: 5
};
// Home Page Find top transport services near you after choosing  Event Values
const GA4HomepageFindTransporterAfterLorrySelectionEventValues = {
    view_profile: 0,
    bid_now: 1,
    view_full_list: 2
};
// Home Page Media section Event Values
const GA4HomepageVahakMediaSelectionEventValues = {
    recommended_video: 1,
    view_all_videos: 2
};
// Home Page Other Event Values
const GA4HomepageOtherActivityEventValues = {
    testimonial: 1,
    playstore: 2,
    transporter_bytes: 3,
    vahak_in_the_news: 4
};
// Header Nav Service sub menu Event Values
const GA4HeaderServiceEventValues = {
    online_load_booking: 0,
    online_lorry_booking: 1,
    grow_network: 2,
    logistics_services: 3,
    full_truck_load: 4,
    part_truck_load: 5,
    business_cards: 6
};
// Service Page online load booking Event Values
const GA4ServicePageOnlineLoadBookingEventValues = {
    book_loads_now: 1,
    start_booking_now: 2,
    mobile_app: 3,
    web: 4,
    type_of_truck_loads_find_now: 5
};
// Service Page online truck booking Event Values
const GA4ServicePageOnlineTruckBookingEventValues = {
    book_trucks_now: 1,
    start_booking_now: 2,
    mobile_app: 3,
    web: 4,
    book_lorries: 5
};
// Service Page grow network Event Values
const GA4ServicePageGrowNetworkEventValues = {
    start_networking: 1,
    grow_network: 2,
    mobile_app: 3,
    web: 4
};
// Service Page logistics services Event Values
const GA4ServicePageLogisticsServicesEventValues = {
    avail_logistics_sercives: 1,
    find_trucks_online: 2,
    mobile_app: 3,
    web: 4
};
// Service Page full truck load Event Values
const GA4ServicePageFullTruckLoadEventValues = {
    book_full_truck_load: 1,
    explore_ftl_market: 2,
    mobile_app: 3,
    web: 4
};
// Service Page part truck load Event Values
const GA4ServicePagePartTruckLoadEventValues = {
    book_part_load: 1,
    explore_part_load_market: 2,
    mobile_app: 3,
    web: 4
};
// Load posting event source values
const GA4LoadPostingSource = {
    home_screen_bid_now: "Home screen bid now",
    marketplace_live_lorry_bid_now: "Marketplace live lorry bid now",
    my_loads_post_load: "My loads post load"
};
// Load posting event source values
const GA4LorryPostingSource = {
    home_screen_bid_now: "Home screen bid now",
    marketplace_live_load_bid_now: "Marketplace live load bid now",
    my_lorries_post_lorry: "My lorries post lorry"
};
// Lorry bid event source values
const moEngageLorryBidSource = {
    home_screen_lorry_bid: "Home screen lorry bid",
    marketplace_lorry_bid: "Marketplace lorry bid"
};
// Load bid event source values
const moEngageLoadBidSource = {
    home_screen_load_bid: "Home screen load bid",
    marketplace_load_bid: "Marketplace load bid"
};
// Bid Submit event source values
const GA4BidSubmitSource = {
    home_page: "Home page",
    load_market: "Load market",
    lorry_market: "Lorry market"
};
// Business event source values
const GA4BusinessCardSource = {
    homescreen: "Homescreen",
    my_profile_section: "My profile section"
};
// APP click event source values
const GA4AppClickSource = {
    homepage_bottom_screen: "Homepage bottom screen",
    homepage_middle_section: "Homepage Middle section",
    profile_page: "profile Page"
};
// Contact Us click event source values
const GA4ContactUsClickSource = {
    homepage_bottom_section: "Homepage bottom section",
    homepage_top_section: "Homepage top section"
};
// Bid Now click event source values
const GA4BidNowClickSource = {
    homepage: "Homepage",
    load_market: "Load Market",
    lorry_market: "Lorry Market"
};
// Market Place filter click event source values
const GA4MarketPlaceFilterClickSource = {
    load_market: "Load Market",
    lorry_market: "Lorry Market"
};
// Call Btn click event source values
const GA4CallBtnClickSource = {
    homepage: "Homepage",
    profile_page: "Profile page"
};
// Post Load or Lorry click event source values
const GA4PostLoadLorryInitClickSource = {
    my_loads_section: "My loads section",
    my_lorry_section: "My lorry section",
    post_button: "post button on my dashboard"
};
// View All click event source values
const GA4ViewAllClickSource = {
    loads: "Loads",
    lorry: "Lorry"
};
// Login button click & login modal event attributes
const GA4LoginOrRegistrationModalEventAttributes = {
    phone_number_registration: "phone_number_registration",
    first_time_user: "first_time_user",
    repeated_user: "repeated_user",
    login_signup_via: "manual"
};
const GA4MembershipEventAttributes = {
    NEW_MEMBERSHIP: "new_membership",
    HOMEPAGE: "homepage",
    EXPLORE_NOW: "explore_now",
    EXPLORE_YOUR_MEMBERSHIP: "explore_your_membership",
    MANAGE: "manage",
    YOUR_MEMBERSHIP: "your_membership",
    TOP_UP_PLAN: "top_up_plan",
    VIEW_OTHER_PLANS: "view_other_plans",
    BUY_MEMBERSHIP: "buy_membership",
    UPGRADE_MEMBERSHIP: "upgrade_membership",
    NEW_MEMBERSHIP_PLAN: "new_membership_plan",
    MEMBERSHIP_PLAN_UPGRADE: "membership_plan_upgrade",
    MEMBERSHIP_PLAN_RENEWAL: "membership_plan_renewal",
    MEMBERSHIP_PLAN_TOPUP: "membership_plan_topup",
    MEMBERSHIP: "membership",
    TOP_UP: "top_up",
    RENEW: "renew",
    MEMBERSHIP_PLAN_LIMIT_EXHAUST: "membership_plan_limit_exhaust",
    MEMBERSHIP_FREE_TRAIL_EXHAUST: "membership_free_trail_exhaust",
    PLAN_LIMIT_EXHAUST: "plan_limit_exhaust",
    FREE_TRAIL_EXHAUST: "free_trail_exhaust",
    UPGRADE: "upgrade"
};
const VWOEvents = {
    sign_up_success: "sign_up",
    login_success: "login_success",
    bid_success: "bid_success",
    post_lorry_success: "post_lorry_success",
    post_load_success: "post_load_success"
};
const GA4EventNamesAdminConsole = {
    /**
     * Admin sidenav
     */
    ADMIN_USER_TYPE: {
        TSO: "tso"
    },
    SIDE_NAV: {
        home_clicked: "home_clicked",
        load_posted_clicked: "load_posted_clicked",
        intransit_loads_clicked: "intransit_loads_clicked",
        lorry_posted_clicked: "lorry_posted_clicked",
        intransit_lorries_clicked: "intransit_lorries_clicked",
        load_enquirycards_clicked: "load_enquirycards_clicked",
        lorry_enquirycards_clicked: "lorry_enquirycards_clicked",
        loadmarket_clicked: "loadmarket_clicked",
        lorrymarket_clicked: "lorrymarket_clicked",
        myusers_clicked: "myusers_clicked",
        claimuser_clicked: "claimuser_clicked"
    },
    /**
     * Event attribute
     */
    TSO_SOURCE_SCREEN: {
        tso_side_nav_bar: "tso_side_nav_bar",
        tso_home: "tso_home",
        tso_load_posted: "tso_load_posted",
        tso_intransit_loads: "tso_intransit_loads",
        tso_lorry_posted: "tso_lorry_posted",
        tso_intransit_lorries: "tso_intransit_lorries",
        tso_load_enquirycards: "tso_load_enquirycards",
        tso_lorry_enquirycards: "tso_lorry_enquirycards",
        tso_load_market: "tso_load_market",
        tso_lorry_market: "tso_lorry_market",
        tso_my_users: "tso_my_users",
        tso_claim_users: "tso_claim_users",
        tso_load_listings: "tso_load_listings",
        tso_intransit_load_listings: "tso_intransit_load_listings",
        tso_lorry_listings: "tso_lorry_listings",
        tso_intransit_lorry_listings: "tso_intransit_lorry_listings"
    },
    //Active loads
    TSO_LOAD_POSTED_SCREEN: {
        searchby_selected: "searchby_selected",
        onchange_search_input: "onchange_search_input",
        editload_clicked: "editload_clicked",
        verifyload_clicked: "verifyload_clicked",
        load_card_clicked: "load_card_clicked",
        call_initiated: "call_initiated"
    },
    //In transit loads
    TSO_IN_TRANSIT_LOAD_SCREEN: {},
    TSO_LOAD_DETAILS_SCREEN: {
        removed_from_market: "removed_from_market",
        bids_clicked: "bids_clicked",
        view_live_lorries_clicked: "view_live_lorries_clicked",
        filters_selected: "filters_selected",
        view_details: "view_details"
    },
    //Active lorries
    TSO_LORRY_POSTED_SCREEN: {
        searchby_selected: "searchby_selected",
        onchange_search_input: "onchange_search_input",
        editlorry_clicked: "editlorry_clicked",
        verifylorry_clicked: "verifylorry_clicked",
        lorry_card_clicked: "lorry_card_clicked",
        call_initiated: "call_initiated"
    },
    //In transit loads
    TSO_IN_TRANSIT_LORRY_SCREEN: {},
    TSO_LORRY_DETAILS_SCREEN: {
        removed_from_market: "removed_from_market",
        bids_clicked: "bids_clicked",
        view_live_loads_clicked: "view_live_loads_clicked",
        filters_selected: "filters_selected",
        view_details: "view_details"
    },
    TSO_USER_PROFILE: {
        searchby_selected: "searchby_selected",
        view_profile_clicked: "view_profile_clicked",
        call_initiated: "call_initiated",
        filters_selected: "filters_selected"
    }
};
const LoadScreenEvents = {
    load_listing_clicked: "load_listing_clicked",
    my_bids_clicked: "my_bids_clicked",
    post_load_button_click: "post_load_button_click",
    filters_clicked: "filters_clicked",
    filters_selected: "filters_selected",
    repost_load_clicked: "repost_load_clicked",
    load_card_clicked: "load_card_clicked",
    shareonwhatsapp_clicked: "shareonwhatsapp_clicked",
    sharedonwhatsapp: "sharedonwhatsapp",
    details_clicked: "details_clicked"
};
const LorryScreenEvents = Object.assign(Object.assign({}, LoadScreenEvents), { lorry_listing_clicked: "lorry_listing_clicked", my_bids_clicked: "my_bids_clicked", add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn", lorry_card_clicked: "lorry_card_clicked", reactivate_lorry_clicked: "reactivate_lorry_clicked", document_upload_clicked: "document_upload_clicked", document_uploaded: "document_uploaded", reactivated_lorry: "reactivated_lorry" });
const BidCardEvents = {
    bid_card_clicked: "bid_card_clicked",
    bid_negotiate_clicked: "bid_negotiate_clicked",
    bid_accept_clicked: "bid_accept_clicked",
    cancel_bidding: "cancel_bidding",
    bid_accepted: "bid_accepted",
    bid_amount_entered: "bid_amount_entered",
    attach_lorry_clicked: "attach_lorry_clicked",
    add_lorry_attach_lorry_btn: "add_lorry_attach_lorry_btn",
    lorry_and_driver_details_added: "lorry_and_driver_details_added",
    call_initiated: "call_initiated",
    bid_negotiated: "bid_negotiated",
    load_bid_negotiated: "load_bid_negotiated",
    lorry_bid_negotiated: "lorry_bid_negotiated",
    select_from_existing_clicked: "select_from_existing_clicked",
    lorry_attached_successfully: "lorry_attached_successfully"
};
const LoadPostingFormEvents = {
    pickup_location_initiated_loadform: "pickup_location_initiated_loadform",
    drop_location_initiated_loadform: "drop_location_initiated_loadform",
    load_form_material_name_entered: "load_form_material_name_entered",
    load_form_quantity_entered: "load_form_quantity_entered",
    load_form_capacity_entered: "load_form_capacity_entered",
    load_form_next_step_1_click: "load_form_next_step_1_click",
    load_form_edit_step_1_click: "load_form_edit_step_1_click",
    load_form_update_step_1_click: "load_form_update_step_1_click",
    load_form_vehicle_added: "load_form_vehicle_added",
    load_form_body_type_selection: "load_form_body_type_selection",
    load_form_tyres_selection: "load_form_tyres_selection",
    load_form_next_step_2_click: "load_form_next_step_2_click",
    load_form_edit_step_2_click: "load_form_edit_step_2_click",
    load_form_update_step_2_click: "load_form_update_step_2_click",
    load_post_payment_type: "load_post_payment_type",
    load_form_advance_enter: "load_form_advance_enter",
    load_form_expected_price_enter: "load_form_expected_price_enter",
    load_form_odc_selected: "load_form_odc_selected",
    load_form_odc_length_entered: "load_form_odc_length_entered",
    load_form_odc_breadth_entered: "load_form_odc_breadth_entered",
    load_form_odc_height_entered: "load_form_odc_height_entered",
    load_form_post_repost_load_button_click: "load_form_post_repost_load_button_click",
    load_post_successfully: "load_post_successfully",
    load_post_failure: "load_post_failure",
    view_live_lorries_clicked: "view_live_lorries_clicked",
    total_load_post: "total_load_post",
    load_lorry_post_repost_success: "load_lorry_post_repost_success",
    reposted_load: "reposted_load"
};
const AssuredLoadEvents = {
    payment_pay_now_btn: "payment_pay_now_btn",
    payment_success: "payment_success"
};
const AdminMiscEvents = {
    admin_notification_trigger: "admin_notification_trigger",
    admin_send_journey_feedback: "admin_send_journey_feedback"
};


//# sourceMappingURL=event-names.js.map


/***/ }),

/***/ 3000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lj": function() { return /* binding */ MostSearchedLinksItemsGaEvents; },
/* harmony export */   "v5": function() { return /* binding */ FooterItemsGaEvents; }
/* harmony export */ });
/* unused harmony export HeaderItemsGaEvents */
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);
/* harmony import */ var _mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16593);



const FooterItemsGaEvents = {
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.ABOUT_US */ .gt.ABOUT_US]: 0,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.CONTACT_US */ .gt.CONTACT_US]: 1,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.CAREERS */ .gt.CAREERS]: 2,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.FAQ */ .gt.FAQ]: 3,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.TERMS_AND_CONDITION */ .gt.TERMS_AND_CONDITION]: 4,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.PAYMENT_GUIDELINES */ .gt.PAYMENT_GUIDELINES]: 5,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.PRIVACY_POLICY */ .gt.PRIVACY_POLICY]: 6,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.CONNECT_WITH_US */ .gt.CONNECT_WITH_US]: 7,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.DOWNLOAD_OUR_APP */ .gt.DOWNLOAD_OUR_APP]: 8,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .FooterItemsConstant.CASHBACK_TERMS_AND_CONDITIONS */ .gt.CASHBACK_TERMS_AND_CONDITIONS]: 10
};
const HeaderItemsGaEvents = {
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .HeaderItemsConstants.SERVICE_MENU */ .kQ.SERVICE_MENU]: 0,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .HeaderItemsConstants.MARKETPLACE */ .kQ.MARKETPLACE]: 1,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .HeaderItemsConstants.TRANSPORT_DIRECTORY */ .kQ.TRANSPORT_DIRECTORY]: 2,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .HeaderItemsConstants.RESOURCES_MENU */ .kQ.RESOURCES_MENU]: 3,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .HeaderItemsConstants.COMPANY_MENU */ .kQ.COMPANY_MENU]: 4,
    [_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .HeaderItemsConstants.LOGIN */ .kQ.LOGIN]: 5
};
const MostSearchedLinksItemsGaEvents = {
    [_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__/* .mostSearchedLinksMenusKeys.ONLINE_TRUCK_BOOKING */ .s.ONLINE_TRUCK_BOOKING]: 0,
    [_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__/* .mostSearchedLinksMenusKeys.ONLINE_LOAD_BOOKING */ .s.ONLINE_LOAD_BOOKING]: 1,
    [_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__/* .mostSearchedLinksMenusKeys.TRANSPORTER */ .s.TRANSPORTER]: 2,
    [_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__/* .mostSearchedLinksMenusKeys.TRANSPORT_SERVICE */ .s.TRANSPORT_SERVICE]: 3,
    [_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__/* .mostSearchedLinksMenusKeys.TRANSPORT_DIRECTORY */ .s.TRANSPORT_DIRECTORY]: 4,
    [_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_1__/* .mostSearchedLinksMenusKeys.LORRY */ .s.LORRY]: 5
};


//# sourceMappingURL=eventsMapObj.js.map


/***/ }),

/***/ 94204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pmi": function() { return /* reexport */ loadStatus/* ACTION_BY_LOAD_STATUS */.pm; },
  "EsW": function() { return /* reexport */ lorryStatus/* ACTION_BY_LORRY_STATUS */.Es; },
  "pGF": function() { return /* reexport */ authorizedUsers/* ALLOWED_ACTION_BY_ROLES */.pG; },
  "wU2": function() { return /* reexport */ api/* API_REQUEST_TYPE */.wU; },
  "l5v": function() { return /* reexport */ constants_link/* APP_STORE_URL */.l5; },
  "T8S": function() { return /* reexport */ event_names/* AdminMiscEvents */.T8; },
  "UEC": function() { return /* reexport */ bidStatus/* BID_STATUS */.UE; },
  "SXn": function() { return /* reexport */ companyDetails/* COMPANY_DETAILS */.S; },
  "RmR": function() { return /* reexport */ socialMediaLinks/* COMPANY_SOCIAL_MEDIA_CHANNELS */.Rm; },
  "E9G": function() { return /* reexport */ misc/* COOKIES */.E9; },
  "AAU": function() { return /* reexport */ serviceTypeId/* CompanyServiceType */.AA; },
  "s6W": function() { return /* reexport */ serviceTypeId/* CompanyServiceTypeMap */.s6; },
  "DLC": function() { return /* reexport */ misc/* DefaultCookieOptions */.DL; },
  "qsA": function() { return /* reexport */ payment/* EXPECTED_AMOUNT_TYPE */.qs; },
  "Q9J": function() { return /* reexport */ payment/* ExpectedAmountType */.Q9; },
  "DCW": function() { return /* reexport */ Faq/* FaqQuestions */.DC; },
  "GB4": function() { return /* reexport */ Faq/* FaqSlugsConstant */.GB; },
  "wQR": function() { return /* reexport */ event_names/* GA4EventNames */.wQ; },
  "rWq": function() { return /* reexport */ event_names/* GA4EventNamesAdminConsole */.rW; },
  "UDd": function() { return /* reexport */ event_names/* GA4LoginOrRegistrationModalEventAttributes */.UD; },
  "gVt": function() { return /* reexport */ automation/* IDs */.g; },
  "TSr": function() { return /* reexport */ misc/* IMG_BASE_URL */.TS; },
  "Jtx": function() { return /* reexport */ loadStatus/* LOAD_STATUS */.Jt; },
  "vOh": function() { return /* reexport */ loadStatus/* LOAD_STATUS_TEXT */.vO; },
  "ixR": function() { return /* reexport */ lorryTypes/* LORRY_BODY_TYPE_MAP */.ix; },
  "f5d": function() { return /* reexport */ lorryTypes/* LORRY_CAPACITY_UNIT_TYPES */.f5; },
  "SvH": function() { return /* reexport */ lorryTypes/* LORRY_CATEGORIES_ENUM */.Sv; },
  "unN": function() { return /* reexport */ lorryStatus/* LORRY_STATUS */.un; },
  "sUU": function() { return /* reexport */ lorryStatus/* LORRY_STATUS_TEXT */.sU; },
  "lIE": function() { return /* reexport */ languages/* Languages */.lI; },
  "E_m": function() { return /* reexport */ event_names/* LoadPostingFormEvents */.E_; },
  "X5m": function() { return /* reexport */ market/* MARKET_TYPE */.X5; },
  "nbI": function() { return /* reexport */ tab/* MY_LOAD_LORRY_TABS */.n; },
  "CY3": function() { return /* reexport */ market/* MarketPlaceType */.CY; },
  "LEv": function() { return /* reexport */ event_names/* NOT_APPLICABLE */.LE; },
  "jtj": function() { return /* reexport */ api/* NoSuccessErrorHandler */.jt; },
  "V_z": function() { return /* reexport */ payment/* PAYMENT_TYPE */.V_; },
  "dhr": function() { return /* reexport */ payment/* PAYMENT_TYPE_MAP */.dh; },
  "vE2": function() { return /* reexport */ misc/* PRODUCTION_ENV */.vE; },
  "QWG": function() { return /* reexport */ bidStatus/* PostAcceptanceBidStatusList */.QW; },
  "Z6p": function() { return /* reexport */ routeStrings/* ROUTES */.Z; },
  "t44": function() { return /* reexport */ StateList/* STATE_LIST */.t4; },
  "R1N": function() { return /* reexport */ screenId/* ScreenId */.R; },
  "VPA": function() { return /* reexport */ serviceTypeId/* ServiceTypeId */.VP; },
  "xao": function() { return /* reexport */ serviceTypeId/* ServiceTypeIdName */.x; },
  "Y4O": function() { return /* reexport */ lorryTypes/* TRUCK_BODY_TYPES */.Y4; },
  "tfp": function() { return /* reexport */ authorizedUsers/* USER_GROUP */.tf; },
  "Vwu": function() { return /* reexport */ userAction/* UserAction */.V; },
  "BLy": function() { return /* reexport */ userScreenId/* UserScreenId */.B; },
  "FWD": function() { return /* reexport */ authorizedUsers/* UserType */.FW; },
  "O6d": function() { return /* reexport */ event_names/* VWOEvents */.O6; },
  "ZMV": function() { return /* reexport */ event_names/* WEB_V2_SOURCE_SCREENS */.ZM; },
  "waf": function() { return /* reexport */ regex/* companyNameCharLimit */.w; },
  "UE5": function() { return /* reexport */ lorryTypes/* getAllowedVehicleList */.UE; },
  "mCA": function() { return /* reexport */ lorryTypes/* getLorryDetailsByName */.mC; },
  "X9c": function() { return /* reexport */ lorryTypes/* getLorryDetailsByType */.X9; },
  "Vxo": function() { return /* reexport */ serviceTypeId/* getServiceTypeId */.Vx; },
  "sBh": function() { return /* reexport */ lorryTypes/* getVehicleInfoByLorryType */.sB; },
  "IOp": function() { return /* reexport */ getWebConfig; },
  "R0m": function() { return /* reexport */ lorryTypes/* initLorryList */.R0; },
  "KzW": function() { return /* reexport */ regex/* referralCodeCharLimit */.Kz; }
});

// UNUSED EXPORTS: ALLOWED_LORRY_CATEGORY_IDS, ALL_ADMIN_ROLES, ALL_LOAD_STATUS, APP_LAUNCH_URL, APP_LINK, AllBidStatusForCsDashboard, ApiKeyFilter, ApiKeyFilterToBooleanMap, AssuredLoadEvents, BID_HISTORY_STATUS_MAP, BID_STATUS_TEXT, BID_UPDATE_TYPE, BULK_LOAD_CARD_STATUS_TEXT, BadgeTypes, BidCardEvents, CACHE_NAME, CASHFREE_PAYMENT_SUCCESS_STATUS, CITIES_WITH_CITY_PAGES, CUSTOM_EVENTS, ClubbedLoadStatus, CommonServiceType, ComponentState, DEEPLINK_BASE_URL, DEFAULT_COMPANY_LOGO, DEFAULT_LANG, EXPIRED_LORRY_STATUS, ExpectedAmountTypeNameMapping, FACEBOOK, FB_CAPI_TOKEN, FB_PIXEL_ID, FEATURE_URLS, FONT_WEIGHTS, FOOTER_ITEM_ATTRIBUTE, FORM_URLS, FaqCategories, FooterItemsConstant, FooterItemsGaEvents, GA4AppClickSource, GA4BidNowClickSource, GA4BidSubmitSource, GA4BusinessCardSource, GA4CallBtnClickSource, GA4ContactUsClickSource, GA4HeaderServiceEventValues, GA4HomePageBtnClickEventValues, GA4HomePageBtnClickLocationEventValues, GA4HomePageMeetTransportServiceProvidersEventValues, GA4HomePageWhatCanWeDoEventValues, GA4HomepageBookRightLoadAfterLorryCategorySelectionEventValues, GA4HomepageBookRightLoadEventValues, GA4HomepageFindTransporterAfterLorrySelectionEventValues, GA4HomepageFindTransporterEventValues, GA4HomepageOtherActivityEventValues, GA4HomepageVahakMediaSelectionEventValues, GA4LoadPostingSource, GA4LorryPostingSource, GA4MarketPlaceFilterClickSource, GA4MembershipEventAttributes, GA4PostLoadLorryInitClickSource, GA4ServicePageFullTruckLoadEventValues, GA4ServicePageGrowNetworkEventValues, GA4ServicePageLogisticsServicesEventValues, GA4ServicePageOnlineLoadBookingEventValues, GA4ServicePageOnlineTruckBookingEventValues, GA4ServicePagePartTruckLoadEventValues, GA4ViewAllClickSource, GstNumberRegexExpNew, HEADER_ITEM_ATTRIBUTE, HeaderItemsConstants, HeaderItemsGaEvents, IMAGE_URLS, IMG_BASE_URL_NEXTJS, INSTAGRAM, IP_DATA_KEY, KAMUser, KYC_VERIFICATION_METHODS_TYPE_URL, LINKEDIN, LOAD_STATUS_TEXT_MAP, LOC_STORAGE, LORRY_BODY_TYPE, LORRY_CATEGORIES, LoadScreenEvents, LorryNameToNumberMap, LorryNumRegExp, LorryScreenEvents, MARKET_TYPE_MAP, MEMBERSHIP_FEATURE, MINIMUM_QUANTITY, MINIMUM_QUANTITY_LIT, MostSearchedLinksItemsGaEvents, NAV_MENU_STRINGS, NAV_UI_LANGUAGES, NEW_LORRY_CAPACITY, PAYMENT_STATUS, PLATFORM_STATS, PLAYSTORE_URLS, PageTypes, Pages, PlivoTeam, PopularDest, REF_VIEWPORT_HEIGHT, REF_VIEWPORT_WIDTH, RupeeSymbol, SERVICE_TYPE_OPTIONS, SESSION, SOURCE_UTM, STATE_ID_LIST, STATE_ID_LIST_NOT_FOR_TESTING, ScreenNameMap, TEST_LOAD_STATE_ID, TWITTER, TWITTER_HANDLE, TapNGoTopCityIds, USER_PROFILE_MODAL_TITLE, UserActionRequiredResponse, VAHAK_EMAIL, VAHAK_EMAIL_INFO, VAHAK_PHONE, VehicleBodyOptionsType, VehicleTypeBodyTypeMap, WHATSAPP_CHAT, YOUTUBE, aadharNoRegExp, cashbackTermsandConditions, companyNameCharMin, companyNameRegExpMsg, deriveVehicleBodyFilterValue, generateLorryList, getNavLanguagesForRoute, getPlatformStatI18nLabels, gstNoRegExp, moEngageLoadBidSource, moEngageLorryBidSource, mostSearchedLinksMenus, mostSearchedLinksMenusKeys, panNoRegExp, phoneRegExp, pincodeRegExp, plotNoRegExp, referralCodeRegExp, useFaqCategories, useFaqQuestions

// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/automation.js
var automation = __webpack_require__(46426);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
;// CONCATENATED MODULE: ../core/dist/constants/cashbackTermsandConditions.js
const cashbackTermsandConditions = [
    {
        headContent: "Definition:",
        subCategoryType: "1",
        subCategories: [
            {
                mainContent: `For the purposes of the Vahak-Cashback T&C, unless the context
                or meaning thereof otherwise requires, the following terms shall
                have the meanings ascribed to them below:`,
                subContents: [
                    ` <b>“Cashback Scheme(s)”</b> means the cashback schemes that
                    have been mentioned in the Vahak-Cashback T&C;`,
                    `<b>“Company”</b> or <b>“Vahak”</b> means Epictus Solutions India Private Limited which expression
                    shall include its parent company;`,
                    `<b>“Cumulative   Transaction   Cashback   Cap”</b> means   the   capping   of   the Cashback,
                    cumulatively for all Eligible Transactions as mentioned in the specific Cashback Scheme;`,
                    `<b>“Eligible Load Provider”</b> means the Load Provider who makes the payment for an
                    Eligible Transaction;`,
                    `<b>“Existing User”</b> shall mean such Load Provider, who has made any payment or a part
                    thereof using Vahak Payments before the commencement of the Validity Period;`,
                    `<b>“Individual Transaction Cashback Cap”</b> means the capping of the Cashback for that
                    Eligible Transaction, as mentioned in the specific Cashback Scheme;`,
                    `<b>“Load Provider”</b> shall mean and include Shipper, Transport Companies and Brokers, as
                    the case may be;`,
                    `<b>“Lorry   Provider”</b> shall   mean   and   include   Truck   Providers,   Transport Companies and
                    Brokers, as the case may be;`,
                    `<b>“New User”</b> shall mean such Load Provider or Lorry provider, who has not made nor received any payment or a part
                    thereof, using Vahak Payments before the commencement of the Validity Period;`,
                    `<b>“Platform(s)”</b> shall mean the mobile application by the name of Vahak: Book Online
                    Truck, Load available on google playstore and the website bearing the URL
                    <a href="https://www.vahak.in/">https://www.vahak.in/</a>;`,
                    `<b>“User(s)”</b> shall mean the Existing User(s) and the New User(s), collectively;`,
                    `<b>“Vahak- Cashback T&C”</b> shall mean the terms and conditions contained herein;`,
                    `<b>“Vahak Payment”</b> refers to a transaction between a Load Provider and Lorry Provider
                    wherein the entire payment for the transaction is made on the Platform;`,
                    `<b>“Validity Period’”</b> shall mean a transaction made on and between <b>April 11, 2022</b> and
                    <b>March 31, 2023</b> (both days inclusive) or such period as maybe decided by the
                    Company, which may be earlier to or later than the date contained herein;`
                ]
            },
            {
                mainContent: `In these, unless the context or meaning thereof otherwise requires:`,
                subContents: [
                    `Words referring to a particular gender are deemed to include the other gender;`,
                    `Words using the singular or plural number also include the plural or singular number, 
                    respectively;`,
                    `The terms “hereof”, ‘herein”, “hereby”, “hereto” and derivative or similar words refer to
                    this entire Vahak- Cashback T&C;`,
                    `The term “clause” refers to the specified clause of this Vahak- Cashback T&C;`,
                    `Reference to any legislation or law or to any provision thereof shall include references to
                    any such law as it may, after the date hereof, from time to time, be amended,
                    supplemented or re-enacted, and any reference to a statutory provision shall include any
                    subordinate legislation made from time to time under that provision;`,
                    `Any term or expression used but not defined herein shall have the same meaning
                    attributable to it under applicable laws;`,
                    `References to the word “include” or “including” shall be construed without limitation;`,
                    `Each of the representations, warranties and undertakings contained hereof shall be
                    separate and independent and shall not be limited by reference to any other clause or by
                    anything in this Vahak- Cashback T&C;`,
                    `In the event of any disagreement, the decision of the Company shall be final and binding;
                    and`,
                    `re-enacted, and any reference to a statutory provision shall include any subordinate
                    legislation made from time to time under that provision.`
                ]
            }
        ]
    },
    {
        headContent: `The purpose of the Vahak-Cashback T&C is to specify and mention in clear terms, the terms
        and conditions that govern the Cashback Scheme, being referred to herein. The Vahak-
        Cashback T&C are applicable to determine the Cashback on the payment made by the Load
        Provider to Lorry Provider using Vahak Payment.`
    },
    {
        headContent: `<b>IT IS ADVISED THAT BEFORE MAKING ANY PAYMENT USING VAHAK PAYMENT -A
        USER SHOULD THOROUGHLY READ, UNDERSTAND AND THEN ACCEPT THE DISCLAIMER AND THE
        GUIDELINE BY LORRY PROVIDER. THE UNDERTAKING AND
        GUIDELINE SHALL BE DEEMED INCORPORATED HEREIN BY WAY OF REFERENCE.
        VAHAK SHALL NOT BE RESPONSIBLE IN ANY MANNER WHATSOEVER FOR ANY
        DISPUTE BETWEEN THE LORRY PROVIDER AND THE LOAD PROVIDER.</b>`
    },
    {
        headContent: `In order to be eligible to receive and/or qualify for the Cashback, the Load Provider shall be
        required to make payment for the transaction using Vahak Payment and should ensure that
        the transaction should satisfy all the other conditions, criterion as has been contained herein:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `The transaction should be carried out within the Validity Period;`
            },
            {
                mainContent: `The payment for transaction made must be E-way bill verified and such E-way bill
                must have expired;`
            },
            {
                mainContent: `The Lorry Provider and the Load Provider should have their KYC and GST/PAN/RC (as
                    applicable) verified and the same should reflect in the records of the Company, at the
                    time of making the transaction; and`
            },
            {
                mainContent: `The entire payment for the transaction should have been made using Vahak Payments
                and no part of it should be pending and/or disputed.`
            }
        ],
        extraContent: `<br />When a transaction qualifies all the conditions mentioned in (a) to (d) above, the
        transaction will be referred to as <b>“Eligible Transaction”</b>.<br/>`
    },
    {
        headContent: `For the avoidance of doubt, it is made clear that for the purpose of calculating CTV, any
        amount of GST or applicable taxes etc, as paid by the Load Provider to the Lorry Provider as
        reflected in the invoice amount, shall be excluded.`
    },
    {
        headContent: `The Cashback is subject to the following:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `The Individual Transaction Cashback Cap and the Cumulative Transaction Cashback
                Cap;`
            },
            {
                mainContent: `Maximum 1 (one) Eligible Transactions with a
                particular Load Provider and  Lorry Provider shall be considered for calculating CTV and Cashback. For the
                avoidance of doubt, it is made clear that all other Eligible Transactions that have not been
                entered into, by and between the Load Provider and the same Lorry Provider, shall be
                considered for calculating CTV and Cashback;`
            },
            {
                mainContent: `Payment value of each eligible transaction should be more than or equal to INR
                10,000 (Indian Rupees Ten Thousand only) and less than or equal to  INR  50,000
                (Indian Rupees Fifty Thousand only). Only these transactions will be eligible for cashback
                schemes;`
            },
            {
                mainContent: `Cumulative transaction value (via vahak payment across lifetime) for the eligible Load
                provider should be less than or equal to INR 10,00,000 (Indian Rupees Ten lakhs only).
                Only transactions up to this limit will be eligible for cashback schemes.`
            }
        ]
    },
    {
        headContent: `order to receive the Cashback, the User is required to share his/her bank account number and
        other details (as sought) on the Platform and post verification of the same, the Cashback shall
        be credited within 15 days from the expiry of the Validity Period or 15 days from the date the
        complete details were shared by the User on the Platform, whichever is later.`
    },
    {
        headContent: `The Company reserves the exclusive right to:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `refuse Cashback to any User in whole or in part, without assigning any reason
                whatsoever;`
            },
            {
                mainContent: `amend, modify – in whole or in part, the Vahak - Cashback T&C, including but not limited
                to the Validity Period, Cashback Scheme etc; and`
            },
            {
                mainContent: `withdraw the Cashback Scheme(s) at any time without providing any reason and without
                providing any prior intimation or notice.`
            }
        ]
    },
    {
        headContent: `In case of any concern, query etc., please write an email to cs@vahak.in with the subject
        line ‘Online Payment Cashback incentive’ necessarily including the following details:`,
        subCategoryType: "a",
        subCategories: [
            {
                mainContent: `Load details;`
            },
            {
                mainContent: `Your communication details; and`
            },
            {
                mainContent: `Particulars of the dispute or query.`
            }
        ]
    },
    {
        headContent: `Disputes, if any, are subject to the exclusive jurisdiction of the competent courts at Bengaluru
        (Karnataka).`
    },
    {
        headContent: `Refer and Earn <b>(only)</b> Terms & Conditions:`,
        subCategories: [
            {
                mainContent: `Coins can be used for Cashback & VAS services only.`
            },
            {
                mainContent: `Coins can't be converted into Rupees`
            }
        ]
    }
];


//# sourceMappingURL=cashbackTermsandConditions.js.map

// EXTERNAL MODULE: ../core/dist/constants/companyDetails.js
var companyDetails = __webpack_require__(51061);
// EXTERNAL MODULE: ../core/dist/constants/platformStats.js
var platformStats = __webpack_require__(28230);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
;// CONCATENATED MODULE: ../core/dist/constants/minimumQuantity.js
const MINIMUM_QUANTITY = [
    { valueObj: { min: 1, max: 5 }, id: 0, value: "1-5", label: "1 - 5 Ton" },
    { valueObj: { min: 5, max: 10 }, id: 1, value: "5-10", label: "5 - 10 Ton" },
    { valueObj: { min: 10, max: 15 }, id: 2, value: "10-15", label: "10 - 15 Ton" },
    { valueObj: { min: 15, max: 20 }, id: 3, value: "15-20", label: "15 - 20 Ton" },
    { valueObj: { min: 20, max: 25 }, id: 4, value: "20-25", label: "20 - 25 Ton" },
    { valueObj: { min: 25, max: Infinity }, id: 5, value: "25", label: "25+ Ton" }
];
const MINIMUM_QUANTITY_LIT = [
    { valueObj: { min: 1, max: 10 }, id: 6, value: "1-10000", label: "1 - 10k Ltr" },
    { valueObj: { min: 10, max: 20 }, id: 7, value: "10000-20000", label: "10k - 20k Ltr" },
    { valueObj: { min: 20, max: 30 }, id: 8, value: "20000-30000", label: "20k - 30k Ltr" },
    { valueObj: { min: 30, max: 40 }, id: 9, value: "30000-40000", label: "30k - 40k Ltr" },
    { valueObj: { min: 40, max: 50 }, id: 10, value: "40000-50000", label: "40k - 50k Ltr" },
    { valueObj: { min: 50, max: Infinity }, id: 11, value: "50000", label: "50k+ Ltr" }
];


//# sourceMappingURL=minimumQuantity.js.map

// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/constants/ServiceType.js + 4 modules
var ServiceType = __webpack_require__(79109);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/socialMediaLinks.js
var socialMediaLinks = __webpack_require__(92683);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
;// CONCATENATED MODULE: ../core/dist/constants/urls.js


const IMAGE_URLS = {
    PREMIUM_LAUNCH_BADGE_GIF: `${misc/* IMG_BASE_URL */.TS}/premium-launch-banner.gif`
};
const FORM_URLS = {
    PREMIUM_LAUNCH_G_FORM: "https://docs.google.com/forms/d/e/1FAIpQLSdCM8q6QFmUJ7vBbsvnwBLnlngz8mRq3fcjTbJenBJUp--t5g/viewform"
};
const KYC_VERIFICATION_METHODS_TYPE_URL = "https://vahak-tr.s3.ap-south-1.amazonaws.com/KycVerificationType.json";


//# sourceMappingURL=urls.js.map

// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/regex.js
var regex = __webpack_require__(14263);
// EXTERNAL MODULE: ../core/dist/constants/tab.js
var tab = __webpack_require__(71076);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
// EXTERNAL MODULE: ../core/dist/constants/userScreenId.js
var userScreenId = __webpack_require__(98606);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
;// CONCATENATED MODULE: ../core/dist/constants/web-config.js


const WebConfig = {
    DEV: {
        logout_timer: 1,
        odc_enabled: [2285, 16214]
    },
    PROD: {
        logout_timer: 10,
        odc_enabled: [2672746, 3306463]
    }
};
const getWebConfig = () => {
    return _services_const/* IS_PROD_ENV */.c ? WebConfig["PROD"] : WebConfig["DEV"];
};


//# sourceMappingURL=web-config.js.map

;// CONCATENATED MODULE: ../core/dist/constants/index.js





































//# sourceMappingURL=index.js.map


/***/ }),

/***/ 87013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hj": function() { return /* binding */ DEFAULT_LANG; },
/* harmony export */   "ft": function() { return /* binding */ NAV_MENU_STRINGS; },
/* harmony export */   "hr": function() { return /* binding */ getNavLanguagesForRoute; },
/* harmony export */   "lI": function() { return /* binding */ Languages; }
/* harmony export */ });
/* unused harmony export NAV_UI_LANGUAGES */
/* harmony import */ var _userScreenId_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98606);


const Languages = [
    {
        id: 0,
        value: "en",
        labelInEn: "English",
        labelInLanguage: ""
    },
    {
        id: 1,
        value: "hi",
        labelInEn: "Hindi",
        labelInLanguage: "हिंदी"
    },
    {
        id: 2,
        value: "gu",
        labelInEn: "Gujarati",
        labelInLanguage: "ગુજરાતી"
    },
    {
        id: 3,
        value: "te",
        labelInEn: "Telugu",
        labelInLanguage: "తెలుగు"
    },
    {
        id: 4,
        value: "kn",
        labelInEn: "Kannada",
        labelInLanguage: "ಕನ್ನಡ"
    }
];
const NAV_UI_LANGUAGES = Languages.filter((language) => language.value === "en" || language.value === "hi");
const DEFAULT_LANG = 0;
const NAV_MENU_STRINGS = [
    {
        menu: "/",
        languages: NAV_UI_LANGUAGES
    },
    {
        menu: "transporters",
        languages: NAV_UI_LANGUAGES
    },
    {
        menu: "frequently-asked-questions",
        languages: NAV_UI_LANGUAGES
    },
    {
        menu: _userScreenId_js__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.cargoInsurance.pathname */ .B.cargoInsurance.pathname,
        languages: NAV_UI_LANGUAGES
    }
];
function getNavLanguagesForRoute(pathname, asPath) {
    const pathWithoutQuery = asPath.split("?")[0];
    return NAV_MENU_STRINGS.find((item) => {
        if (item.menu === "/") {
            return pathname === "/";
        }
        if (item.menu.startsWith("/")) {
            return pathname === item.menu;
        }
        return pathWithoutQuery.includes(item.menu);
    });
}


//# sourceMappingURL=languages.js.map


/***/ }),

/***/ 39422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HS": function() { return /* binding */ PLAYSTORE_URLS; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; }
/* harmony export */ });
/* unused harmony exports APP_LAUNCH_URL, DEEPLINK_BASE_URL, FEATURE_URLS */
const DEEPLINK_BASE_URL = "https://6r7cz.app.link";
var PLAYSTORE_URLS;
(function (PLAYSTORE_URLS) {
    PLAYSTORE_URLS["loadOfflineBidSuccess"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&campaign_source=website&campaign_medium=offline-bidding&campaign_term=&campaign_content=&campaign_name=load-offline-bid-success&ad_network=";
    PLAYSTORE_URLS["lorryOfflineBidSuccess"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&campaign_source=website&campaign_medium=offline-bidding&campaign_term=&campaign_content=&campaign_name=lorry-offline-bid-success&ad_network=";
    PLAYSTORE_URLS["loadOfflineBidExpired"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&campaign_source=website&campaign_medium=offline-bidding&campaign_term=&campaign_content=&campaign_name=load-offline-bid-expired&ad_network=";
    PLAYSTORE_URLS["lorryOfflineBidExpired"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&campaign_source=website&campaign_medium=offline-bidding&campaign_term=&campaign_content=&campaign_name=lorry-offline-bid-expired&ad_network=";
    PLAYSTORE_URLS["transporterSearchPage"] = "https://6r7cz.app.link/getstartedtd";
    PLAYSTORE_URLS["loadMarketCTA1"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&campaign_source=website&campaign_medium=transport-marketplace&campaign_term=&campaign_content=&campaign_name=cta&ad_network=";
    PLAYSTORE_URLS["loadMarketCTA2"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&campaign_source=website&campaign_medium=transport-marketplace&campaign_term=&campaign_content=&campaign_name=re-cta&ad_network=";
    PLAYSTORE_URLS["homeTryForFree"] = "https://6r7cz.app.link/tryforfree";
    PLAYSTORE_URLS["homeCTAbanner"] = "https://6r7cz.app.link/downloadnow";
    PLAYSTORE_URLS["homeBenefits"] = "https://play.google.com/store/apps/details?id=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&hl=en_IN&gl=US";
})(PLAYSTORE_URLS || (PLAYSTORE_URLS = {}));
const APP_STORE_URL = "https://apps.apple.com/in/app/vahak-lcv-truck-booking/id6473833409";
const APP_LAUNCH_URL = "https://vahak.page.link/ceVR";
var FEATURE_URLS;
(function (FEATURE_URLS) {
    FEATURE_URLS["featureOne"] = "https://6r7cz.app.link/f1booknow";
    FEATURE_URLS["featureTwo"] = "https://6r7cz.app.link/createonlinebrand";
    FEATURE_URLS["featureThree"] = "https://6r7cz.app.link/grownetwork";
    FEATURE_URLS["featureFour"] = "https://6r7cz.app.link/startforfree";
    FEATURE_URLS["featureFive"] = "https://6r7cz.app.link/getstartedf5";
    FEATURE_URLS["featureSix"] = "https://6r7cz.app.link/startbidding";
})(FEATURE_URLS || (FEATURE_URLS = {}));


//# sourceMappingURL=link.js.map


/***/ }),

/***/ 61834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CO": function() { return /* binding */ LOAD_STATUS_TEXT_MAP; },
/* harmony export */   "Jt": function() { return /* binding */ LOAD_STATUS; },
/* harmony export */   "SX": function() { return /* binding */ ALL_LOAD_STATUS; },
/* harmony export */   "or": function() { return /* binding */ ClubbedLoadStatus; },
/* harmony export */   "pm": function() { return /* binding */ ACTION_BY_LOAD_STATUS; },
/* harmony export */   "vO": function() { return /* binding */ LOAD_STATUS_TEXT; }
/* harmony export */ });
/**
 * For Premium
 * In Progress - ACTIVE + WITH SOME BIDS
 */
var LOAD_STATUS;
(function (LOAD_STATUS) {
    LOAD_STATUS[LOAD_STATUS["ALL"] = -1] = "ALL";
    LOAD_STATUS[LOAD_STATUS["EXPIRED"] = 0] = "EXPIRED";
    LOAD_STATUS[LOAD_STATUS["COMPLETED"] = 1] = "COMPLETED";
    LOAD_STATUS[LOAD_STATUS["ACTIVE"] = 3] = "ACTIVE";
    LOAD_STATUS[LOAD_STATUS["IN_TRANSIT"] = 4] = "IN_TRANSIT";
    LOAD_STATUS[LOAD_STATUS["STAND_BY"] = 5] = "STAND_BY";
    LOAD_STATUS[LOAD_STATUS["CANCELLED"] = 6] = "CANCELLED";
    LOAD_STATUS[LOAD_STATUS["UNDER_REVIEW"] = 9999] = "UNDER_REVIEW";
})(LOAD_STATUS || (LOAD_STATUS = {}));
const ALL_LOAD_STATUS = [
    LOAD_STATUS.EXPIRED,
    LOAD_STATUS.COMPLETED,
    LOAD_STATUS.ACTIVE,
    LOAD_STATUS.IN_TRANSIT,
    LOAD_STATUS.STAND_BY,
    LOAD_STATUS.CANCELLED
];
var LOAD_STATUS_TEXT;
(function (LOAD_STATUS_TEXT) {
    LOAD_STATUS_TEXT["ALL"] = "All";
    LOAD_STATUS_TEXT["EXPIRED"] = "Expired";
    LOAD_STATUS_TEXT["COMPLETED"] = "Completed";
    LOAD_STATUS_TEXT["ACTIVE"] = "Active";
    LOAD_STATUS_TEXT["IN_TRANSIT"] = "In Transit";
    LOAD_STATUS_TEXT["STAND_BY"] = "Stand By";
    LOAD_STATUS_TEXT["CANCELLED"] = "Cancelled";
    LOAD_STATUS_TEXT["UNDER_REVIEW"] = "Under Review";
})(LOAD_STATUS_TEXT || (LOAD_STATUS_TEXT = {}));
const LOAD_STATUS_TEXT_MAP = {
    [LOAD_STATUS.ALL]: "All",
    [LOAD_STATUS.EXPIRED]: "Expired",
    [LOAD_STATUS.COMPLETED]: "Completed",
    [LOAD_STATUS.ACTIVE]: "Active",
    [LOAD_STATUS.IN_TRANSIT]: "In Transit",
    [LOAD_STATUS.STAND_BY]: "Supplier confirmed",
    [LOAD_STATUS.CANCELLED]: "Cancelled",
    [LOAD_STATUS.UNDER_REVIEW]: "Under Review"
};
const ACTION_BY_LOAD_STATUS = {
    UPDATE_LOADING_TIME: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY, LOAD_STATUS.IN_TRANSIT],
    CS_ATTACH_LORRY: [LOAD_STATUS.IN_TRANSIT],
    CS_LOAD_ASSIGN: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY]
};
const ClubbedLoadStatus = {
    ALL_LOADS: {
        label: "All Loads",
        value: ALL_LOAD_STATUS
    },
    ALL_NON_EXPIRED_LOADS: {
        label: "All Non-Expired Loads",
        value: ALL_LOAD_STATUS.filter((ldSt) => ldSt != LOAD_STATUS.EXPIRED)
    },
    ACTIVE_LOADS: {
        label: "Active + Supplier Confirmed",
        value: [LOAD_STATUS.ACTIVE, LOAD_STATUS.STAND_BY]
    },
    WENT_INTRANSIT: {
        label: "Went In-Transit",
        value: [LOAD_STATUS.IN_TRANSIT, LOAD_STATUS.COMPLETED, LOAD_STATUS.CANCELLED]
    },
    ACTIVE_WITH_BOOKING_CONFIRMED: {
        label: "Active + Booking Paid",
        value: [LOAD_STATUS.ACTIVE],
        flags: {
            booking_confirmed: true
        }
    },
    BOOKING_CONFIRMED: {
        label: "All + Booking Paid",
        value: ALL_LOAD_STATUS,
        flags: {
            booking_confirmed: true
        }
    },
    ACTIVE: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.ACTIVE],
        value: [LOAD_STATUS.ACTIVE]
    },
    STAND_BY: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.STAND_BY],
        value: [LOAD_STATUS.STAND_BY]
    },
    EXPIRED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.EXPIRED],
        value: [LOAD_STATUS.EXPIRED]
    },
    IN_TRANSIT: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.IN_TRANSIT],
        value: [LOAD_STATUS.IN_TRANSIT]
    },
    COMPLETED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.COMPLETED],
        value: [LOAD_STATUS.COMPLETED]
    },
    CANCELLED: {
        label: LOAD_STATUS_TEXT_MAP[LOAD_STATUS.CANCELLED],
        value: [LOAD_STATUS.CANCELLED]
    }
};


//# sourceMappingURL=loadStatus.js.map


/***/ }),

/***/ 69673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* binding */ ACTION_BY_LORRY_STATUS; },
/* harmony export */   "sU": function() { return /* binding */ LORRY_STATUS_TEXT; },
/* harmony export */   "un": function() { return /* binding */ LORRY_STATUS; }
/* harmony export */ });
var LORRY_STATUS;
(function (LORRY_STATUS) {
    LORRY_STATUS[LORRY_STATUS["ALL"] = -1] = "ALL";
    LORRY_STATUS[LORRY_STATUS["ACTIVE"] = 3] = "ACTIVE";
    LORRY_STATUS[LORRY_STATUS["IN_TRANSIT"] = 4] = "IN_TRANSIT";
    LORRY_STATUS[LORRY_STATUS["IN_ACTIVE"] = 0] = "IN_ACTIVE";
    LORRY_STATUS[LORRY_STATUS["STAND_BY"] = 5] = "STAND_BY";
    LORRY_STATUS[LORRY_STATUS["VERIFICATION_FAILED"] = 999] = "VERIFICATION_FAILED";
})(LORRY_STATUS || (LORRY_STATUS = {}));
var LORRY_STATUS_TEXT;
(function (LORRY_STATUS_TEXT) {
    LORRY_STATUS_TEXT["ALL"] = "All";
    LORRY_STATUS_TEXT["IN_ACTIVE"] = "In Active";
    LORRY_STATUS_TEXT["ACTIVE"] = "Active";
    LORRY_STATUS_TEXT["IN_TRANSIT"] = "In Transit";
    LORRY_STATUS_TEXT["VERIFICATION_FAILED"] = "Verification Failed";
    LORRY_STATUS_TEXT["STAND_BY"] = "Stand By";
})(LORRY_STATUS_TEXT || (LORRY_STATUS_TEXT = {}));
const ACTION_BY_LORRY_STATUS = {
    EDIT_LORRY: [LORRY_STATUS.ACTIVE],
    ADD_DRIVER_DETAILS: [LORRY_STATUS.ACTIVE, LORRY_STATUS.IN_TRANSIT]
};


//# sourceMappingURL=lorryStatus.js.map


/***/ }),

/***/ 14345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ VehicleTypeBodyTypeMap; },
/* harmony export */   "QZ": function() { return /* binding */ NEW_LORRY_CAPACITY; },
/* harmony export */   "R0": function() { return /* binding */ initLorryList; },
/* harmony export */   "R1": function() { return /* binding */ LorryNameToNumberMap; },
/* harmony export */   "Sv": function() { return /* binding */ LORRY_CATEGORIES_ENUM; },
/* harmony export */   "UE": function() { return /* binding */ getAllowedVehicleList; },
/* harmony export */   "X9": function() { return /* binding */ getLorryDetailsByType; },
/* harmony export */   "Y4": function() { return /* binding */ TRUCK_BODY_TYPES; },
/* harmony export */   "d4": function() { return /* binding */ VehicleBodyOptionsType; },
/* harmony export */   "f4": function() { return /* binding */ LORRY_BODY_TYPE; },
/* harmony export */   "f5": function() { return /* binding */ LORRY_CAPACITY_UNIT_TYPES; },
/* harmony export */   "ix": function() { return /* binding */ LORRY_BODY_TYPE_MAP; },
/* harmony export */   "kp": function() { return /* binding */ ALLOWED_LORRY_CATEGORY_IDS; },
/* harmony export */   "mC": function() { return /* binding */ getLorryDetailsByName; },
/* harmony export */   "qn": function() { return /* binding */ deriveVehicleBodyFilterValue; },
/* harmony export */   "sB": function() { return /* binding */ getVehicleInfoByLorryType; },
/* harmony export */   "wA": function() { return /* binding */ generateLorryList; }
/* harmony export */ });
/* unused harmony export LORRY_CATEGORIES */
/* harmony import */ var _authorizedUsers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2390);
/* harmony import */ var _bidStatus_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71535);
/* harmony import */ var _bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47762);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77370);
/* harmony import */ var _event_names_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69406);
/* harmony import */ var _eventsMapObj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3000);
/* harmony import */ var _Faq_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80230);
/* harmony import */ var _languages_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87013);
/* harmony import */ var _loadStatus_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61834);
/* harmony import */ var _lorryStatus_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69673);
/* harmony import */ var _mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16593);
/* harmony import */ var _Pages_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2784);
/* harmony import */ var _serviceTypeId_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76705);
/* harmony import */ var _StateList_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52224);
/* harmony import */ var _bidUpdateType_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43298);
/* harmony import */ var _userAction_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69881);
/* harmony import */ var _api_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(24966);
/* harmony import */ var _link_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39422);
/* harmony import */ var _market_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(45678);
/* harmony import */ var _payment_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(91680);
/* harmony import */ var _admin_screenId_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(22391);
/* harmony import */ var _services_const_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41634);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(63118);
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(11663);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(96762);
/* harmony import */ var _methods_compareString_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(83121);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_33__);





































const LORRY_CATEGORIES = {
    TRUCK: 1,
    LCV: 2,
    CONTAINER: 3,
    HYVA: 4,
    TRAILOR: 5,
    TANKER: 6
};
var LORRY_CATEGORIES_ENUM;
(function (LORRY_CATEGORIES_ENUM) {
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["TRUCK"] = 1] = "TRUCK";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["LCV"] = 2] = "LCV";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["CONTAINER"] = 3] = "CONTAINER";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["HYVA"] = 4] = "HYVA";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["TRAILER"] = 5] = "TRAILER";
    LORRY_CATEGORIES_ENUM[LORRY_CATEGORIES_ENUM["TANKER"] = 6] = "TANKER";
})(LORRY_CATEGORIES_ENUM || (LORRY_CATEGORIES_ENUM = {}));
var LORRY_BODY_TYPE;
(function (LORRY_BODY_TYPE) {
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["OPEN"] = 0] = "OPEN";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["CLOSED"] = 1] = "CLOSED";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["METAL_STEEL"] = 2] = "METAL_STEEL";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["STAINLESS_STEEL"] = 3] = "STAINLESS_STEEL";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["OPEN_BODY"] = 4] = "OPEN_BODY";
    LORRY_BODY_TYPE[LORRY_BODY_TYPE["CLOSE_BODY"] = 5] = "CLOSE_BODY";
})(LORRY_BODY_TYPE || (LORRY_BODY_TYPE = {}));
//Need to be verified
const LORRY_BODY_TYPE_MAP = {
    0: "Open body",
    1: "Closed body",
    2: "Metal steel",
    3: "Stainless steel",
    4: "Open body",
    5: "Closed body"
};
var LORRY_CAPACITY_UNIT_TYPES;
(function (LORRY_CAPACITY_UNIT_TYPES) {
    LORRY_CAPACITY_UNIT_TYPES["TONNES"] = "Tonne(s)";
    LORRY_CAPACITY_UNIT_TYPES["KILO_LITRES"] = "Kilo Litre(s)";
    LORRY_CAPACITY_UNIT_TYPES["TONNE"] = "Tonne";
    LORRY_CAPACITY_UNIT_TYPES["KILO_LITRE"] = "Kilo Litre";
})(LORRY_CAPACITY_UNIT_TYPES || (LORRY_CAPACITY_UNIT_TYPES = {}));
const LorryNameToNumberMap = {
    Truck: LORRY_CATEGORIES.TRUCK,
    Trailor: LORRY_CATEGORIES.TRAILOR,
    Container: LORRY_CATEGORIES.CONTAINER,
    LCV: LORRY_CATEGORIES.LCV,
    Hyva: LORRY_CATEGORIES.HYVA,
    Tanker: LORRY_CATEGORIES.TANKER
};
var TRUCK_BODY_TYPES;
(function (TRUCK_BODY_TYPES) {
    TRUCK_BODY_TYPES[TRUCK_BODY_TYPES["OPEN"] = 0] = "OPEN";
    TRUCK_BODY_TYPES[TRUCK_BODY_TYPES["CLOSED"] = 1] = "CLOSED";
})(TRUCK_BODY_TYPES || (TRUCK_BODY_TYPES = {}));
/**
 * Internal use only
 */
var VehicleBodyOptionsType;
(function (VehicleBodyOptionsType) {
    VehicleBodyOptionsType[VehicleBodyOptionsType["OPEN"] = 10] = "OPEN";
    VehicleBodyOptionsType[VehicleBodyOptionsType["CLOSE"] = 11] = "CLOSE";
})(VehicleBodyOptionsType || (VehicleBodyOptionsType = {}));
const NEW_LORRY_TYPES = [
    {
        id: LORRY_CATEGORIES_ENUM.TRUCK,
        label: "Truck",
        iconRight: "Truck-right@3x.png",
        iconRightV2: "Truck-right-v2.png",
        iconLeft: "Truck-left@3x.png",
        fullIconRight: "lorry-icons/v2/Truck.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.CONTAINER,
        label: "Container",
        iconRight: "Container-right@3x.png",
        iconRightV2: "Container-right-v2.png",
        iconLeft: "Container-left@3x.png",
        fullIconRight: "lorry-icons/v2/Container.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.CLOSE]
    },
    {
        id: LORRY_CATEGORIES_ENUM.TRAILER,
        label: "Trailer",
        iconRight: "Trailor-right@3x.png",
        iconRightV2: "Trailor-right-v2.png",
        iconLeft: "Trailor-left@3x.png",
        fullIconRight: "lorry-icons/v2/Trailer.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.LCV,
        label: "LCV",
        iconRight: "LCV-right@3x.png",
        iconRightV2: "LCV-right-v2.png",
        iconLeft: "LCV-left@3x.png",
        fullIconRight: "lorry-icons/v2/LCV.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN, VehicleBodyOptionsType.CLOSE]
    },
    {
        id: LORRY_CATEGORIES_ENUM.HYVA,
        label: "Hyva",
        iconRight: "Hyva-right@3x.png",
        iconRightV2: "Hyva-right-v2.png",
        iconLeft: "Hyva-left@3x.png",
        fullIconRight: "lorry-icons/v2/Hyva.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.TONNES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.TONNE,
        unitShort: "T",
        bodyType: [VehicleBodyOptionsType.OPEN]
    },
    {
        id: LORRY_CATEGORIES_ENUM.TANKER,
        label: "Tanker",
        iconRight: "Tanker-right@3x.png",
        iconRightV2: "Tanker-right-v2.png",
        iconLeft: "Tanker-left@3x.png",
        fullIconRight: "lorry-icons/v2/Tanker.png",
        unit: LORRY_CAPACITY_UNIT_TYPES.KILO_LITRES,
        unitSingular: LORRY_CAPACITY_UNIT_TYPES.KILO_LITRE,
        unitShort: "KL",
        bodyType: [VehicleBodyOptionsType.CLOSE]
    }
];
const VEHICLE_LIST = {
    LOAD_POST: [],
    LORRY_POST: []
};
const ALLOWED_LORRY_CATEGORY_IDS = [
    LORRY_CATEGORIES_ENUM.TRUCK,
    LORRY_CATEGORIES_ENUM.LCV,
    LORRY_CATEGORIES_ENUM.CONTAINER
];
const getAllowedVehicleList = (entityType, option) => {
    var _a;
    const listToFilter = (((_a = option === null || option === void 0 ? void 0 : option.srcList) === null || _a === void 0 ? void 0 : _a.length) ? option.srcList : undefined) ||
        (entityType === "load" ? VEHICLE_LIST.LOAD_POST : VEHICLE_LIST.LORRY_POST);
    return listToFilter.filter((lorry) => ALLOWED_LORRY_CATEGORY_IDS.some((id) => id === lorry.id));
};
const DefaultMinMax = { min: 0, max: 0 };
const NEW_LORRY_CAPACITY = {
    LOAD_POST: DefaultMinMax,
    LORRY_POST: DefaultMinMax
};
function calcCapacity(list) {
    return list.length
        ? list.reduce((range, lorry) => ({
            min: Math.min(range.min, lorry.capacity.min),
            max: Math.max(range.max, lorry.capacity.max)
        }), { min: Infinity, max: -Infinity })
        : DefaultMinMax;
}
const emptyLorryTypeBodyObject = Object.values(LORRY_CATEGORIES_ENUM)
    .filter((v) => typeof v === "number")
    .reduce((acc, key) => {
    acc[key] = {};
    return acc;
}, {});
const VehicleTypeBodyTypeMap = {
    load: emptyLorryTypeBodyObject,
    lorry: emptyLorryTypeBodyObject
};
function mapLorryListIntoBodyMap(list) {
    return list.reduce((acc, lorryInfo) => {
        const { id, bodyOptions } = lorryInfo;
        acc[id] = bodyOptions === null || bodyOptions === void 0 ? void 0 : bodyOptions.reduce((bodyAcc, bodyOption) => {
            bodyAcc[bodyOption.id] = bodyOption.name;
            return bodyAcc;
        }, {});
        return acc;
    }, {});
}
function generateLorryList(listForLoadPost, listForLorryPost) {
    const transformMethod = (lorry) => {
        var _a, _b, _c, _d, _e, _f;
        let min = Infinity;
        let max = -Infinity;
        // Collect min/max from tyre_capacity
        if (lorry.tyre_capacity) {
            for (const t of lorry.tyre_capacity) {
                min = Math.min(min, t.min);
                max = Math.max(max, t.max);
            }
        }
        // Collect min/max from feet_capacity
        if (lorry.feet_capacity) {
            for (const f of lorry.feet_capacity) {
                min = Math.min(min, f.min);
                max = Math.max(max, f.max);
            }
        }
        // If nothing found, fallback to 0
        if (min === Infinity)
            min = 0;
        if (max === -Infinity)
            max = 0;
        const bodyOptions = ((_a = lorry.body) === null || _a === void 0 ? void 0 : _a.map((item) => ({
            id: item.id,
            name: item.name
        }))) || [];
        const tyreOptions = ((_b = lorry.tyres) === null || _b === void 0 ? void 0 : _b.map((item) => ({
            count: item.count,
            text: item.text,
            label: `${item.count} ${item.text}`
        }))) || [];
        const tyreWithCapacity = ((_c = lorry.tyre_capacity) === null || _c === void 0 ? void 0 : _c.map((item) => ({
            min: item.min,
            max: item.max,
            tyreCount: item.tyres_count
        }))) || [];
        const feetOptions = ((_d = lorry.feet) === null || _d === void 0 ? void 0 : _d.map((item, ix) => ({
            id: ix + 1,
            label: `${item.size} ${item.type}`,
            size: item.size,
            sizeType: item.type
        }))) || [];
        const feetWithCapacity = ((_e = lorry.feet_capacity) === null || _e === void 0 ? void 0 : _e.map((item) => ({
            size: item.size,
            sizeType: item.type,
            min: item.min,
            max: item.max
        }))) || [];
        const feetWithTyres = ((_f = lorry.feet_tyre) === null || _f === void 0 ? void 0 : _f.map((item) => ({
            tyreCount: item === null || item === void 0 ? void 0 : item.tyres_count,
            feet: item === null || item === void 0 ? void 0 : item.feet
        }))) || [];
        return Object.assign(Object.assign({}, NEW_LORRY_TYPES.find((lr) => lr.id === (lorry === null || lorry === void 0 ? void 0 : lorry.id))), { remoteInfo: lorry, capacity: { min, max }, capacityText: `${min}-${max} ${lorry.capacity_unit}`, bodyOptions,
            tyreOptions,
            tyreWithCapacity,
            feetOptions,
            feetWithCapacity,
            feetWithTyres,
            getTyreOptionsByCapacity(capacity) {
                const validCapacities = tyreWithCapacity.filter((c) => capacity >= c.min && capacity <= c.max);
                return tyreOptions.filter((t) => validCapacities.find((c) => c.tyreCount === t.count));
            },
            getSizeOptionsByCapacity(capacity) {
                const validCapacities = feetWithCapacity.filter((c) => capacity >= c.min && capacity <= c.max);
                return feetOptions.filter((t) => validCapacities.find((c) => c.size === t.size && c.sizeType === t.sizeType));
            },
            getSizeOptionsByTyre(tyres) {
                var _a;
                const validSizeList = ((_a = feetWithTyres.find((item) => item.tyreCount === tyres)) === null || _a === void 0 ? void 0 : _a.feet) || [];
                return feetOptions.filter((t) => validSizeList.find((c) => c.size === t.size && c.type === t.sizeType));
            } });
    };
    const LOAD_POST_LIST = listForLoadPost.map(transformMethod);
    const LORRY_POST_LIST = listForLorryPost.map(transformMethod);
    return {
        LIST: {
            LOAD_POST: LOAD_POST_LIST,
            LORRY_POST: LORRY_POST_LIST
        },
        ALLOWED_CAPACITY: {
            LOAD_POST: calcCapacity(getAllowedVehicleList("load", {
                srcList: LOAD_POST_LIST
            })),
            LORRY_POST: calcCapacity(getAllowedVehicleList("lorry", {
                srcList: LORRY_POST_LIST
            }))
        },
        BODY_MAP: {
            load: mapLorryListIntoBodyMap(LOAD_POST_LIST),
            lorry: mapLorryListIntoBodyMap(LORRY_POST_LIST)
        }
    };
}
function initLorryList(listForLoadPost, listForLorryPost) {
    var _a, _b, _c, _d;
    const listMeta = generateLorryList(listForLoadPost, listForLorryPost);
    VEHICLE_LIST["LOAD_POST"] = listMeta.LIST.LOAD_POST;
    VEHICLE_LIST["LORRY_POST"] = listMeta.LIST.LORRY_POST;
    VehicleTypeBodyTypeMap["load"] = (_a = listMeta === null || listMeta === void 0 ? void 0 : listMeta.BODY_MAP) === null || _a === void 0 ? void 0 : _a.load;
    VehicleTypeBodyTypeMap["lorry"] = (_b = listMeta === null || listMeta === void 0 ? void 0 : listMeta.BODY_MAP) === null || _b === void 0 ? void 0 : _b.lorry;
    NEW_LORRY_CAPACITY["LOAD_POST"] = (_c = listMeta === null || listMeta === void 0 ? void 0 : listMeta.ALLOWED_CAPACITY) === null || _c === void 0 ? void 0 : _c.LOAD_POST;
    NEW_LORRY_CAPACITY["LORRY_POST"] = (_d = listMeta === null || listMeta === void 0 ? void 0 : listMeta.ALLOWED_CAPACITY) === null || _d === void 0 ? void 0 : _d.LORRY_POST;
}
const getLorryDetailsByType = (type) => {
    return NEW_LORRY_TYPES.find((lorry) => lorry.id === type);
};
const getLorryDetailsByName = (label) => {
    return NEW_LORRY_TYPES.find((lorry) => !!label && (0,_methods_compareString_js__WEBPACK_IMPORTED_MODULE_34__/* .compareString */ .r)(label, lorry === null || lorry === void 0 ? void 0 : lorry.label));
};
const getVehicleInfoByLorryType = (type, ...args) => {
    return getAllowedVehicleList(...args).find((lorry) => lorry.id === type);
};
const deriveVehicleBodyFilterValue = (type, bodyType) => {
    var _a;
    const bodyOption = (_a = getLorryDetailsByType(type)) === null || _a === void 0 ? void 0 : _a.bodyType;
    let result = null;
    if ((bodyOption === null || bodyOption === void 0 ? void 0 : bodyOption.length) === 1) {
        result = bodyOption[0];
    }
    else {
        if (type === LORRY_CATEGORIES_ENUM.LCV && Number.isInteger(bodyType)) {
            if (bodyType === LORRY_BODY_TYPE.OPEN_BODY) {
                result = VehicleBodyOptionsType.OPEN;
            }
            else if (bodyType === LORRY_BODY_TYPE.CLOSE_BODY) {
                result = VehicleBodyOptionsType.CLOSE;
            }
        }
    }
    return result;
};


//# sourceMappingURL=lorryTypes.js.map


/***/ }),

/***/ 45678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ MarketPlaceType; },
/* harmony export */   "X5": function() { return /* binding */ MARKET_TYPE; }
/* harmony export */ });
/* unused harmony export MARKET_TYPE_MAP */
const MARKET_TYPE_MAP = {
    load: 1,
    lorry: 2,
    loads: 1,
    lorries: 2
};
const MARKET_TYPE = {
    LOADS: "loads",
    LORRIES: "lorries",
    LOAD: "load",
    Lorry: "lorry"
};
var MarketPlaceType;
(function (MarketPlaceType) {
    MarketPlaceType["LOAD"] = "load";
    MarketPlaceType["LORRY"] = "lorry";
})(MarketPlaceType || (MarketPlaceType = {}));


//# sourceMappingURL=market.js.map


/***/ }),

/***/ 77370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DL": function() { return /* binding */ DefaultCookieOptions; },
/* harmony export */   "E9": function() { return /* binding */ COOKIES; },
/* harmony export */   "Q3": function() { return /* binding */ IP_DATA_KEY; },
/* harmony export */   "TS": function() { return /* binding */ IMG_BASE_URL; },
/* harmony export */   "Xw": function() { return /* binding */ FONT_WEIGHTS; },
/* harmony export */   "aS": function() { return /* binding */ VAHAK_EMAIL_INFO; },
/* harmony export */   "fD": function() { return /* binding */ CUSTOM_EVENTS; },
/* harmony export */   "gH": function() { return /* binding */ PopularDest; },
/* harmony export */   "gt": function() { return /* binding */ FooterItemsConstant; },
/* harmony export */   "hL": function() { return /* binding */ FOOTER_ITEM_ATTRIBUTE; },
/* harmony export */   "hm": function() { return /* binding */ ComponentState; },
/* harmony export */   "k4": function() { return /* binding */ MEMBERSHIP_FEATURE; },
/* harmony export */   "kQ": function() { return /* binding */ HeaderItemsConstants; },
/* harmony export */   "mb": function() { return /* binding */ APP_LINK; },
/* harmony export */   "mi": function() { return /* binding */ CASHFREE_PAYMENT_SUCCESS_STATUS; },
/* harmony export */   "nD": function() { return /* binding */ IMG_BASE_URL_NEXTJS; },
/* harmony export */   "nJ": function() { return /* binding */ BadgeTypes; },
/* harmony export */   "ng": function() { return /* binding */ FB_PIXEL_ID; },
/* harmony export */   "t": function() { return /* binding */ REF_VIEWPORT_HEIGHT; },
/* harmony export */   "vE": function() { return /* binding */ PRODUCTION_ENV; },
/* harmony export */   "vq": function() { return /* binding */ SOURCE_UTM; },
/* harmony export */   "wO": function() { return /* binding */ LOC_STORAGE; },
/* harmony export */   "xA": function() { return /* binding */ VAHAK_EMAIL; },
/* harmony export */   "yD": function() { return /* binding */ VAHAK_PHONE; }
/* harmony export */ });
/* unused harmony exports BID_HISTORY_STATUS_MAP, CACHE_NAME, CITIES_WITH_CITY_PAGES, DEFAULT_COMPANY_LOGO, EXPIRED_LORRY_STATUS, FB_CAPI_TOKEN, HEADER_ITEM_ATTRIBUTE, REF_VIEWPORT_WIDTH, SESSION, USER_PROFILE_MODAL_TITLE, WHATSAPP_CHAT */
/* provided dependency */ var process = __webpack_require__(34406);
const IMG_BASE_URL = "https://d1rgemtytdlz2g.cloudfront.net";
const IMG_BASE_URL_NEXTJS = "https://d3ib4ot6oar1ep.cloudfront.net";
const SOURCE_UTM = "source_custom_utm";
const PRODUCTION_ENV = "production";
const IP_DATA_KEY = "f2f334b89f92f60f47e0198355537a6eeee9012ea4106a9729bbb58f";
const SESSION = {
    shouldPreventLayoutSwitch: "swl"
};
const COOKIES = {
    token: "vt",
    isVerified: "vv",
    isEmailVerified: "ev",
    isRecoveryEmailVerified: "rev",
    customerCompanyId: "ccid",
    customerPhone: "cpn",
    customerName: "cname",
    customerCompanyLocation: "ccloc",
    csDashboardUserRoles: "csdsbUserRoles",
    csDashboardPermission: "csdsbPerm",
    phoneNum: "phoneNum",
    companyId: "ci",
    companyName: "name",
    companyLocation: "cloc",
    kycPopupInitialLoad: "kip",
    historyLocation: "hl",
    companyLogo: "cLogo",
    userId: "ui",
    serviceType: "st",
    recentTransporterCitySearches: "rtcs",
    currentLoc: "loc",
    callbackRequestedTimestamp: "cr",
    aadharVerificationAttempts: "av",
    blockAadharVerification: "ba",
    blockGstVerification: "bg",
    bulkRequestIdArray: "bri",
    customerServiceType: "cst",
    fromFlutterApp: "fromFlutterApp",
    citySearchCount: "ctCtySch",
    transporterSearchCount: "ctTspSch",
    abTest: "abt",
    exitIntPopup: "exp",
    wrongTurnPop: "wtp",
    referralCode: "rfc",
    sessionId: "sid",
    vahakAutomation: "va",
    thirdPartyCompanyName: "tpc",
    newUser: "newUser"
};
const LOC_STORAGE = {
    callbackRequestedTimestamp: "cr",
    requestedTicketTimestamp: "req-tkt",
    clickToCallMpcMode: "ctc-mpc"
};
const DefaultCookieOptions = {
    path: "/",
    secure: process.env.REACT_APP_ENV === "production" || process.env.NEXT_PUBLIC_REACT_APP_ENV === "production",
    sameSite: "strict",
    maxAge: 24 * 60 * 60 * 30
};
const CUSTOM_EVENTS = {
    LOGGEDIN: "registered user or logged in user"
};
const PopularDest = [
    { state_id: 1, state: "Maharashtra" },
    { state_id: 4, state: "Gujarat" },
    { state_id: 2, state: "Delhi" },
    { state_id: 3, state: "Karnataka" }
];
var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes[BadgeTypes["DEFAULT"] = 0] = "DEFAULT";
    BadgeTypes[BadgeTypes["WARNING"] = 1] = "WARNING";
    BadgeTypes[BadgeTypes["ACTIVE"] = 2] = "ACTIVE";
    BadgeTypes[BadgeTypes["PROGRESS"] = 3] = "PROGRESS";
    BadgeTypes[BadgeTypes["COMPLETED"] = 4] = "COMPLETED";
    BadgeTypes[BadgeTypes["PUBLISHED"] = 5] = "PUBLISHED";
})(BadgeTypes || (BadgeTypes = {}));
var ComponentState;
(function (ComponentState) {
    ComponentState[ComponentState["NORMAL"] = 0] = "NORMAL";
    ComponentState[ComponentState["LOADING"] = 1] = "LOADING";
})(ComponentState || (ComponentState = {}));
const DEFAULT_COMPANY_LOGO = "default.png";
const HEADER_ITEM_ATTRIBUTE = "header-item-attribute";
var HeaderItemsConstants;
(function (HeaderItemsConstants) {
    HeaderItemsConstants["SERVICE_MENU"] = "service-menu";
    HeaderItemsConstants["MARKETPLACE"] = "marketplace";
    HeaderItemsConstants["TRANSPORT_DIRECTORY"] = "transport-directory";
    HeaderItemsConstants["RESOURCES_MENU"] = "resources";
    HeaderItemsConstants["COMPANY_MENU"] = "company";
    HeaderItemsConstants["LOGIN"] = "login";
    HeaderItemsConstants["MEMBERSHIP"] = "membership";
})(HeaderItemsConstants || (HeaderItemsConstants = {}));
const FOOTER_ITEM_ATTRIBUTE = "footer-item-attribute";
var FooterItemsConstant;
(function (FooterItemsConstant) {
    FooterItemsConstant["ABOUT_US"] = "about-us";
    FooterItemsConstant["CONTACT_US"] = "contact-us";
    FooterItemsConstant["CAREERS"] = "careers";
    FooterItemsConstant["NEWSLETTER"] = "newsletter";
    FooterItemsConstant["CONNECT_WITH_US"] = "connect-with-us";
    FooterItemsConstant["DOWNLOAD_OUR_APP"] = "download-our-app";
    FooterItemsConstant["FAQ"] = "faq";
    FooterItemsConstant["TERMS_AND_CONDITION"] = "terms-and-condition";
    FooterItemsConstant["PAYMENT_GUIDELINES"] = "payment-guidelines";
    FooterItemsConstant["CASHBACK_TERMS_AND_CONDITIONS"] = "cashback-terms-and-conditions";
    FooterItemsConstant["MEDIBUDDY_TERMS_AND_CONDITIONS"] = "medibuddy-terms-and-conditions";
    FooterItemsConstant["TAP_N_GO_TERMS_AND_CONDITIONS"] = "tap-n-go-terms-and-conditions";
    FooterItemsConstant["BUSINESS_LOANS_TERMS_AND_CONDITIONS"] = "business-loans-terms-and-conditions";
    FooterItemsConstant["CI_TERMS_AND_CONDITIONS"] = "ci-terms-and-conditions";
    FooterItemsConstant["GPS_TERMS_AND_CONDITIONS"] = "gps-terms-and-conditions";
    FooterItemsConstant["PRIVACY_POLICY"] = "privacy-policy";
    FooterItemsConstant["NEWSLETTER_SUBSCRIBED"] = "newsletter-subscribed";
})(FooterItemsConstant || (FooterItemsConstant = {}));
const FB_PIXEL_ID = "466348821937832";
const FB_CAPI_TOKEN = "EAAFGkspC5FIBR8AuEtpezYbxjDHL1YfF6KfjoRlchYKVC2cr5min1ZAZC0Aj6C4AswZCYNRSmfQdbLO92lZBkUfSc4lOqcGbA5Hqo9UnMPznWHpePl5S3P55q0kvtmXCPiFkuKhW7zv2gDwoFLdIQZBdGqPjxt7V7h3o03u8utWdwjMZBcJIj5xU29JBMW4wZDZD";
const MEMBERSHIP_FEATURE = "https://www.youtube.com/embed/Cc_T6ym0zEQ?si=ETYCxekk991-Zd-c";
const APP_LINK = "https://app.vahak.in/46EB9yJRwkb";
const BID_HISTORY_STATUS_MAP = {
    0: "Waiting",
    1: "Rejected",
    2: "Approved",
    3: "Completed",
    4: "In Transit"
};
const CASHFREE_PAYMENT_SUCCESS_STATUS = ["PAID", "TO_SETTLE", "CFLINK_SUCCESS"];
const WHATSAPP_CHAT = "https://chat.whatsapp.com/HNbwsUwyircDXIBsqk5jus";
const VAHAK_EMAIL = "cs@vahak.in";
const VAHAK_EMAIL_INFO = "info@vahak.in";
const VAHAK_PHONE = "+918035738071";
const REF_VIEWPORT_HEIGHT = 812;
const REF_VIEWPORT_WIDTH = 375;
var FONT_WEIGHTS;
(function (FONT_WEIGHTS) {
    FONT_WEIGHTS[FONT_WEIGHTS["extraBold"] = 1000] = "extraBold";
    FONT_WEIGHTS[FONT_WEIGHTS["bold"] = 850] = "bold";
    FONT_WEIGHTS[FONT_WEIGHTS["semiBold"] = 600] = "semiBold";
    FONT_WEIGHTS[FONT_WEIGHTS["medium"] = 550] = "medium";
    FONT_WEIGHTS[FONT_WEIGHTS["normal"] = 400] = "normal";
})(FONT_WEIGHTS || (FONT_WEIGHTS = {}));
const CACHE_NAME = "v-cache";
const EXPIRED_LORRY_STATUS = (/* unused pure expression or super */ null && ([0, 4]));
const USER_PROFILE_MODAL_TITLE = {
    "company-details": "ABOUT COMPANY",
    "my-routes": "MY ROUTES",
    "my-lorries": "MY LORRIES",
    "office-address": "OFFICE ADDRESSES",
    "document-verification": "Document Verification",
    "company-bio": "Company Bio",
    reviews: "My Reviews",
    faqs: "FAQS",
    aadharVerification: "Aadhaar Verification",
    gstVerification: "Business Document Verification"
};
const CITIES_WITH_CITY_PAGES = (/* unused pure expression or super */ null && ([
    "mumbai",
    "delhi",
    "bangalore",
    "kolkata",
    "chennai",
    "hyderabad",
    "ahmedabad",
    "jaipur",
    "pune"
]));


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 16593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ mostSearchedLinksMenusKeys; },
/* harmony export */   "v": function() { return /* binding */ mostSearchedLinksMenus; }
/* harmony export */ });
var mostSearchedLinksMenusKeys;
(function (mostSearchedLinksMenusKeys) {
    mostSearchedLinksMenusKeys["ONLINE_TRUCK_BOOKING"] = "online-truck-booking";
    mostSearchedLinksMenusKeys["ONLINE_LOAD_BOOKING"] = "online-load-booking";
    mostSearchedLinksMenusKeys["TRANSPORTER"] = "transporter";
    mostSearchedLinksMenusKeys["TRANSPORT_SERVICE"] = "transport-service";
    mostSearchedLinksMenusKeys["TRANSPORT_DIRECTORY"] = "transport-directory";
    mostSearchedLinksMenusKeys["LORRY"] = "lorry";
})(mostSearchedLinksMenusKeys || (mostSearchedLinksMenusKeys = {}));
const mostSearchedLinksMenus = [
    { title: "Online Truck Booking", key: mostSearchedLinksMenusKeys.ONLINE_TRUCK_BOOKING },
    { title: "Online Load Booking", key: mostSearchedLinksMenusKeys.ONLINE_LOAD_BOOKING },
    { title: "Transporters", key: mostSearchedLinksMenusKeys.TRANSPORTER },
    { title: "Major Routes", key: mostSearchedLinksMenusKeys.LORRY }
];


//# sourceMappingURL=mostSearchedLinks.js.map


/***/ }),

/***/ 91680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ ExpectedAmountTypeNameMapping; },
/* harmony export */   "Q9": function() { return /* binding */ ExpectedAmountType; },
/* harmony export */   "R$": function() { return /* binding */ PAYMENT_STATUS; },
/* harmony export */   "V_": function() { return /* binding */ PAYMENT_TYPE; },
/* harmony export */   "dh": function() { return /* binding */ PAYMENT_TYPE_MAP; },
/* harmony export */   "qs": function() { return /* binding */ EXPECTED_AMOUNT_TYPE; }
/* harmony export */ });
const PAYMENT_TYPE_MAP = {
    0: "Advance",
    1: "To Pay"
};
const PAYMENT_STATUS = {
    LOADING: "LOADING",
    PAID: "PAID"
};
const EXPECTED_AMOUNT_TYPE = {
    0: "Fixed Price",
    1: "Per Tonne"
};
var ExpectedAmountType;
(function (ExpectedAmountType) {
    ExpectedAmountType[ExpectedAmountType["FIXED_PRICE"] = 0] = "FIXED_PRICE";
    ExpectedAmountType[ExpectedAmountType["PER_TONNE"] = 1] = "PER_TONNE";
})(ExpectedAmountType || (ExpectedAmountType = {}));
var ExpectedAmountTypeNameMapping;
(function (ExpectedAmountTypeNameMapping) {
    ExpectedAmountTypeNameMapping["FIXED_PRICE"] = "Fixed";
    ExpectedAmountTypeNameMapping["PER_TONNE"] = "Per Tonne";
})(ExpectedAmountTypeNameMapping || (ExpectedAmountTypeNameMapping = {}));
var PAYMENT_TYPE;
(function (PAYMENT_TYPE) {
    PAYMENT_TYPE[PAYMENT_TYPE["Advance"] = 0] = "Advance";
    PAYMENT_TYPE[PAYMENT_TYPE["ToPay"] = 1] = "ToPay";
})(PAYMENT_TYPE || (PAYMENT_TYPE = {}));


//# sourceMappingURL=payment.js.map


/***/ }),

/***/ 28230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getPlatformStatI18nLabels; },
/* harmony export */   "s": function() { return /* binding */ PLATFORM_STATS; }
/* harmony export */ });
/**
 * Canonical platform marketing stats — single source of truth for SEO copy.
 * Update values here only; use helpers or imports elsewhere.
 */
const PLATFORM_STATS = {
    transporters: {
        count: 1000000,
        lakhNumber: 10,
        lakhs: "10 Lakh+",
        lakhsLong: "10 Lakhs+",
        numeric: "10,00,000+",
        verifiedShort: "10 lakh+ verified transporters",
        verifiedLorryOwners: "10 Lakh+ verified lorry owners"
    },
    verifiedTrucks: {
        count: 800000,
        lakhNumber: 8,
        lakhs: "8 Lakh+",
        lakhsLong: "8 lakh+",
        lakhsLongPlural: "8 lakhs+"
    },
    users: {
        lakhs: "10 Lakh+"
    },
    dailyActiveLoads: {
        count: 20000,
        label: "20,000+"
    },
    liveLoadsAndLorries: {
        count: 10000,
        label: "10,000+"
    },
    dailyLoads: {
        count: 1000,
        label: "1000+"
    },
    cities: {
        count: 850,
        label: "850+"
    },
    tripsCompleted: {
        count: 100000,
        label: "1,00,000+"
    },
    bookings: {
        lakhs: "1 Lakh+"
    },
    appDownloads: {
        count: 1000000,
        millions: "1 Million+",
        lakhsLong: "10 Lakhs+"
    },
    locations: {
        count: 15000,
        label: "15,000+"
    }
};
/** i18n interpolation values — pass as the second arg to `t()` for locale strings using {{placeholders}}. */
function getPlatformStatI18nLabels() {
    return {
        transportersLakhs: PLATFORM_STATS.transporters.lakhs,
        transportersLakhsLong: PLATFORM_STATS.transporters.lakhsLong,
        liveLoadsAndLorries: PLATFORM_STATS.liveLoadsAndLorries.label,
        dailyActiveLoads: PLATFORM_STATS.dailyActiveLoads.label,
        verifiedTrucksLakhs: PLATFORM_STATS.verifiedTrucks.lakhs,
        verifiedTrucksLakhsLong: PLATFORM_STATS.verifiedTrucks.lakhsLong,
        locations: PLATFORM_STATS.locations.label
    };
}


//# sourceMappingURL=platformStats.js.map


/***/ }),

/***/ 14263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JS": function() { return /* binding */ gstNoRegExp; },
/* harmony export */   "Kz": function() { return /* binding */ referralCodeCharLimit; },
/* harmony export */   "Lm": function() { return /* binding */ referralCodeRegExp; },
/* harmony export */   "Oj": function() { return /* binding */ phoneRegExp; },
/* harmony export */   "Pq": function() { return /* binding */ GstNumberRegexExpNew; },
/* harmony export */   "_N": function() { return /* binding */ LorryNumRegExp; },
/* harmony export */   "e0": function() { return /* binding */ aadharNoRegExp; },
/* harmony export */   "gy": function() { return /* binding */ pincodeRegExp; },
/* harmony export */   "rH": function() { return /* binding */ companyNameCharMin; },
/* harmony export */   "to": function() { return /* binding */ panNoRegExp; },
/* harmony export */   "vl": function() { return /* binding */ companyNameRegExpMsg; },
/* harmony export */   "w": function() { return /* binding */ companyNameCharLimit; }
/* harmony export */ });
/* unused harmony export plotNoRegExp */
// export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const phoneRegExp = /[1-9]{1}[0-9]{9}/;
const plotNoRegExp = /^\d+((\/)\d+)?$/;
const pincodeRegExp = /^[1-9][0-9]{5}$/;
const referralCodeCharLimit = 9;
const referralCodeRegExp = /^[a-z]{6}\d{3}$/gi;
// regexp errors when doesn't match
const companyNameCharLimit = 50;
const companyNameCharMin = 3;
const companyNameRegExpMsg = `Please enter valid company name`;
const aadharNoRegExp = /^([2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4})$/;
const gstNoRegExp = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
const panNoRegExp = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
// export const LorryNumRegExp = /^[A-Za-z]{2}\d{2}[A-Za-z]{1,3}(?!0{4})[0-9]{4}$/gi;
// export const LorryNumRegExp = /^[a-z]{2}[a-z0-9]*$/gi;
const LorryNumRegExp = /^[a-zA-Z]{2}(?=.*\d)[a-zA-Z0-9]*$/;
const GstNumberRegexExpNew = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[A-Za-z0-9]{1}Z[A-Za-z0-9]{1}$/;


//# sourceMappingURL=regex.js.map


/***/ }),

/***/ 12098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/* harmony import */ var _authorizedUsers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2390);
/* harmony import */ var _bidStatus_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71535);
/* harmony import */ var _bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47762);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77370);
/* harmony import */ var _event_names_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69406);
/* harmony import */ var _eventsMapObj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3000);
/* harmony import */ var _Faq_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80230);
/* harmony import */ var _languages_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87013);
/* harmony import */ var _loadStatus_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61834);
/* harmony import */ var _lorryStatus_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69673);
/* harmony import */ var _lorryTypes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14345);
/* harmony import */ var _mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16593);
/* harmony import */ var _Pages_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2784);
/* harmony import */ var _serviceTypeId_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76705);
/* harmony import */ var _StateList_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52224);
/* harmony import */ var _bidUpdateType_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(43298);
/* harmony import */ var _userAction_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69881);
/* harmony import */ var _api_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(24966);
/* harmony import */ var _link_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(39422);
/* harmony import */ var _market_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(45678);
/* harmony import */ var _payment_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(91680);
/* harmony import */ var _admin_screenId_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(22391);
/* harmony import */ var _services_const_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(41634);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(63118);
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(11663);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(96762);
/* harmony import */ var _methods_generateQueryString_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(99073);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_34__);






































const ROUTES = {
    transporterProfile: {
        withParam: "/transporters/:src/:transporterName/:transporterId",
        getUrl: (src, transporterName, transporterId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return `/transporters/profile/${(_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.replace) === null || _a === void 0 ? void 0 : _a.call(src, / /g, "-")) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b)}/${(_m = (_l = (_k = (_j = (_h = (_g = (_f = (_e = (_d = transporterName === null || transporterName === void 0 ? void 0 : transporterName.replace) === null || _d === void 0 ? void 0 : _d.call(transporterName, / /g, "-")) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, /,/g, "-")) === null || _g === void 0 ? void 0 : _g.replace) === null || _h === void 0 ? void 0 : _h.call(_g, /--/g, "-")) === null || _j === void 0 ? void 0 : _j.replace) === null || _k === void 0 ? void 0 : _k.call(_j, /\s|\.|\//g, "-")) === null || _l === void 0 ? void 0 : _l.toLowerCase) === null || _m === void 0 ? void 0 : _m.call(_l)}/${transporterId}`;
        },
        getUrlWithId: (transporterId) => `/transporters/profile/${transporterId}`
    },
    transporterProfileDetail: {
        getUrl: (transporterId) => `/transporters/profile/detail/${transporterId}`
    },
    transporterReviews: {
        withParam: "/transporters/:src/:transporterName/:transporterId/reviews",
        getUrl: (src, transporterName, transporterId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return `/transporters/profile/${(_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.replace) === null || _a === void 0 ? void 0 : _a.call(src, / /g, "-")) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b)}/${(_m = (_l = (_k = (_j = (_h = (_g = (_f = (_e = (_d = transporterName === null || transporterName === void 0 ? void 0 : transporterName.replace) === null || _d === void 0 ? void 0 : _d.call(transporterName, / /g, "-")) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, /,/g, "-")) === null || _g === void 0 ? void 0 : _g.replace) === null || _h === void 0 ? void 0 : _h.call(_g, /--/g, "-")) === null || _j === void 0 ? void 0 : _j.replace) === null || _k === void 0 ? void 0 : _k.call(_j, /\./g, "")) === null || _l === void 0 ? void 0 : _l.toLowerCase) === null || _m === void 0 ? void 0 : _m.call(_l)}/${transporterId}/reviews`;
        }
    },
    marketplace: {
        withParam: [
            "/marketplace-ae/:mktType/to-:dest",
            "/marketplace-ae/:mktType/:src-to-:dest",
            "/marketplace-ae/:mktType/:src",
            "/marketplace-ae/:mktType",
            "/marketplace/:mktType/to-:dest",
            "/marketplace/:mktType/:src-to-:dest",
            "/marketplace/:mktType/:src",
            "/marketplace/:mktType"
        ],
        getUrl: (mktType, src, dest, isABtestingRoute) => {
            var _a, _b, _c, _d, _e, _f, _g;
            let url = "";
            if (src && dest) {
                url = `/marketplace/${mktType}/${src}-to-${dest}`;
            }
            else if (src) {
                url = `/marketplace/${mktType}/${src}`;
            }
            else if (dest) {
                url = `/marketplace/${mktType}/to-${dest}`;
            }
            else {
                url = `/marketplace/${mktType}`;
            }
            url = (_g = (_f = (_e = (_d = (_c = (_b = (_a = url === null || url === void 0 ? void 0 : url.replace) === null || _a === void 0 ? void 0 : _a.call(url, / /g, "-")) === null || _b === void 0 ? void 0 : _b.replace) === null || _c === void 0 ? void 0 : _c.call(_b, /,/g, "-")) === null || _d === void 0 ? void 0 : _d.replace) === null || _e === void 0 ? void 0 : _e.call(_d, /--/g, "-")) === null || _f === void 0 ? void 0 : _f.toLowerCase) === null || _g === void 0 ? void 0 : _g.call(_f);
            if (isABtestingRoute)
                url = url.replace("marketplace", "marketplace-ae");
            return url;
        }
    },
    loadBid: {
        withParam: ["/marketplace/load/:src-to-:dest#id"],
        getUrl: (src, dest, loadId, companyId) => {
            var _a, _b, _c, _d;
            return (_d = (_b = (_a = `/marketplace/load/${src}-to-${dest}?oppCmpId=${companyId}&loadbid=${loadId}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : (_c = _b.call(_a, / /g, "-")).toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
    },
    lorryBid: {
        withParam: ["/marketplace/lorry/:src#id"],
        getUrl: (src, lorryId, companyId) => {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = `/marketplace/lorry/${src}?oppCmpId=${companyId}&lorrybid=${lorryId}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
        }
    },
    bidHistory: {
        withParam: ["/:mktType-marketplace/bid-history"],
        getUrl: (mktType) => `/${mktType}-marketplace/bid-history`
    },
    transporters: {
        withParam: ["/transporters"],
        getUrl: (src, dest) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            const baseUrl = "/transporters";
            src = (_g = (_f = (_e = (_d = (_c = (_b = (_a = src === null || src === void 0 ? void 0 : src.replace) === null || _a === void 0 ? void 0 : _a.call(src, / /g, "-")) === null || _b === void 0 ? void 0 : _b.replace) === null || _c === void 0 ? void 0 : _c.call(_b, /,/g, "-")) === null || _d === void 0 ? void 0 : _d.replace) === null || _e === void 0 ? void 0 : _e.call(_d, /--/g, "-")) === null || _f === void 0 ? void 0 : _f.toLowerCase) === null || _g === void 0 ? void 0 : _g.call(_f);
            dest = (_p = (_o = (_m = (_l = (_k = (_j = (_h = dest === null || dest === void 0 ? void 0 : dest.replace) === null || _h === void 0 ? void 0 : _h.call(dest, / /g, "-")) === null || _j === void 0 ? void 0 : _j.replace) === null || _k === void 0 ? void 0 : _k.call(_j, /,/g, "-")) === null || _l === void 0 ? void 0 : _l.replace) === null || _m === void 0 ? void 0 : _m.call(_l, /--/g, "-")) === null || _o === void 0 ? void 0 : _o.toLowerCase) === null || _p === void 0 ? void 0 : _p.call(_o);
            if (src && dest) {
                return `${baseUrl}/${src}-to-${dest}`;
            }
            if (src) {
                return `${baseUrl}/${src}`;
            }
            if (dest) {
                return `${baseUrl}/for-${dest}`;
            }
            return baseUrl;
        }
    },
    pageNotFound: {
        withParam: "/page-not-found",
        getUrl: () => "/page-not-found"
    },
    dashboard: {
        withParam: "/dashboard",
        getUrl: () => "/dashboard"
    },
    userProfile: {
        withParam: "/my-profile",
        getUrl: () => "/my-profile"
    },
    userProfileEdit: {
        withParam: "/my-profile/edit",
        getUrl: () => "/my-profile/edit"
    },
    adminConsole: {
        withParam: "/",
        getUrl: () => "/"
    },
    adminConsoleLogin: {
        withParam: "/login",
        getUrl: () => "/login"
    },
    adminConsoleExecutives: {
        withParam: "/executives",
        getUrl: () => "/executives"
    },
    adminConsoleRecords: {
        withParam: "/records",
        getUrl: () => "/records"
    },
    adminConsoleCustomer: {
        withParam: "/customer-login",
        getUrl: () => "/customer-login"
    },
    adminConsoleCustomerProfile: {
        withParam: "/customer-profile",
        getUrl: () => "/customer-profile"
    },
    adminConsoleCustomerProfileEdit: {
        withParam: "/customer-profile/edit",
        getUrl: () => "/customer-profile/edit"
    },
    adminConsoleCustomerMarketplace: {
        withParam: [
            "/customer-marketplace/:mktType/to-:dest",
            "/customer-marketplace/:mktType/:src-to-:dest",
            "/customer-marketplace/:mktType/:src",
            "/customer-marketplace/:mktType"
        ],
        getUrl: (mktType, src, dest) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            let url = "";
            if (src && dest) {
                url = (_d = (_c = (_b = (_a = `/customer-marketplace/${mktType}/${src}-to-${dest}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (src) {
                url = (_h = (_g = (_f = (_e = `/customer-marketplace/${mktType}/${src}`) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            else if (dest) {
                url = (_k = (_j = `/customer-marketplace/${mktType}/to-${dest}`) === null || _j === void 0 ? void 0 : _j.toLowerCase) === null || _k === void 0 ? void 0 : _k.call(_j);
            }
            else {
                url = `/customer-marketplace/${mktType}`;
            }
            return url;
        }
    },
    adminConsoleEditProfile: {
        withParam: "/edit-profile",
        getUrl: () => "/edit-profile"
    },
    adminConsoleEditPassword: {
        withParam: "/edit-password",
        getUrl: () => "/edit-password"
    },
    adminConsoleCreateId: {
        withParam: "/executives/createid",
        getUrl: () => "/executives/createid"
    },
    adminConsoleBlockUsers: {
        withParam: "/block-users",
        getUrl: () => "/block-users"
    },
    adminConsoleSendWhatsAppMessage: {
        withParam: "/send-whatsapp-message",
        getUrl: () => "/send-whatsapp-message"
    },
    adminConsoleGlobalSearchResult: {
        withParam: "/search",
        getUrl: () => "/search"
    },
    adminConsolePremiumClients: {
        withParam: "/premium/client-list",
        getUrl: () => "/premium/client-list"
    },
    premiumLoadTrip: {
        withParam: `/premium/load-trip/`,
        getUrl: (loadId) => `/premium/load-trip/${loadId}`
    },
    premiumTripTrack: {
        withParam: `/premium/load-trip/track`,
        getUrl: () => `/premium/load-trip/track`
    },
    listing: {
        withParam: "/ac/my-loads/listing/:id",
        getUrl: (id) => `/ac/my-loads/listing/${id}`
    },
    myLoadsMyLorries: {
        withParam: [
            "/ac/my-:mktType/:activeTab/to-:dest",
            "/ac/my-:mktType/:activeTab/:src-to-:dest",
            "/ac/my-:mktType/:activeTab/:src",
            "/ac/my-:mktType/:activeTab"
        ],
        getUrl: (mktType, activeTab, src, dest) => {
            var _a;
            let url = "";
            if (src && dest) {
                url = (_a = `/ac/my-${mktType}/${activeTab}/${src}-to-${dest}`.replace(/ /g, "-")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
            }
            else if (src) {
                url = `/ac/my-${mktType}/${activeTab}/${src}`.replace(/ /g, "-").toLowerCase();
            }
            else if (dest) {
                url = `/ac/my-${mktType}/${activeTab}/to-${dest}`.replace(/ /g, "-").toLowerCase();
            }
            else {
                url = `/ac/my-${mktType}/${activeTab}`;
            }
            return url;
        }
    },
    adminConsoleMyLoadsMyLorries: {
        withParam: [
            "/customer-:mktType/:activeTab/to-:dest",
            "/customer-:mktType/:activeTab/:src-to-:dest",
            "/customer-:mktType/:activeTab/:src",
            "/customer-:mktType/:activeTab"
        ],
        getUrl: (mktType, activeTab, src, dest) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            let url = "";
            if (src && dest) {
                url = (_d = (_c = (_b = (_a = `/customer-${mktType}/${activeTab}/${src}-to-${dest}`) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (src) {
                url = (_h = (_g = (_f = (_e = `/customer-${mktType}/${activeTab}/${src}`).replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            else if (dest) {
                url = (_k = (_j = `/customer-${mktType}/${activeTab}/to-${dest}`) === null || _j === void 0 ? void 0 : _j.toLowerCase) === null || _k === void 0 ? void 0 : _k.call(_j);
            }
            else {
                url = `/customer-${mktType}/${activeTab}`;
            }
            return url;
        }
    },
    help: {
        withParam: "/help",
        getUrl: () => "/help"
    },
    paymentList: {
        withParam: `/premium/payment-list`,
        getUrl: () => `/premium/payment-list`
    },
    adminConsoleTrackScreen: {
        withParam: `/track-vehicle`,
        getUrl: () => `/track-vehicle`
    },
    adminConsoleMobileViewHome: {
        withParam: `/mw`,
        getUrl: () => `/mw`
    },
    adminConsoleMobileViewTrackScreen: {
        withParam: `/mw/track-vehicle`,
        getUrl: () => `/mw/track-vehicle`
    },
    adminConsoleMobileViewPhysicalVerifyDoc: {
        withParam: `/mw/physical-verify-doc`,
        getUrl: (ticketId) => {
            let url = `/mw/physical-verify-doc`;
            if (ticketId) {
                url = `${url}/${ticketId}`;
            }
            return url;
        }
    },
    adminConsoleMobileViewMyReferral: {
        withParam: `/mw/my-referral`,
        getUrl: (isNew = false, cid = "") => {
            let url = `/mw/my-referral`;
            if (isNew && !cid) {
                url += "/new";
            }
            if (cid && !isNew) {
                url += `/my-user/${cid}`;
            }
            return url;
        }
    },
    adminConsoleMobileViewAssuredLoadPosted: {
        withParam: `/mw/tso/load/assured-spot`,
        getUrl: () => `/mw/tso/load/assured-spot`
    },
    adminConsoleMobileViewLoadPosted: {
        withParam: `/mw/tso/load/active`,
        getUrl: () => `/mw/tso/load/active`
    },
    adminConsoleMobileViewInTransitLoads: {
        withParam: `/mw/tso/load/in-transit`,
        getUrl: () => `/mw/tso/load/in-transit`
    },
    adminConsoleMobileViewLorryPosted: {
        withParam: `/mw/tso/lorry/active`,
        getUrl: () => `/mw/tso/lorry/active`
    },
    adminConsoleMobileViewInTransitLorries: {
        withParam: `/mw/tso/lorry/in-transit`,
        getUrl: () => `/mw/tso/lorry/in-transit`
    },
    adminConsoleTsoUserLoadOrLorryDetailsPage: {
        withParam: `/mw/tso/:mktType/detail/:entityId`,
        getUrl: (mktType, entityId) => {
            return `/mw/tso/${mktType}/detail/${entityId}`;
        }
    },
    adminConsoleMobileViewMarket: {
        withParam: `/mw/tso/market/:mktType`,
        getUrl: (mktType) => {
            return `/mw/tso/market/${mktType}`;
        }
    },
    adminConsoleMobileViewEnquiryCards: {
        withParam: `/mw/tso/:type/enquiry-cards`,
        getUrl: (type) => `/mw/tso/${type}/enquiry-cards`
    },
    adminConsoleMobileViewEnquiryCardLorriesList: {
        withParam: `/mw/tso/:type/enquiry-cards/live-lorries`,
        getUrl: (type) => `/mw/tso/load/enquiry-cards/live-lorries`
    },
    adminConsoleMobileViewEnquiryCardLoadsList: {
        withParam: `/mw/tso/:type/enquiry-cards/live-loads`,
        getUrl: (type) => `/mw/tso/lorry/enquiry-cards/live-loads`
    },
    adminMobileViewScreen: {
        withParam: `/mw/tso/:name/`,
        getUrl: (name) => `/mw/tso/${name}`
    },
    tsmCashbackStatus: {
        withParam: "/cashback-status",
        getUrl: () => "/cashback-status"
    },
    transporterHome: {
        withParam: "/transporters",
        getUrl: () => "/transporters"
    },
    premiumBulkLoads: {
        withParam: "/premium/bulk-loads",
        getUrl: () => "/premium/bulk-loads"
    },
    premiumBulkLoadsById: {
        withParam: "/premium/bulk-loads",
        getUrl: (bulkId = "") => `/premium/bulk-loads/${bulkId}`
    },
    adminConsoleTicketSystem: {
        withParam: ["/ticket-system/:ticketType", "/ticket-system/:ticketType/:ticketId"],
        getUrl: (ticketType, ticketId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let url = "";
            if (ticketType && ticketId) {
                url = (_d = (_c = (_b = (_a = `/ticket-system/${ticketType}/${ticketId}`).replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (ticketType) {
                url = (_h = (_g = (_f = (_e = `/ticket-system/${ticketType}`).replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            return url;
        }
    },
    adminConsoleTapNgoLoadTicketSystem: {
        withParam: [`/ticket-system/loads/tap-n-go`, "/ticket-system/loads/tap-n-go/:loadId"],
        getUrl: (loadId) => {
            if (loadId) {
                return `/ticket-system/loads/tap-n-go/${loadId}`;
            }
            return `/ticket-system/loads/tap-n-go`;
        }
    },
    adminConsoleRefundRequestTicketSystem: {
        withParam: "/ticket-system/refund-request",
        getUrl: () => "/ticket-system/refund-request"
    },
    adminConsoleVasLeadsTicketSystem: {
        withParam: "/ticket-system/vas-leads",
        getUrl: () => "/ticket-system/vas-leads"
    },
    adminConsoleBidsWithDepositLead: {
        withParam: "/ticket-system/bids-with-deposit-lead",
        getUrl: () => "/ticket-system/bids-with-deposit-lead"
    },
    adminConsoleTicketSystemWithTicketType: {
        withParam: `/ticket-system/:type`,
        getUrl: (path) => {
            return `/ticket-system/${path}`;
        }
    },
    adminConsoleLoadTicketSystemWithTicketType: {
        withParam: `/ticket-system/loads/:type`,
        getUrl: (path, loadId, queryObj) => {
            let targetUrl = `/ticket-system/loads/${path}`;
            if (loadId) {
                targetUrl += `/${loadId}`;
            }
            if (queryObj) {
                targetUrl += `?${(0,_methods_generateQueryString_js__WEBPACK_IMPORTED_MODULE_35__/* .generateQueryString */ .T)(queryObj)}`;
            }
            return targetUrl;
        }
    },
    adminConsoleCSUsers: {
        withParam: ["/cs-users", "/cs-users/:userId", "/cs-roles/add", "/cs-users/edit/:userId"],
        getUrl: (userId, actionType) => {
            let url = `/cs-users`;
            if (actionType === "add") {
                return `/cs-users/add`;
            }
            if (actionType === "edit" && userId && !isNaN(userId)) {
                return `/cs-users/edit/${userId}`;
            }
            if (userId) {
                return `/cs-users/${userId}`;
            }
            return url;
        }
    },
    adminConsoleCSRoles: {
        withParam: ["/cs-roles", "/cs-roles/:userType"],
        getUrl: (userType) => {
            let url = `/cs-roles`;
            if (userType) {
                url = `/cs-roles/${userType}`;
            }
            return url;
        }
    },
    adminConsoleCSAttendance: {
        withParam: ["/cs-attendance"],
        getUrl: () => {
            let url = `/cs-attendance`;
            return url;
        }
    },
    membership: {
        withParam: "/membership/",
        getUrl: () => "/membership/"
    },
    membershipHistory: {
        withParam: "/membership/history",
        getUrl: () => "/membership/history"
    },
    membershipUpgrade: {
        withParam: "/membership/upgrade",
        getUrl: () => "/membership/upgrade"
    },
    membershipPayment: {
        withParam: "/membership/payment",
        getUrl: () => "/membership/payment"
    },
    membershipFeatures: {
        withParam: "/membership/features",
        getUrl: () => "/membership/features"
    },
    adminConsolePaymentReportSystem: {
        withParam: ["/payment-report/:reportType", "/payment-report/:reportType/:reportId"],
        getUrl: (reportType, reportId) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let url = "";
            if (reportType && reportId) {
                url = (_d = (_c = (_b = (_a = `/payment-report/${reportType}/${reportId}`).replace) === null || _b === void 0 ? void 0 : _b.call(_a, / /g, "-")) === null || _c === void 0 ? void 0 : _c.toLowerCase) === null || _d === void 0 ? void 0 : _d.call(_c);
            }
            else if (reportType) {
                url = (_h = (_g = (_f = (_e = `/payment-report/${reportType}`).replace) === null || _f === void 0 ? void 0 : _f.call(_e, / /g, "-")) === null || _g === void 0 ? void 0 : _g.toLowerCase) === null || _h === void 0 ? void 0 : _h.call(_g);
            }
            return url;
        }
    },
    adminMisc: {
        withParam: "/misc/:id",
        getUrl: (id) => `/misc/${id}`
    },
    adminTicketTsoLead: {
        withParam: ["/tso-admin/leads"],
        getUrl: () => {
            let url = `/tso-admin/leads`;
            return url;
        }
    },
    adminTicketTsoSessions: {
        withParam: ["/tso-admin/sessions"],
        getUrl: (companyId, timestamp) => {
            let url = `/tso-admin/sessions`;
            if (companyId && timestamp) {
                url = url + `/${companyId}/${timestamp}`;
            }
            return url;
        }
    },
    adminConsolePathWithScreenId: {
        withParam: ["/:screenId"],
        getUrl: (screenId) => {
            let url = `/${screenId}`;
            return url;
        }
    }
};


//# sourceMappingURL=routeStrings.js.map


/***/ }),

/***/ 76705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ CompanyServiceType; },
/* harmony export */   "VP": function() { return /* binding */ ServiceTypeId; },
/* harmony export */   "Vx": function() { return /* binding */ getServiceTypeId; },
/* harmony export */   "s6": function() { return /* binding */ CompanyServiceTypeMap; },
/* harmony export */   "x": function() { return /* binding */ ServiceTypeIdName; }
/* harmony export */ });
/* unused harmony export CommonServiceType */
var CompanyServiceType;
(function (CompanyServiceType) {
    CompanyServiceType["SHIPPER"] = "Shipper";
    CompanyServiceType["FLEET_OWNER"] = "Fleet Owner";
    CompanyServiceType["TRANSPORT_CONTRACTOR"] = "Transport Contractor";
    CompanyServiceType["AGENT_BROKER"] = "Agent/Broker";
    CompanyServiceType["DEPRECATED_SERVICE_TYPE"] = "Transport Contractor, Agent/Broker";
})(CompanyServiceType || (CompanyServiceType = {}));
const CompanyServiceTypeMap = {
    [CompanyServiceType.SHIPPER]: "Shipper",
    [CompanyServiceType.FLEET_OWNER]: "Truck Owner / Driver",
    [CompanyServiceType.TRANSPORT_CONTRACTOR]: "Transporter",
    [CompanyServiceType.AGENT_BROKER]: "Transporter",
    [CompanyServiceType.DEPRECATED_SERVICE_TYPE]: "Transport Contractor, Agent/Broker"
};
var ServiceTypeId;
(function (ServiceTypeId) {
    ServiceTypeId[ServiceTypeId["SHIPPER"] = 1] = "SHIPPER";
    ServiceTypeId[ServiceTypeId["TRUCKER"] = 2] = "TRUCKER";
    ServiceTypeId[ServiceTypeId["TRANSPORTER"] = 3] = "TRANSPORTER";
})(ServiceTypeId || (ServiceTypeId = {}));
const ServiceTypeIdName = {
    [ServiceTypeId.SHIPPER]: "Shipper",
    [ServiceTypeId.TRUCKER]: "Trucker",
    [ServiceTypeId.TRANSPORTER]: "Transporter"
};
const CommonServiceType = [
    CompanyServiceType.TRANSPORT_CONTRACTOR,
    CompanyServiceType.SHIPPER,
    CompanyServiceType.FLEET_OWNER
];
function getServiceTypeId(serviceType) {
    switch (serviceType) {
        case CompanyServiceType.SHIPPER:
            return ServiceTypeId.SHIPPER;
        case CompanyServiceType.FLEET_OWNER:
            return ServiceTypeId.TRUCKER;
        case CompanyServiceType.TRANSPORT_CONTRACTOR:
        case CompanyServiceType.AGENT_BROKER:
        case CompanyServiceType.DEPRECATED_SERVICE_TYPE:
            return ServiceTypeId.TRANSPORTER;
        default:
            return undefined;
    }
}


//# sourceMappingURL=serviceTypeId.js.map


/***/ }),

/***/ 92683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Er": function() { return /* binding */ INSTAGRAM; },
/* harmony export */   "Ib": function() { return /* binding */ TWITTER; },
/* harmony export */   "OX": function() { return /* binding */ TWITTER_HANDLE; },
/* harmony export */   "Rm": function() { return /* binding */ COMPANY_SOCIAL_MEDIA_CHANNELS; },
/* harmony export */   "VU": function() { return /* binding */ YOUTUBE; },
/* harmony export */   "fW": function() { return /* binding */ LINKEDIN; },
/* harmony export */   "vq": function() { return /* binding */ FACEBOOK; }
/* harmony export */ });
const FACEBOOK = "https://www.facebook.com/vahakindia";
const LINKEDIN = "https://www.linkedin.com/company/vahakindia/";
const YOUTUBE = "https://www.youtube.com/channel/UC58fbLa8WOUEVwxg042C6RA";
const INSTAGRAM = "https://www.instagram.com/vahakindia/";
const TWITTER = "https://twitter.com/VahakIndia";
const TWITTER_HANDLE = "@VahakIndia";
const COMPANY_SOCIAL_MEDIA_CHANNELS = {
    FACEBOOK,
    LINKEDIN,
    YOUTUBE,
    INSTAGRAM,
    TWITTER
};


//# sourceMappingURL=socialMediaLinks.js.map


/***/ }),

/***/ 71076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ MY_LOAD_LORRY_TABS; }
/* harmony export */ });
const MY_LOAD_LORRY_TABS = {
    LISTING: "listing",
    BIDS: "bids"
};


//# sourceMappingURL=tab.js.map


/***/ }),

/***/ 69881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ UserActionRequiredResponse; },
/* harmony export */   "V": function() { return /* binding */ UserAction; }
/* harmony export */ });
var UserAction;
(function (UserAction) {
    UserAction["POST_LOAD"] = "post_load";
    UserAction["POST_LORRY"] = "post_lorry";
    UserAction["LOAD_BID"] = "load_bid";
    UserAction["LORRY_BID"] = "lorry_bid";
    UserAction["SEND_C2C_REQUEST"] = "send_c2c_request";
    UserAction["SEND_CONNECTION_REQUEST"] = "send_connection_request";
    UserAction["SIM_TRACKING_REQUEST"] = "simTracking";
})(UserAction || (UserAction = {}));
var UserActionRequiredResponse;
(function (UserActionRequiredResponse) {
    UserActionRequiredResponse["VERIFY_AADHAAR"] = "aadhaar_verification";
    UserActionRequiredResponse["VERIFY_PAN"] = "pan_verification";
    UserActionRequiredResponse["VERIFY_GST"] = "gst_verification";
    UserActionRequiredResponse["BUY_MEMBERSHIP"] = "buy_membership";
    UserActionRequiredResponse["TOP_UP_MEMBERSHIP"] = "topup_membership";
    UserActionRequiredResponse["UPGRADE_MEMBERSHIP"] = "upgrade_membership";
    UserActionRequiredResponse["DAILY_MEMBERSHIP_LIMIT_EXHAUSTED"] = "daily_membership_limit_exhausted";
    UserActionRequiredResponse["EDIT_COMPANY_NAME"] = "edit_company_name";
    UserActionRequiredResponse["MEMBERSHIP_EXPIRED"] = "membership_expired";
    UserActionRequiredResponse["CLEAR_CASHBACK_COINS"] = "clear_cashback_coins";
})(UserActionRequiredResponse || (UserActionRequiredResponse = {}));


//# sourceMappingURL=userAction.js.map


/***/ }),

/***/ 98606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ UserScreenId; }
/* harmony export */ });
const UserScreenId = {
    payment: {
        id: "payment",
        pathname: "/payment"
    },
    cargoInsurance: {
        id: "cargo-insurance",
        pathname: "/vas/cargo-insurance"
    },
    lcvBooking: {
        id: "lcv-booking",
        pathname: "/lcv-booking"
    },
    listing: {
        id: "listing",
        pathname: "/ac/my-loads/listing"
    }
};


//# sourceMappingURL=userScreenId.js.map


/***/ }),

/***/ 37113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z0": function() { return /* reexport */ useCsDashboard/* useCsDashboard */.Z; },
  "M8": function() { return /* reexport */ useVahakQueryClient/* useVahakMutationQuery */.M8; }
});

// UNUSED EXPORTS: default, useDebounce, useDisableScrollBrowserNav, useGetCurrentLocation, useGetCurrentLocationOnPageLoad, useHandleModalToggle, useHover, useIntersect, useLocalStorage, useOutsideClick, usePlaceSearch, useSetAppContext, useStateSearch, useToggleCBRModal, useToggleModalWithLocalState, useTopDest, useUrlQueryParams, useVahakInfiniteQuery, useVahakQuery, useWindowSize

// EXTERNAL MODULE: ../core/dist/hooks/useHover.js
var useHover = __webpack_require__(89085);
// EXTERNAL MODULE: ../core/dist/hooks/useIntersect.js
var useIntersect = __webpack_require__(86369);
// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast_toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../core/dist/methods/getAuthIdParam.js
var getAuthIdParam = __webpack_require__(4913);
// EXTERNAL MODULE: ../core/dist/methods/formatDate.js
var formatDate = __webpack_require__(11663);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
;// CONCATENATED MODULE: ../core/dist/hooks/useHandleModalToggle.js







































function useHandleModalToggle_useHandleModalToggle(statePathArr) {
    const history = useHistory();
    const location = useLocation();
    const { state } = location;
    const openModal = useCallback(() => {
        history.push({
            pathname: history.location.pathname,
            search: history.location.search,
            hash: history.location.hash,
            state: updateNestedObject(state, statePathArr, true)
        });
    }, [history]);
    const closeModal = useCallback(() => {
        history.replace({
            pathname: history.location.pathname,
            search: history.location.search,
            hash: history.location.hash,
            state: updateNestedObject(state, statePathArr, undefined)
        });
    }, [history]);
    return { openModal, closeModal };
}


//# sourceMappingURL=useHandleModalToggle.js.map

;// CONCATENATED MODULE: ../core/dist/hooks/useCallbackRequestedState.js







function useToggleCBRModal() {
    const history = useHistory();
    // Check if callback is requested less than 24 hours
    const checkCallbackRequestedTimeStamp = () => {
        const oneDay = 60 * 60 * 24 * 1000;
        const callbackTimestamp = window.localStorage.getItem(LOC_STORAGE.callbackRequestedTimestamp);
        // Check if callback is requested less than 24 hours
        if (callbackTimestamp === (null) ||
            getTimeDiffMs(callbackTimestamp, new Date().toISOString()) > oneDay) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Custom Hooks
     */
    const { openModal, closeModal } = useHandleModalToggle(["isCallbackRequestPopupVisible"]);
    const toggleCBRModal = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if (!((_a = history.location.state) === null || _a === void 0 ? void 0 : _a.isCallbackRequestPopupVisible)) {
            if (checkCallbackRequestedTimeStamp()) {
                openModal();
            }
            else {
                toast.info("Your request is being processed, we'll get back to you shortly");
                return false;
            }
        }
        else {
            closeModal();
        }
    });
    return { toggleCBRModal, checkCallbackRequestedTimeStamp };
}


//# sourceMappingURL=useCallbackRequestedState.js.map

// EXTERNAL MODULE: ../core/dist/hooks/useSearch.js
var useSearch = __webpack_require__(32099);
// EXTERNAL MODULE: ../core/dist/hooks/useOutsideClick.js
var useOutsideClick = __webpack_require__(94482);
;// CONCATENATED MODULE: ../core/dist/hooks/useDisableScrollBrowserNav.js


// use this hook to disbale broswer changing page accidentally due to over scroll
function useDisableScrollBrowserNav() {
    useEffect(() => {
        if (document.querySelector("body") !== null) {
            document.querySelector("body").style.overscrollBehaviorX = "none";
        }
    }, []);
}


//# sourceMappingURL=useDisableScrollBrowserNav.js.map

// EXTERNAL MODULE: ../core/dist/hooks/useTopDest.js
var useTopDest = __webpack_require__(75206);
// EXTERNAL MODULE: ../core/dist/hooks/useGetCurrentLocation.js
var useGetCurrentLocation = __webpack_require__(64395);
// EXTERNAL MODULE: ../core/dist/hooks/useSetAppContext.js + 1 modules
var useSetAppContext = __webpack_require__(38566);
;// CONCATENATED MODULE: ../core/dist/hooks/useUrlQueryParams.js



function useUrlQueryParams() {
    const { search } = useLocation();
    return React__default.useMemo(() => new URLSearchParams(search), [search]);
}


//# sourceMappingURL=useUrlQueryParams.js.map

// EXTERNAL MODULE: ../core/dist/hooks/useToggleModalWithLocalState.js
var useToggleModalWithLocalState = __webpack_require__(73778);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var useVahakHttpClient = __webpack_require__(36153);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/hooks/useDebounce.js
var useDebounce = __webpack_require__(63478);
;// CONCATENATED MODULE: ../core/dist/hooks/useWindowSize.js


const getWidth = () => {
    if (typeof window !== "undefined") {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
};
const useWindowSize = () => {
    const [width, setWidth] = useState(getWidth());
    useEffect(() => {
        let timeoutId;
        const resizeListener = () => {
            clearTimeout(timeoutId);
            // change width from the state object after 150 milliseconds
            timeoutId = setTimeout(() => setWidth(getWidth()), 150);
        };
        window.addEventListener("resize", resizeListener);
        // clean up function
        return () => {
            window.removeEventListener("resize", resizeListener);
        };
    }, []);
    return width;
};


//# sourceMappingURL=useWindowSize.js.map

// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
;// CONCATENATED MODULE: ../core/dist/hooks/useLocalStorage.js


const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        if (typeof window === "undefined") {
            return defaultValue;
        }
        try {
            return JSON.parse(localStorage.getItem(key) || String(defaultValue));
        }
        catch (error) {
            return defaultValue;
        }
    });
    const updateValue = (val) => {
        setValue(val);
        if (typeof window !== "undefined") {
            localStorage.setItem(key, JSON.stringify(val));
        }
    };
    return [value, updateValue];
};


//# sourceMappingURL=useLocalStorage.js.map

;// CONCATENATED MODULE: ../core/dist/hooks/index.js




















//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCsDashboard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _app_context_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4628);
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52489);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(63118);
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68381);
/* harmony import */ var _methods_getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4913);
/* harmony import */ var _methods_formatDate_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(11663);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(52224);
/* harmony import */ var _methods_getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(98819);
/* harmony import */ var _methods_getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _methods_getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(96762);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(76705);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(43298);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(91680);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(22391);
/* harmony import */ var _services_const_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(41634);






































const useCsDashboard = () => {
    const { csDashboardPermission, csDashboardUserRoles, isCsDashboardUser, companyId } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_app_context_js__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    const checkRole = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((role) => {
        return (isCsDashboardUser &&
            Array.isArray(role) &&
            !!(role === null || role === void 0 ? void 0 : role.length) &&
            (role === null || role === void 0 ? void 0 : role.some((r) => csDashboardUserRoles === null || csDashboardUserRoles === void 0 ? void 0 : csDashboardUserRoles.includes(r))));
    }, [csDashboardUserRoles]);
    const checkPermission = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((operation, filterType = "or") => {
        var _a;
        if (!isCsDashboardUser) {
            return false;
        }
        if (Array.isArray(operation)) {
            if (filterType === "and") {
                return operation.every((op) => csDashboardPermission === null || csDashboardPermission === void 0 ? void 0 : csDashboardPermission.includes(op));
            }
            else {
                return operation.length > 0 ? operation.some((op) => csDashboardPermission === null || csDashboardPermission === void 0 ? void 0 : csDashboardPermission.includes(op)) : true;
            }
        }
        else {
            return operation ? !!((_a = csDashboardPermission === null || csDashboardPermission === void 0 ? void 0 : csDashboardPermission.includes) === null || _a === void 0 ? void 0 : _a.call(csDashboardPermission, operation)) : false;
        }
    }, [csDashboardPermission]);
    const derivedRole = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        return {
            isTso: checkRole([_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .UserType.TSO */ .FW.TSO]) && checkPermission("tagAgent"),
            isTsoV2: checkRole(_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .USER_GROUP.TSO_V2 */ .tf.TSO_V2),
            isInternalUser: !!checkRole(_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .USER_GROUP.INTERNAL_USERS */ .tf.INTERNAL_USERS),
            isSuperUser: !!checkRole(_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .USER_GROUP.SUPER_USERS */ .tf.SUPER_USERS),
            isSuperAdmin: !!checkRole([_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .UserType.SUPER_ADMIN */ .FW.SUPER_ADMIN]),
            isDeveloper: !!checkRole([_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .UserType.DEVELOPER */ .FW.DEVELOPER]),
            isAdmin: !!checkRole(_constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_2__/* .USER_GROUP.ADMINS */ .tf.ADMINS)
        };
    }, [csDashboardPermission, csDashboardUserRoles]);
    return Object.assign({ checkPermission: checkPermission, isCsDashboardUser: !!isCsDashboardUser, currentOperation: undefined, currentRole: undefined, checkRole: checkRole }, (isCsDashboardUser && Object.assign(Object.assign({}, derivedRole), { currentOperation: csDashboardPermission, currentRole: csDashboardUserRoles, csUserCompanyId: Number(companyId) })));
};


//# sourceMappingURL=useCsDashboard.js.map


/***/ }),

/***/ 63478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}


//# sourceMappingURL=useDebounce.js.map


/***/ }),

/***/ 64395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useGetCurrentLocationOnPageLoad; }
/* harmony export */ });
/* unused harmony export useGetCurrentLocation */
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77370);
/* harmony import */ var _methods_getCurrentLocation_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46047);
/* harmony import */ var _useCsDashboard_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68191);
/* harmony import */ var _services_city_search_service_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20803);







function useGetCurrentLocation() {
    const { isCsDashboardUser } = useCsDashboard();
    const getAndSetCurrentLocation = (paramsOption) => __awaiter(this, void 0, void 0, function* () {
        if (isCsDashboardUser) {
            return;
        }
        const locDataRes = yield fetch(`https://api.ipdata.co?api-key=${IP_DATA_KEY}`);
        if (locDataRes.status === 200) {
            const locData = yield locDataRes.json();
            const { name, id, state, state_id, state_code } = (yield searchUsingPlacesAPI(locData.city, paramsOption))[0];
            const currLocObj = {
                status: "done",
                lat: locData.latitude,
                lng: locData.longitude,
                id,
                name,
                state,
                state_id,
                state_code
            };
            // setCurrentLocation?.(currLocObj);
            return currLocObj;
        }
        // if (!currentLocation) {
        //     const savedLoc = JSON.parse(window.localStorage.getItem("currentLocation") || "null") as Location;
        //     if (savedLoc) {
        //         setCurrentLocation?.({
        //             lat: savedLoc.lat,
        //             lng: savedLoc.lng,
        //             city: savedLoc.city,
        //             state: savedLoc.state
        //         });
        //     } else {
        // window.navigator.geolocation.getCurrentPosition(
        //     ({ coords }) => {
        //         setCurrentLocation?.({ lat: coords.latitude, lng: coords.longitude, status: "done" });
        //         // window.localStorage.setItem(
        //         //     "currentLocation",
        //         //     JSON.stringify({ lat: coords.latitude, lng: coords.longitude })
        //         // );
        //     },
        //     () => {
        //         setCurrentLocation?.({ status: "denied" });
        //         toast.error("Please enable location permission from settings and try again!", {
        //             position: "top-center",
        //             draggable: false,
        //             transition: Slide
        //         });
        //     }
        // );
        // }
        // }
    });
    return { getAndSetCurrentLocation };
}
function useGetCurrentLocationOnPageLoad({ enabled = true, locationSearchParams }) {
    const { isCsDashboardUser } = (0,_useCsDashboard_js__WEBPACK_IMPORTED_MODULE_4__/* .useCsDashboard */ .Z)();
    // const { setCurrentLocation } = useContext(AppContext);
    const [currLoc, setCurrLoc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    // const { getAndSetCurrentLocation } = useGetCurrentLocation();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        // setCurrentLocation?.({ status: "loading" });
        if (!enabled || isCsDashboardUser) {
            return;
        }
        (() => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            const res = yield (0,_methods_getCurrentLocation_js__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentLocation */ .v)(false, locationSearchParams);
            setCurrLoc(res);
        }))();
        // if (navigator.permissions) {
        //     navigator.permissions.query({ name: "geolocation" }).then((status) => {
        //         if (status.state === "granted") {
        //             setCurrentLocation?.({ status: "loading" });
        //             getAndSetCurrentLocation();
        //         }
        //     });
        // } else {
        //     // for Safari
        //     setCurrentLocation?.({ status: "loading" });
        //     getAndSetCurrentLocation();
        // }
        // // window.navigator.geolocation. getAndSetCurrentLocation();
    }, [enabled, isCsDashboardUser]);
    return currLoc;
}


//# sourceMappingURL=useGetCurrentLocation.js.map


/***/ }),

/***/ 89085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useHover; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useHover(ref) {
    const [isHovered, setIsHovered] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const handleMouseOver = () => setIsHovered(true);
    const handleMouseOut = () => setIsHovered(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const node = ref.current;
        if (node) {
            node.addEventListener("mouseover", handleMouseOver);
            node.addEventListener("mouseout", handleMouseOut);
            return () => {
                node.removeEventListener("mouseover", handleMouseOver);
                node.removeEventListener("mouseout", handleMouseOut);
            };
        }
    }, [ref.current] // Recall only if ref changes
    );
    return isHovered;
}


//# sourceMappingURL=useHover.js.map


/***/ }),

/***/ 86369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useIntersect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


const useIntersect = ({ root = null, rootMargin = "0px", threshold = 0 }) => {
    const [entry, updateEntry] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    const [node, setNode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (observer.current) {
            observer.current.disconnect();
        }
        observer.current = new window.IntersectionObserver(([entry]) => updateEntry(entry), {
            root,
            rootMargin,
            threshold
        });
        const { current: currentObserver } = observer;
        currentObserver.disconnect();
        if (node)
            currentObserver.observe(node);
        return () => currentObserver.disconnect();
    }, [node]);
    return { setNode, entry };
};


//# sourceMappingURL=useIntersect.js.map


/***/ }),

/***/ 94482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useOutsideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


const useOutsideClick = (props) => {
    const [popupView, setPopupView] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(props);
    const handlePopupView = () => {
        setPopupView(!popupView);
    };
    const elmRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const handleClickOutside = (event) => {
        if (elmRef.current && !elmRef.current.contains(event.target)) {
            setPopupView(!popupView);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        window.addEventListener("mousedown", handleClickOutside);
        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        };
    }, [popupView]);
    return [popupView, elmRef, handlePopupView];
};


//# sourceMappingURL=useOutsideClick.js.map


/***/ }),

/***/ 32099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ usePlaceSearch; },
/* harmony export */   "k": function() { return /* binding */ useStateSearch; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _app_context_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4628);
/* harmony import */ var _services_city_search_service_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20803);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52224);
/* harmony import */ var _methods_getCurrentLocation_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46047);
/* harmony import */ var _useCsDashboard_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68191);








function useSearch({ defaultOptions, onSelectItem, showCurrentLocationOption, locationParamsOption }) {
    const [searchText, setSearchText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [isSearchLoading, setIsSearchLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [_defaultOptions, setDefaultOptions] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [searchOptions, setSearchOptions] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [selectedItem, setSelectedItem] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const { isCsDashboardUser } = (0,_useCsDashboard_js__WEBPACK_IMPORTED_MODULE_6__/* .useCsDashboard */ .Z)();
    const onInputChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((input) => {
        input === "" && setSearchOptions(_defaultOptions || []);
    }, [defaultOptions]);
    const onFocus = () => {
        setSearchOptions(_defaultOptions || []);
    };
    const _onItemSelected = (selectedItems) => {
        var _a;
        if (((_a = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems[0]) === null || _a === void 0 ? void 0 : _a.category) === "currentLoc") {
            setSelectedItem(undefined);
        }
        else {
            setSelectedItem(selectedItems[0]);
        }
        onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(selectedItems);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        if (showCurrentLocationOption && !isCsDashboardUser) {
            setDefaultOptions([{ name: "Use Current City", category: "currentLoc" }, ...(defaultOptions || [])]);
        }
        else {
            setDefaultOptions(defaultOptions);
        }
    }, [showCurrentLocationOption, defaultOptions]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        _defaultOptions && setSearchOptions(_defaultOptions);
    }, [_defaultOptions]);
    return {
        searchText,
        setSearchText,
        isSearchLoading,
        setIsSearchLoading,
        searchOptions,
        setSearchOptions,
        onInputChange,
        _onItemSelected,
        selectedItem,
        setSelectedItem,
        onFocus
    };
}
function useStateSearch({ defaultOptions, onSelectItem, showCurrentLocationOption, locationParamsOption }) {
    const { isSearchLoading, onInputChange, searchOptions, searchText, setIsSearchLoading, setSearchText, setSearchOptions, _onItemSelected, selectedItem, setSelectedItem, onFocus } = useSearch({
        locationParamsOption,
        defaultOptions,
        onSelectItem,
        showCurrentLocationOption
    });
    const labelKey = ({ state }) => state || "";
    const onSearchInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((query) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        query = decodeURIComponent(query);
        setIsSearchLoading(true);
        setSearchText(query);
        const options = _constants_StateList_js__WEBPACK_IMPORTED_MODULE_4__/* .STATE_LIST.filter */ .t4.filter((s) => s.name.match(new RegExp("^" + query, "i")));
        setSearchOptions(options);
        setIsSearchLoading(false);
    }), []);
    return {
        searchText,
        labelKey,
        setSearchText,
        isSearchLoading,
        setIsSearchLoading,
        searchOptions,
        setSearchOptions,
        onInputChange,
        onSearchInput,
        onItemSelected: _onItemSelected,
        selectedItem,
        setSelectedItem,
        onFocus
    };
}
function usePlaceSearch({ defaultOptions, onSelectItem, showCurrentLocationOption, locationParamsOption }) {
    const { updateRecentTransporterCitySearches } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_app_context_js__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il);
    const { isSearchLoading, onInputChange, searchOptions, searchText, setIsSearchLoading, setSearchText, setSearchOptions, _onItemSelected, selectedItem, setSelectedItem, onFocus } = useSearch({
        defaultOptions,
        onSelectItem,
        showCurrentLocationOption,
        locationParamsOption
    });
    const labelKey = ({ name }) => {
        return name ? name : "";
    };
    const onSearchInput = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((query) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        setIsSearchLoading(true);
        setSearchText(query);
        try {
            const options = (yield (0,_services_city_search_service_js__WEBPACK_IMPORTED_MODULE_3__/* .searchUsingPlacesAPI */ .PP)(query, locationParamsOption));
            if (options.length !== 0)
                setSearchOptions(options.map((option, i) => {
                    return {
                        id: i,
                        name: option.description,
                        state_id: i,
                        state_code: "",
                        state: option.state,
                        place_id: option.place_id,
                        city: option.city
                    };
                }));
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsSearchLoading(false);
        }
    }), []);
    const __onItemSelected = (selectedItems) => (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        var _a;
        if (((_a = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems[0]) === null || _a === void 0 ? void 0 : _a.category) === "currentLoc") {
            setIsSearchLoading(true);
            const currLoc = yield (0,_methods_getCurrentLocation_js__WEBPACK_IMPORTED_MODULE_5__/* .getCurrentLocation */ .v)(true, locationParamsOption);
            if (!currLoc || currLoc.status === "failed") {
                setIsSearchLoading(false);
                return;
            }
            _onItemSelected === null || _onItemSelected === void 0 ? void 0 : _onItemSelected([currLoc]);
            setIsSearchLoading(false);
            return;
        }
        if (selectedItems[0])
            updateRecentTransporterCitySearches === null || updateRecentTransporterCitySearches === void 0 ? void 0 : updateRecentTransporterCitySearches(selectedItems[0]);
        _onItemSelected === null || _onItemSelected === void 0 ? void 0 : _onItemSelected(selectedItems);
        return;
    });
    return {
        labelKey,
        searchText,
        setSearchText,
        isSearchLoading,
        setIsSearchLoading,
        searchOptions,
        setSearchOptions,
        onInputChange,
        onSearchInput,
        onItemSelected: __onItemSelected,
        selectedItem,
        setSelectedItem,
        onFocus
    };
}


//# sourceMappingURL=useSearch.js.map


/***/ }),

/***/ 38566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ useSetAppContext; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../core/dist/methods/getInitialContextValues.js
var getInitialContextValues = __webpack_require__(8660);
// EXTERNAL MODULE: ../core/dist/methods/getUniqueArray.js
var getUniqueArray = __webpack_require__(88020);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(47004);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/hooks/useGetCurrentLocation.js
var useGetCurrentLocation = __webpack_require__(64395);
// EXTERNAL MODULE: ../core/dist/_services/city-search.service.js
var city_search_service = __webpack_require__(20803);
;// CONCATENATED MODULE: ../core/dist/hooks/useMediaQuery.js


const useMediaQuery = (props) => {
    // 1. Memoize the query string for performance and type safety.
    const query = (0,react.useMemo)(() => {
        const { queryType } = props;
        switch (queryType) {
            case "max-width":
            case "min-width":
            case "max-height":
            case "min-height":
                // Safely access sizePx only for custom query types
                return `(${queryType}: ${props.sizePx}px)`;
            case "mobile":
                return `(max-width: 576px)`;
            case "medium-screen":
                return `(max-width: 991px)`;
            case "desktop":
                return `(min-width: 992px)`;
            default:
                return "";
        }
    }, [props]); // Recalculate only when props change.
    // 2. Safely initialize state, considering Server-Side Rendering (SSR).
    const [matches, setMatches] = (0,react.useState)(() => {
        var _a;
        if (typeof window !== "undefined") {
            return window.matchMedia(query).matches;
        }
        // Fallback for SSR and initial state
        return (_a = props.initialState) !== null && _a !== void 0 ? _a : false;
    });
    // 3. Use an efficient listener and fix the dependency array.
    (0,react.useEffect)(() => {
        // Ensure this effect runs only on the client.
        if (typeof window === "undefined")
            return;
        const mediaQueryList = window.matchMedia(query);
        const listener = (event) => {
            setMatches(event.matches);
        };
        // The 'change' event is more efficient than 'resize'.
        mediaQueryList.addEventListener("change", listener);
        // Cleanup listener on component unmount.
        return () => {
            mediaQueryList.removeEventListener("change", listener);
        };
    }, [query]); // <- The dependency array is now correct.
    return matches;
};


//# sourceMappingURL=useMediaQuery.js.map

;// CONCATENATED MODULE: ../core/dist/hooks/useSetAppContext.js
/* provided dependency */ var process = __webpack_require__(34406);











function useSetAppContext({ src } = {}) {
    const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    const isProductionEnv = ENV === "production";
    const router = (0,next_router.useRouter)();
    const [cookies, setCookie, removeCookie] = (0,useCookies/* default */.Z)([]);
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const [context, setContext] = (0,react.useState)(Object.assign(Object.assign(Object.assign({}, (0,getInitialContextValues/* getInitialContextValues */.w)()), (src === "csDashboard" && {
        isCsDashboardUser: true,
        csDashboardUserRoles: cookies.csdsbUserRoles,
        csDashboardPermission: cookies[misc/* COOKIES.csDashboardPermission */.E9.csDashboardPermission]
    })), { isProductionEnv }));
    const currentCity = (0,useGetCurrentLocation/* useGetCurrentLocationOnPageLoad */.j)({
        enabled: src !== "csDashboard",
        locationSearchParams: {
            source: city_search_service/* LocationSearchSource.CompanyCurrentLocation */.T5.CompanyCurrentLocation
        }
    });
    const updateEventCount = (name, value) => {
        var _a, _b;
        const { eventCounts } = context;
        const newValue = Number((_b = value !== null && value !== void 0 ? value : (_a = context === null || context === void 0 ? void 0 : context.eventCounts) === null || _a === void 0 ? void 0 : _a[name]) !== null && _b !== void 0 ? _b : 0) + 1;
        if ((eventCounts === null || eventCounts === void 0 ? void 0 : eventCounts[name]) !== undefined) {
            eventCounts[name] = newValue;
        }
        setCookie(misc/* COOKIES */.E9[name], newValue);
        setContext((state) => (Object.assign(Object.assign({}, state), { eventCounts })));
    };
    const isUserLoggedIn = !!(context.customerCompanyId || context.companyId);
    const checkRestrictedEvent = (name) => {
        var _a;
        switch (name) {
            case "citySearchCount":
            case "transporterSearchCount": {
                const count = Number(((_a = context === null || context === void 0 ? void 0 : context.eventCounts) === null || _a === void 0 ? void 0 : _a[name]) || 0);
                return count >= 3;
            }
            case "pagination": {
                return true;
            }
            default: {
                return false;
            }
        }
    };
    const checkAndHandleGuestUserRestriction = (name) => {
        if (!isUserLoggedIn) {
            if (checkRestrictedEvent(name)) {
                router === null || router === void 0 ? void 0 : router.push({ hash: "#Login" });
                return false;
            }
            updateEventCount === null || updateEventCount === void 0 ? void 0 : updateEventCount(name);
        }
        return true;
    };
    (0,react.useEffect)(() => {
        setContext((context) => (Object.assign(Object.assign({}, context), { isMobileScreen })));
    }, [isMobileScreen]);
    (0,react.useEffect)(() => {
        const fetchCurrentLocation = () => (0,_tslib/* __awaiter */.m)(this, void 0, void 0, function* () {
            if (currentCity === null || currentCity === void 0 ? void 0 : currentCity.place_id) {
                setContext((context) => (Object.assign(Object.assign({}, context), { globalData: Object.assign(Object.assign({}, context.globalData), { userPlaceInfo: currentCity }) })));
            }
        });
        fetchCurrentLocation();
    }, [currentCity]);
    (0,react.useEffect)(() => {
        setContext((state) => (Object.assign(Object.assign(Object.assign(Object.assign({}, state), { isMobile: window.matchMedia("(max-width: 991px)").matches, updateBulkRequestIds: ({ action, fileName, requestId }) => {
                const prevReqIds = state.bulkRequestIds;
                switch (action) {
                    case "ADD":
                        const addedReqIds = [...prevReqIds];
                        // Checking whether the particular id is already present
                        if (!addedReqIds.find((reqId) => reqId.requestId === requestId)) {
                            addedReqIds.push({ requestId, fileName });
                            setCookie(misc/* COOKIES.bulkRequestIdArray */.E9.bulkRequestIdArray, JSON.stringify(addedReqIds), misc/* DefaultCookieOptions */.DL);
                            setContext((state) => (Object.assign(Object.assign({}, state), { bulkRequestIds: addedReqIds })));
                        }
                        break;
                    case "REMOVE":
                        const updatedReqIds = prevReqIds.filter((reqIdObj) => reqIdObj.requestId !== requestId);
                        setCookie(misc/* COOKIES.bulkRequestIdArray */.E9.bulkRequestIdArray, JSON.stringify(updatedReqIds), misc/* DefaultCookieOptions */.DL);
                        setContext((state) => (Object.assign(Object.assign({}, state), { bulkRequestIds: updatedReqIds })));
                        break;
                }
            }, openBulkModal: () => {
                setContext((state) => (Object.assign(Object.assign({}, state), { isBulkUploadModalOpen: true })));
            }, closeBulkModal: () => {
                setContext((state) => (Object.assign(Object.assign({}, state), { isBulkUploadModalOpen: false })));
            }, updateHeaderClassName: (className) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { headerClassName: className })));
            }, setCurrentLocation: (loc) => setContext((state) => (Object.assign(Object.assign({}, state), { currentLocation: loc }))), recentTransporterCitySearches: cookies.rtcs, updateRecentTransporterCitySearches: (city) => {
                city &&
                    setContext((state) => {
                        const updatedRecents = (0,getUniqueArray/* getUniqueArray */.c)([
                            Object.assign(Object.assign({}, city), { category: "recent", categoryLabel: "RECENT SEARCHES" }),
                            ...(state.recentTransporterCitySearches || [])
                        ], "id").slice(0, 5);
                        setCookie(misc/* COOKIES.recentTransporterCitySearches */.E9.recentTransporterCitySearches, JSON.stringify(updatedRecents), misc/* DefaultCookieOptions */.DL);
                        return Object.assign(Object.assign({}, state), { recentTransporterCitySearches: updatedRecents });
                    });
            }, setPhoneNum: (phoneNum) => {
                if (phoneNum) {
                    setCookie("phoneNum", phoneNum, misc/* DefaultCookieOptions */.DL);
                    setContext((state) => (Object.assign(Object.assign({}, state), { phoneNum })));
                }
            }, setName: (name) => {
                if (name) {
                    setCookie("name", name, misc/* DefaultCookieOptions */.DL);
                }
                else {
                    removeCookie("name", misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { name })));
            }, setUserId: (userId) => {
                if (userId) {
                    setCookie(misc/* COOKIES.userId */.E9.userId, userId, misc/* DefaultCookieOptions */.DL);
                }
                else {
                    removeCookie(misc/* COOKIES.userId */.E9.userId, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { userId: userId })));
            }, setCompanyId: (companyId) => {
                if (companyId) {
                    setCookie(misc/* COOKIES.companyId */.E9.companyId, companyId, misc/* DefaultCookieOptions */.DL);
                }
                else {
                    removeCookie(misc/* COOKIES.companyId */.E9.companyId, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { companyId })));
            }, setCompanyLocation: (companyLocation) => {
                if (companyLocation) {
                    setCookie(misc/* COOKIES.companyLocation */.E9.companyLocation, companyLocation, misc/* DefaultCookieOptions */.DL);
                }
                else {
                    removeCookie(misc/* COOKIES.companyLocation */.E9.companyLocation, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { companyLocation })));
            }, setCompanyLogo: (logo) => {
                if (logo) {
                    setCookie(misc/* COOKIES.companyLogo */.E9.companyLogo, logo, misc/* DefaultCookieOptions */.DL);
                }
                else {
                    removeCookie(misc/* COOKIES.companyLogo */.E9.companyLogo, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { companyLogo: logo })));
            }, setIsPhoneVerified: (isVerified) => {
                if (isVerified) {
                    setCookie("vv", 1, Object.assign({}, misc/* DefaultCookieOptions */.DL));
                }
                else {
                    removeCookie("vv", misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { isPhoneVerified: isVerified })));
            }, isEmailVerified: !!+cookies.ev, setIsEmailVerified: (isEmailVerified) => {
                if (isEmailVerified) {
                    setCookie(misc/* COOKIES.isEmailVerified */.E9.isEmailVerified, 1, Object.assign({}, misc/* DefaultCookieOptions */.DL
                    // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                    ));
                }
                else {
                    removeCookie(misc/* COOKIES.isEmailVerified */.E9.isEmailVerified, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { isEmailVerified: isEmailVerified })));
            }, isRecoverEmailVerified: !!+cookies.rev, setIsRecoverEmailVerified: (isRecoveryEmailVerified) => {
                if (isRecoveryEmailVerified) {
                    setCookie(misc/* COOKIES.isRecoveryEmailVerified */.E9.isRecoveryEmailVerified, 1, Object.assign({}, misc/* DefaultCookieOptions */.DL
                    // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                    ));
                }
                else {
                    removeCookie(misc/* COOKIES.isRecoveryEmailVerified */.E9.isRecoveryEmailVerified, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { isRecoverEmailVerified: isRecoveryEmailVerified })));
            } }), (src === "csDashboard" &&
            {
                setCsDashboardUserRoles: (csDashboardUserRoles) => {
                    if (csDashboardUserRoles) {
                        setCookie(misc/* COOKIES.csDashboardUserRoles */.E9.csDashboardUserRoles, csDashboardUserRoles, Object.assign({}, misc/* DefaultCookieOptions */.DL
                        // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                        ));
                    }
                    else {
                        removeCookie(misc/* COOKIES.csDashboardUserRoles */.E9.csDashboardUserRoles, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { csDashboardUserRoles: csDashboardUserRoles })));
                },
                setCsDashboardPermission: (csDashboardPermission) => {
                    if (csDashboardPermission) {
                        setCookie(misc/* COOKIES.csDashboardPermission */.E9.csDashboardPermission, csDashboardPermission, misc/* DefaultCookieOptions */.DL);
                    }
                    else {
                        removeCookie(misc/* COOKIES.csDashboardPermission */.E9.csDashboardPermission, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { csDashboardPermission })));
                },
                customerCompanyId: cookies.ccid,
                setCustomerCompanyId: (customerCompanyId) => {
                    if (customerCompanyId) {
                        setCookie(misc/* COOKIES.customerCompanyId */.E9.customerCompanyId, customerCompanyId, Object.assign({}, misc/* DefaultCookieOptions */.DL
                        // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                        ));
                    }
                    else {
                        removeCookie(misc/* COOKIES.customerCompanyId */.E9.customerCompanyId, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { customerCompanyId: customerCompanyId })));
                },
                customerCompanyLocation: cookies.ccloc,
                setCustomerCompanyLocation: (customerCompanyLocation) => {
                    if (customerCompanyLocation) {
                        setCookie(misc/* COOKIES.customerCompanyLocation */.E9.customerCompanyLocation, customerCompanyLocation, Object.assign({}, misc/* DefaultCookieOptions */.DL
                        // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                        ));
                    }
                    else {
                        removeCookie(misc/* COOKIES.customerCompanyLocation */.E9.customerCompanyLocation, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { customerCompanyLocation: customerCompanyLocation })));
                },
                customerPhone: cookies.cpn,
                setCustomerPhone: (customerPhone) => {
                    if (customerPhone) {
                        setCookie(misc/* COOKIES.customerPhone */.E9.customerPhone, customerPhone, Object.assign({}, misc/* DefaultCookieOptions */.DL
                        // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                        ));
                    }
                    else {
                        removeCookie(misc/* COOKIES.customerPhone */.E9.customerPhone, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { customerPhone: customerPhone })));
                },
                customerName: cookies.cname,
                setCustomerName: (customerName) => {
                    if (customerName) {
                        setCookie(misc/* COOKIES.customerName */.E9.customerName, customerName, Object.assign({}, misc/* DefaultCookieOptions */.DL
                        // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                        ));
                    }
                    else {
                        removeCookie(misc/* COOKIES.customerName */.E9.customerName, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { customerName: customerName })));
                },
                customerServiceType: cookies.cst,
                setCustomerServiceType: (customerServiceType) => {
                    if (customerServiceType) {
                        setCookie(misc/* COOKIES.customerServiceType */.E9.customerServiceType, customerServiceType, Object.assign({}, misc/* DefaultCookieOptions */.DL
                        // maxAge: ENV === "production" ? 30 * 60 : 5 * 60
                        ));
                    }
                    else {
                        removeCookie(misc/* COOKIES.customerServiceType */.E9.customerServiceType, misc/* DefaultCookieOptions */.DL);
                    }
                    setContext((state) => (Object.assign(Object.assign({}, state), { customerServiceType: customerServiceType })));
                },
                tsoLorrySpecialization: undefined,
                setTsoLorrySpecialization: (tsoLorrySpecialization) => {
                    setContext((state) => (Object.assign(Object.assign({}, state), { tsoLorrySpecialization })));
                }
            })), { numOfContactRqsts: +cookies.numOfContactRqsts, updateNumOfContactRqsts: () => {
                setContext((state) => {
                    const newNum = (state.numOfContactRqsts || 0) + 1;
                    const d = new Date();
                    setCookie("numOfContactRqsts", newNum, Object.assign(Object.assign({}, misc/* DefaultCookieOptions */.DL), { expires: ENV === "production"
                            ? new Date(new Date(d.setDate(d.getDate() + 1)).setHours(0))
                            : undefined, maxAge: ENV !== "production" ? 60 : undefined }));
                    return Object.assign(Object.assign({}, state), { numOfContactRqsts: newNum });
                });
            }, updateTransporterContactsRqstd: (newItem) => {
                setContext((state) => {
                    const newArr = state.transporterContactsRqstd
                        ? [...state.transporterContactsRqstd, newItem]
                        : [newItem];
                    const d = new Date();
                    setCookie("tcr", JSON.stringify(newArr), Object.assign(Object.assign({}, misc/* DefaultCookieOptions */.DL), { expires: ENV === "production"
                            ? new Date(new Date(d.setDate(d.getDate() + 1)).setHours(0))
                            : undefined, maxAge: ENV !== "production" ? 60 : undefined }));
                    return Object.assign(Object.assign({}, state), { transporterContactsRqstd: newArr });
                });
            }, updateProfilesViewed: (newProfileId) => {
                setContext((state) => {
                    const newArr = state.profilesViewed ? [...state.profilesViewed, newProfileId] : [newProfileId];
                    setCookie("pv", JSON.stringify(newArr), Object.assign({}, misc/* DefaultCookieOptions */.DL));
                    return Object.assign(Object.assign({}, state), { profilesViewed: newArr });
                });
            }, serviceType: cookies.st || undefined, setServiceType: (serviceType) => {
                if (serviceType) {
                    setCookie(misc/* COOKIES.serviceType */.E9.serviceType, serviceType, misc/* DefaultCookieOptions */.DL);
                }
                else {
                    removeCookie(misc/* COOKIES.serviceType */.E9.serviceType, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { serviceType: serviceType })));
            }, setKycPopupInitialLoad: () => {
                setContext((state) => {
                    let temp;
                    if (Number(state.kycPopupInitialLoad) < 2) {
                        temp = Number(state.kycPopupInitialLoad) + 1;
                        setCookie(misc/* COOKIES.kycPopupInitialLoad */.E9.kycPopupInitialLoad, temp, Object.assign(Object.assign({}, misc/* DefaultCookieOptions */.DL), { expires: undefined, maxAge: undefined }));
                    }
                    else if (Number(state.kycPopupInitialLoad) === 2) {
                        setCookie(misc/* COOKIES.kycPopupInitialLoad */.E9.kycPopupInitialLoad, Number(state.kycPopupInitialLoad) + 1, Object.assign(Object.assign({}, misc/* DefaultCookieOptions */.DL), { expires: new Date(Date.now() + 24 * 60 * 60 * 5 * 1000), maxAge: ENV !== "production" ? 60 : undefined }));
                    }
                    return Object.assign(Object.assign({}, state), { kycPopupInitialLoad: temp });
                });
            }, setHistoryLocation: (historyLocation) => {
                setContext((state) => {
                    setCookie(misc/* COOKIES.historyLocation */.E9.historyLocation, historyLocation, Object.assign(Object.assign({}, misc/* DefaultCookieOptions */.DL), { expires: undefined, maxAge: undefined }));
                    return Object.assign(Object.assign({}, state), { historyLocation: historyLocation });
                });
            }, shouldPreventLayoutSwitch: context.shouldPreventLayoutSwitch, setShouldPreventLayoutSwitch: (shouldPreventLayoutSwitch) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { shouldPreventLayoutSwitch: shouldPreventLayoutSwitch })));
            }, fromFlutterApp: cookies.fromFlutterApp || undefined, setUserAppVersion: (version) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { userAppVersion: version })));
            }, setShowAppRedirectionPopup: (val, props) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { showAppRedirectionPopup: val, appRedirectionPopupProps: val ? props : undefined })));
            }, setGlobalData: (data) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { globalData: Object.assign(Object.assign({}, state === null || state === void 0 ? void 0 : state.globalData), data) })));
            }, updateEventCount,
            checkAndHandleGuestUserRestriction, referralCode: cookies.rfc || undefined, setReferralCode: (referralCode) => {
                const result = new Date();
                result.setDate(result.getDate() + 13); // 14 days expiry time
                if (referralCode) {
                    setCookie(misc/* COOKIES.referralCode */.E9.referralCode, referralCode, Object.assign(Object.assign({}, misc/* DefaultCookieOptions */.DL), { expires: result }));
                }
                else {
                    removeCookie(misc/* COOKIES.referralCode */.E9.referralCode, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { referralCode: referralCode })));
            }, updateRoute: (route) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { route })));
            }, activateAppMandatePopup: () => {
                setContext((state) => (Object.assign(Object.assign({}, state), { showAppMandatePopup: true })));
            }, sessionId: +cookies[misc/* COOKIES.sessionId */.E9.sessionId] || 0, setSessionId: (sessionId) => {
                sessionId
                    ? setCookie(misc/* COOKIES.sessionId */.E9.sessionId, sessionId, misc/* DefaultCookieOptions */.DL)
                    : removeCookie(misc/* COOKIES.sessionId */.E9.sessionId, misc/* DefaultCookieOptions */.DL);
                setContext((state) => (Object.assign(Object.assign({}, state), { sessionId })));
            }, serviceRequestType: context.serviceRequestType, setServiceRequestType: (serviceRequestType) => {
                setContext((state) => (Object.assign(Object.assign({}, state), { serviceRequestType })));
            }, setThirdPartyCompanyName: (companyName) => {
                if (companyName) {
                    setCookie(misc/* COOKIES.thirdPartyCompanyName */.E9.thirdPartyCompanyName, companyName, Object.assign({}, misc/* DefaultCookieOptions */.DL));
                }
                else {
                    removeCookie(misc/* COOKIES.thirdPartyCompanyName */.E9.thirdPartyCompanyName, misc/* DefaultCookieOptions */.DL);
                }
                setContext((state) => (Object.assign(Object.assign({}, state), { thirdPartyCompanyName: companyName })));
            }, isLorryNotAllowedPopupOpen: false, toggleIsLorryNotAllowedPopupOpen: () => {
                setContext((state) => (Object.assign(Object.assign({}, state), { isLorryNotAllowedPopupOpen: !state.isLorryNotAllowedPopupOpen })));
            } })));
        // if (window["wvp"]) {
        //     setLoginInfoInWebView();
        // }
        // getKycMethodTypes(KYC_VERIFICATION_METHODS_TYPE_URL);
    }, []);
    return { context, setContext };
}


//# sourceMappingURL=useSetAppContext.js.map


/***/ }),

/***/ 73778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useToggleModalWithLocalState; },
/* harmony export */   "Z": function() { return /* binding */ useToggleModalWithLocalState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useToggleModalWithLocalState(initialState = false) {
    const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const toggleModal = () => {
        setIsModalOpen((prevState) => !prevState);
    };
    return {
        isModalOpen,
        openModal,
        closeModal,
        toggleModal
    };
}


//# sourceMappingURL=useToggleModalWithLocalState.js.map


/***/ }),

/***/ 75206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useTopDest; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77370);



function useTopDest({ max }) {
    const [topDests, _setTopDests] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(_constants_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .PopularDest */ .gH);
    const setTopDests = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((dest) => {
        _setTopDests((state) => {
            if (!state.slice(0, max).find((s) => (s === null || s === void 0 ? void 0 : s.state_id) === (dest === null || dest === void 0 ? void 0 : dest.state_id))) {
                return [dest, ...state];
            }
            else {
                return state;
            }
        });
    }, [topDests]);
    return { topDests, setTopDests };
}


//# sourceMappingURL=useTopDest.js.map


/***/ }),

/***/ 36153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useVahakHttpClient; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);
/* harmony import */ var _methods_generateUrlParamsFromObject_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13521);
/* harmony import */ var _services_hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49352);
/* harmony import */ var _services_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21928);






const useVahakHttpClient = () => {
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQueryClient)();
    const calculateAuthHeader = () => {
        const authHeaderObj = (0,_services_utils_getAuthHeader_js__WEBPACK_IMPORTED_MODULE_3__/* .getAuthHeader */ .E)();
        return (authHeaderObj === null || authHeaderObj === void 0 ? void 0 : authHeaderObj.token.includes("undefined")) ? {} : authHeaderObj;
    };
    function calculatePath(path, queryParamObj) {
        const _path = queryParamObj
            ? `${path}${path.includes("?") ? "" : "?"}${(0,_methods_generateUrlParamsFromObject_js__WEBPACK_IMPORTED_MODULE_4__/* .generateUrlParamsFromObject */ .Z)(queryParamObj)}`
            : path;
        return _path;
    }
    function invokeHttpCall(path, config) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            const request = new Request(path, config);
            let responseJSON;
            try {
                const response = yield fetch(request);
                responseJSON = yield response.json();
                if (response.ok) {
                    if (response.status === 208) {
                        throw responseJSON;
                    }
                    return Promise.resolve(responseJSON);
                }
                else {
                    if (response.status === 401)
                        queryClient.invalidateQueries(_services_hooks_queryNames_js__WEBPACK_IMPORTED_MODULE_2__/* .QueryNames.validateToken */ ._.validateToken);
                    // This will call the error block
                    throw Object.assign({ statusCode: response.status, statusText: response.statusText }, responseJSON);
                }
            }
            catch (err) {
                return Promise.reject(err);
            }
        });
    }
    function GET(path, queryParamObj, customHeaders) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            const config = { headers: Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()) };
            const init = Object.assign({ method: "GET" }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    function POST(path, body, formData, queryParamObj, customHeaders) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            const config = formData
                ? {
                    headers: Object.assign({}, calculateAuthHeader())
                }
                : {
                    headers: Object.assign(Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()), { Accept: "application/json", "Content-Type": "application/json" })
                };
            const init = Object.assign({ method: "POST", body: formData ? formData : JSON.stringify(body) }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    function PUT(path, body, queryParamObj, customHeaders) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            const config = {
                headers: Object.assign(Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()), { Accept: "application/json", "Content-Type": "application/json" })
            };
            const init = Object.assign({ method: "PUT", body: JSON.stringify(body) }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    function DELETE(path, queryParamObj, customHeaders) {
        return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
            const config = { headers: Object.assign(Object.assign({}, customHeaders), calculateAuthHeader()) };
            const init = Object.assign({ method: "DELETE" }, config);
            const _path = calculatePath(path, queryParamObj);
            return invokeHttpCall(_path, init);
        });
    }
    return {
        GET,
        PUT,
        POST,
        DELETE
    };
};


//# sourceMappingURL=useVahakHttpClient.js.map


/***/ }),

/***/ 37528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M8": function() { return /* binding */ useVahakMutationQuery; },
/* harmony export */   "uE": function() { return /* binding */ useVahakQuery; },
/* harmony export */   "xX": function() { return /* binding */ useVahakInfiniteQuery; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82066);


function useVahakQuery(queryKey, queryFn, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queryKey, queryFn, options);
}
function useVahakMutationQuery(mutationKey, mutationFn, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useMutation)(mutationKey, mutationFn, options);
}
function useVahakInfiniteQuery(queryKey, queryFn, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery)(queryKey, queryFn, options);
}


//# sourceMappingURL=useVahakQueryClient.js.map


/***/ }),

/***/ 9839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgCloseCircle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCloseCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm4.853 15.439a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L12 13.414l-3.439 3.439a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L10.586 12 7.147 8.561a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L12 10.586l3.439-3.439a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L13.414 12z",
    fill: "#646464",
    opacity: 0.6
  })));
}


//# sourceMappingURL=CloseCircle.svg.js.map


/***/ }),

/***/ 96281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ cityStringIncludeParentheses; }
/* harmony export */ });
function cityStringIncludeParentheses(city) {
    if (city) {
        const cityString = city.split(" ");
        if (cityString.length > 1 || city.indexOf("(") != -1) {
            return city.slice(0, -4);
        }
        else {
            return city;
        }
    }
    else {
        return "";
    }
}


//# sourceMappingURL=cityStringIncludeParentheses.js.map


/***/ }),

/***/ 83121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ compareString; }
/* harmony export */ });
function compareString(str1, str2) {
    return (str1 === null || str1 === void 0 ? void 0 : str1.toLowerCase()) === (str2 === null || str2 === void 0 ? void 0 : str2.toLocaleLowerCase());
}


//# sourceMappingURL=compareString.js.map


/***/ }),

/***/ 54534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63118);


function copyToClipboard(content, toastMsg) {
    navigator.clipboard &&
        navigator.clipboard
            .writeText(content)
            .then(() => {
            _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_0__/* .toast.success */ .A.success(toastMsg || "Link Copied");
        })
            .catch((e) => console.log(e));
}


//# sourceMappingURL=copyToClipboard.js.map


/***/ }),

/***/ 57302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ encryptData; }
/* harmony export */ });
/* unused harmony export decryptData */
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_0__);


const encryptData = (data, { key, iv }) => {
    const msg = JSON.stringify(data);
    const parsedIv = crypto_js__WEBPACK_IMPORTED_MODULE_0___default().enc.Utf8.parse(iv);
    const parsedKey = crypto_js__WEBPACK_IMPORTED_MODULE_0___default().enc.Utf8.parse(key);
    const encryptedData = crypto_js__WEBPACK_IMPORTED_MODULE_0___default().AES.encrypt(msg, parsedKey, {
        iv: parsedIv,
        mode: (crypto_js__WEBPACK_IMPORTED_MODULE_0___default().mode.CBC),
        padding: (crypto_js__WEBPACK_IMPORTED_MODULE_0___default().pad.Pkcs7)
    });
    return encryptedData.toString();
};
const decryptData = (encryptedBase64, { key, iv }) => {
    const parsedIv = CryptoJS.enc.Utf8.parse(iv);
    const parsedKey = CryptoJS.enc.Utf8.parse(key);
    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, parsedKey, {
        iv: parsedIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    try {
        return JSON.parse(decryptedText);
    }
    catch (_a) {
        return decryptedText; // In case it's not JSON (e.g., just a string)
    }
};


//# sourceMappingURL=encryptData.js.map


/***/ }),

/***/ 11663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; },
/* harmony export */   "y": function() { return /* binding */ formatType; }
/* harmony export */ });
var formatType;
(function (formatType) {
    formatType[formatType["ddmmyyyy"] = 0] = "ddmmyyyy";
})(formatType || (formatType = {}));
function formatDate(date, format, delimeter = "/") {
    if (format === formatType.ddmmyyyy) {
        const result = date.toLocaleDateString("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
        return result.replaceAll("/", delimeter);
    }
    return date.toDateString();
}


//# sourceMappingURL=formatDate.js.map


/***/ }),

/***/ 50788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ formatLorryNum; }
/* harmony export */ });
const formatLorryNum = (lorryNumber) => {
    if (!lorryNumber) {
        return "";
    }
    const lorryNum = lorryNumber.replaceAll(" ", "").toUpperCase();
    let formattedLorryNumArray = [];
    let currentSegment = lorryNum[0];
    let isPrevCharNumber = false;
    let isCurrentCharNumber = !isNaN(parseInt(lorryNum[0]));
    for (let i = 1; i < lorryNum.length; i++) {
        isCurrentCharNumber = !isNaN(parseInt(lorryNum[i]));
        if (isCurrentCharNumber === isPrevCharNumber) {
            currentSegment += lorryNum[i];
        }
        else {
            formattedLorryNumArray.push(currentSegment);
            currentSegment = "" + lorryNum[i];
        }
        isPrevCharNumber = isCurrentCharNumber;
    }
    formattedLorryNumArray.push(currentSegment);
    const formattedLorryNumber = formattedLorryNumArray.join(" ");
    return formattedLorryNumber;
};


//# sourceMappingURL=formatLorryNum.js.map


/***/ }),

/***/ 99073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ generateQueryString; }
/* harmony export */ });
function generateQueryString(params) {
    const queryParams = new URLSearchParams();
    for (const key in params) {
        if (params.hasOwnProperty(key) && params[key] != null) {
            const value = params[key];
            if (Array.isArray(value)) {
                value.forEach((val) => {
                    queryParams.append(key, String(val));
                });
            }
            else {
                queryParams.append(key, value);
            }
        }
    }
    return queryParams.toString();
}


//# sourceMappingURL=generateQueryString.js.map


/***/ }),

/***/ 73435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ generateUrlParamsFromArray; }
/* harmony export */ });
function generateUrlParamsFromArray(arr, key, skipValue) {
    let paramsString = "";
    arr === null || arr === void 0 ? void 0 : arr.forEach((value, index) => {
        if (!(skipValue === null || skipValue === void 0 ? void 0 : skipValue.includes(value)))
            paramsString += `${index ? "&" : ""}${key}=${value}`;
    });
    return paramsString;
}


//# sourceMappingURL=generateUrlParamsFromArray.js.map


/***/ }),

/***/ 13521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ generateUrlParamsFromObject; }
/* harmony export */ });
function generateUrlParamsFromObject(obj) {
    let paramsString = "";
    const entries = Object.entries(obj);
    entries.forEach(([key, value], index) => {
        if (value) {
            index === 0 ? (paramsString += `${key}=${value}`) : (paramsString += `&${key}=${value}`);
        }
    });
    return paramsString;
}


//# sourceMappingURL=generateUrlParamsFromObject.js.map


/***/ }),

/***/ 95494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getArrayWithType; }
/* harmony export */ });
const getArrayWithType = (data, arrType) => {
    if (Array.isArray(data)) {
        return data.map((_) => arrType(_));
    }
    else if (data === 0 || !!data) {
        return [arrType(data)];
    }
    else {
        return undefined;
    }
};


//# sourceMappingURL=getArrayWithType.js.map


/***/ }),

/***/ 4913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getAuthIdParam; }
/* harmony export */ });
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36908);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);



const cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
function getAuthIdParam(companyId) {
    return companyId ? `a_i=${companyId}` : `a_i=${cookies.get(_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.companyId */ .E9.companyId)}`;
}


//# sourceMappingURL=getAuthIdParam.js.map


/***/ }),

/***/ 46047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getCurrentLocation; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);
/* harmony import */ var _services_city_search_service_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20803);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77370);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63118);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36908);






function getSavedLoc() {
    const cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
    const savedLocString = cookies.get(_constants_misc_js__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.currentLoc */ .E9.currentLoc);
    if (!savedLocString) {
        return;
    }
    const { time } = savedLocString, savedLoc = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._)(savedLocString, ["time"]);
    if (time + 1.5 * 60 * 60 * 1000 < Date.now()) {
        return;
    }
    return savedLoc;
}
function getCurrentLocation(showToastOnFailure = true, option) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        const cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
        try {
            const savedLoc = getSavedLoc();
            if (savedLoc) {
                return {
                    city: savedLoc.city,
                    name: savedLoc.description,
                    description: savedLoc.description,
                    state: savedLoc.state,
                    place_id: savedLoc.place_id
                };
            }
            const locDataRes = yield fetch(`https://api.ipdata.co?api-key=${_constants_misc_js__WEBPACK_IMPORTED_MODULE_2__/* .IP_DATA_KEY */ .Q3}`);
            if (locDataRes.status === 200) {
                const locData = yield locDataRes.json();
                const currLocArray = yield (0,_services_city_search_service_js__WEBPACK_IMPORTED_MODULE_1__/* .searchUsingPlacesAPI */ .PP)(locData.city, Object.assign(Object.assign({}, option), { suppressErrorToast: true }));
                if (currLocArray.length !== 0) {
                    cookies.set(_constants_misc_js__WEBPACK_IMPORTED_MODULE_2__/* .COOKIES.currentLoc */ .E9.currentLoc, JSON.stringify(Object.assign(Object.assign({}, currLocArray[0]), { time: Date.now() })), Object.assign(Object.assign({}, _constants_misc_js__WEBPACK_IMPORTED_MODULE_2__/* .DefaultCookieOptions */ .DL), { maxAge: 24 * 60 * 60 }));
                    return Object.assign(Object.assign({}, currLocArray[0]), { name: currLocArray[0].description });
                }
            }
            else {
                const error = {
                    code: 403,
                    message: "An error occurred. Please try searching for your location."
                };
                throw error;
                // throw "An error occurred. Please try searching for your location.";
            }
        }
        catch (e) {
            showToastOnFailure && _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .A.error(e.message);
            return { status: "failed" };
        }
    });
}


//# sourceMappingURL=getCurrentLocation.js.map


/***/ }),

/***/ 43221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getCurrentState; }
/* harmony export */ });
function getCurrentState(setState) {
    return new Promise((res) => {
        setState((state) => {
            res(state);
            return state;
        });
    });
}


//# sourceMappingURL=getCurrentState.js.map


/***/ }),

/***/ 38026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getDeviceInfo; }
/* harmony export */ });
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_0__);


const { parse } = bowser__WEBPACK_IMPORTED_MODULE_0__;
function getDeviceInfo() {
    return parse(window.navigator.userAgent);
}


//# sourceMappingURL=getDeviceInfo.js.map


/***/ }),

/***/ 19314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getDownloadsFigureTypes; },
/* harmony export */   "u": function() { return /* binding */ getDownloadsFigure; }
/* harmony export */ });
/* harmony import */ var _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28230);


var getDownloadsFigureTypes;
(function (getDownloadsFigureTypes) {
    getDownloadsFigureTypes[getDownloadsFigureTypes["NUMERIC"] = 0] = "NUMERIC";
    getDownloadsFigureTypes[getDownloadsFigureTypes["THOUSANDS"] = 1] = "THOUSANDS";
    getDownloadsFigureTypes[getDownloadsFigureTypes["MILLIONS"] = 2] = "MILLIONS";
    getDownloadsFigureTypes[getDownloadsFigureTypes["LAKHS"] = 3] = "LAKHS";
    getDownloadsFigureTypes[getDownloadsFigureTypes["LAKH_NUMBER"] = 4] = "LAKH_NUMBER";
})(getDownloadsFigureTypes || (getDownloadsFigureTypes = {}));
const getDownloadsFigure = (type = getDownloadsFigureTypes.LAKHS) => {
    switch (type) {
        case getDownloadsFigureTypes.THOUSANDS:
            return "1000 Thousand+";
        case getDownloadsFigureTypes.MILLIONS:
            return _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.appDownloads.millions */ .s.appDownloads.millions;
        case getDownloadsFigureTypes.NUMERIC:
            return _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.numeric */ .s.transporters.numeric;
        case getDownloadsFigureTypes.LAKH_NUMBER:
            return `${_constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.lakhNumber */ .s.transporters.lakhNumber}`;
        default:
            return _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.appDownloads.lakhsLong */ .s.appDownloads.lakhsLong;
    }
};


//# sourceMappingURL=getDownloadsFigure.js.map


/***/ }),

/***/ 8660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getInitialContextValues; }
/* harmony export */ });
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47004);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77370);



const getInitialContextValues = () => {
    var _a, _b, _c;
    const [cookies] = (0,react_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)([]);
    const initialContext = {
        phoneNum: cookies.phoneNum,
        name: cookies.name,
        userId: cookies.ui,
        companyId: cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.companyId */ .E9.companyId],
        companyLocation: cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.companyLocation */ .E9.companyLocation],
        customerCompanyId: cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.customerCompanyId */ .E9.customerCompanyId],
        companyLogo: cookies.cLogo,
        isPhoneVerified: !!+cookies.vv,
        numOfContactRqsts: +cookies.numOfContactRqsts,
        transporterContactsRqstd: cookies.tcr || [],
        kycPopupInitialLoad: cookies.kip || 0,
        historyLocation: cookies.hl,
        isMobile: true,
        currentLocation: { status: "notRequested" },
        profilesViewed: [],
        bulkRequestIds: cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.bulkRequestIdArray */ .E9.bulkRequestIdArray] || [],
        isBulkUploadModalOpen: false,
        eventCounts: {
            citySearchCount: (_a = cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.citySearchCount */ .E9.citySearchCount]) !== null && _a !== void 0 ? _a : 0,
            transporterSearchCount: (_b = cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.transporterSearchCount */ .E9.transporterSearchCount]) !== null && _b !== void 0 ? _b : 0
        },
        showAppMandatePopup: false,
        thirdPartyCompanyName: (_c = cookies[_constants_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .COOKIES.thirdPartyCompanyName */ .E9.thirdPartyCompanyName]) !== null && _c !== void 0 ? _c : "",
        isProductionEnv: false,
        isMobileScreen: false,
        isLorryNotAllowedPopupOpen: false,
        toggleIsLorryNotAllowedPopupOpen: () => { },
        joinedOn: ""
    };
    return initialContext;
};


//# sourceMappingURL=getInitialContextValues.js.map


/***/ }),

/***/ 96762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LE": function() { return /* binding */ getPageLoadSourceUTMParam; },
/* harmony export */   "vh": function() { return /* binding */ transporterUtmParam; }
/* harmony export */ });
/* unused harmony exports marketplaceUtmParam, marketplaceUtmParamTypes, transporterUtmParamTypes */
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52489);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77370);



var transporterUtmParamTypes;
(function (transporterUtmParamTypes) {
    transporterUtmParamTypes["WHAT_CAN_WE_DO"] = "what-can-we-do";
    transporterUtmParamTypes["OTHER_PROFILE"] = "other-profile";
})(transporterUtmParamTypes || (transporterUtmParamTypes = {}));
const transporterUtmParam = {
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.HOMEPAGE */ .c.HOMEPAGE]: 0,
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.GROW_NETWORK */ .c.GROW_NETWORK]: 1,
    [transporterUtmParamTypes.WHAT_CAN_WE_DO]: 2,
    [transporterUtmParamTypes.OTHER_PROFILE]: 3
};
var marketplaceUtmParamTypes;
(function (marketplaceUtmParamTypes) {
    marketplaceUtmParamTypes["WHAT_CAN_WE_DO_LOAD"] = "what-can-we-do-load";
    marketplaceUtmParamTypes["WHAT_CAN_WE_DO_LORRY"] = "what-can-we-do-lorry";
})(marketplaceUtmParamTypes || (marketplaceUtmParamTypes = {}));
const marketplaceUtmParam = {
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.HOMEPAGE */ .c.HOMEPAGE]: 0,
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.LOGISTICS_SERVICE */ .c.LOGISTICS_SERVICE]: 1,
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.ONLINE_LOAD_BOOKING */ .c.ONLINE_LOAD_BOOKING]: 2,
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.ONLINE_TRUCK_BOOKING */ .c.ONLINE_TRUCK_BOOKING]: 3,
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.FULL_TRUCK_LOAD */ .c.FULL_TRUCK_LOAD]: 4,
    [_constants_Pages_js__WEBPACK_IMPORTED_MODULE_0__/* .PageTypes.PART_LOAD_BOOKING */ .c.PART_LOAD_BOOKING]: 5,
    [marketplaceUtmParamTypes.WHAT_CAN_WE_DO_LOAD]: 6,
    [marketplaceUtmParamTypes.WHAT_CAN_WE_DO_LORRY]: 7
};
const getPageLoadSourceUTMParam = ({ urlQueryParams, utmParamObj }) => {
    for (const param in urlQueryParams) {
        if (param === _constants_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .SOURCE_UTM */ .vq) {
            const paramValue = utmParamObj[urlQueryParams[param]];
            if (paramValue !== undefined) {
                return { value: paramValue };
            }
            return undefined;
        }
    }
};


//# sourceMappingURL=getPageLoadSourceUTMParam.js.map


/***/ }),

/***/ 89842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getRemValue; }
/* harmony export */ });
function getRemValue(valueInPx) {
    return `${valueInPx / 16}rem`;
}


//# sourceMappingURL=getRemValue.js.map


/***/ }),

/***/ 98175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getHeightByViewPort; }
/* harmony export */ });
/* unused harmony export getWidthByViewPort */
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52489);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63118);
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68381);
/* harmony import */ var _getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4913);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2784);
/* harmony import */ var _formatDate_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11663);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52224);
/* harmony import */ var _getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98819);
/* harmony import */ var _getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(96762);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(76705);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(43298);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(91680);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(22391);
/* harmony import */ var _services_const_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(41634);





































function getHeightByViewPort(valueInPx) {
    return `${(valueInPx / _constants_misc_js__WEBPACK_IMPORTED_MODULE_3__/* .REF_VIEWPORT_HEIGHT */ .t) * (Math.max(window.screen.availHeight, 640) - 110)}px`;
}
function getWidthByViewPort(valueInPx) {
    return `${(valueInPx / REF_VIEWPORT_WIDTH) * window.screen.availWidth}px`;
}


//# sourceMappingURL=getSizeByViewPort.js.map


/***/ }),

/***/ 55622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getTimeDiffMs; }
/* harmony export */ });
function getTimeDiffMs(t1, t2) {
    return Date.parse(t2) - Date.parse(t1);
}


//# sourceMappingURL=getTimeDiffMs.js.map


/***/ }),

/***/ 98819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getTransporterFigure; },
/* harmony export */   "Y": function() { return /* binding */ getTransporterFigureTypes; }
/* harmony export */ });
/* harmony import */ var _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28230);


var getTransporterFigureTypes;
(function (getTransporterFigureTypes) {
    getTransporterFigureTypes[getTransporterFigureTypes["NUMERIC"] = 0] = "NUMERIC";
    getTransporterFigureTypes[getTransporterFigureTypes["THOUSANDS"] = 1] = "THOUSANDS";
    getTransporterFigureTypes[getTransporterFigureTypes["MILLIONS"] = 2] = "MILLIONS";
    getTransporterFigureTypes[getTransporterFigureTypes["LAKHS"] = 3] = "LAKHS";
    getTransporterFigureTypes[getTransporterFigureTypes["LAKH_NUMBER"] = 4] = "LAKH_NUMBER";
})(getTransporterFigureTypes || (getTransporterFigureTypes = {}));
const getTransporterFigure = (type = getTransporterFigureTypes.LAKHS) => {
    switch (type) {
        case getTransporterFigureTypes.THOUSANDS:
            return "1000 Thousand+";
        case getTransporterFigureTypes.MILLIONS:
            return "1 Million+";
        case getTransporterFigureTypes.NUMERIC:
            return _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.numeric */ .s.transporters.numeric;
        case getTransporterFigureTypes.LAKH_NUMBER:
            return `${_constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.lakhNumber */ .s.transporters.lakhNumber}`;
        default:
            return _constants_platformStats_js__WEBPACK_IMPORTED_MODULE_0__/* .PLATFORM_STATS.transporters.lakhsLong */ .s.transporters.lakhsLong;
    }
};


//# sourceMappingURL=getTransporterFigure.js.map


/***/ }),

/***/ 88020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getUniqueArray; }
/* harmony export */ });
function getUniqueArray(arr, key) {
    if (typeof arr === "object" && key) {
        const newArr = [];
        arr.forEach((item) => {
            if (!newArr.find((a) => a[key] === item[key])) {
                newArr.push(item);
            }
        });
        return newArr;
    }
    else {
        return [...new Set(arr)];
    }
}


//# sourceMappingURL=getUniqueArray.js.map


/***/ }),

/***/ 89170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ groupBy; }
/* harmony export */ });
function groupBy(arr, groupByKey) {
    const output = [];
    arr.forEach((item) => {
        const index = output.findIndex((a) => a.key === item[groupByKey]);
        if (index !== -1) {
            // @ts-ignore
            output[index]["items"].push(item);
        }
        else {
            output.push({ key: item[groupByKey], items: [item] });
        }
    });
    return output;
}


//# sourceMappingURL=groupBy.js.map


/***/ }),

/***/ 34025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ handleLogout; }
/* harmony export */ });
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68381);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87013);



// import { AuthService } from "../../_services/auth.service";
function handleLogout({ setCompanyId, setIsPhoneVerified, setName, setLang, setCompanyLogo, setUserId, setCsDashboardUserRoles, setCustomerCompanyId, setCustomerPhone, setCustomerName, phoneNum, setShowBankAddPopup, setMandateUserVerificationActionType, setMandateUserVerificationActionTriggered, setMandateUserVerificationCallBackFunction, setSessionId, setThirdPartyCompanyName }) {
    setUserId === null || setUserId === void 0 ? void 0 : setUserId(undefined);
    setCompanyLogo === null || setCompanyLogo === void 0 ? void 0 : setCompanyLogo(undefined);
    setCompanyId === null || setCompanyId === void 0 ? void 0 : setCompanyId(undefined);
    setIsPhoneVerified === null || setIsPhoneVerified === void 0 ? void 0 : setIsPhoneVerified(false);
    setName === null || setName === void 0 ? void 0 : setName(undefined);
    setLang === null || setLang === void 0 ? void 0 : setLang(_constants_languages_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LANG */ .Hj);
    setCsDashboardUserRoles === null || setCsDashboardUserRoles === void 0 ? void 0 : setCsDashboardUserRoles(undefined);
    setCustomerCompanyId === null || setCustomerCompanyId === void 0 ? void 0 : setCustomerCompanyId(undefined);
    setCustomerPhone === null || setCustomerPhone === void 0 ? void 0 : setCustomerPhone(undefined);
    setCustomerName === null || setCustomerName === void 0 ? void 0 : setCustomerName(undefined);
    setShowBankAddPopup === null || setShowBankAddPopup === void 0 ? void 0 : setShowBankAddPopup(false);
    setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
    setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
    setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
    _services_auth_service_js__WEBPACK_IMPORTED_MODULE_0__/* .AuthService.logout */ .e8.logout(Number(phoneNum));
    setSessionId === null || setSessionId === void 0 ? void 0 : setSessionId();
    setThirdPartyCompanyName === null || setThirdPartyCompanyName === void 0 ? void 0 : setThirdPartyCompanyName("");
    //
    sessionStorage.removeItem("mandatePostingTrucker");
}


//# sourceMappingURL=handleLogout.js.map


/***/ }),

/***/ 46492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T9": function() { return /* reexport */ generateQueryString/* generateQueryString */.T; },
  "LP": function() { return /* reexport */ generateUrlParamsFromArray/* generateUrlParamsFromArray */.L; },
  "Ah": function() { return /* reexport */ getArrayWithType/* getArrayWithType */.A; },
  "Wu": function() { return /* reexport */ remove_empty_or_null_object_value/* removeEmptyOrNullObjectValue */.W; },
  "A7": function() { return /* reexport */ scrollToElement/* scrollToElement */.k; },
  "_v": function() { return /* reexport */ sleep/* sleep */._; }
});

// UNUSED EXPORTS: GetMarketDataFromBidData, SHARE_APIS, addToCache, arrayAddIf, blockedKYCVerification, capitalize, cityStringIncludeParentheses, compareString, copyToClipboard, decryptData, encryptData, filterLiveEntities, formatDate, formatLorryNum, formatNumber, formatNumberText, formatType, generateLoadBidProps, generateLorryBidProps, generateUrlParamsFromObject, getAuthIdParam, getCurrentState, getDeviceInfo, getDeviceType, getDownloadsFigure, getDownloadsFigureTypes, getEmptyArray, getFormattedTime, getHeightByViewPort, getInitialContextValues, getMinMaxQty, getMinMaxQtyObj, getOtpValue, getPageLoadSourceUTMParam, getPageType, getParamsByName, getQueryParamsBySearchString, getRemValue, getSchemaOrgJson, getServiceTypeObject, getStateListByIds, getStringWordByIndex, getTimeDiffMs, getTimeDiffString, getTomorrowDate, getTransformedValueIfExist, getTransporterFigure, getTransporterFigureTypes, getUniqueArray, getWidthByViewPort, groupBy, handleLogout, hideScrollTopBtn, isCacheValid, isLoadAvailable, isLorryAvailable, isValidCompanyName, marketplaceUtmParam, marketplaceUtmParamTypes, roleCheck, storeEquivalentValuesInASingleVariable, timer, transporterUtmParam, transporterUtmParamTypes, updateNestedObject, updateObjIf, validateVerificationAttempts, webShare

// EXTERNAL MODULE: ../core/dist/methods/getSizeByViewPort.js
var getSizeByViewPort = __webpack_require__(98175);
// EXTERNAL MODULE: ../core/dist/methods/getDeviceInfo.js
var getDeviceInfo = __webpack_require__(38026);
// EXTERNAL MODULE: ../core/dist/methods/sleep.js
var sleep = __webpack_require__(37007);
// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../core/dist/constants/authorizedUsers.js
var authorizedUsers = __webpack_require__(2390);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ../core/dist/constants/bulkLoadCardStatus.js
var bulkLoadCardStatus = __webpack_require__(47762);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/loadStatus.js
var loadStatus = __webpack_require__(61834);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/Pages.js
var Pages = __webpack_require__(52489);
// EXTERNAL MODULE: ../../node_modules/bowser/es5.js
var es5 = __webpack_require__(77160);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast_toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/auth.service.js + 2 modules
var auth_service = __webpack_require__(68381);
// EXTERNAL MODULE: ../core/dist/methods/getAuthIdParam.js
var getAuthIdParam = __webpack_require__(4913);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/methods/formatDate.js
var formatDate = __webpack_require__(11663);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/methods/getTransporterFigure.js
var getTransporterFigure = __webpack_require__(98819);
// EXTERNAL MODULE: ../core/dist/methods/getDownloadsFigure.js
var getDownloadsFigure = __webpack_require__(19314);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
// EXTERNAL MODULE: ../core/dist/methods/getPageLoadSourceUTMParam.js
var getPageLoadSourceUTMParam = __webpack_require__(96762);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
// EXTERNAL MODULE: ../core/dist/constants/serviceTypeId.js
var serviceTypeId = __webpack_require__(76705);
// EXTERNAL MODULE: ../core/dist/constants/bidUpdateType.js
var bidUpdateType = __webpack_require__(43298);
// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/link.js
var constants_link = __webpack_require__(39422);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/payment.js
var payment = __webpack_require__(91680);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
;// CONCATENATED MODULE: ../core/dist/methods/addToCache.js





































function addToCache(request, res) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const cache = yield ((_a = window.caches) === null || _a === void 0 ? void 0 : _a.open(CACHE_NAME));
            const clonedRes = res === null || res === void 0 ? void 0 : res.clone();
            const headers = new Headers(clonedRes === null || clonedRes === void 0 ? void 0 : clonedRes.headers);
            headers.append("sw-fetched-on", new Date().getTime().toString());
            const body = yield clonedRes.blob();
            yield (cache === null || cache === void 0 ? void 0 : cache.put(request, new Response(body, { status: clonedRes.status, statusText: clonedRes.statusText, headers })));
        }
        catch (_b) {
            // Safari private mode / invalid cache keys — skip caching, keep API working.
        }
    });
}


//# sourceMappingURL=addToCache.js.map

// EXTERNAL MODULE: ../core/dist/constants/companyDetails.js
var companyDetails = __webpack_require__(51061);
// EXTERNAL MODULE: ../core/dist/constants/socialMediaLinks.js
var socialMediaLinks = __webpack_require__(92683);
;// CONCATENATED MODULE: ../core/dist/methods/getSchemaOrgJson.js




// Constants
function getSchemaOrgJson({ name = "Vahak | Best Road Transportation Marketplace", path = "", description = "India's no 1 online transport app ! Best mobile app to find truck loads online. Book trucks, containers through our online truck portal", type = "Organization", headline = "", image = `${IMG_BASE_URL}/vahak-timeline_gvlxfa.png`, breadcrumbList = "[]" }) {
    if (breadcrumbList == "[]") {
        return `[
            {
                "@context": "https://schema.org",
                "@type": "${type}",
                "name": "${name}",
                "url": "${COMPANY_DETAILS.website}${path}",
                "description": "${description}",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "${COMPANY_DETAILS.workspace}, ${COMPANY_DETAILS.address}",
                    "addressLocality": "${COMPANY_DETAILS.addressLocality}",
                    "addressRegion": "${COMPANY_DETAILS.addressRegion}",
                    "postalCode": "${COMPANY_DETAILS.postalCode}",
                    "addressCountry": "${COMPANY_DETAILS.addressCountry}"
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "${COMPANY_DETAILS.telephone}",
                    "contactType": "Customer Support"
                },
                "sameAs": [
                    "${FACEBOOK}",
                    "${LINKEDIN}",
                    "${YOUTUBE}",
                    "${INSTAGRAM}",
                    "${TWITTER}"
                ],
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "${COMPANY_DETAILS.potentialActionTargetUrl}/{search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                }
            }
        ]`;
    }
    else {
        return `[
                    {
                        "@context": "https://schema.org",
                        "@type": "${type}",
                        "name": "${name}",
                        "url": "${COMPANY_DETAILS.website}${path}",
                        "description": "${description}",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "${COMPANY_DETAILS.workspace}, ${COMPANY_DETAILS.address}",
                            "addressLocality": "${COMPANY_DETAILS.addressLocality}",
                            "addressRegion": "${COMPANY_DETAILS.addressRegion}",
                            "postalCode": "${COMPANY_DETAILS.postalCode}",
                            "addressCountry": "${COMPANY_DETAILS.addressCountry}"
                        },
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "${COMPANY_DETAILS.telephone}",
                            "contactType": "Customer Support"
                        },
                        "sameAs": [
                            "${FACEBOOK}",
                            "${LINKEDIN}",
                            "${YOUTUBE}",
                            "${INSTAGRAM}",
                            "${TWITTER}"
                        ],
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": {
                            "@type": "EntryPoint",
                            "urlTemplate": "${COMPANY_DETAILS.potentialActionTargetUrl}/{search_term_string}"
                            },
                            "query-input": "required name=search_term_string"
                        }
                    },
                    {
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": ${breadcrumbList}
                    }
                ]`;
    }
}


//# sourceMappingURL=getSchemaOrgJson.js.map

// EXTERNAL MODULE: ../core/dist/methods/copyToClipboard.js
var copyToClipboard = __webpack_require__(54534);
// EXTERNAL MODULE: ../core/dist/methods/web-share.js
var web_share = __webpack_require__(75606);
// EXTERNAL MODULE: ../core/dist/methods/handleLogout.js
var handleLogout = __webpack_require__(34025);
;// CONCATENATED MODULE: ../core/dist/methods/getMarketDataFromBidData.js


function load(inputData) {
    var _a;
    return {
        company_id: inputData.company_id,
        source_text: inputData.source,
        destination_text: inputData.destination,
        expected_amount: inputData.expected_amount,
        expected_type: inputData.expected_type,
        expires_at: inputData.expiration_time,
        id: inputData.entity_id,
        lorry_type_id: (_a = (0,lorryTypes/* getLorryDetailsByName */.mC)(inputData.available_for.split(" ")[2])) === null || _a === void 0 ? void 0 : _a.id,
        lorry_type_text: inputData.available_for.split(" ")[2],
        material_type: inputData.material_type,
        payment_type: inputData.entity_payment_type,
        quantity: Number(inputData.available_for.split(" ")[0]) || undefined
    };
}
function lorry(inputData) {
    var _a;
    return {
        capacity: Number(inputData.available_for.split(" ")[0]) || undefined,
        capacity_unit: inputData.available_for.split(" ")[1],
        company_id: inputData.company_id,
        expires_at: inputData.expiration_time,
        name: inputData.available_for.split(" ")[2],
        number: inputData.lorry_number,
        type: (_a = (0,lorryTypes/* getLorryDetailsByName */.mC)(inputData.available_for.split(" ")[2])) === null || _a === void 0 ? void 0 : _a.id,
        lorry_id: inputData.entity_id
    };
}
const GetMarketDataFromBidData = { load, lorry };


//# sourceMappingURL=getMarketDataFromBidData.js.map

;// CONCATENATED MODULE: ../core/dist/methods/getOtpValue.js


function getOtpValue() {
    return __awaiter(this, void 0, void 0, function* () {
        if ("OTPCredential" in window) {
            const ac = new AbortController();
            navigator.credentials
                .get({
                otp: { transport: ["sms"] },
                signal: ac.signal
            })
                .then((otp) => {
                console.log(otp, "=========>");
                return otp;
            })
                .catch((err) => {
                return err;
            });
        }
    });
}


//# sourceMappingURL=getOtpValue.js.map

// EXTERNAL MODULE: ../core/dist/constants/ServiceType.js + 4 modules
var ServiceType = __webpack_require__(79109);
;// CONCATENATED MODULE: ../core/dist/methods/getServiceTypeObject.js


function getServiceTypeObject(val) {
    return SERVICE_TYPE_OPTIONS.filter((option) => {
        return option.value === val;
    })[0];
}


//# sourceMappingURL=getServiceTypeObject.js.map

;// CONCATENATED MODULE: ../core/dist/methods/validateVerificationAttempts.js




// import { toast } from "../../components/utils/toast/toast";
// This attempt block is common for both GST and Aadhar verification
const blockedKYCVerification = (key) => {
    const cookies = new Cookies();
    // let blockVerification =
    //     key === LOC_STORAGE.aadharVerificationAttempts
    //         ? LOC_STORAGE.blockAadharVerification
    //         : LOC_STORAGE.blockGstVerification;
    let blockVerification = key === COOKIES.aadharVerificationAttempts ? COOKIES.blockAadharVerification : COOKIES.blockGstVerification;
    const blockedTime = 10800000; // 3 hours in ms
    //let attemptedLog = Number(localStorage.getItem(blockVerification));
    let attemptedLog = Number(cookies.get(blockVerification));
    if (Date.now() - attemptedLog > blockedTime) {
        //localStorage.removeItem(blockVerification);
        cookies.remove(blockVerification, DefaultCookieOptions);
        return false;
    }
    toast.error("You have reached maximum attempts, try after some time!");
    // localStorage.removeItem(key);
    cookies.remove(key, DefaultCookieOptions);
    return true;
};
const validateVerificationAttempts = (key) => {
    const cookies = new Cookies();
    // let blockVerification =
    //     key === LOC_STORAGE.aadharVerificationAttempts ? LOC_STORAGE.blockAadharVerification : LOC_STORAGE.blockGstVerification;
    let blockVerification = key === COOKIES.aadharVerificationAttempts ? COOKIES.blockAadharVerification : COOKIES.blockGstVerification;
    // let attempts = Number(localStorage.getItem(key));
    let attempts = Number(cookies.get(key));
    if (attempts === 3) {
        toast.error("You have reached maximum attempts, try after some time!");
        return;
    }
    if (attempts === null) {
        attempts = 0;
    }
    else {
        attempts++;
        // attempts === 3 && localStorage.setItem(blockVerification, String(Date.now()));
        attempts === 3 && cookies.set(blockVerification, String(Date.now()), DefaultCookieOptions);
    }
    toast.error(`You have ${3 - attempts} attempts remaining!`);
    // localStorage.setItem(key, String(attempts));
    cookies.set(key, String(attempts), DefaultCookieOptions);
};


//# sourceMappingURL=validateVerificationAttempts.js.map

;// CONCATENATED MODULE: ../core/dist/methods/shareApis.js
const SHARE_APIS = {
    whatsappDesktop: (shareText, url) => `https://web.whatsapp.com/send?text=${shareText}`,
    whatsappPhone: (shareText, url) => `whatsapp://send?text=${shareText}%0A${url}`,
    fb: (shareText, url) => `https://www.facebook.com/share.php?u=${url}&quote=${shareText}`,
    twitter: (shareText, url) => `https://www.twitter.com/share?text=${shareText}%0A&url=${url}`,
    email: (shareText, url, title) => `mailto:?subject=${title}&body=${shareText}%0A${url}`,
    linkedIn: (shareText, url) => `https://www.linkedin.com/shareArticle?mini=true?summary=${shareText}&url=${url}`
};


//# sourceMappingURL=shareApis.js.map

;// CONCATENATED MODULE: ../core/dist/methods/getStateListByIds.js


const getStateListByIds = (routeIds) => {
    return routeIds === null || routeIds === void 0 ? void 0 : routeIds.map((routeId) => {
        return STATE_LIST.find((stateId) => stateId.id === routeId.id);
    });
};


//# sourceMappingURL=getStateListByIds.js.map

// EXTERNAL MODULE: ../core/dist/methods/storeEquivalentValuesInASingleVariable.js
var storeEquivalentValuesInASingleVariable = __webpack_require__(63002);
;// CONCATENATED MODULE: ../core/dist/methods/getPageType.js





































const getPageType = (path) => {
    if (path === "/")
        return PageTypes.HOMEPAGE;
    else if (path.includes(PageTypes.MARKETPLACE))
        return PageTypes.MARKETPLACE;
    else if (path.includes(PageTypes.TRANSPORTERS))
        return PageTypes.TRANSPORTERS;
    else if (path.includes(PageTypes.GROW_NETWORK))
        return PageTypes.GROW_NETWORK;
    else
        return path.replace(/\//g, "");
};


//# sourceMappingURL=getPageType.js.map

// EXTERNAL MODULE: ../core/dist/methods/scrollToElement.js
var scrollToElement = __webpack_require__(72341);
// EXTERNAL MODULE: ../core/dist/methods/getInitialContextValues.js
var getInitialContextValues = __webpack_require__(8660);
// EXTERNAL MODULE: ../core/dist/methods/remove-empty-or-null-object-value.js
var remove_empty_or_null_object_value = __webpack_require__(43266);
// EXTERNAL MODULE: ../core/dist/methods/isValidCompanyName.js
var isValidCompanyName = __webpack_require__(88954);
// EXTERNAL MODULE: ../core/dist/methods/getArrayWithType.js
var getArrayWithType = __webpack_require__(95494);
// EXTERNAL MODULE: ../core/dist/methods/generateUrlParamsFromArray.js
var generateUrlParamsFromArray = __webpack_require__(73435);
// EXTERNAL MODULE: ../core/dist/methods/generateQueryString.js
var generateQueryString = __webpack_require__(99073);
// EXTERNAL MODULE: ../core/dist/methods/encryptData.js
var encryptData = __webpack_require__(57302);
;// CONCATENATED MODULE: ../core/dist/methods/index.js




























































//# sourceMappingURL=index.js.map


/***/ }),

/***/ 88954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isValidCompanyName; }
/* harmony export */ });
/* harmony import */ var _constants_authorizedUsers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2390);
/* harmony import */ var _constants_bidStatus_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71535);
/* harmony import */ var _constants_bulkLoadCardStatus_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47762);
/* harmony import */ var _constants_misc_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77370);
/* harmony import */ var _constants_event_names_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69406);
/* harmony import */ var _constants_eventsMapObj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3000);
/* harmony import */ var _constants_Faq_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80230);
/* harmony import */ var _constants_languages_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87013);
/* harmony import */ var _constants_loadStatus_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61834);
/* harmony import */ var _constants_lorryStatus_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69673);
/* harmony import */ var _constants_lorryTypes_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14345);
/* harmony import */ var _constants_mostSearchedLinks_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16593);
/* harmony import */ var _constants_Pages_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52489);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77160);
/* harmony import */ var bowser__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(bowser__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30116);
/* harmony import */ var _components_toast_toast_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63118);
/* harmony import */ var _services_auth_service_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68381);
/* harmony import */ var _getAuthIdParam_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4913);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(2784);
/* harmony import */ var _formatDate_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11663);
/* harmony import */ var _constants_StateList_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52224);
/* harmony import */ var _getTransporterFigure_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98819);
/* harmony import */ var _getDownloadsFigure_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(19314);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _getPageLoadSourceUTMParam_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(96762);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _constants_serviceTypeId_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(76705);
/* harmony import */ var _constants_bidUpdateType_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(43298);
/* harmony import */ var _constants_userAction_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(69881);
/* harmony import */ var _constants_api_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(24966);
/* harmony import */ var _constants_link_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(39422);
/* harmony import */ var _constants_market_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(45678);
/* harmony import */ var _constants_payment_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(91680);
/* harmony import */ var _constants_regex_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(14263);
/* harmony import */ var _constants_admin_screenId_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(22391);
/* harmony import */ var _services_const_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(41634);






































function isValidCompanyName(companyName) {
    /* if company name is undefined or empty or length is greater than companyNameCharLimit it is not valid
     * if three consecutive numbers are there then it is not valid
     * if the character is not alphanumeric or space, return false
     * total number of digits in the name cannot exceed 6 */
    var _a;
    if (!companyName ||
        companyName.length <= 0 ||
        companyName.length > _constants_regex_js__WEBPACK_IMPORTED_MODULE_35__/* .companyNameCharLimit */ .w ||
        companyName.match(/[0-9]{3,}/g) ||
        companyName.match(/[^a-z0-9 ]/gi) ||
        ((_a = companyName.match(/[0-9]/g)) === null || _a === void 0 ? void 0 : _a.length) > 6) {
        return false;
    }
    return true;
}


//# sourceMappingURL=isValidCompanyName.js.map


/***/ }),

/***/ 43266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ removeEmptyOrNullObjectValue; }
/* harmony export */ });
function removeEmptyOrNullObjectValue(obj) {
    Object.keys(obj).forEach((k) => (obj[k] && typeof obj[k] === "object" && removeEmptyOrNullObjectValue(obj[k])) ||
        (!obj[k] && obj[k] !== undefined && delete obj[k]));
    return obj;
}


//# sourceMappingURL=remove-empty-or-null-object-value.js.map


/***/ }),

/***/ 72341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ scrollToElement; }
/* harmony export */ });
const scrollToElement = (ref) => {
    setTimeout(() => {
        if (ref && ref.current)
            ref.current.scrollIntoView({ behavior: "smooth" });
    }, 200);
};


//# sourceMappingURL=scrollToElement.js.map


/***/ }),

/***/ 37007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30116);


function sleep(timeInMs) {
    return (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_0__/* .__awaiter */ .m)(this, void 0, void 0, function* () {
        return new Promise((res) => setTimeout(() => {
            res(1);
        }, timeInMs));
    });
}


//# sourceMappingURL=sleep.js.map


/***/ }),

/***/ 63002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ storeEquivalentValuesInASingleVariable; }
/* harmony export */ });
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33958);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_0__);


const storeEquivalentValuesInASingleVariable = (val1, val2) => {
    if (lodash_isequal__WEBPACK_IMPORTED_MODULE_0___default()(val1, val2))
        return val1;
    else
        throw Error(`${val1},${val2} are not same values`);
};


//# sourceMappingURL=storeEquivalentValuesInASingleVariable.js.map


/***/ }),

/***/ 21830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ timer; }
/* harmony export */ });
function timer(timeInSecs, cb) {
    let t = timeInSecs;
    cb(t);
    t--;
    const id = setInterval(() => {
        if (t > -1) {
            cb(t);
            t--;
        }
        else {
            clearInterval(id);
        }
    }, 1000);
    return id;
}


//# sourceMappingURL=timer.js.map


/***/ }),

/***/ 75606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ webShare; }
/* harmony export */ });
/* harmony import */ var _copyToClipboard_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54534);


function webShare(text, url) {
    if (navigator.share) {
        navigator
            .share({
            text,
            url
        })
            .then(() => {
            console.log("Thanks for sharing!");
        })
            .catch(console.error);
    }
    else {
        (0,_copyToClipboard_js__WEBPACK_IMPORTED_MODULE_0__/* .copyToClipboard */ .v)(`${text}\n${url}`);
    }
}


//# sourceMappingURL=web-share.js.map


/***/ }),

/***/ 36474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ styleInject; }
/* harmony export */ });
function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}


//# sourceMappingURL=style-inject.es.js.map


/***/ }),

/***/ 47526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HelperStyles; }
/* harmony export */ });
/* harmony import */ var _node_modules_style_inject_dist_style_inject_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36474);


var css_248z = ".helper-module_center_horizontal__C-xg4 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.helper-module_center_vertical__miCS- {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}";
var HelperStyles = {"center_horizontal":"helper-module_center_horizontal__C-xg4","center_vertical":"helper-module_center_vertical__miCS-"};
(0,_node_modules_style_inject_dist_style_inject_es_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(css_248z);


//# sourceMappingURL=helper.module.scss.js.map


/***/ }),

/***/ 42386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "$G": function() { return /* reexport */ useTranslation/* useTranslation */.$; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, i18n, withTranslation

// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(29463);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/context.js
var context = __webpack_require__(71648);
;// CONCATENATED MODULE: ../../node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(context/* I18nContext.Provider */.OO.Provider, {
    value: value
  }, children);
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },

  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },

  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  strictMode: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js




var _excluded = ["i18n"],
    _excluded2 = ["i18n"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$use;

  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  } //
  // Initial merge of default and user-provided config
  //


  var userI18n = userConfig.i18n,
      userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);

  var defaultI18n = defaultConfig.i18n,
      defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);

  var combinedConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);

  var defaultNS = combinedConfig.defaultNS,
      lng = combinedConfig.lng,
      locales = combinedConfig.locales,
      localeExtension = combinedConfig.localeExtension,
      localePath = combinedConfig.localePath,
      localeStructure = combinedConfig.localeStructure;
  /**
   * Skips translation file resolution while in cimode
   * https://github.com/isaachinman/next-i18next/pull/851#discussion_r503113620
  */

  if (lng === 'cimode') {
    return combinedConfig;
  }

  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;
  }

  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });

  if (false) { var getAllLocales, getNamespaces, unique, _defaultNSExists, _defaultNSPath, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, suffix, prefix, _userConfig$interpola, _userConfig$interpola2, _userConfig$interpola3, _userConfig$interpola4, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }

    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  } //
  // Deep merge with overwrite - goes last
  //


  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = _objectSpread(_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(9249);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(87371);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(45754);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(11987);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(95058);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(39868);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(81079);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(59147);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(34434);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return (0,arrayWithHoles/* default */.Z)(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || (0,nonIterableRest/* default */.Z)();
}
;// CONCATENATED MODULE: ../../node_modules/i18next/dist/esm/i18next.js










function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { i18next_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, i18next_objectSpread(i18next_objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1(_objectSpread$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1(_objectSpread$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = '_zero';

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val.trim();
        if (val.trim() === 'false') formatOptions[key.trim()] = false;
        if (val.trim() === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val.trim())) formatOptions[key.trim()] = parseInt(val.trim(), 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: function number(val, lng, options) {
        return new Intl.NumberFormat(lng, options).format(val);
      },
      currency: function currency(val, lng, options) {
        return new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        })).format(val);
      },
      datetime: function datetime(val, lng, options) {
        return new Intl.DateTimeFormat(lng, _objectSpread$4({}, options)).format(val);
      },
      relativetime: function relativetime(val, lng, options) {
        return new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options)).format(val, options.range || 'day');
      },
      list: function list(val, lng, options) {
        return new Intl.ListFormat(lng, _objectSpread$4({}, options)).format(val);
      }
    };
    this.init(options);
  }

  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,assertThisInitialized/* default */.Z)(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

/* harmony default export */ var i18next = (instance);


;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  var instance = i18next.createInstance(config);
  var initPromise;

  if (!instance.isInitialized) {
    var _config$use;

    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });
    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next.t);
  }

  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;

function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;

    var _ref = props.pageProps,
        _nextI18Next = _ref._nextI18Next;
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale; // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes

    var i18n = (0,react.useMemo)(function () {
      var _userConfig, _userConfig2, _userConfig2$i18n;

      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;

      if (!userConfig && configOverride === null) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }

      if (configOverride !== null) {
        userConfig = configOverride;
      }

      if (!((_userConfig = userConfig) !== null && _userConfig !== void 0 && _userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }

      if (!((_userConfig2 = userConfig) !== null && _userConfig2 !== void 0 && (_userConfig2$i18n = _userConfig2.i18n) !== null && _userConfig2$i18n !== void 0 && _userConfig2$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }

      var _ref2 = _nextI18Next || {},
          initialI18nStore = _ref2.initialI18nStore;

      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride]);
    return i18n !== null ? __jsx(I18nextProvider, {
      i18n: i18n
    }, __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props))) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };

  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(23081);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ BiddingFormProvider; },
/* harmony export */   "Eo": function() { return /* binding */ BID_ACTIONS; },
/* harmony export */   "O7": function() { return /* binding */ BiddingFormContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);




var initialBidFormConfig = {
    load: {
        open: false,
        reset: false,
        id: null
    },
    lorry: {
        open: false,
        reset: false,
        id: null
    },
    loadPreferredAmount: {
        open: false
    },
    attachLorry: {
        open: false
    }
};
var BiddingFormContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialBidFormConfig);
// Define actions
var BID_ACTIONS = {
    LOAD: "LOAD_BID",
    LORRY: "LORRY_BID",
    LOAD_PREFERRED_AMT: "PREFERRED_AMOUNT",
    ATTACH_LORRY: "ATTACH_LORRY",
    RESET: "RESET"
};
var reducer = function(state, action) {
    switch(action.type){
        case BID_ACTIONS.LOAD:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                load: action.payload
            });
        case BID_ACTIONS.LORRY:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                lorry: action.payload
            });
        case BID_ACTIONS.LOAD_PREFERRED_AMT:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                loadPreferredAmount: action.payload
            });
        case BID_ACTIONS.ATTACH_LORRY:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                attachLorry: action.payload
            });
        case BID_ACTIONS.RESET:
            return initialBidFormConfig;
        default:
            return state;
    }
};
var BiddingFormProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialBidFormConfig), bidFormConfig = ref[0], dispatchBid = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BiddingFormContext.Provider, {
        value: {
            bidFormConfig: bidFormConfig,
            dispatchBid: dispatchBid
        },
        children: children
    });
};



/***/ }),

/***/ 31845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useDetailsPageContext; },
/* harmony export */   "y": function() { return /* binding */ DetailsPageContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82066);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49352);
/* harmony import */ var _methods_getRequiredBid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45048);






var DetailsPageContextProvider = function(param) {
    var children = param.children;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQueryClient)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), detailsPageData = ref[0], setDetailsPageData = ref[1];
    var refetchLoadDetails = function(cb) {
        var ref, ref1;
        if ((ref = detailsPageData.loadDetailsV2) === null || ref === void 0 ? void 0 : (ref1 = ref.load_detail) === null || ref1 === void 0 ? void 0 : ref1.id) queryClient.refetchQueries(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.getLoadAllData */ ._.getLoadAllData, {
            inactive: true,
            active: true,
            stale: true
        }).then(function() {
            cb === null || cb === void 0 ? void 0 : cb();
        });
    };
    var refetchLorryDetails = function(cb) {
        var ref, ref1;
        if ((ref = detailsPageData.lorryDetailsV2) === null || ref === void 0 ? void 0 : (ref1 = ref.lorry_detail) === null || ref1 === void 0 ? void 0 : ref1.id) queryClient.refetchQueries(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.getLorryAllDataV2 */ ._.getLorryAllDataV2, {
            inactive: true,
            active: true,
            stale: true
        }).then(function() {
            cb === null || cb === void 0 ? void 0 : cb();
        });
    };
    var refetchGDocApi = function(cb) {
        var ref, ref1, ref2, ref3;
        var ref4;
        var bidId = (ref4 = (ref1 = (0,_methods_getRequiredBid__WEBPACK_IMPORTED_MODULE_4__/* .getRequiredBid */ .h)((ref = detailsPageData.loadDetailsV2) === null || ref === void 0 ? void 0 : ref.bid_infos)) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref4 !== void 0 ? ref4 : (ref3 = (0,_methods_getRequiredBid__WEBPACK_IMPORTED_MODULE_4__/* .getRequiredBid */ .h)((ref2 = detailsPageData.lorryDetailsV2) === null || ref2 === void 0 ? void 0 : ref2.bid_infos)) === null || ref3 === void 0 ? void 0 : ref3.id;
        if (bidId == null) {
            cb === null || cb === void 0 ? void 0 : cb();
            return;
        }
        queryClient.refetchQueries([
            _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_3__/* .QueryNames.getDocumentsNonMutate */ ._.getDocumentsNonMutate,
            bidId
        ], {
            inactive: true,
            active: true,
            stale: true
        }).then(function() {
            cb === null || cb === void 0 ? void 0 : cb();
        });
    };
    var updateDetailsPageData = function(details) {
        setDetailsPageData(function(prevDetails) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prevDetails, details);
        });
    };
    var clearDetailsPageContext = function() {
        setDetailsPageData({});
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailsPageContext.Provider, {
        value: {
            detailsPageData: detailsPageData,
            updateDetailsPageData: updateDetailsPageData,
            clearDetailsPageContext: clearDetailsPageContext,
            refetchLoadDetails: refetchLoadDetails,
            refetchLorryDetails: refetchLorryDetails,
            refetchGDocApi: refetchGDocApi
        },
        children: children
    });
};
var DetailsPageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var useDetailsPageContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(DetailsPageContext);
};


/***/ }),

/***/ 43103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tx": function() { return /* binding */ MarketplaceProvider; },
/* harmony export */   "iT": function() { return /* binding */ MarketplaceContext; },
/* harmony export */   "sF": function() { return /* binding */ MARKETPLACE_ACTIONS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var initialMarketplaceConfig = {
    srcText: "",
    destText: "",
    marketType: undefined,
    lorryTypeIds: [],
    selectedLorryId: undefined,
    selectLorryNumber: undefined
};
var MARKETPLACE_ACTIONS = {
    APPLY_FILTER: "APPLY_FILTER",
    CLEAR_FILTER: "CLEAR_FILTER"
};
var reducer = function(state, action) {
    switch(action.type){
        case MARKETPLACE_ACTIONS.APPLY_FILTER:
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state, action.payload);
        case MARKETPLACE_ACTIONS.CLEAR_FILTER:
            return initialMarketplaceConfig;
        default:
            return state;
    }
};
var MarketplaceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    marketplaceConfig: initialMarketplaceConfig,
    dispatchMarketplace: function() {},
    shouldExecuteApi: undefined,
    setShouldExecuteApi: function() {}
});
var MarketplaceProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialMarketplaceConfig), marketplaceConfig = ref[0], dispatchMarketplace = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), shouldExecuteApi = ref1[0], setShouldExecuteApi = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MarketplaceContext.Provider, {
        value: {
            marketplaceConfig: marketplaceConfig,
            dispatchMarketplace: dispatchMarketplace,
            shouldExecuteApi: shouldExecuteApi,
            setShouldExecuteApi: setShouldExecuteApi
        },
        children: children
    });
};



/***/ }),

/***/ 91904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71960);




var Tooltip = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 45294));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45294)
            ];
        }
    },
    ssr: false
});
var EllipsisText = function(param) {
    var _limit = param.limit, limit = _limit === void 0 ? 0 : _limit, tmp = param.text, _text = tmp === void 0 ? "" : tmp, id = param.id, _tooltipDirection = param.tooltipDirection, tooltipDirection = _tooltipDirection === void 0 ? "left" : _tooltipDirection;
    var text = String(_text);
    var finalText = text.substring(0, limit);
    var isClipped = finalText.length < text.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tooltip, {
        appearOnHover: true,
        position: tooltipDirection,
        tooltipToggler: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            noWrap: true,
            id: id,
            children: [
                finalText,
                isClipped && "..."
            ]
        }),
        tooltipContent: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EllipsisText);


/***/ }),

/***/ 6632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68191);


var IfCanAccess = function(param) {
    var action = param.action, children = param.children, _skipPermission = param.skipPermission, skipPermission = _skipPermission === void 0 ? false : _skipPermission, _alsoCheck = param.alsoCheck, alsoCheck = _alsoCheck === void 0 ? true : _alsoCheck, _allowCsUser = param.allowCsUser, allowCsUser = _allowCsUser === void 0 ? false : _allowCsUser, _allowCustomer = param.allowCustomer, allowCustomer = _allowCustomer === void 0 ? false : _allowCustomer, roles = param.roles;
    var ref = (0,_vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_1__/* .useCsDashboard */ .Z)(), checkPermission = ref.checkPermission, isCsDashboardUser = ref.isCsDashboardUser, checkRole = ref.checkRole;
    var isUserPermitted = checkPermission(action) || (roles === null || roles === void 0 ? void 0 : roles.length) && checkRole(roles);
    var csUserSkip = allowCsUser ? isCsDashboardUser : false;
    var customerSkip = allowCustomer ? !isCsDashboardUser : false;
    return (isUserPermitted || skipPermission || csUserSkip || customerSkip) && alsoCheck ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (IfCanAccess);


/***/ }),

/***/ 3533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ AssuredBidStatusList; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_bidStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71535);

var AssuredBidStatusList = [
    _vahak_core_dist_constants_bidStatus__WEBPACK_IMPORTED_MODULE_0__/* .BID_STATUS.STAND_BY */ .UE.STAND_BY,
    _vahak_core_dist_constants_bidStatus__WEBPACK_IMPORTED_MODULE_0__/* .BID_STATUS.PARTIALLY_ACCEPTED */ .UE.PARTIALLY_ACCEPTED
];


/***/ }),

/***/ 60280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ TicketDocument; },
/* harmony export */   "Gy": function() { return /* binding */ TicketSystemTypes; },
/* harmony export */   "Jk": function() { return /* binding */ TicketDocumentText; },
/* harmony export */   "Rt": function() { return /* binding */ TicketStatusMap; },
/* harmony export */   "Th": function() { return /* binding */ SubscriptionPlan; },
/* harmony export */   "U2": function() { return /* binding */ TicketCallMeBackStatus; },
/* harmony export */   "YU": function() { return /* binding */ TicketStatusFilterValue; },
/* harmony export */   "Ze": function() { return /* binding */ TicketDocumentName; },
/* harmony export */   "d9": function() { return /* binding */ TicketTypeToSystemTypeMap; },
/* harmony export */   "gS": function() { return /* binding */ LoadTicketType; },
/* harmony export */   "i": function() { return /* binding */ TicketTypeToNameMap; },
/* harmony export */   "jB": function() { return /* binding */ CallMeBackStatusMap; },
/* harmony export */   "jc": function() { return /* binding */ VasType; },
/* harmony export */   "m4": function() { return /* binding */ TicketTypeMap; },
/* harmony export */   "md": function() { return /* binding */ TICKET_TYPE_NAME_MAP; },
/* harmony export */   "oy": function() { return /* binding */ TableColumnName; },
/* harmony export */   "qt": function() { return /* binding */ TicketStatusText; },
/* harmony export */   "rm": function() { return /* binding */ DispositionSourceScreen; },
/* harmony export */   "sz": function() { return /* binding */ LoadTicketTypeToAgentTypeNameMap; },
/* harmony export */   "ux": function() { return /* binding */ TicketTitle; },
/* harmony export */   "yo": function() { return /* binding */ RefundRequestStatusMap; },
/* harmony export */   "z1": function() { return /* binding */ SubscriptionPlanText; },
/* harmony export */   "zK": function() { return /* binding */ TicketType; }
/* harmony export */ });
/* unused harmony exports TicketSystemDocActionType, ExtendedTicketTitle, TicketSystemRejectionComments, RejectionCommentsByTicketType, FOSRejectionComment, AcceptAadhaarFormInputLabel, AcceptCompanyDlFormInputLabel, AcceptEwayFormInputLabel, AcceptGstFormInputLabel, TicketSystemModalTitle, TicketActionSuccessText, KycStatusMap, LoadTicketTypeList, LoadTicketTypeToNameMap, LoadTicketNameToTypeMap, CancelLoadBidDInstantOptionList */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87394);
/* harmony import */ var _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22391);
/* harmony import */ var _methods_uiUtil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34695);




var VasType;
(function(VasType) {
    VasType[VasType["CARGO"] = 1] = "CARGO";
    VasType[VasType["GPS"] = 2] = "GPS";
    VasType[VasType["VEHICLE_INSURANCE"] = 3] = "VEHICLE_INSURANCE";
    VasType[VasType["BUSINESS_LOAN"] = 4] = "BUSINESS_LOAN";
})(VasType || (VasType = {}));
var TicketType;
(function(TicketType) {
    TicketType[TicketType["EWAY_VERIFICATION"] = 5] = "EWAY_VERIFICATION";
    TicketType[TicketType["CALL_ME_BACK"] = 10] = "CALL_ME_BACK";
    TicketType[TicketType["HELP"] = 11] = "HELP";
    TicketType[TicketType["VAS_LEADS_CARGO"] = 12] = "VAS_LEADS_CARGO";
    TicketType[TicketType["VAS_LEADS_GPS"] = 13] = "VAS_LEADS_GPS";
    TicketType[TicketType["ACCOUNT_DELETION"] = 14] = "ACCOUNT_DELETION";
    TicketType[TicketType["ASSURED_CALLBACK"] = 15] = "ASSURED_CALLBACK";
    TicketType[TicketType["VAS_LEADS_VEHICLE_INSURANCE"] = 16] = "VAS_LEADS_VEHICLE_INSURANCE";
    TicketType[TicketType["VAS_LEADS_BUSINESS_LOAN"] = 17] = "VAS_LEADS_BUSINESS_LOAN";
    TicketType[TicketType["MEMBERSHIP_CALL_ME_BACK"] = 18] = "MEMBERSHIP_CALL_ME_BACK";
    TicketType[TicketType["IN_TRANSIT_CALLBACK"] = 19] = "IN_TRANSIT_CALLBACK";
    TicketType[TicketType["COMPANY_REGISTRATION"] = 24] = "COMPANY_REGISTRATION";
    TicketType[TicketType["ADS_LEADS"] = 26] = "ADS_LEADS";
    TicketType[TicketType["LOAD_POST_SUPPORT"] = 30] = "LOAD_POST_SUPPORT";
    TicketType[TicketType["AADHAAR_VERIFICATION"] = 100] = "AADHAAR_VERIFICATION";
    TicketType[TicketType["BUSINESS_VERIFICATION"] = 200] = "BUSINESS_VERIFICATION";
    TicketType[TicketType["PAN_VERIFICATION"] = 300] = "PAN_VERIFICATION";
    TicketType[TicketType["RC_VERIFICATION_BLOCKED"] = 400] = "RC_VERIFICATION_BLOCKED";
    TicketType[TicketType["RC_VERIFICATION_FAILED"] = 401] = "RC_VERIFICATION_FAILED";
    TicketType[TicketType["REFUND_REQUEST"] = 500] = "REFUND_REQUEST";
    TicketType[TicketType["BID_CANCELLATION"] = 510] = "BID_CANCELLATION";
    TicketType[TicketType["RC_VERIFICATION_FITNESS"] = 604] = "RC_VERIFICATION_FITNESS";
    TicketType[TicketType["RC_VERIFICATION_TDS"] = 605] = "RC_VERIFICATION_TDS";
    TicketType[TicketType["TSO_LEAD_FORM"] = 700] = "TSO_LEAD_FORM";
    TicketType[TicketType["LORRY_BODY_VERIFICATION"] = 800] = "LORRY_BODY_VERIFICATION";
    TicketType[TicketType["COMPANY_DL_VERIFICATION"] = 900] = "COMPANY_DL_VERIFICATION";
})(TicketType || (TicketType = {}));
var _obj;
var TicketTypeToNameMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, TicketType.RC_VERIFICATION_BLOCKED, "Lorry Document"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, TicketType.RC_VERIFICATION_FAILED, "Lorry Document"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, TicketType.RC_VERIFICATION_TDS, "Lorry TDS Document"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, TicketType.RC_VERIFICATION_FITNESS, "Lorry Fitness Document"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, TicketType.LORRY_BODY_VERIFICATION, "Lorry Body Verification"), _obj);
var TicketSystemTypes;
(function(TicketSystemTypes) {
    TicketSystemTypes["EWAY_VERIFICATION"] = "eway";
    TicketSystemTypes["RC_VERIFICATION"] = "rc";
    TicketSystemTypes["AADHAAR_VERIFICATION"] = "aadhaar";
    TicketSystemTypes["PAN_VERIFICATION"] = "pan";
    TicketSystemTypes["BUSINESS_VERIFICATION"] = "business";
    TicketSystemTypes["REFUND_REQUEST"] = "refund-request";
    TicketSystemTypes["CALL_ME_BACK"] = "call-me-back";
    TicketSystemTypes["HELP"] = "help";
    TicketSystemTypes["ACCOUNT_DELETION"] = "account-deletion";
    TicketSystemTypes["ASSURED_CALLBACK"] = "assured-callback";
    TicketSystemTypes["VAS_LEADS"] = "vas-leads";
    TicketSystemTypes["BID_CANCELLATION"] = "bid-cancellation";
    TicketSystemTypes["COMPANY_REGISTRATION_LEADS"] = "company-registration-leads";
    TicketSystemTypes["ADS_LEADS"] = "ads-leads";
    TicketSystemTypes["MEMBERSHIP_CALL_ME_BACK"] = "membership-call-me-back";
    TicketSystemTypes["IN_TRANSIT_CALLBACK"] = "intransit-call-me-back";
    TicketSystemTypes["COMPANY_DL_VERIFICATION"] = "company-dl-verification";
    TicketSystemTypes["TSO_ADMIN_LEAD"] = "tso-admin-leads";
    TicketSystemTypes["LOAD_POST_SUPPORT"] = "load-post-support";
})(TicketSystemTypes || (TicketSystemTypes = {}));
var _obj1;
var TicketTypeToSystemTypeMap = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.EWAY_VERIFICATION, TicketSystemTypes.EWAY_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.CALL_ME_BACK, TicketSystemTypes.CALL_ME_BACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.HELP, TicketSystemTypes.HELP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.VAS_LEADS_CARGO, TicketSystemTypes.VAS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.VAS_LEADS_GPS, TicketSystemTypes.VAS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.VAS_LEADS_VEHICLE_INSURANCE, TicketSystemTypes.VAS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.VAS_LEADS_BUSINESS_LOAN, TicketSystemTypes.VAS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.ACCOUNT_DELETION, TicketSystemTypes.ACCOUNT_DELETION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.ASSURED_CALLBACK, TicketSystemTypes.ASSURED_CALLBACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.MEMBERSHIP_CALL_ME_BACK, TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.IN_TRANSIT_CALLBACK, TicketSystemTypes.IN_TRANSIT_CALLBACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.COMPANY_REGISTRATION, TicketSystemTypes.COMPANY_REGISTRATION_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.ADS_LEADS, TicketSystemTypes.ADS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.AADHAAR_VERIFICATION, TicketSystemTypes.AADHAAR_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.BUSINESS_VERIFICATION, TicketSystemTypes.BUSINESS_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.PAN_VERIFICATION, TicketSystemTypes.PAN_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.RC_VERIFICATION_BLOCKED, TicketSystemTypes.RC_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.RC_VERIFICATION_FAILED, TicketSystemTypes.RC_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.RC_VERIFICATION_FITNESS, TicketSystemTypes.RC_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.RC_VERIFICATION_TDS, TicketSystemTypes.RC_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.LORRY_BODY_VERIFICATION, TicketSystemTypes.RC_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.REFUND_REQUEST, TicketSystemTypes.REFUND_REQUEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.BID_CANCELLATION, TicketSystemTypes.BID_CANCELLATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.TSO_LEAD_FORM, TicketSystemTypes.VAS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.COMPANY_DL_VERIFICATION, TicketSystemTypes.COMPANY_DL_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, TicketType.LOAD_POST_SUPPORT, TicketSystemTypes.LOAD_POST_SUPPORT), _obj1);
var _obj2;
var TicketTypeMap = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.EWAY_VERIFICATION, TicketType.EWAY_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.CALL_ME_BACK, TicketType.CALL_ME_BACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.AADHAAR_VERIFICATION, TicketType.AADHAAR_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.BUSINESS_VERIFICATION, TicketType.BUSINESS_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.PAN_VERIFICATION, TicketType.PAN_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.RC_VERIFICATION, undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.REFUND_REQUEST, TicketType.REFUND_REQUEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.VAS_LEADS, undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.BID_CANCELLATION, TicketType.BID_CANCELLATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.HELP, TicketType.HELP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.ACCOUNT_DELETION, TicketType.ACCOUNT_DELETION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.ASSURED_CALLBACK, TicketType.ASSURED_CALLBACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.COMPANY_REGISTRATION_LEADS, TicketType.COMPANY_REGISTRATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.ADS_LEADS, TicketType.ADS_LEADS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK, TicketType.MEMBERSHIP_CALL_ME_BACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.IN_TRANSIT_CALLBACK, TicketType.IN_TRANSIT_CALLBACK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.COMPANY_DL_VERIFICATION, TicketType.COMPANY_DL_VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.TSO_ADMIN_LEAD, TicketType.TSO_LEAD_FORM), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, TicketSystemTypes.LOAD_POST_SUPPORT, TicketType.LOAD_POST_SUPPORT), _obj2);
var TicketSystemDocActionType;
(function(TicketSystemDocActionType) {
    TicketSystemDocActionType["REJECT"] = "reject";
    TicketSystemDocActionType["ACCEPT"] = "accept";
})(TicketSystemDocActionType || (TicketSystemDocActionType = {}));
var _obj3;
var TicketTitle = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.AADHAAR_VERIFICATION, "Aadhaar Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.RC_VERIFICATION, "RC Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.PAN_VERIFICATION, "PAN Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.BUSINESS_VERIFICATION, "Business Document Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.EWAY_VERIFICATION, "E-way Bill Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.REFUND_REQUEST, "Refund Request"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.CALL_ME_BACK, "Call me back"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.VAS_LEADS, "VAS Leads"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.BID_CANCELLATION, "Cancellation requests"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.HELP, "Help tickets"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.ACCOUNT_DELETION, "Account deletion"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.ASSURED_CALLBACK, "Assured load call tickets"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.COMPANY_REGISTRATION_LEADS, "Company registration leads"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.ADS_LEADS, "Advertisement leads"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK, "Membership support"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.IN_TRANSIT_CALLBACK, "In-Transit CallBack"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.COMPANY_DL_VERIFICATION, "Company DL Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.TSO_ADMIN_LEAD, "TSO Leads"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, TicketSystemTypes.LOAD_POST_SUPPORT, "Load post support"), _obj3);
var _obj4;
var ExtendedTicketTitle = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, TicketType.RC_VERIFICATION_BLOCKED, "RC Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, TicketType.RC_VERIFICATION_FAILED, "RC Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, TicketType.RC_VERIFICATION_FITNESS, "Lorry Fitness Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, TicketType.RC_VERIFICATION_TDS, "TDS Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, TicketType.LORRY_BODY_VERIFICATION, "Lorry Body Verification"), _obj4);
var _obj5;
var TicketSystemRejectionComments = (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.AADHAAR_VERIFICATION, [
    "Image not clear",
    "Image not in proper portion",
    "Image on aadhaar not matching with selfie",
    "Already linked to another account",
    "Selfie image missing"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.PAN_VERIFICATION, [
    "Name on aadhaar not matching with PAN",
    "Incorrect PAN number",
    "PAN missing",
    "Image not clear"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.BUSINESS_VERIFICATION, [
    "Document not matching",
    "Already linked to another account",
    "Improper image format",
    "Document Expired"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.RC_VERIFICATION, [
    "Image not clear",
    "RC number does not match",
    "Upload fitness certificate",
    "RC Missing"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.EWAY_VERIFICATION, [
    "Invalid E way number",
    "Image not clear",
    "Not an E-way bill",
    "Repeat E-way bill",
    "E-way bill expired",
    "E-way bill date doesn't match",
    "E-way bill GST Doesn't match",
    "Not completed payment",
    "Vehicle number not matching"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.REFUND_REQUEST, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.CALL_ME_BACK, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.VAS_LEADS, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.BID_CANCELLATION, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.HELP, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.ACCOUNT_DELETION, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.ASSURED_CALLBACK, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.COMPANY_REGISTRATION_LEADS, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.ADS_LEADS, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.IN_TRANSIT_CALLBACK, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.COMPANY_DL_VERIFICATION, [
    "Image not clear",
    "Name not as per Aadhaar",
    "Invalid image"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.TSO_ADMIN_LEAD, []), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, TicketSystemTypes.LOAD_POST_SUPPORT, []), _obj5);
var _obj6;
var RejectionCommentsByTicketType = (_obj6 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, TicketType.RC_VERIFICATION_BLOCKED, TicketSystemRejectionComments[TicketSystemTypes["RC_VERIFICATION"]]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, TicketType.RC_VERIFICATION_FAILED, TicketSystemRejectionComments[TicketSystemTypes["RC_VERIFICATION"]]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, TicketType.RC_VERIFICATION_TDS, [
    "Image not clear",
    "RC number does not match",
    "Upload Tax Deduction Source document"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, TicketType.RC_VERIFICATION_FITNESS, [
    "Image not clear",
    "RC number does not match",
    "Upload fitness certificate",
    "Fitness certificate is expired "
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, TicketType.LORRY_BODY_VERIFICATION, [
    "Image not clear",
    "Unable to see vehicle number",
    "Vehicle too far",
    "Vehicle too close"
]), _obj6);
var FOSRejectionComment = (/* unused pure expression or super */ null && ([
    "Document not valid",
    "User not available",
    "Fraud user"
]));
var AcceptAadhaarFormInputLabel = {
    aadhaarNumber: "Enter last 4-digit of Aadhaar number",
    aadhaarName: "Enter Name on Aadhaar",
    state: "Enter State"
};
var AcceptCompanyDlFormInputLabel = {
    dlNumber: "Enter DL number"
};
var AcceptEwayFormInputLabel = {
    ewayNumber: "E-way number"
};
var AcceptGstFormInputLabel = {
    gstType: "Enter document type",
    legalName: "Enter legal name",
    gstNumber: "Enter document number"
};
var TicketSystemModalTitle = {
    rejection: "Rejection comments",
    acceptAadhaar: "Accept Aadhaar document",
    acceptBusiness: "Accept Business document",
    addComments: "Your Comments",
    acceptPAN: "Accept PAN",
    acceptEWay: "Accept E-Way",
    rcVerification: "Accept RC"
};
var _obj7, _obj8, _obj9, _obj10, _obj11, _obj12, _obj13;
var TicketActionSuccessText = (_obj13 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj13, TicketSystemTypes.AADHAAR_VERIFICATION, (_obj7 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj7, TicketSystemDocActionType.REJECT, "Aadhaar Document Rejected Successfully"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj7, TicketSystemDocActionType.ACCEPT, "Aadhaar Document Accepted Successfully"), _obj7)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj13, TicketSystemTypes.PAN_VERIFICATION, (_obj8 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj8, TicketSystemDocActionType.REJECT, "PAN Document Rejected Successfully"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj8, TicketSystemDocActionType.ACCEPT, "PAN Document Accepted Successfully"), _obj8)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj13, TicketSystemTypes.BUSINESS_VERIFICATION, (_obj9 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj9, TicketSystemDocActionType.REJECT, "Business Document Rejected Successfully"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj9, TicketSystemDocActionType.ACCEPT, "Business Document Accepted Successfully"), _obj9)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj13, TicketSystemTypes.RC_VERIFICATION, (_obj10 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, TicketSystemDocActionType.REJECT, "Document Rejected Successfully"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, TicketSystemDocActionType.ACCEPT, "Document Accepted Successfully"), _obj10)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj13, TicketSystemTypes.EWAY_VERIFICATION, (_obj11 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, TicketSystemDocActionType.REJECT, "E-way Bill Rejected Successfully"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, TicketSystemDocActionType.ACCEPT, "E-way Bill Accepted Successfully"), _obj11)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj13, TicketSystemTypes.COMPANY_DL_VERIFICATION, (_obj12 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj12, TicketSystemDocActionType.REJECT, "Company DL Document Rejected Successfully"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj12, TicketSystemDocActionType.ACCEPT, "Company DL Document Accepted Successfully"), _obj12)), _obj13);
var TicketStatusMap;
(function(TicketStatusMap) {
    TicketStatusMap[TicketStatusMap["Unverified"] = 0] = "Unverified";
    TicketStatusMap[TicketStatusMap["Verified"] = 1] = "Verified";
    TicketStatusMap[TicketStatusMap[// PhysicalVerification = 3,
    "Resolving"] = 4] = "Resolving";
    TicketStatusMap[TicketStatusMap[// FOSVerification = 5,
    "Rejected"] = 999] = "Rejected";
})(TicketStatusMap || (TicketStatusMap = {}));
var _obj14;
var KycStatusMap = (_obj14 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj14, TicketStatusMap.Unverified, "Unverified"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj14, TicketStatusMap.Verified, "Verified"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj14, TicketStatusMap.Rejected, "Rejected"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj14, TicketStatusMap.Resolving, ""), _obj14);
var _obj15;
var CallMeBackStatusMap = (_obj15 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj15, TicketStatusMap.Unverified, "New"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj15, TicketStatusMap.Verified, "Closed"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj15, TicketStatusMap.Rejected, ""), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj15, TicketStatusMap.Resolving, ""), _obj15);
var _obj16;
var RefundRequestStatusMap = (_obj16 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj16, TicketStatusMap.Unverified, "Pending"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj16, TicketStatusMap.Verified, "Approved"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj16, TicketStatusMap.Rejected, "Rejected"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj16, TicketStatusMap.Resolving, ""), _obj16);
var TicketStatusText;
(function(TicketStatusText) {
    TicketStatusText["ALL"] = "All";
    TicketStatusText["PENDING"] = "Pending";
    TicketStatusText["REJECTED"] = "Rejected";
    TicketStatusText["ACCEPTED"] = "Accepted";
    TicketStatusText["Resolving"] = "Resolving";
})(TicketStatusText || (TicketStatusText = {}));
var TicketDocumentName;
(function(TicketDocumentName) {
    TicketDocumentName["LR_DOC"] = "lrDoc";
    TicketDocumentName["EWAY_DOC"] = "ewayDoc";
    TicketDocumentName["GOODS_DOC"] = "goodsDoc";
    TicketDocumentName["POD_DOC"] = "podDoc";
    TicketDocumentName["RC_DOC"] = "rcDoc";
    TicketDocumentName["LORRY_FITNESS_DOC"] = "lorryFitnessDoc";
    TicketDocumentName["TDS_DOC"] = "tdsDoc";
    TicketDocumentName["VEHICLE_INSURANCE_DOC"] = "vehicleInsuranceDoc";
    TicketDocumentName["VEHICLE_OWNER_AADHAAR_DOC"] = "vehicleOwnerAadhaarDoc";
    TicketDocumentName["DRIVER_LICENSE_DOC"] = "driverLicenseDoc";
    TicketDocumentName["DRIVER_AADHAAR_DOC"] = "driverAadhaarDoc";
    TicketDocumentName["SHOP_IMAGE_DOC"] = "shopImageDoc";
    TicketDocumentName[// TYPESCRIPT
    "AADHAAR_FRONT"] = "frontDoc";
    TicketDocumentName["AADHAAR_BACK"] = "backDoc";
    TicketDocumentName["AADHAAR_SELFIE"] = "selfieDoc";
    TicketDocumentName["GST_CERTIFICATE"] = "gstCertificate";
    TicketDocumentName["MSME_CERTIFICATE"] = "msmeCertificate";
    TicketDocumentName["GUMASTA_LICENSE"] = "gumastaLicense";
    TicketDocumentName["TRADE_LICENSE"] = "tradeLicense";
    TicketDocumentName["RC_VALIDATION"] = "rcValidation";
    TicketDocumentName["SUPPORTING_DOC"] = "supportDoc";
    TicketDocumentName["LORRY_BODY_FRONT_VIEW"] = "frontDoc";
    TicketDocumentName["LORRY_BODY_BACK_VIEW"] = "backDoc";
    TicketDocumentName["LORRY_BODY_SIDE_VIEW"] = "sideDoc";
    TicketDocumentName["COMPANY_DRIVER_LICENSE_FRONT"] = "companyDriverLicenseFrontDoc";
    TicketDocumentName["COMPANY_DRIVER_LICENSE_BACK"] = "companyDriverLicenseBackDoc";
})(TicketDocumentName || (TicketDocumentName = {}));
var TicketDocument;
(function(TicketDocument) {
    TicketDocument[TicketDocument["LORRY_RECEIPT"] = 1] = "LORRY_RECEIPT";
    TicketDocument[TicketDocument["POD"] = 2] = "POD";
    TicketDocument[TicketDocument["SUPPORTING_DOC"] = 3] = "SUPPORTING_DOC";
    TicketDocument[TicketDocument["EWAY_BILL"] = 5] = "EWAY_BILL";
    TicketDocument[TicketDocument["GOODS_INVOICE"] = 6] = "GOODS_INVOICE";
    TicketDocument[TicketDocument["SHOP_IMAGE"] = 7] = "SHOP_IMAGE";
    TicketDocument[TicketDocument["AADHAAR_FRONT"] = 100] = "AADHAAR_FRONT";
    TicketDocument[TicketDocument["AADHAAR_BACK"] = 101] = "AADHAAR_BACK";
    TicketDocument[TicketDocument["AADHAAR_SELFIE"] = 102] = "AADHAAR_SELFIE";
    TicketDocument[TicketDocument["GST_CERTIFICATE"] = 200] = "GST_CERTIFICATE";
    TicketDocument[TicketDocument["MSME_CERTIFICATE"] = 201] = "MSME_CERTIFICATE";
    TicketDocument[TicketDocument["GUMASTA_LICENSE"] = 202] = "GUMASTA_LICENSE";
    TicketDocument[TicketDocument["TRADE_LICENSE"] = 203] = "TRADE_LICENSE";
    TicketDocument[TicketDocument[// PAN = 300,
    "RC_VALIDATION"] = 400] = "RC_VALIDATION";
    TicketDocument[TicketDocument["RC_DOCUMENT"] = 401] = "RC_DOCUMENT";
    TicketDocument[TicketDocument["DRIVER_LICENSE"] = 600] = "DRIVER_LICENSE";
    TicketDocument[TicketDocument["VEHICLE_INSURANCE"] = 601] = "VEHICLE_INSURANCE";
    TicketDocument[TicketDocument["DRIVER_AADHAAR"] = 602] = "DRIVER_AADHAAR";
    TicketDocument[TicketDocument["VEHICLE_OWNER_AADHAAR"] = 603] = "VEHICLE_OWNER_AADHAAR";
    TicketDocument[TicketDocument["LORRY_FITNESS"] = 604] = "LORRY_FITNESS";
    TicketDocument[TicketDocument["TDS"] = 605] = "TDS";
    TicketDocument[TicketDocument["LORRY_BODY_FRONT_VIEW"] = 800] = "LORRY_BODY_FRONT_VIEW";
    TicketDocument[TicketDocument["LORRY_BODY_BACK_VIEW"] = 801] = "LORRY_BODY_BACK_VIEW";
    TicketDocument[TicketDocument["LORRY_BODY_SIDE_VIEW"] = 802] = "LORRY_BODY_SIDE_VIEW";
    TicketDocument[TicketDocument["COMPANY_DRIVER_LICENSE_FRONT"] = 900] = "COMPANY_DRIVER_LICENSE_FRONT";
    TicketDocument[TicketDocument["COMPANY_DRIVER_LICENSE_BACK"] = 901] = "COMPANY_DRIVER_LICENSE_BACK";
})(TicketDocument || (TicketDocument = {}));
var _obj17;
var TICKET_TYPE_NAME_MAP = (_obj17 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.LORRY_RECEIPT, TicketDocumentName.LR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.POD, TicketDocumentName.POD_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.EWAY_BILL, TicketDocumentName.EWAY_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.GOODS_INVOICE, TicketDocumentName.GOODS_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.SHOP_IMAGE, TicketDocumentName.SHOP_IMAGE_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.RC_DOCUMENT, TicketDocumentName.RC_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.LORRY_FITNESS, TicketDocumentName.LORRY_FITNESS_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.TDS, TicketDocumentName.TDS_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.VEHICLE_INSURANCE, TicketDocumentName.VEHICLE_INSURANCE_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.VEHICLE_OWNER_AADHAAR, TicketDocumentName.VEHICLE_OWNER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.DRIVER_LICENSE, TicketDocumentName.DRIVER_LICENSE_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.DRIVER_AADHAAR, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.RC_VALIDATION, TicketDocumentName.RC_DOC), //TYPESCRIPT - to avoid error
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.AADHAAR_FRONT, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.AADHAAR_BACK, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.AADHAAR_SELFIE, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.GST_CERTIFICATE, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.MSME_CERTIFICATE, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.GUMASTA_LICENSE, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.TRADE_LICENSE, TicketDocumentName.DRIVER_AADHAAR_DOC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.SUPPORTING_DOC, TicketDocumentName.SUPPORTING_DOC), // Lorry Body Verification
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.LORRY_BODY_FRONT_VIEW, TicketDocumentName.LORRY_BODY_FRONT_VIEW), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.LORRY_BODY_BACK_VIEW, TicketDocumentName.LORRY_BODY_BACK_VIEW), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.LORRY_BODY_SIDE_VIEW, TicketDocumentName.LORRY_BODY_SIDE_VIEW), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.COMPANY_DRIVER_LICENSE_FRONT, TicketDocumentName.COMPANY_DRIVER_LICENSE_FRONT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj17, TicketDocument.COMPANY_DRIVER_LICENSE_BACK, TicketDocumentName.COMPANY_DRIVER_LICENSE_BACK), _obj17);
var _obj18;
var TicketDocumentText = (_obj18 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.SUPPORTING_DOC, "Supporting Documents"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.EWAY_BILL, "Eway Bill"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.SHOP_IMAGE, "Shop Image"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.AADHAAR_FRONT, "Front image of aadhaar"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.AADHAAR_BACK, "Back image of aadhaar"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.AADHAAR_SELFIE, "Selfie"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.GST_CERTIFICATE, "GST Certificate"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.MSME_CERTIFICATE, "MSME Certificate"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.GUMASTA_LICENSE, "Gumasta License"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.TRADE_LICENSE, "Trade License"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.RC_VALIDATION, "RC Validation"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.POD, "POD"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.RC_DOCUMENT, "RC Document"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.LORRY_FITNESS, "Lorry Fitness"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.TDS, "TDS"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.DRIVER_LICENSE, "Driver License"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.VEHICLE_INSURANCE, "Vehicle Insurance"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.DRIVER_AADHAAR, "Driver Aadhaar"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.VEHICLE_OWNER_AADHAAR, "Vehicle Owner Aadhaar"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.LORRY_RECEIPT, "Lorry Receipt"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.GOODS_INVOICE, "Goods Invoice"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.LORRY_BODY_FRONT_VIEW, "Front View"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.LORRY_BODY_BACK_VIEW, "Back View"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.LORRY_BODY_SIDE_VIEW, "Side View"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.COMPANY_DRIVER_LICENSE_FRONT, "Front View"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj18, TicketDocument.COMPANY_DRIVER_LICENSE_BACK, "Back View"), _obj18);
var TicketStatusFilterValue;
(function(TicketStatusFilterValue) {
    TicketStatusFilterValue["ALL"] = "";
    TicketStatusFilterValue[TicketStatusFilterValue["PENDING"] = 0] = "PENDING";
    TicketStatusFilterValue[TicketStatusFilterValue["ACCEPTED"] = 1] = "ACCEPTED";
    TicketStatusFilterValue[TicketStatusFilterValue["PhysicalVerification"] = 3] = "PhysicalVerification";
    TicketStatusFilterValue[TicketStatusFilterValue["FosVerified"] = 5] = "FosVerified";
    TicketStatusFilterValue[TicketStatusFilterValue["REJECTED"] = 999] = "REJECTED";
})(TicketStatusFilterValue || (TicketStatusFilterValue = {}));
var SubscriptionPlan;
(function(SubscriptionPlan) {
    SubscriptionPlan[SubscriptionPlan["SHIPPER"] = 1] = "SHIPPER";
    SubscriptionPlan[SubscriptionPlan["TRUCKER"] = 2] = "TRUCKER";
    SubscriptionPlan[SubscriptionPlan["TRANSPORTER"] = 3] = "TRANSPORTER";
})(SubscriptionPlan || (SubscriptionPlan = {}));
var _obj19;
var SubscriptionPlanText = (_obj19 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj19, SubscriptionPlan.SHIPPER, "Shipper"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj19, SubscriptionPlan.TRUCKER, "Trucker"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj19, SubscriptionPlan.TRANSPORTER, "Transporter"), _obj19);
var TicketCallMeBackStatus;
(function(TicketCallMeBackStatus) {
    TicketCallMeBackStatus["ALL"] = "All";
    TicketCallMeBackStatus["NEW"] = "New";
    TicketCallMeBackStatus["CLOSE"] = "Closed";
})(TicketCallMeBackStatus || (TicketCallMeBackStatus = {}));
var TableColumnName = {
    dateTime: {
        name: "dateTime",
        displayName: "Date & Time"
    },
    userProfile: {
        name: "userProfile",
        displayName: "User Profile"
    },
    status: {
        name: "status",
        displayName: "Status"
    },
    billNumber: {
        name: "billNumber",
        displayName: "E-way Bill Number"
    },
    lorryNumber: {
        name: "lorryNumber",
        displayName: "Lorry Number"
    },
    documentStatus: {
        name: "documentStatus",
        displayName: "Documents Status"
    },
    viewDocument: {
        name: "viewDocument",
        displayName: "View Documents"
    },
    actionNdRemarks: {
        name: "actionNdRemarks",
        displayName: "Action & Remarks"
    },
    reason: {
        name: "reason",
        displayName: "Reason"
    },
    refundRequestDateAndTime: {
        name: "dateTime",
        displayName: "Date & Time"
    },
    refundRequestedBy: {
        name: "refundRequestedBy",
        displayName: "Requested By"
    },
    refundRequestedFrom: {
        name: "refundRequestedFrom",
        displayName: "Requested From"
    },
    refundDetails: {
        name: "refundDetails",
        displayName: "Details"
    },
    refundStatusAndAction: {
        name: "refundStatusAndAction",
        displayName: "Updates"
    },
    vasLeadDetails: {
        name: "vasLeadDetails",
        displayName: "Details"
    },
    actionSlot: {
        name: "actionSlot",
        displayName: "action"
    },
    updatedBy: {
        name: "updatedBy",
        displayName: "Updated By"
    },
    source: {
        displayName: "Source",
        name: "source"
    },
    remarks: {
        displayName: "Remarks",
        name: "remarks"
    },
    misc: {
        displayName: "Misc",
        name: "misc"
    }
};
var LoadTicketType;
(function(LoadTicketType) {
    LoadTicketType[LoadTicketType["VERIFICATION"] = 20] = "VERIFICATION";
    LoadTicketType[LoadTicketType["FULFILLMENT"] = 21] = "FULFILLMENT";
    LoadTicketType[LoadTicketType[// VERIFIED_2 = 22,
    "PP_PLACEMENT"] = 27] = "PP_PLACEMENT";
    LoadTicketType[LoadTicketType["PP_LOADING"] = 28] = "PP_LOADING";
    LoadTicketType[LoadTicketType["PP_UNLOADING"] = 29] = "PP_UNLOADING";
})(LoadTicketType || (LoadTicketType = {}));
var LoadTicketTypeList = [
    LoadTicketType.VERIFICATION,
    LoadTicketType.FULFILLMENT,
    LoadTicketType.PP_PLACEMENT,
    LoadTicketType.PP_LOADING,
    LoadTicketType.PP_UNLOADING
];
var _obj20;
var LoadTicketTypeToAgentTypeNameMap = (_obj20 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj20, LoadTicketType.VERIFICATION, "Verification"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj20, LoadTicketType.FULFILLMENT, "Fulfillment"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj20, LoadTicketType.PP_PLACEMENT, "PP Placement"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj20, LoadTicketType.PP_LOADING, "PP Loading"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj20, LoadTicketType.PP_UNLOADING, "PP Unloading"), _obj20);
var _obj21;
var LoadTicketTypeToNameMap = (_obj21 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj21, LoadTicketType.VERIFICATION, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.loadVerification */ .R.loadVerification), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj21, LoadTicketType.FULFILLMENT, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.loadFulfillment */ .R.loadFulfillment), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj21, LoadTicketType.PP_PLACEMENT, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppPlacement */ .R.ppPlacement), _obj21);
var _obj22;
var LoadTicketNameToTypeMap = (_obj22 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.loadVerification */ .R.loadVerification, LoadTicketType.VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.loadVerificationAdmin */ .R.loadVerificationAdmin, LoadTicketType.VERIFICATION), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.loadFulfillment */ .R.loadFulfillment, LoadTicketType.FULFILLMENT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.assuredLoads */ .R.assuredLoads, LoadTicketType.FULFILLMENT), // Post Placement
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppAllLoad */ .R.ppAllLoad, undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppPlacement */ .R.ppPlacement, LoadTicketType.PP_PLACEMENT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppLoading */ .R.ppLoading, LoadTicketType.PP_LOADING), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppUnloading */ .R.ppUnloading, LoadTicketType.PP_UNLOADING), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppCompleted */ .R.ppCompleted, undefined), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj22, _vahak_core_dist_constants_admin_screenId__WEBPACK_IMPORTED_MODULE_0__/* .ScreenId.ppCancelled */ .R.ppCancelled, undefined), _obj22);
var DispositionSourceScreen = {
    LOAD_LIST: "load-list",
    LORRY_LIST: "lorry-list",
    TSO_LOAD: "tso-load",
    TSO_LORRY: "tso-lorry"
};
var CancelLoadBidDInstantOptionNameWithValue = {
    "Vahak coin": "false",
    "Same source account": "true"
};
var CancelLoadBidDInstantOptionList = Object.entries(CancelLoadBidDInstantOptionNameWithValue).map(function(param) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
    return (0,_methods_uiUtil__WEBPACK_IMPORTED_MODULE_3__/* .generateSelectOption */ .Ow)(key, value);
});


/***/ }),

/***/ 47355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProfileVerificationLevel_ProfileVerificationLevel; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core/dist/icons/up_verified_profile.svg
var up_verified_profile = __webpack_require__(78888);
;// CONCATENATED MODULE: ../core/dist/icons/aadhar_verified.svg
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAadharVerified(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url()"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M16.103 13.356a10.093 10.093 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8c-.148.051-.303.078-.459.08h-.016a1.462 1.462 0 01-.476-.082 12.622 12.622 0 01-4.72-2.8 10.073 10.073 0 01-2.407-3.76A21.717 21.717 0 01.02 5.447v-.036c.009-.194.015-.4.018-.622a2.122 2.122 0 011.996-2.077 8.203 8.203 0 005.59-2.36l.008-.01a1.277 1.277 0 011.736 0l.015.011a8.205 8.205 0 005.59 2.36 2.114 2.114 0 011.996 2.077c0 .226.01.43.018.622v.015a21.753 21.753 0 01-.884 7.93z",
    fill: "#FFD686"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.103 13.356a10.091 10.091 0 01-2.413 3.765 12.622 12.622 0 01-4.714 2.8 1.44 1.44 0 01-.458.081V-.004c.315.004.618.126.85.34l.013.012a8.205 8.205 0 005.59 2.36 2.115 2.115 0 011.996 2.077c0 .226.01.429.018.622v.019a21.755 21.755 0 01-.882 7.93z",
    fill: "#FEB72C"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.282 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.073 1.706H8.5a5.777 5.777 0 01-4.088-1.697 5.798 5.798 0 010-8.191A5.777 5.777 0 018.5 4.207h.02c1.53.007 2.994.62 4.074 1.706A5.805 5.805 0 0114.282 10z",
    fill: "#fff"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M14.281 10a5.805 5.805 0 01-1.689 4.086 5.784 5.784 0 01-4.072 1.706V4.209c1.529.007 2.993.62 4.072 1.705A5.805 5.805 0 0114.281 10z",
    fill: "#E0E9FF"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M11.478 8.989l-2.942 2.949-.636.637a.769.769 0 01-1.088 0l-1.368-1.37a.772.772 0 01.548-1.302c.2-.003.395.074.54.212l.824.825 3.035-3.041a.769.769 0 011.3.55.772.772 0 01-.212.54z",
    fill: "#FEB72C"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "aadhar_verified_svg__clip0"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v20H0z"
  })))));
}

/* harmony default export */ var aadhar_verified = (SvgAadharVerified);
// EXTERNAL MODULE: ../core/dist/icons/GST_verified.svg
var GST_verified = __webpack_require__(66740);
;// CONCATENATED MODULE: ../core/dist/icons/Bank_Verified.svg
var _rect, _path, _path2;

function Bank_Verified_extends() { Bank_Verified_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Bank_Verified_extends.apply(this, arguments); }



function SvgBankVerified(props) {
  return /*#__PURE__*/react.createElement("svg", Bank_Verified_extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    x: 0.023,
    y: 0.003,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#0EA546"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.388 2.639A9 9 0 012.66 15.367L15.388 2.639z",
    fill: "#027B2F"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.33 6.543a.257.257 0 00-.172-.058h-1.285a2.07 2.07 0 00-.481-.92h1.75c.071 0 .129-.02.174-.058a.185.185 0 00.067-.147v-.652a.185.185 0 00-.067-.147.259.259 0 00-.173-.057H5.889c-.07 0-.128.019-.173.057a.185.185 0 00-.068.147v.85c0 .056.024.104.072.144.047.04.104.06.169.06h1.09c1.057 0 1.729.242 2.014.723H5.89c-.07 0-.128.02-.173.058a.185.185 0 00-.068.147v.652c0 .06.023.108.068.147a.257.257 0 00.173.057h3.21c-.11.35-.367.616-.77.8-.404.182-.937.274-1.598.274h-.842a.253.253 0 00-.17.06.183.183 0 00-.07.145v.811c0 .056.022.103.067.141.962.87 2.21 2.086 3.743 3.65a.238.238 0 00.188.077h1.466c.105 0 .178-.039.218-.115.05-.077.04-.15-.03-.218-1.463-1.525-2.613-2.667-3.45-3.426.852-.085 1.543-.32 2.074-.703.532-.383.855-.882.97-1.496h1.263c.07 0 .128-.019.173-.057a.184.184 0 00.067-.147V6.69a.184.184 0 00-.067-.147z",
    fill: "#fff"
  })));
}

/* harmony default export */ var Bank_Verified = (SvgBankVerified);
// EXTERNAL MODULE: ../core/dist/icons/VahakMember.svg
var VahakMember = __webpack_require__(4269);
;// CONCATENATED MODULE: ./components/admin/ticket-system/common/ProfileVerificationLevel/ProfileVerificationLevel.tsx



// Icons





var ProfileVerificationLevel = function(param) {
    var isBankVerified = param.isBankVerified, isAadhaarVerified = param.isAadhaarVerified, isGSTVerified = param.isGSTVerified, isMember = param.isMember;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
        gap: 5,
        alignItems: "center",
        children: [
            isGSTVerified && isAadhaarVerified && !isMember ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: "aadhaar and gst verified",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(up_verified_profile/* default */.Z, {})
            }) : isGSTVerified && !isAadhaarVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: "only gst verified",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GST_verified/* default */.Z, {})
            }) : !isGSTVerified && isAadhaarVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: "only aadhaar verified",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(aadhar_verified, {})
            }) : null,
            isBankVerified ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: "bank details available",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bank_Verified, {})
            }) : null,
            isMember ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                title: "Vahak Membership taken",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakMember/* default */.Z, {})
            }) : null
        ]
    });
};
/* harmony default export */ var ProfileVerificationLevel_ProfileVerificationLevel = (ProfileVerificationLevel);


/***/ }),

/***/ 9485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94897);




// constants

var TextLabelAndValue = function(param) {
    var label = param.label, value = param.value, _boldWeight = param.boldWeight, boldWeight = _boldWeight === void 0 ? true : _boldWeight, _preWrapValue = param.preWrapValue, preWrapValue = _preWrapValue === void 0 ? false : _preWrapValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        gap: 5,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].GREY_1000 */ .Z.GREY_1000,
                size: "s",
                lineHeight: "24px",
                weight: "medium",
                children: label
            }),
            ":",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                flex: 1,
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    weight: boldWeight ? "bold" : "regular",
                    preWrap: preWrapValue,
                    children: value
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextLabelAndValue);


/***/ }),

/***/ 25688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ assured_load_AssuredLoadStatus; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/assured-load/AssuredLoadStatus.module.scss
var AssuredLoadStatus_module = __webpack_require__(21711);
var AssuredLoadStatus_module_default = /*#__PURE__*/__webpack_require__.n(AssuredLoadStatus_module);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ./components/assured-load/tap-n-go-timer/TapNgoTimer.tsx
var TapNgoTimer = __webpack_require__(35053);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ./components/assured-load/how-it-works/HowItWorksBtn.tsx + 2 modules
var HowItWorksBtn = __webpack_require__(76136);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core/dist/constants/userScreenId.js
var userScreenId = __webpack_require__(98606);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./context/payment-context.tsx
var payment_context = __webpack_require__(83927);
// EXTERNAL MODULE: ../core/dist/standard-icons/payment-coin.svg
var payment_coin = __webpack_require__(95211);
// EXTERNAL MODULE: ./components/marketplace/load-bid-form-new/bid-form/assured-load/PaymentBtn.module.scss
var PaymentBtn_module = __webpack_require__(94816);
var PaymentBtn_module_default = /*#__PURE__*/__webpack_require__.n(PaymentBtn_module);
;// CONCATENATED MODULE: ./components/marketplace/load-bid-form-new/bid-form/assured-load/PaymentBtn.tsx


// Components

// Constants



// Methods

// Hooks


// Assets


var PaymentBtn = function(param) {
    var bookingAmount = param.bookingAmount, closeBidForm = param.closeBidForm, bookingData = param.bookingData, redirection = param.redirection, paymentType = param.paymentType, trackEvent = param.trackEvent;
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var updatePaymentData = (0,payment_context/* usePayment */.V)().updatePaymentData;
    var router = (0,next_router.useRouter)();
    var currentPath = router.asPath;
    var redirectToCurrentPage = function() {
        router.replace(currentPath, undefined, {
            shallow: true
        });
    };
    var handleRedirection = redirection || redirectToCurrentPage;
    var onAction = function(e) {
        e.stopPropagation();
        closeBidForm === null || closeBidForm === void 0 ? void 0 : closeBidForm();
        updatePaymentData === null || updatePaymentData === void 0 ? void 0 : updatePaymentData({
            type: paymentType,
            allowCoinUse: true,
            bidBookingInfo: bookingData,
            onClickBack: handleRedirection,
            postFailure: handleRedirection,
            postSuccess: handleRedirection,
            onSuccess: function() {
                trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* AssuredLoadEvents.payment_success */.zH.payment_success);
            }
        });
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* AssuredLoadEvents.payment_pay_now_btn */.zH.payment_pay_now_btn);
        router === null || router === void 0 ? void 0 : router.push(userScreenId/* UserScreenId.payment.pathname */.B.payment.pathname, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (PaymentBtn_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            "data-assured-payment-btn": true,
            onClick: onAction,
            disabled: !(bookingData === null || bookingData === void 0 ? void 0 : bookingData.bid_id) || isCsDashboardUser,
            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_coin/* default */.Z, {}),
                    "Pay ",
                    (0,methods/* getPriceString */.Bn)(bookingAmount)
                ]
            }),
            children: null
        })
    });
};
/* harmony default export */ var assured_load_PaymentBtn = (PaymentBtn);

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/auth/company-registration-form/Helpdesk/Helpdesk.tsx + 1 modules
var Helpdesk = __webpack_require__(91173);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ./components/assured-load/helpdesk-wrapper/AssuredHelpDesk.module.scss
var AssuredHelpDesk_module = __webpack_require__(73625);
var AssuredHelpDesk_module_default = /*#__PURE__*/__webpack_require__.n(AssuredHelpDesk_module);
// EXTERNAL MODULE: ./services/useRequestCallBack.tsx
var useRequestCallBack = __webpack_require__(86259);
;// CONCATENATED MODULE: ./components/assured-load/helpdesk-wrapper/AssuredHelpDesk.tsx



// Components

// Constants

// Methods
// Hooks

// Assets


// to delete
var AssuredHelpDesk = function(param) {
    var responsive = param.responsive, callBackSrc = param.callBackSrc;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    }) && responsive;
    var ref = (0,useRequestCallBack/* default */.Z)({
        src: callBackSrc
    }), CallBackForm = ref.CallBackForm, openCallBackReqModal = ref.openCallBackReqModal;
    var handleClick = function() {
        openCallBackReqModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((AssuredHelpDesk_module_default()).main, responsive && (AssuredHelpDesk_module_default()).responsive),
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helpdesk/* default */.Z, {
                bgColor: "transparent",
                faceColor: colors/* default.BLUE */.Z.BLUE,
                showLabel: !isMobileScreen,
                onClick: handleClick
            }),
            CallBackForm
        ]
    });
};
/* harmony default export */ var helpdesk_wrapper_AssuredHelpDesk = (AssuredHelpDesk);

// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ./services/vas/useGeneratePayment.ts
var useGeneratePayment = __webpack_require__(95150);
// EXTERNAL MODULE: ./components/admin/ticket-system-helper/assuredLoad.ts
var assuredLoad = __webpack_require__(3533);
// EXTERNAL MODULE: ./methods/time.ts
var time = __webpack_require__(72397);
;// CONCATENATED MODULE: ../core/dist/icons/bell.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgBell(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M33.27 26.43a9.675 9.675 0 01-3.437-7.403V15c0-5.083-3.776-9.29-8.667-9.996v-1.56a1.444 1.444 0 10-2.889 0v1.56C13.385 5.71 9.611 9.917 9.611 15v4.027a9.685 9.685 0 01-3.45 7.414 2.523 2.523 0 00-.884 1.92 2.53 2.53 0 002.528 2.528H31.64a2.53 2.53 0 002.527-2.528c0-.74-.322-1.439-.897-1.931zM19.721 36.667a5.425 5.425 0 005.307-4.334H14.414a5.425 5.425 0 005.307 4.334z",
    fill: "#000"
  })));
}

/* harmony default export */ var bell = (SvgBell);
// EXTERNAL MODULE: ../core/dist/icons/GreenBackgroundSolidWhiteTick.svg
var GreenBackgroundSolidWhiteTick = __webpack_require__(95825);
;// CONCATENATED MODULE: ./components/assured-load/AssuredLoadStatus.tsx





// Components











// Methods

// Hooks
// Assets



var AssuredLoadStatus = function(param) {
    var meta = param.meta, cId = param.cId, source = param.source, workingListType = param.workingListType, wrapperClassName = param.wrapperClassName, trackEvent = param.trackEvent;
    var bookingInfo = {};
    var isTapNgo = meta === null || meta === void 0 ? void 0 : meta.is_tap_n_go;
    var isSpot = meta === null || meta === void 0 ? void 0 : meta.is_spot_load;
    if (isTapNgo) {
        var ref;
        bookingInfo = (ref = meta === null || meta === void 0 ? void 0 : meta.tap_n_go_info) !== null && ref !== void 0 ? ref : {};
    } else if (isSpot) {
        var ref1;
        bookingInfo = (ref1 = meta === null || meta === void 0 ? void 0 : meta.spot_load_info) !== null && ref1 !== void 0 ? ref1 : {};
    }
    var _load_owner_timer_duration = bookingInfo.load_owner_timer_duration, load_owner_timer_duration = _load_owner_timer_duration === void 0 ? 0 : _load_owner_timer_duration, _lorry_owner_timer_duration = bookingInfo.lorry_owner_timer_duration, lorry_owner_timer_duration = _lorry_owner_timer_duration === void 0 ? 0 : _lorry_owner_timer_duration, is_load_owner_paid = bookingInfo.is_load_owner_paid, _timer_duration = bookingInfo.timer_duration, timer_duration = _timer_duration === void 0 ? 0 : _timer_duration;
    var need2PayBalance = (bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_token_paid) && is_load_owner_paid && !(bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_balance_paid);
    var isLorryOwnerPaid = (bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_balance_paid) || (bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_paid);
    var _updated_at_timestamp = meta.updated_at_timestamp, updated_at_timestamp = _updated_at_timestamp === void 0 ? 0 : _updated_at_timestamp, bid_status = meta.bid_status, loadCid = meta.loadCid, lorryCid = meta.lorryCid;
    var timeLeft = 0;
    var showPaymentBtn = false;
    var descText = null;
    var leftIcon = null;
    var bottomTextHighlight = null;
    var isLoadView = cId === loadCid;
    var isLorryView = cId === lorryCid;
    var lorryAmount = need2PayBalance ? bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.lorry_owner_remaining_amount : bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.lorry_owner_booking_amount;
    var bookingData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, meta === null || meta === void 0 ? void 0 : meta.bookingOrderInfo), {
        bid_id: meta === null || meta === void 0 ? void 0 : meta.bidId,
        load_id: meta === null || meta === void 0 ? void 0 : meta.loadId,
        booking_for: (0,useGeneratePayment/* getRequiredBookingForType */.xw)({
            isTapNGo: meta === null || meta === void 0 ? void 0 : meta.is_tap_n_go,
            isSpot: meta === null || meta === void 0 ? void 0 : meta.is_spot_load,
            isTokenFlow: !!(bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_token_paid),
            isTokenPaid: bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_token_paid,
            isBalancePaid: bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.is_lorry_owner_balance_paid
        }),
        amount: isLoadView ? bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.load_owner_booking_amount : lorryAmount
    });
    var getPaymentBtn = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(assured_load_PaymentBtn, {
            trackEvent: trackEvent,
            bookingAmount: bookingData === null || bookingData === void 0 ? void 0 : bookingData.amount,
            bookingData: bookingData,
            paymentType: isLoadView ? "assured-security-deposit" : "assured-booking-amount"
        });
    };
    var HowItWorkSlot = !!workingListType && /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksBtn/* default */.Z, {
        workingListType: workingListType,
        responsive: true
    });
    var HelpSlot = /*#__PURE__*/ (0,jsx_runtime.jsx)(helpdesk_wrapper_AssuredHelpDesk, {
        responsive: true,
        callBackSrc: "assured"
    });
    if (isTapNgo && bid_status === bidStatus/* BID_STATUS.WAITING */.UE.WAITING && (isLoadView || !isLorryView)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((AssuredLoadStatus_module_default()).waitingAction, source && (AssuredLoadStatus_module_default())[source]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (AssuredLoadStatus_module_default()).iconWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bell, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            size: "s",
                            mSize: "xs",
                            weight: "semibold",
                            children: "Waiting for acceptance from lorry owner"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (AssuredLoadStatus_module_default()).misc,
                    children: HowItWorkSlot
                })
            ]
        });
    }
    var getTapNGoLoadStatus = function() {
        if (isTapNgo) {
            switch(bid_status){
                case bidStatus/* BID_STATUS.STAND_BY */.UE.STAND_BY:
                    {
                        timeLeft = (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + lorry_owner_timer_duration);
                        if (isLorryView) {
                            showPaymentBtn = isLorryView;
                            bottomTextHighlight = /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: colors/* default.ORANGE */.Z.ORANGE,
                                size: "xs",
                                mSize: "xs",
                                children: "*Amount will be refunded if Shipper doesn’t confirm"
                            });
                            descText = /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                                timerTemplate: "Pay your Booking amount in [timer] to confirm your lorry",
                                timeLeft: timeLeft,
                                active: true
                            });
                        } else {
                            leftIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenBackgroundSolidWhiteTick/* default */.Z, {});
                            descText = /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                                timerTemplate: "Lorry owner agreed the fixed price, please wait until lorry owner pays the booking amount in [timer]",
                                timeLeft: timeLeft,
                                active: true
                            });
                        }
                        break;
                    }
                case bidStatus/* BID_STATUS.PARTIALLY_ACCEPTED */.UE.PARTIALLY_ACCEPTED:
                    {
                        timeLeft = (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + load_owner_timer_duration);
                        leftIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenBackgroundSolidWhiteTick/* default */.Z, {});
                        if (isLoadView) {
                            showPaymentBtn = isLoadView;
                            descText = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: colors/* default.GREEN_700 */.Z.GREEN_700,
                                        children: "Lorry owner confirmed the booking, "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                                        timerTemplate: " pay your security deposit in [timer]",
                                        timeLeft: timeLeft,
                                        active: true
                                    })
                                ]
                            });
                        } else {
                            bottomTextHighlight = /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: colors/* default.ORANGE */.Z.ORANGE,
                                size: "xs",
                                mSize: "xs",
                                children: "*Amount will be refunded if Shipper doesn’t confirm"
                            });
                            descText = /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                                timerTemplate: "Waiting for the shipper to confirm booking. We will notify you once booking is confirmed in [timer]",
                                timeLeft: timeLeft,
                                active: true
                            });
                        }
                        break;
                    }
                case bidStatus/* BID_STATUS.IN_TRANSIT */.UE.IN_TRANSIT:
                    {
                        if (need2PayBalance) {
                            timeLeft = (0,time/* getSecondsLeftFromNow */.Js)((bookingInfo === null || bookingInfo === void 0 ? void 0 : bookingInfo.balance_payment_deadline) || 0);
                            if (isLorryView) {
                                showPaymentBtn = isLorryView;
                                descText = /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                                    timerTemplate: "Pay remaining amount in [timer] to confirm this load",
                                    timeLeft: timeLeft,
                                    active: true
                                });
                            } else {
                            // leftIcon = <GreenTick />;
                            // descText = (
                            //     <TapNgoTimer
                            //         timerTemplate={
                            //             "Lorry owner agreed the fixed price, please wait until lorry owner pays the booking amount in [timer]"
                            //         }
                            //         timeLeft={timeLeft}
                            //         active
                            //     />
                            // );
                            }
                        }
                        break;
                    }
            }
        } else if (isSpot) {
            if (assuredLoad/* AssuredBidStatusList.includes */.t.includes(bid_status)) {
                var is3rdPersonView = ![
                    loadCid,
                    lorryCid
                ].includes(cId);
                if (!isLorryOwnerPaid && !is_load_owner_paid && is3rdPersonView) {
                    timeLeft = (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + timer_duration);
                    descText = /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                        timerTemplate: "Booking amount not paid [timer]",
                        timeLeft: timeLeft,
                        active: true
                    });
                } else if (isLorryView || is3rdPersonView) {
                    showPaymentBtn = isLorryView && !isLorryOwnerPaid;
                    bottomTextHighlight = isLorryView && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: colors/* default.ORANGE */.Z.ORANGE,
                        size: "xs",
                        mSize: "xs",
                        children: "*Amount will be refunded if Shipper doesn’t confirm"
                    });
                    leftIcon = isLorryOwnerPaid && /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenBackgroundSolidWhiteTick/* default */.Z, {});
                    descText = isLorryOwnerPaid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                        timerTemplate: "Waiting for the shipper to confirm booking. We will notify you once booking is confirmed in [timer]",
                        timeLeft: (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + load_owner_timer_duration),
                        active: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                        timerTemplate: "Pay your Booking amount in [timer] to confirm your lorry",
                        timeLeft: (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + lorry_owner_timer_duration),
                        active: true
                    });
                } else {
                    leftIcon = is_load_owner_paid && /*#__PURE__*/ (0,jsx_runtime.jsx)(GreenBackgroundSolidWhiteTick/* default */.Z, {});
                    showPaymentBtn = isLoadView && !is_load_owner_paid;
                    descText = is_load_owner_paid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                        timerTemplate: "Lorry owner agreed the fixed price, please wait until lorry owner pays the booking amount in [timer]",
                        timeLeft: (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + lorry_owner_timer_duration),
                        active: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TapNgoTimer/* default */.Z, {
                        timerTemplate: "Pay your security deposit in [timer]",
                        timeLeft: (0,time/* getSecondsLeftFromNow */.Js)(updated_at_timestamp + load_owner_timer_duration),
                        active: true
                    });
                }
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((AssuredLoadStatus_module_default()).wrapper, wrapperClassName, source && (AssuredLoadStatus_module_default())[source]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (AssuredLoadStatus_module_default()).desc,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                            alignItems: "flex-start",
                            gap: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                    width: 16,
                                    height: 16,
                                    gap: "5px",
                                    children: leftIcon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    size: "s",
                                    mSize: "xs",
                                    weight: "semibold",
                                    children: descText
                                })
                            ]
                        }),
                        bottomTextHighlight
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((AssuredLoadStatus_module_default()).action),
                    children: [
                        HowItWorkSlot,
                        HelpSlot,
                        showPaymentBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (AssuredLoadStatus_module_default()).payment,
                            children: getPaymentBtn()
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AssuredLoadStatus_module_default()).main,
        children: getTapNGoLoadStatus()
    });
};
/* harmony default export */ var assured_load_AssuredLoadStatus = (AssuredLoadStatus);


/***/ }),

/***/ 12100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _AppRedirectPayBtn_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3945);
/* harmony import */ var _AppRedirectPayBtn_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_AppRedirectPayBtn_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _vahak_core_dist_standard_icons_payment_coin_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95211);
/* harmony import */ var _vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32450);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4628);






var AppRedirectPayBtn = function(param) {
    var fullWidth = param.fullWidth, type = param.type;
    var setShowAppRedirectionPopup = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il).setShowAppRedirectionPopup;
    var showAppRedirectionModal = function() {
        setShowAppRedirectionPopup === null || setShowAppRedirectionPopup === void 0 ? void 0 : setShowAppRedirectionPopup(true, {
            body: "Please download the app to continue your transaction"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_AppRedirectPayBtn_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            width: fullWidth ? "100%" : 120,
            onClick: function(e) {
                e.stopPropagation();
                showAppRedirectionModal === null || showAppRedirectionModal === void 0 ? void 0 : showAppRedirectionModal();
            },
            mSize: "s",
            children: [
                type === "pay" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_payment_coin_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                        "Pay now"
                    ]
                }),
                type === "receive" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: "Receive payment"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppRedirectPayBtn);


/***/ }),

/***/ 76136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ how_it_works_HowItWorksBtn; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ./components/utils/app-link/AppLink.tsx
var AppLink = __webpack_require__(92477);
// EXTERNAL MODULE: ../core-ui/dist/components/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(48953);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ./components/assured-load/how-it-works/modal/Working.module.scss
var Working_module = __webpack_require__(10303);
var Working_module_default = /*#__PURE__*/__webpack_require__.n(Working_module);
;// CONCATENATED MODULE: ../core/dist/icons/assured-step-arrow.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAssuredStepArrow(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M2.762 1.46a.751.751 0 00-1.31-.733l1.31.733zm31.253 31.31a.748.748 0 00-.121-1.052l-5.29-4.198a.752.752 0 00-1.055.12.748.748 0 00.12 1.052l4.703 3.732-3.737 4.69a.748.748 0 00.12 1.053.752.752 0 001.056-.12l4.204-5.277zM1.452.727a5.44 5.44 0 00-.442 1.056l1.436.442c.095-.308.203-.563.316-.765L1.452.727zM.619 3.905A17.653 17.653 0 00.564 5.99l1.501-.043c-.02-.69-.002-1.33.05-1.908L.619 3.905zm.1 4.146c.077.657.182 1.337.318 2.034L2.51 9.8a26.287 26.287 0 01-.301-1.924l-1.491.174zm.776 4.031c.17.646.367 1.301.588 1.962l1.424-.475a30.175 30.175 0 01-.56-1.869l-1.452.382zm1.303 3.886c.255.622.533 1.247.836 1.869l1.35-.654a30.045 30.045 0 01-.795-1.78l-1.39.565zm1.793 3.681c.337.588.696 1.171 1.08 1.746l1.25-.83c-.364-.545-.706-1.1-1.026-1.658l-1.304.742zm2.283 3.415c.417.537.858 1.064 1.323 1.577l1.115-1.004a25.97 25.97 0 01-1.252-1.491l-1.186.918zm2.763 3.049c.494.467 1.011.92 1.552 1.355l.942-1.166a24.28 24.28 0 01-1.462-1.276l-1.032 1.087zm3.21 2.582a25.27 25.27 0 001.753 1.088l.74-1.303c-.571-.323-1.12-.665-1.649-1.024l-.844 1.239zm3.588 2.03c.614.285 1.248.55 1.903.792l.522-1.405a24.543 24.543 0 01-1.793-.746l-.632 1.36zm3.86 1.433c.648.185 1.313.35 1.997.493l.308-1.467a26.888 26.888 0 01-1.891-.466l-.413 1.44zm4.022.844a32.2 32.2 0 002.042.217l.11-1.494a30.67 30.67 0 01-1.946-.207l-.206 1.484zm4.095.308c.666.01 1.346.002 2.04-.026l-.06-1.497a36.09 36.09 0 01-1.958.025l-.022 1.498zm4.068-.157c.34-.03.685-.065 1.032-.105l-.17-1.488a41.87 41.87 0 01-.997.1l.135 1.493z",
    fill: "#333"
  })));
}

/* harmony default export */ var assured_step_arrow = (SvgAssuredStepArrow);
;// CONCATENATED MODULE: ./components/assured-load/how-it-works/modal/Working.tsx



// Components







// Constants

// Methods
// Hooks

// Assets


var Working = function(param) {
    var toggleModal = param.toggleModal, type = param.type, isTapNgoLoad = param.isTapNgoLoad, isSpotLoad = param.isSpotLoad, isPaidBookingRequired = param.isPaidBookingRequired;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var list = {
        "load-booking": [
            {
                desc: "Post load and verify through OTP",
                imgName: "/assured-load-working-10.svg"
            },
            {
                desc: "Relax while we match your load with the perfect lorry",
                imgName: "/assured-load-working-12.svg"
            },
            {
                desc: isTapNgoLoad ? "Get confirmation at your expected price or receive upto 3 counter offers from lorry owners to accept or reject" : "Receive upto 3 offers from lorry owners. Accept or reject within 30 minutes, or your load will expire",
                imgName: "/assured-load-working-13.svg"
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
        isOpen: true,
        showHeader: false,
        modalSize: "fit",
        onToggle: toggleModal,
        fullScreenSheet: true,
        renderFooter: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* VerticalFlex */.vs, {
            gap: 20,
            className: (Working_module_default()).footer,
            padding: 20,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: colors/* default.BLUE */.Z.BLUE,
                    underline: true,
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                        target: "_blank",
                        href: "/tapngo-terms-and-conditions",
                        children: "*Terms & Conditions apply"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    blockBtn: true,
                    onClick: toggleModal,
                    children: "Got it"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Working_module_default()).main,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Working_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            align: "center",
                            weight: "medium",
                            size: "l",
                            mSize: "md",
                            children: "How Vahak Assured Works?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* ModalCrossIcon */.A, {
                            onClick: toggleModal
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Working_module_default()).body,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Working_module_default()).list,
                        children: type && list[type].map(function(item, ix) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Working_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Working_module_default()).imgWrapper,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Working_module_default()).img,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], (0,_object_spread/* default */.Z)({
                                                    src: item === null || item === void 0 ? void 0 : item.imgName,
                                                    unoptimized: true
                                                }, isMobileScreen ? {
                                                    width: 200,
                                                    height: 145
                                                } : {
                                                    width: 150,
                                                    height: 110
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Working_module_default()).arrow,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(assured_step_arrow, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Working_module_default()).content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                size: "md",
                                                weight: "bold",
                                                color: colors/* default.BLUE */.Z.BLUE,
                                                children: [
                                                    "Step-",
                                                    (ix + 1).toString().padStart(2, "0")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                size: "m",
                                                mSize: "s",
                                                weight: "medium",
                                                children: item === null || item === void 0 ? void 0 : item.desc
                                            })
                                        ]
                                    })
                                ]
                            }, ix);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var modal_Working = (Working);

// EXTERNAL MODULE: ../core-ui/dist/hooks/index.js + 3 modules
var hooks = __webpack_require__(95385);
// EXTERNAL MODULE: ./components/assured-load/how-it-works/HowItWorksBtn.module.scss
var HowItWorksBtn_module = __webpack_require__(82293);
var HowItWorksBtn_module_default = /*#__PURE__*/__webpack_require__.n(HowItWorksBtn_module);
// EXTERNAL MODULE: ../core/dist/icons/info_grey.svg
var info_grey = __webpack_require__(23045);
;// CONCATENATED MODULE: ./components/assured-load/how-it-works/HowItWorksBtn.tsx





// Components





// Constants

// Methods
// Hooks


// Assets


var HowItWorksBtn = function(_param) {
    var responsive = _param.responsive, workingListType = _param.workingListType, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "responsive",
        "workingListType"
    ]);
    var ref = (0,hooks/* useToggleModalWithLocalState */.A$)(false), isModalOpen = ref.isModalOpen, toggleModal = ref.toggleModal;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    }) && responsive;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: classnames_default()((HowItWorksBtn_module_default()).main, responsive && (HowItWorksBtn_module_default()).responsive),
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: toggleModal,
                fillType: "text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                    alignItems: "center",
                    gap: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper/* default */.Z, {
                        width: 16,
                        height: 16,
                        svgFillColor: colors/* default.BLUE */.Z.BLUE,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(info_grey/* default */.Z, {}),
                            !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                size: "s",
                                color: colors/* default.BLUE */.Z.BLUE,
                                children: "\xa0 How it works"
                            })
                        ]
                    })
                })
            }),
            isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_Working, (0,_object_spread/* default */.Z)({
                type: workingListType,
                toggleModal: toggleModal
            }, restProps))
        ]
    });
};
/* harmony default export */ var how_it_works_HowItWorksBtn = (HowItWorksBtn);


/***/ }),

/***/ 35053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35169);
/* harmony import */ var _TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60054);
/* harmony import */ var _vahak_core_dist_icons_timer_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48384);
/* harmony import */ var _vahak_core_dist_methods_timer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21830);
/* harmony import */ var _methods_time__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72397);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71960);




// Components

// Hooks
// Icons

// Methods



var TapNgoTimer = function(param) {
    var timeLeft = param.timeLeft, _active = param.active, active = _active === void 0 ? true : _active, _timerTemplate = param.timerTemplate, timerTemplate = _timerTemplate === void 0 ? "[timer]" : _timerTemplate, color = param.color, size = param.size, mSize = param.mSize, weight = param.weight, timerEndCallBack = param.timerEndCallBack;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(timeLeft), time = ref[0], setTime = ref[1];
    var ref1 = (0,_methods_time__WEBPACK_IMPORTED_MODULE_6__/* .convertSecondsTime */ .tg)(time), m = ref1.m, s = ref1.s;
    var min = m.toString().padStart(2, "0");
    var sec = s.toString().padStart(2, "0");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var id;
        if (active) {
            id = (0,_vahak_core_dist_methods_timer__WEBPACK_IMPORTED_MODULE_7__/* .timer */ .H)(timeLeft, setTime);
        }
        return function() {
            clearInterval(id);
        };
    }, [
        active
    ]);
    var TimerSlot = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8___default().main), active ? (_TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : (_TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8___default().disabled)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                gap: "5px",
                width: 16,
                height: 16,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_timer_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    " ",
                    min,
                    ":",
                    sec,
                    " mins"
                ]
            })
        });
    }, [
        min,
        sec,
        active
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (time === 0 && timerEndCallBack) {
            timerEndCallBack === null || timerEndCallBack === void 0 ? void 0 : timerEndCallBack();
        }
    }, [
        time
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_TapNgoTimer_module_scss__WEBPACK_IMPORTED_MODULE_8___default().main)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            color: color,
            size: size,
            mSize: mSize,
            weight: weight,
            children: timerTemplate === null || timerTemplate === void 0 ? void 0 : timerTemplate.split("[timer]").flatMap(function(item) {
                return [
                    item,
                    TimerSlot
                ];
            }).slice(0, -1)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TapNgoTimer);


/***/ }),

/***/ 91173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Helpdesk_Helpdesk; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../core/dist/icons/callBackUs.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCallBackUs(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.703 8.369v-.617c0-2.056-.811-4.028-2.254-5.481A7.662 7.662 0 0010.01 0C7.97 0 6.013.817 4.57 2.27a7.783 7.783 0 00-2.253 5.482v.617a3.565 3.565 0 00-1.85 1.585 3.609 3.609 0 00.81 4.527 3.54 3.54 0 002.285.833h1.29a.61.61 0 00.43-.181.619.619 0 00.178-.435V8.75a.619.619 0 00-.18-.436.61.61 0 00-.432-.18h-.593v-.382a5.823 5.823 0 011.76-3.958 5.734 5.734 0 013.993-1.62c1.488 0 2.919.58 3.992 1.62a5.823 5.823 0 011.76 3.958v.381h-.59a.61.61 0 00-.432.18.619.619 0 00-.179.437v5.947c0 .163.065.32.18.436a.61.61 0 00.432.18h.274a4.252 4.252 0 01-1.429 1.774 4.206 4.206 0 01-2.132.775.914.914 0 00-.317-.52.902.902 0 00-.57-.203H9a.893.893 0 00-.84.563.913.913 0 00-.066.351v1.04a.912.912 0 00.558.846c.11.045.229.068.348.067h2.003a.883.883 0 00.584-.214.896.896 0 00.301-.548 5.567 5.567 0 003.137-1.19 5.637 5.637 0 001.899-2.783 3.557 3.557 0 002.195-1.194A3.61 3.61 0 0020 11.725a3.55 3.55 0 00-.62-2.046 3.507 3.507 0 00-1.678-1.31z"
  })));
}

/* harmony default export */ var callBackUs = (SvgCallBackUs);
// EXTERNAL MODULE: ./components/auth/company-registration-form/Helpdesk/Helpdesk.module.scss
var Helpdesk_module = __webpack_require__(91604);
var Helpdesk_module_default = /*#__PURE__*/__webpack_require__.n(Helpdesk_module);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ./components/auth/company-registration-form/Helpdesk/Helpdesk.tsx







var Helpdesk = function(param) {
    var onClick = param.onClick, id = param.id, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? colors/* default.BLUE_100 */.Z.BLUE_100 : _bgColor, _faceColor = param.faceColor, faceColor = _faceColor === void 0 ? colors/* default.GREY_600 */.Z.GREY_600 : _faceColor, _showLabel = param.showLabel, showLabel = _showLabel === void 0 ? true : _showLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-help-desk-wrapper": true,
        className: (Helpdesk_module_default()).main,
        onClick: onClick,
        id: id,
        style: {
            backgroundColor: bgColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                svgFillColor: faceColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(callBackUs, {})
            }),
            showLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                "data-help-desk-label": true,
                size: "sm",
                as: "label",
                color: faceColor,
                children: "Help"
            })
        ]
    });
};
/* harmony default export */ var Helpdesk_Helpdesk = (Helpdesk);


/***/ }),

/***/ 29979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_components_Badge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20221);
/* harmony import */ var _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69673);


// Components

// Constants

var LorryBadgeController = function(param) {
    var status = param.status, outlined = param.outlined, verificationPending = param.verificationPending;
    var renderBadge = function() {
        switch(status){
            case _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS.STAND_BY */ .un.STAND_BY:
            case _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS.ACTIVE */ .un.ACTIVE:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Badge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "active",
                        text: _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS_TEXT.ACTIVE */ .sU.ACTIVE,
                        fillType: outlined ? "grey-outline" : "contained",
                        showDot: true
                    });
                }
            case _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS.IN_TRANSIT */ .un.IN_TRANSIT:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Badge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "progress",
                        text: _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS_TEXT.IN_TRANSIT */ .sU.IN_TRANSIT,
                        fillType: outlined ? "grey-outline" : "contained",
                        showDot: true
                    });
                }
            case _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS.VERIFICATION_FAILED */ .un.VERIFICATION_FAILED:
                {
                    return verificationPending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Badge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "progress",
                        text: "Verification pending",
                        fillType: outlined ? "grey-outline" : "contained",
                        showDot: true
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Badge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "warning",
                        text: _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS_TEXT.VERIFICATION_FAILED */ .sU.VERIFICATION_FAILED,
                        fillType: outlined ? "grey-outline" : "contained",
                        showDot: true
                    });
                }
            case _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS.IN_ACTIVE */ .un.IN_ACTIVE:
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Badge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        type: "default",
                        text: _vahak_core_dist_constants_lorryStatus__WEBPACK_IMPORTED_MODULE_3__/* .LORRY_STATUS_TEXT.IN_ACTIVE */ .sU.IN_ACTIVE,
                        fillType: outlined ? "grey-outline" : "contained",
                        showDot: true
                    });
                }
            default:
                return null;
        }
    };
    return renderBadge();
};
/* harmony default export */ __webpack_exports__["Z"] = (LorryBadgeController);


/***/ }),

/***/ 29185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qS": function() { return /* binding */ getCityPageBySlug; },
  "l_": function() { return /* binding */ getCityPagePath; },
  "Zx": function() { return /* binding */ getCityPageSlugs; }
});

// UNUSED EXPORTS: CITY_PAGES, cityPagesBySlug

// EXTERNAL MODULE: ./components/lcv-route-landing/data/lcvRouteCities.ts
var lcvRouteCities = __webpack_require__(22515);
;// CONCATENATED MODULE: ./components/city/data/cityPages.manifest.json
var cityPages_manifest_namespaceObject = JSON.parse('[{"slug":"ahmedabad","hreflangLocales":["en","gu"]},{"slug":"bangalore","hreflangLocales":["en","kn"]},{"slug":"chennai","hreflangLocales":["en","ta"]},{"slug":"delhi","hreflangLocales":["en","hi"]},{"slug":"hyderabad","hreflangLocales":["en","te"]},{"slug":"jaipur","hreflangLocales":["en","hi"]},{"slug":"kolkata","hreflangLocales":["en","bn"]},{"slug":"mumbai","hreflangLocales":["en","mr"]},{"slug":"pune","hreflangLocales":["en","mr"]}]');
// EXTERNAL MODULE: ../core/src/locales/bn/lcvRouteLanding.json
var lcvRouteLanding = __webpack_require__(83596);
// EXTERNAL MODULE: ../core/src/locales/en/lcvRouteLanding.json
var en_lcvRouteLanding = __webpack_require__(84941);
// EXTERNAL MODULE: ../core/src/locales/gu/lcvRouteLanding.json
var gu_lcvRouteLanding = __webpack_require__(97621);
// EXTERNAL MODULE: ../core/src/locales/hi/lcvRouteLanding.json
var hi_lcvRouteLanding = __webpack_require__(24610);
// EXTERNAL MODULE: ../core/src/locales/kn/lcvRouteLanding.json
var kn_lcvRouteLanding = __webpack_require__(28354);
// EXTERNAL MODULE: ../core/src/locales/mr/lcvRouteLanding.json
var mr_lcvRouteLanding = __webpack_require__(42086);
// EXTERNAL MODULE: ../core/src/locales/ta/lcvRouteLanding.json
var ta_lcvRouteLanding = __webpack_require__(27285);
// EXTERNAL MODULE: ../core/src/locales/te/lcvRouteLanding.json
var te_lcvRouteLanding = __webpack_require__(48737);
;// CONCATENATED MODULE: ./components/city/data/cityLocaleSlugs.ts








var _cities, _cities1, _cities2, _cities3, _cities4, _cities5, _cities6, _cities7;
var CITY_SLUGS_BY_LOCALE = {
    bn: new Set(Object.keys((_cities = lcvRouteLanding/* cities */.cA) !== null && _cities !== void 0 ? _cities : {})),
    en: new Set(Object.keys((_cities1 = en_lcvRouteLanding/* cities */.cA) !== null && _cities1 !== void 0 ? _cities1 : {})),
    gu: new Set(Object.keys((_cities2 = gu_lcvRouteLanding/* cities */.cA) !== null && _cities2 !== void 0 ? _cities2 : {})),
    hi: new Set(Object.keys((_cities3 = hi_lcvRouteLanding/* cities */.cA) !== null && _cities3 !== void 0 ? _cities3 : {})),
    kn: new Set(Object.keys((_cities4 = kn_lcvRouteLanding/* cities */.cA) !== null && _cities4 !== void 0 ? _cities4 : {})),
    mr: new Set(Object.keys((_cities5 = mr_lcvRouteLanding/* cities */.cA) !== null && _cities5 !== void 0 ? _cities5 : {})),
    ta: new Set(Object.keys((_cities6 = ta_lcvRouteLanding/* cities */.cA) !== null && _cities6 !== void 0 ? _cities6 : {})),
    te: new Set(Object.keys((_cities7 = te_lcvRouteLanding/* cities */.cA) !== null && _cities7 !== void 0 ? _cities7 : {}))
};
function getVerifiedCityHreflangLocales(slug, hreflangLocales) {
    var ref;
    var verifiedLocales = hreflangLocales.filter(function(locale) {
        var ref;
        return (ref = CITY_SLUGS_BY_LOCALE[locale]) === null || ref === void 0 ? void 0 : ref.has(slug);
    });
    if (verifiedLocales.length > 0) {
        return verifiedLocales;
    }
    return ((ref = CITY_SLUGS_BY_LOCALE.en) === null || ref === void 0 ? void 0 : ref.has(slug)) ? [
        "en"
    ] : [
        "en"
    ];
}

;// CONCATENATED MODULE: ./components/city/data/index.ts



var defineCity = function(slug, hreflangLocales) {
    return {
        slug: slug,
        hreflangLocales: hreflangLocales,
        city: lcvRouteCities/* LCV_ROUTE_CITIES */.U[slug]
    };
};
/** City list — edit cityPages.manifest.json only. */ var CITY_PAGES = cityPages_manifest_namespaceObject.map(function(param) {
    var slug = param.slug, hreflangLocales = param.hreflangLocales;
    return defineCity(slug, getVerifiedCityHreflangLocales(slug, hreflangLocales));
});
var cityPagesBySlug = Object.fromEntries(CITY_PAGES.map(function(city) {
    return [
        city.slug,
        city
    ];
}));
var getCityPageSlugs = function() {
    return Object.keys(cityPagesBySlug);
};
var getCityPageBySlug = function(slug) {
    return cityPagesBySlug[slug];
};
var getCityPagePath = function(slug) {
    return "/city/".concat(slug);
};


/***/ }),

/***/ 20058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ DownloadAppQrModalHost; },
  "Z": function() { return /* binding */ download_app_qr_modal_DownloadAppAction; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core-ui/dist/constants/index.js
var constants = __webpack_require__(73242);
// EXTERNAL MODULE: ../core/dist/icons/close-grey.svg
var close_grey = __webpack_require__(49853);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ./components/marketplace/common/share-modal/getLoadLorryShareUrl.ts
var getLoadLorryShareUrl = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/common/download-app-qr-modal/DownloadAppQrModal.module.scss
var DownloadAppQrModal_module = __webpack_require__(92854);
var DownloadAppQrModal_module_default = /*#__PURE__*/__webpack_require__.n(DownloadAppQrModal_module);
;// CONCATENATED MODULE: ./components/common/download-app-qr-modal/DownloadAppQrModal.tsx







var DOWNLOAD_APP_QR_MODAL = {
    qrImage: "qr_download_link.png",
    title: "Scan QR code to download app",
    defaultStoreUrl: getLoadLorryShareUrl/* VahakAppDownloadLink */.Pq
};
var DownloadAppQrModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, _title = param.title, title = _title === void 0 ? DOWNLOAD_APP_QR_MODAL.title : _title, _qrSrc = param.qrSrc, qrSrc = _qrSrc === void 0 ? DOWNLOAD_APP_QR_MODAL.qrImage : _qrSrc, _qrSize = param.qrSize, qrSize = _qrSize === void 0 ? 220 : _qrSize, _overlayZIndex = param.overlayZIndex, overlayZIndex = _overlayZIndex === void 0 ? constants/* zIndexList.modal */.m7.modal + 100 : _overlayZIndex;
    if (!isOpen) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (DownloadAppQrModal_module_default()).overlay,
        style: {
            zIndex: overlayZIndex
        },
        onClick: onClose,
        role: "presentation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (DownloadAppQrModal_module_default()).dialog,
            onClick: function(event) {
                return event.stopPropagation();
            },
            role: "dialog",
            "aria-modal": "true",
            "aria-label": title,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (DownloadAppQrModal_module_default()).card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (DownloadAppQrModal_module_default()).closeBtn,
                        onClick: onClose,
                        "aria-label": "Close",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_grey/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (DownloadAppQrModal_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (DownloadAppQrModal_module_default()).title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                src: qrSrc,
                                width: qrSize,
                                height: qrSize,
                                alt: ""
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var download_app_qr_modal_DownloadAppQrModal = (DownloadAppQrModal);

;// CONCATENATED MODULE: ./components/common/download-app-qr-modal/DownloadAppAction.tsx







// TEMP: open store links on web instead of the QR modal. Set to false to restore QR flow.
var TEMP_DISABLE_QR_MODAL = true;
var modalListeners = new Set();
var downloadAppQrModalController = {
    open: function() {
        return modalListeners.forEach(function(listener) {
            return listener(true);
        });
    },
    close: function() {
        return modalListeners.forEach(function(listener) {
            return listener(false);
        });
    },
    subscribe: function(listener) {
        modalListeners.add(listener);
        return function() {
            modalListeners.delete(listener);
        };
    }
};
var DownloadAppQrModalHost = function() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        return downloadAppQrModalController.subscribe(setIsOpen);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(download_app_qr_modal_DownloadAppQrModal, {
        isOpen: isOpen,
        onClose: downloadAppQrModalController.close
    });
};
var DownloadAppAction = function(_param) {
    var children = _param.children, storeUrl = _param.storeUrl, href = _param.href, onClick = _param.onClick, className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "storeUrl",
        "href",
        "onClick",
        "className"
    ]);
    var isMobile = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var handleClick = function(event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        event.preventDefault();
        var ref;
        var url = (ref = href !== null && href !== void 0 ? href : storeUrl) !== null && ref !== void 0 ? ref : DOWNLOAD_APP_QR_MODAL.defaultStoreUrl;
        if (TEMP_DISABLE_QR_MODAL || isMobile) {
            window.open(url, "_blank", "noopener,noreferrer");
            return;
        }
        downloadAppQrModalController.open();
    };
    if (href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: href,
            className: className,
            onClick: handleClick
        }, rest), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        onClick: handleClick,
        role: "presentation"
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var download_app_qr_modal_DownloadAppAction = (DownloadAppAction);


/***/ }),

/***/ 67203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _LorryOneLineInfo_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1037);
/* harmony import */ var _LorryOneLineInfo_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LorryOneLineInfo_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14345);
/* harmony import */ var _vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49143);



// Helpers


var LorryOneLineInfo = function(param) {
    var lorryBodyType = param.lorryBodyType, lorryCapacity = param.lorryCapacity, lorrySize = param.lorrySize, lorrySizeText = param.lorrySizeText, lorryType = param.lorryType, lorryTyres = param.lorryTyres, showLorryType = param.showLorryType;
    var ref, ref1;
    var bodyText = (ref = _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .VehicleTypeBodyTypeMap.load */ .Kz.load) === null || ref === void 0 ? void 0 : (ref1 = ref[lorryType]) === null || ref1 === void 0 ? void 0 : ref1[lorryBodyType];
    var renderLorryInfo = function() {
        var nodes = [];
        if (showLorryType) {
            var lorry = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .getLorryDetailsByType */ .X9)(lorryType);
            nodes.push(lorry === null || lorry === void 0 ? void 0 : lorry.label);
        }
        switch(lorryType){
            case _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV:
                nodes.push(bodyText);
                lorrySize && nodes.push("".concat(lorrySize, " ").concat(lorrySizeText || "Ft"));
                lorryCapacity && nodes.push("".concat(lorryCapacity, " Tonne(s)"));
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    nodes: nodes
                });
            case _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .LORRY_CATEGORIES_ENUM.TANKER */ .Sv.TANKER:
                nodes.push(bodyText);
                lorryCapacity && nodes.push("".concat(lorryCapacity, " KL"));
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    nodes: nodes
                });
            case _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .LORRY_CATEGORIES_ENUM.CONTAINER */ .Sv.CONTAINER:
                lorrySize && nodes.push("".concat(lorrySize, " ").concat(lorrySizeText || "Ft"));
                lorryCapacity && nodes.push("".concat(lorryCapacity, " Tonne(s)"));
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    nodes: nodes
                });
            case _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .LORRY_CATEGORIES_ENUM.TRAILER */ .Sv.TRAILER:
                lorrySize && nodes.push("".concat(lorrySize, " ").concat(lorrySizeText || "Ft"));
                lorryCapacity && nodes.push("".concat(lorryCapacity, " Tonne(s)"));
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    nodes: nodes
                });
            case _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .LORRY_CATEGORIES_ENUM.HYVA */ .Sv.HYVA:
                lorryTyres && nodes.push("".concat(lorryTyres, " tyres"));
                lorryCapacity && nodes.push("".concat(lorryCapacity, " Tonne(s)"));
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    nodes: nodes
                });
            case _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_2__/* .LORRY_CATEGORIES_ENUM.TRUCK */ .Sv.TRUCK:
                nodes.push(bodyText);
                lorryTyres && nodes.push("".concat(lorryTyres, " tyres"));
                lorrySize && nodes.push("".concat(lorrySize, " Ft"));
                lorryCapacity && nodes.push("".concat(lorryCapacity, " Tonne(s)"));
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_dot_separated_DotSeparated__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    nodes: nodes,
                    wrapperClassName: (_LorryOneLineInfo_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper)
                });
        }
        return "LorryInfo";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LorryOneLineInfo_module_scss__WEBPACK_IMPORTED_MODULE_4___default().main),
        children: renderLorryInfo()
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LorryOneLineInfo);


/***/ }),

/***/ 79809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ getLorryVerificationDocumentUrlFromRcData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82066);
/* harmony import */ var _vahak_core_ui_dist_hooks_useToggleModalWithLocalState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8779);
/* harmony import */ var _services_useUploadImageService__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80590);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26513);
/* harmony import */ var _services_documentsByReferenceId_useUploadDocumentsService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41740);
/* harmony import */ var _vahak_core_ui_dist_layout_Container__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40936);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_components_Button_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48126);
/* harmony import */ var _vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9937);
/* harmony import */ var _vahak_core_ui_dist_components_FileInput__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33647);
/* harmony import */ var _vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53796);
/* harmony import */ var _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63118);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49352);
/* harmony import */ var _types_document__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(37137);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69406);
/* harmony import */ var _methods_compressImage__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(16569);




//Hooks





//Components







//Constant



//Types



var getLorryVerificationDocumentUrlFromRcData = function() {
    var rc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2;
    var ref3;
    return (ref3 = !!((ref2 = rc === null || rc === void 0 ? void 0 : (ref = rc.info) === null || ref === void 0 ? void 0 : (ref1 = ref.documents) === null || ref1 === void 0 ? void 0 : ref1.find(function(param) {
        var name = param.name;
        return name === "rcDoc";
    })) === null || ref2 === void 0 ? void 0 : ref2.url)) !== null && ref3 !== void 0 ? ref3 : "";
};
var LorryActionBar = function(param) {
    var lorryId = param.lorryId, rcDetails = param.rcDetails, trackEvent = param.trackEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_15__/* .AppContext */ .Il), companyId = ref.companyId, customerCompanyId = ref.customerCompanyId;
    var isMobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQueryClient)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), file = ref1[0], setFile = ref1[1];
    var onChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(newFile) {
            var compressedBlob;
            return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(newFile.size < 1 * 1024 * 1024)) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            setFile(newFile);
                        }
                        _ctx.next = 11;
                        break;
                    case 4:
                        if (!newFile.type.includes("pdf")) {
                            _ctx.next = 7;
                            break;
                        }
                        _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_14__/* .toast.error */ .A.error("Please upload an image");
                        return _ctx.abrupt("return");
                    case 7:
                        _ctx.next = 9;
                        return (0,_methods_compressImage__WEBPACK_IMPORTED_MODULE_20__/* .compressImageTo1MB */ .g3)(newFile);
                    case 9:
                        compressedBlob = _ctx.sent;
                        setFile(compressedBlob);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChange(newFile) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2 = (0,_vahak_core_ui_dist_hooks_useToggleModalWithLocalState__WEBPACK_IMPORTED_MODULE_4__/* .useToggleModalWithLocalState */ .A)(false), isRCUploadModalOpen = ref2.isModalOpen, toggleRCUploadModal = ref2.toggleModal;
    var ref3 = (0,_services_useUploadImageService__WEBPACK_IMPORTED_MODULE_5__/* .useUploadImageService */ .C)(), uploadImage = ref3.mutateAsync;
    var ref4 = (0,_services_documentsByReferenceId_useUploadDocumentsService__WEBPACK_IMPORTED_MODULE_7__/* .usePostDocuments */ .C)(), uploadDocuments = ref4.mutateAsync;
    var ref5 = rcDetails !== null && rcDetails !== void 0 ? rcDetails : {}, tktStatus = ref5.status, _reason = ref5.reason, reason = _reason === void 0 ? "" : _reason, _ticket_id = ref5.ticket_id, ticket_id = _ticket_id === void 0 ? 0 : _ticket_id;
    var isVerificationPending = !!getLorryVerificationDocumentUrlFromRcData(rcDetails);
    var StatusBody, MobileStatusBody;
    var onSizeError = function(err) {
        _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_14__/* .toast.error */ .A.error(err);
    };
    var onClickUploadBtn = function(e) {
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_19__/* .LorryScreenEvents.document_upload_clicked */ .xI.document_upload_clicked, {
            source_screen: "my_lorry"
        });
        toggleRCUploadModal();
    };
    var handleModalToggle = function() {
        setFile(undefined);
        toggleRCUploadModal();
    };
    var disableEventBubbling = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
    };
    var onSubmitRCFile = function() {
        uploadImage({
            file: file,
            operation: "RC"
        }, {
            onSuccess: function(res) {
                var ref;
                var ref1;
                uploadDocuments({
                    company_id: Number(customerCompanyId !== null && customerCompanyId !== void 0 ? customerCompanyId : companyId),
                    reference_id: lorryId,
                    ticket_id: ticket_id,
                    reference_type: _types_document__WEBPACK_IMPORTED_MODULE_18__/* .DocumentReferenceType.LORRY */ .yf.LORRY,
                    document_type: _types_document__WEBPACK_IMPORTED_MODULE_18__/* .DocumentType.RC_VALIDATION */ .n_.RC_VALIDATION,
                    payload: {
                        fields: [],
                        documents: [
                            {
                                name: "rcDoc",
                                url: (ref1 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.path) !== null && ref1 !== void 0 ? ref1 : ""
                            }
                        ]
                    }
                }, {
                    onSuccess: function(res) {
                        var _message;
                        _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_14__/* .toast.success */ .A.success((_message = res === null || res === void 0 ? void 0 : res.data.message) !== null && _message !== void 0 ? _message : "Document Uploaded!!");
                        handleModalToggle();
                        queryClient.invalidateQueries(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_17__/* .QueryNames.userLorries.getLorryInfoById */ ._.userLorries.getLorryInfoById);
                        queryClient.invalidateQueries(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_17__/* .QueryNames.lorrySearch */ ._.lorrySearch);
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_19__/* .LorryScreenEvents.document_uploaded */ .xI.document_uploaded, {
                            source_screen: "rc_document_verification",
                            bs_type: "rc_upload",
                            document_type: "rc"
                        });
                    },
                    onError: function(err) {
                        var ref;
                        _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_14__/* .toast.error */ .A.error((ref = err === null || err === void 0 ? void 0 : err.message) !== null && ref !== void 0 ? ref : "Something Went Wrong!!");
                    }
                });
            }
        });
    };
    switch(tktStatus){
        case _types_document__WEBPACK_IMPORTED_MODULE_18__/* .TicketStatus.REJECTED */ .mk.REJECTED:
            {
                StatusBody = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    gap: 10,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].RED */ .Z.RED,
                            weight: "bold",
                            children: "Rejected"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            weight: "medium",
                            children: [
                                reason,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            fillType: "outlined",
                            size: "s",
                            onClick: onClickUploadBtn,
                            children: "Re Upload"
                        })
                    ]
                });
                MobileStatusBody = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    justifyContent: "space-between",
                    style: {
                        backgroundColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].ORANGE_100 */ .Z.ORANGE_100
                    },
                    padding: "8px 16px",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].RED */ .Z.RED,
                            weight: "bold",
                            size: "sm",
                            children: "Rejected"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            weight: "medium",
                            size: "sm",
                            children: reason
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            fillType: "text",
                            onClick: onClickUploadBtn,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].BLUE */ .Z.BLUE,
                                weight: "bold",
                                size: "s",
                                children: "Re-Upload"
                            })
                        })
                    ]
                });
                break;
            }
        default:
            {
                StatusBody = isVerificationPending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    gap: 10,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].ORANGE_500 */ .Z.ORANGE_500,
                            weight: "bold",
                            children: "Pending"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            weight: "medium",
                            children: "Your RC bill will be verified in 3-4 days "
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    gap: 10,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            weight: "medium",
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].RED */ .Z.RED,
                            children: "Please upload RC to verify your vehicle"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            fillType: "outlined",
                            size: "s",
                            onClick: onClickUploadBtn,
                            children: "Upload RC Document"
                        })
                    ]
                });
                MobileStatusBody = isVerificationPending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    justifyContent: "space-between",
                    style: {
                        backgroundColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].ORANGE_100 */ .Z.ORANGE_100
                    },
                    padding: "8px 16px",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].ORANGE_500 */ .Z.ORANGE_500,
                            weight: "bold",
                            size: "sm",
                            children: "Pending"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            weight: "medium",
                            size: "s",
                            children: "Your RC bill will be verified in 3-4 days"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                    justifyContent: "center",
                    style: {
                        backgroundColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].BLUE_100 */ .Z.BLUE_100
                    },
                    padding: "8px 16px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        fillType: "text",
                        onClick: onClickUploadBtn,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Typography_Typography__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_16__/* ["default"].BLUE */ .Z.BLUE,
                            weight: "bold",
                            size: "sm",
                            children: "Upload RC Document"
                        })
                    })
                });
                break;
            }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            isMobileScreen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                onClick: disableEventBubbling,
                children: MobileStatusBody
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                justifyContent: "flex-end",
                style: {
                    marginTop: 20
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_layout_Container__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    onClick: disableEventBubbling,
                    style: {
                        cursor: "default"
                    },
                    children: StatusBody
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                onClick: disableEventBubbling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_11__["default"], {
                    isOpen: isRCUploadModalOpen,
                    titleText: "RC document Verification",
                    onToggle: handleModalToggle,
                    modalSize: "wide",
                    sheetBodyHeight: "none",
                    sheetBodyMinHeight: "none",
                    sheetPaddingBottom: 20,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        flexDirection: "column",
                        gap: 20,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_FileInput__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                onChange: onChange,
                                selectedFile: file,
                                ctaText: "Browse",
                                onSizeError: onSizeError,
                                fileTypes: [
                                    "JPG",
                                    "PNG",
                                    "JPEG",
                                    "PDF"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                justifyContent: "flex-end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    disabled: !file,
                                    onClick: onSubmitRCFile,
                                    children: "Submit"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LorryActionBar);


/***/ }),

/***/ 1783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lorry_card_LorryCard; },
  "if": function() { return /* binding */ getLorryPreFilledData; }
});

// UNUSED EXPORTS: generateLorryEventAttribute

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/StateList.js
var StateList = __webpack_require__(52224);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core/dist/components/grid/col/Col.js
var Col = __webpack_require__(12215);
// EXTERNAL MODULE: ../core/dist/components/grid/row/Row.js
var Row = __webpack_require__(11758);
// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
// EXTERNAL MODULE: ../core/dist/components/dot-separated/DotSeparated.js + 1 modules
var DotSeparated = __webpack_require__(49143);
// EXTERNAL MODULE: ./components/load-lorry-details/components/src-dest/SrcDest.tsx + 3 modules
var SrcDest = __webpack_require__(91049);
// EXTERNAL MODULE: ./components/badge/lorry-badge-controller/LorryBadgeController.tsx
var LorryBadgeController = __webpack_require__(29979);
// EXTERNAL MODULE: ./components/marketplace/common/expiry-pill/ExpiryPill.tsx + 2 modules
var ExpiryPill = __webpack_require__(49765);
// EXTERNAL MODULE: ./components/marketplace/common/share-modal/ShareModal.tsx + 2 modules
var ShareModal = __webpack_require__(59604);
// EXTERNAL MODULE: ./components/dashboard/list-wrapper/reactivate-load-lorry/ReactivateLoadLorry.tsx + 1 modules
var ReactivateLoadLorry = __webpack_require__(32346);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/components/Chip/index.js
var Chip = __webpack_require__(93834);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ./components/admin/IfCanAccess/IfCanAccess.tsx
var IfCanAccess = __webpack_require__(6632);
// EXTERNAL MODULE: ./components/admin/ticket-system/common/TextLabelAndValue/TextLabelAndValue.tsx
var TextLabelAndValue = __webpack_require__(9485);
// EXTERNAL MODULE: ./components/helper/StopPropagation.tsx
var StopPropagation = __webpack_require__(77845);
// EXTERNAL MODULE: ../core-ui/dist/components/Dropdown/index.js + 2 modules
var Dropdown = __webpack_require__(76304);
// EXTERNAL MODULE: ./components/assured-load/AssuredLoadStatus.tsx + 3 modules
var AssuredLoadStatus = __webpack_require__(25688);
// EXTERNAL MODULE: ./components/assured-load/app-redirection/AppRedirectPayBtn.tsx
var AppRedirectPayBtn = __webpack_require__(12100);
// EXTERNAL MODULE: ./components/dashboard/list-wrapper/lorry-list/lorry-card/LorryCard.module.scss
var LorryCard_module = __webpack_require__(39861);
var LorryCard_module_default = /*#__PURE__*/__webpack_require__.n(LorryCard_module);
// EXTERNAL MODULE: ../core/dist/icons/AngleLeftGray.svg
var AngleLeftGray = __webpack_require__(42425);
// EXTERNAL MODULE: ../core/dist/icons/share_blue.svg
var share_blue = __webpack_require__(58352);
// EXTERNAL MODULE: ../core/dist/icons/call-circle.svg
var call_circle = __webpack_require__(72020);
// EXTERNAL MODULE: ../core/dist/standard-icons/options.svg
var options = __webpack_require__(53272);
;// CONCATENATED MODULE: ../core/dist/methods/getFormattedTime.js
const getFormattedTime = (date) => {
    let convertedDate = new Date(date);
    let hours = convertedDate.getHours();
    let minutes = convertedDate.getMinutes();
    let meridiem = "AM";
    let convertedHours = hours;
    let convertedMinutes = minutes;
    if (convertedHours >= 12) {
        convertedHours = hours - 12;
        meridiem = "PM";
    }
    if (convertedHours == 0) {
        convertedHours = 12;
    }
    convertedMinutes = convertedMinutes < 10 ? "0" + convertedMinutes : convertedMinutes;
    convertedHours = convertedHours < 10 ? "0" + convertedHours : convertedHours;
    let formattedTime = convertedHours + ":" + convertedMinutes;
    formattedTime += " " + meridiem;
    return formattedTime;
};


//# sourceMappingURL=getFormattedTime.js.map

// EXTERNAL MODULE: ../core/dist/methods/formatLorryNum.js
var formatLorryNum = __webpack_require__(50788);
// EXTERNAL MODULE: ./components/common/lorry-one-line-info/LorryOneLineInfo.tsx
var LorryOneLineInfo = __webpack_require__(67203);
// EXTERNAL MODULE: ./utils/getImageNameFromURL.ts
var getImageNameFromURL = __webpack_require__(72366);
// EXTERNAL MODULE: ./methods/generataMaskUrlWithParams.ts
var generataMaskUrlWithParams = __webpack_require__(32740);
// EXTERNAL MODULE: ./components/posting/helpers/constants.ts
var constants = __webpack_require__(40607);
// EXTERNAL MODULE: ../core/dist/constants/bidStatus.js
var constants_bidStatus = __webpack_require__(71535);
// EXTERNAL MODULE: ./components/dashboard/list-wrapper/lorry-list/lorry-card/LorryActionBar/LorryActionBar.tsx
var LorryActionBar = __webpack_require__(79809);
// EXTERNAL MODULE: ./types/document.ts
var types_document = __webpack_require__(37137);
// EXTERNAL MODULE: ./constants/adminOperation.ts
var adminOperation = __webpack_require__(40223);
// EXTERNAL MODULE: ./components/EllipsisText/EllipsisText.tsx
var EllipsisText = __webpack_require__(91904);
// EXTERNAL MODULE: ./components/admin/ticket-system/common/ProfileVerificationLevel/ProfileVerificationLevel.tsx + 2 modules
var ProfileVerificationLevel = __webpack_require__(47355);
// EXTERNAL MODULE: ./components/marketplace/common/verified-pill/VerifiedPill.tsx
var VerifiedPill = __webpack_require__(12426);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
// EXTERNAL MODULE: ./components/admin/ticket-system-helper/assuredLoad.ts
var assuredLoad = __webpack_require__(3533);
// EXTERNAL MODULE: ./services/bid/usePostLoadBid.ts
var usePostLoadBid = __webpack_require__(70452);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./methods/removeSubstringWithParenthesis.ts
var removeSubstringWithParenthesis = __webpack_require__(95535);
// EXTERNAL MODULE: ../core/dist/hooks/index.js + 6 modules
var hooks = __webpack_require__(37113);
;// CONCATENATED MODULE: ./components/admin/ticket-system-helper/assured-helper.ts
function getBookingMeta(info, obj) {
    var isTapNgo = info.isTapNgo;
    if (isTapNgo) {
        return obj["tap_n_go_info"];
    } else {
        return obj["spot_load_info"];
    }
}

;// CONCATENATED MODULE: ./components/dashboard/list-wrapper/lorry-list/lorry-card/LorryCard.tsx








// Context

// Constant

























// Styles

// Icons




// Methods


// Types


















var LorryCard = function(_param) {
    var _state = _param.state, state = _state === void 0 ? misc/* ComponentState.NORMAL */.hm.NORMAL : _state, props = (0,_object_without_properties/* default */.Z)(_param, [
        "state"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var data = props.data, onCardClick = props.onCardClick, onCardClickTrackingHandler = props.onCardClickTrackingHandler, isLastCard = props.isLastCard, handleEditClick = props.handleEditClick, _showProfileInfo = props.showProfileInfo, showProfileInfo = _showProfileInfo === void 0 ? false : _showProfileInfo, onClickGetContact = props.onClickGetContact, onClickViewDocument = props.onClickViewDocument;
    var ref12 = (0,react.useContext)(app_context/* AppContext */.Il), isMobile = ref12.isMobile, customerCompanyId = ref12.customerCompanyId, companyId = ref12.companyId;
    var ref13 = (0,hooks/* useCsDashboard */.Z0)(), isCsDashboardUser = ref13.isCsDashboardUser, checkPermission = ref13.checkPermission, isDeveloper = ref13.isDeveloper;
    var ref14 = (0,react.useState)(0), activeCard = ref14[0], setActiveCard = ref14[1];
    var ref15 = (0,react.useState)(false), openShareModal = ref15[0], setOpenShareModal = ref15[1];
    var router = (0,next_router.useRouter)();
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    // Hooks
    // const { openModal, closeModal } = useHandleModalToggle(["shareModal"]);
    var isVerified = !!(data === null || data === void 0 ? void 0 : (ref = data.lorry_detail) === null || ref === void 0 ? void 0 : ref.is_verified);
    var cId = Number(customerCompanyId || companyId || 0);
    var allowEditLorryStatus = lorryStatus/* ACTION_BY_LORRY_STATUS.EDIT_LORRY.includes */.Es.EDIT_LORRY.includes(data === null || data === void 0 ? void 0 : (ref1 = data.lorry_detail) === null || ref1 === void 0 ? void 0 : ref1.status);
    var allowEditPermission = checkPermission(adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction);
    var VerificationStatus = isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
        className: (LorryCard_module_default()).verifiedPill,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedPill/* default */.Z, {})
    });
    var trackEvent = function(name, _data) {
        sendGAandMoEngageEvent({
            name: name,
            data: (0,_object_spread/* default */.Z)({
                source_screen: "my_lorry",
                from_screen: "my_lorry"
            }, generateLorryEventAttribute(data), _data)
        });
    };
    if (state === misc/* ComponentState.LOADING */.hm.LOADING) {
        return !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((LorryCard_module_default()).lorryCardContainer, (LorryCard_module_default()).loadingState),
            onClick: function() {},
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (LorryCard_module_default()).mainRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LorryCard_module_default()).lorryNumberContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LorryCard_module_default()).lorryIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LorryCard_module_default()).lorryNumber,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LorryCard_module_default()).lorryClassificationContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                                        width: 210
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LorryCard_module_default()).srcDestContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SrcDest/* default */.Z, {
                                state: misc/* ComponentState.LOADING */.hm.LOADING
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LorryCard_module_default()).statusContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                                    width: 90,
                                    height: 28,
                                    type: "pill"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (LorryCard_module_default()).timeStamp,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                })
                            ]
                        })
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((LorryCard_module_default()).lorryCardContainer, (LorryCard_module_default()).loadingState),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LorryCard_module_default()).lorryCardSpaceWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).lorryClassificationContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LorryCard_module_default()).lorryId,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: (LorryCard_module_default()).srcDestCol,
                                xs: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LorryCard_module_default()).srcDestContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SrcDest/* default */.Z, {
                                        state: misc/* ComponentState.LOADING */.hm.LOADING
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LorryCard_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LorryCard_module_default()).lorryClassification,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LorryCard_module_default()).lorryNumber,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).footerSectionWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LorryCard_module_default()).footerSectionContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: classnames_default()((LorryCard_module_default()).bidStatus),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (LorryCard_module_default()).viewDetailsBtn,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    }
    var lorryClassification = (0,lorryTypes/* getLorryDetailsByType */.X9)(data.lorry_detail.type_value);
    var lorry_icon_right = lorryClassification === null || lorryClassification === void 0 ? void 0 : lorryClassification.iconRight;
    var lorry_icon_left = lorryClassification === null || lorryClassification === void 0 ? void 0 : lorryClassification.iconLeft;
    var received_bids = 0, sent_bids = 0, acceptedAtAmount = 0;
    if (data && (data === null || data === void 0 ? void 0 : data.bids_summary)) {
        received_bids = data.bids_summary.received_bids;
        sent_bids = data.bids_summary.sent_bids;
    }
    if (data && data.bid_infos) {
        var ref16;
        var ref17 = (ref16 = data.bid_infos.find(function(bid) {
            return bid.status === constants_bidStatus/* BID_STATUS.IN_TRANSIT */.UE.IN_TRANSIT;
        })) !== null && ref16 !== void 0 ? ref16 : {}, cross_bid = ref17.cross_bid, amount = ref17.amount;
        acceptedAtAmount = cross_bid || amount || 0;
    }
    var getBidStatus = function() {
        switch(data.lorry_detail.status){
            case lorryStatus/* LORRY_STATUS.IN_TRANSIT */.un.IN_TRANSIT:
                {
                    return acceptedAtAmount ? "Accepted bid: ₹".concat(acceptedAtAmount) : "Bid Accepted";
                }
            case lorryStatus/* LORRY_STATUS.ACTIVE */.un.ACTIVE:
                {
                    if (!!(data === null || data === void 0 ? void 0 : data.bids_summary)) {
                        return "".concat(sent_bids + " Sent / " + received_bids + " Received", " ");
                    } else {
                        return "Awaiting Bids";
                    }
                }
            default:
                {
                    return "";
                }
        }
    };
    var bidStatus = getBidStatus();
    var handleShareLorry = function(e) {
        e.stopPropagation();
        setActiveCard(data.lorry_detail.id);
        setOpenShareModal(true);
        trackEvent(event_names/* LorryScreenEvents.shareonwhatsapp_clicked */.xI.shareonwhatsapp_clicked, {
            activity: "lorry"
        });
    };
    var handleReactivationSuccess = function(val) {
        router.query["id"] = val.toString();
        router.push(router, (0,generataMaskUrlWithParams/* generataMaskUrlWithParams */.j)(router.query), {
            shallow: true
        });
        trackEvent(event_names/* LorryScreenEvents.reactivated_lorry */.xI.reactivated_lorry, {});
    };
    var isRCDocumentUploaded = !!(0,LorryActionBar/* getLorryVerificationDocumentUrlFromRcData */.n)(data === null || data === void 0 ? void 0 : (ref2 = data.lorry_detail) === null || ref2 === void 0 ? void 0 : ref2.rc_details);
    var isVerificationPending = isRCDocumentUploaded && (data === null || data === void 0 ? void 0 : (ref3 = data.lorry_detail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.rc_details) === null || ref4 === void 0 ? void 0 : ref4.status) === types_document/* TicketStatus.PENDING */.mk.PENDING;
    var getRCVerificationComponent = function() {
        var ref;
        var isVerifiedLoad = !(data === null || data === void 0 ? void 0 : data.lorry_detail) || (data === null || data === void 0 ? void 0 : (ref = data.lorry_detail) === null || ref === void 0 ? void 0 : ref.status) !== lorryStatus/* LORRY_STATUS.VERIFICATION_FAILED */.un.VERIFICATION_FAILED;
        if (isVerifiedLoad) {
            return null;
        }
        var ref1;
        var ref2 = (ref1 = data === null || data === void 0 ? void 0 : data.lorry_detail) !== null && ref1 !== void 0 ? ref1 : {}, _rc_details = ref2.rc_details, rc_details = _rc_details === void 0 ? {} : _rc_details, id = ref2.id;
        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryActionBar/* default */.Z, {
            lorryId: id,
            rcDetails: rc_details,
            trackEvent: trackEvent
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((LorryCard_module_default()).lorryActions),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryActionBar/* default */.Z, {
                    lorryId: id,
                    rcDetails: rc_details,
                    trackEvent: trackEvent
                })
            })
        });
    };
    var renderTapNgoTimeline;
    var paymentPendingAssuredBids = data === null || data === void 0 ? void 0 : (ref5 = data.bid_infos) === null || ref5 === void 0 ? void 0 : ref5.find(function(bid) {
        var ref, ref1, ref2;
        var isAssuredLoad = (bid === null || bid === void 0 ? void 0 : (ref = bid.load_detail) === null || ref === void 0 ? void 0 : ref.is_tap_n_go) || (bid === null || bid === void 0 ? void 0 : (ref1 = bid.load_detail) === null || ref1 === void 0 ? void 0 : ref1.is_spot_load);
        var bookingMeta = getBookingMeta({
            isTapNgo: bid === null || bid === void 0 ? void 0 : (ref2 = bid.load_detail) === null || ref2 === void 0 ? void 0 : ref2.is_tap_n_go
        }, bid);
        return assuredLoad/* AssuredBidStatusList.includes */.t.includes(bid === null || bid === void 0 ? void 0 : bid.status) || isAssuredLoad && (bid === null || bid === void 0 ? void 0 : bid.status) === constants_bidStatus/* BID_STATUS.IN_TRANSIT */.UE.IN_TRANSIT && !(bookingMeta === null || bookingMeta === void 0 ? void 0 : bookingMeta.is_lorry_owner_paid);
    });
    if (paymentPendingAssuredBids) {
        var ref18, ref19, ref20;
        var bidder_info = paymentPendingAssuredBids.bidder_info, tenderer_info = paymentPendingAssuredBids.tenderer_info;
        var isBidder = cId === (bidder_info === null || bidder_info === void 0 ? void 0 : bidder_info.id);
        var assuredLoadMetaData = {
            spot_load_info: paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : paymentPendingAssuredBids.spot_load_info,
            tap_n_go_info: paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : paymentPendingAssuredBids.tap_n_go_info,
            updated_at_timestamp: paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : paymentPendingAssuredBids.updated_at_timestamp,
            bid_status: paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : paymentPendingAssuredBids.status,
            is_tap_n_go: !!(paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : (ref18 = paymentPendingAssuredBids.load_detail) === null || ref18 === void 0 ? void 0 : ref18.is_tap_n_go),
            is_spot_load: !!(paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : (ref19 = paymentPendingAssuredBids.load_detail) === null || ref19 === void 0 ? void 0 : ref19.is_spot_load),
            loadCid: isBidder ? tenderer_info === null || tenderer_info === void 0 ? void 0 : tenderer_info.id : bidder_info === null || bidder_info === void 0 ? void 0 : bidder_info.id,
            lorryCid: !isBidder ? tenderer_info === null || tenderer_info === void 0 ? void 0 : tenderer_info.id : bidder_info === null || bidder_info === void 0 ? void 0 : bidder_info.id,
            bidId: paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : paymentPendingAssuredBids.id,
            loadId: paymentPendingAssuredBids === null || paymentPendingAssuredBids === void 0 ? void 0 : (ref20 = paymentPendingAssuredBids.load_detail) === null || ref20 === void 0 ? void 0 : ref20.id,
            bookingOrderInfo: {
                bid_type: isBidder ? usePostLoadBid/* BidType.LOAD_BID */.j.LOAD_BID : usePostLoadBid/* BidType.LORRY_BID */.j.LORRY_BID
            }
        };
        var isAssuredLoad = (assuredLoadMetaData === null || assuredLoadMetaData === void 0 ? void 0 : assuredLoadMetaData.is_spot_load) || (assuredLoadMetaData === null || assuredLoadMetaData === void 0 ? void 0 : assuredLoadMetaData.is_tap_n_go);
        if (isAssuredLoad && companyId) {
            renderTapNgoTimeline = /*#__PURE__*/ (0,jsx_runtime.jsx)(AssuredLoadStatus/* default */.Z, {
                meta: assuredLoadMetaData,
                cId: Number(companyId),
                source: "lorry",
                trackEvent: trackEvent
            });
        }
    }
    var headerDropdownList = [
        {
            id: "edit-lorry",
            label: "Edit Lorry",
            enable: allowEditLorryStatus && allowEditPermission,
            onClick: function onClick() {
                handleEditClick(getLorryPreFilledData(data), data.lorry_detail.id, "edit");
            }
        },
        {
            id: "lorry-documents",
            label: "Documents",
            enable: allowEditPermission,
            onClick: function onClick() {
                var ref;
                onClickViewDocument === null || onClickViewDocument === void 0 ? void 0 : onClickViewDocument(data === null || data === void 0 ? void 0 : (ref = data.lorry_detail) === null || ref === void 0 ? void 0 : ref.id);
            }
        }
    ].filter(function(item) {
        return item.enable;
    });
    var DropdownSlot = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: !!(headerDropdownList === null || headerDropdownList === void 0 ? void 0 : headerDropdownList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StopPropagation/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                    options: headerDropdownList,
                    toggleNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(options/* default */.Z, {}),
                    externalProps: {
                        isRtl: true
                    }
                })
            })
        });
    }, [
        headerDropdownList
    ]);
    var _name, _is_bank_verified, _is_aadhaar_verified, _is_gst_verified;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isMobile ? // Desktop Card
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((LorryCard_module_default()).lorryCardContainer),
                onClick: function() {
                    onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick();
                    onCardClickTrackingHandler ? onCardClickTrackingHandler === null || onCardClickTrackingHandler === void 0 ? void 0 : onCardClickTrackingHandler() : trackEvent(event_names/* LorryScreenEvents.lorry_card_clicked */.xI.lorry_card_clicked);
                },
                children: [
                    VerificationStatus,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: (LorryCard_module_default()).mainRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).lorryIconCol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LorryCard_module_default()).lorryNumberContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LorryCard_module_default()).lorryIcon,
                                            children: [
                                                lorry_icon_right ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                    className: (LorryCard_module_default()).icon,
                                                    src: (0,getImageNameFromURL/* getImageNameFromURL */.O)(lorry_icon_right),
                                                    alt: "",
                                                    width: "100%",
                                                    height: "50px"
                                                }) : null,
                                                data.lorry_detail.status !== lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LorryCard_module_default()).shareIcon,
                                                    onClick: handleShareLorry,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_blue/* default */.Z, {})
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LorryCard_module_default()).lorryNumber,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: (0,formatLorryNum/* formatLorryNum */.K)(data.lorry_detail.number)
                                                }),
                                                isDeveloper && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chip/* default */.Z, {
                                                    size: "auto",
                                                    filled: true,
                                                    color: "orange",
                                                    radius: 50,
                                                    onClick: function(event) {
                                                        return event.stopPropagation();
                                                    },
                                                    children: [
                                                        "#LR",
                                                        data.lorry_detail.id
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).lorryClassificationCol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LorryCard_module_default()).lorryClassificationContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: lorryClassification === null || lorryClassification === void 0 ? void 0 : lorryClassification.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryOneLineInfo/* default */.Z, {
                                            lorryBodyType: data.lorry_detail.body_type,
                                            lorryCapacity: data.lorry_detail.capacity,
                                            lorrySize: data.lorry_detail.size,
                                            lorrySizeText: data.lorry_detail.size_text,
                                            lorryType: data.lorry_detail.type_value,
                                            lorryTyres: data.lorry_detail.total_tyres
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).lorrySrcDestCol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LorryCard_module_default()).srcDestContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SrcDest/* default */.Z, {
                                        cardCategory: "lorry",
                                        source: data.lorry_detail.current_city,
                                        routes: data.lorry_detail.routes,
                                        position: isLastCard ? "top" : "bottom"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).lorryBadgeCol,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LorryCard_module_default()).statusContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryBadgeController/* default */.Z, {
                                            status: data.lorry_detail.status,
                                            verificationPending: isVerificationPending
                                        }),
                                        (data === null || data === void 0 ? void 0 : (ref6 = data.lorry_detail) === null || ref6 === void 0 ? void 0 : ref6.status) === lorryStatus/* LORRY_STATUS.IN_TRANSIT */.un.IN_TRANSIT && !isCsDashboardUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (LorryCard_module_default()).payBtnRedirection,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRedirectPayBtn/* default */.Z, {
                                                type: "receive",
                                                fullWidth: true
                                            })
                                        }),
                                        data.lorry_detail.status !== lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (LorryCard_module_default()).bidStatusContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: classnames_default()((LorryCard_module_default()).bidStatus),
                                                children: bidStatus
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).lorryPostedCol,
                                children: data.lorry_detail.status && data.lorry_detail.status !== lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LorryCard_module_default()).timeStamp,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "Posted at ",
                                                data.lorry_detail.updated_at.split(",")[0]
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: data.lorry_detail.updated_at.split(",")[1]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                                    allowCustomer: true,
                                    action: adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction,
                                    alsoCheck: [
                                        lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE
                                    ].includes(data.lorry_detail.status),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LorryCard_module_default()).reActivateCol,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactivateLoadLorry/* default */.Z, {
                                            type: "lorry",
                                            data: data,
                                            onSuccess: handleReactivationSuccess,
                                            trackEvent: trackEvent,
                                            handleOpenEditModal: function(category) {
                                                handleEditClick(getLorryPreFilledData(data), data.lorry_detail.id, category);
                                            }
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).editAndCommentContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                                    action: adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        children: DropdownSlot
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((LorryCard_module_default()).arrowCol),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AngleLeftGray/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                        action: "",
                        allowCsUser: true,
                        alsoCheck: !!(data === null || data === void 0 ? void 0 : (ref7 = data.lorry_detail) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.meta_data) === null || ref8 === void 0 ? void 0 : ref8.body_type),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                padding: "10px 50px 0",
                                gap: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabelAndValue/* default */.Z, {
                                    label: "Verified Body",
                                    value: data === null || data === void 0 ? void 0 : (ref9 = data.lorry_detail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.meta_data) === null || ref10 === void 0 ? void 0 : ref10.body_type
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                        action: adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction,
                        allowCustomer: true,
                        children: getRCVerificationComponent()
                    }),
                    renderTapNgoTimeline && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                            padding: "10px 50px 0",
                            gap: 5,
                            children: renderTapNgoTimeline
                        })
                    })
                ]
            }) : // Mobile card
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LorryCard_module_default()).lorryCardContainer,
                onClick: function() {
                    onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick();
                    onCardClickTrackingHandler ? onCardClickTrackingHandler === null || onCardClickTrackingHandler === void 0 ? void 0 : onCardClickTrackingHandler() : trackEvent(event_names/* LorryScreenEvents.lorry_card_clicked */.xI.lorry_card_clicked);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LorryCard_module_default()).lorryCardSpaceWrapper,
                        children: [
                            VerificationStatus,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LorryCard_module_default()).status,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryBadgeController/* default */.Z, {
                                    verificationPending: isVerificationPending,
                                    status: data.lorry_detail.status,
                                    outlined: true
                                })
                            }),
                            data.lorry_detail.expires_at && data.lorry_detail.status !== lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiryPill/* default */.Z, {
                                expiry_time: data.lorry_detail.expires_at,
                                expiresClass: (LorryCard_module_default()).expired
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LorryCard_module_default()).lorryClassificationContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DotSeparated/* default */.Z, {
                                            dotStyleClassName: (LorryCard_module_default()).lorryId,
                                            nodes: [
                                                /* eslint-disable react/jsx-key */ /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (LorryCard_module_default()).lorryId,
                                                    children: [
                                                        "#LR",
                                                        data.lorry_detail.id
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: (LorryCard_module_default()).postedAt,
                                                    children: [
                                                        "Posted at",
                                                        " ",
                                                        new Date(data.lorry_detail.created_at).toLocaleDateString("en-IN", {
                                                            year: "numeric",
                                                            month: "short",
                                                            day: "numeric"
                                                        }),
                                                        ", ",
                                                        getFormattedTime(data.lorry_detail.created_at),
                                                        " "
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        className: (LorryCard_module_default()).srcDestCol,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (LorryCard_module_default()).srcDestContainer,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SrcDest/* default */.Z, {
                                                cardCategory: "lorry",
                                                source: data.lorry_detail.current_city,
                                                routes: data.lorry_detail.routes
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        style: {
                                            overflow: "hidden"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (LorryCard_module_default()).icon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                        className: (LorryCard_module_default()).icon,
                                                        src: (0,getImageNameFromURL/* getImageNameFromURL */.O)(lorry_icon_left),
                                                        alt: "",
                                                        width: "100%",
                                                        height: "50px"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (LorryCard_module_default()).lorryNumber,
                                                        style: {
                                                            paddingRight: 20
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: (0,formatLorryNum/* formatLorryNum */.K)(data.lorry_detail.number)
                                                            }),
                                                            isDeveloper && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chip/* default */.Z, {
                                                                size: "auto",
                                                                filled: true,
                                                                color: "orange",
                                                                radius: 50,
                                                                onClick: function(event) {
                                                                    return event.stopPropagation();
                                                                },
                                                                children: [
                                                                    "#LR",
                                                                    data.lorry_detail.id
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryOneLineInfo/* default */.Z, {
                                        showLorryType: true,
                                        lorryBodyType: data.lorry_detail.body_type,
                                        lorryCapacity: data.lorry_detail.capacity,
                                        lorrySize: data.lorry_detail.size,
                                        lorrySizeText: data.lorry_detail.size_text,
                                        lorryType: data.lorry_detail.type_value,
                                        lorryTyres: data.lorry_detail.total_tyres
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LorryCard_module_default()).footerSectionWrapper,
                                        children: data.lorry_detail.status && data.lorry_detail.status !== lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LorryCard_module_default()).footerSectionContainer,
                                            children: [
                                                (data === null || data === void 0 ? void 0 : (ref11 = data.lorry_detail) === null || ref11 === void 0 ? void 0 : ref11.status) === lorryStatus/* LORRY_STATUS.IN_TRANSIT */.un.IN_TRANSIT && !isCsDashboardUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRedirectPayBtn/* default */.Z, {
                                                        type: "receive",
                                                        fullWidth: true
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (LorryCard_module_default()).bidStatusContainer,
                                                    children: [
                                                        ![
                                                            lorryStatus/* LORRY_STATUS.IN_TRANSIT */.un.IN_TRANSIT,
                                                            lorryStatus/* LORRY_STATUS.VERIFICATION_FAILED */.un.VERIFICATION_FAILED
                                                        ].includes(data.lorry_detail.status) && !paymentPendingAssuredBids ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classnames_default()((LorryCard_module_default()).bidStatusIndicator, (LorryCard_module_default())[sent_bids || received_bids ? "sentOrReceived" : "awaiting"])
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: classnames_default()((LorryCard_module_default()).bidStatus),
                                                            children: bidStatus
                                                        })
                                                    ]
                                                }),
                                                data.lorry_detail.status === lorryStatus/* LORRY_STATUS.VERIFICATION_FAILED */.un.VERIFICATION_FAILED && !isRCDocumentUploaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                                    margin: "0 10px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        weight: "medium",
                                                        color: colors/* default.RED */.Z.RED,
                                                        size: "s",
                                                        children: "Please upload RC to verify your vehicle"
                                                    })
                                                }) : null
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                                            allowCustomer: true,
                                            action: adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction,
                                            alsoCheck: [
                                                lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE
                                            ].includes(data.lorry_detail.status),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((LorryCard_module_default()).footerSectionContainer, (LorryCard_module_default()).reactivateContainer),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactivateLoadLorry/* default */.Z, {
                                                    type: "lorry",
                                                    data: data,
                                                    onSuccess: handleReactivationSuccess,
                                                    trackEvent: trackEvent,
                                                    handleOpenEditModal: function(category) {
                                                        handleEditClick(getLorryPreFilledData(data), data.lorry_detail.id, category);
                                                    }
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            showProfileInfo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: (LorryCard_module_default()).profileInfoWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                        gap: 5,
                                        justifyContent: "space-between",
                                        onClick: function(e) {
                                            return e.stopPropagation();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (LorryCard_module_default()).profileWrapper,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                                        src: (0,getImageNameFromURL/* getImageNameFromURL */.O)(data.company_detail.logo) || "default.png",
                                                        alt: "",
                                                        width: 40,
                                                        height: 30
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                                                        gap: 12,
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                as: "h1",
                                                                size: "sm",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisText/* default */.Z, {
                                                                    text: (_name = data.company_detail.name) !== null && _name !== void 0 ? _name : "",
                                                                    limit: 15
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileVerificationLevel/* default */.Z, {
                                                                isBankVerified: (_is_bank_verified = data.company_detail.is_bank_verified) !== null && _is_bank_verified !== void 0 ? _is_bank_verified : false,
                                                                isAadhaarVerified: (_is_aadhaar_verified = data.company_detail.is_aadhaar_verified) !== null && _is_aadhaar_verified !== void 0 ? _is_aadhaar_verified : false,
                                                                isGSTVerified: (_is_gst_verified = data.company_detail.is_gst_verified) !== null && _is_gst_verified !== void 0 ? _is_gst_verified : false,
                                                                isMember: data.company_detail.is_member
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (LorryCard_module_default()).callBtn,
                                                onClick: function() {
                                                    return onClickGetContact === null || onClickGetContact === void 0 ? void 0 : onClickGetContact(data.company_detail.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(call_circle/* default */.Z, {})
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            renderTapNgoTimeline
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                        action: adminOperation/* ADMIN_OPERATION.userLoadLorryAction */.F.userLoadLorryAction,
                        allowCustomer: true,
                        children: getRCVerificationComponent()
                    })
                ]
            }),
            activeCard === data.lorry_detail.id && openShareModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal["default"], {
                toggle: function() {
                    setOpenShareModal(false);
                    setActiveCard(0);
                },
                isOpen: !!openShareModal,
                modalTitle: "".concat(t("common:share_lorry")),
                mktType: "lorry",
                data: data,
                trackEvent: trackEvent
            })
        ]
    });
};
/* harmony default export */ var lorry_card_LorryCard = (LorryCard);
var generateLorryEventAttribute = function(lorry) {
    var ref, ref1, ref2, ref3;
    var lorry_detail = (lorry !== null && lorry !== void 0 ? lorry : {}).lorry_detail;
    var requiredLorry = (0,lorryTypes/* getLorryDetailsByType */.X9)(lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.type_value);
    return {
        lorry_id: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.id,
        lorry_status: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.status_text,
        is_lorry_verified: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.is_verified,
        vehicle_number: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.number,
        current_location: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.current_city,
        current_location_id: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.current_location_id,
        current_location_city_id: lorry_detail === null || lorry_detail === void 0 ? void 0 : (ref = lorry_detail.source_info) === null || ref === void 0 ? void 0 : ref.city_id,
        current_location_state_id: lorry_detail === null || lorry_detail === void 0 ? void 0 : (ref1 = lorry_detail.source_info) === null || ref1 === void 0 ? void 0 : ref1.state_id,
        routes: (lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.have_all_india_permit) ? "All India Permit" : lorry_detail === null || lorry_detail === void 0 ? void 0 : (ref2 = lorry_detail.routes) === null || ref2 === void 0 ? void 0 : ref2.map(function(r) {
            var ref;
            return (ref = StateList/* STATE_LIST.find */.t4.find(function(st) {
                return st.id === (r === null || r === void 0 ? void 0 : r.id);
            })) === null || ref === void 0 ? void 0 : ref.code;
        }),
        total_route: lorry_detail === null || lorry_detail === void 0 ? void 0 : (ref3 = lorry_detail.routes) === null || ref3 === void 0 ? void 0 : ref3.length,
        lorry_type: requiredLorry === null || requiredLorry === void 0 ? void 0 : requiredLorry.label,
        lorry_capacity: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.capacity,
        capacity_type: requiredLorry === null || requiredLorry === void 0 ? void 0 : requiredLorry.unit,
        total_tyres: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.total_tyres,
        vehicle_size: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.size,
        vehicle_size_type: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.size_text,
        body_type: (lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.body_type) != undefined ? lorryTypes/* LORRY_BODY_TYPE_MAP */.ix[lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.body_type] : ""
    };
};
var getLorryPreFilledData = function(data) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var stateData = StateList/* STATE_LIST.find */.t4.find(function(state) {
        var ref;
        return state.name === (data === null || data === void 0 ? void 0 : (ref = data.lorry_detail) === null || ref === void 0 ? void 0 : ref.current_state);
    });
    var ref11;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* initialLoadCreationFormValues */.vf), {
        lorryType: data === null || data === void 0 ? void 0 : (ref = data.lorry_detail) === null || ref === void 0 ? void 0 : ref.type_value,
        isLorryCapacityRequired: true,
        lorryCapacity: data === null || data === void 0 ? void 0 : (ref1 = data.lorry_detail) === null || ref1 === void 0 ? void 0 : ref1.capacity,
        lorryBodyType: data === null || data === void 0 ? void 0 : (ref2 = data.lorry_detail) === null || ref2 === void 0 ? void 0 : ref2.body_type,
        lorrySize: data === null || data === void 0 ? void 0 : (ref3 = data.lorry_detail) === null || ref3 === void 0 ? void 0 : ref3.size,
        lorryTyres: data === null || data === void 0 ? void 0 : (ref4 = data.lorry_detail) === null || ref4 === void 0 ? void 0 : ref4.total_tyres,
        sizeText: data === null || data === void 0 ? void 0 : (ref5 = data.lorry_detail) === null || ref5 === void 0 ? void 0 : ref5.size_text,
        lorryNum: data === null || data === void 0 ? void 0 : (ref6 = data.lorry_detail) === null || ref6 === void 0 ? void 0 : ref6.number,
        routeIds: data === null || data === void 0 ? void 0 : (ref7 = data.lorry_detail) === null || ref7 === void 0 ? void 0 : ref7.routes,
        rcDocument: undefined,
        status: data === null || data === void 0 ? void 0 : (ref8 = data.lorry_detail) === null || ref8 === void 0 ? void 0 : ref8.status,
        currentCityText: (0,methods/* getJoinedStringFromArray */.D$)([
            (0,removeSubstringWithParenthesis/* removeSubstringWithParenthesis */.B)((ref11 = data === null || data === void 0 ? void 0 : (ref9 = data.lorry_detail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.current_city) === null || ref10 === void 0 ? void 0 : ref10.split(",")[0]) !== null && ref11 !== void 0 ? ref11 : ""),
            stateData === null || stateData === void 0 ? void 0 : stateData.name
        ]),
        currentCityOption: undefined,
        currentCityPlaceId: ""
    });
};


/***/ }),

/***/ 32346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reactivate_load_lorry_ReactivateLoadLorry; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(29463);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/components/app-btn/AppBtn.js + 2 modules
var AppBtn = __webpack_require__(49995);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ./components/posting/vehicle-restriction-popup/index.ts + 4 modules
var vehicle_restriction_popup = __webpack_require__(48510);
// EXTERNAL MODULE: ./components/dashboard/list-wrapper/reactivate-load-lorry/ReactivateLoadLorry.module.scss
var ReactivateLoadLorry_module = __webpack_require__(73409);
var ReactivateLoadLorry_module_default = /*#__PURE__*/__webpack_require__.n(ReactivateLoadLorry_module);
;// CONCATENATED MODULE: ../core/dist/icons/reactivate.svg
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgReactivate(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M.827 10.482a.827.827 0 100-1.654.827.827 0 000 1.654zm4.966 4.966a.827.827 0 100-1.655.827.827 0 000 1.655zM2.655 13.62a.827.827 0 100-1.654.827.827 0 000 1.655z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M.827 10.482a.827.827 0 100-1.654.827.827 0 000 1.654zM6.62 14.62a.827.827 0 10-1.653 0 .827.827 0 001.654 0zm-3.965-1a.827.827 0 100-1.654.827.827 0 000 1.655zm-1.828-7a.827.827 0 100-1.654.827.827 0 000 1.655zm4.966-4.965a.827.827 0 100-1.655.827.827 0 000 1.655zM2.655 3.482a.827.827 0 100-1.655.827.827 0 000 1.655z",
    fill: "#2355FC"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M.827 6.62a.827.827 0 100-1.654.827.827 0 000 1.655zM6.62.827a.827.827 0 11-1.654 0 .827.827 0 011.655 0zM2.655 3.482a.827.827 0 100-1.655.827.827 0 000 1.655zM9.931 15.45a.827.827 0 01-.221-1.626 6.4 6.4 0 003.32-2.239 6.26 6.26 0 001.315-3.86 6.392 6.392 0 00-4.641-6.1.828.828 0 01.457-1.592 8.156 8.156 0 014.17 2.827 7.949 7.949 0 01.01 9.733 8.062 8.062 0 01-4.188 2.82.83.83 0 01-.228.032l.006.004z",
    fill: "#2355FC"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M14.898 16a.84.84 0 01-.092 0l-4.966-.552a.826.826 0 01-.706-1.045l1.38-4.965a.83.83 0 011.6.443l-1.12 4.028 4 .445a.827.827 0 01-.09 1.65L14.898 16z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ var reactivate = (SvgReactivate);
// EXTERNAL MODULE: ./components/posting/helpers/validations/lorryFormValidations.ts
var lorryFormValidations = __webpack_require__(14981);
// EXTERNAL MODULE: ./components/posting/helpers/constants.ts
var constants = __webpack_require__(40607);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/_services/hooks/usePostingService.js
var usePostingService = __webpack_require__(7941);
// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
// EXTERNAL MODULE: ../core-ui/dist/hooks/index.js + 3 modules
var hooks = __webpack_require__(95385);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ./components/posting/lorry-posting/helpers/constants.ts
var helpers_constants = __webpack_require__(90376);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./methods/generataMaskUrlWithParams.ts
var generataMaskUrlWithParams = __webpack_require__(32740);
// EXTERNAL MODULE: ./context/load-lorry-posting.tsx
var load_lorry_posting = __webpack_require__(8574);
;// CONCATENATED MODULE: ./components/dashboard/list-wrapper/reactivate-load-lorry/ReactivateLoadLorry.tsx







// Context

// Components



// Style

// Icons

// Constant




// Services

//Hooks








var ReactivateLoadLorry = function(param) {
    var type = param.type, data = param.data, reactivateButton = param.reactivateButton, onSuccess = param.onSuccess, trackEvent = param.trackEvent, handleOpenEditModal = param.handleOpenEditModal;
    var companyId = (0,react.useContext)(app_context/* AppContext */.Il).companyId;
    var t = (0,useTranslation/* useTranslation */.$)([
        "userProfile",
        "common"
    ]).t;
    var ref = (0,react.useState)(0), activeCard = ref[0], setActiveCard = ref[1];
    var ref1 = (0,react.useState)(false), isSubmitting = ref1[0], setIsSubmitting = ref1[1];
    var ref2 = (0,react.useState)(null), restrictionKind = ref2[0], setRestrictionKind = ref2[1];
    var updateLoadLorryPostingData = (0,load_lorry_posting/* useLoadLorryPosting */.NS)().updateLoadLorryPostingData;
    /**
     * Lorry Activation
     */ var ref3 = (0,hooks/* useToggleModalWithLocalState */.A$)(), isModalOpen = ref3.isModalOpen, toggleModal = ref3.toggleModal;
    var handleReactivateLorry = function() {
        setActiveCard(data.lorry_detail.id);
        toggleModal();
    };
    var lorryReactivationSuccess = function() {
        /**
         * Events
         */ toggleModal();
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.lorry_detail.id);
    };
    /**
     * Load posting verification check
     */ var ref4 = (0,useValidateUserStatus/* default */.Z)(), ValidateLoadPosting = ref4.ValidateLoadPosting, ValidateLorryPosting = ref4.ValidateLorryPosting;
    var ref5 = (0,usePostingService/* useReactivateLorry */.Zd)(), reactivateLorry = ref5.mutateAsync;
    var queryClient = (0,es.useQueryClient)();
    var router = (0,next_router.useRouter)();
    var handleActivation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(place) {
            var ref, currentPlaceID;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        currentPlaceID = (ref = place === null || place === void 0 ? void 0 : place.place_id) !== null && ref !== void 0 ? ref : "";
                        reactivateLorry({
                            lorryId: data.lorry_id || data.lorry_detail.id,
                            currentPlaceID: currentPlaceID
                        }, {
                            onSuccess: function(res) {
                                toast/* toast.success */.A.success("Lorry reactivated successfully.");
                                queryClient.invalidateQueries([
                                    queryNames/* QueryNames.userLorries.getLorriesByCategory */._.userLorries.getLorriesByCategory,
                                    companyId
                                ]);
                                lorryReactivationSuccess === null || lorryReactivationSuccess === void 0 ? void 0 : lorryReactivationSuccess();
                            },
                            onError: function(res) {
                                toast/* toast.error */.A.error(res.message);
                            }
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleActivation(place) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRestrictionCancel = (0,react.useCallback)(function() {
        setRestrictionKind(null);
    }, []);
    var handleRestrictionAddNewVehicle = (0,react.useCallback)(function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        e === null || e === void 0 ? void 0 : e.preventDefault();
        // Drop details-page id so dashboard does not open Details on this navigation.
        delete router.query.id;
        router.query[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME] = constants/* LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */.jU.VEHICLE_NUMBER;
        ValidateLorryPosting === null || ValidateLorryPosting === void 0 ? void 0 : ValidateLorryPosting(function() {
            updateLoadLorryPostingData({
                category: "post",
                isModalOpen: true,
                type: "lorry",
                data: undefined,
                originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.DASHBOARD */.ec.DASHBOARD
            });
            router.push({
                query: router.query
            }, (0,generataMaskUrlWithParams/* generataMaskUrlWithParams */.j)(router.query), {
                shallow: true,
                scroll: false
            });
            // Delay unmount so the click cannot fall through to the lorry card (opens details for CS).
            window.setTimeout(function() {
                return setRestrictionKind(null);
            }, 0);
        });
    }, [
        ValidateLorryPosting,
        router,
        updateLoadLorryPostingData
    ]);
    var handleReactivateClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var lorry_detail, lorryNumberSchema, lorryNumberData, restriction, _obj, dataToValidate, schema;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.stopPropagation();
                        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* LorryScreenEvents.reactivate_lorry_clicked */.xI.reactivate_lorry_clicked);
                        lorry_detail = (data !== null && data !== void 0 ? data : {}).lorry_detail;
                        lorryNumberSchema = lorryFormValidations/* lorryFormValidations */.W[constants/* LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */.jU.VEHICLE_NUMBER];
                        if (lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.number) {
                            _ctx.next = 7;
                            break;
                        }
                        router.query[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME] = constants/* LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */.jU.VEHICLE_NUMBER;
                        return _ctx.abrupt("return", ValidateLorryPosting === null || ValidateLorryPosting === void 0 ? void 0 : ValidateLorryPosting(function() {
                            router.push({
                                query: router.query
                            }, (0,generataMaskUrlWithParams/* generataMaskUrlWithParams */.j)(router.query), {
                                shallow: true
                            });
                        }));
                    case 7:
                        lorryNumberData = (0,_define_property/* default */.Z)({}, constants/* lorryCreationFormFieldNames.lorryNum */.KP.lorryNum, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.number);
                        _ctx.next = 10;
                        return lorryNumberSchema.isValid(lorryNumberData);
                    case 10:
                        if (_ctx.sent) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", toast/* toast.error */.A.error("Invalid lorry number"));
                    case 12:
                        restriction = (0,vehicle_restriction_popup/* getLorryVehicleRestriction */.V2)({
                            capacity: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.capacity,
                            totalTyres: lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.total_tyres
                        });
                        if (!(restriction === "three_wheeler")) {
                            _ctx.next = 16;
                            break;
                        }
                        setRestrictionKind("three_wheeler_lorry");
                        return _ctx.abrupt("return");
                    case 16:
                        if (!(restriction === "capacity_out_of_range")) {
                            _ctx.next = 19;
                            break;
                        }
                        setRestrictionKind("capacity_reactivate");
                        return _ctx.abrupt("return");
                    case 19:
                        ;
                        dataToValidate = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* lorryCreationFormFieldNames.lorryType */.KP.lorryType, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.type_value), (0,_define_property/* default */.Z)(_obj, constants/* lorryCreationFormFieldNames.lorryCapacity */.KP.lorryCapacity, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.capacity), (0,_define_property/* default */.Z)(_obj, constants/* lorryCreationFormFieldNames.lorryTyres */.KP.lorryTyres, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.total_tyres), (0,_define_property/* default */.Z)(_obj, constants/* lorryCreationFormFieldNames.lorrySize */.KP.lorrySize, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.size), (0,_define_property/* default */.Z)(_obj, constants/* lorryCreationFormFieldNames.sizeText */.KP.sizeText, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.size_text), (0,_define_property/* default */.Z)(_obj, constants/* lorryCreationFormFieldNames.lorryBodyType */.KP.lorryBodyType, lorry_detail === null || lorry_detail === void 0 ? void 0 : lorry_detail.body_type), _obj);
                        schema = lorryFormValidations/* lorryFormValidations */.W[constants/* LORRY_CREATION_FORM_IDS.VEHICLE_TYPE */.jU.VEHICLE_TYPE];
                        schema.validate(dataToValidate).then(function() {
                            ValidateLorryPosting === null || ValidateLorryPosting === void 0 ? void 0 : ValidateLorryPosting(function() {
                                return handleOpenEditModal === null || handleOpenEditModal === void 0 ? void 0 : handleOpenEditModal("re-post");
                            });
                        }).catch(function() {
                            ValidateLorryPosting === null || ValidateLorryPosting === void 0 ? void 0 : ValidateLorryPosting(function() {
                                return handleOpenEditModal === null || handleOpenEditModal === void 0 ? void 0 : handleOpenEditModal("edit");
                            });
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReactivateClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            type === market/* MARKET_TYPE.LOAD */.X5.LOAD || type === market/* MARKET_TYPE.LOADS */.X5.LOADS ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((ReactivateLoadLorry_module_default()).reactivateBtnWrapper),
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: reactivateButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: reactivateButton
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBtn/* default */.Z, {
                    className: (ReactivateLoadLorry_module_default()).reactivateBtn,
                    fillType: "outline",
                    onClick: function(e) {
                        setIsSubmitting(true);
                        e.stopPropagation();
                        ValidateLoadPosting === null || ValidateLoadPosting === void 0 ? void 0 : ValidateLoadPosting((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        handleOpenEditModal === null || handleOpenEditModal === void 0 ? void 0 : handleOpenEditModal("re-post");
                                        setIsSubmitting(false);
                                    case 2:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })));
                    },
                    disabled: activeCard !== 0 || isSubmitting,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reactivate, {}),
                        " \xa0 Re-post"
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((ReactivateLoadLorry_module_default()).reactivateBtnWrapper),
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: reactivateButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: reactivateButton
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBtn/* default */.Z, {
                    className: (ReactivateLoadLorry_module_default()).reactivateBtn,
                    fillType: "outline",
                    onClick: function(e) {
                        void handleReactivateClick(e);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(reactivate, {}),
                        " Re-activate"
                    ]
                })
            }),
            restrictionKind ? /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_restriction_popup/* VehicleRestrictionPopup */.pS, {
                id: "lorry-reactivate-vehicle-restriction-popup",
                isOpen: !!restrictionKind,
                kind: restrictionKind,
                onCancel: handleRestrictionCancel,
                onPrimary: handleRestrictionAddNewVehicle
            }) : null
        ]
    });
};
/* harmony default export */ var reactivate_load_lorry_ReactivateLoadLorry = (ReactivateLoadLorry);


/***/ }),

/***/ 77845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var StopPropagation = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StopPropagation);


/***/ }),

/***/ 16440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92158);
/* harmony import */ var _HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var VARIANT_CLASS = {
    "fade-up": (_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadeUp),
    "fade-left": (_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadeLeft),
    "fade-right": (_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadeRight),
    "scale-up": (_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default().scaleUp)
};
/** Content is visible by default (SSR-safe). Scroll-in animation is opt-in via reduced-motion CSS. */ var HomepageV2Animate = function(param) {
    var children = param.children, _variant = param.variant, variant = _variant === void 0 ? "fade-up" : _variant, _delay = param.delay, delay = _delay === void 0 ? 0 : _delay, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default().animate), VARIANT_CLASS[variant], (_HomepageV2Animate_module_scss__WEBPACK_IMPORTED_MODULE_3___default().visible), className),
        style: {
            transitionDelay: "".concat(delay, "ms")
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomepageV2Animate);


/***/ }),

/***/ 99837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ APP_DOWNLOAD_BANNER_SECTION_ID; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42386);
/* harmony import */ var _AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31196);
/* harmony import */ var _AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _section_card_HomepageV2SectionCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63968);
/* harmony import */ var _utils_AppImg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17073);
/* harmony import */ var _animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16440);
/* harmony import */ var _common_download_app_qr_modal_DownloadAppAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20058);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8880);
/* harmony import */ var _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69406);
/* harmony import */ var _vahak_core_dist_standard_icons_apple_store_mark_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52783);
/* harmony import */ var _vahak_core_dist_standard_icons_google_play_mark_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43510);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(94204);














var PLAY_STORE_URL = "https://6r7cz.app.link/googleplay";
var HOMEPAGE_APP_DOWNLOAD_BANNER = {
    default: "homepage-v2/app-download-banner.png",
    hi: "homepage-v2/app-download-banner-hi.png"
};
function getHomepageAppDownloadBannerImage(locale) {
    return locale === "hi" ? HOMEPAGE_APP_DOWNLOAD_BANNER.hi : HOMEPAGE_APP_DOWNLOAD_BANNER.default;
}
var APP_DOWNLOAD_BANNER_SECTION_ID = "homepage-download-app";
var AppDownloadBannerV2 = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, _id = param.id, id = _id === void 0 ? APP_DOWNLOAD_BANNER_SECTION_ID : _id;
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("navigation"), t = ref.t, i18n = ref.i18n;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_7__/* .AppContext */ .Il), userId = ref1.userId, name = ref1.name, serviceType = ref1.serviceType, companyId = ref1.companyId;
    var bannerImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return getHomepageAppDownloadBannerImage(i18n.language);
    }, [
        i18n.language
    ]);
    var trackDownload = function(store) {
        if (store === "app_store") {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__/* .GA4EventNames.WEB_V2.download_appstore */ .wQ.WEB_V2.download_appstore, eventData);
        } else {
            trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__/* .GA4EventNames.WEB_V2.download_playstore */ .wQ.WEB_V2.download_playstore, eventData);
        }
        (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_8__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__/* .GA4EventNames.Homepage_other_Activity */ .wQ.Homepage_other_Activity, {
            value: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__/* .GA4HomepageOtherActivityEventValues.playstore */ .aj.playstore
        });
        (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_8__/* .moEngageUserEventTrack */ .Im)("download_app_clicked_web", {
            user_id: userId,
            user_name: name,
            service_type: serviceType,
            source_section: "Homepage v2 app download section",
            store: store
        });
        (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_8__/* .ga4sendEvent */ .zs)(_vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__/* .GA4EventNames.Download_app_clicked_web */ .wQ.Download_app_clicked_web, {
            company_id: companyId,
            user_name: name,
            service_type: serviceType,
            source_screen: _vahak_core_dist_constants_event_names__WEBPACK_IMPORTED_MODULE_9__/* .GA4AppClickSource.homepage_middle_section */ .kw.homepage_middle_section
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_section_card_HomepageV2SectionCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        variant: "dark",
        id: id,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().banner),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "fade-right",
                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().eyebrow),
                                children: t("appDownload.eyebrow")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().titleLine),
                                        children: t("appDownload.titleLine1")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().titleLine),
                                        children: t("appDownload.titleLine2")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().subtitle),
                                children: t("appDownload.subtitle")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeButtons),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_download_app_qr_modal_DownloadAppAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        href: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_12__/* .APP_STORE_URL */ .l5v,
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeButton),
                                        storeUrl: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_12__/* .APP_STORE_URL */ .l5v,
                                        onClick: function() {
                                            return trackDownload("app_store");
                                        },
                                        "aria-label": t("appDownload.downloadAppStore"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeIcon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_apple_store_mark_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    "aria-hidden": true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeText),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeLabel),
                                                        children: t("appDownload.storeButtons.downloadOn")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeName),
                                                        children: t("appDownload.storeButtons.appStore")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_download_app_qr_modal_DownloadAppAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        href: PLAY_STORE_URL,
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeButton),
                                        storeUrl: PLAY_STORE_URL,
                                        onClick: function() {
                                            return trackDownload("play_store");
                                        },
                                        "aria-label": t("appDownload.downloadPlayStore"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeIcon),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_standard_icons_google_play_mark_svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    "aria-hidden": true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeText),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeLabel),
                                                        children: t("appDownload.storeButtons.getItOn")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().storeName),
                                                        children: t("appDownload.storeButtons.googlePlay")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().stats),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().stat),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().statValue),
                                                children: t("appDownload.ratings.downloadsValue")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().statLabel),
                                                children: t("appDownload.ratings.downloadsLabel")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().statDivider),
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().stat),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().statValue),
                                                children: t("appDownload.ratings.playStoreValue")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().statLabel),
                                                children: t("appDownload.ratings.playStoreLabel")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_animate_HomepageV2Animate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        variant: "fade-left",
                        delay: 150,
                        className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().imageCol),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_AppImg__WEBPACK_IMPORTED_MODULE_4__["default"], {
                            src: bannerImage,
                            alt: t("appDownload.imageAlt"),
                            width: 400,
                            height: 600,
                            className: (_AppDownloadBannerV2_module_scss__WEBPACK_IMPORTED_MODULE_13___default().bannerImage)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppDownloadBannerV2);


/***/ }),

/***/ 64200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$v": function() { return /* binding */ useCompactLoadBiddingOptional; },
/* harmony export */   "dh": function() { return /* binding */ useCompactLoadBidding; },
/* harmony export */   "mx": function() { return /* binding */ CompactLoadBiddingProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42386);
/* harmony import */ var _hooks_useLoadI18nNamespaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54351);
/* harmony import */ var _methods_getRouteLocalizationNamespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19736);






var CompactLoadBiddingModal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4304), __webpack_require__.e(6090), __webpack_require__.e(5502), __webpack_require__.e(4800), __webpack_require__.e(2181), __webpack_require__.e(6484), __webpack_require__.e(1217), __webpack_require__.e(3128), __webpack_require__.e(3941), __webpack_require__.e(7678), __webpack_require__.e(5736), __webpack_require__.e(254), __webpack_require__.e(6547), __webpack_require__.e(3630), __webpack_require__.e(5262), __webpack_require__.e(8491), __webpack_require__.e(4732), __webpack_require__.e(2533), __webpack_require__.e(2765), __webpack_require__.e(5326), __webpack_require__.e(3569), __webpack_require__.e(5309)]).then(__webpack_require__.bind(__webpack_require__, 91483));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91483)
            ];
        }
    },
    ssr: false
});
var CompactLoadBiddingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
function CompactLoadBiddingProvider(param) {
    var children = param.children, trackEvent = param.trackEvent, eventData = param.eventData;
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().i18n;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), loadData = ref1[0], setLoadData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), onSuccess = ref2[0], setOnSuccess = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), trackRank = ref3[0], setTrackRank = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("closed"), sessionKey = ref4[0], setSessionKey = ref4[1];
    var openCompactBidding = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var nextLoad = param.loadData, nextOnSuccess = param.onSuccess, rank = param.trackRank;
        void (0,_hooks_useLoadI18nNamespaces__WEBPACK_IMPORTED_MODULE_4__/* .loadI18nNamespaces */ .Z$)(i18n, _methods_getRouteLocalizationNamespaces__WEBPACK_IMPORTED_MODULE_5__/* .WEB_V2_BIDDING_LOCALIZATION_NAMESPACES */ .ev).then(function() {
            var ref;
            setLoadData(nextLoad);
            setOnSuccess(function() {
                return nextOnSuccess;
            });
            setTrackRank(rank);
            setSessionKey(String(((ref = nextLoad.load_detail) === null || ref === void 0 ? void 0 : ref.id) || Date.now()));
            setIsOpen(true);
        });
    }, [
        i18n
    ]);
    var closeCompactBidding = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsOpen(false);
    }, []);
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            isCompactBiddingOpen: isOpen,
            openCompactBidding: openCompactBidding,
            closeCompactBidding: closeCompactBidding
        };
    }, [
        closeCompactBidding,
        isOpen,
        openCompactBidding
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CompactLoadBiddingContext.Provider, {
        value: value,
        children: [
            children,
            isOpen && loadData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompactLoadBiddingModal, {
                isOpen: isOpen,
                loadData: loadData,
                onClose: closeCompactBidding,
                onSuccess: onSuccess,
                trackRank: trackRank,
                trackEvent: trackEvent,
                eventData: eventData
            }, sessionKey) : null
        ]
    });
}
function useCompactLoadBidding() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CompactLoadBiddingContext);
    if (!context) {
        throw new Error("useCompactLoadBidding must be used within CompactLoadBiddingProvider");
    }
    return context;
}
/** Non-throwing variant. Returns `null` when no provider is mounted. */ function useCompactLoadBiddingOptional() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CompactLoadBiddingContext);
}


/***/ }),

/***/ 56193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c4": function() { return /* binding */ CompactLoadPostingProvider; },
  "S$": function() { return /* binding */ useCompactLoadPosting; },
  "qA": function() { return /* binding */ useCompactLoadPostingOptional; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./hooks/useLoadI18nNamespaces.ts
var useLoadI18nNamespaces = __webpack_require__(54351);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/constants/api.js
var api = __webpack_require__(24966);
// EXTERNAL MODULE: ../core/dist/constants/lorryStatus.js
var lorryStatus = __webpack_require__(69673);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useLorryMarketService.js + 1 modules
var useLorryMarketService = __webpack_require__(53171);
// EXTERNAL MODULE: ./constants/deep-links.ts
var deep_links = __webpack_require__(73278);
// EXTERNAL MODULE: ./context/load-lorry-posting.tsx
var load_lorry_posting = __webpack_require__(8574);
// EXTERNAL MODULE: ./components/dashboard/list-wrapper/lorry-list/lorry-card/LorryCard.tsx + 2 modules
var LorryCard = __webpack_require__(1783);
// EXTERNAL MODULE: ./components/posting/helpers/constants.ts
var constants = __webpack_require__(40607);
// EXTERNAL MODULE: ./components/posting/lorry-posting/helpers/constants.ts
var helpers_constants = __webpack_require__(90376);
// EXTERNAL MODULE: ./methods/generataMaskUrlWithParams.ts
var generataMaskUrlWithParams = __webpack_require__(32740);
// EXTERNAL MODULE: ./hooks/useOpenNewLoadPosting.ts
var useOpenNewLoadPosting = __webpack_require__(68498);
// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
;// CONCATENATED MODULE: ./hooks/useLoadAddDeepLink.ts

















function isHomepagePath(pathname) {
    return pathname === "/";
}
function isDashboardPath(pathname, asPath) {
    var pathWithoutQuery = asPath.split("?")[0].split("#")[0];
    return pathname.endsWith("/dashboard") || pathWithoutQuery === "/dashboard";
}
function stripDeepLinkQuery(router) {
    var extraKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
    delete newQuery[deep_links/* DEEP_LINK_QUERY_PARAM */.t6];
    delete newQuery[deep_links/* DEEP_LINK_QUERY_PARAM_LEGACY */.b7];
    extraKeys.forEach(function(key) {
        delete newQuery[key];
    });
    delete newQuery._branch_match_id;
    delete newQuery._branch_referrer;
    delete newQuery.utm_medium;
    delete newQuery.utm_source;
    delete newQuery.utm_campaign;
    delete newQuery.u_i;
    router.replace({
        pathname: router.pathname,
        query: newQuery
    }, undefined, {
        shallow: true
    });
}
function openLoginModal(router) {
    var ref;
    if ((ref = router.asPath.split("#")[1]) === null || ref === void 0 ? void 0 : ref.includes("Login")) {
        return;
    }
    // Hash only — passing `query` rewrites `action=load|details` and retriggers this effect.
    router.push({
        hash: "Login"
    }, undefined, {
        shallow: true
    });
}
/**
 * Handles web `?action=` deep links mounted app-wide from CompactLoadPostingProvider.
 *
 * - `load|add` — compact posting (logged-out on `/`, logged-in on `/dashboard`)
 * - `load|details` — my-loads listing `?id=` (auth required; HomepageV2AuthGuard / post-login redirect)
 * - `lorry|reactivate` — my-lorries listing, then lorry re-post modal (auth required)
 */ function useLoadAddDeepLink() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref1.isPhoneVerified, companyId = ref1.companyId, customerCompanyId = ref1.customerCompanyId, setShouldPreventLayoutSwitch = ref1.setShouldPreventLayoutSwitch;
    var openCompactPosting = (ref = useCompactLoadPostingOptional()) === null || ref === void 0 ? void 0 : ref.openCompactPosting;
    var openNewLoadPosting = (0,useOpenNewLoadPosting/* default */.Z)();
    var updateLoadLorryPostingData = (0,load_lorry_posting/* useLoadLorryPosting */.NS)().updateLoadLorryPostingData;
    var ValidateLorryPosting = (0,useValidateUserStatus/* default */.Z)().ValidateLorryPosting;
    var hasHandledRef = (0,react.useRef)(false);
    var hasOpenedLoginRef = (0,react.useRef)(false);
    var isLoggedIn = Boolean(isPhoneVerified && companyId);
    var isLoadAdd = (0,deep_links/* isLoadAddDeepLink */.eu)(router.query, router.asPath);
    var isLoadDetails = (0,deep_links/* isLoadDetailsDeepLink */.kg)(router.query, router.asPath);
    var isLorryReactivate = (0,deep_links/* isLorryReactivateDeepLink */.mz)(router.query, router.asPath);
    var needsAuth = (0,deep_links/* isAuthRequiredDeepLink */.ty)(router.query, router.asPath);
    var lorryId = isLorryReactivate ? (0,deep_links/* getRedirectQueryValue */.sf)(router.query, deep_links/* DEEP_LINK_LORRY_ID_PARAM */.AI) : undefined;
    var listingCompanyId = Number(customerCompanyId || companyId) || undefined;
    var onMyLorriesListing = (0,deep_links/* isMyLorriesListingPath */.AC)(router.pathname, router.asPath);
    var ref2 = (0,useLorryMarketService/* useGetLorriesForCurrentUserQuery */.c)({
        companyId: listingCompanyId,
        request_type: api/* API_REQUEST_TYPE.ELASTIC_SEARCH */.wU.ELASTIC_SEARCH,
        id: lorryId ? [
            Number(lorryId)
        ] : undefined
    }, {
        enabled: Boolean(isLoggedIn && isLorryReactivate && lorryId && onMyLorriesListing && listingCompanyId)
    }), lorryQueryData = ref2.data, isFetchingLorry = ref2.isFetching, isLoadingLorry = ref2.isLoading;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        if (!router.isReady || hasHandledRef.current) {
            return;
        }
        if (!isLoadAdd && !isLoadDetails && !isLorryReactivate) {
            return;
        }
        var onHomepage = isHomepagePath(router.pathname);
        var onDashboard = isDashboardPath(router.pathname, router.asPath);
        var onMyLoadsListing = (0,deep_links/* isMyLoadsListingPath */.YS)(router.pathname, router.asPath);
        if (needsAuth && !isLoggedIn) {
            if (!onHomepage || hasOpenedLoginRef.current) {
                return;
            }
            hasOpenedLoginRef.current = true;
            setShouldPreventLayoutSwitch === null || setShouldPreventLayoutSwitch === void 0 ? void 0 : setShouldPreventLayoutSwitch(true);
            openLoginModal(router);
            return;
        }
        if (isLoadAdd) {
            if (isLoggedIn) {
                if (!onDashboard) {
                    return;
                }
                hasHandledRef.current = true;
                openNewLoadPosting({
                    originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.DASHBOARD */.ec.DASHBOARD,
                    afterOpen: function() {
                        stripDeepLinkQuery(router);
                    }
                });
                return;
            }
            if (!onHomepage || !openCompactPosting) {
                return;
            }
            openCompactPosting();
            hasHandledRef.current = true;
            stripDeepLinkQuery(router);
            return;
        }
        if (isLoadDetails) {
            if (!onMyLoadsListing) {
                return;
            }
            hasHandledRef.current = true;
            stripDeepLinkQuery(router);
            return;
        }
        if (!onMyLorriesListing) {
            return;
        }
        if (!lorryId) {
            hasHandledRef.current = true;
            toast/* toast.error */.A.error("Lorry id is missing");
            stripDeepLinkQuery(router, [
                deep_links/* DEEP_LINK_LORRY_ID_PARAM */.AI
            ]);
            return;
        }
        if (!listingCompanyId || isFetchingLorry || isLoadingLorry) {
            return;
        }
        var lorryCard = lorryQueryData === null || lorryQueryData === void 0 ? void 0 : (ref = lorryQueryData.pages) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.results) === null || ref2 === void 0 ? void 0 : ref2[0];
        hasHandledRef.current = true;
        if (!(lorryCard === null || lorryCard === void 0 ? void 0 : lorryCard.lorry_detail)) {
            toast/* toast.error */.A.error("Lorry not found");
            stripDeepLinkQuery(router, [
                deep_links/* DEEP_LINK_LORRY_ID_PARAM */.AI
            ]);
            return;
        }
        if (lorryCard.lorry_detail.status !== lorryStatus/* LORRY_STATUS.IN_ACTIVE */.un.IN_ACTIVE) {
            toast/* toast.error */.A.error("This lorry cannot be reactivated");
            stripDeepLinkQuery(router, [
                deep_links/* DEEP_LINK_LORRY_ID_PARAM */.AI
            ]);
            return;
        }
        var lorryDetailId = lorryCard.lorry_detail.id;
        ValidateLorryPosting === null || ValidateLorryPosting === void 0 ? void 0 : ValidateLorryPosting(function() {
            updateLoadLorryPostingData({
                category: "re-post",
                isModalOpen: true,
                type: "lorry",
                data: {
                    id: lorryDetailId,
                    values: (0,LorryCard/* getLorryPreFilledData */["if"])(lorryCard)
                },
                originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.DASHBOARD */.ec.DASHBOARD
            });
            var newQuery = (0,_object_spread/* default */.Z)({}, router.query);
            delete newQuery[deep_links/* DEEP_LINK_QUERY_PARAM */.t6];
            delete newQuery[deep_links/* DEEP_LINK_QUERY_PARAM_LEGACY */.b7];
            delete newQuery[deep_links/* DEEP_LINK_LORRY_ID_PARAM */.AI];
            delete newQuery._branch_match_id;
            delete newQuery._branch_referrer;
            delete newQuery.utm_medium;
            delete newQuery.utm_source;
            delete newQuery.utm_campaign;
            delete newQuery.u_i;
            newQuery[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME] = constants/* LORRY_CREATION_FORM_IDS.VEHICLE_ROUTES_SELECTION */.jU.VEHICLE_ROUTES_SELECTION;
            router.push({
                query: newQuery
            }, (0,generataMaskUrlWithParams/* generataMaskUrlWithParams */.j)(newQuery), {
                shallow: true
            });
        });
    }, [
        router.isReady,
        router.pathname,
        router.asPath,
        isLoadAdd,
        isLoadDetails,
        isLorryReactivate,
        needsAuth,
        isLoggedIn,
        openCompactPosting,
        openNewLoadPosting,
        onMyLorriesListing,
        lorryId,
        listingCompanyId,
        isFetchingLorry,
        isLoadingLorry,
        lorryQueryData,
        ValidateLorryPosting,
        updateLoadLorryPostingData,
        setShouldPreventLayoutSwitch
    ]);
}

// EXTERNAL MODULE: ./methods/getRouteLocalizationNamespaces.ts
var getRouteLocalizationNamespaces = __webpack_require__(19736);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-load-posting/CompactLoadPostingProvider.tsx











var CompactLoadPostingModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(1217), __webpack_require__.e(3128), __webpack_require__.e(5794), __webpack_require__.e(2765), __webpack_require__.e(8416), __webpack_require__.e(3569), __webpack_require__.e(4999), __webpack_require__.e(5258)]).then(__webpack_require__.bind(__webpack_require__, 30047));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30047)
            ];
        }
    },
    ssr: false
});
var CompactLoadPostingContext = /*#__PURE__*/ (0,react.createContext)(null);
/** Must render inside Provider. */ function CompactLoadPostingDeepLinkEffects() {
    useLoadAddDeepLink();
    return null;
}
function buildSessionKey(values) {
    var ref, ref1;
    if (!values) {
        return "empty";
    }
    return [
        (ref = values.source) === null || ref === void 0 ? void 0 : ref.place_id,
        (ref1 = values.destination) === null || ref1 === void 0 ? void 0 : ref1.place_id,
        values.lorryType,
        values.tonnes,
        "loadId" in values ? values.loadId : undefined
    ].join("-");
}
function CompactLoadPostingProvider(param) {
    var children = param.children, trackEvent = param.trackEvent, eventData = param.eventData;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), isOpening = ref1[0], setIsOpening = ref1[1];
    var ref2 = (0,react.useState)(), initialValues = ref2[0], setInitialValues = ref2[1];
    var ref3 = (0,react.useState)(), sessionEventData = ref3[0], setSessionEventData = ref3[1];
    var ref4 = (0,react.useState)(false), isRepostSession = ref4[0], setIsRepostSession = ref4[1];
    var ref5 = (0,react.useState)(), sessionOnSuccess = ref5[0], setSessionOnSuccess = ref5[1];
    var ref6 = (0,react.useState)("closed"), sessionKey = ref6[0], setSessionKey = ref6[1];
    var openCompactPosting = (0,react.useCallback)(function(values, options) {
        setIsOpening(true);
        void (0,useLoadI18nNamespaces/* loadI18nNamespaces */.Z$)(i18n, getRouteLocalizationNamespaces/* WEB_V2_POSTING_LOCALIZATION_NAMESPACES */.ju).then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,methods/* prepareMobileSheetOpen */.lj)();
                    case 2:
                        setInitialValues(values);
                        setSessionEventData(options === null || options === void 0 ? void 0 : options.eventData);
                        setIsRepostSession(Boolean(options === null || options === void 0 ? void 0 : options.isRepost));
                        // Callback state must be set via updater wrapper, otherwise React treats
                        // the function as a state updater and executes it immediately.
                        setSessionOnSuccess(function() {
                            return options === null || options === void 0 ? void 0 : options.onSuccess;
                        });
                        setSessionKey(buildSessionKey(values));
                        setIsOpen(true);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))).finally(function() {
            setIsOpening(false);
        });
    }, [
        i18n
    ]);
    var closeCompactPosting = (0,react.useCallback)(function() {
        setIsOpen(false);
    }, []);
    var value = (0,react.useMemo)(function() {
        return {
            isCompactPostingOpen: isOpen,
            isCompactPostingOpening: isOpening,
            openCompactPosting: openCompactPosting,
            closeCompactPosting: closeCompactPosting
        };
    }, [
        closeCompactPosting,
        isOpen,
        isOpening,
        openCompactPosting
    ]);
    var mergedEventData = (0,react.useMemo)(function() {
        return (0,_object_spread/* default */.Z)({}, eventData, sessionEventData);
    }, [
        eventData,
        sessionEventData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompactLoadPostingContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactLoadPostingDeepLinkEffects, {}),
            isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactLoadPostingModal, {
                isOpen: isOpen,
                initialValues: initialValues,
                isRepost: isRepostSession,
                onSuccess: sessionOnSuccess,
                onClose: closeCompactPosting,
                trackEvent: trackEvent,
                eventData: mergedEventData
            }, sessionKey) : null
        ]
    });
}
function useCompactLoadPosting() {
    var context = (0,react.useContext)(CompactLoadPostingContext);
    if (!context) {
        throw new Error("useCompactLoadPosting must be used within CompactLoadPostingProvider");
    }
    return context;
}
/**
 * Non-throwing variant. Returns `null` when no `CompactLoadPostingProvider` is mounted
 * (e.g. the admin console, which only uses the legacy CS posting flow). Use this in
 * shared entry points that may render outside the consumer app's provider tree.
 */ function useCompactLoadPostingOptional() {
    return (0,react.useContext)(CompactLoadPostingContext);
}


/***/ }),

/***/ 82129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ mapLoadFormValuesToCompactInitialValues; },
/* harmony export */   "N": function() { return /* binding */ hasCompactRepostPrefill; }
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3970);

function mapTextToPlace(placeId, text) {
    if (!(placeId === null || placeId === void 0 ? void 0 : placeId.trim())) {
        return undefined;
    }
    var parts = text.split(",").map(function(part) {
        return part.trim();
    }).filter(Boolean);
    return {
        place_id: placeId,
        description: text,
        city: parts.length >= 2 ? parts[parts.length - 2] : parts[0],
        state: parts.length >= 1 ? parts[parts.length - 1] : undefined
    };
}
/** Maps legacy load form values (dashboard repost / edit prefill) into compact flow state. */ function mapLoadFormValuesToCompactInitialValues(values, loadId) {
    var _lorryCapacity;
    var capacity = (_lorryCapacity = values.lorryCapacity) !== null && _lorryCapacity !== void 0 ? _lorryCapacity : values.quantity;
    return {
        source: mapTextToPlace(values.srcPlaceId, values.srcText),
        destination: mapTextToPlace(values.destPlaceId, values.destText),
        lorryType: values.lorryType,
        tonnes: capacity != null && capacity !== undefined ? String(capacity) : "",
        lorryBodyType: values.lorryBodyType,
        lorrySize: values.lorrySize,
        lorryTyres: values.lorryTyres,
        sizeText: values.sizeText,
        loadingTimestamp: (0,_types__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultLoadingTimestamp */ .t)(),
        expectedAmount: values.expectedAmount,
        advancePaymentPercentage: values.advanceAmount,
        minExpectedPrice: values.minExpectedPrice,
        loadId: loadId
    };
}
function hasCompactRepostPrefill(values) {
    var ref, ref1;
    if (!values) {
        return false;
    }
    return Boolean(((ref = values.source) === null || ref === void 0 ? void 0 : ref.place_id) && ((ref1 = values.destination) === null || ref1 === void 0 ? void 0 : ref1.place_id) && values.lorryType && values.expectedAmount != null);
}


/***/ }),

/***/ 3970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ COMPACT_LOAD_POSTING_STEPS; },
/* harmony export */   "t": function() { return /* binding */ getDefaultLoadingTimestamp; }
/* harmony export */ });
var COMPACT_LOAD_POSTING_STEPS;
(function(COMPACT_LOAD_POSTING_STEPS) {
    COMPACT_LOAD_POSTING_STEPS["ROUTE_DETAILS"] = "routeDetails";
    COMPACT_LOAD_POSTING_STEPS["LOAD_DETAILS"] = "loadDetails";
    COMPACT_LOAD_POSTING_STEPS["FREIGHT_QUOTE"] = "freightQuote";
    COMPACT_LOAD_POSTING_STEPS["LOGIN"] = "login";
    COMPACT_LOAD_POSTING_STEPS["SUCCESS"] = "success";
    COMPACT_LOAD_POSTING_STEPS["ERROR"] = "error";
})(COMPACT_LOAD_POSTING_STEPS || (COMPACT_LOAD_POSTING_STEPS = {}));
function getDefaultLoadingTimestamp() {
    var date = new Date();
    date.setHours(date.getHours() + 4, 0, 0, 0);
    return Math.floor(date.getTime() / 1000);
}


/***/ }),

/***/ 68628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getCompactAppDownloadBannerImage; },
/* harmony export */   "X": function() { return /* binding */ COMPACT_APP_DOWNLOAD; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39422);

var COMPACT_APP_DOWNLOAD = {
    appStoreUrl: _vahak_core_dist_constants_link__WEBPACK_IMPORTED_MODULE_0__/* .APP_STORE_URL */ .l5,
    playStoreUrl: "https://6r7cz.app.link/googleplay",
    promoImages: {
        default: "homepage-v2/app-download-banner.png",
        hi: "homepage-v2/app-download-banner-hi.png"
    }
};
function getCompactAppDownloadBannerImage(locale) {
    return locale === "hi" ? COMPACT_APP_DOWNLOAD.promoImages.hi : COMPACT_APP_DOWNLOAD.promoImages.default;
}


/***/ }),

/***/ 69564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yb": function() { return /* reexport */ types/* MANDATORY_VERIFICATION_PAYMENT_WINDOW_KEY */.y; },
  "lX": function() { return /* reexport */ MidnightVerificationProvider; },
  "NJ": function() { return /* reexport */ isMidnightPostingVerificationWindow; },
  "Yf": function() { return /* reexport */ useMidnightVerificationOptional; }
});

// UNUSED EXPORTS: useMidnightVerification

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/homepage-v2/midnight-load-verification/MidnightVerificationProvider.tsx



var MidnightVerificationPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4235).then(__webpack_require__.bind(__webpack_require__, 14235));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14235)
            ];
        }
    },
    ssr: false
});
var MidnightVerificationContext = /*#__PURE__*/ (0,react.createContext)(null);
/**
 * Standalone midnight verification module.
 * Owns its own popup / payment / expire lifecycle — independent of compact load posting UI.
 */ function MidnightVerificationProvider(param) {
    var children = param.children;
    var ref = (0,react.useState)(null), session = ref[0], setSession = ref[1];
    var openMidnightVerification = (0,react.useCallback)(function(nextSession) {
        setSession(nextSession);
    }, []);
    var closeMidnightVerification = (0,react.useCallback)(function() {
        setSession(null);
    }, []);
    var value = (0,react.useMemo)(function() {
        return {
            isMidnightVerificationOpen: !!session,
            openMidnightVerification: openMidnightVerification,
            closeMidnightVerification: closeMidnightVerification
        };
    }, [
        closeMidnightVerification,
        openMidnightVerification,
        session
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MidnightVerificationContext.Provider, {
        value: value,
        children: [
            children,
            session ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MidnightVerificationPopup, {
                isOpen: !!session,
                session: session,
                onClose: closeMidnightVerification
            }, "midnight-".concat(session.loadId)) : null
        ]
    });
}
function useMidnightVerification() {
    var context = useContext(MidnightVerificationContext);
    if (!context) {
        throw new Error("useMidnightVerification must be used within MidnightVerificationProvider");
    }
    return context;
}
/** Non-throwing variant for surfaces that may render outside the provider tree. */ function useMidnightVerificationOptional() {
    return (0,react.useContext)(MidnightVerificationContext);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
;// CONCATENATED MODULE: ./components/homepage-v2/midnight-load-verification/isMidnightPostingVerificationWindow.ts

function parseConfigDate(dateStr) {
    var ref = (0,_sliced_to_array/* default */.Z)(dateStr.split("/").map(Number), 3), day = ref[0], month = ref[1], year = ref[2];
    if (!day || !month || !year) {
        return null;
    }
    var date = new Date(year, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
}
/** Parses times like "9:00 PM" / "7:00 AM" into minutes from midnight. */ function parseAmPmTimeToMinutes(timeStr) {
    var match = timeStr.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!match) {
        return null;
    }
    var hours = Number(match[1]);
    var minutes = Number(match[2]);
    var period = match[3].toUpperCase();
    if (!Number.isFinite(hours) || !Number.isFinite(minutes) || hours < 1 || hours > 12 || minutes < 0 || minutes > 59) {
        return null;
    }
    if (hours === 12) {
        hours = 0;
    }
    if (period === "PM") {
        hours += 12;
    }
    return hours * 60 + minutes;
}
function isDateInFeatureWindow(date, config) {
    var startDate = parseConfigDate(config.from_date || "");
    var endDate = parseConfigDate(config.to_date || "");
    if (!startDate || !endDate) {
        return false;
    }
    var dayOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return dayOnly >= startDate && dayOnly <= endDate;
}
function isTimeInPaymentWindow(date, config) {
    var startMinutes = parseAmPmTimeToMinutes(config.payment_start_time || "");
    var endMinutes = parseAmPmTimeToMinutes(config.payment_end_time || "");
    if (startMinutes == null || endMinutes == null) {
        return false;
    }
    var nowMinutes = date.getHours() * 60 + date.getMinutes();
    // Same-day window (e.g. 9:00 AM → 5:00 PM)
    if (startMinutes <= endMinutes) {
        return nowMinutes >= startMinutes && nowMinutes < endMinutes;
    }
    // Overnight window (e.g. 9:00 PM → 7:00 AM)
    return nowMinutes >= startMinutes || nowMinutes < endMinutes;
}
/** Returns true when verification payment is required for posting at `date` (local time). */ function isMidnightPostingVerificationWindow(date, config) {
    if (!(config === null || config === void 0 ? void 0 : config.is_enabled)) {
        return false;
    }
    return isDateInFeatureWindow(date, config) && isTimeInPaymentWindow(date, config);
}

// EXTERNAL MODULE: ./components/homepage-v2/midnight-load-verification/types.ts
var types = __webpack_require__(92963);
;// CONCATENATED MODULE: ./components/homepage-v2/midnight-load-verification/index.ts





/***/ }),

/***/ 92963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MANDATORY_VERIFICATION_PAYMENT_WINDOW_KEY; }
/* harmony export */ });
var MANDATORY_VERIFICATION_PAYMENT_WINDOW_KEY = "mandatory_verification_amount_payment_window";


/***/ }),

/***/ 63968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomepageV2SectionCard_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36042);
/* harmony import */ var _HomepageV2SectionCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_HomepageV2SectionCard_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var HomepageV2SectionCard = function(param) {
    var variant = param.variant, tmp = param.as, Component = tmp === void 0 ? "section" : tmp, id = param.id, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        id: id,
        tabIndex: id ? -1 : undefined,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HomepageV2SectionCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().card), (_HomepageV2SectionCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant], id && (_HomepageV2SectionCard_module_scss__WEBPACK_IMPORTED_MODULE_3___default().scrollTarget), className),
        "data-variant": variant,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomepageV2SectionCard);


/***/ }),

/***/ 89363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SideNavLayoutWrapper_SideNavLayoutWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./components/layout/side-nav-layout-new/SideNavLayout.module.scss
var SideNavLayout_module = __webpack_require__(61283);
var SideNavLayout_module_default = /*#__PURE__*/__webpack_require__.n(SideNavLayout_module);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core/dist/icons/VahakLogoLightBlue.svg
var VahakLogoLightBlue = __webpack_require__(38772);
;// CONCATENATED MODULE: ../core/dist/icons/Vahak_Nav_Logo.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVahakNavLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 43,
    height: 55,
    viewBox: "0 0 43 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.55 22.958a9.71 9.71 0 01-.834 4.23 8.887 8.887 0 01-.566.813c.22-.042.433-.113.634-.212a2.97 2.97 0 001.139-1.393 3.001 3.001 0 00.13-1.801 5.9 5.9 0 00-.512-1.638l.01.001zm15.335-3.996H32.86a13.733 13.733 0 002.114 4.595c.748 1.178 1.536 2.327 2.208 3.55a22.18 22.18 0 012.792 8.578c.496 5.147-2.187 9.34-6.8 11.584-2.916 1.412-5.554 2.1-7.848 3.797a14.242 14.242 0 00-3.437 3.931c.245-5.485 5.466-6.628 9.61-8.665 4.76-2.336 6.834-6.147 6.248-11.179-.684-4.355-2.421-7.267-4.447-10.63a26.59 26.59 0 01-2.5-4.78 9.471 9.471 0 01-.522-2.7 31.679 31.679 0 00-18.273 0 9.51 9.51 0 01-.523 2.7 27.04 27.04 0 01-2.5 4.783c-2.038 3.368-3.775 6.272-4.458 10.627-.587 5.031 1.49 8.836 6.248 11.181 4.143 2.037 9.365 3.18 9.607 8.666a14.232 14.232 0 00-3.433-3.933c-2.303-1.699-4.945-2.391-7.847-3.797-4.611-2.244-7.304-6.437-6.8-11.584a22.35 22.35 0 012.789-8.578c.672-1.223 1.457-2.376 2.21-3.55a13.691 13.691 0 002.114-4.595h-1.02a13.543 13.543 0 01-1.535 3.256c-2.562 4.213-5.502 7.889-5.721 13.166a23.47 23.47 0 00.229 3.572A7.342 7.342 0 01.09 35.599a11.383 11.383 0 01.25-4.194c.764-3.205 2.562-5.962 4.099-8.802a12.429 12.429 0 001.708-4.247c.07-.49-.02-.988-.253-1.423a2.288 2.288 0 00-1.043-.99c.399-.262.857-.419 1.333-.455a2.097 2.097 0 011.743.754 39.869 39.869 0 00-.955-4.527 33.07 33.07 0 00-1.068-3.336 37.902 37.902 0 00-.701-1.768H5.02a1.56 1.56 0 01-1.135-.385 1.589 1.589 0 01-.535-1.082c.057-.407.259-.78.567-1.049a1.68 1.68 0 012.218.006c.307.271.506.645.562 1.052a1.424 1.424 0 01-.703 1.188 30.802 30.802 0 004.502 5.015A4.57 4.57 0 0012.62 9.38a4.63 4.63 0 00.519-2.866 1.542 1.542 0 01-1.044-.426 1.57 1.57 0 01-.483-1.026c.058-.407.26-.78.568-1.049a1.68 1.68 0 012.217.007c.307.27.507.644.562 1.051-.02.346-.156.674-.385.931a1.51 1.51 0 01-.876.487 7.282 7.282 0 004.088 3.142c-.4.838-.939 1.602-1.592 2.258-1.48.328-2.917.827-4.282 1.488a8.216 8.216 0 01-2.154-.212 1.558 1.558 0 00-.492-.087c.45.738.803 1.533 1.046 2.364 5.404-2.207 16.217-2.2 21.662.016a10.86 10.86 0 011.016-2.39 1.556 1.556 0 00-.492.088 8.212 8.212 0 01-2.154.211 19.457 19.457 0 00-4.287-1.496 8.249 8.249 0 01-1.593-2.257 7.306 7.306 0 004.092-3.143 1.5 1.5 0 01-.877-.48 1.524 1.524 0 01-.386-.93 1.71 1.71 0 01.567-1.049 1.682 1.682 0 012.22.006c.307.27.507.644.562 1.052-.028.39-.2.757-.483 1.026-.282.268-.654.42-1.043.426-.141.988.04 1.995.517 2.87a4.57 4.57 0 002.124 1.979 32.612 32.612 0 004.527-5.016 1.406 1.406 0 01-.705-1.187c.058-.408.26-.78.568-1.049a1.68 1.68 0 012.217.006c.307.27.507.644.562 1.052a1.59 1.59 0 01-.535 1.083 1.56 1.56 0 01-1.138.386h-.192a40.603 40.603 0 00-.7 1.767 34.512 34.512 0 00-1.06 3.335 43.83 43.83 0 00-1.073 4.648c.207-.302.487-.545.814-.707a2.112 2.112 0 011.051-.217c.475.039.932.197 1.33.461-.446.208-.812.555-1.045.99a2.315 2.315 0 00-.252 1.423c.3 1.51.88 2.951 1.708 4.247 1.54 2.843 3.332 5.598 4.101 8.801.344 1.372.429 2.796.252 4.199a7.383 7.383 0 01-1.276 3.357c.17-1.183.246-2.378.23-3.573-.218-5.279-3.155-8.953-5.715-13.168a13.444 13.444 0 01-1.532-3.251l-.01.004zM21.53 2.937a1.54 1.54 0 00.883-.497c.23-.26.368-.592.389-.942a1.752 1.752 0 00-.58-1.071 1.723 1.723 0 00-2.268 0c-.314.275-.52.655-.58 1.071.022.367.17.714.417.983.247.269.58.443.94.492a20.541 20.541 0 01-3.605 8.643l-.013.032h8.03l-.01-.032a20.55 20.55 0 01-3.607-8.675l.003-.004zm5.17 37.244c-1.252 2.207-2.325 1.885-3.413 1.397a4.62 4.62 0 00-4.267-.023c-1.104.502-2.187.874-3.462-1.372a1.744 1.744 0 00.119 2.188c1.507 1.277 4.122 1.614 5.21 4.223.051.62.436.62.488 0 1.09-2.608 3.706-2.941 5.208-4.223a1.74 1.74 0 00.119-2.188l-.001-.002zm-9.272-18.475a8.561 8.561 0 01-.843 5.41c-.546.861-1.163 1.67-1.716 2.461-2.154 3.087-2.052 6.236-.453 8.457a10.29 10.29 0 013.756-2.39c.593-.248 1.201-.456 1.82-.623.466-1.613-1.183-4.165-2.368-4.668a7.458 7.458 0 00-1.595-.383s.078-.305 1.2-1.1a2.685 2.685 0 012.515-.122c.422.164.867.256 1.319.275h.116a3.951 3.951 0 001.317-.275 2.707 2.707 0 012.519.121c1.126.792 1.2 1.101 1.2 1.101a7.487 7.487 0 00-1.598.383c-1.193.502-2.84 3.055-2.368 4.668.62.165 1.23.373 1.822.624a10.498 10.498 0 013.756 2.39c1.6-2.222 1.7-5.37-.452-8.457-.545-.792-1.165-1.6-1.715-2.46a8.553 8.553 0 01-.845-5.41 12.622 12.622 0 014.034-.459c.469 0 .93.108 1.35.316.421.209.788.512 1.074.886 0 0-1.36.122-1.736.737-.375.615-.654.487-1.09.487-3.368 0-1.384-.792-2.778-1.47-.037.69-.006 1.38.093 2.064a11.82 11.82 0 002.794 5.107c2.61 3.366 3.887 9.034-.298 11.983-1.63-2.376-4.177-4.884-7.046-4.914h-.182c-2.868.025-5.417 2.537-7.045 4.914-4.185-2.942-2.915-8.617-.3-11.983a11.797 11.797 0 002.798-5.107c.097-.684.128-1.375.093-2.064-1.396.674.588 1.466-2.78 1.466-.436 0-.719.121-1.09-.487-.372-.608-1.737-.736-1.737-.736a3.07 3.07 0 011.073-.886 3.04 3.04 0 011.35-.317 12.54 12.54 0 014.034.458l.002.003zM11.09 32.469c-.864 3.094-1.7 6.436 2.604 9.745.262.2.565.408.899.616a36.142 36.142 0 013.923 2.227 4.78 4.78 0 011.648 2.031c.35.819.468 1.72.339 2.602a3.299 3.299 0 00-.334-.81 9.767 9.767 0 00-2.869-3.273 38.486 38.486 0 00-3.597-1.838C9.67 41.65 7.862 38.302 9.098 33.565c.836-3.204 1.786-5.074.033-8.05 3.462.836 2.64 4.521 1.962 6.97l-.002-.016zm-2.352-5.76s.048.145.1.355c.19.856.204 1.742.04 2.604-.347 1.998-1.231 3.781-1.405 5.845a8.713 8.713 0 001.351 5.917 10.155 10.155 0 003.15 2.758c1.261.716 2.604 1.217 3.904 1.928 2.072 1.133 4.821 3.168 4.601 5.94-.73-1.754-2.768-3.335-4.446-4.291-1.478-.838-3.221-1.531-4.81-2.344a9.698 9.698 0 01-3.29-2.447 9.805 9.805 0 01-1.998-3.598c-.485-2.31-.335-4.71.433-6.94a24.767 24.767 0 012.371-5.73l-.001.003zm10.577-8.62c-1.03-.736-3.25-.244-3.25-.244.48.127.95.29 1.405.487.8.408 1.529.943 2.16 1.584a2.528 2.528 0 003.007 0 8.15 8.15 0 012.158-1.584c.456-.198.926-.36 1.406-.487 0 0-2.223-.487-3.253.243-1.438 1.03-2.17 1.03-3.627 0h-.006zm11.85 14.37c.865 3.095 1.7 6.437-2.606 9.746-.262.199-.565.407-.896.616a35.667 35.667 0 00-3.923 2.227 4.787 4.787 0 00-1.648 2.03 4.836 4.836 0 00-.341 2.603 3.35 3.35 0 01.334-.81 9.732 9.732 0 012.87-3.282 39.153 39.153 0 013.596-1.839c4.035-2.118 5.844-5.466 4.606-10.202-.835-3.206-1.783-5.076-.03-8.058-3.473.836-2.642 4.521-1.962 6.97zm2.37-5.766s-.05.145-.1.355a6.539 6.539 0 00-.041 2.604c.345 1.998 1.23 3.785 1.406 5.847a8.715 8.715 0 01-1.36 5.916 10.184 10.184 0 01-3.148 2.759c-1.267.715-2.607 1.217-3.914 1.933-2.077 1.134-4.824 3.168-4.601 5.94.73-1.755 2.768-3.337 4.446-4.291 1.477-.838 3.224-1.533 4.812-2.346a9.705 9.705 0 003.286-2.445 9.813 9.813 0 001.999-3.593 13.102 13.102 0 00-.427-6.944 24.788 24.788 0 00-2.381-5.732l.023-.003zm-9.832-3.73a5.858 5.858 0 00-.51 1.638c-.14.6-.092 1.228.136 1.8a2.978 2.978 0 001.14 1.39c.2.1.414.171.633.214a8.743 8.743 0 01-.567-.814 9.793 9.793 0 01-.834-4.223",
    fill: "#BECDF7"
  })));
}

/* harmony default export */ var Vahak_Nav_Logo = (SvgVahakNavLogo);
;// CONCATENATED MODULE: ../core/dist/icons/Post_Nav_Load_Lorry.svg
var _rect, Post_Nav_Load_Lorry_path;

function Post_Nav_Load_Lorry_extends() { Post_Nav_Load_Lorry_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Post_Nav_Load_Lorry_extends.apply(this, arguments); }



function SvgPostNavLoadLorry(props) {
  return /*#__PURE__*/react.createElement("svg", Post_Nav_Load_Lorry_extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#fff"
  })), Post_Nav_Load_Lorry_path || (Post_Nav_Load_Lorry_path = /*#__PURE__*/react.createElement("path", {
    d: "M26.25 33.892v-7.5h7.5a1.25 1.25 0 000-2.5h-7.5v-7.5a1.25 1.25 0 00-2.5 0v7.5h-7.5a1.25 1.25 0 100 2.5h7.5v7.5a1.25 1.25 0 102.5 0z",
    fill: "#2355FC",
    stroke: "#2355FC",
    strokeWidth: 0.6
  })));
}

/* harmony default export */ var Post_Nav_Load_Lorry = (SvgPostNavLoadLorry);
;// CONCATENATED MODULE: ../core/dist/icons/add_blue.svg
var _g, _defs;

function add_blue_extends() { add_blue_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return add_blue_extends.apply(this, arguments); }



function SvgAddBlue(props) {
  return /*#__PURE__*/react.createElement("svg", add_blue_extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#add_blue_svg__clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M11.25 5.25h-4.5V.75a.75.75 0 00-1.5 0v4.5H.75a.75.75 0 000 1.5h4.5v4.5a.75.75 0 101.5 0v-4.5h4.5a.75.75 0 100-1.5z",
    fill: "#2355FC",
    stroke: "#2355FC"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "add_blue_svg__clip0"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

/* harmony default export */ var add_blue = (SvgAddBlue);
// EXTERNAL MODULE: ../core/dist/hooks/useToggleModalWithLocalState.js
var useToggleModalWithLocalState = __webpack_require__(73778);
// EXTERNAL MODULE: ../core/dist/constants/automation.js
var automation = __webpack_require__(46426);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ./constants/marketplace.constants.ts
var marketplace_constants = __webpack_require__(57993);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/components/dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(92266);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/Button.js + 1 modules
var Button = __webpack_require__(48126);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ./components/utils/avatar-image/AvatarImage.tsx
var AvatarImage = __webpack_require__(53325);
// EXTERNAL MODULE: ./components/login-form-new/hooks/performLogoutAndRedirectHome.ts
var performLogoutAndRedirectHome = __webpack_require__(947);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
// EXTERNAL MODULE: ./components/posting/lorry-posting/helpers/constants.ts
var constants = __webpack_require__(90376);
// EXTERNAL MODULE: ./components/posting/load-posting/helpers/constants.ts
var helpers_constants = __webpack_require__(5283);
// EXTERNAL MODULE: ./hooks/useFeatureByServiceType.ts
var useFeatureByServiceType = __webpack_require__(57);
// EXTERNAL MODULE: ../core/dist/constants/admin/screenId.js
var screenId = __webpack_require__(22391);
;// CONCATENATED MODULE: ./utils/getEventSourceScreenAdminConsole.ts


var getEventSourceScreenAdminConsole = function(id) {
    switch(id){
        case screenId/* ScreenId.admin */.R.admin:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_home */.rW.TSO_SOURCE_SCREEN.tso_home,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.home_clicked */.rW.SIDE_NAV.home_clicked
            };
        case screenId/* ScreenId.tsoLoadMarketPlace */.R.tsoLoadMarketPlace:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_load_market */.rW.TSO_SOURCE_SCREEN.tso_load_market,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.loadmarket_clicked */.rW.SIDE_NAV.loadmarket_clicked
            };
        case screenId/* ScreenId.tsoLorryMarketPlace */.R.tsoLorryMarketPlace:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_lorry_market */.rW.TSO_SOURCE_SCREEN.tso_lorry_market,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.lorrymarket_clicked */.rW.SIDE_NAV.lorrymarket_clicked
            };
        case screenId/* ScreenId.myReferrals */.R.myReferrals:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_my_users */.rW.TSO_SOURCE_SCREEN.tso_my_users,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.myusers_clicked */.rW.SIDE_NAV.myusers_clicked
            };
        case screenId/* ScreenId.newReferrals */.R.newReferrals:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_claim_users */.rW.TSO_SOURCE_SCREEN.tso_claim_users,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.claimuser_clicked */.rW.SIDE_NAV.claimuser_clicked
            };
        case screenId/* ScreenId.loadEnquiryCards */.R.loadEnquiryCards:
        case screenId/* ScreenId.tsoLoadEnquiryCard */.R.tsoLoadEnquiryCard:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_load_enquirycards */.rW.TSO_SOURCE_SCREEN.tso_load_enquirycards,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.load_enquirycards_clicked */.rW.SIDE_NAV.load_enquirycards_clicked
            };
        case screenId/* ScreenId.lorryEnquiryCards */.R.lorryEnquiryCards:
        case screenId/* ScreenId.tsoLorryEnquiryCard */.R.tsoLorryEnquiryCard:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_lorry_enquirycards */.rW.TSO_SOURCE_SCREEN.tso_lorry_enquirycards,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.lorry_enquirycards_clicked */.rW.SIDE_NAV.lorry_enquirycards_clicked
            };
        case screenId/* ScreenId.tsoActiveLorryPage */.R.tsoActiveLorryPage:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_lorry_posted */.rW.TSO_SOURCE_SCREEN.tso_lorry_posted,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.lorry_posted_clicked */.rW.SIDE_NAV.lorry_posted_clicked
            };
        case screenId/* ScreenId.tsoInTransitLorryPage */.R.tsoInTransitLorryPage:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_intransit_lorries */.rW.TSO_SOURCE_SCREEN.tso_intransit_lorries,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.intransit_lorries_clicked */.rW.SIDE_NAV.intransit_lorries_clicked
            };
        case screenId/* ScreenId.tsoActiveLoadsPage */.R.tsoActiveLoadsPage:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_load_posted */.rW.TSO_SOURCE_SCREEN.tso_load_posted,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.load_posted_clicked */.rW.SIDE_NAV.load_posted_clicked
            };
        case screenId/* ScreenId.tsoInTransitLoadPage */.R.tsoInTransitLoadPage:
            return {
                SOURCE_SCREEN: event_names/* GA4EventNamesAdminConsole.TSO_SOURCE_SCREEN.tso_intransit_loads */.rW.TSO_SOURCE_SCREEN.tso_intransit_loads,
                EVENT_NAME: event_names/* GA4EventNamesAdminConsole.SIDE_NAV.intransit_loads_clicked */.rW.SIDE_NAV.intransit_loads_clicked
            };
        default:
            break;
    }
};

// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
// EXTERNAL MODULE: ./constants/adminOperation.ts
var adminOperation = __webpack_require__(40223);
// EXTERNAL MODULE: ./context/load-lorry-posting.tsx
var load_lorry_posting = __webpack_require__(8574);
// EXTERNAL MODULE: ./hooks/useOpenNewLoadPosting.ts
var useOpenNewLoadPosting = __webpack_require__(68498);
;// CONCATENATED MODULE: ./components/layout/side-nav-layout-new/SideNavLayout.tsx







//Style

//Hook

// Components
//Icons




//Hooks





















var SideNavLayout = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, _isCollapsed = param.isCollapsed, isCollapsed = _isCollapsed === void 0 ? false : _isCollapsed, navMenuOption = param.navMenuOption, activeTab = param.activeTab, toggleSideBar = param.toggleSideBar;
    var innerRef = (0,react.useRef)(null);
    //This ref can be used to trigger sidenav function from out side
    (0,react.useImperativeHandle)(ref, function() {
        return {
            toggleSidBar: function toggleSidBar() {
                SideBarToggler();
            }
        };
    }, []);
    var _$ref = (0,react.useContext)(app_context/* AppContext */.Il), setHistoryLocation = _$ref.setHistoryLocation, companyLogo = _$ref.companyLogo, name = _$ref.name, serviceType = _$ref.serviceType, companyId = _$ref.companyId, userId = _$ref.userId, csDashboardUserRoles = _$ref.csDashboardUserRoles, customerCompanyId = _$ref.customerCompanyId, companyLocation = _$ref.companyLocation, //These are used in logout function
    setCompanyId = _$ref.setCompanyId, setIsPhoneVerified = _$ref.setIsPhoneVerified, setName = _$ref.setName, setLang = _$ref.setLang, setCompanyLogo = _$ref.setCompanyLogo, setUserId = _$ref.setUserId, phoneNum = _$ref.phoneNum, setCsDashboardUserRoles = _$ref.setCsDashboardUserRoles, setCustomerCompanyId = _$ref.setCustomerCompanyId, setCustomerName = _$ref.setCustomerName, setCustomerPhone = _$ref.setCustomerPhone, setSessionId = _$ref.setSessionId, setThirdPartyCompanyName = _$ref.setThirdPartyCompanyName;
    var _$ref1 = (0,react.useState)({
        menuId: "",
        subMenuId: ""
    }), activeMenu = _$ref1[0], setActiveMenu = _$ref1[1];
    var _$ref2 = (0,react.useState)({
        menuId: "",
        subMenuId: ""
    }), clickedMenu = _$ref2[0], setClickedMenu = _$ref2[1];
    var desktopScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "desktop"
    });
    var midScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "medium-screen"
    });
    var mobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var _$ref3 = (0,useCsDashboard/* useCsDashboard */.Z)(), checkPermission = _$ref3.checkPermission, isCsDashboardUser = _$ref3.isCsDashboardUser;
    var router = (0,next_router.useRouter)();
    var _$ref4 = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(), openSideBar = _$ref4.openModal, collapseSideBar = _$ref4.closeModal, SideBarToggler = _$ref4.toggleModal, isSideBarExpanded = _$ref4.isModalOpen;
    (0,react.useEffect)(function() {
        if (desktopScreen) openSideBar();
        if (!mobileScreen && midScreen) collapseSideBar();
        if (mobileScreen) collapseSideBar();
    }, [
        desktopScreen,
        midScreen,
        mobileScreen
    ]);
    var isTso = checkPermission(adminOperation/* ADMIN_OPERATION.tagAgent */.F.tagAgent);
    //Events
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var handleMenuClick = function(e, data, menuData) {
        var _$ref, _$ref1, _$ref2, _$ref3;
        /**
             * Events
             */ isTso && sendGAandMoEngageEvent({
            name: (_$ref = getEventSourceScreenAdminConsole(menuData.id)) === null || _$ref === void 0 ? void 0 : _$ref.EVENT_NAME,
            data: {
                user_id: userId,
                user_name: name,
                user_type: event_names/* GA4EventNamesAdminConsole.ADMIN_USER_TYPE.TSO */.rW.ADMIN_USER_TYPE.TSO,
                company_id: companyId,
                phone_number: phoneNum,
                home_city: companyLocation,
                home_state: companyLocation,
                source_screen: (_$ref1 = getEventSourceScreenAdminConsole(menuData.id)) === null || _$ref1 === void 0 ? void 0 : _$ref1.SOURCE_SCREEN
            }
        });
        !isCsDashboardUser && sendGAandMoEngageEvent({
            name: menuData.clientAppEventName,
            data: {
                from_screen: router.asPath,
                from: "side_nav"
            }
        });
        /**
             * To prevent reload of active tab on clicking in side menu
             */ if (data.subMenuId === undefined && (activeTab === null || activeTab === void 0 ? void 0 : activeTab.menuId) === data.menuId) return;
        e.stopPropagation();
        if (data.subMenuId) {
            setClickedMenu(data);
            setActiveMenu(data);
        } else if (data.menuId === clickedMenu.menuId && !data.subMenuId) {
            setClickedMenu({
                menuId: "",
                subMenuId: ""
            });
        } else {
            setClickedMenu(data);
        }
        setHistoryLocation === null || setHistoryLocation === void 0 ? void 0 : setHistoryLocation(window === null || window === void 0 ? void 0 : (_$ref2 = window.location) === null || _$ref2 === void 0 ? void 0 : _$ref2.pathname);
        var getMenuPath = menuData.pathName;
        if ((_$ref3 = menuData.subMenu) === null || _$ref3 === void 0 ? void 0 : _$ref3.length) {
            var _$ref4;
            getMenuPath = ((_$ref4 = menuData.subMenu.find(function(sub) {
                return sub.id === data.subMenuId;
            })) === null || _$ref4 === void 0 ? void 0 : _$ref4.pathName) || menuData.pathName;
        }
        /**
             * This condition is added only for TSO
             * For TSO we have separate menu load load and lorry marketplace
             * Since the marketplace is server side, we should not do shallow routing
             */ var shallow = ![
            "tso-load-marketplace",
            "tso-lorry-marketplace",
            "ticket-system"
        ].includes(data.menuId);
        getMenuPath && router.push(getMenuPath, undefined, {
            shallow: shallow
        });
        getMenuPath && mobileScreen && collapseSideBar();
    };
    (0,react.useEffect)(function() {
        if (activeTab) {
            setActiveMenu(activeTab);
            if (activeTab.subMenuId) {
                setClickedMenu(activeTab);
            } else if (activeTab.menuId === clickedMenu.menuId && !activeTab.subMenuId) {
                setClickedMenu({
                    menuId: "",
                    subMenuId: ""
                });
            } else {
                setClickedMenu(activeTab);
            }
        }
    }, [
        router
    ]);
    var handleClickOutside = function(event) {
        event.stopPropagation();
        if (innerRef.current && !innerRef.current.contains(event.target)) {
            collapseSideBar();
        }
    };
    (0,react.useEffect)(function() {
        /**
             * This will close the sidebar when the user clicks outside the sidebar
             * Only in mobile screen
             */ if (!mobileScreen) return;
        document.addEventListener("mousedown", handleClickOutside);
        return function cleanup() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });
    var _$ref5 = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false), openPostingMenu = _$ref5.openModal, closePostingMenu = _$ref5.closeModal, togglePostingMenu = _$ref5.toggleModal, isPostingMenuOpen = _$ref5.isModalOpen;
    var _$ref6 = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false), openUserProfileMenu = _$ref6.openModal, closeUserProfileMenu = _$ref6.closeModal, toggleUserProfileMenu = _$ref6.toggleModal, isUserProfileMenuOpen = _$ref6.isModalOpen;
    var _$ref7 = (0,useFeatureByServiceType/* useFeatureByServiceType */.D)(), ShowLorryPost = _$ref7.ShowLorryPost, ShowLoadPost = _$ref7.ShowLoadPost;
    /**
         * Load posting verification check
         */ var ValidateLorryPosting = (0,useValidateUserStatus/* default */.Z)().ValidateLorryPosting;
    var updateLoadLorryPostingData = (0,load_lorry_posting/* useLoadLorryPosting */.NS)().updateLoadLorryPostingData;
    var openNewLoadPosting = (0,useOpenNewLoadPosting/* default */.Z)();
    var handleOpenLoadLorryPostingForm = function(marketType) {
        if (marketType === "load") {
            /**
                 * Events
                 */ sendGAandMoEngageEvent({
                name: event_names/* GA4EventNames.SIDE_NAV.post_load_button_click */.wQ.SIDE_NAV.post_load_button_click,
                data: {
                    from_screen: router.asPath
                }
            });
            openNewLoadPosting({
                originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.SIDE_NAV */.ec.SIDE_NAV
            });
            return;
        }
        /**
             * Events
             */ sendGAandMoEngageEvent({
            name: event_names/* GA4EventNames.SIDE_NAV.add_lorry_attach_lorry_btn */.wQ.SIDE_NAV.add_lorry_attach_lorry_btn,
            data: {
                from_screen: router.asPath
            }
        });
        updateLoadLorryPostingData === null || updateLoadLorryPostingData === void 0 ? void 0 : updateLoadLorryPostingData({
            isModalOpen: true,
            type: "lorry",
            category: "post",
            originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.SIDE_NAV */.ec.SIDE_NAV
        });
        delete router.query[helpers_constants/* LOAD_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.x.PARAM_NAME];
        router.query[constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME] = "vehicle_number";
        /**
             * This will check for user verification status and opens aadhaar and pan modal or membership upgrade modal
             */ ValidateLorryPosting === null || ValidateLorryPosting === void 0 ? void 0 : ValidateLorryPosting(function() {
            //Callback function
            router.push(router, undefined, {
                shallow: true,
                scroll: false
            });
        });
    };
    var onClickLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,performLogoutAndRedirectHome/* performLogoutAndRedirectHome */.e)({
                            router: router,
                            setCompanyId: setCompanyId,
                            setIsPhoneVerified: setIsPhoneVerified,
                            setName: setName,
                            setLang: setLang,
                            setCompanyLogo: setCompanyLogo,
                            setUserId: setUserId,
                            phoneNum: Number(phoneNum),
                            setCsDashboardUserRoles: setCsDashboardUserRoles,
                            setCustomerCompanyId: setCustomerCompanyId,
                            setCustomerName: setCustomerName,
                            setCustomerPhone: setCustomerPhone,
                            setSessionId: setSessionId,
                            setThirdPartyCompanyName: setThirdPartyCompanyName
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var isProfilePage = router.asPath.includes("my-profile");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((SideNavLayout_module_default()).mainLayoutWrapper),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: classnames_default()((SideNavLayout_module_default()).sideBarWrapper, isSideBarExpanded || isCollapsed ? (SideNavLayout_module_default()).isSideBarExpanded : ""),
                    ref: innerRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SideNavLayout_module_default()).logoWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: automation/* IDs.common.vahakLogo */.g.common.vahakLogo,
                                // title="Vahak - Book Trucks, Trailers, Containers from Thousands of Trusted Transport businesses and Lorry Owners from All India"
                                onClick: function() {
                                    if (isCsDashboardUser) {
                                        return router.push("/");
                                    }
                                    if (companyId) {
                                        var _$ref;
                                        if (router === null || router === void 0 ? void 0 : (_$ref = router.pathname) === null || _$ref === void 0 ? void 0 : _$ref.includes("/dashboard")) return;
                                        router.push(routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl());
                                    } else {
                                        var _$ref1;
                                        if (router === null || router === void 0 ? void 0 : (_$ref1 = router.pathname) === null || _$ref1 === void 0 ? void 0 : _$ref1.includes("/marketplace")) {
                                            router.push("/");
                                            return;
                                        }
                                        router.push(marketplace_constants/* MARKETPLACE_ROUTE_CONFIG.loadUrl */.VV.loadUrl);
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SideNavLayout_module_default()).logoContainer,
                                    children: midScreen && !isSideBarExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Vahak_Nav_Logo, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakLogoLightBlue/* default */.Z, {})
                                })
                            })
                        }),
                        !csDashboardUserRoles ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                ShowLoadPost && !ShowLorryPost ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((SideNavLayout_module_default()).postingBtnContainer),
                                    onClick: function() {
                                        return handleOpenLoadLorryPostingForm("load");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((SideNavLayout_module_default()).postingLabelContainer1, (SideNavLayout_module_default()).postingBtn),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Nav_Load_Lorry, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SideNavLayout_module_default()).postingLabel,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    weight: "medium",
                                                    size: "m",
                                                    color: colors/* default.BLUE */.Z.BLUE,
                                                    children: "Post a Load"
                                                })
                                            })
                                        ]
                                    })
                                }) : !ShowLoadPost && ShowLorryPost ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((SideNavLayout_module_default()).postingBtnContainer),
                                    onClick: function() {
                                        return handleOpenLoadLorryPostingForm("lorry");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((SideNavLayout_module_default()).postingLabelContainer1, (SideNavLayout_module_default()).postingBtn),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Nav_Load_Lorry, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SideNavLayout_module_default()).postingLabel,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    weight: "medium",
                                                    size: "m",
                                                    color: colors/* default.BLUE */.Z.BLUE,
                                                    children: "Attach a lorry"
                                                })
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                ShowLoadPost && ShowLorryPost ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((SideNavLayout_module_default()).postingIconContainer),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                        isOpen: isPostingMenuOpen,
                                        DropdownToggleBtn: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()((SideNavLayout_module_default()).postingLabelContainer),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Nav_Load_Lorry, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SideNavLayout_module_default()).postingLabel,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        weight: "medium",
                                                        size: "m",
                                                        color: colors/* default.BLUE */.Z.BLUE,
                                                        children: "Post"
                                                    })
                                                })
                                            ]
                                        }),
                                        handleToggle: function() {
                                            /**
                                                 * Events
                                                 */ sendGAandMoEngageEvent({
                                                name: event_names/* GA4EventNames.SIDE_NAV.post_btn_clicked */.wQ.SIDE_NAV.post_btn_clicked,
                                                data: {
                                                    from_screen: router.asPath
                                                }
                                            });
                                            togglePostingMenu();
                                        },
                                        onBlur: closePostingMenu,
                                        containerClassName: (SideNavLayout_module_default()).postingMenuDropdownContainer,
                                        direction: "right",
                                        dropdownClassName: (SideNavLayout_module_default()).dropdownMenuItemClassName,
                                        dropdownToggleClassName: (SideNavLayout_module_default()).dropdownToggleClassName,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (SideNavLayout_module_default()).postingButtonWrapper,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    blockBtn: true,
                                                    fillType: "tonal",
                                                    onClick: function() {
                                                        return handleOpenLoadLorryPostingForm("load");
                                                    },
                                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_blue, {}),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        weight: "regular",
                                                        size: "m",
                                                        children: "Post a Load"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    blockBtn: true,
                                                    fillType: "tonal",
                                                    onClick: function() {
                                                        return handleOpenLoadLorryPostingForm("lorry");
                                                    },
                                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_blue, {}),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        weight: "regular",
                                                        size: "m",
                                                        children: "Attach a Lorry"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SideNavLayout_module_default()).navItemsContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SideNavLayout_module_default()).menuItemsWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: classnames_default()((SideNavLayout_module_default()).menuItems),
                                    children: navMenuOption.map(function(menuOption) {
                                        var id = menuOption.id, label = menuOption.label, Icon = menuOption.Icon, IconActive = menuOption.IconActive, pathName = menuOption.pathName, subMenu = menuOption.subMenu, SubMenuToggleIcon = menuOption.SubMenuToggleIcon;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            id: id,
                                            className: classnames_default()((SideNavLayout_module_default()).menuItemWrapper, activeMenu.menuId === id && (SideNavLayout_module_default()).active, (activeTab === null || activeTab === void 0 ? void 0 : activeTab.menuId) === id && !subMenu && (SideNavLayout_module_default()).disableClick),
                                            onClick: function(e) {
                                                return handleMenuClick(e, {
                                                    menuId: id
                                                }, menuOption);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classnames_default()((SideNavLayout_module_default()).menuItem),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (SideNavLayout_module_default()).menuIcon,
                                                            children: activeMenu.menuId === id ? IconActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconActive, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: classnames_default()((SideNavLayout_module_default()).label, (SideNavLayout_module_default()).arowDown),
                                                            children: [
                                                                label,
                                                                " ",
                                                                (subMenu === null || subMenu === void 0 ? void 0 : subMenu.length) && SubMenuToggleIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubMenuToggleIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                subMenu && subMenu.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: classnames_default()((SideNavLayout_module_default()).subMenuItems, (clickedMenu.menuId === id || activeMenu.menuId === id) && (SideNavLayout_module_default()).showSubmenu),
                                                    children: subMenu.map(function(subMenu) {
                                                        var subMenuId = subMenu.id, label = subMenu.label, Icon = subMenu.Icon, IconActive = subMenu.IconActive, pathName = subMenu.pathName, nestedSubMenu = subMenu.subMenu, SubMenuToggleIcon = subMenu.SubMenuToggleIcon;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            id: subMenuId,
                                                            className: classnames_default()((SideNavLayout_module_default()).subMenuItem, activeMenu.subMenuId === subMenuId && (SideNavLayout_module_default()).subMenuActive),
                                                            onClick: function(e) {
                                                                e.stopPropagation();
                                                                handleMenuClick(e, {
                                                                    menuId: id,
                                                                    subMenuId: subMenuId
                                                                }, menuOption);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (SideNavLayout_module_default()).subMenuIcon,
                                                                    children: activeMenu.subMenuId === subMenuId ? IconActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconActive, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: classnames_default()((SideNavLayout_module_default()).subMenuLabel),
                                                                    children: label
                                                                })
                                                            ]
                                                        }, subMenuId);
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                            ]
                                        }, id);
                                    })
                                })
                            })
                        }),
                        !csDashboardUserRoles ? isProfilePage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: "absolute",
                                bottom: "20px",
                                left: "0",
                                width: "inherit"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                blockBtn: true,
                                fillType: "text",
                                onClick: onClickLogout,
                                id: automation/* IDs.profileDropDown.profileLogout */.g.profileDropDown.profileLogout,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    weight: "regular",
                                    size: "m",
                                    color: colors/* default.WHITE */.Z.WHITE,
                                    children: "Logout"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((SideNavLayout_module_default()).userProfileIconContainer),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                isOpen: isUserProfileMenuOpen,
                                DropdownToggleBtn: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((SideNavLayout_module_default()).userProfileLabelContainer),
                                    id: automation/* IDs.profileDropDown.profileDropdownBtn */.g.profileDropDown.profileDropdownBtn,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage/* default */.Z, {
                                            imageUrl: companyLogo,
                                            firstName: name,
                                            size: "xs"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SideNavLayout_module_default()).userProfileLabel,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                weight: "medium",
                                                size: "m",
                                                color: colors/* default.WHITE */.Z.WHITE,
                                                children: name !== null && name !== void 0 ? name : "My profile"
                                            })
                                        })
                                    ]
                                }),
                                handleToggle: function() {
                                    /**
                                             * Events
                                             */ !isCsDashboardUser && sendGAandMoEngageEvent({
                                        name: event_names/* GA4EventNames.SIDE_NAV.profile_menu_clicked */.wQ.SIDE_NAV.profile_menu_clicked,
                                        data: {
                                            from_screen: router.asPath,
                                            from: "side_nav"
                                        }
                                    });
                                    toggleUserProfileMenu();
                                },
                                onBlur: closeUserProfileMenu,
                                containerClassName: (SideNavLayout_module_default()).userProfileMenuDropdownContainer,
                                direction: "left",
                                dropdownClassName: (SideNavLayout_module_default()).dropdownMenuItemClassName,
                                dropdownToggleClassName: (SideNavLayout_module_default()).dropdownToggleClassName,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SideNavLayout_module_default()).userProfileButtonWrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            blockBtn: true,
                                            fillType: "text",
                                            onClick: function() {
                                                /**
                                                     * Events
                                                     */ !isCsDashboardUser && sendGAandMoEngageEvent({
                                                    name: event_names/* GA4EventNames.SIDE_NAV.profile_icon_clicked */.wQ.SIDE_NAV.profile_icon_clicked,
                                                    data: {
                                                        from_screen: router.asPath,
                                                        from: "side_nav"
                                                    }
                                                });
                                                setHistoryLocation === null || setHistoryLocation === void 0 ? void 0 : setHistoryLocation(router.asPath);
                                                router.push(routeStrings/* ROUTES.userProfile.getUrl */.Z.userProfile.getUrl(), undefined, {
                                                    shallow: true,
                                                    scroll: false
                                                });
                                            },
                                            id: automation/* IDs.profileDropDown.myProfileBtn */.g.profileDropDown.myProfileBtn,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                weight: "regular",
                                                size: "m",
                                                children: "My Profile"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            blockBtn: true,
                                            fillType: "text",
                                            onClick: function() {
                                                /**
                                                     * Events
                                                     */ !isCsDashboardUser && sendGAandMoEngageEvent({
                                                    name: event_names/* GA4EventNames.SIDE_NAV.user_logout */.wQ.SIDE_NAV.user_logout,
                                                    data: {
                                                        from_screen: router.asPath,
                                                        from: "side_nav"
                                                    }
                                                });
                                                onClickLogout();
                                            },
                                            id: automation/* IDs.profileDropDown.profileLogout */.g.profileDropDown.profileLogout,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                weight: "regular",
                                                size: "m",
                                                children: "Logout"
                                            })
                                        })
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SideNavLayout_module_default()).siteMainContent,
                    children: children
                })
            ]
        })
    });
});
/* harmony default export */ var side_nav_layout_new_SideNavLayout = (SideNavLayout);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../core/dist/constants/tab.js
var tab = __webpack_require__(71076);
// EXTERNAL MODULE: ../core/dist/icons/load_listing_disabled.svg
var load_listing_disabled = __webpack_require__(67032);
// EXTERNAL MODULE: ../core/dist/icons/load_listing_white.svg
var load_listing_white = __webpack_require__(64353);
// EXTERNAL MODULE: ../core/dist/icons/my_lorries_active.svg
var my_lorries_active = __webpack_require__(33194);
// EXTERNAL MODULE: ../core/dist/icons/my_lorries_inactive.svg
var my_lorries_inactive = __webpack_require__(35900);
// EXTERNAL MODULE: ../core/dist/icons/MarketplaceNavActiveIcon.svg
var MarketplaceNavActiveIcon = __webpack_require__(49749);
// EXTERNAL MODULE: ../core/dist/icons/MarketplaceNavDeadIcon.svg
var MarketplaceNavDeadIcon = __webpack_require__(58463);
// EXTERNAL MODULE: ../core/dist/icons/home-icon.svg
var home_icon = __webpack_require__(16661);
// EXTERNAL MODULE: ../core/dist/icons/home-icon-disabled.svg
var home_icon_disabled = __webpack_require__(2602);
;// CONCATENATED MODULE: ../core/dist/icons/AngleLeftWhite.svg
var AngleLeftWhite_path;

function AngleLeftWhite_extends() { AngleLeftWhite_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AngleLeftWhite_extends.apply(this, arguments); }



function SvgAngleLeftWhite(props) {
  return /*#__PURE__*/react.createElement("svg", AngleLeftWhite_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.554,
    height: 13.125,
    viewBox: "0 0 7.554 13.125"
  }, props), AngleLeftWhite_path || (AngleLeftWhite_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.238 5.839L1.68.291A.983.983 0 00.286 1.675l4.861 4.91-4.861 4.861a.983.983 0 101.394 1.385l5.558-5.548a.982.982 0 000-1.444z",
    fill: "#fff"
  })));
}

/* harmony default export */ var AngleLeftWhite = (SvgAngleLeftWhite);
;// CONCATENATED MODULE: ../core/dist/icons/service-page-active-icon.svg
var service_page_active_icon_path;

function service_page_active_icon_extends() { service_page_active_icon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return service_page_active_icon_extends.apply(this, arguments); }



function SvgServicePageActiveIcon(props) {
  return /*#__PURE__*/react.createElement("svg", service_page_active_icon_extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), service_page_active_icon_path || (service_page_active_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.79 12.6l-.424-.24A1.549 1.549 0 0118.56 11c0-.568.302-1.077.806-1.36l.424-.24c1.158-.652 1.553-2.091.885-3.22l-.806-1.36c-.666-1.126-2.148-1.513-3.303-.863l-.424.238a1.63 1.63 0 01-1.612 0 1.55 1.55 0 01-.806-1.36v-.478c0-1.3-1.085-2.357-2.418-2.357H9.694C8.361 0 7.276 1.058 7.276 2.357v.478a1.55 1.55 0 01-.806 1.36 1.631 1.631 0 01-1.612 0l-.423-.238c-1.155-.65-2.637-.263-3.304.863L.325 6.18C-.343 7.31.052 8.75 1.21 9.4l.425.24c.504.283.806.792.806 1.36 0 .568-.302 1.077-.806 1.36l-.424.24C.053 13.25-.343 14.69.326 15.82l.806 1.36c.667 1.126 2.15 1.513 3.303.863l.423-.238a1.63 1.63 0 011.612 0c.505.285.806.793.806 1.36v.478c0 1.3 1.085 2.357 2.418 2.357h1.612c1.334 0 2.418-1.058 2.418-2.357v-.478c0-.568.302-1.076.806-1.36a1.631 1.631 0 011.612 0l.424.238c1.155.65 2.637.263 3.303-.863l.806-1.36c.668-1.129.273-2.569-.885-3.22zm-9.29 2.329c-2.222 0-4.03-1.763-4.03-3.929s1.808-3.929 4.03-3.929c2.223 0 4.03 1.763 4.03 3.929s-1.807 3.929-4.03 3.929z",
    fill: "#fff"
  })));
}

/* harmony default export */ var service_page_active_icon = (SvgServicePageActiveIcon);
;// CONCATENATED MODULE: ../core/dist/icons/service-page-icon.svg
var service_page_icon_path;

function service_page_icon_extends() { service_page_icon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return service_page_icon_extends.apply(this, arguments); }



function SvgServicePageIcon(props) {
  return /*#__PURE__*/react.createElement("svg", service_page_icon_extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), service_page_icon_path || (service_page_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.79 12.6l-.424-.24A1.549 1.549 0 0118.56 11c0-.568.302-1.077.806-1.36l.424-.24c1.158-.652 1.553-2.091.885-3.22l-.806-1.36c-.666-1.126-2.148-1.513-3.303-.863l-.424.238a1.63 1.63 0 01-1.612 0 1.55 1.55 0 01-.806-1.36v-.478c0-1.3-1.085-2.357-2.418-2.357H9.694C8.361 0 7.276 1.058 7.276 2.357v.478a1.55 1.55 0 01-.806 1.36 1.631 1.631 0 01-1.612 0l-.423-.238c-1.155-.65-2.637-.263-3.304.863L.325 6.18C-.343 7.31.052 8.75 1.21 9.4l.425.24c.504.283.806.792.806 1.36 0 .568-.302 1.077-.806 1.36l-.424.24C.053 13.25-.343 14.69.326 15.82l.806 1.36c.667 1.126 2.15 1.513 3.303.863l.423-.238a1.63 1.63 0 011.612 0c.505.285.806.793.806 1.36v.478c0 1.3 1.085 2.357 2.418 2.357h1.612c1.334 0 2.418-1.058 2.418-2.357v-.478c0-.568.302-1.076.806-1.36a1.631 1.631 0 011.612 0l.424.238c1.155.65 2.637.263 3.303-.863l.806-1.36c.668-1.129.273-2.569-.885-3.22zm-9.29 2.329c-2.222 0-4.03-1.763-4.03-3.929s1.808-3.929 4.03-3.929c2.223 0 4.03 1.763 4.03 3.929s-1.807 3.929-4.03 3.929z",
    fill: "#AFC4FF"
  })));
}

/* harmony default export */ var service_page_icon = (SvgServicePageIcon);
;// CONCATENATED MODULE: ../core/dist/icons/meet-vahak-page-active-icon.svg
var meet_vahak_page_active_icon_path, _path2;

function meet_vahak_page_active_icon_extends() { meet_vahak_page_active_icon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return meet_vahak_page_active_icon_extends.apply(this, arguments); }



function SvgMeetVahakPageActiveIcon(props) {
  return /*#__PURE__*/react.createElement("svg", meet_vahak_page_active_icon_extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), meet_vahak_page_active_icon_path || (meet_vahak_page_active_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.578 4.773c-1.087.153-2.035 1.173-2.045 1.182a.23.23 0 01-.045.037c-1.476.958-2.308.23-2.343.186-.944-.85-.077-2.276-.04-2.336a8.692 8.692 0 011.393-1.755H4.489L2.75 7.825a.21.21 0 01.05.04c2.7 3.052 6.284 5.76 7.698 6.783a.722.722 0 00.933-1.098l-1.946-1.946a.229.229 0 11.326-.323l1.036 1.036.916.917.459.47a.878.878 0 001.25-1.231l-1.784-1.863-.34-.35a.23.23 0 11.326-.326l2.605 2.704a.916.916 0 001.561-.612.891.891 0 00-.275-.671l-1.563-1.513-1.088-1.056a.228.228 0 01-.018-.336.23.23 0 01.336.008l3.094 2.995a.864.864 0 001.245-.01.863.863 0 00-.065-1.243l-5.928-5.427zM3.79.744A8.46 8.46 0 000 .006v8.988h1.4a.688.688 0 00.663-.497l2.103-6.928A.687.687 0 003.79.744z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.32 1.188a2.152 2.152 0 00-1.55-.034c-.877.32-2.158 1.09-3.283 2.929 0 .013-.704 1.146-.041 1.755.023.02.614.516 1.76-.215.165-.172 1.198-1.208 2.42-1.32a.23.23 0 01.174.06l6.006 5.5c.028.025.053.052.078.08.688-.106 1.146-.734 1.279-.963l-2.177-5.933-4.666-1.859zM21.542 1.1a10.132 10.132 0 00-3.818.719.688.688 0 00-.371.878l2.55 6.941a.704.704 0 00.656.458H22V1.111a8 8 0 00-.458-.012z",
    fill: "#fff"
  })));
}

/* harmony default export */ var meet_vahak_page_active_icon = (SvgMeetVahakPageActiveIcon);
;// CONCATENATED MODULE: ../core/dist/icons/meet-vahak-page-icon.svg
var meet_vahak_page_icon_path, meet_vahak_page_icon_path2;

function meet_vahak_page_icon_extends() { meet_vahak_page_icon_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return meet_vahak_page_icon_extends.apply(this, arguments); }



function SvgMeetVahakPageIcon(props) {
  return /*#__PURE__*/react.createElement("svg", meet_vahak_page_icon_extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), meet_vahak_page_icon_path || (meet_vahak_page_icon_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.578 4.773c-1.087.153-2.036 1.173-2.045 1.182a.23.23 0 01-.046.037c-1.475.958-2.307.23-2.342.186-.944-.85-.078-2.276-.04-2.336a8.692 8.692 0 011.392-1.755H4.49L2.75 7.825a.21.21 0 01.05.04c2.7 3.052 6.284 5.76 7.698 6.783a.722.722 0 00.933-1.098l-1.946-1.946a.229.229 0 11.326-.323l1.035 1.036.917.917.458.47a.879.879 0 001.252-1.231l-1.786-1.863-.339-.35a.228.228 0 010-.326.23.23 0 01.326 0l2.605 2.704a.915.915 0 001.561-.612.891.891 0 00-.275-.671l-1.563-1.513-1.088-1.056a.23.23 0 11.318-.328l3.094 2.995a.863.863 0 001.391-.98.86.86 0 00-.211-.274l-5.928-5.426zM3.79.744A8.46 8.46 0 000 .006v8.988h1.4a.688.688 0 00.663-.497l2.103-6.928A.687.687 0 003.79.744z",
    fill: "#AFC4FF"
  })), meet_vahak_page_icon_path2 || (meet_vahak_page_icon_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.32 1.188a2.152 2.152 0 00-1.55-.034c-.877.32-2.158 1.09-3.283 2.929 0 .013-.704 1.146-.041 1.755.023.02.614.516 1.76-.215.165-.172 1.198-1.208 2.42-1.32a.23.23 0 01.174.06l6.006 5.5c.028.025.053.052.078.08.688-.106 1.146-.734 1.279-.963l-2.177-5.933-4.666-1.859zM21.542 1.1a10.132 10.132 0 00-3.818.719.687.687 0 00-.371.878l2.55 6.941a.704.704 0 00.656.458H22V1.111a8 8 0 00-.458-.012z",
    fill: "#AFC4FF"
  })));
}

/* harmony default export */ var meet_vahak_page_icon = (SvgMeetVahakPageIcon);
;// CONCATENATED MODULE: ../core/dist/icons/MembershipCrown.svg
var MembershipCrown_path, MembershipCrown_path2;

function MembershipCrown_extends() { MembershipCrown_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return MembershipCrown_extends.apply(this, arguments); }



function SvgMembershipCrown(props) {
  return /*#__PURE__*/react.createElement("svg", MembershipCrown_extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), MembershipCrown_path || (MembershipCrown_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.302 17.11H3.698c-.54 0-1.011-.368-1.142-.892L.036 6.134a1.177 1.177 0 011.667-1.338L5.77 6.83l3.22-5.368a1.177 1.177 0 012.019 0l3.22 5.368 4.068-2.034a1.177 1.177 0 011.668 1.338l-2.521 10.084a1.177 1.177 0 01-1.142.891z",
    fill: "#FFD71B"
  })), MembershipCrown_path2 || (MembershipCrown_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M16.302 17.11c.54 0 1.01-.368 1.142-.892l2.52-10.084a1.177 1.177 0 00-1.667-1.338L14.23 6.83l-3.221-5.368A1.177 1.177 0 0010 .891v16.218h6.302z",
    fill: "#FFB700"
  })));
}

/* harmony default export */ var MembershipCrown = (SvgMembershipCrown);
;// CONCATENATED MODULE: ../core/dist/icons/MembershipCrownDisabled.svg
var MembershipCrownDisabled_path;

function MembershipCrownDisabled_extends() { MembershipCrownDisabled_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return MembershipCrownDisabled_extends.apply(this, arguments); }



function SvgMembershipCrownDisabled(props) {
  return /*#__PURE__*/react.createElement("svg", MembershipCrownDisabled_extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), MembershipCrownDisabled_path || (MembershipCrownDisabled_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.927 16.84H3.839c-.56 0-1.05-.382-1.185-.925L.037 5.444a1.222 1.222 0 011.731-1.39l4.223 2.112L9.335.593a1.222 1.222 0 012.096 0l3.344 5.574 4.223-2.112a1.222 1.222 0 011.732 1.39l-2.618 10.47a1.222 1.222 0 01-1.185.925z",
    fill: "#AFC4FF"
  })));
}

/* harmony default export */ var MembershipCrownDisabled = (SvgMembershipCrownDisabled);
;// CONCATENATED MODULE: ./components/layout/methods/useGetLayoutOptions.ts




//Constants



//Icons

















var ClientAppMenuId;
(function(ClientAppMenuId) {
    ClientAppMenuId["home"] = "home";
    ClientAppMenuId["myLoads"] = "myLoads";
    ClientAppMenuId["myLories"] = "myLories";
    ClientAppMenuId["marketplace"] = "marketplace";
    ClientAppMenuId["servicePages"] = "servicePages";
    ClientAppMenuId["meetVahak"] = "meetVahak";
    ClientAppMenuId["resource"] = "resource";
    ClientAppMenuId["membership"] = "membership";
})(ClientAppMenuId || (ClientAppMenuId = {}));
function useGetLayoutOptions() {
    var _NavItems;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useFeatureByServiceType/* useFeatureByServiceType */.D)(), showLoadFeatures = ref1.showLoadFeatures, showLorryFeatures = ref1.showLorryFeatures, ShowLoadPost = ref1.ShowLoadPost, ShowLorryPost = ref1.ShowLorryPost;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), haveMembership = ref2.haveMembership, route = ref2.route;
    var NavItems = [];
    NavItems.push({
        id: ClientAppMenuId.home,
        Icon: home_icon_disabled/* default */.Z,
        IconActive: home_icon/* default */.Z,
        label: "Home",
        pathName: "/dashboard",
        clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.homepage_icon_clicked */.wQ.SIDE_NAV.homepage_icon_clicked
    }, {
        id: ClientAppMenuId.myLoads,
        Icon: load_listing_disabled/* default */.Z,
        IconActive: load_listing_white/* default */.Z,
        label: "My Loads",
        pathName: router.asPath.includes("my-loads") ? router.asPath.includes("bids") ? routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.BIDS */.n.BIDS) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING),
        clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.my_load_icon_clicked */.wQ.SIDE_NAV.my_load_icon_clicked
    }, {
        id: ClientAppMenuId.myLories,
        Icon: my_lorries_inactive/* default */.Z,
        IconActive: my_lorries_active/* default */.Z,
        label: "My Lorries",
        pathName: router.asPath.includes("my-lorries") ? router.asPath.includes("bids") ? routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.BIDS */.n.BIDS) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING),
        clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.my_lorry_icon_clicked */.wQ.SIDE_NAV.my_lorry_icon_clicked
    });
    /**
     * This condition is to check if the current user is Shipper service type
     * If yes then remove My lorries from side nav
     */ if (ShowLoadPost && !ShowLorryPost) {
        NavItems.splice(2, 1);
    }
    /**
     * This condition is to check if the current user is Fleet owner service type
     * If yes then remove My loads from side nav
     */ if (ShowLorryPost && !ShowLoadPost) {
        NavItems.splice(1, 1);
    }
    (_NavItems = NavItems).push.apply(_NavItems, (0,_to_consumable_array/* default */.Z)(showLoadFeatures || showLorryFeatures ? [
        {
            id: ClientAppMenuId.marketplace,
            Icon: MarketplaceNavDeadIcon/* default */.Z,
            IconActive: MarketplaceNavActiveIcon/* default */.Z,
            label: "Marketplace",
            pathName: marketplace_constants/* MARKETPLACE_ROUTE_CONFIG.loadUrl */.VV.loadUrl,
            clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.marketplace_icon_clicked */.wQ.SIDE_NAV.marketplace_icon_clicked
        }
    ] : []).concat([
        {
            id: ClientAppMenuId.servicePages,
            Icon: service_page_icon,
            IconActive: service_page_active_icon,
            label: "Services",
            pathName: "",
            clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.services_icon_clicked */.wQ.SIDE_NAV.services_icon_clicked,
            SubMenuToggleIcon: AngleLeftWhite,
            subMenu: [
                {
                    id: "online-load-booking",
                    Icon: "",
                    IconActive: "",
                    label: "Online Load Booking",
                    pathName: "/online-load-booking"
                },
                {
                    id: "online-lorry-booking",
                    Icon: "",
                    IconActive: "",
                    label: "Online Lorry Booking",
                    pathName: "/online-truck-booking"
                },
                {
                    id: "grow-network",
                    Icon: "",
                    IconActive: "",
                    label: "Grow Network",
                    pathName: "/grow-network"
                },
                {
                    id: "logistics-services",
                    Icon: "",
                    IconActive: "",
                    label: "Logistics Services",
                    pathName: "/logistics-services"
                },
                {
                    id: "full-truck-load",
                    Icon: "",
                    IconActive: "",
                    label: "Full Truck Load",
                    pathName: "/full-truck-load"
                },
                {
                    id: "part-load-booking",
                    Icon: "",
                    IconActive: "",
                    label: "Part Load Booking",
                    pathName: "/part-load-booking"
                }
            ]
        },
        {
            id: ClientAppMenuId.meetVahak,
            Icon: meet_vahak_page_icon,
            IconActive: meet_vahak_page_active_icon,
            label: "Meet Vahak",
            pathName: "",
            clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.meet_vahak_icon_clicked */.wQ.SIDE_NAV.meet_vahak_icon_clicked,
            SubMenuToggleIcon: AngleLeftWhite,
            subMenu: [
                {
                    id: "about-us",
                    Icon: "",
                    IconActive: "",
                    label: "About Us",
                    pathName: "/about-us"
                },
                {
                    id: "how-vahak-helps",
                    Icon: "",
                    IconActive: "",
                    label: "How Vahak Helps",
                    pathName: "/how-vahak-helps"
                },
                {
                    id: "why-choose-us",
                    Icon: "",
                    IconActive: "",
                    label: "Why Choose Us",
                    pathName: "/why-choose-us"
                },
                {
                    id: "careers",
                    Icon: "",
                    IconActive: "",
                    label: "Careers",
                    pathName: "/careers"
                },
                {
                    id: "contact-us",
                    Icon: "",
                    IconActive: "",
                    label: "Contact Us",
                    pathName: "/contact-us"
                }
            ]
        },
        {
            id: ClientAppMenuId.membership,
            Icon: MembershipCrownDisabled,
            IconActive: MembershipCrown,
            label: haveMembership ? "Manage Membership" : "Upgrade Membership",
            pathName: haveMembership ? routeStrings/* ROUTES.membership.getUrl */.Z.membership.getUrl() : routeStrings/* ROUTES.membershipUpgrade.getUrl */.Z.membershipUpgrade.getUrl(),
            clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.manage_membership_clicked */.wQ.SIDE_NAV.manage_membership_clicked
        }
    ]));
    //     NavItems.push({
    //         id: "paymentListing",
    //         Icon: <PaymentsDisabledIcon />,
    //         IconActive: <PaymentsEnabledIcon />,
    //         label: "Payment List",
    //         pathName: "/premium/payment-list"
    //     });
    // }
    var navMenuOption;
    /**
     * Temp condition to render trackscreen in mobile app
     * Flutter app layout option
     */ var mwLayout = router.pathname.includes("mw");
    switch(true){
        case mwLayout:
            navMenuOption = NavItems;
            break;
        default:
            //TODO: GOWDHAM Check this
            navMenuOption = NavItems;
            break;
    }
    var checkSubMenu = function(subMenu) {
        return subMenu === null || subMenu === void 0 ? void 0 : subMenu.find(function(sub) {
            var ref;
            router.asPath.includes(sub.pathName) ? router.asPath.includes(sub.pathName) : ((ref = sub.nestedDirectories) === null || ref === void 0 ? void 0 : ref.length) ? sub.nestedDirectories.some(function(d) {
                return router.asPath.includes(d);
            }) : "";
        });
    };
    var activeTab = navMenuOption.find(function(e) {
        var ref, ref1;
        var ROUTE_PATHNAME = router.pathname;
        //Jugaad
        if (((ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("/membership")) && (e === null || e === void 0 ? void 0 : e.id) === "membership") {
            return true;
        }
        if (router.pathname.includes("marketplace")) {
            var ref2, ref3;
            ROUTE_PATHNAME = "/marketplace/".concat(router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.params) === null || ref3 === void 0 ? void 0 : ref3[0]);
        }
        if (router.pathname.includes("transporters")) {
            ROUTE_PATHNAME = "/transporters";
        }
        if (router.pathname === "/web" || router.pathname === "/mob") {
            ROUTE_PATHNAME = "/";
        }
        var removedWebAndMobFromRoute = ROUTE_PATHNAME.replace("/web", "").replace("/mob", "");
        return ((ref1 = e.subMenu) === null || ref1 === void 0 ? void 0 : ref1.length) ? checkSubMenu(e.subMenu) : e.pathName === removedWebAndMobFromRoute;
    });
    var activeSubMenu = (activeTab === null || activeTab === void 0 ? void 0 : (ref = activeTab.subMenu) === null || ref === void 0 ? void 0 : ref.length) ? checkSubMenu(activeTab.subMenu) : undefined;
    return {
        navMenuOption: navMenuOption,
        activeMenu: {
            menuId: activeTab === null || activeTab === void 0 ? void 0 : activeTab.id,
            subMenuId: activeSubMenu === null || activeSubMenu === void 0 ? void 0 : activeSubMenu.id
        }
    };
}

;// CONCATENATED MODULE: ./components/layout/SideNavLayoutWrapper/SideNavLayoutWrapper.tsx




var SideNavLayoutWrapper = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, isCollapsed = param.isCollapsed, toggleSideBar = param.toggleSideBar;
    var _$ref = useGetLayoutOptions(), navMenuOption = _$ref.navMenuOption, activeMenu = _$ref.activeMenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(side_nav_layout_new_SideNavLayout, {
        navMenuOption: navMenuOption,
        activeTab: activeMenu,
        isCollapsed: isCollapsed,
        toggleSideBar: toggleSideBar,
        ref: ref,
        children: children
    });
});
/* harmony default export */ var SideNavLayoutWrapper_SideNavLayoutWrapper = (SideNavLayoutWrapper);


/***/ }),

/***/ 81395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _BottomNavLayout_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30306);
/* harmony import */ var _BottomNavLayout_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BottomNavLayout_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var BottomNavLayout = function(param) {
    var topNavContent = param.topNavContent, Content = param.content, children = param.children, navContent = param.navContent, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className),
        children: [
            topNavContent,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(topNavContent ? (_BottomNavLayout_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bodyContent) : (_BottomNavLayout_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bodyContentNoTop)),
                children: Content ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {}) : children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_BottomNavLayout_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottomNavbarWrapper)),
                children: navContent
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomNavLayout);


/***/ }),

/***/ 51938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12098);
/* harmony import */ var _DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6610);
/* harmony import */ var _DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4628);
/* harmony import */ var _navbar_menu_items__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63938);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26513);
/* harmony import */ var _vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10182);
/* harmony import */ var _vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68191);





// Styles

// Context







var DashboardNav = function(param) {
    var _fromUrl = param.fromUrl, fromUrl = _fromUrl === void 0 ? _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_4__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl("load") : _fromUrl, mktType = param.mktType, _showPostingIcon = param.showPostingIcon, showPostingIcon = _showPostingIcon === void 0 ? true : _showPostingIcon, navbarName = param.navbarName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_5__/* .AppContext */ .Il), companyLogo = ref.companyLogo, name = ref.name, isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId, userId = ref.userId, serviceType = ref.serviceType, setHistoryLocation = ref.setHistoryLocation;
    var mobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), isActive = ref1[0], setIsActive = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isCsDashboardUser = (0,_vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_11__/* .useCsDashboard */ .Z)().isCsDashboardUser;
    //Events
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_10__/* .useEventTrackerService */ .f)().sendGAandMoEngageEvent;
    var handleMenu = function(pathName, clientAppEventName) {
        var ref;
        setHistoryLocation === null || setHistoryLocation === void 0 ? void 0 : setHistoryLocation(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname);
        setIsActive(pathName);
        /**
         * Events
         */ !isCsDashboardUser && sendGAandMoEngageEvent({
            name: clientAppEventName,
            data: {
                from_screen: router.asPath,
                from: "bottom_nav"
            }
        });
        /**
         * Temp fix for sidenav multi click
         */ var ROUTE_PATHNAME = router.pathname;
        //Jugaad
        if (router.pathname.includes("marketplace")) {
            var ref1, ref2;
            ROUTE_PATHNAME = "/marketplace/".concat(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.params) === null || ref2 === void 0 ? void 0 : ref2[0]);
        }
        if (ROUTE_PATHNAME.replace("/web", "").replace("/mob", "") !== pathName) {
            router.push(pathName);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsActive(router.asPath);
    }, [
        router.asPath
    ]);
    var NavItems = (0,_navbar_menu_items__WEBPACK_IMPORTED_MODULE_6__/* .NavBarMenuItems */ .s)(navbarName, mktType);
    /**
     * Temporary fix
     * This whole file will be removed
     */ var activeMenu = function(pathName, id) {
        var isActiveMenu;
        isActiveMenu = isActive.includes(pathName);
        return isActiveMenu;
    };
    return mobileScreen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default().bottomNavbarWrapper),
        children: NavItems.map(function(param) {
            var id = param.id, icon = param.icon, iconActive = param.iconActive, pathName = param.pathName, alternativePath = param.alternativePath, label = param.label, clientAppEventName = param.clientAppEventName;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default().menuItem), (_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[id], activeMenu(pathName, id) ? (_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default().active) : ""),
                onClick: function() {
                    return handleMenu(pathName, clientAppEventName);
                },
                id: id,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default().icon), (_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default())[id]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: activeMenu(pathName, id) ? (_DashboardNav_module_scss__WEBPACK_IMPORTED_MODULE_12___default().activeIcon) : "",
                            children: activeMenu(pathName, id) ? iconActive : icon
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            mSize: "s",
                            align: "center",
                            as: "span",
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GREY_400 */ .Z.GREY_400,
                            children: label
                        })
                    ]
                })
            }, id);
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (DashboardNav);


/***/ }),

/***/ 78485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58013);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4628);
/* harmony import */ var _SideNavLayoutWrapper_SideNavLayoutWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89363);
/* harmony import */ var _bottom_nav_layout_BottomNavLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81395);
/* harmony import */ var _top_nav_layout_TopNavLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63989);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26513);
/* harmony import */ var _top_nav_v2_TopNavV2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74431);



// Context

// Layouts





var DefaultLayout = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _param);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var Content = props.content, children = props.children, navContent = props.navContent, hideTopNav = props.hideTopNav;
    //TODO: GOWDHAM - Need to refactor this issue
    var mobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var isFullyLoggedIn = Boolean(isPhoneVerified && companyId);
    // Keep SideNav for logged-in marketplace. Swapping to TopNav on Bid remounts the page
    // under the click, so the overlay receives the leftover click and the sheet closes.
    if (!isFullyLoggedIn) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_top_nav_layout_TopNavLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            navContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_top_nav_v2_TopNavV2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            content: Content,
            children: children
        });
    }
    if (isPhoneVerified && companyId && !mobileScreen) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SideNavLayoutWrapper_SideNavLayoutWrapper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: Content ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {}) : children
        });
    }
    if (isPhoneVerified && companyId && mobileScreen) {
        return(// <BottomNavLayout topNavContent={<Topbar t={t} router={router} />} navContent={navContent}>
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_bottom_nav_layout_BottomNavLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            topNavContent: hideTopNav ? undefined : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_top_nav_v2_TopNavV2__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            navContent: navContent,
            children: Content ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {}) : children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultLayout);


/***/ }),

/***/ 99456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U1": function() { return /* reexport */ default_top_nav_layout_DefaultTopNavLayout; }
});

// UNUSED EXPORTS: BottomNavLayout, MainPrivateRouteLayout, SideNavLayout, SideNavbar, TopNavLayout, TopNavV2

// EXTERNAL MODULE: ./components/layout/bottom-nav-layout/BottomNavLayout.tsx
var bottom_nav_layout_BottomNavLayout = __webpack_require__(81395);
// EXTERNAL MODULE: ./components/layout/top-nav-layout/TopNavLayout.tsx + 13 modules
var TopNavLayout = __webpack_require__(63989);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var src_extends = __webpack_require__(58013);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/layout/top-nav-v2/TopNavV2.tsx + 8 modules
var TopNavV2 = __webpack_require__(74431);
;// CONCATENATED MODULE: ./components/layout/default-top-nav-layout/DefaultTopNavLayout.tsx






var DefaultTopNavLayout = function(_param) {
    var props = (0,src_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavLayout/* default */.Z, (0,src_object_spread/* default */.Z)({
        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavV2/* default */.Z, {})
    }, props));
};
/* harmony default export */ var default_top_nav_layout_DefaultTopNavLayout = (DefaultTopNavLayout);

// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
// EXTERNAL MODULE: ../core/dist/components/grid/col/Col.js
var col_Col = __webpack_require__(12215);
// EXTERNAL MODULE: ../core/dist/components/grid/row/Row.js
var row_Row = __webpack_require__(11758);
// EXTERNAL MODULE: ../core/dist/icons/VahakLogoLightBlue.svg
var icons_VahakLogoLightBlue = __webpack_require__(38772);
// EXTERNAL MODULE: ./components/utils/app-link/AppLink.tsx
var app_link_AppLink = __webpack_require__(92477);
// EXTERNAL MODULE: ../core/dist/constants/automation.js
var automation = __webpack_require__(46426);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
;// CONCATENATED MODULE: ./components/layout/side-nav-layout/SideNavLayout.tsx



// Components


// Styles

//Icons





var SideNavLayout_SideNavLayout = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function(param, ref) {
    var navContent = param.navContent, Content = param.content, children = param.children, className = param.className, sideBarWrapperClass = param.sideBarWrapperClass, contentWrapperClass = param.contentWrapperClass, _isCollapsed = param.isCollapsed, isCollapsed = _isCollapsed === void 0 ? false : _isCollapsed;
    var companyId = useContext(AppContext).companyId;
    return /*#__PURE__*/ _jsxs(Row, {
        className: classNames(Styles.main, isCollapsed && Styles.collapsedSidebar, !isCollapsed && "isExpanded", className),
        children: [
            /*#__PURE__*/ _jsx(Col, {
                className: classNames(Styles.sideBarWrapper, sideBarWrapperClass, "sideNavLayout_sideBarWrapper"),
                children: /*#__PURE__*/ _jsx("div", {
                    className: Styles.sideBarContainerWrap,
                    ref: ref,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: Styles.sideBarContainer,
                        children: [
                            /*#__PURE__*/ _jsx(AppLink, {
                                id: IDs.common.vahakLogo,
                                href: companyId ? ROUTES.dashboard.getUrl() : "/",
                                // title="Vahak - Book Trucks, Trailers, Containers from Thousands of Trusted Transport businesses and Lorry Owners from All India"
                                passHref: true,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: Styles.logoContainer,
                                    children: /*#__PURE__*/ _jsx(VahakLogoLightBlue, {})
                                })
                            }),
                            navContent
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Col, {
                xl: isCollapsed ? 12 : 10,
                lg: isCollapsed ? 12 : 12,
                md: isCollapsed ? 12 : 12,
                xs: 12,
                className: classNames(Styles.contentWrapper, contentWrapperClass),
                children: Content ? /*#__PURE__*/ _jsx(Content, {}) : children
            })
        ]
    });
})));
/* harmony default export */ var side_nav_layout_SideNavLayout = ((/* unused pure expression or super */ null && (SideNavLayout_SideNavLayout)));

;// CONCATENATED MODULE: ./components/layout/main-private-route-layout/MainPrivateRouteLayout.tsx








var PrivateRouteLayout = function(_param) {
    var props = _extends({}, _param);
    var isMobile = useContext(AppContext).isMobile;
    return !isMobile ? /*#__PURE__*/ _jsx(SideNavLayout, _object_spread({
        className: Styles.sideNavLayout,
        navContent: /*#__PURE__*/ _jsx(_Fragment, {})
    }, props)) : /*#__PURE__*/ _jsx(BottomNavLayout, _object_spread({
        className: Styles.bottomNavLayout,
        topNavContent: /*#__PURE__*/ _jsx(_Fragment, {}),
        navContent: /*#__PURE__*/ _jsx(_Fragment, {})
    }, props));
};
/* harmony default export */ var MainPrivateRouteLayout = ((/* unused pure expression or super */ null && (PrivateRouteLayout)));

;// CONCATENATED MODULE: ./components/layout/side-navbar/SideNavbar.tsx


var SideNavbar = function(props) {
    return /*#__PURE__*/ _jsx("div", {});
};
/* harmony default export */ var side_navbar_SideNavbar = ((/* unused pure expression or super */ null && (SideNavbar)));

// EXTERNAL MODULE: ./components/layout/top-nav-v2/index.tsx
var top_nav_v2 = __webpack_require__(33623);
;// CONCATENATED MODULE: ./components/layout/index.ts













 // export { default as Footer } from "./footer/Footer";
 // export * from "./footer/Footer";


/***/ }),

/***/ 63938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ NavBarMenuItems; },
  "e": function() { return /* binding */ NavBarName; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../core/dist/constants/tab.js
var tab = __webpack_require__(71076);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/icons/load_listing_disabled.svg
var load_listing_disabled = __webpack_require__(67032);
// EXTERNAL MODULE: ../core/dist/icons/load_listing_white.svg
var load_listing_white = __webpack_require__(64353);
// EXTERNAL MODULE: ../core/dist/icons/my_lorries_active.svg
var my_lorries_active = __webpack_require__(33194);
// EXTERNAL MODULE: ../core/dist/icons/my_lorries_inactive.svg
var my_lorries_inactive = __webpack_require__(35900);
// EXTERNAL MODULE: ../core/dist/icons/MarketplaceNavActiveIcon.svg
var MarketplaceNavActiveIcon = __webpack_require__(49749);
// EXTERNAL MODULE: ../core/dist/icons/MarketplaceNavDeadIcon.svg
var MarketplaceNavDeadIcon = __webpack_require__(58463);
// EXTERNAL MODULE: ../core/dist/icons/home-icon.svg
var home_icon = __webpack_require__(16661);
// EXTERNAL MODULE: ../core/dist/icons/home-icon-disabled.svg
var home_icon_disabled = __webpack_require__(2602);
// EXTERNAL MODULE: ../core/dist/icons/vahak-home-icon-mob-active.svg
var vahak_home_icon_mob_active = __webpack_require__(69007);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../core/dist/icons/vahak-home-icon-mob-disable.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVahakHomeIconMobDisable(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.982 8.348a3.607 3.607 0 01-.296 1.539 3.242 3.242 0 01-.201.295.86.86 0 00.225-.077c.182-.122.323-.299.404-.507.08-.208.097-.436.046-.654a2.184 2.184 0 00-.181-.596h.003zm5.44-1.453h-.363c.147.6.402 1.168.75 1.671.266.428.545.846.784 1.29.535.959.872 2.02.99 3.12.176 1.872-.775 3.397-2.412 4.213-1.035.513-1.97.763-2.785 1.38-.488.395-.901.88-1.22 1.43.088-1.994 1.94-2.41 3.41-3.151 1.69-.85 2.425-2.235 2.217-4.065-.242-1.584-.859-2.643-1.577-3.865a9.751 9.751 0 01-.887-1.739 3.515 3.515 0 01-.186-.982 10.978 10.978 0 00-6.483 0 3.535 3.535 0 01-.186.982 9.923 9.923 0 01-.887 1.74c-.723 1.224-1.34 2.28-1.581 3.864-.209 1.83.528 3.213 2.216 4.066 1.47.74 3.323 1.156 3.409 3.151a5.14 5.14 0 00-1.218-1.43c-.817-.618-1.755-.87-2.784-1.38-1.636-.817-2.592-2.342-2.413-4.213a8.27 8.27 0 01.99-3.12c.238-.444.517-.864.784-1.29.348-.504.603-1.07.75-1.671h-.362c-.13.418-.313.816-.545 1.184-.909 1.532-1.952 2.868-2.03 4.787-.005.435.022.869.082 1.3a2.71 2.71 0 01-.453-1.222 4.24 4.24 0 01.089-1.525c.27-1.165.909-2.168 1.454-3.2.293-.472.499-.996.606-1.545a.861.861 0 00-.09-.517.82.82 0 00-.37-.36.98.98 0 01.473-.166.728.728 0 01.619.274 14.812 14.812 0 00-.34-1.646 12.242 12.242 0 00-.378-1.213 13.992 13.992 0 00-.249-.643h-.065a.545.545 0 01-.402-.14.583.583 0 01-.19-.394.626.626 0 01.201-.38.588.588 0 01.787.001c.109.099.18.235.2.383a.528.528 0 01-.25.432 11.112 11.112 0 001.597 1.823c.32-.148.585-.4.754-.718a1.72 1.72 0 00.184-1.042.54.54 0 01-.37-.155.577.577 0 01-.172-.373.626.626 0 01.201-.382.588.588 0 01.787.003c.11.098.18.234.2.382a.566.566 0 01-.137.339.533.533 0 01-.31.177c.332.55.848.957 1.45 1.142a2.993 2.993 0 01-.565.821c-.525.12-1.035.3-1.52.541a2.846 2.846 0 01-.764-.077.54.54 0 00-.174-.031c.16.268.284.557.37.86 1.918-.803 5.755-.8 7.687.005.086-.304.207-.595.36-.87a.54.54 0 00-.174.033c-.25.06-.508.086-.765.077a6.794 6.794 0 00-1.52-.544 3.001 3.001 0 01-.566-.821 2.601 2.601 0 001.452-1.143.53.53 0 01-.311-.174.562.562 0 01-.137-.338.627.627 0 01.201-.382.588.588 0 01.788.002c.108.098.18.234.2.383a.578.578 0 01-.172.373.541.541 0 01-.37.154c-.05.36.014.726.183 1.044.169.318.433.57.754.72a11.764 11.764 0 001.606-1.824.504.504 0 01-.18-.182.528.528 0 01-.07-.25.626.626 0 01.201-.381.588.588 0 01.787.002c.109.098.18.234.2.382a.584.584 0 01-.19.394.545.545 0 01-.404.14h-.068c-.062.149-.152.374-.25.643-.144.398-.27.802-.375 1.213-.157.556-.284 1.12-.38 1.69a.763.763 0 01.288-.257.734.734 0 01.373-.079c.168.014.33.072.472.168a.819.819 0 00-.37.36.86.86 0 00-.09.517c.107.55.312 1.074.606 1.545.546 1.033 1.182 2.035 1.455 3.2.122.499.152 1.017.09 1.527-.051.44-.207.859-.453 1.22.06-.43.087-.864.081-1.299-.077-1.92-1.12-3.255-2.027-4.788a4.944 4.944 0 01-.544-1.182l-.004.001zM8.04 1.068a.543.543 0 00.313-.18.576.576 0 00.138-.343.642.642 0 00-.205-.39.603.603 0 00-.805 0 .642.642 0 00-.206.39c.008.133.06.26.148.357a.551.551 0 00.333.179 7.57 7.57 0 01-1.279 3.143l-.004.012H9.32l-.004-.012a7.574 7.574 0 01-1.28-3.155l.002-.001zm1.835 13.543c-.445.803-.825.686-1.212.508a1.607 1.607 0 00-1.514-.008c-.391.182-.775.318-1.228-.5a.646.646 0 00.042.797c.535.464 1.463.587 1.849 1.535.018.226.155.226.173 0 .387-.948 1.315-1.07 1.848-1.535a.641.641 0 00.042-.796zm-3.29-6.718a3.181 3.181 0 01-.3 1.968c-.193.313-.412.606-.608.894-.765 1.123-.728 2.268-.161 3.076a3.64 3.64 0 011.333-.87c.21-.09.426-.165.646-.226.165-.586-.42-1.515-.84-1.697a2.588 2.588 0 00-.567-.14s.028-.11.426-.4a.937.937 0 01.892-.044c.15.06.308.093.468.1h.041c.16-.006.319-.04.468-.1a.94.94 0 01.893.044c.4.288.426.4.426.4a2.598 2.598 0 00-.567.14c-.423.182-1.007 1.11-.84 1.697.22.06.436.136.646.227.5.188.954.485 1.333.87.568-.81.603-1.954-.16-3.076-.193-.288-.413-.582-.609-.895a3.178 3.178 0 01-.3-1.968c.466-.134.95-.19 1.432-.166.166 0 .33.04.48.115.148.076.279.186.38.322 0 0-.483.044-.616.268-.133.224-.232.177-.387.177-1.195 0-.49-.288-.986-.535-.013.251-.002.503.033.751.175.695.516 1.334.992 1.857.926 1.224 1.38 3.285-.106 4.357-.578-.863-1.482-1.775-2.5-1.786h-.064c-1.018.009-1.922.922-2.5 1.787-1.485-1.07-1.034-3.134-.106-4.358a4.322 4.322 0 00.992-1.857c.035-.248.046-.5.033-.75-.495.245.209.533-.986.533-.155 0-.255.044-.387-.177-.132-.222-.616-.268-.616-.268.101-.136.232-.246.38-.322.15-.076.314-.115.48-.115.482-.025.965.031 1.43.166l.002.001zm-2.249 3.914c-.307 1.125-.603 2.34.924 3.543.093.073.2.149.319.225.48.24.944.51 1.392.81.257.184.46.44.584.738.125.298.166.625.12.946a1.214 1.214 0 00-.118-.294 3.526 3.526 0 00-1.018-1.19c-.414-.246-.84-.47-1.276-.67-1.431-.77-2.073-1.987-1.634-3.71.296-1.165.633-1.845.011-2.927 1.229.304.937 1.644.696 2.535v-.006zM3.5 9.712s.017.053.035.13a2.4 2.4 0 01.015.946c-.123.727-.437 1.375-.498 2.126a3.23 3.23 0 00.479 2.151c.301.411.682.753 1.117 1.004.448.26.925.442 1.386.7.735.412 1.71 1.153 1.632 2.16-.259-.637-.982-1.212-1.577-1.56-.525-.305-1.143-.557-1.707-.852a3.449 3.449 0 01-1.167-.89 3.592 3.592 0 01-.71-1.308 4.868 4.868 0 01.154-2.524 9.131 9.131 0 01.842-2.084v.001zm3.753-3.134C6.888 6.31 6.1 6.489 6.1 6.489c.17.046.337.105.499.177.283.148.542.343.766.576a.883.883 0 001.067 0c.223-.234.481-.429.766-.576.161-.072.328-.13.498-.177 0 0-.788-.177-1.154.089-.51.374-.77.374-1.287 0h-.002zm4.204 5.225c.307 1.126.603 2.341-.924 3.544-.093.073-.2.148-.318.224-.48.24-.945.51-1.392.81-.257.185-.46.44-.585.739a1.798 1.798 0 00-.12.946c.026-.103.066-.202.118-.295.248-.472.596-.88 1.018-1.193.414-.246.84-.469 1.276-.669 1.432-.77 2.073-1.988 1.635-3.71-.297-1.165-.633-1.845-.011-2.93-1.233.304-.938 1.644-.696 2.535zm.842-2.096s-.018.052-.036.129a2.436 2.436 0 00-.014.947c.122.726.436 1.376.498 2.126a3.232 3.232 0 01-.482 2.151c-.302.41-.682.752-1.117 1.003-.45.26-.925.443-1.389.703-.737.413-1.711 1.152-1.632 2.16.258-.638.982-1.213 1.577-1.56.524-.305 1.144-.558 1.707-.853.446-.208.843-.51 1.166-.89.324-.378.565-.823.71-1.306.172-.84.12-1.713-.152-2.525a9.142 9.142 0 00-.845-2.084l.009-.001zM8.81 8.35a2.17 2.17 0 00-.18.596 1.12 1.12 0 00.047.654c.081.208.223.384.405.506a.877.877 0 00.225.078 3.194 3.194 0 01-.202-.296 3.638 3.638 0 01-.296-1.536",
    fill: "#999"
  })));
}

/* harmony default export */ var vahak_home_icon_mob_disable = (SvgVahakHomeIconMobDisable);
;// CONCATENATED MODULE: ../core/dist/icons/bottom-nav-load-icon-mob-active.svg
var bottom_nav_load_icon_mob_active_path;

function bottom_nav_load_icon_mob_active_extends() { bottom_nav_load_icon_mob_active_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bottom_nav_load_icon_mob_active_extends.apply(this, arguments); }



function SvgBottomNavLoadIconMobActive(props) {
  return /*#__PURE__*/react.createElement("svg", bottom_nav_load_icon_mob_active_extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bottom_nav_load_icon_mob_active_path || (bottom_nav_load_icon_mob_active_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.035 0L.381 3.84l6.654 3.735 6.245-3.734L7.035 0zM0 12.159l6.673 3.84V8.207L0 4.472v7.687zM13.743 4.381L7.398 8.204V16l6.654-3.84-.31-7.779z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ var bottom_nav_load_icon_mob_active = (SvgBottomNavLoadIconMobActive);
;// CONCATENATED MODULE: ../core/dist/icons/bottom-nav-load-icon-mob-disabled.svg
var bottom_nav_load_icon_mob_disabled_path;

function bottom_nav_load_icon_mob_disabled_extends() { bottom_nav_load_icon_mob_disabled_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bottom_nav_load_icon_mob_disabled_extends.apply(this, arguments); }



function SvgBottomNavLoadIconMobDisabled(props) {
  return /*#__PURE__*/react.createElement("svg", bottom_nav_load_icon_mob_disabled_extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bottom_nav_load_icon_mob_disabled_path || (bottom_nav_load_icon_mob_disabled_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.035 0L.381 3.84l6.654 3.735 6.245-3.734L7.035 0zM0 12.159l6.673 3.84V8.207L0 4.472v7.687zM13.743 4.381L7.398 8.204V16l6.654-3.84-.31-7.779z",
    fill: "#999"
  })));
}

/* harmony default export */ var bottom_nav_load_icon_mob_disabled = (SvgBottomNavLoadIconMobDisabled);
;// CONCATENATED MODULE: ../core/dist/icons/bottom-nav-lorry-icon-mob-active.svg
var bottom_nav_lorry_icon_mob_active_path, _path2, _path3, _path4;

function bottom_nav_lorry_icon_mob_active_extends() { bottom_nav_lorry_icon_mob_active_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bottom_nav_lorry_icon_mob_active_extends.apply(this, arguments); }



function SvgBottomNavLorryIconMobActive(props) {
  return /*#__PURE__*/react.createElement("svg", bottom_nav_lorry_icon_mob_active_extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bottom_nav_lorry_icon_mob_active_path || (bottom_nav_lorry_icon_mob_active_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 15h3v.5a1 1 0 01-1 1H4a1 1 0 01-1-1V15zM12 15h3v.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V15z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.751 9.75h10.5v-4a2 2 0 00-2-2h-6.5a2 2 0 00-2 2v4zm.875-1.5h8.749v-2a1 1 0 00-1-1h-6.75a1 1 0 00-1 1v2z",
    fill: "#2355FC"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M3 4.5a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75v-3zM15.75 6.75a.75.75 0 01-.75.75v-3a.75.75 0 01.75.75v1.5z",
    fill: "#2355FC"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.538 1.5a1.5 1.5 0 011.5 1.5H2.961a1.5 1.5 0 011.5-1.5h9.077zM2.25 10.25a2 2 0 012-2h9.499a2 2 0 012 2v3a1 1 0 01-1 1H3.25a1 1 0 01-1-1v-3zm4.5 1.25a1 1 0 011-1h2.499a1 1 0 011 1v2h-4.5v-2zm6.75-1.75a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM3 10.5a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75A.75.75 0 013 10.5zM14.999 15h-12v-.75h12V15z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ var bottom_nav_lorry_icon_mob_active = (SvgBottomNavLorryIconMobActive);
;// CONCATENATED MODULE: ../core/dist/icons/bottom-nav-lorry-icon-mob-disabled.svg
var bottom_nav_lorry_icon_mob_disabled_path, bottom_nav_lorry_icon_mob_disabled_path2, bottom_nav_lorry_icon_mob_disabled_path3, bottom_nav_lorry_icon_mob_disabled_path4;

function bottom_nav_lorry_icon_mob_disabled_extends() { bottom_nav_lorry_icon_mob_disabled_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bottom_nav_lorry_icon_mob_disabled_extends.apply(this, arguments); }



function SvgBottomNavLorryIconMobDisabled(props) {
  return /*#__PURE__*/react.createElement("svg", bottom_nav_lorry_icon_mob_disabled_extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bottom_nav_lorry_icon_mob_disabled_path || (bottom_nav_lorry_icon_mob_disabled_path = /*#__PURE__*/react.createElement("path", {
    d: "M3 15h3v.5a1 1 0 01-1 1H4a1 1 0 01-1-1V15zM12 15h3v.5a1 1 0 01-1 1h-1a1 1 0 01-1-1V15z",
    fill: "#999"
  })), bottom_nav_lorry_icon_mob_disabled_path2 || (bottom_nav_lorry_icon_mob_disabled_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.751 9.75h10.5v-4a2 2 0 00-2-2h-6.5a2 2 0 00-2 2v4zm.875-1.5h8.749v-2a1 1 0 00-1-1h-6.75a1 1 0 00-1 1v2z",
    fill: "#999"
  })), bottom_nav_lorry_icon_mob_disabled_path3 || (bottom_nav_lorry_icon_mob_disabled_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M3 4.5a.75.75 0 00-.75.75v1.5c0 .414.336.75.75.75v-3zM15.75 6.75a.75.75 0 01-.75.75v-3a.75.75 0 01.75.75v1.5z",
    fill: "#999"
  })), bottom_nav_lorry_icon_mob_disabled_path4 || (bottom_nav_lorry_icon_mob_disabled_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.538 1.5a1.5 1.5 0 011.5 1.5H2.961a1.5 1.5 0 011.5-1.5h9.077zM2.25 10.25a2 2 0 012-2h9.499a2 2 0 012 2v3a1 1 0 01-1 1H3.25a1 1 0 01-1-1v-3zm4.5 1.25a1 1 0 011-1h2.499a1 1 0 011 1v2h-4.5v-2zm6.75-1.75a.75.75 0 000 1.5h.75a.75.75 0 000-1.5h-.75zM3 10.5a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75A.75.75 0 013 10.5zM14.999 15h-12v-.75h12V15z",
    fill: "#999"
  })));
}

/* harmony default export */ var bottom_nav_lorry_icon_mob_disabled = (SvgBottomNavLorryIconMobDisabled);
;// CONCATENATED MODULE: ../core/dist/icons/bottom-nav-marketplace-icon-mob-active.svg
var bottom_nav_marketplace_icon_mob_active_path;

function bottom_nav_marketplace_icon_mob_active_extends() { bottom_nav_marketplace_icon_mob_active_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bottom_nav_marketplace_icon_mob_active_extends.apply(this, arguments); }



function SvgBottomNavMarketplaceIconMobActive(props) {
  return /*#__PURE__*/react.createElement("svg", bottom_nav_marketplace_icon_mob_active_extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bottom_nav_marketplace_icon_mob_active_path || (bottom_nav_marketplace_icon_mob_active_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.513 4.298l-.744-3.096A1.392 1.392 0 0012.416.125H2.574c-.638 0-1.197.446-1.346 1.077L.484 4.298c-.17.723-.014 1.46.44 2.041.056.078.134.135.197.206v4.917c0 .78.638 1.417 1.418 1.417h9.92c.779 0 1.417-.638 1.417-1.417V6.545c.063-.064.141-.128.198-.199a2.384 2.384 0 00.44-2.048zm-2.118-2.763l.744 3.096a.96.96 0 01-.178.83.831.831 0 01-.665.332c-.433 0-.808-.347-.858-.807l-.41-3.444 1.367-.007zm-4.188.007h1.389l.382 3.203a.952.952 0 01-.233.758c-.156.184-.383.29-.673.29-.475 0-.865-.418-.865-.928V1.542zM5.011 4.745l.39-3.203H6.79v3.323a.91.91 0 01-.914.928.853.853 0 01-.63-.29 1.007 1.007 0 01-.235-.758zM1.858 4.63l.716-3.089H3.97l-.411 3.444c-.057.46-.425.807-.857.807a.816.816 0 01-.66-.333.937.937 0 01-.184-.829z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ var bottom_nav_marketplace_icon_mob_active = (SvgBottomNavMarketplaceIconMobActive);
;// CONCATENATED MODULE: ../core/dist/icons/bottom-nav-marketplace-icon-mob-disabled.svg
var bottom_nav_marketplace_icon_mob_disabled_path;

function bottom_nav_marketplace_icon_mob_disabled_extends() { bottom_nav_marketplace_icon_mob_disabled_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bottom_nav_marketplace_icon_mob_disabled_extends.apply(this, arguments); }



function SvgBottomNavMarketplaceIconMobDisabled(props) {
  return /*#__PURE__*/react.createElement("svg", bottom_nav_marketplace_icon_mob_disabled_extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bottom_nav_marketplace_icon_mob_disabled_path || (bottom_nav_marketplace_icon_mob_disabled_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.513 4.298l-.744-3.096A1.392 1.392 0 0012.416.125H2.574c-.638 0-1.197.446-1.346 1.077L.484 4.298c-.17.723-.014 1.46.44 2.041.056.078.134.135.197.206v4.917c0 .78.638 1.417 1.418 1.417h9.92c.779 0 1.417-.638 1.417-1.417V6.545c.063-.064.141-.128.198-.199a2.384 2.384 0 00.44-2.048zm-2.118-2.763l.744 3.096a.96.96 0 01-.178.83.831.831 0 01-.665.332c-.433 0-.808-.347-.858-.807l-.41-3.444 1.367-.007zm-4.188.007h1.389l.382 3.203a.952.952 0 01-.233.758c-.156.184-.383.29-.673.29-.475 0-.865-.418-.865-.928V1.542zM5.011 4.745l.39-3.203H6.79v3.323a.91.91 0 01-.914.928.853.853 0 01-.63-.29 1.007 1.007 0 01-.235-.758zM1.858 4.63l.716-3.089H3.97l-.411 3.444c-.057.46-.425.807-.857.807a.816.816 0 01-.66-.333.937.937 0 01-.184-.829z",
    fill: "#999"
  })));
}

/* harmony default export */ var bottom_nav_marketplace_icon_mob_disabled = (SvgBottomNavMarketplaceIconMobDisabled);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ./hooks/useFeatureByServiceType.ts
var useFeatureByServiceType = __webpack_require__(57);
// EXTERNAL MODULE: ./constants/marketplace.constants.ts
var marketplace_constants = __webpack_require__(57993);
;// CONCATENATED MODULE: ./components/layout/navbar-menu-items.tsx













//Mobile icon












var NavBarName = {
    PREMIUM_LOADS: "premium-loads"
};
var NavBarMenuItems = function(navbarName, mktType) {
    var _navElementArray;
    var router = (0,next_router.useRouter)();
    var mobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var loadLorryIconStyle = {
        transform: "scale(0.9)"
    };
    var marketPlaceIconStyle = {
        transform: "scale(1.2)",
        marginRight: 4,
        marginLeft: 3
    };
    var ref = (0,useFeatureByServiceType/* useFeatureByServiceType */.D)(), ShowLoadPost = ref.ShowLoadPost, ShowLorryPost = ref.ShowLorryPost, showLoadFeatures = ref.showLoadFeatures, showLorryFeatures = ref.showLorryFeatures;
    var navElementArray = [];
    if (ShowLoadPost) navElementArray.push({
        id: "myLoads",
        icon: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_nav_load_icon_mob_disabled, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(load_listing_disabled/* default */.Z, {
            style: loadLorryIconStyle
        }),
        iconActive: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_nav_load_icon_mob_active, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(load_listing_white/* default */.Z, {
            style: loadLorryIconStyle
        }),
        label: "My Loads",
        pathName: mktType && router.asPath.includes("my-loads") ? router.asPath.includes("bids") ? routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.BIDS */.n.BIDS) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING),
        clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.my_load_icon_clicked */.wQ.SIDE_NAV.my_load_icon_clicked
    });
    if (ShowLorryPost) navElementArray.push({
        id: "myLories",
        icon: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_nav_lorry_icon_mob_disabled, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(my_lorries_inactive/* default */.Z, {
            style: loadLorryIconStyle
        }),
        iconActive: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_nav_lorry_icon_mob_active, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(my_lorries_active/* default */.Z, {
            style: loadLorryIconStyle
        }),
        label: "My Lorries",
        pathName: mktType && router.asPath.includes("my-lorries") ? router.asPath.includes("bids") ? routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.BIDS */.n.BIDS) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING) : routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING),
        clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.my_lorry_icon_clicked */.wQ.SIDE_NAV.my_lorry_icon_clicked
    });
    (_navElementArray = navElementArray).push.apply(_navElementArray, [
        {
            id: "home",
            icon: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(vahak_home_icon_mob_disable, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(home_icon_disabled/* default */.Z, {
                style: loadLorryIconStyle
            }),
            iconActive: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(vahak_home_icon_mob_active/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(home_icon/* default */.Z, {
                style: loadLorryIconStyle
            }),
            label: "Home",
            pathName: routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl(),
            clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.homepage_icon_clicked */.wQ.SIDE_NAV.homepage_icon_clicked
        }
    ].concat((0,_to_consumable_array/* default */.Z)(showLoadFeatures || showLorryFeatures ? [
        {
            id: "marketplace",
            icon: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_nav_marketplace_icon_mob_disabled, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceNavDeadIcon/* default */.Z, {
                style: marketPlaceIconStyle
            }),
            iconActive: mobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottom_nav_marketplace_icon_mob_active, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceNavActiveIcon/* default */.Z, {
                style: marketPlaceIconStyle
            }),
            label: "Market",
            pathName: marketplace_constants/* MARKETPLACE_ROUTE_CONFIG.loadUrl */.VV.loadUrl,
            clientAppEventName: event_names/* GA4EventNames.SIDE_NAV.marketplace_icon_clicked */.wQ.SIDE_NAV.marketplace_icon_clicked
        }
    ] : [])));
    return navElementArray;
};


/***/ }),

/***/ 23441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PlainLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var PlainLayout = function(param) {
    var page = param.page;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: page
    });
};


/***/ }),

/***/ 63989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ top_nav_layout_TopNavLayout; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/icons/PlaystoreBadge.svg
var PlaystoreBadge = __webpack_require__(98703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ../core/dist/constants/mostSearchedLinks.js
var mostSearchedLinks = __webpack_require__(16593);
// EXTERNAL MODULE: ../core/dist/constants/eventsMapObj.js
var eventsMapObj = __webpack_require__(3000);
// EXTERNAL MODULE: ../core/dist/icons/Plus.svg
var Plus = __webpack_require__(57692);
// EXTERNAL MODULE: ../core/dist/icons/Minus.svg
var Minus = __webpack_require__(67843);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
;// CONCATENATED MODULE: ./components/layout/footer/MostSearchedLinks/CategoryList/mostSearchedCategoryList.ts
var mostSearchedCategoryList = {
    "online-truck-booking": [
        "Bangalore",
        "Hyderabad",
        "Mumbai",
        "Chennai",
        "Delhi",
        "Gurgaon",
        "Noida",
        "Coimbatore",
        "Ghaziabad",
        "Chandigarh",
        "udaipur",
        "kolkata",
        "navi mumbai",
        "thane",
        "bhiwandi",
        "pune",
        "nashik",
        "nagpur",
        "rajkot",
        "surat",
        "ahmedabad",
        "vadodara",
        "gandhinagar",
        "jaipur",
        "indore",
        "bhopal",
        "agra",
        "lucknow",
        "faridabad",
        "visakhapatnam",
        "vizag",
        "mysuru",
        "kanpur",
        "varanasi",
        "howrah",
        "gandhidham",
        "patna"
    ],
    "online-load-booking": [
        "Bangalore",
        "Hyderabad",
        "Mumbai",
        "Chennai",
        "Delhi",
        "Gurgaon",
        "Noida",
        "Coimbatore",
        "Ghaziabad",
        "Chandigarh",
        "udaipur",
        "kolkata",
        "navi mumbai",
        "thane",
        "bhiwandi",
        "pune",
        "nashik",
        "nagpur",
        "rajkot",
        "surat",
        "ahmedabad",
        "vadodara",
        "gandhinagar",
        "jaipur",
        "indore",
        "bhopal",
        "agra",
        "lucknow",
        "faridabad",
        "visakhapatnam",
        "vizag",
        "mysuru",
        "kanpur",
        "varanasi",
        "howrah",
        "gandhidham",
        "patna"
    ],
    transporter: [
        "bangalore",
        "hyderabad",
        "mumbai",
        "chennai",
        "delhi",
        "gurgaon",
        "noida",
        "coimbatore",
        "ghaziabad",
        "chandigarh",
        "udaipur",
        "kolkata",
        "navi mumbai",
        "thane",
        "bhiwandi",
        "pune",
        "nashik",
        "nagpur",
        "rajkot",
        "surat",
        "ahmedabad",
        "vadodara",
        "gandhinagar",
        "jaipur",
        "indore",
        "bhopal",
        "agra",
        "lucknow",
        "faridabad",
        "visakhapatnam",
        "vizag",
        "mysuru",
        "kanpur",
        "varanasi",
        "howrah",
        "gandhidham",
        "patna"
    ],
    "transport-service": [
        "bangalore",
        "hyderabad",
        "mumbai",
        "chennai",
        "delhi",
        "gurgaon",
        "noida",
        "coimbatore",
        "ghaziabad",
        "chandigarh",
        "udaipur",
        "kolkata",
        "navi mumbai",
        "thane",
        "bhiwandi",
        "pune",
        "nashik",
        "nagpur",
        "rajkot",
        "surat",
        "ahmedabad",
        "vadodara",
        "gandhinagar",
        "jaipur",
        "indore",
        "bhopal",
        "agra",
        "lucknow",
        "faridabad",
        "visakhapatnam",
        "vizag",
        "mysuru",
        "kanpur",
        "varanasi",
        "howrah",
        "gandhidham",
        "patna"
    ],
    // "truckBooking": [
    //
    //     "bangalore",
    //     "hyderabad",
    //     "mumbai",
    //     "chennai",
    //     "delhi",
    //     "gurgaon",
    //     "noida",
    //     "coimbatore",
    //     "ghaziabad",
    //     "chandigarh",
    //     "udaipur",
    //     "kolkata",
    //     "navi mumbai",
    //     "thane",
    //     "bhiwandi",
    //     "pune",
    //     "nashik",
    //     "nagpur",
    //     "rajkot",
    //     "surat",
    //     "ahmedabad",
    //     "vadodara",
    //     "gandhinagar",
    //     "jaipur",
    //     "indore",
    //     "bhopal",
    //     "agra",
    //     "lucknow",
    //     "faridabad",
    //     "visakhapatnam",
    //     "vizag",
    //     "mysuru",
    //     "kanpur",
    //     "varanasi",
    //     "howrah",
    //     "gandhidham",
    //     "patna"
    // ],
    "transport-directory": [
        "bangalore",
        "hyderabad",
        "mumbai",
        "chennai",
        "delhi",
        "gurgaon",
        "noida",
        "coimbatore",
        "ghaziabad",
        "chandigarh",
        "udaipur",
        "kolkata",
        "navi mumbai",
        "thane",
        "bhiwandi",
        "pune",
        "nashik",
        "nagpur",
        "rajkot",
        "surat",
        "ahmedabad",
        "vadodara",
        "gandhinagar",
        "jaipur",
        "indore",
        "bhopal",
        "agra",
        "lucknow",
        "faridabad",
        "visakhapatnam",
        "vizag",
        "mysuru",
        "kanpur",
        "varanasi",
        "howrah",
        "gandhidham",
        "patna"
    ],
    lorry: [
        {
            src: "Bangalore",
            dest: "Pune"
        },
        {
            src: "Bangalore",
            dest: "Mumbai"
        },
        {
            src: "Bangalore",
            dest: "Delhi"
        },
        {
            src: "Bangalore",
            dest: "Hyderabad"
        },
        {
            src: "Bangalore",
            dest: "Chennai"
        },
        {
            src: "Bangalore",
            dest: "Kolkata"
        },
        {
            src: "Mumbai",
            dest: "Delhi"
        },
        {
            src: "Mumbai",
            dest: "Hyderabad"
        },
        {
            src: "Mumbai",
            dest: "Kolkata"
        },
        {
            src: "Mumbai",
            dest: "Chennai"
        },
        {
            src: "Mumbai",
            dest: "Jaipur"
        },
        {
            src: "Mumbai",
            dest: "Ahmedabad"
        },
        {
            src: "Mumbai",
            dest: "Nagpur"
        },
        {
            src: "Delhi",
            dest: "Nagpur"
        },
        {
            src: "Delhi",
            dest: "Ahmedabad"
        },
        {
            src: "Delhi",
            dest: "Kolkata"
        },
        {
            src: "Delhi",
            dest: "Chennai"
        },
        {
            src: "Delhi",
            dest: "Hyderabad"
        },
        {
            src: "Delhi",
            dest: "Bangalore"
        }
    ]
};

// EXTERNAL MODULE: ./components/layout/footer/MostSearchedLinks/CategoryList/categoryListStyles.module.scss
var categoryListStyles_module = __webpack_require__(8141);
var categoryListStyles_module_default = /*#__PURE__*/__webpack_require__.n(categoryListStyles_module);
;// CONCATENATED MODULE: ./components/layout/footer/MostSearchedLinks/CategoryList/CategoryList.tsx




// Constants



// Styles

var CategoryList = function(param) {
    var selectedList = param.selectedList, isOpen = param.isOpen, isMobile = param.isMobile, limit = param.limit, title = param.title;
    var ref = (0,react.useState)(limit ? limit : 5), showMoreCount = ref[0], setShowMoreCount = ref[1];
    (0,react.useEffect)(function() {
        if (isOpen) {
            setShowMoreCount(limit);
        }
    }, [
        isOpen
    ]);
    var urlEndpointBasedOnSelectedList = function() {
        switch(selectedList){
            case mostSearchedLinks/* mostSearchedLinksMenusKeys.ONLINE_TRUCK_BOOKING */.s.ONLINE_TRUCK_BOOKING:
            case mostSearchedLinks/* mostSearchedLinksMenusKeys.LORRY */.s.LORRY:
                return "marketplace/lorry";
            case mostSearchedLinks/* mostSearchedLinksMenusKeys.ONLINE_LOAD_BOOKING */.s.ONLINE_LOAD_BOOKING:
                return "marketplace/load";
            case mostSearchedLinks/* mostSearchedLinksMenusKeys.TRANSPORT_SERVICE */.s.TRANSPORT_SERVICE:
            case mostSearchedLinks/* mostSearchedLinksMenusKeys.TRANSPORT_DIRECTORY */.s.TRANSPORT_DIRECTORY:
            case mostSearchedLinks/* mostSearchedLinksMenusKeys.TRANSPORTER */.s.TRANSPORTER:
                return "transporters";
            default:
                return "";
        }
    };
    var renderCityLink = function(cityName) {
        var city = cityName.toLowerCase().replace(" ", "-") !== "india" ? "/".concat(cityName.toLowerCase().replace(" ", "-")) : "";
        // if (CITIES_WITH_CITY_PAGES.includes(cityName.toLowerCase().replace(" ", "-"))) {
        //     return <AppLink href={`/city${city}`}>{cityName}</AppLink>;
        // } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
            href: "/".concat(urlEndpointBasedOnSelectedList()).concat(city),
            children: cityName
        });
    // }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                className: classnames_default()((categoryListStyles_module_default()).categoryHeading),
                children: [
                    title,
                    " IN"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: classnames_default()((categoryListStyles_module_default()).mostSearchedCategoryList, isOpen ? (categoryListStyles_module_default()).active : (categoryListStyles_module_default()).inactive, isMobile ? (categoryListStyles_module_default()).mobile : (categoryListStyles_module_default()).web),
                children: mostSearchedCategoryList[selectedList] && mostSearchedCategoryList[selectedList].slice(0, showMoreCount).map(function(cityName, i) {
                    return typeof cityName !== "object" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()((categoryListStyles_module_default())[selectedList]),
                        children: renderCityLink(cityName)
                    }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()((categoryListStyles_module_default())[selectedList]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                            href: "/".concat(urlEndpointBasedOnSelectedList(), "/").concat(cityName.src.toLowerCase().replace(" ", "-"), "-to-").concat(cityName.dest.toLowerCase().replace(" ", "-")),
                            children: [
                                cityName.src,
                                " to ",
                                cityName.dest
                            ]
                        })
                    }, i);
                })
            }),
            selectedList !== "" && isOpen && isMobile && showMoreCount === limit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((categoryListStyles_module_default()).show_more),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            setShowMoreCount(mostSearchedCategoryList[selectedList].length);
                        },
                        className: classnames_default()((categoryListStyles_module_default()).link),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#",
                            passHref: true,
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                children: "Show more"
                            })
                        })
                    })
                })
            }) : isOpen && showMoreCount && showMoreCount > limit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((categoryListStyles_module_default()).show_more),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return setShowMoreCount(limit);
                        },
                        className: classnames_default()((categoryListStyles_module_default()).link),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#",
                            passHref: true,
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                children: "Show less"
                            })
                        })
                    })
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var CategoryList_CategoryList = (CategoryList);

// EXTERNAL MODULE: ./components/layout/footer/MostSearchedLinks/MobileFilter/MobileFilter.module.scss
var MobileFilter_module = __webpack_require__(87381);
var MobileFilter_module_default = /*#__PURE__*/__webpack_require__.n(MobileFilter_module);
;// CONCATENATED MODULE: ./components/layout/footer/MostSearchedLinks/MobileFilter/MobileFilter.tsx



// Components

// Style

// Icons


// Utils & helper functions

var MobileFilter = function(param) {
    var data = param.data;
    var ref = (0,react.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(data[0].key), activeFilter = ref1[0], setActiveFilter = ref1[1];
    var handleClick = function(val) {
        var currentFilterIndex = val.currentFilterIndex;
        if (currentFilterIndex === activeFilter) {
            setIsOpen(function(state) {
                return !state;
            });
        } else {
            setActiveFilter(currentFilterIndex);
            setIsOpen(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((MobileFilter_module_default()).mobileFilter_layout),
        children: data.map(function(menu, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                        className: classnames_default()((MobileFilter_module_default()).filterLinks, menu.key === activeFilter && isOpen ? (MobileFilter_module_default()).active : ""),
                        onClick: function() {
                            return handleClick({
                                currentFilterIndex: menu.key,
                                isOpen: isOpen
                            });
                        },
                        children: [
                            menu.title,
                            " ",
                            menu.key === activeFilter && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_CategoryList, {
                        selectedList: menu.key,
                        isOpen: menu.key === activeFilter && isOpen ? true : false,
                        isMobile: true,
                        limit: 8,
                        title: menu.title
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ var MobileFilter_MobileFilter = (MobileFilter);

;// CONCATENATED MODULE: ./components/layout/footer/MostSearchedLinks/MostSearchedLinks.tsx



// Utils & helper functions




// Icons





var MostSearchedLinks = function() {
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var ref = (0,react.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(mostSearchedLinks/* mostSearchedLinksMenus.0.key */.v[0].key), activeSearch = ref1[0], setActiveSearch = ref1[1];
    var ref2 = (0,react.useState)(true), showLinks = ref2[0], setShowLinks = ref2[1];
    var ref3 = (0,react.useState)(mostSearchedLinks/* mostSearchedLinksMenus.0.title */.v[0].title), title = ref3[0], setTitle = ref3[1];
    var ref4 = (0,react.useState)(0), activeIndex = ref4[0], setActiveIndex = ref4[1];
    var handleClick = function(val) {
        var currentSearchFilter = val.currentSearchFilter, title = val.title, index = val.index;
        var calVal = eventsMapObj/* MostSearchedLinksItemsGaEvents */.Lj[currentSearchFilter];
        if (calVal !== undefined) {
            (0,user_analytics_service/* ga4sendEvent */.zs)("Websitemain_top_navigation_web", {
                value: calVal
            });
        }
        if (activeSearch === currentSearchFilter) {
            setShowLinks(function(state) {
                return !state;
            });
        } else {
            setActiveSearch(currentSearchFilter);
            setShowLinks(true);
            setActiveIndex(index);
            setTitle(title);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mostSearchedLinks ".concat(isOpen ? "active" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        if (isOpen) {
                            setShowLinks(false);
                        } else {
                            setShowLinks(true);
                        }
                        setIsOpen(function(state) {
                            return !state;
                        });
                    // setActiveSearch("onlineTruckBooking");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#",
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Most Searched Links"
                                }),
                                " ",
                                isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                            ]
                        })
                    })
                })
            }),
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("Footer_mobile-link-container", isOpen && "active"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFilter_MobileFilter, {
                    data: mostSearchedLinks/* mostSearchedLinksMenus */.v
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "nav ".concat(isOpen ? "active" : ""),
                        children: mostSearchedLinks/* mostSearchedLinksMenus.map */.v.map(function(menu, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "nav-item ".concat(menu.key === activeSearch && showLinks ? "is-active" : ""),
                                        onClick: function() {
                                            return handleClick({
                                                currentSearchFilter: menu.key,
                                                isOpen: !isOpen,
                                                title: menu.title,
                                                index: index
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "#",
                                            "active-color": "orange",
                                            passHref: true,
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: menu.title
                                                    }),
                                                    " ",
                                                    menu.key === activeSearch && showLinks ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(menu.key === activeSearch || activeIndex - 1 === index ? "active" : "horizontalDivider")
                                    })
                                ]
                            }, menu.key);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_CategoryList, {
                        selectedList: activeSearch || "",
                        title: title,
                        isOpen: showLinks
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MostSearchedLinks_MostSearchedLinks = (MostSearchedLinks);

// EXTERNAL MODULE: ../core/dist/constants/socialMediaLinks.js
var socialMediaLinks = __webpack_require__(92683);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
;// CONCATENATED MODULE: ../core/dist/icons/facebook.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgFacebook(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 24,
    viewBox: "0 0 12 24"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M7.5 8.25v-3A1.5 1.5 0 019 3.75h1.5V0h-3A4.5 4.5 0 003 4.5v3.75H0V12h3v12h4.5V12h3L12 8.25z",
    fill: "#fff"
  })));
}

/* harmony default export */ var facebook = (SvgFacebook);
;// CONCATENATED MODULE: ../core/dist/icons/instagram.svg
var _defs, instagram_path, _path2;

function instagram_extends() { instagram_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_extends.apply(this, arguments); }



function SvgInstagram(props) {
  return /*#__PURE__*/react.createElement("svg", instagram_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.995,
    height: 24,
    viewBox: "0 0 23.995 24"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null))), instagram_path || (instagram_path = /*#__PURE__*/react.createElement("path", {
    className: "instagram_svg__aa",
    d: "M23.935 7.056a8.77 8.77 0 00-.558-2.912A6.148 6.148 0 0019.865.633a8.792 8.792 0 00-2.914-.558C15.669.014 15.261 0 12.003 0S8.336.014 7.056.07a8.772 8.772 0 00-2.911.558 5.856 5.856 0 00-2.129 1.388A5.909 5.909 0 00.633 4.14a8.793 8.793 0 00-.558 2.911C.014 8.336 0 8.744 0 12s.014 3.666.07 4.946a8.769 8.769 0 00.558 2.912A6.147 6.147 0 004.14 23.37a8.793 8.793 0 002.911.56c1.28.056 1.688.07 4.946.07s3.666-.014 4.946-.07a8.767 8.767 0 002.911-.558 6.139 6.139 0 003.512-3.512 8.8 8.8 0 00.558-2.912c.056-1.28.07-1.688.07-4.946s-.003-3.666-.059-4.946zm-2.161 9.8a6.578 6.578 0 01-.413 2.227 3.981 3.981 0 01-2.279 2.279 6.6 6.6 0 01-2.227.412c-1.266.056-1.646.07-4.848.07s-3.587-.014-4.848-.07a6.575 6.575 0 01-2.227-.412 3.693 3.693 0 01-1.381-.897 3.731 3.731 0 01-.9-1.378 6.6 6.6 0 01-.4-2.227c-.056-1.266-.07-1.646-.07-4.848s.014-3.587.07-4.848a6.575 6.575 0 01.412-2.227 3.648 3.648 0 01.9-1.379 3.726 3.726 0 011.378-.9 6.606 6.606 0 012.223-.408c1.266-.056 1.646-.07 4.848-.07s3.587.014 4.848.07a6.578 6.578 0 012.227.413 3.69 3.69 0 011.378.9 3.73 3.73 0 01.9 1.379 6.6 6.6 0 01.413 2.227c.056 1.266.07 1.646.07 4.848s-.018 3.572-.075 4.838zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "instagram_svg__aa",
    d: "M12.003 5.837a6.165 6.165 0 106.165 6.165 6.167 6.167 0 00-6.165-6.165zm0 10.165a4 4 0 114-4 4 4 0 01-4 4zm0 0M19.851 5.593a1.439 1.439 0 11-1.439-1.439 1.439 1.439 0 011.439 1.439zm0 0"
  })));
}

/* harmony default export */ var instagram = (SvgInstagram);
;// CONCATENATED MODULE: ../core/dist/icons/linkedin-logo.svg
var linkedin_logo_defs, linkedin_logo_path;

function linkedin_logo_extends() { linkedin_logo_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return linkedin_logo_extends.apply(this, arguments); }



function SvgLinkedinLogo(props) {
  return /*#__PURE__*/react.createElement("svg", linkedin_logo_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.969,
    height: 23.969,
    viewBox: "0 0 23.969 23.969"
  }, props), linkedin_logo_defs || (linkedin_logo_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null))), linkedin_logo_path || (linkedin_logo_path = /*#__PURE__*/react.createElement("path", {
    className: "linkedin-logo_svg__aa",
    d: "M21.572 0H2.4A2.4 2.4 0 000 2.4v19.172a2.4 2.4 0 002.4 2.4h19.172a2.4 2.4 0 002.4-2.4V2.4a2.4 2.4 0 00-2.4-2.4zM7.191 20.373H3.6V9.587h3.6zM5.393 7.55A2.157 2.157 0 117.55 5.393 2.148 2.148 0 015.393 7.55zm14.98 12.823h-3.6v-6.351a1.8 1.8 0 00-3.6 0v6.352h-3.6V9.587h3.6v1.438a3.871 3.871 0 013-1.678 4.246 4.246 0 014.195 4.195z"
  })));
}

/* harmony default export */ var linkedin_logo = (SvgLinkedinLogo);
;// CONCATENATED MODULE: ../core/dist/icons/youtube.svg
var youtube_defs, youtube_path;

function youtube_extends() { youtube_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return youtube_extends.apply(this, arguments); }



function SvgYoutube(props) {
  return /*#__PURE__*/react.createElement("svg", youtube_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.278,
    height: 24,
    viewBox: "0 0 34.278 24"
  }, props), youtube_defs || (youtube_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("style", null))), youtube_path || (youtube_path = /*#__PURE__*/react.createElement("path", {
    className: "youtube_svg__aa",
    d: "M33.572 3.755A4.294 4.294 0 0030.551.734C27.869 0 17.139 0 17.139 0S6.41 0 3.727.706A4.381 4.381 0 00.706 3.755 45.249 45.249 0 000 12a45.083 45.083 0 00.706 8.245 4.3 4.3 0 003.021 3.021C6.437 24 17.139 24 17.139 24s10.729 0 13.412-.706a4.3 4.3 0 003.021-3.021 45.263 45.263 0 00.706-8.245s.028-5.59-.706-8.273zm-19.85 13.384V6.861L22.644 12zm0 0"
  })));
}

/* harmony default export */ var youtube = (SvgYoutube);
;// CONCATENATED MODULE: ../core/dist/icons/twitter.svg
var _rect, twitter_path;

function twitter_extends() { twitter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }



function SvgTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 509.64"
  }, props), _rect || (_rect = /*#__PURE__*/react.createElement("rect", {
    width: 512,
    height: 509.64,
    rx: 115.61,
    ry: 115.61
  })), twitter_path || (twitter_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M323.74 148.35h36.12l-78.91 90.2 92.83 122.73h-72.69l-56.93-74.43-65.15 74.43h-36.14l84.4-96.47-89.05-116.46h74.53l51.46 68.04 59.53-68.04zm-12.68 191.31h20.02l-129.2-170.82H180.4l130.66 170.82z"
  })));
}

/* harmony default export */ var twitter = (SvgTwitter);
// EXTERNAL MODULE: ./components/layout/footer/Footer.module.scss
var Footer_module = __webpack_require__(44826);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/layout/footer/SocialLinks/SocialLinks.tsx


// Utils & helper functions




// Constants


// Logos





// Styles

var SocialLinks = function(props) {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isMobile = ref.isMobile, userId = ref.userId, name = ref.name, serviceType = ref.serviceType, companyId = ref.companyId;
    // const onClickWhatsapp = () => {
    //     window.open(
    //         isMobile ? VAHAK_WHATSAPP_LINK_MOBILE : VAHAK_WHATSAPP_LINK_DESKTOP,
    //         "_blank",
    //         "noopener noreferrer"
    //     );
    // };
    var handleLinkClick = function(param) {
        var id = param.id, callback = param.callback;
        if (callback) {
            callback(); // to handle whatsapp link
        }
        (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Connect_with_us_clicked_web */.wQ.Connect_with_us_clicked_web, {
            company_id: companyId,
            user_name: name,
            service_type: serviceType,
            channel: id
        });
    };
    var allChannelLinks = [
        {
            id: "Facebook",
            title: "Connect with Vahak community on Facebook",
            link: socialMediaLinks/* FACEBOOK */.vq,
            openInNewTab: true,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook, {
                width: "12",
                height: "25"
            })
        },
        {
            id: "LinkedIn",
            title: "Connect with Vahak group on LinkedIn",
            link: socialMediaLinks/* LINKEDIN */.fW,
            openInNewTab: true,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedin_logo, {
                className: classnames_default()((Footer_module_default()).fillWhite),
                width: "23.97",
                height: "24.97"
            })
        },
        {
            id: "Youtube",
            title: "Connect with Vahak channel on Youtube",
            link: socialMediaLinks/* YOUTUBE */.VU,
            openInNewTab: true,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube, {
                className: classnames_default()((Footer_module_default()).fillWhite),
                width: "34.27",
                height: "25.5"
            })
        },
        // {
        //     id: "WhatsApp",
        //     title: "Connect with Vahak Transport Market on WhatsApp",
        //     openInNewTab: true,
        //     callback: onClickWhatsapp,
        //     icon: <Whatsapp className={classnames(footerStyles.fillWhite)} width="22" height="22" />
        // },
        {
            id: "Instagram",
            title: "Connect with Vahak Transport Market on Instagram",
            link: socialMediaLinks/* INSTAGRAM */.Er,
            openInNewTab: true,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(instagram, {
                className: classnames_default()((Footer_module_default()).fillWhite),
                width: "23.98",
                height: "24"
            })
        },
        {
            id: "Twitter",
            title: "Connect with Vahak Transport Market on Twitter",
            link: socialMediaLinks/* TWITTER */.Ib,
            openInNewTab: true,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter, {
                // className={classnames(footerStyles.fillWhite)}
                width: "24",
                height: "24"
            })
        }
    ];
    var onClickHandleMoEngage = function(channel) {
        (0,user_analytics_service/* moEngageUserEventTrack */.Im)("connect_with_us_clicked_web", {
            user_id: userId,
            user_name: name,
            service_type: serviceType,
            channel: channel
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((Footer_module_default()).socialIconWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((Footer_module_default()).socialIconContainer),
            children: allChannelLinks.map(function(item) {
                var Icon = item.icon, link = item.link, openInNewTab = item.openInNewTab, title = item.title, id = item.id;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                    id: id,
                    openInNewTab: openInNewTab,
                    title: title,
                    href: link,
                    onClick: function() {
                        return handleLinkClick(item);
                    },
                    children: [
                        " ",
                        Icon
                    ]
                }, id);
            })
        })
    });
};
/* harmony default export */ var SocialLinks_SocialLinks = (SocialLinks);

// EXTERNAL MODULE: ./components/utils/app-link/AppLink.tsx
var AppLink = __webpack_require__(92477);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ../core/dist/icons/VahakLogoWhite_v03.svg
var _style, VahakLogoWhite_v03_path, VahakLogoWhite_v03_path2;

function VahakLogoWhite_v03_extends() { VahakLogoWhite_v03_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return VahakLogoWhite_v03_extends.apply(this, arguments); }



function SvgVahakLogoWhiteV03(props) {
  return /*#__PURE__*/react.createElement("svg", VahakLogoWhite_v03_extends({
    id: "VahakLogoWhite_v03_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1213 484",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".VahakLogoWhite_v03_svg__st3{fill:#fff}")), VahakLogoWhite_v03_path || (VahakLogoWhite_v03_path = /*#__PURE__*/react.createElement("path", {
    d: "M200.15 207.6a72.996 72.996 0 01-6.38 32.04c-1.33 2.14-2.77 4.2-4.33 6.17 1.68-.32 3.31-.86 4.85-1.62a22.54 22.54 0 009.75-24.17 44.32 44.32 0 00-3.92-12.41m117.32-30.27h-7.83c3.17 12.51 8.65 24.33 16.16 34.83 5.73 8.92 11.75 17.62 16.89 26.89a167.1 167.1 0 0121.35 65.02c3.79 39.01-16.72 70.76-52.02 87.77-22.29 10.7-42.45 15.91-60.02 28.77a108.062 108.062 0 00-26.28 29.79c1.87-41.56 41.8-50.22 73.48-65.66 36.39-17.76 52.25-46.61 47.77-84.72-5.23-32.99-18.51-55.06-34.02-80.54-7.59-11.39-14-23.53-19.11-36.23a71.112 71.112 0 01-4.03-20.46 244.336 244.336 0 00-139.72 0 71.491 71.491 0 01-4.01 20.46 204.278 204.278 0 01-19.12 36.24c-15.52 25.48-28.8 47.51-34.02 80.54-4.48 38.12 11.39 66.95 47.77 84.72 31.68 15.44 71.61 24.1 73.46 65.66a108.301 108.301 0 00-26.25-29.8c-17.61-12.86-37.81-18.11-60.06-28.77-35.26-17-55.85-48.76-52.01-87.77 2.59-22.9 9.85-45.03 21.33-65.02 5.14-9.26 11.14-17.97 16.9-26.89 7.52-10.5 13-22.31 16.16-34.83h-7.8c-2.77 8.7-6.69 16.98-11.67 24.63-19.59 31.94-42.07 59.79-43.7 99.78-.12 9.05.46 18.1 1.74 27.07a55.361 55.361 0 01-9.75-25.44 85.276 85.276 0 011.91-31.78c5.83-24.28 19.59-45.17 31.34-66.69a93.554 93.554 0 0013.05-32.18c1.1-7.61-2.93-15.04-9.9-18.28 3.04-2 6.53-3.2 10.15-3.48 5.1-.31 10.04 1.81 13.34 5.71a303.577 303.577 0 00-7.3-34.3c-2.27-8.57-5-17.01-8.17-25.28-2.1-5.58-4.04-10.29-5.36-13.39H96.7c-6.57.43-12.26-4.51-12.77-11.08 1.01-7.06 7.55-11.97 14.62-10.96a12.92 12.92 0 0110.97 11.03c-.09 3.74-2.13 7.17-5.38 9.03a233.701 233.701 0 0034.43 37.98c14.18-6.36 22.42-21.35 20.2-36.74-6.17-.08-11.25-4.88-11.67-11.04 1.01-7.06 7.55-11.97 14.62-10.96A12.92 12.92 0 01172.69 72c-.32 5.39-4.32 9.85-9.64 10.74a55.728 55.728 0 0031.27 23.81 62.369 62.369 0 01-12.18 17.1c-11.32 2.5-22.3 6.3-32.74 11.34-5.54.19-11.07-.35-16.47-1.6-1.21-.42-2.48-.64-3.76-.67 3.42 5.6 6.1 11.62 7.95 17.91 41.32-16.72 123.99-16.67 165.62.13a82.21 82.21 0 017.78-18.11c-1.28.02-2.55.25-3.76.67a63.358 63.358 0 01-16.47 1.6 149.694 149.694 0 00-32.78-11.34 62.732 62.732 0 01-12.18-17.1 55.761 55.761 0 0031.29-23.81 11.5 11.5 0 01-9.6-10.7c1.01-7.07 7.56-11.98 14.63-10.97 5.71.82 10.2 5.32 10.98 11.04-.43 6.15-5.5 10.95-11.67 11.04-2.22 15.38 6.02 30.37 20.2 36.74a248.905 248.905 0 0034.62-37.98 10.68 10.68 0 01-5.39-9.03c1.01-7.06 7.55-11.97 14.62-10.96a12.92 12.92 0 0110.97 11.03c-.48 6.6-6.2 11.58-12.8 11.14h-1.47c-1.33 3.09-3.26 7.78-5.36 13.39a257.8 257.8 0 00-8.09 25.27 326.969 326.969 0 00-8.2 35.22c3.22-4.64 8.62-7.28 14.26-6.97 3.62.28 7.12 1.48 10.15 3.48-6.98 3.24-11 10.67-9.9 18.28a93.199 93.199 0 0013.05 32.18c11.77 21.54 25.48 42.42 31.36 66.69a85.652 85.652 0 011.93 31.81 55.583 55.583 0 01-9.75 25.44c1.29-8.96 1.87-18.01 1.76-27.07-1.67-40.01-24.13-67.84-43.7-99.78a102.19 102.19 0 01-11.72-24.63M222.93 55.9c5.39-.95 9.42-5.49 9.73-10.95-1.04-7.24-7.74-12.26-14.98-11.23-5.82.83-10.4 5.41-11.23 11.23.34 5.72 4.69 10.41 10.37 11.17a154.888 154.888 0 01-27.56 65.49l-.1.23h61.4l-.08-.23a154.889 154.889 0 01-27.57-65.69m39.56 282.18c-9.59 16.72-17.79 14.28-26.11 10.58a35.619 35.619 0 00-32.63-.17c-8.44 3.8-16.72 6.62-26.47-10.4a13.127 13.127 0 00.92 16.58c11.52 9.69 31.52 12.23 39.83 32.04.4 4.69 3.33 4.69 3.73 0 8.34-19.76 28.34-22.29 39.82-32.04 4.21-4.61 4.6-11.54.91-16.59m-70.9-140.03c2.44 14.01.17 28.43-6.45 41.01-4.17 6.52-8.89 12.64-13.12 18.64-16.47 23.39-15.69 47.25-3.46 64.09a78.785 78.785 0 0128.72-18.11c4.53-1.88 9.19-3.46 13.93-4.73 3.55-12.22-9.05-31.57-18.11-35.38-3.95-1.4-8.04-2.38-12.2-2.9 0 0 .6-2.31 9.17-8.34 5.87-3.46 13.07-3.8 19.24-.92 3.23 1.23 6.63 1.93 10.09 2.08h.89c3.45-.12 6.85-.82 10.07-2.08a20.833 20.833 0 0119.26.92c8.61 5.99 9.17 8.34 9.17 8.34-4.16.52-8.25 1.5-12.2 2.9-9.13 3.8-21.72 23.16-18.11 35.38 4.75 1.24 9.4 2.82 13.93 4.73a80.371 80.371 0 0128.72 18.11c12.25-16.85 13.01-40.7-3.45-64.09-4.17-6-8.9-12.12-13.12-18.64-6.63-12.58-8.9-27-6.45-41.01a97.304 97.304 0 0130.84-3.47c7.26-.01 14.11 3.36 18.53 9.11 0 0-10.39.92-13.26 5.58-2.87 4.66-5 3.69-8.34 3.69-25.76 0-10.59-5.99-21.25-11.14-.28 5.23-.05 10.47.71 15.65a89.329 89.329 0 0021.37 38.7c19.95 25.5 29.72 68.44-2.28 90.78-12.45-18-31.93-37.03-53.87-37.23h-1.39c-21.93.19-41.42 19.22-53.87 37.23-32.04-22.29-22.29-65.29-2.28-90.78a89.265 89.265 0 0021.39-38.7c.74-5.18.98-10.42.71-15.65-10.67 5.19 4.5 11.14-21.26 11.14-3.33 0-5.49.92-8.34-3.69-2.84-4.61-13.28-5.58-13.28-5.58a23.421 23.421 0 0118.53-9.11c10.4-.51 20.81.66 30.84 3.47m-48.48 81.57c-6.62 23.45-12.97 48.76 19.91 73.84 1.98 1.51 4.32 3.09 6.87 4.67 10.34 5 20.37 10.63 30.01 16.87a36.315 36.315 0 0115.2 35.11c-.58-2.15-1.43-4.22-2.55-6.14a74.426 74.426 0 00-21.94-24.8c-8.92-5.11-18.11-9.76-27.51-13.93-30.84-16.05-44.66-41.42-35.22-77.31 6.39-24.28 13.65-38.45.25-61.05 26.47 6.34 20.2 34.26 15 52.82m-18-43.77s.38 1.1.77 2.69c1.45 6.49 1.56 13.2.31 19.73-2.65 15.14-9.41 28.65-10.74 44.3a65.562 65.562 0 0010.34 44.83 77.65 77.65 0 0024.07 20.9c9.65 5.42 19.92 9.22 29.87 14.6 15.84 8.59 36.86 23.97 35.18 45.01-5.58-13.29-21.17-25.27-34.05-32.51-11.29-6.35-24.63-11.6-36.78-17.76a74.112 74.112 0 01-40.39-45.7 98.224 98.224 0 013.26-52.62c4.2-15.19 10.31-29.79 18.18-43.45m80.83-65.27c-7.89-5.58-24.87-1.84-24.87-1.84 3.67.96 7.27 2.19 10.75 3.69a63.507 63.507 0 0116.51 11.98c6.84 5 16.12 5 22.96 0 4.8-4.87 10.38-8.92 16.5-11.98 3.49-1.5 7.08-2.74 10.75-3.69 0 0-16.97-3.69-24.87 1.84-11.01 7.8-16.58 7.8-27.73 0m90.56 108.89c6.62 23.45 12.97 48.76-19.92 73.84-1.98 1.51-4.32 3.09-6.85 4.67a275.088 275.088 0 00-30.01 16.87 36.341 36.341 0 00-15.21 35.11c.58-2.15 1.45-4.22 2.57-6.14a73.896 73.896 0 0121.93-24.87c8.93-5.11 18.11-9.76 27.51-13.93 30.84-16.05 44.68-41.42 35.22-77.31-6.39-24.28-13.64-38.45-.23-61.05-26.57 6.34-20.21 34.26-15.01 52.81m18.11-43.69s-.38 1.1-.77 2.69a48.926 48.926 0 00-.31 19.73c2.63 15.15 9.4 28.68 10.74 44.3a65.562 65.562 0 01-10.34 44.83 77.78 77.78 0 01-24.07 20.9c-9.67 5.42-19.92 9.22-29.87 14.6-15.88 8.59-36.88 23.97-35.18 45.01 5.58-13.29 21.16-25.27 34.03-32.51 11.29-6.35 24.65-11.6 36.79-17.76a74.185 74.185 0 0040.4-45.75 98.42 98.42 0 00-3.26-52.62 186.488 186.488 0 00-18.21-43.43m-74.99-28.29c-1.91 3.92-3.22 8.1-3.9 12.41-2.18 9.31 1.72 18.99 9.75 24.17 1.54.75 3.17 1.3 4.85 1.62a62.806 62.806 0 01-4.34-6.17 73.623 73.623 0 01-6.38-32.04",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })), VahakLogoWhite_v03_path2 || (VahakLogoWhite_v03_path2 = /*#__PURE__*/react.createElement("path", {
    className: "VahakLogoWhite_v03_svg__st3",
    d: "M584.76 166.2l-67.71 162.07h-32.79L416.55 166.2h32.56l51.43 122.91 51.43-122.91h32.79zM702.72 254.9v73.37h-28.07v-14.63c-8.96 11.32-24.3 17.46-38.45 17.46-25.95 0-45.53-15.33-45.53-38.93 0-24.06 22.41-40.58 49.78-40.58 11.09 0 23.12 2.36 34.21 6.61v-3.3c0-14.16-7.78-27.84-29.96-27.84-11.56 0-22.65 4.01-33.03 9.2l-9.91-20.05c17.22-8.49 33.26-12.74 48.6-12.74 32.3 0 52.36 20.52 52.36 51.43zm-28.08 35.15v-13.68c-8.96-3.07-19.11-4.72-29.96-4.72-14.39 0-25.95 8.02-25.95 19.58 0 11.56 10.14 18.87 23.83 18.87 13.92 0 28.78-7.08 32.08-20.05zM845.68 250.65v77.61h-27.84v-71.95c0-16.51-10.62-28.31-25.71-28.31-16.28 0-29.72 11.8-29.72 26.42v73.84h-28.78v-164.9h28.78v59.69c7.31-11.8 21.7-19.58 37.98-19.58 26.65 0 45.29 19.58 45.29 47.18zM982.27 254.9v73.37H954.2v-14.63c-8.97 11.32-24.3 17.46-38.45 17.46-25.95 0-45.53-15.33-45.53-38.93 0-24.06 22.41-40.58 49.78-40.58 11.09 0 23.12 2.36 34.21 6.61v-3.3c0-14.16-7.79-27.84-29.96-27.84-11.56 0-22.65 4.01-33.03 9.2l-9.91-20.05c17.22-8.49 33.26-12.74 48.6-12.74 32.31 0 52.36 20.52 52.36 51.43zm-28.07 35.15v-13.68c-8.97-3.07-19.11-4.72-29.96-4.72-14.39 0-25.95 8.02-25.95 19.58 0 11.56 10.14 18.87 23.83 18.87 13.92 0 28.78-7.08 32.08-20.05zM1078.29 260.8l48.6 67.47h-33.5l-34.44-48.6-17.22 18.17v30.43h-28.78v-164.9h28.78V264.1l52.84-57.8h33.97l-50.25 54.5z"
  })));
}

/* harmony default export */ var VahakLogoWhite_v03 = (SvgVahakLogoWhiteV03);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/constants/platformStats.js
var platformStats = __webpack_require__(28230);
// EXTERNAL MODULE: ./constants/marketplace.constants.ts
var marketplace_constants = __webpack_require__(57993);
// EXTERNAL MODULE: ./components/lcv-route-landing/lcvRouteFooterLinks.ts
var lcvRouteFooterLinks = __webpack_require__(99968);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../core/src/locales/bn/lcvRouteLanding.json
var lcvRouteLanding = __webpack_require__(83596);
// EXTERNAL MODULE: ../core/src/locales/en/lcvRouteLanding.json
var en_lcvRouteLanding = __webpack_require__(84941);
// EXTERNAL MODULE: ../core/src/locales/gu/lcvRouteLanding.json
var gu_lcvRouteLanding = __webpack_require__(97621);
// EXTERNAL MODULE: ../core/src/locales/hi/lcvRouteLanding.json
var hi_lcvRouteLanding = __webpack_require__(24610);
// EXTERNAL MODULE: ../core/src/locales/kn/lcvRouteLanding.json
var kn_lcvRouteLanding = __webpack_require__(28354);
// EXTERNAL MODULE: ../core/src/locales/mr/lcvRouteLanding.json
var mr_lcvRouteLanding = __webpack_require__(42086);
// EXTERNAL MODULE: ../core/src/locales/ta/lcvRouteLanding.json
var ta_lcvRouteLanding = __webpack_require__(27285);
// EXTERNAL MODULE: ../core/src/locales/te/lcvRouteLanding.json
var te_lcvRouteLanding = __webpack_require__(48737);
// EXTERNAL MODULE: ./components/city/data/index.ts + 2 modules
var data = __webpack_require__(29185);
;// CONCATENATED MODULE: ./components/city/cityFooterLinks.ts










var _cities, _breadcrumbCityName, _cities1, _breadcrumbCityName1, _cities2, _breadcrumbCityName2, _cities3, _breadcrumbCityName3, _cities4, _breadcrumbCityName4, _cities5, _breadcrumbCityName5, _cities6, _breadcrumbCityName6, _cities7, _breadcrumbCityName7;
var CITY_LABELS_BY_LOCALE = {
    bn: Object.fromEntries(Object.entries((_cities = lcvRouteLanding/* cities */.cA) !== null && _cities !== void 0 ? _cities : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName = city.breadcrumbCityName) !== null && _breadcrumbCityName !== void 0 ? _breadcrumbCityName : slug
        ];
    })),
    en: Object.fromEntries(Object.entries((_cities1 = en_lcvRouteLanding/* cities */.cA) !== null && _cities1 !== void 0 ? _cities1 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName1 = city.breadcrumbCityName) !== null && _breadcrumbCityName1 !== void 0 ? _breadcrumbCityName1 : slug
        ];
    })),
    gu: Object.fromEntries(Object.entries((_cities2 = gu_lcvRouteLanding/* cities */.cA) !== null && _cities2 !== void 0 ? _cities2 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName2 = city.breadcrumbCityName) !== null && _breadcrumbCityName2 !== void 0 ? _breadcrumbCityName2 : slug
        ];
    })),
    hi: Object.fromEntries(Object.entries((_cities3 = hi_lcvRouteLanding/* cities */.cA) !== null && _cities3 !== void 0 ? _cities3 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName3 = city.breadcrumbCityName) !== null && _breadcrumbCityName3 !== void 0 ? _breadcrumbCityName3 : slug
        ];
    })),
    kn: Object.fromEntries(Object.entries((_cities4 = kn_lcvRouteLanding/* cities */.cA) !== null && _cities4 !== void 0 ? _cities4 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName4 = city.breadcrumbCityName) !== null && _breadcrumbCityName4 !== void 0 ? _breadcrumbCityName4 : slug
        ];
    })),
    mr: Object.fromEntries(Object.entries((_cities5 = mr_lcvRouteLanding/* cities */.cA) !== null && _cities5 !== void 0 ? _cities5 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName5 = city.breadcrumbCityName) !== null && _breadcrumbCityName5 !== void 0 ? _breadcrumbCityName5 : slug
        ];
    })),
    ta: Object.fromEntries(Object.entries((_cities6 = ta_lcvRouteLanding/* cities */.cA) !== null && _cities6 !== void 0 ? _cities6 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName6 = city.breadcrumbCityName) !== null && _breadcrumbCityName6 !== void 0 ? _breadcrumbCityName6 : slug
        ];
    })),
    te: Object.fromEntries(Object.entries((_cities7 = te_lcvRouteLanding/* cities */.cA) !== null && _cities7 !== void 0 ? _cities7 : {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), slug = _param[0], city = _param[1];
        return [
            slug,
            (_breadcrumbCityName7 = city.breadcrumbCityName) !== null && _breadcrumbCityName7 !== void 0 ? _breadcrumbCityName7 : slug
        ];
    }))
};
var getCityPageLocalizedPath = function(locale, slug) {
    var basePath = (0,data/* getCityPagePath */.l_)(slug);
    return locale === "en" ? basePath : "/".concat(locale).concat(basePath);
};
var ref, ref1;
var getCityPageLabel = function(locale, slug) {
    var ref2;
    return (ref1 = (ref = (ref2 = CITY_LABELS_BY_LOCALE[locale]) === null || ref2 === void 0 ? void 0 : ref2[slug]) !== null && ref !== void 0 ? ref : CITY_LABELS_BY_LOCALE.en[slug]) !== null && ref1 !== void 0 ? ref1 : slug;
};
var getCityPageFooterLinkGroups = function() {
    return (0,data/* getCityPageSlugs */.Zx)().map(function(slug) {
        var ref;
        var ref1;
        var locales = (ref1 = (ref = (0,data/* getCityPageBySlug */.qS)(slug)) === null || ref === void 0 ? void 0 : ref.hreflangLocales) !== null && ref1 !== void 0 ? ref1 : [
            "en"
        ];
        return {
            slug: slug,
            alternates: locales.map(function(locale) {
                return {
                    locale: locale,
                    label: getCityPageLabel(locale, slug),
                    path: getCityPageLocalizedPath(locale, slug)
                };
            })
        };
    });
};

;// CONCATENATED MODULE: ./components/layout/footer/Footer.tsx




// import FadeIn from "react-lazyload-fadein";

// Logos

// Components



// Utils & helper functions






// Style







var HighlightedLink = function(param) {
    var path = param.path, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                href: path,
                className: (Footer_module_default()).link__highlighted,
                children: children
            }),
            "\xa0"
        ]
    });
};
var Footer = function() {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isMobile = ref.isMobile, userId = ref.userId, name = ref.name, serviceType = ref.serviceType, companyId = ref.companyId;
    var router = (0,next_router.useRouter)();
    var onClickSendGaEvents = function(e) {
        var attribute = e.currentTarget.getAttribute(misc/* FOOTER_ITEM_ATTRIBUTE */.hL);
        if (attribute) {
            var val = eventsMapObj/* FooterItemsGaEvents */.v5[attribute];
            if (val !== undefined) {
                (0,user_analytics_service/* ga4sendEvent */.zs)("website_bottom_navigation_web", {
                    value: val
                });
            }
            if (attribute === misc/* FooterItemsConstant.DOWNLOAD_OUR_APP */.gt.DOWNLOAD_OUR_APP) {
                (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Download_app_clicked_web */.wQ.Download_app_clicked_web, {
                    company_id: companyId,
                    user_name: name,
                    service_type: serviceType,
                    source_screen: event_names/* GA4AppClickSource.homepage_bottom_screen */.kw.homepage_bottom_screen
                });
            } else if (attribute === misc/* FooterItemsConstant.CONTACT_US */.gt.CONTACT_US) {
                (0,user_analytics_service/* ga4sendEvent */.zs)(event_names/* GA4EventNames.Contact_us_clicked_web */.wQ.Contact_us_clicked_web, {
                    company_id: companyId,
                    user_name: name,
                    service_type: serviceType,
                    section: event_names/* GA4ContactUsClickSource.homepage_bottom_section */.Bz.homepage_bottom_section
                });
            }
        }
    };
    var _obj, _obj1, _obj2, _obj3, _obj4, _obj5, _obj6, _obj7, _obj8, _obj9, _obj10, _obj11, _obj12, _obj13, _obj14, _obj15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: classnames_default()((Footer_module_default()).footer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("row", (Footer_module_default()).row, (Footer_module_default()).topLinks),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-12", "col-lg-4"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()((Footer_module_default()).logoFooter),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    if (companyId) {
                                                        var ref;
                                                        if (router === null || router === void 0 ? void 0 : (ref = router.pathname) === null || ref === void 0 ? void 0 : ref.includes("/dashboard")) return;
                                                        router.push(routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl());
                                                    } else {
                                                        var ref1;
                                                        if (router === null || router === void 0 ? void 0 : (ref1 = router.pathname) === null || ref1 === void 0 ? void 0 : ref1.includes("/marketplace")) {
                                                            router.push("/");
                                                            return;
                                                        }
                                                        router.push(marketplace_constants/* MARKETPLACE_ROUTE_CONFIG.loadUrl */.VV.loadUrl);
                                                    }
                                                },
                                                title: "Vahak - Book LCVs, containers and trucks from trusted transporters across India",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakLogoWhite_v03, {
                                                    width: "140"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Book LCVs, containers and trucks in minutes from trusted transporters across India."
                                        })
                                    ]
                                }),
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-12"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Connect with us on"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks_SocialLinks, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-6", "col-md-4", "col-lg-3"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Company"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: classnames_default()((Footer_module_default()).footerList),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj = {}, (0,_define_property/* default */.Z)(_obj, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.ABOUT_US */.gt.ABOUT_US), (0,_define_property/* default */.Z)(_obj, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/about-us",
                                                    title: "Feel free to contact Vahak team for any queries",
                                                    children: "About us"
                                                })), _obj)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.CONTACT_US */.gt.CONTACT_US), (0,_define_property/* default */.Z)(_obj1, "onClick", function() {
                                                    onClickSendGaEvents;
                                                    (0,user_analytics_service/* moEngageUserEventTrack */.Im)("contact_us_clicked_web", {
                                                        user_id: userId,
                                                        user_name: name,
                                                        service_type: serviceType,
                                                        section: "Homepage bottom section"
                                                    });
                                                }), (0,_define_property/* default */.Z)(_obj1, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/contact-us",
                                                    title: "Feel free to contact Vahak team for any queries",
                                                    children: "Contact Us"
                                                })), _obj1)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.CAREERS */.gt.CAREERS), (0,_define_property/* default */.Z)(_obj2, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj2, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/careers",
                                                    title: "Click to know more about open positions in Vahak",
                                                    children: "Careers"
                                                })), _obj2))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classnames_default()("d-block", "d-md-none", "mt-5"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: classnames_default()((Footer_module_default()).footerHead),
                                                    children: "Transport Nagar"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: classnames_default()((Footer_module_default()).footerList),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.FAQ */.gt.FAQ), (0,_define_property/* default */.Z)(_obj3, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj3, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                        href: "/transport-nagar/sanjay-gandhi",
                                                        title: "Sanjay gandhi transport nagar",
                                                        children: "Sanjay Gandhi"
                                                    })), _obj3))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-6", "col-md-4", "col-lg-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Misc"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: classnames_default()((Footer_module_default()).footerList),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.FAQ */.gt.FAQ), (0,_define_property/* default */.Z)(_obj4, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj4, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/frequently-asked-questions",
                                                    title: "Click to know more about FAQ’s",
                                                    children: "Frequently Asked Questions"
                                                })), _obj4)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.TERMS_AND_CONDITION */.gt.TERMS_AND_CONDITION), (0,_define_property/* default */.Z)(_obj5, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj5, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/terms-and-conditions",
                                                    title: "Click to read our Terms and Conditions",
                                                    locale: "",
                                                    children: "Terms and Conditions"
                                                })), _obj5)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.PAYMENT_GUIDELINES */.gt.PAYMENT_GUIDELINES), (0,_define_property/* default */.Z)(_obj6, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj6, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/payments-terms-and-conditions",
                                                    title: "Click to know more about Payment Guidelines",
                                                    locale: "",
                                                    children: "Payment Guidelines and T&C"
                                                })), _obj6)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj7 = {}, (0,_define_property/* default */.Z)(_obj7, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.CASHBACK_TERMS_AND_CONDITIONS */.gt.CASHBACK_TERMS_AND_CONDITIONS), (0,_define_property/* default */.Z)(_obj7, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj7, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/cashback-terms-and-condition",
                                                    title: "Click to know more about Cashback Guidelines",
                                                    locale: "",
                                                    children: "Cashback T&C"
                                                })), _obj7)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj8 = {}, (0,_define_property/* default */.Z)(_obj8, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.MEDIBUDDY_TERMS_AND_CONDITIONS */.gt.MEDIBUDDY_TERMS_AND_CONDITIONS), (0,_define_property/* default */.Z)(_obj8, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj8, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/medibuddy-terms-and-conditions",
                                                    title: "Click to know more about Medibuddy Terms and Conditions",
                                                    locale: "",
                                                    children: "Medibuddy T&C"
                                                })), _obj8)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj9 = {}, (0,_define_property/* default */.Z)(_obj9, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.TAP_N_GO_TERMS_AND_CONDITIONS */.gt.TAP_N_GO_TERMS_AND_CONDITIONS), (0,_define_property/* default */.Z)(_obj9, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj9, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/tapngo-terms-and-conditions",
                                                    title: "Click to know more about Tap N Go Terms and Conditions",
                                                    locale: "",
                                                    children: "Assured Loads T&C"
                                                })), _obj9)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj10 = {}, (0,_define_property/* default */.Z)(_obj10, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.CI_TERMS_AND_CONDITIONS */.gt.CI_TERMS_AND_CONDITIONS), (0,_define_property/* default */.Z)(_obj10, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj10, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/".concat(misc/* FooterItemsConstant.CI_TERMS_AND_CONDITIONS */.gt.CI_TERMS_AND_CONDITIONS),
                                                    title: "Free Cargo Insurance Terms and Conditions",
                                                    locale: "",
                                                    children: "Free Cargo Insurance T&C"
                                                })), _obj10)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj11 = {}, (0,_define_property/* default */.Z)(_obj11, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.GPS_TERMS_AND_CONDITIONS */.gt.GPS_TERMS_AND_CONDITIONS), (0,_define_property/* default */.Z)(_obj11, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj11, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/".concat(misc/* FooterItemsConstant.GPS_TERMS_AND_CONDITIONS */.gt.GPS_TERMS_AND_CONDITIONS),
                                                    title: "GPS Terms and Conditions",
                                                    locale: "",
                                                    children: "GPS T&C"
                                                })), _obj11)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj12 = {}, (0,_define_property/* default */.Z)(_obj12, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, "refund-and-cancellation-terms-and-conditions"), (0,_define_property/* default */.Z)(_obj12, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj12, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/refund-and-cancellation-terms-and-conditions",
                                                    title: "Refund and Cancellation Terms and Conditions",
                                                    locale: "",
                                                    children: "Refund and Cancellation T&C"
                                                })), _obj12)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj13 = {}, (0,_define_property/* default */.Z)(_obj13, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.PRIVACY_POLICY */.gt.PRIVACY_POLICY), (0,_define_property/* default */.Z)(_obj13, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj13, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                    href: "/privacy-policy",
                                                    title: "Click to read our Privacy Policy",
                                                    locale: "",
                                                    children: "Privacy Policy"
                                                })), _obj13))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-6", "col-md-4", "col-lg-2", "d-none", "d-md-block"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Transport Nagar"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: classnames_default()((Footer_module_default()).footerList),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (_obj14 = {}, (0,_define_property/* default */.Z)(_obj14, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.FAQ */.gt.FAQ), (0,_define_property/* default */.Z)(_obj14, "onClick", onClickSendGaEvents), (0,_define_property/* default */.Z)(_obj14, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                href: "/transport-nagar/sanjay-gandhi",
                                                title: "Sanjay gandhi transport nagar",
                                                children: "Sanjay Gandhi"
                                            })), _obj14))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "d-none", "col-6", "col-md-4", "col-lg-2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Products"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: classnames_default()((Footer_module_default()).footerList),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                        href: "".concat(routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("load")),
                                                        title: "Click to know more about live marketplace",
                                                        children: "Live Marketplace"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                                        href: "/transporters",
                                                        title: "Click to know more about Transport Directory",
                                                        children: "Transport Directory"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("row", (Footer_module_default()).row, (Footer_module_default()).getInTouch),
                            children: [
                                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-12", "col-lg-4"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Connect with us on"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks_SocialLinks, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-lg-3"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: classnames_default()((Footer_module_default()).footerHead),
                                            children: "Download our app on"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (_obj15 = {}, (0,_define_property/* default */.Z)(_obj15, misc/* FOOTER_ITEM_ATTRIBUTE */.hL, misc/* FooterItemsConstant.DOWNLOAD_OUR_APP */.gt.DOWNLOAD_OUR_APP), (0,_define_property/* default */.Z)(_obj15, "onClick", function() {
                                            onClickSendGaEvents;
                                            (0,user_analytics_service/* moEngageUserEventTrack */.Im)("download_app_clicked_web", {
                                                user_id: userId,
                                                user_name: name,
                                                service_type: serviceType,
                                                source_section: "Footer section"
                                            });
                                        }), (0,_define_property/* default */.Z)(_obj15, "children", /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                            openInNewTab: true,
                                            title: "Book Trucks for all India, Download Vahak",
                                            href: "https://6r7cz.app.link/googleplay",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaystoreBadge/* default */.Z, {
                                                className: classnames_default()((Footer_module_default()).footerPlaystoreIcon, "img-fluid"),
                                                width: "165",
                                                height: "50",
                                                title: "Book Trucks for all India, Download Vahak"
                                            })
                                        })), _obj15))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Footer_module_default()).divider)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("row", (Footer_module_default()).row, (Footer_module_default()).mostSearchedLinkContainer),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((Footer_module_default()).col, "col"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MostSearchedLinks_MostSearchedLinks, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Footer_module_default()).divider)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("row", (Footer_module_default()).row),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("col", (Footer_module_default()).col),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((Footer_module_default()).trustContent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Find LCVs faster on Vahak, India's leading online lorry booking and transport marketplace. Connect with verified transporters and lorry owners across Pan India and find the right vehicle for your load. Get access to competitive freight rates and choose from a wide network of LCVs, mini trucks, Tata Ace, Bolero, Bada Dost and other commercial vehicles. Post your load and get matched with verified transporters for faster load booking and confirmation. Find vehicles for local, intercity and long-distance transportation across major routes in India. With one of India's largest networks of ",
                                                platformStats/* PLATFORM_STATS.transporters.lakhs */.s.transporters.lakhs,
                                                " transporters and lorry owners, Vahak makes finding and booking an LCV simpler and faster."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (Footer_module_default()).seoContent,
                                            children: FOOTER_SECTIONS.map(function(param) {
                                                var title = param.title, items = param.items, routeGroups = param.routeGroups;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            children: title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (Footer_module_default()).grid,
                                                            children: routeGroups ? routeGroups.map(function(group, groupIndex) {
                                                                var ref;
                                                                var alternate = (ref = group.alternates.find(function(entry) {
                                                                    return entry.locale === router.locale;
                                                                })) !== null && ref !== void 0 ? ref : group.alternates.find(function(entry) {
                                                                    return entry.locale === "en";
                                                                });
                                                                if (!alternate) {
                                                                    return null;
                                                                }
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedLink, {
                                                                            path: alternate.path,
                                                                            children: alternate.label
                                                                        }),
                                                                        groupIndex < routeGroups.length - 1 && " | "
                                                                    ]
                                                                }, group.slug);
                                                            }) : items.map(function(param, ix) {
                                                                var path = param.path, label = param.label;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightedLink, {
                                                                            path: path,
                                                                            children: label
                                                                        }),
                                                                        ix < items.length - 1 && " | "
                                                                    ]
                                                                }, path);
                                                            })
                                                        })
                                                    ]
                                                }, title);
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: classnames_default()((Footer_module_default()).footer, (Footer_module_default()).footerBar),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Footer_module_default()).divider)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((Footer_module_default()).row, "row"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-12", "order-1", "col-sm-5"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((Footer_module_default()).copyRights),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "\xa9 ",
                                                new Date().getFullYear(),
                                                " Epictus Solutions India Private Limited. All Rights Reserved"
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Footer_module_default()).col, "col-12", "order-3", "col-sm-2", "order-sm-2"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((Footer_module_default()).madeInIndia),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                "Made with",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    role: "img",
                                                    "aria-label": "love",
                                                    children: "❤️"
                                                }),
                                                " ",
                                                "in India"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var footer_Footer = (Footer);
var POPULAR_LOAD_CITIES = [
    {
        slug: "mumbai-maharashtra-india",
        label: "Mumbai"
    },
    {
        slug: "new-delhi-delhi-india",
        label: "Delhi"
    },
    {
        slug: "bengaluru-karnataka-india",
        label: "Bangalore"
    },
    {
        slug: "chennai-tamil-nadu-india",
        label: "Chennai"
    },
    {
        slug: "hyderabad-telangana-india",
        label: "Hyderabad"
    },
    {
        slug: "pune-maharashtra-india",
        label: "Pune"
    },
    {
        slug: "ahmedabad-gujarat-india",
        label: "Ahmedabad"
    },
    {
        slug: "kolkata-west-bengal-india",
        label: "Kolkata"
    }
];
var TOP_CITIES = POPULAR_LOAD_CITIES;
var VAHAK_SERVICES = [
    {
        path: "/full-truck-load",
        label: "Full Truck Load (FTL)"
    },
    {
        path: "/part-load-booking",
        label: "Part Load Booking"
    },
    {
        path: "/freight-calculator",
        label: "Freight Rate Calculator"
    },
    {
        path: "/transporters",
        label: "Find Transporters"
    },
    {
        path: "/online-truck-booking",
        label: "Online Truck Booking"
    }
];
var LCV_ROUTE_FOOTER_LINK_GROUPS = (0,lcvRouteFooterLinks/* getLcvRouteFooterLinkGroups */.z)();
var CITY_PAGE_FOOTER_LINK_GROUPS = getCityPageFooterLinkGroups();
var FOOTER_SECTIONS = [
    {
        title: "LCV booking routes",
        routeGroups: LCV_ROUTE_FOOTER_LINK_GROUPS
    },
    {
        title: "Book LCV by city",
        routeGroups: CITY_PAGE_FOOTER_LINK_GROUPS
    },
    // {
    //     title: "Popular truck booking routes",
    //     items: POPULAR_ROUTES
    // },
    {
        title: "Search loads in top cities",
        items: TOP_CITIES.map(function(param) {
            var slug = param.slug, label = param.label;
            return {
                path: "/marketplace/load/".concat(slug),
                label: "Loads in ".concat(label)
            };
        })
    },
    {
        title: "Vahak services",
        items: VAHAK_SERVICES
    }
];

;// CONCATENATED MODULE: ./components/layout/top-nav-layout/TopNavLayout.tsx


// Context


var TopNavLayout = function(param) {
    var navContent = param.navContent, Content = param.content, children = param.children;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            navContent,
            Content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {}) : children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_Footer, {})
        ]
    });
};
/* harmony default export */ var top_nav_layout_TopNavLayout = (TopNavLayout);


/***/ }),

/***/ 74431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ top_nav_v2_TopNavV2; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/constants/userScreenId.js
var userScreenId = __webpack_require__(98606);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
;// CONCATENATED MODULE: ../core/dist/icons/VahakCircleBlueLogo.svg
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgVahakCircleBlueLogo(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15z",
    fill: "#2355FC"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.019 13.46a3.495 3.495 0 01-.316 1.559 3.249 3.249 0 01-.214.3.95.95 0 00.24-.08c.398-.25.592-.722.482-1.174-.034-.21-.1-.413-.194-.604m5.808-1.472h-.388a5 5 0 00.8 1.694c.284.433.582.856.836 1.307.57.971.93 2.047 1.057 3.161.187 1.897-.828 3.44-2.575 4.268-1.103.52-2.101.773-2.97 1.399-.522.4-.963.89-1.302 1.448.093-2.02 2.07-2.442 3.637-3.192 1.801-.864 2.586-2.267 2.365-4.12-.26-1.604-.916-2.677-1.684-3.915a9.66 9.66 0 01-.946-1.762 3.403 3.403 0 01-.2-.995 12.303 12.303 0 00-6.915 0c-.016.34-.083.675-.198.995a9.874 9.874 0 01-.947 1.762c-.768 1.239-1.425 2.31-1.684 3.916-.221 1.853.564 3.255 2.365 4.12 1.568.75 3.544 1.171 3.636 3.192a5.298 5.298 0 00-1.3-1.45c-.871-.625-1.871-.88-2.972-1.398-1.746-.827-2.765-2.37-2.575-4.268a8.098 8.098 0 011.056-3.161c.255-.45.552-.874.837-1.307.372-.511.643-1.085.8-1.694h-.387a4.903 4.903 0 01-.577 1.198c-.97 1.553-2.083 2.907-2.163 4.851-.006.44.023.88.086 1.316a2.664 2.664 0 01-.483-1.237 4.075 4.075 0 01.095-1.545c.288-1.18.97-2.196 1.551-3.242a4.504 4.504 0 00.646-1.565.845.845 0 00-.49-.889c.15-.097.323-.155.502-.17a.808.808 0 01.66.279 14.535 14.535 0 00-.765-2.897 16.6 16.6 0 00-.265-.651h-.07a.592.592 0 01-.631-.54.638.638 0 01.723-.532c.283.04.505.259.543.536a.52.52 0 01-.266.44 11.434 11.434 0 001.704 1.846 1.687 1.687 0 001-1.786.582.582 0 01-.578-.537.638.638 0 01.724-.533c.283.04.504.259.543.536a.567.567 0 01-.477.522c.355.558.906.97 1.548 1.158-.152.309-.356.59-.603.832a7.485 7.485 0 00-1.62.55 3.19 3.19 0 01-.816-.077.62.62 0 00-.186-.032c.17.272.302.565.393.87 2.046-.813 6.138-.81 8.198.006.092-.308.221-.603.385-.88a.606.606 0 00-.186.032 3.19 3.19 0 01-.815.078 7.5 7.5 0 00-1.623-.551 3.04 3.04 0 01-.602-.832 2.753 2.753 0 001.548-1.157.563.563 0 01-.475-.52.638.638 0 01.724-.534c.283.04.505.259.544.537a.583.583 0 01-.578.537 1.688 1.688 0 001 1.786 12.183 12.183 0 001.713-1.847.518.518 0 01-.266-.439.638.638 0 01.723-.533c.283.04.505.259.543.537a.592.592 0 01-.633.541h-.073c-.066.15-.162.378-.265.651-.155.403-.289.813-.4 1.229a15.65 15.65 0 00-.407 1.712.81.81 0 01.706-.338c.18.013.352.071.503.169a.843.843 0 00-.49.888c.113.557.332 1.088.645 1.565.583 1.047 1.262 2.063 1.553 3.243.13.505.162 1.03.095 1.546-.054.446-.22.87-.483 1.237.064-.435.094-.875.088-1.316-.083-1.945-1.195-3.298-2.163-4.851a4.93 4.93 0 01-.58-1.198m-4.681-5.903a.577.577 0 00.481-.532.654.654 0 00-.741-.546.65.65 0 00-.556.546.587.587 0 00.513.543A7.46 7.46 0 0113.48 9.28l-.005.011h3.04l-.005-.011a7.46 7.46 0 01-1.364-3.194m1.958 13.72c-.475.813-.88.694-1.292.514a1.791 1.791 0 00-1.616-.008c-.417.185-.827.322-1.31-.506a.63.63 0 00.046.807c.57.47 1.56.594 1.971 1.557.02.228.165.228.185 0 .413-.96 1.403-1.083 1.97-1.557a.63.63 0 00.046-.807zm-3.51-6.809a3.08 3.08 0 01-.319 1.995c-.206.316-.44.614-.65.906-.814 1.137-.776 2.297-.17 3.116a3.908 3.908 0 011.421-.88 5.62 5.62 0 01.69-.23c.175-.595-.448-1.536-.897-1.72a2.917 2.917 0 00-.604-.142s.03-.112.454-.405a1.04 1.04 0 01.953-.045c.16.06.328.094.499.101h.044c.17-.006.34-.04.498-.101.306-.14.662-.123.954.045.426.29.454.405.454.405a2.92 2.92 0 00-.604.141c-.452.185-1.075 1.126-.896 1.72.235.06.465.138.689.23a3.99 3.99 0 011.422.88c.606-.818.643-1.978-.171-3.115-.207-.292-.44-.59-.65-.906a3.074 3.074 0 01-.319-1.995 4.897 4.897 0 011.527-.168c.359 0 .698.163.917.443 0 0-.515.044-.657.271-.142.227-.247.18-.412.18-1.275 0-.525-.292-1.052-.542a3.76 3.76 0 00.035.76c.186.705.55 1.352 1.058 1.882.987 1.24 1.47 3.328-.113 4.414-.616-.875-1.58-1.8-2.667-1.81h-.068c-1.086.01-2.05.935-2.667 1.81-1.585-1.083-1.103-3.174-.113-4.414a4.32 4.32 0 001.06-1.881c.036-.252.048-.507.034-.761-.528.252.223.541-1.052.541-.165 0-.272.045-.413-.179-.14-.224-.657-.271-.657-.271.22-.28.558-.443.917-.443a4.87 4.87 0 011.526.168m-2.399 3.966c-.328 1.14-.642 2.371.985 3.59.098.074.214.151.34.228a13.82 13.82 0 011.486.82c.56.383.852 1.044.752 1.707a1.213 1.213 0 00-.126-.298 3.64 3.64 0 00-1.086-1.206 15 15 0 00-1.362-.677c-1.526-.78-2.21-2.014-1.743-3.76.316-1.18.676-1.869.012-2.968 1.31.309 1 1.666.743 2.568m-.891-2.128s.018.053.038.13c.071.316.077.642.015.96-.131.736-.466 1.393-.532 2.154a3.143 3.143 0 00.512 2.18c.321.416.727.761 1.192 1.016.477.263.986.448 1.478.71.784.417 1.824 1.165 1.741 2.188-.276-.646-1.048-1.229-1.685-1.58-.559-.31-1.22-.565-1.82-.864a3.625 3.625 0 01-2-2.222 4.695 4.695 0 01.162-2.559 8.99 8.99 0 01.9-2.112m4-3.173c-.39-.272-1.23-.09-1.23-.09.181.047.36.107.532.18.302.15.579.346.817.582a.976.976 0 001.136 0c.238-.237.514-.434.817-.582.173-.073.35-.134.532-.18 0 0-.84-.18-1.23.09-.546.379-.822.379-1.373 0zm4.483 5.294c.328 1.14.642 2.37-.986 3.59-.098.074-.214.15-.339.227-.512.243-1.008.517-1.485.82a1.754 1.754 0 00-.753 1.708c.029-.105.072-.205.127-.299a3.614 3.614 0 011.086-1.209c.442-.248.896-.474 1.361-.677 1.527-.78 2.212-2.014 1.744-3.76-.317-1.18-.676-1.869-.012-2.968-1.315.309-1 1.666-.743 2.568zm.896-2.125s-.019.054-.038.131a2.346 2.346 0 00-.015.96c.13.736.465 1.394.531 2.153a3.144 3.144 0 01-.512 2.18 3.832 3.832 0 01-1.191 1.016c-.479.264-.986.449-1.478.71-.786.418-1.826 1.166-1.742 2.189.277-.647 1.048-1.229 1.685-1.581.558-.309 1.22-.564 1.82-.864a3.629 3.629 0 002-2.224 4.705 4.705 0 00-.161-2.558 8.982 8.982 0 00-.901-2.112m-3.712-1.375a2.11 2.11 0 00-.193.603c-.108.453.085.924.483 1.175a.97.97 0 00.24.08 3.074 3.074 0 01-.215-.3 3.525 3.525 0 01-.316-1.559",
    fill: "#fff"
  })));
}

/* harmony default export */ var VahakCircleBlueLogo = (SvgVahakCircleBlueLogo);
;// CONCATENATED MODULE: ../core/dist/icons/profile.svg
var profile_path;

function profile_extends() { profile_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return profile_extends.apply(this, arguments); }



function SvgProfile(props) {
  return /*#__PURE__*/react.createElement("svg", profile_extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), profile_path || (profile_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.62 12.33a4.54 4.54 0 100-9.08 4.54 4.54 0 000 9.08zM18.557 16.078a8.29 8.29 0 00-14.224 5.783.795.795 0 00.794.794H20.11a.795.795 0 00.795-.794 8.001 8.001 0 00-.385-2.482 8.23 8.23 0 00-1.963-3.3z",
    fill: "#2355FC"
  })));
}

/* harmony default export */ var profile = (SvgProfile);
// EXTERNAL MODULE: ./components/layout/continue-sign-up/ContinueSignup.module.scss
var ContinueSignup_module = __webpack_require__(81514);
var ContinueSignup_module_default = /*#__PURE__*/__webpack_require__.n(ContinueSignup_module);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var components_Typography = __webpack_require__(71960);
;// CONCATENATED MODULE: ../core/dist/icons/AngelRightOrange.svg
var AngelRightOrange_path;

function AngelRightOrange_extends() { AngelRightOrange_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return AngelRightOrange_extends.apply(this, arguments); }



function SvgAngelRightOrange(props) {
  return /*#__PURE__*/react.createElement("svg", AngelRightOrange_extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), AngelRightOrange_path || (AngelRightOrange_path = /*#__PURE__*/react.createElement("path", {
    d: "M1 9.992l4-4-4-4",
    stroke: "#E78500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ var AngelRightOrange = (SvgAngelRightOrange);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
;// CONCATENATED MODULE: ./components/layout/continue-sign-up/ContinueSignup.tsx




//Style

//Components

// Icons





var ContinueSignup = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId, userId = ref.userId;
    var ref1 = (0,react.useState)(true), hideSignUpBanner = ref1[0], setHideSignUpBanner = ref1[1];
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var handleClick = function() {
        sendGAandMoEngageEvent({
            name: constants/* GA4EventNames.COMPANY_REGISTRATION.continue_signup_banner */.wQR.COMPANY_REGISTRATION.continue_signup_banner,
            data: {
                userId: userId
            }
        });
        router.push({
            hash: "#Login"
        });
    };
    (0,react.useEffect)(function() {
        if (!isPhoneVerified || companyId) {
            setHideSignUpBanner(true);
        } else {
            setHideSignUpBanner(false);
        }
    }, [
        isPhoneVerified,
        companyId
    ]);
    if (hideSignUpBanner) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((ContinueSignup_module_default()).main),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((ContinueSignup_module_default()).wrapper, "container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                    size: "m",
                    mSize: "s",
                    as: "p",
                    align: "center",
                    children: "Complete the company registration"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ContinueSignup_module_default()).actionBtn,
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* default */.Z, {
                        size: "m",
                        mSize: "s",
                        as: "p",
                        color: colors/* default.ORANGE_500 */.Z.ORANGE_500,
                        underline: true,
                        children: [
                            "Continue SignUp ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AngelRightOrange, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var continue_sign_up_ContinueSignup = (ContinueSignup);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ./components/layout/top-nav-new/profile-item-pop-menu/ProfileItemPopupMenu.module.scss
var ProfileItemPopupMenu_module = __webpack_require__(6660);
var ProfileItemPopupMenu_module_default = /*#__PURE__*/__webpack_require__.n(ProfileItemPopupMenu_module);
// EXTERNAL MODULE: ../core/dist/components/dropdown/Dropdown.js + 1 modules
var Dropdown = __webpack_require__(92266);
// EXTERNAL MODULE: ./components/utils/avatar-image/AvatarImage.tsx
var AvatarImage = __webpack_require__(53325);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/components/BottomSheet/BottomSheet.js + 1 modules
var BottomSheet = __webpack_require__(30012);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/Button.js + 1 modules
var Button = __webpack_require__(48126);
// EXTERNAL MODULE: ../core/dist/constants/automation.js
var automation = __webpack_require__(46426);
// EXTERNAL MODULE: ./constants/adminOperation.ts
var adminOperation = __webpack_require__(40223);
// EXTERNAL MODULE: ../core/dist/methods/handleLogout.js
var handleLogout = __webpack_require__(34025);
// EXTERNAL MODULE: ./components/login-form-new/hooks/performLogoutAndRedirectHome.ts
var performLogoutAndRedirectHome = __webpack_require__(947);
// EXTERNAL MODULE: ./components/admin/IfCanAccess/IfCanAccess.tsx
var IfCanAccess = __webpack_require__(6632);
// EXTERNAL MODULE: ../core-ui/dist/hooks/index.js + 3 modules
var hooks = __webpack_require__(95385);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
;// CONCATENATED MODULE: ../core/dist/standard-icons/Logout.svg
var Logout_path, Logout_path2;

function Logout_extends() { Logout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Logout_extends.apply(this, arguments); }



function SvgLogout(props) {
  return /*#__PURE__*/react.createElement("svg", Logout_extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), Logout_path || (Logout_path = /*#__PURE__*/react.createElement("path", {
    d: "M18.569 11.036H7.534a.992.992 0 00-.996.996c0 .553.443.996.996.996H18.57l-2.458 2.48a.989.989 0 000 1.416.989.989 0 001.417 0l4.184-4.184c.177-.177.288-.442.288-.708 0-.266-.11-.51-.288-.708l-4.206-4.162a.969.969 0 00-.708-.288.888.888 0 00-.687.288.989.989 0 000 1.417l2.458 2.457z",
    fill: "#818181"
  })), Logout_path2 || (Logout_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2.996 21.064h10.161a.992.992 0 00.996-.996v-3.874a.992.992 0 00-.996-.996.992.992 0 00-.996.996v2.878H3.992V4.992h8.169V7.87c0 .554.443.996.996.996a.992.992 0 00.996-.996V3.996A.992.992 0 0013.157 3H2.997A.992.992 0 002 3.996v16.05c0 .553.443 1.018.996 1.018z",
    fill: "#818181"
  })));
}

/* harmony default export */ var Logout = (SvgLogout);
// EXTERNAL MODULE: ../core/dist/standard-icons/profile.svg
var standard_icons_profile = __webpack_require__(89821);
// EXTERNAL MODULE: ../core-ui/dist/components/Chip/index.js
var Chip = __webpack_require__(93834);
// EXTERNAL MODULE: ./context/call/ClickToCallAppProvider.tsx + 16 modules
var ClickToCallAppProvider = __webpack_require__(50094);
// EXTERNAL MODULE: ../core-ui/dist/components/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(94072);
// EXTERNAL MODULE: ./components/quick-action-popup/QuickActionPopup.tsx
var QuickActionPopup = __webpack_require__(37372);
;// CONCATENATED MODULE: ./components/layout/top-nav-new/custom-prefernce/CsCustomPrefernce.tsx








var CsCustomPrefernce = function(param) {
    var popupProps = param.popupProps;
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), globalData = ref1.globalData, setGlobalData = ref1.setGlobalData;
    var onChangeCsPrefernce = function(e) {
        var result = {};
        if (e.target.name === "no-tag") {
            result["locationTags"] = e.target.checked ? [] : undefined;
        }
        setGlobalData === null || setGlobalData === void 0 ? void 0 : setGlobalData(result);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickActionPopup/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, popupProps), {
        titleText: "Custom Prefernce",
        ctaText: "Close",
        ctaAction: popupProps === null || popupProps === void 0 ? void 0 : popupProps.onToggle,
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* VerticalFlex */.vs, {
            gap: 4,
            margin: "20px 0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                id: "no-tag",
                label: "No Location Tags",
                name: "no-tag",
                onChange: onChangeCsPrefernce,
                value: Array.isArray(globalData === null || globalData === void 0 ? void 0 : globalData.locationTags) && !(globalData === null || globalData === void 0 ? void 0 : (ref = globalData.locationTags) === null || ref === void 0 ? void 0 : ref.length),
                alignItems: "center"
            })
        })
    }));
};
/* harmony default export */ var custom_prefernce_CsCustomPrefernce = (CsCustomPrefernce);

// EXTERNAL MODULE: ./components/helper/StopPropagation.tsx
var StopPropagation = __webpack_require__(77845);
;// CONCATENATED MODULE: ./components/layout/top-nav-new/profile-item-pop-menu/ProfileItemPopupMenu.tsx









//Style

//Context

//component






//Constant




//methods



//Hooks



//Icon







var getIsDesktopViewport = function() {
    return  true && window.matchMedia("(min-width: 992px)").matches;
};
var ProfileItemPopupMenu = function(param) {
    var onClickMenuCallBack = param.onClickMenuCallBack, useBottomSheetMenu = param.useBottomSheetMenu;
    var clickToCallContext = (0,ClickToCallAppProvider/* useClickToCall */.k$)();
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), companyLogo = ref.companyLogo, name = ref.name, setCompanyId = ref.setCompanyId, setIsPhoneVerified = ref.setIsPhoneVerified, setName = ref.setName, setLang = ref.setLang, setCompanyLogo = ref.setCompanyLogo, setUserId = ref.setUserId, phoneNum = ref.phoneNum, setCsDashboardUserRoles = ref.setCsDashboardUserRoles, setCustomerCompanyId = ref.setCustomerCompanyId, setCustomerName = ref.setCustomerName, setCustomerPhone = ref.setCustomerPhone, csDashboardUserRoles = ref.csDashboardUserRoles, setSessionId = ref.setSessionId, fromFlutterApp = ref.fromFlutterApp, setThirdPartyCompanyName = ref.setThirdPartyCompanyName;
    var ref1 = (0,hooks/* useToggleModalWithLocalState */.A$)(false), isDropDownOpen = ref1.isModalOpen, openProfilePopup = ref1.openModal, toggleProfilePopup = ref1.toggleModal;
    var ref2 = (0,hooks/* useToggleModalWithLocalState */.A$)(false), isUserProfileSheetVisible = ref2.isModalOpen, toggleUserProfileSheetPopup = ref2.toggleModal, closeUserProfileSheetPopup = ref2.closeModal;
    var preferncePopup = (0,hooks/* useToggleModalWithLocalState */.A$)(false);
    var ref3 = (0,react.useState)(false), isMounted = ref3[0], setIsMounted = ref3[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        var closeSheetOnNavigate = function() {
            closeUserProfileSheetPopup();
        };
        router.events.on("routeChangeStart", closeSheetOnNavigate);
        return function() {
            router.events.off("routeChangeStart", closeSheetOnNavigate);
        };
    }, [
        closeUserProfileSheetPopup,
        router.events
    ]);
    var isDesktopViewport = (0,useMediaQuery/* default */.Z)({
        queryType: "desktop",
        initialState: getIsDesktopViewport()
    });
    var shouldUseBottomSheet = useBottomSheetMenu !== null && useBottomSheetMenu !== void 0 ? useBottomSheetMenu : !isDesktopViewport;
    var closeProfileMenu = function() {
        onClickMenuCallBack === null || onClickMenuCallBack === void 0 ? void 0 : onClickMenuCallBack();
        if (shouldUseBottomSheet) {
            if (isUserProfileSheetVisible) {
                toggleUserProfileSheetPopup();
            }
            return;
        }
        if (isDropDownOpen) {
            toggleProfilePopup();
        }
    };
    var onClickLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        closeProfileMenu();
                        _ctx.next = 3;
                        return (0,performLogoutAndRedirectHome/* performLogoutAndRedirectHome */.e)({
                            router: router,
                            setCompanyId: setCompanyId,
                            setIsPhoneVerified: setIsPhoneVerified,
                            setName: setName,
                            setLang: setLang,
                            setCompanyLogo: setCompanyLogo,
                            setUserId: setUserId,
                            phoneNum: Number(phoneNum),
                            setCsDashboardUserRoles: setCsDashboardUserRoles,
                            setCustomerCompanyId: setCustomerCompanyId,
                            setCustomerName: setCustomerName,
                            setCustomerPhone: setCustomerPhone,
                            setSessionId: setSessionId,
                            setThirdPartyCompanyName: setThirdPartyCompanyName
                        });
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAdminConsoleLogout = function() {
        (0,handleLogout/* handleLogout */.h)({
            setCompanyId: setCompanyId,
            setIsPhoneVerified: setIsPhoneVerified,
            setName: setName,
            setLang: setLang,
            setCompanyLogo: setCompanyLogo,
            setUserId: setUserId,
            setCsDashboardUserRoles: setCsDashboardUserRoles,
            setCustomerCompanyId: setCustomerCompanyId,
            setCustomerPhone: setCustomerPhone,
            setCustomerName: setCustomerName,
            setSessionId: setSessionId
        });
    };
    var PROFILE_OPTIONS = [
        {
            id: automation/* IDs.profileDropDown.myProfileBtn */.g.profileDropDown.myProfileBtn,
            title: "My Profile",
            route: routeStrings/* ROUTES.userProfile.getUrl */.Z.userProfile.getUrl(),
            handler: undefined,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(standard_icons_profile/* default */.Z, {}),
            wrapperClass: "",
            textColor: undefined,
            hide: false
        },
        {
            id: automation/* IDs.profileDropDown.profileLogout */.g.profileDropDown.profileLogout,
            title: "Logout",
            route: "",
            handler: onClickLogout,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout, {}),
            wrapperClass: (ProfileItemPopupMenu_module_default()).logout,
            textColor: colors/* default.RED */.Z.RED,
            hide: undefined
        }
    ];
    var handleOptionClick = function(route) {
        closeProfileMenu();
        router.push(route, undefined, {
            shallow: true
        });
    };
    var handleOtherClick = function(type) {
        closeProfileMenu();
        if (type === "prefernce") {
            preferncePopup.openModal();
        }
    };
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var renderOptions = function() {
        return !isCsDashboardUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            padding: 20,
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    alignItems: "center",
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage/* default */.Z, {
                            imageUrl: companyLogo,
                            alt: name || "Vahak User",
                            size: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                            weight: "semibold",
                            size: "m",
                            children: name || "Guest"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                    className: classnames_default()((ProfileItemPopupMenu_module_default()).profileOptions),
                    flexDirection: "column",
                    gap: 20,
                    children: PROFILE_OPTIONS.map(function(option) {
                        if (option.hide) return;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                            alignItems: "center",
                            gap: 10,
                            className: classnames_default()((ProfileItemPopupMenu_module_default()).profileOption, option.wrapperClass),
                            onClick: function() {
                                return option.handler ? option.handler() : handleOptionClick(option.route);
                            },
                            id: option.id,
                            children: [
                                option.icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                    weight: "semibold",
                                    size: "m",
                                    color: option.textColor ? option.textColor : colors/* default.BLACK */.Z.BLACK,
                                    children: option.title
                                })
                            ]
                        });
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            padding: 20,
            flexDirection: "column",
            gap: 10,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    gap: 10,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage/* default */.Z, {
                            imageUrl: companyLogo,
                            alt: name || "Vahak User",
                            size: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                            gap: 0,
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                    weight: "semibold",
                                    size: "m",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                    weight: "semibold",
                                    size: "sm",
                                    color: colors/* default.GREY_500 */.Z.GREY_500,
                                    children: phoneNum
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                    weight: "semibold",
                                    size: "sm",
                                    color: colors/* default.GREY_500 */.Z.GREY_500,
                                    textTransform: "uppercase",
                                    children: csDashboardUserRoles === null || csDashboardUserRoles === void 0 ? void 0 : csDashboardUserRoles.map(function(role) {
                                        return role.replaceAll("_", " ");
                                    }).join(", ")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                    action: adminOperation/* ADMIN_OPERATION.profileView */.F.profileView,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            radius: 100,
                            size: "auto",
                            color: "red",
                            filled: true
                        }, (clickToCallContext === null || clickToCallContext === void 0 ? void 0 : clickToCallContext.isReady) && {
                            color: "green"
                        }), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Typography/* default */.Z, {
                                children: [
                                    "Plivo Status : ",
                                    (clickToCallContext === null || clickToCallContext === void 0 ? void 0 : clickToCallContext.isReady) ? "Connected" : "Not Connected"
                                ]
                            })
                        }))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    flexDirection: "column",
                    gap: 20,
                    padding: "20px 20px 0px 20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                            action: adminOperation/* ADMIN_OPERATION.blockUnblockUser */.F.blockUnblockUser,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                alignItems: "center",
                                gap: 10,
                                className: classnames_default()((ProfileItemPopupMenu_module_default()).profileOption),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    fillType: "text",
                                    onClick: function() {
                                        return handleOptionClick(routeStrings/* ROUTES.adminConsoleBlockUsers.getUrl */.Z.adminConsoleBlockUsers.getUrl());
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                        weight: "semibold",
                                        size: "sm",
                                        color: colors/* default.BLACK */.Z.BLACK,
                                        children: "Block Users"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                            action: "",
                            roles: constants/* ALLOWED_ACTION_BY_ROLES.CUSTOM_PREFERENCE_VISIBILTY */.pGF.CUSTOM_PREFERENCE_VISIBILTY,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                alignItems: "center",
                                gap: 10,
                                className: classnames_default()((ProfileItemPopupMenu_module_default()).profileOption),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    fillType: "text",
                                    onClick: function() {
                                        return handleOtherClick("prefernce");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                            weight: "semibold",
                                            size: "sm",
                                            color: colors/* default.BLACK */.Z.BLACK,
                                            children: "Custom Prefernce"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StopPropagation/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_prefernce_CsCustomPrefernce, {
                                                popupProps: {
                                                    isOpen: preferncePopup === null || preferncePopup === void 0 ? void 0 : preferncePopup.isModalOpen,
                                                    onToggle: preferncePopup === null || preferncePopup === void 0 ? void 0 : preferncePopup.toggleModal
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                            action: adminOperation/* ADMIN_OPERATION.profileView */.F.profileView,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                alignItems: "center",
                                gap: 10,
                                className: classnames_default()((ProfileItemPopupMenu_module_default()).profileOption),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    fillType: "text",
                                    onClick: function() {
                                        return handleOptionClick(routeStrings/* ROUTES.adminConsoleSendWhatsAppMessage.getUrl */.Z.adminConsoleSendWhatsAppMessage.getUrl());
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                        weight: "semibold",
                                        size: "sm",
                                        color: colors/* default.BLACK */.Z.BLACK,
                                        children: "Send Whatsapp Message"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IfCanAccess/* default */.Z, {
                            action: "",
                            roles: constants/* ALLOWED_ACTION_BY_ROLES.ALLOW_QUICK_LOGOUT */.pGF.ALLOW_QUICK_LOGOUT,
                            children: Boolean(fromFlutterApp) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.ZP, {
                                alignItems: "center",
                                gap: 10,
                                className: classnames_default()((ProfileItemPopupMenu_module_default()).profileOption),
                                onClick: handleAdminConsoleLogout,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    fillType: "text",
                                    id: automation/* IDs.profileDropDown.profileLogout */.g.profileDropDown.profileLogout,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Typography/* default */.Z, {
                                        weight: "semibold",
                                        size: "sm",
                                        color: colors/* default.RED */.Z.RED,
                                        children: "Logout"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProfileItemPopupMenu_module_default()).main,
        children: [
            !shouldUseBottomSheet ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                isOpen: isDropDownOpen,
                DropdownToggleBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage/* default */.Z, {
                    imageUrl: companyLogo,
                    alt: name || "Vahak User",
                    size: "sm"
                }),
                handleToggle: toggleProfilePopup,
                containerClassName: "",
                direction: "left",
                dropdownClassName: (ProfileItemPopupMenu_module_default()).profileDropdown,
                dropdownToggleClassName: (ProfileItemPopupMenu_module_default()).profileDropdownDropdownToggle,
                id: automation/* IDs.header.profileAvatar */.g.header.profileAvatar,
                children: renderOptions()
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: automation/* IDs.header.profileAvatar */.g.header.profileAvatar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage/* default */.Z, {
                    size: "sm",
                    imageUrl: companyLogo,
                    alt: name || "Vahak User",
                    onClick: toggleUserProfileSheetPopup
                })
            }),
            shouldUseBottomSheet && isUserProfileSheetVisible && isMounted ? /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet/* default */.Z, {
                isOpen: isUserProfileSheetVisible,
                onToggle: toggleUserProfileSheetPopup,
                showCloseIcon: false,
                showHeader: false,
                bodyMinHeight: "auto",
                children: renderOptions()
            }), document.body) : null
        ]
    });
};
/* harmony default export */ var profile_item_pop_menu_ProfileItemPopupMenu = (ProfileItemPopupMenu);

// EXTERNAL MODULE: ../core-ui/dist/methods/browser.js
var browser = __webpack_require__(82238);
// EXTERNAL MODULE: ./components/common/download-app-qr-modal/DownloadAppAction.tsx + 1 modules
var DownloadAppAction = __webpack_require__(20058);
// EXTERNAL MODULE: ./components/homepage-v2/compactAppDownload.constants.ts
var compactAppDownload_constants = __webpack_require__(68628);
// EXTERNAL MODULE: ./components/layout/top-nav-v2/SmartAppBanner.module.scss
var SmartAppBanner_module = __webpack_require__(13922);
var SmartAppBanner_module_default = /*#__PURE__*/__webpack_require__.n(SmartAppBanner_module);
;// CONCATENATED MODULE: ./components/layout/top-nav-v2/SmartAppBanner.tsx








var STORAGE_KEY = "hpv2-smart-app-banner-dismissed";
var BANNER_HEIGHT = "68px";
var SmartAppBanner = function(param) {
    var onDownload = param.onDownload;
    var t = (0,esm/* useTranslation */.$G)("navigation").t;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var isApple = typeof navigator !== "undefined" && (0,browser/* isIOSWebKit */.B$)();
    var storeUrl = isApple ? compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.appStoreUrl */.X.appStoreUrl : compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.playStoreUrl */.X.playStoreUrl;
    (0,react.useEffect)(function() {
        try {
            if (window.sessionStorage.getItem(STORAGE_KEY) === "1") {
                return;
            }
        } catch (e) {
        // Private mode — still show.
        }
        if (!window.matchMedia("(max-width: 991px)").matches) {
            return;
        }
        setIsVisible(true);
    }, []);
    (0,react.useEffect)(function() {
        var height = isVisible ? BANNER_HEIGHT : "0px";
        document.documentElement.style.setProperty("--hp-v2-smart-banner-height", height);
        return function() {
            document.documentElement.style.setProperty("--hp-v2-smart-banner-height", "0px");
        };
    }, [
        isVisible
    ]);
    var handleDismiss = function() {
        try {
            window.sessionStorage.setItem(STORAGE_KEY, "1");
        } catch (e) {
        // Private mode.
        }
        setIsVisible(false);
    };
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SmartAppBanner_module_default()).banner,
        role: "region",
        "aria-label": t("appDownload.smartBanner.title"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (SmartAppBanner_module_default()).dismiss,
                onClick: handleDismiss,
                "aria-label": t("appDownload.smartBanner.dismiss"),
                children: "\xd7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (SmartAppBanner_module_default()).icon,
                "aria-hidden": true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakCircleBlueLogo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SmartAppBanner_module_default()).copy,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SmartAppBanner_module_default()).title,
                        children: t("appDownload.smartBanner.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SmartAppBanner_module_default()).tagline,
                        children: t("appDownload.smartBanner.tagline")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAppAction/* default */.Z, {
                href: storeUrl,
                storeUrl: storeUrl,
                className: (SmartAppBanner_module_default()).cta,
                onClick: function() {
                    return onDownload === null || onDownload === void 0 ? void 0 : onDownload(isApple ? "app_store" : "play_store");
                },
                "aria-label": isApple ? t("appDownload.downloadAppStore") : t("appDownload.downloadPlayStore"),
                children: t("appDownload.smartBanner.cta")
            })
        ]
    });
};
/* harmony default export */ var top_nav_v2_SmartAppBanner = (SmartAppBanner);

// EXTERNAL MODULE: ./components/homepage-v2/app-download-banner/AppDownloadBannerV2.tsx
var AppDownloadBannerV2 = __webpack_require__(99837);
// EXTERNAL MODULE: ./constants/marketplace.constants.ts
var marketplace_constants = __webpack_require__(57993);
// EXTERNAL MODULE: ./hooks/useLoadI18nNamespaces.ts
var useLoadI18nNamespaces = __webpack_require__(54351);
// EXTERNAL MODULE: ./hooks/useOpenNewLoadPosting.ts
var useOpenNewLoadPosting = __webpack_require__(68498);
// EXTERNAL MODULE: ./context/load-lorry-posting.tsx
var load_lorry_posting = __webpack_require__(8574);
// EXTERNAL MODULE: ./methods/getRouteLocalizationNamespaces.ts
var getRouteLocalizationNamespaces = __webpack_require__(19736);
// EXTERNAL MODULE: ./components/layout/top-nav-v2/TopNavV2.module.scss
var TopNavV2_module = __webpack_require__(99030);
var TopNavV2_module_default = /*#__PURE__*/__webpack_require__.n(TopNavV2_module);
;// CONCATENATED MODULE: ./components/layout/top-nav-v2/TopNavV2.tsx





























var GA_FROM = "homepage_v2_top_nav";
var TopNavV2 = function() {
    var ref = react.useContext(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("navigation").t;
    (0,useLoadI18nNamespaces/* default */.ZP)(getRouteLocalizationNamespaces/* WEB_V2_SHELL_LOCALIZATION_NAMESPACES */.y$);
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var openNewLoadPosting = (0,useOpenNewLoadPosting/* default */.Z)();
    var isDesktop = (0,useMediaQuery/* default */.Z)({
        queryType: "desktop",
        initialState:  true ? window.matchMedia("(min-width: 992px)").matches : 0
    });
    var ref1 = (0,react.useState)(false), isHamburgerMenuOpen = ref1[0], setIsHamburgerMenuOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isScrolled = ref2[0], setIsScrolled = ref2[1];
    // TEMP: language change hidden
    // const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
    (0,react.useEffect)(function() {
        var closeDrawerOnNavigate = function() {
            return setIsHamburgerMenuOpen(false);
        };
        router.events.on("routeChangeStart", closeDrawerOnNavigate);
        return function() {
            router.events.off("routeChangeStart", closeDrawerOnNavigate);
        };
    }, [
        router.events
    ]);
    var isHomepage = router.pathname === "/";
    var isCargoInsurancePage = router.pathname === userScreenId/* UserScreenId.cargoInsurance.pathname */.B.cargoInsurance.pathname;
    var isMembershipPage = router.pathname === routeStrings/* ROUTES.membershipUpgrade.getUrl */.Z.membershipUpgrade.getUrl();
    var isMarketplaceLoadPage = router.pathname === "/marketplace/[...params]" && router.asPath.includes(marketplace_constants/* MARKETPLACE_ROUTE_CONFIG.loadUrl */.VV.loadUrl);
    var hasDarkHero = isHomepage || isCargoInsurancePage || isMembershipPage || isMarketplaceLoadPage;
    (0,react.useEffect)(function() {
        if (!hasDarkHero) {
            setIsScrolled(false);
            return;
        }
        var updateScrolledState = function() {
            return setIsScrolled(window.scrollY > 24);
        };
        updateScrolledState();
        window.addEventListener("scroll", updateScrolledState, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", updateScrolledState);
        };
    }, [
        hasDarkHero
    ]);
    // TEMP: language change hidden
    // const PageLanguages = getNavLanguagesForRoute(router.pathname, router.asPath);
    var trackEvent = function(eventName, extra) {
        sendGAandMoEngageEvent({
            name: eventName,
            data: (0,_object_spread/* default */.Z)({
                from_screen: router.asPath,
                from: GA_FROM
            }, extra)
        });
    };
    var resetMenuState = function() {
        setIsHamburgerMenuOpen(false);
    // TEMP: language change hidden
    // setIsLanguageMenuOpen(false);
    };
    var handleRouteNav = function(pathname, eventName) {
        trackEvent(eventName);
        resetMenuState();
        router.push(pathname);
    };
    var handleLogoClick = function() {
        resetMenuState();
        if (companyId) {
            if (router.pathname.includes("/dashboard")) {
                return;
            }
            router.push(routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl());
            return;
        }
        if (isHomepage) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            return;
        }
        router.push("/");
    };
    var handleLogin = function() {
        trackEvent(event_names/* GA4EventNames.WEB_V2.title_login_signup */.wQ.WEB_V2.title_login_signup);
        resetMenuState();
        router.push({
            hash: "#Login"
        });
    };
    var handleDownloadClick = function() {
        trackEvent(event_names/* GA4EventNames.WEB_V2.title_download_app_clicked */.wQ.WEB_V2.title_download_app_clicked);
        resetMenuState();
        if ((0,methods/* scrollToElementById */.H5)(AppDownloadBannerV2/* APP_DOWNLOAD_BANNER_SECTION_ID */.c)) {
            return;
        }
        window.open(compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.playStoreUrl */.X.playStoreUrl, "_blank", "noopener,noreferrer");
    };
    var getTopNavSourceScreen = (0,react.useCallback)(function() {
        if (isHomepage) {
            return event_names/* WEB_V2_SOURCE_SCREENS.HOME_PAGE */.ZM.HOME_PAGE;
        }
        if (isMarketplaceLoadPage) {
            return event_names/* WEB_V2_SOURCE_SCREENS.MARKETPLACE */.ZM.MARKETPLACE;
        }
        if (isMembershipPage) {
            return event_names/* WEB_V2_SOURCE_SCREENS.MEMBERSHIP */.ZM.MEMBERSHIP;
        }
        if (isCargoInsurancePage) {
            return event_names/* WEB_V2_SOURCE_SCREENS.CARGO_INSURANCE */.ZM.CARGO_INSURANCE;
        }
        return event_names/* WEB_V2_SOURCE_SCREENS.HOME_PAGE */.ZM.HOME_PAGE;
    }, [
        isCargoInsurancePage,
        isHomepage,
        isMarketplaceLoadPage,
        isMembershipPage
    ]);
    var handleFindLorry = (0,react.useCallback)(function() {
        trackEvent(event_names/* GA4EventNames.WEB_V2.title_find_lorry_clicked */.wQ.WEB_V2.title_find_lorry_clicked);
        resetMenuState();
        openNewLoadPosting({
            originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.HOME */.ec.HOME,
            eventData: {
                source_screen: getTopNavSourceScreen()
            }
        });
    }, [
        getTopNavSourceScreen,
        openNewLoadPosting
    ]);
    var navLinks = (0,react.useMemo)(function() {
        return [
            {
                id: "find-lorry",
                label: t("findLorry"),
                onClick: handleFindLorry
            },
            {
                id: "find-loads",
                label: t("findLoads"),
                isActive: isMarketplaceLoadPage,
                onClick: function() {
                    return handleRouteNav(marketplace_constants/* MARKETPLACE_ROUTE_CONFIG.loadUrl */.VV.loadUrl, event_names/* GA4EventNames.WEB_V2.title_find_loads_clicked */.wQ.WEB_V2.title_find_loads_clicked);
                }
            },
            {
                id: "download-app",
                label: t("downloadApp"),
                onClick: handleDownloadClick
            },
            {
                id: "membership",
                label: t("membership"),
                isActive: isMembershipPage,
                onClick: function() {
                    return handleRouteNav(routeStrings/* ROUTES.membershipUpgrade.getUrl */.Z.membershipUpgrade.getUrl(), event_names/* GA4EventNames.WEB_V2.title_membership_clicked */.wQ.WEB_V2.title_membership_clicked);
                }
            },
            {
                id: "cargo-insurance",
                label: t("cargoInsurance"),
                isActive: isCargoInsurancePage,
                onClick: function() {
                    if (isCargoInsurancePage) {
                        resetMenuState();
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                        return;
                    }
                    handleRouteNav(userScreenId/* UserScreenId.cargoInsurance.pathname */.B.cargoInsurance.pathname, event_names/* GA4EventNames.WEB_V2.title_cargo_insurance_clicked */.wQ.WEB_V2.title_cargo_insurance_clicked);
                }
            }
        ];
    }, [
        handleFindLorry,
        isCargoInsurancePage,
        isMarketplaceLoadPage,
        isMembershipPage,
        t
    ]);
    // TEMP: language change hidden
    /*
    const renderLangList = () => (
        <ul className={Styles.languageSubmenuWrapper}>
            {PageLanguages?.languages?.map((language) => (
                <li
                    key={language.id}
                    className={classnames(Styles.languageSubmenu, (lang || 0) === language.id && Styles.active)}
                    onClick={() => {
                        trackEvent(GA4EventNames.WEB_V2.title_language_change, {
                            language: language.value
                        });
                        setLang?.(language.id);
                        resetMenuState();
                    }}
                >
                    <Typography weight="medium" size="sm">
                        {language.labelInLanguage}
                    </Typography>
                    <Typography weight="medium" size={language.labelInEn === "English" ? "sm" : "xs"}>
                        {language.labelInEn}
                    </Typography>
                </li>
            ))}
        </ul>
    );
    */ var renderNavLink = function(link, className) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: className,
            onClick: link.onClick,
            children: link.label
        }, link.id);
    };
    var renderAuthControl = function() {
        if (isPhoneVerified) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TopNavV2_module_default()).profileSlot,
                id: automation/* IDs.profileDropDown.profileDropdownBtn */.g.profileDropDown.profileDropdownBtn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(profile_item_pop_menu_ProfileItemPopupMenu, {
                    onClickMenuCallBack: resetMenuState,
                    useBottomSheetMenu: !isDesktop
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TopNavV2_module_default()).authActions,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (TopNavV2_module_default()).loginBtn,
                        onClick: handleLogin,
                        children: t("login")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: (TopNavV2_module_default()).mobileLoginBtn,
                    onClick: handleLogin,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(profile, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("login")
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: classnames_default()((TopNavV2_module_default()).main, hasDarkHero && (TopNavV2_module_default()).darkHeroMain, hasDarkHero && isScrolled && (TopNavV2_module_default()).darkHeroMainScrolled),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(top_nav_v2_SmartAppBanner, {
                onDownload: function(store) {
                    return trackEvent(store === "app_store" ? event_names/* GA4EventNames.WEB_V2.download_appstore */.wQ.WEB_V2.download_appstore : event_names/* GA4EventNames.WEB_V2.download_playstore */.wQ.WEB_V2.download_playstore);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(continue_sign_up_ContinueSignup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TopNavV2_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TopNavV2_module_default()).left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((TopNavV2_module_default()).hamburgerMenu, isHamburgerMenuOpen && (TopNavV2_module_default()).open),
                                onClick: function() {
                                    return setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
                                },
                                role: "button",
                                tabIndex: 0,
                                "aria-label": "Toggle menu",
                                onKeyDown: function(event) {
                                    if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (TopNavV2_module_default()).logoWrapper,
                                id: automation/* IDs.common.vahakLogo */.g.common.vahakLogo,
                                onClick: handleLogoClick,
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: function(event) {
                                    if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        handleLogoClick();
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VahakCircleBlueLogo, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (TopNavV2_module_default()).logoText,
                                        children: "Vahak"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: (TopNavV2_module_default()).centerNav,
                        "aria-label": "Primary",
                        children: navLinks.map(function(link) {
                            return renderNavLink(link, classnames_default()((TopNavV2_module_default()).navLink, link.isActive && (TopNavV2_module_default()).navLinkActive));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TopNavV2_module_default()).right,
                        children: renderAuthControl()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((TopNavV2_module_default()).appDrawMenu, isHamburgerMenuOpen && (TopNavV2_module_default()).isOpen),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TopNavV2_module_default()).appDrawMenuOptionListWrapper,
                    children: [
                        navLinks.map(function(link) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TopNavV2_module_default()).appDrawMenuOption,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: classnames_default()((TopNavV2_module_default()).drawerLink, link.isActive && (TopNavV2_module_default()).drawerLinkActive),
                                    onClick: link.onClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: colors/* default.BLACK */.Z.BLACK,
                                        weight: "semibold",
                                        mSize: "sm",
                                        children: link.label
                                    })
                                })
                            }, link.id);
                        }),
                        !isPhoneVerified ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopNavV2_module_default()).drawerActions,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (TopNavV2_module_default()).drawerLoginBtn,
                                    onClick: handleLogin,
                                    children: t("login")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (TopNavV2_module_default()).drawerSignUpBtn,
                                    onClick: handleLogin,
                                    children: t("signUp")
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var top_nav_v2_TopNavV2 = (TopNavV2);


/***/ }),

/***/ 33623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TopNavV2__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TopNavV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74431);



/***/ }),

/***/ 52686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ getLcvRouteBySlug; },
  "a": function() { return /* binding */ getLcvRouteSlugs; }
});

;// CONCATENATED MODULE: ./components/lcv-route-landing/data/lcvRoutes.manifest.json
var lcvRoutes_manifest_namespaceObject = JSON.parse('[{"slug":"ahmedabad-to-mumbai","source":"ahmedabad","destination":"mumbai","hreflangLocales":["en","gu"]},{"slug":"bangalore-to-chennai","source":"bangalore","destination":"chennai","hreflangLocales":["en","kn"]},{"slug":"bangalore-to-hyderabad","source":"bangalore","destination":"hyderabad","hreflangLocales":["en","kn"]},{"slug":"chennai-to-bangalore","source":"chennai","destination":"bangalore","hreflangLocales":["en","ta"]},{"slug":"chennai-to-hyderabad","source":"chennai","destination":"hyderabad","hreflangLocales":["en","ta"]},{"slug":"delhi-to-jaipur","source":"delhi","destination":"jaipur","hreflangLocales":["en","hi"]},{"slug":"delhi-to-kolkata","source":"delhi","destination":"kolkata","hreflangLocales":["en","hi"]},{"slug":"delhi-to-mumbai","source":"delhi","destination":"mumbai","hreflangLocales":["en","hi"]},{"slug":"hyderabad-to-bangalore","source":"hyderabad","destination":"bangalore","hreflangLocales":["en","kn","te"]},{"slug":"hyderabad-to-chennai","source":"hyderabad","destination":"chennai","hreflangLocales":["en","te"]},{"slug":"jaipur-to-delhi","source":"jaipur","destination":"delhi","hreflangLocales":["en","hi"]},{"slug":"kolkata-to-delhi","source":"kolkata","destination":"delhi","hreflangLocales":["en","bn"]},{"slug":"mumbai-to-ahmedabad","source":"mumbai","destination":"ahmedabad","hreflangLocales":["en","mr"]},{"slug":"mumbai-to-delhi","source":"mumbai","destination":"delhi","hreflangLocales":["en","hi","mr"]},{"slug":"mumbai-to-pune","source":"mumbai","destination":"pune","hreflangLocales":["en","mr"]},{"slug":"pune-to-mumbai","source":"pune","destination":"mumbai","hreflangLocales":["en","mr"]}]');
// EXTERNAL MODULE: ./components/lcv-route-landing/data/lcvRouteCities.ts
var lcvRouteCities = __webpack_require__(22515);
// EXTERNAL MODULE: ../core/src/locales/bn/lcvRouteLanding.json
var lcvRouteLanding = __webpack_require__(83596);
// EXTERNAL MODULE: ../core/src/locales/en/lcvRouteLanding.json
var en_lcvRouteLanding = __webpack_require__(84941);
// EXTERNAL MODULE: ../core/src/locales/gu/lcvRouteLanding.json
var gu_lcvRouteLanding = __webpack_require__(97621);
// EXTERNAL MODULE: ../core/src/locales/hi/lcvRouteLanding.json
var hi_lcvRouteLanding = __webpack_require__(24610);
// EXTERNAL MODULE: ../core/src/locales/kn/lcvRouteLanding.json
var kn_lcvRouteLanding = __webpack_require__(28354);
// EXTERNAL MODULE: ../core/src/locales/mr/lcvRouteLanding.json
var mr_lcvRouteLanding = __webpack_require__(42086);
// EXTERNAL MODULE: ../core/src/locales/ta/lcvRouteLanding.json
var ta_lcvRouteLanding = __webpack_require__(27285);
// EXTERNAL MODULE: ../core/src/locales/te/lcvRouteLanding.json
var te_lcvRouteLanding = __webpack_require__(48737);
;// CONCATENATED MODULE: ./components/lcv-route-landing/data/lcvRouteLocaleSlugs.ts








var _routes, _routes1, _routes2, _routes3, _routes4, _routes5, _routes6, _routes7;
var LCV_ROUTE_SLUGS_BY_LOCALE = {
    bn: new Set(Object.keys((_routes = lcvRouteLanding/* routes */._j) !== null && _routes !== void 0 ? _routes : {})),
    en: new Set(Object.keys((_routes1 = en_lcvRouteLanding/* routes */._j) !== null && _routes1 !== void 0 ? _routes1 : {})),
    gu: new Set(Object.keys((_routes2 = gu_lcvRouteLanding/* routes */._j) !== null && _routes2 !== void 0 ? _routes2 : {})),
    hi: new Set(Object.keys((_routes3 = hi_lcvRouteLanding/* routes */._j) !== null && _routes3 !== void 0 ? _routes3 : {})),
    kn: new Set(Object.keys((_routes4 = kn_lcvRouteLanding/* routes */._j) !== null && _routes4 !== void 0 ? _routes4 : {})),
    mr: new Set(Object.keys((_routes5 = mr_lcvRouteLanding/* routes */._j) !== null && _routes5 !== void 0 ? _routes5 : {})),
    ta: new Set(Object.keys((_routes6 = ta_lcvRouteLanding/* routes */._j) !== null && _routes6 !== void 0 ? _routes6 : {})),
    te: new Set(Object.keys((_routes7 = te_lcvRouteLanding/* routes */._j) !== null && _routes7 !== void 0 ? _routes7 : {}))
};
function getVerifiedHreflangLocales(slug, hreflangLocales) {
    var ref;
    var verifiedLocales = hreflangLocales.filter(function(locale) {
        var ref;
        return (ref = LCV_ROUTE_SLUGS_BY_LOCALE[locale]) === null || ref === void 0 ? void 0 : ref.has(slug);
    });
    if (verifiedLocales.length > 0) {
        return verifiedLocales;
    }
    return ((ref = LCV_ROUTE_SLUGS_BY_LOCALE.en) === null || ref === void 0 ? void 0 : ref.has(slug)) ? [
        "en"
    ] : [
        "en"
    ];
}

;// CONCATENATED MODULE: ./components/lcv-route-landing/data/routes.ts



var defineRoute = function(slug, source, destination, hreflangLocales) {
    return {
        slug: slug,
        hreflangLocales: hreflangLocales,
        source: lcvRouteCities/* LCV_ROUTE_CITIES */.U[source],
        destination: lcvRouteCities/* LCV_ROUTE_CITIES */.U[destination]
    };
};
/** Route list — edit lcvRoutes.manifest.json only (also used by sitemap generator). */ var LCV_ROUTES = lcvRoutes_manifest_namespaceObject.map(function(param) {
    var slug = param.slug, source = param.source, destination = param.destination, hreflangLocales = param.hreflangLocales;
    return defineRoute(slug, source, destination, getVerifiedHreflangLocales(slug, hreflangLocales));
});
var lcvRoutesBySlug = Object.fromEntries(LCV_ROUTES.map(function(route) {
    return [
        route.slug,
        route
    ];
}));

;// CONCATENATED MODULE: ./components/lcv-route-landing/data/index.ts

var getLcvRouteSlugs = function() {
    return Object.keys(lcvRoutesBySlug);
};
var getLcvRouteBySlug = function(slug) {
    return lcvRoutesBySlug[slug];
};


/***/ }),

/***/ 22515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ LCV_ROUTE_CITIES; }
/* harmony export */ });
var LCV_ROUTE_CITIES = {
    ahmedabad: {
        city: "Ahmedabad",
        state: "Gujarat",
        description: "Ahmedabad, Gujarat, India",
        place_id: "ChIJSdRbuoqEXjkRFmVPYRHdzk8",
        state_id: 4
    },
    bangalore: {
        city: "Bangalore",
        state: "Karnataka",
        description: "Bangalore, Karnataka, India",
        place_id: "ChIJbU60yXAWrjsR4E9-UejD3_g",
        state_id: 3
    },
    chennai: {
        city: "Chennai",
        state: "Tamil Nadu",
        description: "Chennai, Tamil Nadu, India",
        place_id: "ChIJYTN9T-plUjoRM9RjaAunYW4",
        state_id: 6
    },
    delhi: {
        city: "Delhi",
        state: "Delhi",
        description: "Delhi, Delhi, India",
        place_id: "ChIJLbZ-NFv9DDkRzk0gTkm3wlI",
        state_id: 2
    },
    hyderabad: {
        city: "Hyderabad",
        state: "Telangana",
        description: "Hyderabad, Telangana, India",
        place_id: "ChIJx9Lr6tqZyzsRwvu6koO3k64",
        state_id: 5
    },
    jaipur: {
        city: "Jaipur",
        state: "Rajasthan",
        description: "Jaipur, Rajasthan, India",
        place_id: "ChIJgeJXTN9KbDkRCS7yDDrG4Qw",
        state_id: 8
    },
    kolkata: {
        city: "Kolkata",
        state: "West Bengal",
        description: "Kolkata, West Bengal, India",
        place_id: "ChIJ5093-p34AjoR-3pT1B1o9p4",
        state_id: 7
    },
    mumbai: {
        city: "Mumbai",
        state: "Maharashtra",
        description: "Mumbai, Maharashtra, India",
        place_id: "ChIJwe1EZjDG5zsRaYxkjY_tpF0",
        state_id: 1
    },
    pune: {
        city: "Pune",
        state: "Maharashtra",
        description: "Pune, Maharashtra, India",
        place_id: "ChIJARFGZy6_wjsRQ-Oenb9DjYI",
        state_id: 1
    }
};


/***/ }),

/***/ 99968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ getLcvRouteLocalizedPath; },
/* harmony export */   "z": function() { return /* binding */ getLcvRouteFooterLinkGroups; }
/* harmony export */ });
/* harmony import */ var _core_src_locales_bn_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83596);
/* harmony import */ var _core_src_locales_en_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84941);
/* harmony import */ var _core_src_locales_gu_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97621);
/* harmony import */ var _core_src_locales_hi_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24610);
/* harmony import */ var _core_src_locales_kn_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28354);
/* harmony import */ var _core_src_locales_mr_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42086);
/* harmony import */ var _core_src_locales_ta_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27285);
/* harmony import */ var _core_src_locales_te_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48737);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52686);
/* harmony import */ var _lcvRouteLanding_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11529);










var LCV_ROUTE_LABELS_BY_LOCALE = {
    bn: _core_src_locales_bn_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_0__/* .footer.lcvRouteLabels */ .Mv.TA,
    en: _core_src_locales_en_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_1__/* .footer.lcvRouteLabels */ .Mv.TA,
    gu: _core_src_locales_gu_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_2__/* .footer.lcvRouteLabels */ .Mv.TA,
    hi: _core_src_locales_hi_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_3__/* .footer.lcvRouteLabels */ .Mv.TA,
    kn: _core_src_locales_kn_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_4__/* .footer.lcvRouteLabels */ .Mv.TA,
    mr: _core_src_locales_mr_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_5__/* .footer.lcvRouteLabels */ .Mv.TA,
    ta: _core_src_locales_ta_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_6__/* .footer.lcvRouteLabels */ .Mv.TA,
    te: _core_src_locales_te_lcvRouteLanding_json__WEBPACK_IMPORTED_MODULE_7__/* .footer.lcvRouteLabels */ .Mv.TA
};
var getLcvRouteLocalizedPath = function(locale, slug) {
    var basePath = (0,_lcvRouteLanding_constants__WEBPACK_IMPORTED_MODULE_9__/* .getLcvBookingRoutePath */ .Yv)(slug);
    return locale === "en" ? basePath : "/".concat(locale).concat(basePath);
};
var ref;
var getLcvRouteLabel = function(locale, slug) {
    var ref1;
    return (ref = (ref1 = LCV_ROUTE_LABELS_BY_LOCALE[locale]) === null || ref1 === void 0 ? void 0 : ref1[slug]) !== null && ref !== void 0 ? ref : LCV_ROUTE_LABELS_BY_LOCALE.en[slug];
};
var getLcvRouteFooterLinkGroups = function() {
    return _lcvRouteLanding_constants__WEBPACK_IMPORTED_MODULE_9__/* .LCV_BOOKING_ROUTE_SLUGS.map */ .C1.map(function(slug) {
        var ref;
        var ref1;
        var locales = (ref1 = (ref = (0,_data__WEBPACK_IMPORTED_MODULE_8__/* .getLcvRouteBySlug */ .l)(slug)) === null || ref === void 0 ? void 0 : ref.hreflangLocales) !== null && ref1 !== void 0 ? ref1 : [
            "en"
        ];
        return {
            slug: slug,
            alternates: locales.map(function(locale) {
                return {
                    locale: locale,
                    label: getLcvRouteLabel(locale, slug),
                    path: getLcvRouteLocalizedPath(locale, slug)
                };
            })
        };
    });
};


/***/ }),

/***/ 11529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ LCV_BOOKING_ROUTE_SLUGS; },
/* harmony export */   "Yv": function() { return /* binding */ getLcvBookingRoutePath; },
/* harmony export */   "rp": function() { return /* binding */ LCV_ROUTE_PLAY_STORE_URL; },
/* harmony export */   "te": function() { return /* binding */ LCV_ROUTE_SOCIAL_LINKS; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92683);
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52686);


var LCV_ROUTE_PLAY_STORE_URL = "https://6r7cz.app.link/googleplay";
var LCV_BOOKING_ROUTE_SLUGS = (0,_data__WEBPACK_IMPORTED_MODULE_1__/* .getLcvRouteSlugs */ .a)();
var getLcvBookingRoutePath = function(slug) {
    return "/lcv-booking/".concat(slug);
};
var LCV_ROUTE_SOCIAL_LINKS = [
    {
        label: "Facebook",
        href: _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_0__/* .FACEBOOK */ .vq,
        iconClassName: "ti ti-brand-facebook"
    },
    {
        label: "LinkedIn",
        href: _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_0__/* .LINKEDIN */ .fW,
        iconClassName: "ti ti-brand-linkedin"
    },
    {
        label: "YouTube",
        href: _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_0__/* .YOUTUBE */ .VU,
        iconClassName: "ti ti-brand-youtube"
    },
    {
        label: "Instagram",
        href: _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_0__/* .INSTAGRAM */ .Er,
        iconClassName: "ti ti-brand-instagram"
    }
];


/***/ }),

/***/ 91049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_dest_SrcDest; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ./components/load-lorry-details/components/src-dest/SrcDest.module.scss
var SrcDest_module = __webpack_require__(23403);
var SrcDest_module_default = /*#__PURE__*/__webpack_require__.n(SrcDest_module);
// EXTERNAL MODULE: ../core/dist/constants/market.js
var market = __webpack_require__(45678);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ./components/load-lorry-details/components/tool-tip/Tooltip.tsx
var Tooltip = __webpack_require__(45294);
// EXTERNAL MODULE: ./components/user-profile/my-routes/route-state/RouteState.module.scss
var RouteState_module = __webpack_require__(20036);
var RouteState_module_default = /*#__PURE__*/__webpack_require__.n(RouteState_module);
;// CONCATENATED MODULE: ../core/dist/icons/PlusDark.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgPlusDark(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.333 7H1.667M7 1.667v10.667V1.667z",
    stroke: "#515151",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

/* harmony default export */ var PlusDark = (SvgPlusDark);
// EXTERNAL MODULE: ../core/dist/icons/tick_blue.svg
var tick_blue = __webpack_require__(99292);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
;// CONCATENATED MODULE: ./components/user-profile/my-routes/route-state/RouteState.tsx




//icons




var RouteState = function(param) {
    var routeValue = param.routeValue, isSelect = param.isSelect, isSectionRoute = param.isSectionRoute, routeClass = param.routeClass, onClickSelect = param.onClickSelect, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((RouteState_module_default()).route, routeClass, isSelect && (RouteState_module_default()).selected),
        onClick: function() {
            return index && onClickSelect(index);
        },
        children: [
            !isSectionRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: isSelect ? /*#__PURE__*/ (0,jsx_runtime.jsx)(tick_blue/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusDark, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                size: "sm",
                color: colors/* default.GREY_700 */.Z.GREY_700,
                weight: "medium",
                children: routeValue
            })
        ]
    }, index);
};
/* harmony default export */ var route_state_RouteState = (RouteState);

// EXTERNAL MODULE: ../core/dist/components/ellipsis-tooltip/EllipsisTooltip.js + 1 modules
var EllipsisTooltip = __webpack_require__(62945);
;// CONCATENATED MODULE: ../core/dist/icons/doubleArrow.svg
var doubleArrow_path;

function doubleArrow_extends() { doubleArrow_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return doubleArrow_extends.apply(this, arguments); }



function SvgDoubleArrow(props) {
  return /*#__PURE__*/react.createElement("svg", doubleArrow_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), doubleArrow_path || (doubleArrow_path = /*#__PURE__*/react.createElement("path", {
    fill: "#275AE6",
    d: "M19.508 8.811L11.188.492a1.68 1.68 0 10-2.376 2.377l7.13 7.13-7.13 7.13a1.682 1.682 0 002.377 2.377l8.319-8.32a1.68 1.68 0 000-2.375zM9.505 8.308L2.9 1.346a1.64 1.64 0 00-2.402 0 1.858 1.858 0 000 2.532l5.404 5.695L.498 15.27a1.857 1.857 0 000 2.531 1.638 1.638 0 002.402 0l6.605-6.961a1.859 1.859 0 000-2.531z"
  })));
}

/* harmony default export */ var doubleArrow = (SvgDoubleArrow);
// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
;// CONCATENATED MODULE: ./components/load-lorry-details/components/src-dest/SrcDest.tsx





// Styles






// Icons

// Context


var SrcDest = function(_param) {
    var _state = _param.state, state = _state === void 0 ? misc/* ComponentState.NORMAL */.hm.NORMAL : _state, prop = (0,_object_without_properties/* default */.Z)(_param, [
        "state"
    ]);
    var ref, ref1, ref2, ref3;
    var cardCategory = prop.cardCategory, source = prop.source, _id = prop.id, id = _id === void 0 ? "" : _id, props = (0,_object_without_properties/* default */.Z)(prop, [
        "cardCategory",
        "source",
        "id"
    ]);
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var routes = props.routes, _position = props.position, position = _position === void 0 ? "bottom" : _position;
    var destination = props.destination;
    var isMobile = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    if (state === misc/* ComponentState.LOADING */.hm.LOADING) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SrcDest_module_default()).lorrySrcDestBox,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((SrcDest_module_default()).sourceDestWrap, misc/* ComponentState.LOADING */.hm.LOADING && (SrcDest_module_default()).loading),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SrcDest_module_default()).source,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                            width: 150,
                            height: 18
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SrcDest_module_default()).dest,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                            width: 150,
                            height: 18
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (cardCategory === market/* MARKET_TYPE.Lorry */.X5.Lorry || cardCategory === market/* MARKET_TYPE.LORRIES */.X5.LORRIES) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SrcDest_module_default()).lorrySrcDestBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((SrcDest_module_default()).sourceDestWrap),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SrcDest_module_default()).source,
                            id: "".concat(id, "--source"),
                            children: source
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SrcDest_module_default()).dest,
                            id: "".concat(id, "--dest"),
                            children: [
                                t("common:towards"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(doubleArrow, {}),
                                " ",
                                !isMobile ? routes === null || routes === void 0 ? void 0 : (ref = routes.slice) === null || ref === void 0 ? void 0 : ref.call(routes, 0, 1).map(function(route) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            route.name,
                                            " ",
                                            (routes === null || routes === void 0 ? void 0 : routes.length) > 1 && "|",
                                            " "
                                        ]
                                    }, route.id);
                                }) : ((routes === null || routes === void 0 ? void 0 : routes.length) || 0) < 2 && (routes === null || routes === void 0 ? void 0 : (ref1 = routes.slice) === null || ref1 === void 0 ? void 0 : ref1.call(routes, 0, 1).map(function(route) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EllipsisTooltip/* default */.Z, {
                                            textValue: route.name || "",
                                            greaterThanValue: 8,
                                            styles: {
                                                maxWidth: "60px",
                                                position: "absolute",
                                                top: "0",
                                                paddingLeft: "2px"
                                            }
                                        })
                                    }, route.id);
                                })),
                                " ",
                                ((routes === null || routes === void 0 ? void 0 : routes.length) || 0) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                                        tooltipToggler: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SrcDest_module_default()).viewStates,
                                            children: "".concat(isMobile ? "" : "+").concat(!isMobile ? ((routes === null || routes === void 0 ? void 0 : routes.length) || 0) - 1 : (routes === null || routes === void 0 ? void 0 : routes.length) || 0, " ").concat(t("common:states"))
                                        }),
                                        tooltipContent: routes && (!isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SrcDest_module_default()).routes,
                                            children: routes === null || routes === void 0 ? void 0 : (ref2 = routes.slice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(routes, 1, routes === null || routes === void 0 ? void 0 : routes.length)) === null || ref3 === void 0 ? void 0 : ref3.map(function(route, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (SrcDest_module_default()).route,
                                                    children: route.name
                                                }, index);
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SrcDest_module_default()).routeWrapperMobile,
                                            children: routes.map(function(route, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(route_state_RouteState, {
                                                    routeValue: route.name,
                                                    isSectionRoute: true,
                                                    routeClass: (SrcDest_module_default()).myRoutes,
                                                    onClickSelect: function() {}
                                                }, index);
                                            })
                                        })),
                                        appearOnHover: !isMobile,
                                        position: position,
                                        fallbackText: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: "No routes"
                                        }),
                                        shouldOpenInBottomSheet: isMobile
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            (cardCategory === market/* MARKET_TYPE.LOAD */.X5.LOAD || cardCategory === market/* MARKET_TYPE.LOADS */.X5.LOADS) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SrcDest_module_default()).sourceDestWrap,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SrcDest_module_default()).source,
                            id: "".concat(id, "--source"),
                            children: source !== "undefined" ? source : ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SrcDest_module_default()).dest,
                            id: "".concat(id, "--dest"),
                            children: destination !== "undefined" ? destination : ""
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var src_dest_SrcDest = (SrcDest);


/***/ }),

/***/ 45294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_dist_icons_closeOdc_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54171);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78580);
/* harmony import */ var _Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _vahak_core_dist_hooks_useHover__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89085);
/* harmony import */ var _vahak_core_dist_hooks_useOutsideClick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94482);
/* harmony import */ var _vahak_core_ui_dist_components_BottomSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84287);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26513);




// Icons

// Styles





var Tooltip = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var wrapperClassName = param.wrapperClassName, _wrapperStyle = param.wrapperStyle, wrapperStyle = _wrapperStyle === void 0 ? {} : _wrapperStyle, tooltipContainerClassName = param.tooltipContainerClassName, tooltipTogglerClassName = param.tooltipTogglerClassName, tooltipToggler = param.tooltipToggler, _appearOnHover = param.appearOnHover, appearOnHover = _appearOnHover === void 0 ? false : _appearOnHover, tooltipContent = param.tooltipContent, _position = param.position, position = _position === void 0 ? "top" : _position, fallbackText = param.fallbackText, _shouldOpenInBottomSheet = param.shouldOpenInBottomSheet, shouldOpenInBottomSheet = _shouldOpenInBottomSheet === void 0 ? false : _shouldOpenInBottomSheet, _isCloseIconDisabled = param.isCloseIconDisabled, isCloseIconDisabled = _isCloseIconDisabled === void 0 ? false : _isCloseIconDisabled, _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_vahak_core_dist_hooks_useOutsideClick__WEBPACK_IMPORTED_MODULE_5__/* .useOutsideClick */ .O)(false), 3), popupView = _$ref[0], elmRef = _$ref[1], handlePopupView = _$ref[2];
    var togglerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var tooltipContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isHovered = (0,_vahak_core_dist_hooks_useHover__WEBPACK_IMPORTED_MODULE_4__/* .useHover */ .X)(togglerRef);
    var isMobile = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    // const [tooltipContainerHeight, setTooltipContainerHeight] = useState(0);
    // const [tooltipLines, setTooltipLines] = useState(0);
    var onClickToggler = function() {
        if (!appearOnHover) {
            handlePopupView();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            onClickToggler: onClickToggler
        };
    });
    /**
         * This piece of code is required for future reference will be removed later
         */ // useEffect(() => {
    //     if (tooltipContainerRef.current || elmRef.current) {
    //         const tooltipContainerHeight = appearOnHover
    //             ? tooltipContainerRef.current?.clientHeight
    //             : elmRef.current?.clientHeight;
    //         const tooltipOffsetHeight = appearOnHover
    //             ? tooltipContainerRef.current?.offsetHeight
    //             : elmRef.current?.offsetHeight;
    //         const tooltipLineHeight = appearOnHover
    //             ? tooltipContainerRef.current?.style.lineHeight
    //             : elmRef.current?.style.lineHeight;
    //         setTooltipContainerHeight(tooltipContainerHeight);
    //         setTooltipLines(tooltipOffsetHeight / Number(tooltipLineHeight.split(/(\d+)/)[1]));
    //         console.log(tooltipOffsetHeight / Number(tooltipLineHeight.split(/(\d+)/)[1]), "tooltipLineNumber");
    //     }
    // }, [appearOnHover, elmRef, isHovered]);
    // style={{ ["--tooltipContainer-height" as any]: `${10 / 6}px` }}
    // style={{ top: `-${tooltipContainerHeight + 200}%`, lineHeight: "16px" }}
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tooltipWrapper), wrapperClassName),
        style: wrapperStyle,
        children: [
            (appearOnHover && isHovered && enabled || popupView) && !shouldOpenInBottomSheet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9___default().tooltipContainer), tooltipContainerClassName, (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9___default())[position]),
                ref: !appearOnHover ? elmRef : tooltipContainerRef,
                children: [
                    !appearOnHover && !isCloseIconDisabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9___default().closeIcon),
                        onClick: handlePopupView,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_closeOdc_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    }),
                    tooltipContent ? tooltipContent : fallbackText
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: togglerRef,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Tooltip_module_scss__WEBPACK_IMPORTED_MODULE_9___default().contentWrapper), tooltipTogglerClassName),
                onClick: enabled ? onClickToggler : undefined,
                children: tooltipToggler
            }),
            isMobile && shouldOpenInBottomSheet && popupView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_BottomSheet__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                isOpen: popupView && shouldOpenInBottomSheet,
                onToggle: handlePopupView,
                children: tooltipContent ? tooltipContent : fallbackText
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["default"] = (Tooltip);


/***/ }),

/***/ 947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ performLogoutAndRedirectHome; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8880);
/* harmony import */ var _vahak_core_dist_methods_handleLogout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34025);





function performLogoutAndRedirectHome(_param) {
    return _performLogoutAndRedirectHome.apply(this, arguments);
}
function _performLogoutAndRedirectHome() {
    _performLogoutAndRedirectHome = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
        var router, logoutParams;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    router = _param.router, logoutParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
                        "router"
                    ]);
                    (0,_vahak_core_dist_methods_handleLogout__WEBPACK_IMPORTED_MODULE_2__/* .handleLogout */ .h)(logoutParams);
                    (0,_vahak_core_dist_services_user_analytics_service__WEBPACK_IMPORTED_MODULE_1__/* .moEngageUserLogOut */ .SR)();
                    _ctx.next = 5;
                    return router.replace("/", undefined, {
                        shallow: true,
                        scroll: false
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _performLogoutAndRedirectHome.apply(this, arguments);
}


/***/ }),

/***/ 49765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ExpiryPill; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/marketplace/common/expiry-pill/ExpiryPill.module.scss
var ExpiryPill_module = __webpack_require__(3778);
var ExpiryPill_module_default = /*#__PURE__*/__webpack_require__.n(ExpiryPill_module);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/methods/getTimeDiffMs.js
var getTimeDiffMs = __webpack_require__(55622);
;// CONCATENATED MODULE: ../core/dist/methods/getTimeDiffString.js
function getStr(diffNum, label) {
    const roundVal = Math.round(diffNum);
    return roundVal === 1 ? `${roundVal} ${label}` : `${roundVal} ${label}s`;
}
function getTimeDiffString(t1, t2) {
    const t1Ms = Date.parse(t1);
    const t2Ms = t2 ? Date.parse(t2) : Date.now();
    const diffSecs = (t2Ms - t1Ms) / 1000;
    const min = 60;
    const hour = min * 60;
    const day = hour * 24;
    const week = day * 7;
    const month = day * 30;
    const year = day * 365;
    switch (true) {
        case diffSecs < min:
            return getStr(diffSecs, "Second");
        case diffSecs >= min && diffSecs < hour:
            return getStr(diffSecs / min, "Minute");
        case diffSecs >= hour && diffSecs < day:
            return getStr(diffSecs / hour, "Hour");
        case diffSecs >= day && diffSecs < week:
            return getStr(diffSecs / day, "Day");
        case diffSecs >= week && diffSecs < month:
            return getStr(diffSecs / week, "Week");
        case diffSecs >= month && diffSecs < year:
            return getStr(diffSecs / month, "Month");
        default:
            return getStr(diffSecs / year, "Year");
    }
}


//# sourceMappingURL=getTimeDiffString.js.map

;// CONCATENATED MODULE: ./components/marketplace/constants.ts
var expiryPriority = {
    most: {
        text: "#FF0000",
        background: "#FFE3E3"
    },
    moderate: {
        text: "#002385",
        background: "#D9E9FF"
    },
    least: {
        text: "#E57E00",
        background: "#FFF4D3"
    }
};

;// CONCATENATED MODULE: ./components/marketplace/common/expiry-pill/ExpiryPill.tsx


// Styles


// Helpers


// Constants

var expiryPill = function(param) {
    var expiresClass = param.expiresClass, expiry_time = param.expiry_time, _is_mobile = param.is_mobile, is_mobile = _is_mobile === void 0 ? false : _is_mobile, expiration_hour = param.expiration_hour;
    var renderTime = function(expiry_time) {
        var time = getTimeDiffString(new Date().toISOString(), expiry_time);
        if (parseInt(time) > 0 || expiration_hour && parseInt(expiration_hour) > 0) {
            var timeExpires = (0,getTimeDiffMs/* getTimeDiffMs */.y)(new Date().toISOString(), expiry_time);
            var expirationHours = expiration_hour ? parseInt(expiration_hour) : 0;
            var hours = Math.floor(timeExpires / (1000 * 60 * 60)) || expirationHours;
            var expirationTime = parseInt(time) > 0 ? time : expiration_hour;
            if (hours < 2) return {
                text: "Expires in ".concat(expirationTime),
                styleObj: expiryPriority.most
            };
            else if (hours < 24) return {
                text: "Expires in ".concat(expirationTime),
                styleObj: expiryPriority.moderate
            };
            else return {
                text: "Expires in ".concat(expirationTime),
                styleObj: expiryPriority.least
            };
        } else {
            return {
                text: "Expired",
                styleObj: expiryPriority.most
            };
        }
    };
    var ref = renderTime(expiry_time), text = ref.text, styleObj = ref.styleObj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()(expiresClass, is_mobile ? (ExpiryPill_module_default()).expires_mobile : (ExpiryPill_module_default()).expires_desktop),
        style: {
            backgroundColor: is_mobile ? "transparent" : styleObj.background,
            color: styleObj.text
        },
        children: text
    });
};
/* harmony default export */ var ExpiryPill = (expiryPill);


/***/ }),

/***/ 59604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ share_modal_ShareModal; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/components/app-btn/AppBtn.js + 2 modules
var AppBtn = __webpack_require__(49995);
// EXTERNAL MODULE: ../core/dist/methods/copyToClipboard.js
var copyToClipboard = __webpack_require__(54534);
// EXTERNAL MODULE: ../core/dist/methods/cityStringIncludeParentheses.js
var cityStringIncludeParentheses = __webpack_require__(96281);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ./components/marketplace/common/share-modal/Activation.module.scss
var Activation_module = __webpack_require__(51702);
var Activation_module_default = /*#__PURE__*/__webpack_require__.n(Activation_module);
// EXTERNAL MODULE: ../core/dist/components/search/Search.js + 65 modules
var Search = __webpack_require__(81528);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core/dist/components/search-full-screen-mobile/SearchFullScreenMobile.js + 3 modules
var SearchFullScreenMobile = __webpack_require__(87890);
// EXTERNAL MODULE: ../core/dist/hooks/useSearch.js
var useSearch = __webpack_require__(32099);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/icons/share_blue.svg
var share_blue = __webpack_require__(58352);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ../core/dist/_services/hooks/usePostingService.js
var usePostingService = __webpack_require__(7941);
// EXTERNAL MODULE: ../core/dist/_services/city-search.service.js
var city_search_service = __webpack_require__(20803);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
// EXTERNAL MODULE: ../core/dist/hooks/useToggleModalWithLocalState.js
var useToggleModalWithLocalState = __webpack_require__(73778);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
;// CONCATENATED MODULE: ./components/marketplace/common/share-modal/Activation.tsx






// Styles

// Components




// Hooks

// Context

// Assests

// Services



// Helpers




var Activation = function(param) {
    var activateLorry = param.activateLorry, toggle = param.toggle, src = param.src, setSrc = param.setSrc, data = param.data, lorryInfo = param.lorryInfo, setSearchingOnMobile = param.setSearchingOnMobile, isSharingDisabled = param.isSharingDisabled;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    // Context
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), recentTransporterCitySearches = ref.recentTransporterCitySearches, companyId = ref.companyId, isMobile = ref.isMobile, name = ref.name;
    var ref1 = (0,useToggleModalWithLocalState/* useToggleModalWithLocalState */.A)(false), openModal = ref1.openModal, closeModal = ref1.closeModal, isModalOpen = ref1.isModalOpen;
    var getLastWord = function(text) {
        var n = text.split(" ");
        return n[n.length - 1];
    };
    //Events
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var ref2 = (0,useSearch/* usePlaceSearch */.A)({
        locationParamsOption: {
            source: city_search_service/* LocationSearchSource.LorryPostingSrc */.T5.LorryPostingSrc
        },
        showCurrentLocationOption: true,
        defaultOptions: recentTransporterCitySearches,
        onSelectItem: function(selected) {
            if (selected && selected.length) {
                /**
                     * Events
                     */ sendGAandMoEngageEvent({
                    name: event_names/* GA4EventNames.LORRY_POSTING_MODAL.lorry_form_city_selected */.wQ.LORRY_POSTING_MODAL.lorry_form_city_selected,
                    data: {
                        form_type: "reactivation",
                        vehicle_number: data.lorry_detail.number,
                        lorry_type: data.lorry_detail.type,
                        current_city: selected[0].name,
                        total_route: data.lorry_detail.routes,
                        vehicle_type: data.lorry_detail.lorry_type,
                        capacity: data.lorry_detail.capacity,
                        body_type: data.lorry_detail.body_type,
                        total_tyres: data.lorry_detail.total_tyres
                    }
                });
            }
            if (isMobile) {
                closeModal();
                setSearchingOnMobile && setSearchingOnMobile(false);
            }
            setSrc(selected[0]);
        }
    }), isSearchLoading = ref2.isSearchLoading, labelKey = ref2.labelKey, onItemSelected = ref2.onItemSelected, onSearchInput = ref2.onSearchInput, searchOptions = ref2.searchOptions, searchText = ref2.searchText, onFocus = ref2.onFocus;
    // Hooks
    var ref3 = (0,usePostingService/* useReactivateLorry */.Zd)(), reactivateLorry = ref3.mutateAsync;
    var queryClient = (0,es.useQueryClient)();
    var handleActivation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, currentPlaceID;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (src === null || src === void 0 ? void 0 : src.name) {
                            _ctx.next = 4;
                            break;
                        }
                        toast/* toast.error */.A.error("Select a city before proceeding");
                        return _ctx.abrupt("return");
                    case 4:
                        /**
         * Events
         */ sendGAandMoEngageEvent({
                            name: event_names/* GA4EventNames.LORRY_LISTING.lorry_form_reactivate_click */.wQ.LORRY_LISTING.lorry_form_reactivate_click,
                            data: {
                                form_type: "reactivation",
                                vehicle_number: data.number,
                                lorry_type: data.type,
                                current_city: data.current_city,
                                total_route: (ref = data.routes) === null || ref === void 0 ? void 0 : ref.length,
                                routes: data.routes,
                                vehicle_type: (ref1 = (0,lorryTypes/* getLorryDetailsByType */.X9)(data.type)) === null || ref1 === void 0 ? void 0 : ref1.label,
                                capacity: data.capacity,
                                body_type: null,
                                total_tyres: null,
                                verification_document_type: null
                            }
                        });
                        _ctx.next = 7;
                        return (0,city_search_service/* searchUsingPlacesAPI */.PP)(src === null || src === void 0 ? void 0 : src.name, {
                            source: city_search_service/* LocationSearchSource.LorryPostingSrc */.T5.LorryPostingSrc
                        });
                    case 7:
                        _ctx.t1 = ref2 = _ctx.sent[0];
                        _ctx.t0 = _ctx.t1 === null;
                        if (_ctx.t0) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.t0 = ref2 === void 0;
                    case 11:
                        if (!_ctx.t0) {
                            _ctx.next = 15;
                            break;
                        }
                        _ctx.t2 = void 0;
                        _ctx.next = 16;
                        break;
                    case 15:
                        _ctx.t2 = ref2.place_id;
                    case 16:
                        currentPlaceID = _ctx.t2;
                        reactivateLorry({
                            lorryId: data.lorry_id || data.lorry_detail.id || (lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.id),
                            currentPlaceID: currentPlaceID
                        }, {
                            onSuccess: function(res) {
                                toast/* toast.success */.A.success("Lorry reactivated successfully.");
                                queryClient.invalidateQueries([
                                    queryNames/* QueryNames.userLorries.getLorriesByCategory */._.userLorries.getLorriesByCategory,
                                    companyId,
                                    // @ts-expect-error signature types
                                    lorryTypes/* LorryNameToNumberMap */.R1[(data === null || data === void 0 ? void 0 : data.name) || getLastWord((lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.lorry_type_text) || (data === null || data === void 0 ? void 0 : data.lorry_detail.type))]
                                ]);
                                activateLorry();
                            },
                            onError: function(res) {
                                toast/* toast.error */.A.error(res.message);
                            }
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleActivation() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickCancel = function() {
        toggle();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Activation_module_default()).activation,
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Activation_module_default()).searchDiv,
                onClick: function() {
                    openModal();
                    setSearchingOnMobile && setSearchingOnMobile(true);
                },
                children: src ? src.name : t("share_modal_enter_vehicle_location")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                    isLoading: isSearchLoading,
                    id: "src-search",
                    labelText: "",
                    onSearch: onSearchInput,
                    onSelectItem: onItemSelected,
                    options: searchOptions,
                    labelKey: labelKey,
                    selectedItem: src,
                    searchText: searchText,
                    onFocus: onFocus,
                    placeholder: t("share_modal_enter_vehicle_location"),
                    minLength: 0,
                    containerClassName: (Activation_module_default()).searchContainer
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Activation_module_default()).ctas,
                children: [
                    isMobile && !isSharingDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBtn/* default */.Z, {
                        className: (Activation_module_default()).cancel,
                        fillType: "outline",
                        onClick: onClickCancel,
                        children: t("cancel_btn")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBtn/* default */.Z, {
                        className: (Activation_module_default()).share,
                        onClick: handleActivation,
                        disabled: isSharingDisabled && !src,
                        children: isSharingDisabled ? t("re_activate_lorry") : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(share_blue/* default */.Z, {}),
                                " ",
                                t("share_btn")
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFullScreenMobile/* default */.Z, {
                isLoading: isSearchLoading,
                id: "src-search",
                onSearch: onSearchInput,
                onSelectItem: onItemSelected,
                onFocus: onFocus,
                options: searchOptions,
                labelKey: labelKey,
                selectedItem: src,
                searchText: searchText,
                isVisible: !!isModalOpen,
                onClickBackBtn: function() {
                    setSearchingOnMobile && setSearchingOnMobile(false);
                    closeModal();
                },
                placeholder: t("share_modal_enter_vehicle_location")
            })
        ]
    });
};
/* harmony default export */ var share_modal_Activation = (Activation);

// EXTERNAL MODULE: ./components/marketplace/common/share-modal/ShareModal.module.scss
var ShareModal_module = __webpack_require__(90794);
var ShareModal_module_default = /*#__PURE__*/__webpack_require__.n(ShareModal_module);
// EXTERNAL MODULE: ../core/dist/icons/whatsapp_icon.svg
var whatsapp_icon = __webpack_require__(59644);
;// CONCATENATED MODULE: ../core/dist/icons/FacebookGrey.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgFacebookGrey(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 20"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.25 6.875v-2.5a1.25 1.25 0 011.25-1.25h1.25V0h-2.5A3.75 3.75 0 002.5 3.75v3.125H0V10h2.5v10h3.75V10h2.5L10 6.875z",
    fill: "#80868b"
  })));
}

/* harmony default export */ var FacebookGrey = (SvgFacebookGrey);
// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ./services/sharableShortLink/helper.ts
var helper = __webpack_require__(92508);
// EXTERNAL MODULE: ./components/marketplace/common/share-modal/getLoadLorryShareUrl.ts
var getLoadLorryShareUrl = __webpack_require__(77442);
// EXTERNAL MODULE: ./components/marketplace/common/share-modal/shareApis.ts
var shareApis = __webpack_require__(57271);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
;// CONCATENATED MODULE: ./components/marketplace/common/share-modal/ShareModal.tsx







// Components






// Style

// Assets









var ShareModal = function(_param) {
    var toggle = _param.toggle, isOpen = _param.isOpen, modalTitle = _param.modalTitle, _isCustomLink = _param.isCustomLink, isCustomLink = _isCustomLink === void 0 ? false : _isCustomLink, trackEvent = _param.trackEvent, props = (0,_object_without_properties/* default */.Z)(_param, [
        "toggle",
        "isOpen",
        "modalTitle",
        "isCustomLink",
        "trackEvent"
    ]);
    var referralCode = (0,react.useContext)(app_context/* AppContext */.Il).referralCode;
    var copyLinkURL = props.copyLinkURL, facebookShareText = props.facebookShareText, whatsappShareText = props.whatsappShareText;
    var shareData = props.data, lorryInfo = props.lorryInfo, loadInfo = props.loadInfo, _mktType = props.mktType, mktType = _mktType === void 0 ? "load" : _mktType, _needActivation = props.needActivation, needActivation = _needActivation === void 0 ? false : _needActivation, _isSharingDisabled = props.isSharingDisabled, isSharingDisabled = _isSharingDisabled === void 0 ? false : _isSharingDisabled, onSuccess = props.onSuccess;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)(undefined), url = ref[0], setUrl = ref[1];
    var ref1 = (0,react.useState)(undefined), whatsapptext = ref1[0], setWhatsappText = ref1[1];
    var ref2 = (0,react.useState)(undefined), fbText = ref2[0], setFbText = ref2[1];
    var ref3 = (0,react.useState)(true), isLoadingUrlData = ref3[0], setIsloadingUrlData = ref3[1];
    var ref4 = (0,react.useState)(), src = ref4[0], setSrc = ref4[1];
    var ref5 = (0,react.useState)(false), isShareCtaPressed = ref5[0], setIsShareCtaPressed = ref5[1];
    (0,react.useEffect)(function() {
        if (url && fbText && whatsapptext) {
            setIsloadingUrlData(false);
        } else if (copyLinkURL && whatsappShareText && facebookShareText) {
            setIsloadingUrlData(false);
            setUrl(copyLinkURL);
            setFbText(facebookShareText);
            setWhatsappText(whatsappShareText);
        }
    }, [
        url,
        fbText,
        whatsapptext,
        copyLinkURL,
        whatsappShareText,
        facebookShareText
    ]);
    (0,react.useEffect)(function() {
        if (!shareData && !lorryInfo && !loadInfo) {
            return;
        }
        if (needActivation && !isShareCtaPressed) return;
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, utm_params, link, requestOptions;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        utm_params = mktType === "load" ? "web_load_share" : "web_lorry_share";
                        link = mktType === "load" ? (0,helper/* generateMarketplaceCardLongDynamicLink */.Qd)({
                            mktType: "load",
                            source: (0,cityStringIncludeParentheses/* cityStringIncludeParentheses */.e)((shareData === null || shareData === void 0 ? void 0 : shareData.source) || (shareData === null || shareData === void 0 ? void 0 : shareData.source_text) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref = loadInfo.load_detail) === null || ref === void 0 ? void 0 : ref.source)),
                            destination: (0,cityStringIncludeParentheses/* cityStringIncludeParentheses */.e)((shareData === null || shareData === void 0 ? void 0 : shareData.destination) || (shareData === null || shareData === void 0 ? void 0 : shareData.destination_text) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref1 = loadInfo.load_detail) === null || ref1 === void 0 ? void 0 : ref1.destination)),
                            entityId: (shareData === null || shareData === void 0 ? void 0 : shareData.id) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref2 = loadInfo.load_detail) === null || ref2 === void 0 ? void 0 : ref2.id),
                            oppcmpid: (shareData === null || shareData === void 0 ? void 0 : shareData.oppositeCompanyId) || (shareData === null || shareData === void 0 ? void 0 : shareData.transporter_id) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref3 = loadInfo.load_detail) === null || ref3 === void 0 ? void 0 : ref3.company_id),
                            referralCode: referralCode !== null && referralCode !== void 0 ? referralCode : "",
                            utm_campaign: utm_params,
                            utm_medium: utm_params,
                            utm_source: utm_params
                        }) : (0,helper/* generateMarketplaceCardLongDynamicLink */.Qd)({
                            mktType: "lorry",
                            source: (0,cityStringIncludeParentheses/* cityStringIncludeParentheses */.e)((shareData === null || shareData === void 0 ? void 0 : shareData.source) || (shareData === null || shareData === void 0 ? void 0 : shareData.source_text) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref4 = loadInfo.load_detail) === null || ref4 === void 0 ? void 0 : ref4.source)),
                            destination: (0,cityStringIncludeParentheses/* cityStringIncludeParentheses */.e)((shareData === null || shareData === void 0 ? void 0 : shareData.destination) || (shareData === null || shareData === void 0 ? void 0 : shareData.destination_text) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref5 = loadInfo.load_detail) === null || ref5 === void 0 ? void 0 : ref5.destination)),
                            entityId: (shareData === null || shareData === void 0 ? void 0 : shareData.id) || (lorryInfo === null || lorryInfo === void 0 ? void 0 : lorryInfo.id),
                            oppcmpid: (shareData === null || shareData === void 0 ? void 0 : shareData.oppositeCompanyId) || (shareData === null || shareData === void 0 ? void 0 : shareData.transporter_id) || (loadInfo === null || loadInfo === void 0 ? void 0 : (ref6 = loadInfo.load_detail) === null || ref6 === void 0 ? void 0 : ref6.company_id),
                            referralCode: referralCode !== null && referralCode !== void 0 ? referralCode : "",
                            utm_campaign: utm_params,
                            utm_medium: utm_params,
                            utm_source: utm_params
                        });
                        requestOptions = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                dynamicLinkInfo: {
                                    domainUriPrefix: (0,helper/* getShortLinkBaseUrl */.fh)(),
                                    link: link,
                                    androidInfo: {
                                        androidPackageName: "search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak",
                                        androidFallbackLink: link,
                                        androidMinPackageVersionCode: ""
                                    },
                                    iosInfo: {
                                        iosBundleId: "",
                                        iosFallbackLink: "",
                                        iosCustomScheme: "",
                                        iosIpadFallbackLink: "",
                                        iosIpadBundleId: "",
                                        iosAppStoreId: ""
                                    },
                                    analyticsInfo: {
                                        googlePlayAnalytics: {
                                            utmSource: utm_params,
                                            utmMedium: utm_params,
                                            utmCampaign: utm_params
                                        },
                                        itunesConnectAnalytics: {
                                            at: "",
                                            ct: "",
                                            mt: "",
                                            pt: ""
                                        }
                                    },
                                    socialMetaTagInfo: {
                                        socialTitle: "",
                                        socialDescription: "",
                                        socialImageLink: ""
                                    }
                                },
                                suffix: {
                                    option: "short"
                                }
                            })
                        };
                        fetch(_services_const/* default.GET_SHORT_LINK */.Z.GET_SHORT_LINK + "key=AIzaSyBvHW1U7rzdZp2NQuzpSCFgGy87__ShkfE", requestOptions).then(function(response) {
                            return response.json();
                        }).then(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (!(mktType === "load")) {
                                                _ctx.next = 15;
                                                break;
                                            }
                                            setUrl(data.shortLink);
                                            if (!data.shortLink) {
                                                _ctx.next = 13;
                                                break;
                                            }
                                            _ctx.t0 = setWhatsappText;
                                            _ctx.next = 6;
                                            return (0,getLoadLorryShareUrl/* getLoadShareText */.Oh)(shareData || lorryInfo || loadInfo, false, data.shortLink);
                                        case 6:
                                            _ctx.t1 = _ctx.sent;
                                            (0, _ctx.t0)(_ctx.t1);
                                            _ctx.t2 = setFbText;
                                            _ctx.next = 11;
                                            return (0,getLoadLorryShareUrl/* getLoadShareText */.Oh)(shareData || lorryInfo || loadInfo, false, data.shortLink);
                                        case 11:
                                            _ctx.t3 = _ctx.sent;
                                            (0, _ctx.t2)(_ctx.t3);
                                        case 13:
                                            _ctx.next = 27;
                                            break;
                                        case 15:
                                            setUrl(data.shortLink);
                                            if (!data.shortLink) {
                                                _ctx.next = 27;
                                                break;
                                            }
                                            _ctx.t4 = setWhatsappText;
                                            _ctx.next = 20;
                                            return (0,getLoadLorryShareUrl/* getLorryShareText */.JJ)(shareData || lorryInfo || loadInfo, false, data.shortLink);
                                        case 20:
                                            _ctx.t5 = _ctx.sent;
                                            (0, _ctx.t4)(_ctx.t5);
                                            _ctx.t6 = setFbText;
                                            _ctx.next = 25;
                                            return (0,getLoadLorryShareUrl/* getLorryShareText */.JJ)(shareData || lorryInfo || loadInfo, false, data.shortLink);
                                        case 25:
                                            _ctx.t7 = _ctx.sent;
                                            (0, _ctx.t6)(_ctx.t7);
                                        case 27:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        shareData,
        loadInfo,
        lorryInfo,
        isShareCtaPressed
    ]);
    var onClickCopy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (url) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        (0,copyToClipboard/* copyToClipboard */.v)(url, t("share_modal_link_copied"));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickCopy() {
            return _ref.apply(this, arguments);
        };
    }();
    var activateLorry = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isSharingDisabled) {
                            setIsShareCtaPressed(true);
                        } else {
                            if (onSuccess) onSuccess();
                            else toggle();
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function activateLorry() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
            isOpen: isOpen,
            onToggle: toggle,
            modalSize: "fit",
            titleText: isShareCtaPressed && t("share_lorry") || modalTitle,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ShareModal_module_default()).modalDialog,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ShareModal_module_default()).modalBody,
                    children: needActivation && !isShareCtaPressed && (shareData || lorryInfo || loadInfo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(share_modal_Activation, {
                        data: shareData,
                        lorryInfo: lorryInfo,
                        src: src,
                        setSrc: setSrc,
                        toggle: toggle,
                        activateLorry: activateLorry,
                        isSharingDisabled: isSharingDisabled
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((ShareModal_module_default()).BodyContentWrapper),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((ShareModal_module_default()).copyLinkContainer),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBtn/* default */.Z, {
                                    btnType: "submit",
                                    className: classnames_default()((ShareModal_module_default()).copyLinkButton),
                                    onClick: onClickCopy,
                                    children: !isLoadingUrlData ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ShareModal_module_default()).url,
                                                children: url
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ShareModal_module_default()).btnText,
                                                children: t("share_modal_copy_url")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()((ShareModal_module_default()).socialShareContainer),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()((ShareModal_module_default()).socialMediaShare),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: (ShareModal_module_default()).socialMediaShareCol,
                                            children: !isLoadingUrlData ? t("share_modal_share_it_on") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                                                width: "103px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                            className: (ShareModal_module_default()).socialMediaShareCol,
                                            href: window.navigator.userAgent.toLowerCase().includes("mobile") ? shareApis/* SHARE_APIS.whatsappPhone */.i.whatsappPhone(whatsapptext) : shareApis/* SHARE_APIS.whatsappDesktop */.i.whatsappDesktop(whatsapptext),
                                            openInNewTab: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                onClick: function() {
                                                    trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* LoadScreenEvents.sharedonwhatsapp */.tj.sharedonwhatsapp);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classnames_default()((ShareModal_module_default()).whatsappShare),
                                                        children: !isLoadingUrlData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(whatsapp_icon/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                                                            height: "80px"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        className: (ShareModal_module_default()).socialName,
                                                        children: !isLoadingUrlData ? t("whatsApp") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(A/* default */.Z, {
                                            className: (ShareModal_module_default()).socialMediaShareCol,
                                            href: shareApis/* SHARE_APIS.fb */.i.fb(fbText, url),
                                            openInNewTab: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()((ShareModal_module_default()).facebookShare),
                                                    children: !isLoadingUrlData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookGrey, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {
                                                        height: "80px"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: (ShareModal_module_default()).socialName,
                                                    children: !isLoadingUrlData ? t("facebook") : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton["default"], {})
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var share_modal_ShareModal = (ShareModal);


/***/ }),

/***/ 77442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JJ": function() { return /* binding */ getLorryShareText; },
/* harmony export */   "Oh": function() { return /* binding */ getLoadShareText; },
/* harmony export */   "Pq": function() { return /* binding */ VahakAppDownloadLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14345);
/* harmony import */ var _vahak_core_dist_methods_cityStringIncludeParentheses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96281);




var VahakAppDownloadLink = "https://vahak.page.link/YyZk";
function getLoadShareText(data, isMobile, shortLink) {
    return _getLoadShareText.apply(this, arguments);
}
function _getLoadShareText() {
    _getLoadShareText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, isMobile, shortLink) {
        var ref, ref1, ref2, ref3;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    return _ctx.abrupt("return", "".concat((data === null || data === void 0 ? void 0 : data.source_text) || (data === null || data === void 0 ? void 0 : data.source), " to ").concat((data === null || data === void 0 ? void 0 : data.destination_text) || (data === null || data === void 0 ? void 0 : data.destination), " - ").concat(data === null || data === void 0 ? void 0 : data.quantity, " ").concat((ref = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_1__/* .getLorryDetailsByType */ .X9)((data === null || data === void 0 ? void 0 : data.lorry_type_id) || (data === null || data === void 0 ? void 0 : data.lorry_id))) === null || ref === void 0 ? void 0 : ref.unit, " ").concat((data === null || data === void 0 ? void 0 : data.lorry_type_text) || (data === null || data === void 0 ? void 0 : (ref1 = data.load_details) === null || ref1 === void 0 ? void 0 : ref1.lorry_type_text) || (data === null || data === void 0 ? void 0 : data.lorry_type), " required. *Click the link to Book this load today: ").concat(shortLink, "*%0A%0ARegards,%0A").concat(((ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.name) || (data === null || data === void 0 ? void 0 : data.company_name) || data.transporter_name, "%0A").concat(((ref3 = data.company) === null || ref3 === void 0 ? void 0 : ref3.service_type) || data.company_service_type || "", "%0A%0AConnect %26 Deal with me regularly on Vahak: ").concat(VahakAppDownloadLink));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getLoadShareText.apply(this, arguments);
}
function getLorryShareText(data, isMobile, shortLink) {
    return _getLorryShareText.apply(this, arguments);
}
function _getLorryShareText() {
    _getLorryShareText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, isMobile, shortLink) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    return _ctx.abrupt("return", "".concat((data === null || data === void 0 ? void 0 : (ref = data.lorry_detail) === null || ref === void 0 ? void 0 : ref.type) || data.lorry_type_text || "".concat(data.capacity, " ").concat(data.capacity_unit, " ").concat(data.name), " available in ").concat((0,_vahak_core_dist_methods_cityStringIncludeParentheses__WEBPACK_IMPORTED_MODULE_3__/* .cityStringIncludeParentheses */ .e)(data.current_city_name || (data === null || data === void 0 ? void 0 : (ref1 = data.lorry_detail) === null || ref1 === void 0 ? void 0 : ref1.current_city) || data.current_city), ". *Click the link to Book this lorry today: ").concat(shortLink, "*%0A%0ARegards,%0A").concat(((ref2 = data.company_details) === null || ref2 === void 0 ? void 0 : ref2.name) || data.transporter_name || (data === null || data === void 0 ? void 0 : (ref3 = data.company_detail) === null || ref3 === void 0 ? void 0 : ref3.name) || (data === null || data === void 0 ? void 0 : (ref4 = data.company_details) === null || ref4 === void 0 ? void 0 : ref4.company_name), "%0A").concat(((ref5 = data.company_details) === null || ref5 === void 0 ? void 0 : ref5.service_type) || (data === null || data === void 0 ? void 0 : (ref6 = data.company_detail) === null || ref6 === void 0 ? void 0 : ref6.service_type) || data.company_service_type || "", "%0A%0AConnect %26 Deal with me regularly on Vahak: ").concat(VahakAppDownloadLink));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getLorryShareText.apply(this, arguments);
}


/***/ }),

/***/ 57271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SHARE_APIS; }
/* harmony export */ });
var SHARE_APIS = {
    whatsappDesktop: function(shareText) {
        return "https://web.whatsapp.com/send?text=".concat(shareText);
    },
    whatsappPhone: function(shareText) {
        return "whatsapp://send?text=".concat(shareText);
    },
    fb: function(shareText, url) {
        return "https://www.facebook.com/share.php?u=".concat(url, "&quote=").concat(shareText);
    },
    twitter: function(shareText, url) {
        return "https://www.twitter.com/share?text=".concat(shareText, "%0A&url=").concat(url);
    },
    email: function(shareText, url, title) {
        return "mailto:?subject=".concat(title, "&body=").concat(shareText, "%0A").concat(url);
    },
    linkedIn: function(shareText, url) {
        return "https://www.linkedin.com/shareArticle?mini=true?summary=".concat(shareText, "&url=").concat(url);
    }
};


/***/ }),

/***/ 12426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _vahak_core_ui_dist_components_Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93834);
/* harmony import */ var _VerifiedPill_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28791);
/* harmony import */ var _VerifiedPill_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_VerifiedPill_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var VerifiedPill = function(param) {
    var onClick = param.onClick, isTapNgoVerified = param.isTapNgoVerified, isSpotLoad = param.isSpotLoad;
    var _text = "";
    if (isTapNgoVerified || isSpotLoad) {
        _text = "Vahak Assured";
    }
    return !!_text ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: "orange",
        onClick: onClick,
        filled: true,
        fillColor: "transparent",
        size: "small",
        radius: "16px",
        padded: false,
        children: _text
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_VerifiedPill_module_scss__WEBPACK_IMPORTED_MODULE_2___default().verified),
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_VerifiedPill_module_scss__WEBPACK_IMPORTED_MODULE_2___default().verifiedText),
            children: "Verified"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VerifiedPill);


/***/ }),

/***/ 92659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ callback_request_CallbackRequest; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63397);
// EXTERNAL MODULE: ../../node_modules/yup/index.esm.js
var index_esm = __webpack_require__(48601);
// EXTERNAL MODULE: ../core-ui/dist/components/TextArea/index.js
var TextArea = __webpack_require__(50951);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/Button.js + 1 modules
var Button = __webpack_require__(48126);
// EXTERNAL MODULE: ../core-ui/dist/components/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(50116);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(53796);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ./components/misc/callback-request/callback-request-form/CallbackRequestForm.module.scss
var CallbackRequestForm_module = __webpack_require__(53146);
var CallbackRequestForm_module_default = /*#__PURE__*/__webpack_require__.n(CallbackRequestForm_module);
// EXTERNAL MODULE: ../core/dist/components/flat-input/FlatInput.js
var FlatInput = __webpack_require__(93902);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/_services/index.js + 6 modules
var _services = __webpack_require__(96122);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ./utils/form/index.ts
var utils_form = __webpack_require__(2198);
// EXTERNAL MODULE: ../core/dist/constants/regex.js
var regex = __webpack_require__(14263);
;// CONCATENATED MODULE: ./components/misc/callback-request/callback-request-form/CallbackRequestForm.tsx












// Styles







var CallBackReason;
(function(CallBackReason) {
    CallBackReason["LOAD_HELP"] = "How to book a load";
    CallBackReason["LORRY_HELP"] = "How to book a lorry";
    CallBackReason["OTHER"] = "Other";
})(CallBackReason || (CallBackReason = {}));
var reason = Object.values(CallBackReason).map(function(key) {
    return {
        label: key,
        value: key
    };
});
var CallbackRequestForm = function(param) {
    var onSubmit = param.onSubmit, onClose = param.onClose, _sourceScreen = param.sourceScreen, sourceScreen = _sourceScreen === void 0 ? "" : _sourceScreen;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), phoneNum = ref.phoneNum, userId = ref.userId, companyId = ref.companyId;
    var formInit = {
        phone: String(!!userId ? phoneNum : ""),
        reason: "",
        reasonText: ""
    };
    var formFieldNames = (0,utils_form/* generateFormFieldNames */.l)(formInit);
    var helpRequestService = (0,_services/* useHelpRequestTicket */.YK)();
    var _obj;
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: formInit,
        validateOnChange: true,
        validateOnMount: true,
        onSubmit: function() {},
        validationSchema: index_esm/* object */.Ry((_obj = {}, (0,_define_property/* default */.Z)(_obj, formFieldNames.reasonText, index_esm/* string */.Z_().required()), (0,_define_property/* default */.Z)(_obj, formFieldNames.phone, index_esm/* string */.Z_().required().matches(regex/* phoneRegExp */.Oj)), _obj))
    });
    var handleReasonChange = function(e) {
        formik.setFieldValue(formFieldNames.reason, e.target.value);
        var needReasonText = e.target.value !== CallBackReason.OTHER;
        formik.setFieldValue(formFieldNames.reasonText, needReasonText ? e.target.value : "");
    };
    var onChangeInput = function(e) {
        var value = e.target.value;
        if (e.target.name === formFieldNames.phone) {
            formik.setFieldValue(e.target.name, value.slice(0, 10));
        } else {
            formik.setFieldValue(e.target.name, value);
        }
    };
    var handleCallMeBackRequest = function() {
        var _values = formik.values, phone = _values.phone, reasonText = _values.reasonText, reason = _values.reason;
        helpRequestService.mutate({
            company_id: Number(companyId),
            issue: reasonText,
            topic: "other",
            source_screen: sourceScreen
        }, {
            onSuccess: function(response) {
                var ref;
                if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.ticket_id) {
                    var ref1;
                    var ref2;
                    toast/* toast.success */.A.success((ref2 = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref2 !== void 0 ? ref2 : "");
                }
                onSubmit(reasonText, reason);
            },
            onError: function(error) {
                var ref;
                toast/* toast.error */.A.error((ref = error === null || error === void 0 ? void 0 : error.message) !== null && ref !== void 0 ? ref : "Something went wrong!");
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CallbackRequestForm_module_default()).mainWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                size: "m",
                color: colors/* default.GREY_600 */.Z.GREY_600,
                children: "You will receive a Call back from our Customer Care Executives within 24 hours"
            }),
            !!formInit.phone ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                children: [
                    "Phone Number :\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        weight: "bold",
                        children: [
                            "+91-",
                            String(formInit.phone).replace("+91", ""),
                            " "
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((CallbackRequestForm_module_default()).inputWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatInput/* default */.Z, {
                    name: formFieldNames.phone,
                    type: "number",
                    value: formik.values[formFieldNames.phone],
                    onChange: onChangeInput,
                    labelText: "Enter your mobile number",
                    valuePrefix: "+91 - "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        groupLabel: "Tell us your reason to request the Call back",
                        value: formik.values[formFieldNames.reason],
                        name: formFieldNames.reason,
                        option: reason,
                        onChange: handleReasonChange,
                        direction: "row",
                        gap: 5,
                        wrap: true,
                        required: true,
                        id: "callback-reason"
                    }),
                    formik.values[formFieldNames.reason] === CallBackReason.OTHER ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                        value: formik.values[formFieldNames.reasonText],
                        name: formFieldNames.reasonText,
                        onChange: onChangeInput,
                        placeholder: "Enter reason"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                justifyContent: "flex-end",
                gap: 20,
                margin: "20px 0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "secondary",
                        fillType: "outlined",
                        width: 120,
                        onClick: onClose,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: 120,
                        onClick: handleCallMeBackRequest,
                        disabled: !formik.isValid,
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var callback_request_form_CallbackRequestForm = (CallbackRequestForm);

// EXTERNAL MODULE: ./components/misc/callback-request/CallbackRequest.module.scss
var CallbackRequest_module = __webpack_require__(86668);
var CallbackRequest_module_default = /*#__PURE__*/__webpack_require__.n(CallbackRequest_module);
// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
;// CONCATENATED MODULE: ./components/misc/callback-request/CallbackRequest.tsx






// Style


var CallbackRequest = function(param) {
    var toggleButton = param.toggleButton, className = param.className, type = param.type, isCallbackRequestPopupVisible = param.isCallbackRequestPopupVisible, toggleCallBackRequestModal = param.toggleCallBackRequestModal, onSubmit = param.onSubmit, sourceScreen = param.sourceScreen, trackOnClose = param.trackOnClose, trackOnCancelled = param.trackOnCancelled;
    var loginCheck = (0,useValidateUserStatus/* default */.Z)().loginCheck;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            toggleButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                className: classnames_default()((CallbackRequest_module_default()).toggleButton, className),
                onClick: function() {
                    return loginCheck("none", toggleCallBackRequestModal);
                },
                children: toggleButton
            }),
            isCallbackRequestPopupVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
                isOpen: isCallbackRequestPopupVisible,
                onToggle: function() {
                    toggleCallBackRequestModal();
                    trackOnClose === null || trackOnClose === void 0 ? void 0 : trackOnClose();
                },
                titleText: "Request a Call back",
                modalSize: "fit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(callback_request_form_CallbackRequestForm, {
                    onSubmit: onSubmit,
                    type: type,
                    onClose: function() {
                        toggleCallBackRequestModal();
                        trackOnCancelled === null || trackOnCancelled === void 0 ? void 0 : trackOnCancelled();
                    },
                    sourceScreen: sourceScreen
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
};
/* harmony default export */ var callback_request_CallbackRequest = (CallbackRequest);


/***/ }),

/***/ 40932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KV": function() { return /* binding */ ClearAppCookiesAndLogoutFlutterPage; },
  "ce": function() { return /* binding */ GotBackToPreviousFlutterPage; }
});

// UNUSED EXPORTS: FlutterGetGpsLocation, FlutterOpenCamera

// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
;// CONCATENATED MODULE: ./methods/getCookieByName.ts
var getCookieByName = function(cookieName) {
    if (true) {
        var name = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == " "){
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
};

;// CONCATENATED MODULE: ./components/mobile-app/mobileAppFunctions.js


var isReqFromFlutter = getCookieByName(misc/* COOKIES.fromFlutterApp */.E9.fromFlutterApp) === "true" ? true : false;
function GotBackToPreviousFlutterPage(message) {
    if (isReqFromFlutter) BackClickWebViewEvent.postMessage(message);
}
function ClearAppCookiesAndLogoutFlutterPage(message) {
    if (isReqFromFlutter) LogoutWebViewEvent.postMessage(message);
}
function FlutterOpenCamera(title, isFrontCamera) {
    if (isReqFromFlutter) OpenCamera.postMessage(JSON.stringify({
        title: title,
        front: isFrontCamera
    }));
}
function FlutterGetGpsLocation(title) {
    if (isReqFromFlutter) GetGPSLocation.postMessage(title);
}


/***/ }),

/***/ 6330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_components_Chip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93834);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94897);






var PostingChip = function(_param) {
    var active = _param.active, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "active"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Chip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        radius: 44,
        outlined: true
    }, active ? {
        filled: true,
        fillColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BLUE_100 */ .Z.BLUE_100,
        outlineColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BLUE */ .Z.BLUE,
        fontColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BLUE */ .Z.BLUE
    } : {
        filled: false,
        fillColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].GREY_200 */ .Z.GREY_200,
        outlineColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].GREY_200 */ .Z.GREY_200,
        fontColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].GREY_700 */ .Z.GREY_700
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (PostingChip);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BH": function() { return /* binding */ LORRY_POSTING_FORM_LABELS; },
/* harmony export */   "EQ": function() { return /* binding */ initialLorryCreationFormValues; },
/* harmony export */   "FG": function() { return /* binding */ LOAD_POSTING_FORM_LABELS; },
/* harmony export */   "JK": function() { return /* binding */ LCV_DEFAULT_TYRE_COUNT; },
/* harmony export */   "KP": function() { return /* binding */ lorryCreationFormFieldNames; },
/* harmony export */   "Ks": function() { return /* binding */ initialLorryFieldFormValues; },
/* harmony export */   "RT": function() { return /* binding */ LOAD_CREATION_FORM_GROUP; },
/* harmony export */   "XT": function() { return /* binding */ commonLorryFormFieldNames; },
/* harmony export */   "jU": function() { return /* binding */ LORRY_CREATION_FORM_IDS; },
/* harmony export */   "n_": function() { return /* binding */ LORRY_CREATION_FORM_GROUP; },
/* harmony export */   "tG": function() { return /* binding */ resolveLoadPostTotalTyres; },
/* harmony export */   "vW": function() { return /* binding */ loadCreationFormFieldNames; },
/* harmony export */   "vf": function() { return /* binding */ initialLoadCreationFormValues; },
/* harmony export */   "y5": function() { return /* binding */ LOAD_CREATION_FORM_IDS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);
/* harmony import */ var _utils_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2198);
/* harmony import */ var _lorry_posting_lorry_posting_form_fields_vehicle_route_SelectedRouterInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56427);





var LORRY_POSTING_FORM_LABELS;
(function(LORRY_POSTING_FORM_LABELS) {
    LORRY_POSTING_FORM_LABELS["VEHICLE_DETAILS"] = "Vehicle Details";
    LORRY_POSTING_FORM_LABELS["VEHICLE_TYPE"] = "Vehicle Type";
    LORRY_POSTING_FORM_LABELS["VEHICLE_ROUTES_SELECTION"] = "Vehicle Routes";
    LORRY_POSTING_FORM_LABELS["LORRY_POSTED_SUCCESSFULLY"] = "Lorry Posted Successfully";
})(LORRY_POSTING_FORM_LABELS || (LORRY_POSTING_FORM_LABELS = {}));
var LORRY_CREATION_FORM_IDS;
(function(LORRY_CREATION_FORM_IDS) {
    LORRY_CREATION_FORM_IDS["VEHICLE_NUMBER"] = "vehicle_number";
    LORRY_CREATION_FORM_IDS["VERIFY_VEHICLE"] = "verify_vehicle";
    LORRY_CREATION_FORM_IDS["VERIFY_VEHICLE_FAILED"] = "verify_vehicle_failed";
    LORRY_CREATION_FORM_IDS["VEHICLE_TYPE"] = "vehicle_type";
    LORRY_CREATION_FORM_IDS["VEHICLE_ROUTES_SELECTION"] = "vehicle_routes_selection";
    LORRY_CREATION_FORM_IDS["LORRY_POSTED_SUCCESSFULLY"] = "lorry_posted_successfully";
})(LORRY_CREATION_FORM_IDS || (LORRY_CREATION_FORM_IDS = {}));
var LORRY_CREATION_FORM_GROUP;
(function(LORRY_CREATION_FORM_GROUP) {
    LORRY_CREATION_FORM_GROUP["VEHICLE_DETAILS"] = "Vehicle Details";
})(LORRY_CREATION_FORM_GROUP || (LORRY_CREATION_FORM_GROUP = {}));
/** Default tyre count for LCV when tyre selection is not shown. */ var LCV_DEFAULT_TYRE_COUNT = 4;
/** LCV tyre UI is removed — load APIs still expect total_tyres (default 4). */ function resolveLoadPostTotalTyres(lorryType, lorryTyres) {
    if (lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV) {
        return lorryTyres && lorryTyres > 0 ? lorryTyres : LCV_DEFAULT_TYRE_COUNT;
    }
    return lorryTyres || 0;
}
var initialLorryFieldFormValues = {
    vehicleBody: null,
    lorryType: 0,
    isLorryCapacityRequired: true,
    lorryCapacity: 0,
    lorryBodyType: null,
    lorrySize: 0,
    lorrySizeNoPreference: false,
    lorryTyres: 0,
    sizeText: "",
    showCapacityField: false,
    allowedCapacityMin: undefined,
    allowedCapacityMax: undefined,
    allowedVehicleList: undefined
};
var commonLorryFormFieldNames = (0,_utils_form__WEBPACK_IMPORTED_MODULE_2__/* .generateFormFieldNames */ .l)(initialLorryFieldFormValues);
var initialLorryCreationFormValues = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    lorryNum: "",
    currentCityPlaceId: "",
    currentCityText: "",
    currentCityOption: undefined,
    routeIds: [],
    rcDocument: undefined,
    rcExpired: false,
    isRcUploadRequired: false,
    priceDestinations: [
        _lorry_posting_lorry_posting_form_fields_vehicle_route_SelectedRouterInfo__WEBPACK_IMPORTED_MODULE_1__/* .AnyDestinationOption */ .g === null || _lorry_posting_lorry_posting_form_fields_vehicle_route_SelectedRouterInfo__WEBPACK_IMPORTED_MODULE_1__/* .AnyDestinationOption */ .g === void 0 ? void 0 : _lorry_posting_lorry_posting_form_fields_vehicle_route_SelectedRouterInfo__WEBPACK_IMPORTED_MODULE_1__/* .AnyDestinationOption.value */ .g.value
    ]
}, initialLorryFieldFormValues);
var lorryCreationFormFieldNames = (0,_utils_form__WEBPACK_IMPORTED_MODULE_2__/* .generateFormFieldNames */ .l)(initialLorryCreationFormValues);
var LOAD_POSTING_FORM_LABELS;
(function(LOAD_POSTING_FORM_LABELS) {
    LOAD_POSTING_FORM_LABELS["LOAD_DETAILS"] = "Load Details";
    LOAD_POSTING_FORM_LABELS["VEHICLE_TYPE"] = "Vehicle Details";
    LOAD_POSTING_FORM_LABELS["PAYMENT_DETAILS"] = "Payment Details";
})(LOAD_POSTING_FORM_LABELS || (LOAD_POSTING_FORM_LABELS = {}));
var LOAD_CREATION_FORM_IDS;
(function(LOAD_CREATION_FORM_IDS) {
    LOAD_CREATION_FORM_IDS["LOAD_LOCATION_DETAILS"] = "load_locations_details";
    LOAD_CREATION_FORM_IDS["LOAD_INFO"] = "load_info";
    LOAD_CREATION_FORM_IDS["VEHICLE_TYPE"] = "vehicle_type";
    LOAD_CREATION_FORM_IDS["PAYMENT_DETAILS"] = "payment_details";
    LOAD_CREATION_FORM_IDS["ADVANCE_AMOUNT"] = "advance_amount";
    LOAD_CREATION_FORM_IDS["LOAD_POSTED_SUCCESSFULLY"] = "load_post_success";
})(LOAD_CREATION_FORM_IDS || (LOAD_CREATION_FORM_IDS = {}));
var LOAD_CREATION_FORM_GROUP;
(function(LOAD_CREATION_FORM_GROUP) {
    LOAD_CREATION_FORM_GROUP["LOAD_DETAILS"] = "Location & Material details";
    LOAD_CREATION_FORM_GROUP["PAYMENT_DETAILS"] = "Payment Details";
})(LOAD_CREATION_FORM_GROUP || (LOAD_CREATION_FORM_GROUP = {}));
var initialLoadCreationFormValues = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialLorryFieldFormValues), {
    srcPlaceId: "",
    destPlaceId: "",
    srcText: "",
    destText: "",
    material: "",
    quantity: undefined,
    quantityType: "Tonne(s)",
    expectedAmount: undefined,
    isNegotiable: false,
    paymentType: 1,
    isFixedPrice: true,
    advanceAmount: undefined,
    remarks: "",
    is_odc: false,
    length: undefined,
    breadth: undefined,
    height: undefined,
    loadingTimestamp: undefined,
    postedTime: undefined,
    isExpectedAmountMandatory: true,
    savedDestPlaceInfo: undefined,
    savedSrcPlaceInfo: undefined,
    minExpectedPrice: undefined,
    // recommendedPriceMin: undefined,
    // recommendedPriceMax: undefined,
    rcExpired: false,
    isLorryCapacityRequired: false,
    source_id: undefined,
    destination_id: undefined,
    isSpotLoad: false,
    isTapNgoLoad: false,
    loadGhostingPenaltyDeduction: false,
    showLoadGhostingPaymentBanner: false,
    savedWaypointsPlaceInfo: undefined,
    stopPoints: undefined,
    selectedLorryType: undefined,
    loadOwnerCompanyId: 0
});
var loadCreationFormFieldNames = (0,_utils_form__WEBPACK_IMPORTED_MODULE_2__/* .generateFormFieldNames */ .l)(initialLoadCreationFormValues);


/***/ }),

/***/ 61838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ lorryValidationSchema; },
/* harmony export */   "P": function() { return /* binding */ lorryTypeValidation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87394);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48601);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40607);






/**
 * We have not added hardcore validations like if the container is a 32 ft sxl then
 * capacity can only be 7,8,9 tonne because we don't have an open field.
 *
 * Backend validations should be there.
 *
 *
 * rcDocument is disabled as in app its not mandatory field
 */ var isLoadForm = function(option) {
    var ref;
    return (option === null || option === void 0 ? void 0 : (ref = option.parent) === null || ref === void 0 ? void 0 : ref.formSource) === "load";
};
var _obj;
var lorryValidationSchema = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.rcDocument */ .KP.rcDocument, yup__WEBPACK_IMPORTED_MODULE_1__/* .mixed */ .nK().when("isRcUploadRequired", {
    is: true,
    then: function(schema) {
        return schema.required("Required");
    },
    otherwise: function(schema) {
        return schema.notRequired();
    }
})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryType */ .KP.lorryType, yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().positive("Lorry type is required!")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryCapacity */ .KP.lorryCapacity, yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().when([
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryType */ .KP.lorryType,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.allowedCapacityMin */ .KP.allowedCapacityMin,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.allowedCapacityMax */ .KP.allowedCapacityMax,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.allowedVehicleList */ .KP.allowedVehicleList
], function(param, schema) {
    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 4), lorryType = _param[0], allowedCapacityMin = _param[1], allowedCapacityMax = _param[2], allowedVehicleList = _param[3];
    var ref, ref1;
    var selectedLorry = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryType, "lorry", {
        srcList: allowedVehicleList
    });
    // Admin/CS new-user restriction sets allowedCapacity*; always intersect with those bounds.
    var requiredMin = allowedCapacityMin !== null && allowedCapacityMin !== void 0 ? allowedCapacityMin : _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .NEW_LORRY_CAPACITY.LORRY_POST.min */ .QZ.LORRY_POST.min;
    var requiredMax = allowedCapacityMax !== null && allowedCapacityMax !== void 0 ? allowedCapacityMax : _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .NEW_LORRY_CAPACITY.LORRY_POST.max */ .QZ.LORRY_POST.max;
    var ref2;
    var min = Math.max((ref2 = selectedLorry === null || selectedLorry === void 0 ? void 0 : (ref = selectedLorry.capacity) === null || ref === void 0 ? void 0 : ref.min) !== null && ref2 !== void 0 ? ref2 : requiredMin, requiredMin);
    var ref3;
    var max = Math.min((ref3 = selectedLorry === null || selectedLorry === void 0 ? void 0 : (ref1 = selectedLorry.capacity) === null || ref1 === void 0 ? void 0 : ref1.max) !== null && ref3 !== void 0 ? ref3 : requiredMax, requiredMax);
    var rangeText = "".concat(min, "-").concat(max);
    return schema.when(_constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.isLorryCapacityRequired */ .KP.isLorryCapacityRequired, {
        is: true,
        then: function() {
            if (min > max) {
                return yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().typeError("Please enter a valid number").test("capacity-not-supported", "This vehicle capacity is not supported", function() {
                    return false;
                }).required("Lorry Capacity is required field");
            }
            return yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().typeError("Please enter a valid number").min(min, "Invalid capacity (Range: ".concat(rangeText, ")")).max(max, "Invalid capacity (Range: ".concat(rangeText, ")")).required("Lorry Capacity is required field");
        },
        otherwise: function() {
            return yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().nullable();
        }
    });
})), // [lorryCreationFormFieldNames.lorryCapacity]: Yup.number().when(
//     [
//         lorryCreationFormFieldNames.lorryType,
//         lorryCreationFormFieldNames.lorryTyres,
//         lorryCreationFormFieldNames.lorrySize,
//         lorryCreationFormFieldNames.sizeText
//     ],
//     (...args: any) => {
//         const [lorryType, lorryTyres, lorrySize, lorrySizeText, _, option] = args;
//         /**
//          * Lorry Capacity is present in all except in Trailer
//          */
//         const selectedLorry = _NEW_LORRY_TYPES.filter((x) => x.id === lorryType)[0];
//         const isTruck = lorryType === LORRY_CATEGORIES_ENUM.TRUCK;
//         const isContainer = lorryType === LORRY_CATEGORIES_ENUM.CONTAINER;
//         const isTrailer = lorryType === LORRY_CATEGORIES_ENUM.TRAILER;
//         const isLcv = lorryType === LORRY_CATEGORIES_ENUM.LCV;
//         const isHyva = lorryType === LORRY_CATEGORIES_ENUM.HYVA;
//         const isTanker = lorryType === LORRY_CATEGORIES_ENUM.TANKER;
//         let selectedLorryCapacity;
//         let selectedLorryCapacityText = selectedLorry ? selectedLorry.capacityText : undefined;
//         if (isTruck) {
//             const lorry = selectedLorry?.tyreWithCapacity?.find((x) => x.id === lorryTyres);
//             selectedLorryCapacity = lorry?.capacity;
//             selectedLorryCapacityText = lorry?.capacityText;
//         } else if (isContainer) {
//             const lorry = selectedLorry?.bodyTypeWithCapacity?.find(
//                 (x) => x.id === getContainerSizeEnum(lorrySize, lorrySizeText)
//             );
//             selectedLorryCapacity = lorry?.capacity;
//             selectedLorryCapacityText = lorry?.capacityText;
//         } else if (isTrailer) {
//             const lorry = selectedLorry?.bodyTypeWithCapacity?.find(
//                 (x) => x.id === getTrailerBodyEnum(lorrySize, lorrySizeText)
//             );
//             selectedLorryCapacity = lorry?.capacity;
//             selectedLorryCapacityText = lorry?.capacityText;
//         } else if (isLcv) {
//             const lorry = selectedLorry?.bodyTypeWithCapacity?.find((x) => x.id === getLcvSizeEnum(lorrySize));
//             selectedLorryCapacity = lorry?.capacity;
//             selectedLorryCapacityText = lorry?.capacityText;
//         } else if (isHyva) {
//             const lorry = selectedLorry?.tyreWithCapacity?.find((x) => x.id === lorryTyres);
//             selectedLorryCapacity = lorry?.capacity;
//             selectedLorryCapacityText = lorry?.capacityText;
//         } else if (isTanker) {
//             const lorry = selectedLorry?.tyreWithCapacity?.find((x) => x.id === lorryTyres);
//             selectedLorryCapacity = lorry?.capacity;
//             selectedLorryCapacityText = lorry?.capacityText;
//         }
//         if (lorryType !== LORRY_CATEGORIES_ENUM.TRAILER)
//             return Yup.number().when([lorryCreationFormFieldNames.isLorryCapacityRequired], {
//                 is: true,
//                 then: selectedLorryCapacity
//                     ? Yup.number()
//                           .typeError("Please enter a valid number")
//                           .min(selectedLorryCapacity.min, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
//                           .max(selectedLorryCapacity.max, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
//                           .required("Lorry Capacity is required field")
//                     : Yup.number()
//                           .typeError("Please enter a valid number")
//                           .min(1, `Lorry Capacity can't be less than 1`)
//                           .max(100, `Lorry Capacity can't be more than 100`)
//                           .required("Lorry Capacity is required field")
//             });
//         else
//             return Yup.number().when([lorryCreationFormFieldNames.isLorryCapacityRequired], {
//                 is: true,
//                 then: selectedLorryCapacity
//                     ? Yup.number()
//                           .typeError("Please enter a valid number")
//                           .min(selectedLorryCapacity.min, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
//                           .max(selectedLorryCapacity.max, `Invalid capacity (Range: ${selectedLorryCapacityText})`)
//                           .required("Lorry Capacity is required field")
//                     : Yup.number()
//                           .typeError("Please enter a valid number")
//                           .min(1, `Lorry Capacity can't be less than 1`)
//                           .max(100, `Lorry Capacity can't be more than 100`)
//                           .required("Lorry Capacity is required field")
//             });
//     }
// ),
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryTyres */ .KP.lorryTyres, yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().when([
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryType */ .KP.lorryType
], function(values, schema) {
    var _values = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values, 1), lorryType = _values[0];
    /**
             * Lorry Tyres are only present in Truck, Hyva and Tanker (not LCV).
             */ if (lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRUCK */ .Sv.TRUCK || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.HYVA */ .Sv.HYVA || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TANKER */ .Sv.TANKER) return schema.positive("Tyres should be present");
    else return schema;
})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorrySize */ .KP.lorrySize, yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().when([
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryType */ .KP.lorryType,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryTyres */ .KP.lorryTyres,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryCapacity */ .KP.lorryCapacity,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorrySizeNoPreference */ .KP.lorrySizeNoPreference
], function(values, schema) {
    var ref, ref1, ref2, ref3;
    var _values = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values, 4), lorryType = _values[0], lorryTyres = _values[1], lorryCapacity = _values[2], lorrySizeNoPreference = _values[3];
    var vehicleInfo = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryType, "lorry");
    var isTruckSizeAvailable = !!(vehicleInfo === null || vehicleInfo === void 0 ? void 0 : (ref = vehicleInfo.getSizeOptionsByTyre) === null || ref === void 0 ? void 0 : (ref1 = ref.call(vehicleInfo, lorryTyres)) === null || ref1 === void 0 ? void 0 : ref1.length);
    var isLcvSizeAvailable = !!(vehicleInfo === null || vehicleInfo === void 0 ? void 0 : (ref2 = vehicleInfo.getSizeOptionsByCapacity) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(vehicleInfo, Number(lorryCapacity))) === null || ref3 === void 0 ? void 0 : ref3.length);
    if (lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRUCK */ .Sv.TRUCK && isTruckSizeAvailable) {
        return schema.positive("Lorry Size should be present");
    } else if (lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV && isLcvSizeAvailable && !lorrySizeNoPreference) {
        return schema.positive("Lorry Size should be present");
    } else if (lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.CONTAINER */ .Sv.CONTAINER || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRAILER */ .Sv.TRAILER) {
        return schema.positive("Lorry Size should be present");
    } else return schema;
})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryBodyType */ .KP.lorryBodyType, yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx().when(_constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryType */ .KP.lorryType, function(values, schema) {
    var lorryType = values;
    var selectedLorry = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryType, "lorry");
    var allowedTypes = [
        _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV,
        _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRUCK */ .Sv.TRUCK,
        _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TANKER */ .Sv.TANKER
    ];
    if (!allowedTypes.includes(lorryType)) {
        return schema.nullable();
    }
    return schema.typeError("Please enter a valid number").test("valid-body-type", "Invalid body type", function(value) {
        var ref;
        return !!(selectedLorry === null || selectedLorry === void 0 ? void 0 : (ref = selectedLorry.bodyOptions) === null || ref === void 0 ? void 0 : ref.some(function(body) {
            return body.id === value;
        }));
    });
})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.sizeText */ .KP.sizeText, yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().when([
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryType */ .KP.lorryType,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryTyres */ .KP.lorryTyres,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorryCapacity */ .KP.lorryCapacity,
    _constants__WEBPACK_IMPORTED_MODULE_2__/* .lorryCreationFormFieldNames.lorrySizeNoPreference */ .KP.lorrySizeNoPreference
], function(values, schema) {
    var ref, ref1, ref2, ref3;
    var _values = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(values, 4), lorryType = _values[0], lorryTyres = _values[1], lorryCapacity = _values[2], lorrySizeNoPreference = _values[3];
    var vehicleInfo = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getVehicleInfoByLorryType */ .sB)(lorryType, "lorry");
    var isTruckSizeAvailable = !!(vehicleInfo === null || vehicleInfo === void 0 ? void 0 : (ref = vehicleInfo.getSizeOptionsByTyre) === null || ref === void 0 ? void 0 : (ref1 = ref.call(vehicleInfo, lorryTyres)) === null || ref1 === void 0 ? void 0 : ref1.length);
    var isLcvSizeAvailable = !!(vehicleInfo === null || vehicleInfo === void 0 ? void 0 : (ref2 = vehicleInfo.getSizeOptionsByCapacity) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(vehicleInfo, Number(lorryCapacity))) === null || ref3 === void 0 ? void 0 : ref3.length);
    var shouldRequireSize = lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.CONTAINER */ .Sv.CONTAINER || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRAILER */ .Sv.TRAILER || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.TRUCK */ .Sv.TRUCK && isTruckSizeAvailable || lorryType === _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .LORRY_CATEGORIES_ENUM.LCV */ .Sv.LCV && isLcvSizeAvailable && !lorrySizeNoPreference;
    return shouldRequireSize ? schema.required("Size text is required") : schema.notRequired();
})), _obj);
var lorryTypeValidation = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry().shape((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, lorryValidationSchema));


/***/ }),

/***/ 14981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ lorryFormValidations; }
/* harmony export */ });
/* unused harmony export lorryNumValidation */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_constants_regex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14263);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48601);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40607);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61838);



var ref;




var lorryNumValidation = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_1__/* .lorryCreationFormFieldNames.lorryNum */ .KP.lorryNum, yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(_vahak_core_dist_constants_regex__WEBPACK_IMPORTED_MODULE_4__/* .LorryNumRegExp */ ._N, "Please enter a valid Lorry Number").min(7, "Please enter a valid Lorry Number").max(11, "Please enter a valid Lorry Number").required("Lorry number is required!"));
var _obj, _obj1;
var lorryFormValidations = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, _constants__WEBPACK_IMPORTED_MODULE_1__/* .LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */ .jU.VEHICLE_NUMBER, yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, lorryNumValidation))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, _constants__WEBPACK_IMPORTED_MODULE_1__/* .LORRY_CREATION_FORM_IDS.VEHICLE_TYPE */ .jU.VEHICLE_TYPE, yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _common__WEBPACK_IMPORTED_MODULE_2__/* .lorryValidationSchema */ .M))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, _constants__WEBPACK_IMPORTED_MODULE_1__/* .LORRY_CREATION_FORM_IDS.VEHICLE_ROUTES_SELECTION */ .jU.VEHICLE_ROUTES_SELECTION, yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry().shape((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _common__WEBPACK_IMPORTED_MODULE_2__/* .lorryValidationSchema */ .M), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_1__/* .lorryCreationFormFieldNames.currentCityText */ .KP.currentCityText, yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("Current location is required!")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _constants__WEBPACK_IMPORTED_MODULE_1__/* .lorryCreationFormFieldNames.priceDestinations */ .KP.priceDestinations, (ref = yup__WEBPACK_IMPORTED_MODULE_0__/* .array */ .IX().min(1, "Select one route atleast")) === null || ref === void 0 ? void 0 : ref.required("Select one route atleast")), _obj)))), _obj1);


/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LOAD_POSTING_FORM_LOCATION_STATE; }
/* harmony export */ });
var LOAD_POSTING_FORM_LOCATION_STATE;
(function(LOAD_POSTING_FORM_LOCATION_STATE) {
    LOAD_POSTING_FORM_LOCATION_STATE["PARAM_NAME"] = "load-posting-form";
})(LOAD_POSTING_FORM_LOCATION_STATE || (LOAD_POSTING_FORM_LOCATION_STATE = {}));


/***/ }),

/***/ 84788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ buildRestrictedVehicleFormMeta; },
/* harmony export */   "MA": function() { return /* binding */ NEW_USER_VEHICLE_RESTRICTION_KEY; },
/* harmony export */   "_K": function() { return /* binding */ VEHICLE_REMOTE_CONFIG_KEY; },
/* harmony export */   "mr": function() { return /* binding */ filterExpirementLorryList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var _vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14345);





/** Firebase remote-config keys that own the vehicle catalogs per posting surface. */ var VEHICLE_REMOTE_CONFIG_KEY = {
    load: "lorry_config_data",
    lorry: "vehicle_config_data"
};
var NEW_USER_VEHICLE_RESTRICTION_KEY = "new_user_vehicle_restriction";
function parseISODate(dateStr) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateStr.split("-").map(Number), 3), year = ref[0], month = ref[1], day = ref[2];
    return new Date(year, month - 1, day);
}
function parseDate(dateStr) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dateStr.split("/").map(Number), 3), day = ref[0], month = ref[1], year = ref[2];
    return new Date(year, month - 1, day);
}
function isValidDate(date) {
    return !Number.isNaN(date.getTime());
}
function isJoinedOnInExperimentWindow(gate, joinedOn) {
    if (!joinedOn) {
        return false;
    }
    var startDate = parseDate(gate.from_date || "");
    var endDate = parseDate(gate.to_date || "");
    var joinedOnDate = parseISODate(joinedOn);
    return isValidDate(startDate) && isValidDate(endDate) && isValidDate(joinedOnDate) && startDate <= joinedOnDate && joinedOnDate < endDate;
}
function isValidJoinedOn(joinedOn) {
    if (!joinedOn) {
        return false;
    }
    return isValidDate(parseISODate(joinedOn));
}
function getRestrictionGate(meta, scope) {
    if (scope === "lorry") {
        var _lorry;
        return (_lorry = meta.lorry) !== null && _lorry !== void 0 ? _lorry : {};
    }
    return meta;
}
/** Logged-out users and new users (joined within experiment window) get the restriction. */ function shouldApplyRestriction(meta, companyId, joinedOn, scope) {
    var ref;
    var gate = getRestrictionGate(meta, scope);
    if (!(gate === null || gate === void 0 ? void 0 : gate.is_enabled)) {
        return false;
    }
    if (companyId && ((ref = gate.exempt_company_ids) === null || ref === void 0 ? void 0 : ref.includes(companyId))) {
        return false;
    }
    // Logged out, or joinedOn missing/invalid — apply restriction
    if (!companyId || !isValidJoinedOn(joinedOn)) {
        return true;
    }
    // New user within experiment window
    return isJoinedOnInExperimentWindow(gate, joinedOn);
}
function isFeetSizeAllowed(size, meta) {
    if (meta.allowed_feet_min != null && size < meta.allowed_feet_min) {
        return false;
    }
    if (meta.allowed_feet_max != null && size > meta.allowed_feet_max) {
        return false;
    }
    return true;
}
/** Intersect source range with allowed capacity bounds; null if no overlap. */ function clampCapacityRange(min, max, meta) {
    var allowedMin = meta.allowed_capacity_min_mt;
    var allowedMax = meta.allowed_capacity_max_mt;
    if (allowedMin == null && allowedMax == null) {
        return {
            min: min,
            max: max
        };
    }
    var clampedMin = allowedMin != null ? Math.max(min, allowedMin) : min;
    var clampedMax = allowedMax != null ? Math.min(max, allowedMax) : max;
    if (clampedMin > clampedMax) {
        return null;
    }
    return {
        min: clampedMin,
        max: clampedMax
    };
}
function filterVehicleByRestrictions(vehicle, meta) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    // Feet bounds (allowed_feet_min/max) apply to LCV only; others use capacity clamp alone.
    var shouldFilterFeet = ((ref = vehicle.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "lcv";
    var feet = shouldFilterFeet ? (ref1 = vehicle.feet) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return isFeetSizeAllowed(item.size, meta);
    }) : vehicle.feet;
    var feet_capacity = (ref2 = vehicle.feet_capacity) === null || ref2 === void 0 ? void 0 : ref2.flatMap(function(item) {
        if (shouldFilterFeet && !isFeetSizeAllowed(item.size, meta)) {
            return [];
        }
        var clamped = clampCapacityRange(item.min, item.max, meta);
        return clamped ? [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item, clamped)
        ] : [];
    });
    var tyre_capacity = (ref3 = vehicle.tyre_capacity) === null || ref3 === void 0 ? void 0 : ref3.flatMap(function(item) {
        var clamped = clampCapacityRange(item.min, item.max, meta);
        return clamped ? [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item, clamped)
        ] : [];
    });
    var hadCapacityData = Boolean(((ref4 = vehicle.tyre_capacity) === null || ref4 === void 0 ? void 0 : ref4.length) || ((ref5 = vehicle.feet_capacity) === null || ref5 === void 0 ? void 0 : ref5.length));
    var hasCapacityInRange = Boolean((tyre_capacity === null || tyre_capacity === void 0 ? void 0 : tyre_capacity.length) || (feet_capacity === null || feet_capacity === void 0 ? void 0 : feet_capacity.length));
    // Drop vehicles whose capacities do not overlap the allowed range.
    if (hadCapacityData && !hasCapacityInRange) {
        return null;
    }
    var ref10;
    var feet_tyre = shouldFilterFeet ? (ref6 = vehicle.feet_tyre) === null || ref6 === void 0 ? void 0 : ref6.map(function(item) {
        var ref;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item), {
            feet: (ref10 = (ref = item.feet) === null || ref === void 0 ? void 0 : ref.filter(function(foot) {
                return isFeetSizeAllowed(foot.size, meta);
            })) !== null && ref10 !== void 0 ? ref10 : []
        });
    }).filter(function(item) {
        return item.feet.length > 0;
    }) : vehicle.feet_tyre;
    var shouldSyncTyres = Boolean(((ref7 = vehicle.tyre_capacity) === null || ref7 === void 0 ? void 0 : ref7.length) || ((ref8 = vehicle.feet_tyre) === null || ref8 === void 0 ? void 0 : ref8.length));
    var ref11, ref12;
    var allowedTyreCounts = new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((ref11 = tyre_capacity === null || tyre_capacity === void 0 ? void 0 : tyre_capacity.map(function(item) {
        return item.tyres_count;
    })) !== null && ref11 !== void 0 ? ref11 : []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((ref12 = feet_tyre === null || feet_tyre === void 0 ? void 0 : feet_tyre.map(function(item) {
        return item.tyres_count;
    })) !== null && ref12 !== void 0 ? ref12 : [])));
    var tyres = shouldSyncTyres ? (ref9 = vehicle.tyres) === null || ref9 === void 0 ? void 0 : ref9.filter(function(item) {
        return allowedTyreCounts.has(item.count);
    }) : vehicle.tyres;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, vehicle, feet !== undefined ? {
        feet: feet
    } : {}, feet_capacity !== undefined ? {
        feet_capacity: feet_capacity
    } : {}, tyre_capacity !== undefined ? {
        tyre_capacity: tyre_capacity
    } : {}, feet_tyre !== undefined ? {
        feet_tyre: feet_tyre
    } : {}, tyres !== undefined ? {
        tyres: tyres
    } : {});
}
var filterExpirementLorryList = function(data) {
    var ref, ref1;
    var companyId = data.companyId, meta = data.meta, joinedOn = data.joinedOn, scope = data.scope;
    var fullList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(data.list);
    if (!shouldApplyRestriction(meta, companyId, joinedOn, scope)) {
        return fullList;
    }
    // Prefer experiment vehicle defs from meta.config; fall back to full catalog.
    var sourceList = ((ref = meta.config) === null || ref === void 0 ? void 0 : (ref1 = ref.vehicles) === null || ref1 === void 0 ? void 0 : ref1.length) ? meta.config.vehicles : fullList;
    return sourceList.map(function(vehicle) {
        return filterVehicleByRestrictions(vehicle, meta);
    }).filter(function(vehicle) {
        return Boolean(vehicle);
    });
};
/**
 * Filter remote vehicle catalog for a company/scope, then derive form capacity bounds
 * + allowed vehicle chips (used by admin/CS load & lorry posting forms).
 */ function buildRestrictedVehicleFormMeta(data) {
    var ref, ref1, ref2, ref3;
    var resultList = filterExpirementLorryList(data) || [];
    var generated = (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .generateLorryList */ .wA)(resultList, resultList);
    var listKey = data.scope === "load" ? "LOAD_POST" : "LORRY_POST";
    return {
        allowedCapacityMin: (ref = generated.ALLOWED_CAPACITY) === null || ref === void 0 ? void 0 : (ref1 = ref[listKey]) === null || ref1 === void 0 ? void 0 : ref1.min,
        allowedCapacityMax: (ref2 = generated.ALLOWED_CAPACITY) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[listKey]) === null || ref3 === void 0 ? void 0 : ref3.max,
        allowedVehicleList: (0,_vahak_core_dist_constants_lorryTypes__WEBPACK_IMPORTED_MODULE_0__/* .getAllowedVehicleList */ .UE)(data.scope, {
            srcList: generated.LIST[listKey]
        })
    };
}


/***/ }),

/***/ 90376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ LORRY_POSTING_FORM_LOCATION_STATE; }
/* harmony export */ });
var LORRY_POSTING_FORM_LOCATION_STATE;
(function(LORRY_POSTING_FORM_LOCATION_STATE) {
    LORRY_POSTING_FORM_LOCATION_STATE["PARAM_NAME"] = "lorry-posting-form";
})(LORRY_POSTING_FORM_LOCATION_STATE || (LORRY_POSTING_FORM_LOCATION_STATE = {}));


/***/ }),

/***/ 56427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ AnyDestinationOption; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_dist_icons_cross_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77000);
/* harmony import */ var _vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60054);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71960);
/* harmony import */ var _posting_form_common_posting_chip_PostingChip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6330);





// import Styles from "./SelectedRouterInfo.module.scss";






var ANY_DESTINATION_ID = "ANY_DESTINATION";
var AnyDestinationOption = {
    label: "Any destination within 250 km",
    id: ANY_DESTINATION_ID,
    value: {
        price: 0,
        place: {
            place_id: ANY_DESTINATION_ID
        }
    }
};
var SelectedRouterInfo = function(param) {
    var _titleText = param.titleText, titleText = _titleText === void 0 ? "Where would you like to go?" : _titleText, onRemove = param.onRemove, onAdd = param.onAdd, tmp = param.activeCities, _activeCities = tmp === void 0 ? [] : tmp, showAnyDestinationOption = param.showAnyDestinationOption;
    var activeCities = _activeCities === null || _activeCities === void 0 ? void 0 : _activeCities.filter(function(v) {
        return v.id != (AnyDestinationOption === null || AnyDestinationOption === void 0 ? void 0 : AnyDestinationOption.id) && !!(v === null || v === void 0 ? void 0 : v.label);
    });
    var renderedOption = showAnyDestinationOption ? [
        AnyDestinationOption
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(activeCities)) : activeCities;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__/* .VerticalFlex */ .vs, {
        gap: 14,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                weight: "medium",
                color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].GREY_600 */ .Z.GREY_600,
                mSize: "xs",
                size: "sm",
                children: titleText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                flexWrap: "wrap",
                gap: 8,
                children: renderedOption === null || renderedOption === void 0 ? void 0 : renderedOption.map(function(item) {
                    var isActive = (_activeCities === null || _activeCities === void 0 ? void 0 : _activeCities.findIndex(function(activeCity) {
                        return (activeCity === null || activeCity === void 0 ? void 0 : activeCity.id) === (item === null || item === void 0 ? void 0 : item.id);
                    })) >= 0;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_posting_form_common_posting_chip_PostingChip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        size: "xs",
                        onClick: function() {
                            return onAdd === null || onAdd === void 0 ? void 0 : onAdd(item);
                        }
                    }, isActive && {
                        active: true,
                        color: "blue",
                        outlined: true,
                        rightNode: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: 18,
                            height: 18,
                            svgFillColor: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_5__/* ["default"].GREY_700 */ .Z.GREY_700,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_cross_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                        }),
                        onClick: function() {
                            return onRemove === null || onRemove === void 0 ? void 0 : onRemove(item);
                        }
                    }), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            size: "s",
                            children: item === null || item === void 0 ? void 0 : item.label
                        })
                    }));
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectedRouterInfo);


/***/ }),

/***/ 48510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pS": function() { return /* reexport */ vehicle_restriction_popup_VehicleRestrictionPopup; },
  "nK": function() { return /* reexport */ formatLoadCapacityRangeLabel; },
  "MG": function() { return /* reexport */ formatLorryCapacityRangeLabel; },
  "V2": function() { return /* reexport */ getLorryVehicleRestriction; },
  "vP": function() { return /* reexport */ isLoadCapacityOutsideAllowedRange; },
  "pn": function() { return /* reexport */ isLorryCapacityOutsideAllowedRange; },
  "Gg": function() { return /* reexport */ isThreeWheelerVehicle; }
});

// UNUSED EXPORTS: VEHICLE_RESTRICTION_BANNER, getVehicleRestrictionPopupConfig, isCapacityOutsideAllowedRange

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core/dist/constants/lorryTypes.js
var lorryTypes = __webpack_require__(14345);
;// CONCATENATED MODULE: ./components/posting/vehicle-restriction-popup/getLorryVehicleRestriction.ts

function isThreeWheelerVehicle(input) {
    return input.vehicleCategory === "3WT" || Number(input.totalTyres) === 3;
}
function isCapacityOutsideAllowedRange(capacity, bounds) {
    if (!Number.isFinite(capacity) || capacity <= 0) {
        return false;
    }
    if (!bounds.min && !bounds.max) {
        return false;
    }
    return capacity < bounds.min || capacity > bounds.max;
}
function isLorryCapacityOutsideAllowedRange(capacity, bounds) {
    var ref, ref1;
    return isCapacityOutsideAllowedRange(capacity, {
        min: (ref = bounds === null || bounds === void 0 ? void 0 : bounds.min) !== null && ref !== void 0 ? ref : lorryTypes/* NEW_LORRY_CAPACITY.LORRY_POST.min */.QZ.LORRY_POST.min,
        max: (ref1 = bounds === null || bounds === void 0 ? void 0 : bounds.max) !== null && ref1 !== void 0 ? ref1 : lorryTypes/* NEW_LORRY_CAPACITY.LORRY_POST.max */.QZ.LORRY_POST.max
    });
}
function isLoadCapacityOutsideAllowedRange(capacity, bounds) {
    var ref, ref1;
    return isCapacityOutsideAllowedRange(capacity, {
        min: (ref = bounds === null || bounds === void 0 ? void 0 : bounds.min) !== null && ref !== void 0 ? ref : lorryTypes/* NEW_LORRY_CAPACITY.LOAD_POST.min */.QZ.LOAD_POST.min,
        max: (ref1 = bounds === null || bounds === void 0 ? void 0 : bounds.max) !== null && ref1 !== void 0 ? ref1 : lorryTypes/* NEW_LORRY_CAPACITY.LOAD_POST.max */.QZ.LOAD_POST.max
    });
}
function getLorryVehicleRestriction(input, bounds) {
    if (isThreeWheelerVehicle(input)) {
        return "three_wheeler";
    }
    if (isLorryCapacityOutsideAllowedRange(Number(input.capacity), bounds)) {
        return "capacity_out_of_range";
    }
    return null;
}
function formatLorryCapacityRangeLabel(bounds) {
    var ref;
    var min = (ref = bounds === null || bounds === void 0 ? void 0 : bounds.min) !== null && ref !== void 0 ? ref : lorryTypes/* NEW_LORRY_CAPACITY.LORRY_POST.min */.QZ.LORRY_POST.min;
    var ref1;
    var max = (ref1 = bounds === null || bounds === void 0 ? void 0 : bounds.max) !== null && ref1 !== void 0 ? ref1 : lorryTypes/* NEW_LORRY_CAPACITY.LORRY_POST.max */.QZ.LORRY_POST.max;
    return "".concat(min, "T - ").concat(max, "T");
}
function formatLoadCapacityRangeLabel(bounds) {
    var ref;
    var min = (ref = bounds === null || bounds === void 0 ? void 0 : bounds.min) !== null && ref !== void 0 ? ref : lorryTypes/* NEW_LORRY_CAPACITY.LOAD_POST.min */.QZ.LOAD_POST.min;
    var ref1;
    var max = (ref1 = bounds === null || bounds === void 0 ? void 0 : bounds.max) !== null && ref1 !== void 0 ? ref1 : lorryTypes/* NEW_LORRY_CAPACITY.LOAD_POST.max */.QZ.LOAD_POST.max;
    return "".concat(min, "T - ").concat(max, "T");
}

;// CONCATENATED MODULE: ./components/posting/vehicle-restriction-popup/types.ts
var VEHICLE_RESTRICTION_BANNER = {
    RANGE_NOT_ALLOWED: "homepage-v2/post-form-banner/range-not-allowed.png",
    VEHICLE_NOT_ALLOWED: "homepage-v2/post-form-banner/vehicle-not-allowed.png"
};

;// CONCATENATED MODULE: ./components/posting/vehicle-restriction-popup/getVehicleRestrictionPopupConfig.tsx




function CapacityRangeText(param) {
    var prefix = param.prefix, rangeLabel = param.rangeLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            prefix,
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: rangeLabel || formatLorryCapacityRangeLabel()
            })
        ]
    });
}
function getVehicleRestrictionPopupConfig(kind, options) {
    var rangeLabel = options === null || options === void 0 ? void 0 : options.capacityRangeLabel;
    switch(kind){
        case "capacity_activate":
            return {
                kind: kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.RANGE_NOT_ALLOWED,
                title: "Vehicle not supported",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)(CapacityRangeText, {
                    prefix: "We only support vehicles with capacity",
                    rangeLabel: rangeLabel
                }),
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
        case "capacity_reactivate":
            return {
                kind: kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.RANGE_NOT_ALLOWED,
                title: "Vehicle not supported anymore",
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)(CapacityRangeText, {
                    prefix: "We now only support vehicles with capacity",
                    rangeLabel: rangeLabel
                }),
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
        case "three_wheeler_lorry":
            return {
                kind: kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.VEHICLE_NOT_ALLOWED,
                title: "This vehicle is not supported",
                description: "We do not support 3 wheeler LCVs. Please add another vehicle.",
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
        case "three_wheeler_load_repost":
            return {
                kind: kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.VEHICLE_NOT_ALLOWED,
                title: "This vehicle is not supported",
                description: "We do not support 3 wheeler LCVs.",
                cancelLabel: "Cancel",
                primaryLabel: "Edit & Post Load"
            };
        case "unsupported_category":
            return {
                kind: kind,
                bannerSrc: VEHICLE_RESTRICTION_BANNER.VEHICLE_NOT_ALLOWED,
                title: "This vehicle is not supported",
                description: "We no longer support Tanker, Hyva & Trailer.",
                cancelLabel: "Cancel",
                primaryLabel: "Add New Vehicle"
            };
    }
}

// EXTERNAL MODULE: ./components/posting/vehicle-restriction-popup/VehicleRestrictionPopup.module.scss
var VehicleRestrictionPopup_module = __webpack_require__(9906);
var VehicleRestrictionPopup_module_default = /*#__PURE__*/__webpack_require__.n(VehicleRestrictionPopup_module);
;// CONCATENATED MODULE: ./components/posting/vehicle-restriction-popup/VehicleRestrictionPopup.tsx






var VehicleRestrictionPopup = function(param) {
    var isOpen = param.isOpen, kind = param.kind, onCancel = param.onCancel, onPrimary = param.onPrimary, _id = param.id, id = _id === void 0 ? "vehicle-restriction-popup" : _id, primaryLabelOverride = param.primaryLabelOverride, capacityRangeLabel = param.capacityRangeLabel;
    var config = getVehicleRestrictionPopupConfig(kind, {
        capacityRangeLabel: capacityRangeLabel
    });
    var primaryLabel = primaryLabelOverride || config.primaryLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
        id: id,
        isOpen: isOpen,
        onToggle: onCancel,
        showHeader: false,
        modalSize: "fit",
        borderRadius: 25,
        sheetBorderRadius: 25,
        paddedModal: false,
        paddedSheet: false,
        showBottomSheetOverlay: true,
        blurBackground: true,
        disableSheetSwipe: true,
        // Nested over load/lorry posting modals — avoid overlay/esc dismissing the parent form.
        modalShouldCloseOnOverlayClick: false,
        modalShouldCloseOnEsc: false,
        disableSheetOverlayClick: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (VehicleRestrictionPopup_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (VehicleRestrictionPopup_module_default()).bannerWrap,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                        className: (VehicleRestrictionPopup_module_default()).banner,
                        src: config.bannerSrc,
                        alt: "",
                        width: 167,
                        height: 115,
                        "aria-hidden": true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (VehicleRestrictionPopup_module_default()).body,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (VehicleRestrictionPopup_module_default()).title,
                            children: config.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (VehicleRestrictionPopup_module_default()).description,
                            children: config.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (VehicleRestrictionPopup_module_default()).actions,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "".concat((VehicleRestrictionPopup_module_default()).actionBtn, " ").concat((VehicleRestrictionPopup_module_default()).cancelBtn),
                            onClick: function(e) {
                                e.stopPropagation();
                                onCancel();
                            },
                            children: config.cancelLabel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "".concat((VehicleRestrictionPopup_module_default()).actionBtn, " ").concat((VehicleRestrictionPopup_module_default()).primaryBtn),
                            onClick: function(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                onPrimary(e);
                            },
                            children: primaryLabel
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var vehicle_restriction_popup_VehicleRestrictionPopup = (VehicleRestrictionPopup);

;// CONCATENATED MODULE: ./components/posting/vehicle-restriction-popup/index.ts






/***/ }),

/***/ 37372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47281);
/* harmony import */ var _QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32450);
/* harmony import */ var _vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9937);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31013);





// Components



var QuickActionPopup = function(param) {
    var _id = param.id, id = _id === void 0 ? "quick-pop" : _id, description = param.description, isOpen = param.isOpen, onToggle = param.onToggle, header = param.header, ctaText = param.ctaText, ctaAction = param.ctaAction, ctaProps = param.ctaProps, secondaryCtaProps = param.secondaryCtaProps, secondaryCtaAction = param.secondaryCtaAction, secondaryCtaText = param.secondaryCtaText, _showCloseIcon = param.showCloseIcon, showCloseIcon = _showCloseIcon === void 0 ? true : _showCloseIcon, headerProps = param.headerProps, _modalSize = param.modalSize, modalSize = _modalSize === void 0 ? "wide" : _modalSize, spacing = param.spacing, titleText = param.titleText, commonCtaProps = param.commonCtaProps, popupProps = param.popupProps, modalProps = param.modalProps, _ctaPlacement = param.ctaPlacement, ctaPlacement = _ctaPlacement === void 0 ? "body" : _ctaPlacement;
    var ActionSlot = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().ctaContainer),
            children: [
                secondaryCtaText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    onClick: secondaryCtaAction,
                    id: id + "-secondary",
                    fillType: "outlined"
                }, commonCtaProps, secondaryCtaProps), {
                    children: secondaryCtaText
                })) : null,
                ctaText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    onClick: ctaAction,
                    id: id + "-primary"
                }, commonCtaProps, ctaProps), {
                    children: ctaText
                })) : null
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_3__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, popupProps, modalProps), {
            isOpen: isOpen,
            showCloseIcon: showCloseIcon,
            onToggle: onToggle,
            modalSize: modalSize,
            sheetPaddingBottom: 20,
            modalSeparationGap: 0,
            id: id,
            borderRadius: 8,
            titleText: titleText,
            renderFooter: ctaPlacement === "footer" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "data-popup-footer": true,
                children: ActionSlot
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: (_QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main),
                flexDirection: "column",
                gap: spacing !== null && spacing !== void 0 ? spacing : 20,
                children: [
                    !!header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        className: (_QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header)
                    }, headerProps), {
                        children: header
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_QuickActionPopup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
                        children: description
                    }),
                    ctaPlacement === "body" && ActionSlot
                ]
            })
        })) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QuickActionPopup);


/***/ }),

/***/ 83347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ useRegisterPageSeo; },
/* harmony export */   "Ej": function() { return /* binding */ GlobalSeoHead; },
/* harmony export */   "a4": function() { return /* binding */ SeoProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92683);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61706);






var SeoContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
function SeoProvider(param) {
    var children = param.children;
    var pageConfigRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SeoContext.Provider, {
        value: pageConfigRef,
        children: children
    });
}
function useRegisterPageSeo(config) {
    var pageConfigRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SeoContext);
    if (!pageConfigRef) {
        return;
    }
    pageConfigRef.current = config;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        pageConfigRef.current = config;
        return function() {
            if (pageConfigRef.current === config) {
                pageConfigRef.current = null;
            }
        };
    }, [
        pageConfigRef,
        config
    ]);
}
function GlobalSeoHead() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pageConfigRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SeoContext);
    var ref, _locale;
    var resolved = (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_5__/* .buildPageSeo */ .U7)((ref = pageConfigRef === null || pageConfigRef === void 0 ? void 0 : pageConfigRef.current) !== null && ref !== void 0 ? ref : null, {
        asPath: router.asPath,
        locale: (_locale = router.locale) !== null && _locale !== void 0 ? _locale : "en"
    });
    if (!resolved) {
        return null;
    }
    var hasPageMeta = Boolean(resolved.title);
    var shouldRenderRobots = hasPageMeta || resolved.shouldBeIndexed === false;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            hasPageMeta && resolved.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: resolved.title
            }) : null,
            hasPageMeta && resolved.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: resolved.description
            }) : null,
            hasPageMeta && resolved.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: resolved.keywords
            }) : null,
            shouldRenderRobots ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: resolved.shouldBeIndexed ? "index, follow" : "noindex, nofollow"
            }) : null,
            hasPageMeta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: resolved.canonicalUrl
            }) : null,
            hasPageMeta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: resolved.ogUrl
            }) : null,
            hasPageMeta && resolved.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: resolved.title
            }) : null,
            hasPageMeta && resolved.ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: resolved.ogDescription
            }) : null,
            hasPageMeta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: resolved.ogImgSrc
            }) : null,
            hasPageMeta && resolved.ogImgAltText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: resolved.ogImgAltText
            }) : null,
            hasPageMeta && resolved.ogType ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: resolved.ogType
            }) : null,
            hasPageMeta && resolved.ogSiteName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: resolved.ogSiteName
            }) : null,
            hasPageMeta && resolved.ogLocale ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: resolved.ogLocale
            }) : null,
            hasPageMeta ? resolved.ogLocaleAlternates.map(function(locale) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:locale:alternate",
                    content: locale
                }, locale);
            }) : null,
            hasPageMeta && resolved.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }) : null,
            hasPageMeta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: _vahak_core_dist_constants_socialMediaLinks__WEBPACK_IMPORTED_MODULE_4__/* .TWITTER_HANDLE */ .OX
            }) : null,
            hasPageMeta && resolved.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: resolved.title
            }) : null,
            hasPageMeta && resolved.ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: resolved.ogDescription
            }) : null,
            hasPageMeta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: resolved.ogImgSrc
            }) : null,
            resolved.hreflangAlternates.map(function(param) {
                var hreflang = param.hreflang, href = param.href;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    hrefLang: hreflang,
                    href: href
                }, hreflang);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: "x-default",
                href: resolved.hreflangDefault
            }),
            hasPageMeta ? resolved.schemaScripts.map(function(param) {
                var id = param.id, json = param.json;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    id: id,
                    dangerouslySetInnerHTML: {
                        __html: json
                    }
                }, id);
            }) : null
        ]
    });
}


/***/ }),

/***/ 38681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ServiceRequestType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ServiceRequestModal_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(49271);
/* harmony import */ var _ServiceRequestModal_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_ServiceRequestModal_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9937);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48953);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_components_Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7100);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32450);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4628);
/* harmony import */ var _admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60280);
/* harmony import */ var _vahak_core_ui_dist_hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95385);
/* harmony import */ var _vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26513);
/* harmony import */ var _services_vas_useCreateVasTicket__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78325);
/* harmony import */ var _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(63118);
/* harmony import */ var _vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(38920);
/* harmony import */ var _utils_AppImg__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(17073);




















var ServiceRequestType;
(function(ServiceRequestType) {
    ServiceRequestType["GPS"] = "gps";
    ServiceRequestType["CARGO_INSURANCE"] = "cargoInsurance";
    ServiceRequestType["VEHICLE_INSURANCE"] = "vehicleInsurance";
    ServiceRequestType["BUSINESS_LOAN"] = "businessLoan";
})(ServiceRequestType || (ServiceRequestType = {}));
var ServiceRequestModal = function(param) {
    var onClose = param.onClose;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_10__/* .AppContext */ .Il), name = ref2.name, phoneNum = ref2.phoneNum, companyId = ref2.companyId, serviceRequestType = ref2.serviceRequestType, setServiceRequestType = ref2.setServiceRequestType;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: name !== null && name !== void 0 ? name : "",
        phone: String(phoneNum !== null && phoneNum !== void 0 ? phoneNum : "")
    }), data = ref3[0], setData = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), ticketRaisedSuccessfully = ref4[0], setTicketRaisedSuccessfully = ref4[1];
    var ref5 = (0,_vahak_core_ui_dist_hooks__WEBPACK_IMPORTED_MODULE_12__/* .useToggleModalWithLocalState */ .A$)(Boolean(serviceRequestType)), isModalOpen = ref5.isModalOpen, toggleModal = ref5.toggleModal, openModal = ref5.openModal;
    var isMobileScreen = (0,_vahak_core_ui_dist_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        queryType: "mobile"
    });
    var getServiceTypeData = function() {
        switch(serviceRequestType){
            case "gps":
                return {
                    title: "GPS",
                    ticketType: _admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_11__/* .TicketType.VAS_LEADS_GPS */ .zK.VAS_LEADS_GPS,
                    vasType: _admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_11__/* .VasType.GPS */ .jc.GPS,
                    description: "Gain real-time shipment visibility and improve delivery efficiency"
                };
            // case "businessLoan":
            //     return {
            //         title: "Business Loan",
            //         ticketType: TicketType.VAS_LEADS_BUSINESS_LOAN,
            //         vasType: VasType.BUSINESS_LOAN,
            //         description: "Secure financing to grow your logistics business"
            //     };
            case "cargoInsurance":
                return {
                    title: "Cargo Insurance",
                    ticketType: _admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_11__/* .TicketType.VAS_LEADS_CARGO */ .zK.VAS_LEADS_CARGO,
                    vasType: _admin_ticket_system_helper_constants__WEBPACK_IMPORTED_MODULE_11__/* .VasType.CARGO */ .jc.CARGO,
                    description: "Protect your valuable goods in transit with comprehensive coverage"
                };
            // case "vehicleInsurance":
            //     return {
            //         title: "Vehicle Insurance",
            //         ticketType: TicketType.VAS_LEADS_VEHICLE_INSURANCE,
            //         vasType: VasType.VEHICLE_INSURANCE,
            //         description: "Ensure your fleet is covered against unforeseen accidents"
            //     };
            default:
                break;
        }
    };
    var renderSuccess = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_ServiceRequestModal_module_scss__WEBPACK_IMPORTED_MODULE_18___default().successScreen),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                flexDirection: "column",
                alignItems: "center",
                gap: 23,
                margin: "0 0 10px 0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_AppImg__WEBPACK_IMPORTED_MODULE_17__["default"], {
                        src: "/ticket-raised-success.svg",
                        alt: "",
                        width: isMobileScreen ? 134 : 250,
                        height: isMobileScreen ? 81 : 152,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        size: "md",
                        align: "center",
                        weight: "semibold",
                        color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GREY_1000 */ .Z.GREY_1000,
                        children: [
                            "Ticket submitted ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            " Successfully"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        align: "center",
                        weight: "medium",
                        color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GREY_600 */ .Z.GREY_600,
                        children: "Our Agent will contact you shortly"
                    })
                ]
            })
        });
    };
    var getSourceScreen = function() {
        switch(router.pathname){
            case "/vas/cargo-insurance":
                return "Cargo Insurance";
            case "/vas/commercial-vehicle-insurance":
                return "Commercial Vehicle Insurance";
            default:
                return "Requested from web - Top nav";
        }
    };
    var ref6 = (0,_services_vas_useCreateVasTicket__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(), raiseVasTicket = ref6.mutateAsync;
    var handleClickRaiseTicket = function() {
        var ref;
        var ref1;
        raiseVasTicket((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
            company_id: Number(companyId),
            vas_type: (ref1 = (ref = getServiceTypeData()) === null || ref === void 0 ? void 0 : ref.vasType) !== null && ref1 !== void 0 ? ref1 : 0,
            reference_type: 1,
            user_name: data.name,
            phone_number: data.phone
        }, serviceRequestType === ServiceRequestType.GPS && {
            plan_id: 12,
            no_of_devices: 0
        }), {
            onSuccess: function onSuccess(data) {
                setTicketRaisedSuccessfully(true);
            },
            onError: function onError(error) {
                setServiceRequestType === null || setServiceRequestType === void 0 ? void 0 : setServiceRequestType(undefined);
                toggleModal();
                _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_15__/* .toast.error */ .A.error(error.message);
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (serviceRequestType) {
            openModal();
            router.push({
                hash: "#".concat(serviceRequestType)
            });
        }
    }, [
        serviceRequestType
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_ModalOrBottomSheetWrapper__WEBPACK_IMPORTED_MODULE_3__["default"], {
        isOpen: isModalOpen || true,
        paddedModal: false,
        modalSize: "fit",
        showHeader: false,
        borderRadius: 16,
        sheetBorderRadius: 16,
        disableSheetSwipe: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            className: (_ServiceRequestModal_module_scss__WEBPACK_IMPORTED_MODULE_18___default().main),
            flexDirection: "column",
            gap: 12,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    style: {
                        marginBottom: 20
                    },
                    children: [
                        !ticketRaisedSuccessfully ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* .VerticalFlex */ .vs, {
                            gap: 10,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    as: "p",
                                    size: "xl",
                                    weight: "semibold",
                                    children: (ref = getServiceTypeData()) === null || ref === void 0 ? void 0 : ref.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    as: "p",
                                    size: "s",
                                    weight: "medium",
                                    children: (ref1 = getServiceTypeData()) === null || ref1 === void 0 ? void 0 : ref1.description
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalCrossIcon */ .A, {
                            onClick: function() {
                                setServiceRequestType === null || setServiceRequestType === void 0 ? void 0 : setServiceRequestType(undefined);
                                toggleModal();
                                onClose();
                            },
                            id: "serviceRequestPopup--closeBtn"
                        })
                    ]
                }),
                ticketRaisedSuccessfully ? renderSuccess() : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            flexDirection: "column",
                            gap: 13,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: "m",
                                    weight: "medium",
                                    color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GREY_700 */ .Z.GREY_700,
                                    children: "Enter your name"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    id: "",
                                    name: "name",
                                    type: "text",
                                    value: data.name,
                                    onChange: function(e) {
                                        setData({
                                            name: (0,_vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_16__/* .stringOperations */ .$M)(e.target.value, [
                                                "removeSpecialCharacters"
                                            ]),
                                            phone: data.phone
                                        });
                                    },
                                    placeholder: "",
                                    length: 20,
                                    autoFocus: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            flexDirection: "column",
                            gap: 13,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    size: "m",
                                    weight: "medium",
                                    color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].GREY_700 */ .Z.GREY_700,
                                    children: "Enter your phone number"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    id: "",
                                    name: "phone",
                                    type: "text",
                                    value: data.phone,
                                    onChange: function(e) {
                                        setData({
                                            name: data.name,
                                            phone: e.target.value.replace(/\D/g, "")
                                        });
                                    },
                                    length: 10,
                                    prefixNode: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_8__/* ["default"].BLACK */ .Z.BLACK,
                                        size: "md",
                                        mSize: "s",
                                        weight: "semibold",
                                        children: [
                                            "+91 -",
                                            " "
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_ServiceRequestModal_module_scss__WEBPACK_IMPORTED_MODULE_18___default().submitBtn),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                blockBtn: true,
                                onClick: handleClickRaiseTicket,
                                disabled: !(data.name && data.phone.length === 10),
                                children: "Submit"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ServiceRequestModal);


/***/ }),

/***/ 17073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77370);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(34406);





var myLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    // return `${IMG_BASE_URL}/${width}/${src}`;
    // const isWebPNOTSupported = window.localStorage.getItem("isWebPSupported") === "0";
    // conso le.log("WEBP>>>>>>.", process.env.isWebPSupported);
    var isWebPNOTSupported = process.env.isWebPSupported === "0";
    return "".concat(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__/* .IMG_BASE_URL_NEXTJS */ .nD, "/").concat(width, "/").concat(quality || 75, "/").concat(isWebPNOTSupported ? "default" : "webp", "/").concat(src);
// return `${IMG_BASE_URL}/${width}/${quality || 75}/webp/${src}`;
};
var AppImg = function(_param) {
    var _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "blur" : _placeholder, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "placeholder"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        loader: myLoader,
        placeholder: placeholder,
        blurDataURL: placeholder === "blur" ? myLoader({
            src: props.src,
            width: 128,
            quality: 1
        }) : undefined
    }, props, props.unoptimized && {
        src: _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__/* .IMG_BASE_URL */ .TS + props.src
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (AppImg);


/***/ }),

/***/ 92477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _AppLink_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43219);
/* harmony import */ var _AppLink_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_AppLink_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var AppLink = function(_param) {
    var className = _param.className, style = _param.style, children = _param.children, title = _param.title, id = _param.id, target = _param.target, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "style",
        "children",
        "title",
        "id",
        "target"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        passHref: true,
        locale: "",
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_AppLink_module_scss__WEBPACK_IMPORTED_MODULE_7___default().a), className),
            style: style,
            title: title,
            id: id,
            target: target,
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppLink);


/***/ }),

/***/ 53325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _AppImg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17073);
/* harmony import */ var _AvatarImage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54672);
/* harmony import */ var _AvatarImage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_AvatarImage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_getImageNameFromURL__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72366);





// Style


var AvatarImage = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "xs" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "size"
    ]);
    var imageSize = props.imageSize;
    var imageUrl = props.imageUrl, alt = props.alt, firstName = props.firstName, lastName = props.lastName, defaultUrl = props.defaultUrl, className = props.className, onClick = props.onClick;
    var sizes = {
        xs: 36,
        s: 40,
        sm: 45,
        md: 60,
        lg: 100,
        custom: imageSize
    };
    var initial = [];
    if (firstName || lastName) {
        if (firstName) {
            initial.push(firstName[0]);
        }
        if (lastName) {
            initial.push(lastName[0]);
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_AvatarImage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imageContainer), className),
        style: {
            width: sizes[size],
            height: sizes[size]
        },
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppImg__WEBPACK_IMPORTED_MODULE_3__["default"], {
            src: (0,_utils_getImageNameFromURL__WEBPACK_IMPORTED_MODULE_6__/* .getImageNameFromURL */ .O)(imageUrl) || (0,_utils_getImageNameFromURL__WEBPACK_IMPORTED_MODULE_6__/* .getImageNameFromURL */ .O)(defaultUrl) || "default.png",
            alt: alt,
            width: sizes[size],
            height: sizes[size],
            placeholder: "empty"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AvatarImage);


/***/ }),

/***/ 60537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AB_TEST_CAMPAIGN_IDS; }
/* harmony export */ });
var AB_TEST_CAMPAIGN_IDS = {
    downloadApp: "15",
    downloadAppProd: "29",
    newOnboardingFormDev: "23",
    newOnboardingFormProd: "26",
    mandateLoadLorryPostingDev: "28",
    mandatePostingShipperProd: "30",
    mandatePostingTransporterProd: "32",
    homepageLoadPostingProd: "34",
    homepageLoadPostingDev: "35"
};


/***/ }),

/***/ 40223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ADMIN_OPERATION; }
/* harmony export */ });
/* unused harmony export ADMIN_OPERATION_LIST */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38920);


var listOfKeys = [
    "none",
    "blockUnblockUser",
    "editOperations",
    "editRoles",
    "profileEdit",
    "profileView",
    "readOperations",
    "readRoles",
    "tagAgent",
    "tagAgentManagerUI",
    "tagAgentTsoLoad",
    "tagAgentTsoLorry",
    "ticketAadhar",
    "ticketAssuredLoadAdmin",
    "ticketAssuredLoad",
    "ticketBidCancellation",
    "ticketCompanyRegistration",
    "ticketCallMeBack",
    "ticketEway",
    "ticketGST",
    "ticketPAN",
    "ticketPhysicalVerification",
    "ticketRC",
    "ticketRefundRequest",
    "ticketVerifiedLoad1",
    "postPlacementAdminView",
    "postPlacementView",
    "ticketPPPlacement",
    "ticketPPLoading",
    "ticketPPUnloading",
    "userLoadLorryAction",
    "userPhoneNumberVisibilityUI",
    "tsoBulkTagging",
    "paymentReports",
    "metaBaseReport",
    "paymentCIReports",
    "bdOpsOperation",
    "ticketVasCargo",
    "ticketVasGps",
    "ticketTsoCompanyLeads",
    "ticketMembershipCallMeBack",
    "ticketHelp",
    "ticketAccountDeletion",
    "ticketLoadVerification",
    "ticketLoadVerificationAdmin"
];
var ADMIN_OPERATION = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (0,_vahak_core_ui_dist_methods__WEBPACK_IMPORTED_MODULE_0__/* .generateObjectFromKeys */ .lX)(listOfKeys));
var ADMIN_OPERATION_LIST = Object.keys(ADMIN_OPERATION);


/***/ }),

/***/ 67577:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var IDs = {
    businessCards: {
        businessCardHomeScreenLink: "home_services_drpd_businesscard",
        businessCard: "businesscard",
        businessCardImage: "businesscard_image",
        businessCardShareButton: "businesscard_btn_share",
        businessCardDownloadButton: "businesscard_btn_download"
    },
    marketplace: {
        marketLoad: "mktHeader_btn_load",
        marketLorry: "mktHeader_btn_lorry"
    },
    profile: {
        tapNgoToggle: "tap-n-go-toggle"
    },
    mandatePopup: {
        mandateSignupBtn: "mandate-signup-btn"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (IDs);


/***/ }),

/***/ 73278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AC": function() { return /* binding */ isMyLorriesListingPath; },
/* harmony export */   "AI": function() { return /* binding */ DEEP_LINK_LORRY_ID_PARAM; },
/* harmony export */   "YS": function() { return /* binding */ isMyLoadsListingPath; },
/* harmony export */   "b7": function() { return /* binding */ DEEP_LINK_QUERY_PARAM_LEGACY; },
/* harmony export */   "eu": function() { return /* binding */ isLoadAddDeepLink; },
/* harmony export */   "kg": function() { return /* binding */ isLoadDetailsDeepLink; },
/* harmony export */   "mz": function() { return /* binding */ isLorryReactivateDeepLink; },
/* harmony export */   "sf": function() { return /* binding */ getRedirectQueryValue; },
/* harmony export */   "t6": function() { return /* binding */ DEEP_LINK_QUERY_PARAM; },
/* harmony export */   "ty": function() { return /* binding */ isAuthRequiredDeepLink; },
/* harmony export */   "xb": function() { return /* binding */ getLoggedInDeepLinkHref; }
/* harmony export */ });
/* unused harmony exports DEEP_LINK_REDIRECT, DEEP_LINK_ID_PARAM */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87394);
/* harmony import */ var _vahak_core_dist_constants_tab__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71076);
/* harmony import */ var _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12098);





var DEEP_LINK_REDIRECT = {
    LOAD_ADD: "load|add",
    LOAD_DETAILS: "load|details",
    LORRY_REACTIVATE: "lorry|reactivate"
};
/** Canonical query param for web deep links. */ var DEEP_LINK_QUERY_PARAM = "action";
/** Legacy query param — still present on older Firebase / page.link URLs. Load-add only. */ var DEEP_LINK_QUERY_PARAM_LEGACY = "r";
/** Load details entity id. Same key the listing page uses to open `Details`. */ var DEEP_LINK_ID_PARAM = "id";
/** Lorry reactivate entity id. Not `id` — listing `id` opens details instead of the reactivate modal. */ var DEEP_LINK_LORRY_ID_PARAM = "lorryid";
function getRedirectQueryValue(query, key) {
    var value = query[key];
    return Array.isArray(value) ? value[0] : value;
}
function getQueryString(asPath) {
    var ref;
    var ref1;
    return (ref1 = (ref = asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[1]) === null || ref === void 0 ? void 0 : ref.split("#")[0]) !== null && ref1 !== void 0 ? ref1 : "";
}
function escapeRegex(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function hasPipeActionInQuery(query, key, action) {
    return getRedirectQueryValue(query, key) === action;
}
function hasPipeActionInAsPath(asPath, key, action) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(action.split("|"), 2), left = ref[0], right = ref[1];
    if (!left || !right) {
        return false;
    }
    // Unencoded `|` is parsed as `key=left` only — fall back to raw URL.
    return new RegExp("(?:^|&)".concat(escapeRegex(key), "=").concat(escapeRegex(left), "(?:%7C|\\|)").concat(escapeRegex(right), "(?:&|$)"), "i").test(getQueryString(asPath));
}
function hasPipeAction(query, asPath, action, keys) {
    return keys.some(function(key) {
        return hasPipeActionInQuery(query, key, action) || hasPipeActionInAsPath(asPath, key, action);
    });
}
function isLoadAddDeepLink(query, asPath) {
    return hasPipeAction(query, asPath, DEEP_LINK_REDIRECT.LOAD_ADD, [
        DEEP_LINK_QUERY_PARAM,
        DEEP_LINK_QUERY_PARAM_LEGACY
    ]);
}
function isLoadDetailsDeepLink(query, asPath) {
    return hasPipeAction(query, asPath, DEEP_LINK_REDIRECT.LOAD_DETAILS, [
        DEEP_LINK_QUERY_PARAM
    ]);
}
function isLorryReactivateDeepLink(query, asPath) {
    return hasPipeAction(query, asPath, DEEP_LINK_REDIRECT.LORRY_REACTIVATE, [
        DEEP_LINK_QUERY_PARAM
    ]);
}
function isAuthRequiredDeepLink(query, asPath) {
    return isLoadDetailsDeepLink(query, asPath) || isLorryReactivateDeepLink(query, asPath);
}
function pathWithoutQuery(pathname, asPath) {
    return asPath.split("?")[0].split("#")[0] || pathname;
}
function isMyLoadsListingPath(pathname, asPath) {
    var path = pathWithoutQuery(pathname, asPath);
    return /\/ac\/my-loads\/listing\/?$/.test(path) || /\/ac\/my-loads\/listing\/?$/.test(pathname);
}
function isMyLorriesListingPath(pathname, asPath) {
    var path = pathWithoutQuery(pathname, asPath);
    return /\/ac\/my-lorries\/listing\/?$/.test(path) || /\/ac\/my-lorries\/listing\/?$/.test(pathname);
}
function appendQuery(path, params) {
    var search = Object.entries(params).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    }).join("&");
    return search ? "".concat(path, "?").concat(search) : path;
}
/**
 * Logged-in destination after landing on `/` (auth guard + post-login).
 * Load-add stays on `/dashboard` so compact posting can open. The other two
 * go to the listing page that already owns that UI.
 */ function getLoggedInDeepLinkHref(query, asPath) {
    if (isLoadAddDeepLink(query, asPath)) {
        var ref, ref1;
        return appendQuery(_vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.dashboard.getUrl */ .Z.dashboard.getUrl(), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, DEEP_LINK_QUERY_PARAM, (ref1 = (ref = getRedirectQueryValue(query, DEEP_LINK_QUERY_PARAM)) !== null && ref !== void 0 ? ref : getRedirectQueryValue(query, DEEP_LINK_QUERY_PARAM_LEGACY)) !== null && ref1 !== void 0 ? ref1 : DEEP_LINK_REDIRECT.LOAD_ADD));
    }
    if (isLoadDetailsDeepLink(query, asPath)) {
        var loadId = getRedirectQueryValue(query, DEEP_LINK_ID_PARAM);
        var listing = _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.myLoadsMyLorries.getUrl */ .Z.myLoadsMyLorries.getUrl("loads", _vahak_core_dist_constants_tab__WEBPACK_IMPORTED_MODULE_0__/* .MY_LOAD_LORRY_TABS.LISTING */ .n.LISTING);
        return loadId ? appendQuery(listing, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, DEEP_LINK_ID_PARAM, loadId)) : listing;
    }
    if (isLorryReactivateDeepLink(query, asPath)) {
        var lorryId = getRedirectQueryValue(query, DEEP_LINK_LORRY_ID_PARAM);
        var listing1 = _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.myLoadsMyLorries.getUrl */ .Z.myLoadsMyLorries.getUrl("lorries", _vahak_core_dist_constants_tab__WEBPACK_IMPORTED_MODULE_0__/* .MY_LOAD_LORRY_TABS.LISTING */ .n.LISTING);
        return appendQuery(listing1, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, DEEP_LINK_QUERY_PARAM, DEEP_LINK_REDIRECT.LORRY_REACTIVATE), lorryId ? (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, DEEP_LINK_LORRY_ID_PARAM, lorryId) : {}));
    }
    return undefined;
}


/***/ }),

/***/ 57993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VV": function() { return /* binding */ MARKETPLACE_ROUTE_CONFIG; }
/* harmony export */ });
/* unused harmony exports MARKETPLACE_ANY_DESTINATION_ID, MARKETPLACE_ISR_REVALIDATE_SECONDS, TRANSPORT_DIRECTORY_ISR_REVALIDATE_SECONDS, isConsumerMarketplacePath */
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12098);


var MARKETPLACE_ROUTE_CONFIG = {
    loadUrl: _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl(_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .MarketPlaceType.LOAD */ .CY3.LOAD),
    loadType: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .MarketPlaceType.LOAD */ .CY3.LOAD,
    lorryUrl: _vahak_core_dist_constants_routeStrings__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.marketplace.getUrl */ .Z.marketplace.getUrl(_vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .MarketPlaceType.LORRY */ .CY3.LORRY),
    lorryType: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .MarketPlaceType.LORRY */ .CY3.LORRY
};
var MARKETPLACE_ANY_DESTINATION_ID = (/* unused pure expression or super */ null && (-1));
/** ISR cache for static shells — shell is i18n + URL props only; listings fetch client-side. */ var MARKETPLACE_ISR_REVALIDATE_SECONDS = (/* unused pure expression or super */ null && (7 * 24 * 60 * 60));
var TRANSPORT_DIRECTORY_ISR_REVALIDATE_SECONDS = (/* unused pure expression or super */ null && (MARKETPLACE_ISR_REVALIDATE_SECONDS));
/** Consumer `/marketplace/*` routes. */ function isConsumerMarketplacePath(pathname) {
    return pathname.includes("/marketplace") && !pathname.includes("/tso/");
}


/***/ }),

/***/ 50837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C_": function() { return /* binding */ MARKETPLACE_ROUTE; },
/* harmony export */   "J_": function() { return /* binding */ TAG_AGENT_SINGLE_USER_LOAD_PAGE; },
/* harmony export */   "Of": function() { return /* binding */ TRANSPORT_NAGAR; },
/* harmony export */   "RH": function() { return /* binding */ CLIENT_LISTING_PAGE; },
/* harmony export */   "Rb": function() { return /* binding */ PAYMENT_LIST; },
/* harmony export */   "Rk": function() { return /* binding */ MEMBERSHIP; },
/* harmony export */   "ef": function() { return /* binding */ HOME_ROUTE; },
/* harmony export */   "fN": function() { return /* binding */ TRANSPORT_DIRECTORY; },
/* harmony export */   "fW": function() { return /* binding */ MY_LORRIES_PAGE; },
/* harmony export */   "k4": function() { return /* binding */ MEMBERSHIP_FEATURE; },
/* harmony export */   "lG": function() { return /* binding */ USER_PROFILE_PAGE; },
/* harmony export */   "mp": function() { return /* binding */ MEMBERSHIP_HISTORY; },
/* harmony export */   "p$": function() { return /* binding */ MEMBERSHIP_UPGRADE; },
/* harmony export */   "r6": function() { return /* binding */ BULK_LOADS_LIST; },
/* harmony export */   "sj": function() { return /* binding */ PREMIUM_LOAD_TRIP; },
/* harmony export */   "v2": function() { return /* binding */ LISTING_PAGE; },
/* harmony export */   "vQ": function() { return /* binding */ BANK_DETAILS; },
/* harmony export */   "wJ": function() { return /* binding */ MEMBERSHIP_PAYMENT; },
/* harmony export */   "yQ": function() { return /* binding */ MOBILE_APP; },
/* harmony export */   "zO": function() { return /* binding */ DASHBOARD_ROUTE; }
/* harmony export */ });
/* unused harmony exports CS_GLOBAL_SEARCH_PAGE, TRACK_VEHICLE, MW_TRACK_VEHICLE, TAG_AGENT_REFERRAL_PAGE, TAG_AGENT_LOAD_PAGE, TAG_AGENT_LORRY_PAGE, TAG_AGENT_SINGLE_USER_LORRY_PAGE, TAG_AGENT_ENQUIRY_CARD_PAGE, MW_HOME, PREMIUM_CLIENT_LISTING, PREMIUM_ROUTE, ADMIN_LOGIN, ADMIN_HOME, CUSTOMER_LOGIN, BLOCK_USER, SEND_WHATSAPP_MESSAGE, TICKET_SYSTEM_ROUTE_AADHAAR, TICKET_SYSTEM_ROUTE_PAN, TICKET_SYSTEM_ROUTE_BUSINESS, TICKET_SYSTEM_ROUTE_EWAY, TICKET_SYSTEM_ROUTE_RC, TICKET_SYSTEM_ROUTE_PAYMENT_REFUND, TICKET_SYSTEM_ROUTE_ACCOUNT_DELETION, TICKET_SYSTEM_ROUTE_VAS_LEADS, TICKET_SYSTEM_ROUTE_HELP, TICKET_SYSTEM_ROUTE_BID_CANCELLATION */
var MARKETPLACE_ROUTE = "marketplace";
var LISTING_PAGE = "myLoadLorries";
var CLIENT_LISTING_PAGE = "listing";
var BULK_LOADS_LIST = "bulkLoads";
var PREMIUM_LOAD_TRIP = "premiumLoadsTrip";
var USER_PROFILE_PAGE = "userProfile";
var CS_GLOBAL_SEARCH_PAGE = "cs_global_search_page";
var MOBILE_APP = "mobileApp";
var PAYMENT_LIST = "paymentList";
var TRACK_VEHICLE = "trackVehicle";
var MW_TRACK_VEHICLE = "mwTrackVehicle";
var TAG_AGENT_REFERRAL_PAGE = "tagAgent";
var TAG_AGENT_LOAD_PAGE = "tagAgentLoadPage";
var TAG_AGENT_SINGLE_USER_LOAD_PAGE = "tagAgentSingleUserLoadPage";
var TAG_AGENT_LORRY_PAGE = "tagAgentLorryPage";
var TAG_AGENT_SINGLE_USER_LORRY_PAGE = "tagAgentSingleUserLorryPage";
var TAG_AGENT_ENQUIRY_CARD_PAGE = "tagAgentEnquiryCardPage";
var MW_HOME = "mwHome";
var PREMIUM_CLIENT_LISTING = "premiumClientListing";
var PREMIUM_ROUTE = "premiumRoute";
var HOME_ROUTE = "homeRoute";
var DASHBOARD_ROUTE = "dashboard";
var TRANSPORT_DIRECTORY = "transportDirectory";
var ADMIN_LOGIN = "adminLogin";
var ADMIN_HOME = "adminHome";
var CUSTOMER_LOGIN = "customerLogin";
var BLOCK_USER = "blockUser";
var SEND_WHATSAPP_MESSAGE = "sendWhatsappMessage";
var TICKET_SYSTEM_ROUTE_AADHAAR = "ticketSystemAadhaar";
var TICKET_SYSTEM_ROUTE_PAN = "ticketSystemPan";
var TICKET_SYSTEM_ROUTE_BUSINESS = "ticketSystemBusiness";
var TICKET_SYSTEM_ROUTE_EWAY = "ticketSystemEway";
var TICKET_SYSTEM_ROUTE_RC = "ticketSystemRC";
var TICKET_SYSTEM_ROUTE_PAYMENT_REFUND = "ticketSystemPaymentRefund";
var TICKET_SYSTEM_ROUTE_ACCOUNT_DELETION = "ticketSystemAccountDeletion";
var TICKET_SYSTEM_ROUTE_VAS_LEADS = "ticketSystemVasLeads";
var TICKET_SYSTEM_ROUTE_HELP = "ticketSystemHelp";
var TICKET_SYSTEM_ROUTE_BID_CANCELLATION = "ticketSystemBidCancellation";
var MEMBERSHIP = "membership";
var MEMBERSHIP_PAYMENT = "membership-payment";
var MEMBERSHIP_UPGRADE = "membership-upgrade";
var MEMBERSHIP_HISTORY = "membership-history";
var MEMBERSHIP_FEATURE = "membership-feature";
var BANK_DETAILS = "bank-details";
var TRANSPORT_NAGAR = "transport-nagar";
var MY_LORRIES_PAGE = "MY_LORRIES_PAGE"; //Report system routes


/***/ }),

/***/ 94954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useRemoteConfig; },
/* harmony export */   "j": function() { return /* binding */ RemoteConfigProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44681);
// context/RemoteConfigContext.tsx





var RemoteConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({
    readValue: function() {
        throw new Error("RemoteConfig not initialized");
    },
    reloadConfig: function() {},
    isLoaded: false
});
var RemoteConfigProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), configInstance = ref[0], setConfigInstance = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoaded = ref1[0], setIsLoaded = ref1[1];
    var reloadConfig = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,_vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__/* .fetchAndActivate */ .xS)(_vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__/* .remoteConfig */ .Sn);
                    case 3:
                        setConfigInstance(_vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__/* .remoteConfig */ .Sn);
                        setIsLoaded(true);
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Failed to activate remote config", _ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function reloadConfig() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        !!_vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__/* .remoteConfig */ .Sn && reloadConfig();
    }, [
        _vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__/* .remoteConfig */ .Sn
    ]);
    var readValue = function(keyName, format, fallback) {
        return (0,_vahak_core_dist_services_firebase_service__WEBPACK_IMPORTED_MODULE_3__/* .readRemoteConfigValue */ .IN)(configInstance, keyName, format, fallback);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RemoteConfigContext.Provider, {
        value: {
            readValue: readValue,
            reloadConfig: reloadConfig,
            isLoaded: isLoaded
        },
        children: children
    });
};
var useRemoteConfig = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(RemoteConfigContext);
};


/***/ }),

/***/ 50094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k$": function() { return /* binding */ useClickToCall; }
});

// UNUSED EXPORTS: CallBtnWithIcon, ClickToCallAppProvider, useCallMode

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../core-ui/dist/components/IconWrapper/index.js
var components_IconWrapper = __webpack_require__(60054);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast_toast = __webpack_require__(63118);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var components_Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var utils_AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var layout_Flex = __webpack_require__(31013);
;// CONCATENATED MODULE: ../core-ui/dist/components/common/DraggableWrapper/DraggableWrapper.js



const DraggableWrapper_DraggableWrapper = ({ children, className, initialStyle = {}, }) => {
    const [position, setPosition] = useState(null);
    const [startPosition, setStartPosition] = useState({
        x: 0,
        y: 0,
    });
    const [dragging, setDragging] = useState(false);
    const handleDragStart = (e) => {
        var _a, _b;
        const rect = e.currentTarget.getBoundingClientRect();
        const currentX = (_a = position === null || position === void 0 ? void 0 : position.x) !== null && _a !== void 0 ? _a : rect.left;
        const currentY = (_b = position === null || position === void 0 ? void 0 : position.y) !== null && _b !== void 0 ? _b : rect.top;
        setStartPosition({
            x: e.clientX - currentX,
            y: e.clientY - currentY,
        });
        setDragging(true);
    };
    const handleDrag = (e) => {
        if (!dragging)
            return;
        setPosition({
            x: e.clientX - startPosition.x,
            y: e.clientY - startPosition.y,
        });
    };
    const handleDragEnd = () => {
        setDragging(false);
    };
    useEffect(() => {
        if (dragging) {
            window.addEventListener("mousemove", handleDrag);
            window.addEventListener("mouseup", handleDragEnd);
        }
        else {
            window.removeEventListener("mousemove", handleDrag);
            window.removeEventListener("mouseup", handleDragEnd);
        }
        return () => {
            window.removeEventListener("mousemove", handleDrag);
            window.removeEventListener("mouseup", handleDragEnd);
        };
    }, [dragging, startPosition]);
    const dynamicStyle = position
        ? {
            left: `${position.x}px`,
            top: `${position.y}px`,
            transform: "none",
        }
        : initialStyle;
    return (jsx("span", Object.assign({ className: className, onMouseDown: handleDragStart, style: Object.assign({ position: "fixed", zIndex: Number.MAX_SAFE_INTEGER, cursor: dragging ? "grabbing" : "grab" }, dynamicStyle) }, { children: children })));
};


//# sourceMappingURL=DraggableWrapper.js.map

;// CONCATENATED MODULE: ../core/dist/icons/call-accept.svg
var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgCallAccept(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#call-accept_svg__clip0_1359_599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M921.78 158.104c-210.914-210.851-552.825-210.8-763.676.116-210.851 210.916-210.8 552.825.116 763.676 210.916 210.854 552.825 210.804 763.676-.116A539.998 539.998 0 001080 539.884a539.984 539.984 0 00-158.22-381.78zm-103.969 594.11c-.023.023-.046.048-.072.071v-.179l-27.36 27.179c-35.385 35.832-86.919 50.575-135.901 38.88a478.48 478.48 0 01-138.959-62.279 641.978 641.978 0 01-109.62-88.381 646.873 646.873 0 01-81.901-99.36 503.95 503.95 0 01-61.56-124.56c-16.818-51.882-2.881-108.812 36.001-147.06l32.039-32.039c8.908-8.948 23.382-8.98 32.328-.072.023.024.049.047.072.072l101.159 101.159c8.948 8.908 8.98 23.383.072 32.329a4.992 4.992 0 01-.072.071l-59.4 59.4c-17.043 16.859-19.187 43.648-5.039 63.001a694.659 694.659 0 0071.101 82.981 690.439 690.439 0 0093.599 78.66c19.337 13.488 45.552 11.214 62.279-5.4l57.42-58.32c8.907-8.947 23.382-8.979 32.328-.071l.072.071 101.34 101.52c8.95 8.906 8.982 23.379.074 32.327z",
    fill: "#0F863C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.811 752.214c-.023.023-.046.049-.072.072v-.18l-27.36 27.18c-35.385 35.832-86.919 50.574-135.901 38.88a478.48 478.48 0 01-138.959-62.279 642.074 642.074 0 01-109.62-88.381 646.969 646.969 0 01-81.901-99.36 503.957 503.957 0 01-61.56-124.561c-16.818-51.882-2.881-108.812 36.001-147.059l32.039-32.039c8.908-8.948 23.382-8.98 32.328-.072.023.023.049.046.072.072l101.159 101.159c8.948 8.908 8.98 23.382.072 32.328l-.072.072-59.4 59.4c-17.043 16.858-19.187 43.647-5.039 63.001a694.728 694.728 0 0071.101 82.98 690.446 690.446 0 0093.599 78.661c19.337 13.487 45.552 11.213 62.279-5.4l57.42-58.32c8.908-8.948 23.382-8.98 32.328-.072l.072.072 101.34 101.52c8.95 8.906 8.982 23.378.074 32.326z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "call-accept_svg__clip0_1359_599"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v1080H0z"
  })))));
}

/* harmony default export */ var call_accept = ((/* unused pure expression or super */ null && (SvgCallAccept)));
;// CONCATENATED MODULE: ../core/dist/icons/call-mic.svg
var call_mic_g, call_mic_defs;

function call_mic_extends() { call_mic_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return call_mic_extends.apply(this, arguments); }



function SvgCallMic(props) {
  return /*#__PURE__*/React.createElement("svg", call_mic_extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), call_mic_g || (call_mic_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#call-mic_svg__clip0_1359_591)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540 1080c298.234 0 540-241.766 540-540C1080 241.766 838.234 0 540 0 241.766 0 0 241.766 0 540c0 298.234 241.766 540 540 540zm0-922.501c62.589 0 113.799 51.209 113.799 113.798v288.01c0 62.59-51.21 113.799-113.799 113.799-62.589 0-113.799-51.209-113.799-113.799v-288.01c0-62.589 51.21-113.798 113.799-113.798zm35.999 765c0 19.881-16.118 35.999-36.001 35.999-19.881 0-35.999-16.118-35.999-35.999V819.387c-57.91-8.02-109.928-35.09-149.457-74.621-47.571-47.571-77.098-113.217-77.098-185.459v-67.913c0-19.883 16.118-36.001 36.001-36.001s36 16.118 36 36.001v67.913c0 52.365 21.449 99.997 56.004 134.553 34.556 34.556 82.188 56.004 134.551 56.004 52.365 0 99.999-21.448 134.553-56.004 34.553-34.556 56.004-82.188 56.004-134.553v-67.913c0-19.883 16.117-36.001 36-36.001s35.999 16.118 35.999 36.001v67.913c0 72.242-29.527 137.888-77.098 185.459-39.531 39.531-91.551 66.599-149.459 74.621v103.112z",
    fill: "#0F863C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 1080c298.234 0 540-241.766 540-540C1080 241.766 838.234 0 540 0 241.766 0 0 241.766 0 540c0 298.234 241.766 540 540 540zm0-922.501c62.589 0 113.799 51.209 113.799 113.798v288.01c0 62.59-51.21 113.799-113.799 113.799-62.589 0-113.799-51.209-113.799-113.799v-288.01c0-62.589 51.21-113.798 113.799-113.798zm35.999 765c0 19.881-16.118 35.999-36.001 35.999-19.881 0-35.999-16.118-35.999-35.999V819.387c-57.91-8.02-109.928-35.09-149.457-74.621-47.571-47.571-77.098-113.217-77.098-185.459v-67.913c0-19.883 16.118-36.001 36.001-36.001s36 16.118 36 36.001v67.913c0 52.365 21.449 99.997 56.004 134.553 34.556 34.556 82.188 56.004 134.551 56.004 52.365 0 99.999-21.448 134.553-56.004 34.553-34.556 56.004-82.188 56.004-134.553v-67.913c0-19.883 16.117-36.001 36-36.001s35.999 16.118 35.999 36.001v67.913c0 72.242-29.527 137.888-77.098 185.459-39.531 39.531-91.551 66.599-149.459 74.621v103.112z",
    fill: "#0F863C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.993 158.203c62.59 0 113.799 51.209 113.799 113.799v288.01c0 62.589-51.209 113.798-113.799 113.798-62.589 0-113.798-51.209-113.798-113.798v-288.01c0-62.59 51.209-113.799 113.798-113.799zm35.999 765.001c0 19.881-16.118 35.998-36.001 35.998-19.88 0-35.998-16.117-35.998-35.998V820.091c-57.911-8.02-109.928-35.089-149.458-74.621-47.57-47.571-77.097-113.216-77.097-185.458v-67.914c0-19.883 16.117-36 36-36s36.001 16.117 36.001 36v67.914c0 52.365 21.448 99.997 56.004 134.552 34.556 34.556 82.187 56.004 134.55 56.004 52.366 0 100-21.448 134.553-56.004 34.554-34.555 56.004-82.187 56.004-134.552v-67.914c0-19.883 16.118-36 36.001-36s35.999 16.117 35.999 36v67.914c0 72.242-29.528 137.887-77.098 185.458-39.532 39.532-91.551 66.599-149.46 74.621v103.113z",
    fill: "#fff"
  }))), call_mic_defs || (call_mic_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "call-mic_svg__clip0_1359_591"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v1080H0z"
  })))));
}

/* harmony default export */ var call_mic = ((/* unused pure expression or super */ null && (SvgCallMic)));
;// CONCATENATED MODULE: ../core/dist/icons/call-mic-muted.svg
var call_mic_muted_g, call_mic_muted_defs;

function call_mic_muted_extends() { call_mic_muted_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return call_mic_muted_extends.apply(this, arguments); }



function SvgCallMicMuted(props) {
  return /*#__PURE__*/React.createElement("svg", call_mic_muted_extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), call_mic_muted_g || (call_mic_muted_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#call-mic-muted_svg__clip0_1359_594)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540 1080c298.234 0 540-241.766 540-540C1080 241.766 838.234 0 540 0 241.766 0 0 241.766 0 540c0 298.234 241.766 540 540 540zm0-922.501c62.589 0 113.799 51.209 113.799 113.798v288.01c0 62.59-51.21 113.799-113.799 113.799-62.589 0-113.799-51.209-113.799-113.799v-288.01c0-62.589 51.21-113.798 113.799-113.798zm35.999 765c0 19.881-16.118 35.999-36.001 35.999-19.881 0-35.999-16.118-35.999-35.999V819.387c-57.91-8.02-109.928-35.09-149.457-74.621-47.571-47.571-77.098-113.217-77.098-185.459v-67.913c0-19.883 16.118-36.001 36.001-36.001s36 16.118 36 36.001v67.913c0 52.365 21.449 99.997 56.004 134.553 34.556 34.556 82.188 56.004 134.551 56.004 52.365 0 99.999-21.448 134.553-56.004 34.553-34.556 56.004-82.188 56.004-134.553v-67.913c0-19.883 16.117-36.001 36-36.001s35.999 16.118 35.999 36.001v67.913c0 72.242-29.527 137.888-77.098 185.459-39.531 39.531-91.551 66.599-149.459 74.621v103.112z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 1080c298.234 0 540-241.766 540-540C1080 241.766 838.234 0 540 0 241.766 0 0 241.766 0 540c0 298.234 241.766 540 540 540zm0-922.501c62.589 0 113.799 51.209 113.799 113.798v288.01c0 62.59-51.21 113.799-113.799 113.799-62.589 0-113.799-51.209-113.799-113.799v-288.01c0-62.589 51.21-113.798 113.799-113.798zm35.999 765c0 19.881-16.118 35.999-36.001 35.999-19.881 0-35.999-16.118-35.999-35.999V819.387c-57.91-8.02-109.928-35.09-149.457-74.621-47.571-47.571-77.098-113.217-77.098-185.459v-67.913c0-19.883 16.118-36.001 36.001-36.001s36 16.118 36 36.001v67.913c0 52.365 21.449 99.997 56.004 134.553 34.556 34.556 82.188 56.004 134.551 56.004 52.365 0 99.999-21.448 134.553-56.004 34.553-34.556 56.004-82.188 56.004-134.553v-67.913c0-19.883 16.117-36.001 36-36.001s35.999 16.118 35.999 36.001v67.913c0 72.242-29.527 137.888-77.098 185.459-39.531 39.531-91.551 66.599-149.459 74.621v103.112z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.993 158.203c62.59 0 113.799 51.209 113.799 113.799v288.01c0 62.589-51.209 113.798-113.799 113.798-62.589 0-113.798-51.209-113.798-113.798v-288.01c0-62.59 51.209-113.799 113.798-113.799zm35.999 765.001c0 19.881-16.118 35.998-36.001 35.998-19.88 0-35.998-16.117-35.998-35.998V820.091c-57.911-8.02-109.928-35.089-149.458-74.621-47.57-47.571-77.097-113.216-77.097-185.458v-67.914c0-19.883 16.117-36 36-36s36.001 16.117 36.001 36v67.914c0 52.365 21.448 99.997 56.004 134.552 34.556 34.556 82.187 56.004 134.55 56.004 52.366 0 100-21.448 134.553-56.004 34.554-34.555 56.004-82.187 56.004-134.552v-67.914c0-19.883 16.118-36 36.001-36s35.999 16.117 35.999 36v67.914c0 72.242-29.528 137.887-77.098 185.458-39.532 39.532-91.551 66.599-149.46 74.621v103.113z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.646 834.353c-8.089-8.089-8.089-21.204 0-29.293l540.628-540.628c8.089-8.089 21.204-8.089 29.293 0 8.09 8.089 8.09 21.204 0 29.294L295.94 834.353c-8.09 8.089-21.205 8.089-29.294 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.433 811.568c-8.09-8.089-8.09-21.204 0-29.293L772.06 241.647c8.09-8.089 21.205-8.089 29.294 0 8.089 8.089 8.089 21.204 0 29.293L260.726 811.568c-8.089 8.089-21.204 8.089-29.293 0z",
    fill: "#DC2626"
  }))), call_mic_muted_defs || (call_mic_muted_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "call-mic-muted_svg__clip0_1359_594"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v1080H0z"
  })))));
}

/* harmony default export */ var call_mic_muted = ((/* unused pure expression or super */ null && (SvgCallMicMuted)));
;// CONCATENATED MODULE: ../core/dist/icons/call-reject.svg
var call_reject_g, call_reject_defs;

function call_reject_extends() { call_reject_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return call_reject_extends.apply(this, arguments); }



function SvgCallReject(props) {
  return /*#__PURE__*/React.createElement("svg", call_reject_extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), call_reject_g || (call_reject_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#call-reject_svg__clip0_1359_604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.081 1080c298.233-.04 539.969-241.847 539.919-540.082C1079.95 241.684 838.151-.046 539.917 0 241.682.046-.048 241.848-.002 540.082A540 540 0 00540.081 1080zM193.499 586.385v-.102l.127.127.128-38.566c-.316-50.357 25.7-97.222 68.604-123.588a478.478 478.478 0 01142.297-54.221 642.06 642.06 0 01140.008-15.019 646.993 646.993 0 01128.171 12.346 503.958 503.958 0 01131.607 44.548c48.578 24.794 78.979 74.905 78.53 129.443v45.311c.028 12.626-10.184 22.883-22.809 22.91H717c-12.626.028-22.883-10.184-22.91-22.809v-84.106c.131-23.972-17.296-44.43-40.985-48.111a694.645 694.645 0 00-108.952-8.401 690.348 690.348 0 00-121.806 10.564c-23.21 4.136-40.14 24.281-40.22 47.856l.637 81.84c.028 12.626-10.185 22.883-22.809 22.91h-.101l-143.445-.126c-12.626.031-22.882-10.18-22.91-22.806z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.499 586.385c0-.033-.002-.067 0-.102l.127.127.128-38.566c-.316-50.357 25.699-97.222 68.604-123.588a478.478 478.478 0 01142.297-54.221 642.054 642.054 0 01140.008-15.019 646.976 646.976 0 01128.17 12.346A503.945 503.945 0 01804.44 411.91c48.579 24.794 78.98 74.904 78.531 129.443v45.311c.028 12.626-10.185 22.883-22.809 22.91H717c-12.626.028-22.884-10.185-22.911-22.809v-84.106c.132-23.972-17.296-44.43-40.985-48.111a694.636 694.636 0 00-108.952-8.401 690.45 690.45 0 00-121.806 10.563c-23.21 4.137-40.139 24.281-40.22 47.857l.637 81.84c.029 12.626-10.184 22.883-22.808 22.91h-.102l-143.444-.127c-12.626.032-22.882-10.179-22.91-22.805z",
    fill: "#fff"
  }))), call_reject_defs || (call_reject_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "call-reject_svg__clip0_1359_604"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1080v1080H0z"
  })))));
}

/* harmony default export */ var call_reject = ((/* unused pure expression or super */ null && (SvgCallReject)));
// EXTERNAL MODULE: ../core/dist/standard-icons/plus-circle-white.svg
var plus_circle_white = __webpack_require__(73099);
// EXTERNAL MODULE: ../core-ui/dist/components/common/BordererCard/BordererCard.js + 1 modules
var BordererCard_BordererCard = __webpack_require__(56832);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var components_Button = __webpack_require__(32450);
;// CONCATENATED MODULE: ./context/call/type.ts
var PLVIO_CALL_STATE;
(function(PLVIO_CALL_STATE) {
    PLVIO_CALL_STATE["INITIALIZED"] = "initialized";
    PLVIO_CALL_STATE["RINGING"] = "ringing";
    PLVIO_CALL_STATE["ANSWERED"] = "answered";
    PLVIO_CALL_STATE["REJECTED"] = "rejected";
    PLVIO_CALL_STATE["IGNORED"] = "ignored";
    PLVIO_CALL_STATE["CANCELED"] = "canceled";
    PLVIO_CALL_STATE["FAILED"] = "failed";
    PLVIO_CALL_STATE["ENDED"] = "ended";
})(PLVIO_CALL_STATE || (PLVIO_CALL_STATE = {}));
var type_PLIVO_CALL_STATUS_TEXT;
(function(PLIVO_CALL_STATUS_TEXT) {
    PLIVO_CALL_STATUS_TEXT["HANGUP"] = "Hangup";
    PLIVO_CALL_STATUS_TEXT["ANSWERED"] = "Answered";
    PLIVO_CALL_STATUS_TEXT["INITIATED"] = "Initiated";
    PLIVO_CALL_STATUS_TEXT["RINGING"] = "Ringing";
})(type_PLIVO_CALL_STATUS_TEXT || (type_PLIVO_CALL_STATUS_TEXT = {}));

;// CONCATENATED MODULE: ./components/call/ConferenceCallPopup.tsx



















var ConferenceCallPopup_ConferenceCallPopup = function(param) {
    var onHangup = param.onHangup, onToggleMute = param.onToggleMute, callInfo = param.callInfo, onAnswer = param.onAnswer, onReject = param.onReject, onClickAddToConference = param.onClickAddToConference, onKick = param.onKick;
    var ref = callInfo || {}, startTime = ref.startTime, endTime = ref.endTime, isCallActive = ref.isCallActive;
    var timerId = useRef();
    var ref1 = useState(0), duration = ref1[0], setDuration = ref1[1];
    var showMuteBtn = callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected;
    var ref2 = convertSecondsTime(duration), m = ref2.m, s = ref2.s, h = ref2.h;
    var hour = h.toString().padStart(2, "0");
    var min = m.toString().padStart(2, "0");
    var sec = s.toString().padStart(2, "0");
    var callDurationFormattedText = "".concat(h ? "".concat(hour, ":") : "").concat(min, ":").concat(sec);
    var updateDuration = function() {
        if (startTime) {
            var ref;
            var A = startTime.getTime();
            var B = (endTime === null || endTime === void 0 ? void 0 : (ref = endTime.getTime) === null || ref === void 0 ? void 0 : ref.call(endTime)) || Date.now();
            var duration = Math.ceil((B - A) / 1000);
            setDuration(duration);
        }
    };
    useEffect(function() {
        if (!startTime) return;
        var shouldTrack = isCallActive && !endTime;
        // Update once immediately
        updateDuration();
        if (shouldTrack) {
            timerId.current = setInterval(updateDuration, 1000);
        }
        // Cleanup function
        return function() {
            if (timerId.current) {
                clearInterval(timerId.current);
                timerId.current = null;
            }
        };
    }, [
        startTime,
        endTime,
        isCallActive
    ]);
    var membersList = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.membersInfo) ? Object.values(callInfo === null || callInfo === void 0 ? void 0 : callInfo.membersInfo) : [];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(DraggableWrapper, {
            initialStyle: {
                left: "50%",
                top: "80%",
                transform: "translateX(-50%)"
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: Styles.main,
                children: /*#__PURE__*/ _jsxs(VerticalFlex, {
                    gap: 12,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Flex, {
                            gap: 12,
                            justifyContent: "center",
                            children: membersList.map(function(member, index) {
                                var ref, ref1;
                                var allowKick = [
                                    PLIVO_CALL_STATUS_TEXT.ANSWERED
                                ].includes((ref = member.remote_meta_info) === null || ref === void 0 ? void 0 : ref.current_status) && (membersList === null || membersList === void 0 ? void 0 : membersList.length) > 1 && index > 0;
                                return /*#__PURE__*/ _jsx(_Fragment, {
                                    children: /*#__PURE__*/ _jsxs(BordererCard, {
                                        className: Styles.person,
                                        padded: false,
                                        children: [
                                            /*#__PURE__*/ _jsx(AppImg, {
                                                src: getImageNameFromURL((member === null || member === void 0 ? void 0 : member.imgUrl) || "default.png"),
                                                alt: "",
                                                width: "40",
                                                height: "40",
                                                className: Styles.personImg
                                            }),
                                            /*#__PURE__*/ _jsxs(VerticalFlex, {
                                                gap: 2,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Typography, {
                                                        weight: "semibold",
                                                        size: "xs",
                                                        children: member === null || member === void 0 ? void 0 : member.name
                                                    }),
                                                    !!(member === null || member === void 0 ? void 0 : member.remote_meta_info) && /*#__PURE__*/ _jsxs(Typography, {
                                                        weight: "semibold",
                                                        size: "xs",
                                                        align: "center",
                                                        textTransform: "uppercase",
                                                        children: [
                                                            "(",
                                                            member === null || member === void 0 ? void 0 : (ref1 = member.remote_meta_info) === null || ref1 === void 0 ? void 0 : ref1.current_status,
                                                            ")"
                                                        ]
                                                    }),
                                                    !!onKick && allowKick && /*#__PURE__*/ _jsx(Button, {
                                                        fillType: "text",
                                                        blockBtn: true,
                                                        color: "danger",
                                                        size: "s",
                                                        onClick: function() {
                                                            return onKick(member.call_uuid);
                                                        },
                                                        children: "REMOVE"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: Styles.action,
                            children: [
                                showMuteBtn && /*#__PURE__*/ _jsx(IconWrapper, {
                                    width: 32,
                                    height: 32,
                                    onClick: onToggleMute,
                                    children: (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isMuted) ? /*#__PURE__*/ _jsx(MicMuteIcon, {}) : /*#__PURE__*/ _jsx(MicIcon, {})
                                }),
                                !!(onHangup || onReject) && /*#__PURE__*/ _jsx(IconWrapper, {
                                    width: 32,
                                    height: 32,
                                    onClick: onHangup ? onHangup : onReject,
                                    children: /*#__PURE__*/ _jsx(RejectIcon, {})
                                }),
                                !!onAnswer && /*#__PURE__*/ _jsx(IconWrapper, {
                                    width: 32,
                                    height: 32,
                                    onClick: onAnswer,
                                    children: /*#__PURE__*/ _jsx(AcceptIcon, {})
                                }),
                                !!onClickAddToConference && /*#__PURE__*/ _jsx(IconWrapper, {
                                    width: 32,
                                    height: 32,
                                    onClick: onClickAddToConference,
                                    children: /*#__PURE__*/ _jsx(PlusIcon, {})
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    gap: 20,
                                    justifyContent: "center",
                                    children: [
                                        (callInfo === null || callInfo === void 0 ? void 0 : callInfo.startTime) ? /*#__PURE__*/ _jsx(Typography, {
                                            weight: "bold",
                                            color: COLORS.RED,
                                            size: "s",
                                            children: callDurationFormattedText
                                        }) : null,
                                        /*#__PURE__*/ _jsx(Typography, {
                                            size: "s",
                                            color: COLORS.WHITE,
                                            children: callInfo === null || callInfo === void 0 ? void 0 : callInfo.callDesc
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var call_ConferenceCallPopup = ((/* unused pure expression or super */ null && (ConferenceCallPopup_ConferenceCallPopup)));

// EXTERNAL MODULE: ./components/quick-action-popup/QuickActionPopup.tsx
var quick_action_popup_QuickActionPopup = __webpack_require__(37372);
// EXTERNAL MODULE: ../core-ui/dist/components/Input/index.js
var components_Input = __webpack_require__(7100);
// EXTERNAL MODULE: ../core/dist/_services/index.js + 6 modules
var _services = __webpack_require__(96122);
// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ../core-ui/dist/constants/index.js
var constants = __webpack_require__(73242);
;// CONCATENATED MODULE: ./components/call/AddToConference.tsx
















var AddToConference_AddToConference = function(param) {
    var onSubmit = param.onSubmit, popupProps = param.popupProps;
    var getPhoneNumberDetails = useSearchCompanyByPhoneNumberMutation();
    var ref = useState(""), phoneNumnber = ref[0], setPhoneNumnber = ref[1];
    var ref1 = useState(), companyDetails = ref1[0], setCompanyDetails = ref1[1];
    var ref2 = useState(false), canContinue = ref2[0], setCanContinue = ref2[1];
    var onChangePhoneInput = function(e) {
        var ref;
        var ref1;
        var val = (ref1 = (ref = e === null || e === void 0 ? void 0 : e.target.value) === null || ref === void 0 ? void 0 : ref.replace(/\D/g, "")) !== null && ref1 !== void 0 ? ref1 : "";
        setPhoneNumnber(val);
        setCompanyDetails(undefined);
        setCanContinue(false);
    };
    useEffect(function() {
        var phoneNumber = extractPhoneNumber(phoneNumnber || "");
        if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.length) === 10) {
            getPhoneNumberDetails.mutate({
                phoneNumber: phoneNumber
            }, {
                onError: function() {},
                onSuccess: function(res) {
                    var ref;
                    if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.length) !== 0) {
                        var ref1;
                        var user = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.at(0);
                        setCompanyDetails(user);
                    }
                },
                onSettled: function() {
                    setCanContinue(true);
                }
            });
        }
    }, [
        phoneNumnber
    ]);
    var ref3 = companyDetails || {}, _name = ref3.name, name = _name === void 0 ? "" : _name, _logo = ref3.logo, logo = _logo === void 0 ? "" : _logo, service_type = ref3.service_type, location_text = ref3.location_text;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(QuickActionPopup, _object_spread_props(_object_spread({
            isOpen: true,
            titleText: "Add To Call"
        }, popupProps), {
            description: /*#__PURE__*/ _jsxs(VerticalFlex, {
                alignItems: "center",
                gap: 60,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: 500
                        },
                        children: /*#__PURE__*/ _jsx(Input, {
                            headingLabel: "Search Customer with phone number",
                            type: "text",
                            value: phoneNumnber || "",
                            onChange: onChangePhoneInput,
                            length: 10,
                            prefixNode: "+91",
                            inputMode: "numeric",
                            outline: "underline"
                        })
                    }),
                    !!(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.id) && /*#__PURE__*/ _jsx(BordererCard, {
                        children: /*#__PURE__*/ _jsx(Flex, {
                            gap: 20,
                            justifyContent: "space-between",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: Styles.person,
                                children: [
                                    /*#__PURE__*/ _jsx(AppImg, {
                                        src: getImageNameFromURL(logo || "default.png"),
                                        alt: "",
                                        width: "60",
                                        height: "60",
                                        className: Styles.personImg
                                    }),
                                    /*#__PURE__*/ _jsxs(VerticalFlex, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Typography, {
                                                weight: "semibold",
                                                size: "sm",
                                                children: name
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                weight: "semibold",
                                                size: "sm",
                                                children: getJoinedStringFromArray([
                                                    service_type,
                                                    location_text
                                                ], DotSymbol)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: function() {
                            return onSubmit({
                                imgUrl: logo,
                                name: name,
                                number: phoneNumnber
                            });
                        },
                        width: 500,
                        isRounded: true,
                        disabled: !canContinue,
                        children: "Merge Call"
                    })
                ]
            })
        }))
    });
};
/* harmony default export */ var call_AddToConference = ((/* unused pure expression or super */ null && (AddToConference_AddToConference)));

// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core-ui/dist/methods/string.js
var string = __webpack_require__(75905);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var hooks_useVahakHttpClient = __webpack_require__(36153);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
;// CONCATENATED MODULE: ./services/call/useCallInitiation.ts





var useCallInitiation_useCallInitiation = function() {
    var POST = useVahakHttpClient().POST;
    var method = function(data) {
        return POST(API.CALL_INITIATE, data);
    };
    return useVahakMutationQuery(QueryNames.call.initiate, method);
};

// EXTERNAL MODULE: ../core-ui/dist/hooks/index.js + 3 modules
var hooks = __webpack_require__(95385);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../core/dist/methods/encryptData.js
var encryptData = __webpack_require__(57302);
;// CONCATENATED MODULE: ./context/call/SharedPlivoSdkProvider.tsx
/* provided dependency */ var process = __webpack_require__(34406);








var SharedPlivoSdkContext = /*#__PURE__*/ (0,react.createContext)({
    isReady: false
});
var SharedPlivoSdkProvider_useSharedPlivoSdk = function() {
    return useContext(SharedPlivoSdkContext);
};
var plivoSdkInitPromise = null;
var getOrCreatePlivoSdk = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!plivoSdkInitPromise) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", plivoSdkInitPromise);
                case 2:
                    plivoSdkInitPromise = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                        var isProd, PlivoBrowserSdk, sdk;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    isProd = process.env.NEXT_PUBLIC_REACT_APP_ENV === misc/* PRODUCTION_ENV */.vE;
                                    _ctx.next = 3;
                                    return __webpack_require__.e(/* import() */ 5699).then(__webpack_require__.t.bind(__webpack_require__, 97278, 23));
                                case 3:
                                    PlivoBrowserSdk = _ctx.sent.default;
                                    sdk = new PlivoBrowserSdk({
                                        debug: isProd ? "OFF" : "ALL",
                                        permOnClick: true,
                                        enableTracking: false,
                                        codecs: [
                                            "OPUS",
                                            "PCMU"
                                        ],
                                        enableIPV6: false,
                                        audioConstraints: {
                                            optional: [
                                                {
                                                    googAutoGainControl: false
                                                }
                                            ]
                                        },
                                        closeProtection: true,
                                        enableNoiseReduction: true
                                    });
                                    sdk.client.setRingToneBack(false);
                                    return _ctx.abrupt("return", sdk);
                                case 7:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }))();
                    return _ctx.abrupt("return", plivoSdkInitPromise);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOrCreatePlivoSdk() {
        return _ref.apply(this, arguments);
    };
}();
var SharedPlivoSdkProvider_SharedPlivoSdkProvider = function(param) {
    var children = param.children;
    var ref = useContext(AppContext), plivoCred = ref.plivoCred, companyId = ref.companyId;
    var ref1 = useState(), plivoBrowserSdk = ref1[0], setPlivoBrowserSdk = ref1[1];
    var ref2 = useState(false), isReady = ref2[0], setIsReady = ref2[1];
    useEffect(function() {
        var cancelled = false;
        getOrCreatePlivoSdk().then(function(sdk) {
            if (!cancelled) {
                setPlivoBrowserSdk(sdk);
            }
        }).catch(function() {
            plivoSdkInitPromise = null;
        });
        return function() {
            cancelled = true;
        };
    }, []);
    useEffect(function() {
        if (!plivoBrowserSdk || !(plivoCred === null || plivoCred === void 0 ? void 0 : plivoCred.plivo_user_id)) {
            return;
        }
        var client = plivoBrowserSdk.client;
        var onLogin = function() {
            return setIsReady(true);
        };
        var onLoginFailed = function(reason) {
            toast.error("Plivo ".concat(reason));
            setIsReady(false);
        };
        var onLogout = function() {
            return setIsReady(false);
        };
        client.on("onLogin", onLogin);
        client.on("onLoginFailed", onLoginFailed);
        client.on("onLogout", onLogout);
        if (client.isLoggedIn) {
            setIsReady(true);
        } else {
            var config = {
                key: process.env.NEXT_PUBLIC_ENC_KEY,
                iv: process.env.NEXT_PUBLIC_ENC_IV
            };
            try {
                var password = decryptData(plivoCred.plivo_password, config);
                client.login(plivoCred.plivo_user_id, password);
            } catch (e) {
                toast.error("Not registed to use Plvio");
            }
        }
        return function() {
            client.off("onLogin", onLogin);
            client.off("onLoginFailed", onLoginFailed);
            client.off("onLogout", onLogout);
        };
    }, [
        plivoBrowserSdk,
        plivoCred
    ]);
    useEffect(function() {
        var ref;
        if ((plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.isLoggedIn) && !companyId) {
            plivoBrowserSdk.client.logout();
            setIsReady(false);
        }
    }, [
        companyId,
        plivoBrowserSdk
    ]);
    return /*#__PURE__*/ _jsx(SharedPlivoSdkContext.Provider, {
        value: {
            plivoBrowserSdk: plivoBrowserSdk,
            isReady: isReady
        },
        children: children
    });
};

// EXTERNAL MODULE: ../core/dist/icons/Call_CTA_BLUE.svg
var Call_CTA_BLUE = __webpack_require__(27335);
;// CONCATENATED MODULE: ../core/dist/icons/phone-user.svg
var phone_user_g, phone_user_defs;

function phone_user_extends() { phone_user_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return phone_user_extends.apply(this, arguments); }



function SvgPhoneUser(props) {
  return /*#__PURE__*/React.createElement("svg", phone_user_extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), phone_user_g || (phone_user_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone-user_svg__clip0_14456_52496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.718 155.971C504.775 186.701 512 220.507 512 256c0 141.38-114.62 256-256 256-38.339 0-74.71-8.43-107.361-23.536a101.87 101.87 0 0022.59-22.88A226.08 226.08 0 00344 464.25a226.064 226.064 0 00133.466-253.088 226.082 226.082 0 00-10.427-35.886 101.642 101.642 0 0024.679-19.305zM256 0c31.664 0 61.986 5.75 89.979 16.262a101.513 101.513 0 00-18.244 25.454A226.023 226.023 0 00256 30a224.5 224.5 0 00-88 17.75A226.081 226.081 0 0038.96 319.29a101.7 101.7 0 00-25.031 20.213C4.902 313.331 0 285.238 0 256 0 114.62 114.62 0 256 0zM89.002 324.35c-45.573 0-82.65 37.077-82.65 82.65 0 45.573 37.076 82.65 82.65 82.65 45.573 0 82.65-37.077 82.65-82.65 0-45.573-37.077-82.65-82.65-82.65z",
    fill: "#2355FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.239 384.848c0-18.348-14.904-33.236-33.236-33.236-18.332 0-33.236 14.888-33.236 33.236 0 18.332 14.904 33.236 33.236 33.236 18.332 0 33.236-14.904 33.236-33.236zM32.832 455.838c13.667 15.698 33.772 25.65 56.171 25.65 22.4 0 42.505-9.952 56.172-25.65l-2.008-6.689c-4.228-14.055-17.157-23.686-31.832-23.686H66.672c-14.675 0-27.604 9.631-31.832 23.686l-2.008 6.689z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.002 4.35c-45.573 0-82.65 37.077-82.65 82.65 0 45.573 37.077 82.65 82.65 82.65 45.573 0 82.65-37.077 82.65-82.65 0-45.573-37.077-82.65-82.65-82.65z",
    fill: "#2355FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.239 64.848c0-18.348-14.904-33.236-33.236-33.236-18.332 0-33.236 14.888-33.236 33.236 0 18.332 14.904 33.236 33.236 33.236 18.332 0 33.236-14.904 33.236-33.236zM361.832 135.838c13.667 15.698 33.772 25.65 56.171 25.65 22.4 0 42.505-9.952 56.172-25.65l-2.008-6.689c-4.228-14.055-17.157-23.686-31.832-23.686h-44.663c-14.675 0-27.604 9.631-31.832 23.686l-2.008 6.689z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.689 378.87c-14.87-1-35.83-6.13-56.29-13.45-72.14-25.82-142.53-94.61-157.49-190.83-2.66-17.13.14-32.78 13.12-45.52 4.35-4.26 8.22-9 12.47-13.36 16-16.47 39.38-16.89 55.95-1.07 5.25 5 10.59 9.93 15.71 15.09a38.072 38.072 0 011.37 52.79c-4 4.44-8.2 8.66-12.42 12.87-4.61 4.6-10.34 7.24-16.49 9.16-7.59 2.38-9 5.56-5.55 12.81 21.8 45.66 55.923 78.537 102.37 98.63 6.21 2.68 9.08 1.47 11.58-4.69 5.48-13.51 15.53-23.36 27.08-31.32 13.07-9 31.79-7 44.17 3.64a263.117 263.117 0 0119.43 18.5 38.224 38.224 0 01-.05 52.25c-1.93 2.1-3.92 4.15-5.77 6.31-11.14 12.95-25.27 19.01-49.19 18.19z",
    fill: "#2355FC"
  }))), phone_user_defs || (phone_user_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone-user_svg__clip0_14456_52496"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })))));
}

/* harmony default export */ var phone_user = ((/* unused pure expression or super */ null && (SvgPhoneUser)));
// EXTERNAL MODULE: ../core/dist/_services/auth.adminConsole.service.js
var auth_adminConsole_service = __webpack_require__(72207);
;// CONCATENATED MODULE: ./services/call/useConferenceCall.ts




var useConferenceCall_useConferenceCall = function() {
    var POST = useVahakHttpClient().POST;
    var method = function(data) {
        return POST(API.CONFERENCE_INITIATE, data);
    };
    return useVahakMutationQuery(QueryNames.call.conferenceInitiate, method);
};
var useConferenceCall_useConferenceCallKick = function() {
    var POST = useVahakHttpClient().POST;
    var method = function(data) {
        return POST(API.CONFERENCE_KICKOUT, data);
    };
    return useVahakMutationQuery(QueryNames.call.conferenceKick, method);
};
var useConferenceCall_useConferenceCallEnd = function() {
    var POST = useVahakHttpClient().POST;
    var method = function(data) {
        return POST(API.CONFERENCE_END, data);
    };
    return useVahakMutationQuery(QueryNames.call.conferenceEnd, method);
};

// EXTERNAL MODULE: ../../node_modules/firebase/firestore/dist/esm/index.esm.js + 3 modules
var index_esm = __webpack_require__(97357);
// EXTERNAL MODULE: ../core/dist/_services/firebase.service.js + 1 modules
var firebase_service = __webpack_require__(44681);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var dist_constants = __webpack_require__(94204);
;// CONCATENATED MODULE: ./services/call/useRealtimeCallInfo.ts
/* provided dependency */ var useRealtimeCallInfo_process = __webpack_require__(34406);





var useRealtimeCallInfo_useRealtimeCallInfo = function(param) {
    var mpcName = param.mpcName, enabled = param.enabled, onUpdate = param.onUpdate;
    var ref = useState([]), data = ref[0], setData = ref[1];
    useEffect(function() {
        if (!enabled || !mpcName) {
            setData([]);
            return;
        }
        var env = useRealtimeCallInfo_process.env.NEXT_PUBLIC_REACT_APP_ENV === PRODUCTION_ENV ? "prod" : "dev";
        var colRef = collection(db, "conference_call_status", env, mpcName);
        var unsubscribe = onSnapshot(colRef, function(snapshot) {
            if (snapshot.empty) {
                setData([]);
                return;
            }
            var docs = snapshot.docs.map(function(doc) {
                return _object_spread({
                    id: doc.id
                }, doc.data());
            });
            setData(docs);
            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(docs);
        });
        return function() {
            unsubscribe();
            setData([]);
        };
    }, [
        mpcName,
        enabled
    ]);
    return {
        data: data
    };
};
/* harmony default export */ var call_useRealtimeCallInfo = ((/* unused pure expression or super */ null && (useRealtimeCallInfo_useRealtimeCallInfo)));

;// CONCATENATED MODULE: ./context/call/BrowerClickToCallProviderMpc.tsx











// Components




// Constants


// Methods


// Hooks



// Assets





// ✅ Create Context
var CallPopupContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
var MAX_ALLOWED_CONFERENCE_MEMBER = 3;
var BrowerClickToCallProviderMpc_MpcClickToCallProvider = function(param) {
    var children = param.children;
    var ref = useContext(AppContext), companyId = ref.companyId, phoneNum = ref.phoneNum, route = ref.route;
    var ref1 = useSharedPlivoSdk(), plivoBrowserSdk = ref1.plivoBrowserSdk, isReady = ref1.isReady;
    var ref2 = useState({}), callInfo = ref2[0], setCallInfo = ref2[1];
    var getPhoneNumberDetails = useSearchCompanyByPhoneNumberMutation();
    var callIntitate = useCallInitiation();
    var conferenceIntitate = useConferenceCall();
    var conferenceKick = useConferenceCallKick();
    var conferenceEnd = useConferenceCallEnd();
    var conferencePopup = useToggleModalWithLocalState(false);
    var addToConferencePopup = useToggleModalWithLocalState(false);
    var ref3 = useState(""), mpcCallToResume = ref3[0], setMpcCallToResume = ref3[1];
    var ref4 = useState([]), pendingConferencePhones = ref4[0], setPendingConferencePhones = ref4[1];
    var mpcCallToResumeRef = useRef(mpcCallToResume);
    mpcCallToResumeRef.current = mpcCallToResume;
    var memberList = Object.values((callInfo === null || callInfo === void 0 ? void 0 : callInfo.membersInfo) || {});
    var normalizeConferencePhone = function(phone) {
        return extractPhoneNumber(phone || "") || "";
    };
    var isPhoneInConference = function(phone) {
        var normalizedPhone = normalizeConferencePhone(phone);
        if (!normalizedPhone) {
            return false;
        }
        var isPending = pendingConferencePhones.some(function(pendingPhone) {
            return normalizeConferencePhone(pendingPhone) === normalizedPhone;
        });
        if (isPending) {
            return true;
        }
        return memberList.findIndex(function(member) {
            return normalizeConferencePhone((member === null || member === void 0 ? void 0 : member.memberPhoneNumber) || (member === null || member === void 0 ? void 0 : member.number)) === normalizedPhone;
        }) >= 0;
    };
    var addPendingConferencePhone = function(phone) {
        var normalizedPhone = normalizeConferencePhone(phone);
        if (!normalizedPhone) {
            return;
        }
        setPendingConferencePhones(function(prev) {
            return prev.some(function(pendingPhone) {
                return normalizeConferencePhone(pendingPhone) === normalizedPhone;
            }) ? prev : _to_consumable_array(prev).concat([
                phone
            ]);
        });
    };
    var removePendingConferencePhone = function(phone) {
        var normalizedPhone = normalizeConferencePhone(phone);
        if (!normalizedPhone) {
            return;
        }
        setPendingConferencePhones(function(prev) {
            return prev.filter(function(pendingPhone) {
                return normalizeConferencePhone(pendingPhone) !== normalizedPhone;
            });
        });
    };
    var showCallAcceptAction = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) && (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isIncomingCall) && !(callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected);
    var showCallHanguptAction = ((callInfo === null || callInfo === void 0 ? void 0 : callInfo.isIncomingCall) ? callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected : callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) && (!mpcCallToResume || memberList.some(function(m) {
        var ref;
        return [
            PLIVO_CALL_STATUS_TEXT.ANSWERED,
            PLIVO_CALL_STATUS_TEXT.HANGUP
        ].includes((ref = m.remote_meta_info) === null || ref === void 0 ? void 0 : ref.current_status);
    }));
    var showCallRejectAction = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isIncomingCall) && (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) && !(callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected);
    var allowMoreParticipant = memberList.length + pendingConferencePhones.length < MAX_ALLOWED_CONFERENCE_MEMBER;
    var showAddToConference = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) && (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected) && allowMoreParticipant;
    var updateCallInfo = function(data) {
        return setCallInfo(function(v) {
            return _object_spread({}, v, data);
        });
    };
    // CTA
    var toggleMute = function() {
        var ref, ref1;
        setCallInfo(function(v) {
            return _object_spread_props(_object_spread({}, v), {
                isMuted: !v.isMuted
            });
        });
        (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isMuted) ? plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.unmute() : plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref1 = plivoBrowserSdk.client) === null || ref1 === void 0 ? void 0 : ref1.mute();
    };
    var onHangup = function() {
        console.error("onHangup ~ onHangup CALLED");
        try {
            // onCallTerminated will get triggered
            onEnd();
        // setTimeout(() => {
        //     plivoBrowserSdk?.client?.hangup();
        // }, 1000);
        } catch (error) {
            console.error("onHangup ~ error:", error);
        }
    };
    var onReject = function() {
        var ref;
        plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.reject("");
    // onCallFailed will get triggered
    };
    var onAnswer = function(uid) {
        var _uid = uid || (callInfo === null || callInfo === void 0 ? void 0 : callInfo.callUUID);
        if (_uid) {
            var ref;
            plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.answer(_uid, "reject");
        //onCallAnswered
        }
    };
    var append91 = function(n) {
        var _number = extractPhoneNumber(n || "");
        return _number ? "91".concat(_number) : "";
    };
    var startCall = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(meta, callInitiateParams) {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return addToConference(mpcCallToResumeRef.current, meta, callInitiateParams);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function startCall(meta, callInitiateParams) {
            return _ref.apply(this, arguments);
        };
    }();
    var reset = function() {
        var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2000;
        setMpcCallToResume("");
        setPendingConferencePhones([]);
        setTimeout(function() {
            setCallInfo({
                popupActive: false,
                isCallActive: false,
                isConnected: false
            });
        }, delay);
        addToConferencePopup.closeModal();
    };
    var Events = {
        // Outbound Start
        onCalling: function() {
            for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                arr[_key] = arguments[_key];
            }
            console.error("onCalling ~ arr:", arr);
            updateCallInfo({
                callDesc: "Connecting",
                popupActive: true,
                isOutgoingCall: true,
                isCallActive: true
            });
        },
        onCallRemoteRinging: function(_callInfo) {
            console.error("onCallRemoteRinging ~ arr:", {
                _callInfo: _callInfo
            });
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Ringing"
            }));
        },
        onCallConnected: function(_callInfo) {
            console.error("onCallConnected ~ arr:", _callInfo);
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Connected"
            }));
        },
        onCallFailed: function(reason, _callInfo) {
            console.error("onCallFailed ", {
                reason: reason,
                _callInfo: _callInfo
            });
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: reason,
                isCallActive: false,
                isConnected: false
            }));
            reset();
        },
        onCallAnswered: function(_callInfo) {
            console.error("onCallAnswered ~ arr:", _callInfo);
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Answered",
                isConnected: true,
                startTime: new Date()
            }));
        },
        onCallTerminated: function(hangUpInfo, _callInfo) {
            console.error("onCallTerminated ~ arr:", {
                hangUpInfo: hangUpInfo,
                _callInfo: _callInfo,
                callInfo: callInfo
            });
            updateCallInfo({
                callDesc: "Call Ended",
                isCallActive: false,
                isConnected: false,
                endTime: new Date()
            });
            reset();
            playCallTerminatedTone(2, 200);
        },
        onIncomingCall: function(callerID, extraHeaders, _callInfo, callerName) {
            console.error("onIncomingCall ~ arr:", {
                callerID: callerID,
                extraHeaders: extraHeaders,
                _callInfo: _callInfo,
                callerName: callerName
            });
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Incoming Call",
                popupActive: true,
                isCallActive: true,
                isIncomingCall: true
            }));
        // setTimeout(() => {
        //     onAnswer(_callInfo?.callUUID);
        // }, 1000);
        },
        onIncomingCallCanceled: function() {
            for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                arr[_key] = arguments[_key];
            }
            console.error("onIncomingCallCanceled ~ arr:", arr);
            updateCallInfo({
                callDesc: "Incoming Call Cancelled By User",
                isCallActive: false,
                isConnected: false
            });
            reset();
        }
    };
    useRealtimeCallInfo({
        enabled: !!mpcCallToResume && !!(callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive),
        mpcName: mpcCallToResume,
        onUpdate: function onUpdate(data) {
            if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
                setCallInfo(function(prev) {
                    var updatedMembersInfo = _object_spread({}, prev.membersInfo || {});
                    data.forEach(function(member) {
                        var ref;
                        var memberPhn = (ref = member.initiation_json) === null || ref === void 0 ? void 0 : ref.To;
                        if (!memberPhn || !updatedMembersInfo[memberPhn]) return;
                        if (member.current_status === PLIVO_CALL_STATUS_TEXT.HANGUP) {
                            if ((data === null || data === void 0 ? void 0 : data.length) === 2) {
                                onHangup();
                            } else {
                                delete updatedMembersInfo[memberPhn];
                            }
                            return;
                        }
                        updatedMembersInfo[memberPhn].remote_meta_info = member;
                    });
                    return _object_spread_props(_object_spread({}, prev), {
                        membersInfo: updatedMembersInfo
                    });
                });
            }
        }
    });
    useEffect(function() {
        if (!plivoBrowserSdk) {
            return;
        }
        var client = plivoBrowserSdk.client;
        var callEvents = [
            [
                "onCalling",
                Events.onCalling
            ],
            [
                "onCallConnected",
                Events.onCallConnected
            ],
            [
                "onCallAnswered",
                Events.onCallAnswered
            ],
            [
                "onCallRemoteRinging",
                Events.onCallRemoteRinging
            ],
            [
                "onCallFailed",
                Events.onCallFailed
            ],
            [
                "onCallTerminated",
                Events.onCallTerminated
            ],
            [
                "onIncomingCall",
                Events.onIncomingCall
            ],
            [
                "onIncomingCallCanceled",
                Events.onIncomingCallCanceled
            ]
        ];
        callEvents.forEach(function(param) {
            var _param = _sliced_to_array(param, 2), event = _param[0], handler = _param[1];
            return client.on(event, handler);
        });
        return function() {
            callEvents.forEach(function(param) {
                var _param = _sliced_to_array(param, 2), event = _param[0], handler = _param[1];
                return client.off(event, handler);
            });
        };
    }, [
        plivoBrowserSdk,
        companyId
    ]);
    var registerCallCta = function(meta, callInitiateParams) {
        if (isPhoneInConference(meta === null || meta === void 0 ? void 0 : meta.number)) {
            return null;
        }
        var activeMpcName = mpcCallToResumeRef.current;
        var isConferenceSessionActive = Boolean(activeMpcName || (callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive) || (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) || pendingConferencePhones.length);
        if (isReady && (meta === null || meta === void 0 ? void 0 : meta.number) && allowMoreParticipant) {
            if (isConferenceSessionActive) {
                if (!activeMpcName) {
                    return null;
                }
                return /*#__PURE__*/ _jsx(IconWrapper, {
                    width: 32,
                    height: 32,
                    onClick: function() {
                        return addToConference(activeMpcName, meta, callInitiateParams);
                    },
                    children: /*#__PURE__*/ _jsx(ConfernceCallIconMobile, {})
                });
            }
            return /*#__PURE__*/ _jsx(IconWrapper, {
                onClick: function() {
                    return startCall(meta, callInitiateParams);
                },
                children: /*#__PURE__*/ _jsx(CallIconMobile, {})
            });
        }
        return null;
    };
    var addToConference = function(mpcName, meta, callInitiateParams) {
        return new Promise(function(resolve) {
            var number = (meta || {}).number;
            var reqNumber = append91(number || "");
            var agentNumber = append91(String(phoneNum) || "");
            if (!reqNumber) {
                return resolve(0);
            }
            addPendingConferencePhone(reqNumber);
            updateCallInfo({
                popupActive: true,
                isOutgoingCall: true,
                isCallActive: true,
                callDesc: mpcName ? "Adding to conference" : "Connecting"
            });
            conferenceIntitate.mutateAsync(_object_spread_props(_object_spread({
                screen_name: route
            }, callInitiateParams, mpcName ? {
                mpc_name: mpcName
            } : {
                agent: agentNumber
            }), {
                customers: [
                    reqNumber
                ]
            }), {
                onSuccess: function onSuccess(data) {
                    var ref, ref1, ref2, ref3;
                    var resolvedMpcName = (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.mpc_name) || mpcName;
                    if (resolvedMpcName) {
                        setMpcCallToResume(resolvedMpcName);
                    }
                    var memberInfo = data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.users) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.customers) === null || ref3 === void 0 ? void 0 : ref3.find(function(member) {
                        return reqNumber === (member === null || member === void 0 ? void 0 : member.phone);
                    });
                    if (memberInfo) {
                        setCallInfo(function(i) {
                            var ref;
                            return _object_spread_props(_object_spread({}, i), {
                                mpcUuid: data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.mpc_uuid,
                                membersInfo: _object_spread_props(_object_spread({}, i["membersInfo"]), _define_property({}, memberInfo.phone, _object_spread_props(_object_spread({}, meta), {
                                    call_uuid: memberInfo.call_uuid,
                                    memberPhoneNumber: memberInfo.phone
                                })))
                            });
                        });
                    }
                    removePendingConferencePhone(reqNumber);
                    resolve(0);
                },
                onError: function(err) {
                    removePendingConferencePhone(reqNumber);
                    (err === null || err === void 0 ? void 0 : err.message) && toast.error("Unable to add");
                }
            });
        });
    };
    var onSubmitAddConferenceCall = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(meta) {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isPhoneInConference(meta === null || meta === void 0 ? void 0 : meta.number)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", toast.error("Already In Call"));
                    case 2:
                        addToConferencePopup === null || addToConferencePopup === void 0 ? void 0 : addToConferencePopup.toggleModal();
                        _ctx.next = 5;
                        return addToConference(mpcCallToResumeRef.current, meta, {});
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmitAddConferenceCall(meta) {
            return _ref.apply(this, arguments);
        };
    }();
    var onKick = function(cuid) {
        var _obj;
        conferenceKick.mutateAsync({
            call_uuid: cuid,
            mpc_name: mpcCallToResume
        }, (_obj = {}, _define_property(_obj, "onSuccess", function onSuccess(data) {
            var memberInfo = memberList === null || memberList === void 0 ? void 0 : memberList.find(function(member) {
                return cuid === (member === null || member === void 0 ? void 0 : member.call_uuid);
            });
            if (!memberInfo) return;
            setCallInfo(function(prev) {
                var _ref = prev.membersInfo || {}, _memberPhoneNumber = memberInfo.memberPhoneNumber, _ = _ref[_memberPhoneNumber], restMembers = _object_without_properties(_ref, [
                    _memberPhoneNumber
                ].map(_to_property_key));
                return _object_spread_props(_object_spread({}, prev), {
                    membersInfo: restMembers
                });
            });
        }), _define_property(_obj, "onError", function(err) {
            (err === null || err === void 0 ? void 0 : err.message) && toast.error("You cannot remove the user");
        }), _obj));
    };
    var onEnd = function() {
        conferenceEnd.mutateAsync({
            mpc_name: mpcCallToResume
        }, {
            onSuccess: function onSuccess(data) {},
            onError: function(err) {
                (err === null || err === void 0 ? void 0 : err.message) && toast.error("Error while end");
            }
        });
    };
    var startCallRef = useRef(startCall);
    var registerCallCtaRef = useRef(registerCallCta);
    startCallRef.current = startCall;
    registerCallCtaRef.current = registerCallCta;
    var stableStartCall = useCallback(function(meta, callInitiateParams) {
        return startCallRef.current(meta, callInitiateParams);
    }, []);
    var stableRegisterCallCta = useCallback(function(meta, callInitiateParams) {
        return registerCallCtaRef.current(meta, callInitiateParams);
    }, []);
    var contextValue = useMemo(function() {
        return {
            startCall: stableStartCall,
            registerCallCta: stableRegisterCallCta,
            isReady: isReady,
            isCallSessionActive: Boolean((callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive) || (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) || mpcCallToResume || pendingConferencePhones.length),
            callCtaStateKey: [
                mpcCallToResume
            ].concat(_to_consumable_array(memberList.map(function(member) {
                return normalizeConferencePhone(member.memberPhoneNumber || member.number);
            })), _to_consumable_array(pendingConferencePhones.map(function(phone) {
                return normalizeConferencePhone(phone);
            })), [
                String(allowMoreParticipant),
                String(callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive)
            ]).join("|")
        };
    }, [
        isReady,
        callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive,
        callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive,
        mpcCallToResume,
        memberList,
        pendingConferencePhones,
        allowMoreParticipant,
        stableStartCall,
        stableRegisterCallCta
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isReady && !!(callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive) && /*#__PURE__*/ _jsx(ConferenceCallPopup, _object_spread({
                onToggleMute: toggleMute,
                callInfo: callInfo
            }, showCallAcceptAction && {
                onAnswer: onAnswer
            }, showCallHanguptAction && {
                onHangup: onHangup,
                onKick: onKick
            }, showAddToConference && {
                onClickAddToConference: addToConferencePopup === null || addToConferencePopup === void 0 ? void 0 : addToConferencePopup.toggleModal
            })),
            (addToConferencePopup === null || addToConferencePopup === void 0 ? void 0 : addToConferencePopup.isModalOpen) && /*#__PURE__*/ _jsx(AddToConference, {
                onSubmit: onSubmitAddConferenceCall,
                popupProps: {
                    onToggle: addToConferencePopup === null || addToConferencePopup === void 0 ? void 0 : addToConferencePopup.toggleModal
                }
            }),
            /*#__PURE__*/ _jsx(CallPopupContext.Provider, {
                value: contextValue,
                children: children
            })
        ]
    });
};
// ✅ Custom Hook for Using Context
var BrowerClickToCallProviderMpc_useMpcClickToCall = function() {
    var context = useContext(CallPopupContext);
    return context;
};

;// CONCATENATED MODULE: ./components/call/CallPopup.tsx
















var CallPopup_CallPopup = function(param) {
    var onHangup = param.onHangup, onToggleMute = param.onToggleMute, callInfo = param.callInfo, onAnswer = param.onAnswer, onReject = param.onReject, onClickAddToConference = param.onClickAddToConference;
    var ref, ref1;
    var ref2 = callInfo || {}, startTime = ref2.startTime, endTime = ref2.endTime, isCallActive = ref2.isCallActive;
    var timerId = useRef();
    var ref3 = useState(0), duration = ref3[0], setDuration = ref3[1];
    var showMuteBtn = callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected;
    var ref4 = convertSecondsTime(duration), m = ref4.m, s = ref4.s, h = ref4.h;
    var hour = h.toString().padStart(2, "0");
    var min = m.toString().padStart(2, "0");
    var sec = s.toString().padStart(2, "0");
    var callDurationFormattedText = "".concat(h ? "".concat(hour, ":") : "").concat(min, ":").concat(sec);
    var updateDuration = function() {
        if (startTime) {
            var ref;
            var A = startTime.getTime();
            var B = (endTime === null || endTime === void 0 ? void 0 : (ref = endTime.getTime) === null || ref === void 0 ? void 0 : ref.call(endTime)) || Date.now();
            var duration = Math.ceil((B - A) / 1000);
            setDuration(duration);
        }
    };
    useEffect(function() {
        if (!startTime) return;
        var shouldTrack = isCallActive && !endTime;
        // Update once immediately
        updateDuration();
        if (shouldTrack) {
            timerId.current = setInterval(updateDuration, 1000);
        }
        // Cleanup function
        return function() {
            if (timerId.current) {
                clearInterval(timerId.current);
                timerId.current = null;
            }
        };
    }, [
        startTime,
        endTime,
        isCallActive
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(DraggableWrapper, {
            initialStyle: {
                left: "50%",
                top: "80%",
                transform: "translateX(-50%)"
            },
            children: /*#__PURE__*/ _jsxs("div", {
                className: Styles.main,
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        gap: 20,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: Styles.person,
                                children: [
                                    /*#__PURE__*/ _jsx(AppImg, {
                                        src: getImageNameFromURL((callInfo === null || callInfo === void 0 ? void 0 : (ref = callInfo.calleInfomation) === null || ref === void 0 ? void 0 : ref.imgUrl) || "default.png"),
                                        alt: "",
                                        width: "60",
                                        height: "60",
                                        className: Styles.personImg
                                    }),
                                    /*#__PURE__*/ _jsx(VerticalFlex, {
                                        gap: 8,
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            weight: "semibold",
                                            size: "sm",
                                            color: COLORS.WHITE,
                                            children: callInfo === null || callInfo === void 0 ? void 0 : (ref1 = callInfo.calleInfomation) === null || ref1 === void 0 ? void 0 : ref1.name
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: Styles.action,
                                children: [
                                    showMuteBtn && /*#__PURE__*/ _jsx(IconWrapper, {
                                        width: 50,
                                        height: 50,
                                        onClick: onToggleMute,
                                        children: (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isMuted) ? /*#__PURE__*/ _jsx(MicMuteIcon, {}) : /*#__PURE__*/ _jsx(MicIcon, {})
                                    }),
                                    !!(onHangup || onReject) && /*#__PURE__*/ _jsx(IconWrapper, {
                                        width: 50,
                                        height: 50,
                                        onClick: onHangup ? onHangup : onReject,
                                        children: /*#__PURE__*/ _jsx(RejectIcon, {})
                                    }),
                                    !!onAnswer && /*#__PURE__*/ _jsx(IconWrapper, {
                                        width: 50,
                                        height: 50,
                                        onClick: onAnswer,
                                        children: /*#__PURE__*/ _jsx(AcceptIcon, {})
                                    }),
                                    !!onClickAddToConference && /*#__PURE__*/ _jsx(IconWrapper, {
                                        width: 50,
                                        height: 50,
                                        onClick: onClickAddToConference,
                                        children: /*#__PURE__*/ _jsx(PlusIcon, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        gap: 20,
                        children: [
                            (callInfo === null || callInfo === void 0 ? void 0 : callInfo.startTime) ? /*#__PURE__*/ _jsx(Typography, {
                                weight: "bold",
                                color: COLORS.RED,
                                size: "s",
                                children: callDurationFormattedText
                            }) : null,
                            /*#__PURE__*/ _jsx(Typography, {
                                size: "s",
                                color: COLORS.WHITE,
                                children: callInfo === null || callInfo === void 0 ? void 0 : callInfo.callDesc
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var call_CallPopup = ((/* unused pure expression or super */ null && (CallPopup_CallPopup)));

;// CONCATENATED MODULE: ./context/call/BrowerClickToCallProviderOld.tsx





// Components



// Constants

// Methods

// Hooks


// Assets



// ✅ Create Context
var BrowerClickToCallProviderOld_CallPopupContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
var BrowerClickToCallProviderOld_SingleClickToCallProvider = function(param) {
    var children = param.children;
    var ref = useContext(AppContext), companyId = ref.companyId, route = ref.route;
    var ref1 = useSharedPlivoSdk(), plivoBrowserSdk = ref1.plivoBrowserSdk, isReady = ref1.isReady;
    var ref2 = useState({}), callInfo = ref2[0], setCallInfo = ref2[1];
    var getPhoneNumberDetails = useSearchCompanyByPhoneNumberMutation();
    var callIntitate = useCallInitiation();
    var updateCallInfo = function(data) {
        return setCallInfo(function(v) {
            return _object_spread({}, v, data);
        });
    };
    // CTA
    var toggleMute = function() {
        var ref, ref1;
        setCallInfo(function(v) {
            return _object_spread_props(_object_spread({}, v), {
                isMuted: !v.isMuted
            });
        });
        (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isMuted) ? plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.unmute() : plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref1 = plivoBrowserSdk.client) === null || ref1 === void 0 ? void 0 : ref1.mute();
    };
    var onHangup = function() {
        try {
            var ref;
            plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.hangup();
        // onCallTerminated will get triggered
        } catch (error) {
            console.error("onHangup ~ error:", error);
        }
    };
    var onReject = function() {
        var ref;
        plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.reject("");
    // onCallFailed will get triggered
    };
    var onAnswer = function() {
        if (callInfo === null || callInfo === void 0 ? void 0 : callInfo.callUUID) {
            var ref;
            plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.answer(callInfo === null || callInfo === void 0 ? void 0 : callInfo.callUUID, "reject");
        //onCallAnswered
        }
    };
    var updateUserDetails = function(phone_number) {
        var reqNumber = extractPhoneNumber(phone_number || "");
        if (reqNumber) {
            getPhoneNumberDetails.mutate({
                phoneNumber: reqNumber
            }, {
                onError: function() {},
                onSuccess: function(res) {
                    var ref;
                    if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.length) !== 0) {
                        var ref1;
                        var user = res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.at(0);
                        updateCallInfo({
                            calleInfomation: {
                                imgUrl: user === null || user === void 0 ? void 0 : user.logo,
                                name: user === null || user === void 0 ? void 0 : user.name,
                                number: phone_number
                            }
                        });
                    }
                }
            });
        }
    };
    // Helper
    var startCall = function(meta, callInitiateParams) {
        if ((callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) || (callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive)) {
            return;
        }
        var payload = _object_spread_props(_object_spread({}, callInitiateParams), {
            caller_id: (callInitiateParams === null || callInitiateParams === void 0 ? void 0 : callInitiateParams.caller_id) || Number(companyId)
        });
        return new Promise(function(resolve) {
            var number = (meta || {}).number;
            var reqNumber = extractPhoneNumber(number || "");
            callIntitate === null || callIntitate === void 0 ? void 0 : callIntitate.mutateAsync(payload, {
                onSuccess: function() {
                    var ref;
                    if (reqNumber && (plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : (ref = plivoBrowserSdk.client) === null || ref === void 0 ? void 0 : ref.isLoggedIn)) {
                        setCallInfo({
                            calleInfomation: meta,
                            callInitiateParams: payload,
                            popupActive: true,
                            isOutgoingCall: true,
                            isCallActive: true,
                            callDesc: "Connecting"
                        });
                        plivoBrowserSdk === null || plivoBrowserSdk === void 0 ? void 0 : plivoBrowserSdk.client.call("91".concat(reqNumber), _object_spread({}, payload.reference_id != null && {
                            "X-PH-reference-id": String(payload.reference_id)
                        }, payload.reference_type != null && {
                            "X-PH-reference-type": String(payload.reference_type)
                        }, payload.caller_id != null && {
                            "X-PH-caller-id": String(payload.caller_id)
                        }, payload.callee_id != null && {
                            "X-PH-callee-id": String(payload.callee_id)
                        }, payload.load_id != null && {
                            "X-PH-load-id": String(payload.load_id)
                        }, payload.lorry_id != null && {
                            "X-PH-lorry-id": String(payload.lorry_id)
                        }, payload.bid_id != null && {
                            "X-PH-bid-id": String(payload.bid_id)
                        }, payload.ticket_id != null && {
                            "X-PH-ticket-id": String(payload.ticket_id)
                        }, route && {
                            "X-PH-screen-name": route
                        }));
                        resolve(0);
                    }
                },
                onError: function(err) {
                    (err === null || err === void 0 ? void 0 : err.message) && toast.error(err === null || err === void 0 ? void 0 : err.message);
                }
            });
        });
    };
    var reset = function() {
        var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2000;
        setTimeout(function() {
            setCallInfo({
                popupActive: false,
                isCallActive: false,
                isConnected: false
            });
        }, delay);
    };
    var Events = {
        // Outbound Start
        onCalling: function() {
            for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                arr[_key] = arguments[_key];
            }
            console.error("onCalling ~ arr:", arr);
            updateCallInfo({
                callDesc: "Connecting",
                popupActive: true,
                isOutgoingCall: true,
                isCallActive: true
            });
        },
        onCallRemoteRinging: function(_callInfo) {
            console.error("onCallRemoteRinging ~ arr:", {
                _callInfo: _callInfo
            });
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Ringing"
            }));
        },
        onCallConnected: function(_callInfo) {
            console.error("onCallConnected ~ arr:", _callInfo);
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Connected"
            }));
        },
        onCallFailed: function(reason, _callInfo) {
            console.error("onCallFailed ", {
                reason: reason,
                _callInfo: _callInfo
            });
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: reason,
                isCallActive: false,
                isConnected: false
            }));
            reset();
        },
        onCallAnswered: function(_callInfo) {
            console.error("onCallAnswered ~ arr:", _callInfo);
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Answered",
                isConnected: true,
                startTime: new Date()
            }));
        },
        onCallTerminated: function(hangUpInfo, _callInfo) {
            console.error("onCallTerminated ~ arr:", {
                hangUpInfo: hangUpInfo,
                _callInfo: _callInfo,
                callInfo: callInfo
            });
            updateCallInfo({
                callDesc: "Call Ended",
                isCallActive: false,
                isConnected: false,
                endTime: new Date()
            });
            reset();
            playCallTerminatedTone(2, 200);
        },
        onIncomingCall: function(callerID, extraHeaders, _callInfo, callerName) {
            console.error("onIncomingCall ~ arr:", {
                callerID: callerID,
                extraHeaders: extraHeaders,
                _callInfo: _callInfo,
                callerName: callerName
            });
            updateCallInfo(_object_spread_props(_object_spread({}, _callInfo), {
                callDesc: "Incoming Call",
                popupActive: true,
                isCallActive: true,
                isIncomingCall: true,
                calleInfomation: {
                    imgUrl: "",
                    name: "",
                    number: callerName
                }
            }));
            updateUserDetails(callerName);
        },
        onIncomingCallCanceled: function() {
            for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                arr[_key] = arguments[_key];
            }
            console.error("onIncomingCallCanceled ~ arr:", arr);
            updateCallInfo({
                callDesc: "Incoming Call Cancelled By User",
                isCallActive: false,
                isConnected: false
            });
            reset();
        }
    };
    useEffect(function() {
        if (!plivoBrowserSdk) {
            return;
        }
        var client = plivoBrowserSdk.client;
        var callEvents = [
            [
                "onCalling",
                Events.onCalling
            ],
            [
                "onCallConnected",
                Events.onCallConnected
            ],
            [
                "onCallAnswered",
                Events.onCallAnswered
            ],
            [
                "onCallRemoteRinging",
                Events.onCallRemoteRinging
            ],
            [
                "onCallFailed",
                Events.onCallFailed
            ],
            [
                "onCallTerminated",
                Events.onCallTerminated
            ],
            [
                "onIncomingCall",
                Events.onIncomingCall
            ],
            [
                "onIncomingCallCanceled",
                Events.onIncomingCallCanceled
            ]
        ];
        callEvents.forEach(function(param) {
            var _param = _sliced_to_array(param, 2), event = _param[0], handler = _param[1];
            return client.on(event, handler);
        });
        return function() {
            callEvents.forEach(function(param) {
                var _param = _sliced_to_array(param, 2), event = _param[0], handler = _param[1];
                return client.off(event, handler);
            });
        };
    }, [
        plivoBrowserSdk,
        companyId
    ]);
    var isCallSessionActive = Boolean((callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) || (callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive));
    var registerCallCta = function(meta, callInitiateParams) {
        if (isCallSessionActive) {
            return null;
        }
        if (isReady && (meta === null || meta === void 0 ? void 0 : meta.number) && hasSingleCallCalleeId(callInitiateParams)) {
            return /*#__PURE__*/ _jsx(IconWrapper, {
                onClick: function() {
                    return startCall(meta, callInitiateParams);
                },
                children: /*#__PURE__*/ _jsx(CallIconMobile, {})
            });
        }
        return null;
    };
    var showCallAcceptAction = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) && (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isIncomingCall) && !(callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected);
    var showCallHanguptAction = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isIncomingCall) ? callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected : callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive;
    var showCallRejectAction = (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isIncomingCall) && (callInfo === null || callInfo === void 0 ? void 0 : callInfo.isCallActive) && !(callInfo === null || callInfo === void 0 ? void 0 : callInfo.isConnected);
    var startCallRef = useRef(startCall);
    var registerCallCtaRef = useRef(registerCallCta);
    startCallRef.current = startCall;
    registerCallCtaRef.current = registerCallCta;
    var stableStartCall = useCallback(function(meta, callInitiateParams) {
        return startCallRef.current(meta, callInitiateParams);
    }, []);
    var stableRegisterCallCta = useCallback(function(meta, callInitiateParams) {
        return registerCallCtaRef.current(meta, callInitiateParams);
    }, []);
    var contextValue = useMemo(function() {
        return {
            startCall: stableStartCall,
            registerCallCta: stableRegisterCallCta,
            isReady: isReady,
            isCallSessionActive: isCallSessionActive,
            callCtaStateKey: String(isCallSessionActive)
        };
    }, [
        isReady,
        isCallSessionActive,
        stableStartCall,
        stableRegisterCallCta
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isReady && !!(callInfo === null || callInfo === void 0 ? void 0 : callInfo.popupActive) && /*#__PURE__*/ _jsx(CallPopup, _object_spread({
                onToggleMute: toggleMute,
                callInfo: callInfo
            }, showCallAcceptAction && {
                onAnswer: onAnswer
            }, showCallHanguptAction && {
                onHangup: onHangup
            }, showCallRejectAction && {
                onReject: onReject
            })),
            /*#__PURE__*/ _jsx(BrowerClickToCallProviderOld_CallPopupContext.Provider, {
                value: contextValue,
                children: children
            })
        ]
    });
};
// ✅ Custom Hook for Using Context
var BrowerClickToCallProviderOld_useSingleClickToCall = function() {
    var context = useContext(BrowerClickToCallProviderOld_CallPopupContext);
    return context;
};

;// CONCATENATED MODULE: ./context/call/ClickToCallAppProvider.tsx







var CallModeContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
var getInitialMpcMode = function() {
    if (false) {}
    var stored = getLocalStorageData(LOC_STORAGE.clickToCallMpcMode);
    return typeof stored === "boolean" ? stored : false;
};
var UnifiedClickToCallContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MpcClickToCallBridge = function(param) {
    var onApiChange = param.onApiChange;
    var api = useMpcClickToCall();
    var onApiChangeRef = useRef(onApiChange);
    var apiRef = useRef(api);
    onApiChangeRef.current = onApiChange;
    apiRef.current = api;
    useLayoutEffect(function() {
        onApiChangeRef.current(apiRef.current);
        return function() {
            return onApiChangeRef.current(undefined);
        };
    }, [
        api === null || api === void 0 ? void 0 : api.isReady,
        api === null || api === void 0 ? void 0 : api.isCallSessionActive,
        api === null || api === void 0 ? void 0 : api.callCtaStateKey
    ]);
    useLayoutEffect(function() {
        onApiChangeRef.current(apiRef.current);
    }, []);
    return null;
};
var SingleClickToCallBridge = function(param) {
    var onApiChange = param.onApiChange;
    var api = useSingleClickToCall();
    var onApiChangeRef = useRef(onApiChange);
    var apiRef = useRef(api);
    onApiChangeRef.current = onApiChange;
    apiRef.current = api;
    useLayoutEffect(function() {
        onApiChangeRef.current(apiRef.current);
        return function() {
            return onApiChangeRef.current(undefined);
        };
    }, [
        api === null || api === void 0 ? void 0 : api.isReady,
        api === null || api === void 0 ? void 0 : api.isCallSessionActive,
        api === null || api === void 0 ? void 0 : api.callCtaStateKey
    ]);
    useLayoutEffect(function() {
        onApiChangeRef.current(apiRef.current);
    }, []);
    return null;
};
var ClickToCallAppProvider = function(param) {
    var children = param.children;
    var ref = useState(getInitialMpcMode), isMpcMode = ref[0], setIsMpcModeState = ref[1];
    var ref1 = useState(), unifiedApi = ref1[0], setUnifiedApi = ref1[1];
    var isCallSessionActiveRef = useRef(false);
    isCallSessionActiveRef.current = Boolean(unifiedApi === null || unifiedApi === void 0 ? void 0 : unifiedApi.isCallSessionActive);
    var handleApiChange = useCallback(function(api) {
        setUnifiedApi(function(prev) {
            if (!api) {
                return undefined;
            }
            if (!prev) {
                return api;
            }
            if (prev.isReady !== api.isReady) {
                return api;
            }
            if (prev.isCallSessionActive !== api.isCallSessionActive) {
                return api;
            }
            if (prev.callCtaStateKey !== api.callCtaStateKey) {
                return api;
            }
            if (prev.startCall !== api.startCall || prev.registerCallCta !== api.registerCallCta) {
                return api;
            }
            return prev;
        });
    }, []);
    var setIsMpcMode = useCallback(function(enabled) {
        if (isCallSessionActiveRef.current) {
            return;
        }
        setIsMpcModeState(function(current) {
            return current === enabled ? current : enabled;
        });
    }, []);
    var toggleMpcMode = useCallback(function() {
        if (isCallSessionActiveRef.current) {
            return;
        }
        setIsMpcModeState(function(current) {
            return !current;
        });
    }, []);
    useEffect(function() {
        setLocalStorageData(LOC_STORAGE.clickToCallMpcMode, isMpcMode);
    }, [
        isMpcMode
    ]);
    var callModeValue = useMemo(function() {
        return {
            isMpcMode: isMpcMode,
            setIsMpcMode: setIsMpcMode,
            toggleMpcMode: toggleMpcMode
        };
    }, [
        isMpcMode,
        setIsMpcMode,
        toggleMpcMode
    ]);
    return /*#__PURE__*/ _jsx(CallModeContext.Provider, {
        value: callModeValue,
        children: /*#__PURE__*/ _jsx(SharedPlivoSdkProvider, {
            children: /*#__PURE__*/ _jsxs(UnifiedClickToCallContext.Provider, {
                value: unifiedApi,
                children: [
                    isMpcMode ? /*#__PURE__*/ _jsx(MpcClickToCallProvider, {
                        children: /*#__PURE__*/ _jsx(MpcClickToCallBridge, {
                            onApiChange: handleApiChange
                        })
                    }, "mpc") : /*#__PURE__*/ _jsx(SingleClickToCallProvider, {
                        children: /*#__PURE__*/ _jsx(SingleClickToCallBridge, {
                            onApiChange: handleApiChange
                        })
                    }, "single"),
                    children
                ]
            })
        })
    });
};
var useCallMode = function() {
    var context = useContext(CallModeContext);
    if (!context) {
        throw new Error("useCallMode must be used within ClickToCallAppProvider");
    }
    return context;
};
var useClickToCall = function() {
    return (0,react.useContext)(UnifiedClickToCallContext);
};
var CallBtnWithIcon = function(props) {
    var context = useClickToCall();
    var CTA_SLOT = context === null || context === void 0 ? void 0 : context.registerCallCta(props.meta, props.callInitiateParams);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: CTA_SLOT
    });
};


/***/ }),

/***/ 8574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NS": function() { return /* binding */ useLoadLorryPosting; },
/* harmony export */   "ec": function() { return /* binding */ POSTING_FORM_MODAL_ORIGINATION_PAGE; },
/* harmony export */   "fb": function() { return /* binding */ LoadLorryPostingProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_posting_load_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5283);
/* harmony import */ var _components_posting_lorry_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90376);








var POSTING_FORM_MODAL_ORIGINATION_PAGE;
(function(POSTING_FORM_MODAL_ORIGINATION_PAGE) {
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["DASHBOARD"] = 0] = "DASHBOARD";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["USER_PROFILE"] = 1] = "USER_PROFILE";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["MARKETPLACE"] = 2] = "MARKETPLACE";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["KAM_UPDATING_LORRY_ON_BULK_LOAD"] = 3] = "KAM_UPDATING_LORRY_ON_BULK_LOAD";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["UPDATE_VEHICLE_DETAILS_KAM"] = 4] = "UPDATE_VEHICLE_DETAILS_KAM";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["HOME"] = 5] = "HOME";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["TSO_LORRY"] = 6] = "TSO_LORRY";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["SIDE_NAV"] = 7] = "SIDE_NAV";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["LORRY_BID_FORM"] = 8] = "LORRY_BID_FORM";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["RC_VERIFICATION"] = 9] = "RC_VERIFICATION";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["TICKET_SYSTEM"] = 10] = "TICKET_SYSTEM";
    POSTING_FORM_MODAL_ORIGINATION_PAGE[POSTING_FORM_MODAL_ORIGINATION_PAGE["TRANSPORTER_PROFILE"] = 11] = "TRANSPORTER_PROFILE";
})(POSTING_FORM_MODAL_ORIGINATION_PAGE || (POSTING_FORM_MODAL_ORIGINATION_PAGE = {}));
var LoadLorryPostingProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), loadLorryData = ref[0], setLoadLorryPostingData = ref[1];
    var updateLoadLorryPostingData = function(details) {
        setLoadLorryPostingData(function(prevDetails) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, prevDetails, details), {
                firstPost: details === null || details === void 0 ? void 0 : details.firstPost
            });
        });
    };
    var clearPostingData = function() {
        setLoadLorryPostingData(undefined);
    };
    var openLoadPostingModal = function(step) {
        !!step && next_router__WEBPACK_IMPORTED_MODULE_2___default().push({
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_2___default().query)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _components_posting_load_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_3__/* .LOAD_POSTING_FORM_LOCATION_STATE.PARAM_NAME */ .x.PARAM_NAME, step))
        }, undefined, {
            shallow: true,
            scroll: false
        });
    };
    var openLorryPostingModal = function(step) {
        !!step && next_router__WEBPACK_IMPORTED_MODULE_2___default().push({
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (next_router__WEBPACK_IMPORTED_MODULE_2___default().query)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _components_posting_lorry_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_4__/* .LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */ .v.PARAM_NAME, step))
        }, undefined, {
            shallow: true,
            scroll: false
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoadLorryPostingContext.Provider, {
        value: {
            loadLorryData: loadLorryData,
            updateLoadLorryPostingData: updateLoadLorryPostingData,
            openLoadPostingModal: openLoadPostingModal,
            openLorryPostingModal: openLorryPostingModal,
            clearPostingData: clearPostingData
        },
        children: children
    });
};
var LoadLorryPostingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var useLoadLorryPosting = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LoadLorryPostingContext);
};


/***/ }),

/***/ 83927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ PaymentProvider; },
/* harmony export */   "V": function() { return /* binding */ usePayment; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);


var PaymentProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), paymentData = ref[0], setPaymentData = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PaymentContext.Provider, {
        value: {
            paymentData: paymentData,
            updatePaymentData: setPaymentData
        },
        children: children
    });
};
var PaymentContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var usePayment = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PaymentContext);
};


/***/ }),

/***/ 57:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useFeatureByServiceType; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68191);
/* harmony import */ var _constants_adminOperation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40223);





function useFeatureByServiceType(externalServiceType) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), customerServiceType = ref.customerServiceType, serviceType = ref.serviceType, isPhoneVerified = ref.isPhoneVerified;
    var ref1 = (0,_vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_3__/* .useCsDashboard */ .Z)(), checkPermission = ref1.checkPermission, isCsDashboardUser = ref1.isCsDashboardUser;
    /**
     * We may remove this check in future
     * This can be removed and modify according to requirement
     */ // To check whether current CS User has load / lorry edit access
    var csUserViewPermission = checkPermission(_constants_adminOperation__WEBPACK_IMPORTED_MODULE_4__/* .ADMIN_OPERATION.profileView */ .F.profileView);
    var csUserEditPermission = checkPermission(_constants_adminOperation__WEBPACK_IMPORTED_MODULE_4__/* .ADMIN_OPERATION.userLoadLorryAction */ .F.userLoadLorryAction);
    if (isCsDashboardUser) {
        return {
            showLoadFeatures: csUserViewPermission,
            showLorryFeatures: csUserViewPermission,
            showLoadAndLorryFeatures: csUserViewPermission,
            ShowLoadPost: csUserEditPermission,
            ShowLorryPost: csUserEditPermission
        };
    }
    var isUserLoggedIn = isPhoneVerified;
    switch(externalServiceType || customerServiceType || serviceType){
        case _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyServiceType.SHIPPER */ .AAU.SHIPPER:
            return {
                showLoadFeatures: false,
                showLorryFeatures: !isUserLoggedIn,
                showLoadAndLorryFeatures: false,
                ShowLoadPost: true,
                ShowLorryPost: false
            };
        case _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyServiceType.FLEET_OWNER */ .AAU.FLEET_OWNER:
            return {
                showLoadFeatures: true,
                showLorryFeatures: false,
                showLoadAndLorryFeatures: false,
                ShowLoadPost: false,
                ShowLorryPost: true
            };
        case _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyServiceType.AGENT_BROKER */ .AAU.AGENT_BROKER:
        case _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyServiceType.TRANSPORT_CONTRACTOR */ .AAU.TRANSPORT_CONTRACTOR:
        case _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_2__/* .CompanyServiceType.DEPRECATED_SERVICE_TYPE */ .AAU.DEPRECATED_SERVICE_TYPE:
        default:
            return {
                showLoadFeatures: true,
                showLorryFeatures: !isUserLoggedIn,
                showLoadAndLorryFeatures: !isUserLoggedIn,
                ShowLoadPost: true,
                ShowLorryPost: true
            };
    }
}


/***/ }),

/***/ 54351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z$": function() { return /* binding */ loadI18nNamespaces; }
/* harmony export */ });
/* unused harmony export useLoadI18nNamespaces */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42386);





/**
 * Fetches and merges namespace JSON over the network (next-i18next client API).
 * Safe to call multiple times — i18next caches loaded namespaces.
 */ function loadI18nNamespaces(i18n, namespaces) {
    return _loadI18nNamespaces.apply(this, arguments);
}
function _loadI18nNamespaces() {
    _loadI18nNamespaces = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(i18n, namespaces) {
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!(i18n === null || i18n === void 0 ? void 0 : i18n.loadNamespaces) || !namespaces.length)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return i18n.loadNamespaces((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(namespaces));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _loadI18nNamespaces.apply(this, arguments);
}
/**
 * Client-side namespace preload. Use when a surface (nav, modal) mounts or opens
 * and the current page may not have requested those namespaces in SSR.
 */ function useLoadI18nNamespaces(namespaces) {
    var enabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().i18n;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled) {
            return;
        }
        void loadI18nNamespaces(i18n, namespaces);
    }, [
        enabled,
        i18n,
        namespaces
    ]);
}
/* harmony default export */ __webpack_exports__["ZP"] = (useLoadI18nNamespaces);


/***/ }),

/***/ 41062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useLocalStorageMethod; }
/* harmony export */ });
var useLocalStorageMethod = function() {
    var getLocalData = function(keyName, handler) {
        if (false) {}
        var data = localStorage.getItem(keyName);
        if (!data || data === "undefined" || data === "null") {
            return {};
        }
        try {
            var result = JSON.parse(data);
            return handler ? handler(result) : result;
        } catch (e) {
            return {};
        }
    };
    var setLocalData = function(keyName, data) {
        if (false) {}
        if (data === undefined) return; // don't store undefined
        localStorage.setItem(keyName, JSON.stringify(data));
    };
    var removeLocalData = function(keyName) {
        if (false) {}
        localStorage.removeItem(keyName);
    };
    return {
        getLocalData: getLocalData,
        setLocalData: setLocalData,
        removeLocalData: removeLocalData
    };
};


/***/ }),

/***/ 68498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useOpenNewLoadPosting */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68191);
/* harmony import */ var _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8574);
/* harmony import */ var _components_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40607);
/* harmony import */ var _components_posting_load_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5283);
/* harmony import */ var _components_posting_lorry_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90376);
/* harmony import */ var _components_homepage_v2_compact_load_posting_CompactLoadPostingProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56193);
/* harmony import */ var _components_homepage_v2_compact_load_posting_mapLoadFormValuesToCompactInitialValues__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82129);
/* harmony import */ var _useValidateUserStatus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4641);












/**
 * Single entry point for opening a fresh ("post") or "re-post" load posting flow.
 *
 * Consumer users get the compact flow. CS dashboard users keep the legacy standalone modal.
 */ var useOpenNewLoadPosting = function() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var isCsDashboardUser = (0,_vahak_core_dist_hooks_useCsDashboard__WEBPACK_IMPORTED_MODULE_2__/* .useCsDashboard */ .Z)().isCsDashboardUser;
    var openCompactPosting = (ref = (0,_components_homepage_v2_compact_load_posting_CompactLoadPostingProvider__WEBPACK_IMPORTED_MODULE_7__/* .useCompactLoadPostingOptional */ .qA)()) === null || ref === void 0 ? void 0 : ref.openCompactPosting;
    var ref1 = (0,_context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_3__/* .useLoadLorryPosting */ .NS)(), updateLoadLorryPostingData = ref1.updateLoadLorryPostingData, openLoadPostingModal = ref1.openLoadPostingModal;
    var ValidateLoadPosting = (0,_useValidateUserStatus__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)().ValidateLoadPosting;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var originationPage = param.originationPage, _category = param.category, category = _category === void 0 ? "post" : _category, initialValues = param.initialValues, prefilledLoadData = param.prefilledLoadData, repostLoadId = param.repostLoadId, firstPost = param.firstPost, _loadStep = param.loadStep, loadStep = _loadStep === void 0 ? _components_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_4__/* .LOAD_CREATION_FORM_IDS.LOAD_LOCATION_DETAILS */ .y5.LOAD_LOCATION_DETAILS : _loadStep, eventData = param.eventData, afterOpen = param.afterOpen, onSuccess = param.onSuccess, skipValidation = param.skipValidation;
        if (!isCsDashboardUser && openCompactPosting) {
            var compactValues = prefilledLoadData ? (0,_components_homepage_v2_compact_load_posting_mapLoadFormValuesToCompactInitialValues__WEBPACK_IMPORTED_MODULE_8__/* .mapLoadFormValuesToCompactInitialValues */ .I)(prefilledLoadData, repostLoadId) : initialValues;
            openCompactPosting(compactValues, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventData ? {
                eventData: eventData
            } : {}), {
                isRepost: category === "re-post",
                onSuccess: onSuccess
            }));
            afterOpen === null || afterOpen === void 0 ? void 0 : afterOpen();
            return;
        }
        var openLegacy = function() {
            updateLoadLorryPostingData === null || updateLoadLorryPostingData === void 0 ? void 0 : updateLoadLorryPostingData((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                isModalOpen: true,
                type: "load",
                category: category,
                originationPage: originationPage,
                firstPost: firstPost
            }, prefilledLoadData && repostLoadId && {
                data: {
                    id: repostLoadId,
                    values: prefilledLoadData
                }
            }), {
                onSuccess: onSuccess
            }));
            delete router.query[_components_posting_lorry_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_6__/* .LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */ .v.PARAM_NAME];
            router.query[_components_posting_load_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_5__/* .LOAD_POSTING_FORM_LOCATION_STATE.PARAM_NAME */ .x.PARAM_NAME] = loadStep;
            openLoadPostingModal === null || openLoadPostingModal === void 0 ? void 0 : openLoadPostingModal(loadStep);
            afterOpen === null || afterOpen === void 0 ? void 0 : afterOpen();
        };
        if (skipValidation) {
            openLegacy();
            return;
        }
        ValidateLoadPosting(openLegacy);
    }, [
        isCsDashboardUser,
        openCompactPosting,
        updateLoadLorryPostingData,
        openLoadPostingModal,
        router,
        ValidateLoadPosting
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useOpenNewLoadPosting);


/***/ }),

/***/ 4672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ hooks_useRouteTransitionLoader; },
  "t3": function() { return /* binding */ startRouteTransitionLoader; }
});

// UNUSED EXPORTS: stopRouteTransitionLoader

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./constants/route-loader.ts
/** Routes that should show the truck loader during client-side navigation. */ var ROUTE_LOADER = {
    localePrefixPattern: /^\/(en|te|hi|gu|kn|mr|ta|bn)(?=\/|$)/,
    serverRenderedPaths: {
        nextjs: [
            /^\/login$/,
            /^\/help(\/.*)?$/,
            /^\/forum(\/.*)?$/,
            /^\/marketplace(\/.*)?$/,
            /^\/transporters(\/.*)?$/,
            /^\/membership\/upgrade$/,
            /^\/ac\/my-loads(\/.*)?$/,
            /^\/ac\/my-lorries(\/.*)?$/,
            /^\/dashboard(\/.*)?$/,
            /^\/my-profile(\/.*)?$/
        ],
        admin: [
            /^\/mw\/tso\/market(\/.*)?$/,
            /^\/customer-marketplace(\/.*)?$/,
            /^\/customer-loads(\/.*)?$/,
            // load detail pages use getStaticProps + fallback:blocking — wait shows no UI without this
            /^\/ticket-system\/loads\/[^/]+\/[^/]+/
        ]
    }
};

;// CONCATENATED MODULE: ./hooks/useRouteTransitionLoader.ts



var normalizeRoutePath = function(path) {
    return path.split("?")[0].split("#")[0];
};
var stripLocaleFromPath = function(path) {
    var withoutLocale = path.replace(ROUTE_LOADER.localePrefixPattern, "");
    return withoutLocale === "" ? "/" : withoutLocale;
};
var isTransitionLoaderRoute = function(url, app) {
    var path = stripLocaleFromPath(normalizeRoutePath(url));
    return ROUTE_LOADER.serverRenderedPaths[app].some(function(pattern) {
        return pattern.test(path);
    });
};
var isTransitionLoaderNavigation = function(nextUrl, currentAsPath, app) {
    if (normalizeRoutePath(nextUrl) === normalizeRoutePath(currentAsPath)) {
        return false;
    }
    return isTransitionLoaderRoute(nextUrl, app);
};
var manualLoaderActive = false;
var manualLoaderListeners = new Set();
function notifyManualLoaderListeners() {
    manualLoaderListeners.forEach(function(listener) {
        return listener();
    });
}
/** Show the global truck loader immediately (e.g. before router.push resolves). */ function startRouteTransitionLoader() {
    if (manualLoaderActive) {
        return;
    }
    manualLoaderActive = true;
    notifyManualLoaderListeners();
}
function stopRouteTransitionLoader() {
    if (!manualLoaderActive) {
        return;
    }
    manualLoaderActive = false;
    notifyManualLoaderListeners();
}
var useRouteTransitionLoader = function(app) {
    var ref = (0,react.useState)(false), isRouterLoading = ref[0], setIsRouterLoading = ref[1];
    var ref1 = (0,react.useState)(0), setManualLoaderRevision = ref1[1];
    var router = (0,next_router.useRouter)();
    var currentPathRef = (0,react.useRef)(router.asPath);
    (0,react.useEffect)(function() {
        var onManualLoaderChange = function() {
            return setManualLoaderRevision(function(revision) {
                return revision + 1;
            });
        };
        manualLoaderListeners.add(onManualLoaderChange);
        return function() {
            manualLoaderListeners.delete(onManualLoaderChange);
        };
    }, []);
    (0,react.useEffect)(function() {
        currentPathRef.current = router.asPath;
    }, [
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        var handleRouteChangeStart = function(url) {
            if (isTransitionLoaderNavigation(url, currentPathRef.current, app)) {
                setIsRouterLoading(true);
            }
        };
        var handleRouteChangeEnd = function() {
            setIsRouterLoading(false);
            stopRouteTransitionLoader();
        };
        router_default().events.on("routeChangeStart", handleRouteChangeStart);
        router_default().events.on("routeChangeComplete", handleRouteChangeEnd);
        router_default().events.on("routeChangeError", handleRouteChangeEnd);
        return function() {
            router_default().events.off("routeChangeStart", handleRouteChangeStart);
            router_default().events.off("routeChangeComplete", handleRouteChangeEnd);
            router_default().events.off("routeChangeError", handleRouteChangeEnd);
        };
    }, [
        app
    ]);
    return isRouterLoading || manualLoaderActive;
};
/* harmony default export */ var hooks_useRouteTransitionLoader = (useRouteTransitionLoader);


/***/ }),

/***/ 4641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useValidateUserStatus; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ../core/dist/_services/const.js
var _services_const = __webpack_require__(41634);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakQueryClient.js
var useVahakQueryClient = __webpack_require__(37528);
// EXTERNAL MODULE: ../core/dist/hooks/useVahakHttpClient.js
var useVahakHttpClient = __webpack_require__(36153);
;// CONCATENATED MODULE: ./services/useUserActionValidationService.ts






var useUserActionValidationService = function(options, request) {
    var getCompanyId = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).getCompanyId;
    var GET = (0,useVahakHttpClient/* default */.Z)().GET;
    var validateUserAction = function() {
        var ref, ref1;
        var resolvedCompanyId = (ref1 = (ref = getCompanyId === null || getCompanyId === void 0 ? void 0 : getCompanyId()) !== null && ref !== void 0 ? ref : request === null || request === void 0 ? void 0 : request.companyId) !== null && ref1 !== void 0 ? ref1 : 0;
        var queryObj = {
            c_i: resolvedCompanyId,
            action: request === null || request === void 0 ? void 0 : request.action
        };
        return GET(_services_const/* default.GET_USER_ACTION_VALIDATION */.Z.GET_USER_ACTION_VALIDATION, queryObj);
    };
    /**
     * If you don't know the error type pass unknown
     */ return (0,useVahakQueryClient/* useVahakQuery */.uE)([
        queryNames/* QueryNames.userActionValidation */._.userActionValidation,
        request === null || request === void 0 ? void 0 : request.action,
        request === null || request === void 0 ? void 0 : request.companyId
    ], validateUserAction, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
        select: function(data) {
            return data;
        }
    }));
};

// EXTERNAL MODULE: ../core/dist/constants/userAction.js
var userAction = __webpack_require__(69881);
// EXTERNAL MODULE: ./BiddingFormContextProvider.tsx
var BiddingFormContextProvider = __webpack_require__(25634);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
;// CONCATENATED MODULE: ./hooks/useValidateUserStatus.ts




//Context

//Services

//Constants



var useValidateUserStatus = function() {
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, setShowClearDuePopup = ref.setShowClearDuePopup, setShowMandateKycPopup = ref.setShowMandateKycPopup, setShowGstVerificationPopup = ref.setShowGstVerificationPopup, setShowUpgradeMembershipPlanPopup = ref.setShowUpgradeMembershipPlanPopup, setMandateUserVerificationCallBackFunction = ref.setMandateUserVerificationCallBackFunction, setMandateUserVerificationActionTriggered = ref.setMandateUserVerificationActionTriggered, setMandateUserVerificationActionType = ref.setMandateUserVerificationActionType, companyId = ref.companyId, customerCompanyId = ref.customerCompanyId;
    var dispatchBid = (0,react.useContext)(BiddingFormContextProvider/* BiddingFormContext */.O7).dispatchBid;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), enable = ref1[0], setEnable = ref1[1];
    var ref2 = (0,react.useState)(null), validationRequest = ref2[0], setValidationRequest = ref2[1];
    var validateOptionsRef = (0,react.useRef)();
    var validationCompanyIdRef = (0,react.useRef)(0);
    var validationCallbackRef = (0,react.useRef)();
    var validationActiveRef = (0,react.useRef)(false);
    var resolveValidationCompanyId = function(options) {
        return Number(options === null || options === void 0 ? void 0 : options.companyId) || Number(customerCompanyId) || Number(companyId);
    };
    var finishValidation = function() {
        validationActiveRef.current = false;
        validateOptionsRef.current = undefined;
        validationCallbackRef.current = undefined;
        setEnable(false);
        setValidationRequest(null);
    };
    var resetBidding = function() {
        dispatchBid({
            type: BiddingFormContextProvider/* BID_ACTIONS.LORRY */.Eo.LORRY,
            payload: {
                open: false
            }
        });
        dispatchBid({
            type: BiddingFormContextProvider/* BID_ACTIONS.LOAD */.Eo.LOAD,
            payload: {
                open: false
            }
        });
        var loadLorryId = router.query["loadbid"] || router.query["lorrybid"];
        if (loadLorryId) {
            delete router.query["lorrybid"];
            delete router.query["loadbid"];
            delete router.query["oppcmpid"];
            delete router.query["utm_medium"];
            delete router.query["utm_source"];
            delete router.query["_branch_match_id"];
            delete router.query["_branch_referrer"];
            delete router.query["r"];
            delete router.query["u_i"];
            delete router.query["utm_campaign"];
            router.replace(router, {
                query: ""
            }, {
                shallow: true,
                scroll: false
            });
        }
    };
    useUserActionValidationService({
        onSuccess: function(res) {
            if (!validationActiveRef.current) {
                return;
            }
            switch(res === null || res === void 0 ? void 0 : res.data.action_required){
                case userAction/* UserActionRequiredResponse.CLEAR_CASHBACK_COINS */.Q.CLEAR_CASHBACK_COINS:
                    setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                        isOpen: true,
                        dueAmount: res.data.cashback_balance
                    });
                    break;
                case userAction/* UserActionRequiredResponse.VERIFY_AADHAAR */.Q.VERIFY_AADHAAR:
                    setShowMandateKycPopup === null || setShowMandateKycPopup === void 0 ? void 0 : setShowMandateKycPopup(true);
                    break;
                case userAction/* UserActionRequiredResponse.VERIFY_PAN */.Q.VERIFY_PAN:
                    setShowMandateKycPopup === null || setShowMandateKycPopup === void 0 ? void 0 : setShowMandateKycPopup(true);
                    break;
                case userAction/* UserActionRequiredResponse.VERIFY_GST */.Q.VERIFY_GST:
                    setShowGstVerificationPopup === null || setShowGstVerificationPopup === void 0 ? void 0 : setShowGstVerificationPopup(true);
                    break;
                case userAction/* UserActionRequiredResponse.BUY_MEMBERSHIP */.Q.BUY_MEMBERSHIP:
                case userAction/* UserActionRequiredResponse.UPGRADE_MEMBERSHIP */.Q.UPGRADE_MEMBERSHIP:
                case userAction/* UserActionRequiredResponse.TOP_UP_MEMBERSHIP */.Q.TOP_UP_MEMBERSHIP:
                case userAction/* UserActionRequiredResponse.MEMBERSHIP_EXPIRED */.Q.MEMBERSHIP_EXPIRED:
                case userAction/* UserActionRequiredResponse.DAILY_MEMBERSHIP_LIMIT_EXHAUSTED */.Q.DAILY_MEMBERSHIP_LIMIT_EXHAUSTED:
                    var ref;
                    setShowUpgradeMembershipPlanPopup === null || setShowUpgradeMembershipPlanPopup === void 0 ? void 0 : setShowUpgradeMembershipPlanPopup(true, (ref = validationRequest === null || validationRequest === void 0 ? void 0 : validationRequest.action) !== null && ref !== void 0 ? ref : userAction/* UserAction.POST_LOAD */.V.POST_LOAD, res === null || res === void 0 ? void 0 : res.data.action_required);
                    setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
                    setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
                    setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
                    resetBidding();
                    break;
                default:
                    if (res === null || res === void 0 ? void 0 : res.data.can_continue) {
                        var ref1;
                        (ref1 = validationCallbackRef.current) === null || ref1 === void 0 ? void 0 : ref1.call(validationCallbackRef);
                    } else {
                        var options = validateOptionsRef.current;
                        if (options === null || options === void 0 ? void 0 : options.onCannotContinue) {
                            options.onCannotContinue();
                        } else if (!(options === null || options === void 0 ? void 0 : options.suppressCannotContinueToast)) {
                            var ref2;
                            toast/* toast.error */.A.error(res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.action_required);
                        }
                    }
                    break;
            }
            finishValidation();
        },
        onError: function(err) {
            if (!validationActiveRef.current) {
                return;
            }
            console.log("Error ", err);
            var options = validateOptionsRef.current;
            if (options === null || options === void 0 ? void 0 : options.onValidationError) {
                options.onValidationError();
            } else if (!(options === null || options === void 0 ? void 0 : options.suppressValidationErrorToast)) {
                toast/* toast.error */.A.error("Some thing went wrong, please try again later.");
            }
            finishValidation();
            setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
            setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
            setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
            resetBidding();
        },
        enabled: enable && Boolean(validationRequest),
        retry: 0,
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0
    }, validationRequest, {
        getCompanyId: function() {
            return validationCompanyIdRef.current || Number(customerCompanyId) || Number(companyId);
        }
    });
    var loginCheck = function(actionType, cb) {
        if (!companyId || !isPhoneVerified) {
            router.push({
                hash: "Login"
            }, undefined, {
                shallow: true
            });
            if (actionType && cb) {
                setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType(actionType);
                setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(true);
                setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(cb);
            }
            return false;
        } else return true;
    };
    var startValidation = function(action, cb, options) {
        var resolvedCompanyId = resolveValidationCompanyId(options);
        if (!resolvedCompanyId) {
            if (options === null || options === void 0 ? void 0 : options.onValidationError) {
                options.onValidationError();
            } else if (!(options === null || options === void 0 ? void 0 : options.suppressValidationErrorToast)) {
                toast/* toast.error */.A.error("Some thing went wrong, please try again later.");
            }
            return;
        }
        validationCompanyIdRef.current = resolvedCompanyId;
        validationCallbackRef.current = cb;
        validateOptionsRef.current = options;
        validationActiveRef.current = true;
        setValidationRequest({
            companyId: resolvedCompanyId,
            action: action
        });
        setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(true);
        setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(cb);
        setEnable(true);
    };
    var ValidateLoadPosting = function(cb, skipLoginCheck, options) {
        /**
         * Base case
         */ if (!skipLoginCheck) {
            if (!loginCheck(userAction/* UserAction.POST_LOAD */.V.POST_LOAD, cb)) return;
        }
        startValidation(userAction/* UserAction.POST_LOAD */.V.POST_LOAD, cb, options);
    };
    var ValidateLorryPosting = function(cb, skipLoginCheck) {
        /**
         * Base case
         */ if (!skipLoginCheck) {
            if (!loginCheck(userAction/* UserAction.POST_LORRY */.V.POST_LORRY, cb)) return;
        }
        //No validation for lorry posting form — still mark intentional open so
        // StandaloneLorryPostingFormModal does not strip the query on empty referrer.
        setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(true);
        return cb === null || cb === void 0 ? void 0 : cb();
        /**
         * V2
         * This will refetch the c/status api
         */ startValidation(userAction/* UserAction.POST_LORRY */.V.POST_LORRY, cb);
    };
    var ValidateLorryBidding = function(cb, skipLoginCheck) {
        /**
         * Base case
         */ if (!skipLoginCheck) {
            if (!loginCheck(userAction/* UserAction.LORRY_BID */.V.LORRY_BID, cb)) return;
        }
        /**
         * V2
         * This will refetch the c/status api
         */ startValidation(userAction/* UserAction.LORRY_BID */.V.LORRY_BID, cb);
    };
    var ValidateLoadBidding = function(cb, skipLoginCheck, options) {
        /**
         * Base case
         */ if (!skipLoginCheck) {
            if (!loginCheck(userAction/* UserAction.LOAD_BID */.V.LOAD_BID, cb)) return;
        }
        startValidation(userAction/* UserAction.LOAD_BID */.V.LOAD_BID, cb, options);
    };
    var verifyKycNow = function(type, cb) {
        /**
         * Base case
         */ if (!loginCheck()) return;
        setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(cb);
        if (type === "GST") {
            setShowGstVerificationPopup === null || setShowGstVerificationPopup === void 0 ? void 0 : setShowGstVerificationPopup(true);
            return;
        }
        if (type === "Aadhaar" || type === "PAN") {
            setShowMandateKycPopup === null || setShowMandateKycPopup === void 0 ? void 0 : setShowMandateKycPopup(true);
            return;
        }
        cb === null || cb === void 0 ? void 0 : cb();
        setShowMandateKycPopup === null || setShowMandateKycPopup === void 0 ? void 0 : setShowMandateKycPopup(false);
        setShowGstVerificationPopup === null || setShowGstVerificationPopup === void 0 ? void 0 : setShowGstVerificationPopup(false);
        router.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router), {
            hash: undefined
        }));
        setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
    };
    return {
        ValidateLoadPosting: ValidateLoadPosting,
        ValidateLorryPosting: ValidateLorryPosting,
        ValidateLorryBidding: ValidateLorryBidding,
        ValidateLoadBidding: ValidateLoadBidding,
        verifyKycNow: verifyKycNow,
        loginCheck: loginCheck
    };
};
/* harmony default export */ var hooks_useValidateUserStatus = (useValidateUserStatus);


/***/ }),

/***/ 16569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cu": function() { return /* binding */ compressImageToGivenMB; },
/* harmony export */   "g3": function() { return /* binding */ compressImageTo1MB; },
/* harmony export */   "uR": function() { return /* binding */ isFileSizeGreaterThan; }
/* harmony export */ });
/* unused harmony export compressImageFileTo1MB */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var compressImageTo1MB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var sizeDividend, maxSizeInMB, _args = arguments;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sizeDividend = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 1, maxSizeInMB = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 1;
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onload = function(event) {
                            var ref;
                            var img = new Image();
                            img.onload = function() {
                                var canvas = document.createElement("canvas");
                                var ctx = canvas.getContext("2d");
                                if (!ctx) {
                                    reject(new Error("Failed to get canvas context"));
                                    return;
                                }
                                var newWidth = img.width / sizeDividend;
                                var newHeight = img.height / sizeDividend;
                                canvas.width = newWidth;
                                canvas.height = newHeight;
                                ctx.drawImage(img, 0, 0, newWidth, newHeight);
                                canvas.toBlob(function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(blob) {
                                        var nextSizeDividend, nextBlob;
                                        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (blob) {
                                                        _ctx.next = 3;
                                                        break;
                                                    }
                                                    reject(new Error("Compression failed"));
                                                    return _ctx.abrupt("return");
                                                case 3:
                                                    // @ts-expect-error: name and lastModified are not standard Blob props
                                                    blob.name = file.name;
                                                    // @ts-expect-error: name and lastModified are not standard Blob props
                                                    blob.lastModified = file.lastModified;
                                                    if (!(blob.size < maxSizeInMB * 1024 * 1024)) {
                                                        _ctx.next = 9;
                                                        break;
                                                    }
                                                    {
                                                        // If blob size is less than 1 MB, resolve with the blob
                                                        resolve(blob);
                                                    }
                                                    _ctx.next = 14;
                                                    break;
                                                case 9:
                                                    nextSizeDividend = sizeDividend + 0.1;
                                                    _ctx.next = 12;
                                                    return compressImageTo1MB(file, nextSizeDividend);
                                                case 12:
                                                    nextBlob = _ctx.sent;
                                                    resolve(nextBlob);
                                                case 14:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(blob) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(), file.type, 0.1);
                            };
                            img.src = (ref = event.target) === null || ref === void 0 ? void 0 : ref.result;
                        };
                        reader.onerror = function() {
                            return reject(new Error("File reading failed"));
                        };
                        reader.readAsDataURL(file);
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressImageTo1MB(file) {
        return _ref.apply(this, arguments);
    };
}();
var compressImageFileTo1MB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var maxSizeInMB, sizeDividend, compressedBlob, _args = arguments;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    maxSizeInMB = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 1, sizeDividend = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 1;
                    _ctx.next = 3;
                    return compressImageTo1MB(file, sizeDividend, maxSizeInMB);
                case 3:
                    compressedBlob = _ctx.sent;
                    return _ctx.abrupt("return", new File([
                        compressedBlob
                    ], file.name, {
                        type: compressedBlob.type,
                        lastModified: file.lastModified
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressImageFileTo1MB(file) {
        return _ref.apply(this, arguments);
    };
}();
var isFileSizeGreaterThan = function(file, maxSizeInMB) {
    var sizeInBytes = maxSizeInMB * 1024 * 1024;
    return file.size > sizeInBytes;
};
var compressImageToGivenMB = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var maxSizeInMB, quality, maxBytes, dataUrl, img, sizeDividend, compressedFile, canvas, ctx, blob, _args = arguments;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    maxSizeInMB = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 1, quality = _args.length > 2 && _args[2] !== void 0 ? _args[2] : 0.8;
                    maxBytes = maxSizeInMB * 1024 * 1024;
                    _ctx.next = 4;
                    return new Promise(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onload = function() {
                            return resolve(reader.result);
                        };
                        reader.onerror = function() {
                            return reject(new Error("File reading failed"));
                        };
                        reader.readAsDataURL(file);
                    });
                case 4:
                    dataUrl = _ctx.sent;
                    _ctx.next = 7;
                    return new Promise(function(resolve, reject) {
                        var image = new Image();
                        image.onload = function() {
                            return resolve(image);
                        };
                        image.onerror = function() {
                            return reject(new Error("Image load failed"));
                        };
                        image.src = dataUrl;
                    });
                case 7:
                    img = _ctx.sent;
                    sizeDividend = 1;
                    compressedFile = null;
                case 10:
                    if (false) {}
                    canvas = document.createElement("canvas");
                    ctx = canvas.getContext("2d");
                    if (ctx) {
                        _ctx.next = 15;
                        break;
                    }
                    throw new Error("Failed to get canvas context");
                case 15:
                    canvas.width = Math.round(img.width / sizeDividend);
                    canvas.height = Math.round(img.height / sizeDividend);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    _ctx.next = 20;
                    return new Promise(function(resolve) {
                        return canvas.toBlob(resolve, file.type, quality);
                    });
                case 20:
                    blob = _ctx.sent;
                    if (blob) {
                        _ctx.next = 23;
                        break;
                    }
                    throw new Error("Compression failed");
                case 23:
                    compressedFile = new File([
                        blob
                    ], file.name, {
                        type: file.type,
                        lastModified: file.lastModified
                    });
                    if (!(compressedFile.size <= maxBytes)) {
                        _ctx.next = 26;
                        break;
                    }
                    return _ctx.abrupt("break", 31);
                case 26:
                    // Increase sizeDividend slightly to reduce dimensions
                    sizeDividend += 0.1;
                    if (!(sizeDividend > 10)) {
                        _ctx.next = 29;
                        break;
                    }
                    return _ctx.abrupt("break", 31);
                case 29:
                    _ctx.next = 10;
                    break;
                case 31:
                    return _ctx.abrupt("return", compressedFile);
                case 32:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function compressImageToGivenMB(file) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 32740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ generataMaskUrlWithParams; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_methods_generateUrlParamsFromObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13521);
/* harmony import */ var _getPathName__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48929);


function generataMaskUrlWithParams(queryParam, maskUrl) {
    return (maskUrl ? maskUrl : (0,_getPathName__WEBPACK_IMPORTED_MODULE_0__/* .getPathName */ .y)()) + "?" + (0,_vahak_core_dist_methods_generateUrlParamsFromObject__WEBPACK_IMPORTED_MODULE_1__/* .generateUrlParamsFromObject */ .Z)(queryParam);
}


/***/ }),

/***/ 40942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getAllVwoABTestVariations; }
/* harmony export */ });
/* unused harmony export getVwoABTestVariation */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77370);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36908);
/* harmony import */ var _constants_abTestVariations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60537);








var getSavedABTest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var cookies, savedABTestString;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
                    _ctx.next = 3;
                    return cookies.get(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__/* .COOKIES.abTest */ .E9.abTest);
                case 3:
                    savedABTestString = _ctx.sent;
                    if (savedABTestString) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return", {});
                case 6:
                    return _ctx.abrupt("return", JSON.parse(savedABTestString));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSavedABTest() {
        return _ref.apply(this, arguments);
    };
}();
var getABTestVariation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(campaign) {
        var cookies, abTestCookieData, currentCampaignVariation;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
                    _ctx.next = 3;
                    return getSavedABTest();
                case 3:
                    abTestCookieData = _ctx.sent;
                    currentCampaignVariation = abTestCookieData[campaign];
                    if (!currentCampaignVariation) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", +currentCampaignVariation);
                case 9:
                    if ( true && window) {
                        if (window.VWO && window.VWO.onVariationApplied) {
                            window.VWO.onVariationApplied(function(c) {
                                // c= [ , campaign, variation]
                                if (c[1] == campaign) {
                                    abTestCookieData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, abTestCookieData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, campaign, c[2]));
                                    cookies.set(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__/* .COOKIES.abTest */ .E9.abTest, JSON.stringify(abTestCookieData), _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_1__/* .DefaultCookieOptions */ .DL);
                                    currentCampaignVariation = c[2];
                                }
                            });
                        }
                    }
                    return _ctx.abrupt("return", +currentCampaignVariation);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getABTestVariation(campaign) {
        return _ref.apply(this, arguments);
    };
}();
var getVwoABTestVariation = function(campaign) {
    var cookies = new Cookies();
    var abTestVariation = cookies.get("_vis_opt_exp_".concat(campaign, "_combi")) || cookies.get("_vis_opt_exp_".concat(campaign, "_combi_choose"));
    if (abTestVariation) {
        return +abTestVariation;
    }
    return null;
};
var getAllVwoABTestVariations = function() {
    var cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
    var abTestVariations = {};
    for(var campaign in _constants_abTestVariations__WEBPACK_IMPORTED_MODULE_2__/* .AB_TEST_CAMPAIGN_IDS */ .V){
        var variation = cookies.get("_vis_opt_exp_".concat(_constants_abTestVariations__WEBPACK_IMPORTED_MODULE_2__/* .AB_TEST_CAMPAIGN_IDS */ .V[campaign], "_combi")) || cookies.get("_vis_opt_exp_".concat(_constants_abTestVariations__WEBPACK_IMPORTED_MODULE_2__/* .AB_TEST_CAMPAIGN_IDS */ .V[campaign], "_combi_choose"));
        abTestVariations[_constants_abTestVariations__WEBPACK_IMPORTED_MODULE_2__/* .AB_TEST_CAMPAIGN_IDS */ .V[campaign]] = +variation;
    }
    return {
        abTestVariations: abTestVariations
    };
};


/***/ }),

/***/ 48929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getPathName; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function getPathName() {
    var pathName = "";
    next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname.includes("web") ? pathName = next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname.replace("/web", "") : next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname.includes("mob") ? pathName = next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname.replace("/mob", "") : (next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname);
    return pathName;
}


/***/ }),

/***/ 45048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ getRequiredBid; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_constants_bidStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71535);

var getRequiredBid = function(bids) {
    return bids === null || bids === void 0 ? void 0 : bids.find(function(bid) {
        return bid.status != null && _vahak_core_dist_constants_bidStatus__WEBPACK_IMPORTED_MODULE_0__/* .PostAcceptanceBidStatusList.includes */ .QW.includes(bid.status);
    });
};


/***/ }),

/***/ 19736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ev": function() { return /* binding */ WEB_V2_BIDDING_LOCALIZATION_NAMESPACES; },
/* harmony export */   "ju": function() { return /* binding */ WEB_V2_POSTING_LOCALIZATION_NAMESPACES; },
/* harmony export */   "y$": function() { return /* binding */ WEB_V2_SHELL_LOCALIZATION_NAMESPACES; }
/* harmony export */ });
/* unused harmony exports WEB_V2_NAV_LOCALIZATION_NAMESPACES, LCV_ROUTE_BOOKING_LOCALIZATION_NAMESPACES, LOGGED_IN_APP_LOCALIZATION_NAMESPACES, HOME_LOCALIZATION_NAMESPACES, MARKETPLACE_V3_LOCALIZATION_NAMESPACES, MEMBERSHIP_UPGRADE_LOCALIZATION_NAMESPACES, DASHBOARD_LOCALIZATION_NAMESPACES, LISTING_PAGE_LOCALIZATION_NAMESPACES, USER_PROFILE_LOCALIZATION_NAMESPACES, BANK_DETAILS_LOCALIZATION_NAMESPACES, MEMBERSHIP_PLAN_LOCALIZATION_NAMESPACES, TRANSPORT_DIRECTORY_LOCALIZATION_NAMESPACES, TRANSPORTER_PROFILE_LOCALIZATION_NAMESPACES, TRANSPORT_NAGAR_LOCALIZATION_NAMESPACES, SERVICE_PAGE_LOCALIZATION_NAMESPACES, WHY_CHOOSE_US_LOCALIZATION_NAMESPACES, HOW_VAHAK_HELPS_LOCALIZATION_NAMESPACES, CITY_PAGE_LOCALIZATION_NAMESPACES, FAQ_LOCALIZATION_NAMESPACES, CONTACT_US_LOCALIZATION_NAMESPACES, CAREERS_LOCALIZATION_NAMESPACES, ABOUT_US_LOCALIZATION_NAMESPACES, PREMIUM_LOCALIZATION_NAMESPACES, PAYMENT_LOCALIZATION_NAMESPACES, HELP_LOCALIZATION_NAMESPACES, STATIC_PAGE_LOCALIZATION_NAMESPACES, VAS_STATIC_LOCALIZATION_NAMESPACES, CARGO_INSURANCE_LOCALIZATION_NAMESPACES, ROUTE_LOCALIZATION_NAMESPACES, getRouteLocalizationNamespaces */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50930);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94204);
/* harmony import */ var _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50837);




/** TopNavV2 labels (Find Loads, profile menu, app download banner). */ var WEB_V2_NAV_LOCALIZATION_NAMESPACES = [
    "navigation",
    "common"
];
/** Compact post-load sheet (opened from side nav, dashboard, marketplace, etc.). */ var WEB_V2_POSTING_LOCALIZATION_NAMESPACES = [
    "load-form",
    "homepageV2",
    "mktCardV2",
    "navigation",
    "common"
];
/** LCV route SEO landing pages — hero CTAs open the compact post-load sheet. */ var LCV_ROUTE_BOOKING_LOCALIZATION_NAMESPACES = [
    "lcvRouteLanding"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES));
/** Compact bid sheet */ var WEB_V2_BIDDING_LOCALIZATION_NAMESPACES = [
    "load-form",
    "mktCardV2",
    "homepageV2"
];
/** Nav + posting — load client-side on any route that can open post flow or TopNavV2. */ var WEB_V2_SHELL_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES));
/** Logged-in shell: mobile TopNavV2 + side-nav post load + compact flows. */ var LOGGED_IN_APP_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES));
/** Homepage + compact bid/post + top nav + shared cards */ var HOME_LOCALIZATION_NAMESPACES = [
    "homepageV2",
    "mktCardV2",
    "load-form",
    "navigation",
    "common"
];
/** Marketplace V3 + shared homepage-v2 / LCV landing surfaces */ var MARKETPLACE_V3_LOCALIZATION_NAMESPACES = [
    "marketplaceV3",
    "lcvRouteLanding",
    "homepageV2",
    "mktCardV2",
    "load-form",
    "navigation",
    "common"
];
/** Public upgrade page + compact post-load sheet opened from TopNavV2 / side nav. */ var MEMBERSHIP_UPGRADE_LOCALIZATION_NAMESPACES = [
    "membershipPage"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES));
/** Logged-in dashboard home + TopNavV2 + compact post-load flow */ var DASHBOARD_LOCALIZATION_NAMESPACES = [
    "homeRevamp"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES));
/** My loads / lorries listing & bids */ var LISTING_PAGE_LOCALIZATION_NAMESPACES = [
    "marketplace",
    "userProfile"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES));
var USER_PROFILE_LOCALIZATION_NAMESPACES = [
    "userProfile"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES));
var BANK_DETAILS_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES);
var MEMBERSHIP_PLAN_LOCALIZATION_NAMESPACES = [
    "membershipPage",
    "navigation",
    "common"
];
var TRANSPORT_DIRECTORY_LOCALIZATION_NAMESPACES = [
    "transporters"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
var TRANSPORTER_PROFILE_LOCALIZATION_NAMESPACES = [
    "userProfile",
    "marketplace",
    "transporters"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
var TRANSPORT_NAGAR_LOCALIZATION_NAMESPACES = [
    "common",
    "mktCardV2"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES));
var SERVICE_PAGE_LOCALIZATION_NAMESPACES = [
    "servicePages"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
var WHY_CHOOSE_US_LOCALIZATION_NAMESPACES = [
    "whyChooseUs"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
var HOW_VAHAK_HELPS_LOCALIZATION_NAMESPACES = [
    "howVahakHelpYou"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
/** City SEO landing pages — hero CTAs open the compact post-load sheet. */ var CITY_PAGE_LOCALIZATION_NAMESPACES = [
    "lcvRouteLanding"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES));
var FAQ_LOCALIZATION_NAMESPACES = [
    "faq"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
var CONTACT_US_LOCALIZATION_NAMESPACES = [
    "contactus"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES));
var CAREERS_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES);
var ABOUT_US_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES);
var PREMIUM_LOCALIZATION_NAMESPACES = [
    "marketplace"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES));
var PAYMENT_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(LOGGED_IN_APP_LOCALIZATION_NAMESPACES);
var HELP_LOCALIZATION_NAMESPACES = [
    "help",
    "common"
];
/** Legal/static pages with TopNavV2 only (content is mostly hardcoded). */ var STATIC_PAGE_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES);
/** Public VAS pages with TopNavV2 + compact post-load sheet (no page-specific i18n file). */ var VAS_STATIC_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES);
/** Cargo insurance — page copy + compact post-load sheet opened from TopNavV2. */ var CARGO_INSURANCE_LOCALIZATION_NAMESPACES = [
    "cargoInsurance"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_POSTING_LOCALIZATION_NAMESPACES));
var _obj;
/**
 * Maps a route pathname or layout route id to the i18n namespace files
 * required by `serverSideTranslations`.
 */ var ROUTE_LOCALIZATION_NAMESPACES = (_obj = {
    "/": HOME_LOCALIZATION_NAMESPACES
}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .HOME_ROUTE */ .ef, HOME_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .MARKETPLACE_ROUTE */ .C_, MARKETPLACE_V3_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "/membership/upgrade", MEMBERSHIP_UPGRADE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .MEMBERSHIP_UPGRADE */ .p$, MEMBERSHIP_UPGRADE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .DASHBOARD_ROUTE */ .zO, DASHBOARD_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "/dashboard", DASHBOARD_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .LISTING_PAGE */ .v2, LISTING_PAGE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .BANK_DETAILS */ .vQ, BANK_DETAILS_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .MEMBERSHIP */ .Rk, MEMBERSHIP_PLAN_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .MEMBERSHIP_HISTORY */ .mp, MEMBERSHIP_PLAN_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .MY_LORRIES_PAGE */ .fW, USER_PROFILE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "new", USER_PROFILE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .USER_PROFILE_PAGE */ .lG, USER_PROFILE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .TRANSPORT_DIRECTORY */ .fN, TRANSPORT_DIRECTORY_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "transporterProfile", TRANSPORTER_PROFILE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .TRANSPORT_NAGAR */ .Of, TRANSPORT_NAGAR_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "servicePages", SERVICE_PAGE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "whyChooseUs", WHY_CHOOSE_US_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "howVahakHelpYou", HOW_VAHAK_HELPS_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "cityPages", CITY_PAGE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "faq", FAQ_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "contactus", CONTACT_US_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "careers", CAREERS_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "aboutUs", ABOUT_US_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "premium", PREMIUM_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .BULK_LOADS_LIST */ .r6, PREMIUM_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREMIUM_LOAD_TRIP */ .sj, PREMIUM_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAYMENT_LIST */ .Rb, PREMIUM_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.payment.id */ .BLy.payment.id, PAYMENT_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "help", HELP_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "staticPage", STATIC_PAGE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.cargoInsurance.pathname */ .BLy.cargoInsurance.pathname, CARGO_INSURANCE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.cargoInsurance.id */ .BLy.cargoInsurance.id, CARGO_INSURANCE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "/vas/commercial-vehicle-insurance", VAS_STATIC_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.lcvBooking.pathname */ .BLy.lcvBooking.pathname, LCV_ROUTE_BOOKING_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.lcvBooking.id */ .BLy.lcvBooking.id, LCV_ROUTE_BOOKING_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _constants_route_constants__WEBPACK_IMPORTED_MODULE_3__/* .CLIENT_LISTING_PAGE */ .RH, LISTING_PAGE_LOCALIZATION_NAMESPACES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_0__/* .UserScreenId.listing.pathname */ .BLy.listing.pathname, LISTING_PAGE_LOCALIZATION_NAMESPACES), _obj);
var DEFAULT_LOCALIZATION_NAMESPACES = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(WEB_V2_NAV_LOCALIZATION_NAMESPACES);
function getRouteLocalizationNamespaces(route) {
    var namespaces = ROUTE_LOCALIZATION_NAMESPACES[route];
    if (namespaces) {
        return _to_consumable_array(namespaces);
    }
    return _to_consumable_array(DEFAULT_LOCALIZATION_NAMESPACES);
}


/***/ }),

/***/ 61706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U7": function() { return /* binding */ buildPageSeo; },
  "av": function() { return /* binding */ getDefaultOgImage; },
  "cd": function() { return /* binding */ getHomeUrl; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ./components/lcv-route-landing/data/index.ts + 3 modules
var data = __webpack_require__(52686);
// EXTERNAL MODULE: ./components/city/data/index.ts + 2 modules
var city_data = __webpack_require__(29185);
;// CONCATENATED MODULE: ./methods/getFaqSchemaOrgJson.ts
function getFaqSchemaOrgJson(param) {
    var quesAns = param.quesAns;
    var mainEntityArr = JSON.stringify(quesAns.map(function(q) {
        var answerText = q.descList ? "".concat(q.answer, "<ul>").concat(q.descList.map(function(item) {
            return "<li>".concat(item, "</li>");
        }).join(""), "</ul>") : q.answer;
        return {
            "@type": "Question",
            name: q.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: answerText
            }
        };
    }));
    return '\n                    {\n                        "@context": "https://schema.org",\n                        "@type": "FAQPage",\n                        "mainEntity": '.concat(mainEntityArr, "\n                    }\n            ");
}

;// CONCATENATED MODULE: ./methods/pageSeo.ts







var LOCALE_PATH_PREFIX = /^\/(en|hi|te|gu|kn|mr|bn|ta)(?=\/|$)/;
var DEFAULT_HREFLANG_LOCALES = [
    "en",
    "hi"
];
var DEFAULT_OG_IMAGE = "".concat(misc/* IMG_BASE_URL */.TS, "/web_og_image_jan_22.png");
var LCV_BOOKING_PATH = "/lcv-booking";
var LCV_BOOKING_PREFIX = "".concat(LCV_BOOKING_PATH, "/");
var CITY_PATH = "/city";
var CITY_PREFIX = "".concat(CITY_PATH, "/");
var HREFLANG_BY_LOCALE = {
    bn: "bn-IN",
    en: "en-IN",
    gu: "gu-IN",
    hi: "hi-IN",
    kn: "kn-IN",
    mr: "mr-IN",
    ta: "ta-IN",
    te: "te-IN"
};
function getLocaleHreflang(locale) {
    var _locale;
    return (_locale = HREFLANG_BY_LOCALE[locale]) !== null && _locale !== void 0 ? _locale : "en-IN";
}
function getLocaleOgLocale(locale) {
    return getLocaleHreflang(locale).replace("-", "_");
}
function getCanonicalPath(asPath) {
    var clean = asPath.replace(/^\/en\//, "/").replace(/^\/(web|mob)(?=\/|$)/, "").replace(/\/$/, "").split("?")[0].split("#")[0];
    return clean || "/";
}
function getLocaleNeutralPath(asPath) {
    var path = getCanonicalPath(asPath).replace(LOCALE_PATH_PREFIX, "");
    return path || "/";
}
function getLocaleNeutralPathFromCanonicalUrl(canonicalUrl) {
    var website = constants/* COMPANY_DETAILS.website.replace */.SXn.website.replace(/\/$/, "");
    if (!canonicalUrl.startsWith(website)) {
        return undefined;
    }
    var path = canonicalUrl.slice(website.length).split("?")[0].split("#")[0];
    if (!path || path === "/") {
        return "/";
    }
    return path.startsWith("/") ? path : "/".concat(path);
}
function resolveLocaleNeutralPath(config) {
    if (config.localeNeutralPath) {
        return config.localeNeutralPath.startsWith("/") ? config.localeNeutralPath : "/".concat(config.localeNeutralPath);
    }
    if (config.asPath) {
        return getLocaleNeutralPath(config.asPath);
    }
    if (config.canonicalUrl) {
        var ref;
        return (ref = getLocaleNeutralPathFromCanonicalUrl(config.canonicalUrl)) !== null && ref !== void 0 ? ref : "/";
    }
    return "/";
}
function getLocalizedPageUrl(locale, localeNeutralPath) {
    var website = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : constants/* COMPANY_DETAILS.website */.SXn.website;
    if (locale === "en") {
        return localeNeutralPath === "/" ? website : "".concat(website).concat(localeNeutralPath);
    }
    return localeNeutralPath === "/" ? "".concat(website, "/").concat(locale) : "".concat(website, "/").concat(locale).concat(localeNeutralPath);
}
function resolveCanonicalUrl(config, locale, localeNeutralPath) {
    if (locale === "en" && config.canonicalUrl) {
        return config.canonicalUrl;
    }
    return getLocalizedPageUrl(locale, localeNeutralPath);
}
function getHreflangAlternates(localeNeutralPath, locales) {
    return locales.map(function(locale) {
        return {
            hreflang: getLocaleHreflang(locale),
            href: getLocalizedPageUrl(locale, localeNeutralPath)
        };
    });
}
/** Add new SEO landing route families here. */ function getRouteSeoDefaults(localeNeutralPath) {
    if (localeNeutralPath === LCV_BOOKING_PATH) {
        return {
            hreflangLocales: DEFAULT_HREFLANG_LOCALES,
            schemaType: "WebPage"
        };
    }
    if (localeNeutralPath.startsWith(LCV_BOOKING_PREFIX)) {
        var slug = localeNeutralPath.slice(LCV_BOOKING_PREFIX.length).split("/")[0];
        var route = slug ? (0,data/* getLcvRouteBySlug */.l)(slug) : undefined;
        if (route) {
            var _hreflangLocales;
            return {
                hreflangLocales: (_hreflangLocales = route.hreflangLocales) !== null && _hreflangLocales !== void 0 ? _hreflangLocales : [
                    "en"
                ],
                schemaType: "WebPage"
            };
        }
    }
    if (localeNeutralPath.startsWith(CITY_PREFIX)) {
        var slug1 = localeNeutralPath.slice(CITY_PREFIX.length).split("/")[0];
        var city = slug1 ? (0,city_data/* getCityPageBySlug */.qS)(slug1) : undefined;
        if (city) {
            var _hreflangLocales1;
            return {
                hreflangLocales: (_hreflangLocales1 = city.hreflangLocales) !== null && _hreflangLocales1 !== void 0 ? _hreflangLocales1 : [
                    "en"
                ],
                schemaType: "WebPage"
            };
        }
    }
    return {
        hreflangLocales: DEFAULT_HREFLANG_LOCALES,
        schemaType: "WebPage"
    };
}
function appendBreadcrumbSchema(schemaScripts, breadcrumbJson) {
    if (!breadcrumbJson) {
        return;
    }
    schemaScripts.push({
        id: "jsonld-breadcrumb",
        json: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: JSON.parse(breadcrumbJson)
        })
    });
}
function breadcrumbListJson(items, locale, localeNeutralPathForCurrent) {
    return JSON.stringify(items.map(function(item, index) {
        var itemUrl = item.url;
        if (!itemUrl && item.path) {
            itemUrl = getLocalizedPageUrl(locale, item.path);
        }
        if (!itemUrl && index === items.length - 1 && localeNeutralPathForCurrent) {
            itemUrl = getLocalizedPageUrl(locale, localeNeutralPathForCurrent);
        }
        return (0,_object_spread/* default */.Z)({
            "@type": "ListItem",
            position: index + 1,
            name: item.name
        }, itemUrl ? {
            item: itemUrl
        } : {});
    }));
}
function getDefaultOgImage() {
    return DEFAULT_OG_IMAGE;
}
function getHomeUrl() {
    return "".concat(constants/* COMPANY_DETAILS.website */.SXn.website, "/");
}
function buildPageSeo(input, fallback) {
    var ref;
    var config = input ? (0,_object_spread/* default */.Z)({
        locale: fallback.locale,
        asPath: fallback.asPath
    }, input) : null;
    if (!(config === null || config === void 0 ? void 0 : config.title) && !(config === null || config === void 0 ? void 0 : config.description)) {
        var localeNeutralPath = getLocaleNeutralPath(fallback.asPath);
        var ref1 = getRouteSeoDefaults(localeNeutralPath), routeHreflangLocales = ref1.hreflangLocales;
        var hreflangLocales = (0,_to_consumable_array/* default */.Z)(routeHreflangLocales);
        var canonicalUrl = getLocalizedPageUrl(fallback.locale, localeNeutralPath);
        var ref2;
        return {
            canonicalUrl: canonicalUrl,
            ogUrl: canonicalUrl,
            ogImgSrc: DEFAULT_OG_IMAGE,
            shouldBeIndexed: (ref2 = config === null || config === void 0 ? void 0 : config.shouldBeIndexed) !== null && ref2 !== void 0 ? ref2 : true,
            ogLocaleAlternates: [],
            hreflangAlternates: getHreflangAlternates(localeNeutralPath, hreflangLocales),
            hreflangDefault: getLocalizedPageUrl("en", localeNeutralPath),
            schemaScripts: []
        };
    }
    var _locale;
    var locale = (_locale = config.locale) !== null && _locale !== void 0 ? _locale : fallback.locale;
    var localeNeutralPath1 = resolveLocaleNeutralPath(config);
    var routeDefaults = getRouteSeoDefaults(localeNeutralPath1);
    var canonicalUrl1 = resolveCanonicalUrl(config, locale, localeNeutralPath1);
    var ogUrl = locale === "en" && config.ogUrl ? config.ogUrl : canonicalUrl1;
    var _ogDescription;
    var ogDescription = (_ogDescription = config.ogDescription) !== null && _ogDescription !== void 0 ? _ogDescription : config.description;
    var _ogImgSrc;
    var ogImgSrc = (_ogImgSrc = config.ogImgSrc) !== null && _ogImgSrc !== void 0 ? _ogImgSrc : DEFAULT_OG_IMAGE;
    var _hreflangLocales;
    var hreflangLocales1 = (0,_to_consumable_array/* default */.Z)((_hreflangLocales = config.hreflangLocales) !== null && _hreflangLocales !== void 0 ? _hreflangLocales : routeDefaults.hreflangLocales);
    var _schema;
    var schema = (_schema = config.schema) !== null && _schema !== void 0 ? _schema : {};
    var _includeDefault, ref3;
    var includeDefault = (ref3 = (_includeDefault = schema.includeDefault) !== null && _includeDefault !== void 0 ? _includeDefault : config.includeDefaultSchema) !== null && ref3 !== void 0 ? ref3 : false;
    var _type, ref4;
    var schemaType = (ref4 = (_type = schema.type) !== null && _type !== void 0 ? _type : config.schemaType) !== null && ref4 !== void 0 ? ref4 : routeDefaults.schemaType;
    var _faqList;
    var faqList = (_faqList = schema.faqList) !== null && _faqList !== void 0 ? _faqList : config.faqList;
    var breadcrumbJson = config.breadcrumbList;
    if ((ref = schema.breadcrumbItems) === null || ref === void 0 ? void 0 : ref.length) {
        breadcrumbJson = breadcrumbListJson(schema.breadcrumbItems, locale, localeNeutralPath1);
    }
    var schemaScripts = [];
    if (includeDefault && schemaType === "WebPage" && config.title && config.description) {
        var graph = [
            {
                "@type": "WebPage",
                name: config.title,
                description: config.description,
                url: canonicalUrl1,
                inLanguage: getLocaleHreflang(locale)
            }
        ];
        if (breadcrumbJson) {
            graph.push({
                "@type": "BreadcrumbList",
                itemListElement: JSON.parse(breadcrumbJson)
            });
        }
        schemaScripts.push({
            id: "jsonld-page",
            json: JSON.stringify({
                "@context": "https://schema.org",
                "@graph": graph
            })
        });
    }
    if (faqList === null || faqList === void 0 ? void 0 : faqList.length) {
        schemaScripts.push({
            id: "jsonld-faq",
            json: getFaqSchemaOrgJson({
                quesAns: faqList
            })
        });
    }
    if (!includeDefault && breadcrumbJson) {
        appendBreadcrumbSchema(schemaScripts, breadcrumbJson);
    }
    if (schema.extraJsonLd) {
        var entries = Array.isArray(schema.extraJsonLd) ? schema.extraJsonLd : [
            schema.extraJsonLd
        ];
        entries.forEach(function(entry, index) {
            schemaScripts.push({
                id: "jsonld-extra-".concat(index),
                json: JSON.stringify(entry)
            });
        });
    }
    var _shouldBeIndexed;
    return {
        title: config.title,
        description: config.description,
        keywords: config.keywords,
        canonicalUrl: canonicalUrl1,
        ogUrl: ogUrl,
        ogDescription: ogDescription,
        ogImgSrc: ogImgSrc,
        ogImgAltText: config.ogImgAltText,
        ogType: config.ogType,
        ogSiteName: config.ogSiteName,
        ogLocale: getLocaleOgLocale(locale),
        ogLocaleAlternates: hreflangLocales1.filter(function(entry) {
            return entry !== locale;
        }).map(getLocaleOgLocale),
        shouldBeIndexed: (_shouldBeIndexed = config.shouldBeIndexed) !== null && _shouldBeIndexed !== void 0 ? _shouldBeIndexed : true,
        hreflangAlternates: getHreflangAlternates(localeNeutralPath1, hreflangLocales1),
        hreflangDefault: getLocalizedPageUrl("en", localeNeutralPath1),
        schemaScripts: schemaScripts
    };
}


/***/ }),

/***/ 95535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ removeSubstringWithParenthesis; }
/* harmony export */ });
var removeSubstringWithParenthesis = function(input) {
    return input.replace(/\(.*?\)/g, "").trim();
};


/***/ }),

/***/ 72397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Js": function() { return /* binding */ getSecondsLeftFromNow; },
/* harmony export */   "tg": function() { return /* binding */ convertSecondsTime; }
/* harmony export */ });
/* unused harmony exports mergeDateAndTime, getCurrentUnixTimestamp */
function mergeDateAndTime() {
    var dateWithDatePart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), dateWithTimePart = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    // Extract date components from the first Date object
    if (dateWithDatePart && dateWithTimePart) {
        var year = dateWithDatePart.getFullYear();
        var month = dateWithDatePart.getMonth();
        var day = dateWithDatePart.getDate();
        // Extract time components from the second Date object
        var hours = dateWithTimePart.getHours();
        var minutes = dateWithTimePart.getMinutes();
        var seconds = dateWithTimePart.getSeconds();
        var milliseconds = dateWithTimePart.getMilliseconds();
        // Create a new Date object by merging date and time components
        return new Date(year, month, day, hours, minutes, seconds, milliseconds);
    }
}
function convertSecondsTime() {
    var secs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var hours = Math.floor(secs / (60 * 60));
    var divisor_for_minutes = secs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);
    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);
    return {
        h: hours,
        m: minutes,
        s: seconds
    };
}
function getCurrentUnixTimestamp() {
    var currentUnixTimestamp = Math.floor(Date.now() / 1000); // Current time in seconds (Unix time)
    return currentUnixTimestamp;
}
function getSecondsLeftFromNow(futureUnixTime) {
    var currentTime = getCurrentUnixTimestamp();
    var differenceInSeconds = Math.max(futureUnixTime - currentTime, 0);
    return differenceInSeconds;
}


/***/ }),

/***/ 34695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ow": function() { return /* binding */ generateSelectOption; }
/* harmony export */ });
/* unused harmony exports numericEnumToArrayKeys, numericEnumToArrayValues */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70865);

var generateSelectOption = function(label, value, id) {
    var result = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        label: label,
        value: value
    }, id != undefined && {
        id: id
    });
    return result;
};
function numericEnumToArrayKeys(data) {
    return Object.keys(data).filter(function(key) {
        return isNaN(Number(key));
    });
}
function numericEnumToArrayValues(data) {
    return Object.values(data).filter(function(key) {
        return !isNaN(Number(key));
    });
}


/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(30195)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(9788)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(30199)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(2784));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (experimentalUnoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (false) {}
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
var ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"https://d3ib4ot6oar1ep.cloudfront.net","loader":"default","dangerouslyAllowSVG":false} || {}, _experimentalRemotePatterns = ref.experimentalRemotePatterns, experimentalRemotePatterns = _experimentalRemotePatterns === void 0 ? [] : _experimentalRemotePatterns, experimentalUnoptimized = ref.experimentalUnoptimized;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"https://d3ib4ot6oar1ep.cloudfront.net","loader":"default","dangerouslyAllowSVG":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (false) {}
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    // auto params can be combined with comma separation, or reiteration
    params.set("auto", params.getAll("auto").join(",") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(19178)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an AppRouterInstance, then it'll have `softPush` and
        // `softReplace`.
        if ("softPush" in router && "softReplace" in router) {
            // If we're doing a soft navigation, use the soft variants of
            // replace/push.
            var method = soft ? replace ? "softReplace" : "softPush" : replace ? "replace" : "push";
            router[method](href);
        } else {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        }
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, soft = props.soft, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "soft",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _slicedToArray(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(54566)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(2784);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
var observers = new Map();
var idList = [];
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 59470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36908);
/* harmony import */ var _vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77370);
/* harmony import */ var _vahak_core_dist_services_hooks_useAuthService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26231);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49352);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82066);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_methods_handleLogout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34025);
/* harmony import */ var _vahak_core_dist_services_utils_removeAuthToken__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(886);
/* harmony import */ var _components_mobile_app_mobileAppFunctions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40932);












var AuthVerifyComponent = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_7__/* .AppContext */ .Il), setCompanyId = ref.setCompanyId, setIsPhoneVerified = ref.setIsPhoneVerified, setName = ref.setName, setLang = ref.setLang, setCompanyLogo = ref.setCompanyLogo, setUserId = ref.setUserId, phoneNum = ref.phoneNum, setCsDashboardUserRoles = ref.setCsDashboardUserRoles, setCustomerCompanyId = ref.setCustomerCompanyId, setCustomerName = ref.setCustomerName, setCustomerPhone = ref.setCustomerPhone, setShowBankAddPopup = ref.setShowBankAddPopup, setSessionId = ref.setSessionId, setThirdPartyCompanyName = ref.setThirdPartyCompanyName;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), validateQueryEnabled = ref1[0], setValidateQueryEnabled = ref1[1];
    var prevPathNameRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var cookies = new react_cookie__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z();
    var token = cookies.get(_vahak_core_dist_constants_misc__WEBPACK_IMPORTED_MODULE_3__/* .COOKIES.token */ .E9.token);
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQueryClient)();
    var ref2 = (0,_vahak_core_dist_services_hooks_useAuthService__WEBPACK_IMPORTED_MODULE_4__/* .useValidateToken */ .h)({
        token: token,
        enabled: validateQueryEnabled
    }), tokenStatus = ref2.data;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setValidateQueryEnabled(!!token);
    }, [
        token
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!token || tokenStatus === true) {
            return;
        }
        if (tokenStatus === false) {
            /**
             * TODO (gowdham): update handleLogout method with latest code from master
             */ (0,_vahak_core_dist_services_utils_removeAuthToken__WEBPACK_IMPORTED_MODULE_9__/* .removeAuthToken */ .H)();
            (0,_vahak_core_dist_methods_handleLogout__WEBPACK_IMPORTED_MODULE_8__/* .handleLogout */ .h)({
                setCompanyId: setCompanyId,
                setIsPhoneVerified: setIsPhoneVerified,
                setName: setName,
                setLang: setLang,
                setCompanyLogo: setCompanyLogo,
                setUserId: setUserId,
                phoneNum: Number(phoneNum),
                setCsDashboardUserRoles: setCsDashboardUserRoles,
                setCustomerCompanyId: setCustomerCompanyId,
                setCustomerName: setCustomerName,
                setCustomerPhone: setCustomerPhone,
                setShowBankAddPopup: setShowBankAddPopup,
                setSessionId: setSessionId,
                setThirdPartyCompanyName: setThirdPartyCompanyName
            });
            (0,_components_mobile_app_mobileAppFunctions__WEBPACK_IMPORTED_MODULE_10__/* .ClearAppCookiesAndLogoutFlutterPage */ .KV)();
        }
    }, [
        tokenStatus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleRouteChange = function() {
            if (prevPathNameRef.current === router.pathname) {
                return;
            }
            queryClient.invalidateQueries(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_5__/* .QueryNames.validateToken */ ._.validateToken);
            prevPathNameRef.current = router.pathname;
        };
        router.events.on("routeChangeStart", handleRouteChange);
        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["default"] = (AuthVerifyComponent);


/***/ }),

/***/ 23081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./public/assets/css/index.css
var css = __webpack_require__(31183);
// EXTERNAL MODULE: ../../node_modules/bootstrap/scss/bootstrap.scss
var bootstrap = __webpack_require__(3344);
// EXTERNAL MODULE: ../core/dist/scss/index.scss
var scss = __webpack_require__(92870);
// EXTERNAL MODULE: ./styles/aboutus.scss
var aboutus = __webpack_require__(15610);
// EXTERNAL MODULE: ./styles/MostSearchedLinks.scss
var MostSearchedLinks = __webpack_require__(60946);
// EXTERNAL MODULE: ./styles/header.scss
var header = __webpack_require__(21581);
// EXTERNAL MODULE: ./styles/DashboardNav.scss
var DashboardNav = __webpack_require__(26434);
// EXTERNAL MODULE: ./styles/Search.scss
var Search = __webpack_require__(71070);
// EXTERNAL MODULE: ./styles/moengage-optin.scss
var moengage_optin = __webpack_require__(46359);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(75969);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/CookiesContext.js
var CookiesContext = __webpack_require__(83029);
;// CONCATENATED MODULE: ../../node_modules/react-cookie/es6/CookiesProvider.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var CookiesProvider = /** @class */ (function (_super) {
    __extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) {
            _this.cookies = props.cookies;
        }
        else {
            _this.cookies = new es6/* default */.Z();
        }
        return _this;
    }
    CookiesProvider.prototype.render = function () {
        return react.createElement(CookiesContext/* Provider */.zt, { value: this.cookies }, this.props.children);
    };
    return CookiesProvider;
}(react.Component));
/* harmony default export */ var es6_CookiesProvider = (CookiesProvider);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(56203);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/constants/tab.js
var tab = __webpack_require__(71076);
// EXTERNAL MODULE: ../../node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(36023);
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/hooks/useSetAppContext.js + 1 modules
var useSetAppContext = __webpack_require__(38566);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(47004);
// EXTERNAL MODULE: ../core/dist/components/toast/toast.js + 6 modules
var toast = __webpack_require__(63118);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./methods/getPathName.ts
var getPathName = __webpack_require__(48929);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useUserProfileService.js
var useUserProfileService = __webpack_require__(84327);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../core/dist/_services/hooks/queryNames.js
var queryNames = __webpack_require__(49352);
// EXTERNAL MODULE: ./methods/getABTestVariation.ts
var getABTestVariation = __webpack_require__(40942);
// EXTERNAL MODULE: ../core/dist/_services/hooks/useEventTrackerService.js + 1 modules
var useEventTrackerService = __webpack_require__(10182);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ../core/dist/_services/user-analytics.service.js
var user_analytics_service = __webpack_require__(8880);
// EXTERNAL MODULE: ./services/company/useGetCompanyCashbackDetails.ts
var useGetCompanyCashbackDetails = __webpack_require__(93269);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core/dist/hooks/useCsDashboard.js
var useCsDashboard = __webpack_require__(68191);
// EXTERNAL MODULE: ./context/RemoteConfigContext.tsx
var RemoteConfigContext = __webpack_require__(94954);
// EXTERNAL MODULE: ./components/posting/load-posting/helpers/lcv-expirement.ts
var lcv_expirement = __webpack_require__(84788);
;// CONCATENATED MODULE: ./CommonInnerContextWrapper.tsx







var Context = /*#__PURE__*/ (0,react.createContext)({});
function CommonInnerContextWrapper(param) {
    var children = param.children;
    var context = (0,react.useContext)(app_context/* AppContext */.Il);
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var companyId = Number((context === null || context === void 0 ? void 0 : context.customerCompanyId) || (context === null || context === void 0 ? void 0 : context.companyId)) || 0;
    var remoteConfig = (0,RemoteConfigContext/* useRemoteConfig */.V)();
    var readRemoteConfig = remoteConfig.readValue;
    var initializedKeyRef = (0,react.useRef)(null);
    // Init during render (not useEffect) so children see the list on the same pass as isLoaded.
    if (remoteConfig === null || remoteConfig === void 0 ? void 0 : remoteConfig.isLoaded) {
        var ref;
        var initKey = "".concat(companyId, "-").concat((ref = context === null || context === void 0 ? void 0 : context.joinedOn) !== null && ref !== void 0 ? ref : "", "-").concat(isCsDashboardUser);
        if (initializedKeyRef.current !== initKey) {
            var loadConfig = readRemoteConfig(lcv_expirement/* VEHICLE_REMOTE_CONFIG_KEY.load */._K.load, "json", []);
            var lorryConfig = readRemoteConfig(lcv_expirement/* VEHICLE_REMOTE_CONFIG_KEY.lorry */._K.lorry, "json", []);
            var ref1;
            var listForLoad = (ref1 = loadConfig === null || loadConfig === void 0 ? void 0 : loadConfig.vehicles) !== null && ref1 !== void 0 ? ref1 : [];
            var ref2;
            var listForLorry = (ref2 = lorryConfig === null || lorryConfig === void 0 ? void 0 : lorryConfig.vehicles) !== null && ref2 !== void 0 ? ref2 : [];
            if (!isCsDashboardUser) {
                var restrictionMeta = readRemoteConfig(lcv_expirement/* NEW_USER_VEHICLE_RESTRICTION_KEY */.MA, "json");
                var ref3;
                var joinedOn = (ref3 = context === null || context === void 0 ? void 0 : context.joinedOn) !== null && ref3 !== void 0 ? ref3 : "";
                var ref4;
                listForLoad = (ref4 = (0,lcv_expirement/* filterExpirementLorryList */.mr)({
                    companyId: companyId,
                    joinedOn: joinedOn,
                    list: listForLoad,
                    meta: restrictionMeta,
                    scope: "load"
                })) !== null && ref4 !== void 0 ? ref4 : [];
                var ref5;
                listForLorry = (ref5 = (0,lcv_expirement/* filterExpirementLorryList */.mr)({
                    companyId: companyId,
                    joinedOn: joinedOn,
                    list: listForLorry,
                    meta: restrictionMeta,
                    scope: "lorry"
                })) !== null && ref5 !== void 0 ? ref5 : [];
            }
            (0,constants/* initLorryList */.R0m)(listForLoad, listForLorry);
            initializedKeyRef.current = initKey;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: {},
        children: children
    });
}
/* harmony default export */ var CommonInnerContextWrapper_0 = (CommonInnerContextWrapper);

;// CONCATENATED MODULE: ./AppContextWrapper.tsx





















// import BulkMinimiseMaximise from "./components/min-max-bulk/BulkMinimiseMaximise";








var SupportMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() | SupportMenu */ 5606).then(__webpack_require__.bind(__webpack_require__, 12016)).catch(function() {
        return function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        };
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12016)
            ];
        }
    },
    ssr: false
});
// polyfill of Object.fromEntries for old browsers. react-query is using Object.fromEntries which causes error in old browsers.
if (!Object.fromEntries) {
    Object.fromEntries = function(entries) {
        if (!entries || !entries[Symbol.iterator]) {
            throw new Error("Object.fromEntries() requires a single iterable argument");
        }
        var obj = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                obj[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
}
function AppContextWrapper(param) {
    var children = param.children, isMobile = param.isMobile;
    var i18n = (0,esm/* useTranslation */.$G)().i18n;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "numOfContactRqsts"
    ]), 2), cookies = ref[0], setCookie = ref[1];
    var ref1 = (0,useUserProfileService/* useUpdateCompanyDetails */.JK)(), updateCompanyDetails = ref1.mutateAsync;
    var router = (0,client_router.useRouter)();
    var tokenDetails = router.query["td"];
    var ref2 = (0,useSetAppContext/* useSetAppContext */.G)(), context = ref2.context, setContext = ref2.setContext;
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var ref3 = (0,useGetCompanyCashbackDetails/* useGetCompanyCashbackDetailsMutationQuery */.Y)(), getCompanyCashabackDetails = ref3.mutateAsync;
    var queryClient = (0,es.useQueryClient)();
    /**
     * User company details - api call
     * On page load this api will be called and updated in context
     * Coverage - Nextjs package
     * * Any changes should be changed in both AppContextWrapper nextjs and admin
     */ (0,useUserProfileService/* useGetUserProfileDetails */.SX)({
        companyId: Number(context.companyId)
    }, {
        enabled: Boolean(context.isPhoneVerified && Number(context.companyId)),
        refetchInterval: 0,
        retry: 0,
        refetchOnWindowFocus: false,
        onError: function() {},
        onSuccess: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, ref1, companyData, finalDataToExtract, result, cashbackDetails, ref2, ref3, ref4, coinsData, ref5, membershipData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            companyData = data;
                            finalDataToExtract = {};
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return getCompanyCashabackDetails({
                                companyId: Number(context.companyId)
                            });
                        case 6:
                            result = _ctx.sent;
                            cashbackDetails = (result === null || result === void 0 ? void 0 : result.data) || {};
                            ;
                            coinsData = {
                                coinsTotal: Math.ceil((ref2 = cashbackDetails === null || cashbackDetails === void 0 ? void 0 : cashbackDetails.total_cashback_amount) !== null && ref2 !== void 0 ? ref2 : 0),
                                coinsBlocked: Math.ceil((ref3 = cashbackDetails === null || cashbackDetails === void 0 ? void 0 : cashbackDetails.blocked_cashback_amount) !== null && ref3 !== void 0 ? ref3 : 0),
                                coinsExpiringToday: Math.ceil((ref4 = cashbackDetails === null || cashbackDetails === void 0 ? void 0 : cashbackDetails.coins_expiring_today) !== null && ref4 !== void 0 ? ref4 : 0),
                                coinsAvailable: 0
                            };
                            coinsData["coinsAvailable"] = Math.max(coinsData.coinsTotal - coinsData.coinsBlocked, 0);
                            finalDataToExtract = (0,_object_spread/* default */.Z)({}, coinsData);
                            _ctx.next = 16;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](3);
                        case 16:
                            if (context === null || context === void 0 ? void 0 : (ref = context.globalData) === null || ref === void 0 ? void 0 : ref.is_login_successful) {
                                ;
                                (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("total_loads", companyData === null || companyData === void 0 ? void 0 : companyData.total_loads);
                                (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("total_lorries", companyData === null || companyData === void 0 ? void 0 : companyData.total_lorries);
                                (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("total_connections", companyData === null || companyData === void 0 ? void 0 : companyData.total_connections);
                                (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("user_rating", companyData === null || companyData === void 0 ? void 0 : companyData.avg_rating);
                                (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("materials_handled", companyData === null || companyData === void 0 ? void 0 : companyData.handled_materials);
                                (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("routes", companyData === null || companyData === void 0 ? void 0 : (ref5 = companyData.routes) === null || ref5 === void 0 ? void 0 : ref5.map(function(r) {
                                    return r.name;
                                }));
                            }
                            membershipData = {
                                membershipRequired: companyData === null || companyData === void 0 ? void 0 : companyData.membership_required,
                                haveMembership: companyData === null || companyData === void 0 ? void 0 : companyData.have_membership,
                                membershipStatus: companyData === null || companyData === void 0 ? void 0 : companyData.membership_status,
                                membershipPlanName: companyData === null || companyData === void 0 ? void 0 : companyData.membership_plan_name
                            };
                            setContext(function(state) {
                                return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    joinedOn: companyData === null || companyData === void 0 ? void 0 : companyData.joined_on,
                                    isAadhaarVerified: data === null || data === void 0 ? void 0 : data.is_aadhaar_verified,
                                    isPanVerified: data === null || data === void 0 ? void 0 : data.is_pan_verified,
                                    isGstVerified: data === null || data === void 0 ? void 0 : data.is_gst_verified,
                                    userCompanyInfo: {
                                        cityName: data === null || data === void 0 ? void 0 : data.city,
                                        stateName: data === null || data === void 0 ? void 0 : data.state,
                                        stateId: companyData === null || companyData === void 0 ? void 0 : companyData.state_id,
                                        placeId: data === null || data === void 0 ? void 0 : data.company_place_id
                                    },
                                    taggedAgent: data === null || data === void 0 ? void 0 : data.agent_details
                                }), finalDataToExtract, membershipData);
                            });
                            (ref1 = context.setCompanyId) === null || ref1 === void 0 ? void 0 : ref1.call(context, data === null || data === void 0 ? void 0 : data.id);
                            context.setName(data === null || data === void 0 ? void 0 : data.name);
                            context.setServiceType(data === null || data === void 0 ? void 0 : data.service_type);
                            context.setCompanyLogo(data === null || data === void 0 ? void 0 : data.logo);
                            context.setUserId(data === null || data === void 0 ? void 0 : data.user_id);
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        14
                    ]
                ]);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    (0,react.useEffect)(function() {
        setContext(function(state) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                lang: (ref = languages/* Languages.find */.lI.find(function(lang) {
                    return lang.value === i18n.language;
                })) === null || ref === void 0 ? void 0 : ref.id,
                setLang: function(lang) {
                    var language = languages/* Languages.find */.lI.find(function(langObj) {
                        return langObj.id === lang;
                    });
                    if (i18n.language !== (language === null || language === void 0 ? void 0 : language.value)) {
                        // i18n.changeLanguage(language?.value);
                        router.push({
                            pathname: (0,getPathName/* getPathName */.y)(),
                            query: (0,_object_spread/* default */.Z)({}, router.query)
                        }, undefined, {
                            locale: (language === null || language === void 0 ? void 0 : language.value) || "en"
                        });
                        if (cookies[misc/* COOKIES.companyId */.E9.companyId]) {
                            (0,useUserProfileService/* handleUpdateCompanyDetails */.IP)(updateCompanyDetails, {
                                companyId: cookies[misc/* COOKIES.companyId */.E9.companyId],
                                languageCode: lang
                            });
                        }
                        toast/* toast.success */.A.success("Language changed to ".concat((language === null || language === void 0 ? void 0 : language.labelInLanguage) || "English"));
                    }
                },
                /**
             * This is to close the kyc modal when router is changed
             */ showMandateKycPopup: false,
                showGstVerificationPopup: false
            });
        });
    }, [
        router.pathname
    ]);
    (0,react.useEffect)(function() {
        var referralCode = new URLSearchParams(router.asPath.split("?")[1]).get("referral_code");
        if (referralCode && context.setReferralCode) {
            var ref;
            (ref = context.setReferralCode) === null || ref === void 0 ? void 0 : ref.call(context, referralCode);
        }
    }, [
        context.setReferralCode
    ]);
    (0,react.useEffect)(function() {
        setContext(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                hostURL: window.location.origin,
                setShowUpgradeMembershipPlanPopup: function(val, targetAction, membershipStatus) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showUpgradeMembershipPlanPopup: val,
                            upgradeModalTargetAction: targetAction,
                            upgradeModalMembershipStatus: membershipStatus,
                            mandateUserVerificationCallBackFunction: undefined
                        });
                    });
                },
                setShowMandateKycPopup: function(val) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showMandateKycPopup: val,
                            mandateUserVerificationCallBackFunction: undefined
                        });
                    });
                },
                setShowGstVerificationPopup: function(val) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showGstVerificationPopup: val,
                            mandateUserVerificationCallBackFunction: undefined
                        });
                    });
                },
                setMandateUserVerificationCallBackFunction: function(cb) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            mandateUserVerificationCallBackFunction: cb
                        });
                    });
                },
                hideMandateKycPop: function() {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showMandateKycPopup: false,
                            mandateUserVerificationCallBackFunction: undefined
                        });
                    });
                },
                resetMandateKycPop: function() {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showMandateKycPopup: true,
                            mandateUserVerificationCallBackFunction: undefined
                        });
                    });
                },
                revalidateGetDocsStatus: function() {
                    return queryClient.invalidateQueries([
                        queryNames/* QueryNames.getDocumentsNonMutate */._.getDocumentsNonMutate
                    ]);
                },
                setModalState: function(modalState) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            modalState: (0,_object_spread/* default */.Z)({}, modalState)
                        });
                    });
                },
                setMandateUserVerificationActionTriggered: function(val) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            mandateUserVerificationActionTriggered: val
                        });
                    });
                },
                setMandateUserVerificationActionType: function(val) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            mandateUserVerificationActionType: val
                        });
                    });
                },
                setShowBankAddPopup: function(val, cb) {
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showBankAddPopup: val,
                            onSuccessAddBankCallback: cb
                        });
                    });
                },
                setShowShareModalPopup: function(param) {
                    var isVisible = param.isVisible, mktType = param.mktType, data = param.data;
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showShareModalPopup: {
                                isVisible: isVisible,
                                mktType: mktType,
                                data: data
                            }
                        });
                    });
                }
            }), (0,getABTestVariation/* getAllVwoABTestVariations */.c)()), {
                setAbTestVariations: function() {
                    setContext(function(state) {
                        return (0,_object_spread/* default */.Z)({}, state, (0,getABTestVariation/* getAllVwoABTestVariations */.c)());
                    });
                },
                setShowClearDuePopup: function(param) {
                    var isOpen = param.isOpen, dueAmount = param.dueAmount;
                    setContext(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            showClearDuePopup: isOpen,
                            dueAmount: dueAmount,
                            mandateUserVerificationCallBackFunction: undefined
                        });
                    });
                }
            });
        });
    }, []);
    (0,react.useEffect)(function() {
        if (tokenDetails) {
            var _NEXT_PUBLIC_THIRD_PARTY_COOKIE_ENCRYPTION_KEY;
            var bytes = crypto_js_default().AES.decrypt(tokenDetails.toString(), (_NEXT_PUBLIC_THIRD_PARTY_COOKIE_ENCRYPTION_KEY = "7406556d-a755-4b8e-8e17-f8feca26b752") !== null && _NEXT_PUBLIC_THIRD_PARTY_COOKIE_ENCRYPTION_KEY !== void 0 ? _NEXT_PUBLIC_THIRD_PARTY_COOKIE_ENCRYPTION_KEY : "");
            var decryptedData = JSON.parse(bytes.toString((crypto_js_default()).enc.Utf8));
            var ci = decryptedData.ci, vt = decryptedData.vt;
            if (ci && vt) {
                setContext(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        companyId: ci,
                        isPhoneVerified: true,
                        thirdPartyCompanyName: "Roadcast"
                    });
                });
                setCookie(misc/* COOKIES.thirdPartyCompanyName */.E9.thirdPartyCompanyName, "Roadcast", misc/* DefaultCookieOptions */.DL);
                setCookie(misc/* COOKIES.token */.E9.token, vt, misc/* DefaultCookieOptions */.DL);
                setCookie(misc/* COOKIES.isVerified */.E9.isVerified, 1, misc/* DefaultCookieOptions */.DL);
                sendGAandMoEngageEvent({
                    name: event_names/* GA4EventNames.THIRD_PARTY.third_party_login */.wQ.THIRD_PARTY.third_party_login,
                    data: {
                        third_party_company_name: "Roadcast",
                        company_id: ci
                    }
                });
            }
            delete router.query["td"];
        }
    }, [
        tokenDetails
    ]);
    /**
     * Since aspath will return pathname along with query params
     * router.asPath.split("?")[0] - added this condition
     */ var hideSupportMenuInExcludedRoutes = [
        routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING),
        routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("loads", tab/* MY_LOAD_LORRY_TABS.BIDS */.n.BIDS),
        routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING),
        routeStrings/* ROUTES.myLoadsMyLorries.getUrl */.Z.myLoadsMyLorries.getUrl("lorries", tab/* MY_LOAD_LORRY_TABS.BIDS */.n.BIDS),
        routeStrings/* ROUTES.help.getUrl */.Z.help.getUrl()
    ].includes(router.asPath.split("?")[0]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(app_context/* AppContext.Provider */.Il.Provider, {
        value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, context), {
            isMobile: isMobile
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommonInnerContextWrapper_0, {
            children: [
                children,
                isMobile && !hideSupportMenuInExcludedRoutes && /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportMenu, {})
            ]
        })
    });
}
/* harmony default export */ var AppContextWrapper_0 = (AppContextWrapper);

// EXTERNAL MODULE: ../../node_modules/react-query/devtools/index.js
var devtools = __webpack_require__(17783);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/layout/dashboard-navbar/DashboardNavbar.tsx
var DashboardNavbar = __webpack_require__(51938);
// EXTERNAL MODULE: ./components/layout/index.ts + 4 modules
var layout = __webpack_require__(99456);
// EXTERNAL MODULE: ./constants/route-constants.ts
var route_constants = __webpack_require__(50837);
;// CONCATENATED MODULE: ./components/layout/private-route/PrivateRoute.tsx





var PrivateRoute = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var router = (0,next_router.useRouter)();
    var wasAuthenticatedRef = (0,react.useRef)(false);
    var isAuthenticated = Boolean(isPhoneVerified && companyId);
    (0,react.useEffect)(function() {
        if (isAuthenticated) {
            wasAuthenticatedRef.current = true;
            return;
        }
        if (wasAuthenticatedRef.current) {
            wasAuthenticatedRef.current = false;
            void router.replace("/", undefined, {
                shallow: true,
                scroll: false
            });
            return;
        }
        router.push("".concat(routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("load")));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isAuthenticated && children
    });
};
/* harmony default export */ var private_route_PrivateRoute = (PrivateRoute);

;// CONCATENATED MODULE: ./components/layout/private-premium-route/PrivatePremiumRoute.tsx




var PrivatePremiumRoute_PrivateRoute = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (!isPhoneVerified || !companyId) {
            router.push("/login");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPhoneVerified,
        companyId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isPhoneVerified && companyId && children
    });
};
/* harmony default export */ var PrivatePremiumRoute = (PrivatePremiumRoute_PrivateRoute);

// EXTERNAL MODULE: ./components/layout/navbar-menu-items.tsx + 7 modules
var navbar_menu_items = __webpack_require__(63938);
;// CONCATENATED MODULE: ./components/layout/mobile-app-no-navbar/MobileAppWebViewLayout.tsx


var MobileAppWebViewLayout = function(param) {
    var page = param.page;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: page
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(58013);
// EXTERNAL MODULE: ./components/layout/default-layout/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(78485);
;// CONCATENATED MODULE: ./components/layout/DefaultLayoutWrapper/DefaultLayoutWrapper.tsx




// Layout

// Context

//Constants

var DefaultLayoutWrapper = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId, shouldPreventLayoutSwitch = ref.shouldPreventLayoutSwitch;
    var Content = props.content, children = props.children, navContent = props.navContent, pageRoute = props.pageRoute, hideTopNav = props.hideTopNav;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        /**
         * Temp fix
         * home page fix
         */ if (!shouldPreventLayoutSwitch) setTimeout(function() {
            if ([
                "/",
                "/web",
                "/mob"
            ].includes(router.pathname) && isPhoneVerified && !!companyId) {
                router.replace({
                    pathname: routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl(),
                    hash: undefined
                }, undefined, {
                    shallow: false
                });
            }
        }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.pathname,
        isPhoneVerified,
        companyId,
        shouldPreventLayoutSwitch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
        navContent: navContent,
        hideTopNav: hideTopNav,
        children: children
    });
};
/* harmony default export */ var DefaultLayoutWrapper_DefaultLayoutWrapper = (DefaultLayoutWrapper);

// EXTERNAL MODULE: ./components/layout/SideNavLayoutWrapper/SideNavLayoutWrapper.tsx + 13 modules
var SideNavLayoutWrapper = __webpack_require__(89363);
;// CONCATENATED MODULE: ./components/layout/membership-layout-wrapper/MembershipLayoutWrapper.tsx






var MembershipLayoutWrapper = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var Content = props.content, children = props.children, navContent = props.navContent, pageRoute = props.pageRoute;
    if (isPhoneVerified && companyId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavLayoutWrapper/* default */.Z, {
            children: children
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
            navContent: navContent,
            children: children
        });
    }
};

// EXTERNAL MODULE: ./components/layout/plain-layout/PlainLayout.tsx
var PlainLayout = __webpack_require__(23441);
// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ../core/dist/constants/userScreenId.js
var userScreenId = __webpack_require__(98606);
// EXTERNAL MODULE: ../core/dist/components/loader.js
var loader = __webpack_require__(26415);
// EXTERNAL MODULE: ../core-ui/dist/methods/browser.js
var browser = __webpack_require__(82238);
// EXTERNAL MODULE: ./constants/deep-links.ts
var deep_links = __webpack_require__(73278);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/CompactLoadPostingProvider.tsx + 1 modules
var CompactLoadPostingProvider = __webpack_require__(56193);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-bidding/CompactLoadBiddingProvider.tsx
var CompactLoadBiddingProvider = __webpack_require__(64200);
;// CONCATENATED MODULE: ./components/layout/homepage-v2-auth-guard/HomepageV2AuthGuard.tsx










var HomepageV2AuthGuard = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref.isPhoneVerified, companyId = ref.companyId;
    var router = (0,next_router.useRouter)();
    var compactPosting = (0,CompactLoadPostingProvider/* useCompactLoadPostingOptional */.qA)();
    var compactBidding = (0,CompactLoadBiddingProvider/* useCompactLoadBiddingOptional */.$v)();
    var isLoggedIn = isPhoneVerified && !!companyId;
    var isOnHomepage = router.pathname === "/";
    var isCompactFlowOpen = Boolean((compactPosting === null || compactPosting === void 0 ? void 0 : compactPosting.isCompactPostingOpen) || (compactPosting === null || compactPosting === void 0 ? void 0 : compactPosting.isCompactPostingOpening) || (compactBidding === null || compactBidding === void 0 ? void 0 : compactBidding.isCompactBiddingOpen));
    var isAuthDeepLink = (0,deep_links/* isAuthRequiredDeepLink */.ty)(router.query, router.asPath);
    var shouldRedirect = isLoggedIn && isOnHomepage && (isAuthDeepLink || !isCompactFlowOpen);
    (0,react.useEffect)(function() {
        if (!shouldRedirect || !router.isReady) {
            return;
        }
        var ref;
        var redirectUrl = (ref = (0,deep_links/* getLoggedInDeepLinkHref */.xb)(router.query, router.asPath)) !== null && ref !== void 0 ? ref : routeStrings/* ROUTES.dashboard.getUrl */.Z.dashboard.getUrl();
        // iOS Safari cancels in-flight chunk/CSS/API fetches during client-side route changes.
        if ((0,browser/* shouldUseFullPageNavigation */.HV)()) {
            (0,browser/* replaceLocation */.DR)(redirectUrl);
            return;
        }
        router.replace(redirectUrl);
    }, [
        shouldRedirect,
        router.isReady,
        router.query,
        router.asPath,
        router
    ]);
    if (shouldRedirect) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var homepage_v2_auth_guard_HomepageV2AuthGuard = (HomepageV2AuthGuard);

// EXTERNAL MODULE: ../core-ui/dist/methods/index.js + 3 modules
var methods = __webpack_require__(38920);
// EXTERNAL MODULE: ./components/layout/top-nav-layout/TopNavLayout.tsx + 13 modules
var TopNavLayout = __webpack_require__(63989);
// EXTERNAL MODULE: ./components/layout/top-nav-v2/index.tsx
var top_nav_v2 = __webpack_require__(33623);
// EXTERNAL MODULE: ./components/homepage-v2/app-download-banner/AppDownloadBannerV2.tsx
var AppDownloadBannerV2 = __webpack_require__(99837);
;// CONCATENATED MODULE: ./components/layout/web-v2-layout/WebV2Layout.tsx







var WebV2Layout = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        (0,methods/* scrollToElementByIdFromHash */.iA)(router.asPath, AppDownloadBannerV2/* APP_DOWNLOAD_BANNER_SECTION_ID */.c);
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNavLayout/* default */.Z, {
        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_nav_v2/* default */.Z, {}),
        children: children
    });
};
/* harmony default export */ var web_v2_layout_WebV2Layout = (WebV2Layout);

;// CONCATENATED MODULE: ./utils/getlayoutForPage.tsx

















function getlayoutForPage(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var getLayout;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    switch(pageProps.route){
        // case HOME_ROUTE:
        //     getLayout = (page: any) => <SideNavLayoutWrapper>{page}</SideNavLayoutWrapper>;
        //     break;
        case route_constants/* HOME_ROUTE */.ef:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_v2_auth_guard_HomepageV2AuthGuard, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(web_v2_layout_WebV2Layout, {
                        children: page
                    })
                });
            };
            break;
        case userScreenId/* UserScreenId.cargoInsurance.id */.B.cargoInsurance.id:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(web_v2_layout_WebV2Layout, {
                    children: page
                });
            };
            break;
        case route_constants/* CLIENT_LISTING_PAGE */.RH:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainLayout/* PlainLayout */.o, {
                        page: page
                    })
                });
            };
            break;
        case route_constants/* MARKETPLACE_ROUTE */.C_:
        case route_constants/* TRANSPORT_DIRECTORY */.fN:
            if (pageProps.marketplaceType === constants/* MarketPlaceType.LORRY */.CY3.LORRY) {
                getLayout = function(page) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainLayout/* PlainLayout */.o, {
                        page: page
                    });
                };
                break;
            }
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
                    navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {
                        mktType: pageProps.marketplaceType
                    }),
                    pageRoute: pageProps.route,
                    children: page
                });
            };
            break;
        case route_constants/* USER_PROFILE_PAGE */.lG:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
                        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {}),
                        children: page
                    })
                });
            };
            break;
        case route_constants/* MY_LORRIES_PAGE */.fW:
        case "new":
            // Temp changes, check with @sudhanshu for layout
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                    children: !isMobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
                        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {}),
                        children: page
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainLayout/* PlainLayout */.o, {
                        page: page
                    })
                });
            };
            break;
        case route_constants/* LISTING_PAGE */.v2:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
                        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {
                            mktType: pageProps.activeMarketType
                        }),
                        hideTopNav: pageProps.activeMarketType === "loads" && pageProps.activeTab === tab/* MY_LOAD_LORRY_TABS.LISTING */.n.LISTING,
                        children: page
                    })
                });
            };
            break;
        case route_constants/* DASHBOARD_ROUTE */.zO:
        case route_constants/* BANK_DETAILS */.vQ:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
                        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {
                            mktType: pageProps.activeMarketType
                        }),
                        children: page
                    })
                });
            };
            break;
        // case BULK_LOADS_LIST:
        //     getLayout = (page: any) => (
        //         <PrivatePremiumRoute>
        //             <DefaultLayoutWrapper
        //                 navContent={<DashboardNav navbarName={NavBarName.PREMIUM_LOADS} showPostingIcon={false} />}
        //             >
        //                 {page}
        //             </DefaultLayoutWrapper>
        //         </PrivatePremiumRoute>
        //     );
        //     break;
        // case PREMIUM_LOAD_TRIP:
        //     getLayout = (page: any) => (
        //         <PrivatePremiumRoute>
        //             <DefaultLayoutWrapper
        //                 navContent={<DashboardNav navbarName={NavBarName.PREMIUM_LOADS} showPostingIcon={false} />}
        //             >
        //                 {page}
        //             </DefaultLayoutWrapper>
        //         </PrivatePremiumRoute>
        //     );
        //     break;
        case route_constants/* MEMBERSHIP_UPGRADE */.p$:
            {
                getLayout = function(page) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipLayoutWrapper, {
                        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {
                            mktType: pageProps.marketplaceType
                        }),
                        pageRoute: pageProps.route,
                        children: page
                    });
                };
                break;
            }
        case route_constants/* MEMBERSHIP */.Rk:
        case route_constants/* MEMBERSHIP_HISTORY */.mp:
            {
                getLayout = function(page) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipLayoutWrapper, {
                            navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {
                                mktType: pageProps.marketplaceType
                            }),
                            pageRoute: pageProps.route,
                            children: page
                        })
                    });
                };
                break;
            }
        case route_constants/* MEMBERSHIP_PAYMENT */.wJ:
        case route_constants/* MEMBERSHIP_FEATURE */.k4:
        case userScreenId/* UserScreenId.payment.id */.B.payment.id:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(private_route_PrivateRoute, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainLayout/* PlainLayout */.o, {
                        page: page
                    })
                });
            };
            break;
        case route_constants/* MOBILE_APP */.yQ:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileAppWebViewLayout, {
                    page: page
                });
            };
            break;
        case route_constants/* PAYMENT_LIST */.Rb:
            getLayout = function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivatePremiumRoute, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayoutWrapper_DefaultLayoutWrapper, {
                        navContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbar/* default */.Z, {
                            navbarName: navbar_menu_items/* NavBarName.PREMIUM_LOADS */.e.PREMIUM_LOADS,
                            showPostingIcon: false
                        }),
                        children: page
                    })
                });
            };
            break;
        default:
            var _getLayout;
            getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : function(page) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* DefaultTopNavLayout */.U1, {
                    children: page
                });
            };
            break;
    }
    return getLayout;
}

// EXTERNAL MODULE: ./hooks/useRouteTransitionLoader.ts + 1 modules
var useRouteTransitionLoader = __webpack_require__(4672);
;// CONCATENATED MODULE: ./components/common/route-transition-loader/RouteTransitionLoader.tsx




var TruckLoader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7642), __webpack_require__.e(3540), __webpack_require__.e(1411)]).then(__webpack_require__.bind(__webpack_require__, 71411));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71411)
            ];
        }
    },
    ssr: false
});
var RouteTransitionLoader = function(param) {
    var app = param.app;
    var isLoading = (0,useRouteTransitionLoader/* default */.ZP)(app);
    if (!isLoading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckLoader, {});
};
/* harmony default export */ var route_transition_loader_RouteTransitionLoader = (RouteTransitionLoader);

// EXTERNAL MODULE: ./pages/AuthVerifyComponent.tsx
var AuthVerifyComponent = __webpack_require__(59470);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./constants/abTestVariations.ts
var constants_abTestVariations = __webpack_require__(60537);
// EXTERNAL MODULE: ./components/user-profile/mandate-user-verification/app-mandate/AppMandatePopup.module.scss
var AppMandatePopup_module = __webpack_require__(34568);
var AppMandatePopup_module_default = /*#__PURE__*/__webpack_require__.n(AppMandatePopup_module);
// EXTERNAL MODULE: ../core-ui/dist/components/Button/index.js
var Button = __webpack_require__(32450);
// EXTERNAL MODULE: ../core-ui/dist/components/Typography/index.js
var Typography = __webpack_require__(71960);
// EXTERNAL MODULE: ../core-ui/dist/layout/Flex.js
var Flex = __webpack_require__(31013);
// EXTERNAL MODULE: ../core-ui/dist/constants/colors.js
var colors = __webpack_require__(94897);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ./constants/automation.ts
var automation = __webpack_require__(67577);
;// CONCATENATED MODULE: ./components/user-profile/mandate-user-verification/app-mandate/SignupMandatePopup.tsx











var SignupMandatePopup = function(param) {
    var onCloseBtnClick = param.onCloseBtnClick;
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        document.body.style.overflow = "hidden";
        return function() {
            document.body.style.overflow = "unset";
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (AppMandatePopup_module_default()).main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AppMandatePopup_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppMandatePopup_module_default()).banner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                        src: "/app-download-baner.svg",
                        width: 343,
                        height: 333,
                        unoptimized: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                    flexDirection: "column",
                    gap: 12,
                    className: (AppMandatePopup_module_default()).innerContent,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            weight: "bold",
                            mSize: "md",
                            align: "center",
                            children: "SIGN UP ON VAHAK NOW!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            mSize: "s",
                            align: "center",
                            color: colors/* default.GREY_700 */.Z.GREY_700,
                            weight: "medium",
                            children: "Book from 1000+ verified loads and lorries posted everyday in just a few clicks!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            id: automation/* default.mandatePopup.mandateSignupBtn */.Z.mandatePopup.mandateSignupBtn,
                            blockBtn: true,
                            onClick: function() {
                                var ref;
                                (ref = window.VWO) === null || ref === void 0 ? void 0 : ref.event("mandate_signup");
                                onCloseBtnClick();
                                sendGAandMoEngageEvent({
                                    name: "mandate_signup_clicked_web",
                                    data: {
                                        source_section: "Web_App_Download_Mandate"
                                    }
                                });
                                router.push({
                                    hash: "#Login"
                                });
                            },
                            children: "Login / Signup"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var app_mandate_SignupMandatePopup = (SignupMandatePopup);

// EXTERNAL MODULE: ./components/service-request-modal/ServiceRequestModal.tsx
var ServiceRequestModal = __webpack_require__(38681);
// EXTERNAL MODULE: ./hooks/useValidateUserStatus.ts + 1 modules
var useValidateUserStatus = __webpack_require__(4641);
// EXTERNAL MODULE: ../../node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(36908);
// EXTERNAL MODULE: ../core/dist/_services/index.js + 6 modules
var _services = __webpack_require__(96122);
// EXTERNAL MODULE: ./hooks/useLocalStorageMethod.ts
var useLocalStorageMethod = __webpack_require__(41062);
;// CONCATENATED MODULE: ./components/LoginModalGlobalWrapper.tsx
/* provided dependency */ var process = __webpack_require__(34406);







var LoginFormNew = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(5829), __webpack_require__.e(1217), __webpack_require__.e(3128), __webpack_require__.e(2765), __webpack_require__.e(4675), __webpack_require__.e(1693)]).then(__webpack_require__.bind(__webpack_require__, 24061));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24061)
            ];
        }
    },
    ssr: false
});

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(c) {
        return (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16);
    });
}
var LoginModalGlobalWrapper = function() {
    var isMobile = function isMobile() {
        var regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(window === null || window === void 0 ? void 0 : window.navigator.userAgent);
    };
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), setName = ref1.setName, setCompanyId = ref1.setCompanyId, setIsPhoneVerified = ref1.setIsPhoneVerified, setCompanyLocation = ref1.setCompanyLocation, setCompanyLogo = ref1.setCompanyLogo, setUserId = ref1.setUserId, setServiceType = ref1.setServiceType, setSessionId = ref1.setSessionId, isPhoneVerified = ref1.isPhoneVerified, companyId = ref1.companyId;
    var ref2 = (0,useLocalStorageMethod/* useLocalStorageMethod */.m)(), setLocalData = ref2.setLocalData, getLocalData = ref2.getLocalData, removeLocalData = ref2.removeLocalData;
    var router = (0,next_router.useRouter)();
    var ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    var cookies = new Cookies/* default */.Z();
    var ref3 = (0,react.useState)(""), trueCallerReqId = ref3[0], setTrueCallerReqId = ref3[1];
    var ref4 = (0,react.useState)({
        enable: false,
        poolingCount: 0
    }), enableTrueCallerApi = ref4[0], setEnableTrueCallerApi = ref4[1];
    var ref5 = (0,react.useState)(true), showLoginModal = ref5[0], setShowLoginModal = ref5[1];
    var ref6 = (0,react.useState)(true), isFocused = ref6[0], setIsFocused = ref6[1];
    (0,react.useEffect)(function() {
        var checkFocus = function() {
            setIsFocused(document.hasFocus());
        };
        // Initial check
        checkFocus();
        // Add event listeners to detect focus changes
        window.addEventListener("focus", checkFocus);
        window.addEventListener("blur", checkFocus);
        // Cleanup event listeners on component unmount
        return function() {
            window.removeEventListener("focus", checkFocus);
            window.removeEventListener("blur", checkFocus);
        };
    }, []);
    var TRUE_CALLER_STATUS;
    (function(TRUE_CALLER_STATUS) {
        TRUE_CALLER_STATUS["FLOW_INVOKED"] = "flow_invoked";
        TRUE_CALLER_STATUS["USE_ANOTHER_NUMBER"] = "use_another_number";
        TRUE_CALLER_STATUS["USER_REJECTED"] = "user_rejected";
    })(TRUE_CALLER_STATUS || (TRUE_CALLER_STATUS = {}));
    // useEffect(() => {
    //     if (typeof window != "undefined" && window && isLoginModalOpen && isMobile() && !isPhoneVerified) {
    //         const is_iOS = window?.navigator.platform.indexOf("Mac") === 0 || window?.navigator.platform === "iPhone";
    //         if (is_iOS) return;
    //         const reqId = uuidv4();
    //         const trueCallerConfig = {
    //             type: "btmsheet",
    //             requestNonce: reqId,
    //             partnerKey: process.env.NEXT_PUBLIC_TRUE_CALLER_APP_KEY,
    //             partnerName: "Vahak",
    //             lang: "en",
    //             loginPrefix: "continue",
    //             loginSuffix: "verifymobile",
    //             ctaPrefix: "use",
    //             ctaColor: "%2355FC",
    //             ctaTextColor: "%23ffffff",
    //             btnShape: "round",
    //             skipOption: "useanothermethod",
    //             ttl: 20000
    //         };
    //         const queryParams = generateUrlParamsFromObject(trueCallerConfig);
    //         const trueCallerWindow: any = `truecallersdk://truesdk/web_verify?${queryParams}`;
    //         window.location = trueCallerWindow;
    //         setTrueCallerReqId(reqId);
    //     }
    // }, [isLoginModalOpen]);
    // useEffect(() => {
    //     let timerId: any;
    //     if (isLoginModalOpen && isFocused && !isPhoneVerified && trueCallerReqId) {
    //         timerId = setTimeout(() => {
    //             setEnableTrueCallerApi({ enable: true, poolingCount: 0 });
    //         }, 1000);
    //     }
    //     return () => clearTimeout(timerId);
    // }, [isFocused]);
    var sendGAandMoEngageEvent = (0,_services/* useEventTrackerService */.fQ)().sendGAandMoEngageEvent;
    // useGetTrueCallerUserDetails(
    //     {
    //         requestId: trueCallerReqId
    //     },
    //     {
    //         enabled: Boolean(trueCallerReqId !== "" && isLoginModalOpen && enableTrueCallerApi.enable),
    //         retry: 0,
    //         onSuccess: async (data: any) => {
    //             setTrueCallerReqId("");
    //             /**
    //              * This is base case to check if user did anything else other than continue
    //              * From api we'll get this message "use_another_number" & "user_rejected"
    //              */
    //             if (data?.message === "use_another_number" || data?.message === "user_rejected") {
    //                 return;
    //             }
    //             setShowLoginModal(false);
    //             delete router.query["referral_code"];
    //             router.replace({ ...router, hash: undefined });
    //             if (data) {
    //                 // login
    //                 cookies.set(COOKIES.token, data.access_token, {
    //                     secure: ENV === "production",
    //                     sameSite: "strict",
    //                     path: "/",
    //                     maxAge: 24 * 60 * 60 * 30
    //                 });
    //                 setSessionId?.(data?.session_id);
    //                 setIsPhoneVerified?.(true);
    //                 setName?.(data.c_name);
    //                 setCompanyId?.(data.c_id);
    //                 setCompanyLocation?.(data.c_loc);
    //                 setUserId?.(data.u_id);
    //                 setCompanyLogo?.(data?.profile_image);
    //                 if (data.c_serv) setServiceType?.(data.c_serv);
    //             }
    //             if (!Boolean(data.c_id)) {
    //                 sendGAandMoEngageEvent({
    //                     name: GA4EventNames.LOGIN_OR_SIGNUP_MODAL.user_signup,
    //                     data: {
    //                         source_screen: GA4LoginOrRegistrationModalEventAttributes.phone_number_registration,
    //                         phone_number: data.phone_number,
    //                         sign_up_via: "truecaller",
    //                         user_id: data.u_id
    //                     }
    //                 });
    //                 return;
    //             }
    //             sendGAandMoEngageEvent({
    //                 name: GA4EventNames.LOGIN_OR_SIGNUP_MODAL.user_login,
    //                 data: {
    //                     source_screen: GA4LoginOrRegistrationModalEventAttributes.phone_number_registration,
    //                     phone_number: data.phone_number,
    //                     login_via: "truecaller",
    //                     company_id: data.c_id,
    //                     user_id: data.u_id
    //                 }
    //             });
    //             moEngageUserLogIn(Number(data.u_id));
    //             moEngageUserAttributeTrack("Name", data.c_name);
    //             moEngageUserAttributeTrack("Phone", data.phone_number);
    //             moEngageUserAttributeTrack("company_id", data.c_id);
    //             moEngageUserAttributeTrack("user_id", data.u_id);
    //             moEngageUserAttributeTrack("user_type", WebsiteUserType.CLIENT);
    //             window?.VWO?.event(VWOEvents.login_success);
    //         },
    //         onError(err: any) {
    //             setEnableTrueCallerApi({ ...enableTrueCallerApi, enable: false });
    //             let timeOut;
    //             if (err.message.includes(TRUE_CALLER_STATUS.FLOW_INVOKED) && enableTrueCallerApi.poolingCount < 3) {
    //                 timeOut = setTimeout(() => {
    //                     setEnableTrueCallerApi({ enable: true, poolingCount: enableTrueCallerApi.poolingCount + 1 });
    //                 }, 3000);
    //                 return;
    //             } else {
    //                 timeOut && clearTimeout(timeOut);
    //                 setEnableTrueCallerApi({ ...enableTrueCallerApi, enable: false });
    //                 setShowLoginModal(true);
    //                 return;
    //             }
    //         }
    //     }
    // );
    /**
     * Discount popup - on tab close
     */ var _isPhoneVerified = cookies.get("vv");
    (0,react.useEffect)(function() {
        var handleBeforeUnload = function(event) {
            if (typeof getLocalData("discountPopup") === "object" && !_isPhoneVerified) {
                event.preventDefault();
                event.returnValue = "";
                setLocalData("discountPopup", true);
                router.push({
                    pathname: router.asPath.replaceAll("%23Login", ""),
                    hash: "#Login"
                });
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        /**
         * On reload discountPopup is setting to true
         * This code will remove that
         */ window.addEventListener("unload", function(event) {
            typeof getLocalData("discountPopup") !== "object" && getLocalData("discountPopup") && removeLocalData("discountPopup");
        });
        return function() {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        _isPhoneVerified
    ]);
    /**
     * Discount popup - browser back button
     */ (0,react.useEffect)(function() {
        var handlePopState = function(event) {
            if (typeof getLocalData("discountPopup") === "object" && !_isPhoneVerified) {
                if (event.state) {
                    setLocalData("discountPopup", true);
                    router.push({
                        pathname: router.asPath.replaceAll("%23Login", ""),
                        hash: "#Login"
                    });
                }
            }
        };
        // Listen for the popstate event (triggered by the browser back button)
        window.addEventListener("popstate", handlePopState);
        return function() {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [
        _isPhoneVerified
    ]);
    if (companyId && isPhoneVerified) {
        return null;
    }
    var isLoginModalOpen = (ref = router.asPath.split("#")[1]) === null || ref === void 0 ? void 0 : ref.includes("Login");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoginModalOpen && showLoginModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginFormNew, {}) : null
    });
};
/* harmony default export */ var components_LoginModalGlobalWrapper = (LoginModalGlobalWrapper);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ./components/clear-due-modal/ClearDueModal.module.scss
var ClearDueModal_module = __webpack_require__(28104);
var ClearDueModal_module_default = /*#__PURE__*/__webpack_require__.n(ClearDueModal_module);
// EXTERNAL MODULE: ./services/vas/useGeneratePayment.ts
var useGeneratePayment = __webpack_require__(95150);
// EXTERNAL MODULE: ./services/useRazorpay.ts
var useRazorpay = __webpack_require__(25514);
// EXTERNAL MODULE: ../core-ui/dist/components/ModalOrBottomSheetWrapper/index.js
var ModalOrBottomSheetWrapper = __webpack_require__(9937);
// EXTERNAL MODULE: ../core-ui/dist/components/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(48953);
// EXTERNAL MODULE: ../core-ui/dist/components/Chip/index.js
var Chip = __webpack_require__(93834);
// EXTERNAL MODULE: ../core/dist/standard-icons/warning-red.svg
var warning_red = __webpack_require__(73205);
;// CONCATENATED MODULE: ./components/clear-due-modal/ClearDueModal.tsx



//Style

//Context

//Hooks & services



//Components






//Constants

//Icons


var ClearDueModal = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), showClearDuePopup = ref.showClearDuePopup, setShowClearDuePopup = ref.setShowClearDuePopup, companyId = ref.companyId, dueAmount = ref.dueAmount;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var ref1 = (0,useGeneratePayment/* useGeneratePayment */.zw)(), generatePayment = ref1.mutateAsync;
    var initializePayment = (0,useRazorpay/* default */.Z)().initializePayment;
    var handleClickClearDue = function() {
        if (isCsDashboardUser) return;
        generatePayment({
            companyId: Number(companyId),
            redeemCashback: false,
            bookingAmountOrderRequest: [
                {
                    amount: dueAmount,
                    booking_for: useGeneratePayment/* BookingForMap.CASHBACK_DUE */.hB.CASHBACK_DUE
                }
            ]
        }, {
            onSuccess: function(vasResponse) {
                var tmp = vasResponse.data, ref = tmp === void 0 ? {} : tmp, razorpay_order_id = ref.razorpay_order_id, order_amount = ref.order_amount;
                if (razorpay_order_id && order_amount && order_amount > 0) {
                    initializePayment({
                        order_id: razorpay_order_id,
                        amount: order_amount,
                        onSuccess: function(response) {
                            setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                                isOpen: false,
                                dueAmount: 0
                            });
                        },
                        onError: function(err) {
                            setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                                isOpen: false,
                                dueAmount: 0
                            });
                        },
                        onDismiss: function() {
                            setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                                isOpen: false,
                                dueAmount: 0
                            });
                        }
                    });
                } else if (order_amount === 0) {
                    setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                        isOpen: false,
                        dueAmount: 0
                    });
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrBottomSheetWrapper["default"], {
        isOpen: showClearDuePopup,
        onToggle: function() {
            return setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                isOpen: false,
                dueAmount: 0
            });
        },
        modalSize: "fit",
        paddedModal: false,
        paddedSheet: false,
        disableSheetSwipe: true,
        renderTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 20px 0 20px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    weight: "semibold",
                    children: "Pending dues"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* ModalCrossIcon */.A, {
                    onClick: function() {
                        return setShowClearDuePopup === null || setShowClearDuePopup === void 0 ? void 0 : setShowClearDuePopup({
                            isOpen: false,
                            dueAmount: 0
                        });
                    }
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
            padding: "20px",
            style: {
                maxWidth: isMobileScreen ? "" : "400px"
            },
            flexDirection: "column",
            gap: 20,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: colors/* default.GREY_700 */.Z.GREY_700,
                    weight: "medium",
                    size: "sm",
                    children: "Hi, you have pending dues because you did not confirm the booking after lorry confirmation."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    radius: "8px",
                    size: "auto",
                    fillColor: "#FFE5E5",
                    filled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.ZP, {
                        alignItems: "center",
                        gap: 10,
                        padding: "13px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(warning_red/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                weight: "semibold",
                                size: "sm",
                                children: [
                                    "Total dues - ₹",
                                    Math.abs(Number(dueAmount))
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ClearDueModal_module_default()).BtnWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        isRounded: true,
                        blockBtn: true,
                        onClick: handleClickClearDue,
                        disabled: isCsDashboardUser,
                        children: isCsDashboardUser ? "Ask user to clear dues" : "Clear Dues"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var clear_due_modal_ClearDueModal = (ClearDueModal);

;// CONCATENATED MODULE: ./components/global-components-wrapper.tsx
/* provided dependency */ var global_components_wrapper_process = __webpack_require__(34406);






//Context












//Components
var AadhaarAndPanVerification = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(110), __webpack_require__.e(6799)]).then(__webpack_require__.bind(__webpack_require__, 97932));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97932)
            ];
        }
    },
    ssr: false
});
var GSTVerification = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(110), __webpack_require__.e(2129)]).then(__webpack_require__.bind(__webpack_require__, 87085));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87085)
            ];
        }
    },
    ssr: false
});
var UpgradeMembershipPlanModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1666).then(__webpack_require__.bind(__webpack_require__, 61666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61666)
            ];
        }
    },
    ssr: false
});
var AppRedirectionPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1991).then(__webpack_require__.bind(__webpack_require__, 51991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51991)
            ];
        }
    },
    ssr: false
});
var ChangeLanguage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4169).then(__webpack_require__.bind(__webpack_require__, 24169));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24169)
            ];
        }
    },
    ssr: false
});
var AddBankPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3232), __webpack_require__.e(2406)]).then(__webpack_require__.bind(__webpack_require__, 73232));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73232)
            ];
        }
    },
    ssr: false
});
var ShareModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59604));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59604)
            ];
        }
    },
    ssr: false
});
var ShareLoadModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5326), __webpack_require__.e(5755), __webpack_require__.e(9978)]).then(__webpack_require__.bind(__webpack_require__, 66197));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66197)
            ];
        }
    },
    ssr: false
});
var AppMandatePopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4894).then(__webpack_require__.bind(__webpack_require__, 54894));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54894)
            ];
        }
    },
    ssr: false
});
var GlobalComponentsWrapper = function(param) {
    var pageRoute = param.pageRoute;
    var ref, ref1, ref2, ref3;
    var _ref = (0,react.useContext)(app_context/* AppContext */.Il), showGstVerificationPopup = _ref.showGstVerificationPopup, showMandateKycPopup = _ref.showMandateKycPopup, showUpgradeMembershipPlanPopup = _ref.showUpgradeMembershipPlanPopup, showBankAddPopup = _ref.showBankAddPopup, setShowBankAddPopup = _ref.setShowBankAddPopup, onSuccessAddBankCallback = _ref.onSuccessAddBankCallback, showAppRedirectionPopup = _ref.showAppRedirectionPopup, showShareModalPopup = _ref.showShareModalPopup, setShowShareModalPopup = _ref.setShowShareModalPopup, updateRoute = _ref.updateRoute, isPhoneVerified = _ref.isPhoneVerified, setServiceRequestType = _ref.setServiceRequestType, serviceRequestType = _ref.serviceRequestType, serviceType = _ref.serviceType, showClearDuePopup = _ref.showClearDuePopup, //
    setShowMandateKycPopup = _ref.setShowMandateKycPopup, setShowGstVerificationPopup = _ref.setShowGstVerificationPopup, setShowUpgradeMembershipPlanPopup = _ref.setShowUpgradeMembershipPlanPopup, mandateUserVerificationCallBackFunction = _ref.mandateUserVerificationCallBackFunction, setMandateUserVerificationCallBackFunction = _ref.setMandateUserVerificationCallBackFunction, setMandateUserVerificationActionTriggered = _ref.setMandateUserVerificationActionTriggered, mandateUserVerificationActionTriggered = _ref.mandateUserVerificationActionTriggered, setMandateUserVerificationActionType = _ref.setMandateUserVerificationActionType, mandateUserVerificationActionType = _ref.mandateUserVerificationActionType, companyId = _ref.companyId, customerCompanyId = _ref.customerCompanyId, restContext = (0,_object_without_properties/* default */.Z)(_ref, [
        "showGstVerificationPopup",
        "showMandateKycPopup",
        "showUpgradeMembershipPlanPopup",
        "showBankAddPopup",
        "setShowBankAddPopup",
        "onSuccessAddBankCallback",
        "showAppRedirectionPopup",
        "showShareModalPopup",
        "setShowShareModalPopup",
        "updateRoute",
        "isPhoneVerified",
        "setServiceRequestType",
        "serviceRequestType",
        "serviceType",
        "showClearDuePopup",
        "setShowMandateKycPopup",
        "setShowGstVerificationPopup",
        "setShowUpgradeMembershipPlanPopup",
        "mandateUserVerificationCallBackFunction",
        "setMandateUserVerificationCallBackFunction",
        "setMandateUserVerificationActionTriggered",
        "mandateUserVerificationActionTriggered",
        "setMandateUserVerificationActionType",
        "mandateUserVerificationActionType",
        "companyId",
        "customerCompanyId"
    ]);
    var showAppMandatePopup = false;
    var showSignUpMandatePopup = false;
    var ref4 = (0,react.useState)(false), closeAppMandatePopup = ref4[0], setCloseAppMandatePopup = ref4[1];
    var abTestVariations = (0,getABTestVariation/* getAllVwoABTestVariations */.c)().abTestVariations;
    /**
     * Temp condition check
     * This will be removed when login modal is refactored to use context or local state
     */ var router = (0,next_router.useRouter)();
    var isLoginModalOpen = (ref = router.asPath.split("#")[1]) === null || ref === void 0 ? void 0 : ref.includes("Login");
    var isGPSModalOpen = (ref1 = router.asPath.split("#")[1]) === null || ref1 === void 0 ? void 0 : ref1.includes("gps");
    var isVerificationModalOpen = (ref2 = router.asPath.split("#")[1]) === null || ref2 === void 0 ? void 0 : ref2.includes("verify-id");
    if (!serviceRequestType) {
        isGPSModalOpen && (setServiceRequestType === null || setServiceRequestType === void 0 ? void 0 : setServiceRequestType(app_context/* ServiceRequestType.GPS */.No.GPS));
    }
    if (!showMandateKycPopup) {
        isVerificationModalOpen && (setShowMandateKycPopup === null || setShowMandateKycPopup === void 0 ? void 0 : setShowMandateKycPopup(true));
    }
    if ( true && window) {
        window.VWO = window.VWO || [];
        window.VWO.event = window.VWO.event || function() {
            window.VWO.push([
                "event"
            ].concat([].slice.call(arguments)));
        };
        var is_iOS = (window === null || window === void 0 ? void 0 : window.navigator.platform.indexOf("Mac")) === 0 || (window === null || window === void 0 ? void 0 : window.navigator.platform) === "iPhone";
        var ENV = global_components_wrapper_process.env.REACT_APP_ENV || global_components_wrapper_process.env.NEXT_PUBLIC_REACT_APP_ENV;
        var downloadAppTestCampaign = ENV === "production" ? constants_abTestVariations/* AB_TEST_CAMPAIGN_IDS.downloadAppProd */.V.downloadAppProd : constants_abTestVariations/* AB_TEST_CAMPAIGN_IDS.downloadApp */.V.downloadApp;
        if (!isPhoneVerified) {
            if (abTestVariations[downloadAppTestCampaign] == 2 && !showAppMandatePopup) {
                var ref5;
                window === null || window === void 0 ? void 0 : (ref5 = window.VWO) === null || ref5 === void 0 ? void 0 : ref5.event("mandate_download_app_shown");
                showSignUpMandatePopup = false;
                showAppMandatePopup = true;
            } else if (abTestVariations[downloadAppTestCampaign] == 3 && !isLoginModalOpen && serviceType && !(companyId && isPhoneVerified)) {
                var ref6;
                window === null || window === void 0 ? void 0 : (ref6 = window.VWO) === null || ref6 === void 0 ? void 0 : ref6.event("mandate_signup_shown");
                showAppMandatePopup = false;
            //showSignUpMandatePopup = true;
            }
        }
    }
    var onCloseBtnClick = function() {
        setCloseAppMandatePopup(true);
    };
    // const showLangMenu = router.asPath.includes("transporters");
    var handleBankPopupToggle = function() {
        return setShowBankAddPopup === null || setShowBankAddPopup === void 0 ? void 0 : setShowBankAddPopup(false);
    };
    (0,react.useEffect)(function() {
        if (updateRoute) {
            updateRoute === null || updateRoute === void 0 ? void 0 : updateRoute(pageRoute);
            return updateRoute;
        }
    }, [
        updateRoute,
        pageRoute
    ]);
    var ref7 = (0,useValidateUserStatus/* default */.Z)(), ValidateLoadBidding = ref7.ValidateLoadBidding, ValidateLoadPosting = ref7.ValidateLoadPosting, ValidateLorryBidding = ref7.ValidateLorryBidding, ValidateLorryPosting = ref7.ValidateLorryPosting;
    (0,react.useEffect)(function() {
        if (mandateUserVerificationActionType && companyId && isPhoneVerified && mandateUserVerificationActionTriggered) switch(mandateUserVerificationActionType){
            case constants/* UserAction.LOAD_BID */.Vwu.LOAD_BID:
                return ValidateLoadBidding(function() {
                    mandateUserVerificationCallBackFunction === null || mandateUserVerificationCallBackFunction === void 0 ? void 0 : mandateUserVerificationCallBackFunction();
                    setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
                    setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
                    setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
                }, true);
            case constants/* UserAction.POST_LOAD */.Vwu.POST_LOAD:
                return ValidateLoadPosting(function() {
                    mandateUserVerificationCallBackFunction === null || mandateUserVerificationCallBackFunction === void 0 ? void 0 : mandateUserVerificationCallBackFunction();
                    setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
                    setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
                    setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
                }, true);
            case constants/* UserAction.LORRY_BID */.Vwu.LORRY_BID:
                return ValidateLorryBidding(function() {
                    mandateUserVerificationCallBackFunction === null || mandateUserVerificationCallBackFunction === void 0 ? void 0 : mandateUserVerificationCallBackFunction();
                    setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
                    setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
                    setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
                }, true);
            case constants/* UserAction.POST_LORRY */.Vwu.POST_LORRY:
                return ValidateLorryPosting(function() {
                    mandateUserVerificationCallBackFunction === null || mandateUserVerificationCallBackFunction === void 0 ? void 0 : mandateUserVerificationCallBackFunction();
                    setMandateUserVerificationActionType === null || setMandateUserVerificationActionType === void 0 ? void 0 : setMandateUserVerificationActionType("");
                    setMandateUserVerificationActionTriggered === null || setMandateUserVerificationActionTriggered === void 0 ? void 0 : setMandateUserVerificationActionTriggered(false);
                    setMandateUserVerificationCallBackFunction === null || setMandateUserVerificationCallBackFunction === void 0 ? void 0 : setMandateUserVerificationCallBackFunction(undefined);
                }, true);
            default:
                return;
        }
    }, [
        companyId,
        isPhoneVerified,
        mandateUserVerificationActionType,
        mandateUserVerificationActionTriggered
    ]);
    (0,react.useEffect)(function() {
        isPhoneVerified && (0,user_analytics_service/* moEngageUserAttributeTrack */.av)("user_type", useEventTrackerService/* WebsiteUserType.CLIENT */.y.CLIENT);
    }, [
        isPhoneVerified
    ]);
    // useEffect(() => {
    //     const ENV = process.env.REACT_APP_ENV || process.env.NEXT_PUBLIC_REACT_APP_ENV;
    //     const downloadAppTestCampaign =
    //         ENV === "production" ? AB_TEST_CAMPAIGN_IDS["downloadAppProd"] : AB_TEST_CAMPAIGN_IDS["downloadApp"];
    //     if (
    //         abTestVariations[downloadAppTestCampaign] == 3 &&
    //         !isLoginModalOpen &&
    //         serviceType &&
    //         !(companyId && isPhoneVerified)
    //     ) {
    //         router?.push({ hash: "#Login" });
    //     }
    // }, [serviceType, isPhoneVerified, abTestVariations, companyId]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LoginModalGlobalWrapper, {}),
            showMandateKycPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(AadhaarAndPanVerification, {}),
            showGstVerificationPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(GSTVerification, {}),
            showUpgradeMembershipPlanPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(UpgradeMembershipPlanModal, {}),
            showBankAddPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddBankPage, {
                onSuccess: onSuccessAddBankCallback,
                isOpen: showBankAddPopup,
                onToggle: handleBankPopupToggle
            }),
            showAppRedirectionPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppRedirectionPopup, {}),
            (showShareModalPopup === null || showShareModalPopup === void 0 ? void 0 : showShareModalPopup.isVisible) && showShareModalPopup.mktType === "load" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLoadModal, {
                isOpen: showShareModalPopup.isVisible,
                onClose: function() {
                    return setShowShareModalPopup === null || setShowShareModalPopup === void 0 ? void 0 : setShowShareModalPopup({
                        isVisible: false,
                        mktType: "load",
                        data: undefined
                    });
                },
                shareData: showShareModalPopup.data,
                loadCardData: (ref3 = showShareModalPopup.data) === null || ref3 === void 0 ? void 0 : ref3.loadCardData
            }) : null,
            (showShareModalPopup === null || showShareModalPopup === void 0 ? void 0 : showShareModalPopup.isVisible) && showShareModalPopup.mktType === "lorry" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal, {
                isOpen: showShareModalPopup.isVisible,
                modalTitle: "Share ".concat(showShareModalPopup.mktType, " details"),
                toggle: function() {
                    return setShowShareModalPopup === null || setShowShareModalPopup === void 0 ? void 0 : setShowShareModalPopup({
                        isVisible: false,
                        mktType: "load",
                        data: undefined
                    });
                },
                data: showShareModalPopup.data,
                mktType: "".concat(showShareModalPopup.mktType)
            }) : null,
            showSignUpMandatePopup && !closeAppMandatePopup && serviceType && /*#__PURE__*/ (0,jsx_runtime.jsx)(app_mandate_SignupMandatePopup, {
                onCloseBtnClick: onCloseBtnClick
            }),
            serviceRequestType && /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceRequestModal/* default */.Z, {
                onClose: function() {
                    router.replace((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router), {
                        hash: undefined
                    }));
                    setServiceRequestType === null || setServiceRequestType === void 0 ? void 0 : setServiceRequestType(undefined);
                }
            }),
            showClearDuePopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(clear_due_modal_ClearDueModal, {})
        ]
    });
};
/* harmony default export */ var global_components_wrapper = (GlobalComponentsWrapper);

// EXTERNAL MODULE: ./BiddingFormContextProvider.tsx
var BiddingFormContextProvider = __webpack_require__(25634);
// EXTERNAL MODULE: ./MarketplaceContextProvider.tsx
var MarketplaceContextProvider = __webpack_require__(43103);
// EXTERNAL MODULE: ../core-ui/dist/constants/index.js
var dist_constants = __webpack_require__(73242);
// EXTERNAL MODULE: ./context/payment-context.tsx
var payment_context = __webpack_require__(83927);
// EXTERNAL MODULE: ./context/load-lorry-posting.tsx
var load_lorry_posting = __webpack_require__(8574);
// EXTERNAL MODULE: ./DetailsPageContextProvider.tsx
var DetailsPageContextProvider = __webpack_require__(31845);
// EXTERNAL MODULE: ./components/posting/lorry-posting/helpers/constants.ts
var helpers_constants = __webpack_require__(90376);
// EXTERNAL MODULE: ./components/posting/helpers/constants.ts
var posting_helpers_constants = __webpack_require__(40607);
// EXTERNAL MODULE: ./methods/generataMaskUrlWithParams.ts
var generataMaskUrlWithParams = __webpack_require__(32740);
;// CONCATENATED MODULE: ./components/posting/lorry-posting/standalone-lorry-posting-form-modal/StandaloneLorryPostingFormModal.tsx




// Components
var LorryPosting = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6090), __webpack_require__.e(5502), __webpack_require__.e(4800), __webpack_require__.e(2181), __webpack_require__.e(6484), __webpack_require__.e(7726), __webpack_require__.e(1217), __webpack_require__.e(3941), __webpack_require__.e(7678), __webpack_require__.e(5736), __webpack_require__.e(254), __webpack_require__.e(745), __webpack_require__.e(1245)]).then(__webpack_require__.bind(__webpack_require__, 50903));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50903)
            ];
        }
    },
    ssr: false
});
// Context






var StandaloneLorryPostingFormModal_ModalOrBottomSheetWrapper = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9937));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9937)
            ];
        }
    },
    ssr: false
});
var StandaloneLorryPostingFormModal = function(param) {
    var originationPage = param.originationPage, onSuccessfulLorryCreation = param.onSuccessfulLorryCreation, KamClientSupplierCompanyId = param.KamClientSupplierCompanyId, onModalClosing = param.onModalClosing, allowedLorryType = param.allowedLorryType, editLorryData = param.editLorryData;
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var ref = (0,load_lorry_posting/* useLoadLorryPosting */.NS)(), clearPostingData = ref.clearPostingData, loadLorryData = ref.loadLorryData;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), isPhoneVerified = ref1.isPhoneVerified, companyId = ref1.companyId, mandateUserVerificationActionTriggered = ref1.mandateUserVerificationActionTriggered;
    var activeStep = router.query[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME];
    var handleModalClose = function() {
        var ref;
        delete router.query[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME];
        router.push(router, isCsDashboardUser ? undefined : (0,generataMaskUrlWithParams/* generataMaskUrlWithParams */.j)(router.query), {
            shallow: true,
            scroll: false
        });
        clearPostingData();
        onModalClosing && onModalClosing();
        loadLorryData === null || loadLorryData === void 0 ? void 0 : (ref = loadLorryData.onClose) === null || ref === void 0 ? void 0 : ref.call(loadLorryData);
    };
    (0,react.useEffect)(function() {
        /**
         * Base condition check
         */ if (!router.asPath.includes(helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME) || (editLorryData === null || editLorryData === void 0 ? void 0 : editLorryData.id)) return;
        if (!mandateUserVerificationActionTriggered && document.referrer === "") {
            delete router.query[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME];
            router.push(router, undefined, {
                shallow: true,
                scroll: false
            });
            return;
        } else {
            router.query[helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME] = posting_helpers_constants/* LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */.jU.VEHICLE_NUMBER;
            router.push(router, undefined, {
                shallow: true,
                scroll: false
            });
        }
    /* eslint-disable react-hooks/exhaustive-deps*/ }, []);
    var dynamicWidth = activeStep === posting_helpers_constants/* LORRY_CREATION_FORM_IDS.VERIFY_VEHICLE_FAILED */.jU.VERIFY_VEHICLE_FAILED || activeStep === posting_helpers_constants/* LORRY_CREATION_FORM_IDS.LORRY_POSTED_SUCCESSFULLY */.jU.LORRY_POSTED_SUCCESSFULLY;
    if (!Boolean(isPhoneVerified && companyId)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: router.asPath.includes(helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StandaloneLorryPostingFormModal_ModalOrBottomSheetWrapper, {
            isOpen: router.asPath.includes(helpers_constants/* LORRY_POSTING_FORM_LOCATION_STATE.PARAM_NAME */.v.PARAM_NAME),
            onToggle: handleModalClose,
            showHeader: false,
            paddedModal: false,
            paddedSheet: false,
            fullScreenSheet: true,
            modalSize: dynamicWidth ? "wide" : "fit",
            modalBodyHeight: "100vh",
            modalShouldCloseOnOverlayClick: false,
            modalShouldCloseOnEsc: false,
            children: activeStep && /*#__PURE__*/ (0,jsx_runtime.jsx)(LorryPosting, {
                activeStep: activeStep,
                closeModal: handleModalClose,
                originationPage: originationPage,
                onSuccessfulLorryCreation: onSuccessfulLorryCreation,
                KamClientSupplierCompanyId: KamClientSupplierCompanyId,
                allowedLorryType: allowedLorryType,
                editLorryData: editLorryData
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};
/* harmony default export */ var standalone_lorry_posting_form_modal_StandaloneLorryPostingFormModal = (StandaloneLorryPostingFormModal);

// EXTERNAL MODULE: ./hooks/useOpenNewLoadPosting.ts
var useOpenNewLoadPosting = __webpack_require__(68498);
// EXTERNAL MODULE: ./components/posting/vehicle-restriction-popup/index.ts + 4 modules
var vehicle_restriction_popup = __webpack_require__(48510);
;// CONCATENATED MODULE: ./components/posting/load-posting/standalone-load-posting-form-modal/LorryNotAllowedPopup.tsx






var LorryNotAllowedPopup = function(param) {
    var isModalOpen = param.isModalOpen, toggleModal = param.toggleModal;
    var ref = (0,load_lorry_posting/* useLoadLorryPosting */.NS)(), clearPostingData = ref.clearPostingData, updateLoadLorryPostingData = ref.updateLoadLorryPostingData, loadLorryData = ref.loadLorryData, openLorryPostingModal = ref.openLorryPostingModal;
    var openNewLoadPosting = (0,useOpenNewLoadPosting/* default */.Z)();
    var closeAndClear = function() {
        clearPostingData();
        toggleModal();
    };
    var handlePrimary = function() {
        var originationPage = loadLorryData === null || loadLorryData === void 0 ? void 0 : loadLorryData.originationPage;
        if ((loadLorryData === null || loadLorryData === void 0 ? void 0 : loadLorryData.type) === "load") {
            closeAndClear();
            openNewLoadPosting({
                originationPage: originationPage,
                loadStep: posting_helpers_constants/* LOAD_CREATION_FORM_IDS.LOAD_LOCATION_DETAILS */.y5.LOAD_LOCATION_DETAILS
            });
            return;
        }
        closeAndClear();
        setTimeout(function() {
            updateLoadLorryPostingData({
                category: "post",
                isModalOpen: true,
                type: "lorry",
                originationPage: load_lorry_posting/* POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE */.ec.MARKETPLACE
            });
            openLorryPostingModal(posting_helpers_constants/* LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */.jU.VEHICLE_NUMBER);
        }, 100);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(vehicle_restriction_popup/* VehicleRestrictionPopup */.pS, {
        id: "lorry-not-allowed-popup",
        isOpen: isModalOpen,
        kind: "unsupported_category",
        onCancel: closeAndClear,
        onPrimary: handlePrimary,
        primaryLabelOverride: (loadLorryData === null || loadLorryData === void 0 ? void 0 : loadLorryData.type) === "load" ? "Post New Load" : undefined
    });
};
/* harmony default export */ var standalone_load_posting_form_modal_LorryNotAllowedPopup = (LorryNotAllowedPopup);

// EXTERNAL MODULE: ./components/common/download-app-qr-modal/DownloadAppAction.tsx + 1 modules
var DownloadAppAction = __webpack_require__(20058);
;// CONCATENATED MODULE: ./components/common-global-wrapper.tsx











var StandaloneLoadPostingFormModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9813).then(__webpack_require__.bind(__webpack_require__, 29813));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29813)
            ];
        }
    },
    ssr: false
});
var LiveLorryLocationModalWrapper = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2892), __webpack_require__.e(3993)]).then(__webpack_require__.bind(__webpack_require__, 33993));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33993)
            ];
        }
    },
    ssr: false
});
var CommonGlobalComponentsWrapper = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), isLorryNotAllowedPopupOpen = ref1.isLorryNotAllowedPopupOpen, toggleIsLorryNotAllowedPopupOpen = ref1.toggleIsLorryNotAllowedPopupOpen;
    var isCsDashboardUser = (0,useCsDashboard/* useCsDashboard */.Z)().isCsDashboardUser;
    var loadLorryData = (0,load_lorry_posting/* useLoadLorryPosting */.NS)().loadLorryData;
    var ref2 = loadLorryData !== null && loadLorryData !== void 0 ? loadLorryData : {}, type = ref2.type, data = ref2.data, isModalOpen = ref2.isModalOpen, originationPage = ref2.originationPage;
    var loadData = type === "load" ? data : undefined;
    var lorryData = type === "lorry" ? data : undefined;
    var detailsPageData = (0,DetailsPageContextProvider/* useDetailsPageContext */.R)().detailsPageData;
    /**
     * Consumer users use compact load posting for post and re-post.
     * Legacy modal stays for CS dashboard users and admin edit flows.
     * Expected-price uses its own modal via isUpdateExpectedPriceModalOpen.
     */ var showLegacyLoadModal = isModalOpen && type === "load" && (isCsDashboardUser || (loadLorryData === null || loadLorryData === void 0 ? void 0 : loadLorryData.category) === "edit");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showLegacyLoadModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(StandaloneLoadPostingFormModal, {
                editLoadData: loadData,
                originationPage: originationPage
            }),
            isModalOpen && type === "lorry" && /*#__PURE__*/ (0,jsx_runtime.jsx)(standalone_lorry_posting_form_modal_StandaloneLorryPostingFormModal, {
                editLorryData: lorryData,
                originationPage: originationPage,
                KamClientSupplierCompanyId: (ref = loadLorryData) === null || ref === void 0 ? void 0 : ref.companyId
            }),
            (detailsPageData === null || detailsPageData === void 0 ? void 0 : detailsPageData.openLorryLocationModal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveLorryLocationModalWrapper, {}),
            isLorryNotAllowedPopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(standalone_load_posting_form_modal_LorryNotAllowedPopup, {
                isModalOpen: isLorryNotAllowedPopupOpen,
                toggleModal: function() {
                    return toggleIsLorryNotAllowedPopupOpen();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAppAction/* DownloadAppQrModalHost */.z, {})
        ]
    });
};
/* harmony default export */ var common_global_wrapper = (CommonGlobalComponentsWrapper);

;// CONCATENATED MODULE: ./components/homepage-v2/compact-flow/useCompactFlowAppTracker.ts


/**
 * Shared app-provider wiring for compact posting/bidding flows.
 * Exposes the common GA/MoEngage trackEvent adapter used by both flows.
 *
 * Namespace loading is handled on demand when a modal opens (see compact providers)
 * and when TopNavV2 mounts (navigation).
 */ function useCompactFlowAppTracker() {
    var sendGAandMoEngageEvent = (0,useEventTrackerService/* useEventTrackerService */.f)().sendGAandMoEngageEvent;
    var trackEvent = (0,react.useCallback)(function(eventName, data) {
        var trackGa = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, trackMo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, trackFbCapi = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        sendGAandMoEngageEvent({
            name: eventName,
            data: data
        }, trackGa, trackMo, trackFbCapi);
    }, [
        sendGAandMoEngageEvent
    ]);
    return {
        trackEvent: trackEvent
    };
}

;// CONCATENATED MODULE: ./components/homepage-v2/compact-load-posting/CompactLoadPostingAppProvider.tsx





/**
 * App-level host for the compact load posting flow.
 *
 * Mounts `CompactLoadPostingProvider` once at the top of the tree so any consumer
 * surface (side nav, dashboard, marketplace, profile) can open the compact flow.
 * Posting i18n namespaces are fetched when the modal opens (`loadNamespaces`).
 */ var CompactLoadPostingAppProvider = function(param) {
    var children = param.children;
    var trackEvent = useCompactFlowAppTracker().trackEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactLoadPostingProvider/* CompactLoadPostingProvider */.c4, {
        trackEvent: trackEvent,
        eventData: {
            source_screen: event_names/* WEB_V2_SOURCE_SCREENS.LOAD_FORM */.ZM.LOAD_FORM
        },
        children: children
    });
};
/* harmony default export */ var compact_load_posting_CompactLoadPostingAppProvider = (CompactLoadPostingAppProvider);

// EXTERNAL MODULE: ./components/homepage-v2/midnight-load-verification/index.ts + 2 modules
var midnight_load_verification = __webpack_require__(69564);
;// CONCATENATED MODULE: ./components/homepage-v2/compact-load-bidding/CompactLoadBiddingAppProvider.tsx





/**
 * App-level host for the compact load bidding flow.
 *
 * Bidding i18n namespaces are fetched when the modal opens (`loadNamespaces`).
 */ var CompactLoadBiddingAppProvider = function(param) {
    var children = param.children;
    var trackEvent = useCompactFlowAppTracker().trackEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompactLoadBiddingProvider/* CompactLoadBiddingProvider */.mx, {
        trackEvent: trackEvent,
        eventData: {
            source_screen: event_names/* WEB_V2_SOURCE_SCREENS.BID_FORM */.ZM.BID_FORM
        },
        children: children
    });
};
/* harmony default export */ var compact_load_bidding_CompactLoadBiddingAppProvider = (CompactLoadBiddingAppProvider);

// EXTERNAL MODULE: ../../node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(44655);
;// CONCATENATED MODULE: ./context/CommonProviderWrapper.tsx



var CommonProviderWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoteConfigContext/* RemoteConfigProvider */.j, {
        children: children
    });
};

;// CONCATENATED MODULE: ./components/seo-header/HomePageMetaScript.tsx



var GLOBAL_ORGANIZATION_SCHEMA_JSON = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: constants/* COMPANY_DETAILS.name */.SXn.name,
    url: constants/* COMPANY_DETAILS.website */.SXn.website,
    logo: constants/* COMPANY_DETAILS.logo */.SXn.logo,
    description: "India's largest online truck and load booking marketplace connecting shippers with verified transporters.",
    foundingDate: "2020",
    sameAs: Object.values(constants/* COMPANY_SOCIAL_MEDIA_CHANNELS */.RmR),
    contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer service",
        availableLanguage: [
            "English",
            "Hindi"
        ],
        url: constants/* COMPANY_DETAILS.website */.SXn.website + "/contact-us"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: constants/* COMPANY_DETAILS.addressLocality */.SXn.addressLocality,
        addressRegion: constants/* COMPANY_DETAILS.addressRegion */.SXn.addressRegion,
        addressCountry: constants/* COMPANY_DETAILS.addressCountry */.SXn.addressCountry
    }
});
var OrganizationSchemaScript = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        id: "jsonld-organization",
        dangerouslySetInnerHTML: {
            __html: GLOBAL_ORGANIZATION_SCHEMA_JSON
        }
    });
};
/** Site-wide Organization JSON-LD — prefer inlining {@link OrganizationSchemaScript} inside a Head block. */ var HomePageMetaScript = function() {
    return /*#__PURE__*/ _jsx(Head, {
        children: /*#__PURE__*/ _jsx(OrganizationSchemaScript, {})
    });
};
/* harmony default export */ var seo_header_HomePageMetaScript = ((/* unused pure expression or super */ null && (HomePageMetaScript)));

// EXTERNAL MODULE: ./components/seo-header/PageSeo.tsx
var PageSeo = __webpack_require__(83347);
;// CONCATENATED MODULE: ./pages/_app.tsx
/* provided dependency */ var _app_process = __webpack_require__(34406);






































var queryClient = new es.QueryClient();
 // dependency from core-ui




var IS_PROD_ENV = _app_process.env.NEXT_PUBLIC_REACT_APP_ENV === misc/* PRODUCTION_ENV */.vE;
var gaId = IS_PROD_ENV ? "G-DR8CDQM1JW" : "G-FG78FWFD6F";
var moengageAppId = IS_PROD_ENV ? "N68SRK42JD90WOPGMLGMGSHI" : "1VH5KJH9KQD9I0NWLSGZVHHS";
var moEngageDebugLogs = !IS_PROD_ENV && _app_process.env.NEXT_PUBLIC_REACT_APP_MOENGAGE_DEBUGGER_MODE !== "false" ? 1 : 0;
var moeDataCenter = "dc_3";
function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref;
    var router = (0,next_router.useRouter)();
    var cookies = new Cookies/* default */.Z();
    var vahakAutomationCookie = cookies.get(misc/* COOKIES.vahakAutomation */.E9.vahakAutomation);
    var isVahakAutomation = false;
    if (vahakAutomationCookie) {
        isVahakAutomation = Boolean(JSON.parse(vahakAutomationCookie));
    }
    // Use the layout defined at the page level, if available
    var getLayout = getlayoutForPage({
        Component: Component,
        pageProps: pageProps
    });
    var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
    useIsomorphicLayoutEffect(function() {
        document.documentElement.lang = router.locale || "en";
    }, [
        router.locale
    ]);
    /**
     * use this to set support for webP
     */ useIsomorphicLayoutEffect(function() {
        var _isWebPSupported = function _isWebPSupported() {
            return new Promise(function(res) {
                var webP = new Image();
                webP.src = "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
                webP.onload = webP.onerror = function() {
                    res(webP.height === 2);
                };
            });
        };
        _isWebPSupported().then(function(res) {
            _app_process.env.isWebPSupported = res ? "1" : "0";
        // localStorage.setItem("isWebPSupported", res ? "1" : "0");
        });
    }, []);
    (0,react.useEffect)(function() {
        if ("serviceWorker" in navigator) {
            window.addEventListener("load", function() {
                navigator.serviceWorker.register("/serviceworker.js").then(function(registration) {
                    console.log("Service Worker registration successful with scope: ", registration.scope);
                }, function(err) {
                    console.log("Service Worker registration failed: ", err);
                });
            });
        }
    }, []);
    var isMobile =  true ? (ref = window.navigator.userAgent) === null || ref === void 0 ? void 0 : ref.includes("Mobile") : 0;
    var hideChatMenuInExcludedRoutes = [
        routeStrings/* ROUTES.membershipPayment.getUrl */.Z.membershipPayment.getUrl()
    ].includes(router.asPath.split("?")[0]);
    // useEffect(() => {
    //     const TAWK = (window as any)["Tawk_API"];
    //     if (TAWK && hideChatMenuInExcludedRoutes) {
    //         TAWK?.hideWidget();
    //     }
    //     return () => {
    //         if (TAWK) {
    //             TAWK?.showWidget();
    //         }
    //     };
    // }, [router.asPath]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSeo/* SeoProvider */.a4, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "viewport",
                            content: "width=device-width,minimum-scale=1,initial-scale=1,interactive-widget=resizes-content"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: "https://www.googletagmanager.com/ns.html?id=GTM-PKTN2X8",
                                height: "0",
                                width: "0",
                                style: {
                                    display: "none",
                                    visibility: "hidden"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "preconnect",
                            href: "https://dev.visualwebsiteoptimizer.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationSchemaScript, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "vwoCode",
                    strategy: "lazyOnload",
                    dangerouslySetInnerHTML: {
                        __html: "\n                        window._vwo_code || (function() {\n                        var account_id=684830,\n                        version=2.0,\n                        settings_tolerance=2000,\n                        hide_element='body',\n                        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',\n                        f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){w._vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "my-script-2",
                    strategy: "afterInteractive",
                    dangerouslySetInnerHTML: {
                        __html: 'window.vahak = {}; window.vahak.is_p = "'.concat(IS_PROD_ENV, '";')
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    strategy: "lazyOnload",
                    src: 'https://www.googletagmanager.com/gtag/js?id="'.concat(gaId, '"')
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "my-script-4",
                    strategy: "lazyOnload",
                    dangerouslySetInnerHTML: {
                        __html: '\n                    window.dataLayer = window.dataLayer || [];\n                    function gtag() {\n                        dataLayer.push(arguments);\n                    };\n                    gtag("js", new Date());\n                    function getUserId(){\n                        if(document.cookie){\n                            if(document.cookie.split("; ")){\n                                for(let c of document.cookie.split("; ")){\n                                    if(c.split("=")){\n                                        for(let c1 of c.split("=")){\n                                            if(c1==="ui"){\n                                                return c.split("=")[1]\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    gtag("config","'.concat(gaId, '", { send_page_view: false, user_id: getUserId()});\n                    ')
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "meta-pixel",
                    strategy: "lazyOnload",
                    dangerouslySetInnerHTML: {
                        __html: "\n                    !function(f,b,e,v,n,t,s)\n                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n                    n.queue=[];t=b.createElement(e);t.async=!0;\n                    t.src=v;s=b.getElementsByTagName(e)[0];\n                    s.parentNode.insertBefore(t,s)}(window, document,'script',\n                    'https://connect.facebook.net/en_US/fbevents.js');\n                    fbq('init', '".concat(misc/* FB_PIXEL_ID */.ng, "');\n                    fbq('track', 'PageView');\n                    ")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "moengage-script",
                    strategy: "afterInteractive",
                    dangerouslySetInnerHTML: {
                        __html: '\n                    var moeDataCenter = "dc_3";\n                    !(function (e, n, i, t, a, r, o, d) {\n                        if (!moeDataCenter || !moeDataCenter.match(/^dc_[0-9]+$/gm))\n                            return console.error(\n                                "Data center has not been passed correctly. Please follow the SDK installation instruction carefully."\n                            );\n                        var s = (e[a] = e[a] || []);\n                        if (((s.invoked = 0), s.initialised > 0 || s.invoked > 0))\n                            return (\n                                console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"), !1\n                            );\n                        e.moengage_object = a;\n                        var l = {},\n                            g = function n(i) {\n                                return function () {\n                                    for (var n = arguments.length, t = Array(n), a = 0; a < n; a++) t[a] = arguments[a];\n                                    (e.moengage_q = e.moengage_q || []).push({ f: i, a: t });\n                                };\n                            },\n                            u = [\n                                "track_event",\n                                "add_user_attribute",\n                                "add_first_name",\n                                "add_last_name",\n                                "add_email",\n                                "add_mobile",\n                                "add_user_name",\n                                "add_gender",\n                                "add_birthday",\n                                "destroy_session",\n                                "add_unique_user_id",\n                                "update_unique_user_id",\n                                "moe_events",\n                                "call_web_push",\n                                "track",\n                                "location_type_attribute"\n                            ],\n                            m = { onsite: ["getData", "registerCallback"] };\n                        for (var c in u) l[u[c]] = g(u[c]);\n                        for (var v in m) for (var f in m[v]) null == l[v] && (l[v] = {}), (l[v][m[v][f]] = g(v + "." + m[v][f]));\n                        (r = n.createElement(i)),\n                            (o = n.getElementsByTagName("head")[0]),\n                            (r.async = 1),\n                            (r.src = t),\n                            o.appendChild(r),\n                            (e.moe =\n                                e.moe ||\n                                function () {\n                                    return ((s.invoked = s.invoked + 1), s.invoked > 1)\n                                        ? (console.error(\n                                            "MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"\n                                        ),\n                                        !1)\n                                        : ((d = arguments.length <= 0 ? void 0 : arguments[0]), l);\n                                }),\n                            r.addEventListener("load", function () {\n                                if (d) return (e[a] = e.moe(d)), (e[a].initialised = e[a].initialised + 1 || 1), !0;\n                            }),\n                            r.addEventListener("error", function () {\n                                return console.error("Moengage Web SDK loading failed."), !1;\n                            });\n                    })(\n                        window,\n                        document,\n                        "script",\n                        "https://cdn.moengage.com/release/'.concat(moeDataCenter, '/moe_webSdk.min.latest.js",\n                        "Moengage"\n                    );\n\n                    Moengage = moe({\n                    app_id:"').concat(moengageAppId, '",\n                    debug_logs: ').concat(moEngageDebugLogs, ',\n                    cards: {\n                        enable: true,\n                        placeholder: \'#cardIcon\',\n                        backgroundColor: "#F6FBFC", // any valid CSS color format\n                        overLayColor: "rgba(0, 0, 0, 0.8)",\n                        fontFaces: [{\n                            family: "Sofia",\n                            url: "https://fonts.gstatic.com/s/sofia/v14/8QIHdirahM3j_su5uI0Orbjl.woff2"\n                        }, {\n                            family: "Audiowide",\n                            url: "https://fonts.gstatic.com/s/audiowide/v16/l7gdbjpo0cum0ckerWCdlg_OMRlABg.woff2"\n                        }],\n                        cardDismiss: {\n                            color: "#db2828", // any valid CSS color format\n                            enable: true // boolean value, which enable the dismiss option.\n                        },\n                        optionButtonColor: "#C4C4C4", // any valid CSS color format\n                        dateTimeColor: "#8E8E8E", // any valid CSS color format\n                        unclickedCardIndicatorColor: "blue", // any valid CSS color format\n                        pinIcon: "https://app-cdn.moengage.com/sdk/pin-icon.svg", // absolute path to the icon image.\n                        refreshIcon: "https://app-cdn.moengage.com/sdk/refresh-icon.svg", // absolute path to the icon image.\n                        navigationBar: {\n                            backgroundColor: "#00237C", // any valid CSS color format\n                            text: "Notifications", // string. eg, Notifications\n                            color: "#fff", // any valid CSS color format\n                            fontSize: "16px", // any valid CSS size format\n                            fontFamily: "", // any font family which is added to the website\n                        },\n                        closeButton: {\n                            webIcon: "https://app-cdn.moengage.com/sdk/cross-icon.svg",\n                            mWebIcon: "https://app-cdn.moengage.com/sdk/cross-icon.svg",\n                        },\n                        tab: {\n                            active: {\n                            color: "#06A6B7",\n                            underlineColor: "#06A6B7",\n                            backgroundColor: "transparent"\n                            },\n                            inactiveTabFontColor: "#7C7C7C",\n                            fontSize: "14px", // any valid CSS size format\n                            fontFamily: "", // any font family which is added to the website\n                            backgroundColor: "#fff", // any valid CSS color format\n                        },\n                        // webFloating: {\n                        //     enable: ').concat(!isVahakAutomation, ', // false by default\n                        //     icon: "https://app-cdn.moengage.com/sdk/bell-icon.svg", // absolute path to the icon image. by default, our icon will be used.\n                        //     postion: "0px 10px 80px 0", // need all 4 offset in proper CSS format in the order of top, right, bottom, left.\n                        //     countBackgroundColor: "#FF5A5F",\n                        //     countColor: "#fff",\n                        //     iconBackgroundColor: "#D9DFED",\n                        //     fontFamily: "Audiowide"\n                        // },\n                        // mWebFloating: {\n                        //     enable: ').concat(!isVahakAutomation, ', // false by default\n                        //     icon: "https://app-cdn.moengage.com/sdk/bell-icon.svg", // absolute path to the icon image. by default, our icon will be used.\n                        //     postion: "0px 7px 130px 0", // need all 4 offset in proper CSS format in the order of top, right, bottom, left.\n                        //     countBackgroundColor: "#FF5A5F",\n                        //     countColor: "#fff",\n                        //     iconBackgroundColor: "#D9DFED",\n                        //     fontFamily: "Audiowide"\n                        // },\n                        card: {\n                            headerFontSize: "16px",\n                            descriptionFontSize: "14px",\n                            ctaFontSize: "12px",\n                            fontFamily: "inherit",\n                            horizontalRowColor: "#D9DFED"\n                        },\n                        noDataContent: {\n                            img: "https://app-cdn.moengage.com/sdk/cards-no-result.svg",\n                            text: "No notifications to show, check again later.",\n                        }\n                    },\n                    cluster: "DC_3",\n                    swPath: "/serviceworker.js"\n                    }); \n                    \n                    ')
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es6_CookiesProvider, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es.QueryClientProvider, {
                        client: queryClient,
                        contextSharing: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(devtools.ReactQueryDevtools, {
                                initialIsOpen: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                                newestOnTop: true,
                                style: {
                                    zIndex: dist_constants/* zIndexList.ToastContainer */.m7.ToastContainer
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonProviderWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppContextWrapper_0, {
                                    isMobile: pageProps.isMobile,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarketplaceContextProvider/* MarketplaceProvider */.Tx, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment_context/* PaymentProvider */.O, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BiddingFormContextProvider/* BiddingFormProvider */.Ed, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(load_lorry_posting/* LoadLorryPostingProvider */.fb, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPageContextProvider/* DetailsPageContextProvider */.y, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(midnight_load_verification/* MidnightVerificationProvider */.lX, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(compact_load_posting_CompactLoadPostingAppProvider, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(compact_load_bidding_CompactLoadBiddingAppProvider, {
                                                                        children: [
                                                                            getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                                                                isMobile: isMobile || false
                                                                            }))),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSeo/* GlobalSeoHead */.Ej, {}),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(route_transition_loader_RouteTransitionLoader, {
                                                                                app: "nextjs"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(global_components_wrapper, {
                                                                                pageRoute: pageProps === null || pageProps === void 0 ? void 0 : pageProps.route
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_global_wrapper, {})
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthVerifyComponent["default"], {})
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp));


/***/ }),

/***/ 70452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ usePostLoadBid; },
/* harmony export */   "j": function() { return /* binding */ BidType; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36153);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);




var BidType;
(function(BidType) {
    BidType[BidType["LOAD_BID"] = 1] = "LOAD_BID";
    BidType[BidType["LORRY_BID"] = 2] = "LORRY_BID";
})(BidType || (BidType = {}));
var usePostLoadBid = function() {
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().POST;
    var postLoadBid = function(param) {
        var amount = param.amount, bidder_id = param.bidder_id, is_vehicle_available = param.is_vehicle_available, load_id = param.load_id, _type = param.type, type = _type === void 0 ? 0 : _type, bidder_comment = param.bidder_comment, _is_negotiable = param.is_negotiable, is_negotiable = _is_negotiable === void 0 ? true : _is_negotiable, vehicle_number = param.vehicle_number, quantity = param.quantity, lorry_id = param.lorry_id;
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SUBMIT_LOAD_BID */ .Z.SUBMIT_LOAD_BID, {
            amount: amount,
            type: type,
            is_negotiable: is_negotiable,
            is_vehicle_available: is_vehicle_available || Boolean(vehicle_number),
            bidder_comment: bidder_comment,
            load_id: load_id,
            bidder_id: bidder_id,
            quantity: quantity,
            vehicle_number: vehicle_number,
            lorry_id: lorry_id
        });
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__/* .useVahakMutationQuery */ .M8)(_queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].bid.postLoadBid */ .Z.bid.postLoadBid, postLoadBid);
};


/***/ }),

/***/ 93269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useGetCompanyCashbackDetailsMutationQuery; },
/* harmony export */   "p": function() { return /* binding */ useGetCompanyCashbackDetailsQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36153);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);
/* harmony import */ var _vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46492);







var buildCompanyCashbackUrl = function(params) {
    return "".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__/* ["default"].USER_CASHBACK_DETAILS */ .Z.USER_CASHBACK_DETAILS, "&").concat((0,_vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__/* .generateQueryString */ .T9)({
        c_i: params === null || params === void 0 ? void 0 : params.companyId
    }));
};
var useGetCompanyCashbackDetailsMutationQuery = function() {
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().GET;
    var method = function(params) {
        return GET(buildCompanyCashbackUrl(params));
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__/* .useVahakMutationQuery */ .M8)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyCashbackDetails */ .Z.getCompanyCashbackDetails
    ], method);
};
var useGetCompanyCashbackDetailsQuery = function(params, options) {
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().GET;
    var method = function() {
        return GET(buildCompanyCashbackUrl(params));
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__/* .useVahakQuery */ .uE)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCompanyCashbackDetails */ .Z.getCompanyCashbackDetails,
        params
    ], method, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, options), {
        select: function(data) {
            return data.data;
        }
    }));
};


/***/ }),

/***/ 41740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ usePostDocuments; }
/* harmony export */ });
/* unused harmony export useUploadDocumentsNonMutate */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41634);
//Hooks



// services

//Endpoints

var usePostDocuments = function() {
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().POST;
    var getDocuments = function(data) {
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UPLOAD_DOCUMENTS */ .Z.UPLOAD_DOCUMENTS, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, data));
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakMutationQuery */ .M8)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_2__/* .QueryNames.getDocuments */ ._.getDocuments
    ], getDocuments);
};
/**
 *
 * @param options
 * @param params
 * @returns
 *
 * Experimental purpose, POST query without mutation
 * So we can invalidate the query
 */ var useUploadDocumentsNonMutate = function(options, params) {
    var company_id = params.company_id, document_type = params.document_type, payload = params.payload, reference_id = params.reference_id, reference_type = params.reference_type, ticket_id = params.ticket_id;
    var POST = useVahakHttpClient().POST;
    var getDocuments = function() {
        return POST(API.GET_DOCUMENTS, {
            company_id: company_id,
            document_type: document_type,
            payload: payload,
            reference_id: reference_id,
            reference_type: reference_type,
            ticket_id: ticket_id
        });
    };
    return useVahakQuery([
        QueryNames.getDocumentsNonMutate
    ], getDocuments, options);
};


/***/ }),

/***/ 9433:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var queryNames = {
    premiumTripListing: "premium-trip-listing",
    changeLorryStatus: "change-lorry-status",
    tripTrackListing: "trip-track-listing",
    changeDriverDetails: "change-driver-details",
    tripDocs: "trip-docs",
    postTripDocs: "post-trip-docs",
    myLoadBids: "my-load-bids",
    myLorryBids: "my-lorry-bids",
    uploadImage: "upload-image",
    UserLorriesForUpdatingDriverDetailsKam: "user-lorries-for-updating-driver-details-kam",
    userReports: "user-reports",
    getCompanyPostingAndBiddingLimit: "get-company-posting-and-bidding-limit",
    getLoadMarketV2: "getLoadMarketV2",
    getLoadMarketInfiniteQueryV2: "getLoadMarketInfiniteQueryV2",
    getSimilarPastDepositors: "getSimilarPastDepositors",
    getCompanyDetails: "get-company-details",
    getCompanyCashbackDetails: "get-company-cashback-details",
    getCompanyInfo: "get-company-info",
    getLatAndLongBasedOnPlaceId: "getLatAndLongBasedOnPlaceId",
    deleteBankAccount: "deleteBankAccount",
    getLorryMarketV2: "getLorryMarketV2",
    getLorryMarketInfiniteQueryV2: "getLorryMarketInfiniteQueryV2",
    getShortLink: "getShortLink",
    getLiveLoadsByLorryIdInfiniteQueryV2: "getLiveLoadsByLorryIdInfiniteQueryV2",
    getLiveLorriesByLoadIdInfiniteQueryV2: "getLiveLorriesByLoadIdInfiniteQueryV2",
    bid: {
        postLoadBid: "postLoadBid",
        bidInfoUpdate: "bidInfoUpdate"
    },
    bulkTag: "bulkTag",
    bulkUnTag: "bulkUnTag",
    createVasTicket: "createVasTicket",
    trueCallerUserDetails: "trueCallerUserDetails",
    updateReportDisposition: "updateReportDisposition",
    getLorryCurrentTripLocation: "getLorryCurrentTripLocation",
    getLorryLocationHistory: "getLorryLocationHistory",
    getReverseGeoPoint: "getReverseGeoPoint",
    getLocationDetails: "getLocationDetails",
    updateLorryRoute: "updateLorryRoute",
    updateDriverDetails: "updateDriverDetails",
    attachDriverDetails: "attachDriverDetails",
    enableSimTracking: "enableSimTracking",
    removeDriverDetails: "removeDriverDetails",
    updateLoadDetails: "updateLoadDetails"
};
/* harmony default export */ __webpack_exports__["Z"] = (queryNames);


/***/ }),

/***/ 92508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ generateMarketplaceCardLongDynamicLink; },
/* harmony export */   "fh": function() { return /* binding */ getShortLinkBaseUrl; }
/* harmony export */ });
/* unused harmony export getWebsiteBaseUrl */
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94204);


var SHORT_LINK_DEV = "https://vahaktest.page.link";
var SHORT_LINK_PROD = "https://vahak.page.link";
var getShortLinkBaseUrl = function() {
    return _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__/* .IS_PROD_ENV */ .c ? SHORT_LINK_PROD : SHORT_LINK_DEV;
};
var getWebsiteBaseUrl = function() {
    return _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__/* .IS_PROD_ENV */ .c ? _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_1__/* .COMPANY_DETAILS.website */ .SXn.website : _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_1__/* .COMPANY_DETAILS.stagingLink */ .SXn.stagingLink;
};
var generateMarketplaceCardLongDynamicLink = function(param) {
    var mktType = param.mktType, source = param.source, destination = param.destination, entityId = param.entityId, oppcmpid = param.oppcmpid, referralCode = param.referralCode, utm_source = param.utm_source, utm_medium = param.utm_medium, utm_campaign = param.utm_campaign;
    var ID = mktType === "load" ? "loadbid=".concat(entityId) : "lorrybid=".concat(entityId);
    var destinationLink = "".concat(getWebsiteBaseUrl(), "/marketplace/").concat(mktType, "/").concat(source ? source : "").concat(destination ? "-to-" + destination : "", "?").concat(ID).concat(referralCode ? "&referral_code=" + referralCode : "").concat(oppcmpid ? "&oppcmpid=" + oppcmpid : "", "&r=load|").concat(entityId, "&u_i=").concat(oppcmpid, "&utm_source=").concat(utm_source, "&utm_medium=").concat(utm_medium, "&utm_campaign=").concat(utm_campaign, "&p=1");
    var longLink = "".concat(getShortLinkBaseUrl(), "/?link=").concat(destinationLink, "&apn=search.find.lorries.invite.transporter.add.lorries.deliveries.codenicely.search.vahak&afl=").concat(destinationLink);
    return destinationLink;
};


/***/ }),

/***/ 25514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50930);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63118);
/* provided dependency */ var process = __webpack_require__(34406);



var RAZORPAY_HIDDEN_PAYMENT_METHODS = [
    {
        method: "emi"
    },
    {
        method: "paylater"
    }
];
var ALLOWED_RAZORPAY_HOSTS = [
    "localhost",
    "127.0.0.1",
    "vahak.in"
];
var isAllowedRazorpayHost = function() {
    if (false) {}
    var host = window.location.hostname.toLowerCase();
    return ALLOWED_RAZORPAY_HOSTS.some(function(allowed) {
        return host === allowed || host.endsWith(".".concat(allowed));
    });
};
var useRazorpay = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), paymentId = ref[0], setPaymentId = ref[1];
    var loadRazorpayScript = function() {
        return new Promise(function(resolve) {
            var script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            script.onload = function() {
                resolve();
            };
            document.body.appendChild(script);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        loadRazorpayScript();
    }, []);
    var initializePayment = function(params) {
        if (!isAllowedRazorpayHost()) {
            _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .A.error("Payment is not allowed on this domain");
            params.onDismiss();
            return;
        }
        var options = {
            key: process.env.NEXT_PUBLIC_RAZORPAY_KEY,
            currency: "INR",
            amount: params.amount * 100,
            order_id: params.order_id,
            handler: function(response) {
                var ref;
                setPaymentId(response.razorpay_payment_id);
                params === null || params === void 0 ? void 0 : (ref = params.onSuccess) === null || ref === void 0 ? void 0 : ref.call(params, response);
            },
            modal: {
                ondismiss: params.onDismiss
            },
            timeout: 5 * 60,
            hidden: {
                contact: true,
                email: true
            },
            config: {
                display: {
                    hide: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(RAZORPAY_HIDDEN_PAYMENT_METHODS),
                    preferences: {
                        show_default_blocks: true
                    }
                }
            }
        };
        var razorpay = new window.Razorpay(options);
        razorpay.on("payment.failed", params.onError);
        razorpay.open();
    };
    return {
        paymentId: paymentId,
        initializePayment: initializePayment
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useRazorpay);


/***/ }),

/***/ 86259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_misc_callback_request_CallbackRequest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92659);
/* harmony import */ var _vahak_core_ui_dist_hooks_useToggleModalWithLocalState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8779);




var useRequestCallBack = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _src = ref.src, src = _src === void 0 ? "-" : _src, trackOnClose = ref.trackOnClose, trackOnCancelled = ref.trackOnCancelled, trackOnSubmit = ref.trackOnSubmit;
    var ref1 = (0,_vahak_core_ui_dist_hooks_useToggleModalWithLocalState__WEBPACK_IMPORTED_MODULE_3__/* .useToggleModalWithLocalState */ .A)(false), openCallBackReqModal = ref1.openModal, closeCallBackReqModal = ref1.closeModal, isModalOpen = ref1.isModalOpen;
    var CallBackForm = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isModalOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_misc_callback_request_CallbackRequest__WEBPACK_IMPORTED_MODULE_2__["default"], {
            isCallbackRequestPopupVisible: isModalOpen,
            toggleCallBackRequestModal: closeCallBackReqModal,
            onSubmit: function(reason) {
                closeCallBackReqModal();
                trackOnSubmit === null || trackOnSubmit === void 0 ? void 0 : trackOnSubmit(reason);
            },
            sourceScreen: src,
            trackOnCancelled: trackOnCancelled,
            trackOnClose: trackOnClose
        }) : null
    });
    return {
        CallBackForm: CallBackForm,
        openCallBackReqModal: openCallBackReqModal
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useRequestCallBack);


/***/ }),

/***/ 80590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useUploadImageService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36153);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37528);






function useUploadImageService() {
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().POST;
    function uploadImage(_) {
        return _uploadImage.apply(this, arguments);
    }
    function _uploadImage() {
        _uploadImage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var file, operation, payload, customHeaders, formData;
            return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        file = param.file, operation = param.operation;
                        payload = {
                            file: file,
                            operation: operation
                        };
                        customHeaders = {
                            "Content-Type": "multipart/form-data"
                        };
                        formData = new FormData();
                        if (file) {
                            formData.append("file", file);
                        }
                        formData.append("operation", operation);
                        return _ctx.abrupt("return", POST("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].MISC_UPLOAD_IMAGE */ .Z.MISC_UPLOAD_IMAGE), payload, formData, {}, customHeaders));
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _uploadImage.apply(this, arguments);
    }
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_4__/* .useVahakMutationQuery */ .M8)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].uploadImage */ .Z.uploadImage
    ], uploadImage);
}


/***/ }),

/***/ 78325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCreateVasTicket; }
/* harmony export */ });
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36153);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);
/* harmony import */ var _vahak_core_dist_methods_remove_empty_or_null_object_value__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43266);





function useCreateVasTicket() {
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().POST;
    var createVasTicket = function(data) {
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CREATE_VAS_TICKET */ .Z.CREATE_VAS_TICKET, (0,_vahak_core_dist_methods_remove_empty_or_null_object_value__WEBPACK_IMPORTED_MODULE_4__/* .removeEmptyOrNullObjectValue */ .W)(data));
    };
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_1__/* .useVahakMutationQuery */ .M8)(_queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].createVasTicket */ .Z.createVasTicket, createVasTicket);
};


/***/ }),

/***/ 95150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VP": function() { return /* binding */ toBookingAmountOrderRequest; },
/* harmony export */   "hB": function() { return /* binding */ BookingForMap; },
/* harmony export */   "x6": function() { return /* binding */ PaymentMode; },
/* harmony export */   "xw": function() { return /* binding */ getRequiredBookingForType; },
/* harmony export */   "zw": function() { return /* binding */ useGeneratePayment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);





var PaymentMode;
(function(PaymentMode) {
    PaymentMode[PaymentMode["CLIENT"] = 1] = "CLIENT";
    PaymentMode[PaymentMode["ADMIN"] = 2] = "ADMIN";
})(PaymentMode || (PaymentMode = {}));
var toBookingAmountOrderRequest = function(items) {
    return items === null || items === void 0 ? void 0 : items.map(function(param) {
        var amount = param.amount, load_id = param.load_id, bid_id = param.bid_id, bid_type = param.bid_type, booking_for = param.booking_for;
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            amount: amount,
            load_id: load_id,
            bid_type: bid_type,
            booking_for: booking_for
        }, bid_id ? {
            bid_id: bid_id
        } : {});
    });
};
var useGeneratePayment = function() {
    var generatePayment = function generatePayment(data) {
        var _paymentMode;
        var payload = {
            payment_mode: (_paymentMode = data.paymentMode) !== null && _paymentMode !== void 0 ? _paymentMode : PaymentMode.CLIENT,
            company_id: data.companyId,
            redeem_cashback: data.redeemCashback,
            vas_order_request: data.vasOrders,
            booking_amount_order_request: toBookingAmountOrderRequest(data === null || data === void 0 ? void 0 : data.bookingAmountOrderRequest)
        };
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].RAZORPAY_PAYMENT_LINK */ .Z.RAZORPAY_PAYMENT_LINK, payload);
    };
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().POST;
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_2__/* .useVahakMutationQuery */ .M8)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_0__/* .QueryNames.generatePayment */ ._.generatePayment
    ], generatePayment, {
        onSettled: function() {}
    });
};
var BookingForMap;
(function(BookingForMap) {
    BookingForMap[BookingForMap["TAP_N_GO"] = 1] = "TAP_N_GO";
    BookingForMap[BookingForMap["SPOT"] = 2] = "SPOT";
    BookingForMap[BookingForMap["TAP_N_GO_TOKEN"] = 3] = "TAP_N_GO_TOKEN";
    BookingForMap[BookingForMap["TAP_N_GO_BALANCE"] = 4] = "TAP_N_GO_BALANCE";
    BookingForMap[BookingForMap["SPOT_LOAD_TOKEN"] = 5] = "SPOT_LOAD_TOKEN";
    BookingForMap[BookingForMap["SPOT_LOAD_BALANCE"] = 6] = "SPOT_LOAD_BALANCE";
    BookingForMap[BookingForMap["CASHBACK_DUE"] = 10] = "CASHBACK_DUE";
})(BookingForMap || (BookingForMap = {}));
function getRequiredBookingForType(info) {
    var isTapNGo = info.isTapNGo, isSpot = info.isSpot, isTokenFlow = info.isTokenFlow, isTokenPaid = info.isTokenPaid, isBalancePaid = info.isBalancePaid;
    if (isTapNGo) {
        if (isTokenFlow) {
            if (!isTokenPaid) return BookingForMap.TAP_N_GO_TOKEN;
        // if (!isBalancePaid) return BookingForMap.TAP_N_GO_BALANCE;
        }
        return BookingForMap.TAP_N_GO;
    }
    if (isSpot) {
        if (isTokenFlow) {
            if (!isTokenPaid) return BookingForMap.SPOT_LOAD_TOKEN;
        // if (!isBalancePaid) return BookingForMap.SPOT_LOAD_BALANCE;
        }
        return BookingForMap.SPOT;
    }
}


/***/ }),

/***/ 37137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mk": function() { return /* binding */ TicketStatus; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; },
/* harmony export */   "yf": function() { return /* binding */ DocumentReferenceType; }
/* harmony export */ });
/* unused harmony export TicketCode */
var DocumentReferenceType;
(function(DocumentReferenceType) {
    DocumentReferenceType[DocumentReferenceType["LOAD"] = 1] = "LOAD";
    DocumentReferenceType[DocumentReferenceType["LORRY"] = 2] = "LORRY";
    DocumentReferenceType[DocumentReferenceType["COMPANY"] = 3] = "COMPANY";
})(DocumentReferenceType || (DocumentReferenceType = {}));
var TicketCode;
(function(TicketCode) {
    TicketCode[TicketCode["LORRY_RECEIPT"] = 1] = "LORRY_RECEIPT";
    TicketCode[TicketCode["POD"] = 2] = "POD";
    TicketCode[TicketCode["SUPPORTING_DOC"] = 3] = "SUPPORTING_DOC";
    TicketCode[TicketCode["EWAY_BILL"] = 5] = "EWAY_BILL";
    TicketCode[TicketCode["GOODS_INVOICE"] = 6] = "GOODS_INVOICE";
    TicketCode[TicketCode["SHOP_IMAGE"] = 7] = "SHOP_IMAGE";
    TicketCode[TicketCode["AADHAAR"] = 100] = "AADHAAR";
    TicketCode[TicketCode["BUSINESS_DOCUMENTS"] = 200] = "BUSINESS_DOCUMENTS";
    TicketCode[TicketCode["PAN"] = 300] = "PAN";
    TicketCode[TicketCode["RC_VALIDATION"] = 400] = "RC_VALIDATION";
})(TicketCode || (TicketCode = {}));
var TicketStatus;
(function(TicketStatus) {
    TicketStatus[TicketStatus["PENDING"] = 0] = "PENDING";
    TicketStatus[TicketStatus["APPROVED"] = 1] = "APPROVED";
    TicketStatus[TicketStatus["RESOLVING"] = 4] = "RESOLVING";
    TicketStatus[TicketStatus["REJECTED"] = 999] = "REJECTED";
})(TicketStatus || (TicketStatus = {}));
var DocumentType;
(function(DocumentType) {
    DocumentType[DocumentType["LORRY_RECEIPT"] = 1] = "LORRY_RECEIPT";
    DocumentType[DocumentType["POD"] = 2] = "POD";
    DocumentType[DocumentType["SUPPORTING_DOC"] = 3] = "SUPPORTING_DOC";
    DocumentType[DocumentType["EWAY_BILL"] = 5] = "EWAY_BILL";
    DocumentType[DocumentType["GOODS_INVOICE"] = 7] = "GOODS_INVOICE";
    DocumentType[DocumentType["SHOP_IMAGE"] = 6] = "SHOP_IMAGE";
    DocumentType[DocumentType["AADHAAR_FRONT"] = 100] = "AADHAAR_FRONT";
    DocumentType[DocumentType["AADHAAR_BACK"] = 101] = "AADHAAR_BACK";
    DocumentType[DocumentType["AADHAAR_SELFIE"] = 102] = "AADHAAR_SELFIE";
    DocumentType[DocumentType["GST_CERTIFICATE"] = 200] = "GST_CERTIFICATE";
    DocumentType[DocumentType["MSME_CERTIFICATE"] = 201] = "MSME_CERTIFICATE";
    DocumentType[DocumentType["GUMASTA_LICENSE"] = 202] = "GUMASTA_LICENSE";
    DocumentType[DocumentType["TRADE_LICENSE"] = 203] = "TRADE_LICENSE";
    DocumentType[DocumentType["PAN"] = 300] = "PAN";
    DocumentType[DocumentType["RC_VALIDATION"] = 400] = "RC_VALIDATION";
    DocumentType[DocumentType["DRIVER_LICENSE"] = 600] = "DRIVER_LICENSE";
    DocumentType[DocumentType["DRIVER_AADHAAR"] = 602] = "DRIVER_AADHAAR";
    DocumentType[DocumentType["LORRY_BODY"] = 800] = "LORRY_BODY";
})(DocumentType || (DocumentType = {}));


/***/ }),

/***/ 2198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ generateFormFieldNames; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87394);

var generateFormFieldNames = function(obj) {
    var newObj = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_step.value, 1), key = _value[0];
            // @ts-expect-error
            newObj[key] = key;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return newObj;
};


/***/ }),

/***/ 72366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getImageNameFromURL; }
/* harmony export */ });
function getImageNameFromURL(url) {
    if (!url) return "";
    var urlSplit = [];
    urlSplit = url.split("/");
    return urlSplit[urlSplit.length - 1];
}


/***/ }),

/***/ 21711:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"AssuredLoadStatus_main__RfTFo","wrapper":"AssuredLoadStatus_wrapper__9SuVW","load":"AssuredLoadStatus_load__yV_fd","lorry":"AssuredLoadStatus_lorry__4fegH","bid":"AssuredLoadStatus_bid__WggBB","desc":"AssuredLoadStatus_desc__3YK3B","action":"AssuredLoadStatus_action__yY6ON","misc":"AssuredLoadStatus_misc__tJfht","payment":"AssuredLoadStatus_payment__IjDpn","waitingAction":"AssuredLoadStatus_waitingAction__zYhSh","iconWrapper":"AssuredLoadStatus_iconWrapper__YAr8U"};

/***/ }),

/***/ 3945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"AppRedirectPayBtn_main__m75Lm"};

/***/ }),

/***/ 73625:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"AssuredHelpDesk_main__iNOML","responsive":"AssuredHelpDesk_responsive__Q_JDu"};

/***/ }),

/***/ 82293:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"HowItWorksBtn_main__AK_HP","responsive":"HowItWorksBtn_responsive__42v1m"};

/***/ }),

/***/ 10303:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Working_main__E0upl","header":"Working_header__MiB_O","body":"Working_body__6PgdU","list":"Working_list__Y8i41","item":"Working_item__Ush_5","imgWrapper":"Working_imgWrapper__TPdl8","arrow":"Working_arrow__wJu_A","content":"Working_content__ako_d","img":"Working_img__1ELYK"};

/***/ }),

/***/ 35169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"TapNgoTimer_main__JqSS6","active":"TapNgoTimer_active__ysHV8","disabled":"TapNgoTimer_disabled__dFLjl"};

/***/ }),

/***/ 91604:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Helpdesk_main__Ki7am"};

/***/ }),

/***/ 28104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BtnWrapper":"ClearDueModal_BtnWrapper__6HCvZ"};

/***/ }),

/***/ 92854:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"DownloadAppQrModal_overlay__vemqh","dialog":"DownloadAppQrModal_dialog__cszsh","card":"DownloadAppQrModal_card__mJw0z","closeBtn":"DownloadAppQrModal_closeBtn__OZ6s_","content":"DownloadAppQrModal_content__MBPpv","title":"DownloadAppQrModal_title__ey90p"};

/***/ }),

/***/ 1037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"LorryOneLineInfo_main__kb8mO","wrapper":"LorryOneLineInfo_wrapper__I6zRk"};

/***/ }),

/***/ 39861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lorryCardContainer":"LorryCard_lorryCardContainer__0z3tn","verifiedPill":"LorryCard_verifiedPill__1OE14","payBtnRedirection":"LorryCard_payBtnRedirection__SMCHs","mainRow":"LorryCard_mainRow__gLuCY","lorryIconCol":"LorryCard_lorryIconCol__dN8gY","lorryClassificationCol":"LorryCard_lorryClassificationCol__lp_Kz","lorrySrcDestCol":"LorryCard_lorrySrcDestCol__LjwKM","lorryBadgeCol":"LorryCard_lorryBadgeCol__4PrNm","lorryPostedCol":"LorryCard_lorryPostedCol__R4fMy","editAndCommentContainer":"LorryCard_editAndCommentContainer__l5sfi","editAndComment":"LorryCard_editAndComment__ydJeJ","lorryCommentCol":"LorryCard_lorryCommentCol__H0ZsU","arrowCol":"LorryCard_arrowCol__yUGMb","lorryNumberContainer":"LorryCard_lorryNumberContainer__CJ9cR","lorryIcon":"LorryCard_lorryIcon__TI935","icon":"LorryCard_icon__PJilb","shareIcon":"LorryCard_shareIcon__k_IYd","lorryNumber":"LorryCard_lorryNumber__bvmzf","lorryClassificationContainer":"LorryCard_lorryClassificationContainer__I6Hrf","statusContainer":"LorryCard_statusContainer__QJIfG","bidStatusContainer":"LorryCard_bidStatusContainer__8j4BD","bidStatus":"LorryCard_bidStatus__5ABw_","timeStamp":"LorryCard_timeStamp__K6gqZ","reActivateCol":"LorryCard_reActivateCol__8HBvq","reActivate":"LorryCard_reActivate__EA9lR","lorryActions":"LorryCard_lorryActions__3gbHP","loadingState":"LorryCard_loadingState__u7Iec","lorryCardSpaceWrapper":"LorryCard_lorryCardSpaceWrapper__msOt6","status":"LorryCard_status__VH0KQ","expired":"LorryCard_expired__TkPs9","profileInfoWrapper":"LorryCard_profileInfoWrapper__De5ye","profileWrapper":"LorryCard_profileWrapper__1Bma5","lorryId":"LorryCard_lorryId__JXwfr","postedAt":"LorryCard_postedAt__nDItH","srcDestCol":"LorryCard_srcDestCol__Jvycg","lorryClassification":"LorryCard_lorryClassification__ZPsTk","footerSectionWrapper":"LorryCard_footerSectionWrapper__vvSZs","viewDetailsBtn":"LorryCard_viewDetailsBtn__5jTHE","footerSectionContainer":"LorryCard_footerSectionContainer__b3VNZ","reactivateContainer":"LorryCard_reactivateContainer__MSVuJ","bidStatusIndicator":"LorryCard_bidStatusIndicator__pmOng","sentOrReceived":"LorryCard_sentOrReceived__PwA58","awaiting":"LorryCard_awaiting__AU5mF"};

/***/ }),

/***/ 73409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reactivateBtnWrapper":"ReactivateLoadLorry_reactivateBtnWrapper__aQ9w9","reactivateBtn":"ReactivateLoadLorry_reactivateBtn__gk38h"};

/***/ }),

/***/ 92158:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animate":"HomepageV2Animate_animate__G1_yE","fadeUp":"HomepageV2Animate_fadeUp__EPcdF","visible":"HomepageV2Animate_visible__RzqE2","fadeLeft":"HomepageV2Animate_fadeLeft__TmZcH","fadeRight":"HomepageV2Animate_fadeRight__HFrid","scaleUp":"HomepageV2Animate_scaleUp__A_ZKX","hpv2HeroSlideIn":"HomepageV2Animate_hpv2HeroSlideIn__BTaAh","hpv2HeroFadeIn":"HomepageV2Animate_hpv2HeroFadeIn__5T5Jw","hpv2HeroFadeInOpacity":"HomepageV2Animate_hpv2HeroFadeInOpacity__iH_0X","hpv2FadeUp":"HomepageV2Animate_hpv2FadeUp__fwMKH","hpv2FadeLeft":"HomepageV2Animate_hpv2FadeLeft__xKUGT","hpv2FadeRight":"HomepageV2Animate_hpv2FadeRight__t9UXH","hpv2ScaleUp":"HomepageV2Animate_hpv2ScaleUp__5dm6n","hpv2Blink":"HomepageV2Animate_hpv2Blink__C5YN_","hpv2FloatA":"HomepageV2Animate_hpv2FloatA__JU5kk","hpv2FloatB":"HomepageV2Animate_hpv2FloatB__9Abg5","hpv2DemoProgress":"HomepageV2Animate_hpv2DemoProgress__TRbXX","hpv2DemoSlideIn":"HomepageV2Animate_hpv2DemoSlideIn__4m9KS","hpv2DemoFadeIn":"HomepageV2Animate_hpv2DemoFadeIn__bX5io","hpv2DemoScaleIn":"HomepageV2Animate_hpv2DemoScaleIn__hDXd1","hpv2DemoBounce":"HomepageV2Animate_hpv2DemoBounce__BuiTi","hpv2PulseDot":"HomepageV2Animate_hpv2PulseDot__piE7j","hpv2PriceShimmer":"HomepageV2Animate_hpv2PriceShimmer__C9HNq"};

/***/ }),

/***/ 31196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AppDownloadBannerV2_container__5KPNY","banner":"AppDownloadBannerV2_banner__4giQK","content":"AppDownloadBannerV2_content__9T0yG","eyebrow":"AppDownloadBannerV2_eyebrow__AGaWO","title":"AppDownloadBannerV2_title__wwx8_","titleLine":"AppDownloadBannerV2_titleLine__P9hvk","subtitle":"AppDownloadBannerV2_subtitle__t2gAC","storeButtons":"AppDownloadBannerV2_storeButtons__M8GrT","storeButton":"AppDownloadBannerV2_storeButton__4hk1_","storeIcon":"AppDownloadBannerV2_storeIcon__iWr0M","storeText":"AppDownloadBannerV2_storeText___7S_j","storeLabel":"AppDownloadBannerV2_storeLabel__s5uT4","storeName":"AppDownloadBannerV2_storeName__VRxHj","stats":"AppDownloadBannerV2_stats__Cv9DW","stat":"AppDownloadBannerV2_stat__ZSSYy","statDivider":"AppDownloadBannerV2_statDivider___oQIw","statValue":"AppDownloadBannerV2_statValue__RQvDG","statLabel":"AppDownloadBannerV2_statLabel__X9leL","imageCol":"AppDownloadBannerV2_imageCol__B7m_f","bannerImage":"AppDownloadBannerV2_bannerImage__3KudY","hpv2FloatA":"AppDownloadBannerV2_hpv2FloatA__MzSlf","hpv2HeroSlideIn":"AppDownloadBannerV2_hpv2HeroSlideIn___pZMV","hpv2HeroFadeIn":"AppDownloadBannerV2_hpv2HeroFadeIn__xh1fQ","hpv2HeroFadeInOpacity":"AppDownloadBannerV2_hpv2HeroFadeInOpacity__tv_i0","hpv2FadeUp":"AppDownloadBannerV2_hpv2FadeUp__rTF_n","hpv2FadeLeft":"AppDownloadBannerV2_hpv2FadeLeft__MNf2_","hpv2FadeRight":"AppDownloadBannerV2_hpv2FadeRight__ajHX8","hpv2ScaleUp":"AppDownloadBannerV2_hpv2ScaleUp___BJSZ","hpv2Blink":"AppDownloadBannerV2_hpv2Blink__XmxE_","hpv2FloatB":"AppDownloadBannerV2_hpv2FloatB__BauEg","hpv2DemoProgress":"AppDownloadBannerV2_hpv2DemoProgress__oPtzy","hpv2DemoSlideIn":"AppDownloadBannerV2_hpv2DemoSlideIn__45g8H","hpv2DemoFadeIn":"AppDownloadBannerV2_hpv2DemoFadeIn__ICcmx","hpv2DemoScaleIn":"AppDownloadBannerV2_hpv2DemoScaleIn__0WzyU","hpv2DemoBounce":"AppDownloadBannerV2_hpv2DemoBounce__NYjXy","hpv2PulseDot":"AppDownloadBannerV2_hpv2PulseDot__2szfD","hpv2PriceShimmer":"AppDownloadBannerV2_hpv2PriceShimmer__tkCj7"};

/***/ }),

/***/ 36042:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"HomepageV2SectionCard_card__V9piI","white":"HomepageV2SectionCard_white__0Hipz","light":"HomepageV2SectionCard_light__56iUR","dark":"HomepageV2SectionCard_dark__5OdYS","footer":"HomepageV2SectionCard_footer__p6FNo","scrollTarget":"HomepageV2SectionCard_scrollTarget__sEzun","hpv2HeroSlideIn":"HomepageV2SectionCard_hpv2HeroSlideIn__kH3qH","hpv2HeroFadeIn":"HomepageV2SectionCard_hpv2HeroFadeIn__VjE_a","hpv2HeroFadeInOpacity":"HomepageV2SectionCard_hpv2HeroFadeInOpacity__lVQVa","hpv2FadeUp":"HomepageV2SectionCard_hpv2FadeUp__xGUXL","hpv2FadeLeft":"HomepageV2SectionCard_hpv2FadeLeft__4j62P","hpv2FadeRight":"HomepageV2SectionCard_hpv2FadeRight__EBA5U","hpv2ScaleUp":"HomepageV2SectionCard_hpv2ScaleUp__V1QvU","hpv2Blink":"HomepageV2SectionCard_hpv2Blink__yAF3z","hpv2FloatA":"HomepageV2SectionCard_hpv2FloatA__dL_da","hpv2FloatB":"HomepageV2SectionCard_hpv2FloatB__9vyvb","hpv2DemoProgress":"HomepageV2SectionCard_hpv2DemoProgress__wDbEv","hpv2DemoSlideIn":"HomepageV2SectionCard_hpv2DemoSlideIn__sE5Kg","hpv2DemoFadeIn":"HomepageV2SectionCard_hpv2DemoFadeIn__J0rOz","hpv2DemoScaleIn":"HomepageV2SectionCard_hpv2DemoScaleIn__wCLXj","hpv2DemoBounce":"HomepageV2SectionCard_hpv2DemoBounce__QvOdW","hpv2PulseDot":"HomepageV2SectionCard_hpv2PulseDot___XUyE","hpv2PriceShimmer":"HomepageV2SectionCard_hpv2PriceShimmer__Tk2m_"};

/***/ }),

/***/ 30306:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottomNavbarWrapper":"BottomNavLayout_bottomNavbarWrapper__RFYih","bodyContent":"BottomNavLayout_bodyContent__PLu7T","bodyContentNoTop":"BottomNavLayout_bodyContentNoTop__HpTsx","hpv2HeroSlideIn":"BottomNavLayout_hpv2HeroSlideIn__M9Sc5","hpv2HeroFadeIn":"BottomNavLayout_hpv2HeroFadeIn__Uhakc","hpv2HeroFadeInOpacity":"BottomNavLayout_hpv2HeroFadeInOpacity__TrdRp","hpv2FadeUp":"BottomNavLayout_hpv2FadeUp__oN_YS","hpv2FadeLeft":"BottomNavLayout_hpv2FadeLeft__tm0ad","hpv2FadeRight":"BottomNavLayout_hpv2FadeRight__LQMSc","hpv2ScaleUp":"BottomNavLayout_hpv2ScaleUp__oiRPS","hpv2Blink":"BottomNavLayout_hpv2Blink__Br9Kl","hpv2FloatA":"BottomNavLayout_hpv2FloatA___Jf7P","hpv2FloatB":"BottomNavLayout_hpv2FloatB__Dr49s","hpv2DemoProgress":"BottomNavLayout_hpv2DemoProgress__KZcva","hpv2DemoSlideIn":"BottomNavLayout_hpv2DemoSlideIn__X_sKK","hpv2DemoFadeIn":"BottomNavLayout_hpv2DemoFadeIn__f8iLb","hpv2DemoScaleIn":"BottomNavLayout_hpv2DemoScaleIn__YqLjJ","hpv2DemoBounce":"BottomNavLayout_hpv2DemoBounce__yr_CX","hpv2PulseDot":"BottomNavLayout_hpv2PulseDot__4A_dJ","hpv2PriceShimmer":"BottomNavLayout_hpv2PriceShimmer__pO9pL"};

/***/ }),

/***/ 81514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ContinueSignup_main__N8GRB","wrapper":"ContinueSignup_wrapper__aX7OK","actionBtn":"ContinueSignup_actionBtn__jkkmd"};

/***/ }),

/***/ 6610:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"DashboardNav_main__hTKLz","bottomNavbarWrapper":"DashboardNav_bottomNavbarWrapper__a1ybG","menuItem":"DashboardNav_menuItem__DoJsJ","active":"DashboardNav_active__QOGnC","icon":"DashboardNav_icon__MCy_u","navMenu":"DashboardNav_navMenu__M8vYu","postLoadLory":"DashboardNav_postLoadLory__YkmUE","label":"DashboardNav_label__x9KMe","postingIcon":"DashboardNav_postingIcon__q21pu","postingMenuDropdownContainer":"DashboardNav_postingMenuDropdownContainer__h2jfK","dropdownMenuItemClassName":"DashboardNav_dropdownMenuItemClassName__DP1Ue","dropdownToggleClassName":"DashboardNav_dropdownToggleClassName__h_Dyg","postingLabelContainer":"DashboardNav_postingLabelContainer__YiNZC","postingLabel":"DashboardNav_postingLabel__HHf7w","postingMenuItem":"DashboardNav_postingMenuItem__DpL1M","postingMenuItemBtn":"DashboardNav_postingMenuItemBtn__Yo58O","userProfile":"DashboardNav_userProfile__rySYO"};

/***/ }),

/***/ 44826:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__4akbQ","link__highlighted":"Footer_link__highlighted__jYdWx","divider":"Footer_divider__yydVI","row":"Footer_row__AlR87","topLinks":"Footer_topLinks__8wNfB","getInTouch":"Footer_getInTouch__Peiry","footerPlaystoreIcon":"Footer_footerPlaystoreIcon__NemXP","mostSearchedLinkContainer":"Footer_mostSearchedLinkContainer__B1Icf","trustContent":"Footer_trustContent__iVs0G","socialIconWrapper":"Footer_socialIconWrapper__OrqZE","socialIconContainer":"Footer_socialIconContainer____bxR","fillWhite":"Footer_fillWhite__kN2lb","logoFooter":"Footer_logoFooter__0iTCN","footerHead":"Footer_footerHead__q_7W6","textFoot":"Footer_textFoot__jLU2m","footerList":"Footer_footerList__0pZLl","hiring":"Footer_hiring__LOOgL","footerBar":"Footer_footerBar__LAQ6m","copyRights":"Footer_copyRights__hKawl","madeInIndia":"Footer_madeInIndia__ouhDs","payments":"Footer_payments__yn_zo","col":"Footer_col__Wro4Q","seoContent":"Footer_seoContent__tRTjz","a":"Footer_a__5QBd0"};

/***/ }),

/***/ 8141:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoryHeading":"categoryListStyles_categoryHeading__LP_fB","mostSearchedCategoryList":"categoryListStyles_mostSearchedCategoryList__RUf8p","inactive":"categoryListStyles_inactive__doQ_U","active":"categoryListStyles_active__8nVFd","majorRoutes":"categoryListStyles_majorRoutes__g1ZcX","show_more":"categoryListStyles_show_more__yAfl0"};

/***/ }),

/***/ 87381:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobileFilter_layout":"MobileFilter_mobileFilter_layout__XyJHj","filterLinks":"MobileFilter_filterLinks__2v3AF","active":"MobileFilter_active__uS0qK"};

/***/ }),

/***/ 61283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainLayoutWrapper":"SideNavLayout_mainLayoutWrapper__uHUEu","sideBarWrapper":"SideNavLayout_sideBarWrapper__LaMGa","isSideBarExpanded":"SideNavLayout_isSideBarExpanded__y5TwB","userProfileIconContainer":"SideNavLayout_userProfileIconContainer__bTz2t","userProfileLabelContainer":"SideNavLayout_userProfileLabelContainer__2KCGW","userProfileLabel":"SideNavLayout_userProfileLabel__TO9gx","logoWrapper":"SideNavLayout_logoWrapper__z_CHG","logoContainer":"SideNavLayout_logoContainer__OcjeE","dropdownMenuItemClassName":"SideNavLayout_dropdownMenuItemClassName__9f9Qn","userProfileButtonWrapper":"SideNavLayout_userProfileButtonWrapper__qo_UP","postingMenuDropdownContainer":"SideNavLayout_postingMenuDropdownContainer__U6Neg","postingButtonWrapper":"SideNavLayout_postingButtonWrapper__FiHCD","postingBtnContainer":"SideNavLayout_postingBtnContainer__BFXFn","postingBtn":"SideNavLayout_postingBtn__7qps7","postingIconContainer":"SideNavLayout_postingIconContainer__De_Xp","postingLabelContainer":"SideNavLayout_postingLabelContainer__0MSpQ","postingLabel":"SideNavLayout_postingLabel__0qCIp","menuItemsWrapper":"SideNavLayout_menuItemsWrapper__YsNVg","menuItems":"SideNavLayout_menuItems__GNylx","menuItemWrapper":"SideNavLayout_menuItemWrapper__5IWTE","menuItem":"SideNavLayout_menuItem__T9vsZ","menuIcon":"SideNavLayout_menuIcon__cLSLd","label":"SideNavLayout_label__ndm4C","arowDown":"SideNavLayout_arowDown__2q_DC","disableClick":"SideNavLayout_disableClick__pwZnh","active":"SideNavLayout_active__Ftvkr","subMenuItems":"SideNavLayout_subMenuItems__j0ajP","showSubmenu":"SideNavLayout_showSubmenu__zqw5n","subMenuItem":"SideNavLayout_subMenuItem__LM_nw","subMenuIcon":"SideNavLayout_subMenuIcon__5S8Mk","subMenuLabel":"SideNavLayout_subMenuLabel__szKsr","subMenuActive":"SideNavLayout_subMenuActive__OdyCw","siteMainContent":"SideNavLayout_siteMainContent__EfeEV"};

/***/ }),

/***/ 6660:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ProfileItemPopupMenu_main__UaF2w","profileDropdown":"ProfileItemPopupMenu_profileDropdown__YOlLg","profileOptions":"ProfileItemPopupMenu_profileOptions__LCCYw","profileOption":"ProfileItemPopupMenu_profileOption__iV7Z_","logout":"ProfileItemPopupMenu_logout__cPL6X"};

/***/ }),

/***/ 13922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"SmartAppBanner_banner__6WH3X","dismiss":"SmartAppBanner_dismiss__0ZoFz","icon":"SmartAppBanner_icon__PIys_","copy":"SmartAppBanner_copy__4DBUT","title":"SmartAppBanner_title__BRewR","tagline":"SmartAppBanner_tagline__rY_uW","cta":"SmartAppBanner_cta__JCkwr"};

/***/ }),

/***/ 99030:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"TopNavV2_main__E_1dQ","inner":"TopNavV2_inner__7GIES","left":"TopNavV2_left__wG0H7","logoWrapper":"TopNavV2_logoWrapper__iROi4","logoText":"TopNavV2_logoText__OgXtA","centerNav":"TopNavV2_centerNav__NRPmf","navLink":"TopNavV2_navLink__bgfoz","navLinkActive":"TopNavV2_navLinkActive__CiSAH","right":"TopNavV2_right__4wlor","authActions":"TopNavV2_authActions__hpHyB","profileSlot":"TopNavV2_profileSlot__566qC","mobileLoginBtn":"TopNavV2_mobileLoginBtn__E6G_e","loginBtn":"TopNavV2_loginBtn__OdGlq","langIconWrapper":"TopNavV2_langIconWrapper__TP9NB","languageDropdownContainer":"TopNavV2_languageDropdownContainer__CLLUH","languageDropdown":"TopNavV2_languageDropdown__31zfA","languageDropdownToggle":"TopNavV2_languageDropdownToggle__1gJxK","languageSubmenuWrapper":"TopNavV2_languageSubmenuWrapper__1cZjp","languageSubmenu":"TopNavV2_languageSubmenu__UbxoM","active":"TopNavV2_active__9IkH0","hamburgerMenu":"TopNavV2_hamburgerMenu__E594n","darkHeroMain":"TopNavV2_darkHeroMain__ZmIBf","darkHeroMainScrolled":"TopNavV2_darkHeroMainScrolled__fxQGX","appDrawMenu":"TopNavV2_appDrawMenu__i_vSF","open":"TopNavV2_open__6LcOj","isOpen":"TopNavV2_isOpen__tOe9B","appDrawMenuOptionListWrapper":"TopNavV2_appDrawMenuOptionListWrapper__wmw9A","appDrawMenuOption":"TopNavV2_appDrawMenuOption__rgBa3","drawerLink":"TopNavV2_drawerLink__kfpOG","drawerLinkActive":"TopNavV2_drawerLinkActive__ToXxc","drawerActions":"TopNavV2_drawerActions__f9Pmb","drawerLoginBtn":"TopNavV2_drawerLoginBtn__O54Xp","drawerSignUpBtn":"TopNavV2_drawerSignUpBtn__Anpju","downloadBanner":"TopNavV2_downloadBanner__M4azD","hpv2HeroSlideIn":"TopNavV2_hpv2HeroSlideIn__hI3uM","hpv2HeroFadeIn":"TopNavV2_hpv2HeroFadeIn__g1347","hpv2HeroFadeInOpacity":"TopNavV2_hpv2HeroFadeInOpacity___1Mbe","hpv2FadeUp":"TopNavV2_hpv2FadeUp__XJWUy","hpv2FadeLeft":"TopNavV2_hpv2FadeLeft__rSfk4","hpv2FadeRight":"TopNavV2_hpv2FadeRight__0bm6M","hpv2ScaleUp":"TopNavV2_hpv2ScaleUp__shhA1","hpv2Blink":"TopNavV2_hpv2Blink__TUe0W","hpv2FloatA":"TopNavV2_hpv2FloatA__GUkPQ","hpv2FloatB":"TopNavV2_hpv2FloatB___JM9n","hpv2DemoProgress":"TopNavV2_hpv2DemoProgress__UfURt","hpv2DemoSlideIn":"TopNavV2_hpv2DemoSlideIn__fU5U4","hpv2DemoFadeIn":"TopNavV2_hpv2DemoFadeIn__Fxcx_","hpv2DemoScaleIn":"TopNavV2_hpv2DemoScaleIn__Y67e5","hpv2DemoBounce":"TopNavV2_hpv2DemoBounce__xIj_F","hpv2PulseDot":"TopNavV2_hpv2PulseDot__Xr0wn","hpv2PriceShimmer":"TopNavV2_hpv2PriceShimmer__TvjTH"};

/***/ }),

/***/ 23403:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"SrcDest_loading__KLiiQ","source":"SrcDest_source__9KniL","dest":"SrcDest_dest__0TpLL","lorrySrcDestBox":"SrcDest_lorrySrcDestBox__GZIcT","popup":"SrcDest_popup__ycPGb","routes":"SrcDest_routes__QdPCj","route":"SrcDest_route__DSv3f","sourceDestWrap":"SrcDest_sourceDestWrap__dJhg5","viewStates":"SrcDest_viewStates__SoGyJ","routeWrapperMobile":"SrcDest_routeWrapperMobile__jxgf7"};

/***/ }),

/***/ 78580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__SQOKm","tooltipContainer":"Tooltip_tooltipContainer__Kce0x","top":"Tooltip_top__iztE_","bottom":"Tooltip_bottom__bGTfF","right":"Tooltip_right__cG1mV","left":"Tooltip_left__wZyU5","contentWrapper":"Tooltip_contentWrapper__QyEqX","closeIcon":"Tooltip_closeIcon__b1fv7","bottomSheetBody":"Tooltip_bottomSheetBody__TXOiW"};

/***/ }),

/***/ 3778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"expires_desktop":"ExpiryPill_expires_desktop__dCEie","expires_mobile":"ExpiryPill_expires_mobile__z_cUf"};

/***/ }),

/***/ 51702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"activation":"Activation_activation__Ou09k","searchContainer":"Activation_searchContainer__23I2j","searchDiv":"Activation_searchDiv__vxern","ctas":"Activation_ctas__Hseme","share":"Activation_share__3RCsy","cancel":"Activation_cancel__Q4aio"};

/***/ }),

/***/ 90794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalDialog":"ShareModal_modalDialog____V7h","modalHeader":"ShareModal_modalHeader__5QqCg","closeIcon":"ShareModal_closeIcon__8fPN5","modalBody":"ShareModal_modalBody__WqXZb","BodyContentWrapper":"ShareModal_BodyContentWrapper__1Z6if","copyLinkContainer":"ShareModal_copyLinkContainer__8Z9nE","copyLinkButton":"ShareModal_copyLinkButton__NgLQU","url":"ShareModal_url__HmnZL","socialShareContainer":"ShareModal_socialShareContainer__Z0QeX","socialMediaShare":"ShareModal_socialMediaShare__rRhh_","socialMediaShareCol":"ShareModal_socialMediaShareCol__H3zsT","socialName":"ShareModal_socialName__z6V4v","whatsappShare":"ShareModal_whatsappShare__cQrFN","facebookShare":"ShareModal_facebookShare__D4DaC","sendSms":"ShareModal_sendSms__rTNVO","sendSmsContainer":"ShareModal_sendSmsContainer__AE1Uj","sendSmsForm":"ShareModal_sendSmsForm__BBwKF","appInput":"ShareModal_appInput__KaHRC","inputContainer":"ShareModal_inputContainer__kGqBv","inputWrapper":"ShareModal_inputWrapper__N74Zg","input":"ShareModal_input___GP1u","sendSmsButton":"ShareModal_sendSmsButton__gwVr_","modal-backdrop":"ShareModal_modal-backdrop__TNvX0","show":"ShareModal_show__Vzm5M"};

/***/ }),

/***/ 28791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"verified":"VerifiedPill_verified__GR9Ff","verifiedText":"VerifiedPill_verifiedText__a8Eui"};

/***/ }),

/***/ 94816:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"PaymentBtn_main__bfM59"};

/***/ }),

/***/ 86668:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"CallbackRequest_toggleButton__5YW0V","callbackRequestHeader":"CallbackRequest_callbackRequestHeader__K0xXO","bottomSheetHeading":"CallbackRequest_bottomSheetHeading__QKWkx"};

/***/ }),

/***/ 53146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"CallbackRequestForm_mainWrapper__mftRh","inputWrapper":"CallbackRequestForm_inputWrapper__7EgfU"};

/***/ }),

/***/ 9906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"VehicleRestrictionPopup_content__tv_Jr","bannerWrap":"VehicleRestrictionPopup_bannerWrap__gBBbJ","banner":"VehicleRestrictionPopup_banner__wuGHB","body":"VehicleRestrictionPopup_body__iQYc_","title":"VehicleRestrictionPopup_title__MrFyS","description":"VehicleRestrictionPopup_description__DoAwa","actions":"VehicleRestrictionPopup_actions__ZboxI","actionBtn":"VehicleRestrictionPopup_actionBtn__rDvRS","cancelBtn":"VehicleRestrictionPopup_cancelBtn__rx0yU","primaryBtn":"VehicleRestrictionPopup_primaryBtn__HVIaF"};

/***/ }),

/***/ 47281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaContainer":"QuickActionPopup_ctaContainer__elAkT","main":"QuickActionPopup_main__jFhtE","icon":"QuickActionPopup_icon__yk5HJ","header":"QuickActionPopup_header__3Hfgd","description":"QuickActionPopup_description__nHn2P"};

/***/ }),

/***/ 49271:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ServiceRequestModal_main__X_MRi","submitBtn":"ServiceRequestModal_submitBtn__3lCj5","successScreen":"ServiceRequestModal_successScreen__GN_5e","imgContainer":"ServiceRequestModal_imgContainer__6M_p2"};

/***/ }),

/***/ 34568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"AppMandatePopup_main__glMe7","content":"AppMandatePopup_content__r98_s","innerContent":"AppMandatePopup_innerContent__1lF1d","closeIcon":"AppMandatePopup_closeIcon__bMJv1"};

/***/ }),

/***/ 20036:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"route":"RouteState_route__edv_G","selected":"RouteState_selected__LjwaB"};

/***/ }),

/***/ 43219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"a":"AppLink_a__QrBud"};

/***/ }),

/***/ 54672:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"AvatarImage_imageContainer__K2ao3","initialContainer":"AvatarImage_initialContainer__2J_A_"};

/***/ }),

/***/ 44655:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31183:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3344:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92870:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26434:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 60946:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 71070:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 15610:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21581:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 46359:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 50633:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 926:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 39868:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 80753:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 9249:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 87371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 56666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 95058:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 45754:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88960);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 81665:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88960);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 81079:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 34434:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 33028:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56666);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/***/ }),

/***/ 59740:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31461);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 11987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86522);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80753);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 88960:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 76854:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(39868);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(59147);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(34434);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 86522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ 59147:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(926);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 85500:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ getApps; },
/* harmony export */   "Jn": function() { return /* binding */ SDK_VERSION; },
/* harmony export */   "KN": function() { return /* binding */ registerVersion; },
/* harmony export */   "Mq": function() { return /* binding */ getApp; },
/* harmony export */   "Xd": function() { return /* binding */ _registerComponent; },
/* harmony export */   "ZF": function() { return /* binding */ initializeApp; },
/* harmony export */   "qX": function() { return /* binding */ _getProvider; }
/* harmony export */ });
/* unused harmony exports _DEFAULT_ENTRY_NAME, _addComponent, _addOrOverwriteComponent, _apps, _clearComponents, _components, _isFirebaseApp, _isFirebaseServerApp, _removeServiceInstance, _serverApps, deleteApp, initializeServerApp, onLog, setLogLevel */
/* harmony import */ var _firebase_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46387);
/* harmony import */ var _firebase_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68207);
/* harmony import */ var _firebase_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83395);
/* harmony import */ var idb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55389);






/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class PlatformLoggerServiceImpl {
    constructor(container) {
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers
            .map(provider => {
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            }
            else {
                return null;
            }
        })
            .filter(logString => logString)
            .join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */
function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */;
}

const name$q = "@firebase/app";
const version$1 = "0.10.16";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const logger = new _firebase_logger__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd('@firebase/app');

const name$p = "@firebase/app-compat";

const name$o = "@firebase/analytics-compat";

const name$n = "@firebase/analytics";

const name$m = "@firebase/app-check-compat";

const name$l = "@firebase/app-check";

const name$k = "@firebase/auth";

const name$j = "@firebase/auth-compat";

const name$i = "@firebase/database";

const name$h = "@firebase/data-connect";

const name$g = "@firebase/database-compat";

const name$f = "@firebase/functions";

const name$e = "@firebase/functions-compat";

const name$d = "@firebase/installations";

const name$c = "@firebase/installations-compat";

const name$b = "@firebase/messaging";

const name$a = "@firebase/messaging-compat";

const name$9 = "@firebase/performance";

const name$8 = "@firebase/performance-compat";

const name$7 = "@firebase/remote-config";

const name$6 = "@firebase/remote-config-compat";

const name$5 = "@firebase/storage";

const name$4 = "@firebase/storage-compat";

const name$3 = "@firebase/firestore";

const name$2 = "@firebase/vertexai";

const name$1 = "@firebase/firestore-compat";

const name = "firebase";
const version = "11.0.2";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$q]: 'fire-core',
    [name$p]: 'fire-core-compat',
    [name$n]: 'fire-analytics',
    [name$o]: 'fire-analytics-compat',
    [name$l]: 'fire-app-check',
    [name$m]: 'fire-app-check-compat',
    [name$k]: 'fire-auth',
    [name$j]: 'fire-auth-compat',
    [name$i]: 'fire-rtdb',
    [name$h]: 'fire-data-connect',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    [name$2]: 'fire-vertex',
    'fire-js': 'fire-js', // Platform identifier for JS SDK.
    [name]: 'fire-js-all'
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
const _apps = new Map();
/**
 * @internal
 */
const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    }
    catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values()) {
        _addComponent(app, component);
    }
    for (const serverApp of _serverApps.values()) {
        _addComponent(serverApp, component);
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    const heartbeatController = app.container
        .getProvider('heartbeat')
        .getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name, instanceIdentifier = DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */
function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */
function _isFirebaseServerApp(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERRORS = {
    ["no-app" /* AppError.NO_APP */]: "No Firebase App '{$appName}' has been created - " +
        'call initializeApp() first',
    ["bad-app-name" /* AppError.BAD_APP_NAME */]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */]: 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new _firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .ErrorFactory */ .LL('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseAppImpl {
    constructor(options, config, container) {
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new _firebase_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .wA('app', () => this, "PUBLIC" /* ComponentType.PUBLIC */));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */, { appName: this._name });
        }
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class FirebaseServerAppImpl extends (/* unused pure expression or super */ null && (FirebaseAppImpl)) {
    constructor(options, serverConfig, name, container) {
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined
            ? serverConfig.automaticDataCollectionEnabled
            : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) {
            // Construct the parent FirebaseAppImp object.
            super(options, config, container);
        }
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({ automaticDataCollectionEnabled }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') {
            this._finalizationRegistry = new FinalizationRegistry(() => {
                this.automaticCleanup();
            });
        }
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$q, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) {
            return;
        }
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) {
            this._finalizationRegistry.register(obj, this);
        }
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) {
            return 0;
        }
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        void deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    checkDestroyed() {
        if (this.isDeleted) {
            throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */
const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = { name };
    }
    const config = Object.assign({ name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    options || (options = (0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultAppConfig */ .aH)());
    if (!options) {
        throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */);
    }
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .deepEqual */ .vZ)(options, existingApp.options) &&
            (0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .deepEqual */ .vZ)(config, existingApp.config)) {
            return existingApp;
        }
        else {
            throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */, { appName: name });
        }
    }
    const container = new _firebase_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentContainer */ .H0(name);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig) {
    if (isBrowser() && !isWebWorker()) {
        // FirebaseServerApp isn't designed to be run in browsers.
        throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */);
    }
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) {
        _serverAppConfig.automaticDataCollectionEnabled = false;
    }
    let appOptions;
    if (_isFirebaseApp(_options)) {
        appOptions = _options.options;
    }
    else {
        appOptions = _options;
    }
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) {
        delete nameObj.releaseOnDeref;
    }
    const hashCode = (s) => {
        return [...s].reduce((hash, c) => (Math.imul(31, hash) + c.charCodeAt(0)) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') {
            throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */, {});
        }
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new ComponentContainer(nameString);
    for (const component of _components.values()) {
        container.addComponent(component);
    }
    const newApp = new FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && (0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultAppConfig */ .aH)()) {
        return initializeApp();
    }
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    }
    else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container
            .getProviders()
            .map(provider => provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */
function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += `-${variant}`;
    }
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) {
            warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new _firebase_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .wA(`${library}-version`, () => ({ library, version }), "VERSION" /* ComponentType.VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */);
    }
    setUserLogHandler(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function setLogLevel(logLevel) {
    setLogLevel$1(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = (0,idb__WEBPACK_IMPORTED_MODULE_3__/* .openDB */ .X3)(DB_NAME, DB_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        try {
                            db.createObjectStore(STORE_NAME);
                        }
                        catch (e) {
                            // Safari/iOS browsers throw occasional exceptions on
                            // db.createObjectStore() that may be a bug. Avoid blocking
                            // the rest of the app functionality.
                            console.warn(e);
                        }
                }
            }
        }).catch(e => {
            throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    }
    catch (e) {
        if (e instanceof _firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .FirebaseError */ .ZR) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    }
    catch (e) {
        if (e instanceof _firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .FirebaseError */ .ZR) {
            logger.warn(e.message);
        }
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */, {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MAX_HEADER_BYTES = 1024;
// 30 days
const STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;
class HeartbeatServiceImpl {
    constructor(container) {
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(result => {
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */
    async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container
                .getProvider('platform-logger')
                .getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
                    return;
                }
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date ||
                this._heartbeatsCache.heartbeats.some(singleDateHeartbeat => singleDateHeartbeat.date === date)) {
                return;
            }
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({ date, agent });
            }
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats =
                this._heartbeatsCache.heartbeats.filter(singleDateHeartbeat => {
                    const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                    const now = Date.now();
                    return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                });
            return this._storage.overwrite(this._heartbeatsCache);
        }
        catch (e) {
            logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */
    async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) {
                await this._heartbeatsCachePromise;
            }
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null ||
                this._heartbeatsCache.heartbeats.length === 0) {
                return '';
            }
            const date = getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .base64urlEncodeWithoutPadding */ .L)(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            }
            else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                void this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        }
        catch (e) {
            logger.warn(e);
            return '';
        }
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache) {
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find(hb => hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        }
        else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app) {
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .isIndexedDBAvailable */ .hl)()) {
            return false;
        }
        else {
            return (0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .validateIndexedDBOpenable */ .eu)()
                .then(() => true)
                .catch(() => false);
        }
    }
    /**
     * Read all heartbeats.
     */
    async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return { heartbeats: [] };
        }
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) {
                return idbHeartbeatObject;
            }
            else {
                return { heartbeats: [] };
            }
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) {
            return;
        }
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */
function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0,_firebase_util__WEBPACK_IMPORTED_MODULE_2__/* .base64urlEncodeWithoutPadding */ .L)(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new _firebase_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .wA('platform-logger', container => new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    _registerComponent(new _firebase_component__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .wA('heartbeat', container => new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */));
    // Register `app` package.
    registerVersion(name$q, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    registerVersion(name$q, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 46387:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H0": function() { return /* binding */ ComponentContainer; },
/* harmony export */   "wA": function() { return /* binding */ Component; }
/* harmony export */ });
/* unused harmony export Provider */
/* harmony import */ var _firebase_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83395);


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    constructor(name, instanceFactory, type) {
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */
class Provider {
    constructor(name, container) {
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */
    get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new _firebase_util__WEBPACK_IMPORTED_MODULE_0__/* .Deferred */ .BH();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) ||
                this.shouldAutoInitialize()) {
                // initialize the service if it can be auto-initialized
                try {
                    const instance = this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                    if (instance) {
                        deferred.resolve(instance);
                    }
                }
                catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                }
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) ||
            this.shouldAutoInitialize()) {
            try {
                return this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
            }
            catch (e) {
                if (optional) {
                    return null;
                }
                else {
                    throw e;
                }
            }
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) {
                return null;
            }
            else {
                throw Error(`Service ${this.name} is not available`);
            }
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) {
            throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        }
        if (this.component) {
            throw Error(`Component for ${this.name} has already been provided`);
        }
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) {
            return;
        }
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) {
            try {
                this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
            }
            catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
            }
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            }
            catch (e) {
                // when the instance factory throws an exception, it should not cause
                // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services
                .filter(service => 'INTERNAL' in service) // legacy services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service.INTERNAL.delete()),
            ...services
                .filter(service => '_delete' in service) // modularized services
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .map(service => service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) {
            throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        }
        if (!this.isComponentSet()) {
            throw Error(`Component ${this.name} has not been registered yet`);
        }
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()) {
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) {
                instanceDeferred.resolve(instance);
            }
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */
    onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) {
            callback(existingInstance, normalizedIdentifier);
        }
        return () => {
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */
    invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) {
            return;
        }
        for (const callback of callbacks) {
            try {
                callback(instance, identifier);
            }
            catch (_a) {
                // ignore errors in the onInit callback
            }
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */
            this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */
            if (this.component.onInstanceCreated) {
                try {
                    this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                }
                catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                }
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) {
            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        }
        else {
            return identifier; // assume multiple instances are supported before the component is provided.
        }
    }
    shouldAutoInitialize() {
        return (!!this.component &&
            this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */);
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */
class ComponentContainer {
    constructor(name) {
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */
    addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        }
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) {
            // delete the existing provider from the container, so we can register the new component
            this.providers.delete(component.name);
        }
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */
    getProvider(name) {
        if (this.providers.has(name)) {
            return this.providers.get(name);
        }
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 68207:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yd": function() { return /* binding */ Logger; },
/* harmony export */   "in": function() { return /* binding */ LogLevel; }
/* harmony export */ });
/* unused harmony exports setLogLevel, setUserLogHandler */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
const defaultLogHandler = (instance, logType, ...args) => {
    if (logType < instance.logLevel) {
        return;
    }
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) {
        console[method](`[${now}]  ${instance.name}:`, ...args);
    }
    else {
        throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
    }
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    constructor(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) {
            throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        }
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') {
            throw new TypeError('Value assigned to `logHandler` must be a function');
        }
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */
    debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler &&
            this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach(inst => {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances) {
        let customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        }
        else {
            instance.userLogHandler = (instance, level, ...args) => {
                const message = args
                    .map(arg => {
                    if (arg == null) {
                        return null;
                    }
                    else if (typeof arg === 'string') {
                        return arg;
                    }
                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    }
                    else if (arg instanceof Error) {
                        return arg.message;
                    }
                    else {
                        try {
                            return JSON.stringify(arg);
                        }
                        catch (ignored) {
                            return null;
                        }
                    }
                })
                    .filter(arg => arg)
                    .join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message,
                        args,
                        type: instance.name
                    });
                }
            };
        }
    }
}


//# sourceMappingURL=index.esm2017.js.map


/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 18770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 58013:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 93520:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 26297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 87394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 68875:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 97357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hJ": function() { return /* reexport */ collection; },
  "PL": function() { return /* reexport */ getDocs; },
  "ad": function() { return /* reexport */ getFirestore; },
  "cf": function() { return /* reexport */ onSnapshot; },
  "Xo": function() { return /* reexport */ orderBy; },
  "IO": function() { return /* reexport */ query; },
  "ar": function() { return /* reexport */ where; },
  "qs": function() { return /* reexport */ writeBatch; }
});

// UNUSED EXPORTS: AbstractUserDataWriter, AggregateField, AggregateQuerySnapshot, Bytes, CACHE_SIZE_UNLIMITED, CollectionReference, DocumentReference, DocumentSnapshot, FieldPath, FieldValue, Firestore, FirestoreError, GeoPoint, LoadBundleTask, PersistentCacheIndexManager, Query, QueryCompositeFilterConstraint, QueryConstraint, QueryDocumentSnapshot, QueryEndAtConstraint, QueryFieldFilterConstraint, QueryLimitConstraint, QueryOrderByConstraint, QuerySnapshot, QueryStartAtConstraint, SnapshotMetadata, Timestamp, Transaction, VectorValue, WriteBatch, _AutoId, _ByteString, _DatabaseId, _DocumentKey, _EmptyAppCheckTokenProvider, _EmptyAuthCredentialsProvider, _FieldPath, _TestingHooks, _cast, _debugAssert, _internalAggregationQueryToProtoRunAggregationQueryRequest, _internalQueryToProtoQueryTarget, _isBase64Available, _logWarn, _validateIsNotUsedTogether, addDoc, aggregateFieldEqual, aggregateQuerySnapshotEqual, and, arrayRemove, arrayUnion, average, clearIndexedDbPersistence, collectionGroup, connectFirestoreEmulator, count, deleteAllPersistentCacheIndexes, deleteDoc, deleteField, disableNetwork, disablePersistentCacheIndexAutoCreation, doc, documentId, enableIndexedDbPersistence, enableMultiTabIndexedDbPersistence, enableNetwork, enablePersistentCacheIndexAutoCreation, endAt, endBefore, ensureFirestoreConfigured, executeWrite, getAggregateFromServer, getCountFromServer, getDoc, getDocFromCache, getDocFromServer, getDocsFromCache, getDocsFromServer, getPersistentCacheIndexManager, increment, initializeFirestore, limit, limitToLast, loadBundle, memoryEagerGarbageCollector, memoryLocalCache, memoryLruGarbageCollector, namedQuery, onSnapshotsInSync, or, persistentLocalCache, persistentMultipleTabManager, persistentSingleTabManager, queryEqual, refEqual, runTransaction, serverTimestamp, setDoc, setIndexConfiguration, setLogLevel, snapshotEqual, startAfter, startAt, sum, terminate, updateDoc, vector, waitForPendingWrites

// EXTERNAL MODULE: ../../node_modules/@firebase/app/dist/esm/index.esm2017.js
var index_esm2017 = __webpack_require__(85500);
// EXTERNAL MODULE: ../../node_modules/@firebase/component/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(46387);
// EXTERNAL MODULE: ../../node_modules/@firebase/logger/dist/esm/index.esm2017.js
var dist_esm_index_esm2017 = __webpack_require__(68207);
// EXTERNAL MODULE: ../../node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(83395);
;// CONCATENATED MODULE: ../../node_modules/@firebase/webchannel-wrapper/dist/bloom-blob/esm/bloom_blob_es2018.js
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var bloom_blob_es2018 = {};

/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/

var Integer;
var Md5;
(function() {var h;/** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
function k(f,a){function c(){}c.prototype=a.prototype;f.D=a.prototype;f.prototype=new c;f.prototype.constructor=f;f.C=function(d,e,g){for(var b=Array(arguments.length-2),r=2;r<arguments.length;r++)b[r-2]=arguments[r];return a.prototype[e].apply(d,b)};}function l(){this.blockSize=-1;}function m(){this.blockSize=-1;this.blockSize=64;this.g=Array(4);this.B=Array(this.blockSize);this.o=this.h=0;this.s();}k(m,l);m.prototype.s=function(){this.g[0]=1732584193;this.g[1]=4023233417;this.g[2]=2562383102;this.g[3]=271733878;this.o=this.h=0;};
function n(f,a,c){c||(c=0);var d=Array(16);if("string"===typeof a)for(var e=0;16>e;++e)d[e]=a.charCodeAt(c++)|a.charCodeAt(c++)<<8|a.charCodeAt(c++)<<16|a.charCodeAt(c++)<<24;else for(e=0;16>e;++e)d[e]=a[c++]|a[c++]<<8|a[c++]<<16|a[c++]<<24;a=f.g[0];c=f.g[1];e=f.g[2];var g=f.g[3];var b=a+(g^c&(e^g))+d[0]+3614090360&4294967295;a=c+(b<<7&4294967295|b>>>25);b=g+(e^a&(c^e))+d[1]+3905402710&4294967295;g=a+(b<<12&4294967295|b>>>20);b=e+(c^g&(a^c))+d[2]+606105819&4294967295;e=g+(b<<17&4294967295|b>>>15);
b=c+(a^e&(g^a))+d[3]+3250441966&4294967295;c=e+(b<<22&4294967295|b>>>10);b=a+(g^c&(e^g))+d[4]+4118548399&4294967295;a=c+(b<<7&4294967295|b>>>25);b=g+(e^a&(c^e))+d[5]+1200080426&4294967295;g=a+(b<<12&4294967295|b>>>20);b=e+(c^g&(a^c))+d[6]+2821735955&4294967295;e=g+(b<<17&4294967295|b>>>15);b=c+(a^e&(g^a))+d[7]+4249261313&4294967295;c=e+(b<<22&4294967295|b>>>10);b=a+(g^c&(e^g))+d[8]+1770035416&4294967295;a=c+(b<<7&4294967295|b>>>25);b=g+(e^a&(c^e))+d[9]+2336552879&4294967295;g=a+(b<<12&4294967295|
b>>>20);b=e+(c^g&(a^c))+d[10]+4294925233&4294967295;e=g+(b<<17&4294967295|b>>>15);b=c+(a^e&(g^a))+d[11]+2304563134&4294967295;c=e+(b<<22&4294967295|b>>>10);b=a+(g^c&(e^g))+d[12]+1804603682&4294967295;a=c+(b<<7&4294967295|b>>>25);b=g+(e^a&(c^e))+d[13]+4254626195&4294967295;g=a+(b<<12&4294967295|b>>>20);b=e+(c^g&(a^c))+d[14]+2792965006&4294967295;e=g+(b<<17&4294967295|b>>>15);b=c+(a^e&(g^a))+d[15]+1236535329&4294967295;c=e+(b<<22&4294967295|b>>>10);b=a+(e^g&(c^e))+d[1]+4129170786&4294967295;a=c+(b<<
5&4294967295|b>>>27);b=g+(c^e&(a^c))+d[6]+3225465664&4294967295;g=a+(b<<9&4294967295|b>>>23);b=e+(a^c&(g^a))+d[11]+643717713&4294967295;e=g+(b<<14&4294967295|b>>>18);b=c+(g^a&(e^g))+d[0]+3921069994&4294967295;c=e+(b<<20&4294967295|b>>>12);b=a+(e^g&(c^e))+d[5]+3593408605&4294967295;a=c+(b<<5&4294967295|b>>>27);b=g+(c^e&(a^c))+d[10]+38016083&4294967295;g=a+(b<<9&4294967295|b>>>23);b=e+(a^c&(g^a))+d[15]+3634488961&4294967295;e=g+(b<<14&4294967295|b>>>18);b=c+(g^a&(e^g))+d[4]+3889429448&4294967295;c=
e+(b<<20&4294967295|b>>>12);b=a+(e^g&(c^e))+d[9]+568446438&4294967295;a=c+(b<<5&4294967295|b>>>27);b=g+(c^e&(a^c))+d[14]+3275163606&4294967295;g=a+(b<<9&4294967295|b>>>23);b=e+(a^c&(g^a))+d[3]+4107603335&4294967295;e=g+(b<<14&4294967295|b>>>18);b=c+(g^a&(e^g))+d[8]+1163531501&4294967295;c=e+(b<<20&4294967295|b>>>12);b=a+(e^g&(c^e))+d[13]+2850285829&4294967295;a=c+(b<<5&4294967295|b>>>27);b=g+(c^e&(a^c))+d[2]+4243563512&4294967295;g=a+(b<<9&4294967295|b>>>23);b=e+(a^c&(g^a))+d[7]+1735328473&4294967295;
e=g+(b<<14&4294967295|b>>>18);b=c+(g^a&(e^g))+d[12]+2368359562&4294967295;c=e+(b<<20&4294967295|b>>>12);b=a+(c^e^g)+d[5]+4294588738&4294967295;a=c+(b<<4&4294967295|b>>>28);b=g+(a^c^e)+d[8]+2272392833&4294967295;g=a+(b<<11&4294967295|b>>>21);b=e+(g^a^c)+d[11]+1839030562&4294967295;e=g+(b<<16&4294967295|b>>>16);b=c+(e^g^a)+d[14]+4259657740&4294967295;c=e+(b<<23&4294967295|b>>>9);b=a+(c^e^g)+d[1]+2763975236&4294967295;a=c+(b<<4&4294967295|b>>>28);b=g+(a^c^e)+d[4]+1272893353&4294967295;g=a+(b<<11&4294967295|
b>>>21);b=e+(g^a^c)+d[7]+4139469664&4294967295;e=g+(b<<16&4294967295|b>>>16);b=c+(e^g^a)+d[10]+3200236656&4294967295;c=e+(b<<23&4294967295|b>>>9);b=a+(c^e^g)+d[13]+681279174&4294967295;a=c+(b<<4&4294967295|b>>>28);b=g+(a^c^e)+d[0]+3936430074&4294967295;g=a+(b<<11&4294967295|b>>>21);b=e+(g^a^c)+d[3]+3572445317&4294967295;e=g+(b<<16&4294967295|b>>>16);b=c+(e^g^a)+d[6]+76029189&4294967295;c=e+(b<<23&4294967295|b>>>9);b=a+(c^e^g)+d[9]+3654602809&4294967295;a=c+(b<<4&4294967295|b>>>28);b=g+(a^c^e)+d[12]+
3873151461&4294967295;g=a+(b<<11&4294967295|b>>>21);b=e+(g^a^c)+d[15]+530742520&4294967295;e=g+(b<<16&4294967295|b>>>16);b=c+(e^g^a)+d[2]+3299628645&4294967295;c=e+(b<<23&4294967295|b>>>9);b=a+(e^(c|~g))+d[0]+4096336452&4294967295;a=c+(b<<6&4294967295|b>>>26);b=g+(c^(a|~e))+d[7]+1126891415&4294967295;g=a+(b<<10&4294967295|b>>>22);b=e+(a^(g|~c))+d[14]+2878612391&4294967295;e=g+(b<<15&4294967295|b>>>17);b=c+(g^(e|~a))+d[5]+4237533241&4294967295;c=e+(b<<21&4294967295|b>>>11);b=a+(e^(c|~g))+d[12]+1700485571&
4294967295;a=c+(b<<6&4294967295|b>>>26);b=g+(c^(a|~e))+d[3]+2399980690&4294967295;g=a+(b<<10&4294967295|b>>>22);b=e+(a^(g|~c))+d[10]+4293915773&4294967295;e=g+(b<<15&4294967295|b>>>17);b=c+(g^(e|~a))+d[1]+2240044497&4294967295;c=e+(b<<21&4294967295|b>>>11);b=a+(e^(c|~g))+d[8]+1873313359&4294967295;a=c+(b<<6&4294967295|b>>>26);b=g+(c^(a|~e))+d[15]+4264355552&4294967295;g=a+(b<<10&4294967295|b>>>22);b=e+(a^(g|~c))+d[6]+2734768916&4294967295;e=g+(b<<15&4294967295|b>>>17);b=c+(g^(e|~a))+d[13]+1309151649&
4294967295;c=e+(b<<21&4294967295|b>>>11);b=a+(e^(c|~g))+d[4]+4149444226&4294967295;a=c+(b<<6&4294967295|b>>>26);b=g+(c^(a|~e))+d[11]+3174756917&4294967295;g=a+(b<<10&4294967295|b>>>22);b=e+(a^(g|~c))+d[2]+718787259&4294967295;e=g+(b<<15&4294967295|b>>>17);b=c+(g^(e|~a))+d[9]+3951481745&4294967295;f.g[0]=f.g[0]+a&4294967295;f.g[1]=f.g[1]+(e+(b<<21&4294967295|b>>>11))&4294967295;f.g[2]=f.g[2]+e&4294967295;f.g[3]=f.g[3]+g&4294967295;}
m.prototype.u=function(f,a){void 0===a&&(a=f.length);for(var c=a-this.blockSize,d=this.B,e=this.h,g=0;g<a;){if(0==e)for(;g<=c;)n(this,f,g),g+=this.blockSize;if("string"===typeof f)for(;g<a;){if(d[e++]=f.charCodeAt(g++),e==this.blockSize){n(this,d);e=0;break}}else for(;g<a;)if(d[e++]=f[g++],e==this.blockSize){n(this,d);e=0;break}}this.h=e;this.o+=a;};
m.prototype.v=function(){var f=Array((56>this.h?this.blockSize:2*this.blockSize)-this.h);f[0]=128;for(var a=1;a<f.length-8;++a)f[a]=0;var c=8*this.o;for(a=f.length-8;a<f.length;++a)f[a]=c&255,c/=256;this.u(f);f=Array(16);for(a=c=0;4>a;++a)for(var d=0;32>d;d+=8)f[c++]=this.g[a]>>>d&255;return f};function p(f,a){var c=q;return Object.prototype.hasOwnProperty.call(c,f)?c[f]:c[f]=a(f)}function t(f,a){this.h=a;for(var c=[],d=!0,e=f.length-1;0<=e;e--){var g=f[e]|0;d&&g==a||(c[e]=g,d=!1);}this.g=c;}var q={};function u(f){return -128<=f&&128>f?p(f,function(a){return new t([a|0],0>a?-1:0)}):new t([f|0],0>f?-1:0)}function v(f){if(isNaN(f)||!isFinite(f))return w;if(0>f)return x(v(-f));for(var a=[],c=1,d=0;f>=c;d++)a[d]=f/c|0,c*=4294967296;return new t(a,0)}
function y(f,a){if(0==f.length)throw Error("number format error: empty string");a=a||10;if(2>a||36<a)throw Error("radix out of range: "+a);if("-"==f.charAt(0))return x(y(f.substring(1),a));if(0<=f.indexOf("-"))throw Error('number format error: interior "-" character');for(var c=v(Math.pow(a,8)),d=w,e=0;e<f.length;e+=8){var g=Math.min(8,f.length-e),b=parseInt(f.substring(e,e+g),a);8>g?(g=v(Math.pow(a,g)),d=d.j(g).add(v(b))):(d=d.j(c),d=d.add(v(b)));}return d}var w=u(0),z=u(1),A=u(16777216);h=t.prototype;
h.m=function(){if(B(this))return -x(this).m();for(var f=0,a=1,c=0;c<this.g.length;c++){var d=this.i(c);f+=(0<=d?d:4294967296+d)*a;a*=4294967296;}return f};h.toString=function(f){f=f||10;if(2>f||36<f)throw Error("radix out of range: "+f);if(C(this))return "0";if(B(this))return "-"+x(this).toString(f);for(var a=v(Math.pow(f,6)),c=this,d="";;){var e=D(c,a).g;c=F(c,e.j(a));var g=((0<c.g.length?c.g[0]:c.h)>>>0).toString(f);c=e;if(C(c))return g+d;for(;6>g.length;)g="0"+g;d=g+d;}};
h.i=function(f){return 0>f?0:f<this.g.length?this.g[f]:this.h};function C(f){if(0!=f.h)return !1;for(var a=0;a<f.g.length;a++)if(0!=f.g[a])return !1;return !0}function B(f){return -1==f.h}h.l=function(f){f=F(this,f);return B(f)?-1:C(f)?0:1};function x(f){for(var a=f.g.length,c=[],d=0;d<a;d++)c[d]=~f.g[d];return (new t(c,~f.h)).add(z)}h.abs=function(){return B(this)?x(this):this};
h.add=function(f){for(var a=Math.max(this.g.length,f.g.length),c=[],d=0,e=0;e<=a;e++){var g=d+(this.i(e)&65535)+(f.i(e)&65535),b=(g>>>16)+(this.i(e)>>>16)+(f.i(e)>>>16);d=b>>>16;g&=65535;b&=65535;c[e]=b<<16|g;}return new t(c,c[c.length-1]&-2147483648?-1:0)};function F(f,a){return f.add(x(a))}
h.j=function(f){if(C(this)||C(f))return w;if(B(this))return B(f)?x(this).j(x(f)):x(x(this).j(f));if(B(f))return x(this.j(x(f)));if(0>this.l(A)&&0>f.l(A))return v(this.m()*f.m());for(var a=this.g.length+f.g.length,c=[],d=0;d<2*a;d++)c[d]=0;for(d=0;d<this.g.length;d++)for(var e=0;e<f.g.length;e++){var g=this.i(d)>>>16,b=this.i(d)&65535,r=f.i(e)>>>16,E=f.i(e)&65535;c[2*d+2*e]+=b*E;G(c,2*d+2*e);c[2*d+2*e+1]+=g*E;G(c,2*d+2*e+1);c[2*d+2*e+1]+=b*r;G(c,2*d+2*e+1);c[2*d+2*e+2]+=g*r;G(c,2*d+2*e+2);}for(d=0;d<
a;d++)c[d]=c[2*d+1]<<16|c[2*d];for(d=a;d<2*a;d++)c[d]=0;return new t(c,0)};function G(f,a){for(;(f[a]&65535)!=f[a];)f[a+1]+=f[a]>>>16,f[a]&=65535,a++;}function H(f,a){this.g=f;this.h=a;}
function D(f,a){if(C(a))throw Error("division by zero");if(C(f))return new H(w,w);if(B(f))return a=D(x(f),a),new H(x(a.g),x(a.h));if(B(a))return a=D(f,x(a)),new H(x(a.g),a.h);if(30<f.g.length){if(B(f)||B(a))throw Error("slowDivide_ only works with positive integers.");for(var c=z,d=a;0>=d.l(f);)c=I(c),d=I(d);var e=J(c,1),g=J(d,1);d=J(d,2);for(c=J(c,2);!C(d);){var b=g.add(d);0>=b.l(f)&&(e=e.add(c),g=b);d=J(d,1);c=J(c,1);}a=F(f,e.j(a));return new H(e,a)}for(e=w;0<=f.l(a);){c=Math.max(1,Math.floor(f.m()/
a.m()));d=Math.ceil(Math.log(c)/Math.LN2);d=48>=d?1:Math.pow(2,d-48);g=v(c);for(b=g.j(a);B(b)||0<b.l(f);)c-=d,g=v(c),b=g.j(a);C(g)&&(g=z);e=e.add(g);f=F(f,b);}return new H(e,f)}h.A=function(f){return D(this,f).h};h.and=function(f){for(var a=Math.max(this.g.length,f.g.length),c=[],d=0;d<a;d++)c[d]=this.i(d)&f.i(d);return new t(c,this.h&f.h)};h.or=function(f){for(var a=Math.max(this.g.length,f.g.length),c=[],d=0;d<a;d++)c[d]=this.i(d)|f.i(d);return new t(c,this.h|f.h)};
h.xor=function(f){for(var a=Math.max(this.g.length,f.g.length),c=[],d=0;d<a;d++)c[d]=this.i(d)^f.i(d);return new t(c,this.h^f.h)};function I(f){for(var a=f.g.length+1,c=[],d=0;d<a;d++)c[d]=f.i(d)<<1|f.i(d-1)>>>31;return new t(c,f.h)}function J(f,a){var c=a>>5;a%=32;for(var d=f.g.length-c,e=[],g=0;g<d;g++)e[g]=0<a?f.i(g+c)>>>a|f.i(g+c+1)<<32-a:f.i(g+c);return new t(e,f.h)}m.prototype.digest=m.prototype.v;m.prototype.reset=m.prototype.s;m.prototype.update=m.prototype.u;Md5 = bloom_blob_es2018.Md5=m;t.prototype.add=t.prototype.add;t.prototype.multiply=t.prototype.j;t.prototype.modulo=t.prototype.A;t.prototype.compare=t.prototype.l;t.prototype.toNumber=t.prototype.m;t.prototype.toString=t.prototype.toString;t.prototype.getBits=t.prototype.i;t.fromNumber=v;t.fromString=y;Integer = bloom_blob_es2018.Integer=t;}).apply( typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self  : typeof window !== 'undefined' ? window  : {});


//# sourceMappingURL=bloom_blob_es2018.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/webchannel-wrapper/dist/webchannel-blob/esm/webchannel_blob_es2018.js
var webchannel_blob_es2018_commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var webchannel_blob_es2018 = {};

/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/

var XhrIo;
var FetchXmlHttpFactory;
var WebChannel;
var EventType;
var ErrorCode;
var Stat;
var Event;
var getStatEventTarget;
var createWebChannelTransport;
(function() {var h,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};function ba(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof webchannel_blob_es2018_commonjsGlobal&&webchannel_blob_es2018_commonjsGlobal];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var ca=ba(this);
function da(a,b){if(b)a:{var c=ca;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e];}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b});}}function ea(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return {value:b(f,a[f]),done:!1}}d=!0;return {done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}
da("Array.prototype.values",function(a){return a?a:function(){return ea(this,function(b,c){return c})}});/** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/
var fa=fa||{},k=this||self;function ha(a){var b=typeof a;b="object"!=b?b:a?Array.isArray(a)?"array":b:"null";return "array"==b||"object"==b&&"number"==typeof a.length}function n(a){var b=typeof a;return "object"==b&&null!=a||"function"==b}function ia(a,b,c){return a.call.apply(a.bind,arguments)}
function ja(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return p.apply(null,arguments)}
function ka(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}function r(a,b){function c(){}c.prototype=b.prototype;a.aa=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Qb=function(d,e,f){for(var g=Array(arguments.length-2),m=2;m<arguments.length;m++)g[m-2]=arguments[m];return b.prototype[e].apply(d,g)};}function la(a){const b=a.length;if(0<b){const c=Array(b);for(let d=0;d<b;d++)c[d]=a[d];return c}return []}function ma(a,b){for(let c=1;c<arguments.length;c++){const d=arguments[c];if(ha(d)){const e=a.length||0,f=d.length||0;a.length=e+f;for(let g=0;g<f;g++)a[e+g]=d[g];}else a.push(d);}}class na{constructor(a,b){this.i=a;this.j=b;this.h=0;this.g=null;}get(){let a;0<this.h?(this.h--,a=this.g,this.g=a.next,a.next=null):a=this.i();return a}}function t(a){return /^[\s\xa0]*$/.test(a)}function u(){var a=k.navigator;return a&&(a=a.userAgent)?a:""}function oa(a){oa[" "](a);return a}oa[" "]=function(){};var pa=-1!=u().indexOf("Gecko")&&!(-1!=u().toLowerCase().indexOf("webkit")&&-1==u().indexOf("Edge"))&&!(-1!=u().indexOf("Trident")||-1!=u().indexOf("MSIE"))&&-1==u().indexOf("Edge");function qa(a,b,c){for(const d in a)b.call(c,a[d],d,a);}function ra(a,b){for(const c in a)b.call(void 0,a[c],c,a);}function sa(a){const b={};for(const c in a)b[c]=a[c];return b}const ta="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ua(a,b){let c,d;for(let e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(let f=0;f<ta.length;f++)c=ta[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c]);}}function va(a){var b=1;a=a.split(":");const c=[];for(;0<b&&a.length;)c.push(a.shift()),b--;a.length&&c.push(a.join(":"));return c}function wa(a){k.setTimeout(()=>{throw a;},0);}function xa(){var a=za;let b=null;a.g&&(b=a.g,a.g=a.g.next,a.g||(a.h=null),b.next=null);return b}class Aa{constructor(){this.h=this.g=null;}add(a,b){const c=Ba.get();c.set(a,b);this.h?this.h.next=c:this.g=c;this.h=c;}}var Ba=new na(()=>new Ca,a=>a.reset());class Ca{constructor(){this.next=this.g=this.h=null;}set(a,b){this.h=a;this.g=b;this.next=null;}reset(){this.next=this.g=this.h=null;}}let x,y=!1,za=new Aa,Ea=()=>{const a=k.Promise.resolve(void 0);x=()=>{a.then(Da);};};var Da=()=>{for(var a;a=xa();){try{a.h.call(a.g);}catch(c){wa(c);}var b=Ba;b.j(a);100>b.h&&(b.h++,a.next=b.g,b.g=a);}y=!1;};function z(){this.s=this.s;this.C=this.C;}z.prototype.s=!1;z.prototype.ma=function(){this.s||(this.s=!0,this.N());};z.prototype.N=function(){if(this.C)for(;this.C.length;)this.C.shift()();};function A(a,b){this.type=a;this.g=this.target=b;this.defaultPrevented=!1;}A.prototype.h=function(){this.defaultPrevented=!0;};var Fa=function(){if(!k.addEventListener||!Object.defineProperty)return !1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0;}});try{const c=()=>{};k.addEventListener("test",c,b);k.removeEventListener("test",c,b);}catch(c){}return a}();function C(a,b){A.call(this,a?a.type:"");this.relatedTarget=this.g=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.state=null;this.pointerId=0;this.pointerType="";this.i=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.g=b;if(b=a.relatedTarget){if(pa){a:{try{oa(b.nodeName);var e=!0;break a}catch(f){}e=
!1;}e||(b=null);}}else "mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=
a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType="string"===typeof a.pointerType?a.pointerType:Ga[a.pointerType]||"";this.state=a.state;this.i=a;a.defaultPrevented&&C.aa.h.call(this);}}r(C,A);var Ga={2:"touch",3:"pen",4:"mouse"};C.prototype.h=function(){C.aa.h.call(this);var a=this.i;a.preventDefault?a.preventDefault():a.returnValue=!1;};var D="closure_listenable_"+(1E6*Math.random()|0);var Ha=0;function Ia(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.ha=e;this.key=++Ha;this.da=this.fa=!1;}function Ja(a){a.da=!0;a.listener=null;a.proxy=null;a.src=null;a.ha=null;}function Ka(a){this.src=a;this.g={};this.h=0;}Ka.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.g[f];a||(a=this.g[f]=[],this.h++);var g=La(a,b,d,e);-1<g?(b=a[g],c||(b.fa=!1)):(b=new Ia(b,this.src,f,!!d,e),b.fa=c,a.push(b));return b};function Ma(a,b){var c=b.type;if(c in a.g){var d=a.g[c],e=Array.prototype.indexOf.call(d,b,void 0),f;(f=0<=e)&&Array.prototype.splice.call(d,e,1);f&&(Ja(b),0==a.g[c].length&&(delete a.g[c],a.h--));}}
function La(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.da&&f.listener==b&&f.capture==!!c&&f.ha==d)return e}return -1}var Na="closure_lm_"+(1E6*Math.random()|0),Oa={};function Qa(a,b,c,d,e){if(d&&d.once)return Ra(a,b,c,d,e);if(Array.isArray(b)){for(var f=0;f<b.length;f++)Qa(a,b[f],c,d,e);return null}c=Sa(c);return a&&a[D]?a.K(b,c,n(d)?!!d.capture:!!d,e):Ta(a,b,c,!1,d,e)}
function Ta(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=n(e)?!!e.capture:!!e,m=Ua(a);m||(a[Na]=m=new Ka(a));c=m.add(b,c,d,g,f);if(c.proxy)return c;d=Va();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Fa||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(Wa(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");return c}
function Va(){function a(c){return b.call(a.src,a.listener,c)}const b=Xa;return a}function Ra(a,b,c,d,e){if(Array.isArray(b)){for(var f=0;f<b.length;f++)Ra(a,b[f],c,d,e);return null}c=Sa(c);return a&&a[D]?a.L(b,c,n(d)?!!d.capture:!!d,e):Ta(a,b,c,!0,d,e)}
function Ya(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)Ya(a,b[f],c,d,e);else (d=n(d)?!!d.capture:!!d,c=Sa(c),a&&a[D])?(a=a.i,b=String(b).toString(),b in a.g&&(f=a.g[b],c=La(f,c,d,e),-1<c&&(Ja(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.g[b],a.h--)))):a&&(a=Ua(a))&&(b=a.g[b.toString()],a=-1,b&&(a=La(b,c,d,e)),(c=-1<a?b[a]:null)&&Za(c));}
function Za(a){if("number"!==typeof a&&a&&!a.da){var b=a.src;if(b&&b[D])Ma(b.i,a);else {var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(Wa(c),d):b.addListener&&b.removeListener&&b.removeListener(d);(c=Ua(b))?(Ma(c,a),0==c.h&&(c.src=null,b[Na]=null)):Ja(a);}}}function Wa(a){return a in Oa?Oa[a]:Oa[a]="on"+a}function Xa(a,b){if(a.da)a=!0;else {b=new C(b,this);var c=a.listener,d=a.ha||a.src;a.fa&&Za(a);a=c.call(d,b);}return a}
function Ua(a){a=a[Na];return a instanceof Ka?a:null}var $a="__closure_events_fn_"+(1E9*Math.random()>>>0);function Sa(a){if("function"===typeof a)return a;a[$a]||(a[$a]=function(b){return a.handleEvent(b)});return a[$a]}function E(){z.call(this);this.i=new Ka(this);this.M=this;this.F=null;}r(E,z);E.prototype[D]=!0;E.prototype.removeEventListener=function(a,b,c,d){Ya(this,a,b,c,d);};
function F(a,b){var c,d=a.F;if(d)for(c=[];d;d=d.F)c.push(d);a=a.M;d=b.type||b;if("string"===typeof b)b=new A(b,a);else if(b instanceof A)b.target=b.target||a;else {var e=b;b=new A(d,a);ua(b,e);}e=!0;if(c)for(var f=c.length-1;0<=f;f--){var g=b.g=c[f];e=ab(g,d,!0,b)&&e;}g=b.g=a;e=ab(g,d,!0,b)&&e;e=ab(g,d,!1,b)&&e;if(c)for(f=0;f<c.length;f++)g=b.g=c[f],e=ab(g,d,!1,b)&&e;}
E.prototype.N=function(){E.aa.N.call(this);if(this.i){var a=this.i,c;for(c in a.g){for(var d=a.g[c],e=0;e<d.length;e++)Ja(d[e]);delete a.g[c];a.h--;}}this.F=null;};E.prototype.K=function(a,b,c,d){return this.i.add(String(a),b,!1,c,d)};E.prototype.L=function(a,b,c,d){return this.i.add(String(a),b,!0,c,d)};
function ab(a,b,c,d){b=a.i.g[String(b)];if(!b)return !0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.da&&g.capture==c){var m=g.listener,q=g.ha||g.src;g.fa&&Ma(a.i,g);e=!1!==m.call(q,d)&&e;}}return e&&!d.defaultPrevented}function bb(a,b,c){if("function"===typeof a)c&&(a=p(a,c));else if(a&&"function"==typeof a.handleEvent)a=p(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function cb(a){a.g=bb(()=>{a.g=null;a.i&&(a.i=!1,cb(a));},a.l);const b=a.h;a.h=null;a.m.apply(null,b);}class eb extends z{constructor(a,b){super();this.m=a;this.l=b;this.h=null;this.i=!1;this.g=null;}j(a){this.h=arguments;this.g?this.i=!0:cb(this);}N(){super.N();this.g&&(k.clearTimeout(this.g),this.g=null,this.i=!1,this.h=null);}}function G(a){z.call(this);this.h=a;this.g={};}r(G,z);var fb=[];function gb(a){qa(a.g,function(b,c){this.g.hasOwnProperty(c)&&Za(b);},a);a.g={};}G.prototype.N=function(){G.aa.N.call(this);gb(this);};G.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};var hb=k.JSON.stringify;var ib=k.JSON.parse;var jb=class{stringify(a){return k.JSON.stringify(a,void 0)}parse(a){return k.JSON.parse(a,void 0)}};function kb(){}kb.prototype.h=null;function lb(a){return a.h||(a.h=a.i())}function mb(){}var H={OPEN:"a",kb:"b",Ja:"c",wb:"d"};function nb(){A.call(this,"d");}r(nb,A);function ob(){A.call(this,"c");}r(ob,A);var I={},pb=null;function qb(){return pb=pb||new E}I.La="serverreachability";function rb(a){A.call(this,I.La,a);}r(rb,A);function J(a){const b=qb();F(b,new rb(b));}I.STAT_EVENT="statevent";function sb(a,b){A.call(this,I.STAT_EVENT,a);this.stat=b;}r(sb,A);function K(a){const b=qb();F(b,new sb(b,a));}I.Ma="timingevent";function tb(a,b){A.call(this,I.Ma,a);this.size=b;}r(tb,A);
function ub(a,b){if("function"!==typeof a)throw Error("Fn must not be null and must be a function");return k.setTimeout(function(){a();},b)}function vb(){this.g=!0;}vb.prototype.xa=function(){this.g=!1;};function wb(a,b,c,d,e,f){a.info(function(){if(a.g)if(f){var g="";for(var m=f.split("&"),q=0;q<m.length;q++){var l=m[q].split("=");if(1<l.length){var v=l[0];l=l[1];var w=v.split("_");g=2<=w.length&&"type"==w[1]?g+(v+"="+l+"&"):g+(v+"=redacted&");}}}else g=null;else g=f;return "XMLHTTP REQ ("+d+") [attempt "+e+"]: "+b+"\n"+c+"\n"+g});}
function xb(a,b,c,d,e,f,g){a.info(function(){return "XMLHTTP RESP ("+d+") [ attempt "+e+"]: "+b+"\n"+c+"\n"+f+" "+g});}function L(a,b,c,d){a.info(function(){return "XMLHTTP TEXT ("+b+"): "+yb(a,c)+(d?" "+d:"")});}function zb(a,b){a.info(function(){return "TIMEOUT: "+b});}vb.prototype.info=function(){};
function yb(a,b){if(!a.g)return b;if(!b)return null;try{var c=JSON.parse(b);if(c)for(a=0;a<c.length;a++)if(Array.isArray(c[a])){var d=c[a];if(!(2>d.length)){var e=d[1];if(Array.isArray(e)&&!(1>e.length)){var f=e[0];if("noop"!=f&&"stop"!=f&&"close"!=f)for(var g=1;g<e.length;g++)e[g]="";}}}return hb(c)}catch(m){return b}}var Ab={NO_ERROR:0,gb:1,tb:2,sb:3,nb:4,rb:5,ub:6,Ia:7,TIMEOUT:8,xb:9};var Bb={lb:"complete",Hb:"success",Ja:"error",Ia:"abort",zb:"ready",Ab:"readystatechange",TIMEOUT:"timeout",vb:"incrementaldata",yb:"progress",ob:"downloadprogress",Pb:"uploadprogress"};var Cb;function Db(){}r(Db,kb);Db.prototype.g=function(){return new XMLHttpRequest};Db.prototype.i=function(){return {}};Cb=new Db;function M(a,b,c,d){this.j=a;this.i=b;this.l=c;this.R=d||1;this.U=new G(this);this.I=45E3;this.H=null;this.o=!1;this.m=this.A=this.v=this.L=this.F=this.S=this.B=null;this.D=[];this.g=null;this.C=0;this.s=this.u=null;this.X=-1;this.J=!1;this.O=0;this.M=null;this.W=this.K=this.T=this.P=!1;this.h=new Eb;}function Eb(){this.i=null;this.g="";this.h=!1;}var Fb={},Gb={};function Hb(a,b,c){a.L=1;a.v=Ib(N(b));a.m=c;a.P=!0;Jb(a,null);}
function Jb(a,b){a.F=Date.now();Kb(a);a.A=N(a.v);var c=a.A,d=a.R;Array.isArray(d)||(d=[String(d)]);Lb(c.i,"t",d);a.C=0;c=a.j.J;a.h=new Eb;a.g=Mb(a.j,c?b:null,!a.m);0<a.O&&(a.M=new eb(p(a.Y,a,a.g),a.O));b=a.U;c=a.g;d=a.ca;var e="readystatechange";Array.isArray(e)||(e&&(fb[0]=e.toString()),e=fb);for(var f=0;f<e.length;f++){var g=Qa(c,e[f],d||b.handleEvent,!1,b.h||b);if(!g)break;b.g[g.key]=g;}b=a.H?sa(a.H):{};a.m?(a.u||(a.u="POST"),b["Content-Type"]="application/x-www-form-urlencoded",a.g.ea(a.A,a.u,
a.m,b)):(a.u="GET",a.g.ea(a.A,a.u,null,b));J();wb(a.i,a.u,a.A,a.l,a.R,a.m);}M.prototype.ca=function(a){a=a.target;const b=this.M;b&&3==P(a)?b.j():this.Y(a);};
M.prototype.Y=function(a){try{if(a==this.g)a:{const w=P(this.g);var b=this.g.Ba();const O=this.g.Z();if(!(3>w)&&(3!=w||this.g&&(this.h.h||this.g.oa()||Nb(this.g)))){this.J||4!=w||7==b||(8==b||0>=O?J(3):J(2));Ob(this);var c=this.g.Z();this.X=c;b:if(Pb(this)){var d=Nb(this.g);a="";var e=d.length,f=4==P(this.g);if(!this.h.i){if("undefined"===typeof TextDecoder){Q(this);Qb(this);var g="";break b}this.h.i=new k.TextDecoder;}for(b=0;b<e;b++)this.h.h=!0,a+=this.h.i.decode(d[b],{stream:!(f&&b==e-1)});d.length=
0;this.h.g+=a;this.C=0;g=this.h.g;}else g=this.g.oa();this.o=200==c;xb(this.i,this.u,this.A,this.l,this.R,w,c);if(this.o){if(this.T&&!this.K){b:{if(this.g){var m,q=this.g;if((m=q.g?q.g.getResponseHeader("X-HTTP-Initial-Response"):null)&&!t(m)){var l=m;break b}}l=null;}if(c=l)L(this.i,this.l,c,"Initial handshake response via X-HTTP-Initial-Response"),this.K=!0,Rb(this,c);else {this.o=!1;this.s=3;K(12);Q(this);Qb(this);break a}}if(this.P){c=!0;let B;for(;!this.J&&this.C<g.length;)if(B=Sb(this,g),B==Gb){4==
w&&(this.s=4,K(14),c=!1);L(this.i,this.l,null,"[Incomplete Response]");break}else if(B==Fb){this.s=4;K(15);L(this.i,this.l,g,"[Invalid Chunk]");c=!1;break}else L(this.i,this.l,B,null),Rb(this,B);Pb(this)&&0!=this.C&&(this.h.g=this.h.g.slice(this.C),this.C=0);4!=w||0!=g.length||this.h.h||(this.s=1,K(16),c=!1);this.o=this.o&&c;if(!c)L(this.i,this.l,g,"[Invalid Chunked Response]"),Q(this),Qb(this);else if(0<g.length&&!this.W){this.W=!0;var v=this.j;v.g==this&&v.ba&&!v.M&&(v.j.info("Great, no buffering proxy detected. Bytes received: "+
g.length),Tb(v),v.M=!0,K(11));}}else L(this.i,this.l,g,null),Rb(this,g);4==w&&Q(this);this.o&&!this.J&&(4==w?Ub(this.j,this):(this.o=!1,Kb(this)));}else Vb(this.g),400==c&&0<g.indexOf("Unknown SID")?(this.s=3,K(12)):(this.s=0,K(13)),Q(this),Qb(this);}}}catch(w){}finally{}};function Pb(a){return a.g?"GET"==a.u&&2!=a.L&&a.j.Ca:!1}
function Sb(a,b){var c=a.C,d=b.indexOf("\n",c);if(-1==d)return Gb;c=Number(b.substring(c,d));if(isNaN(c))return Fb;d+=1;if(d+c>b.length)return Gb;b=b.slice(d,d+c);a.C=d+c;return b}M.prototype.cancel=function(){this.J=!0;Q(this);};function Kb(a){a.S=Date.now()+a.I;Wb(a,a.I);}function Wb(a,b){if(null!=a.B)throw Error("WatchDog timer not null");a.B=ub(p(a.ba,a),b);}function Ob(a){a.B&&(k.clearTimeout(a.B),a.B=null);}
M.prototype.ba=function(){this.B=null;const a=Date.now();0<=a-this.S?(zb(this.i,this.A),2!=this.L&&(J(),K(17)),Q(this),this.s=2,Qb(this)):Wb(this,this.S-a);};function Qb(a){0==a.j.G||a.J||Ub(a.j,a);}function Q(a){Ob(a);var b=a.M;b&&"function"==typeof b.ma&&b.ma();a.M=null;gb(a.U);a.g&&(b=a.g,a.g=null,b.abort(),b.ma());}
function Rb(a,b){try{var c=a.j;if(0!=c.G&&(c.g==a||Xb(c.h,a)))if(!a.K&&Xb(c.h,a)&&3==c.G){try{var d=c.Da.g.parse(b);}catch(l){d=null;}if(Array.isArray(d)&&3==d.length){var e=d;if(0==e[0])a:{if(!c.u){if(c.g)if(c.g.F+3E3<a.F)Yb(c),Zb(c);else break a;$b(c);K(18);}}else c.za=e[1],0<c.za-c.T&&37500>e[2]&&c.F&&0==c.v&&!c.C&&(c.C=ub(p(c.Za,c),6E3));if(1>=ac(c.h)&&c.ca){try{c.ca();}catch(l){}c.ca=void 0;}}else R(c,11);}else if((a.K||c.g==a)&&Yb(c),!t(b))for(e=c.Da.g.parse(b),b=0;b<e.length;b++){let l=e[b];c.T=
l[0];l=l[1];if(2==c.G)if("c"==l[0]){c.K=l[1];c.ia=l[2];const v=l[3];null!=v&&(c.la=v,c.j.info("VER="+c.la));const w=l[4];null!=w&&(c.Aa=w,c.j.info("SVER="+c.Aa));const O=l[5];null!=O&&"number"===typeof O&&0<O&&(d=1.5*O,c.L=d,c.j.info("backChannelRequestTimeoutMs_="+d));d=c;const B=a.g;if(B){const ya=B.g?B.g.getResponseHeader("X-Client-Wire-Protocol"):null;if(ya){var f=d.h;f.g||-1==ya.indexOf("spdy")&&-1==ya.indexOf("quic")&&-1==ya.indexOf("h2")||(f.j=f.l,f.g=new Set,f.h&&(bc(f,f.h),f.h=null));}if(d.D){const db=
B.g?B.g.getResponseHeader("X-HTTP-Session-Id"):null;db&&(d.ya=db,S(d.I,d.D,db));}}c.G=3;c.l&&c.l.ua();c.ba&&(c.R=Date.now()-a.F,c.j.info("Handshake RTT: "+c.R+"ms"));d=c;var g=a;d.qa=cc(d,d.J?d.ia:null,d.W);if(g.K){dc(d.h,g);var m=g,q=d.L;q&&(m.I=q);m.B&&(Ob(m),Kb(m));d.g=g;}else ec(d);0<c.i.length&&fc(c);}else "stop"!=l[0]&&"close"!=l[0]||R(c,7);else 3==c.G&&("stop"==l[0]||"close"==l[0]?"stop"==l[0]?R(c,7):gc(c):"noop"!=l[0]&&c.l&&c.l.ta(l),c.v=0);}J(4);}catch(l){}}var hc=class{constructor(a,b){this.g=a;this.map=b;}};function ic(a){this.l=a||10;k.PerformanceNavigationTiming?(a=k.performance.getEntriesByType("navigation"),a=0<a.length&&("hq"==a[0].nextHopProtocol||"h2"==a[0].nextHopProtocol)):a=!!(k.chrome&&k.chrome.loadTimes&&k.chrome.loadTimes()&&k.chrome.loadTimes().wasFetchedViaSpdy);this.j=a?this.l:1;this.g=null;1<this.j&&(this.g=new Set);this.h=null;this.i=[];}function jc(a){return a.h?!0:a.g?a.g.size>=a.j:!1}function ac(a){return a.h?1:a.g?a.g.size:0}function Xb(a,b){return a.h?a.h==b:a.g?a.g.has(b):!1}
function bc(a,b){a.g?a.g.add(b):a.h=b;}function dc(a,b){a.h&&a.h==b?a.h=null:a.g&&a.g.has(b)&&a.g.delete(b);}ic.prototype.cancel=function(){this.i=kc(this);if(this.h)this.h.cancel(),this.h=null;else if(this.g&&0!==this.g.size){for(const a of this.g.values())a.cancel();this.g.clear();}};function kc(a){if(null!=a.h)return a.i.concat(a.h.D);if(null!=a.g&&0!==a.g.size){let b=a.i;for(const c of a.g.values())b=b.concat(c.D);return b}return la(a.i)}function lc(a){if(a.V&&"function"==typeof a.V)return a.V();if("undefined"!==typeof Map&&a instanceof Map||"undefined"!==typeof Set&&a instanceof Set)return Array.from(a.values());if("string"===typeof a)return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}
function mc(a){if(a.na&&"function"==typeof a.na)return a.na();if(!a.V||"function"!=typeof a.V){if("undefined"!==typeof Map&&a instanceof Map)return Array.from(a.keys());if(!("undefined"!==typeof Set&&a instanceof Set)){if(ha(a)||"string"===typeof a){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(const d in a)b[c++]=d;return b}}}
function nc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||"string"===typeof a)Array.prototype.forEach.call(a,b,void 0);else for(var c=mc(a),d=lc(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a);}var oc=RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");function pc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1);}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"");}}}function T(a){this.g=this.o=this.j="";this.s=null;this.m=this.l="";this.h=!1;if(a instanceof T){this.h=a.h;qc(this,a.j);this.o=a.o;this.g=a.g;rc(this,a.s);this.l=a.l;var b=a.i;var c=new sc;c.i=b.i;b.g&&(c.g=new Map(b.g),c.h=b.h);tc(this,c);this.m=a.m;}else a&&(b=String(a).match(oc))?(this.h=!1,qc(this,b[1]||"",!0),this.o=uc(b[2]||""),this.g=uc(b[3]||"",!0),rc(this,b[4]),this.l=uc(b[5]||"",!0),tc(this,b[6]||"",!0),this.m=uc(b[7]||"")):(this.h=!1,this.i=new sc(null,this.h));}
T.prototype.toString=function(){var a=[],b=this.j;b&&a.push(vc(b,wc,!0),":");var c=this.g;if(c||"file"==b)a.push("//"),(b=this.o)&&a.push(vc(b,wc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.s,null!=c&&a.push(":",String(c));if(c=this.l)this.g&&"/"!=c.charAt(0)&&a.push("/"),a.push(vc(c,"/"==c.charAt(0)?xc:yc,!0));(c=this.i.toString())&&a.push("?",c);(c=this.m)&&a.push("#",vc(c,zc));return a.join("")};function N(a){return new T(a)}
function qc(a,b,c){a.j=c?uc(b,!0):b;a.j&&(a.j=a.j.replace(/:$/,""));}function rc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.s=b;}else a.s=null;}function tc(a,b,c){b instanceof sc?(a.i=b,Ac(a.i,a.h)):(c||(b=vc(b,Bc)),a.i=new sc(b,a.h));}function S(a,b,c){a.i.set(b,c);}function Ib(a){S(a,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^Date.now()).toString(36));return a}
function uc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function vc(a,b,c){return "string"===typeof a?(a=encodeURI(a).replace(b,Cc),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Cc(a){a=a.charCodeAt(0);return "%"+(a>>4&15).toString(16)+(a&15).toString(16)}var wc=/[#\/\?@]/g,yc=/[#\?:]/g,xc=/[#\?]/g,Bc=/[#\?@]/g,zc=/#/g;function sc(a,b){this.h=this.g=null;this.i=a||null;this.j=!!b;}
function U(a){a.g||(a.g=new Map,a.h=0,a.i&&pc(a.i,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c);}));}h=sc.prototype;h.add=function(a,b){U(this);this.i=null;a=V(this,a);var c=this.g.get(a);c||this.g.set(a,c=[]);c.push(b);this.h+=1;return this};function Dc(a,b){U(a);b=V(a,b);a.g.has(b)&&(a.i=null,a.h-=a.g.get(b).length,a.g.delete(b));}function Ec(a,b){U(a);b=V(a,b);return a.g.has(b)}
h.forEach=function(a,b){U(this);this.g.forEach(function(c,d){c.forEach(function(e){a.call(b,e,d,this);},this);},this);};h.na=function(){U(this);const a=Array.from(this.g.values()),b=Array.from(this.g.keys()),c=[];for(let d=0;d<b.length;d++){const e=a[d];for(let f=0;f<e.length;f++)c.push(b[d]);}return c};h.V=function(a){U(this);let b=[];if("string"===typeof a)Ec(this,a)&&(b=b.concat(this.g.get(V(this,a))));else {a=Array.from(this.g.values());for(let c=0;c<a.length;c++)b=b.concat(a[c]);}return b};
h.set=function(a,b){U(this);this.i=null;a=V(this,a);Ec(this,a)&&(this.h-=this.g.get(a).length);this.g.set(a,[b]);this.h+=1;return this};h.get=function(a,b){if(!a)return b;a=this.V(a);return 0<a.length?String(a[0]):b};function Lb(a,b,c){Dc(a,b);0<c.length&&(a.i=null,a.g.set(V(a,b),la(c)),a.h+=c.length);}
h.toString=function(){if(this.i)return this.i;if(!this.g)return "";const a=[],b=Array.from(this.g.keys());for(var c=0;c<b.length;c++){var d=b[c];const f=encodeURIComponent(String(d)),g=this.V(d);for(d=0;d<g.length;d++){var e=f;""!==g[d]&&(e+="="+encodeURIComponent(String(g[d])));a.push(e);}}return this.i=a.join("&")};function V(a,b){b=String(b);a.j&&(b=b.toLowerCase());return b}
function Ac(a,b){b&&!a.j&&(U(a),a.i=null,a.g.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Dc(this,d),Lb(this,e,c));},a));a.j=b;}function Fc(a,b){const c=new vb;if(k.Image){const d=new Image;d.onload=ka(W,c,"TestLoadImage: loaded",!0,b,d);d.onerror=ka(W,c,"TestLoadImage: error",!1,b,d);d.onabort=ka(W,c,"TestLoadImage: abort",!1,b,d);d.ontimeout=ka(W,c,"TestLoadImage: timeout",!1,b,d);k.setTimeout(function(){if(d.ontimeout)d.ontimeout();},1E4);d.src=a;}else b(!1);}
function Gc(a,b){const c=new vb,d=new AbortController,e=setTimeout(()=>{d.abort();W(c,"TestPingServer: timeout",!1,b);},1E4);fetch(a,{signal:d.signal}).then(f=>{clearTimeout(e);f.ok?W(c,"TestPingServer: ok",!0,b):W(c,"TestPingServer: server error",!1,b);}).catch(()=>{clearTimeout(e);W(c,"TestPingServer: error",!1,b);});}function W(a,b,c,d,e){try{e&&(e.onload=null,e.onerror=null,e.onabort=null,e.ontimeout=null),d(c);}catch(f){}}function Hc(){this.g=new jb;}function Ic(a,b,c){const d=c||"";try{nc(a,function(e,f){let g=e;n(e)&&(g=hb(e));b.push(d+f+"="+encodeURIComponent(g));});}catch(e){throw b.push(d+"type="+encodeURIComponent("_badmap")),e;}}function Jc(a){this.l=a.Ub||null;this.j=a.eb||!1;}r(Jc,kb);Jc.prototype.g=function(){return new Kc(this.l,this.j)};Jc.prototype.i=function(a){return function(){return a}}({});function Kc(a,b){E.call(this);this.D=a;this.o=b;this.m=void 0;this.status=this.readyState=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.u=new Headers;this.h=null;this.B="GET";this.A="";this.g=!1;this.v=this.j=this.l=null;}r(Kc,E);h=Kc.prototype;
h.open=function(a,b){if(0!=this.readyState)throw this.abort(),Error("Error reopening a connection");this.B=a;this.A=b;this.readyState=1;Lc(this);};h.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.g=!0;const b={headers:this.u,method:this.B,credentials:this.m,cache:void 0};a&&(b.body=a);(this.D||k).fetch(new Request(this.A,b)).then(this.Sa.bind(this),this.ga.bind(this));};
h.abort=function(){this.response=this.responseText="";this.u=new Headers;this.status=0;this.j&&this.j.cancel("Request was aborted.").catch(()=>{});1<=this.readyState&&this.g&&4!=this.readyState&&(this.g=!1,Mc(this));this.readyState=0;};
h.Sa=function(a){if(this.g&&(this.l=a,this.h||(this.status=this.l.status,this.statusText=this.l.statusText,this.h=a.headers,this.readyState=2,Lc(this)),this.g&&(this.readyState=3,Lc(this),this.g)))if("arraybuffer"===this.responseType)a.arrayBuffer().then(this.Qa.bind(this),this.ga.bind(this));else if("undefined"!==typeof k.ReadableStream&&"body"in a){this.j=a.body.getReader();if(this.o){if(this.responseType)throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');this.response=
[];}else this.response=this.responseText="",this.v=new TextDecoder;Nc(this);}else a.text().then(this.Ra.bind(this),this.ga.bind(this));};function Nc(a){a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));}h.Pa=function(a){if(this.g){if(this.o&&a.value)this.response.push(a.value);else if(!this.o){var b=a.value?a.value:new Uint8Array(0);if(b=this.v.decode(b,{stream:!a.done}))this.response=this.responseText+=b;}a.done?Mc(this):Lc(this);3==this.readyState&&Nc(this);}};
h.Ra=function(a){this.g&&(this.response=this.responseText=a,Mc(this));};h.Qa=function(a){this.g&&(this.response=a,Mc(this));};h.ga=function(){this.g&&Mc(this);};function Mc(a){a.readyState=4;a.l=null;a.j=null;a.v=null;Lc(a);}h.setRequestHeader=function(a,b){this.u.append(a,b);};h.getResponseHeader=function(a){return this.h?this.h.get(a.toLowerCase())||"":""};
h.getAllResponseHeaders=function(){if(!this.h)return "";const a=[],b=this.h.entries();for(var c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Lc(a){a.onreadystatechange&&a.onreadystatechange.call(a);}Object.defineProperty(Kc.prototype,"withCredentials",{get:function(){return "include"===this.m},set:function(a){this.m=a?"include":"same-origin";}});function Oc(a){let b="";qa(a,function(c,d){b+=d;b+=":";b+=c;b+="\r\n";});return b}function Pc(a,b,c){a:{for(d in c){var d=!1;break a}d=!0;}d||(c=Oc(c),"string"===typeof a?(null!=c&&encodeURIComponent(String(c))):S(a,b,c));}function X(a){E.call(this);this.headers=new Map;this.o=a||null;this.h=!1;this.v=this.g=null;this.D="";this.m=0;this.l="";this.j=this.B=this.u=this.A=!1;this.I=null;this.H="";this.J=!1;}r(X,E);var Qc=/^https?$/i,Rc=["POST","PUT"];h=X.prototype;h.Ha=function(a){this.J=a;};
h.ea=function(a,b,c,d){if(this.g)throw Error("[goog.net.XhrIo] Object is active with another request="+this.D+"; newUri="+a);b=b?b.toUpperCase():"GET";this.D=a;this.l="";this.m=0;this.A=!1;this.h=!0;this.g=this.o?this.o.g():Cb.g();this.v=this.o?lb(this.o):lb(Cb);this.g.onreadystatechange=p(this.Ea,this);try{this.B=!0,this.g.open(b,String(a),!0),this.B=!1;}catch(f){Sc(this,f);return}a=c||"";c=new Map(this.headers);if(d)if(Object.getPrototypeOf(d)===Object.prototype)for(var e in d)c.set(e,d[e]);else if("function"===
typeof d.keys&&"function"===typeof d.get)for(const f of d.keys())c.set(f,d.get(f));else throw Error("Unknown input type for opt_headers: "+String(d));d=Array.from(c.keys()).find(f=>"content-type"==f.toLowerCase());e=k.FormData&&a instanceof k.FormData;!(0<=Array.prototype.indexOf.call(Rc,b,void 0))||d||e||c.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");for(const [f,g]of c)this.g.setRequestHeader(f,g);this.H&&(this.g.responseType=this.H);"withCredentials"in this.g&&this.g.withCredentials!==
this.J&&(this.g.withCredentials=this.J);try{Tc(this),this.u=!0,this.g.send(a),this.u=!1;}catch(f){Sc(this,f);}};function Sc(a,b){a.h=!1;a.g&&(a.j=!0,a.g.abort(),a.j=!1);a.l=b;a.m=5;Uc(a);Vc(a);}function Uc(a){a.A||(a.A=!0,F(a,"complete"),F(a,"error"));}h.abort=function(a){this.g&&this.h&&(this.h=!1,this.j=!0,this.g.abort(),this.j=!1,this.m=a||7,F(this,"complete"),F(this,"abort"),Vc(this));};h.N=function(){this.g&&(this.h&&(this.h=!1,this.j=!0,this.g.abort(),this.j=!1),Vc(this,!0));X.aa.N.call(this);};
h.Ea=function(){this.s||(this.B||this.u||this.j?Wc(this):this.bb());};h.bb=function(){Wc(this);};
function Wc(a){if(a.h&&"undefined"!=typeof fa&&(!a.v[1]||4!=P(a)||2!=a.Z()))if(a.u&&4==P(a))bb(a.Ea,0,a);else if(F(a,"readystatechange"),4==P(a)){a.h=!1;try{const g=a.Z();a:switch(g){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var b=!0;break a;default:b=!1;}var c;if(!(c=b)){var d;if(d=0===g){var e=String(a.D).match(oc)[1]||null;!e&&k.self&&k.self.location&&(e=k.self.location.protocol.slice(0,-1));d=!Qc.test(e?e.toLowerCase():"");}c=d;}if(c)F(a,"complete"),F(a,"success");else {a.m=
6;try{var f=2<P(a)?a.g.statusText:"";}catch(m){f="";}a.l=f+" ["+a.Z()+"]";Uc(a);}}finally{Vc(a);}}}function Vc(a,b){if(a.g){Tc(a);const c=a.g,d=a.v[0]?()=>{}:null;a.g=null;a.v=null;b||F(a,"ready");try{c.onreadystatechange=d;}catch(e){}}}function Tc(a){a.I&&(k.clearTimeout(a.I),a.I=null);}h.isActive=function(){return !!this.g};function P(a){return a.g?a.g.readyState:0}h.Z=function(){try{return 2<P(this)?this.g.status:-1}catch(a){return -1}};h.oa=function(){try{return this.g?this.g.responseText:""}catch(a){return ""}};
h.Oa=function(a){if(this.g){var b=this.g.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));return ib(b)}};function Nb(a){try{if(!a.g)return null;if("response"in a.g)return a.g.response;switch(a.H){case "":case "text":return a.g.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in a.g)return a.g.mozResponseArrayBuffer}return null}catch(b){return null}}
function Vb(a){const b={};a=(a.g&&2<=P(a)?a.g.getAllResponseHeaders()||"":"").split("\r\n");for(let d=0;d<a.length;d++){if(t(a[d]))continue;var c=va(a[d]);const e=c[0];c=c[1];if("string"!==typeof c)continue;c=c.trim();const f=b[e]||[];b[e]=f;f.push(c);}ra(b,function(d){return d.join(", ")});}h.Ba=function(){return this.m};h.Ka=function(){return "string"===typeof this.l?this.l:String(this.l)};function Xc(a,b,c){return c&&c.internalChannelParams?c.internalChannelParams[a]||b:b}
function Yc(a){this.Aa=0;this.i=[];this.j=new vb;this.ia=this.qa=this.I=this.W=this.g=this.ya=this.D=this.H=this.m=this.S=this.o=null;this.Ya=this.U=0;this.Va=Xc("failFast",!1,a);this.F=this.C=this.u=this.s=this.l=null;this.X=!0;this.za=this.T=-1;this.Y=this.v=this.B=0;this.Ta=Xc("baseRetryDelayMs",5E3,a);this.cb=Xc("retryDelaySeedMs",1E4,a);this.Wa=Xc("forwardChannelMaxRetries",2,a);this.wa=Xc("forwardChannelRequestTimeoutMs",2E4,a);this.pa=a&&a.xmlHttpFactory||void 0;this.Xa=a&&a.Tb||void 0;this.Ca=
a&&a.useFetchStreams||!1;this.L=void 0;this.J=a&&a.supportsCrossDomainXhr||!1;this.K="";this.h=new ic(a&&a.concurrentRequestLimit);this.Da=new Hc;this.P=a&&a.fastHandshake||!1;this.O=a&&a.encodeInitMessageHeaders||!1;this.P&&this.O&&(this.O=!1);this.Ua=a&&a.Rb||!1;a&&a.xa&&this.j.xa();a&&a.forceLongPolling&&(this.X=!1);this.ba=!this.P&&this.X&&a&&a.detectBufferingProxy||!1;this.ja=void 0;a&&a.longPollingTimeout&&0<a.longPollingTimeout&&(this.ja=a.longPollingTimeout);this.ca=void 0;this.R=0;this.M=
!1;this.ka=this.A=null;}h=Yc.prototype;h.la=8;h.G=1;h.connect=function(a,b,c,d){K(0);this.W=a;this.H=b||{};c&&void 0!==d&&(this.H.OSID=c,this.H.OAID=d);this.F=this.X;this.I=cc(this,null,this.W);fc(this);};
function gc(a){Zc(a);if(3==a.G){var b=a.U++,c=N(a.I);S(c,"SID",a.K);S(c,"RID",b);S(c,"TYPE","terminate");$c(a,c);b=new M(a,a.j,b);b.L=2;b.v=Ib(N(c));c=!1;if(k.navigator&&k.navigator.sendBeacon)try{c=k.navigator.sendBeacon(b.v.toString(),"");}catch(d){}!c&&k.Image&&((new Image).src=b.v,c=!0);c||(b.g=Mb(b.j,null),b.g.ea(b.v));b.F=Date.now();Kb(b);}ad(a);}function Zb(a){a.g&&(Tb(a),a.g.cancel(),a.g=null);}
function Zc(a){Zb(a);a.u&&(k.clearTimeout(a.u),a.u=null);Yb(a);a.h.cancel();a.s&&("number"===typeof a.s&&k.clearTimeout(a.s),a.s=null);}function fc(a){if(!jc(a.h)&&!a.s){a.s=!0;var b=a.Ga;x||Ea();y||(x(),y=!0);za.add(b,a);a.B=0;}}function bd(a,b){if(ac(a.h)>=a.h.j-(a.s?1:0))return !1;if(a.s)return a.i=b.D.concat(a.i),!0;if(1==a.G||2==a.G||a.B>=(a.Va?0:a.Wa))return !1;a.s=ub(p(a.Ga,a,b),cd(a,a.B));a.B++;return !0}
h.Ga=function(a){if(this.s)if(this.s=null,1==this.G){if(!a){this.U=Math.floor(1E5*Math.random());a=this.U++;const e=new M(this,this.j,a);let f=this.o;this.S&&(f?(f=sa(f),ua(f,this.S)):f=this.S);null!==this.m||this.O||(e.H=f,f=null);if(this.P)a:{var b=0;for(var c=0;c<this.i.length;c++){b:{var d=this.i[c];if("__data__"in d.map&&(d=d.map.__data__,"string"===typeof d)){d=d.length;break b}d=void 0;}if(void 0===d)break;b+=d;if(4096<b){b=c;break a}if(4096===b||c===this.i.length-1){b=c+1;break a}}b=1E3;}else b=
1E3;b=dd(this,e,b);c=N(this.I);S(c,"RID",a);S(c,"CVER",22);this.D&&S(c,"X-HTTP-Session-Id",this.D);$c(this,c);f&&(this.O?b="headers="+encodeURIComponent(String(Oc(f)))+"&"+b:this.m&&Pc(c,this.m,f));bc(this.h,e);this.Ua&&S(c,"TYPE","init");this.P?(S(c,"$req",b),S(c,"SID","null"),e.T=!0,Hb(e,c,null)):Hb(e,c,b);this.G=2;}}else 3==this.G&&(a?ed(this,a):0==this.i.length||jc(this.h)||ed(this));};
function ed(a,b){var c;b?c=b.l:c=a.U++;const d=N(a.I);S(d,"SID",a.K);S(d,"RID",c);S(d,"AID",a.T);$c(a,d);a.m&&a.o&&Pc(d,a.m,a.o);c=new M(a,a.j,c,a.B+1);null===a.m&&(c.H=a.o);b&&(a.i=b.D.concat(a.i));b=dd(a,c,1E3);c.I=Math.round(.5*a.wa)+Math.round(.5*a.wa*Math.random());bc(a.h,c);Hb(c,d,b);}function $c(a,b){a.H&&qa(a.H,function(c,d){S(b,d,c);});a.l&&nc({},function(c,d){S(b,d,c);});}
function dd(a,b,c){c=Math.min(a.i.length,c);var d=a.l?p(a.l.Na,a.l,a):null;a:{var e=a.i;let f=-1;for(;;){const g=["count="+c];-1==f?0<c?(f=e[0].g,g.push("ofs="+f)):f=0:g.push("ofs="+f);let m=!0;for(let q=0;q<c;q++){let l=e[q].g;const v=e[q].map;l-=f;if(0>l)f=Math.max(0,e[q].g-100),m=!1;else try{Ic(v,g,"req"+l+"_");}catch(w){d&&d(v);}}if(m){d=g.join("&");break a}}}a=a.i.splice(0,c);b.D=a;return d}function ec(a){if(!a.g&&!a.u){a.Y=1;var b=a.Fa;x||Ea();y||(x(),y=!0);za.add(b,a);a.v=0;}}
function $b(a){if(a.g||a.u||3<=a.v)return !1;a.Y++;a.u=ub(p(a.Fa,a),cd(a,a.v));a.v++;return !0}h.Fa=function(){this.u=null;fd(this);if(this.ba&&!(this.M||null==this.g||0>=this.R)){var a=2*this.R;this.j.info("BP detection timer enabled: "+a);this.A=ub(p(this.ab,this),a);}};h.ab=function(){this.A&&(this.A=null,this.j.info("BP detection timeout reached."),this.j.info("Buffering proxy detected and switch to long-polling!"),this.F=!1,this.M=!0,K(10),Zb(this),fd(this));};
function Tb(a){null!=a.A&&(k.clearTimeout(a.A),a.A=null);}function fd(a){a.g=new M(a,a.j,"rpc",a.Y);null===a.m&&(a.g.H=a.o);a.g.O=0;var b=N(a.qa);S(b,"RID","rpc");S(b,"SID",a.K);S(b,"AID",a.T);S(b,"CI",a.F?"0":"1");!a.F&&a.ja&&S(b,"TO",a.ja);S(b,"TYPE","xmlhttp");$c(a,b);a.m&&a.o&&Pc(b,a.m,a.o);a.L&&(a.g.I=a.L);var c=a.g;a=a.ia;c.L=1;c.v=Ib(N(b));c.m=null;c.P=!0;Jb(c,a);}h.Za=function(){null!=this.C&&(this.C=null,Zb(this),$b(this),K(19));};function Yb(a){null!=a.C&&(k.clearTimeout(a.C),a.C=null);}
function Ub(a,b){var c=null;if(a.g==b){Yb(a);Tb(a);a.g=null;var d=2;}else if(Xb(a.h,b))c=b.D,dc(a.h,b),d=1;else return;if(0!=a.G)if(b.o)if(1==d){c=b.m?b.m.length:0;b=Date.now()-b.F;var e=a.B;d=qb();F(d,new tb(d,c));fc(a);}else ec(a);else if(e=b.s,3==e||0==e&&0<b.X||!(1==d&&bd(a,b)||2==d&&$b(a)))switch(c&&0<c.length&&(b=a.h,b.i=b.i.concat(c)),e){case 1:R(a,5);break;case 4:R(a,10);break;case 3:R(a,6);break;default:R(a,2);}}
function cd(a,b){let c=a.Ta+Math.floor(Math.random()*a.cb);a.isActive()||(c*=2);return c*b}function R(a,b){a.j.info("Error code "+b);if(2==b){var c=p(a.fb,a),d=a.Xa;const e=!d;d=new T(d||"//www.google.com/images/cleardot.gif");k.location&&"http"==k.location.protocol||qc(d,"https");Ib(d);e?Fc(d.toString(),c):Gc(d.toString(),c);}else K(2);a.G=0;a.l&&a.l.sa(b);ad(a);Zc(a);}h.fb=function(a){a?(this.j.info("Successfully pinged google.com"),K(2)):(this.j.info("Failed to ping google.com"),K(1));};
function ad(a){a.G=0;a.ka=[];if(a.l){const b=kc(a.h);if(0!=b.length||0!=a.i.length)ma(a.ka,b),ma(a.ka,a.i),a.h.i.length=0,la(a.i),a.i.length=0;a.l.ra();}}function cc(a,b,c){var d=c instanceof T?N(c):new T(c);if(""!=d.g)b&&(d.g=b+"."+d.g),rc(d,d.s);else {var e=k.location;d=e.protocol;b=b?b+"."+e.hostname:e.hostname;e=+e.port;var f=new T(null);d&&qc(f,d);b&&(f.g=b);e&&rc(f,e);c&&(f.l=c);d=f;}c=a.D;b=a.ya;c&&b&&S(d,c,b);S(d,"VER",a.la);$c(a,d);return d}
function Mb(a,b,c){if(b&&!a.J)throw Error("Can't create secondary domain capable XhrIo object.");b=a.Ca&&!a.pa?new X(new Jc({eb:c})):new X(a.pa);b.Ha(a.J);return b}h.isActive=function(){return !!this.l&&this.l.isActive(this)};function gd(){}h=gd.prototype;h.ua=function(){};h.ta=function(){};h.sa=function(){};h.ra=function(){};h.isActive=function(){return !0};h.Na=function(){};function hd(){}hd.prototype.g=function(a,b){return new Y(a,b)};
function Y(a,b){E.call(this);this.g=new Yc(b);this.l=a;this.h=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.g.o=a;a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});b&&b.va&&(a?a["X-WebChannel-Client-Profile"]=b.va:a={"X-WebChannel-Client-Profile":b.va});this.g.S=
a;(a=b&&b.Sb)&&!t(a)&&(this.g.m=a);this.v=b&&b.supportsCrossDomainXhr||!1;this.u=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!t(b)&&(this.g.D=b,a=this.h,null!==a&&b in a&&(a=this.h,b in a&&delete a[b]));this.j=new Z(this);}r(Y,E);Y.prototype.m=function(){this.g.l=this.j;this.v&&(this.g.J=!0);this.g.connect(this.l,this.h||void 0);};Y.prototype.close=function(){gc(this.g);};
Y.prototype.o=function(a){var b=this.g;if("string"===typeof a){var c={};c.__data__=a;a=c;}else this.u&&(c={},c.__data__=hb(a),a=c);b.i.push(new hc(b.Ya++,a));3==b.G&&fc(b);};Y.prototype.N=function(){this.g.l=null;delete this.j;gc(this.g);delete this.g;Y.aa.N.call(this);};
function id(a){nb.call(this);a.__headers__&&(this.headers=a.__headers__,this.statusCode=a.__status__,delete a.__headers__,delete a.__status__);var b=a.__sm__;if(b){a:{for(const c in b){a=c;break a}a=void 0;}if(this.i=a)a=this.i,b=null!==b&&a in b?b[a]:void 0;this.data=b;}else this.data=a;}r(id,nb);function jd(){ob.call(this);this.status=1;}r(jd,ob);function Z(a){this.g=a;}r(Z,gd);Z.prototype.ua=function(){F(this.g,"a");};Z.prototype.ta=function(a){F(this.g,new id(a));};
Z.prototype.sa=function(a){F(this.g,new jd());};Z.prototype.ra=function(){F(this.g,"b");};hd.prototype.createWebChannel=hd.prototype.g;Y.prototype.send=Y.prototype.o;Y.prototype.open=Y.prototype.m;Y.prototype.close=Y.prototype.close;createWebChannelTransport = webchannel_blob_es2018.createWebChannelTransport=function(){return new hd};getStatEventTarget = webchannel_blob_es2018.getStatEventTarget=function(){return qb()};Event = webchannel_blob_es2018.Event=I;Stat = webchannel_blob_es2018.Stat={mb:0,pb:1,qb:2,Jb:3,Ob:4,Lb:5,Mb:6,Kb:7,Ib:8,Nb:9,PROXY:10,NOPROXY:11,Gb:12,Cb:13,Db:14,Bb:15,Eb:16,Fb:17,ib:18,hb:19,jb:20};Ab.NO_ERROR=0;Ab.TIMEOUT=8;Ab.HTTP_ERROR=6;
ErrorCode = webchannel_blob_es2018.ErrorCode=Ab;Bb.COMPLETE="complete";EventType = webchannel_blob_es2018.EventType=Bb;mb.EventType=H;H.OPEN="a";H.CLOSE="b";H.ERROR="c";H.MESSAGE="d";E.prototype.listen=E.prototype.K;WebChannel = webchannel_blob_es2018.WebChannel=mb;FetchXmlHttpFactory = webchannel_blob_es2018.FetchXmlHttpFactory=Jc;X.prototype.listenOnce=X.prototype.L;X.prototype.getLastError=X.prototype.Ka;X.prototype.getLastErrorCode=X.prototype.Ba;X.prototype.getStatus=X.prototype.Z;X.prototype.getResponseJson=X.prototype.Oa;X.prototype.getResponseText=X.prototype.oa;
X.prototype.send=X.prototype.ea;X.prototype.setWithCredentials=X.prototype.Ha;XhrIo = webchannel_blob_es2018.XhrIo=X;}).apply( typeof webchannel_blob_es2018_commonjsGlobal !== 'undefined' ? webchannel_blob_es2018_commonjsGlobal : typeof self !== 'undefined' ? self  : typeof window !== 'undefined' ? window  : {});


//# sourceMappingURL=webchannel_blob_es2018.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/firestore/dist/index.esm2017.js
/* provided dependency */ var process = __webpack_require__(34406);
/* provided dependency */ var Buffer = __webpack_require__(48834)["Buffer"];







const w = "@firebase/firestore";

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */
class User {
    constructor(e) {
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */    toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}

/** A user with a null UID. */ User.UNAUTHENTICATED = new User(null), 
// TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
User.GOOGLE_CREDENTIALS = new User("google-credentials-uid"), User.FIRST_PARTY = new User("first-party-uid"), 
User.MOCK_USER = new User("mock-user");

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let S = "11.0.2";

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const b = new dist_esm_index_esm2017/* Logger */.Yd("@firebase/firestore");

// Helper methods are needed because variables can't be exported as read/write
function __PRIVATE_getLogLevel() {
    return b.logLevel;
}

/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function setLogLevel(e) {
    b.setLogLevel(e);
}

function __PRIVATE_logDebug(e, ...t) {
    if (b.logLevel <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG) {
        const n = t.map(__PRIVATE_argToString);
        b.debug(`Firestore (${S}): ${e}`, ...n);
    }
}

function __PRIVATE_logError(e, ...t) {
    if (b.logLevel <= dist_esm_index_esm2017/* LogLevel.ERROR */["in"].ERROR) {
        const n = t.map(__PRIVATE_argToString);
        b.error(`Firestore (${S}): ${e}`, ...n);
    }
}

/**
 * @internal
 */ function __PRIVATE_logWarn(e, ...t) {
    if (b.logLevel <= dist_esm_index_esm2017/* LogLevel.WARN */["in"].WARN) {
        const n = t.map(__PRIVATE_argToString);
        b.warn(`Firestore (${S}): ${e}`, ...n);
    }
}

/**
 * Converts an additional log parameter to a string representation.
 */ function __PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
        /** Formats an object as a JSON string, suitable for logging. */
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function fail(e = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const t = `FIRESTORE (${S}) INTERNAL ASSERTION FAILED: ` + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw __PRIVATE_logError(t), new Error(t);
}

/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function __PRIVATE_hardAssert(e, t) {
    e || fail();
}

/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function __PRIVATE_debugAssert(e, t) {
    e || fail();
}

/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function __PRIVATE_debugCast(e, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const D = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */
    OK: "ok",
    /** The operation was cancelled (typically by the caller). */
    CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */
    UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */
    INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */
    DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */
    NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */
    ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */
    PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */
    UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */
    RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */
    FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */
    OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */
    UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */
    INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */
    DATA_LOSS: "data-loss"
};

/** An error returned by a Firestore operation. */ class FirestoreError extends dist_index_esm2017/* FirebaseError */.ZR {
    /** @hideconstructor */
    constructor(
    /**
     * The backend error code associated with this error.
     */
    e, 
    /**
     * A custom error description.
     */
    t) {
        super(e, t), this.code = e, this.message = t, 
        // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = () => `${this.name}: [code=${this.code}]: ${this.message}`;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_Deferred {
    constructor() {
        this.promise = new Promise(((e, t) => {
            this.resolve = e, this.reject = t;
        }));
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_OAuthToken {
    constructor(e, t) {
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}

/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class __PRIVATE_EmptyAuthCredentialsProvider {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable((() => t(User.UNAUTHENTICATED)));
    }
    shutdown() {}
}

/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class __PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e) {
        this.token = e, 
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */
        this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, 
        // Fire with initial user.
        e.enqueueRetryable((() => t(this.token.user)));
    }
    shutdown() {
        this.changeListener = null;
    }
}

class __PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e) {
        this.t = e, 
        /** Tracks the current User. */
        this.currentUser = User.UNAUTHENTICATED, 
        /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */
        this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        __PRIVATE_hardAssert(void 0 === this.o);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
                const __PRIVATE_guardedChangeListener = e => this.i !== n ? (n = this.i, 
        t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
                let r = new __PRIVATE_Deferred;
        this.o = () => {
            this.i++, this.currentUser = this.u(), r.resolve(), r = new __PRIVATE_Deferred, 
            e.enqueueRetryable((() => __PRIVATE_guardedChangeListener(this.currentUser)));
        };
        const __PRIVATE_awaitNextToken = () => {
            const t = r;
            e.enqueueRetryable((async () => {
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            }));
        }, __PRIVATE_registerAuth = e => {
            __PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, 
            this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e => __PRIVATE_registerAuth(e))), 
        // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout((() => {
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : (
                // If auth is still not available, proceed with `null` user
                __PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), 
                r.resolve(), r = new __PRIVATE_Deferred);
            }
        }), 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t => 
        // Cancel the request since the token changed while the request was
        // outstanding so the response is potentially for a previous user (which
        // user, we can't be sure).
        this.i !== e ? (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), 
        this.getToken()) : t ? (__PRIVATE_hardAssert("string" == typeof t.accessToken), 
        new __PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null)) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return __PRIVATE_hardAssert(null === e || "string" == typeof e), new User(e);
    }
}

/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class __PRIVATE_FirstPartyToken {
    constructor(e, t, n) {
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = User.FIRST_PARTY, 
        this.T = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */    I() {
        return this.P ? this.P() : null;
    }
    get headers() {
        this.T.set("X-Goog-AuthUser", this.l);
        // Use array notation to prevent minification
        const e = this.I();
        return e && this.T.set("Authorization", e), this.h && this.T.set("X-Goog-Iam-Authorization-Token", this.h), 
        this.T;
    }
}

/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class __PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n) {
        this.l = e, this.h = t, this.P = n;
    }
    getToken() {
        return Promise.resolve(new __PRIVATE_FirstPartyToken(this.l, this.h, this.P));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable((() => t(User.FIRST_PARTY)));
    }
    shutdown() {}
    invalidateToken() {}
}

class AppCheckToken {
    constructor(e) {
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}

class __PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(e) {
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    start(e, t) {
        __PRIVATE_hardAssert(void 0 === this.o);
        const onTokenChanged = e => {
            null != e.error && __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.R;
            return this.R = e.token, __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), 
            n ? t(e.token) : Promise.resolve();
        };
        this.o = t => {
            e.enqueueRetryable((() => onTokenChanged(t)));
        };
        const __PRIVATE_registerAppCheck = e => {
            __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, 
            this.o && this.appCheck.addTokenListener(this.o);
        };
        this.A.onInit((e => __PRIVATE_registerAppCheck(e))), 
        // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout((() => {
            if (!this.appCheck) {
                const e = this.A.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : 
                // If AppCheck is still not available, proceed without it.
                __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }), 0);
    }
    getToken() {
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e => e ? (__PRIVATE_hardAssert("string" == typeof e.token), 
        this.R = e.token, new AppCheckToken(e.token)) : null)) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}

/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class __PRIVATE_EmptyAppCheckTokenProvider {
    getToken() {
        return Promise.resolve(new AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}

/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */
function __PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n); else 
    // Falls back to Math.random
    for (let t = 0; t < e; t++) n[t] = Math.floor(256 * Math.random());
    return n;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class __PRIVATE_AutoId {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
        // The largest byte value that is a multiple of `char.length`.
                let n = "";
        for (;n.length < 20; ) {
            const r = __PRIVATE_randomBytes(40);
            for (let i = 0; i < r.length; ++i) 
            // Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
        }
        return n;
    }
}

function __PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}

/** Helper to compare arrays using isEqual(). */ function __PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every(((e, r) => n(e, t[r])));
}

/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function __PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */
class Timestamp {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */
    static now() {
        return Timestamp.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */    static fromDate(e) {
        return Timestamp.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */    static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
        return new Timestamp(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */    constructor(
    /**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */
    e, 
    /**
     * The fractions of a second at nanosecond resolution.*
     */
    t) {
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
                if (e >= 253402300800) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */    toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */    toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? __PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : __PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */    isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */    toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */    toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */    valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
                return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class SnapshotVersion {
    static fromTimestamp(e) {
        return new SnapshotVersion(e);
    }
    static min() {
        return new SnapshotVersion(new Timestamp(0, 0));
    }
    static max() {
        return new SnapshotVersion(new Timestamp(253402300799, 999999999));
    }
    constructor(e) {
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */    toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Path represents an ordered sequence of string segments.
 */
class BasePath {
    constructor(e, t, n) {
        void 0 === t ? t = 0 : t > e.length && fail(), void 0 === n ? n = e.length - t : n > e.length - t && fail(), 
        this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof BasePath ? e.forEach((e => {
            t.push(e);
        })) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */    limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for (let t = this.offset, n = this.limit(); t < n; t++) e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for (let r = 0; r < n; r++) {
            const n = e.get(r), i = t.get(r);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
    }
}

/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class ResourcePath extends BasePath {
    construct(e, t, n) {
        return new ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */    toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */    static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e) {
            if (n.indexOf("//") >= 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
                        t.push(...n.split("/").filter((e => e.length > 0)));
        }
        return new ResourcePath(t);
    }
    static emptyPath() {
        return new ResourcePath([]);
    }
}

const v = /^[_a-zA-Z][_a-zA-Z0-9]*$/;

/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class FieldPath$1 extends BasePath {
    construct(e, t, n) {
        return new FieldPath$1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */    static isValidIdentifier(e) {
        return v.test(e);
    }
    canonicalString() {
        return this.toArray().map((e => (e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), 
        FieldPath$1.isValidIdentifier(e) || (e = "`" + e + "`"), e))).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */    isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */    static keyField() {
        return new FieldPath$1([ "__name__" ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */    static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = () => {
            if (0 === n.length) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for (;r < e.length; ) {
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new FirestoreError(D.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new FirestoreError(D.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), 
            r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new FirestoreError(D.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new FieldPath$1(t);
    }
    static emptyPath() {
        return new FieldPath$1([]);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */ class DocumentKey {
    constructor(e) {
        this.path = e;
    }
    static fromPath(e) {
        return new DocumentKey(ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new DocumentKey(ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new DocumentKey(ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */    hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */    getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */    getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */    static fromSegments(e) {
        return new DocumentKey(new ResourcePath(e.slice()));
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */
/**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */
class FieldIndex {
    constructor(
    /**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */
    e, 
    /** The collection ID this index applies to. */
    t, 
    /** The field segments for this index. */
    n, 
    /** Shows how up-to-date the index is for the current user. */
    r) {
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}

/** An ID for an index that has not yet been added to persistence.  */
/** Returns the ArrayContains/ArrayContainsAny segment for this index. */
function __PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e => 2 /* IndexKind.CONTAINS */ === e.kind));
}

/** Returns all directional (ascending/descending) segments for this index. */ function __PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e => 2 /* IndexKind.CONTAINS */ !== e.kind));
}

/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */
/**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */
function __PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for (let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r) if (n = __PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 
    0 !== n) return n;
    return __PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}

/** Returns a debug representation of the field index */ FieldIndex.UNKNOWN_ID = -1;

/** An index component consisting of field path and index type.  */
class IndexSegment {
    constructor(
    /** The field path of the component. */
    e, 
    /** The fields sorting order. */
    t) {
        this.fieldPath = e, this.kind = t;
    }
}

function __PRIVATE_indexSegmentComparator(e, t) {
    const n = FieldPath$1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : __PRIVATE_primitiveComparator(e.kind, t.kind);
}

/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class IndexState {
    constructor(
    /**
     * Indicates when the index was last updated (relative to other indexes).
     */
    e, 
    /** The the latest indexed read time, document and batch id. */
    t) {
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */    static empty() {
        return new IndexState(0, IndexOffset.min());
    }
}

/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function __PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = SnapshotVersion.fromTimestamp(1e9 === r ? new Timestamp(n + 1, 0) : new Timestamp(n, r));
    return new IndexOffset(i, DocumentKey.empty(), t);
}

/** Creates a new offset based on the provided document. */ function __PRIVATE_newIndexOffsetFromDocument(e) {
    return new IndexOffset(e.readTime, e.key, -1);
}

/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class IndexOffset {
    constructor(
    /**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */
    e, 
    /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */
    t, 
    /*
     * The largest mutation batch id that's been processed by Firestore.
     */
    n) {
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */    static min() {
        return new IndexOffset(SnapshotVersion.min(), DocumentKey.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */    static max() {
        return new IndexOffset(SnapshotVersion.max(), DocumentKey.empty(), -1);
    }
}

function __PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = DocumentKey.comparator(e.documentKey, t.documentKey), 
    0 !== n ? n : __PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const C = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";

/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class PersistenceTransaction {
    constructor() {
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e => e()));
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function __PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== D.FAILED_PRECONDITION || e.message !== C) throw e;
    __PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class PersistencePromise {
    constructor(e) {
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, 
        // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, 
        // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e => {
            this.isDone = !0, this.result = e, this.nextCallback && 
            // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }), (e => {
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        }));
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new PersistencePromise(((n, r) => {
            this.nextCallback = t => {
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = e => {
                this.wrapFailure(t, e).next(n, r);
            };
        }));
    }
    toPromise() {
        return new Promise(((e, t) => {
            this.next(e, t);
        }));
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof PersistencePromise ? t : PersistencePromise.resolve(t);
        } catch (e) {
            return PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction((() => e(t))) : PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction((() => e(t))) : PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new PersistencePromise(((t, n) => {
            t(e);
        }));
    }
    static reject(e) {
        return new PersistencePromise(((t, n) => {
            n(e);
        }));
    }
    static waitFor(
    // Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new PersistencePromise(((t, n) => {
            let r = 0, i = 0, s = !1;
            e.forEach((e => {
                ++r, e.next((() => {
                    ++i, s && i === r && t();
                }), (e => n(e)));
            })), s = !0, i === r && t();
        }));
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */    static or(e) {
        let t = PersistencePromise.resolve(!1);
        for (const n of e) t = t.next((e => e ? PersistencePromise.resolve(e) : n()));
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach(((e, r) => {
            n.push(t.call(this, e, r));
        })), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */    static mapArray(e, t) {
        return new PersistencePromise(((n, r) => {
            const i = e.length, s = new Array(i);
            let o = 0;
            for (let _ = 0; _ < i; _++) {
                const a = _;
                t(e[a]).next((e => {
                    s[a] = e, ++o, o === i && n(s);
                }), (e => r(e)));
            }
        }));
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */    static doWhile(e, t) {
        return new PersistencePromise(((n, r) => {
            const process = () => {
                !0 === e() ? t().next((() => {
                    process();
                }), r) : n();
            };
            process();
        }));
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */
class __PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new __PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new __PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t) {
        this.action = e, this.transaction = t, this.aborted = !1, 
        /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */
        this.V = new __PRIVATE_Deferred, this.transaction.oncomplete = () => {
            this.V.resolve();
        }, this.transaction.onabort = () => {
            t.error ? this.V.reject(new __PRIVATE_IndexedDbTransactionError(e, t.error)) : this.V.resolve();
        }, this.transaction.onerror = t => {
            const n = __PRIVATE_checkForAndReportiOSError(t.target.error);
            this.V.reject(new __PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get m() {
        return this.V.promise;
    }
    abort(e) {
        e && this.V.reject(e), this.aborted || (__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), 
        this.aborted = !0, this.transaction.abort());
    }
    g() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */    store(e) {
        const t = this.transaction.objectStore(e);
        return new __PRIVATE_SimpleDbStore(t);
    }
}

/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class __PRIVATE_SimpleDb {
    /** Deletes the specified database. */
    static delete(e) {
        return __PRIVATE_logDebug("SimpleDb", "Removing database:", e), __PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */    static p() {
        if (!isIndexedDBAvailable()) return !1;
        if (__PRIVATE_SimpleDb.S()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
                const e = getUA(), t = __PRIVATE_SimpleDb.D(e), n = 0 < t && t < 10, r = __PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
                return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */    static S() {
        var e;
        return "undefined" != typeof process && "YES" === (null === (e = process.__PRIVATE_env) || void 0 === e ? void 0 : e.v);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */    static C(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */
    static D(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */    constructor(e, t, n) {
        this.name = e, this.version = t, this.F = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === __PRIVATE_SimpleDb.D(getUA()) && __PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */    async M(e) {
        return this.db || (__PRIVATE_logDebug("SimpleDb", "Opening database:", this.name), 
        this.db = await new Promise(((t, n) => {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = e => {
                const n = e.target.result;
                t(n);
            }, r.onblocked = () => {
                n(new __PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = t => {
                const r = t.target.error;
                "VersionError" === r.name ? n(new FirestoreError(D.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new FirestoreError(D.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new __PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = e => {
                __PRIVATE_logDebug("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.F.O(t, r.transaction, e.oldVersion, this.version).next((() => {
                    __PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + this.version + " complete");
                }));
            };
        }))), this.N && (this.db.onversionchange = e => this.N(e)), this.db;
    }
    L(e) {
        this.N = e, this.db && (this.db.onversionchange = t => e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for (;;) {
            ++s;
            try {
                this.db = await this.M(e);
                const t = __PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e => (t.g(), 
                e))).catch((e => (
                // Abort the transaction if there was an error.
                t.abort(e), PersistencePromise.reject(e)))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch((() => {})), 
                // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.m, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                                if (__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", n), 
                this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}

/** Parse User Agent to determine Android version. Returns -1 if not found. */ function __PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}

/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class __PRIVATE_IterationController {
    constructor(e) {
        this.B = e, this.k = !1, this.q = null;
    }
    get isDone() {
        return this.k;
    }
    get K() {
        return this.q;
    }
    set cursor(e) {
        this.B = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */    done() {
        this.k = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */    $(e) {
        this.q = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */    delete() {
        return __PRIVATE_wrapRequest(this.B.delete());
    }
}

/** An error that wraps exceptions that thrown during IndexedDB execution. */ class __PRIVATE_IndexedDbTransactionError extends (/* unused pure expression or super */ null && (FirestoreError)) {
    constructor(e, t) {
        super(D.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}

/** Verifies whether `e` is an IndexedDbTransactionError. */ function __PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}

/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class __PRIVATE_SimpleDbStore {
    constructor(e) {
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? (__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), 
        n = this.store.put(t, e)) : (__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), 
        n = this.store.put(e)), __PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */    add(e) {
        __PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
        return __PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */    get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return __PRIVATE_wrapRequest(this.store.get(e)).next((t => (
        // Normalize nonexistence to null.
        void 0 === t && (t = null), __PRIVATE_logDebug("SimpleDb", "GET", this.store.name, e, t), 
        t)));
    }
    delete(e) {
        __PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
        return __PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */    count() {
        __PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
        return __PRIVATE_wrapRequest(this.store.count());
    }
    U(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
                if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new PersistencePromise(((t, n) => {
                e.onerror = e => {
                    n(e.target.error);
                }, e.onsuccess = e => {
                    t(e.target.result);
                };
            }));
        }
        {
            const e = this.cursor(n), t = [];
            return this.W(e, ((e, n) => {
                t.push(n);
            })).next((() => t));
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */    G(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new PersistencePromise(((e, t) => {
            n.onerror = e => {
                t(e.target.error);
            }, n.onsuccess = t => {
                e(t.target.result);
            };
        }));
    }
    j(e, t) {
        __PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.H = !1;
        const r = this.cursor(n);
        return this.W(r, ((e, t, n) => n.delete()));
    }
    J(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.W(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */    Y(e) {
        const t = this.cursor({});
        return new PersistencePromise(((n, r) => {
            t.onerror = e => {
                const t = __PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = t => {
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e => {
                    e ? r.continue() : n();
                })) : n();
            };
        }));
    }
    W(e, t) {
        const n = [];
        return new PersistencePromise(((r, i) => {
            e.onerror = e => {
                i(e.target.error);
            }, e.onsuccess = e => {
                const i = e.target.result;
                if (!i) return void r();
                const s = new __PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof PersistencePromise) {
                    const e = o.catch((e => (s.done(), PersistencePromise.reject(e))));
                    n.push(e);
                }
                s.isDone ? r() : null === s.K ? i.continue() : i.continue(s.K);
            };
        })).next((() => PersistencePromise.waitFor(n)));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.H ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}

/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function __PRIVATE_wrapRequest(e) {
    return new PersistencePromise(((t, n) => {
        e.onsuccess = e => {
            const n = e.target.result;
            t(n);
        }, e.onerror = e => {
            const t = __PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    }));
}

// Guard so we only report the error once.
let F = (/* unused pure expression or super */ null && (!1));

function __PRIVATE_checkForAndReportiOSError(e) {
    const t = __PRIVATE_SimpleDb.D(getUA());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new FirestoreError("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return F || (F = !0, 
            // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout((() => {
                throw e;
            }), 0)), e;
        }
    }
    return e;
}

/** This class is responsible for the scheduling of Index Backfiller. */
class __PRIVATE_IndexBackfillerScheduler {
    constructor(e, t) {
        this.asyncQueue = e, this.Z = t, this.task = null;
    }
    start() {
        this.X(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    X(e) {
        __PRIVATE_logDebug("IndexBackfiller", `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, (async () => {
            this.task = null;
            try {
                __PRIVATE_logDebug("IndexBackfiller", `Documents written: ${await this.Z.ee()}`);
            } catch (e) {
                __PRIVATE_isIndexedDbTransactionError(e) ? __PRIVATE_logDebug("IndexBackfiller", "Ignoring IndexedDB error during index backfill: ", e) : await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.X(6e4);
        }));
    }
}

/** Implements the steps for backfilling indexes. */ class __PRIVATE_IndexBackfiller {
    constructor(
    /**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */
    e, t) {
        this.localStore = e, this.persistence = t;
    }
    async ee(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t => this.te(t, e)));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */    te(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return PersistencePromise.doWhile((() => !0 === i && r > 0), (() => this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t => {
            if (null !== t && !n.has(t)) return __PRIVATE_logDebug("IndexBackfiller", `Processing collection: ${t}`), 
            this.ne(e, t, r).next((e => {
                r -= e, n.add(t);
            }));
            i = !1;
        })))).next((() => t - r));
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */    ne(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r => this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n => {
            const i = n.changes;
            return this.localStore.indexManager.updateIndexEntries(e, i).next((() => this.re(r, n))).next((n => (__PRIVATE_logDebug("IndexBackfiller", `Updating offset: ${n}`), 
            this.localStore.indexManager.updateCollectionGroup(e, t, n)))).next((() => i.size));
        }))));
    }
    /** Returns the next offset based on the provided documents. */    re(e, t) {
        let n = e;
        return t.changes.forEach(((e, t) => {
            const r = __PRIVATE_newIndexOffsetFromDocument(t);
            __PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        })), new IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class __PRIVATE_ListenSequence {
    constructor(e, t) {
        this.previousValue = e, t && (t.sequenceNumberHandler = e => this.ie(e), this.se = e => t.writeSequenceNumber(e));
    }
    ie(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.se && this.se(e), e;
    }
}

__PRIVATE_ListenSequence.oe = -1;

/**
 * Returns whether a variable is either undefined or null.
 */
function __PRIVATE_isNullOrUndefined(e) {
    return null == e;
}

/** Returns whether the value represents -0. */ function __PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}

/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */
function __PRIVATE_encodeResourcePath(e) {
    let t = "";
    for (let n = 0; n < e.length; n++) t.length > 0 && (t = __PRIVATE_encodeSeparator(t)), 
    t = __PRIVATE_encodeSegment(e.get(n), t);
    return __PRIVATE_encodeSeparator(t);
}

/** Encodes a single segment of a resource path into the given result */ function __PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for (let t = 0; t < r; t++) {
        const r = e.charAt(t);
        switch (r) {
          case "\0":
            n += "";
            break;

          case "":
            n += "";
            break;

          default:
            n += r;
        }
    }
    return n;
}

/** Encodes a path separator into the given result */ function __PRIVATE_encodeSeparator(e) {
    return e + "";
}

/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function __PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if (__PRIVATE_hardAssert(t >= 2), 2 === t) return __PRIVATE_hardAssert("" === e.charAt(0) && "" === e.charAt(1)), 
    ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
        const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for (let i = 0; i < t; ) {
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf("", i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && fail();
        switch (e.charAt(t + 1)) {
          case "":
            const s = e.substring(i, t);
            let o;
            0 === r.length ? 
            // Avoid copying for the common case of a segment that excludes \0
            // and \001
            o = s : (r += s, o = r, r = ""), n.push(o);
            break;

          case "":
            r += e.substring(i, t), r += "\0";
            break;

          case "":
            // The escape character can be used in the output to encode itself.
            r += e.substring(i, t + 1);
            break;

          default:
            fail();
        }
        i = t + 2;
    }
    return new ResourcePath(n);
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const M = (/* unused pure expression or super */ null && ([ "userId", "batchId" ]));

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */
/**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */
function __PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [ e, __PRIVATE_encodeResourcePath(t) ];
}

/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function __PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [ e, __PRIVATE_encodeResourcePath(t), n ];
}

/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const x = {}, O = (/* unused pure expression or super */ null && ([ "prefixPath", "collectionGroup", "readTime", "documentId" ])), N = (/* unused pure expression or super */ null && ([ "prefixPath", "collectionGroup", "documentId" ])), L = (/* unused pure expression or super */ null && ([ "collectionGroup", "readTime", "prefixPath", "documentId" ])), B = (/* unused pure expression or super */ null && ([ "canonicalId", "targetId" ])), k = (/* unused pure expression or super */ null && ([ "targetId", "path" ])), q = (/* unused pure expression or super */ null && ([ "path", "targetId" ])), Q = (/* unused pure expression or super */ null && ([ "collectionId", "parent" ])), K = (/* unused pure expression or super */ null && ([ "indexId", "uid" ])), $ = (/* unused pure expression or super */ null && ([ "uid", "sequenceNumber" ])), U = (/* unused pure expression or super */ null && ([ "indexId", "uid", "arrayValue", "directionalValue", "orderedDocumentKey", "documentKey" ])), W = (/* unused pure expression or super */ null && ([ "indexId", "uid", "orderedDocumentKey" ])), G = (/* unused pure expression or super */ null && ([ "userId", "collectionPath", "documentId" ])), z = (/* unused pure expression or super */ null && ([ "userId", "collectionPath", "largestBatchId" ])), j = (/* unused pure expression or super */ null && ([ "userId", "collectionGroup", "largestBatchId" ])), H = [ ...[ ...[ ...[ ...[ "mutationQueues", "mutations", "documentMutations", "remoteDocuments", "targets", "owner", "targetGlobal", "targetDocuments" ], "clientMetadata" ], "remoteDocumentGlobal" ], "collectionParents" ], "bundles", "namedQueries" ], J = [ ...H, "documentOverlays" ], Y = [ "mutationQueues", "mutations", "documentMutations", "remoteDocumentsV14", "targets", "owner", "targetGlobal", "targetDocuments", "clientMetadata", "remoteDocumentGlobal", "collectionParents", "bundles", "namedQueries", "documentOverlays" ], Z = Y, X = [ ...Z, "indexConfiguration", "indexState", "indexEntries" ], ee = (/* unused pure expression or super */ null && (X)), te = [ ...X, "globals" ];

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_IndexedDbTransaction extends (/* unused pure expression or super */ null && (PersistenceTransaction)) {
    constructor(e, t) {
        super(), this._e = e, this.currentSequenceNumber = t;
    }
}

function __PRIVATE_getStore(e, t) {
    const n = __PRIVATE_debugCast(e);
    return __PRIVATE_SimpleDb.C(n._e, t);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_objectSize(e) {
    let t = 0;
    for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}

function forEach(e, t) {
    for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}

function __PRIVATE_mapToArray(e, t) {
    const n = [];
    for (const r in e) Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}

function isEmpty(e) {
    for (const t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class SortedMap {
    constructor(e, t) {
        this.comparator = e, this.root = t || LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for (;!t.isEmpty(); ) {
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for (;!n.isEmpty(); ) {
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : (
            // Count all nodes left of the node plus the node itself
            t += n.left.size + 1, n = n.right);
        }
        // Node not found
                return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal(((t, n) => (e(t, n), !1)));
    }
    toString() {
        const e = [];
        return this.inorderTraversal(((t, n) => (e.push(`${t}:${n}`), !1))), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new SortedMapIterator(this.root, e, this.comparator, !0);
    }
}

 // end SortedMap
// An iterator over an LLRBNode.
class SortedMapIterator {
    constructor(e, t, n, r) {
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for (;!e.isEmpty(); ) if (i = t ? n(e.key, t) : 1, 
        // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) 
        // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right; else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for (e = e.left; !e.isEmpty(); ) this.nodeStack.push(e), e = e.right; else for (e = e.right; !e.isEmpty(); ) this.nodeStack.push(e), 
        e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}

 // end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class LLRBNode {
    constructor(e, t, n, r, i) {
        this.key = e, this.value = t, this.color = null != n ? n : LLRBNode.RED, this.left = null != r ? r : LLRBNode.EMPTY, 
        this.right = null != i ? i : LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), 
        r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), 
        e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), 
        r = r.copy(null, null, null, r.left.remove(e, t), null); else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 
            0 === t(e, r.key)) {
                if (r.right.isEmpty()) return LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), 
        e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), 
        e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw fail();
        if (this.right.isRed()) throw fail();
        const e = this.left.check();
        if (e !== this.right.check()) throw fail();
        return e + (this.isRed() ? 0 : 1);
    }
}

 // end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
LLRBNode.EMPTY = null, LLRBNode.RED = !0, LLRBNode.BLACK = !1;

// end LLRBEmptyNode
LLRBNode.EMPTY = new 
// Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor() {
        this.size = 0;
    }
    get key() {
        throw fail();
    }
    get value() {
        throw fail();
    }
    get color() {
        throw fail();
    }
    get left() {
        throw fail();
    }
    get right() {
        throw fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */
class SortedSet {
    constructor(e) {
        this.comparator = e, this.data = new SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */    forEach(e) {
        this.data.inorderTraversal(((t, n) => (e(t), !1)));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */    forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for (;n.hasNext(); ) {
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */    forEachWhile(e, t) {
        let n;
        for (n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext(); ) {
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */    firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */    add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */    delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
                return t.size < e.size && (t = e, e = this), e.forEach((e => {
            t = t.add(e);
        })), t;
    }
    isEqual(e) {
        if (!(e instanceof SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for (;t.hasNext(); ) {
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t => {
            e.push(t);
        })), e;
    }
    toString() {
        const e = [];
        return this.forEach((t => e.push(t))), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new SortedSet(this.comparator);
        return t.data = e, t;
    }
}

class SortedSetIterator {
    constructor(e) {
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}

/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */
/**
 * Returns the next element from the iterator or `undefined` if none available.
 */
function __PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class FieldMask {
    constructor(e) {
        this.fields = e, 
        // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort(FieldPath$1.comparator);
    }
    static empty() {
        return new FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */    unionWith(e) {
        let t = new SortedSet(FieldPath$1.comparator);
        for (const e of this.fields) t = t.add(e);
        for (const n of e) t = t.add(n);
        return new FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */    covers(e) {
        for (const t of this.fields) if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return __PRIVATE_arrayEquals(this.fields, e.fields, ((e, t) => e.isEqual(t)));
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An error encountered while decoding base64 string.
 */ class __PRIVATE_Base64DecodeError extends Error {
    constructor() {
        super(...arguments), this.name = "Base64DecodeError";
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Converts a Base64 encoded string to a binary string. */
/** True if and only if the Base64 conversion functions are available. */
function __PRIVATE_isBase64Available() {
    return "undefined" != typeof atob;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class ByteString {
    constructor(e) {
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new __PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }
        /** Converts a binary string to a Base64 encoded string. */ (e);
        return new ByteString(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = 
        /**
 * Helper function to convert an Uint8array to a binary string.
 */
        function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for (let n = 0; n < e.length; ++n) t += String.fromCharCode(e[n]);
            return t;
        }
        /**
 * Helper function to convert a binary string to an Uint8Array.
 */ (e);
        return new ByteString(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: () => e < this.binaryString.length ? {
                value: this.binaryString.charCodeAt(e++),
                done: !1
            } : {
                value: void 0,
                done: !0
            }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
            return t;
        }
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
        // A RegExp matching ISO 8601 UTC timestamps with optional fraction.
        (this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return __PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}

ByteString.EMPTY_BYTE_STRING = new ByteString("");

const ne = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);

/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function __PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if (__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = ne.exec(e);
        if (__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
                const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: __PRIVATE_normalizeNumber(e.seconds),
        nanos: __PRIVATE_normalizeNumber(e.nanos)
    };
}

/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function __PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}

/** Converts the possible Proto types for Blobs into a ByteString. */ function __PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? ByteString.fromBase64String(e) : ByteString.fromUint8Array(e);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function __PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}

/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */
/**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */
function __PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields.__previous_value__;
    return __PRIVATE_isServerTimestamp(t) ? __PRIVATE_getPreviousValue(t) : t;
}

/**
 * Returns the local time at which this timestamp was first set.
 */ function __PRIVATE_getLocalWriteTime(e) {
    const t = __PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new Timestamp(t.seconds, t.nanos);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */
    constructor(e, t, n, r, i, s, o, _, a) {
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, 
        this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, 
        this.useFetchStreams = a;
    }
}

/** The default database name for a project. */
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */
class DatabaseId {
    constructor(e, t) {
        this.projectId = e, this.database = t || "(default)";
    }
    static empty() {
        return new DatabaseId("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(e) {
        return e instanceof DatabaseId && e.projectId === this.projectId && e.database === this.database;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const re = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, ie = {
    nullValue: "NULL_VALUE"
};

/** Extracts the backend's type order for the provided value. */
function __PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */ : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */ : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */ : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */ : "stringValue" in e ? 5 /* TypeOrder.StringValue */ : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */ : "referenceValue" in e ? 7 /* TypeOrder.RefValue */ : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */ : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */ : "mapValue" in e ? __PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */ : __PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */ : __PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */ : 11 /* TypeOrder.ObjectValue */ : fail();
}

/** Tests `left` and `right` for equality based on the backend semantics. */ function __PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = __PRIVATE_typeOrder(e);
    if (n !== __PRIVATE_typeOrder(t)) return !1;
    switch (n) {
      case 0 /* TypeOrder.NullValue */ :
      case 9007199254740991 /* TypeOrder.MaxValue */ :
        return !0;

      case 1 /* TypeOrder.BooleanValue */ :
        return e.booleanValue === t.booleanValue;

      case 4 /* TypeOrder.ServerTimestampValue */ :
        return __PRIVATE_getLocalWriteTime(e).isEqual(__PRIVATE_getLocalWriteTime(t));

      case 3 /* TypeOrder.TimestampValue */ :
        return function __PRIVATE_timestampEquals(e, t) {
            if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) 
            // Use string equality for ISO 8601 timestamps
            return e.timestampValue === t.timestampValue;
            const n = __PRIVATE_normalizeTimestamp(e.timestampValue), r = __PRIVATE_normalizeTimestamp(t.timestampValue);
            return n.seconds === r.seconds && n.nanos === r.nanos;
        }(e, t);

      case 5 /* TypeOrder.StringValue */ :
        return e.stringValue === t.stringValue;

      case 6 /* TypeOrder.BlobValue */ :
        return function __PRIVATE_blobEquals(e, t) {
            return __PRIVATE_normalizeByteString(e.bytesValue).isEqual(__PRIVATE_normalizeByteString(t.bytesValue));
        }(e, t);

      case 7 /* TypeOrder.RefValue */ :
        return e.referenceValue === t.referenceValue;

      case 8 /* TypeOrder.GeoPointValue */ :
        return function __PRIVATE_geoPointEquals(e, t) {
            return __PRIVATE_normalizeNumber(e.geoPointValue.latitude) === __PRIVATE_normalizeNumber(t.geoPointValue.latitude) && __PRIVATE_normalizeNumber(e.geoPointValue.longitude) === __PRIVATE_normalizeNumber(t.geoPointValue.longitude);
        }(e, t);

      case 2 /* TypeOrder.NumberValue */ :
        return function __PRIVATE_numberEquals(e, t) {
            if ("integerValue" in e && "integerValue" in t) return __PRIVATE_normalizeNumber(e.integerValue) === __PRIVATE_normalizeNumber(t.integerValue);
            if ("doubleValue" in e && "doubleValue" in t) {
                const n = __PRIVATE_normalizeNumber(e.doubleValue), r = __PRIVATE_normalizeNumber(t.doubleValue);
                return n === r ? __PRIVATE_isNegativeZero(n) === __PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
            }
            return !1;
        }(e, t);

      case 9 /* TypeOrder.ArrayValue */ :
        return __PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], __PRIVATE_valueEquals);

      case 10 /* TypeOrder.VectorValue */ :
      case 11 /* TypeOrder.ObjectValue */ :
        return function __PRIVATE_objectEquals(e, t) {
            const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
            if (__PRIVATE_objectSize(n) !== __PRIVATE_objectSize(r)) return !1;
            for (const e in n) if (n.hasOwnProperty(e) && (void 0 === r[e] || !__PRIVATE_valueEquals(n[e], r[e]))) return !1;
            return !0;
        }
        /** Returns true if the ArrayValue contains the specified element. */ (e, t);

      default:
        return fail();
    }
}

function __PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e => __PRIVATE_valueEquals(e, t)));
}

function __PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = __PRIVATE_typeOrder(e), r = __PRIVATE_typeOrder(t);
    if (n !== r) return __PRIVATE_primitiveComparator(n, r);
    switch (n) {
      case 0 /* TypeOrder.NullValue */ :
      case 9007199254740991 /* TypeOrder.MaxValue */ :
        return 0;

      case 1 /* TypeOrder.BooleanValue */ :
        return __PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);

      case 2 /* TypeOrder.NumberValue */ :
        return function __PRIVATE_compareNumbers(e, t) {
            const n = __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = __PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
            return n < r ? -1 : n > r ? 1 : n === r ? 0 : 
            // one or both are NaN.
            isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
        }(e, t);

      case 3 /* TypeOrder.TimestampValue */ :
        return __PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);

      case 4 /* TypeOrder.ServerTimestampValue */ :
        return __PRIVATE_compareTimestamps(__PRIVATE_getLocalWriteTime(e), __PRIVATE_getLocalWriteTime(t));

      case 5 /* TypeOrder.StringValue */ :
        return __PRIVATE_primitiveComparator(e.stringValue, t.stringValue);

      case 6 /* TypeOrder.BlobValue */ :
        return function __PRIVATE_compareBlobs(e, t) {
            const n = __PRIVATE_normalizeByteString(e), r = __PRIVATE_normalizeByteString(t);
            return n.compareTo(r);
        }(e.bytesValue, t.bytesValue);

      case 7 /* TypeOrder.RefValue */ :
        return function __PRIVATE_compareReferences(e, t) {
            const n = e.split("/"), r = t.split("/");
            for (let e = 0; e < n.length && e < r.length; e++) {
                const t = __PRIVATE_primitiveComparator(n[e], r[e]);
                if (0 !== t) return t;
            }
            return __PRIVATE_primitiveComparator(n.length, r.length);
        }(e.referenceValue, t.referenceValue);

      case 8 /* TypeOrder.GeoPointValue */ :
        return function __PRIVATE_compareGeoPoints(e, t) {
            const n = __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(t.latitude));
            if (0 !== n) return n;
            return __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.longitude), __PRIVATE_normalizeNumber(t.longitude));
        }(e.geoPointValue, t.geoPointValue);

      case 9 /* TypeOrder.ArrayValue */ :
        return __PRIVATE_compareArrays(e.arrayValue, t.arrayValue);

      case 10 /* TypeOrder.VectorValue */ :
        return function __PRIVATE_compareVectors(e, t) {
            var n, r, i, s;
            const o = e.fields || {}, _ = t.fields || {}, a = null === (n = o.value) || void 0 === n ? void 0 : n.arrayValue, u = null === (r = _.value) || void 0 === r ? void 0 : r.arrayValue, c = __PRIVATE_primitiveComparator((null === (i = null == a ? void 0 : a.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == u ? void 0 : u.values) || void 0 === s ? void 0 : s.length) || 0);
            if (0 !== c) return c;
            return __PRIVATE_compareArrays(a, u);
        }(e.mapValue, t.mapValue);

      case 11 /* TypeOrder.ObjectValue */ :
        return function __PRIVATE_compareMaps(e, t) {
            if (e === re.mapValue && t === re.mapValue) return 0;
            if (e === re.mapValue) return 1;
            if (t === re.mapValue) return -1;
            const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
            // Even though MapValues are likely sorted correctly based on their insertion
            // order (e.g. when received from the backend), local modifications can bring
            // elements out of order. We need to re-sort the elements to ensure that
            // canonical IDs are independent of insertion order.
            r.sort(), s.sort();
            for (let e = 0; e < r.length && e < s.length; ++e) {
                const t = __PRIVATE_primitiveComparator(r[e], s[e]);
                if (0 !== t) return t;
                const o = __PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                if (0 !== o) return o;
            }
            return __PRIVATE_primitiveComparator(r.length, s.length);
        }
        /**
 * Generates the canonical ID for the provided field value (as used in Target
 * serialization).
 */ (e.mapValue, t.mapValue);

      default:
        throw fail();
    }
}

function __PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return __PRIVATE_primitiveComparator(e, t);
    const n = __PRIVATE_normalizeTimestamp(e), r = __PRIVATE_normalizeTimestamp(t), i = __PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : __PRIVATE_primitiveComparator(n.nanos, r.nanos);
}

function __PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for (let e = 0; e < n.length && e < r.length; ++e) {
        const t = __PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return __PRIVATE_primitiveComparator(n.length, r.length);
}

function canonicalId(e) {
    return __PRIVATE_canonifyValue(e);
}

function __PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = __PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return __PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return DocumentKey.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || []) n ? n = !1 : t += ",", t += __PRIVATE_canonifyValue(r);
        return t + "]";
    }
    /**
 * Returns an approximate (and wildly inaccurate) in-memory size for the field
 * value.
 *
 * The memory size takes into account only the actual user data as it resides
 * in memory and ignores object overhead.
 */ (e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t) r ? r = !1 : n += ",", n += `${i}:${__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : fail();
}

function __PRIVATE_estimateByteSize(e) {
    switch (__PRIVATE_typeOrder(e)) {
      case 0 /* TypeOrder.NullValue */ :
      case 1 /* TypeOrder.BooleanValue */ :
        return 4;

      case 2 /* TypeOrder.NumberValue */ :
        return 8;

      case 3 /* TypeOrder.TimestampValue */ :
      case 8 /* TypeOrder.GeoPointValue */ :
        // GeoPoints are made up of two distinct numbers (latitude + longitude)
        return 16;

      case 4 /* TypeOrder.ServerTimestampValue */ :
        const t = __PRIVATE_getPreviousValue(e);
        return t ? 16 + __PRIVATE_estimateByteSize(t) : 16;

      case 5 /* TypeOrder.StringValue */ :
        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
        // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
        // integer values"
        return 2 * e.stringValue.length;

      case 6 /* TypeOrder.BlobValue */ :
        return __PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();

      case 7 /* TypeOrder.RefValue */ :
        return e.referenceValue.length;

      case 9 /* TypeOrder.ArrayValue */ :
        return function __PRIVATE_estimateArrayByteSize(e) {
            return (e.values || []).reduce(((e, t) => e + __PRIVATE_estimateByteSize(t)), 0);
        }
        /** Returns a reference value for the provided database and key. */ (e.arrayValue);

      case 10 /* TypeOrder.VectorValue */ :
      case 11 /* TypeOrder.ObjectValue */ :
        return function __PRIVATE_estimateMapByteSize(e) {
            let t = 0;
            return forEach(e.fields, ((e, n) => {
                t += e.length + __PRIVATE_estimateByteSize(n);
            })), t;
        }(e.mapValue);

      default:
        throw fail();
    }
}

function __PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}

/** Returns true if `value` is an IntegerValue . */ function isInteger(e) {
    return !!e && "integerValue" in e;
}

/** Returns true if `value` is a DoubleValue. */
/** Returns true if `value` is an ArrayValue. */
function isArray(e) {
    return !!e && "arrayValue" in e;
}

/** Returns true if `value` is a NullValue. */ function __PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}

/** Returns true if `value` is NaN. */ function __PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}

/** Returns true if `value` is a MapValue. */ function __PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}

/** Returns true if `value` is a VetorValue. */ function __PRIVATE_isVectorValue(e) {
    var t, n;
    return "__vector__" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}

/** Creates a deep copy of `source`. */ function __PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return forEach(e.mapValue.fields, ((e, n) => t.mapValue.fields[e] = __PRIVATE_deepClone(n))), 
        t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for (let n = 0; n < (e.arrayValue.values || []).length; ++n) t.arrayValue.values[n] = __PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}

/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function __PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}

const se = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__vector__"
            },
            value: {
                arrayValue: {}
            }
        }
    }
};

/** Returns the lowest value for the given value type (inclusive). */ function __PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? ie : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? __PRIVATE_isVectorValue(e) ? se : {
        mapValue: {}
    } : fail();
}

/** Returns the largest value for the given value type (exclusive). */ function __PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? se : "mapValue" in e ? __PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : re : fail();
}

function __PRIVATE_lowerBoundCompare(e, t) {
    const n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}

function __PRIVATE_upperBoundCompare(e, t) {
    const n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class ObjectValue {
    constructor(e) {
        this.value = e;
    }
    static empty() {
        return new ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */    field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for (let n = 0; n < e.length - 1; ++n) if (t = (t.mapValue.fields || {})[e.get(n)], 
            !__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */    set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = __PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */    setAll(e) {
        let t = FieldPath$1.emptyPath(), n = {}, r = [];
        e.forEach(((e, i) => {
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = __PRIVATE_deepClone(e) : r.push(i.lastSegment());
        }));
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */    delete(e) {
        const t = this.field(e.popLast());
        __PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return __PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */    getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for (let n = 0; n < e.length; ++n) {
            let r = t.mapValue.fields[e.get(n)];
            __PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */    applyChanges(e, t, n) {
        forEach(t, ((t, n) => e[t] = n));
        for (const t of n) delete e[t];
    }
    clone() {
        return new ObjectValue(__PRIVATE_deepClone(this.value));
    }
}

/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function __PRIVATE_extractFieldMask(e) {
    const t = [];
    return forEach(e.fields, ((e, n) => {
        const r = new FieldPath$1([ e ]);
        if (__PRIVATE_isMapValue(n)) {
            const e = __PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) 
            // Preserve the empty map by adding it to the FieldMask.
            t.push(r); else 
            // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e) t.push(r.child(n));
        } else 
        // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    })), new FieldMask(t);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class MutableDocument {
    constructor(e, t, n, r, i, s, o) {
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, 
        this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */    static newInvalidDocument(e) {
        return new MutableDocument(e, 0 /* DocumentType.INVALID */ , 
        /* version */ SnapshotVersion.min(), 
        /* readTime */ SnapshotVersion.min(), 
        /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */);
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */    static newFoundDocument(e, t, n, r) {
        return new MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , 
        /* version */ t, 
        /* readTime */ SnapshotVersion.min(), 
        /* createTime */ n, r, 0 /* DocumentState.SYNCED */);
    }
    /** Creates a new document that is known to not exist at the given version. */    static newNoDocument(e, t) {
        return new MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , 
        /* version */ t, 
        /* readTime */ SnapshotVersion.min(), 
        /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */);
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */    static newUnknownDocument(e, t) {
        return new MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , 
        /* version */ t, 
        /* readTime */ SnapshotVersion.min(), 
        /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */);
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */    convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual(SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */ !== this.documentType && 0 /* DocumentType.INVALID */ !== this.documentType || (this.createTime = e), 
        this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, 
        this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */    convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , 
        this.data = ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , 
        this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */    convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , 
        this.data = ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , 
        this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = SnapshotVersion.min(), 
        this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */ !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */ === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */ === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */ === this.documentType;
    }
    isEqual(e) {
        return e instanceof MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}

/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */
class Bound {
    constructor(e, t) {
        this.position = e, this.inclusive = t;
    }
}

function __PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for (let i = 0; i < e.position.length; i++) {
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = DocumentKey.comparator(DocumentKey.fromName(o.referenceValue), n.key); else {
            r = __PRIVATE_valueCompare(o, n.data.field(s.field));
        }
        if ("desc" /* Direction.DESCENDING */ === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}

/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function __PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for (let n = 0; n < e.position.length; n++) {
        if (!__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */) {
        this.field = e, this.dir = t;
    }
}

function __PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Filter {}

class FieldFilter extends Filter {
    constructor(e, t, n) {
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */    static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */ === t || "not-in" /* Operator.NOT_IN */ === t ? this.createKeyFieldInFilter(e, t, n) : new __PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */ === t ? new __PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */ === t ? new __PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */ === t ? new __PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ === t ? new __PRIVATE_ArrayContainsAnyFilter(e, n) : new FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */ === t ? new __PRIVATE_KeyFieldInFilter(e, n) : new __PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
                return "!=" /* Operator.NOT_EQUAL */ === this.op ? null !== t && this.matchesComparison(__PRIVATE_valueCompare(t, this.value)) : null !== t && __PRIVATE_typeOrder(this.value) === __PRIVATE_typeOrder(t) && this.matchesComparison(__PRIVATE_valueCompare(t, this.value));
        // Only compare types with matching backend order (such as double and int).
        }
    matchesComparison(e) {
        switch (this.op) {
          case "<" /* Operator.LESS_THAN */ :
            return e < 0;

          case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
            return e <= 0;

          case "==" /* Operator.EQUAL */ :
            return 0 === e;

          case "!=" /* Operator.NOT_EQUAL */ :
            return 0 !== e;

          case ">" /* Operator.GREATER_THAN */ :
            return e > 0;

          case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            return e >= 0;

          default:
            return fail();
        }
    }
    isInequality() {
        return [ "<" /* Operator.LESS_THAN */ , "<=" /* Operator.LESS_THAN_OR_EQUAL */ , ">" /* Operator.GREATER_THAN */ , ">=" /* Operator.GREATER_THAN_OR_EQUAL */ , "!=" /* Operator.NOT_EQUAL */ , "not-in" /* Operator.NOT_IN */ ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [ this ];
    }
    getFilters() {
        return [ this ];
    }
}

class CompositeFilter extends Filter {
    constructor(e, t) {
        super(), this.filters = e, this.op = t, this.ae = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */    static create(e, t) {
        return new CompositeFilter(e, t);
    }
    matches(e) {
        return __PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t => !t.matches(e))) : void 0 !== this.filters.find((t => t.matches(e)));
    }
    getFlattenedFilters() {
        return null !== this.ae || (this.ae = this.filters.reduce(((e, t) => e.concat(t.getFlattenedFilters())), [])), 
        this.ae;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}

function __PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */ === e.op;
}

function __PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */ === e.op;
}

/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlatConjunction(e) {
    return __PRIVATE_compositeFilterIsFlat(e) && __PRIVATE_compositeFilterIsConjunction(e);
}

/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters) if (t instanceof CompositeFilter) return !1;
    return !0;
}

function __PRIVATE_canonifyFilter(e) {
    if (e instanceof FieldFilter) 
    // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + canonicalId(e.value);
    if (__PRIVATE_compositeFilterIsFlatConjunction(e)) 
    // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e => __PRIVATE_canonifyFilter(e))).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e => __PRIVATE_canonifyFilter(e))).join(",");
        return `${e.op}(${t})`;
    }
}

function __PRIVATE_filterEquals(e, t) {
    return e instanceof FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof FieldFilter && e.op === t.op && e.field.isEqual(t.field) && __PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) {
            return e.filters.reduce(((e, n, r) => e && __PRIVATE_filterEquals(n, t.filters[r])), !0);
        }
        return !1;
    }
    /**
 * Returns a new composite filter that contains all filter from
 * `compositeFilter` plus all the given filters in `otherFilters`.
 */ (e, t) : void fail();
}

function __PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return CompositeFilter.create(n, e.op);
}

/** Returns a debug description for `filter`. */ function __PRIVATE_stringifyFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${canonicalId(e.value)}`;
    }
    /** Filter that matches on key fields (i.e. '__name__'). */ (e) : e instanceof CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map(__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}

class __PRIVATE_KeyFieldFilter extends FieldFilter {
    constructor(e, t, n) {
        super(e, t, n), this.key = DocumentKey.fromName(n.referenceValue);
    }
    matches(e) {
        const t = DocumentKey.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}

/** Filter that matches on key fields within an array. */ class __PRIVATE_KeyFieldInFilter extends FieldFilter {
    constructor(e, t) {
        super(e, "in" /* Operator.IN */ , t), this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t => t.isEqual(e.key)));
    }
}

/** Filter that matches on key fields not present within an array. */ class __PRIVATE_KeyFieldNotInFilter extends FieldFilter {
    constructor(e, t) {
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t => t.isEqual(e.key)));
    }
}

function __PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e => DocumentKey.fromName(e.referenceValue)));
}

/** A Filter that implements the array-contains operator. */ class __PRIVATE_ArrayContainsFilter extends FieldFilter {
    constructor(e, t) {
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return isArray(t) && __PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}

/** A Filter that implements the IN operator. */ class __PRIVATE_InFilter extends FieldFilter {
    constructor(e, t) {
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && __PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}

/** A Filter that implements the not-in operator. */ class __PRIVATE_NotInFilter extends FieldFilter {
    constructor(e, t) {
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if (__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && !__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}

/** A Filter that implements the array-contains-any operator. */ class __PRIVATE_ArrayContainsAnyFilter extends FieldFilter {
    constructor(e, t) {
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e => __PRIVATE_arrayValueContains(this.value.arrayValue, e)));
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Visible for testing
class __PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null) {
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, 
        this.startAt = s, this.endAt = o, this.ue = null;
    }
}

/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function __PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new __PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}

function __PRIVATE_canonifyTarget(e) {
    const t = __PRIVATE_debugCast(e);
    if (null === t.ue) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e => __PRIVATE_canonifyFilter(e))).join(","), 
        e += "|ob:", e += t.orderBy.map((e => function __PRIVATE_canonifyOrderBy(e) {
            // TODO(b/29183165): Make this collision robust.
            return e.field.canonicalString() + e.dir;
        }(e))).join(","), __PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), 
        t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e => canonicalId(e))).join(",")), 
        t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e => canonicalId(e))).join(",")), 
        t.ue = e;
    }
    return t.ue;
}

function __PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for (let n = 0; n < e.orderBy.length; n++) if (!__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for (let n = 0; n < e.filters.length; n++) if (!__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && (!!e.path.isEqual(t.path) && (!!__PRIVATE_boundEquals(e.startAt, t.startAt) && __PRIVATE_boundEquals(e.endAt, t.endAt)));
}

function __PRIVATE_targetIsDocumentTarget(e) {
    return DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}

/** Returns the field filters that target the given field path. */ function __PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e => e instanceof FieldFilter && e.field.isEqual(t)));
}

/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */
/**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */
function __PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = ie, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of __PRIVATE_targetGetFieldFiltersForPath(e, t)) {
        let e = ie, t = !0;
        switch (n.op) {
          case "<" /* Operator.LESS_THAN */ :
          case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
            e = __PRIVATE_valuesGetLowerBound(n.value);
            break;

          case "==" /* Operator.EQUAL */ :
          case "in" /* Operator.IN */ :
          case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            e = n.value;
            break;

          case ">" /* Operator.GREATER_THAN */ :
            e = n.value, t = !1;
            break;

          case "!=" /* Operator.NOT_EQUAL */ :
          case "not-in" /* Operator.NOT_IN */ :
            e = ie;
 // Remaining filters cannot be used as lower bounds.
                }
        __PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
        if (null !== n) for (let s = 0; s < e.orderBy.length; ++s) {
        if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            __PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}

/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function __PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = re, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of __PRIVATE_targetGetFieldFiltersForPath(e, t)) {
        let e = re, t = !0;
        switch (n.op) {
          case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
          case ">" /* Operator.GREATER_THAN */ :
            e = __PRIVATE_valuesGetUpperBound(n.value), t = !1;
            break;

          case "==" /* Operator.EQUAL */ :
          case "in" /* Operator.IN */ :
          case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
            e = n.value;
            break;

          case "<" /* Operator.LESS_THAN */ :
            e = n.value, t = !1;
            break;

          case "!=" /* Operator.NOT_EQUAL */ :
          case "not-in" /* Operator.NOT_IN */ :
            e = re;
 // Remaining filters cannot be used as upper bounds.
                }
        __PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
        if (null !== n) for (let s = 0; s < e.orderBy.length; ++s) {
        if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            __PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}

/** Returns the number of segments of a perfect index for this target. */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */
class __PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */
    constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null) {
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, 
        this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.ce = null, 
        // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.le = null, 
        // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.he = null, this.startAt, this.endAt;
    }
}

/** Creates a new Query instance with the options provided. */ function __PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new __PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}

/** Creates a new Query for a query that matches all documents at `path` */ function __PRIVATE_newQueryForPath(e) {
    return new __PRIVATE_QueryImpl(e);
}

/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */
/**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */
function __PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}

// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */
function __PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}

/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function __PRIVATE_queryNormalizedOrderBy(e) {
    const t = __PRIVATE_debugCast(e);
    if (null === t.ce) {
        t.ce = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
                for (const n of t.explicitOrderBy) t.ce.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
                const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new SortedSet(FieldPath$1.comparator);
            return e.filters.forEach((e => {
                e.getFlattenedFilters().forEach((e => {
                    e.isInequality() && (t = t.add(e.field));
                }));
            })), t;
        }
        /**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ (t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
                r.forEach((r => {
            e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new OrderBy(r, n));
        })), 
        // Add the document key field to the last if it is not explicitly ordered.
        e.has(FieldPath$1.keyField().canonicalString()) || t.ce.push(new OrderBy(FieldPath$1.keyField(), n));
    }
    return t.ce;
}

/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function __PRIVATE_queryToTarget(e) {
    const t = __PRIVATE_debugCast(e);
    return t.le || (t.le = __PRIVATE__queryToTarget(t, __PRIVATE_queryNormalizedOrderBy(e))), 
    t.le;
}

/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function __PRIVATE_queryToAggregateTarget(e) {
    const t = __PRIVATE_debugCast(e);
    return t.he || (
    // Do not include implicit order-bys for aggregate queries.
    t.he = __PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.he;
}

function __PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */ === e.limitType) return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e => {
            const t = "desc" /* Direction.DESCENDING */ === e.dir ? "asc" /* Direction.ASCENDING */ : "desc" /* Direction.DESCENDING */;
            return new OrderBy(e.field, t);
        }));
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}

function __PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([ t ]);
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}

function __PRIVATE_queryWithLimit(e, t, n) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}

function __PRIVATE_queryEquals(e, t) {
    return __PRIVATE_targetEquals(__PRIVATE_queryToTarget(e), __PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}

// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function __PRIVATE_canonifyQuery(e) {
    return `${__PRIVATE_canonifyTarget(__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}

function __PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), 
        e.filters.length > 0 && (t += `, filters: [${e.filters.map((e => __PRIVATE_stringifyFilter(e))).join(", ")}]`), 
        __PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e => function __PRIVATE_stringifyOrderBy(e) {
            return `${e.field.canonicalString()} (${e.dir})`;
        }(e))).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", 
        t += e.startAt.position.map((e => canonicalId(e))).join(",")), e.endAt && (t += ", endAt: ", 
        t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e => canonicalId(e))).join(",")), 
        `Target(${t})`;
    }(__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}

/** Returns whether `doc` matches the constraints of `query`. */ function __PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : DocumentKey.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }
    /**
 * A document must have a value for every ordering clause in order to show up
 * in the results.
 */ (e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of __PRIVATE_queryNormalizedOrderBy(e)) 
        // order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters) if (!n.matches(t)) return !1;
        return !0;
    }
    /** Makes sure a document is within the bounds, if provided. */ (e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !
        /**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */
        function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }
    /**
 * Returns the collection group that this query targets.
 *
 * PORTING NOTE: This is only used in the Web SDK to facilitate multi-tab
 * synchronization for query results.
 */ (e, t);
}

function __PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}

/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function __PRIVATE_newQueryComparator(e) {
    return (t, n) => {
        let r = !1;
        for (const i of __PRIVATE_queryNormalizedOrderBy(e)) {
            const e = __PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}

function __PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? DocumentKey.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? __PRIVATE_valueCompare(r, i) : fail();
    }(e.field, t, n);
    switch (e.dir) {
      case "asc" /* Direction.ASCENDING */ :
        return r;

      case "desc" /* Direction.DESCENDING */ :
        return -1 * r;

      default:
        return fail();
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class ObjectMap {
    constructor(e, t) {
        this.mapKeyFn = e, this.equalsFn = t, 
        /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */
        this.inner = {}, 
        /** The number of entries stored in the map */
        this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */    get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) for (const [t, r] of n) if (this.equalsFn(t, e)) return r;
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */    set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [ [ e, t ] ], void this.innerSize++;
        for (let n = 0; n < r.length; n++) if (this.equalsFn(r[n][0], e)) 
        // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [ e, t ]);
        r.push([ e, t ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */    delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for (let r = 0; r < n.length; r++) if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), 
        this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        forEach(this.inner, ((t, n) => {
            for (const [t, r] of n) e(t, r);
        }));
    }
    isEmpty() {
        return isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const oe = new SortedMap(DocumentKey.comparator);

function __PRIVATE_mutableDocumentMap() {
    return oe;
}

const _e = new SortedMap(DocumentKey.comparator);

function documentMap(...e) {
    let t = _e;
    for (const n of e) t = t.insert(n.key, n);
    return t;
}

function __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = _e;
    return e.forEach(((e, n) => t = t.insert(e, n.overlayedDocument))), t;
}

function __PRIVATE_newOverlayMap() {
    return __PRIVATE_newDocumentKeyMap();
}

function __PRIVATE_newMutationMap() {
    return __PRIVATE_newDocumentKeyMap();
}

function __PRIVATE_newDocumentKeyMap() {
    return new ObjectMap((e => e.toString()), ((e, t) => e.isEqual(t)));
}

const ae = new SortedMap(DocumentKey.comparator);

const ue = new SortedSet(DocumentKey.comparator);

function __PRIVATE_documentKeySet(...e) {
    let t = ue;
    for (const n of e) t = t.add(n);
    return t;
}

const ce = new SortedSet(__PRIVATE_primitiveComparator);

function __PRIVATE_targetIdSet() {
    return ce;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function __PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: __PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}

/**
 * Returns an IntegerValue for `value`.
 */ function __PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}

/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function toNumber(e, t) {
    return isSafeInteger(t) ? __PRIVATE_toInteger(t) : __PRIVATE_toDouble(e, t);
}

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Used to represent a field transform on a mutation. */ class TransformOperation {
    constructor() {
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}

/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function __PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof __PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
                return t && __PRIVATE_isServerTimestamp(t) && (t = __PRIVATE_getPreviousValue(t)), 
        t && (n.fields.__previous_value__ = t), {
            mapValue: n
        };
    }(n, t) : e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = __PRIVATE_computeTransformOperationBaseValue(e, t), r = asNumber(n) + asNumber(e.Pe);
        return isInteger(n) && isInteger(e.Pe) ? __PRIVATE_toInteger(r) : __PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}

/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function __PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}

/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function __PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof __PRIVATE_NumericIncrementTransformOperation ? 
    /** Returns true if `value` is either an IntegerValue or a DoubleValue. */
    function __PRIVATE_isNumber(e) {
        return isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}

/** Transforms a value into a server-generated timestamp. */
class __PRIVATE_ServerTimestampTransform extends TransformOperation {}

/** Transforms an array value via a union operation. */ class __PRIVATE_ArrayUnionTransformOperation extends TransformOperation {
    constructor(e) {
        super(), this.elements = e;
    }
}

function __PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = __PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements) n.some((e => __PRIVATE_valueEquals(e, t))) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}

/** Transforms an array value via a remove operation. */ class __PRIVATE_ArrayRemoveTransformOperation extends TransformOperation {
    constructor(e) {
        super(), this.elements = e;
    }
}

function __PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = __PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements) n = n.filter((e => !__PRIVATE_valueEquals(e, t)));
    return {
        arrayValue: {
            values: n
        }
    };
}

/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class __PRIVATE_NumericIncrementTransformOperation extends TransformOperation {
    constructor(e, t) {
        super(), this.serializer = e, this.Pe = t;
    }
}

function asNumber(e) {
    return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}

function __PRIVATE_coercedFieldValuesArray(e) {
    return isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** A field path and the TransformOperation to perform upon it. */ class FieldTransform {
    constructor(e, t) {
        this.field = e, this.transform = t;
    }
}

function __PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof __PRIVATE_ArrayUnionTransformOperation && t instanceof __PRIVATE_ArrayUnionTransformOperation || e instanceof __PRIVATE_ArrayRemoveTransformOperation && t instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_arrayEquals(e.elements, t.elements, __PRIVATE_valueEquals) : e instanceof __PRIVATE_NumericIncrementTransformOperation && t instanceof __PRIVATE_NumericIncrementTransformOperation ? __PRIVATE_valueEquals(e.Pe, t.Pe) : e instanceof __PRIVATE_ServerTimestampTransform && t instanceof __PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}

/** The result of successfully applying a mutation to the backend. */
class MutationResult {
    constructor(
    /**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */
    e, 
    /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */
    t) {
        this.version = e, this.transformResults = t;
    }
}

/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class Precondition {
    constructor(e, t) {
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */    static none() {
        return new Precondition;
    }
    /** Creates a new Precondition with an exists flag. */    static exists(e) {
        return new Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */    static updateTime(e) {
        return new Precondition(e);
    }
    /** Returns whether this Precondition is empty. */    get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}

/** Returns true if the preconditions is valid for the given document. */ function __PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}

/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class Mutation {}

/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function __PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
        if (null === t) return e.isNoDocument() ? new __PRIVATE_DeleteMutation(e.key, Precondition.none()) : new __PRIVATE_SetMutation(e.key, e.data, Precondition.none());
    {
        const n = e.data, r = ObjectValue.empty();
        let i = new SortedSet(FieldPath$1.comparator);
        for (let e of t.fields) if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
                        null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), 
            i = i.add(e);
        }
        return new __PRIVATE_PatchMutation(e.key, r, new FieldMask(i.toArray()), Precondition.none());
    }
}

/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function __PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) 
        // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll(__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}

/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function __PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) 
        // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = __PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), 
        null;
 // SetMutation overwrites all fields.
        }
    /**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */ (e, t, n, r) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = __PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll(__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), 
        null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e => e.field)));
    }
    /**
 * Returns a FieldPath/Value map with the content of the PatchMutation.
 */ (e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if (__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), 
        null;
        return n;
    }
    /**
 * A mutation that verifies the existence of the document at the given key with
 * the provided precondition.
 *
 * The `verify` operation is only used in Transactions, and this class serves
 * primarily to facilitate serialization into protos.
 */ (e, t, n);
}

/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function __PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms) {
        const e = t.data.field(r.field), i = __PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}

function __PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && (!!e.key.isEqual(t.key) && (!!e.precondition.isEqual(t.precondition) && (!!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && __PRIVATE_arrayEquals(e, t, ((e, t) => __PRIVATE_fieldTransformEquals(e, t)));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */ === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */ !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask)))));
}

/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class __PRIVATE_SetMutation extends Mutation {
    constructor(e, t, n, r = []) {
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, 
        this.type = 0 /* MutationType.Set */;
    }
    getFieldMask() {
        return null;
    }
}

class __PRIVATE_PatchMutation extends Mutation {
    constructor(e, t, n, r, i = []) {
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, 
        this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}

function __PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n => {
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    })), t;
}

/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function __PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    __PRIVATE_hardAssert(e.length === n.length);
    for (let i = 0; i < n.length; i++) {
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, __PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}

/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function __PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e) {
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, __PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}

/** A mutation that deletes the document at the given key. */ class __PRIVATE_DeleteMutation extends Mutation {
    constructor(e, t) {
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , 
        this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}

class __PRIVATE_VerifyMutation extends Mutation {
    constructor(e, t) {
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , 
        this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */
    constructor(e, t, n, r) {
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */    applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for (let t = 0; t < this.mutations.length; t++) {
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) {
                __PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
            }
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */    applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations) n.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
                for (const n of this.mutations) n.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */    applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = __PRIVATE_newMutationMap();
        return this.mutations.forEach((r => {
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
                        let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
                        o = t.has(r.key) ? null : o;
            const _ = __PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument(SnapshotVersion.min());
        })), n;
    }
    keys() {
        return this.mutations.reduce(((e, t) => e.add(t.key)), __PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && __PRIVATE_arrayEquals(this.mutations, e.mutations, ((e, t) => __PRIVATE_mutationEquals(e, t))) && __PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, ((e, t) => __PRIVATE_mutationEquals(e, t)));
    }
}

/** The result of applying a mutation batch to the backend. */ class MutationBatchResult {
    constructor(e, t, n, 
    /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */
    r) {
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */    static from(e, t, n) {
        __PRIVATE_hardAssert(e.mutations.length === n.length);
        let r = function __PRIVATE_documentVersionMap() {
            return ae;
        }();
        const i = e.mutations;
        for (let e = 0; e < i.length; e++) r = r.insert(i[e].key, n[e].version);
        return new MutationBatchResult(e, t, n, r);
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class Overlay {
    constructor(e, t) {
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Concrete implementation of the Aggregate type.
 */ class __PRIVATE_AggregateImpl {
    constructor(e, t, n) {
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ExistenceFilter {
    constructor(e, t) {
        this.count = e, this.unchangedNames = t;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var le, he;

/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */
function __PRIVATE_isPermanentError(e) {
    switch (e) {
      default:
        return fail();

      case D.CANCELLED:
      case D.UNKNOWN:
      case D.DEADLINE_EXCEEDED:
      case D.RESOURCE_EXHAUSTED:
      case D.INTERNAL:
      case D.UNAVAILABLE:
 // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
              case D.UNAUTHENTICATED:
        return !1;

      case D.INVALID_ARGUMENT:
      case D.NOT_FOUND:
      case D.ALREADY_EXISTS:
      case D.PERMISSION_DENIED:
      case D.FAILED_PRECONDITION:
 // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
              case D.ABORTED:
      case D.OUT_OF_RANGE:
      case D.UNIMPLEMENTED:
      case D.DATA_LOSS:
        return !0;
    }
}

/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */
/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */
function __PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) 
    // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return __PRIVATE_logError("GRPC error has no .code"), D.UNKNOWN;
    switch (e) {
      case le.OK:
        return D.OK;

      case le.CANCELLED:
        return D.CANCELLED;

      case le.UNKNOWN:
        return D.UNKNOWN;

      case le.DEADLINE_EXCEEDED:
        return D.DEADLINE_EXCEEDED;

      case le.RESOURCE_EXHAUSTED:
        return D.RESOURCE_EXHAUSTED;

      case le.INTERNAL:
        return D.INTERNAL;

      case le.UNAVAILABLE:
        return D.UNAVAILABLE;

      case le.UNAUTHENTICATED:
        return D.UNAUTHENTICATED;

      case le.INVALID_ARGUMENT:
        return D.INVALID_ARGUMENT;

      case le.NOT_FOUND:
        return D.NOT_FOUND;

      case le.ALREADY_EXISTS:
        return D.ALREADY_EXISTS;

      case le.PERMISSION_DENIED:
        return D.PERMISSION_DENIED;

      case le.FAILED_PRECONDITION:
        return D.FAILED_PRECONDITION;

      case le.ABORTED:
        return D.ABORTED;

      case le.OUT_OF_RANGE:
        return D.OUT_OF_RANGE;

      case le.UNIMPLEMENTED:
        return D.UNIMPLEMENTED;

      case le.DATA_LOSS:
        return D.DATA_LOSS;

      default:
        return fail();
    }
}

/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ (he = le || (le = {}))[he.OK = 0] = "OK", he[he.CANCELLED = 1] = "CANCELLED", 
he[he.UNKNOWN = 2] = "UNKNOWN", he[he.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", 
he[he.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", he[he.NOT_FOUND = 5] = "NOT_FOUND", 
he[he.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", he[he.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", 
he[he.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", he[he.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", 
he[he.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", he[he.ABORTED = 10] = "ABORTED", 
he[he.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", he[he.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", 
he[he.INTERNAL = 13] = "INTERNAL", he[he.UNAVAILABLE = 14] = "UNAVAILABLE", he[he.DATA_LOSS = 15] = "DATA_LOSS";

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */
let Pe = null;

/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An instance of the Platform's 'TextEncoder' implementation.
 */
function __PRIVATE_newTextEncoder() {
    return new TextEncoder;
}

/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Te = new Integer([ 4294967295, 4294967295 ], 0);

// Hash a string using md5 hashing algorithm.
function __PRIVATE_getMd5HashValue(e) {
    const t = __PRIVATE_newTextEncoder().encode(e), n = new Md5;
    return n.update(t), new Uint8Array(n.digest());
}

// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function __PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [ new Integer([ n, r ], 0), new Integer([ i, s ], 0) ];
}

class BloomFilter {
    constructor(e, t, n) {
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new __PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new __PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) 
        // Only empty bloom filter can have 0 hash count.
        throw new __PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) 
        // Empty bloom filter should have 0 padding.
        throw new __PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.Te = 8 * e.length - t, 
        // Set the bit count in Integer to avoid repetition in mightContain().
        this.Ie = Integer.fromNumber(this.Te);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Ee(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply(Integer.fromNumber(n)));
        // Wrap if hash value overflow 64bit.
                return 1 === r.compare(Te) && (r = new Integer([ r.getBits(0), r.getBits(1) ], 0)), 
        r.modulo(this.Ie).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    de(e) {
        return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.Te) return !1;
        const t = __PRIVATE_getMd5HashValue(e), [n, r] = __PRIVATE_get64BitUints(t);
        for (let e = 0; e < this.hashCount; e++) {
            const t = this.Ee(n, r, e);
            if (!this.de(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */    static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new BloomFilter(i, r, t);
        return n.forEach((e => s.insert(e))), s;
    }
    insert(e) {
        if (0 === this.Te) return;
        const t = __PRIVATE_getMd5HashValue(e), [n, r] = __PRIVATE_get64BitUints(t);
        for (let e = 0; e < this.hashCount; e++) {
            const t = this.Ee(n, r, e);
            this.Ae(t);
        }
    }
    Ae(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}

class __PRIVATE_BloomFilterError extends Error {
    constructor() {
        super(...arguments), this.name = "BloomFilterError";
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class RemoteEvent {
    constructor(
    /**
     * The snapshot version this event brings us up to, or MIN if not set.
     */
    e, 
    /**
     * A map from target to changes to the target. See TargetChange.
     */
    t, 
    /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */
    n, 
    /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */
    r, 
    /**
     * A set of which document updates are due only to limbo resolution targets.
     */
    i) {
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, 
        this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), 
        new RemoteEvent(SnapshotVersion.min(), r, new SortedMap(__PRIVATE_primitiveComparator), __PRIVATE_mutableDocumentMap(), __PRIVATE_documentKeySet());
    }
}

/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class TargetChange {
    constructor(
    /**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */
    e, 
    /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */
    t, 
    /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */
    n, 
    /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */
    r, 
    /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */
    i) {
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, 
        this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */    static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new TargetChange(n, t, __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet());
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class __PRIVATE_DocumentWatchChange {
    constructor(
    /** The new document applies to all of these targets. */
    e, 
    /** The new document is removed from all of these targets. */
    t, 
    /** The key of the document for this change. */
    n, 
    /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */
    r) {
        this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
    }
}

class __PRIVATE_ExistenceFilterChange {
    constructor(e, t) {
        this.targetId = e, this.me = t;
    }
}

class __PRIVATE_WatchTargetChange {
    constructor(
    /** What kind of change occurred to the watch target. */
    e, 
    /** The target IDs that were added/removed/set. */
    t, 
    /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    n = ByteString.EMPTY_BYTE_STRING
    /** An RPC error indicating why the watch failed. */ , r = null) {
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}

/** Tracks the internal state of a Watch target. */ class __PRIVATE_TargetState {
    constructor() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */
        this.fe = 0, 
        /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */
        this.ge = __PRIVATE_snapshotChangesMap(), 
        /** See public getters for explanations of these fields. */
        this.pe = ByteString.EMPTY_BYTE_STRING, this.ye = !1, 
        /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */
        this.we = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */    get current() {
        return this.ye;
    }
    /** The last resume token sent to us for this target. */    get resumeToken() {
        return this.pe;
    }
    /** Whether this target has pending target adds or target removes. */    get Se() {
        return 0 !== this.fe;
    }
    /** Whether we have modified any state that should trigger a snapshot. */    get be() {
        return this.we;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */    De(e) {
        e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */    ve() {
        let e = __PRIVATE_documentKeySet(), t = __PRIVATE_documentKeySet(), n = __PRIVATE_documentKeySet();
        return this.ge.forEach(((r, i) => {
            switch (i) {
              case 0 /* ChangeType.Added */ :
                e = e.add(r);
                break;

              case 2 /* ChangeType.Modified */ :
                t = t.add(r);
                break;

              case 1 /* ChangeType.Removed */ :
                n = n.add(r);
                break;

              default:
                fail();
            }
        })), new TargetChange(this.pe, this.ye, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */    Ce() {
        this.we = !1, this.ge = __PRIVATE_snapshotChangesMap();
    }
    Fe(e, t) {
        this.we = !0, this.ge = this.ge.insert(e, t);
    }
    Me(e) {
        this.we = !0, this.ge = this.ge.remove(e);
    }
    xe() {
        this.fe += 1;
    }
    Oe() {
        this.fe -= 1, __PRIVATE_hardAssert(this.fe >= 0);
    }
    Ne() {
        this.we = !0, this.ye = !0;
    }
}

/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */
class __PRIVATE_WatchChangeAggregator {
    constructor(e) {
        this.Le = e, 
        /** The internal state of all tracked targets. */
        this.Be = new Map, 
        /** Keeps track of the documents to update since the last raised snapshot. */
        this.ke = __PRIVATE_mutableDocumentMap(), this.qe = __PRIVATE_documentTargetMap(), 
        /** A mapping of document keys to their set of target IDs. */
        this.Qe = __PRIVATE_documentTargetMap(), 
        /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */
        this.Ke = new SortedMap(__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */    $e(e) {
        for (const t of e.Re) e.Ve && e.Ve.isFoundDocument() ? this.Ue(t, e.Ve) : this.We(t, e.key, e.Ve);
        for (const t of e.removedTargetIds) this.We(t, e.key, e.Ve);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */    Ge(e) {
        this.forEachTarget(e, (t => {
            const n = this.ze(t);
            switch (e.state) {
              case 0 /* WatchTargetChangeState.NoChange */ :
                this.je(t) && n.De(e.resumeToken);
                break;

              case 1 /* WatchTargetChangeState.Added */ :
                // We need to decrement the number of pending acks needed from watch
                // for this targetId.
                n.Oe(), n.Se || 
                // We have a freshly added target, so we need to reset any state
                // that we had previously. This can happen e.g. when remove and add
                // back a target for existence filter mismatches.
                n.Ce(), n.De(e.resumeToken);
                break;

              case 2 /* WatchTargetChangeState.Removed */ :
                // We need to keep track of removed targets to we can post-filter and
                // remove any target changes.
                // We need to decrement the number of pending acks needed from watch
                // for this targetId.
                n.Oe(), n.Se || this.removeTarget(t);
                break;

              case 3 /* WatchTargetChangeState.Current */ :
                this.je(t) && (n.Ne(), n.De(e.resumeToken));
                break;

              case 4 /* WatchTargetChangeState.Reset */ :
                this.je(t) && (
                // Reset the target and synthesizes removes for all existing
                // documents. The backend will re-add any documents that still
                // match the target before it sends the next global snapshot.
                this.He(t), n.De(e.resumeToken));
                break;

              default:
                fail();
            }
        }));
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */    forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach(((e, n) => {
            this.je(n) && t(n);
        }));
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */    Je(e) {
        const t = e.targetId, n = e.me.count, r = this.Ye(t);
        if (r) {
            const i = r.target;
            if (__PRIVATE_targetIsDocumentTarget(i)) if (0 === n) {
                // The existence filter told us the document does not exist. We deduce
                // that this document does not exist and apply a deleted document to
                // our updates. Without applying this deleted document there might be
                // another query that will raise this document as part of a snapshot
                // until it is resolved, essentially exposing inconsistency between
                // queries.
                const e = new DocumentKey(i.path);
                this.We(t, e, MutableDocument.newNoDocument(e, SnapshotVersion.min()));
            } else __PRIVATE_hardAssert(1 === n); else {
                const r = this.Ze(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.Xe(e), i = n ? this.et(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */;
                    if (0 /* BloomFilterApplicationStatus.Success */ !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.He(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */ === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */;
                        this.Ke = this.Ke.insert(t, e);
                    }
                    null == Pe || Pe.tt(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */ === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: e => {
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }
                    /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (r, e.me, this.Le.nt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */    Xe(e) {
        const t = e.me.unchangedNames;
        if (!t || !t.bits) return null;
        const {bits: {bitmap: n = "", padding: r = 0}, hashCount: i = 0} = t;
        let s, o;
        try {
            s = __PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof __PRIVATE_Base64DecodeError) return __PRIVATE_logWarn("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), 
            null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new BloomFilter(s, r, i);
        } catch (e) {
            return __PRIVATE_logWarn(e instanceof __PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), 
            null;
        }
        return 0 === o.Te ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */    et(e, t, n) {
        return t.me.count === n - this.rt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */ : 2 /* BloomFilterApplicationStatus.FalsePositive */;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */    rt(e, t) {
        const n = this.Le.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n => {
            const i = this.Le.nt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.We(t, n, /*updatedDocument=*/ null), r++);
        })), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */    it(e) {
        const t = new Map;
        this.Be.forEach(((n, r) => {
            const i = this.Ye(r);
            if (i) {
                if (n.current && __PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new DocumentKey(i.target.path);
                    this.st(t).has(r) || this.ot(r, t) || this.We(r, t, MutableDocument.newNoDocument(t, e));
                }
                n.be && (t.set(r, n.ve()), n.Ce());
            }
        }));
        let n = __PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
                this.Qe.forEach(((e, t) => {
            let r = !0;
            t.forEachWhile((e => {
                const t = this.Ye(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ === t.purpose || (r = !1, 
                !1);
            })), r && (n = n.add(e));
        })), this.ke.forEach(((t, n) => n.setReadTime(e)));
        const r = new RemoteEvent(e, t, this.Ke, this.ke, n);
        return this.ke = __PRIVATE_mutableDocumentMap(), this.qe = __PRIVATE_documentTargetMap(), 
        this.Qe = __PRIVATE_documentTargetMap(), this.Ke = new SortedMap(__PRIVATE_primitiveComparator), 
        r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */
    // Visible for testing.
    Ue(e, t) {
        if (!this.je(e)) return;
        const n = this.ot(e, t.key) ? 2 /* ChangeType.Modified */ : 0 /* ChangeType.Added */;
        this.ze(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e)), 
        this.Qe = this.Qe.insert(t.key, this._t(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */
    // Visible for testing.
    We(e, t, n) {
        if (!this.je(e)) return;
        const r = this.ze(e);
        this.ot(e, t) ? r.Fe(t, 1 /* ChangeType.Removed */) : 
        // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Me(t), this.Qe = this.Qe.insert(t, this._t(t).delete(e)), this.Qe = this.Qe.insert(t, this._t(t).add(e)), 
        n && (this.ke = this.ke.insert(t, n));
    }
    removeTarget(e) {
        this.Be.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */    Ze(e) {
        const t = this.ze(e).ve();
        return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */    xe(e) {
        this.ze(e).xe();
    }
    ze(e) {
        let t = this.Be.get(e);
        return t || (t = new __PRIVATE_TargetState, this.Be.set(e, t)), t;
    }
    _t(e) {
        let t = this.Qe.get(e);
        return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.Qe = this.Qe.insert(e, t)), 
        t;
    }
    st(e) {
        let t = this.qe.get(e);
        return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.qe = this.qe.insert(e, t)), 
        t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */    je(e) {
        const t = null !== this.Ye(e);
        return t || __PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), 
        t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */    Ye(e) {
        const t = this.Be.get(e);
        return t && t.Se ? null : this.Le.ut(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */    He(e) {
        this.Be.set(e, new __PRIVATE_TargetState);
        this.Le.getRemoteKeysForTarget(e).forEach((t => {
            this.We(e, t, /*updatedDocument=*/ null);
        }));
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */    ot(e, t) {
        return this.Le.getRemoteKeysForTarget(e).has(t);
    }
}

function __PRIVATE_documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}

function __PRIVATE_snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}

const Ie = (() => {
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), Ee = (() => {
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), de = (() => {
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();

/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */
class JsonProtoSerializer {
    constructor(e, t) {
        this.databaseId = e, this.useProto3Json = t;
    }
}

/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */
function __PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || __PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}

/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */
/**
 * Returns a value for a Date that's appropriate to put into a proto.
 */
function toTimestamp(e, t) {
    if (e.useProto3Json) {
        return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    }
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}

/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */
function __PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}

/**
 * Returns a ByteString based on the proto string value.
 */ function __PRIVATE_toVersion(e, t) {
    return toTimestamp(e, t.toTimestamp());
}

function __PRIVATE_fromVersion(e) {
    return __PRIVATE_hardAssert(!!e), SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = __PRIVATE_normalizeTimestamp(e);
        return new Timestamp(t.seconds, t.nanos);
    }(e));
}

function __PRIVATE_toResourceName(e, t) {
    return __PRIVATE_toResourcePath(e, t).canonicalString();
}

function __PRIVATE_toResourcePath(e, t) {
    const n = function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new ResourcePath([ "projects", e.projectId, "databases", e.database ]);
    }(e).child("documents");
    return void 0 === t ? n : n.child(t);
}

function __PRIVATE_fromResourceName(e) {
    const t = ResourcePath.fromString(e);
    return __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(t)), t;
}

function __PRIVATE_toName(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t.path);
}

function fromName(e, t) {
    const n = __PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new FirestoreError(D.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new FirestoreError(D.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new DocumentKey(__PRIVATE_extractLocalPathFromResourceName(n));
}

function __PRIVATE_toQueryPath(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t);
}

function __PRIVATE_fromQueryPath(e) {
    const t = __PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
        return 4 === t.length ? ResourcePath.emptyPath() : __PRIVATE_extractLocalPathFromResourceName(t);
}

function __PRIVATE_getEncodedDatabaseId(e) {
    return new ResourcePath([ "projects", e.databaseId.projectId, "databases", e.databaseId.database ]).canonicalString();
}

function __PRIVATE_extractLocalPathFromResourceName(e) {
    return __PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}

/** Creates a Document proto from key and fields (but no create/update time) */ function __PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: __PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}

function __PRIVATE_fromDocument(e, t, n) {
    const r = fromName(e, t.name), i = __PRIVATE_fromVersion(t.updateTime), s = t.createTime ? __PRIVATE_fromVersion(t.createTime) : SnapshotVersion.min(), o = new ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}

function __PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        __PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        const n = fromName(e, t.found.name), r = __PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? __PRIVATE_fromVersion(t.found.createTime) : SnapshotVersion.min(), s = new ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        __PRIVATE_hardAssert(!!t.missing), __PRIVATE_hardAssert(!!t.readTime);
        const n = fromName(e, t.missing), r = __PRIVATE_fromVersion(t.readTime);
        return MutableDocument.newNoDocument(n, r);
    }(e, t) : fail();
}

function __PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */ : "ADD" === e ? 1 /* WatchTargetChangeState.Added */ : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */ : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */ : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */ : fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? (__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), 
            ByteString.fromBase64String(t || "")) : (__PRIVATE_hardAssert(void 0 === t || 
            // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof Buffer || t instanceof Uint8Array), ByteString.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? D.UNKNOWN : __PRIVATE_mapCodeFromRpcCode(e.code);
            return new FirestoreError(t, e.message || "");
        }(o);
        n = new __PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = fromName(e, r.document.name), s = __PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? __PRIVATE_fromVersion(r.document.createTime) : SnapshotVersion.min(), _ = new ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = fromName(e, r.document), s = r.readTime ? __PRIVATE_fromVersion(r.readTime) : SnapshotVersion.min(), o = MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = fromName(e, r.document), s = r.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return fail();
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const {count: r = 0, unchangedNames: i} = e, s = new ExistenceFilter(r, i), o = e.targetId;
            n = new __PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}

function toMutation(e, t) {
    let n;
    if (t instanceof __PRIVATE_SetMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.value)
    }; else if (t instanceof __PRIVATE_DeleteMutation) n = {
        delete: __PRIVATE_toName(e, t.key)
    }; else if (t instanceof __PRIVATE_PatchMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: __PRIVATE_toDocumentMask(t.fieldMask)
    }; else {
        if (!(t instanceof __PRIVATE_VerifyMutation)) return fail();
        n = {
            verify: __PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e => function __PRIVATE_toFieldTransform(e, t) {
        const n = t.transform;
        if (n instanceof __PRIVATE_ServerTimestampTransform) return {
            fieldPath: t.field.canonicalString(),
            setToServerValue: "REQUEST_TIME"
        };
        if (n instanceof __PRIVATE_ArrayUnionTransformOperation) return {
            fieldPath: t.field.canonicalString(),
            appendMissingElements: {
                values: n.elements
            }
        };
        if (n instanceof __PRIVATE_ArrayRemoveTransformOperation) return {
            fieldPath: t.field.canonicalString(),
            removeAllFromArray: {
                values: n.elements
            }
        };
        if (n instanceof __PRIVATE_NumericIncrementTransformOperation) return {
            fieldPath: t.field.canonicalString(),
            increment: n.Pe
        };
        throw fail();
    }(0, e)))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: __PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : fail();
    }(e, t.precondition)), n;
}

function __PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? Precondition.updateTime(__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? Precondition.exists(e.exists) : Precondition.none();
    }(t.currentDocument) : Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t => function __PRIVATE_fromFieldTransform(e, t) {
        let n = null;
        if ("setToServerValue" in t) __PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), 
        n = new __PRIVATE_ServerTimestampTransform; else if ("appendMissingElements" in t) {
            const e = t.appendMissingElements.values || [];
            n = new __PRIVATE_ArrayUnionTransformOperation(e);
        } else if ("removeAllFromArray" in t) {
            const e = t.removeAllFromArray.values || [];
            n = new __PRIVATE_ArrayRemoveTransformOperation(e);
        } else "increment" in t ? n = new __PRIVATE_NumericIncrementTransformOperation(e, t.increment) : fail();
        const r = FieldPath$1.fromServerFormat(t.fieldPath);
        return new FieldTransform(r, n);
    }(e, t))) : [];
    if (t.update) {
        t.update.name;
        const i = fromName(e, t.update.name), s = new ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new FieldMask(t.map((e => FieldPath$1.fromServerFormat(e))));
            }(t.updateMask);
            return new __PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new __PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = fromName(e, t.delete);
        return new __PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = fromName(e, t.verify);
        return new __PRIVATE_VerifyMutation(r, n);
    }
    return fail();
}

function __PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? (__PRIVATE_hardAssert(void 0 !== t), e.map((e => function __PRIVATE_fromWriteResult(e, t) {
        // NOTE: Deletes don't have an updateTime.
        let n = e.updateTime ? __PRIVATE_fromVersion(e.updateTime) : __PRIVATE_fromVersion(t);
        return n.isEqual(SnapshotVersion.min()) && (
        // The Firestore Emulator currently returns an update time of 0 for
        // deletes of non-existing documents (rather than null). This breaks the
        // test "get deleted doc while offline with source=cache" as NoDocuments
        // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
        // TODO(#2149): Remove this when Emulator is fixed
        n = __PRIVATE_fromVersion(t)), new MutationResult(n, e.transformResults || []);
    }(e, t)))) : [];
}

function __PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [ __PRIVATE_toQueryPath(e, t.path) ]
    };
}

function __PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [ {
        collectionId: t.collectionGroup,
        allDescendants: !0
    } ]) : (i = r.popLast(), n.structuredQuery.from = [ {
        collectionId: r.lastSegment()
    } ]), n.parent = __PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return __PRIVATE_toFilter(CompositeFilter.create(e, "and" /* CompositeOperator.AND */));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e => 
        // visible for testing
        function __PRIVATE_toPropertyOrder(e) {
            return {
                field: __PRIVATE_toFieldPathReference(e.field),
                direction: __PRIVATE_toDirection(e.dir)
            };
        }(e)));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = __PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ct: n,
        parent: i
    };
}

function __PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const {ct: i, parent: s} = __PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e => {
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    })), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        lt: o,
        parent: s
    };
}

function __PRIVATE_convertQueryTargetToQuery(e) {
    let t = __PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        __PRIVATE_hardAssert(1 === r);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = __PRIVATE_fromFilter(e);
        if (t instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [ t ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e => function __PRIVATE_fromPropertyOrder(e) {
            return new OrderBy(__PRIVATE_fromFieldPathReference(e.field), 
            // visible for testing
            function __PRIVATE_fromDirection(e) {
                switch (e) {
                  case "ASCENDING":
                    return "asc" /* Direction.ASCENDING */;

                  case "DESCENDING":
                    return "desc" /* Direction.DESCENDING */;

                  default:
                    return;
                }
            }
            // visible for testing
            (e.direction));
        }
        // visible for testing
        (e)));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, __PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new Bound(n, t);
    }
    // visible for testing
    (n.endAt)), __PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}

function __PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch (e) {
          case "TargetPurposeListen" /* TargetPurpose.Listen */ :
            return null;

          case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
            return "existence-filter-mismatch";

          case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
            return "existence-filter-mismatch-bloom";

          case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
            return "limbo-document";

          default:
            return fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}

function __PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch (e.unaryFilter.op) {
          case "IS_NAN":
            const t = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
            return FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                doubleValue: NaN
            });

          case "IS_NULL":
            const n = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
            return FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                nullValue: "NULL_VALUE"
            });

          case "IS_NOT_NAN":
            const r = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
            return FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                doubleValue: NaN
            });

          case "IS_NOT_NULL":
            const i = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
            return FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                nullValue: "NULL_VALUE"
            });

          default:
            return fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return FieldFilter.create(__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch (e) {
              case "EQUAL":
                return "==" /* Operator.EQUAL */;

              case "NOT_EQUAL":
                return "!=" /* Operator.NOT_EQUAL */;

              case "GREATER_THAN":
                return ">" /* Operator.GREATER_THAN */;

              case "GREATER_THAN_OR_EQUAL":
                return ">=" /* Operator.GREATER_THAN_OR_EQUAL */;

              case "LESS_THAN":
                return "<" /* Operator.LESS_THAN */;

              case "LESS_THAN_OR_EQUAL":
                return "<=" /* Operator.LESS_THAN_OR_EQUAL */;

              case "ARRAY_CONTAINS":
                return "array-contains" /* Operator.ARRAY_CONTAINS */;

              case "IN":
                return "in" /* Operator.IN */;

              case "NOT_IN":
                return "not-in" /* Operator.NOT_IN */;

              case "ARRAY_CONTAINS_ANY":
                return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */;

              default:
                return fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return CompositeFilter.create(e.compositeFilter.filters.map((e => __PRIVATE_fromFilter(e))), function __PRIVATE_fromCompositeOperatorName(e) {
            switch (e) {
              case "AND":
                return "and" /* CompositeOperator.AND */;

              case "OR":
                return "or" /* CompositeOperator.OR */;

              default:
                return fail();
            }
        }(e.compositeFilter.op));
    }(e) : fail();
}

function __PRIVATE_toDirection(e) {
    return Ie[e];
}

function __PRIVATE_toOperatorName(e) {
    return Ee[e];
}

function __PRIVATE_toCompositeOperatorName(e) {
    return de[e];
}

function __PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}

function __PRIVATE_fromFieldPathReference(e) {
    return FieldPath$1.fromServerFormat(e.fieldPath);
}

function __PRIVATE_toFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */ === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */ === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: __PRIVATE_toFieldPathReference(e.field),
                op: __PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e => __PRIVATE_toFilter(e)));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: __PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : fail();
}

function __PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e => t.push(e.canonicalString()))), {
        fieldPaths: t
    };
}

function __PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable set of metadata that the local store tracks for each target.
 */ class TargetData {
    constructor(
    /** The target being listened to. */
    e, 
    /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */
    t, 
    /** The purpose of the target. */
    n, 
    /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */
    r, 
    /** The latest snapshot version seen for this target. */
    i = SnapshotVersion.min()
    /**
     * The maximum snapshot version at which the associated view
     * contained no limbo documents.
     */ , s = SnapshotVersion.min()
    /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ , o = ByteString.EMPTY_BYTE_STRING
    /**
     * The number of documents that last matched the query at the resume token or
     * read time. Documents are counted only when making a listen request with
     * resume token or read time, otherwise, keep it null.
     */ , _ = null) {
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, 
        this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */    withSequenceNumber(e) {
        return new TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */    withResumeToken(e, t) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, 
        /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */    withExpectedCount(e) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */    withLastLimboFreeSnapshotVersion(e) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Serializer for values stored in the LocalStore. */ class __PRIVATE_LocalSerializer {
    constructor(e) {
        this.ht = e;
    }
}

/** Decodes a remote document from storage locally to a Document. */ function __PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = __PRIVATE_fromDocument(e.ht, t.document, !!t.hasCommittedMutations); else if (t.noDocument) {
        const e = DocumentKey.fromSegments(t.noDocument.path), r = __PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return fail();
        {
            const e = DocumentKey.fromSegments(t.unknownDocument.path), r = __PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new Timestamp(e[0], e[1]);
        return SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}

/** Encodes a document for storage locally. */ function __PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: __PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: __PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: toTimestamp(e, t.version.toTimestamp()),
            createTime: toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ht, t); else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: __PRIVATE_toDbTimestamp(t.version)
    }; else {
        if (!t.isUnknownDocument()) return fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: __PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}

function __PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [ t.seconds, t.nanoseconds ];
}

function __PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}

function __PRIVATE_fromDbTimestamp(e) {
    const t = new Timestamp(e.seconds, e.nanoseconds);
    return SnapshotVersion.fromTimestamp(t);
}

/** Encodes a batch of mutations into a DbMutationBatch for local storage. */
/** Decodes a DbMutationBatch into a MutationBatch */
function __PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t => __PRIVATE_fromMutation(e.ht, t)));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
        for (let e = 0; e < t.mutations.length - 1; ++e) {
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), 
            ++e;
        }
    }
    const r = t.mutations.map((t => __PRIVATE_fromMutation(e.ht, t))), i = Timestamp.fromMillis(t.localWriteTimeMs);
    return new MutationBatch(t.batchId, i, n, r);
}

/** Decodes a DbTarget into TargetData */ function __PRIVATE_fromDbTarget(e) {
    const t = __PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? __PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : SnapshotVersion.min();
    let r;
    return r = 
    /**
 * A helper function for figuring out what kind of query has been stored.
 */
    function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }
    /** Encodes a DbBundle to a BundleMetadata object. */ (e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return __PRIVATE_hardAssert(1 === e.documents.length), __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return __PRIVATE_queryToTarget(__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, ByteString.fromBase64String(e.resumeToken));
}

/** Encodes TargetData into a DbTarget for storage locally. */ function __PRIVATE_toDbTarget(e, t) {
    const n = __PRIVATE_toDbTimestamp(t.snapshotVersion), r = __PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = __PRIVATE_targetIsDocumentTarget(t.target) ? __PRIVATE_toDocumentsTarget(e.ht, t.target) : __PRIVATE_toQueryTarget(e.ht, t.target).ct;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
        const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
        return {
        targetId: t.targetId,
        canonicalId: __PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}

/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */
function __PRIVATE_fromBundledQuery(e) {
    const t = __PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? __PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */) : t;
}

/** Encodes a NamedQuery proto object to a NamedQuery model object. */
/** Encodes a DbDocumentOverlay object to an Overlay model object. */
function __PRIVATE_fromDbDocumentOverlay(e, t) {
    return new Overlay(t.largestBatchId, __PRIVATE_fromMutation(e.ht, t.overlayMutation));
}

/** Decodes an Overlay model object into a DbDocumentOverlay object. */
/**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */
function __PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [ e, __PRIVATE_encodeResourcePath(t.path.popLast()), n ];
}

function __PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: __PRIVATE_toDbTimestamp(r.readTime),
        documentKey: __PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return __PRIVATE_bundlesStore(e).get(t).next((e => {
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: __PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }
            /** Encodes a BundleMetadata to a DbBundle. */ (e);
        }));
    }
    saveBundleMetadata(e, t) {
        return __PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }
        /** Encodes a DbNamedQuery to a NamedQuery. */ (t));
    }
    getNamedQuery(e, t) {
        return __PRIVATE_namedQueriesStore(e).get(t).next((e => {
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: __PRIVATE_fromDbTimestamp(e.readTime)
                };
            }
            /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */ (e);
        }));
    }
    saveNamedQuery(e, t) {
        return __PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}

/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function __PRIVATE_bundlesStore(e) {
    return __PRIVATE_getStore(e, "bundles");
}

/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function __PRIVATE_namedQueriesStore(e) {
    return __PRIVATE_getStore(e, "namedQueries");
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class __PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */
    constructor(e, t) {
        this.serializer = e, this.userId = t;
    }
    static Pt(e, t) {
        const n = t.uid || "";
        return new __PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return __PRIVATE_documentOverlayStore(e).get(__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e => e ? __PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null));
    }
    getOverlays(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return PersistencePromise.forEach(t, (t => this.getOverlay(e, t).next((e => {
            null !== e && n.set(t, e);
        })))).next((() => n));
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach(((n, i) => {
            const s = new Overlay(t, i);
            r.push(this.Tt(e, s));
        })), PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
                t.forEach((e => r.add(__PRIVATE_encodeResourcePath(e.getCollectionPath()))));
        const i = [];
        return r.forEach((t => {
            const r = IDBKeyRange.bound([ this.userId, t, n ], [ this.userId, t, n + 1 ], 
            /*lowerOpen=*/ !1, 
            /*upperOpen=*/ !0);
            i.push(__PRIVATE_documentOverlayStore(e).j("collectionPathOverlayIndex", r));
        })), PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = __PRIVATE_newOverlayMap(), i = __PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([ this.userId, i, n ], [ this.userId, i, Number.POSITIVE_INFINITY ], 
        /*lowerOpen=*/ !0);
        return __PRIVATE_documentOverlayStore(e).U("collectionPathOverlayIndex", s).next((e => {
            for (const t of e) {
                const e = __PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        }));
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = __PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
                const o = IDBKeyRange.bound([ this.userId, t, n ], [ this.userId, t, Number.POSITIVE_INFINITY ], 
        /*lowerOpen=*/ !0);
        return __PRIVATE_documentOverlayStore(e).J({
            index: "collectionGroupOverlayIndex",
            range: o
        }, ((e, t, n) => {
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = __PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        })).next((() => i));
    }
    Tt(e, t) {
        return __PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = __PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: toMutation(e.ht, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}

/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function __PRIVATE_documentOverlayStore(e) {
    return __PRIVATE_getStore(e, "documentOverlays");
}

/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_IndexedDbGlobalsCache {
    It(e) {
        return __PRIVATE_getStore(e, "globals");
    }
    getSessionToken(e) {
        return this.It(e).get("sessionToken").next((e => {
            const t = null == e ? void 0 : e.value;
            return t ? ByteString.fromUint8Array(t) : ByteString.EMPTY_BYTE_STRING;
        }));
    }
    setSessionToken(e, t) {
        return this.It(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */
class __PRIVATE_FirestoreIndexValueWriter {
    constructor() {}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */
    Et(e, t) {
        this.dt(e, t), 
        // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.At();
    }
    dt(e, t) {
        if ("nullValue" in e) this.Rt(t, 5); else if ("booleanValue" in e) this.Rt(t, 10), 
        t.Vt(e.booleanValue ? 1 : 0); else if ("integerValue" in e) this.Rt(t, 15), t.Vt(__PRIVATE_normalizeNumber(e.integerValue)); else if ("doubleValue" in e) {
            const n = __PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Rt(t, 13) : (this.Rt(t, 15), __PRIVATE_isNegativeZero(n) ? 
            // -0.0, 0 and 0.0 are all considered the same
            t.Vt(0) : t.Vt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Rt(t, 20), "string" == typeof n && (n = __PRIVATE_normalizeTimestamp(n)), t.ft(`${n.seconds || ""}`), 
            t.Vt(n.nanos || 0);
        } else if ("stringValue" in e) this.gt(e.stringValue, t), this.yt(t); else if ("bytesValue" in e) this.Rt(t, 30), 
        t.wt(__PRIVATE_normalizeByteString(e.bytesValue)), this.yt(t); else if ("referenceValue" in e) this.St(e.referenceValue, t); else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Rt(t, 45), t.Vt(n.latitude || 0), t.Vt(n.longitude || 0);
        } else "mapValue" in e ? __PRIVATE_isMaxValue(e) ? this.Rt(t, Number.MAX_SAFE_INTEGER) : __PRIVATE_isVectorValue(e) ? this.bt(e.mapValue, t) : (this.Dt(e.mapValue, t), 
        this.yt(t)) : "arrayValue" in e ? (this.vt(e.arrayValue, t), this.yt(t)) : fail();
    }
    gt(e, t) {
        this.Rt(t, 25), this.Ct(e, t);
    }
    Ct(e, t) {
        t.ft(e);
    }
    Dt(e, t) {
        const n = e.fields || {};
        this.Rt(t, 55);
        for (const e of Object.keys(n)) this.gt(e, t), this.dt(n[e], t);
    }
    bt(e, t) {
        var n, r;
        const i = e.fields || {};
        this.Rt(t, 53);
        // Vectors sort first by length
        const s = "value", o = (null === (r = null === (n = i[s].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
        this.Rt(t, 15), t.Vt(__PRIVATE_normalizeNumber(o)), 
        // Vectors then sort by position value
        this.gt(s, t), this.dt(i[s], t);
    }
    vt(e, t) {
        const n = e.values || [];
        this.Rt(t, 50);
        for (const e of n) this.dt(e, t);
    }
    St(e, t) {
        this.Rt(t, 37);
        DocumentKey.fromName(e).path.forEach((e => {
            this.Rt(t, 60), this.Ct(e, t);
        }));
    }
    Rt(e, t) {
        e.Vt(t);
    }
    yt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Vt(2);
    }
}

__PRIVATE_FirestoreIndexValueWriter.Ft = new __PRIVATE_FirestoreIndexValueWriter;

/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */
function __PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 == 0 && (
    // Test if the first four bits are zero.
    t += 4, e <<= 4), e >> 6 == 0 && (
    // Test if the first two (or next two) bits are zero.
    t += 2, e <<= 2), e >> 7 == 0 && (
    // Test if the remaining bit is zero.
    t += 1), t;
}

/** Counts the number of leading zeros in the given byte array. */
/**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */
function __PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for (let n = 0; n < 8; ++n) {
            const r = __PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}

/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class __PRIVATE_OrderedCodeWriter {
    constructor() {
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Mt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for (;!n.done; ) this.xt(n.value), n = t.next();
        this.Ot();
    }
    Nt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for (;!n.done; ) this.Lt(n.value), n = t.next();
        this.Bt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */    kt(e) {
        for (const t of e) {
            const e = t.charCodeAt(0);
            if (e < 128) this.xt(e); else if (e < 2048) this.xt(960 | e >>> 6), this.xt(128 | 63 & e); else if (t < "\ud800" || "\udbff" < t) this.xt(480 | e >>> 12), 
            this.xt(128 | 63 & e >>> 6), this.xt(128 | 63 & e); else {
                const e = t.codePointAt(0);
                this.xt(240 | e >>> 18), this.xt(128 | 63 & e >>> 12), this.xt(128 | 63 & e >>> 6), 
                this.xt(128 | 63 & e);
            }
        }
        this.Ot();
    }
    /** Writes utf8 bytes into this byte sequence, descending */    qt(e) {
        for (const t of e) {
            const e = t.charCodeAt(0);
            if (e < 128) this.Lt(e); else if (e < 2048) this.Lt(960 | e >>> 6), this.Lt(128 | 63 & e); else if (t < "\ud800" || "\udbff" < t) this.Lt(480 | e >>> 12), 
            this.Lt(128 | 63 & e >>> 6), this.Lt(128 | 63 & e); else {
                const e = t.codePointAt(0);
                this.Lt(240 | e >>> 18), this.Lt(128 | 63 & e >>> 12), this.Lt(128 | 63 & e >>> 6), 
                this.Lt(128 | 63 & e);
            }
        }
        this.Bt();
    }
    Qt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Kt(e), n = __PRIVATE_unsignedNumLength(t);
        this.$t(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for (let e = t.length - n; e < t.length; ++e) this.buffer[this.position++] = 255 & t[e];
    }
    Ut(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Kt(e), n = __PRIVATE_unsignedNumLength(t);
        this.$t(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for (let e = t.length - n; e < t.length; ++e) this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */    Wt() {
        this.Gt(255), this.Gt(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */    zt() {
        this.jt(255), this.jt(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */    reset() {
        this.position = 0;
    }
    seed(e) {
        this.$t(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */    Ht() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */    Kt(e) {
        const t = 
        /** Converts a JavaScript number to a byte array (using big endian encoding). */
        function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = 0 != (128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
                // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for (let e = 1; e < t.length; ++e) t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */    xt(e) {
        const t = 255 & e;
        0 === t ? (this.Gt(0), this.Gt(255)) : 255 === t ? (this.Gt(255), this.Gt(0)) : this.Gt(t);
    }
    /** Writes a single byte descending to the buffer.  */    Lt(e) {
        const t = 255 & e;
        0 === t ? (this.jt(0), this.jt(255)) : 255 === t ? (this.jt(255), this.jt(0)) : this.jt(e);
    }
    Ot() {
        this.Gt(0), this.Gt(1);
    }
    Bt() {
        this.jt(0), this.jt(1);
    }
    Gt(e) {
        this.$t(1), this.buffer[this.position++] = e;
    }
    jt(e) {
        this.$t(1), this.buffer[this.position++] = ~e;
    }
    $t(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
                let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
                n < t && (n = t);
        // Create the new buffer.
                const r = new Uint8Array(n);
        r.set(this.buffer), // copy old data
        this.buffer = r;
    }
}

class __PRIVATE_AscendingIndexByteEncoder {
    constructor(e) {
        this.Jt = e;
    }
    wt(e) {
        this.Jt.Mt(e);
    }
    ft(e) {
        this.Jt.kt(e);
    }
    Vt(e) {
        this.Jt.Qt(e);
    }
    At() {
        this.Jt.Wt();
    }
}

class __PRIVATE_DescendingIndexByteEncoder {
    constructor(e) {
        this.Jt = e;
    }
    wt(e) {
        this.Jt.Nt(e);
    }
    ft(e) {
        this.Jt.qt(e);
    }
    Vt(e) {
        this.Jt.Ut(e);
    }
    At() {
        this.Jt.zt();
    }
}

/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class __PRIVATE_IndexByteEncoder {
    constructor() {
        this.Jt = new __PRIVATE_OrderedCodeWriter, this.Yt = new __PRIVATE_AscendingIndexByteEncoder(this.Jt), 
        this.Zt = new __PRIVATE_DescendingIndexByteEncoder(this.Jt);
    }
    seed(e) {
        this.Jt.seed(e);
    }
    Xt(e) {
        return 0 /* IndexKind.ASCENDING */ === e ? this.Yt : this.Zt;
    }
    Ht() {
        return this.Jt.Ht();
    }
    reset() {
        this.Jt.reset();
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Represents an index entry saved by the SDK in persisted storage. */ class __PRIVATE_IndexEntry {
    constructor(e, t, n, r) {
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */    en() {
        const e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.directionalValue, 0), t !== e ? n.set([ 0 ], this.directionalValue.length) : ++n[n.length - 1], 
        new __PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
    }
}

function __PRIVATE_indexEntryComparator(e, t) {
    let n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 
    0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 
    0 !== n ? n : DocumentKey.comparator(e.documentKey, t.documentKey)));
}

function __PRIVATE_compareByteArrays(e, t) {
    for (let n = 0; n < e.length && n < t.length; ++n) {
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class __PRIVATE_TargetIndexMatcher {
    constructor(e) {
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.tn = new SortedSet(((e, t) => FieldPath$1.comparator(e.field, t.field))), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), 
        this.nn = e.orderBy, this.rn = [];
        for (const t of e.filters) {
            const e = t;
            e.isInequality() ? this.tn = this.tn.add(e) : this.rn.push(e);
        }
    }
    get sn() {
        return this.tn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */    on(e) {
        if (__PRIVATE_hardAssert(e.collectionGroup === this.collectionId), this.sn) 
        // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
                const t = __PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this._n(t)) return !1;
        const n = __PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for (;i < n.length && this._n(n[i]); ++i) r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
                if (i === n.length) return !0;
        if (this.tn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.tn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
                        if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.an(e, t) || !this.un(this.nn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
                for (;i < n.length; ++i) {
            const e = n[i];
            if (s >= this.nn.length || !this.un(this.nn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */    cn() {
        if (this.sn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
                let e = new SortedSet(FieldPath$1.comparator);
        const t = [];
        for (const n of this.rn) {
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */ === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ === n.op) t.push(new IndexSegment(n.field, 2 /* IndexKind.CONTAINS */)); else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new IndexSegment(n.field, 0 /* IndexKind.ASCENDING */));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
                for (const n of this.nn) 
        // Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new IndexSegment(n.field, "asc" /* Direction.ASCENDING */ === n.dir ? 0 /* IndexKind.ASCENDING */ : 1 /* IndexKind.DESCENDING */)));
        return new FieldIndex(FieldIndex.UNKNOWN_ID, this.collectionId, t, IndexState.empty());
    }
    _n(e) {
        for (const t of this.rn) if (this.an(t, e)) return !0;
        return !1;
    }
    an(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */ === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ === e.op;
        return 2 /* IndexKind.CONTAINS */ === t.kind === n;
    }
    un(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */ === t.kind && "asc" /* Direction.ASCENDING */ === e.dir || 1 /* IndexKind.DESCENDING */ === t.kind && "desc" /* Direction.DESCENDING */ === e.dir);
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */
/**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function __PRIVATE_computeInExpansion(e) {
    var t, n;
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), 
    e instanceof FieldFilter) {
        if (e instanceof __PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t => FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t)))) || [];
            return CompositeFilter.create(r, "or" /* CompositeOperator.OR */);
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
        const r = e.filters.map((e => __PRIVATE_computeInExpansion(e)));
    return CompositeFilter.create(r, e.op);
}

/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function __PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = __PRIVATE_computeDistributedNormalForm(__PRIVATE_computeInExpansion(e));
    return __PRIVATE_hardAssert(__PRIVATE_isDisjunctiveNormalForm(t)), __PRIVATE_isSingleFieldFilter(t) || __PRIVATE_isFlatConjunction(t) ? [ t ] : t.getFilters();
}

/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function __PRIVATE_isSingleFieldFilter(e) {
    return e instanceof FieldFilter;
}

/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function __PRIVATE_isFlatConjunction(e) {
    return e instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(e);
}

/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function __PRIVATE_isDisjunctiveNormalForm(e) {
    return __PRIVATE_isSingleFieldFilter(e) || __PRIVATE_isFlatConjunction(e) || 
    /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */
    function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof CompositeFilter && __PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters()) if (!__PRIVATE_isSingleFieldFilter(t) && !__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}

function __PRIVATE_computeDistributedNormalForm(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), 
    e instanceof FieldFilter) return e;
    if (1 === e.filters.length) return __PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
        const t = e.filters.map((e => __PRIVATE_computeDistributedNormalForm(e)));
    let n = CompositeFilter.create(t, e.op);
    return n = __PRIVATE_applyAssociation(n), __PRIVATE_isDisjunctiveNormalForm(n) ? n : (__PRIVATE_hardAssert(n instanceof CompositeFilter), 
    __PRIVATE_hardAssert(__PRIVATE_compositeFilterIsConjunction(n)), __PRIVATE_hardAssert(n.filters.length > 1), 
    n.filters.reduce(((e, t) => __PRIVATE_applyDistribution(e, t))));
}

function __PRIVATE_applyDistribution(e, t) {
    let n;
    return __PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), 
    __PRIVATE_hardAssert(t instanceof FieldFilter || t instanceof CompositeFilter), 
    // FieldFilter FieldFilter
    n = e instanceof FieldFilter ? t instanceof FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return CompositeFilter.create([ e, t ], "and" /* CompositeOperator.AND */);
    }(e, t) : __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof FieldFilter ? __PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if (__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), __PRIVATE_compositeFilterIsConjunction(e) && __PRIVATE_compositeFilterIsConjunction(t)) return __PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
                const n = __PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = __PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e => __PRIVATE_applyDistribution(e, r)));
        return CompositeFilter.create(i, "or" /* CompositeOperator.OR */);
    }(e, t), __PRIVATE_applyAssociation(n);
}

function __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if (__PRIVATE_compositeFilterIsConjunction(t)) 
    // Case 1
    return __PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t => __PRIVATE_applyDistribution(e, t)));
        return CompositeFilter.create(n, "or" /* CompositeOperator.OR */);
    }
}

/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function __PRIVATE_applyAssociation(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter), 
    e instanceof FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
        if (1 === t.length) return __PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
        if (__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
        const n = t.map((e => __PRIVATE_applyAssociation(e))), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
        return n.forEach((t => {
        t instanceof FieldFilter ? r.push(t) : t instanceof CompositeFilter && (t.op === e.op ? 
        // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : 
        // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    })), 1 === r.length ? r[0] : CompositeFilter.create(r, e.op);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory implementation of IndexManager.
 */ class __PRIVATE_MemoryIndexManager {
    constructor() {
        this.ln = new __PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.ln.add(t), PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return PersistencePromise.resolve(this.ln.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve(0 /* IndexType.NONE */);
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return PersistencePromise.resolve(IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return PersistencePromise.resolve(IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
}

/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class __PRIVATE_MemoryCollectionParentIndex {
    constructor() {
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new SortedSet(ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new SortedSet(ResourcePath.comparator)).toArray();
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Ae = new Uint8Array(0);

/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */
class __PRIVATE_IndexedDbIndexManager {
    constructor(e, t) {
        this.databaseId = t, 
        /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */
        this.hn = new __PRIVATE_MemoryCollectionParentIndex, 
        /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */
        this.Pn = new ObjectMap((e => __PRIVATE_canonifyTarget(e)), ((e, t) => __PRIVATE_targetEquals(e, t))), 
        this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */    addToCollectionParentIndex(e, t) {
        if (!this.hn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener((() => {
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.hn.add(t);
            }));
            const i = {
                collectionId: n,
                parent: __PRIVATE_encodeResourcePath(r)
            };
            return __PRIVATE_collectionParentsStore(e).put(i);
        }
        return PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([ t, "" ], [ __PRIVATE_immediateSuccessor(t), "" ], 
        /*lowerOpen=*/ !1, 
        /*upperOpen=*/ !0);
        return __PRIVATE_collectionParentsStore(e).U(r).next((e => {
            for (const r of e) {
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push(__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        }));
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = __PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e => [ e.fieldPath.canonicalString(), e.kind ]))
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = __PRIVATE_indexStateStore(e);
            return i.next((e => {
                n.put(__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            }));
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e), i = __PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next((() => r.delete(IDBKeyRange.bound([ t.indexId ], [ t.indexId + 1 ], 
        /*lowerOpen=*/ !1, 
        /*upperOpen=*/ !0)))).next((() => i.delete(IDBKeyRange.bound([ t.indexId ], [ t.indexId + 1 ], 
        /*lowerOpen=*/ !1, 
        /*upperOpen=*/ !0))));
    }
    deleteAllFieldIndexes(e) {
        const t = __PRIVATE_indexConfigurationStore(e), n = __PRIVATE_indexEntriesStore(e), r = __PRIVATE_indexStateStore(e);
        return t.j().next((() => n.j())).next((() => r.j()));
    }
    createTargetIndexes(e, t) {
        return PersistencePromise.forEach(this.Tn(t), (t => this.getIndexType(e, t).next((n => {
            if (0 /* IndexType.NONE */ === n || 1 /* IndexType.PARTIAL */ === n) {
                const n = new __PRIVATE_TargetIndexMatcher(t).cn();
                if (null != n) return this.addFieldIndex(e, n);
            }
        }))));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = __PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return PersistencePromise.forEach(this.Tn(t), (t => this.In(e, t).next((e => {
            r && (r = !!e), i.set(t, e);
        })))).next((() => {
            if (r) {
                let e = __PRIVATE_documentKeySet();
                const r = [];
                return PersistencePromise.forEach(i, ((i, s) => {
                    __PRIVATE_logDebug("IndexedDbIndexManager", `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e => `${e.fieldPath}:${e.kind}`)).join(",")}`;
                    }(i)} to execute ${__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = __PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of __PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath)) switch (t.op) {
                          case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                            return t.value.arrayValue.values || [];

                          case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                            return [ t.value ];
                            // Remaining filters are not array filters.
                                                }
                        return null;
                    }
                    /**
 * Returns the list of values that are used in != or NOT_IN filters. Returns
 * `null` if there are no such filters.
 */ (s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of __PRIVATE_fieldIndexGetDirectionalSegments(t)) for (const t of __PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath)) switch (t.op) {
                          case "==" /* Operator.EQUAL */ :
                          case "in" /* Operator.IN */ :
                            // Encode equality prefix, which is encoded in the index value before
                            // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                            // `value != 'ab'`).
                            n.set(r.fieldPath.canonicalString(), t.value);
                            break;

                          case "not-in" /* Operator.NOT_IN */ :
                          case "!=" /* Operator.NOT_EQUAL */ :
                            // NotIn/NotEqual is always a suffix. There cannot be any remaining
                            // segments and hence we can return early here.
                            return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                            // Remaining filters cannot be used as notIn bounds.
                                                }
                        return null;
                    }
                    /**
 * Returns a lower bound of field values that can be used as a starting point to
 * scan the index defined by `fieldIndex`. Returns `MIN_VALUE` if no lower bound
 * exists.
 */ (s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                                                for (const i of __PRIVATE_fieldIndexGetDirectionalSegments(t)) {
                            const t = 0 /* IndexKind.ASCENDING */ === i.kind ? __PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : __PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new Bound(n, r);
                    }
                    /**
 * Returns an upper bound of field values that can be used as an ending point
 * when scanning the index defined by `fieldIndex`. Returns `MAX_VALUE` if no
 * upper bound exists.
 */ (s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                                                for (const i of __PRIVATE_fieldIndexGetDirectionalSegments(t)) {
                            const t = 0 /* IndexKind.ASCENDING */ === i.kind ? __PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : __PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new Bound(n, r);
                    }(s, i), c = this.En(i, s, a), l = this.En(i, s, u), h = this.dn(i, s, _), P = this.An(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return PersistencePromise.forEach(P, (i => n.G(i, t.limit).next((t => {
                        t.forEach((t => {
                            const n = DocumentKey.fromSegments(t.documentKey);
                            e.has(n) || (e = e.add(n), r.push(n));
                        }));
                    }))));
                })).next((() => r));
            }
            return PersistencePromise.resolve(null);
        }));
    }
    Tn(e) {
        let t = this.Pn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [ e ]; else {
            t = __PRIVATE_getDnfTerms(CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */)).map((t => __PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt)));
        }
        return this.Pn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */    An(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for (let c = 0; c < _; ++c) {
            const _ = t ? this.Rn(t[c / a]) : Ae, l = this.Vn(e, _, n[c % a], r), h = this.mn(e, _, i[c % a], s), P = o.map((t => this.Vn(e, _, t, 
            /* inclusive= */ !0)));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */    Vn(e, t, n, r) {
        const i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
        return r ? i : i.en();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */    mn(e, t, n, r) {
        const i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
        return r ? i.en() : i;
    }
    In(e, t) {
        const n = new __PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e => {
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e) {
                n.on(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            }
            return t;
        }));
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */;
        const r = this.Tn(t);
        return PersistencePromise.forEach(r, (t => this.In(e, t).next((e => {
            e ? 0 /* IndexType.NONE */ !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                let t = new SortedSet(FieldPath$1.comparator), n = !1;
                for (const r of e.filters) for (const e of r.getFlattenedFilters()) 
                // __name__ is not an explicit segment of any index, so we don't need to
                // count it.
                e.field.isKeyField() || (
                // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                // though these are on the same field, they should be counted as two
                // separate segments in an index.
                "array-contains" /* Operator.ARRAY_CONTAINS */ === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ === e.op ? n = !0 : t = t.add(e.field));
                for (const n of e.orderBy) 
                // __name__ is not an explicit segment of any index, so we don't need to
                // count it.
                n.field.isKeyField() || (t = t.add(n.field));
                return t.size + (n ? 1 : 0);
            }(t) && (n = 1 /* IndexType.PARTIAL */) : n = 0 /* IndexType.NONE */;
        })))).next((() => 
        // OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
        // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
        // and apply the limit in memory as a post-processing step.
        function __PRIVATE_targetHasLimit(e) {
            return null !== e.limit;
        }(t) && r.length > 1 && 2 /* IndexType.FULL */ === n ? 1 /* IndexType.PARTIAL */ : n));
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */    fn(e, t) {
        const n = new __PRIVATE_IndexByteEncoder;
        for (const r of __PRIVATE_fieldIndexGetDirectionalSegments(e)) {
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Xt(r.kind);
            __PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, i);
        }
        return n.Ht();
    }
    /** Encodes a single value to the ascending index format. */    Rn(e) {
        const t = new __PRIVATE_IndexByteEncoder;
        return __PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, t.Xt(0 /* IndexKind.ASCENDING */)), 
        t.Ht();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */    gn(e, t) {
        const n = new __PRIVATE_IndexByteEncoder;
        return __PRIVATE_FirestoreIndexValueWriter.Ft.Et(__PRIVATE_refValue(this.databaseId, t), n.Xt(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = __PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */ : t[t.length - 1].kind;
        }(e))), n.Ht();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */    dn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new __PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of __PRIVATE_fieldIndexGetDirectionalSegments(e)) {
            const e = n[i++];
            for (const n of r) if (this.pn(t, s.fieldPath) && isArray(e)) r = this.yn(r, s, e); else {
                const t = n.Xt(s.kind);
                __PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, t);
            }
        }
        return this.wn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */    En(e, t, n) {
        return this.dn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */    wn(e) {
        const t = [];
        for (let n = 0; n < e.length; ++n) t[n] = e[n].Ht();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */    yn(e, t, n) {
        const r = [ ...e ], i = [];
        for (const e of n.arrayValue.values || []) for (const n of r) {
            const r = new __PRIVATE_IndexByteEncoder;
            r.seed(n.Ht()), __PRIVATE_FirestoreIndexValueWriter.Ft.Et(e, r.Xt(t.kind)), i.push(r);
        }
        return i;
    }
    pn(e, t) {
        return !!e.filters.find((e => e instanceof FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */ === e.op || "not-in" /* Operator.NOT_IN */ === e.op)));
    }
    getFieldIndexes(e, t) {
        const n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e);
        return (t ? n.U("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.U()).next((e => {
            const t = [];
            return PersistencePromise.forEach(e, (e => r.get([ e.indexId, this.uid ]).next((n => {
                t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                    const n = t ? new IndexState(t.sequenceNumber, new IndexOffset(__PRIVATE_fromDbTimestamp(t.readTime), new DocumentKey(__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : IndexState.empty(), r = e.fields.map((([e, t]) => new IndexSegment(FieldPath$1.fromServerFormat(e), t)));
                    return new FieldIndex(e.indexId, e.collectionGroup, r, n);
                }(e, n));
            })))).next((() => t));
        }));
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e => 0 === e.length ? null : (e.sort(((e, t) => {
            const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
            return 0 !== n ? n : __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
        })), e[0].collectionGroup)));
    }
    updateCollectionGroup(e, t, n) {
        const r = __PRIVATE_indexConfigurationStore(e), i = __PRIVATE_indexStateStore(e);
        return this.Sn(e).next((e => r.U("collectionGroupIndex", IDBKeyRange.bound(t, t)).next((t => PersistencePromise.forEach(t, (t => i.put(__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n))))))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return PersistencePromise.forEach(t, ((t, r) => {
            const i = n.get(t.collectionGroup);
            return (i ? PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i => (n.set(t.collectionGroup, i), 
            PersistencePromise.forEach(i, (n => this.bn(e, t, n).next((t => {
                const i = this.Dn(r, n);
                return t.isEqual(i) ? PersistencePromise.resolve() : this.vn(e, r, n, t, i);
            })))))));
        }));
    }
    Cn(e, t, n, r) {
        return __PRIVATE_indexEntriesStore(e).put({
            indexId: r.indexId,
            uid: this.uid,
            arrayValue: r.arrayValue,
            directionalValue: r.directionalValue,
            orderedDocumentKey: this.gn(n, t.key),
            documentKey: t.key.path.toArray()
        });
    }
    Fn(e, t, n, r) {
        return __PRIVATE_indexEntriesStore(e).delete([ r.indexId, this.uid, r.arrayValue, r.directionalValue, this.gn(n, t.key), t.key.path.toArray() ]);
    }
    bn(e, t, n) {
        const r = __PRIVATE_indexEntriesStore(e);
        let i = new SortedSet(__PRIVATE_indexEntryComparator);
        return r.J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([ n.indexId, this.uid, this.gn(n, t) ])
        }, ((e, r) => {
            i = i.add(new __PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
        })).next((() => i));
    }
    /** Creates the index entries for the given document. */    Dn(e, t) {
        let n = new SortedSet(__PRIVATE_indexEntryComparator);
        const r = this.fn(t, e);
        if (null == r) return n;
        const i = __PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if (isArray(s)) for (const i of s.arrayValue.values || []) n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, this.Rn(i), r));
        } else n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, Ae, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */    vn(e, t, n, r, i) {
        __PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for (;_ || a; ) {
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? 
                    // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && (
                    // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = __PRIVATE_advanceIterator(o)) : t ? (i(_), _ = __PRIVATE_advanceIterator(s)) : (_ = __PRIVATE_advanceIterator(s), 
                a = __PRIVATE_advanceIterator(o));
            }
        }(r, i, __PRIVATE_indexEntryComparator, (
        /* onAdd= */ r => {
            s.push(this.Cn(e, t, n, r));
        }), (
        /* onRemove= */ r => {
            s.push(this.Fn(e, t, n, r));
        })), PersistencePromise.waitFor(s);
    }
    Sn(e) {
        let t = 1;
        return __PRIVATE_indexStateStore(e).J({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([ this.uid, Number.MAX_SAFE_INTEGER ])
        }, ((e, n, r) => {
            r.done(), t = n.sequenceNumber + 1;
        })).next((() => t));
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */    createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort(((e, t) => __PRIVATE_indexEntryComparator(e, t))).filter(((e, t, n) => !t || 0 !== __PRIVATE_indexEntryComparator(e, n[t - 1])));
        const r = [];
        r.push(e);
        for (const i of n) {
            const n = __PRIVATE_indexEntryComparator(i, e), s = __PRIVATE_indexEntryComparator(i, t);
            if (0 === n) 
            // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.en(); else if (n > 0 && s < 0) 
            // `notInValue` is in the middle of the range
            r.push(i), r.push(i.en()); else if (s > 0) 
            // `notInValue` (and all following values) are out of the range
            break;
        }
        r.push(t);
        const i = [];
        for (let e = 0; e < r.length; e += 2) {
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Mn(r[e], r[e + 1])) return [];
            const t = [ r[e].indexId, this.uid, r[e].arrayValue, r[e].directionalValue, Ae, [] ], n = [ r[e + 1].indexId, this.uid, r[e + 1].arrayValue, r[e + 1].directionalValue, Ae, [] ];
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Mn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return __PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next(__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return PersistencePromise.mapArray(this.Tn(t), (t => this.In(e, t).next((e => e || fail())))).next(__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}

/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function __PRIVATE_collectionParentsStore(e) {
    return __PRIVATE_getStore(e, "collectionParents");
}

/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function __PRIVATE_indexEntriesStore(e) {
    return __PRIVATE_getStore(e, "indexEntries");
}

/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function __PRIVATE_indexConfigurationStore(e) {
    return __PRIVATE_getStore(e, "indexConfiguration");
}

/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function __PRIVATE_indexStateStore(e) {
    return __PRIVATE_getStore(e, "indexState");
}

function __PRIVATE_getMinOffsetFromFieldIndexes(e) {
    __PRIVATE_hardAssert(0 !== e.length);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for (let r = 1; r < e.length; r++) {
        const i = e[r].indexState.offset;
        __PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new IndexOffset(t.readTime, t.documentKey, n);
}

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Re = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};

class LruParams {
    static withCacheSize(e) {
        return new LruParams(e, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(
    // When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, 
    // The percentage of sequence numbers that we will attempt to collect
    t, 
    // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */
function removeMutationBatch(e, t, n) {
    const r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.J({
        range: o
    }, ((e, t, n) => (_++, n.delete())));
    s.push(a.next((() => {
        __PRIVATE_hardAssert(1 === _);
    })));
    const u = [];
    for (const e of n.mutations) {
        const r = __PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return PersistencePromise.waitFor(s).next((() => u));
}

/**
 * Returns an approximate size for the given document.
 */ function __PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document; else if (e.unknownDocument) t = e.unknownDocument; else {
        if (!e.noDocument) throw fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** A mutation queue for a specific user, backed by IndexedDB. */ LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, 
LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, LruParams.DEFAULT = new LruParams(41943040, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), 
LruParams.DISABLED = new LruParams(-1, 0, 0);

class __PRIVATE_IndexedDbMutationQueue {
    constructor(
    /**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */
    e, t, n, r) {
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, 
        /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */
        // PORTING NOTE: Multi-tab only.
        this.xn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */    static Pt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        __PRIVATE_hardAssert("" !== e.uid);
        const i = e.isAuthenticated() ? e.uid : "";
        return new __PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([ this.userId, Number.NEGATIVE_INFINITY ], [ this.userId, Number.POSITIVE_INFINITY ]);
        return __PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: n
        }, ((e, n, r) => {
            t = !1, r.done();
        })).next((() => t));
    }
    addMutationBatch(e, t, n, r) {
        const i = __PRIVATE_documentMutationsStore(e), s = __PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o => {
            __PRIVATE_hardAssert("number" == typeof o);
            const _ = new MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t => toMutation(e.ht, t))), i = n.mutations.map((t => toMutation(e.ht, t)));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new SortedSet(((e, t) => __PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString())));
            for (const e of r) {
                const t = __PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, x));
            }
            return c.forEach((t => {
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            })), e.addOnCommittedListener((() => {
                this.xn[o] = _.keys();
            })), PersistencePromise.waitFor(u).next((() => _));
        }));
    }
    lookupMutationBatch(e, t) {
        return __PRIVATE_mutationsStore(e).get(t).next((e => e ? (__PRIVATE_hardAssert(e.userId === this.userId), 
        __PRIVATE_fromDbMutationBatch(this.serializer, e)) : null));
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */
    // PORTING NOTE: Multi-tab only.
    On(e, t) {
        return this.xn[t] ? PersistencePromise.resolve(this.xn[t]) : this.lookupMutationBatch(e, t).next((e => {
            if (e) {
                const n = e.keys();
                return this.xn[t] = n, n;
            }
            return null;
        }));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([ this.userId, n ]);
        let i = null;
        return __PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: r
        }, ((e, t, r) => {
            t.userId === this.userId && (__PRIVATE_hardAssert(t.batchId >= n), i = __PRIVATE_fromDbMutationBatch(this.serializer, t)), 
            r.done();
        })).next((() => i));
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([ this.userId, Number.POSITIVE_INFINITY ]);
        let n = -1;
        return __PRIVATE_mutationsStore(e).J({
            index: "userMutationsIndex",
            range: t,
            reverse: !0
        }, ((e, t, r) => {
            n = t.batchId, r.done();
        })).next((() => n));
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([ this.userId, -1 ], [ this.userId, Number.POSITIVE_INFINITY ]);
        return __PRIVATE_mutationsStore(e).U("userMutationsIndex", t).next((e => e.map((e => __PRIVATE_fromDbMutationBatch(this.serializer, e)))));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return __PRIVATE_documentMutationsStore(e).J({
            range: r
        }, ((n, r, s) => {
            const [o, _, a] = n, u = __PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
                        if (o === this.userId && t.path.isEqual(u)) 
            // Look up the mutation batch in the store.
            return __PRIVATE_mutationsStore(e).get(a).next((e => {
                if (!e) throw fail();
                __PRIVATE_hardAssert(e.userId === this.userId), i.push(__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
            s.done();
        })).next((() => i));
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new SortedSet(__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t => {
            const i = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = __PRIVATE_documentMutationsStore(e).J({
                range: s
            }, ((e, r, i) => {
                const [s, o, _] = e, a = __PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            }));
            r.push(o);
        })), PersistencePromise.waitFor(r).next((() => this.Nn(e, n)));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new SortedSet(__PRIVATE_primitiveComparator);
        return __PRIVATE_documentMutationsStore(e).J({
            range: s
        }, ((e, t, i) => {
            const [s, _, a] = e, u = __PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? 
            // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        })).next((() => this.Nn(e, o)));
    }
    Nn(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t => {
            r.push(__PRIVATE_mutationsStore(e).get(t).next((e => {
                if (null === e) throw fail();
                __PRIVATE_hardAssert(e.userId === this.userId), n.push(__PRIVATE_fromDbMutationBatch(this.serializer, e));
            })));
        })), PersistencePromise.waitFor(r).next((() => n));
    }
    removeMutationBatch(e, t) {
        return removeMutationBatch(e._e, this.userId, t).next((n => (e.addOnCommittedListener((() => {
            this.Ln(t.batchId);
        })), PersistencePromise.forEach(n, (t => this.referenceDelegate.markPotentiallyOrphaned(e, t))))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */
    // PORTING NOTE: Multi-tab only
    Ln(e) {
        delete this.xn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t => {
            if (!t) return PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
                        const n = IDBKeyRange.lowerBound(
            /**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */
            function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [ e ];
            }(this.userId)), r = [];
            return __PRIVATE_documentMutationsStore(e).J({
                range: n
            }, ((e, t, n) => {
                if (e[0] === this.userId) {
                    const t = __PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            })).next((() => {
                __PRIVATE_hardAssert(0 === r.length);
            }));
        }));
    }
    containsKey(e, t) {
        return __PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */
    Bn(e) {
        return __PRIVATE_mutationQueuesStore(e).get(this.userId).next((e => e || {
            userId: this.userId,
            lastAcknowledgedBatchId: -1,
            lastStreamToken: ""
        }));
    }
}

/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function __PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = __PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return __PRIVATE_documentMutationsStore(e).J({
        range: s,
        H: !0
    }, ((e, n, r) => {
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    })).next((() => o));
}

/** Returns true if any mutation queue contains the given document. */
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */
function __PRIVATE_mutationsStore(e) {
    return __PRIVATE_getStore(e, "mutations");
}

/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_documentMutationsStore(e) {
    return __PRIVATE_getStore(e, "documentMutations");
}

/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_mutationQueuesStore(e) {
    return __PRIVATE_getStore(e, "mutationQueues");
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Offset to ensure non-overlapping target ids. */
/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */
class __PRIVATE_TargetIdGenerator {
    constructor(e) {
        this.kn = e;
    }
    next() {
        return this.kn += 2, this.kn;
    }
    static qn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new __PRIVATE_TargetIdGenerator(0);
    }
    static Qn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new __PRIVATE_TargetIdGenerator(-1);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_IndexedDbTargetCache {
    constructor(e, t) {
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Kn(e).next((t => {
            const n = new __PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.$n(e, t).next((() => t.highestTargetId));
        }));
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Kn(e).next((e => SnapshotVersion.fromTimestamp(new Timestamp(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds))));
    }
    getHighestSequenceNumber(e) {
        return this.Kn(e).next((e => e.highestListenSequenceNumber));
    }
    setTargetsMetadata(e, t, n) {
        return this.Kn(e).next((r => (r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), 
        t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.$n(e, r))));
    }
    addTargetData(e, t) {
        return this.Un(e, t).next((() => this.Kn(e).next((n => (n.targetCount += 1, this.Wn(t, n), 
        this.$n(e, n))))));
    }
    updateTargetData(e, t) {
        return this.Un(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next((() => __PRIVATE_targetsStore(e).delete(t.targetId))).next((() => this.Kn(e))).next((t => (__PRIVATE_hardAssert(t.targetCount > 0), 
        t.targetCount -= 1, this.$n(e, t))));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return __PRIVATE_targetsStore(e).J(((s, o) => {
            const _ = __PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        })).next((() => PersistencePromise.waitFor(i))).next((() => r));
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */    forEachTarget(e, t) {
        return __PRIVATE_targetsStore(e).J(((e, n) => {
            const r = __PRIVATE_fromDbTarget(n);
            t(r);
        }));
    }
    Kn(e) {
        return __PRIVATE_globalTargetStore(e).get("targetGlobalKey").next((e => (__PRIVATE_hardAssert(null !== e), 
        e)));
    }
    $n(e, t) {
        return __PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
    }
    Un(e, t) {
        return __PRIVATE_targetsStore(e).put(__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */    Wn(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), 
        e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, 
        n = !0), n;
    }
    getTargetCount(e) {
        return this.Kn(e).next((e => e.targetCount));
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = __PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([ n, Number.NEGATIVE_INFINITY ], [ n, Number.POSITIVE_INFINITY ]);
        let i = null;
        return __PRIVATE_targetsStore(e).J({
            range: r,
            index: "queryTargetsIndex"
        }, ((e, n, r) => {
            const s = __PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
                        __PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        })).next((() => i));
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = __PRIVATE_documentTargetStore(e);
        return t.forEach((t => {
            const s = __PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        })), PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = __PRIVATE_documentTargetStore(e);
        return PersistencePromise.forEach(t, (t => {
            const i = __PRIVATE_encodeResourcePath(t.path);
            return PersistencePromise.waitFor([ r.delete([ n, i ]), this.referenceDelegate.removeReference(e, n, t) ]);
        }));
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = __PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([ t ], [ t + 1 ], 
        /*lowerOpen=*/ !1, 
        /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([ t ], [ t + 1 ], 
        /*lowerOpen=*/ !1, 
        /*upperOpen=*/ !0), r = __PRIVATE_documentTargetStore(e);
        let i = __PRIVATE_documentKeySet();
        return r.J({
            range: n,
            H: !0
        }, ((e, t, n) => {
            const r = __PRIVATE_decodeResourcePath(e[1]), s = new DocumentKey(r);
            i = i.add(s);
        })).next((() => i));
    }
    containsKey(e, t) {
        const n = __PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([ n ], [ __PRIVATE_immediateSuccessor(n) ], 
        /*lowerOpen=*/ !1, 
        /*upperOpen=*/ !0);
        let i = 0;
        return __PRIVATE_documentTargetStore(e).J({
            index: "documentTargetsIndex",
            H: !0,
            range: r
        }, (([e, t], n, r) => {
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        })).next((() => i > 0));
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */
    // PORTING NOTE: Multi-tab only.
    ut(e, t) {
        return __PRIVATE_targetsStore(e).get(t).next((e => e ? __PRIVATE_fromDbTarget(e) : null));
    }
}

/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function __PRIVATE_targetsStore(e) {
    return __PRIVATE_getStore(e, "targets");
}

/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function __PRIVATE_globalTargetStore(e) {
    return __PRIVATE_getStore(e, "targetGlobal");
}

/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function __PRIVATE_documentTargetStore(e) {
    return __PRIVATE_getStore(e, "targetDocuments");
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = __PRIVATE_primitiveComparator(e, n);
    return 0 === i ? __PRIVATE_primitiveComparator(t, r) : i;
}

/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class __PRIVATE_RollingSequenceNumberBuffer {
    constructor(e) {
        this.Gn = e, this.buffer = new SortedSet(__PRIVATE_bufferEntryComparator), this.zn = 0;
    }
    jn() {
        return ++this.zn;
    }
    Hn(e) {
        const t = [ e, this.jn() ];
        if (this.buffer.size < this.Gn) this.buffer = this.buffer.add(t); else {
            const e = this.buffer.last();
            __PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}

/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class __PRIVATE_LruScheduler {
    constructor(e, t, n) {
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Jn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Yn(6e4);
    }
    stop() {
        this.Jn && (this.Jn.cancel(), this.Jn = null);
    }
    get started() {
        return null !== this.Jn;
    }
    Yn(e) {
        __PRIVATE_logDebug("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), 
        this.Jn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, (async () => {
            this.Jn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                __PRIVATE_isIndexedDbTransactionError(e) ? __PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Yn(3e5);
        }));
    }
}

/**
 * Implements the steps for LRU garbage collection.
 */ class __PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t) {
        this.Zn = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Zn.Xn(e).next((e => Math.floor(t / 100 * e)));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return PersistencePromise.resolve(__PRIVATE_ListenSequence.oe);
        const n = new __PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Zn.forEachTarget(e, (e => n.Hn(e.sequenceNumber))).next((() => this.Zn.er(e, (e => n.Hn(e))))).next((() => n.maxValue));
    }
    removeTargets(e, t, n) {
        return this.Zn.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Zn.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), 
        PersistencePromise.resolve(Re)) : this.getCacheSize(e).next((n => n < this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), 
        Re) : this.tr(e, t)));
    }
    getCacheSize(e) {
        return this.Zn.getCacheSize(e);
    }
    tr(e, t) {
        let n, r, i, s, o, a, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t => (
        // Cap at the configured max
        t > this.params.maximumSequenceNumbersToCollect ? (__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), 
        r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r)))).next((r => (n = r, 
        o = Date.now(), this.removeTargets(e, n, t)))).next((t => (i = t, a = Date.now(), 
        this.removeOrphanedDocuments(e, n)))).next((e => {
            if (u = Date.now(), __PRIVATE_getLogLevel() <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG) {
                __PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (a - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - a) + "ms\n" + `Total Duration: ${u - c}ms`);
            }
            return PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        }));
    }
}

function __PRIVATE_newLruGarbageCollector(e, t) {
    return new __PRIVATE_LruGarbageCollectorImpl(e, t);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Provides LRU functionality for IndexedDB persistence. */ class __PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t) {
        this.db = e, this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    Xn(e) {
        const t = this.nr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e => t.next((t => e + t))));
    }
    nr(e) {
        let t = 0;
        return this.er(e, (e => {
            t++;
        })).next((() => t));
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    er(e, t) {
        return this.rr(e, ((e, n) => t(n)));
    }
    addReference(e, t, n) {
        return __PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return __PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return __PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */    ir(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return __PRIVATE_mutationQueuesStore(e).Y((r => __PRIVATE_mutationQueueContainsKey(e, r, t).next((e => (e && (n = !0), 
            PersistencePromise.resolve(!e)))))).next((() => n));
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.rr(e, ((s, o) => {
            if (o <= t) {
                const t = this.ir(e, s).next((t => {
                    if (!t) 
                    // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next((() => (n.removeEntry(s, SnapshotVersion.min()), 
                    __PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                        return [ 0, __PRIVATE_encodeResourcePath(e.path) ];
                    }
                    /**
 * @returns A value suitable for writing a sentinel row in the target-document
 * store.
 */ (s)))));
                }));
                r.push(t);
            }
        })).next((() => PersistencePromise.waitFor(r))).next((() => n.apply(e))).next((() => i));
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return __PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */    rr(e, t) {
        const n = __PRIVATE_documentTargetStore(e);
        let r, i = __PRIVATE_ListenSequence.oe;
        return n.J({
            index: "documentTargetsIndex"
        }, (([e, n], {path: s, sequenceNumber: o}) => {
            0 === e ? (
            // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            i !== __PRIVATE_ListenSequence.oe && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i), 
            // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : 
            // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = __PRIVATE_ListenSequence.oe;
        })).next((() => {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== __PRIVATE_ListenSequence.oe && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i);
        }));
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}

function __PRIVATE_writeSentinelKey(e, t) {
    return __PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: __PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class RemoteDocumentChangeBuffer {
    constructor() {
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new ObjectMap((e => e.toString()), ((e, t) => e.isEqual(t))), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */    addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */    removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */    getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */    getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */    apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */    assertNotApplied() {}
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class __PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e) {
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */    addEntry(e, t, n) {
        return __PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */    removeEntry(e, t, n) {
        return __PRIVATE_remoteDocumentsStore(e).delete(
        /**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */
        function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [ 
            /* prefix path */ n.slice(0, n.length - 2), 
            /* collection id */ n[n.length - 2], __PRIVATE_toDbTimestampKey(t), 
            /* document id */ n[n.length - 1] ];
        }
        /**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentCollectionGroupIndex` index.
 */ (t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */    updateMetadata(e, t) {
        return this.getMetadata(e).next((n => (n.byteSize += t, this.sr(e, n))));
    }
    getEntry(e, t) {
        let n = MutableDocument.newInvalidDocument(t);
        return __PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only(__PRIVATE_dbKey(t))
        }, ((e, r) => {
            n = this._r(t, r);
        })).next((() => n));
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */    ar(e, t) {
        let n = {
            size: 0,
            document: MutableDocument.newInvalidDocument(t)
        };
        return __PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: IDBKeyRange.only(__PRIVATE_dbKey(t))
        }, ((e, r) => {
            n = {
                document: this._r(t, r),
                size: __PRIVATE_dbDocumentSize(r)
            };
        })).next((() => n));
    }
    getEntries(e, t) {
        let n = __PRIVATE_mutableDocumentMap();
        return this.ur(e, t, ((e, t) => {
            const r = this._r(e, t);
            n = n.insert(e, r);
        })).next((() => n));
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */    cr(e, t) {
        let n = __PRIVATE_mutableDocumentMap(), r = new SortedMap(DocumentKey.comparator);
        return this.ur(e, t, ((e, t) => {
            const i = this._r(e, t);
            n = n.insert(e, i), r = r.insert(e, __PRIVATE_dbDocumentSize(t));
        })).next((() => ({
            documents: n,
            lr: r
        })));
    }
    ur(e, t, n) {
        if (t.isEmpty()) return PersistencePromise.resolve();
        let r = new SortedSet(__PRIVATE_dbKeyComparator);
        t.forEach((e => r = r.add(e)));
        const i = IDBKeyRange.bound(__PRIVATE_dbKey(r.first()), __PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return __PRIVATE_remoteDocumentsStore(e).J({
            index: "documentKeyIndex",
            range: i
        }, ((e, t, r) => {
            const i = DocumentKey.fromSegments([ ...t.prefixPath, t.collectionGroup, t.documentId ]);
            // Go through keys not found in cache.
                        for (;o && __PRIVATE_dbKeyComparator(o, i) < 0; ) n(o, null), o = s.getNext();
            o && o.isEqual(i) && (
            // Key found in cache.
            n(o, t), o = s.hasNext() ? s.getNext() : null), 
            // Skip to the next key (if there is one).
            o ? r.$(__PRIVATE_dbKey(o)) : r.done();
        })).next((() => {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for (;o; ) n(o, null), o = s.hasNext() ? s.getNext() : null;
        }));
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [ s.popLast().toArray(), s.lastSegment(), __PRIVATE_toDbTimestampKey(n.readTime), n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment() ], _ = [ s.popLast().toArray(), s.lastSegment(), [ Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER ], "" ];
        return __PRIVATE_remoteDocumentsStore(e).U(IDBKeyRange.bound(o, _, !0)).next((e => {
            null == i || i.incrementDocumentReadCount(e.length);
            let n = __PRIVATE_mutableDocumentMap();
            for (const i of e) {
                const e = this._r(DocumentKey.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && (__PRIVATE_queryMatches(t, e) || r.has(e.key)) && (
                // Either the document matches the given query, or it is mutated.
                n = n.insert(e.key, e));
            }
            return n;
        }));
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = __PRIVATE_mutableDocumentMap();
        const s = __PRIVATE_dbCollectionGroupKey(t, n), o = __PRIVATE_dbCollectionGroupKey(t, IndexOffset.max());
        return __PRIVATE_remoteDocumentsStore(e).J({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(s, o, !0)
        }, ((e, t, n) => {
            const s = this._r(DocumentKey.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        })).next((() => i));
    }
    newChangeBuffer(e) {
        return new __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e => e.byteSize));
    }
    getMetadata(e) {
        return __PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next((e => (__PRIVATE_hardAssert(!!e), 
        e)));
    }
    sr(e, t) {
        return __PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */    _r(e, t) {
        if (t) {
            const e = __PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
                        if (!(e.isNoDocument() && e.version.isEqual(SnapshotVersion.min()))) return e;
        }
        return MutableDocument.newInvalidDocument(e);
    }
}

/** Creates a new IndexedDbRemoteDocumentCache. */ function __PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}

/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class __PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends (/* unused pure expression or super */ null && (RemoteDocumentChangeBuffer)) {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */
    constructor(e, t) {
        super(), this.hr = e, this.trackRemovals = t, 
        // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Pr = new ObjectMap((e => e.toString()), ((e, t) => e.isEqual(t)));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new SortedSet(((e, t) => __PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString())));
        return this.changes.forEach(((i, s) => {
            const o = this.Pr.get(i);
            if (t.push(this.hr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = __PRIVATE_toDbRemoteDocument(this.hr.serializer, s);
                r = r.add(i.path.popLast());
                const a = __PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.hr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = __PRIVATE_toDbRemoteDocument(this.hr.serializer, s.convertToNoDocument(SnapshotVersion.min()));
                t.push(this.hr.addEntry(e, i, n));
            }
        })), r.forEach((n => {
            t.push(this.hr.indexManager.addToCollectionParentIndex(e, n));
        })), t.push(this.hr.updateMetadata(e, n)), PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.hr.ar(e, t).next((e => (this.Pr.set(t, {
            size: e.size,
            readTime: e.document.readTime
        }), e.document)));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.hr.cr(e, t).next((({documents: e, lr: t}) => (
        // Note: `getAllFromCache` returns two maps instead of a single map from
        // keys to `DocumentSizeEntry`s. This is to allow returning the
        // `MutableDocumentMap` directly, without a conversion.
        t.forEach(((t, n) => {
            this.Pr.set(t, {
                size: n,
                readTime: e.get(t).readTime
            });
        })), e)));
    }
}

function __PRIVATE_documentGlobalStore(e) {
    return __PRIVATE_getStore(e, "remoteDocumentGlobal");
}

/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function __PRIVATE_remoteDocumentsStore(e) {
    return __PRIVATE_getStore(e, "remoteDocumentsV14");
}

/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function __PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [ 
    /* prefix path */ t.slice(0, t.length - 2), 
    /* collection id */ t[t.length - 2], 
    /* document id */ t[t.length - 1] ];
}

function __PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [ 
    /* collection id */ e, __PRIVATE_toDbTimestampKey(t.readTime), 
    /* prefix path */ n.slice(0, n.length - 2), 
    /* document id */ n.length > 0 ? n[n.length - 1] : "" ];
}

/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function __PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for (let e = 0; e < n.length - 2 && e < r.length - 2; ++e) if (i = __PRIVATE_primitiveComparator(n[e], r[e]), 
    i) return i;
    return i = __PRIVATE_primitiveComparator(n.length, r.length), i || (i = __PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), 
    i || __PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */
class OverlayedDocument {
    constructor(e, 
    /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */
    t) {
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class LocalDocumentsView {
    constructor(e, t, n, r) {
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, 
        this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */    getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r => (n = r, this.remoteDocumentCache.getEntry(e, t)))).next((e => (null !== n && __PRIVATE_mutationApplyToLocalView(n.mutation, e, FieldMask.empty(), Timestamp.now()), 
        e)));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */    getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t => this.getLocalViewOfDocuments(e, t, __PRIVATE_documentKeySet()).next((() => t))));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */    getLocalViewOfDocuments(e, t, n = __PRIVATE_documentKeySet()) {
        const r = __PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next((() => this.computeViews(e, t, r, n).next((e => {
            let t = documentMap();
            return e.forEach(((e, n) => {
                t = t.insert(e, n.overlayedDocument);
            })), t;
        }))));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */    getOverlayedDocuments(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next((() => this.computeViews(e, t, n, __PRIVATE_documentKeySet())));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */    populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e => {
            t.has(e) || r.push(e);
        })), this.documentOverlayCache.getOverlays(e, r).next((e => {
            e.forEach(((e, n) => {
                t.set(e, n);
            }));
        }));
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */    computeViews(e, t, n, r) {
        let i = __PRIVATE_mutableDocumentMap();
        const s = __PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return __PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach(((e, t) => {
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
                        r.has(t.key) && (void 0 === o || o.mutation instanceof __PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), 
            __PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), Timestamp.now())) : 
            // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, FieldMask.empty());
        })), this.recalculateAndSaveOverlays(e, i).next((e => (e.forEach(((e, t) => s.set(e, t))), 
        t.forEach(((e, t) => {
            var n;
            return o.set(e, new OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
        })), o)));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = __PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
                let r = new SortedMap(((e, t) => e - t)), i = __PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e => {
            for (const i of e) i.keys().forEach((e => {
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || __PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            }));
        })).next((() => {
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
                        for (;o.hasNext(); ) {
                const r = o.getNext(), _ = r.key, a = r.value, u = __PRIVATE_newMutationMap();
                a.forEach((e => {
                    if (!i.has(e)) {
                        const r = __PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                })), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return PersistencePromise.waitFor(s);
        })).next((() => n));
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */    recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t => this.recalculateAndSaveOverlays(e, t)));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */    getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */
        return function __PRIVATE_isDocumentQuery$1(e) {
            return DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : __PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */    getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i => {
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : PersistencePromise.resolve(__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
                        let o = -1, _ = i;
            return s.next((t => PersistencePromise.forEach(t, ((t, n) => (o < n.largestBatchId && (o = n.largestBatchId), 
            i.get(t) ? PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e => {
                _ = _.insert(t, e);
            }))))).next((() => this.populateOverlays(e, t, i))).next((() => this.computeViews(e, _, t, __PRIVATE_documentKeySet()))).next((e => ({
                batchId: o,
                changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
            })))));
        }));
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new DocumentKey(t)).next((e => {
            let t = documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        }));
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o => PersistencePromise.forEach(o, (o => {
            const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                return new __PRIVATE_QueryImpl(t, 
                /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
            }(t, o.child(i));
            return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e => {
                e.forEach(((e, t) => {
                    s = s.insert(e, t);
                }));
            }));
        })).next((() => s))));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s => (i = s, 
        this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r)))).next((e => {
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach(((t, n) => {
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, MutableDocument.newInvalidDocument(r)));
            }));
            // Apply the overlays and match against the query.
            let n = documentMap();
            return e.forEach(((e, r) => {
                const s = i.get(e);
                void 0 !== s && __PRIVATE_mutationApplyToLocalView(s.mutation, r, FieldMask.empty(), Timestamp.now()), 
                // Finally, insert the documents that still match the query
                __PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            })), n;
        }));
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryBundleCache {
    constructor(e) {
        this.serializer = e, this.Tr = new Map, this.Ir = new Map;
    }
    getBundleMetadata(e, t) {
        return PersistencePromise.resolve(this.Tr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Tr.set(t.id, 
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */
        function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: __PRIVATE_fromVersion(e.createTime)
            };
        }(t)), PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return PersistencePromise.resolve(this.Ir.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Ir.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: __PRIVATE_fromVersion(e.readTime)
            };
        }(t)), PersistencePromise.resolve();
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory implementation of DocumentOverlayCache.
 */ class __PRIVATE_MemoryDocumentOverlayCache {
    constructor() {
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new SortedMap(DocumentKey.comparator), this.Er = new Map;
    }
    getOverlay(e, t) {
        return PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return PersistencePromise.forEach(t, (t => this.getOverlay(e, t).next((e => {
            null !== e && n.set(t, e);
        })))).next((() => n));
    }
    saveOverlays(e, t, n) {
        return n.forEach(((n, r) => {
            this.Tt(e, t, r);
        })), PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Er.get(n);
        return void 0 !== r && (r.forEach((e => this.overlays = this.overlays.remove(e))), 
        this.Er.delete(n)), PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = __PRIVATE_newOverlayMap(), i = t.length + 1, s = new DocumentKey(t.child("")), o = this.overlays.getIteratorFrom(s);
        for (;o.hasNext(); ) {
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
                        s.path.length === i && (e.largestBatchId > n && r.set(e.getKey(), e));
        }
        return PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new SortedMap(((e, t) => e - t));
        const s = this.overlays.getIterator();
        for (;s.hasNext(); ) {
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = __PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), 
                t.set(e.getKey(), e);
            }
        }
        const o = __PRIVATE_newOverlayMap(), _ = i.getIterator();
        for (;_.hasNext(); ) {
            if (_.getNext().value.forEach(((e, t) => o.set(e, t))), o.size() >= r) break;
        }
        return PersistencePromise.resolve(o);
    }
    Tt(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Er.get(r.largestBatchId).delete(n.key);
            this.Er.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Er.get(t);
        void 0 === i && (i = __PRIVATE_documentKeySet(), this.Er.set(t, i)), this.Er.set(t, i.add(n.key));
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryGlobalsCache {
    constructor() {
        this.sessionToken = ByteString.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, PersistencePromise.resolve();
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class __PRIVATE_ReferenceSet {
    constructor() {
        // A set of outstanding references to a document sorted by key.
        this.dr = new SortedSet(__PRIVATE_DocReference.Ar), 
        // A set of outstanding references to a document sorted by target id.
        this.Rr = new SortedSet(__PRIVATE_DocReference.Vr);
    }
    /** Returns true if the reference set contains no references. */    isEmpty() {
        return this.dr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */    addReference(e, t) {
        const n = new __PRIVATE_DocReference(e, t);
        this.dr = this.dr.add(n), this.Rr = this.Rr.add(n);
    }
    /** Add references to the given document keys for the given ID. */    mr(e, t) {
        e.forEach((e => this.addReference(e, t)));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */    removeReference(e, t) {
        this.gr(new __PRIVATE_DocReference(e, t));
    }
    pr(e, t) {
        e.forEach((e => this.removeReference(e, t)));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */    yr(e) {
        const t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1), i = [];
        return this.Rr.forEachInRange([ n, r ], (e => {
            this.gr(e), i.push(e.key);
        })), i;
    }
    wr() {
        this.dr.forEach((e => this.gr(e)));
    }
    gr(e) {
        this.dr = this.dr.delete(e), this.Rr = this.Rr.delete(e);
    }
    Sr(e) {
        const t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1);
        let i = __PRIVATE_documentKeySet();
        return this.Rr.forEachInRange([ n, r ], (e => {
            i = i.add(e.key);
        })), i;
    }
    containsKey(e) {
        const t = new __PRIVATE_DocReference(e, 0), n = this.dr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}

class __PRIVATE_DocReference {
    constructor(e, t) {
        this.key = e, this.br = t;
    }
    /** Compare by key then by ID */    static Ar(e, t) {
        return DocumentKey.comparator(e.key, t.key) || __PRIVATE_primitiveComparator(e.br, t.br);
    }
    /** Compare by ID then by key */    static Vr(e, t) {
        return __PRIVATE_primitiveComparator(e.br, t.br) || DocumentKey.comparator(e.key, t.key);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryMutationQueue {
    constructor(e, t) {
        this.indexManager = e, this.referenceDelegate = t, 
        /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */
        this.mutationQueue = [], 
        /** Next value to use when assigning sequential IDs to each mutation batch. */
        this.Dr = 1, 
        /** An ordered mapping between documents and the mutations batch IDs. */
        this.vr = new SortedSet(__PRIVATE_DocReference.Ar);
    }
    checkEmpty(e) {
        return PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Dr;
        this.Dr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r) this.vr = this.vr.add(new __PRIVATE_DocReference(t.key, i)), 
        this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return PersistencePromise.resolve(this.Cr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Fr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
                return PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.Dr - 1);
    }
    getAllMutationBatches(e) {
        return PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new __PRIVATE_DocReference(t, 0), r = new __PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.vr.forEachInRange([ n, r ], (e => {
            const t = this.Cr(e.br);
            i.push(t);
        })), PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new SortedSet(__PRIVATE_primitiveComparator);
        return t.forEach((e => {
            const t = new __PRIVATE_DocReference(e, 0), r = new __PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.vr.forEachInRange([ t, r ], (e => {
                n = n.add(e.br);
            }));
        })), PersistencePromise.resolve(this.Mr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        DocumentKey.isDocumentKey(i) || (i = i.child(""));
        const s = new __PRIVATE_DocReference(new DocumentKey(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
                let o = new SortedSet(__PRIVATE_primitiveComparator);
        return this.vr.forEachWhile((e => {
            const t = e.key.path;
            return !!n.isPrefixOf(t) && (
            // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            t.length === r && (o = o.add(e.br)), !0);
        }), s), PersistencePromise.resolve(this.Mr(o));
    }
    Mr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e => {
            const n = this.Cr(e);
            null !== n && t.push(n);
        })), t;
    }
    removeMutationBatch(e, t) {
        __PRIVATE_hardAssert(0 === this.Or(t.batchId, "removed")), this.mutationQueue.shift();
        let n = this.vr;
        return PersistencePromise.forEach(t.mutations, (r => {
            const i = new __PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        })).next((() => {
            this.vr = n;
        }));
    }
    Ln(e) {
        // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new __PRIVATE_DocReference(t, 0), r = this.vr.firstAfterOrEqual(n);
        return PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */    Or(e, t) {
        return this.Fr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */    Fr(e) {
        if (0 === this.mutationQueue.length) 
        // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
                return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */    Cr(e) {
        const t = this.Fr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */
class __PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */
    constructor(e) {
        this.Nr = e, 
        /** Underlying cache of documents and their read times. */
        this.docs = function __PRIVATE_documentEntryMap() {
            return new SortedMap(DocumentKey.comparator);
        }(), 
        /** Size of all cached documents. */
        this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */    addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.Nr(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */    removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return PersistencePromise.resolve(n ? n.document.mutableCopy() : MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = __PRIVATE_mutableDocumentMap();
        return t.forEach((e => {
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : MutableDocument.newInvalidDocument(e));
        })), PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = __PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
                const s = t.path, o = new DocumentKey(s.child("")), _ = this.docs.getIteratorFrom(o);
        for (;_.hasNext(); ) {
            const {key: e, value: {document: o}} = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || (__PRIVATE_indexOffsetComparator(__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || __PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy())));
        }
        return PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        fail();
    }
    Lr(e, t) {
        return PersistencePromise.forEach(this.docs, (e => t(e)));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new __PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return PersistencePromise.resolve(this.size);
    }
}

/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */
/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */
class __PRIVATE_MemoryRemoteDocumentChangeBuffer extends RemoteDocumentChangeBuffer {
    constructor(e) {
        super(), this.hr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach(((n, r) => {
            r.isValidDocument() ? t.push(this.hr.addEntry(e, r)) : this.hr.removeEntry(n);
        })), PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.hr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.hr.getEntries(e, t);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryTargetCache {
    constructor(e) {
        this.persistence = e, 
        /**
         * Maps a target to the data about that target
         */
        this.Br = new ObjectMap((e => __PRIVATE_canonifyTarget(e)), __PRIVATE_targetEquals), 
        /** The last received snapshot version. */
        this.lastRemoteSnapshotVersion = SnapshotVersion.min(), 
        /** The highest numbered target ID encountered. */
        this.highestTargetId = 0, 
        /** The highest sequence number encountered. */
        this.kr = 0, 
        /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */
        this.qr = new __PRIVATE_ReferenceSet, this.targetCount = 0, this.Qr = __PRIVATE_TargetIdGenerator.qn();
    }
    forEachTarget(e, t) {
        return this.Br.forEach(((e, n) => t(n))), PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return PersistencePromise.resolve(this.kr);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.Qr.next(), PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.kr && (this.kr = t), 
        PersistencePromise.resolve();
    }
    Un(e) {
        this.Br.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.Qr = new __PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), 
        e.sequenceNumber > this.kr && (this.kr = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Un(t), this.targetCount += 1, PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Un(t), PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.Br.delete(t.target), this.qr.yr(t.targetId), this.targetCount -= 1, 
        PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.Br.forEach(((s, o) => {
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.Br.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), 
            r++);
        })), PersistencePromise.waitFor(i).next((() => r));
    }
    getTargetCount(e) {
        return PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.Br.get(t) || null;
        return PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.qr.mr(t, n), PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.qr.pr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t => {
            i.push(r.markPotentiallyOrphaned(e, t));
        })), PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.qr.yr(t), PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.qr.Sr(t);
        return PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return PersistencePromise.resolve(this.qr.containsKey(t));
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */
class __PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */
    constructor(e, t) {
        this.Kr = {}, this.overlays = {}, this.$r = new __PRIVATE_ListenSequence(0), this.Ur = !1, 
        this.Ur = !0, this.Wr = new __PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), 
        this.Gr = new __PRIVATE_MemoryTargetCache(this);
        this.indexManager = new __PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new __PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e => this.referenceDelegate.zr(e))), this.serializer = new __PRIVATE_LocalSerializer(t), 
        this.jr = new __PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.Ur = !1, Promise.resolve();
    }
    get started() {
        return this.Ur;
    }
    setDatabaseDeletedListener() {
        // No op.
    }
    setNetworkEnabled() {
        // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new __PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), 
        t;
    }
    getMutationQueue(e, t) {
        let n = this.Kr[e.toKey()];
        return n || (n = new __PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.Kr[e.toKey()] = n), 
        n;
    }
    getGlobalsCache() {
        return this.Wr;
    }
    getTargetCache() {
        return this.Gr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.jr;
    }
    runTransaction(e, t, n) {
        __PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new __PRIVATE_MemoryTransaction(this.$r.next());
        return this.referenceDelegate.Hr(), n(r).next((e => this.referenceDelegate.Jr(r).next((() => e)))).toPromise().then((e => (r.raiseOnCommittedEvent(), 
        e)));
    }
    Yr(e, t) {
        return PersistencePromise.or(Object.values(this.Kr).map((n => () => n.containsKey(e, t))));
    }
}

/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class __PRIVATE_MemoryTransaction extends PersistenceTransaction {
    constructor(e) {
        super(), this.currentSequenceNumber = e;
    }
}

class __PRIVATE_MemoryEagerDelegate {
    constructor(e) {
        this.persistence = e, 
        /** Tracks all documents that are active in Query views. */
        this.Zr = new __PRIVATE_ReferenceSet, 
        /** The list of documents that are potentially GCed after each transaction. */
        this.Xr = null;
    }
    static ei(e) {
        return new __PRIVATE_MemoryEagerDelegate(e);
    }
    get ti() {
        if (this.Xr) return this.Xr;
        throw fail();
    }
    addReference(e, t, n) {
        return this.Zr.addReference(n, t), this.ti.delete(n.toString()), PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Zr.removeReference(n, t), this.ti.add(n.toString()), PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.ti.add(t.toString()), PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Zr.yr(t.targetId).forEach((e => this.ti.add(e.toString())));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e => {
            e.forEach((e => this.ti.add(e.toString())));
        })).next((() => n.removeTargetData(e, t)));
    }
    Hr() {
        this.Xr = new Set;
    }
    Jr(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return PersistencePromise.forEach(this.ti, (n => {
            const r = DocumentKey.fromPath(n);
            return this.ni(e, r).next((e => {
                e || t.removeEntry(r, SnapshotVersion.min());
            }));
        })).next((() => (this.Xr = null, t.apply(e))));
    }
    updateLimboDocument(e, t) {
        return this.ni(e, t).next((e => {
            e ? this.ti.delete(t.toString()) : this.ti.add(t.toString());
        }));
    }
    zr(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    ni(e, t) {
        return PersistencePromise.or([ () => PersistencePromise.resolve(this.Zr.containsKey(t)), () => this.persistence.getTargetCache().containsKey(e, t), () => this.persistence.Yr(e, t) ]);
    }
}

class __PRIVATE_MemoryLruDelegate {
    constructor(e, t) {
        this.persistence = e, this.ri = new ObjectMap((e => __PRIVATE_encodeResourcePath(e.path)), ((e, t) => e.isEqual(t))), 
        this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    static ei(e, t) {
        return new __PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Hr() {}
    Jr(e) {
        return PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    Xn(e) {
        const t = this.nr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e => t.next((t => e + t))));
    }
    nr(e) {
        let t = 0;
        return this.er(e, (e => {
            t++;
        })).next((() => t));
    }
    er(e, t) {
        return PersistencePromise.forEach(this.ri, ((n, r) => this.ir(e, n, r).next((e => e ? PersistencePromise.resolve() : t(r)))));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.Lr(e, (r => this.ir(e, r, t).next((e => {
            e || (n++, i.removeEntry(r, SnapshotVersion.min()));
        })))).next((() => i.apply(e))).next((() => n));
    }
    markPotentiallyOrphaned(e, t) {
        return this.ri.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.ri.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.ri.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.ri.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    zr(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += __PRIVATE_estimateByteSize(e.data.value)), t;
    }
    ir(e, t, n) {
        return PersistencePromise.or([ () => this.persistence.Yr(e, t), () => this.persistence.getTargetCache().containsKey(e, t), () => {
            const e = this.ri.get(t);
            return PersistencePromise.resolve(void 0 !== e && e > n);
        } ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Performs database creation and schema upgrades. */ class __PRIVATE_SchemaConverter {
    constructor(e) {
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */    O(e, t, n, r) {
        const i = new __PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore("owner");
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            e.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", M, {
                unique: !0
            }), e.createObjectStore("documentMutations");
        }
        /**
 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
 * and rewrites all data.
 */ (e), __PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore("remoteDocuments");
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
                let s = PersistencePromise.resolve();
        return n < 3 && r >= 3 && (
        // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
        }(e), __PRIVATE_createQueryCache(e)), s = s.next((() => 
        /**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */
        function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
            const t = e.store("targetGlobal"), n = {
                highestTargetId: 0,
                highestListenSequenceNumber: 0,
                lastRemoteSnapshotVersion: SnapshotVersion.min().toTimestamp(),
                targetCount: 0
            };
            return t.put("targetGlobalKey", n);
        }(i)))), n < 4 && r >= 4 && (0 !== n && (
        // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        s = s.next((() => function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
            return t.store("mutations").U().next((n => {
                e.deleteObjectStore("mutations");
                e.createObjectStore("mutations", {
                    keyPath: "batchId",
                    autoIncrement: !0
                }).createIndex("userMutationsIndex", M, {
                    unique: !0
                });
                const r = t.store("mutations"), i = n.map((e => r.put(e)));
                return PersistencePromise.waitFor(i);
            }));
        }(e, i)))), s = s.next((() => {
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(e);
        }))), n < 5 && r >= 5 && (s = s.next((() => this.ii(i)))), n < 6 && r >= 6 && (s = s.next((() => (function __PRIVATE_createDocumentGlobalStore(e) {
            e.createObjectStore("remoteDocumentGlobal");
        }(e), this.si(i))))), n < 7 && r >= 7 && (s = s.next((() => this.oi(i)))), n < 8 && r >= 8 && (s = s.next((() => this._i(e, i)))), 
        n < 9 && r >= 9 && (s = s.next((() => {
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
            // Note: Schema version 9 used to create a read time index for the
            // RemoteDocumentCache. This is now done with schema version 13.
                }))), n < 10 && r >= 10 && (s = s.next((() => this.ai(i)))), n < 11 && r >= 11 && (s = s.next((() => {
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(e);
        }))), n < 12 && r >= 12 && (s = s.next((() => {
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore("documentOverlays", {
                    keyPath: G
                });
                t.createIndex("collectionPathOverlayIndex", z, {
                    unique: !1
                }), t.createIndex("collectionGroupOverlayIndex", j, {
                    unique: !1
                });
            }(e);
        }))), n < 13 && r >= 13 && (s = s.next((() => function __PRIVATE_createRemoteDocumentCache(e) {
            const t = e.createObjectStore("remoteDocumentsV14", {
                keyPath: O
            });
            t.createIndex("documentKeyIndex", N), t.createIndex("collectionGroupIndex", L);
        }(e))).next((() => this.ui(e, i))).next((() => e.deleteObjectStore("remoteDocuments")))), 
        n < 14 && r >= 14 && (s = s.next((() => this.ci(e, i)))), n < 15 && r >= 15 && (s = s.next((() => function __PRIVATE_createFieldIndex(e) {
            e.createObjectStore("indexConfiguration", {
                keyPath: "indexId",
                autoIncrement: !0
            }).createIndex("collectionGroupIndex", "collectionGroup", {
                unique: !1
            });
            e.createObjectStore("indexState", {
                keyPath: K
            }).createIndex("sequenceNumberIndex", $, {
                unique: !1
            });
            e.createObjectStore("indexEntries", {
                keyPath: U
            }).createIndex("documentKeyIndex", W, {
                unique: !1
            });
        }(e)))), n < 16 && r >= 16 && (
        // Clear the object stores to remove possibly corrupted index entries
        s = s.next((() => {
            t.objectStore("indexState").clear();
        })).next((() => {
            t.objectStore("indexEntries").clear();
        }))), n < 17 && r >= 17 && (s = s.next((() => {
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore("globals", {
                    keyPath: "name"
                });
            }(e);
        }))), s;
    }
    si(e) {
        let t = 0;
        return e.store("remoteDocuments").J(((e, n) => {
            t += __PRIVATE_dbDocumentSize(n);
        })).next((() => {
            const n = {
                byteSize: t
            };
            return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        }));
    }
    ii(e) {
        const t = e.store("mutationQueues"), n = e.store("mutations");
        return t.U().next((t => PersistencePromise.forEach(t, (t => {
            const r = IDBKeyRange.bound([ t.userId, -1 ], [ t.userId, t.lastAcknowledgedBatchId ]);
            return n.U("userMutationsIndex", r).next((n => PersistencePromise.forEach(n, (n => {
                __PRIVATE_hardAssert(n.userId === t.userId);
                const r = __PRIVATE_fromDbMutationBatch(this.serializer, n);
                return removeMutationBatch(e, t.userId, r).next((() => {}));
            }))));
        }))));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */    oi(e) {
        const t = e.store("targetDocuments"), n = e.store("remoteDocuments");
        return e.store("targetGlobal").get("targetGlobalKey").next((e => {
            const r = [];
            return n.J(((n, i) => {
                const s = new ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [ 0, __PRIVATE_encodeResourcePath(e) ];
                }(s);
                r.push(t.get(o).next((n => n ? PersistencePromise.resolve() : (n => t.put({
                    targetId: 0,
                    path: __PRIVATE_encodeResourcePath(n),
                    sequenceNumber: e.highestListenSequenceNumber
                }))(s))));
            })).next((() => PersistencePromise.waitFor(r)));
        }));
    }
    _i(e, t) {
        // Create the index.
        e.createObjectStore("collectionParents", {
            keyPath: Q
        });
        const n = t.store("collectionParents"), r = new __PRIVATE_MemoryCollectionParentIndex, addEntry = e => {
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: __PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
                // Index existing remote documents.
        return t.store("remoteDocuments").J({
            H: !0
        }, ((e, t) => {
            const n = new ResourcePath(e);
            return addEntry(n.popLast());
        })).next((() => t.store("documentMutations").J({
            H: !0
        }, (([e, t, n], r) => {
            const i = __PRIVATE_decodeResourcePath(t);
            return addEntry(i.popLast());
        }))));
    }
    ai(e) {
        const t = e.store("targets");
        return t.J(((e, n) => {
            const r = __PRIVATE_fromDbTarget(n), i = __PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        }));
    }
    ui(e, t) {
        const n = t.store("remoteDocuments"), r = [];
        return n.J(((e, n) => {
            const i = t.store("remoteDocumentsV14"), s = function __PRIVATE_extractKey(e) {
                return e.document ? new DocumentKey(ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? DocumentKey.fromSegments(e.noDocument.path) : e.unknownDocument ? DocumentKey.fromSegments(e.unknownDocument.path) : fail();
            }
            /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [ 0, 0 ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        })).next((() => PersistencePromise.waitFor(r)));
    }
    ci(e, t) {
        const n = t.store("mutations"), r = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.ei, this.serializer.ht);
        return n.U().next((e => {
            const n = new Map;
            return e.forEach((e => {
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : __PRIVATE_documentKeySet();
                __PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e => r = r.add(e))), 
                n.set(e.userId, r);
            })), PersistencePromise.forEach(n, ((e, n) => {
                const s = new User(n), o = __PRIVATE_IndexedDbDocumentOverlayCache.Pt(this.serializer, s), _ = i.getIndexManager(s), a = __PRIVATE_IndexedDbMutationQueue.Pt(s, this.serializer, _, i.referenceDelegate);
                return new LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new __PRIVATE_IndexedDbTransaction(t, __PRIVATE_ListenSequence.oe), e).next();
            }));
        }));
    }
}

function __PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: k
    }).createIndex("documentTargetsIndex", q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", B, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}

const Ve = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";

/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */
/**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */
class __PRIVATE_IndexedDbPersistence {
    constructor(
    /**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */
    e, t, n, r, i, s, o, _, a, 
    /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */
    u, c = 17) {
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, 
        this.li = i, this.window = s, this.document = o, this.hi = a, this.Pi = u, this.Ti = c, 
        this.$r = null, this.Ur = !1, this.isPrimary = !1, this.networkEnabled = !0, 
        /** Our window.unload handler, if registered. */
        this.Ii = null, this.inForeground = !1, 
        /** Our 'visibilitychange' listener if registered. */
        this.Ei = null, 
        /** The client metadata refresh task. */
        this.di = null, 
        /** The last time we garbage collected the client metadata object store. */
        this.Ai = Number.NEGATIVE_INFINITY, 
        /** A listener to notify on primary state changes. */
        this.Ri = e => Promise.resolve(), !__PRIVATE_IndexedDbPersistence.p()) throw new FirestoreError(D.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new __PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Vi = t + "main", 
        this.serializer = new __PRIVATE_LocalSerializer(_), this.mi = new __PRIVATE_SimpleDb(this.Vi, this.Ti, new __PRIVATE_SchemaConverter(this.serializer)), 
        this.Wr = new __PRIVATE_IndexedDbGlobalsCache, this.Gr = new __PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), 
        this.remoteDocumentCache = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), 
        this.jr = new __PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.fi = this.window.localStorage : (this.fi = null, 
        !1 === u && __PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */    start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.gi().then((() => {
            if (!this.isPrimary && !this.allowTabSynchronization) 
            // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new FirestoreError(D.FAILED_PRECONDITION, Ve);
            return this.pi(), this.yi(), this.wi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e => this.Gr.getHighestSequenceNumber(e)));
        })).then((e => {
            this.$r = new __PRIVATE_ListenSequence(e, this.hi);
        })).then((() => {
            this.Ur = !0;
        })).catch((e => (this.mi && this.mi.close(), Promise.reject(e))));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */    Si(e) {
        return this.Ri = async t => {
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */    setDatabaseDeletedListener(e) {
        this.mi.L((async t => {
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        }));
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */    setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, 
        // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.li.enqueueAndForget((async () => {
            this.started && await this.gi();
        })));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */    gi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e => __PRIVATE_clientMetadataStore(e).put({
            clientId: this.clientId,
            updateTimeMs: Date.now(),
            networkEnabled: this.networkEnabled,
            inForeground: this.inForeground
        }).next((() => {
            if (this.isPrimary) return this.bi(e).next((e => {
                e || (this.isPrimary = !1, this.li.enqueueRetryable((() => this.Ri(!1))));
            }));
        })).next((() => this.Di(e))).next((t => this.isPrimary && !t ? this.vi(e).next((() => !1)) : !!t && this.Ci(e).next((() => !0)))))).catch((e => {
            if (__PRIVATE_isIndexedDbTransactionError(e)) 
            // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return __PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), 
            this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return __PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), 
            /* isPrimary= */ !1;
        })).then((e => {
            this.isPrimary !== e && this.li.enqueueRetryable((() => this.Ri(e))), this.isPrimary = e;
        }));
    }
    bi(e) {
        return __PRIVATE_primaryClientStore(e).get("owner").next((e => PersistencePromise.resolve(this.Fi(e))));
    }
    Mi(e) {
        return __PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */    async xi() {
        if (this.isPrimary && !this.Oi(this.Ai, 18e5)) {
            this.Ai = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e => {
                const t = __PRIVATE_getStore(e, "clientMetadata");
                return t.U().next((e => {
                    const n = this.Ni(e, 18e5), r = e.filter((e => -1 === n.indexOf(e)));
                    // Delete metadata for clients that are no longer considered active.
                    return PersistencePromise.forEach(r, (e => t.delete(e.clientId))).next((() => r));
                }));
            })).catch((() => []));
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
                        if (this.fi) for (const t of e) this.fi.removeItem(this.Li(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */    wi() {
        this.di = this.li.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, (() => this.gi().then((() => this.xi())).then((() => this.wi()))));
    }
    /** Checks whether `client` is the local client. */    Fi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */    Di(e) {
        if (this.Pi) return PersistencePromise.resolve(!0);
        return __PRIVATE_primaryClientStore(e).get("owner").next((t => {
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.Oi(t.leaseTimestampMs, 5e3) && !this.Bi(t.ownerId)) {
                if (this.Fi(t) && this.networkEnabled) return !0;
                if (!this.Fi(t)) {
                    if (!t.allowTabSynchronization) 
                    // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new FirestoreError(D.FAILED_PRECONDITION, Ve);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || __PRIVATE_clientMetadataStore(e).U().next((e => void 0 === this.Ni(e, 5e3).find((e => {
                if (this.clientId !== e.clientId) {
                    const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                    if (t || n && r) return !0;
                }
                return !1;
            }))));
        })).next((e => (this.isPrimary !== e && __PRIVATE_logDebug("IndexedDbPersistence", `Client ${e ? "is" : "is not"} eligible for a primary lease.`), 
        e)));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.Ur = !1, this.ki(), this.di && (this.di.cancel(), this.di = null), this.qi(), 
        this.Qi(), 
        // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.mi.runTransaction("shutdown", "readwrite", [ "owner", "clientMetadata" ], (e => {
            const t = new __PRIVATE_IndexedDbTransaction(e, __PRIVATE_ListenSequence.oe);
            return this.vi(t).next((() => this.Mi(t)));
        })), this.mi.close(), 
        // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Ki();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */    Ni(e, t) {
        return e.filter((e => this.Oi(e.updateTimeMs, t) && !this.Bi(e.clientId)));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */    $i() {
        return this.runTransaction("getActiveClients", "readonly", (e => __PRIVATE_clientMetadataStore(e).U().next((e => this.Ni(e, 18e5).map((e => e.clientId))))));
    }
    get started() {
        return this.Ur;
    }
    getGlobalsCache() {
        return this.Wr;
    }
    getMutationQueue(e, t) {
        return __PRIVATE_IndexedDbMutationQueue.Pt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Gr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new __PRIVATE_IndexedDbIndexManager(e, this.serializer.ht.databaseId);
    }
    getDocumentOverlayCache(e) {
        return __PRIVATE_IndexedDbDocumentOverlayCache.Pt(this.serializer, e);
    }
    getBundleCache() {
        return this.jr;
    }
    runTransaction(e, t, n) {
        __PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = 
        /** Returns the object stores for the provided schema. */
        function __PRIVATE_getObjectStores(e) {
            return 17 === e ? te : 16 === e ? ee : 15 === e ? X : 14 === e ? Z : 13 === e ? Y : 12 === e ? J : 11 === e ? H : void fail();
        }(this.Ti);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
                return this.mi.runTransaction(e, r, i, (r => (s = new __PRIVATE_IndexedDbTransaction(r, this.$r ? this.$r.next() : __PRIVATE_ListenSequence.oe), 
        "readwrite-primary" === t ? this.bi(s).next((e => !!e || this.Di(s))).next((t => {
            if (!t) throw __PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), 
            this.isPrimary = !1, this.li.enqueueRetryable((() => this.Ri(!1))), new FirestoreError(D.FAILED_PRECONDITION, C);
            return n(s);
        })).next((e => this.Ci(s).next((() => e)))) : this.Ui(s).next((() => n(s)))))).then((e => (s.raiseOnCommittedEvent(), 
        e)));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */
    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ui(e) {
        return __PRIVATE_primaryClientStore(e).get("owner").next((e => {
            if (null !== e && this.Oi(e.leaseTimestampMs, 5e3) && !this.Bi(e.ownerId) && !this.Fi(e) && !(this.Pi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new FirestoreError(D.FAILED_PRECONDITION, Ve);
        }));
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */    Ci(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return __PRIVATE_primaryClientStore(e).put("owner", t);
    }
    static p() {
        return __PRIVATE_SimpleDb.p();
    }
    /** Checks the primary lease and removes it if we are the current primary. */    vi(e) {
        const t = __PRIVATE_primaryClientStore(e);
        return t.get("owner").next((e => this.Fi(e) ? (__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), 
        t.delete("owner")) : PersistencePromise.resolve()));
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */    Oi(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || (__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), 
        !1));
    }
    pi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ei = () => {
            this.li.enqueueAndForget((() => (this.inForeground = "visible" === this.document.visibilityState, 
            this.gi())));
        }, this.document.addEventListener("visibilitychange", this.Ei), this.inForeground = "visible" === this.document.visibilityState);
    }
    qi() {
        this.Ei && (this.document.removeEventListener("visibilitychange", this.Ei), this.Ei = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */    yi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.Ii = () => {
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.ki();
            const e = /(?:Version|Mobile)\/1[456]/;
            isSafari() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && 
            // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.li.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.li.enqueueAndForget((() => this.shutdown()));
        }, this.window.addEventListener("pagehide", this.Ii));
    }
    Qi() {
        this.Ii && (this.window.removeEventListener("pagehide", this.Ii), this.Ii = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */    Bi(e) {
        var t;
        try {
            const n = null !== (null === (t = this.fi) || void 0 === t ? void 0 : t.getItem(this.Li(e)));
            return __PRIVATE_logDebug("IndexedDbPersistence", `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), 
            n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return __PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), 
            !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */    ki() {
        if (this.fi) try {
            this.fi.setItem(this.Li(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            __PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */    Ki() {
        if (this.fi) try {
            this.fi.removeItem(this.Li(this.clientId));
        } catch (e) {
            // Ignore
        }
    }
    Li(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}

/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function __PRIVATE_primaryClientStore(e) {
    return __PRIVATE_getStore(e, "owner");
}

/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function __PRIVATE_clientMetadataStore(e) {
    return __PRIVATE_getStore(e, "clientMetadata");
}

/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function __PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */
class __PRIVATE_LocalViewChanges {
    constructor(e, t, n, r) {
        this.targetId = e, this.fromCache = t, this.Wi = n, this.Gi = r;
    }
    static zi(e, t) {
        let n = __PRIVATE_documentKeySet(), r = __PRIVATE_documentKeySet();
        for (const e of t.docChanges) switch (e.type) {
          case 0 /* ChangeType.Added */ :
            n = n.add(e.doc.key);
            break;

          case 1 /* ChangeType.Removed */ :
            r = r.add(e.doc.key);
 // do nothing
                }
        return new __PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class QueryContext {
    constructor() {
        /**
         * Counts the number of documents passed through during local query execution.
         */
        this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */
class __PRIVATE_QueryEngine {
    constructor() {
        this.ji = !1, this.Hi = !1, 
        /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */
        this.Ji = 100, this.Yi = 
        /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */
        function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0,dist_index_esm2017/* isSafari */.G6)() ? 8 : __PRIVATE_getAndroidVersion((0,dist_index_esm2017/* getUA */.z$)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */    initialize(e, t) {
        this.Zi = e, this.indexManager = t, this.ji = !0;
    }
    /** Returns all local documents matching the specified query. */    getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.Xi(e, t).next((e => {
            i.result = e;
        })).next((() => {
            if (!i.result) return this.es(e, t, r, n).next((e => {
                i.result = e;
            }));
        })).next((() => {
            if (i.result) return;
            const n = new QueryContext;
            return this.ts(e, t, n).next((r => {
                if (i.result = r, this.Hi) return this.ns(e, t, n, r.size);
            }));
        })).next((() => i.result));
    }
    ns(e, t, n, r) {
        return n.documentReadCount < this.Ji ? (__PRIVATE_getLogLevel() <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG && __PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", __PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Ji, "documents"), 
        PersistencePromise.resolve()) : (__PRIVATE_getLogLevel() <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG && __PRIVATE_logDebug("QueryEngine", "Query:", __PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), 
        n.documentReadCount > this.Yi * r ? (__PRIVATE_getLogLevel() <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG && __PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", __PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), 
        this.indexManager.createTargetIndexes(e, __PRIVATE_queryToTarget(t))) : PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */    Xi(e, t) {
        if (__PRIVATE_queryMatchesAllDocuments(t)) 
        // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return PersistencePromise.resolve(null);
        let n = __PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r => 0 /* IndexType.NONE */ === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */ === r && (
        // We cannot apply a limit for targets that are served using a partial
        // index. If a partial index will be used to serve the target, the
        // query may return a superset of documents that match the target
        // (e.g. if the index doesn't include all the target's filters), or
        // may return the correct set of documents in the wrong order (e.g. if
        // the index doesn't include a segment for one of the orderBys).
        // Therefore, a limit should not be applied in such cases.
        t = __PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */), n = __PRIVATE_queryToTarget(t)), 
        this.indexManager.getDocumentsMatchingTarget(e, n).next((r => {
            const i = __PRIVATE_documentKeySet(...r);
            return this.Zi.getDocuments(e, i).next((r => this.indexManager.getMinOffset(e, n).next((n => {
                const s = this.rs(t, r);
                return this.ss(t, s, i, n.readTime) ? this.Xi(e, __PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */)) : this.os(e, s, t, n);
            }))));
        })))));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */    es(e, t, n, r) {
        return __PRIVATE_queryMatchesAllDocuments(t) || r.isEqual(SnapshotVersion.min()) ? PersistencePromise.resolve(null) : this.Zi.getDocuments(e, n).next((i => {
            const s = this.rs(t, i);
            return this.ss(t, s, n, r) ? PersistencePromise.resolve(null) : (__PRIVATE_getLogLevel() <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG && __PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), __PRIVATE_stringifyQuery(t)), 
            this.os(e, s, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)).next((e => e)));
        }));
        // Queries that have never seen a snapshot without limbo free documents
        // should also be run as a full collection scan.
        }
    /** Applies the query filter and sorting to the provided documents.  */    rs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new SortedSet(__PRIVATE_newQueryComparator(e));
        return t.forEach(((t, r) => {
            __PRIVATE_queryMatches(e, r) && (n = n.add(r));
        })), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */    ss(e, t, n, r) {
        if (null === e.limit) 
        // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) 
        // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
                const i = "F" /* LimitType.First */ === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ts(e, t, n) {
        return __PRIVATE_getLogLevel() <= dist_esm_index_esm2017/* LogLevel.DEBUG */["in"].DEBUG && __PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", __PRIVATE_stringifyQuery(t)), 
        this.Zi.getDocumentsMatchingQuery(e, t, IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */    os(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Zi.getDocumentsMatchingQuery(e, n, r).next((e => (
        // Merge with existing results
        t.forEach((t => {
            e = e.insert(t.key, t);
        })), e)));
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */
class __PRIVATE_LocalStoreImpl {
    constructor(
    /** Manages our in-memory or durable persistence. */
    e, t, n, r) {
        this.persistence = e, this._s = t, this.serializer = r, 
        /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */
        this.us = new SortedMap(__PRIVATE_primitiveComparator), 
        /** Maps a target to its targetID. */
        // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.cs = new ObjectMap((e => __PRIVATE_canonifyTarget(e)), __PRIVATE_targetEquals), 
        /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */
        this.ls = new Map, this.hs = e.getRemoteDocumentCache(), this.Gr = e.getTargetCache(), 
        this.jr = e.getBundleCache(), this.Ps(n);
    }
    Ps(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), 
        this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new LocalDocumentsView(this.hs, this.mutationQueue, this.documentOverlayCache, this.indexManager), 
        this.hs.setIndexManager(this.indexManager), this._s.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t => e.collect(t, this.us)));
    }
}

function __PRIVATE_newLocalStore(
/** Manages our in-memory or durable persistence. */
e, t, n, r) {
    return new __PRIVATE_LocalStoreImpl(e, t, n, r);
}

/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */
// PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function __PRIVATE_localStoreHandleUserChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e => {
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i => (r = i, n.Ps(t), n.mutationQueue.getAllMutationBatches(e)))).next((t => {
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = __PRIVATE_documentKeySet();
            for (const e of r) {
                i.push(e.batchId);
                for (const t of e.mutations) o = o.add(t.key);
            }
            for (const e of t) {
                s.push(e.batchId);
                for (const t of e.mutations) o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
                        return n.localDocuments.getDocuments(e, o).next((e => ({
                Ts: e,
                removedBatchIds: i,
                addedBatchIds: s
            })));
        }));
    }));
}

/* Accepts locally generated Mutations and commit them to storage. */
/**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */
function __PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e => {
        const r = t.batch.keys(), i = n.hs.newChangeBuffer({
            trackRemovals: !0
        });
        return function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = PersistencePromise.resolve();
            return s.forEach((e => {
                o = o.next((() => r.getEntry(t, e))).next((t => {
                    const s = n.docVersions.get(e);
                    __PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), 
                    t.isValidDocument() && (
                    // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    t.setReadTime(n.commitVersion), r.addEntry(t)));
                }));
            })), o.next((() => e.mutationQueue.removeMutationBatch(t, i)));
        }
        /** Returns the local view of the documents affected by a mutation batch. */
        // PORTING NOTE: Multi-Tab only.
        (n, e, t, i).next((() => i.apply(e))).next((() => n.mutationQueue.performConsistencyCheck(e))).next((() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId))).next((() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
            let t = __PRIVATE_documentKeySet();
            for (let n = 0; n < e.mutationResults.length; ++n) {
                e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
            }
            return t;
        }
        /**
 * Removes mutations from the MutationQueue for the specified batch;
 * LocalDocuments will be recalculated.
 *
 * @returns The resulting modified documents.
 */ (t)))).next((() => n.localDocuments.getDocuments(e, r)));
    }));
}

/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */
function __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = __PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e => t.Gr.getLastRemoteSnapshotVersion(e)));
}

/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function __PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = __PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.us;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e => {
        const s = n.hs.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
                i = n.us;
        const o = [];
        t.targetChanges.forEach(((s, _) => {
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
                        o.push(n.Gr.removeMatchingKeys(e, s.removedDocuments, _).next((() => n.Gr.addMatchingKeys(e, s.addedDocuments, _))));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken(ByteString.EMPTY_BYTE_STRING, SnapshotVersion.min()).withLastLimboFreeSnapshotVersion(SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), 
            i = i.insert(_, u), 
            // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */
            function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }
            /**
 * Notifies local store of the changed views to locally pin documents.
 */ (a, u, s) && o.push(n.Gr.updateTargetData(e, u));
        }));
        let _ = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r => {
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        })), 
        // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push(__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e => {
            _ = e.Is, a = e.Es;
        }))), !r.isEqual(SnapshotVersion.min())) {
            const t = n.Gr.getLastRemoteSnapshotVersion(e).next((t => n.Gr.setTargetsMetadata(e, e.currentSequenceNumber, r)));
            o.push(t);
        }
        return PersistencePromise.waitFor(o).next((() => s.apply(e))).next((() => n.localDocuments.getLocalViewOfDocuments(e, _, a))).next((() => _));
    })).then((e => (n.us = i, e)));
}

/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function __PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = __PRIVATE_documentKeySet(), i = __PRIVATE_documentKeySet();
    return n.forEach((e => r = r.add(e))), t.getEntries(e, r).next((e => {
        let r = __PRIVATE_mutableDocumentMap();
        return n.forEach(((n, s) => {
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
                        s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), 
            // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual(SnapshotVersion.min()) ? (
            // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), 
            r = r.insert(n, s)) : __PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        })), {
            Is: r,
            Es: i
        };
    }));
}

/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */
function __PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e => (void 0 === t && (t = -1), 
    n.mutationQueue.getNextMutationBatchAfterBatchId(e, t))));
}

/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */
/**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */
function __PRIVATE_localStoreAllocateTarget(e, t) {
    const n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e => {
        let r;
        return n.Gr.getTargetData(e, t).next((i => i ? (
        // This target has been listened to previously, so reuse the
        // previous targetID.
        // TODO(mcg): freshen last accessed date?
        r = i, PersistencePromise.resolve(r)) : n.Gr.allocateTargetId(e).next((i => (r = new TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), 
        n.Gr.addTargetData(e, r).next((() => r)))))));
    })).then((e => {
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.us.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.us = n.us.insert(e.targetId, e), 
        n.cs.set(t, e.targetId)), e;
    }));
}

/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */
// Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */
// PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function __PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = r.us.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e => r.persistence.referenceDelegate.removeTarget(e, i)));
    } catch (e) {
        if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        __PRIVATE_logDebug("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.us = r.us.remove(t), r.cs.delete(i.target);
}

/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function __PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    let i = SnapshotVersion.min(), s = __PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", (// Use readwrite instead of readonly so indexes can be created
    // Use readwrite instead of readonly so indexes can be created
    e => function __PRIVATE_localStoreGetTargetData(e, t, n) {
        const r = __PRIVATE_debugCast(e), i = r.cs.get(n);
        return void 0 !== i ? PersistencePromise.resolve(r.us.get(i)) : r.Gr.getTargetData(t, n);
    }(r, e, __PRIVATE_queryToTarget(t)).next((t => {
        if (t) return i = t.lastLimboFreeSnapshotVersion, r.Gr.getMatchingKeysForTargetId(e, t.targetId).next((e => {
            s = e;
        }));
    })).next((() => r._s.getDocumentsMatchingQuery(e, t, n ? i : SnapshotVersion.min(), n ? s : __PRIVATE_documentKeySet()))).next((e => (__PRIVATE_setMaxReadTime(r, __PRIVATE_queryCollectionGroup(t), e), 
    {
        documents: e,
        ds: s
    })))));
}

// PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = __PRIVATE_debugCast(e), r = __PRIVATE_debugCast(n.Gr), i = n.us.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e => r.ut(e, t).next((e => e ? e.target : null))));
}

/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = __PRIVATE_debugCast(e), r = n.ls.get(t) || SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
        return n.persistence.runTransaction("Get new document changes", "readonly", (e => n.hs.getAllFromCollectionGroup(e, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), 
    /* limit= */ Number.MAX_SAFE_INTEGER))).then((e => (__PRIVATE_setMaxReadTime(n, t, e), 
    e)));
}

/** Sets the collection group's maximum read time from the given documents. */
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.ls.get(t) || SnapshotVersion.min();
    n.forEach(((e, t) => {
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    })), e.ls.set(t, r);
}

/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */
/**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */
async function __PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = __PRIVATE_debugCast(e);
    let s = __PRIVATE_documentKeySet(), o = __PRIVATE_mutableDocumentMap();
    for (const e of n) {
        const n = t.As(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Rs(e);
        r.setReadTime(t.Vs(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.hs.newChangeBuffer({
        trackRemovals: !0
    }), a = await __PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
        return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e => __PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t => (_.apply(e), 
    t))).next((t => i.Gr.removeMatchingKeysForTargetId(e, a.targetId).next((() => i.Gr.addMatchingKeys(e, s, a.targetId))).next((() => i.localDocuments.getLocalViewOfDocuments(e, t.Is, t.Es))).next((() => t.Is))))));
}

/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */
/**
 * Saves the given `NamedQuery` to local persistence.
 */
async function __PRIVATE_localStoreSaveNamedQuery(e, t, n = __PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await __PRIVATE_localStoreAllocateTarget(e, __PRIVATE_queryToTarget(__PRIVATE_fromBundledQuery(t.bundledQuery))), i = __PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e => {
        const s = __PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
                if (r.snapshotVersion.compareTo(s) >= 0) return i.jr.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
                const o = r.withResumeToken(ByteString.EMPTY_BYTE_STRING, s);
        return i.us = i.us.insert(o.targetId, o), i.Gr.updateTargetData(e, o).next((() => i.Gr.removeMatchingKeysForTargetId(e, r.targetId))).next((() => i.Gr.addMatchingKeys(e, n, r.targetId))).next((() => i.jr.saveNamedQuery(e, t)));
    }));
}

/** Assembles the key for a client state in WebStorage */
function createWebStorageClientStateKey(e, t) {
    return `firestore_clients_${e}_${t}`;
}

// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>

// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */
function createWebStorageMutationBatchKey(e, t, n) {
    let r = `firestore_mutations_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}

// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */
function createWebStorageQueryTargetMetadataKey(e, t) {
    return `firestore_targets_${e}_${t}`;
}

// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */
// Visible for testing
class __PRIVATE_MutationMetadata {
    constructor(e, t, n, r) {
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */    static fs(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [ "pending", "acknowledged", "rejected" ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, 
        s && (i = new FirestoreError(r.error.code, r.error.message))), s ? new __PRIVATE_MutationMetadata(e, t, r.state, i) : (__PRIVATE_logError("SharedClientState", `Failed to parse mutation state for ID '${t}': ${n}`), 
        null);
    }
    gs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}

/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */
// Visible for testing
class __PRIVATE_QueryTargetMetadata {
    constructor(e, t, n) {
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */    static fs(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [ "not-current", "current", "rejected" ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, 
        i && (r = new FirestoreError(n.error.code, n.error.message))), i ? new __PRIVATE_QueryTargetMetadata(e, n.state, r) : (__PRIVATE_logError("SharedClientState", `Failed to parse target state for ID '${e}': ${t}`), 
        null);
    }
    gs() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}

/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class __PRIVATE_RemoteClientState {
    constructor(e, t) {
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */    static fs(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = __PRIVATE_targetIdSet();
        for (let e = 0; r && e < n.activeTargetIds.length; ++e) r = isSafeInteger(n.activeTargetIds[e]), 
        i = i.add(n.activeTargetIds[e]);
        return r ? new __PRIVATE_RemoteClientState(e, i) : (__PRIVATE_logError("SharedClientState", `Failed to parse client data for instance '${e}': ${t}`), 
        null);
    }
}

/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class __PRIVATE_SharedOnlineState {
    constructor(e, t) {
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */    static fs(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [ "Unknown", "Online", "Offline" ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new __PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : (__PRIVATE_logError("SharedClientState", `Failed to parse online state: ${e}`), 
        null);
    }
}

/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */
// Visible for testing.
class __PRIVATE_LocalClientState {
    constructor() {
        this.activeTargetIds = __PRIVATE_targetIdSet();
    }
    ps(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    ys(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */    gs() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}

/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class __PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i) {
        this.window = e, this.li = t, this.persistenceKey = n, this.ws = r, this.syncEngine = null, 
        this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Ss = this.bs.bind(this), 
        this.Ds = new SortedMap(__PRIVATE_primitiveComparator), this.started = !1, 
        /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */
        this.vs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Cs = createWebStorageClientStateKey(this.persistenceKey, this.ws), 
        this.Fs = 
        /** Assembles the key for the current sequence number. */
        function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }
        /**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (this.persistenceKey), this.Ds = this.Ds.insert(this.ws, new __PRIVATE_LocalClientState), 
        this.Ms = new RegExp(`^firestore_clients_${s}_([^_]*)$`), this.xs = new RegExp(`^firestore_mutations_${s}_(\\d+)(?:_(.*))?$`), 
        this.Os = new RegExp(`^firestore_targets_${s}_(\\d+)$`), this.Ns = 
        /** Assembles the key for the online state of the primary tab. */
        function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }
        // The WebStorage prefix that plays as a event to indicate the remote documents
        // might have changed due to some secondary tabs loading a bundle.
        // format of the key is:
        //     firestore_bundle_loaded_v2_<persistenceKey>
        // The version ending with "v2" stores the list of modified collection groups.
        (this.persistenceKey), this.Ls = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }
        // The WebStorage key prefix for the key that stores the last sequence number allocated. The key
        // looks like 'firestore_sequence_number_<persistence_prefix>'.
        (this.persistenceKey), 
        // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Ss);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */    static p(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.$i();
        for (const t of e) {
            if (t === this.ws) continue;
            const e = this.getItem(createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = __PRIVATE_RemoteClientState.fs(t, e);
                n && (this.Ds = this.Ds.insert(n.clientId, n));
            }
        }
        this.Bs();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.Ns);
        if (t) {
            const e = this.ks(t);
            e && this.qs(e);
        }
        for (const e of this.vs) this.bs(e);
        this.vs = [], 
        // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", (() => this.shutdown())), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Fs, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.Qs(this.Ds);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Ds.forEach(((n, r) => {
            r.activeTargetIds.has(e) && (t = !0);
        })), t;
    }
    addPendingMutation(e) {
        this.Ks(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.Ks(e, t, n), 
        // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.$s(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
                if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = __PRIVATE_QueryTargetMetadata.fs(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
                return t && this.Us.ps(e), this.Bs(), n;
    }
    removeLocalQueryTarget(e) {
        this.Us.ys(e), this.Bs();
    }
    isLocalQueryTarget(e) {
        return this.Us.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Ws(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e => {
            this.$s(e);
        })), this.currentUser = e, n.forEach((e => {
            this.addPendingMutation(e);
        }));
    }
    setOnlineState(e) {
        this.Gs(e);
    }
    notifyBundleLoaded(e) {
        this.zs(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Ss), this.removeItem(this.Cs), 
        this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return __PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
    }
    setItem(e, t) {
        __PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        __PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
    }
    bs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if (__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.Cs) return void __PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.li.enqueueRetryable((async () => {
                if (this.started) {
                    if (null !== t.key) if (this.Ms.test(t.key)) {
                        if (null == t.newValue) {
                            const e = this.js(t.key);
                            return this.Hs(e, null);
                        }
                        {
                            const e = this.Js(t.key, t.newValue);
                            if (e) return this.Hs(e.clientId, e);
                        }
                    } else if (this.xs.test(t.key)) {
                        if (null !== t.newValue) {
                            const e = this.Ys(t.key, t.newValue);
                            if (e) return this.Zs(e);
                        }
                    } else if (this.Os.test(t.key)) {
                        if (null !== t.newValue) {
                            const e = this.Xs(t.key, t.newValue);
                            if (e) return this.eo(e);
                        }
                    } else if (t.key === this.Ns) {
                        if (null !== t.newValue) {
                            const e = this.ks(t.newValue);
                            if (e) return this.qs(e);
                        }
                    } else if (t.key === this.Fs) {
                        const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                            let t = __PRIVATE_ListenSequence.oe;
                            if (null != e) try {
                                const n = JSON.parse(e);
                                __PRIVATE_hardAssert("number" == typeof n), t = n;
                            } catch (e) {
                                __PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                            }
                            return t;
                        }
                        /**
 * `MemorySharedClientState` is a simple implementation of SharedClientState for
 * clients using memory persistence. The state in this class remains fully
 * isolated and no synchronization is performed.
 */ (t.newValue);
                        e !== __PRIVATE_ListenSequence.oe && this.sequenceNumberHandler(e);
                    } else if (t.key === this.Ls) {
                        const e = this.no(t.newValue);
                        await Promise.all(e.map((e => this.syncEngine.ro(e))));
                    }
                } else this.vs.push(t);
            }));
        }
    }
    get Us() {
        return this.Ds.get(this.ws);
    }
    Bs() {
        this.setItem(this.Cs, this.Us.gs());
    }
    Ks(e, t, n) {
        const r = new __PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.gs());
    }
    $s(e) {
        const t = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Gs(e) {
        const t = {
            clientId: this.ws,
            onlineState: e
        };
        this.storage.setItem(this.Ns, JSON.stringify(t));
    }
    Ws(e, t, n) {
        const r = createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new __PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.gs());
    }
    zs(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Ls, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */    js(e) {
        const t = this.Ms.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */    Js(e, t) {
        const n = this.js(e);
        return __PRIVATE_RemoteClientState.fs(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */    Ys(e, t) {
        const n = this.xs.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return __PRIVATE_MutationMetadata.fs(new User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */    Xs(e, t) {
        const n = this.Os.exec(e), r = Number(n[1]);
        return __PRIVATE_QueryTargetMetadata.fs(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */    ks(e) {
        return __PRIVATE_SharedOnlineState.fs(e);
    }
    no(e) {
        return JSON.parse(e);
    }
    async Zs(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.io(e.batchId, e.state, e.error);
        __PRIVATE_logDebug("SharedClientState", `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    eo(e) {
        return this.syncEngine.so(e.targetId, e.state, e.error);
    }
    Hs(e, t) {
        const n = t ? this.Ds.insert(e, t) : this.Ds.remove(e), r = this.Qs(this.Ds), i = this.Qs(n), s = [], o = [];
        return i.forEach((e => {
            r.has(e) || s.push(e);
        })), r.forEach((e => {
            i.has(e) || o.push(e);
        })), this.syncEngine.oo(s, o).then((() => {
            this.Ds = n;
        }));
    }
    qs(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Ds.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    Qs(e) {
        let t = __PRIVATE_targetIdSet();
        return e.forEach(((e, n) => {
            t = t.unionWith(n.activeTargetIds);
        })), t;
    }
}

class __PRIVATE_MemorySharedClientState {
    constructor() {
        this._o = new __PRIVATE_LocalClientState, this.ao = {}, this.onlineStateHandler = null, 
        this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
        // No op.
    }
    updateMutationState(e, t, n) {
        // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this._o.ps(e), this.ao[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.ao[e] = t;
    }
    removeLocalQueryTarget(e) {
        this._o.ys(e);
    }
    isLocalQueryTarget(e) {
        return this._o.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.ao[e];
    }
    getAllActiveQueryTargets() {
        return this._o.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this._o.activeTargetIds.has(e);
    }
    start() {
        return this._o = new __PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
        // No op.
    }
    setOnlineState(e) {
        // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
        // No op.
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_NoopConnectivityMonitor {
    uo(e) {
        // No-op.
    }
    shutdown() {
        // No-op.
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */
/**
 * Browser implementation of ConnectivityMonitor.
 */
class __PRIVATE_BrowserConnectivityMonitor {
    constructor() {
        this.co = () => this.lo(), this.ho = () => this.Po(), this.To = [], this.Io();
    }
    uo(e) {
        this.To.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.co), window.removeEventListener("offline", this.ho);
    }
    Io() {
        window.addEventListener("online", this.co), window.addEventListener("offline", this.ho);
    }
    lo() {
        __PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const e of this.To) e(0 /* NetworkStatus.AVAILABLE */);
    }
    Po() {
        __PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const e of this.To) e(1 /* NetworkStatus.UNAVAILABLE */);
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */
    static p() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let me = null;

/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */
/**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */
function __PRIVATE_generateUniqueDebugId() {
    return null === me ? me = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : me++, "0x" + me.toString(16);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const fe = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};

/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */
class __PRIVATE_StreamBridge {
    constructor(e) {
        this.Eo = e.Eo, this.Ao = e.Ao;
    }
    Ro(e) {
        this.Vo = e;
    }
    mo(e) {
        this.fo = e;
    }
    po(e) {
        this.yo = e;
    }
    onMessage(e) {
        this.wo = e;
    }
    close() {
        this.Ao();
    }
    send(e) {
        this.Eo(e);
    }
    So() {
        this.Vo();
    }
    bo() {
        this.fo();
    }
    Do(e) {
        this.yo(e);
    }
    vo(e) {
        this.wo(e);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ge = "WebChannelConnection";

class __PRIVATE_WebChannelConnection extends 
/**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */
class __PRIVATE_RestConnection {
    get Co() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e) {
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Fo = t + "://" + e.host, this.Mo = `projects/${n}/databases/${r}`, this.xo = "(default)" === this.databaseId.database ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Oo(e, t, n, r, i) {
        const s = __PRIVATE_generateUniqueDebugId(), o = this.No(e, t.toUriEncodedString());
        __PRIVATE_logDebug("RestConnection", `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Mo,
            "x-goog-request-params": this.xo
        };
        return this.Lo(_, r, i), this.Bo(e, o, _, n).then((t => (__PRIVATE_logDebug("RestConnection", `Received RPC '${e}' ${s}: `, t), 
        t)), (t => {
            throw __PRIVATE_logWarn("RestConnection", `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), 
            t;
        }));
    }
    ko(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Oo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */    Lo(e, t, n) {
        e["X-Goog-Api-Client"] = 
        // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + S;
        }(), 
        // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), 
        t && t.headers.forEach(((t, n) => e[n] = t)), n && n.headers.forEach(((t, n) => e[n] = t));
    }
    No(e, t) {
        const n = fe[e];
        return `${this.Fo}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */    terminate() {
        // No-op
    }
} {
    constructor(e) {
        super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, 
        this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    Bo(e, t, n, r) {
        const i = __PRIVATE_generateUniqueDebugId();
        return new Promise(((s, o) => {
            const _ = new XhrIo;
            _.setWithCredentials(!0), _.listenOnce(EventType.COMPLETE, (() => {
                try {
                    switch (_.getLastErrorCode()) {
                      case ErrorCode.NO_ERROR:
                        const t = _.getResponseJson();
                        __PRIVATE_logDebug(ge, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), 
                        s(t);
                        break;

                      case ErrorCode.TIMEOUT:
                        __PRIVATE_logDebug(ge, `RPC '${e}' ${i} timed out`), o(new FirestoreError(D.DEADLINE_EXCEEDED, "Request time out"));
                        break;

                      case ErrorCode.HTTP_ERROR:
                        const n = _.getStatus();
                        if (__PRIVATE_logDebug(ge, `RPC '${e}' ${i} failed with status:`, n, "response text:", _.getResponseText()), 
                        n > 0) {
                            let e = _.getResponseJson();
                            Array.isArray(e) && (e = e[0]);
                            const t = null == e ? void 0 : e.error;
                            if (t && t.status && t.message) {
                                const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                    const t = e.toLowerCase().replace(/_/g, "-");
                                    return Object.values(D).indexOf(t) >= 0 ? t : D.UNKNOWN;
                                }(t.status);
                                o(new FirestoreError(e, t.message));
                            } else o(new FirestoreError(D.UNKNOWN, "Server responded with status " + _.getStatus()));
                        } else 
                        // If we received an HTTP_ERROR but there's no status code,
                        // it's most probably a connection issue
                        o(new FirestoreError(D.UNAVAILABLE, "Connection failed."));
                        break;

                      default:
                        fail();
                    }
                } finally {
                    __PRIVATE_logDebug(ge, `RPC '${e}' ${i} completed.`);
                }
            }));
            const a = JSON.stringify(r);
            __PRIVATE_logDebug(ge, `RPC '${e}' ${i} sending request:`, r), _.send(t, "POST", a, n, 15);
        }));
    }
    qo(e, t, n) {
        const r = __PRIVATE_generateUniqueDebugId(), i = [ this.Fo, "/", "google.firestore.v1.Firestore", "/", e, "/channel" ], s = createWebChannelTransport(), o = getStatEventTarget(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), 
        this.Lo(_.initMessageHeaders, t, n), 
        // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        __PRIVATE_logDebug(ge, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
                let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
                const P = new __PRIVATE_StreamBridge({
            Eo: t => {
                h ? __PRIVATE_logDebug(ge, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || (__PRIVATE_logDebug(ge, `Opening RPC '${e}' stream ${r} transport.`), 
                c.open(), l = !0), __PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} sending:`, t), 
                c.send(t));
            },
            Ao: () => c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n) => {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e => {
                try {
                    n(e);
                } catch (e) {
                    setTimeout((() => {
                        throw e;
                    }), 0);
                }
            }));
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
                return __PRIVATE_unguardedEventListen(c, WebChannel.EventType.OPEN, (() => {
            h || (__PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} transport opened.`), P.So());
        })), __PRIVATE_unguardedEventListen(c, WebChannel.EventType.CLOSE, (() => {
            h || (h = !0, __PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} transport closed`), 
            P.Do());
        })), __PRIVATE_unguardedEventListen(c, WebChannel.EventType.ERROR, (t => {
            h || (h = !0, __PRIVATE_logWarn(ge, `RPC '${e}' stream ${r} transport errored:`, t), 
            P.Do(new FirestoreError(D.UNAVAILABLE, "The operation could not be completed")));
        })), __PRIVATE_unguardedEventListen(c, WebChannel.EventType.MESSAGE, (t => {
            var n;
            if (!h) {
                const i = t.data[0];
                __PRIVATE_hardAssert(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = (null == s ? void 0 : s.error) || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    __PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = 
                    /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */
                    function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = le[e];
                        if (void 0 !== t) return __PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = D.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), 
                    // Mark closed so no further events are propagated
                    h = !0, P.Do(new FirestoreError(n, i)), c.close();
                } else __PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} received:`, i), P.vo(i);
            }
        })), __PRIVATE_unguardedEventListen(o, Event.STAT_EVENT, (t => {
            t.stat === Stat.PROXY ? __PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === Stat.NOPROXY && __PRIVATE_logDebug(ge, `RPC '${e}' stream ${r} detected no buffering proxy`);
        })), setTimeout((() => {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.bo();
        }), 0), P;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Initializes the WebChannelConnection for the browser. */
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The Platform's 'window' implementation or null if not available. */
function __PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}

/** The Platform's 'document' implementation or null if not available. */ function getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_newSerializer(e) {
    return new JsonProtoSerializer(e, /* useProto3Json= */ !0);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */
class __PRIVATE_ExponentialBackoff {
    constructor(
    /**
     * The AsyncQueue to run backoff operations on.
     */
    e, 
    /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */
    t, 
    /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */
    n = 1e3
    /**
     * The multiplier to use to determine the extended base delay after each
     * attempt.
     */ , r = 1.5
    /**
     * The maximum base delay after which no further backoff is performed.
     * Note that jitter will still be applied, so the actual delay could be as
     * much as 1.5*maxDelayMs.
     */ , i = 6e4) {
        this.li = e, this.timerId = t, this.Qo = n, this.Ko = r, this.$o = i, this.Uo = 0, 
        this.Wo = null, 
        /** The last backoff attempt, as epoch milliseconds. */
        this.Go = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */    reset() {
        this.Uo = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */    zo() {
        this.Uo = this.$o;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */    jo(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.Uo + this.Ho()), n = Math.max(0, Date.now() - this.Go), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
                r > 0 && __PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Uo} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), 
        this.Wo = this.li.enqueueAfterDelay(this.timerId, r, (() => (this.Go = Date.now(), 
        e()))), 
        // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.Uo *= this.Ko, this.Uo < this.Qo && (this.Uo = this.Qo), this.Uo > this.$o && (this.Uo = this.$o);
    }
    Jo() {
        null !== this.Wo && (this.Wo.skipDelay(), this.Wo = null);
    }
    cancel() {
        null !== this.Wo && (this.Wo.cancel(), this.Wo = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */    Ho() {
        return (Math.random() - .5) * this.Uo;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */
class __PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _) {
        this.li = e, this.Yo = n, this.Zo = r, this.connection = i, this.authCredentialsProvider = s, 
        this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , 
        /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */
        this.Xo = 0, this.e_ = null, this.t_ = null, this.stream = null, 
        /**
         * Count of response messages received.
         */
        this.n_ = 0, this.r_ = new __PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */    i_() {
        return 1 /* PersistentStreamState.Starting */ === this.state || 5 /* PersistentStreamState.Backoff */ === this.state || this.s_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */    s_() {
        return 2 /* PersistentStreamState.Open */ === this.state || 3 /* PersistentStreamState.Healthy */ === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */    start() {
        this.n_ = 0, 4 /* PersistentStreamState.Error */ !== this.state ? this.auth() : this.o_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */    async stop() {
        this.i_() && await this.close(0 /* PersistentStreamState.Initial */);
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */    __() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.r_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */    a_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.s_() && null === this.e_ && (this.e_ = this.li.enqueueAfterDelay(this.Yo, 6e4, (() => this.u_())));
    }
    /** Sends a message to the underlying stream. */    c_(e) {
        this.l_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */    async u_() {
        if (this.s_()) 
        // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */);
    }
    /** Marks the stream as active again. */    l_() {
        this.e_ && (this.e_.cancel(), this.e_ = null);
    }
    /** Cancels the health check delayed operation. */    h_() {
        this.t_ && (this.t_.cancel(), this.t_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */    async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.l_(), this.h_(), this.r_.cancel(), 
        // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Xo++, 4 /* PersistentStreamState.Error */ !== e ? 
        // If this is an intentional close ensure we don't delay our next connection attempt.
        this.r_.reset() : t && t.code === D.RESOURCE_EXHAUSTED ? (
        // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        __PRIVATE_logError(t.toString()), __PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), 
        this.r_.zo()) : t && t.code === D.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */ !== this.state && (
        // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), 
        // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.P_(), this.stream.close(), this.stream = null), 
        // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, 
        // Notify the listener that the stream closed.
        await this.listener.po(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */    P_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */;
        const e = this.T_(this.Xo), t = this.Xo;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
                Promise.all([ this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken() ]).then((([e, n]) => {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Xo === t && 
            // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.I_(e, n);
        }), (t => {
            e((() => {
                const e = new FirestoreError(D.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.E_(e);
            }));
        }));
    }
    I_(e, t) {
        const n = this.T_(this.Xo);
        this.stream = this.d_(e, t), this.stream.Ro((() => {
            n((() => this.listener.Ro()));
        })), this.stream.mo((() => {
            n((() => (this.state = 2 /* PersistentStreamState.Open */ , this.t_ = this.li.enqueueAfterDelay(this.Zo, 1e4, (() => (this.s_() && (this.state = 3 /* PersistentStreamState.Healthy */), 
            Promise.resolve()))), this.listener.mo())));
        })), this.stream.po((e => {
            n((() => this.E_(e)));
        })), this.stream.onMessage((e => {
            n((() => 1 == ++this.n_ ? this.A_(e) : this.onNext(e)));
        }));
    }
    o_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.r_.jo((async () => {
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        }));
    }
    // Visible for tests
    E_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return __PRIVATE_logDebug("PersistentStream", `close with error: ${e}`), this.stream = null, 
        this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */    T_(e) {
        return t => {
            this.li.enqueueAndForget((() => this.Xo === e ? t() : (__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), 
            Promise.resolve())));
        };
    }
}

/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class __PRIVATE_PersistentListenStream extends __PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s) {
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), 
        this.serializer = i;
    }
    d_(e, t) {
        return this.connection.qo("Listen", e, t);
    }
    A_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.r_.reset();
        const t = __PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? SnapshotVersion.min() : t.readTime ? __PRIVATE_fromVersion(t.readTime) : SnapshotVersion.min();
        }(e);
        return this.listener.R_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */    V_(e) {
        const t = {};
        t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = __PRIVATE_targetIsDocumentTarget(r) ? {
                documents: __PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: __PRIVATE_toQueryTarget(e, r).ct
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = __PRIVATE_toBytes(e, t.resumeToken);
                const r = __PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = __PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = __PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.c_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */    m_(e) {
        const t = {};
        t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, 
        this.c_(t);
    }
}

/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class __PRIVATE_PersistentWriteStream extends __PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s) {
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), 
        this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */    get f_() {
        return this.n_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    P_() {
        this.f_ && this.g_([]);
    }
    d_(e, t) {
        return this.connection.qo("Write", e, t);
    }
    A_(e) {
        // Always capture the last stream token.
        return __PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, 
        // The first response is always the handshake response
        __PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.listener.p_();
    }
    onNext(e) {
        // Always capture the last stream token.
        __PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, 
        // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.r_.reset();
        const t = __PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = __PRIVATE_fromVersion(e.commitTime);
        return this.listener.y_(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */    w_() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = __PRIVATE_getEncodedDatabaseId(this.serializer), this.c_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */    g_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e => toMutation(this.serializer, e)))
        };
        this.c_(t);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */
class __PRIVATE_DatastoreImpl extends class Datastore {} {
    constructor(e, t, n, r) {
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, 
        this.serializer = r, this.S_ = !1;
    }
    b_() {
        if (this.S_) throw new FirestoreError(D.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */    Oo(e, t, n, r) {
        return this.b_(), Promise.all([ this.authCredentials.getToken(), this.appCheckCredentials.getToken() ]).then((([i, s]) => this.connection.Oo(e, __PRIVATE_toResourcePath(t, n), r, i, s))).catch((e => {
            throw "FirebaseError" === e.name ? (e.code === D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), 
            this.appCheckCredentials.invalidateToken()), e) : new FirestoreError(D.UNKNOWN, e.toString());
        }));
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */    ko(e, t, n, r, i) {
        return this.b_(), Promise.all([ this.authCredentials.getToken(), this.appCheckCredentials.getToken() ]).then((([s, o]) => this.connection.ko(e, __PRIVATE_toResourcePath(t, n), r, s, o, i))).catch((e => {
            throw "FirebaseError" === e.name ? (e.code === D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), 
            this.appCheckCredentials.invalidateToken()), e) : new FirestoreError(D.UNKNOWN, e.toString());
        }));
    }
    terminate() {
        this.S_ = !0, this.connection.terminate();
    }
}

// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */
class __PRIVATE_OnlineStateTracker {
    constructor(e, t) {
        this.asyncQueue = e, this.onlineStateHandler = t, 
        /** The current OnlineState. */
        this.state = "Unknown" /* OnlineState.Unknown */ , 
        /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */
        this.D_ = 0, 
        /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */
        this.v_ = null, 
        /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */
        this.C_ = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */    F_() {
        0 === this.D_ && (this.M_("Unknown" /* OnlineState.Unknown */), this.v_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, (() => (this.v_ = null, 
        this.x_("Backend didn't respond within 10 seconds."), this.M_("Offline" /* OnlineState.Offline */), 
        Promise.resolve()))));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */    O_(e) {
        "Online" /* OnlineState.Online */ === this.state ? this.M_("Unknown" /* OnlineState.Unknown */) : (this.D_++, 
        this.D_ >= 1 && (this.N_(), this.x_(`Connection failed 1 times. Most recent error: ${e.toString()}`), 
        this.M_("Offline" /* OnlineState.Offline */)));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */    set(e) {
        this.N_(), this.D_ = 0, "Online" /* OnlineState.Online */ === e && (
        // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        this.C_ = !1), this.M_(e);
    }
    M_(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    x_(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.C_ ? (__PRIVATE_logError(t), this.C_ = !1) : __PRIVATE_logDebug("OnlineStateTracker", t);
    }
    N_() {
        null !== this.v_ && (this.v_.cancel(), this.v_ = null);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_RemoteStoreImpl {
    constructor(
    /**
     * The local store, used to fill the write pipeline with outbound mutations.
     */
    e, 
    /** The client-side proxy for interacting with the backend. */
    t, n, r, i) {
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, 
        /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */
        this.L_ = [], 
        /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */
        this.B_ = new Map, 
        /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */
        this.k_ = new Set, 
        /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */
        this.q_ = [], this.Q_ = i, this.Q_.uo((e => {
            n.enqueueAndForget((async () => {
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                __PRIVATE_canUseNetwork(this) && (__PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change."), 
                await async function __PRIVATE_restartNetwork(e) {
                    const t = __PRIVATE_debugCast(e);
                    t.k_.add(4 /* OfflineCause.ConnectivityChange */), await __PRIVATE_disableNetworkInternal(t), 
                    t.K_.set("Unknown" /* OnlineState.Unknown */), t.k_.delete(4 /* OfflineCause.ConnectivityChange */), 
                    await __PRIVATE_enableNetworkInternal(t);
                }(this));
            }));
        })), this.K_ = new __PRIVATE_OnlineStateTracker(n, r);
    }
}

async function __PRIVATE_enableNetworkInternal(e) {
    if (__PRIVATE_canUseNetwork(e)) for (const t of e.q_) await t(/* enabled= */ !0);
}

/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function __PRIVATE_disableNetworkInternal(e) {
    for (const t of e.q_) await t(/* enabled= */ !1);
}

/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */
function __PRIVATE_remoteStoreListen(e, t) {
    const n = __PRIVATE_debugCast(e);
    n.B_.has(t.targetId) || (
    // Mark this as something the client is currently listening for.
    n.B_.set(t.targetId, t), __PRIVATE_shouldStartWatchStream(n) ? 
    // The listen will be sent in onWatchStreamOpen
    __PRIVATE_startWatchStream(n) : __PRIVATE_ensureWatchStream(n).s_() && __PRIVATE_sendWatchRequest(n, t));
}

/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function __PRIVATE_remoteStoreUnlisten(e, t) {
    const n = __PRIVATE_debugCast(e), r = __PRIVATE_ensureWatchStream(n);
    n.B_.delete(t), r.s_() && __PRIVATE_sendUnwatchRequest(n, t), 0 === n.B_.size && (r.s_() ? r.a_() : __PRIVATE_canUseNetwork(n) && 
    // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.K_.set("Unknown" /* OnlineState.Unknown */));
}

/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function __PRIVATE_sendWatchRequest(e, t) {
    if (e.U_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    __PRIVATE_ensureWatchStream(e).V_(t);
}

/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function __PRIVATE_sendUnwatchRequest(e, t) {
    e.U_.xe(t), __PRIVATE_ensureWatchStream(e).m_(t);
}

function __PRIVATE_startWatchStream(e) {
    e.U_ = new __PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: t => e.remoteSyncer.getRemoteKeysForTarget(t),
        ut: t => e.B_.get(t) || null,
        nt: () => e.datastore.serializer.databaseId
    }), __PRIVATE_ensureWatchStream(e).start(), e.K_.F_();
}

/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function __PRIVATE_shouldStartWatchStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWatchStream(e).i_() && e.B_.size > 0;
}

function __PRIVATE_canUseNetwork(e) {
    return 0 === __PRIVATE_debugCast(e).k_.size;
}

function __PRIVATE_cleanUpWatchStreamState(e) {
    e.U_ = void 0;
}

async function __PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.K_.set("Online" /* OnlineState.Online */);
}

async function __PRIVATE_onWatchStreamOpen(e) {
    e.B_.forEach(((t, n) => {
        __PRIVATE_sendWatchRequest(e, t);
    }));
}

async function __PRIVATE_onWatchStreamClose(e, t) {
    __PRIVATE_cleanUpWatchStreamState(e), 
    // If we still need the watch stream, retry the connection.
    __PRIVATE_shouldStartWatchStream(e) ? (e.K_.O_(t), __PRIVATE_startWatchStream(e)) : 
    // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.K_.set("Unknown" /* OnlineState.Unknown */);
}

async function __PRIVATE_onWatchStreamChange(e, t, n) {
    if (
    // Mark the client as online since we got a message from the server
    e.K_.set("Online" /* OnlineState.Online */), t instanceof __PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */ === t.state && t.cause) 
    // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await 
        /** Handles an error on a target */
        async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds) 
            // A watched target might have been removed already.
            e.B_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.B_.delete(r), e.U_.removeTarget(r));
        }
        /**
 * Attempts to fill our write pipeline with writes from the LocalStore.
 *
 * Called internally to bootstrap or refill the write pipeline and by
 * SyncEngine whenever there are new mutations to process.
 *
 * Starts the write stream if necessary.
 */ (e, t);
    } catch (n) {
        __PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), 
        await __PRIVATE_disableNetworkUntilRecovery(e, n);
    } else if (t instanceof __PRIVATE_DocumentWatchChange ? e.U_.$e(t) : t instanceof __PRIVATE_ExistenceFilterChange ? e.U_.Je(t) : e.U_.Ge(t), 
    !n.isEqual(SnapshotVersion.min())) try {
        const t = await __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && 
        // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await 
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */
        function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.U_.it(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
                        return n.targetChanges.forEach(((n, r) => {
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.B_.get(r);
                    // A watched target might have been removed already.
                                        i && e.B_.set(r, i.withResumeToken(n.resumeToken, t));
                }
            })), 
            // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach(((t, n) => {
                const r = e.B_.get(t);
                if (!r) 
                // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                                e.B_.set(t, r.withResumeToken(ByteString.EMPTY_BYTE_STRING, r.snapshotVersion)), 
                // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                __PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new TargetData(r.target, t, n, r.sequenceNumber);
                __PRIVATE_sendWatchRequest(e, i);
            })), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        __PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t), await __PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}

/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function __PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.k_.add(1 /* OfflineCause.IndexedDbFailed */), 
    // Disable network and raise offline snapshots
    await __PRIVATE_disableNetworkInternal(e), e.K_.set("Offline" /* OnlineState.Offline */), 
    n || (
    // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    n = () => __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), 
    // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable((async () => {
        __PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access"), await n(), e.k_.delete(1 /* OfflineCause.IndexedDbFailed */), 
        await __PRIVATE_enableNetworkInternal(e);
    }));
}

/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function __PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n => __PRIVATE_disableNetworkUntilRecovery(e, n, t)));
}

async function __PRIVATE_fillWritePipeline(e) {
    const t = __PRIVATE_debugCast(e), n = __PRIVATE_ensureWriteStream(t);
    let r = t.L_.length > 0 ? t.L_[t.L_.length - 1].batchId : -1;
    for (;__PRIVATE_canAddToWritePipeline(t); ) try {
        const e = await __PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.L_.length && n.a_();
            break;
        }
        r = e.batchId, __PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await __PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    __PRIVATE_shouldStartWriteStream(t) && __PRIVATE_startWriteStream(t);
}

/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function __PRIVATE_canAddToWritePipeline(e) {
    return __PRIVATE_canUseNetwork(e) && e.L_.length < 10;
}

/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function __PRIVATE_addToWritePipeline(e, t) {
    e.L_.push(t);
    const n = __PRIVATE_ensureWriteStream(e);
    n.s_() && n.f_ && n.g_(t.mutations);
}

function __PRIVATE_shouldStartWriteStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWriteStream(e).i_() && e.L_.length > 0;
}

function __PRIVATE_startWriteStream(e) {
    __PRIVATE_ensureWriteStream(e).start();
}

async function __PRIVATE_onWriteStreamOpen(e) {
    __PRIVATE_ensureWriteStream(e).w_();
}

async function __PRIVATE_onWriteHandshakeComplete(e) {
    const t = __PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
        for (const n of e.L_) t.g_(n.mutations);
}

async function __PRIVATE_onMutationResult(e, t, n) {
    const r = e.L_.shift(), i = MutationBatchResult.from(r, t, n);
    await __PRIVATE_executeWithRecovery(e, (() => e.remoteSyncer.applySuccessfulWrite(i))), 
    // It's possible that with the completion of this mutation another
    // slot has freed up.
    await __PRIVATE_fillWritePipeline(e);
}

async function __PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && __PRIVATE_ensureWriteStream(e).f_ && 
    // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return __PRIVATE_isPermanentError(e) && e !== D.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.L_.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
                        __PRIVATE_ensureWriteStream(e).__(), await __PRIVATE_executeWithRecovery(e, (() => e.remoteSyncer.rejectFailedWrite(n.batchId, t))), 
            // It's possible that with the completion of this mutation
            // another slot has freed up.
            await __PRIVATE_fillWritePipeline(e);
        }
    }(e, t), 
    // The write stream might have been started by refilling the write
    // pipeline for failed writes
    __PRIVATE_shouldStartWriteStream(e) && __PRIVATE_startWriteStream(e);
}

async function __PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
    const r = __PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
        n.k_.add(3 /* OfflineCause.CredentialChange */), await __PRIVATE_disableNetworkInternal(n), 
    r && 
    // Don't set the network status to Unknown if we are offline.
    n.K_.set("Unknown" /* OnlineState.Unknown */), await n.remoteSyncer.handleCredentialChange(t), 
    n.k_.delete(3 /* OfflineCause.CredentialChange */), await __PRIVATE_enableNetworkInternal(n);
}

/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function __PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = __PRIVATE_debugCast(e);
    t ? (n.k_.delete(2 /* OfflineCause.IsSecondary */), await __PRIVATE_enableNetworkInternal(n)) : t || (n.k_.add(2 /* OfflineCause.IsSecondary */), 
    await __PRIVATE_disableNetworkInternal(n), n.K_.set("Unknown" /* OnlineState.Unknown */));
}

/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWatchStream(e) {
    return e.W_ || (
    // Create stream (but note that it is not started yet).
    e.W_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = __PRIVATE_debugCast(e);
        return r.b_(), new __PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }
    /**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (e.datastore, e.asyncQueue, {
        Ro: __PRIVATE_onWatchStreamConnected.bind(null, e),
        mo: __PRIVATE_onWatchStreamOpen.bind(null, e),
        po: __PRIVATE_onWatchStreamClose.bind(null, e),
        R_: __PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.q_.push((async t => {
        t ? (e.W_.__(), __PRIVATE_shouldStartWatchStream(e) ? __PRIVATE_startWatchStream(e) : e.K_.set("Unknown" /* OnlineState.Unknown */)) : (await e.W_.stop(), 
        __PRIVATE_cleanUpWatchStreamState(e));
    }))), e.W_;
}

/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWriteStream(e) {
    return e.G_ || (
    // Create stream (but note that it is not started yet).
    e.G_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = __PRIVATE_debugCast(e);
        return r.b_(), new __PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Ro: () => Promise.resolve(),
        mo: __PRIVATE_onWriteStreamOpen.bind(null, e),
        po: __PRIVATE_onWriteStreamClose.bind(null, e),
        p_: __PRIVATE_onWriteHandshakeComplete.bind(null, e),
        y_: __PRIVATE_onMutationResult.bind(null, e)
    }), e.q_.push((async t => {
        t ? (e.G_.__(), 
        // This will start the write stream if necessary.
        await __PRIVATE_fillWritePipeline(e)) : (await e.G_.stop(), e.L_.length > 0 && (__PRIVATE_logDebug("RemoteStore", `Stopping write stream with ${e.L_.length} pending writes`), 
        e.L_ = []));
    }))), e.G_;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */
class DelayedOperation {
    constructor(e, t, n, r, i) {
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, 
        this.deferred = new __PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), 
        // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e => {}));
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */    static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */    start(e) {
        this.timerHandle = setTimeout((() => this.handleDelayElapsed()), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */    skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */    cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new FirestoreError(D.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget((() => null !== this.timerHandle ? (this.clearTimeout(), 
        this.op().then((e => this.deferred.resolve(e)))) : Promise.resolve()));
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), 
        this.timerHandle = null);
    }
}

/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function __PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if (__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), __PRIVATE_isIndexedDbTransactionError(e)) return new FirestoreError(D.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */
    static emptySet(e) {
        return new DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */    constructor(e) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n) => e(t, n) || DocumentKey.comparator(t.key, n.key) : (e, t) => DocumentKey.comparator(e.key, t.key), 
        this.keyedMap = documentMap(), this.sortedSet = new SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */    indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */    forEach(e) {
        this.sortedSet.inorderTraversal(((t, n) => (e(t), !1)));
    }
    /** Inserts or updates a document with the same key */    add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */    delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for (;t.hasNext(); ) {
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t => {
            e.push(t.toString());
        })), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class __PRIVATE_DocumentChangeSet {
    constructor() {
        this.z_ = new SortedMap(DocumentKey.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.z_.get(t);
        n ? 
        // Merge the new change with the existing change.
        0 /* ChangeType.Added */ !== e.type && 3 /* ChangeType.Metadata */ === n.type ? this.z_ = this.z_.insert(t, e) : 3 /* ChangeType.Metadata */ === e.type && 1 /* ChangeType.Removed */ !== n.type ? this.z_ = this.z_.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */ === e.type && 2 /* ChangeType.Modified */ === n.type ? this.z_ = this.z_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */ === e.type && 0 /* ChangeType.Added */ === n.type ? this.z_ = this.z_.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */ === e.type && 0 /* ChangeType.Added */ === n.type ? this.z_ = this.z_.remove(t) : 1 /* ChangeType.Removed */ === e.type && 2 /* ChangeType.Modified */ === n.type ? this.z_ = this.z_.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */ === e.type && 1 /* ChangeType.Removed */ === n.type ? this.z_ = this.z_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 
        // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        fail() : this.z_ = this.z_.insert(t, e);
    }
    j_() {
        const e = [];
        return this.z_.inorderTraversal(((t, n) => {
            e.push(n);
        })), e;
    }
}

class ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a) {
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, 
        this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, 
        this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */    static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e => {
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        })), new ViewSnapshot(e, t, DocumentSet.emptySet(t), s, n, r, 
        /* syncStateChanged= */ !0, 
        /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && __PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for (let e = 0; e < t.length; e++) if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class __PRIVATE_QueryListenersInfo {
    constructor() {
        this.H_ = void 0, this.J_ = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Y_() {
        return this.J_.some((e => e.Z_()));
    }
}

class __PRIVATE_EventManagerImpl {
    constructor() {
        this.queries = __PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , 
        this.X_ = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = __PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = __PRIVATE_newQueriesObjectMap(), r.forEach(((e, n) => {
                for (const e of n.J_) e.onError(t);
            }));
        }
        // Call all global snapshot listeners that have been set.
        (this, new FirestoreError(D.ABORTED, "Firestore shutting down"));
    }
}

function __PRIVATE_newQueriesObjectMap() {
    return new ObjectMap((e => __PRIVATE_canonifyQuery(e)), __PRIVATE_queryEquals);
}

async function __PRIVATE_eventManagerListen(e, t) {
    const n = __PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Y_() && t.Z_() && (
    // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */) : (s = new __PRIVATE_QueryListenersInfo, 
    r = t.Z_() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ : 1 /* ListenerSetupAction.InitializeLocalListenOnly */);
    try {
        switch (r) {
          case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
            s.H_ = await n.onListen(i, 
            /** enableRemoteListen= */ !0);
            break;

          case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
            s.H_ = await n.onListen(i, 
            /** enableRemoteListen= */ !1);
            break;

          case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
            await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = __PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.J_.push(t), 
    // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.ea(n.onlineState), s.H_) {
        t.ta(s.H_) && __PRIVATE_raiseSnapshotsInSyncEvent(n);
    }
}

async function __PRIVATE_eventManagerUnlisten(e, t) {
    const n = __PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */;
    const s = n.queries.get(r);
    if (s) {
        const e = s.J_.indexOf(t);
        e >= 0 && (s.J_.splice(e, 1), 0 === s.J_.length ? i = t.Z_() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ : !s.Y_() && t.Z_() && (
        // The removed listener is the last one that sourced from watch.
        i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */));
    }
    switch (i) {
      case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
        return n.queries.delete(r), n.onUnlisten(r, 
        /** disableRemoteListen= */ !0);

      case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
        return n.queries.delete(r), n.onUnlisten(r, 
        /** disableRemoteListen= */ !1);

      case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
        return n.onLastRemoteStoreUnlisten(r);

      default:
        return;
    }
}

function __PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t) {
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.J_) t.ta(e) && (r = !0);
            i.H_ = e;
        }
    }
    r && __PRIVATE_raiseSnapshotsInSyncEvent(n);
}

function __PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.J_) e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
        r.queries.delete(t);
}

function __PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.X_.forEach((e => {
        e.next();
    }));
}

var pe, ye;

/** Listen to both cache and server changes */
(ye = pe || (pe = {})).na = "default", 
/** Listen to changes in cache only */
ye.Cache = "cache";

/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */
class __PRIVATE_QueryListener {
    constructor(e, t, n) {
        this.query = e, this.ra = t, 
        /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */
        this.ia = !1, this.sa = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , 
        this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */    ta(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges) 3 /* ChangeType.Metadata */ !== n.type && t.push(n);
            e = new ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, 
            /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.ia ? this.oa(e) && (this.ra.next(e), t = !0) : this._a(e, this.onlineState) && (this.aa(e), 
        t = !0), this.sa = e, t;
    }
    onError(e) {
        this.ra.error(e);
    }
    /** Returns whether a snapshot was raised. */    ea(e) {
        this.onlineState = e;
        let t = !1;
        return this.sa && !this.ia && this._a(this.sa, e) && (this.aa(this.sa), t = !0), 
        t;
    }
    _a(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
                if (!this.Z_()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
                const n = "Offline" /* OnlineState.Offline */ !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
                return (!this.options.ua || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */ === t);
        // Raise data from cache if we have any documents, have cached results before,
        // or we are offline.
        }
    oa(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.sa && this.sa.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
        // Generally we should have hit one of the cases above, but it's possible
        // to get here if there were only metadata docChanges and they got
        // stripped out.
        }
    aa(e) {
        e = ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), 
        this.ia = !0, this.ra.next(e);
    }
    Z_() {
        return this.options.source !== pe.Cache;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class __PRIVATE_SizedBundleElement {
    constructor(e, 
    // How many bytes this element takes to store in the bundle.
    t) {
        this.ca = e, this.byteLength = t;
    }
    la() {
        return "metadata" in this.ca;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class __PRIVATE_BundleConverterImpl {
    constructor(e) {
        this.serializer = e;
    }
    As(e) {
        return fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */    Rs(e) {
        return e.metadata.exists ? __PRIVATE_fromDocument(this.serializer, e.document, !1) : MutableDocument.newNoDocument(this.As(e.metadata.name), this.Vs(e.metadata.readTime));
    }
    Vs(e) {
        return __PRIVATE_fromVersion(e);
    }
}

/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class __PRIVATE_BundleLoader {
    constructor(e, t, n) {
        this.ha = e, this.localStore = t, this.serializer = n, 
        /** Batched queries to be saved into storage */
        this.queries = [], 
        /** Batched documents to be saved into storage */
        this.documents = [], 
        /** The collection groups affected by this bundle. */
        this.collectionGroups = new Set, this.progress = __PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */    Pa(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.ca.namedQuery) this.queries.push(e.ca.namedQuery); else if (e.ca.documentMetadata) {
            this.documents.push({
                metadata: e.ca.documentMetadata
            }), e.ca.documentMetadata.exists || ++t;
            const n = ResourcePath.fromString(e.ca.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.ca.document && (this.documents[this.documents.length - 1].document = e.ca.document, 
        ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, 
        Object.assign({}, this.progress)) : null;
    }
    Ta(e) {
        const t = new Map, n = new __PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e) if (r.metadata.queries) {
            const e = n.As(r.metadata.name);
            for (const n of r.metadata.queries) {
                const r = (t.get(n) || __PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */    async complete() {
        const e = await __PRIVATE_localStoreApplyBundledDocuments(this.localStore, new __PRIVATE_BundleConverterImpl(this.serializer), this.documents, this.ha.id), t = this.Ta(this.documents);
        for (const e of this.queries) await __PRIVATE_localStoreSaveNamedQuery(this.localStore, e, t.get(e.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ia: this.collectionGroups,
            Ea: e
        };
    }
}

/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function __PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}

/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __PRIVATE_AddedLimboDocument {
    constructor(e) {
        this.key = e;
    }
}

class __PRIVATE_RemovedLimboDocument {
    constructor(e) {
        this.key = e;
    }
}

/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class __PRIVATE_View {
    constructor(e, 
    /** Documents included in the remote target */
    t) {
        this.query = e, this.da = t, this.Aa = null, this.hasCachedResults = !1, 
        /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */
        this.current = !1, 
        /** Documents in the view but not in the remote target */
        this.Ra = __PRIVATE_documentKeySet(), 
        /** Document Keys that have local changes */
        this.mutatedKeys = __PRIVATE_documentKeySet(), this.Va = __PRIVATE_newQueryComparator(e), 
        this.ma = new DocumentSet(this.Va);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */    get fa() {
        return this.da;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */    ga(e, t) {
        const n = t ? t.pa : new __PRIVATE_DocumentChangeSet, r = t ? t.ma : this.ma;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */ === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */ === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal(((e, t) => {
            const u = r.get(e), c = __PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || 
            // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
                        if (u && c) {
                u.data.isEqual(c.data) ? l !== h && (n.track({
                    type: 3 /* ChangeType.Metadata */ ,
                    doc: c
                }), P = !0) : this.ya(u, c) || (n.track({
                    type: 2 /* ChangeType.Modified */ ,
                    doc: c
                }), P = !0, (_ && this.Va(c, _) > 0 || a && this.Va(c, a) < 0) && (
                // This doc moved from inside the limit to outside the limit.
                // That means there may be some other doc in the local cache
                // that should be included instead.
                o = !0));
            } else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && (
            // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        })), null !== this.query.limit) for (;s.size > this.query.limit; ) {
            const e = "F" /* LimitType.First */ === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            ma: s,
            pa: n,
            ss: o,
            mutatedKeys: i
        };
    }
    ya(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */
    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.ma;
        this.ma = e.ma, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.pa.j_();
        s.sort(((e, t) => function __PRIVATE_compareChangeType(e, t) {
            const order = e => {
                switch (e) {
                  case 0 /* ChangeType.Added */ :
                    return 1;

                  case 2 /* ChangeType.Modified */ :
                  case 3 /* ChangeType.Metadata */ :
                    // A metadata change is converted to a modified change at the public
                    // api layer.  Since we sort by document key and then change type,
                    // metadata and modified changes must be sorted equivalently.
                    return 2;

                  case 1 /* ChangeType.Removed */ :
                    return 0;

                  default:
                    return fail();
                }
            };
            return order(e) - order(t);
        }
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (e.type, t.type) || this.Va(e.doc, t.doc))), this.wa(n), r = null != r && r;
        const o = t && !r ? this.Sa() : [], _ = 0 === this.Ra.size && this.current && !r ? 1 /* SyncState.Synced */ : 0 /* SyncState.Local */ , a = _ !== this.Aa;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
                if (this.Aa = _, 0 !== s.length || a) {
            return {
                snapshot: new ViewSnapshot(this.query, e.ma, i, s, e.mutatedKeys, 0 /* SyncState.Local */ === _, a, 
                /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
                ba: o
            };
        }
        // no changes
        return {
            ba: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */    ea(e) {
        return this.current && "Offline" /* OnlineState.Offline */ === e ? (
        // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        this.current = !1, this.applyChanges({
            ma: this.ma,
            pa: new __PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            ss: !1
        }, 
        /* limboResolutionEnabled= */ !1)) : {
            ba: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */    Da(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.da.has(e) && (
        // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.ma.has(e) && !this.ma.get(e).hasLocalMutations);
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */    wa(e) {
        e && (e.addedDocuments.forEach((e => this.da = this.da.add(e))), e.modifiedDocuments.forEach((e => {})), 
        e.removedDocuments.forEach((e => this.da = this.da.delete(e))), this.current = e.current);
    }
    Sa() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
                const e = this.Ra;
        this.Ra = __PRIVATE_documentKeySet(), this.ma.forEach((e => {
            this.Da(e.key) && (this.Ra = this.Ra.add(e.key));
        }));
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e => {
            this.Ra.has(e) || t.push(new __PRIVATE_RemovedLimboDocument(e));
        })), this.Ra.forEach((n => {
            e.has(n) || t.push(new __PRIVATE_AddedLimboDocument(n));
        })), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */
    // PORTING NOTE: Multi-tab only.
    va(e) {
        this.da = e.ds, this.Ra = __PRIVATE_documentKeySet();
        const t = this.ga(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */
    // PORTING NOTE: Multi-tab only.
    Ca() {
        return ViewSnapshot.fromInitialDocuments(this.query, this.ma, this.mutatedKeys, 0 /* SyncState.Local */ === this.Aa, this.hasCachedResults);
    }
}

/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */
class __PRIVATE_QueryView {
    constructor(
    /**
     * The query itself.
     */
    e, 
    /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */
    t, 
    /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */
    n) {
        this.query = e, this.targetId = t, this.view = n;
    }
}

/** Tracks a limbo resolution. */ class LimboResolution {
    constructor(e) {
        this.key = e, 
        /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */
        this.Fa = !1;
    }
}

/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class __PRIVATE_SyncEngineImpl {
    constructor(e, t, n, 
    // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s) {
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, 
        this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Ma = {}, this.xa = new ObjectMap((e => __PRIVATE_canonifyQuery(e)), __PRIVATE_queryEquals), 
        this.Oa = new Map, 
        /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */
        this.Na = new Set, 
        /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */
        this.La = new SortedMap(DocumentKey.comparator), 
        /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */
        this.Ba = new Map, this.ka = new __PRIVATE_ReferenceSet, 
        /** Stores user completion handlers, indexed by User and BatchId. */
        this.qa = {}, 
        /** Stores user callbacks waiting for all pending writes to be acknowledged. */
        this.Qa = new Map, this.Ka = __PRIVATE_TargetIdGenerator.Qn(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , 
        // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.$a = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.$a;
    }
}

/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */
async function __PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = __PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.xa.get(t);
    return s ? (
    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Ca()) : i = await __PRIVATE_allocateTargetAndMaybeListen(r, t, n, 
    /** shouldInitializeView= */ !0), i;
}

/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function __PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = __PRIVATE_ensureWatchCallbacks(e);
    await __PRIVATE_allocateTargetAndMaybeListen(n, t, 
    /** shouldListenToRemote= */ !0, 
    /** shouldInitializeView= */ !1);
}

async function __PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await __PRIVATE_localStoreAllocateTarget(e.localStore, __PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await __PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), 
    e.isPrimaryClient && n && __PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}

/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function __PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.Ua = (t, n, r) => async function __PRIVATE_applyDocChanges(e, t, n, r) {
        let i = t.view.ga(n);
        i.ss && (
        // The query has a limit and some docs were removed, so we need
        // to re-run the query against the local store to make sure we
        // didn't lose any good docs that had been past the limit.
        i = await __PRIVATE_localStoreExecuteQuery(e.localStore, t.query, 
        /* usePreviousResults= */ !1).then((({documents: e}) => t.view.ga(e, i))));
        const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, 
        /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
        return __PRIVATE_updateTrackedLimbos(e, t.targetId, _.ba), _.snapshot;
    }(e, t, n, r);
    const s = await __PRIVATE_localStoreExecuteQuery(e.localStore, t, 
    /* usePreviousResults= */ !0), o = new __PRIVATE_View(t, s.ds), _ = o.ga(s.documents), a = TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */ !== e.onlineState, i), u = o.applyChanges(_, 
    /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    __PRIVATE_updateTrackedLimbos(e, n, u.ba);
    const c = new __PRIVATE_QueryView(t, n, o);
    return e.xa.set(t, c), e.Oa.has(n) ? e.Oa.get(n).push(t) : e.Oa.set(n, [ t ]), u.snapshot;
}

/** Stops listening to the query. */ async function __PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = r.xa.get(t), s = r.Oa.get(i.targetId);
    if (s.length > 1) return r.Oa.set(i.targetId, s.filter((e => !__PRIVATE_queryEquals(e, t)))), 
    void r.xa.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
        if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, 
        /*keepPersistedTargetData=*/ !1).then((() => {
            r.sharedClientState.clearQueryState(i.targetId), n && __PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), 
            __PRIVATE_removeAndCleanupTarget(r, i.targetId);
        })).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else __PRIVATE_removeAndCleanupTarget(r, i.targetId), await __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, 
    /*keepPersistedTargetData=*/ !0);
}

/** Unlistens to the remote store while still listening to the cache. */ async function __PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = __PRIVATE_debugCast(e), r = n.xa.get(t), i = n.Oa.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && (
    // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    n.sharedClientState.removeLocalQueryTarget(r.targetId), __PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}

/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function __PRIVATE_syncEngineWrite(e, t, n) {
    const r = __PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = __PRIVATE_debugCast(e), r = Timestamp.now(), i = t.reduce(((e, t) => e.add(t.key)), __PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e => {
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
                return n.hs.getEntries(e, i).next((e => {
                    _ = e, _.forEach(((e, t) => {
                        t.isValidDocument() || (a = a.add(e));
                    }));
                })).next((() => n.localDocuments.getOverlayedDocuments(e, _))).next((i => {
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t) {
                        const t = __PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && 
                        // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new __PRIVATE_PatchMutation(e.key, t, __PRIVATE_extractFieldMask(t.value.mapValue), Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                })).next((t => {
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                }));
            })).then((() => ({
                batchId: o.batchId,
                changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
            })));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.qa[e.currentUser.toKey()];
            r || (r = new SortedMap(__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.qa[e.currentUser.toKey()] = r;
        }
        /**
 * Resolves or rejects the user callback for the given batch and then discards
 * it.
 */ (r, e.batchId, n), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), 
        await __PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = __PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}

/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function __PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = __PRIVATE_debugCast(e);
    try {
        const e = await __PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
                t.targetChanges.forEach(((e, t) => {
            const r = n.Ba.get(t);
            r && (
            // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            __PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), 
            e.addedDocuments.size > 0 ? r.Fa = !0 : e.modifiedDocuments.size > 0 ? __PRIVATE_hardAssert(r.Fa) : e.removedDocuments.size > 0 && (__PRIVATE_hardAssert(r.Fa), 
            r.Fa = !1));
        })), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}

/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function __PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
        if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */ === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */ === n) {
        const e = [];
        r.xa.forEach(((n, r) => {
            const i = r.view.ea(t);
            i.snapshot && e.push(i.snapshot);
        })), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = __PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach(((e, n) => {
                for (const e of n.J_) 
                // Run global snapshot listeners if a consistent snapshot has been emitted.
                e.ea(t) && (r = !0);
            })), r && __PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Ma.R_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}

/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function __PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
        r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Ba.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new SortedMap(DocumentKey.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
                e = e.insert(s, MutableDocument.newNoDocument(s, SnapshotVersion.min()));
        const n = __PRIVATE_documentKeySet().add(s), i = new RemoteEvent(SnapshotVersion.min(), 
        /* targetChanges= */ new Map, 
        /* targetMismatches= */ new SortedMap(__PRIVATE_primitiveComparator), e, n);
        await __PRIVATE_syncEngineApplyRemoteEvent(r, i), 
        // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.La = r.La.remove(s), r.Ba.delete(t), __PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await __PRIVATE_localStoreReleaseTarget(r.localStore, t, 
    /* keepPersistedTargetData */ !1).then((() => __PRIVATE_removeAndCleanupTarget(r, t, n))).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
}

async function __PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = __PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await __PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
                __PRIVATE_processUserCallback(n, r, /*error=*/ null), __PRIVATE_triggerPendingWritesCallbacks(n, r), 
        n.sharedClientState.updateMutationState(r, "acknowledged"), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}

async function __PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = __PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e => {
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t => (__PRIVATE_hardAssert(null !== t), 
                r = t.keys(), n.mutationQueue.removeMutationBatch(e, t)))).next((() => n.mutationQueue.performConsistencyCheck(e))).next((() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t))).next((() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r))).next((() => n.localDocuments.getDocuments(e, r)));
            }));
        }
        /**
 * Returns the largest (latest) batch id in mutation queue that is pending
 * server response.
 *
 * Returns `BATCHID_UNKNOWN` if the queue is empty.
 */ (r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
                __PRIVATE_processUserCallback(r, t, n), __PRIVATE_triggerPendingWritesCallbacks(r, t), 
        r.sharedClientState.updateMutationState(t, "rejected", n), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await __PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}

/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function __PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = __PRIVATE_debugCast(e);
    __PRIVATE_canUseNetwork(n.remoteStore) || __PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = __PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e => t.mutationQueue.getHighestUnacknowledgedBatchId(e)));
        }(n.localStore);
        if (-1 === e) 
        // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.Qa.get(e) || [];
        r.push(t), n.Qa.set(e, r);
    } catch (e) {
        const n = __PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}

/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function __PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Qa.get(t) || []).forEach((e => {
        e.resolve();
    })), e.Qa.delete(t);
}

/** Reject all outstanding callbacks waiting for pending writes to complete. */ function __PRIVATE_processUserCallback(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    let i = r.qa[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
        if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.qa[r.currentUser.toKey()] = i;
    }
}

function __PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Oa.get(t)) e.xa.delete(r), n && e.Ma.Wa(r, n);
    if (e.Oa.delete(t), e.isPrimaryClient) {
        e.ka.yr(t).forEach((t => {
            e.ka.containsKey(t) || 
            // We removed the last reference for this key
            __PRIVATE_removeLimboTarget(e, t);
        }));
    }
}

function __PRIVATE_removeLimboTarget(e, t) {
    e.Na.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.La.get(t);
    null !== n && (__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.La = e.La.remove(t), 
    e.Ba.delete(n), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}

function __PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n) if (r instanceof __PRIVATE_AddedLimboDocument) e.ka.addReference(r.key, t), 
    __PRIVATE_trackLimboChange(e, r); else if (r instanceof __PRIVATE_RemovedLimboDocument) {
        __PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.ka.removeReference(r.key, t);
        e.ka.containsKey(r.key) || 
        // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, r.key);
    } else fail();
}

function __PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.La.get(n) || e.Na.has(r) || (__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), 
    e.Na.add(r), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}

/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function __PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for (;e.Na.size > 0 && e.La.size < e.maxConcurrentLimboResolutions; ) {
        const t = e.Na.values().next().value;
        e.Na.delete(t);
        const n = new DocumentKey(ResourcePath.fromString(t)), r = e.Ka.next();
        e.Ba.set(r, new LimboResolution(n)), e.La = e.La.insert(n, r), __PRIVATE_remoteStoreListen(e.remoteStore, new TargetData(__PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , __PRIVATE_ListenSequence.oe));
    }
}

async function __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.xa.isEmpty() || (r.xa.forEach(((e, _) => {
        o.push(r.Ua(_, t, n).then((e => {
            var t;
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
                        if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const i = e ? !e.fromCache : null === (t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === t ? void 0 : t.current;
                r.sharedClientState.updateQueryState(_.targetId, i ? "current" : "not-current");
            }
            // Update views if there are actual changes.
                        if (e) {
                i.push(e);
                const t = __PRIVATE_LocalViewChanges.zi(_.targetId, e);
                s.push(t);
            }
        })));
    })), await Promise.all(o), r.Ma.R_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = __PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e => PersistencePromise.forEach(t, (t => PersistencePromise.forEach(t.Wi, (r => n.persistence.referenceDelegate.addReference(e, t.targetId, r))).next((() => PersistencePromise.forEach(t.Gi, (r => n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))))))));
        } catch (e) {
            if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            __PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e);
        }
        for (const e of t) {
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.us.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                                n.us = n.us.insert(t, i);
            }
        }
    }(r.localStore, s));
}

async function __PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        __PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
        const e = await __PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, 
        // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.Qa.forEach((e => {
                e.forEach((e => {
                    e.reject(new FirestoreError(D.CANCELLED, t));
                }));
            })), e.Qa.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), 
        // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Ts);
    }
}

function __PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = __PRIVATE_debugCast(e), r = n.Ba.get(t);
    if (r && r.Fa) return __PRIVATE_documentKeySet().add(r.key);
    {
        let e = __PRIVATE_documentKeySet();
        const r = n.Oa.get(t);
        if (!r) return e;
        for (const t of r) {
            const r = n.xa.get(t);
            e = e.unionWith(r.view.fa);
        }
        return e;
    }
}

/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function __PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = __PRIVATE_debugCast(e), r = await __PRIVATE_localStoreExecuteQuery(n.localStore, t.query, 
    /* usePreviousResults= */ !0), i = t.view.va(r);
    return n.isPrimaryClient && __PRIVATE_updateTrackedLimbos(n, t.targetId, i.ba), 
    i;
}

/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */
// PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = __PRIVATE_debugCast(e);
    return __PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e => __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e)));
}

/** Applies a mutation state to an existing batch.  */
// PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = __PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = __PRIVATE_debugCast(e), r = __PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e => r.On(e, t).next((t => t ? n.localDocuments.getDocuments(e, t) : PersistencePromise.resolve(null)))));
    }
    // PORTING NOTE: Multi-Tab only.
    (i.localStore, t);
    null !== s ? ("pending" === n ? 
    // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await __PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? (
    // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    __PRIVATE_processUserCallback(i, t, r || null), __PRIVATE_triggerPendingWritesCallbacks(i, t), 
    function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        __PRIVATE_debugCast(__PRIVATE_debugCast(e).mutationQueue).Ln(t);
    }
    // PORTING NOTE: Multi-Tab only.
    (i.localStore, t)) : fail(), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : 
    // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    __PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
}

/** Applies a query target change from a different tab. */
// PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = __PRIVATE_debugCast(e);
    if (__PRIVATE_ensureWatchCallbacks(n), __PRIVATE_syncEngineEnsureWriteCallbacks(n), 
    !0 === t && !0 !== n.$a) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.$a = !0, await __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t) __PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.$a) {
        const e = [];
        let t = Promise.resolve();
        n.Oa.forEach(((r, i) => {
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then((() => (__PRIVATE_removeAndCleanupTarget(n, i), 
            __PRIVATE_localStoreReleaseTarget(n.localStore, i, 
            /*keepPersistedTargetData=*/ !0)))), __PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        })), await t, await __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), 
        // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = __PRIVATE_debugCast(e);
            t.Ba.forEach(((e, n) => {
                __PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            })), t.ka.wr(), t.Ba = new Map, t.La = new SortedMap(DocumentKey.comparator);
        }
        /**
 * Reconcile the query views of the provided query targets with the state from
 * persistence. Raises snapshots for any changes that affect the local
 * client and returns the updated state of all target's query data.
 *
 * @param syncEngine - The sync engine implementation
 * @param targets - the list of targets with views that need to be recomputed
 * @param transitionToPrimary - `true` iff the tab transitions from a secondary
 * tab to a primary tab
 */
        // PORTING NOTE: Multi-Tab only.
        (n), n.$a = !1, await __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}

async function __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t) {
        let t;
        const n = r.Oa.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await __PRIVATE_localStoreAllocateTarget(r.localStore, __PRIVATE_queryToTarget(n[0]));
            for (const e of n) {
                const t = r.xa.get(e), n = await __PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await __PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await __PRIVATE_localStoreAllocateTarget(r.localStore, n), await __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(n), e, 
            /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Ma.R_(s), i;
}

/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_synthesizeTargetToQuery(e) {
    return __PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}

/** Returns the IDs of the clients that are currently active. */
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return __PRIVATE_debugCast(__PRIVATE_debugCast(e).persistence).$i();
    }(__PRIVATE_debugCast(e).localStore);
}

/** Applies a query target change from a different tab. */
// PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = __PRIVATE_debugCast(e);
    if (i.$a) 
    // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void __PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.");
    const s = i.Oa.get(t);
    if (s && s.length > 0) switch (n) {
      case "current":
      case "not-current":
        {
            const e = await __PRIVATE_localStoreGetNewDocumentChanges(i.localStore, __PRIVATE_queryCollectionGroup(s[0])), r = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, ByteString.EMPTY_BYTE_STRING);
            await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
            break;
        }

      case "rejected":
        await __PRIVATE_localStoreReleaseTarget(i.localStore, t, 
        /* keepPersistedTargetData */ !0), __PRIVATE_removeAndCleanupTarget(i, t, r);
        break;

      default:
        fail();
    }
}

/** Adds or removes Watch targets for queries from different tabs. */ async function __PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = __PRIVATE_ensureWatchCallbacks(e);
    if (r.$a) {
        for (const e of t) {
            if (r.Oa.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                __PRIVATE_logDebug("SyncEngine", "Adding an already active target " + e);
                continue;
            }
            const t = await __PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await __PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(t), n.targetId, 
            /*current=*/ !1, n.resumeToken), __PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n) 
        // Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Oa.has(e) && 
        // Release queries that are still active.
        await __PRIVATE_localStoreReleaseTarget(r.localStore, e, 
        /* keepPersistedTargetData */ !1).then((() => {
            __PRIVATE_remoteStoreUnlisten(r.remoteStore, e), __PRIVATE_removeAndCleanupTarget(r, e);
        })).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}

function __PRIVATE_ensureWatchCallbacks(e) {
    const t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = __PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), 
    t.remoteStore.remoteSyncer.getRemoteKeysForTarget = __PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), 
    t.remoteStore.remoteSyncer.rejectListen = __PRIVATE_syncEngineRejectListen.bind(null, t), 
    t.Ma.R_ = __PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Ma.Wa = __PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), 
    t;
}

function __PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = __PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), 
    t.remoteStore.remoteSyncer.rejectFailedWrite = __PRIVATE_syncEngineRejectFailedWrite.bind(null, t), 
    t;
}

/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function __PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (
    /** Loads a bundle and returns the list of affected collection groups. */
    async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = __PRIVATE_debugCast(e), r = __PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e => n.jr.getBundleMetadata(e, t.id))).then((e => !!e && e.createTime.compareTo(r) >= 0));
            }
            /**
 * Saves the given `BundleMetadata` to local persistence.
 */ (e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress(__PRIVATE_bundleInitialProgress(r));
            const i = new __PRIVATE_BundleLoader(r, e.localStore, t.serializer);
            let s = await t.Ga();
            for (;s; ) {
                const e = await i.Pa(s);
                e && n._updateProgress(e), s = await t.Ga();
            }
            const o = await i.complete();
            return await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ea, 
            /* remoteEvent */ void 0), 
            // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = __PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e => n.jr.saveBundleMetadata(e, t)));
            }
            /**
 * Returns a promise of a `NamedQuery` associated with given query name. Promise
 * resolves to undefined if no persisted data can be found.
 */ (e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Ia);
        } catch (e) {
            return __PRIVATE_logWarn("SyncEngine", `Loading bundle failed with ${e}`), n._failWith(e), 
            Promise.resolve(new Set);
        }
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
    /**
 * Provides all components needed for Firestore with in-memory persistence.
 * Uses EagerGC garbage collection.
 */)(r, t, n).then((e => {
        r.sharedClientState.notifyBundleLoaded(e);
    }));
}

class __PRIVATE_MemoryOfflineComponentProvider {
    constructor() {
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = __PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.za(e), 
        this.persistence = this.ja(e), await this.persistence.start(), this.localStore = this.Ha(e), 
        this.gcScheduler = this.Ja(e, this.localStore), this.indexBackfillerScheduler = this.Ya(e, this.localStore);
    }
    Ja(e, t) {
        return null;
    }
    Ya(e, t) {
        return null;
    }
    Ha(e) {
        return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    ja(e) {
        return new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.ei, this.serializer);
    }
    za(e) {
        return new __PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), 
        this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}

__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: () => new __PRIVATE_MemoryOfflineComponentProvider
};

class __PRIVATE_LruGcMemoryOfflineComponentProvider extends __PRIVATE_MemoryOfflineComponentProvider {
    constructor(e) {
        super(), this.cacheSizeBytes = e;
    }
    Ja(e, t) {
        __PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof __PRIVATE_MemoryLruDelegate);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    ja(e) {
        const t = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
        return new __PRIVATE_MemoryPersistence((e => __PRIVATE_MemoryLruDelegate.ei(e, t)), this.serializer);
    }
}

/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class __PRIVATE_IndexedDbOfflineComponentProvider extends (/* unused pure expression or super */ null && (__PRIVATE_MemoryOfflineComponentProvider)) {
    constructor(e, t, n) {
        super(), this.Za = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", 
        this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Za.initialize(this, e), 
        // Enqueue writes from a previous session
        await __PRIVATE_syncEngineEnsureWriteCallbacks(this.Za.syncEngine), await __PRIVATE_fillWritePipeline(this.Za.remoteStore), 
        // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Si((() => (this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), 
        this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), 
        Promise.resolve())));
    }
    Ha(e) {
        return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Ja(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Ya(e, t) {
        const n = new __PRIVATE_IndexBackfiller(t, this.persistence);
        return new __PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    ja(e) {
        const t = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
        return new __PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, __PRIVATE_getWindow(), getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    za(e) {
        return new __PRIVATE_MemorySharedClientState;
    }
}

/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class __PRIVATE_MultiTabOfflineComponentProvider extends (/* unused pure expression or super */ null && (__PRIVATE_IndexedDbOfflineComponentProvider)) {
    constructor(e, t) {
        super(e, t, /* forceOwnership= */ !1), this.Za = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Za.syncEngine;
        this.sharedClientState instanceof __PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            io: __PRIVATE_syncEngineApplyBatchState.bind(null, t),
            so: __PRIVATE_syncEngineApplyTargetState.bind(null, t),
            oo: __PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            $i: __PRIVATE_syncEngineGetActiveClients.bind(null, t),
            ro: __PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), 
        // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Si((async e => {
            await __PRIVATE_syncEngineApplyPrimaryState(this.Za.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), 
            this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        }));
    }
    za(e) {
        const t = __PRIVATE_getWindow();
        if (!__PRIVATE_WebStorageSharedClientState.p(t)) throw new FirestoreError(D.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new __PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}

/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, 
        this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), 
        this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, 
        /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = e => __PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */), 
        this.remoteStore.remoteSyncer.handleCredentialChange = __PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), 
        await __PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new __PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = __PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new __PRIVATE_WebChannelConnection(e);
        }
        /** Return the Platform-specific connectivity monitor. */ (e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new __PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new __PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }
        /** Re-enables the network. Idempotent. */ (this.localStore, this.datastore, e.asyncQueue, (e => __PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */)), function __PRIVATE_newConnectivityMonitor() {
            return __PRIVATE_BrowserConnectivityMonitor.p() ? new __PRIVATE_BrowserConnectivityMonitor : new __PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, 
        // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new __PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.$a = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e, t;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = __PRIVATE_debugCast(e);
            __PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.k_.add(5 /* OfflineCause.Shutdown */), 
            await __PRIVATE_disableNetworkInternal(t), t.Q_.shutdown(), 
            // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.K_.set("Unknown" /* OnlineState.Unknown */);
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate(), 
        null === (t = this.eventManager) || void 0 === t || t.terminate();
    }
}

OnlineComponentProvider.provider = {
    build: () => new OnlineComponentProvider
};

/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */
function __PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read() {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel() {},
        releaseLock() {},
        closed: Promise.resolve()
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */
class __PRIVATE_AsyncObserver {
    constructor(e) {
        this.observer = e, 
        /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */
        this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.Xa(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Xa(this.observer.error, e) : __PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    eu() {
        this.muted = !0;
    }
    Xa(e, t) {
        setTimeout((() => {
            this.muted || e(t);
        }), 0);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class __PRIVATE_BundleReaderImpl {
    constructor(
    /** The reader to read from underlying binary bundle data source. */
    e, t) {
        this.tu = e, this.serializer = t, 
        /** Cached bundle metadata. */
        this.metadata = new __PRIVATE_Deferred, 
        /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */
        this.buffer = new Uint8Array, this.nu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), 
        // Read the metadata (which is the first element).
        this.ru().then((e => {
            e && e.la() ? this.metadata.resolve(e.ca.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.ca)}`));
        }), (e => this.metadata.reject(e)));
    }
    close() {
        return this.tu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Ga() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.ru();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */    async ru() {
        const e = await this.iu();
        if (null === e) return null;
        const t = this.nu.decode(e), n = Number(t);
        isNaN(n) && this.su(`length string (${t}) is not valid number`);
        const r = await this.ou(n);
        return new __PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */    _u() {
        return this.buffer.findIndex((e => e === "{".charCodeAt(0)));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */    async iu() {
        for (;this._u() < 0; ) {
            if (await this.au()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
                if (0 === this.buffer.length) return null;
        const e = this._u();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
                e < 0 && this.su("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
                return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */    async ou(e) {
        for (;this.buffer.length < e; ) {
            await this.au() && this.su("Reached the end of bundle when more is expected.");
        }
        const t = this.nu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
                return this.buffer = this.buffer.slice(e), t;
    }
    su(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.tu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */    async au() {
        const e = await this.tu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */
class Transaction$2 {
    constructor(e) {
        this.datastore = e, 
        // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, 
        /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */
        this.lastTransactionError = null, 
        /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */
        this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new FirestoreError(D.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), 
        this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = __PRIVATE_debugCast(e), r = {
                documents: t.map((e => __PRIVATE_toName(n.serializer, e)))
            }, i = await n.ko("BatchGetDocuments", n.serializer.databaseId, ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e => {
                const t = __PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            }));
            const o = [];
            return t.forEach((e => {
                const t = s.get(e.toString());
                __PRIVATE_hardAssert(!!t), o.push(t);
            })), o;
        }(this.datastore, e);
        return t.forEach((e => this.recordVersion(e))), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new __PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
                this.mutations.forEach((t => {
            e.delete(t.key.toString());
        })), 
        // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach(((e, t) => {
            const n = DocumentKey.fromPath(t);
            this.mutations.push(new __PRIVATE_VerifyMutation(n, this.precondition(n)));
        })), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = __PRIVATE_debugCast(e), r = {
                writes: t.map((e => toMutation(n.serializer, e)))
            };
            await n.Oo("Commit", n.serializer.databaseId, ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version; else {
            if (!e.isNoDocument()) throw fail();
            // Represent a deleted doc using SnapshotVersion.min().
            t = SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) 
            // This transaction will fail no matter what.
            throw new FirestoreError(D.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */    precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual(SnapshotVersion.min()) ? Precondition.exists(!1) : Precondition.updateTime(t) : Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */    preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
                if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual(SnapshotVersion.min())) 
            // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new FirestoreError(D.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
                        return Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class __PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i) {
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, 
        this.deferred = i, this.uu = n.maxAttempts, this.r_ = new __PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */);
    }
    /** Runs the transaction and sets the result on deferred. */    cu() {
        this.uu -= 1, this.lu();
    }
    lu() {
        this.r_.jo((async () => {
            const e = new Transaction$2(this.datastore), t = this.hu(e);
            t && t.then((t => {
                this.asyncQueue.enqueueAndForget((() => e.commit().then((() => {
                    this.deferred.resolve(t);
                })).catch((e => {
                    this.Pu(e);
                }))));
            })).catch((e => {
                this.Pu(e);
            }));
        }));
    }
    hu(e) {
        try {
            const t = this.updateFunction(e);
            return !__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), 
            null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Pu(e) {
        this.uu > 0 && this.Tu(e) ? (this.uu -= 1, this.asyncQueue.enqueueAndForget((() => (this.lu(), 
        Promise.resolve())))) : this.deferred.reject(e);
    }
    Tu(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */
class FirestoreClient {
    constructor(e, t, 
    /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */
    n, r, i) {
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, 
        this.user = User.UNAUTHENTICATED, this.clientId = __PRIVATE_AutoId.newId(), this.authCredentialListener = () => Promise.resolve(), 
        this.appCheckCredentialListener = () => Promise.resolve(), this._uninitializedComponentsProvider = i, 
        this.authCredentials.start(n, (async e => {
            __PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), 
            this.user = e;
        })), this.appCheckCredentials.start(n, (e => (__PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), 
        this.appCheckCredentialListener(e, this.user))));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new __PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted((async () => {
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), 
                // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = __PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        })), e.promise;
    }
}

async function __PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener((async e => {
        r.isEqual(e) || (await __PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    })), 
    // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener((() => e.terminate())), e._offlineComponents = t;
}

async function __PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await __PRIVATE_ensureOfflineComponents(e);
    __PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), 
    // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e => __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e))), 
    e.setAppCheckTokenChangeListener(((e, n) => __PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n))), 
    e._onlineComponents = t;
}

/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function __PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) if (e._uninitializedComponentsProvider) {
        __PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
        try {
            await __PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
        } catch (t) {
            const n = t;
            if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                return "FirebaseError" === e.name ? e.code === D.FAILED_PRECONDITION || e.code === D.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || 
                // When the browser is out of quota we could get either quota exceeded
                // or an aborted error depending on whether the error happened during
                // schema migration.
                22 === e.code || 20 === e.code || 
                // Firefox Private Browsing mode disables IndexedDb and returns
                // INVALID_STATE for any usage.
                11 === e.code;
            }(n)) throw n;
            __PRIVATE_logWarn("Error using user provided cache. Falling back to memory cache: " + n), 
            await __PRIVATE_setOfflineComponentProvider(e, new __PRIVATE_MemoryOfflineComponentProvider);
        }
    } else __PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider"), 
    await __PRIVATE_setOfflineComponentProvider(e, new __PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    return e._offlineComponents;
}

async function __PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? (__PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider"), 
    await __PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : (__PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider"), 
    await __PRIVATE_setOnlineComponentProvider(e, new OnlineComponentProvider))), e._onlineComponents;
}

function __PRIVATE_getPersistence(e) {
    return __PRIVATE_ensureOfflineComponents(e).then((e => e.persistence));
}

function __PRIVATE_getLocalStore(e) {
    return __PRIVATE_ensureOfflineComponents(e).then((e => e.localStore));
}

function __PRIVATE_getRemoteStore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then((e => e.remoteStore));
}

function __PRIVATE_getSyncEngine(e) {
    return __PRIVATE_ensureOnlineComponents(e).then((e => e.syncEngine));
}

function __PRIVATE_getDatastore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then((e => e.datastore));
}

async function __PRIVATE_getEventManager(e) {
    const t = await __PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = __PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = __PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), 
    n.onFirstRemoteStoreListen = __PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), 
    n.onLastRemoteStoreUnlisten = __PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), 
    n;
}

/** Enables the network connection and re-enqueues all pending operations. */ function __PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue((async () => {
        const t = await __PRIVATE_getPersistence(e), n = await __PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = __PRIVATE_debugCast(e);
            return t.k_.delete(0 /* OfflineCause.UserDisabled */), __PRIVATE_enableNetworkInternal(t);
        }(n);
    }));
}

/** Disables the network connection. Pending operations will not complete. */ function __PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue((async () => {
        const t = await __PRIVATE_getPersistence(e), n = await __PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = __PRIVATE_debugCast(e);
            t.k_.add(0 /* OfflineCause.UserDisabled */), await __PRIVATE_disableNetworkInternal(t), 
            // Set the OnlineState to Offline so get()s return from cache, etc.
            t.K_.set("Offline" /* OnlineState.Offline */);
        }(n);
    }));
}

/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function __PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget((async () => async function __PRIVATE_readDocumentFromCache(e, t, n) {
        try {
            const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                const n = __PRIVATE_debugCast(e);
                return n.persistence.runTransaction("read document", "readonly", (e => n.localDocuments.getDocument(e, t)));
            }(e, t);
            r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new FirestoreError(D.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
        } catch (e) {
            const r = __PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
            n.reject(r);
        }
    }
    /**
 * Retrieves a latency-compensated document from the backend via a
 * SnapshotListener.
 */ (await __PRIVATE_getLocalStore(e), t, n))), n.promise;
}

function __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget((async () => function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
        const s = new __PRIVATE_AsyncObserver({
            next: _ => {
                // Mute and remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                s.eu(), t.enqueueAndForget((() => __PRIVATE_eventManagerUnlisten(e, o)));
                const a = _.docs.has(n);
                !a && _.fromCache ? 
                // TODO(dimond): If we're online and the document doesn't
                // exist then we resolve with a doc.exists set to false. If
                // we're offline however, we reject the Promise in this
                // case. Two options: 1) Cache the negative response from
                // the server so we can deliver that even when you're
                // offline 2) Actually reject the Promise in the online case
                // if the document doesn't exist.
                i.reject(new FirestoreError(D.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new FirestoreError(D.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
            },
            error: e => i.reject(e)
        }), o = new __PRIVATE_QueryListener(__PRIVATE_newQueryForPath(n.path), s, {
            includeMetadataChanges: !0,
            ua: !0
        });
        return __PRIVATE_eventManagerListen(e, o);
    }(await __PRIVATE_getEventManager(e), e.asyncQueue, t, n, r))), r.promise;
}

function __PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget((async () => async function __PRIVATE_executeQueryFromCache(e, t, n) {
        try {
            const r = await __PRIVATE_localStoreExecuteQuery(e, t, 
            /* usePreviousResults= */ !0), i = new __PRIVATE_View(t, r.ds), s = i.ga(r.documents), o = i.applyChanges(s, 
            /* limboResolutionEnabled= */ !1);
            n.resolve(o.snapshot);
        } catch (e) {
            const r = __PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
            n.reject(r);
        }
    }
    /**
 * Retrieves a latency-compensated query snapshot from the backend via a
 * SnapshotListener.
 */ (await __PRIVATE_getLocalStore(e), t, n))), n.promise;
}

function __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget((async () => function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
        const s = new __PRIVATE_AsyncObserver({
            next: n => {
                // Mute and remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                s.eu(), t.enqueueAndForget((() => __PRIVATE_eventManagerUnlisten(e, o))), n.fromCache && "server" === r.source ? i.reject(new FirestoreError(D.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
            },
            error: e => i.reject(e)
        }), o = new __PRIVATE_QueryListener(n, s, {
            includeMetadataChanges: !0,
            ua: !0
        });
        return __PRIVATE_eventManagerListen(e, o);
    }(await __PRIVATE_getEventManager(e), e.asyncQueue, t, n, r))), r.promise;
}

function __PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget((async () => {
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await __PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = __PRIVATE_debugCast(e), {request: s, lt: o, parent: _} = __PRIVATE_toRunAggregationQueryRequest(i.serializer, __PRIVATE_queryToAggregateTarget(t), n);
                i.connection.Co || delete s.parent;
                const a = (await i.ko("RunAggregationQuery", i.serializer.databaseId, _, s, 
                /*expectedResponseCount=*/ 1)).filter((e => !!e.result));
                // Omit RunAggregationQueryResponse that only contain readTimes.
                                __PRIVATE_hardAssert(1 === a.length);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce(((e, t) => (e[o[t]] = u[t], e)), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    })), r.promise;
}

function __PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new __PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget((async () => function __PRIVATE_addSnapshotsInSyncListener(e, t) {
        __PRIVATE_debugCast(e).X_.add(t), 
        // Immediately fire an initial event, indicating all existing listeners
        // are in-sync.
        t.next();
    }(await __PRIVATE_getEventManager(e), n))), () => {
        n.eu(), e.asyncQueue.enqueueAndForget((async () => function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
            __PRIVATE_debugCast(e).X_.delete(t);
        }(await __PRIVATE_getEventManager(e), n)));
    };
}

/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function __PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? __PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new __PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return __PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return __PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, __PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget((async () => {
        __PRIVATE_syncEngineLoadBundle(await __PRIVATE_getSyncEngine(e), i, r);
    }));
}

function __PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue((async () => function __PRIVATE_localStoreGetNamedQuery(e, t) {
        const n = __PRIVATE_debugCast(e);
        return n.persistence.runTransaction("Get named query", "readonly", (e => n.jr.getNamedQuery(e, t)));
    }(await __PRIVATE_getLocalStore(e), t)));
}

function __PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue((async () => async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
        const n = __PRIVATE_debugCast(e), r = n.indexManager, i = [];
        return n.persistence.runTransaction("Configure indexes", "readwrite", (e => r.getFieldIndexes(e).next((n => 
        /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
        /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */
        function __PRIVATE_diffArrays(e, t, n, r, i) {
            e = [ ...e ], t = [ ...t ], e.sort(n), t.sort(n);
            const s = e.length, o = t.length;
            let _ = 0, a = 0;
            for (;_ < o && a < s; ) {
                const s = n(e[a], t[_]);
                s < 0 ? 
                // The element was removed if the next element in our ordered
                // walkthrough is only in `before`.
                i(e[a++]) : s > 0 ? 
                // The element was added if the next element in our ordered walkthrough
                // is only in `after`.
                r(t[_++]) : (_++, a++);
            }
            for (;_ < o; ) r(t[_++]);
            for (;a < s; ) i(e[a++]);
        }
        /**
 * Verifies equality for an array of primitives.
 *
 * @private
 * @internal
 * @param left Array of primitives.
 * @param right Array of primitives.
 * @return True if arrays are equal.
 */ (n, t, __PRIVATE_fieldIndexSemanticComparator, (t => {
            i.push(r.addFieldIndex(e, t));
        }), (t => {
            i.push(r.deleteFieldIndex(e, t));
        })))).next((() => PersistencePromise.waitFor(i)))));
    }(await __PRIVATE_getLocalStore(e), t)));
}

function __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue((async () => function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
        __PRIVATE_debugCast(e)._s.Hi = t;
    }(await __PRIVATE_getLocalStore(e), t)));
}

function __PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue((async () => function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
        const t = __PRIVATE_debugCast(e), n = t.indexManager;
        return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e => n.deleteAllFieldIndexes(e)));
    }
    /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
    // The format of the LocalStorage key that stores the client state is:
    //     firestore_clients_<persistence_prefix>_<instance_key>
    (await __PRIVATE_getLocalStore(e))));
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */
/**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */
function __PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const we = new Map;

/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}

/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function __PRIVATE_validateIsNotUsedTogether(e, t, n, r) {
    if (!0 === t && !0 === r) throw new FirestoreError(D.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}

/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function __PRIVATE_validateDocumentPath(e) {
    if (!DocumentKey.isDocumentKey(e)) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}

/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function __PRIVATE_validateCollectionPath(e) {
    if (DocumentKey.isDocumentKey(e)) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}

/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */
/** Returns a string describing the type / value of the provided input. */
function __PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), 
    JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = 
            /** try to get the constructor name for an object. */
            function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }
            /**
 * Casts `obj` to `T`, optionally unwrapping Compat types to expose the
 * underlying instance. Throws if  `obj` is not an instance of `T`.
 *
 * This cast is used in the Lite and Full SDK to verify instance types for
 * arguments passed to the public API.
 * @internal
 */ (e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : fail();
}

function __PRIVATE_cast(e, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && (
    // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new FirestoreError(D.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = __PRIVATE_valueDescription(e);
            throw new FirestoreError(D.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}

function __PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */
class FirestoreSettingsImpl {
    constructor(e) {
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new FirestoreError(D.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, 
        this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040; else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new FirestoreError(D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        __PRIVATE_validateIsNotUsedTogether("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), 
        this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : 
        // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, 
        this.experimentalLongPollingOptions = __PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), 
        function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new FirestoreError(D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new FirestoreError(D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new FirestoreError(D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
        /**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ (this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}

class Firestore$1 {
    /** @hideconstructor */
    constructor(e, t, n, r) {
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, 
        this._app = r, 
        /**
         * Whether it's a Firestore or Firestore Lite instance.
         */
        this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new FirestoreSettingsImpl({}), 
        this._settingsFrozen = !1, 
        // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */    get app() {
        if (!this._app) throw new FirestoreError(D.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new FirestoreError(D.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new __PRIVATE_EmptyAuthCredentialsProvider;
            switch (e.type) {
              case "firstParty":
                return new __PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);

              case "provider":
                return e.client;

              default:
                throw new FirestoreError(D.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), 
        this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */    toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */    _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */
        return function __PRIVATE_removeComponents(e) {
            const t = we.get(e);
            t && (__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), we.delete(e), 
            t.terminate());
        }(this), Promise.resolve();
    }
}

/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function connectFirestoreEmulator(e, t, n, r = {}) {
    var i;
    const s = (e = __PRIVATE_cast(e, Firestore$1))._getSettings(), o = `${t}:${n}`;
    if ("firestore.googleapis.com" !== s.host && s.host !== o && __PRIVATE_logWarn("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), 
    e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = User.MOCK_USER; else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0,dist_index_esm2017/* createMockUserToken */.Sg)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new FirestoreError(D.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new User(s);
        }
        e._authCredentials = new __PRIVATE_EmulatorAuthCredentialsProvider(new __PRIVATE_OAuthToken(t, n));
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class Query {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */
    constructor(e, 
    /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */
    t, n) {
        this.converter = t, this._query = n, 
        /** The type of this Firestore reference. */
        this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new Query(this.firestore, e, this._query);
    }
}

/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class DocumentReference {
    /** @hideconstructor */
    constructor(e, 
    /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */
    t, n) {
        this.converter = t, this._key = n, 
        /** The type of this Firestore reference. */
        this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */    get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */    get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */    get parent() {
        return new CollectionReference(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new DocumentReference(this.firestore, e, this._key);
    }
}

/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class CollectionReference extends Query {
    /** @hideconstructor */
    constructor(e, t, n) {
        super(e, t, __PRIVATE_newQueryForPath(n)), this._path = n, 
        /** The type of this Firestore reference. */
        this.type = "collection";
    }
    /** The collection's identifier. */    get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */    get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */    get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new DocumentReference(this.firestore, 
        /* converter= */ null, new DocumentKey(e));
    }
    withConverter(e) {
        return new CollectionReference(this.firestore, e, this._path);
    }
}

function collection(e, t, ...n) {
    if (e = (0,dist_index_esm2017/* getModularInstance */.m9)(e), __PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof Firestore$1) {
        const r = ResourcePath.fromString(t, ...n);
        return __PRIVATE_validateCollectionPath(r), new CollectionReference(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof DocumentReference || e instanceof CollectionReference)) throw new FirestoreError(D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child(ResourcePath.fromString(t, ...n));
        return __PRIVATE_validateCollectionPath(r), new CollectionReference(e.firestore, 
        /* converter= */ null, r);
    }
}

// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function collectionGroup(e, t) {
    if (e = __PRIVATE_cast(e, Firestore$1), __PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), 
    t.indexOf("/") >= 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new Query(e, 
    /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new __PRIVATE_QueryImpl(ResourcePath.emptyPath(), e);
    }(t));
}

function doc(e, t, ...n) {
    if (e = getModularInstance(e), 
    // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = __PRIVATE_AutoId.newId()), __PRIVATE_validateNonEmptyArgument("doc", "path", t), 
    e instanceof Firestore$1) {
        const r = ResourcePath.fromString(t, ...n);
        return __PRIVATE_validateDocumentPath(r), new DocumentReference(e, 
        /* converter= */ null, new DocumentKey(r));
    }
    {
        if (!(e instanceof DocumentReference || e instanceof CollectionReference)) throw new FirestoreError(D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child(ResourcePath.fromString(t, ...n));
        return __PRIVATE_validateDocumentPath(r), new DocumentReference(e.firestore, e instanceof CollectionReference ? e.converter : null, new DocumentKey(r));
    }
}

/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function refEqual(e, t) {
    return e = getModularInstance(e), t = getModularInstance(t), (e instanceof DocumentReference || e instanceof CollectionReference) && (t instanceof DocumentReference || t instanceof CollectionReference) && (e.firestore === t.firestore && e.path === t.path && e.converter === t.converter);
}

/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function queryEqual(e, t) {
    return e = getModularInstance(e), t = getModularInstance(t), e instanceof Query && t instanceof Query && (e.firestore === t.firestore && __PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()) {
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Iu = [], 
        // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Eu = !1, 
        // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.du = [], 
        // visible for testing
        this.Au = null, 
        // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Ru = !1, 
        // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Vu = !1, 
        // List of TimerIds to fast-forward delays for.
        this.mu = [], 
        // Backoff timer used to schedule retries for retryable operations
        this.r_ = new __PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */), 
        // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.fu = () => {
            const e = getDocument();
            e && __PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), 
            this.r_.Jo();
        }, this.gu = e;
        const t = getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.fu);
    }
    get isShuttingDown() {
        return this.Eu;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */    enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.pu(), 
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.yu(e);
    }
    enterRestrictedMode(e) {
        if (!this.Eu) {
            this.Eu = !0, this.Vu = e || !1;
            const t = getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.fu);
        }
    }
    enqueue(e) {
        if (this.pu(), this.Eu) 
        // Return a Promise which never resolves.
        return new Promise((() => {}));
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
                const t = new __PRIVATE_Deferred;
        return this.yu((() => this.Eu && this.Vu ? Promise.resolve() : (e().then(t.resolve, t.reject), 
        t.promise))).then((() => t.promise));
    }
    enqueueRetryable(e) {
        this.enqueueAndForget((() => (this.Iu.push(e), this.wu())));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */    async wu() {
        if (0 !== this.Iu.length) {
            try {
                await this.Iu[0](), this.Iu.shift(), this.r_.reset();
            } catch (e) {
                if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
 // Failure will be handled by AsyncQueue
                                __PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
            }
            this.Iu.length > 0 && 
            // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.r_.jo((() => this.wu()));
        }
    }
    yu(e) {
        const t = this.gu.then((() => (this.Ru = !0, e().catch((e => {
            this.Au = e, this.Ru = !1;
            const t = 
            /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */
            function __PRIVATE_getMessageOrStack(e) {
                let t = e.message || "";
                e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                return t;
            }
            /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (e);
            // Re-throw the error so that this.tail becomes a rejected Promise and
            // all further attempts to chain (via .then) will just short-circuit
            // and return the rejected Promise.
            throw __PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
        })).then((e => (this.Ru = !1, e))))));
        return this.gu = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.pu(), 
        // Fast-forward delays for timerIds that have been overridden.
        this.mu.indexOf(e) > -1 && (t = 0);
        const r = DelayedOperation.createAndSchedule(this, e, t, n, (e => this.Su(e)));
        return this.du.push(r), r;
    }
    pu() {
        this.Au && fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */    async bu() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do {
            e = this.gu, await e;
        } while (e !== this.gu);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */    Du(e) {
        for (const t of this.du) if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */    vu(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.bu().then((() => {
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
            this.du.sort(((e, t) => e.targetTimeMs - t.targetTimeMs));
            for (const t of this.du) if (t.skipDelay(), "all" /* TimerId.All */ !== e && t.timerId === e) break;
            return this.bu();
        }));
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */    Cu(e) {
        this.mu.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */    Su(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.du.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */        this.du.splice(t, 1);
    }
}

function __PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
    return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t) if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
    /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ (e, [ "next", "error", "complete" ]);
}

class LoadBundleTask {
    constructor() {
        this._progressObserver = {}, this._taskCompletionResolver = new __PRIVATE_Deferred, 
        this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */    onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */    catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */    then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */    _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), 
        this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */    _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), 
        this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */    _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const Se = (/* unused pure expression or super */ null && (-1));

/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class Firestore extends Firestore$1 {
    /** @hideconstructor */
    constructor(e, t, n, r) {
        super(e, t, n, r), 
        /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */
        this.type = "firestore", this._queue = new __PRIVATE_AsyncQueueImpl, this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new __PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}

/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function initializeFirestore(e, t, n) {
    n || (n = "(default)");
    const r = _getProvider(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if (deepEqual(i, t)) return e;
        throw new FirestoreError(D.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new FirestoreError(D.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new FirestoreError(D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}

function getFirestore(t, n) {
    const r = "object" == typeof t ? t : (0,index_esm2017/* getApp */.Mq)(), i = "string" == typeof t ? t : n || "(default)", s = (0,index_esm2017/* _getProvider */.qX)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0,dist_index_esm2017/* getDefaultEmulatorHostnameAndPort */.P0)("firestore");
        e && connectFirestoreEmulator(s, ...e);
    }
    return s;
}

/**
 * @internal
 */ function ensureFirestoreConfigured(e) {
    if (e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || __PRIVATE_configureFirestore(e), e._firestoreClient;
}

function __PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, __PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._componentsProvider || (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._componentsProvider = {
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    }), e._firestoreClient = new FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = null == e ? void 0 : e._online.build();
        return {
            _offline: null == e ? void 0 : e._offline.build(t),
            _online: t
        };
    }
    /**
 * Attempts to enable persistent storage, if possible.
 *
 * On failure, `enableIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * Note: `enableIndexedDbPersistence()` must be called before any other functions
 * (other than {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ (e._componentsProvider));
}

function enableIndexedDbPersistence(e, t) {
    __PRIVATE_logWarn("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return __PRIVATE_setPersistenceProviders(e, OnlineComponentProvider.provider, {
        build: e => new __PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, null == t ? void 0 : t.forceOwnership)
    }), Promise.resolve();
}

/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function enableMultiTabIndexedDbPersistence(e) {
    __PRIVATE_logWarn("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    __PRIVATE_setPersistenceProviders(e, OnlineComponentProvider.provider, {
        build: e => new __PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}

/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function __PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = __PRIVATE_cast(e, Firestore))._firestoreClient || e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new FirestoreError(D.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, __PRIVATE_configureFirestore(e);
}

/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function clearIndexedDbPersistence(e) {
    if (e._initialized && !e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new __PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted((async () => {
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!__PRIVATE_SimpleDb.p()) return Promise.resolve();
                const t = e + "main";
                await __PRIVATE_SimpleDb.delete(t);
            }(__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    })), t.promise;
}

/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function waitForPendingWrites(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget((async () => __PRIVATE_syncEngineRegisterPendingWritesCallback(await __PRIVATE_getSyncEngine(e), t))), 
        t.promise;
    }(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}

/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function enableNetwork(e) {
    return __PRIVATE_firestoreClientEnableNetwork(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}

/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function disableNetwork(e) {
    return __PRIVATE_firestoreClientDisableNetwork(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}

/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function terminate(e) {
    return _removeServiceInstance(e.app, "firestore", e._databaseId.database), e._delete();
}

/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function loadBundle(e, t) {
    const n = ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), r = new LoadBundleTask;
    return __PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}

/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function namedQuery(e, t) {
    return __PRIVATE_firestoreClientGetNamedQuery(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), t).then((t => t ? new Query(e, null, t.query) : null));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents an aggregation that can be performed by Firestore.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class AggregateField {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */
    constructor(e = "count", t) {
        this._internalFieldPath = t, 
        /** A type string to uniquely identify instances of this class. */
        this.type = "AggregateField", this.aggregateType = e;
    }
}

/**
 * The results of executing an aggregation query.
 */ class AggregateQuerySnapshot {
    /** @hideconstructor */
    constructor(e, t, n) {
        this._userDataWriter = t, this._data = n, 
        /** A type string to uniquely identify instances of this class. */
        this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */    data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing an array of bytes.
 */ class Bytes {
    /** @hideconstructor */
    constructor(e) {
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */    static fromBase64String(e) {
        try {
            return new Bytes(ByteString.fromBase64String(e));
        } catch (e) {
            throw new FirestoreError(D.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */    static fromUint8Array(e) {
        return new Bytes(ByteString.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */    toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */    toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */    toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */    isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class FieldPath {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */
    constructor(...e) {
        for (let t = 0; t < e.length; ++t) if (0 === e[t].length) throw new FirestoreError(D.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new FieldPath$1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */    isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}

/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function documentId() {
    return new FieldPath("__name__");
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class FieldValue {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */
    constructor(e) {
        this._methodName = e;
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class GeoPoint {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */
    constructor(e, t) {
        if (!isFinite(e) || e < -90 || e > 90) throw new FirestoreError(D.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new FirestoreError(D.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */    get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */    get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */    isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */    toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */    _compareTo(e) {
        return __PRIVATE_primitiveComparator(this._lat, e._lat) || __PRIVATE_primitiveComparator(this._long, e._long);
    }
}

/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a vector type in Firestore documents.
 * Create an instance with {@link FieldValue.vector}.
 *
 * @class VectorValue
 */ class VectorValue {
    /**
     * @private
     * @internal
     */
    constructor(e) {
        // Making a copy of the parameter.
        this._values = (e || []).map((e => e));
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */    toArray() {
        return this._values.map((e => e));
    }
    /**
     * Returns `true` if the two VectorValue has the same raw number arrays, returns `false` otherwise.
     */    isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for (let n = 0; n < e.length; ++n) if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const be = /^__.*__$/;

/** The result of parsing document data (e.g. for a setData call). */ class ParsedSetData {
    constructor(e, t, n) {
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new __PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}

/** The result of parsing "update" data (i.e. for an updateData call). */ class ParsedUpdateData {
    constructor(e, 
    // The fieldMask does not include document transforms.
    t, n) {
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}

function __PRIVATE_isWrite(e) {
    switch (e) {
      case 0 /* UserDataSource.Set */ :
 // fall through
              case 2 /* UserDataSource.MergeSet */ :
 // fall through
              case 1 /* UserDataSource.Update */ :
        return !0;

      case 3 /* UserDataSource.Argument */ :
      case 4 /* UserDataSource.ArrayArgument */ :
        return !1;

      default:
        throw fail();
    }
}

/** A "context" object passed around while parsing user data. */ class __PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */
    constructor(e, t, n, r, i, s) {
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, 
        // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Fu(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Mu() {
        return this.settings.Mu;
    }
    /** Returns a new context with the specified settings overwritten. */    xu(e) {
        return new __PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    Ou(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.xu({
            path: n,
            Nu: !1
        });
        return r.Lu(e), r;
    }
    Bu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.xu({
            path: n,
            Nu: !1
        });
        return r.Fu(), r;
    }
    ku(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.xu({
            path: void 0,
            Nu: !0
        });
    }
    qu(e) {
        return __PRIVATE_createError(e, this.settings.methodName, this.settings.Qu || !1, this.path, this.settings.Ku);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */    contains(e) {
        return void 0 !== this.fieldMask.find((t => e.isPrefixOf(t))) || void 0 !== this.fieldTransforms.find((t => e.isPrefixOf(t.field)));
    }
    Fu() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for (let e = 0; e < this.path.length; e++) this.Lu(this.path.get(e));
    }
    Lu(e) {
        if (0 === e.length) throw this.qu("Document fields must not be empty");
        if (__PRIVATE_isWrite(this.Mu) && be.test(e)) throw this.qu('Document fields cannot begin and end with "__"');
    }
}

/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class __PRIVATE_UserDataReader {
    constructor(e, t, n) {
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || __PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */    $u(e, t, n, r = !1) {
        return new __PRIVATE_ParseContextImpl({
            Mu: e,
            methodName: t,
            Ku: n,
            path: FieldPath$1.emptyPath(),
            Nu: !1,
            Qu: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}

function __PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = __PRIVATE_newSerializer(e._databaseId);
    return new __PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}

/** Parse document data from a set() call. */ function __PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.$u(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */ : 0 /* UserDataSource.Set */ , t, n, i);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = __PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new FieldMask(o.fieldMask), u = o.fieldTransforms; else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields) {
            const i = __PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new FirestoreError(D.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            __PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new FieldMask(e), u = o.fieldTransforms.filter((e => a.covers(e.field)));
    } else a = null, u = o.fieldTransforms;
    return new ParsedSetData(new ObjectValue(_), a, u);
}

class __PRIVATE_DeleteFieldValueImpl extends FieldValue {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */ !== e.Mu) throw 1 /* UserDataSource.Update */ === e.Mu ? e.qu(`${this._methodName}() can only appear at the top level of your update data`) : e.qu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof __PRIVATE_DeleteFieldValueImpl;
    }
}

/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function __PRIVATE_createSentinelChildContext(e, t, n) {
    return new __PRIVATE_ParseContextImpl({
        Mu: 3 /* UserDataSource.Argument */ ,
        Ku: t.settings.Ku,
        methodName: e._methodName,
        Nu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}

class __PRIVATE_ServerTimestampFieldValueImpl extends (/* unused pure expression or super */ null && (FieldValue)) {
    _toFieldTransform(e) {
        return new FieldTransform(e.path, new __PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_ServerTimestampFieldValueImpl;
    }
}

class __PRIVATE_ArrayUnionFieldValueImpl extends (/* unused pure expression or super */ null && (FieldValue)) {
    constructor(e, t) {
        super(e), this.Uu = t;
    }
    _toFieldTransform(e) {
        const t = __PRIVATE_createSentinelChildContext(this, e, 
        /*array=*/ !0), n = this.Uu.map((e => __PRIVATE_parseData(e, t))), r = new __PRIVATE_ArrayUnionTransformOperation(n);
        return new FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_ArrayUnionFieldValueImpl && deepEqual(this.Uu, e.Uu);
    }
}

class __PRIVATE_ArrayRemoveFieldValueImpl extends (/* unused pure expression or super */ null && (FieldValue)) {
    constructor(e, t) {
        super(e), this.Uu = t;
    }
    _toFieldTransform(e) {
        const t = __PRIVATE_createSentinelChildContext(this, e, 
        /*array=*/ !0), n = this.Uu.map((e => __PRIVATE_parseData(e, t))), r = new __PRIVATE_ArrayRemoveTransformOperation(n);
        return new FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_ArrayRemoveFieldValueImpl && deepEqual(this.Uu, e.Uu);
    }
}

class __PRIVATE_NumericIncrementFieldValueImpl extends (/* unused pure expression or super */ null && (FieldValue)) {
    constructor(e, t) {
        super(e), this.Wu = t;
    }
    _toFieldTransform(e) {
        const t = new __PRIVATE_NumericIncrementTransformOperation(e.serializer, toNumber(e.serializer, this.Wu));
        return new FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_NumericIncrementFieldValueImpl && this.Wu === e.Wu;
    }
}

/** Parse update data from an update() call. */ function __PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.$u(1 /* UserDataSource.Update */ , t, n);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = ObjectValue.empty();
    forEach(r, ((e, r) => {
        const _ = __PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
                r = (0,dist_index_esm2017/* getModularInstance */.m9)(r);
        const a = i.Bu(_);
        if (r instanceof __PRIVATE_DeleteFieldValueImpl) 
        // Add it to the field mask, but don't add anything to updateData.
        s.push(_); else {
            const e = __PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    }));
    const _ = new FieldMask(s);
    return new ParsedUpdateData(o, _, i.fieldTransforms);
}

/** Parse update data from a list of field/value arguments. */ function __PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.$u(1 /* UserDataSource.Update */ , t, n), _ = [ __PRIVATE_fieldPathFromArgument$1(t, r, n) ], a = [ i ];
    if (s.length % 2 != 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for (let e = 0; e < s.length; e += 2) _.push(__PRIVATE_fieldPathFromArgument$1(t, s[e])), 
    a.push(s[e + 1]);
    const u = [], c = ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for (let e = _.length - 1; e >= 0; --e) if (!__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
                n = (0,dist_index_esm2017/* getModularInstance */.m9)(n);
        const r = o.Bu(t);
        if (n instanceof __PRIVATE_DeleteFieldValueImpl) 
        // Add it to the field mask, but don't add anything to updateData.
        u.push(t); else {
            const e = __PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new FieldMask(u);
    return new ParsedUpdateData(c, l, o.fieldTransforms);
}

/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function __PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return __PRIVATE_parseData(n, e.$u(r ? 4 /* UserDataSource.ArrayArgument */ : 3 /* UserDataSource.Argument */ , t));
}

/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function __PRIVATE_parseData(e, t) {
    if (__PRIVATE_looksLikeJsonObject(
    // Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0,dist_index_esm2017/* getModularInstance */.m9)(e))) return __PRIVATE_validatePlainObject("Unsupported field value:", t, e), 
    __PRIVATE_parseObject(e, t);
    if (e instanceof FieldValue) 
    // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */
    return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!__PRIVATE_isWrite(t.Mu)) throw t.qu(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.qu(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }
    /**
 * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
 *
 * @returns The parsed value
 */ (e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) 
    // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (
    // If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.Nu && 4 /* UserDataSource.ArrayArgument */ !== t.Mu) throw t.qu("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e) {
                let e = __PRIVATE_parseData(i, t.ku(r));
                null == e && (
                // Just include nulls in the array for fields being replaced with a
                // sentinel.
                e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0,dist_index_esm2017/* getModularInstance */.m9)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = Timestamp.fromDate(e);
            return {
                timestampValue: toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new Timestamp(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof GeoPoint) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof Bytes) return {
            bytesValue: __PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof DocumentReference) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.qu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: __PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof VectorValue) 
        /**
 * Creates a new VectorValue proto value (using the internal format).
 */
        return function __PRIVATE_parseVectorValue(e, t) {
            return {
                mapValue: {
                    fields: {
                        __type__: {
                            stringValue: "__vector__"
                        },
                        value: {
                            arrayValue: {
                                values: e.toArray().map((e => {
                                    if ("number" != typeof e) throw t.qu("VectorValues must only contain numeric values.");
                                    return __PRIVATE_toDouble(t.serializer, e);
                                }))
                            }
                        }
                    }
                }
            };
        }
        /**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */ (e, t);
        throw t.qu(`Unsupported field value: ${__PRIVATE_valueDescription(e)}`);
    }(e, t);
}

function __PRIVATE_parseObject(e, t) {
    const n = {};
    return isEmpty(e) ? 
    // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : forEach(e, ((e, r) => {
        const i = __PRIVATE_parseData(r, t.Ou(e));
        null != i && (n[e] = i);
    })), {
        mapValue: {
            fields: n
        }
    };
}

function __PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof Timestamp || e instanceof GeoPoint || e instanceof Bytes || e instanceof DocumentReference || e instanceof FieldValue || e instanceof VectorValue);
}

function __PRIVATE_validatePlainObject(e, t, n) {
    if (!__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        const r = __PRIVATE_valueDescription(n);
        throw "an object" === r ? t.qu(e + " a custom object") : t.qu(e + " " + r);
    }
}

/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function __PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if ((
    // If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    t = (0,dist_index_esm2017/* getModularInstance */.m9)(t)) instanceof FieldPath) return t._internalPath;
    if ("string" == typeof t) return __PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw __PRIVATE_createError("Field path arguments must be of type string or ", e, 
    /* hasConverter= */ !1, 
    /* path= */ void 0, n);
}

/**
 * Matches any characters in a field path string that are reserved.
 */ const De = new RegExp("[~\\*/\\[\\]]");

/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function __PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search(De) >= 0) throw __PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, 
    /* hasConverter= */ !1, 
    /* path= */ void 0, n);
    try {
        return new FieldPath(...t.split("."))._internalPath;
    } catch (r) {
        throw __PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, 
        /* hasConverter= */ !1, 
        /* path= */ void 0, n);
    }
}

function __PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), 
    a += ")"), new FirestoreError(D.INVALID_ARGUMENT, _ + e + a);
}

/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function __PRIVATE_fieldMaskContains(e, t) {
    return e.some((e => e.isEqual(t)));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */
    constructor(e, t, n, r, i) {
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, 
        this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */    get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */    get ref() {
        return new DocumentReference(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */    exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */    data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, 
                /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */
    // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field(__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}

/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class QueryDocumentSnapshot$1 extends DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */
    data() {
        return super.data();
    }
}

/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function __PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? __PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof FieldPath ? t._internalPath : t._delegate._internalPath;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */ === e.limitType && 0 === e.explicitOrderBy.length) throw new FirestoreError(D.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}

/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class AppliableConstraint {}

/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class QueryConstraint extends AppliableConstraint {}

function query(e, t, ...n) {
    let r = [];
    t instanceof AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e => e instanceof QueryCompositeFilterConstraint)).length, n = e.filter((e => e instanceof QueryFieldFilterConstraint)).length;
        if (t > 1 || t > 0 && n > 0) throw new FirestoreError(D.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
    /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ (r);
    for (const t of r) e = t._apply(e);
    return e;
}

/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class QueryFieldFilterConstraint extends QueryConstraint {
    /**
     * @internal
     */
    constructor(e, t, n) {
        super(), this._field = e, this._op = t, this._value = n, 
        /** The type of this query constraint */
        this.type = "where";
    }
    static _create(e, t, n) {
        return new QueryFieldFilterConstraint(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return __PRIVATE_validateNewFieldFilter(e._query, t), new Query(e.firestore, e.converter, __PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = __PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */ === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ === s) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */ === s || "not-in" /* Operator.NOT_IN */ === s) {
                    __PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o) t.push(__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = __PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */ !== s && "not-in" /* Operator.NOT_IN */ !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ !== s || __PRIVATE_validateDisjunctiveFilterElements(o, s), 
            _ = __PRIVATE_parseQueryValue(n, t, o, 
            /* allowArrays= */ "in" /* Operator.IN */ === s || "not-in" /* Operator.NOT_IN */ === s);
            return FieldFilter.create(i, s, _);
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}

/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function where(e, t, n) {
    const r = t, i = __PRIVATE_fieldPathFromArgument("where", e);
    return QueryFieldFilterConstraint._create(i, r, n);
}

/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class QueryCompositeFilterConstraint extends AppliableConstraint {
    /**
     * @internal
     */
    constructor(
    /** The type of this query constraint */
    e, t) {
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new QueryCompositeFilterConstraint(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t => t._parse(e))).filter((e => e.getFilters().length > 0));
        return 1 === t.length ? t[0] : CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r) __PRIVATE_validateNewFieldFilter(n, e), n = __PRIVATE_queryWithAddedFilter(n, e);
        }
        // Checks if any of the provided filter operators are included in the given list of filters and
        // returns the first one that is, or null if none are.
        (e._query, t), new Query(e.firestore, e.converter, __PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */ : "or" /* CompositeOperator.OR */;
    }
}

/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function or(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e => __PRIVATE_validateQueryFilterConstraint("or", e))), QueryCompositeFilterConstraint._create("or" /* CompositeOperator.OR */ , e);
}

/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function and(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e => __PRIVATE_validateQueryFilterConstraint("and", e))), QueryCompositeFilterConstraint._create("and" /* CompositeOperator.AND */ , e);
}

/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class QueryOrderByConstraint extends QueryConstraint {
    /**
     * @internal
     */
    constructor(e, t) {
        super(), this._field = e, this._direction = t, 
        /** The type of this query constraint */
        this.type = "orderBy";
    }
    static _create(e, t) {
        return new QueryOrderByConstraint(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new FirestoreError(D.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new FirestoreError(D.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            return new OrderBy(t, n);
        }
        /**
 * Create a `Bound` from a query and a document.
 *
 * Note that the `Bound` will always include the key of the document
 * and so only the provided document will compare equal to the returned
 * position.
 *
 * Will throw if the document does not contain all fields of the order by
 * of the query or if any of the fields in the order by are an uncommitted
 * server timestamp.
 */ (e._query, this._field, this._direction);
        return new Query(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([ t ]);
            return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}

/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function orderBy(e, t = "asc") {
    const n = t, r = __PRIVATE_fieldPathFromArgument("orderBy", e);
    return QueryOrderByConstraint._create(r, n);
}

/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class QueryLimitConstraint extends (/* unused pure expression or super */ null && (QueryConstraint)) {
    /**
     * @internal
     */
    constructor(
    /** The type of this query constraint */
    e, t, n) {
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new QueryLimitConstraint(e, t, n);
    }
    _apply(e) {
        return new Query(e.firestore, e.converter, __PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}

/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limit(e) {
    return __PRIVATE_validatePositiveNumber("limit", e), QueryLimitConstraint._create("limit", e, "F" /* LimitType.First */);
}

/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limitToLast(e) {
    return __PRIVATE_validatePositiveNumber("limitToLast", e), QueryLimitConstraint._create("limitToLast", e, "L" /* LimitType.Last */);
}

/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class QueryStartAtConstraint extends (/* unused pure expression or super */ null && (QueryConstraint)) {
    /**
     * @internal
     */
    constructor(
    /** The type of this query constraint */
    e, t, n) {
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new QueryStartAtConstraint(e, t, n);
    }
    _apply(e) {
        const t = __PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new Query(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}

function startAt(...e) {
    return QueryStartAtConstraint._create("startAt", e, 
    /*inclusive=*/ !0);
}

function startAfter(...e) {
    return QueryStartAtConstraint._create("startAfter", e, 
    /*inclusive=*/ !1);
}

/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class QueryEndAtConstraint extends (/* unused pure expression or super */ null && (QueryConstraint)) {
    /**
     * @internal
     */
    constructor(
    /** The type of this query constraint */
    e, t, n) {
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new QueryEndAtConstraint(e, t, n);
    }
    _apply(e) {
        const t = __PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new Query(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}

function endBefore(...e) {
    return QueryEndAtConstraint._create("endBefore", e, 
    /*inclusive=*/ !1);
}

function endAt(...e) {
    return QueryEndAtConstraint._create("endAt", e, 
    /*inclusive=*/ !0);
}

/** Helper function to create a bound from a document or fields */ function __PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = getModularInstance(n[0]), n[0] instanceof DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new FirestoreError(D.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
                for (const n of __PRIVATE_queryNormalizedOrderBy(e)) if (n.field.isKeyField()) s.push(__PRIVATE_refValue(t, r.key)); else {
            const e = r.data.field(n.field);
            if (__PRIVATE_isServerTimestamp(e)) throw new FirestoreError(D.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new Bound(s, i);
    }
    /**
 * Converts a list of field values to a `Bound` for the given query.
 */ (e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = __PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new FirestoreError(D.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for (let s = 0; s < i.length; s++) {
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child(ResourcePath.fromString(a));
                    if (!DocumentKey.isDocumentKey(n)) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new DocumentKey(n);
                    _.push(__PRIVATE_refValue(t, i));
                } else {
                    const e = __PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new Bound(_, s);
        }
        /**
 * Parses the given `documentIdValue` into a `ReferenceValue`, throwing
 * appropriate errors if the value is anything other than a `DocumentReference`
 * or `string`, or if the string is malformed.
 */ (e._query, e.firestore._databaseId, i, t, n, r);
    }
}

function __PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0,dist_index_esm2017/* getModularInstance */.m9)(n))) {
        if ("" === n) throw new FirestoreError(D.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child(ResourcePath.fromString(n));
        if (!DocumentKey.isDocumentKey(r)) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return __PRIVATE_refValue(e, new DocumentKey(r));
    }
    if (n instanceof DocumentReference) return __PRIVATE_refValue(e, n._key);
    throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${__PRIVATE_valueDescription(n)}.`);
}

/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function __PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}

/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function __PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e) for (const e of n.getFlattenedFilters()) if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch (e) {
          case "!=" /* Operator.NOT_EQUAL */ :
            return [ "!=" /* Operator.NOT_EQUAL */ , "not-in" /* Operator.NOT_IN */ ];

          case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
          case "in" /* Operator.IN */ :
            return [ "not-in" /* Operator.NOT_IN */ ];

          case "not-in" /* Operator.NOT_IN */ :
            return [ "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , "in" /* Operator.IN */ , "not-in" /* Operator.NOT_IN */ , "!=" /* Operator.NOT_EQUAL */ ];

          default:
            return [];
        }
    }(t.op));
    if (null !== n) 
    // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new FirestoreError(D.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}

function __PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof QueryFieldFilterConstraint || t instanceof QueryCompositeFilterConstraint)) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}

class AbstractUserDataWriter {
    convertValue(e, t = "none") {
        switch (__PRIVATE_typeOrder(e)) {
          case 0 /* TypeOrder.NullValue */ :
            return null;

          case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue;

          case 2 /* TypeOrder.NumberValue */ :
            return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);

          case 3 /* TypeOrder.TimestampValue */ :
            return this.convertTimestamp(e.timestampValue);

          case 4 /* TypeOrder.ServerTimestampValue */ :
            return this.convertServerTimestamp(e, t);

          case 5 /* TypeOrder.StringValue */ :
            return e.stringValue;

          case 6 /* TypeOrder.BlobValue */ :
            return this.convertBytes(__PRIVATE_normalizeByteString(e.bytesValue));

          case 7 /* TypeOrder.RefValue */ :
            return this.convertReference(e.referenceValue);

          case 8 /* TypeOrder.GeoPointValue */ :
            return this.convertGeoPoint(e.geoPointValue);

          case 9 /* TypeOrder.ArrayValue */ :
            return this.convertArray(e.arrayValue, t);

          case 11 /* TypeOrder.ObjectValue */ :
            return this.convertObject(e.mapValue, t);

          case 10 /* TypeOrder.VectorValue */ :
            return this.convertVectorValue(e.mapValue);

          default:
            throw fail();
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */    convertObjectMap(e, t = "none") {
        const n = {};
        return forEach(e, ((e, r) => {
            n[e] = this.convertValue(r, t);
        })), n;
    }
    /**
     * @internal
     */    convertVectorValue(e) {
        var t, n, r;
        const i = null === (r = null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t.value.arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.map((e => __PRIVATE_normalizeNumber(e.doubleValue)));
        return new VectorValue(i);
    }
    convertGeoPoint(e) {
        return new GeoPoint(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e => this.convertValue(e, t)));
    }
    convertServerTimestamp(e, t) {
        switch (t) {
          case "previous":
            const n = __PRIVATE_getPreviousValue(e);
            return null == n ? null : this.convertValue(n, t);

          case "estimate":
            return this.convertTimestamp(__PRIVATE_getLocalWriteTime(e));

          default:
            return null;
        }
    }
    convertTimestamp(e) {
        const t = __PRIVATE_normalizeTimestamp(e);
        return new Timestamp(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = ResourcePath.fromString(e);
        __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(n));
        const r = new DatabaseId(n.get(1), n.get(3)), i = new DocumentKey(n.popFirst(5));
        return r.isEqual(t) || 
        // TODO(b/64130202): Somehow support foreign references.
        __PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), 
        i;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function __PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, 
    r;
}

class __PRIVATE_LiteUserDataWriter extends (/* unused pure expression or super */ null && (AbstractUserDataWriter)) {
    constructor(e) {
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new Bytes(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new DocumentReference(this.firestore, /* converter= */ null, t);
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function sum(e) {
    return new AggregateField("sum", __PRIVATE_fieldPathFromArgument$1("sum", e));
}

/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function average(e) {
    return new AggregateField("avg", __PRIVATE_fieldPathFromArgument$1("average", e));
}

/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function count() {
    return new AggregateField("count");
}

/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function aggregateFieldEqual(e, t) {
    var n, r;
    return e instanceof AggregateField && t instanceof AggregateField && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}

/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function aggregateQuerySnapshotEqual(e, t) {
    return queryEqual(e.query, t.query) && deepEqual(e.data(), t.data());
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class SnapshotMetadata {
    /** @hideconstructor */
    constructor(e, t) {
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */    isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}

/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class DocumentSnapshot extends DocumentSnapshot$1 {
    /** @hideconstructor protected */
    constructor(e, t, n, r, i, s) {
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */    exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */    data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new QueryDocumentSnapshot(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, 
                /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */
    // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field(__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
}

/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class QueryDocumentSnapshot extends DocumentSnapshot {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */
    data(e = {}) {
        return super.data(e);
    }
}

/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class QuerySnapshot {
    /** @hideconstructor */
    constructor(e, t, n, r) {
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new SnapshotMetadata(r.hasPendingWrites, r.fromCache), 
        this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */    get docs() {
        const e = [];
        return this.forEach((t => e.push(t))), e;
    }
    /** The number of documents in the `QuerySnapshot`. */    get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */    get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */    forEach(e, t) {
        this._snapshot.docs.forEach((n => {
            e.call(t, new QueryDocumentSnapshot(this._firestore, this._userDataWriter, n.key, n, new SnapshotMetadata(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        }));
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */    docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new FirestoreError(D.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = 
        /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */
        function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n => {
                    const r = new QueryDocumentSnapshot(e._firestore, e._userDataWriter, n.doc.key, n.doc, new SnapshotMetadata(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                }));
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e => t || 3 /* ChangeType.Metadata */ !== e.type)).map((t => {
                    const r = new QueryDocumentSnapshot(e._firestore, e._userDataWriter, t.doc.key, t.doc, new SnapshotMetadata(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */ !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 
                    1 /* ChangeType.Removed */ !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), 
                    {
                        type: __PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                }));
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
}

function __PRIVATE_resultChangeType(e) {
    switch (e) {
      case 0 /* ChangeType.Added */ :
        return "added";

      case 2 /* ChangeType.Modified */ :
      case 3 /* ChangeType.Metadata */ :
        return "modified";

      case 1 /* ChangeType.Removed */ :
        return "removed";

      default:
        return fail();
    }
}

// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function snapshotEqual(e, t) {
    return e instanceof DocumentSnapshot && t instanceof DocumentSnapshot ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof QuerySnapshot && t instanceof QuerySnapshot && (e._firestore === t._firestore && queryEqual(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot));
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function getDoc(e) {
    e = __PRIVATE_cast(e, DocumentReference);
    const t = __PRIVATE_cast(e.firestore, Firestore);
    return __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(ensureFirestoreConfigured(t), e._key).then((n => __PRIVATE_convertToDocSnapshot(t, e, n)));
}

class __PRIVATE_ExpUserDataWriter extends AbstractUserDataWriter {
    constructor(e) {
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new Bytes(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new DocumentReference(this.firestore, /* converter= */ null, t);
    }
}

/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function getDocFromCache(e) {
    e = __PRIVATE_cast(e, DocumentReference);
    const t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n => new DocumentSnapshot(t, r, e._key, n, new SnapshotMetadata(null !== n && n.hasLocalMutations, 
    /* fromCache= */ !0), e.converter)));
}

/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function getDocFromServer(e) {
    e = __PRIVATE_cast(e, DocumentReference);
    const t = __PRIVATE_cast(e.firestore, Firestore);
    return __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(ensureFirestoreConfigured(t), e._key, {
        source: "server"
    }).then((n => __PRIVATE_convertToDocSnapshot(t, e, n)));
}

/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function getDocs(e) {
    e = __PRIVATE_cast(e, Query);
    const t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n => new QuerySnapshot(t, r, e, n)));
}

/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function getDocsFromCache(e) {
    e = __PRIVATE_cast(e, Query);
    const t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n => new QuerySnapshot(t, r, e, n)));
}

/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function getDocsFromServer(e) {
    e = __PRIVATE_cast(e, Query);
    const t = __PRIVATE_cast(e.firestore, Firestore), n = ensureFirestoreConfigured(t), r = new __PRIVATE_ExpUserDataWriter(t);
    return __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n => new QuerySnapshot(t, r, e, n)));
}

function setDoc(e, t, n) {
    e = __PRIVATE_cast(e, DocumentReference);
    const r = __PRIVATE_cast(e.firestore, Firestore), i = __PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return executeWrite(r, [ __PRIVATE_parseSetData(__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, Precondition.none()) ]);
}

function updateDoc(e, t, n, ...r) {
    e = __PRIVATE_cast(e, DocumentReference);
    const i = __PRIVATE_cast(e.firestore, Firestore), s = __PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof (
    // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    t = getModularInstance(t)) || t instanceof FieldPath ? __PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : __PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return executeWrite(i, [ o.toMutation(e._key, Precondition.exists(!0)) ]);
}

/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function deleteDoc(e) {
    return executeWrite(__PRIVATE_cast(e.firestore, Firestore), [ new __PRIVATE_DeleteMutation(e._key, Precondition.none()) ]);
}

/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function addDoc(e, t) {
    const n = __PRIVATE_cast(e.firestore, Firestore), r = doc(e), i = __PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return executeWrite(n, [ __PRIVATE_parseSetData(__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, Precondition.exists(!1)) ]).then((() => r));
}

function onSnapshot(e, ...t) {
    var n, r, i;
    e = (0,dist_index_esm2017/* getModularInstance */.m9)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || __PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if (__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), 
        t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof DocumentReference) u = __PRIVATE_cast(e.firestore, Firestore), 
    c = __PRIVATE_newQueryForPath(e._key.path), a = {
        next: n => {
            t[o] && t[o](__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    }; else {
        const n = __PRIVATE_cast(e, Query);
        u = __PRIVATE_cast(n.firestore, Firestore), c = n._query;
        const r = new __PRIVATE_ExpUserDataWriter(u);
        a = {
            next: e => {
                t[o] && t[o](new QuerySnapshot(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, __PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new __PRIVATE_AsyncObserver(r), s = new __PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget((async () => __PRIVATE_eventManagerListen(await __PRIVATE_getEventManager(e), s))), 
        () => {
            i.eu(), e.asyncQueue.enqueueAndForget((async () => __PRIVATE_eventManagerUnlisten(await __PRIVATE_getEventManager(e), s)));
        };
    }(ensureFirestoreConfigured(u), c, _, a);
}

function onSnapshotsInSync(e, t) {
    return __PRIVATE_firestoreClientAddSnapshotsInSyncListener(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), __PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}

/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function executeWrite(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget((async () => __PRIVATE_syncEngineWrite(await __PRIVATE_getSyncEngine(e), t, n))), 
        n.promise;
    }(ensureFirestoreConfigured(e), t);
}

/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function __PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new __PRIVATE_ExpUserDataWriter(e);
    return new DocumentSnapshot(e, i, t._key, r, new SnapshotMetadata(n.hasPendingWrites, n.fromCache), t.converter);
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function getCountFromServer(e) {
    return getAggregateFromServer(e, {
        count: count()
    });
}

/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function getAggregateFromServer(e, t) {
    const n = __PRIVATE_cast(e.firestore, Firestore), r = ensureFirestoreConfigured(n), i = __PRIVATE_mapToArray(t, ((e, t) => new __PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)));
    // Run the aggregation and convert the results
    return __PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t => 
    /**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */
    function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
        const r = new __PRIVATE_ExpUserDataWriter(e);
        return new AggregateQuerySnapshot(t, r, n);
    }
    /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (n, e, t)));
}

class __PRIVATE_MemoryLocalCacheImpl {
    constructor(e) {
        this.kind = "memory", this._onlineComponentProvider = OnlineComponentProvider.provider, 
        (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = {
            build: () => new __PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}

class __PRIVATE_PersistentLocalCacheImpl {
    constructor(e) {
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), 
        t = e.tabManager) : (t = persistentSingleTabManager(void 0), t._initialize(e)), 
        this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}

class __PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor() {
        this.kind = "memoryEager", this._offlineComponentProvider = __PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}

class __PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e) {
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: () => new __PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}

/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function memoryEagerGarbageCollector() {
    return new __PRIVATE_MemoryEagerGarbageCollectorImpl;
}

/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function memoryLruGarbageCollector(e) {
    return new __PRIVATE_MemoryLruGarbageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}

/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function memoryLocalCache(e) {
    return new __PRIVATE_MemoryLocalCacheImpl(e);
}

/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function persistentLocalCache(e) {
    return new __PRIVATE_PersistentLocalCacheImpl(e);
}

class __PRIVATE_SingleTabManagerImpl {
    constructor(e) {
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */    _initialize(e) {
        this._onlineComponentProvider = OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: t => new __PRIVATE_IndexedDbOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership)
        };
    }
}

class __PRIVATE_MultiTabManagerImpl {
    constructor() {
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */    _initialize(e) {
        this._onlineComponentProvider = OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: t => new __PRIVATE_MultiTabOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes)
        };
    }
}

/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function persistentSingleTabManager(e) {
    return new __PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}

/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function persistentMultipleTabManager() {
    return new __PRIVATE_MultiTabManagerImpl;
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ve = {
    maxAttempts: 5
};

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */
class WriteBatch {
    /** @hideconstructor */
    constructor(e, t) {
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, 
        this._dataReader = __PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = __PRIVATE_validateReference(e, this._firestore), i = __PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = __PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = __PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
                let s;
        return s = "string" == typeof (t = (0,dist_index_esm2017/* getModularInstance */.m9)(t)) || t instanceof FieldPath ? __PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : __PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), 
        this._mutations.push(s.toMutation(i._key, Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */    delete(e) {
        this._verifyNotCommitted();
        const t = __PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new __PRIVATE_DeleteMutation(t._key, Precondition.none())), 
        this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */    commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new FirestoreError(D.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}

function __PRIVATE_validateReference(e, t) {
    if ((e = (0,dist_index_esm2017/* getModularInstance */.m9)(e)).firestore !== t) throw new FirestoreError(D.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */
class Transaction extends (/* unused pure expression or super */ null && (class Transaction$1 {
    /** @hideconstructor */
    constructor(e, t) {
        this._firestore = e, this._transaction = t, this._dataReader = __PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */    get(e) {
        const t = __PRIVATE_validateReference(e, this._firestore), n = new __PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([ t._key ]).then((e => {
            if (!e || 1 !== e.length) return fail();
            const r = e[0];
            if (r.isFoundDocument()) return new DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw fail();
        }));
    }
    set(e, t, n) {
        const r = __PRIVATE_validateReference(e, this._firestore), i = __PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = __PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = __PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
                let s;
        return s = "string" == typeof (t = getModularInstance(t)) || t instanceof FieldPath ? __PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : __PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), 
        this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */    delete(e) {
        const t = __PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
})) {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */
    constructor(e, t) {
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */    get(e) {
        const t = __PRIVATE_validateReference(e, this._firestore), n = new __PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e => new DocumentSnapshot(this._firestore, n, t._key, e._document, new SnapshotMetadata(
        /* hasPendingWrites= */ !1, 
        /* fromCache= */ !1), t.converter)));
    }
}

/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function runTransaction(e, t, n) {
    e = __PRIVATE_cast(e, Firestore);
    const r = Object.assign(Object.assign({}, ve), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new FirestoreError(D.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget((async () => {
            const i = await __PRIVATE_getDatastore(e);
            new __PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).cu();
        })), r.promise;
    }(ensureFirestoreConfigured(e), (n => t(new Transaction(e, n))), r);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function deleteField() {
    return new __PRIVATE_DeleteFieldValueImpl("deleteField");
}

/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function serverTimestamp() {
    return new __PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}

/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function arrayUnion(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}

/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function arrayRemove(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}

/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function increment(e) {
    return new __PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}

/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function vector(e) {
    return new VectorValue(e);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function writeBatch(e) {
    return ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), new WriteBatch(e, (t => executeWrite(e, t)));
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function setIndexConfiguration(e, t) {
    const n = ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) 
    // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return __PRIVATE_logWarn("Cannot enable indexes when persistence is disabled"), 
    Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new FirestoreError(D.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes) {
            const t = __PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields) {
                const e = __PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", __PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new IndexSegment(e, 2 /* IndexKind.CONTAINS */)) : "ASCENDING" === t.order ? r.push(new IndexSegment(e, 0 /* IndexKind.ASCENDING */)) : "DESCENDING" === t.order && r.push(new IndexSegment(e, 1 /* IndexKind.DESCENDING */));
            }
            n.push(new FieldIndex(FieldIndex.UNKNOWN_ID, t, r, IndexState.empty()));
        }
        return n;
    }(t);
    return __PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}

function __PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new FirestoreError(D.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class PersistentCacheIndexManager {
    /** @hideconstructor */
    constructor(e) {
        this._firestore = e, 
        /** A type string to uniquely identify instances of this class. */
        this.type = "PersistentCacheIndexManager";
    }
}

/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function getPersistentCacheIndexManager(e) {
    var t;
    e = __PRIVATE_cast(e, Firestore);
    const n = Ce.get(e);
    if (n) return n;
    if ("persistent" !== (null === (t = ensureFirestoreConfigured(e)._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offline.kind)) return null;
    const r = new PersistentCacheIndexManager(e);
    return Ce.set(e, r), r;
}

/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function enablePersistentCacheIndexAutoCreation(e) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}

/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function disablePersistentCacheIndexAutoCreation(e) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}

/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function deleteAllPersistentCacheIndexes(e) {
    __PRIVATE_firestoreClientDeleteAllFieldIndexes(ensureFirestoreConfigured(e._firestore)).then((e => __PRIVATE_logDebug("deleting all persistent cache indexes succeeded"))).catch((e => __PRIVATE_logWarn("deleting all persistent cache indexes failed", e)));
}

function __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(ensureFirestoreConfigured(e._firestore), t).then((e => __PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`))).catch((e => __PRIVATE_logWarn(`setting persistent cache index auto creation isEnabled=${t} failed`, e)));
}

/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const Ce = new WeakMap;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _internalQueryToProtoQueryTarget(e) {
    var t;
    const n = null === (t = ensureFirestoreConfigured(__PRIVATE_cast(e.firestore, Firestore))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : __PRIVATE_toQueryTarget(n, __PRIVATE_queryToTarget(e._query)).ct;
}

/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function _internalAggregationQueryToProtoRunAggregationQueryRequest(e, t) {
    var n;
    const r = __PRIVATE_mapToArray(t, ((e, t) => new __PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath))), i = null === (n = ensureFirestoreConfigured(__PRIVATE_cast(e.firestore, Firestore))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : __PRIVATE_toRunAggregationQueryRequest(i, __PRIVATE_queryToAggregateTarget(e._query), r, 
    /* skipAliasing= */ !0).request;
}

/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class TestingHooks {
    constructor() {
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */    static onExistenceFilterMismatch(e) {
        return __PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}

/**
 * The implementation of `TestingHooksSpi`.
 */ class __PRIVATE_TestingHooksSpiImpl {
    constructor() {
        this.Gu = new Map;
    }
    static get instance() {
        return Fe || (Fe = new __PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if (Pe) throw new Error("a TestingHooksSpi instance is already set");
            Pe = e;
        }(Fe)), Fe;
    }
    tt(e) {
        this.Gu.forEach((t => t(e)));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Gu;
        return n.set(t, e), () => n.delete(t);
    }
}

let Fe = null;

/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        S = e;
    }(index_esm2017/* SDK_VERSION */.Jn), (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA("firestore", ((e, {instanceIdentifier: n, options: r}) => {
        const i = e.getProvider("app").getImmediate(), s = new Firestore(new __PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new __PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [ "projectId" ])) throw new FirestoreError(D.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new DatabaseId(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }), "PUBLIC").setMultipleInstances(!0)), (0,index_esm2017/* registerVersion */.KN)(w, "4.7.5", e), 
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0,index_esm2017/* registerVersion */.KN)(w, "4.7.5", "esm2017");
}();


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/firebase/firestore/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 57214:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xS": function() { return /* reexport */ fetchAndActivate; },
  "Pf": function() { return /* reexport */ getBoolean; },
  "Dx": function() { return /* reexport */ getNumber; },
  "sN": function() { return /* reexport */ getRemoteConfig; },
  "KF": function() { return /* reexport */ getString; }
});

// UNUSED EXPORTS: activate, ensureInitialized, fetchConfig, getAll, getValue, isSupported, setLogLevel

// EXTERNAL MODULE: ../../node_modules/@firebase/app/dist/esm/index.esm2017.js
var index_esm2017 = __webpack_require__(85500);
// EXTERNAL MODULE: ../../node_modules/@firebase/util/dist/index.esm2017.js
var dist_index_esm2017 = __webpack_require__(83395);
// EXTERNAL MODULE: ../../node_modules/@firebase/component/dist/esm/index.esm2017.js
var esm_index_esm2017 = __webpack_require__(46387);
// EXTERNAL MODULE: ../../node_modules/@firebase/logger/dist/esm/index.esm2017.js
var dist_esm_index_esm2017 = __webpack_require__(68207);
// EXTERNAL MODULE: ../../node_modules/idb/build/index.js + 1 modules
var build = __webpack_require__(55389);
;// CONCATENATED MODULE: ../../node_modules/@firebase/installations/dist/esm/index.esm2017.js





const index_esm2017_name = "@firebase/installations";
const version = "0.6.11";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof dist_index_esm2017/* FirebaseError */.ZR &&
        error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */, {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) {
        // Internal Server Error. Retry request.
        return fn();
    }
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    }
    else {
        throw await getErrorFromResponse('Create Installation', response);
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 0b01110000 + (fidByteArray[0] % 0b00010000);
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    for (const callback of callbacks) {
        callback(fid);
    }
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key, fid });
    }
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = e => {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = (0,build/* openDB */.X3)(DATABASE_NAME, DATABASE_VERSION, {
            upgrade: (db, oldVersion) => {
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (oldVersion) {
                    case 0:
                        db.createObjectStore(OBJECT_STORE_NAME);
                }
            }
        });
    }
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await objectStore.get(key));
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) {
        fidChanged(appConfig, value.fid);
    }
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */
async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = (await store.get(key));
    const newValue = updateFn(oldValue);
    if (newValue === undefined) {
        await store.delete(key);
    }
    else {
        await store.put(newValue, key);
    }
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
        fidChanged(appConfig, newValue.fid);
    }
    return newValue;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, oldEntry => {
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) {
        // FID generation failed. Waiting for the FID from the server.
        return { installationEntry: await registrationPromise };
    }
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        return {
            installationEntry,
            registrationPromise: waitUntilFidRegistration(installations)
        };
    }
    else {
        return { installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    }
    catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) {
            // Server returned a "FID cannot be used" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            // Registration failed. Set FID as not registered.
            await set(installations.appConfig, {
                fid: installationEntry.fid,
                registrationStatus: 0 /* RequestStatus.NOT_STARTED */
            });
        }
        throw e;
    }
}
/** Call if FID registration is pending in another request. */
async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) {
            return registrationPromise;
        }
        else {
            // if there is no registrationPromise, entry is registered.
            return installationEntry;
        }
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) {
            headers.append('x-firebase-client', heartbeatsHeader);
        }
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    }
    else {
        throw await getErrorFromResponse('Generate Auth Token', response);
    }
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
            // There is a valid token in the DB.
            return oldEntry;
        }
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        }
        else {
            // No token or token expired.
            if (!navigator.onLine) {
                throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise
        ? await tokenPromise
        : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */
async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while (entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */) {
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */) {
        // The request timed out or failed in a different call. Try again.
        return refreshAuthToken(installations, forceRefresh);
    }
    else {
        return authToken;
    }
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, oldEntry => {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */);
        }
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken });
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    }
    catch (e) {
        if (isServerError(e) &&
            (e.customData.serverCode === 401 || e.customData.serverCode === 404)) {
            // Server returned a "FID not found" or a "Invalid authentication" error.
            // Generate a new ID next time.
            await remove(installations.appConfig);
        }
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* RequestStatus.NOT_STARTED */ } });
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* RequestStatus.COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) {
        registrationPromise.catch(console.error);
    }
    else {
        // If the installation is already registered, update the authentication
        // token if needed.
        refreshAuthToken(installationsImpl).catch(console.error);
    }
    return installationEntry.fid;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */
async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) {
        // A createInstallation request is in progress. Wait until it finishes.
        await registrationPromise;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(() => fetch(endpoint, request));
    if (!response.ok) {
        throw await getErrorFromResponse('Delete Installation', response);
    }
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, oldEntry => {
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */) {
            // Delete the unregistered entry without sending a deleteInstallation request.
            return undefined;
        }
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */) {
            // Can't delete while trying to register.
            throw ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */);
        }
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */) {
            if (!navigator.onLine) {
                throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */);
            }
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */
function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return () => {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations(app = getApp()) {
    const installationsImpl = _getProvider(app, 'installations').getImmediate();
    return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys) {
        if (!app.options[keyName]) {
            throw getMissingValueError(keyName);
        }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */, {
        valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = (0,index_esm2017/* _getProvider */.qX)(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: () => Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container) => {
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0,index_esm2017/* _getProvider */.qX)(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: () => getId(installations),
        getToken: (forceRefresh) => getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */));
    (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */));
}

/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
registerInstallations();
(0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version);
// BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
(0,index_esm2017/* registerVersion */.KN)(index_esm2017_name, version, 'esm2017');


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/@firebase/remote-config/dist/esm/index.esm2017.js






const esm_index_esm2017_name = "@firebase/remote-config";
const index_esm2017_version = "0.4.11";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Shims a minimal AbortSignal.
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */
class RemoteConfigAbortSignal {
    constructor() {
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach(listener => listener());
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const RC_COMPONENT_NAME = 'remote-config';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const index_esm2017_ERROR_DESCRIPTION_MAP = {
    ["registration-window" /* ErrorCode.REGISTRATION_WINDOW */]: 'Undefined window object. This SDK only supports usage in a browser environment.',
    ["registration-project-id" /* ErrorCode.REGISTRATION_PROJECT_ID */]: 'Undefined project identifier. Check Firebase app initialization.',
    ["registration-api-key" /* ErrorCode.REGISTRATION_API_KEY */]: 'Undefined API key. Check Firebase app initialization.',
    ["registration-app-id" /* ErrorCode.REGISTRATION_APP_ID */]: 'Undefined app identifier. Check Firebase app initialization.',
    ["storage-open" /* ErrorCode.STORAGE_OPEN */]: 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
    ["storage-get" /* ErrorCode.STORAGE_GET */]: 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
    ["storage-set" /* ErrorCode.STORAGE_SET */]: 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
    ["storage-delete" /* ErrorCode.STORAGE_DELETE */]: 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.',
    ["fetch-client-network" /* ErrorCode.FETCH_NETWORK */]: 'Fetch client failed to connect to a network. Check Internet connection.' +
        ' Original error: {$originalErrorMessage}.',
    ["fetch-timeout" /* ErrorCode.FETCH_TIMEOUT */]: 'The config fetch request timed out. ' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.',
    ["fetch-throttle" /* ErrorCode.FETCH_THROTTLE */]: 'The config fetch request timed out while in an exponential backoff state.' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.' +
        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
    ["fetch-client-parse" /* ErrorCode.FETCH_PARSE */]: 'Fetch client could not parse response.' +
        ' Original error: {$originalErrorMessage}.',
    ["fetch-status" /* ErrorCode.FETCH_STATUS */]: 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.',
    ["indexed-db-unavailable" /* ErrorCode.INDEXED_DB_UNAVAILABLE */]: 'Indexed DB is not supported by current browser'
};
const index_esm2017_ERROR_FACTORY = new dist_index_esm2017/* ErrorFactory */.LL('remoteconfig' /* service */, 'Remote Config' /* service name */, index_esm2017_ERROR_DESCRIPTION_MAP);
// Note how this is like typeof/instanceof, but for ErrorCode.
function hasErrorCode(e, errorCode) {
    return e instanceof dist_index_esm2017/* FirebaseError */.ZR && e.code.indexOf(errorCode) !== -1;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_VALUE_FOR_BOOLEAN = false;
const DEFAULT_VALUE_FOR_STRING = '';
const DEFAULT_VALUE_FOR_NUMBER = 0;
const BOOLEAN_TRUTHY_VALUES = ['1', 'true', 't', 'yes', 'y', 'on'];
class Value {
    constructor(_source, _value = DEFAULT_VALUE_FOR_STRING) {
        this._source = _source;
        this._value = _value;
    }
    asString() {
        return this._value;
    }
    asBoolean() {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_BOOLEAN;
        }
        return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
    }
    asNumber() {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_NUMBER;
        }
        let num = Number(this._value);
        if (isNaN(num)) {
            num = DEFAULT_VALUE_FOR_NUMBER;
        }
        return num;
    }
    getSource() {
        return this._source;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 * @returns A {@link RemoteConfig} instance.
 *
 * @public
 */
function getRemoteConfig(app = (0,index_esm2017/* getApp */.Mq)()) {
    app = (0,dist_index_esm2017/* getModularInstance */.m9)(app);
    const rcProvider = (0,index_esm2017/* _getProvider */.qX)(app, RC_COMPONENT_NAME);
    return rcProvider.getImmediate();
}
/**
 * Makes the last fetched config available to the getters.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @returns A `Promise` which resolves to true if the current call activated the fetched configs.
 * If the fetched configs were already activated, the `Promise` will resolve to false.
 *
 * @public
 */
async function activate(remoteConfig) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    const [lastSuccessfulFetchResponse, activeConfigEtag] = await Promise.all([
        rc._storage.getLastSuccessfulFetchResponse(),
        rc._storage.getActiveConfigEtag()
    ]);
    if (!lastSuccessfulFetchResponse ||
        !lastSuccessfulFetchResponse.config ||
        !lastSuccessfulFetchResponse.eTag ||
        lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
        // Either there is no successful fetched config, or is the same as current active
        // config.
        return false;
    }
    await Promise.all([
        rc._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
        rc._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
    ]);
    return true;
}
/**
 * Ensures the last activated config are available to the getters.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 *
 * @returns A `Promise` that resolves when the last activated config is available to the getters.
 * @public
 */
function ensureInitialized(remoteConfig) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    if (!rc._initializePromise) {
        rc._initializePromise = rc._storageCache.loadFromStorage().then(() => {
            rc._isInitializationComplete = true;
        });
    }
    return rc._initializePromise;
}
/**
 * Fetches and caches configuration from the Remote Config service.
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @public
 */
async function fetchConfig(remoteConfig) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    // Aborts the request after the given timeout, causing the fetch call to
    // reject with an `AbortError`.
    //
    // <p>Aborting after the request completes is a no-op, so we don't need a
    // corresponding `clearTimeout`.
    //
    // Locating abort logic here because:
    // * it uses a developer setting (timeout)
    // * it applies to all retries (like curl's max-time arg)
    // * it is consistent with the Fetch API's signal input
    const abortSignal = new RemoteConfigAbortSignal();
    setTimeout(async () => {
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        abortSignal.abort();
    }, rc.settings.fetchTimeoutMillis);
    // Catches *all* errors thrown by client so status can be set consistently.
    try {
        await rc._client.fetch({
            cacheMaxAgeMillis: rc.settings.minimumFetchIntervalMillis,
            signal: abortSignal
        });
        await rc._storageCache.setLastFetchStatus('success');
    }
    catch (e) {
        const lastFetchStatus = hasErrorCode(e, "fetch-throttle" /* ErrorCode.FETCH_THROTTLE */)
            ? 'throttle'
            : 'failure';
        await rc._storageCache.setLastFetchStatus(lastFetchStatus);
        throw e;
    }
}
/**
 * Gets all config.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @returns All config.
 *
 * @public
 */
function getAll(remoteConfig) {
    const rc = getModularInstance(remoteConfig);
    return getAllKeys(rc._storageCache.getActiveConfig(), rc.defaultConfig).reduce((allConfigs, key) => {
        allConfigs[key] = getValue(remoteConfig, key);
        return allConfigs;
    }, {});
}
/**
 * Gets the value for the given key as a boolean.
 *
 * Convenience method for calling <code>remoteConfig.getValue(key).asBoolean()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a boolean.
 * @public
 */
function getBoolean(remoteConfig, key) {
    return getValue((0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig), key).asBoolean();
}
/**
 * Gets the value for the given key as a number.
 *
 * Convenience method for calling <code>remoteConfig.getValue(key).asNumber()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a number.
 *
 * @public
 */
function getNumber(remoteConfig, key) {
    return getValue((0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig), key).asNumber();
}
/**
 * Gets the value for the given key as a string.
 * Convenience method for calling <code>remoteConfig.getValue(key).asString()</code>.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key as a string.
 *
 * @public
 */
function getString(remoteConfig, key) {
    return getValue((0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig), key).asString();
}
/**
 * Gets the {@link Value} for the given key.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param key - The name of the parameter.
 *
 * @returns The value for the given key.
 *
 * @public
 */
function getValue(remoteConfig, key) {
    const rc = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    if (!rc._isInitializationComplete) {
        rc._logger.debug(`A value was requested for key "${key}" before SDK initialization completed.` +
            ' Await on ensureInitialized if the intent was to get a previously activated value.');
    }
    const activeConfig = rc._storageCache.getActiveConfig();
    if (activeConfig && activeConfig[key] !== undefined) {
        return new Value('remote', activeConfig[key]);
    }
    else if (rc.defaultConfig && rc.defaultConfig[key] !== undefined) {
        return new Value('default', String(rc.defaultConfig[key]));
    }
    rc._logger.debug(`Returning static value for key "${key}".` +
        ' Define a default or remote value if this is unintentional.');
    return new Value('static');
}
/**
 * Defines the log level to use.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 * @param logLevel - The log level to set.
 *
 * @public
 */
function setLogLevel(remoteConfig, logLevel) {
    const rc = getModularInstance(remoteConfig);
    switch (logLevel) {
        case 'debug':
            rc._logger.logLevel = LogLevel.DEBUG;
            break;
        case 'silent':
            rc._logger.logLevel = LogLevel.SILENT;
            break;
        default:
            rc._logger.logLevel = LogLevel.ERROR;
    }
}
/**
 * Dedupes and returns an array of all the keys of the received objects.
 */
function getAllKeys(obj1 = {}, obj2 = {}) {
    return Object.keys(Object.assign(Object.assign({}, obj1), obj2));
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
 *
 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
 * Cache API doesn't support matching entries by time.
 */
class CachingClient {
    constructor(client, storage, storageCache, logger) {
        this.client = client;
        this.storage = storage;
        this.storageCache = storageCache;
        this.logger = logger;
    }
    /**
     * Returns true if the age of the cached fetched configs is less than or equal to
     * {@link Settings#minimumFetchIntervalInSeconds}.
     *
     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
     * native Fetch API.
     *
     * <p>Visible for testing.
     */
    isCachedDataFresh(cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
        // Cache can only be fresh if it's populated.
        if (!lastSuccessfulFetchTimestampMillis) {
            this.logger.debug('Config fetch cache check. Cache unpopulated.');
            return false;
        }
        // Calculates age of cache entry.
        const cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
        const isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
        this.logger.debug('Config fetch cache check.' +
            ` Cache age millis: ${cacheAgeMillis}.` +
            ` Cache max age millis (minimumFetchIntervalMillis setting): ${cacheMaxAgeMillis}.` +
            ` Is cache hit: ${isCachedDataFresh}.`);
        return isCachedDataFresh;
    }
    async fetch(request) {
        // Reads from persisted storage to avoid cache miss if callers don't wait on initialization.
        const [lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse] = await Promise.all([
            this.storage.getLastSuccessfulFetchTimestampMillis(),
            this.storage.getLastSuccessfulFetchResponse()
        ]);
        // Exits early on cache hit.
        if (lastSuccessfulFetchResponse &&
            this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
            return lastSuccessfulFetchResponse;
        }
        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
        // that allows the caller to pass an ETag.
        request.eTag =
            lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
        // Falls back to service on cache miss.
        const response = await this.client.fetch(request);
        // Fetch throws for non-success responses, so success is guaranteed here.
        const storageOperations = [
            // Uses write-through cache for consistency with synchronous public API.
            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
        ];
        if (response.status === 200) {
            // Caches response only if it has changed, ie non-304 responses.
            storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
        }
        await Promise.all(storageOperations);
        return response;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Attempts to get the most accurate browser language setting.
 *
 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
 *
 * <p>Defers default language specification to server logic for consistency.
 *
 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
 */
function getUserLanguage(navigatorLanguage = navigator) {
    return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
        // Supported in most browsers, but returns the language of the browser
        // UI, not the language set in browser settings.
        navigatorLanguage.language
    // Polyfill otherwise.
    );
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the Client abstraction for the Remote Config REST API.
 */
class RestClient {
    constructor(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
        this.firebaseInstallations = firebaseInstallations;
        this.sdkVersion = sdkVersion;
        this.namespace = namespace;
        this.projectId = projectId;
        this.apiKey = apiKey;
        this.appId = appId;
    }
    /**
     * Fetches from the Remote Config REST API.
     *
     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
     * connect to the network.
     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
     * fetch response.
     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
     */
    async fetch(request) {
        const [installationId, installationToken] = await Promise.all([
            this.firebaseInstallations.getId(),
            this.firebaseInstallations.getToken()
        ]);
        const urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE ||
            'https://firebaseremoteconfig.googleapis.com';
        const url = `${urlBase}/v1/projects/${this.projectId}/namespaces/${this.namespace}:fetch?key=${this.apiKey}`;
        const headers = {
            'Content-Type': 'application/json',
            'Content-Encoding': 'gzip',
            // Deviates from pure decorator by not passing max-age header since we don't currently have
            // service behavior using that header.
            'If-None-Match': request.eTag || '*'
        };
        const requestBody = {
            /* eslint-disable camelcase */
            sdk_version: this.sdkVersion,
            app_instance_id: installationId,
            app_instance_id_token: installationToken,
            app_id: this.appId,
            language_code: getUserLanguage()
            /* eslint-enable camelcase */
        };
        const options = {
            method: 'POST',
            headers,
            body: JSON.stringify(requestBody)
        };
        // This logic isn't REST-specific, but shimming abort logic isn't worth another decorator.
        const fetchPromise = fetch(url, options);
        const timeoutPromise = new Promise((_resolve, reject) => {
            // Maps async event listener to Promise API.
            request.signal.addEventListener(() => {
                // Emulates https://heycam.github.io/webidl/#aborterror
                const error = new Error('The operation was aborted.');
                error.name = 'AbortError';
                reject(error);
            });
        });
        let response;
        try {
            await Promise.race([fetchPromise, timeoutPromise]);
            response = await fetchPromise;
        }
        catch (originalError) {
            let errorCode = "fetch-client-network" /* ErrorCode.FETCH_NETWORK */;
            if ((originalError === null || originalError === void 0 ? void 0 : originalError.name) === 'AbortError') {
                errorCode = "fetch-timeout" /* ErrorCode.FETCH_TIMEOUT */;
            }
            throw index_esm2017_ERROR_FACTORY.create(errorCode, {
                originalErrorMessage: originalError === null || originalError === void 0 ? void 0 : originalError.message
            });
        }
        let status = response.status;
        // Normalizes nullable header to optional.
        const responseEtag = response.headers.get('ETag') || undefined;
        let config;
        let state;
        // JSON parsing throws SyntaxError if the response body isn't a JSON string.
        // Requesting application/json and checking for a 200 ensures there's JSON data.
        if (response.status === 200) {
            let responseBody;
            try {
                responseBody = await response.json();
            }
            catch (originalError) {
                throw index_esm2017_ERROR_FACTORY.create("fetch-client-parse" /* ErrorCode.FETCH_PARSE */, {
                    originalErrorMessage: originalError === null || originalError === void 0 ? void 0 : originalError.message
                });
            }
            config = responseBody['entries'];
            state = responseBody['state'];
        }
        // Normalizes based on legacy state.
        if (state === 'INSTANCE_STATE_UNSPECIFIED') {
            status = 500;
        }
        else if (state === 'NO_CHANGE') {
            status = 304;
        }
        else if (state === 'NO_TEMPLATE' || state === 'EMPTY_CONFIG') {
            // These cases can be fixed remotely, so normalize to safe value.
            config = {};
        }
        // Normalize to exception-based control flow for non-success cases.
        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
        // differentiating success states (200 from 304; the state body param is undefined in a
        // standard 304).
        if (status !== 304 && status !== 200) {
            throw index_esm2017_ERROR_FACTORY.create("fetch-status" /* ErrorCode.FETCH_STATUS */, {
                httpStatus: status
            });
        }
        return { status, eTag: responseEtag, config };
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject) => {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(() => {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(index_esm2017_ERROR_FACTORY.create("fetch-throttle" /* ErrorCode.FETCH_THROTTLE */, {
                throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof dist_index_esm2017/* FirebaseError */.ZR) || !e.customData) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return (httpStatus === 429 ||
        httpStatus === 500 ||
        httpStatus === 503 ||
        httpStatus === 504);
}
/**
 * Decorates a Client with retry logic.
 *
 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
 * responses (because the SDK has no use for error responses).
 */
class RetryingClient {
    constructor(client, storage) {
        this.client = client;
        this.storage = storage;
    }
    async fetch(request) {
        const throttleMetadata = (await this.storage.getThrottleMetadata()) || {
            backoffCount: 0,
            throttleEndTimeMillis: Date.now()
        };
        return this.attemptFetch(request, throttleMetadata);
    }
    /**
     * A recursive helper for attempting a fetch request repeatedly.
     *
     * @throws any non-retriable errors.
     */
    async attemptFetch(request, { throttleEndTimeMillis, backoffCount }) {
        // Starts with a (potentially zero) timeout to support resumption from stored state.
        // Ensures the throttle end time is honored if the last attempt timed out.
        // Note the SDK will never make a request if the fetch timeout expires at this point.
        await setAbortableTimeout(request.signal, throttleEndTimeMillis);
        try {
            const response = await this.client.fetch(request);
            // Note the SDK only clears throttle state if response is success or non-retriable.
            await this.storage.deleteThrottleMetadata();
            return response;
        }
        catch (e) {
            if (!isRetriableError(e)) {
                throw e;
            }
            // Increments backoff state.
            const throttleMetadata = {
                throttleEndTimeMillis: Date.now() + (0,dist_index_esm2017/* calculateBackoffMillis */.$s)(backoffCount),
                backoffCount: backoffCount + 1
            };
            // Persists state.
            await this.storage.setThrottleMetadata(throttleMetadata);
            return this.attemptFetch(request, throttleMetadata);
        }
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1000; // One minute
const DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1000; // Twelve hours.
/**
 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
 *
 * See {@link https://github.com/firebase/firebase-js-sdk/blob/main/packages/firebase/index.d.ts|interface documentation} for method descriptions.
 */
class RemoteConfig {
    get fetchTimeMillis() {
        return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
    }
    get lastFetchStatus() {
        return this._storageCache.getLastFetchStatus() || 'no-fetch-yet';
    }
    constructor(
    // Required by FirebaseServiceFactory interface.
    app, 
    // JS doesn't support private yet
    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
    // underscore prefix.
    /**
     * @internal
     */
    _client, 
    /**
     * @internal
     */
    _storageCache, 
    /**
     * @internal
     */
    _storage, 
    /**
     * @internal
     */
    _logger) {
        this.app = app;
        this._client = _client;
        this._storageCache = _storageCache;
        this._storage = _storage;
        this._logger = _logger;
        /**
         * Tracks completion of initialization promise.
         * @internal
         */
        this._isInitializationComplete = false;
        this.settings = {
            fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
            minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
        };
        this.defaultConfig = {};
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
 */
function toFirebaseError(event, errorCode) {
    const originalError = event.target.error || undefined;
    return index_esm2017_ERROR_FACTORY.create(errorCode, {
        originalErrorMessage: originalError && (originalError === null || originalError === void 0 ? void 0 : originalError.message)
    });
}
/**
 * A general-purpose store keyed by app + namespace + {@link
 * ProjectNamespaceKeyFieldValue}.
 *
 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
 *
 * <p>Visible for testing.
 */
const APP_NAMESPACE_STORE = 'app_namespace_store';
const DB_NAME = 'firebase_remote_config';
const DB_VERSION = 1;
// Visible for testing.
function openDatabase() {
    return new Promise((resolve, reject) => {
        try {
            const request = indexedDB.open(DB_NAME, DB_VERSION);
            request.onerror = event => {
                reject(toFirebaseError(event, "storage-open" /* ErrorCode.STORAGE_OPEN */));
            };
            request.onsuccess = event => {
                resolve(event.target.result);
            };
            request.onupgradeneeded = event => {
                const db = event.target.result;
                // We don't use 'break' in this switch statement, the fall-through
                // behavior is what we want, because if there are multiple versions between
                // the old version and the current version, we want ALL the migrations
                // that correspond to those versions to run, not only the last one.
                // eslint-disable-next-line default-case
                switch (event.oldVersion) {
                    case 0:
                        db.createObjectStore(APP_NAMESPACE_STORE, {
                            keyPath: 'compositeKey'
                        });
                }
            };
        }
        catch (error) {
            reject(index_esm2017_ERROR_FACTORY.create("storage-open" /* ErrorCode.STORAGE_OPEN */, {
                originalErrorMessage: error === null || error === void 0 ? void 0 : error.message
            }));
        }
    });
}
/**
 * Abstracts data persistence.
 */
class Storage {
    /**
     * @param appId enables storage segmentation by app (ID + name).
     * @param appName enables storage segmentation by app (ID + name).
     * @param namespace enables storage segmentation by namespace.
     */
    constructor(appId, appName, namespace, openDbPromise = openDatabase()) {
        this.appId = appId;
        this.appName = appName;
        this.namespace = namespace;
        this.openDbPromise = openDbPromise;
    }
    getLastFetchStatus() {
        return this.get('last_fetch_status');
    }
    setLastFetchStatus(status) {
        return this.set('last_fetch_status', status);
    }
    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
    // consider adding timestamp to all storage records and an optional max age arg to getters.
    getLastSuccessfulFetchTimestampMillis() {
        return this.get('last_successful_fetch_timestamp_millis');
    }
    setLastSuccessfulFetchTimestampMillis(timestamp) {
        return this.set('last_successful_fetch_timestamp_millis', timestamp);
    }
    getLastSuccessfulFetchResponse() {
        return this.get('last_successful_fetch_response');
    }
    setLastSuccessfulFetchResponse(response) {
        return this.set('last_successful_fetch_response', response);
    }
    getActiveConfig() {
        return this.get('active_config');
    }
    setActiveConfig(config) {
        return this.set('active_config', config);
    }
    getActiveConfigEtag() {
        return this.get('active_config_etag');
    }
    setActiveConfigEtag(etag) {
        return this.set('active_config_etag', etag);
    }
    getThrottleMetadata() {
        return this.get('throttle_metadata');
    }
    setThrottleMetadata(metadata) {
        return this.set('throttle_metadata', metadata);
    }
    deleteThrottleMetadata() {
        return this.delete('throttle_metadata');
    }
    async get(key) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readonly');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.get(compositeKey);
                request.onerror = event => {
                    reject(toFirebaseError(event, "storage-get" /* ErrorCode.STORAGE_GET */));
                };
                request.onsuccess = event => {
                    const result = event.target.result;
                    if (result) {
                        resolve(result.value);
                    }
                    else {
                        resolve(undefined);
                    }
                };
            }
            catch (e) {
                reject(index_esm2017_ERROR_FACTORY.create("storage-get" /* ErrorCode.STORAGE_GET */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    async set(key, value) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.put({
                    compositeKey,
                    value
                });
                request.onerror = (event) => {
                    reject(toFirebaseError(event, "storage-set" /* ErrorCode.STORAGE_SET */));
                };
                request.onsuccess = () => {
                    resolve();
                };
            }
            catch (e) {
                reject(index_esm2017_ERROR_FACTORY.create("storage-set" /* ErrorCode.STORAGE_SET */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    async delete(key) {
        const db = await this.openDbPromise;
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
            const objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
            const compositeKey = this.createCompositeKey(key);
            try {
                const request = objectStore.delete(compositeKey);
                request.onerror = (event) => {
                    reject(toFirebaseError(event, "storage-delete" /* ErrorCode.STORAGE_DELETE */));
                };
                request.onsuccess = () => {
                    resolve();
                };
            }
            catch (e) {
                reject(index_esm2017_ERROR_FACTORY.create("storage-delete" /* ErrorCode.STORAGE_DELETE */, {
                    originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                }));
            }
        });
    }
    // Facilitates composite key functionality (which is unsupported in IE).
    createCompositeKey(key) {
        return [this.appId, this.appName, this.namespace, key].join();
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A memory cache layer over storage to support the SDK's synchronous read requirements.
 */
class StorageCache {
    constructor(storage) {
        this.storage = storage;
    }
    /**
     * Memory-only getters
     */
    getLastFetchStatus() {
        return this.lastFetchStatus;
    }
    getLastSuccessfulFetchTimestampMillis() {
        return this.lastSuccessfulFetchTimestampMillis;
    }
    getActiveConfig() {
        return this.activeConfig;
    }
    /**
     * Read-ahead getter
     */
    async loadFromStorage() {
        const lastFetchStatusPromise = this.storage.getLastFetchStatus();
        const lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
        const activeConfigPromise = this.storage.getActiveConfig();
        // Note:
        // 1. we consistently check for undefined to avoid clobbering defined values
        //   in memory
        // 2. we defer awaiting to improve readability, as opposed to destructuring
        //   a Promise.all result, for example
        const lastFetchStatus = await lastFetchStatusPromise;
        if (lastFetchStatus) {
            this.lastFetchStatus = lastFetchStatus;
        }
        const lastSuccessfulFetchTimestampMillis = await lastSuccessfulFetchTimestampMillisPromise;
        if (lastSuccessfulFetchTimestampMillis) {
            this.lastSuccessfulFetchTimestampMillis =
                lastSuccessfulFetchTimestampMillis;
        }
        const activeConfig = await activeConfigPromise;
        if (activeConfig) {
            this.activeConfig = activeConfig;
        }
    }
    /**
     * Write-through setters
     */
    setLastFetchStatus(status) {
        this.lastFetchStatus = status;
        return this.storage.setLastFetchStatus(status);
    }
    setLastSuccessfulFetchTimestampMillis(timestampMillis) {
        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
    }
    setActiveConfig(activeConfig) {
        this.activeConfig = activeConfig;
        return this.storage.setActiveConfig(activeConfig);
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerRemoteConfig() {
    (0,index_esm2017/* _registerComponent */.Xd)(new esm_index_esm2017/* Component */.wA(RC_COMPONENT_NAME, remoteConfigFactory, "PUBLIC" /* ComponentType.PUBLIC */).setMultipleInstances(true));
    (0,index_esm2017/* registerVersion */.KN)(esm_index_esm2017_name, index_esm2017_version);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0,index_esm2017/* registerVersion */.KN)(esm_index_esm2017_name, index_esm2017_version, 'esm2017');
    function remoteConfigFactory(container, { instanceIdentifier: namespace }) {
        /* Dependencies */
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        // The following call will always succeed because rc has `import '@firebase/installations'`
        const installations = container
            .getProvider('installations-internal')
            .getImmediate();
        // Guards against the SDK being used in non-browser environments.
        if (typeof window === 'undefined') {
            throw index_esm2017_ERROR_FACTORY.create("registration-window" /* ErrorCode.REGISTRATION_WINDOW */);
        }
        // Guards against the SDK being used when indexedDB is not available.
        if (!(0,dist_index_esm2017/* isIndexedDBAvailable */.hl)()) {
            throw index_esm2017_ERROR_FACTORY.create("indexed-db-unavailable" /* ErrorCode.INDEXED_DB_UNAVAILABLE */);
        }
        // Normalizes optional inputs.
        const { projectId, apiKey, appId } = app.options;
        if (!projectId) {
            throw index_esm2017_ERROR_FACTORY.create("registration-project-id" /* ErrorCode.REGISTRATION_PROJECT_ID */);
        }
        if (!apiKey) {
            throw index_esm2017_ERROR_FACTORY.create("registration-api-key" /* ErrorCode.REGISTRATION_API_KEY */);
        }
        if (!appId) {
            throw index_esm2017_ERROR_FACTORY.create("registration-app-id" /* ErrorCode.REGISTRATION_APP_ID */);
        }
        namespace = namespace || 'firebase';
        const storage = new Storage(appId, app.name, namespace);
        const storageCache = new StorageCache(storage);
        const logger = new dist_esm_index_esm2017/* Logger */.Yd(esm_index_esm2017_name);
        // Sets ERROR as the default log level.
        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
        logger.logLevel = dist_esm_index_esm2017/* LogLevel.ERROR */["in"].ERROR;
        const restClient = new RestClient(installations, 
        // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
        index_esm2017/* SDK_VERSION */.Jn, namespace, projectId, apiKey, appId);
        const retryingClient = new RetryingClient(restClient, storage);
        const cachingClient = new CachingClient(retryingClient, storage, storageCache, logger);
        const remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger);
        // Starts warming cache.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        ensureInitialized(remoteConfigInstance);
        return remoteConfigInstance;
    }
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// This API is put in a separate file, so we can stub fetchConfig and activate in tests.
// It's not possible to stub standalone functions from the same module.
/**
 *
 * Performs fetch and activate operations, as a convenience.
 *
 * @param remoteConfig - The {@link RemoteConfig} instance.
 *
 * @returns A `Promise` which resolves to true if the current call activated the fetched configs.
 * If the fetched configs were already activated, the `Promise` will resolve to false.
 *
 * @public
 */
async function fetchAndActivate(remoteConfig) {
    remoteConfig = (0,dist_index_esm2017/* getModularInstance */.m9)(remoteConfig);
    await fetchConfig(remoteConfig);
    return activate(remoteConfig);
}
/**
 * This method provides two different checks:
 *
 * 1. Check if IndexedDB exists in the browser environment.
 * 2. Check if the current browser context allows IndexedDB `open()` calls.
 *
 * @returns A `Promise` which resolves to true if a {@link RemoteConfig} instance
 * can be initialized in this environment, or false if it cannot.
 * @public
 */
async function isSupported() {
    if (!isIndexedDBAvailable()) {
        return false;
    }
    try {
        const isDBOpenable = await validateIndexedDBOpenable();
        return isDBOpenable;
    }
    catch (error) {
        return false;
    }
}

/**
 * The Firebase Remote Config Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */
/** register component and version */
registerRemoteConfig();


//# sourceMappingURL=index.esm2017.js.map

;// CONCATENATED MODULE: ../../node_modules/firebase/remote-config/dist/esm/index.esm.js

//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 55389:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X3": function() { return /* binding */ openDB; }
});

// UNUSED EXPORTS: deleteDB, unwrap, wrap

;// CONCATENATED MODULE: ../../node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap_idb_value_wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap_idb_value_wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap_idb_value_wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap_idb_value_wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap_idb_value_wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap_idb_value_wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ../../node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap_idb_value_wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap_idb_value_wrap(request.result), event.oldVersion, event.newVersion, wrap_idb_value_wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));




/***/ }),

/***/ 83596:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"আহমেদাবাদ থেকে মুম্বাই LCV","bangalore-to-chennai":"বেঙ্গালুরু থেকে চেন্নাই LCV","bangalore-to-hyderabad":"বেঙ্গালুরু থেকে হায়দ্রাবাদ LCV","chennai-to-bangalore":"চেন্নাই থেকে বেঙ্গালুরু LCV","chennai-to-hyderabad":"চেন্নাই থেকে হায়দ্রাবাদ LCV","hyderabad-to-bangalore":"হায়দ্রাবাদ থেকে বেঙ্গালুরু LCV","hyderabad-to-chennai":"হায়দ্রাবাদ থেকে চেন্নাই LCV","delhi-to-jaipur":"দিল্লি থেকে জয়পুর LCV","delhi-to-kolkata":"দিল্লি থেকে কলকাতা LCV","delhi-to-mumbai":"দিল্লি থেকে মুম্বাই LCV","jaipur-to-delhi":"জয়পুর থেকে দিল্লি LCV","kolkata-to-delhi":"কলকাতা থেকে দিল্লি LCV","mumbai-to-ahmedabad":"মুম্বাই থেকে আহমেদাবাদ LCV","mumbai-to-delhi":"মুম্বাই থেকে দিল্লি LCV","mumbai-to-pune":"পুনে থেকে মুম্বাই LCV","pune-to-mumbai":"পুনে থেকে মুম্বাই LCV"}},"_j":{"kolkata-to-delhi":{"seo":{"title":"কলকাতা থেকে দিল্লি LCV বুক করুন | Vahak","description":"কয়েক মিনিটে কলকাতা থেকে দিল্লি যাচাইকৃত LCV বুক করুন। লাইভ ট্র্যাকিং, কার্গো বীমা, কোনো লুকানো চার্জ নেই। এই রুটে 500+ যাচাইকৃত ট্রান্সপোর্টার।"},"pickupCity":"কলকাতা","dropCity":"দিল্লি","heroHeadline2Lines":["কলকাতা থেকে","দিল্লি পর্যন্ত"],"heroSub":"যাচাইকৃত ট্রান্সপোর্টার। লাইভ ট্র্যাকিং।","breadcrumbRouteName":"কলকাতা থেকে দিল্লি","aboutText":"কলকাতা থেকে দিল্লি NH19 (ঐতিহাসিক গ্র্যান্ড ট্রাঙ্ক রোড) ধরে 1,500 কিমি দীর্ঘ একটি করিডোর, যা সড়কপথে LCV শিপমেন্টের জন্য সাধারণত 28-30 ঘণ্টায় অতিক্রম করা হয়। এটি কলকাতার বন্দর ও পূর্ব ভারতের বাণিজ্য কেন্দ্রকে দিল্লি NCR-এর শিল্প ও বাণিজ্যিক কেন্দ্রের সাথে সংযুক্তকারী একটি গুরুত্বপূর্ণ দীর্ঘ-দূরত্বের মালবাহী রুট — এটি সাধারণত পাট, চা, ইঞ্জিনিয়ারিং সামগ্রী, বস্ত্র এবং FMCG শিপমেন্টের জন্য ব্যবহৃত হয়।","footerSeoText":"Vahak হলো সারা ভারতে শিপারদের যাচাইকৃত ট্রান্সপোর্টারদের সাথে সংযুক্তকারী একটি অনলাইন LCV বুকিং মার্কেটপ্লেস। কলকাতা-দিল্লি রুটে, ব্যবসাগুলো পার্ট-লোড এবং ফুল-লোড LCV শিপমেন্টের জন্য Tata Ace, Tempo, Tata 407 এবং পিকআপ গাড়ি বুক করতে Vahak ব্যবহার করে, প্রতিটি বুকিংয়ে লাইভ ট্র্যাকিং এবং কার্গো বীমাসহ।","faqs":[{"question":"কলকাতা থেকে দিল্লি একই দিনে LCV পাওয়া যায় কি?","answer":"হ্যাঁ, সাধারণত একই দিনে পিকআপ পাওয়া যায়। এই রুটে বেশিরভাগ বুকিংয়ের জন্য 10 মিনিটের মধ্যে ট্রান্সপোর্টার নিশ্চিত হয়।","defaultOpen":true},{"question":"কলকাতা থেকে দিল্লি LCV-র খরচ কত?","answer":"দাম লোডের ওজন, LCV-র আকার এবং মরসুম অনুযায়ী পরিবর্তিত হয়, কোনো লুকানো চার্জ নেই। আপনার লোডের জন্য নির্দিষ্ট অনুমানের জন্য উপরের মূল্য অনুমান টুল ব্যবহার করুন।"},{"question":"যাতায়াতের সময় আমার মালামালের বীমা আছে কি?","answer":"হ্যাঁ, যাতায়াতের সময় আপনার মালামাল রক্ষা করতে এই রুটে কার্গো বীমা পাওয়া যায়।"},{"question":"কলকাতা থেকে দিল্লি 1 টন লোডের জন্য কোন আকারের LCV দরকার?","answer":"1 টন লোড সাধারণত Tata Ace বা Tata 407-এর মতো স্ট্যান্ডার্ড LCV-তে ফিট হয়। বুকিং করার সময় আপনার লোডের বিবরণ লিখুন এবং Vahak সঠিক আকার সুপারিশ করবে।"},{"question":"আমি কি আগামীকালের জন্য পিকআপ শিডিউল করতে পারি?","answer":"হ্যাঁ, আপনি শুধু একই দিনেই নয়, যেকোনো ভবিষ্যতের তারিখের জন্য পিকআপ শিডিউল করতে পারেন। লোড পোস্ট করার সময় আপনার পছন্দের পিকআপ সময় সেট করুন।"},{"question":"LCV-র জন্য সর্বোচ্চ পেলোড কত?","answer":"এই রুটে বেশিরভাগ LCV 3.5 টন পর্যন্ত বহন করতে পারে। আপনার লোডের ওজনের উপর ভিত্তি করে Vahak সঠিক গাড়ির আকারের সাথে মিলিয়ে দেবে।"}],"popularRoutes":[{"label":"কলকাতা থেকে ভুবনেশ্বর"},{"label":"দিল্লি থেকে জয়পুর"},{"label":"কলকাতা থেকে পাটনা"}],"vehicleTypes":[{"label":"টাটা এস"},{"label":"টেম্পো"},{"label":"টাটা 407"},{"label":"পিকআপ"}]}},"cA":{"kolkata":{"seo":{"title":"কলকাতায় LCV বুক করুন | Vahak","description":"কয়েক মিনিটে কলকাতায় যাচাইকৃত LCV বুক করুন। লাইভ ট্র্যাকিং, কার্গো বীমা, কোনো লুকানো চার্জ নেই।"},"pickupCity":"কলকাতা","dropPlaceholder":"ড্রপ লোকেশন লিখুন","heroHeadline2Lines":["কলকাতা"],"heroSub":"যাচাইকৃত ট্রান্সপোর্টার। লাইভ ট্র্যাকিং।","breadcrumbCityName":"কলকাতা","trustStrip":"কলকাতায় 7,000+ যাচাইকৃত ট্রান্সপোর্টার","aboutTitle":"কলকাতা পরিবহন সম্পর্কে","aboutText":"কলকাতা, ভারতের পূর্বাঞ্চলীয় প্রবেশদ্বার বন্দর শহর, পাট, প্রকৌশল, IT পরিষেবা এবং চামড়া শিল্পে মালবাহী চাহিদা বাড়ায়। প্রতিদিন বিপুল পরিমাণ চা, পাট এবং প্রকৌশল সামগ্রীর চালান শহর থেকে NH19 এবং NH16 এর মতো ফ্রেট করিডোরের সাথে সংযুক্ত হয়ে যাতায়াত করে।","tags":["পাট ও বস্ত্র","প্রকৌশল সামগ্রী","IT পরিষেবা","চামড়া","বন্দর ও শিপিং"],"proofStats":[{"value":"7,000+","label":"কলকাতায় যাচাইকৃত ট্রান্সপোর্টার"},{"value":"10 মিনিট","label":"LCV বুক করার সময়"}],"localResources":{"title":"স্থানীয় তথ্য","dhabas":[{"name":"আজাদ হিন্দ ধাবা","location":"NH19, গোপালপুর, পশ্চিমবঙ্গ"}],"contacts":[{"label":"পুলিশ","number":"100"},{"label":"অ্যাম্বুলেন্স","number":"108"},{"label":"কলকাতা ট্রাফিক পুলিশ হেল্পলাইন","number":"1073"},{"label":"জাতীয় সড়ক হেল্পলাইন","number":"1033"}],"moreToggle":"পেট্রোল পাম্প, সার্ভিস স্টেশন, হাসপাতাল দেখুন","note":"প্রদর্শিত জরুরি নম্বরগুলি প্রমিত রাজ্য/জাতীয় হেল্পলাইন — প্রকাশ করার আগে একটি সরকারি সূত্র থেকে যাচাই করুন।"},"faqs":[{"question":"কলকাতা শহরের সীমানার মধ্যে ট্রাক প্রবেশে কি কোনো বিধিনিষেধ আছে?","answer":"কিছু অভ্যন্তরীণ শহরের রাস্তায় ব্যস্ত সময়ে ভারী যানবাহনের চলাচল সীমিত থাকে। Vahak ট্রান্সপোর্টাররা এই নিয়মগুলি অনুযায়ী পিকআপ এবং ড্রপের সময় স্বয়ংক্রিয়ভাবে পরিকল্পনা করে।","defaultOpen":true},{"question":"কলকাতায় LCV এর দাম কীভাবে নির্ধারিত হয়?","answer":"দাম নির্ভর করে দূরত্ব, লোডের ওজন, গাড়ির ধরন এবং আপনার রুটে বর্তমান চাহিদার উপর। আপনি বিনামূল্যে আপনার লোড পোস্ট করতে পারেন এবং যাচাইকৃত ট্রান্সপোর্টারদের বিড তুলনা করতে পারেন।"},{"question":"আমার বুকিংয়ের জন্য কি আমি GST ইনভয়েস পাব?","answer":"হ্যাঁ, Vahak এর মাধ্যমে করা প্রতিটি বুকিংয়ের জন্য GST ইনভয়েস দেওয়া হয়, যা আপনার লোড নিশ্চিত হওয়ার সাথে সাথে স্বয়ংক্রিয়ভাবে তৈরি হয়।"},{"question":"যদি আমার লোড সময়মতো পিকআপ না হয় তাহলে কী হবে?","answer":"Vahak এর সাপোর্ট টিম প্রতিটি সক্রিয় বুকিং পর্যবেক্ষণ করে এবং পিকআপ বিলম্বিত হলে আপনার লোড অন্য একজন যাচাইকৃত ট্রান্সপোর্টারকে পুনরায় বরাদ্দ করতে হস্তক্ষেপ করে।"}],"popularRoutesLabel":"কলকাতা থেকে জনপ্রিয় রুট","popularRoutes":[{"label":"কলকাতা থেকে দিল্লি","href":"/lcv-booking/kolkata-to-delhi"}],"vehicleTypesLabel":"গাড়ির ধরন অনুযায়ী বুক করুন","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak একটি অনলাইন LCV বুকিং মার্কেটপ্লেস যা শিপারদের সারা ভারতের যাচাইকৃত ট্রান্সপোর্টারদের সাথে সংযুক্ত করে। কলকাতায়, ব্যবসাগুলি Vahak ব্যবহার করে পার্ট-লোড এবং ফুল-লোড LCV চালানের জন্য Tata Ace, Tempo, Tata 407 এবং Pickup গাড়ি বুক করে, প্রতিটি বুকিংয়ে লাইভ ট্র্যাকিং এবং কার্গো বীমা সহ।","footerGroups":[{"label":"কলকাতা থেকে জনপ্রিয় রুট","links":[{"label":"কলকাতা থেকে দিল্লি LCV","href":"/lcv-booking/kolkata-to-delhi"}],"moreLink":{"label":"সব রুট দেখুন →","href":"/lcv-booking"}},{"label":"অন্যান্য শহরে LCV বুক করুন","links":[{"label":"মুম্বাই","href":"/city/mumbai"},{"label":"দিল্লি","href":"/city/delhi"},{"label":"ব্যাঙ্গালোর","href":"/city/bangalore"},{"label":"আহমেদাবাদ","href":"/city/ahmedabad"}],"moreLink":{"label":"সব শহর দেখুন →","href":"/"}},{"label":"গাড়ির ধরন","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"কোম্পানি","links":[{"label":"আমাদের সম্পর্কে","href":"/about-us"},{"label":"কর্মজীবন","href":"/careers"},{"label":"যোগাযোগ করুন","href":"/contact-us"}]},{"label":"আইনি","links":[{"label":"শর্তাবলী","href":"/terms-and-conditions"},{"label":"গোপনীয়তা নীতি","href":"/privacy-policy"},{"label":"প্রায়শই জিজ্ঞাসিত প্রশ্ন","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 84941:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"Ahmedabad to Mumbai LCV","bangalore-to-chennai":"Bangalore to Chennai LCV","bangalore-to-hyderabad":"Bangalore to Hyderabad LCV","chennai-to-bangalore":"Chennai to Bangalore LCV","chennai-to-hyderabad":"Chennai to Hyderabad LCV","hyderabad-to-bangalore":"Hyderabad to Bangalore LCV","hyderabad-to-chennai":"Hyderabad to Chennai LCV","delhi-to-jaipur":"Delhi to Jaipur LCV","delhi-to-kolkata":"Delhi to Kolkata LCV","delhi-to-mumbai":"Delhi to Mumbai LCV","jaipur-to-delhi":"Jaipur to Delhi LCV","kolkata-to-delhi":"Kolkata to Delhi LCV","mumbai-to-ahmedabad":"Mumbai to Ahmedabad LCV","mumbai-to-delhi":"Mumbai to Delhi LCV","mumbai-to-pune":"Mumbai to Pune LCV","pune-to-mumbai":"Pune to Mumbai LCV"}},"_j":{"bangalore-to-hyderabad":{"seo":{"title":"Book LCV from Bangalore to Hyderabad | Vahak","description":"Book a verified LCV from Bangalore to Hyderabad in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Bangalore","dropCity":"Hyderabad","heroHeadline2Lines":["Bangalore","to Hyderabad"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Bangalore to Hyderabad","aboutText":"Bangalore to Hyderabad is a 570 km corridor along NH44, typically covered in 10-12 hours by road. It\'s a key freight lane connecting Karnataka\'s electronics and tech manufacturing base with Hyderabad\'s pharma, IT and industrial hubs — commonly used for electronics, pharma goods, textiles and machinery shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Bangalore to Hyderabad corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Bangalore to Hyderabad?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Bangalore to Hyderabad?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Bangalore to Hyderabad?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Bangalore to Chennai"},{"label":"Hyderabad to Chennai"},{"label":"Bangalore to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"hyderabad-to-bangalore":{"seo":{"title":"Book LCV from Hyderabad to Bangalore | Vahak","description":"Book a verified LCV from Hyderabad to Bangalore in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Hyderabad","dropCity":"Bangalore","heroHeadline2Lines":["Hyderabad","to Bangalore"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Hyderabad to Bangalore","aboutText":"Hyderabad to Bangalore is a 570 km corridor along NH44, typically covered in 10-12 hours by road. It\'s a key freight lane connecting Hyderabad\'s pharma, IT and industrial hubs with Karnataka\'s electronics and tech manufacturing base — commonly used for pharma goods, electronics, textiles and machinery shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Hyderabad to Bangalore corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Hyderabad to Bangalore?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Hyderabad to Bangalore?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Hyderabad to Bangalore?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Hyderabad to Chennai"},{"label":"Bangalore to Chennai"},{"label":"Hyderabad to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"delhi-to-jaipur":{"seo":{"title":"Book LCV from Delhi to Jaipur | Vahak","description":"Book a verified LCV from Delhi to Jaipur in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Delhi","dropCity":"Jaipur","heroHeadline2Lines":["Delhi","to Jaipur"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Delhi to Jaipur","aboutText":"Delhi to Jaipur is a 280 km corridor along NH48, typically covered in 5-6 hours by road. It\'s a key freight lane connecting the NCR\'s industrial and manufacturing base with Jaipur\'s textile, handicraft and gems and jewellery trade — commonly used for textiles, handicrafts, electronics and FMCG shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Delhi to Jaipur corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Delhi to Jaipur?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Delhi to Jaipur?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Delhi to Jaipur?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Delhi to Chandigarh"},{"label":"Jaipur to Udaipur"},{"label":"Delhi to Agra"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"jaipur-to-delhi":{"seo":{"title":"Book LCV from Jaipur to Delhi | Vahak","description":"Book a verified LCV from Jaipur to Delhi in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Jaipur","dropCity":"Delhi","heroHeadline2Lines":["Jaipur","to Delhi"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Jaipur to Delhi","aboutText":"Jaipur to Delhi is a 280 km corridor along NH48, typically covered in 5-6 hours by road. It\'s a key freight lane connecting Jaipur\'s textile, handicraft and gems and jewellery trade with the NCR\'s industrial and manufacturing base — commonly used for textiles, handicrafts, electronics and FMCG shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Jaipur to Delhi corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Jaipur to Delhi?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Jaipur to Delhi?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Jaipur to Delhi?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Jaipur to Udaipur"},{"label":"Delhi to Chandigarh"},{"label":"Delhi to Agra"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"mumbai-to-pune":{"seo":{"title":"Book LCV from Mumbai to Pune | Vahak","description":"Book a verified LCV from Mumbai to Pune in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Mumbai","dropCity":"Pune","heroHeadline2Lines":["Mumbai","to Pune"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Mumbai to Pune","aboutText":"Mumbai to Pune is a 150 km corridor along the Mumbai-Pune Expressway (NH48), typically covered in 3-4 hours by road. It\'s one of Maharashtra\'s busiest freight lanes, connecting Mumbai\'s commercial and FMCG hub with Pune\'s automotive, auto-ancillary and IT manufacturing base — commonly used for auto parts, FMCG, pharma and electronics shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Mumbai to Pune corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Mumbai to Pune?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Mumbai to Pune?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Mumbai to Pune?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Mumbai to Ahmedabad"},{"label":"Pune to Nashik"},{"label":"Mumbai to Nashik"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"pune-to-mumbai":{"seo":{"title":"Book LCV from Pune to Mumbai | Vahak","description":"Book a verified LCV from Pune to Mumbai in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Pune","dropCity":"Mumbai","heroHeadline2Lines":["Pune","to Mumbai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Pune to Mumbai","aboutText":"Pune to Mumbai is a 150 km corridor along the Mumbai-Pune Expressway (NH48), typically covered in 3-4 hours by road. It\'s one of Maharashtra\'s busiest freight lanes, connecting Pune\'s automotive, auto-ancillary and IT manufacturing base with Mumbai\'s commercial and FMCG hub — commonly used for auto parts, FMCG, pharma and electronics shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Pune to Mumbai corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Pune to Mumbai?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Pune to Mumbai?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Pune to Mumbai?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Pune to Nashik"},{"label":"Mumbai to Ahmedabad"},{"label":"Mumbai to Nashik"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"delhi-to-mumbai":{"seo":{"title":"Book LCV from Delhi to Mumbai | Vahak","description":"Book a verified LCV from Delhi to Mumbai in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Delhi","dropCity":"Mumbai","heroHeadline2Lines":["Delhi","to Mumbai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Delhi to Mumbai","aboutText":"Delhi to Mumbai is a 1,400 km corridor along NH48, typically covered in 24-28 hours by road for LCV shipments. It\'s one of India\'s busiest long-haul freight lanes, connecting Delhi NCR\'s industrial and trading base with Mumbai\'s commercial and financial hub — commonly used for FMCG, textiles, electronics and machinery shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Delhi to Mumbai corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Delhi to Mumbai?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Delhi to Mumbai?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Delhi to Mumbai?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Delhi to Jaipur"},{"label":"Mumbai to Ahmedabad"},{"label":"Pune to Mumbai"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"mumbai-to-delhi":{"seo":{"title":"Book LCV from Mumbai to Delhi | Vahak","description":"Book a verified LCV from Mumbai to Delhi in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Mumbai","dropCity":"Delhi","heroHeadline2Lines":["Mumbai","to Delhi"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Mumbai to Delhi","aboutText":"Mumbai to Delhi is a 1,400 km corridor along NH48, typically covered in 24-28 hours by road for LCV shipments. It\'s one of India\'s busiest long-haul freight lanes, connecting Mumbai\'s commercial and financial hub with Delhi NCR\'s industrial and trading base — commonly used for FMCG, textiles, electronics and machinery shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Mumbai to Delhi corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Mumbai to Delhi?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Mumbai to Delhi?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Mumbai to Delhi?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Mumbai to Ahmedabad"},{"label":"Delhi to Jaipur"},{"label":"Mumbai to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"delhi-to-kolkata":{"seo":{"title":"Book LCV from Delhi to Kolkata | Vahak","description":"Book a verified LCV from Delhi to Kolkata in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Delhi","dropCity":"Kolkata","heroHeadline2Lines":["Delhi","to Kolkata"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Delhi to Kolkata","aboutText":"Delhi to Kolkata is a 1,500 km corridor along NH19 (the historic Grand Trunk Road), typically covered in 28-30 hours by road for LCV shipments. It\'s a key long-haul freight lane connecting Delhi NCR\'s industrial and trading base with Kolkata\'s port and eastern trade hub — commonly used for engineering goods, textiles, FMCG and general trade shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Delhi to Kolkata corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Delhi to Kolkata?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Delhi to Kolkata?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Delhi to Kolkata?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Delhi to Jaipur"},{"label":"Kolkata to Patna"},{"label":"Kolkata to Bhubaneswar"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"kolkata-to-delhi":{"seo":{"title":"Book LCV from Kolkata to Delhi | Vahak","description":"Book a verified LCV from Kolkata to Delhi in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Kolkata","dropCity":"Delhi","heroHeadline2Lines":["Kolkata","to Delhi"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Kolkata to Delhi","aboutText":"Kolkata to Delhi is a 1,500 km corridor along NH19 (the historic Grand Trunk Road), typically covered in 28-30 hours by road for LCV shipments. It\'s a key long-haul freight lane connecting Kolkata\'s port and eastern trade hub with Delhi NCR\'s industrial and trading base — commonly used for jute, tea, engineering goods, textiles and FMCG shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Kolkata to Delhi corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Kolkata to Delhi?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Kolkata to Delhi?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Kolkata to Delhi?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Kolkata to Bhubaneswar"},{"label":"Delhi to Jaipur"},{"label":"Kolkata to Patna"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"ahmedabad-to-mumbai":{"seo":{"title":"Book LCV from Ahmedabad to Mumbai | Vahak","description":"Book a verified LCV from Ahmedabad to Mumbai in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Ahmedabad","dropCity":"Mumbai","heroHeadline2Lines":["Ahmedabad","to Mumbai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Ahmedabad to Mumbai","aboutText":"Ahmedabad to Mumbai is a 530 km corridor along NH48, typically covered in 9-10 hours by road. It connects Gujarat\'s textile, chemical and pharmaceutical manufacturing base with Mumbai\'s commercial, port and FMCG hub — commonly used for textiles, chemicals, pharma and FMCG shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Ahmedabad to Mumbai corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Ahmedabad to Mumbai?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Ahmedabad to Mumbai?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Ahmedabad to Mumbai?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Mumbai to Pune"},{"label":"Ahmedabad to Surat"},{"label":"Mumbai to Delhi"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"mumbai-to-ahmedabad":{"seo":{"title":"Book LCV from Mumbai to Ahmedabad | Vahak","description":"Book a verified LCV from Mumbai to Ahmedabad in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Mumbai","dropCity":"Ahmedabad","heroHeadline2Lines":["Mumbai","to Ahmedabad"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Mumbai to Ahmedabad","aboutText":"Mumbai to Ahmedabad is a 530 km corridor along NH48, typically covered in 9-10 hours by road. It connects Mumbai\'s commercial, port and FMCG hub with Gujarat\'s textile, chemical and pharmaceutical manufacturing base — commonly used for textiles, chemicals, pharma and FMCG shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Mumbai to Ahmedabad corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Mumbai to Ahmedabad?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Mumbai to Ahmedabad?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Mumbai to Ahmedabad?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Mumbai to Pune"},{"label":"Ahmedabad to Surat"},{"label":"Mumbai to Delhi"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"chennai-to-hyderabad":{"seo":{"title":"Book LCV from Chennai to Hyderabad | Vahak","description":"Book a verified LCV from Chennai to Hyderabad in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Chennai","dropCity":"Hyderabad","heroHeadline2Lines":["Chennai","to Hyderabad"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Chennai to Hyderabad","aboutText":"Chennai to Hyderabad is a 625 km corridor along NH16, typically covered in 10-11 hours by road. It connects Chennai\'s automotive and leather manufacturing base with Hyderabad\'s pharma, IT and industrial hubs — commonly used for auto parts, leather goods, pharma, electronics and textiles shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Chennai to Hyderabad corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Chennai to Hyderabad?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Chennai to Hyderabad?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Chennai to Hyderabad?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Chennai to Bangalore"},{"label":"Bangalore to Hyderabad"},{"label":"Hyderabad to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"hyderabad-to-chennai":{"seo":{"title":"Book LCV from Hyderabad to Chennai | Vahak","description":"Book a verified LCV from Hyderabad to Chennai in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Hyderabad","dropCity":"Chennai","heroHeadline2Lines":["Hyderabad","to Chennai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Hyderabad to Chennai","aboutText":"Hyderabad to Chennai is a 625 km corridor along NH16, typically covered in 10-11 hours by road. It connects Hyderabad\'s pharma, IT and industrial hubs with Chennai\'s automotive and leather manufacturing base — commonly used for pharma, electronics, auto parts, leather goods and textiles shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Hyderabad to Chennai corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Hyderabad to Chennai?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Hyderabad to Chennai?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Hyderabad to Chennai?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Hyderabad to Bangalore"},{"label":"Chennai to Bangalore"},{"label":"Hyderabad to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"bangalore-to-chennai":{"seo":{"title":"Book LCV from Bangalore to Chennai | Vahak","description":"Book a verified LCV from Bangalore to Chennai in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Bangalore","dropCity":"Chennai","heroHeadline2Lines":["Bangalore","to Chennai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Bangalore to Chennai","aboutText":"Bangalore to Chennai is a 350 km corridor along NH48, typically covered in 6-7 hours by road. It connects Karnataka\'s electronics and tech manufacturing base with Chennai\'s automotive and auto-ancillary hub — commonly used for auto parts, electronics, IT hardware, leather goods and textiles shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Bangalore to Chennai corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Bangalore to Chennai?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Bangalore to Chennai?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Bangalore to Chennai?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Bangalore to Hyderabad"},{"label":"Chennai to Hyderabad"},{"label":"Bangalore to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]},"chennai-to-bangalore":{"seo":{"title":"Book LCV from Chennai to Bangalore | Vahak","description":"Book a verified LCV from Chennai to Bangalore in minutes. Live tracking, cargo insurance, no hidden charges. 500+ verified transporters on this route."},"pickupCity":"Chennai","dropCity":"Bangalore","heroHeadline2Lines":["Chennai","to Bangalore"],"heroSub":"Verified transporters. Live tracking.","breadcrumbRouteName":"Chennai to Bangalore","aboutText":"Chennai to Bangalore is a 350 km corridor along NH48, typically covered in 6-7 hours by road. It connects Chennai\'s automotive and auto-ancillary hub with Karnataka\'s electronics and tech manufacturing base — commonly used for auto parts, electronics, IT hardware, leather goods and textiles shipments.","footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. On the Chennai to Bangalore corridor, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","faqs":[{"question":"Is LCV available same-day, Chennai to Bangalore?","answer":"Yes, same-day pickup is usually available. Most bookings on this route get a confirmed transporter within 10 minutes.","defaultOpen":true},{"question":"How much does an LCV cost, Chennai to Bangalore?","answer":"Prices vary by load weight, LCV size and season, with no hidden charges. Use the price estimate tool above for a quote specific to your load."},{"question":"Is my cargo insured during transit?","answer":"Yes, cargo insurance is available on this route to cover your goods during transit."},{"question":"What size LCV do I need for a 1 tonne load, Chennai to Bangalore?","answer":"A 1 tonne load typically fits a standard LCV such as a Tata Ace or Tata 407. Enter your load details when booking and Vahak will suggest the right size."},{"question":"Can I schedule pickup for tomorrow?","answer":"Yes, you can schedule pickup for any future date, not just same-day. Just set your preferred pickup time when posting the load."},{"question":"What is the maximum payload for an LCV?","answer":"Most LCVs on this route carry up to 3.5 tonnes. Vahak will match you with the right vehicle size based on your load weight."}],"popularRoutes":[{"label":"Chennai to Hyderabad"},{"label":"Bangalore to Hyderabad"},{"label":"Bangalore to Pune"}],"vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}]}},"cA":{"ahmedabad":{"seo":{"title":"Book LCV in Ahmedabad | Vahak","description":"Book a verified LCV in Ahmedabad in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Ahmedabad."},"pickupCity":"Ahmedabad","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Ahmedabad"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Ahmedabad","trustStrip":"6,000+ verified transporters in Ahmedabad","aboutTitle":"About Ahmedabad transport","aboutText":"Ahmedabad, India\'s textile capital, drives freight demand across textiles, pharmaceuticals, chemicals and financial services sectors. High volume of textile and pharma shipments move through the city daily, connecting to freight corridors like NH8 and NH48.","tags":["Textiles","Pharmaceuticals","Chemicals","Financial services"],"proofStats":[{"value":"6,000+","label":"verified transporters in Ahmedabad"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Umiya Annapurna Kathiyawadi","location":"NH8, Rajodpura, Gujarat"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Women\'s helpline (Ahmedabad)","number":"1091"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Ahmedabad city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Ahmedabad?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Ahmedabad","popularRoutes":[{"label":"Ahmedabad to Mumbai","href":"/lcv-booking/ahmedabad-to-mumbai"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Ahmedabad, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Ahmedabad","links":[{"label":"Ahmedabad to Mumbai LCV","href":"/lcv-booking/ahmedabad-to-mumbai"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Hyderabad","href":"/city/hyderabad"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"bangalore":{"seo":{"title":"Book LCV in Bangalore | Vahak","description":"Book a verified LCV in Bangalore in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Bangalore."},"pickupCity":"Bangalore","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Bangalore"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Bangalore","trustStrip":"8,000+ verified transporters in Bangalore","aboutTitle":"About Bangalore transport","aboutText":"Bangalore, India\'s IT and startup capital, drives freight demand across software, electronics manufacturing, biotechnology and aerospace sectors. High volume of electronics and industrial component shipments move through hubs like Peenya and Electronic City daily, connecting to freight corridors like NH44 and NH75.","tags":["IT and software","Electronics manufacturing","Biotechnology","Aerospace","Startups"],"proofStats":[{"value":"8,000+","label":"verified transporters in Bangalore"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Hotel Karthik","location":"NH75, Kunigal"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Bangalore traffic control room","number":"1073"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Bangalore city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Bangalore?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Bangalore","popularRoutes":[{"label":"Bangalore to Hyderabad","href":"/lcv-booking/bangalore-to-hyderabad"},{"label":"Bangalore to Chennai","href":"/lcv-booking/bangalore-to-chennai"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Bangalore, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Bangalore","links":[{"label":"Bangalore to Hyderabad LCV","href":"/lcv-booking/bangalore-to-hyderabad"},{"label":"Bangalore to Chennai LCV","href":"/lcv-booking/bangalore-to-chennai"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Pune","href":"/city/pune"},{"label":"Hyderabad","href":"/city/hyderabad"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"chennai":{"seo":{"title":"Book LCV in Chennai | Vahak","description":"Book a verified LCV in Chennai in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Chennai."},"pickupCity":"Chennai","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Chennai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Chennai","trustStrip":"8,000+ verified transporters in Chennai","aboutTitle":"About Chennai transport","aboutText":"Chennai, India\'s automobile manufacturing hub, drives freight demand across automotive, IT services, leather and port logistics sectors. High volume of auto component and textile shipments move through hubs like Sriperumbudur and Ambattur daily, connecting to freight corridors like NH48 and NH16.","tags":["Automobile manufacturing","IT services","Leather","Port and shipping"],"proofStats":[{"value":"8,000+","label":"verified transporters in Chennai"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Shri Krishna Inn","location":"NH44, Shoolagiri, Tamil Nadu"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Greater Chennai traffic helpline","number":"9003130103"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Chennai city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Chennai?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Chennai","popularRoutes":[{"label":"Chennai to Bangalore","href":"/lcv-booking/chennai-to-bangalore"},{"label":"Chennai to Hyderabad","href":"/lcv-booking/chennai-to-hyderabad"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Chennai, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Chennai","links":[{"label":"Chennai to Bangalore LCV","href":"/lcv-booking/chennai-to-bangalore"},{"label":"Chennai to Hyderabad LCV","href":"/lcv-booking/chennai-to-hyderabad"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Hyderabad","href":"/city/hyderabad"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"delhi":{"seo":{"title":"Book LCV in Delhi | Vahak","description":"Book a verified LCV in Delhi NCR in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Delhi."},"pickupCity":"Delhi","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Delhi"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Delhi","trustStrip":"15,000+ verified transporters in Delhi NCR","aboutTitle":"About Delhi transport","aboutText":"Delhi NCR, India\'s national capital region, drives freight demand across government, IT services, auto components and textile sectors. High volume of manufacturing and e-commerce shipments move through hubs like Gurugram, Noida and Faridabad daily, connecting to freight corridors like NH44 and NH48.","tags":["Government and administration","IT services","Auto components","Textiles","E-commerce"],"proofStats":[{"value":"15,000+","label":"verified transporters in Delhi NCR"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Amrik Sukhdev","location":"NH44, Murthal, Haryana"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"102"},{"label":"Delhi traffic police helpline","number":"1095"},{"label":"Delhi transport department","number":"011-2399 4223"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions in Delhi?","answer":"Yes, Delhi restricts heavy vehicle entry during certain daytime hours and applies an entry charge on some routes. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Delhi?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Delhi","popularRoutes":[{"label":"Delhi to Jaipur","href":"/lcv-booking/delhi-to-jaipur"},{"label":"Delhi to Mumbai","href":"/lcv-booking/delhi-to-mumbai"},{"label":"Delhi to Kolkata","href":"/lcv-booking/delhi-to-kolkata"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Delhi NCR, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Delhi","links":[{"label":"Delhi to Jaipur LCV","href":"/lcv-booking/delhi-to-jaipur"},{"label":"Delhi to Mumbai LCV","href":"/lcv-booking/delhi-to-mumbai"},{"label":"Delhi to Kolkata LCV","href":"/lcv-booking/delhi-to-kolkata"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Pune","href":"/city/pune"},{"label":"Hyderabad","href":"/city/hyderabad"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"hyderabad":{"seo":{"title":"Book LCV in Hyderabad | Vahak","description":"Book a verified LCV in Hyderabad in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Hyderabad."},"pickupCity":"Hyderabad","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Hyderabad"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Hyderabad","trustStrip":"9,000+ verified transporters in Hyderabad","aboutTitle":"About Hyderabad transport","aboutText":"Hyderabad, India\'s pharma and IT hub, drives freight demand across pharmaceuticals, IT services, aerospace and film production sectors. High volume of pharma and electronics shipments move through hubs like HITEC City and Genome Valley daily, connecting to freight corridors like NH44 and NH65.","tags":["Pharmaceuticals","IT services","Aerospace and defense","Film production"],"proofStats":[{"value":"9,000+","label":"verified transporters in Hyderabad"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"7 Food Court","location":"NH65, Nalgonda, Telangana"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Hyderabad traffic helpline","number":"9010203626"},{"label":"Telangana transport department","number":"1800-425-1110"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Hyderabad city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Hyderabad?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Hyderabad","popularRoutes":[{"label":"Hyderabad to Bangalore","href":"/lcv-booking/hyderabad-to-bangalore"},{"label":"Hyderabad to Chennai","href":"/lcv-booking/hyderabad-to-chennai"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Hyderabad, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Hyderabad","links":[{"label":"Hyderabad to Bangalore LCV","href":"/lcv-booking/hyderabad-to-bangalore"},{"label":"Hyderabad to Chennai LCV","href":"/lcv-booking/hyderabad-to-chennai"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Kolkata","href":"/city/kolkata"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"jaipur":{"seo":{"title":"Book LCV in Jaipur | Vahak","description":"Book a verified LCV in Jaipur in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Jaipur."},"pickupCity":"Jaipur","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Jaipur"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Jaipur","trustStrip":"5,000+ verified transporters in Jaipur","aboutTitle":"About Jaipur transport","aboutText":"Jaipur, India\'s gems and handicrafts hub, drives freight demand across jewellery, textiles and tourism sectors. High volume of gems, block-print textile and handicraft shipments move through the city daily, connecting to freight corridors like NH48 and NH11.","tags":["Gems and jewellery","Textiles and handicrafts","Tourism"],"proofStats":[{"value":"5,000+","label":"verified transporters in Jaipur"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Highway King","location":"NH48, Behror, Rajasthan"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Jaipur traffic police helpline","number":"1095"},{"label":"Rajasthan transport department","number":"0141-2740021"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Jaipur city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Jaipur?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Jaipur","popularRoutes":[{"label":"Jaipur to Delhi","href":"/lcv-booking/jaipur-to-delhi"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Jaipur, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Jaipur","links":[{"label":"Jaipur to Delhi LCV","href":"/lcv-booking/jaipur-to-delhi"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Chennai","href":"/city/chennai"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"kolkata":{"seo":{"title":"Book LCV in Kolkata | Vahak","description":"Book a verified LCV in Kolkata in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Kolkata."},"pickupCity":"Kolkata","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Kolkata"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Kolkata","trustStrip":"7,000+ verified transporters in Kolkata","aboutTitle":"About Kolkata transport","aboutText":"Kolkata, India\'s eastern gateway port city, drives freight demand across jute, engineering, IT services and leather sectors. High volume of tea, jute and engineering goods shipments move through the city daily, connecting to freight corridors like NH19 and NH16.","tags":["Jute and textiles","Engineering goods","IT services","Leather","Port and shipping"],"proofStats":[{"value":"7,000+","label":"verified transporters in Kolkata"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Azad Hind Dhaba","location":"NH19, Gopalpur, West Bengal"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Kolkata traffic police helpline","number":"1073"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Kolkata city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Kolkata?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Kolkata","popularRoutes":[{"label":"Kolkata to Delhi","href":"/lcv-booking/kolkata-to-delhi"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Kolkata, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Kolkata","links":[{"label":"Kolkata to Delhi LCV","href":"/lcv-booking/kolkata-to-delhi"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Ahmedabad","href":"/city/ahmedabad"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"mumbai":{"seo":{"title":"Book LCV in Mumbai | Vahak","description":"Book a verified LCV in Mumbai in minutes. Live tracking, cargo insurance, no hidden charges. 12,000+ verified transporters in Mumbai."},"pickupCity":"Mumbai","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Mumbai"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Mumbai","trustStrip":"12,000+ verified transporters in Mumbai","aboutTitle":"About Mumbai transport","aboutText":"Mumbai, India\'s financial capital, drives freight demand across finance, IT, entertainment, jewellery and automobile sectors. High volume of e-commerce and textile shipments move out of the city daily, connecting to major freight corridors like NH48 and NH66.","tags":["Financial services","IT and services","Entertainment","Jewellery","Automobiles"],"proofStats":[{"value":"12,000+","label":"verified transporters in Mumbai"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Prabhu ka dhaba","location":"NH-3, Igatpuri"},{"name":"Sidhu Punjabi dhaba","location":"Old Mumbai-Pune Hwy"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Mumbai traffic police","number":"103"},{"label":"Maharashtra RTO","number":"1800-233-4780"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry time restrictions in Mumbai?","answer":"Certain routes have restricted hours for heavy vehicles inside city limits. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Mumbai?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Mumbai","popularRoutes":[{"label":"Mumbai to Pune","href":"/lcv-booking/mumbai-to-pune"},{"label":"Mumbai to Delhi","href":"/lcv-booking/mumbai-to-delhi"},{"label":"Mumbai to Ahmedabad","href":"/lcv-booking/mumbai-to-ahmedabad"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Mumbai, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Mumbai","links":[{"label":"Mumbai to Pune LCV","href":"/lcv-booking/mumbai-to-pune"},{"label":"Mumbai to Delhi LCV","href":"/lcv-booking/mumbai-to-delhi"},{"label":"Mumbai to Ahmedabad LCV","href":"/lcv-booking/mumbai-to-ahmedabad"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Pune","href":"/city/pune"},{"label":"Hyderabad","href":"/city/hyderabad"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]},"pune":{"seo":{"title":"Book LCV in Pune | Vahak","description":"Book a verified LCV in Pune in minutes. Live tracking, cargo insurance, no hidden charges. Verified transporters in Pune."},"pickupCity":"Pune","dropPlaceholder":"Enter drop location","heroHeadline2Lines":["Pune"],"heroSub":"Verified transporters. Live tracking.","breadcrumbCityName":"Pune","trustStrip":"7,000+ verified transporters in Pune","aboutTitle":"About Pune transport","aboutText":"Pune, India\'s automobile and IT hub, drives freight demand across automotive manufacturing, IT services and education sectors. High volume of auto component and electronics shipments move through hubs like Hinjewadi and Chakan daily, connecting to freight corridors like NH48 and NH60.","tags":["Automobile manufacturing","IT services","Education","Engineering"],"proofStats":[{"value":"7,000+","label":"verified transporters in Pune"},{"value":"10 min","label":"time to book LCV"}],"localResources":{"title":"Local resources","dhabas":[{"name":"Kinara Village Dhaba","location":"NH48, Old Mumbai-Pune Highway"}],"contacts":[{"label":"Police","number":"100"},{"label":"Ambulance","number":"108"},{"label":"Pune police control room","number":"020-26126296"},{"label":"Maharashtra RTO","number":"1800-233-4780"},{"label":"National highway helpline","number":"1033"}],"moreToggle":"View petrol pumps, service stations, hospitals","note":"Emergency numbers shown are standard state/national helplines — verify against an official source before publishing."},"faqs":[{"question":"Are there truck entry restrictions inside Pune city limits?","answer":"Certain inner-city roads restrict heavy vehicle movement during peak hours. Vahak transporters plan pickup and drop timing around these rules automatically.","defaultOpen":true},{"question":"How is LCV pricing decided in Pune?","answer":"Pricing depends on distance, load weight, vehicle type and current demand on your route. You can post your load for free and compare bids from verified transporters."},{"question":"Will I get a GST invoice for my booking?","answer":"Yes, a GST invoice is provided for every booking made through Vahak, generated automatically once your load is confirmed."},{"question":"What happens if my load isn\'t picked up on time?","answer":"Vahak\'s support team monitors every active booking and steps in to reassign your load to another verified transporter if pickup is delayed."}],"popularRoutesLabel":"Popular routes from Pune","popularRoutes":[{"label":"Pune to Mumbai","href":"/lcv-booking/pune-to-mumbai"}],"vehicleTypesLabel":"Book by vehicle type","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak is an online LCV booking marketplace connecting shippers with verified transporters across India. In Pune, businesses use Vahak to book Tata Ace, Tempo, Tata 407 and Pickup vehicles for part-load and full-load LCV shipments, with live tracking and cargo insurance on every booking.","footerGroups":[{"label":"Popular Routes from Pune","links":[{"label":"Pune to Mumbai LCV","href":"/lcv-booking/pune-to-mumbai"}],"moreLink":{"label":"View all routes →","href":"/lcv-booking"}},{"label":"Book LCV in Other Cities","links":[{"label":"Mumbai","href":"/city/mumbai"},{"label":"Delhi","href":"/city/delhi"},{"label":"Bangalore","href":"/city/bangalore"},{"label":"Jaipur","href":"/city/jaipur"}],"moreLink":{"label":"View all cities →","href":"/"}},{"label":"Vehicle Types","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"Company","links":[{"label":"About us","href":"/about-us"},{"label":"Careers","href":"/careers"},{"label":"Contact us","href":"/contact-us"}]},{"label":"Legal","links":[{"label":"Terms & Conditions","href":"/terms-and-conditions"},{"label":"Privacy Policy","href":"/privacy-policy"},{"label":"Frequently Asked Questions","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 97621:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"અમદાવાદથી મુંબઈ LCV","bangalore-to-chennai":"બેંગલોરથી ચેન્નાઈ LCV","bangalore-to-hyderabad":"બેંગલોરથી હૈદરાબાદ LCV","chennai-to-bangalore":"ચેન્નાઈથી બેંગલોર LCV","chennai-to-hyderabad":"ચેન્નાઈથી હૈદરાબાદ LCV","hyderabad-to-bangalore":"હૈદરાબાદથી બેંગલોર LCV","hyderabad-to-chennai":"હૈદરાબાદથી ચેન્નાઈ LCV","delhi-to-jaipur":"દિલ્હીથી જયપુર LCV","delhi-to-kolkata":"દિલ્હીથી કોલકાતા LCV","delhi-to-mumbai":"દિલ્હીથી મુંબઈ LCV","jaipur-to-delhi":"જયપુરથી દિલ્હી LCV","kolkata-to-delhi":"કોલકાતાથી દિલ્હી LCV","mumbai-to-ahmedabad":"મુંબઈથી અમદાવાદ LCV","mumbai-to-delhi":"મુંબઈથી દિલ્હી LCV","mumbai-to-pune":"મુંબઈથી પુણે LCV","pune-to-mumbai":"પુણેથી મુંબઈ LCV"}},"_j":{"ahmedabad-to-mumbai":{"seo":{"title":"અમદાવાદથી મુંબઈ માટે LCV બુક કરો | Vahak","description":"થોડી મિનિટોમાં અમદાવાદથી મુંબઈ માટે વેરિફાઈડ LCV બુક કરો. લાઈવ ટ્રેકિંગ, કાર્ગો ઈન્શ્યોરન્સ, કોઈ છુપાયેલા ચાર્જ નથી. આ રૂટ પર 500+ વેરિફાઈડ ટ્રાન્સપોર્ટર."},"pickupCity":"અમદાવાદ","dropCity":"મુંબઈ","heroHeadline2Lines":["અમદાવાદથી","મુંબઈ સુધી"],"heroSub":"વેરિફાઈડ ટ્રાન્સપોર્ટર. લાઈવ ટ્રેકિંગ.","breadcrumbRouteName":"અમદાવાદથી મુંબઈ","aboutText":"અમદાવાદથી મુંબઈ NH48 માર્ગ પર 530 કિમીનો કોરિડોર છે, જે રોડ માર્ગે સામાન્ય રીતે 9-10 કલાકમાં કાપવામાં આવે છે. તે ગુજરાતના કાપડ, રસાયણ અને ફાર્મા ઉત્પાદન કેન્દ્રને મુંબઈના વ્યાપારિક, બંદર અને FMCG કેન્દ્ર સાથે જોડે છે — તેનો ઉપયોગ સામાન્ય રીતે કાપડ, રસાયણો, ફાર્મા અને FMCG શિપમેન્ટ માટે થાય છે.","footerSeoText":"Vahak એ સમગ્ર ભારતમાં શિપર્સને વેરિફાઈડ ટ્રાન્સપોર્ટર સાથે જોડતું ઓનલાઈન LCV બુકિંગ માર્કેટપ્લેસ છે. અમદાવાદ-મુંબઈ રૂટ પર, વ્યવસાયો પાર્ટ-લોડ અને ફુલ-લોડ LCV શિપમેન્ટ માટે Tata Ace, Tempo, Tata 407 અને પિકઅપ વાહનો બુક કરવા માટે Vahak નો ઉપયોગ કરે છે, દરેક બુકિંગ પર લાઈવ ટ્રેકિંગ અને કાર્ગો ઈન્શ્યોરન્સ સાથે.","faqs":[{"question":"શું અમદાવાદથી મુંબઈ માટે એ જ દિવસે LCV ઉપલબ્ધ છે?","answer":"હા, સામાન્ય રીતે એ જ દિવસે પિકઅપ ઉપલબ્ધ છે. આ રૂટ પર મોટાભાગની બુકિંગ માટે 10 મિનિટમાં ટ્રાન્સપોર્ટરની પુષ્ટિ થઈ જાય છે.","defaultOpen":true},{"question":"અમદાવાદથી મુંબઈ માટે LCV નો ખર્ચ કેટલો છે?","answer":"ભાવ લોડના વજન, LCV ના કદ અને સીઝન પ્રમાણે બદલાય છે, કોઈ છુપાયેલા ચાર્જ નથી. તમારા લોડ માટે ચોક્કસ અંદાજ માટે ઉપર આપેલા ભાવ અંદાજ ટૂલનો ઉપયોગ કરો."},{"question":"શું પરિવહન દરમિયાન મારા માલનો વીમો છે?","answer":"હા, પરિવહન દરમિયાન તમારા માલનું રક્ષણ કરવા માટે આ રૂટ પર કાર્ગો ઈન્શ્યોરન્સ ઉપલબ્ધ છે."},{"question":"અમદાવાદથી મુંબઈ માટે 1 ટન લોડ માટે કયા કદનું LCV જોઈએ?","answer":"1 ટન લોડ સામાન્ય રીતે Tata Ace અથવા Tata 407 જેવા સ્ટાન્ડર્ડ LCV માં ફિટ થાય છે. બુકિંગ કરતી વખતે તમારા લોડની વિગતો દાખલ કરો અને Vahak યોગ્ય કદ સૂચવશે."},{"question":"શું હું આવતીકાલ માટે પિકઅપ શેડ્યૂલ કરી શકું?","answer":"હા, તમે ફક્ત એ જ દિવસ માટે જ નહીં પરંતુ કોઈપણ ભવિષ્યની તારીખ માટે પિકઅપ શેડ્યૂલ કરી શકો છો. લોડ પોસ્ટ કરતી વખતે તમારો પસંદગીનો પિકઅપ સમય સેટ કરો."},{"question":"LCV માટે મહત્તમ પેલોડ કેટલો છે?","answer":"આ રૂટ પર મોટાભાગના LCV 3.5 ટન સુધી લઈ જઈ શકે છે. તમારા લોડના વજનના આધારે Vahak યોગ્ય વાહન કદ સાથે મેચ કરશે."}],"popularRoutes":[{"label":"મુંબઈથી પુણે"},{"label":"અમદાવાદથી સુરત"},{"label":"મુંબઈથી દિલ્હી"}],"vehicleTypes":[{"label":"ટાટા એસ"},{"label":"ટેમ્પો"},{"label":"ટાટા 407"},{"label":"પિકઅપ"}]}},"cA":{"ahmedabad":{"seo":{"title":"અમદાવાદમાં LCV બુક કરો | Vahak","description":"થોડી મિનિટોમાં અમદાવાદમાં પ્રમાણિત LCV બુક કરો. લાઇવ ટ્રેકિંગ, કાર્ગો વીમો, કોઈ છુપાયેલ ચાર્જ નથી."},"pickupCity":"અમદાવાદ","dropPlaceholder":"ડ્રોપ લોકેશન દાખલ કરો","heroHeadline2Lines":["અમદાવાદ"],"heroSub":"પ્રમાણિત ટ્રાન્સપોર્ટર્સ. લાઇવ ટ્રેકિંગ.","breadcrumbCityName":"અમદાવાદ","trustStrip":"અમદાવાદમાં 6,000+ પ્રમાણિત ટ્રાન્સપોર્ટર્સ","aboutTitle":"અમદાવાદ પરિવહન વિશે","aboutText":"અમદાવાદ, ભારતની ટેક્સટાઇલ રાજધાની, ટેક્સટાઇલ, ફાર્માસ્યુટિકલ્સ, રસાયણો અને નાણાકીય સેવાઓ ક્ષેત્રોમાં માલવાહક માંગને વેગ આપે છે. મોટા પ્રમાણમાં ટેક્સટાઇલ અને ફાર્મા શિપમેન્ટ દરરોજ શહેરમાંથી NH8 અને NH48 જેવા ફ્રેટ કોરિડોર સાથે જોડાય છે.","tags":["ટેક્સટાઇલ","ફાર્માસ્યુટિકલ્સ","રસાયણો","નાણાકીય સેવાઓ"],"proofStats":[{"value":"6,000+","label":"અમદાવાદમાં પ્રમાણિત ટ્રાન્સપોર્ટર્સ"},{"value":"10 મિનિટ","label":"LCV બુક કરવાનો સમય"}],"localResources":{"title":"સ્થાનિક માહિતી","dhabas":[{"name":"ઉમિયા અન્નપૂર્ણા કાઠિયાવાડી","location":"NH8, રાજોડપુરા, ગુજરાત"}],"contacts":[{"label":"પોલીસ","number":"100"},{"label":"એમ્બ્યુલન્સ","number":"108"},{"label":"મહિલા હેલ્પલાઇન (અમદાવાદ)","number":"1091"},{"label":"રાષ્ટ્રીય ધોરીમાર્ગ હેલ્પલાઇન","number":"1033"}],"moreToggle":"પેટ્રોલ પંપ, સર્વિસ સ્ટેશન, હોસ્પિટલો જુઓ","note":"બતાવેલા ઇમરજન્સી નંબરો પ્રમાણભૂત રાજ્ય/રાષ્ટ્રીય હેલ્પલાઇન છે — પ્રકાશિત કરતા પહેલા સત્તાવાર સ્ત્રોત પાસેથી ચકાસો."},"faqs":[{"question":"શું અમદાવાદ શહેરની હદમાં ટ્રક પ્રવેશ પર પ્રતિબંધો છે?","answer":"કેટલાક આંતરિક-શહેર રસ્તાઓ પીક અવર્સ દરમિયાન ભારે વાહનોની અવરજવર પર પ્રતિબંધ મૂકે છે. Vahak ટ્રાન્સપોર્ટર્સ આ નિયમો અનુસાર પિકઅપ અને ડ્રોપનો સમય આપમેળે ગોઠવે છે.","defaultOpen":true},{"question":"અમદાવાદમાં LCV ની કિંમત કેવી રીતે નક્કી થાય છે?","answer":"કિંમત અંતર, લોડનું વજન, વાહનનો પ્રકાર અને તમારા માર્ગ પરની હાલની માંગ પર આધાર રાખે છે. તમે તમારો લોડ મફતમાં પોસ્ટ કરી શકો છો અને પ્રમાણિત ટ્રાન્સપોર્ટર્સની બિડની તુલના કરી શકો છો."},{"question":"શું મને મારી બુકિંગ માટે GST ઇન્વોઇસ મળશે?","answer":"હા, Vahak દ્વારા કરવામાં આવેલી દરેક બુકિંગ માટે GST ઇન્વોઇસ આપવામાં આવે છે, જે તમારો લોડ કન્ફર્મ થતાં જ આપમેળે જનરેટ થાય છે."},{"question":"જો મારો લોડ સમયસર પિકઅપ ન થાય તો શું થાય છે?","answer":"Vahak ની સપોર્ટ ટીમ દરેક સક્રિય બુકિંગ પર નજર રાખે છે અને પિકઅપમાં વિલંબ થાય તો તમારો લોડ બીજા પ્રમાણિત ટ્રાન્સપોર્ટરને ફરીથી સોંપે છે."}],"popularRoutesLabel":"અમદાવાદથી લોકપ્રિય માર્ગો","popularRoutes":[{"label":"અમદાવાદ થી મુંબઈ","href":"/lcv-booking/ahmedabad-to-mumbai"}],"vehicleTypesLabel":"વાહનના પ્રકાર મુજબ બુક કરો","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak એક ઓનલાઇન LCV બુકિંગ માર્કેટપ્લેસ છે જે શિપર્સને સમગ્ર ભારતમાં પ્રમાણિત ટ્રાન્સપોર્ટર્સ સાથે જોડે છે. અમદાવાદમાં, વ્યવસાયો Vahak નો ઉપયોગ કરીને પાર્ટ-લોડ અને ફુલ-લોડ LCV શિપમેન્ટ માટે Tata Ace, Tempo, Tata 407 અને Pickup વાહનો બુક કરે છે, દરેક બુકિંગ પર લાઇવ ટ્રેકિંગ અને કાર્ગો વીમા સાથે.","footerGroups":[{"label":"અમદાવાદથી લોકપ્રિય માર્ગો","links":[{"label":"અમદાવાદ થી મુંબઈ LCV","href":"/lcv-booking/ahmedabad-to-mumbai"}],"moreLink":{"label":"બધા માર્ગો જુઓ →","href":"/lcv-booking"}},{"label":"અન્ય શહેરોમાં LCV બુક કરો","links":[{"label":"મુંબઈ","href":"/city/mumbai"},{"label":"દિલ્હી","href":"/city/delhi"},{"label":"બેંગલુરુ","href":"/city/bangalore"},{"label":"હૈદરાબાદ","href":"/city/hyderabad"}],"moreLink":{"label":"બધા શહેરો જુઓ →","href":"/"}},{"label":"વાહન પ્રકારો","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"કંપની","links":[{"label":"અમારા વિશે","href":"/about-us"},{"label":"કારકિર્દી","href":"/careers"},{"label":"સંપર્ક કરો","href":"/contact-us"}]},{"label":"કાનૂની","links":[{"label":"નિયમો અને શરતો","href":"/terms-and-conditions"},{"label":"ગોપનીયતા નીતિ","href":"/privacy-policy"},{"label":"વારંવાર પૂછાતા પ્રશ્નો","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 24610:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"अहमदाबाद से मुंबई LCV","bangalore-to-chennai":"बैंगलोर से चेन्नई LCV","bangalore-to-hyderabad":"बैंगलोर से हैदराबाद LCV","chennai-to-bangalore":"चेन्नई से बैंगलोर LCV","chennai-to-hyderabad":"चेन्नई से हैदराबाद LCV","hyderabad-to-bangalore":"हैदराबाद से बैंगलोर LCV","hyderabad-to-chennai":"हैदराबाद से चेन्नई LCV","delhi-to-jaipur":"दिल्ली से जयपुर LCV","delhi-to-kolkata":"दिल्ली से कोलकाता LCV","delhi-to-mumbai":"दिल्ली से मुंबई LCV","jaipur-to-delhi":"जयपुर से दिल्ली LCV","kolkata-to-delhi":"कोलकाता से दिल्ली LCV","mumbai-to-ahmedabad":"मुंबई से अहमदाबाद LCV","mumbai-to-delhi":"मुंबई से दिल्ली LCV","mumbai-to-pune":"मुंबई से पुणे LCV","pune-to-mumbai":"पुणे से मुंबई LCV"}},"_j":{"delhi-to-jaipur":{"seo":{"title":"दिल्ली से जयपुर के लिए LCV बुक करें | Vahak","description":"मिनटों में दिल्ली से जयपुर के लिए सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा शुल्क नहीं। इस रूट पर 500+ सत्यापित ट्रांसपोर्टर।"},"pickupCity":"दिल्ली","dropCity":"जयपुर","heroHeadline2Lines":["दिल्ली से","जयपुर तक"],"heroSub":"सत्यापित ट्रांसपोर्टर। लाइव ट्रैकिंग।","breadcrumbRouteName":"दिल्ली से जयपुर","aboutText":"दिल्ली से जयपुर NH48 मार्ग पर 280 किमी की दूरी है, जिसे सड़क मार्ग से आमतौर पर 5-6 घंटे में तय किया जाता है। यह NCR के औद्योगिक और विनिर्माण केंद्र को जयपुर के कपड़ा, हस्तशिल्प और रत्न-आभूषण व्यापार से जोड़ने वाला एक प्रमुख माल ढुलाई मार्ग है — यह आमतौर पर कपड़ा, हस्तशिल्प, इलेक्ट्रॉनिक्स और FMCG शिपमेंट के लिए उपयोग किया जाता है।","footerSeoText":"Vahak भारत भर में शिपर्स को सत्यापित ट्रांसपोर्टरों से जोड़ने वाला एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है। दिल्ली-जयपुर रूट पर, व्यवसाय पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और पिकअप वाहन बुक करने के लिए Vahak का उपयोग करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","faqs":[{"question":"क्या दिल्ली से जयपुर के लिए उसी दिन LCV उपलब्ध है?","answer":"हां, आमतौर पर उसी दिन पिकअप उपलब्ध है। इस रूट पर अधिकांश बुकिंग के लिए 10 मिनट के भीतर ट्रांसपोर्टर की पुष्टि हो जाती है।","defaultOpen":true},{"question":"दिल्ली से जयपुर के लिए LCV की कीमत कितनी है?","answer":"कीमतें लोड के वजन, LCV के आकार और सीज़न के अनुसार अलग-अलग होती हैं, कोई छिपा शुल्क नहीं। अपने लोड के लिए विशेष अनुमान हेतु ऊपर दिए गए मूल्य अनुमान टूल का उपयोग करें।"},{"question":"क्या ट्रांजिट के दौरान मेरे सामान का बीमा होता है?","answer":"हां, ट्रांजिट के दौरान आपके सामान की सुरक्षा के लिए इस रूट पर कार्गो बीमा उपलब्ध है।"},{"question":"दिल्ली से जयपुर के लिए 1 टन लोड के लिए किस आकार का LCV चाहिए?","answer":"1 टन लोड आमतौर पर Tata Ace या Tata 407 जैसे मानक LCV में फिट हो जाता है। बुकिंग के समय अपने लोड का विवरण दर्ज करें और Vahak सही आकार सुझाएगा।"},{"question":"क्या मैं कल के लिए पिकअप शेड्यूल कर सकता हूं?","answer":"हां, आप केवल उसी दिन ही नहीं बल्कि किसी भी भविष्य की तारीख के लिए पिकअप शेड्यूल कर सकते हैं। लोड पोस्ट करते समय अपना पसंदीदा पिकअप समय सेट करें।"},{"question":"LCV के लिए अधिकतम पेलोड कितना है?","answer":"इस रूट पर अधिकांश LCV 3.5 टन तक ले जा सकते हैं। आपके लोड के वजन के आधार पर Vahak सही वाहन आकार से मिलान करेगा।"}],"popularRoutes":[{"label":"दिल्ली से चंडीगढ़"},{"label":"जयपुर से उदयपुर"},{"label":"दिल्ली से आगरा"}],"vehicleTypes":[{"label":"टाटा ऐस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"jaipur-to-delhi":{"seo":{"title":"जयपुर से दिल्ली के लिए LCV बुक करें | Vahak","description":"मिनटों में जयपुर से दिल्ली के लिए सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा शुल्क नहीं। इस रूट पर 500+ सत्यापित ट्रांसपोर्टर।"},"pickupCity":"जयपुर","dropCity":"दिल्ली","heroHeadline2Lines":["जयपुर से","दिल्ली तक"],"heroSub":"सत्यापित ट्रांसपोर्टर। लाइव ट्रैकिंग।","breadcrumbRouteName":"जयपुर से दिल्ली","aboutText":"जयपुर से दिल्ली NH48 मार्ग पर 280 किमी की दूरी है, जिसे सड़क मार्ग से आमतौर पर 5-6 घंटे में तय किया जाता है। यह जयपुर के कपड़ा, हस्तशिल्प और रत्न-आभूषण व्यापार को NCR के औद्योगिक और विनिर्माण केंद्र से जोड़ने वाला एक प्रमुख माल ढुलाई मार्ग है — यह आमतौर पर कपड़ा, हस्तशिल्प, इलेक्ट्रॉनिक्स और FMCG शिपमेंट के लिए उपयोग किया जाता है।","footerSeoText":"Vahak भारत भर में शिपर्स को सत्यापित ट्रांसपोर्टरों से जोड़ने वाला एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है। जयपुर-दिल्ली रूट पर, व्यवसाय पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और पिकअप वाहन बुक करने के लिए Vahak का उपयोग करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","faqs":[{"question":"क्या जयपुर से दिल्ली के लिए उसी दिन LCV उपलब्ध है?","answer":"हां, आमतौर पर उसी दिन पिकअप उपलब्ध है। इस रूट पर अधिकांश बुकिंग के लिए 10 मिनट के भीतर ट्रांसपोर्टर की पुष्टि हो जाती है।","defaultOpen":true},{"question":"जयपुर से दिल्ली के लिए LCV की कीमत कितनी है?","answer":"कीमतें लोड के वजन, LCV के आकार और सीज़न के अनुसार अलग-अलग होती हैं, कोई छिपा शुल्क नहीं। अपने लोड के लिए विशेष अनुमान हेतु ऊपर दिए गए मूल्य अनुमान टूल का उपयोग करें।"},{"question":"क्या ट्रांजिट के दौरान मेरे सामान का बीमा होता है?","answer":"हां, ट्रांजिट के दौरान आपके सामान की सुरक्षा के लिए इस रूट पर कार्गो बीमा उपलब्ध है।"},{"question":"जयपुर से दिल्ली के लिए 1 टन लोड के लिए किस आकार का LCV चाहिए?","answer":"1 टन लोड आमतौर पर Tata Ace या Tata 407 जैसे मानक LCV में फिट हो जाता है। बुकिंग के समय अपने लोड का विवरण दर्ज करें और Vahak सही आकार सुझाएगा।"},{"question":"क्या मैं कल के लिए पिकअप शेड्यूल कर सकता हूं?","answer":"हां, आप केवल उसी दिन ही नहीं बल्कि किसी भी भविष्य की तारीख के लिए पिकअप शेड्यूल कर सकते हैं। लोड पोस्ट करते समय अपना पसंदीदा पिकअप समय सेट करें।"},{"question":"LCV के लिए अधिकतम पेलोड कितना है?","answer":"इस रूट पर अधिकांश LCV 3.5 टन तक ले जा सकते हैं। आपके लोड के वजन के आधार पर Vahak सही वाहन आकार से मिलान करेगा।"}],"popularRoutes":[{"label":"जयपुर से उदयपुर"},{"label":"दिल्ली से चंडीगढ़"},{"label":"दिल्ली से आगरा"}],"vehicleTypes":[{"label":"टाटा ऐस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"delhi-to-mumbai":{"seo":{"title":"दिल्ली से मुंबई के लिए LCV बुक करें | Vahak","description":"मिनटों में दिल्ली से मुंबई के लिए सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा शुल्क नहीं। इस रूट पर 500+ सत्यापित ट्रांसपोर्टर।"},"pickupCity":"दिल्ली","dropCity":"मुंबई","heroHeadline2Lines":["दिल्ली से","मुंबई तक"],"heroSub":"सत्यापित ट्रांसपोर्टर। लाइव ट्रैकिंग।","breadcrumbRouteName":"दिल्ली से मुंबई","aboutText":"दिल्ली से मुंबई NH48 मार्ग पर 1,400 किमी की दूरी है, जिसे सड़क मार्ग से LCV शिपमेंट के लिए आमतौर पर 24-28 घंटे में तय किया जाता है। यह भारत के सबसे व्यस्त लंबी दूरी के माल ढुलाई मार्गों में से एक है, जो दिल्ली NCR के औद्योगिक और व्यापारिक केंद्र को मुंबई के व्यावसायिक और वित्तीय केंद्र से जोड़ता है — यह आमतौर पर कपड़ा, हस्तशिल्प, इलेक्ट्रॉनिक्स और FMCG शिपमेंट के लिए उपयोग किया जाता है।","footerSeoText":"Vahak भारत भर में शिपर्स को सत्यापित ट्रांसपोर्टरों से जोड़ने वाला एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है। दिल्ली-मुंबई रूट पर, व्यवसाय पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और पिकअप वाहन बुक करने के लिए Vahak का उपयोग करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","faqs":[{"question":"क्या दिल्ली से मुंबई के लिए उसी दिन LCV उपलब्ध है?","answer":"हां, आमतौर पर उसी दिन पिकअप उपलब्ध है। इस रूट पर अधिकांश बुकिंग के लिए 10 मिनट के भीतर ट्रांसपोर्टर की पुष्टि हो जाती है।","defaultOpen":true},{"question":"दिल्ली से मुंबई के लिए LCV की कीमत कितनी है?","answer":"कीमतें लोड के वजन, LCV के आकार और सीज़न के अनुसार अलग-अलग होती हैं, कोई छिपा शुल्क नहीं। अपने लोड के लिए विशेष अनुमान हेतु ऊपर दिए गए मूल्य अनुमान टूल का उपयोग करें।"},{"question":"क्या ट्रांजिट के दौरान मेरे सामान का बीमा होता है?","answer":"हां, ट्रांजिट के दौरान आपके सामान की सुरक्षा के लिए इस रूट पर कार्गो बीमा उपलब्ध है।"},{"question":"दिल्ली से मुंबई के लिए 1 टन लोड के लिए किस आकार का LCV चाहिए?","answer":"1 टन लोड आमतौर पर Tata Ace या Tata 407 जैसे मानक LCV में फिट हो जाता है। बुकिंग के समय अपने लोड का विवरण दर्ज करें और Vahak सही आकार सुझाएगा।"},{"question":"क्या मैं कल के लिए पिकअप शेड्यूल कर सकता हूं?","answer":"हां, आप केवल उसी दिन ही नहीं बल्कि किसी भी भविष्य की तारीख के लिए पिकअप शेड्यूल कर सकते हैं। लोड पोस्ट करते समय अपना पसंदीदा पिकअप समय सेट करें।"},{"question":"LCV के लिए अधिकतम पेलोड कितना है?","answer":"इस रूट पर अधिकांश LCV 3.5 टन तक ले जा सकते हैं। आपके लोड के वजन के आधार पर Vahak सही वाहन आकार से मिलान करेगा।"}],"popularRoutes":[{"label":"दिल्ली से जयपुर"},{"label":"मुंबई से अहमदाबाद"},{"label":"पुणे से मुंबई"}],"vehicleTypes":[{"label":"टाटा ऐस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"mumbai-to-delhi":{"seo":{"title":"मुंबई से दिल्ली के लिए LCV बुक करें | Vahak","description":"मिनटों में मुंबई से दिल्ली के लिए सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा शुल्क नहीं। इस रूट पर 500+ सत्यापित ट्रांसपोर्टर।"},"pickupCity":"मुंबई","dropCity":"दिल्ली","heroHeadline2Lines":["मुंबई से","दिल्ली तक"],"heroSub":"सत्यापित ट्रांसपोर्टर। लाइव ट्रैकिंग।","breadcrumbRouteName":"मुंबई से दिल्ली","aboutText":"मुंबई से दिल्ली NH48 मार्ग पर 1,400 किमी की दूरी है, जिसे सड़क मार्ग से LCV शिपमेंट के लिए आमतौर पर 24-28 घंटे में तय किया जाता है। यह भारत के सबसे व्यस्त लंबी दूरी के माल ढुलाई मार्गों में से एक है, जो मुंबई के व्यावसायिक और वित्तीय केंद्र को दिल्ली NCR के औद्योगिक और व्यापारिक केंद्र से जोड़ता है — यह आमतौर पर कपड़ा, हस्तशिल्प, इलेक्ट्रॉनिक्स और FMCG शिपमेंट के लिए उपयोग किया जाता है।","footerSeoText":"Vahak भारत भर में शिपर्स को सत्यापित ट्रांसपोर्टरों से जोड़ने वाला एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है। मुंबई-दिल्ली रूट पर, व्यवसाय पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और पिकअप वाहन बुक करने के लिए Vahak का उपयोग करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","faqs":[{"question":"क्या मुंबई से दिल्ली के लिए उसी दिन LCV उपलब्ध है?","answer":"हां, आमतौर पर उसी दिन पिकअप उपलब्ध है। इस रूट पर अधिकांश बुकिंग के लिए 10 मिनट के भीतर ट्रांसपोर्टर की पुष्टि हो जाती है।","defaultOpen":true},{"question":"मुंबई से दिल्ली के लिए LCV की कीमत कितनी है?","answer":"कीमतें लोड के वजन, LCV के आकार और सीज़न के अनुसार अलग-अलग होती हैं, कोई छिपा शुल्क नहीं। अपने लोड के लिए विशेष अनुमान हेतु ऊपर दिए गए मूल्य अनुमान टूल का उपयोग करें।"},{"question":"क्या ट्रांजिट के दौरान मेरे सामान का बीमा होता है?","answer":"हां, ट्रांजिट के दौरान आपके सामान की सुरक्षा के लिए इस रूट पर कार्गो बीमा उपलब्ध है।"},{"question":"मुंबई से दिल्ली के लिए 1 टन लोड के लिए किस आकार का LCV चाहिए?","answer":"1 टन लोड आमतौर पर Tata Ace या Tata 407 जैसे मानक LCV में फिट हो जाता है। बुकिंग के समय अपने लोड का विवरण दर्ज करें और Vahak सही आकार सुझाएगा।"},{"question":"क्या मैं कल के लिए पिकअप शेड्यूल कर सकता हूं?","answer":"हां, आप केवल उसी दिन ही नहीं बल्कि किसी भी भविष्य की तारीख के लिए पिकअप शेड्यूल कर सकते हैं। लोड पोस्ट करते समय अपना पसंदीदा पिकअप समय सेट करें।"},{"question":"LCV के लिए अधिकतम पेलोड कितना है?","answer":"इस रूट पर अधिकांश LCV 3.5 टन तक ले जा सकते हैं। आपके लोड के वजन के आधार पर Vahak सही वाहन आकार से मिलान करेगा।"}],"popularRoutes":[{"label":"मुंबई से अहमदाबाद"},{"label":"दिल्ली से जयपुर"},{"label":"मुंबई से पुणे"}],"vehicleTypes":[{"label":"टाटा ऐस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"delhi-to-kolkata":{"seo":{"title":"दिल्ली से कोलकाता के लिए LCV बुक करें | Vahak","description":"मिनटों में दिल्ली से कोलकाता के लिए सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा शुल्क नहीं। इस रूट पर 500+ सत्यापित ट्रांसपोर्टर।"},"pickupCity":"दिल्ली","dropCity":"कोलकाता","heroHeadline2Lines":["दिल्ली से","कोलकाता तक"],"heroSub":"सत्यापित ट्रांसपोर्टर। लाइव ट्रैकिंग।","breadcrumbRouteName":"दिल्ली से कोलकाता","aboutText":"दिल्ली से कोलकाता NH19 (ऐतिहासिक ग्रैंड ट्रंक रोड) मार्ग पर 1,500 किमी की दूरी है, जिसे सड़क मार्ग से LCV शिपमेंट के लिए आमतौर पर 28-30 घंटे में तय किया जाता है। यह दिल्ली NCR के औद्योगिक और व्यापारिक केंद्र को कोलकाता के बंदरगाह और पूर्वी भारत के व्यापार केंद्र से जोड़ने वाला एक प्रमुख लंबी दूरी का माल ढुलाई मार्ग है — यह आमतौर पर कपड़ा, हस्तशिल्प, इलेक्ट्रॉनिक्स और FMCG शिपमेंट के लिए उपयोग किया जाता है।","footerSeoText":"Vahak भारत भर में शिपर्स को सत्यापित ट्रांसपोर्टरों से जोड़ने वाला एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है। दिल्ली-कोलकाता रूट पर, व्यवसाय पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और पिकअप वाहन बुक करने के लिए Vahak का उपयोग करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","faqs":[{"question":"क्या दिल्ली से कोलकाता के लिए उसी दिन LCV उपलब्ध है?","answer":"हां, आमतौर पर उसी दिन पिकअप उपलब्ध है। इस रूट पर अधिकांश बुकिंग के लिए 10 मिनट के भीतर ट्रांसपोर्टर की पुष्टि हो जाती है।","defaultOpen":true},{"question":"दिल्ली से कोलकाता के लिए LCV की कीमत कितनी है?","answer":"कीमतें लोड के वजन, LCV के आकार और सीज़न के अनुसार अलग-अलग होती हैं, कोई छिपा शुल्क नहीं। अपने लोड के लिए विशेष अनुमान हेतु ऊपर दिए गए मूल्य अनुमान टूल का उपयोग करें।"},{"question":"क्या ट्रांजिट के दौरान मेरे सामान का बीमा होता है?","answer":"हां, ट्रांजिट के दौरान आपके सामान की सुरक्षा के लिए इस रूट पर कार्गो बीमा उपलब्ध है।"},{"question":"दिल्ली से कोलकाता के लिए 1 टन लोड के लिए किस आकार का LCV चाहिए?","answer":"1 टन लोड आमतौर पर Tata Ace या Tata 407 जैसे मानक LCV में फिट हो जाता है। बुकिंग के समय अपने लोड का विवरण दर्ज करें और Vahak सही आकार सुझाएगा।"},{"question":"क्या मैं कल के लिए पिकअप शेड्यूल कर सकता हूं?","answer":"हां, आप केवल उसी दिन ही नहीं बल्कि किसी भी भविष्य की तारीख के लिए पिकअप शेड्यूल कर सकते हैं। लोड पोस्ट करते समय अपना पसंदीदा पिकअप समय सेट करें।"},{"question":"LCV के लिए अधिकतम पेलोड कितना है?","answer":"इस रूट पर अधिकांश LCV 3.5 टन तक ले जा सकते हैं। आपके लोड के वजन के आधार पर Vahak सही वाहन आकार से मिलान करेगा।"}],"popularRoutes":[{"label":"दिल्ली से जयपुर"},{"label":"कोलकाता से पटना"},{"label":"कोलकाता से भुवनेश्वर"}],"vehicleTypes":[{"label":"टाटा ऐस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]}},"cA":{"delhi":{"seo":{"title":"दिल्ली में LCV बुक करें | Vahak","description":"कुछ ही मिनटों में दिल्ली NCR में सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा हुआ शुल्क नहीं।"},"pickupCity":"दिल्ली","dropPlaceholder":"ड्रॉप लोकेशन दर्ज करें","heroHeadline2Lines":["दिल्ली"],"heroSub":"सत्यापित ट्रांसपोर्टर्स. लाइव ट्रैकिंग.","breadcrumbCityName":"दिल्ली","trustStrip":"दिल्ली NCR में 15,000+ सत्यापित ट्रांसपोर्टर्स","aboutTitle":"दिल्ली परिवहन के बारे में","aboutText":"दिल्ली NCR, भारत का राष्ट्रीय राजधानी क्षेत्र, सरकार, IT सेवाओं, ऑटो पार्ट्स और टेक्सटाइल क्षेत्रों में माल ढुलाई की मांग को बढ़ाता है। गुरुग्राम, नोएडा और फरीदाबाद जैसे केंद्रों के माध्यम से बड़ी मात्रा में विनिर्माण और ई-कॉमर्स शिपमेंट प्रतिदिन NH44 और NH48 जैसे फ्रेट कॉरिडोर से जुड़ते हैं।","tags":["सरकार और प्रशासन","IT सेवाएं","ऑटो पार्ट्स","टेक्सटाइल","ई-कॉमर्स"],"proofStats":[{"value":"15,000+","label":"दिल्ली NCR में सत्यापित ट्रांसपोर्टर्स"},{"value":"10 मिनट","label":"LCV बुक करने का समय"}],"localResources":{"title":"स्थानीय जानकारी","dhabas":[{"name":"अमरिक सुखदेव","location":"NH44, मुरथल, हरियाणा"}],"contacts":[{"label":"पुलिस","number":"100"},{"label":"एम्बुलेंस","number":"102"},{"label":"दिल्ली ट्रैफिक पुलिस हेल्पलाइन","number":"1095"},{"label":"दिल्ली परिवहन विभाग","number":"011-2399 4223"},{"label":"राष्ट्रीय राजमार्ग हेल्पलाइन","number":"1033"}],"moreToggle":"पेट्रोल पंप, सर्विस स्टेशन, अस्पताल देखें","note":"दिखाए गए आपातकालीन नंबर मानक राज्य/राष्ट्रीय हेल्पलाइन हैं — प्रकाशित करने से पहले किसी आधिकारिक स्रोत से सत्यापित करें।"},"faqs":[{"question":"क्या दिल्ली में ट्रक प्रवेश पर प्रतिबंध हैं?","answer":"हां, दिल्ली कुछ दिन के समय भारी वाहनों के प्रवेश को प्रतिबंधित करता है और कुछ मार्गों पर प्रवेश शुल्क लगाता है। Vahak ट्रांसपोर्टर्स इन नियमों के अनुसार पिकअप और ड्रॉप का समय स्वचालित रूप से तय करते हैं।","defaultOpen":true},{"question":"दिल्ली में LCV की कीमत कैसे तय होती है?","answer":"कीमत दूरी, लोड के वजन, वाहन के प्रकार और आपके मार्ग पर मौजूदा मांग पर निर्भर करती है। आप अपना लोड मुफ्त में पोस्ट कर सकते हैं और सत्यापित ट्रांसपोर्टर्स की बोलियों की तुलना कर सकते हैं।"},{"question":"क्या मुझे मेरी बुकिंग के लिए GST इनवॉइस मिलेगा?","answer":"हां, Vahak के माध्यम से की गई हर बुकिंग के लिए GST इनवॉइस दिया जाता है, जो आपका लोड कन्फर्म होते ही स्वचालित रूप से जनरेट हो जाता है।"},{"question":"अगर मेरा लोड समय पर पिकअप नहीं हुआ तो क्या होगा?","answer":"Vahak की सपोर्ट टीम हर सक्रिय बुकिंग पर नज़र रखती है और पिकअप में देरी होने पर आपके लोड को किसी अन्य सत्यापित ट्रांसपोर्टर को फिर से सौंपती है।"}],"popularRoutesLabel":"दिल्ली से लोकप्रिय मार्ग","popularRoutes":[{"label":"दिल्ली से जयपुर","href":"/lcv-booking/delhi-to-jaipur"},{"label":"दिल्ली से मुंबई","href":"/lcv-booking/delhi-to-mumbai"},{"label":"दिल्ली से कोलकाता","href":"/lcv-booking/delhi-to-kolkata"}],"vehicleTypesLabel":"वाहन के प्रकार के अनुसार बुक करें","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है जो शिपर्स को पूरे भारत में सत्यापित ट्रांसपोर्टर्स से जोड़ता है। दिल्ली NCR में, व्यवसाय Vahak का उपयोग करके पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और Pickup वाहन बुक करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","footerGroups":[{"label":"दिल्ली से लोकप्रिय मार्ग","links":[{"label":"दिल्ली से जयपुर LCV","href":"/lcv-booking/delhi-to-jaipur"},{"label":"दिल्ली से मुंबई LCV","href":"/lcv-booking/delhi-to-mumbai"},{"label":"दिल्ली से कोलकाता LCV","href":"/lcv-booking/delhi-to-kolkata"}],"moreLink":{"label":"सभी मार्ग देखें →","href":"/lcv-booking"}},{"label":"अन्य शहरों में LCV बुक करें","links":[{"label":"मुंबई","href":"/city/mumbai"},{"label":"बेंगलुरु","href":"/city/bangalore"},{"label":"पुणे","href":"/city/pune"},{"label":"हैदराबाद","href":"/city/hyderabad"}],"moreLink":{"label":"सभी शहर देखें →","href":"/"}},{"label":"वाहन प्रकार","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"कंपनी","links":[{"label":"हमारे बारे में","href":"/about-us"},{"label":"करियर","href":"/careers"},{"label":"संपर्क करें","href":"/contact-us"}]},{"label":"कानूनी","links":[{"label":"नियम और शर्तें","href":"/terms-and-conditions"},{"label":"गोपनीयता नीति","href":"/privacy-policy"},{"label":"अक्सर पूछे जाने वाले प्रश्न","href":"/frequently-asked-questions"}]}]},"jaipur":{"seo":{"title":"जयपुर में LCV बुक करें | Vahak","description":"कुछ ही मिनटों में जयपुर में सत्यापित LCV बुक करें। लाइव ट्रैकिंग, कार्गो बीमा, कोई छिपा हुआ शुल्क नहीं।"},"pickupCity":"जयपुर","dropPlaceholder":"ड्रॉप लोकेशन दर्ज करें","heroHeadline2Lines":["जयपुर"],"heroSub":"सत्यापित ट्रांसपोर्टर्स. लाइव ट्रैकिंग.","breadcrumbCityName":"जयपुर","trustStrip":"जयपुर में 5,000+ सत्यापित ट्रांसपोर्टर्स","aboutTitle":"जयपुर परिवहन के बारे में","aboutText":"जयपुर, भारत का रत्न और हस्तशिल्प केंद्र, आभूषण, वस्त्र और पर्यटन क्षेत्रों में माल ढुलाई की मांग को बढ़ाता है। रत्न, ब्लॉक-प्रिंट वस्त्र और हस्तशिल्प की भारी मात्रा में शिपमेंट रोज़ शहर से होकर NH48 और NH11 जैसे फ्रेट कॉरिडोर से जुड़ती हैं।","tags":["रत्न और आभूषण","वस्त्र और हस्तशिल्प","पर्यटन"],"proofStats":[{"value":"5,000+","label":"जयपुर में सत्यापित ट्रांसपोर्टर्स"},{"value":"10 मिनट","label":"LCV बुक करने का समय"}],"localResources":{"title":"स्थानीय जानकारी","dhabas":[{"name":"हाईवे किंग","location":"NH48, बहरोड़, राजस्थान"}],"contacts":[{"label":"पुलिस","number":"100"},{"label":"एम्बुलेंस","number":"108"},{"label":"जयपुर ट्रैफिक पुलिस हेल्पलाइन","number":"1095"},{"label":"राजस्थान परिवहन विभाग","number":"0141-2740021"},{"label":"राष्ट्रीय राजमार्ग हेल्पलाइन","number":"1033"}],"moreToggle":"पेट्रोल पंप, सर्विस स्टेशन, अस्पताल देखें","note":"दिखाए गए आपातकालीन नंबर मानक राज्य/राष्ट्रीय हेल्पलाइन हैं — प्रकाशित करने से पहले किसी आधिकारिक स्रोत से सत्यापित करें।"},"faqs":[{"question":"क्या जयपुर शहर की सीमा के भीतर ट्रक प्रवेश पर प्रतिबंध हैं?","answer":"कुछ आंतरिक शहर की सड़कों पर व्यस्त समय के दौरान भारी वाहनों की आवाजाही प्रतिबंधित होती है। Vahak ट्रांसपोर्टर्स इन नियमों के अनुसार पिकअप और ड्रॉप का समय स्वचालित रूप से तय करते हैं।","defaultOpen":true},{"question":"जयपुर में LCV की कीमत कैसे तय होती है?","answer":"कीमत दूरी, लोड के वजन, वाहन के प्रकार और आपके मार्ग पर मौजूदा मांग पर निर्भर करती है। आप अपना लोड मुफ्त में पोस्ट कर सकते हैं और सत्यापित ट्रांसपोर्टर्स की बोलियों की तुलना कर सकते हैं।"},{"question":"क्या मुझे मेरी बुकिंग के लिए GST इनवॉइस मिलेगा?","answer":"हां, Vahak के माध्यम से की गई हर बुकिंग के लिए GST इनवॉइस दिया जाता है, जो आपका लोड कन्फर्म होते ही स्वचालित रूप से जनरेट हो जाता है।"},{"question":"अगर मेरा लोड समय पर पिकअप नहीं हुआ तो क्या होगा?","answer":"Vahak की सपोर्ट टीम हर सक्रिय बुकिंग पर नज़र रखती है और पिकअप में देरी होने पर आपके लोड को किसी अन्य सत्यापित ट्रांसपोर्टर को फिर से सौंपती है।"}],"popularRoutesLabel":"जयपुर से लोकप्रिय मार्ग","popularRoutes":[{"label":"जयपुर से दिल्ली","href":"/lcv-booking/jaipur-to-delhi"}],"vehicleTypesLabel":"वाहन के प्रकार के अनुसार बुक करें","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak एक ऑनलाइन LCV बुकिंग मार्केटप्लेस है जो शिपर्स को पूरे भारत में सत्यापित ट्रांसपोर्टर्स से जोड़ता है। जयपुर में, व्यवसाय Vahak का उपयोग करके पार्ट-लोड और फुल-लोड LCV शिपमेंट के लिए Tata Ace, Tempo, Tata 407 और Pickup वाहन बुक करते हैं, हर बुकिंग पर लाइव ट्रैकिंग और कार्गो बीमा के साथ।","footerGroups":[{"label":"जयपुर से लोकप्रिय मार्ग","links":[{"label":"जयपुर से दिल्ली LCV","href":"/lcv-booking/jaipur-to-delhi"}],"moreLink":{"label":"सभी मार्ग देखें →","href":"/lcv-booking"}},{"label":"अन्य शहरों में LCV बुक करें","links":[{"label":"मुंबई","href":"/city/mumbai"},{"label":"दिल्ली","href":"/city/delhi"},{"label":"बेंगलुरु","href":"/city/bangalore"},{"label":"चेन्नई","href":"/city/chennai"}],"moreLink":{"label":"सभी शहर देखें →","href":"/"}},{"label":"वाहन प्रकार","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"कंपनी","links":[{"label":"हमारे बारे में","href":"/about-us"},{"label":"करियर","href":"/careers"},{"label":"संपर्क करें","href":"/contact-us"}]},{"label":"कानूनी","links":[{"label":"नियम और शर्तें","href":"/terms-and-conditions"},{"label":"गोपनीयता नीति","href":"/privacy-policy"},{"label":"अक्सर पूछे जाने वाले प्रश्न","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 28354:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"ಅಹಮದಾಬಾದ್‌ನಿಂದ ಮುಂಬೈ LCV","bangalore-to-chennai":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ LCV","bangalore-to-hyderabad":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ LCV","chennai-to-bangalore":"ಚೆನ್ನೈಯಿಂದ ಬೆಂಗಳೂರಿಗೆ LCV","chennai-to-hyderabad":"ಚೆನ್ನೈಯಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ LCV","hyderabad-to-bangalore":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ LCV","hyderabad-to-chennai":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಚೆನ್ನೈಗೆ LCV","delhi-to-jaipur":"ದೆಹಲಿಯಿಂದ ಜೈಪುರ LCV","delhi-to-kolkata":"ದೆಹಲಿಯಿಂದ ಕೊಲ್ಕತ್ತಾ LCV","delhi-to-mumbai":"ದೆಹಲಿಯಿಂದ ಮುಂಬೈ LCV","jaipur-to-delhi":"ಜೈಪುರದಿಂದ ದೆಹಲಿ LCV","kolkata-to-delhi":"ಕೊಲ್ಕತ್ತಾದಿಂದ ದೆಹಲಿ LCV","mumbai-to-ahmedabad":"ಮುಂಬೈಯಿಂದ ಅಹಮದಾಬಾದ್ LCV","mumbai-to-delhi":"ಮುಂಬೈಯಿಂದ ದೆಹಲಿ LCV","mumbai-to-pune":"ಮುಂಬೈಯಿಂದ ಪುಣೆ LCV","pune-to-mumbai":"ಪುಣೆಯಿಂದ ಮುಂಬೈ LCV"}},"_j":{"bangalore-to-hyderabad":{"seo":{"title":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ LCV ಬುಕ್ ಮಾಡಿ | Vahak","description":"ನಿಮಿಷಗಳಲ್ಲಿ ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ ಪರಿಶೀಲಿತ LCV ಬುಕ್ ಮಾಡಿ. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಸರಕು ವಿಮೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ. ಈ ಮಾರ್ಗದಲ್ಲಿ 500+ ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರು."},"pickupCity":"ಬೆಂಗಳೂರು","dropCity":"ಹೈದರಾಬಾದ್","heroHeadline2Lines":["ಬೆಂಗಳೂರಿನಿಂದ","ಹೈದರಾಬಾದ್‌ಗೆ"],"heroSub":"ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರು. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್.","breadcrumbRouteName":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ","aboutText":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ NH44 ಮಾರ್ಗದ ಉದ್ದಕ್ಕೂ 570 ಕಿ.ಮೀ ದೂರವಿದ್ದು, ರಸ್ತೆ ಮೂಲಕ ಸಾಮಾನ್ಯವಾಗಿ 10-12 ಗಂಟೆಗಳಲ್ಲಿ ಕ್ರಮಿಸಬಹುದು. ಇದು ಕರ್ನಾಟಕದ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಮತ್ತು ತಂತ್ರಜ್ಞಾನ ಉತ್ಪಾದನಾ ಕೇಂದ್ರವನ್ನು ಹೈದರಾಬಾದ್‌ನ ಫಾರ್ಮಾ, ಐಟಿ ಮತ್ತು ಕೈಗಾರಿಕಾ ಕೇಂದ್ರಗಳೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಪ್ರಮುಖ ಸರಕು ಮಾರ್ಗವಾಗಿದೆ — ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್, ಔಷಧ ಉತ್ಪನ್ನಗಳು, ಜವಳಿ ಮತ್ತು ಯಂತ್ರೋಪಕರಣ ಸಾಗಣೆಗೆ ಸಾಮಾನ್ಯವಾಗಿ ಬಳಸಲಾಗುತ್ತದೆ.","footerSeoText":"Vahak ಎಂಬುದು ಭಾರತದಾದ್ಯಂತ ಸಾಗಣೆದಾರರನ್ನು ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಆನ್‌ಲೈನ್ LCV ಬುಕಿಂಗ್ ಮಾರುಕಟ್ಟೆಯಾಗಿದೆ. ಬೆಂಗಳೂರು-ಹೈದರಾಬಾದ್ ಮಾರ್ಗದಲ್ಲಿ, ವ್ಯವಹಾರಗಳು ಭಾಗಶಃ ಮತ್ತು ಪೂರ್ಣ ಲೋಡ್ LCV ಸಾಗಣೆಗಾಗಿ Tata Ace, Tempo, Tata 407 ಮತ್ತು ಪಿಕಪ್ ವಾಹನಗಳನ್ನು ಬುಕ್ ಮಾಡಲು Vahak ಅನ್ನು ಬಳಸುತ್ತವೆ, ಪ್ರತಿ ಬುಕಿಂಗ್‌ನಲ್ಲಿ ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಸರಕು ವಿಮೆಯೊಂದಿಗೆ.","faqs":[{"question":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ ಅದೇ ದಿನ LCV ಲಭ್ಯವಿದೆಯೇ?","answer":"ಹೌದು, ಸಾಮಾನ್ಯವಾಗಿ ಅದೇ ದಿನ ಪಿಕಪ್ ಲಭ್ಯವಿದೆ. ಈ ಮಾರ್ಗದಲ್ಲಿ ಹೆಚ್ಚಿನ ಬುಕಿಂಗ್‌ಗಳಿಗೆ 10 ನಿಮಿಷಗಳಲ್ಲಿ ಸಾಗಣೆದಾರರು ದೃಢಪಡುತ್ತಾರೆ.","defaultOpen":true},{"question":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ LCV ವೆಚ್ಚ ಎಷ್ಟು?","answer":"ಬೆಲೆಗಳು ಲೋಡ್ ತೂಕ, LCV ಗಾತ್ರ ಮತ್ತು ಋತುವಿನ ಪ್ರಕಾರ ಬದಲಾಗುತ್ತವೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ. ನಿಮ್ಮ ಲೋಡ್‌ಗೆ ನಿರ್ದಿಷ್ಟ ಉಲ್ಲೇಖಕ್ಕಾಗಿ ಮೇಲಿನ ಬೆಲೆ ಅಂದಾಜು ಪರಿಕರವನ್ನು ಬಳಸಿ."},{"question":"ಸಾಗಣೆ ಸಮಯದಲ್ಲಿ ನನ್ನ ಸರಕು ವಿಮೆ ಮಾಡಲ್ಪಟ್ಟಿದೆಯೇ?","answer":"ಹೌದು, ಸಾಗಣೆ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಸರಕುಗಳನ್ನು ರಕ್ಷಿಸಲು ಈ ಮಾರ್ಗದಲ್ಲಿ ಸರಕು ವಿಮೆ ಲಭ್ಯವಿದೆ."},{"question":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್‌ಗೆ 1 ಟನ್ ಲೋಡ್‌ಗೆ ಯಾವ ಗಾತ್ರದ LCV ಬೇಕು?","answer":"1 ಟನ್ ಲೋಡ್ ಸಾಮಾನ್ಯವಾಗಿ Tata Ace ಅಥವಾ Tata 407 ನಂತಹ ಪ್ರಮಾಣಿತ LCV ಗೆ ಸೂಕ್ತವಾಗಿದೆ. ಬುಕಿಂಗ್ ಮಾಡುವಾಗ ನಿಮ್ಮ ಲೋಡ್ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ ಮತ್ತು Vahak ಸೂಕ್ತ ಗಾತ್ರವನ್ನು ಸೂಚಿಸುತ್ತದೆ."},{"question":"ನಾನು ನಾಳೆಗೆ ಪಿಕಪ್ ವೇಳಾಪಟ್ಟಿ ಮಾಡಬಹುದೇ?","answer":"ಹೌದು, ಅದೇ ದಿನ ಮಾತ್ರವಲ್ಲದೆ ಯಾವುದೇ ಭವಿಷ್ಯದ ದಿನಾಂಕಕ್ಕೆ ಪಿಕಪ್ ವೇಳಾಪಟ್ಟಿ ಮಾಡಬಹುದು. ಲೋಡ್ ಪೋಸ್ಟ್ ಮಾಡುವಾಗ ನಿಮ್ಮ ಆದ್ಯತೆಯ ಪಿಕಪ್ ಸಮಯವನ್ನು ಹೊಂದಿಸಿ."},{"question":"LCV ಗೆ ಗರಿಷ್ಠ ಪೇಲೋಡ್ ಎಷ್ಟು?","answer":"ಈ ಮಾರ್ಗದಲ್ಲಿ ಹೆಚ್ಚಿನ LCV ಗಳು 3.5 ಟನ್‌ವರೆಗೆ ಸಾಗಿಸುತ್ತವೆ. ನಿಮ್ಮ ಲೋಡ್ ತೂಕದ ಆಧಾರದ ಮೇಲೆ Vahak ಸೂಕ್ತ ವಾಹನ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸುತ್ತದೆ."}],"popularRoutes":[{"label":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈ"},{"label":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಚೆನ್ನೈ"},{"label":"ಬೆಂಗಳೂರಿನಿಂದ ಪುಣೆ"}],"vehicleTypes":[{"label":"ಟಾಟಾ ಏಸ್"},{"label":"ಟೆಂಪೋ"},{"label":"ಟಾಟಾ 407"},{"label":"ಪಿಕಪ್"}]},"hyderabad-to-bangalore":{"seo":{"title":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ LCV ಬುಕ್ ಮಾಡಿ | Vahak","description":"ನಿಮಿಷಗಳಲ್ಲಿ ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ ಪರಿಶೀಲಿತ LCV ಬುಕ್ ಮಾಡಿ. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಸರಕು ವಿಮೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ. ಈ ಮಾರ್ಗದಲ್ಲಿ 500+ ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರು."},"pickupCity":"ಹೈದರಾಬಾದ್","dropCity":"ಬೆಂಗಳೂರು","heroHeadline2Lines":["ಹೈದರಾಬಾದ್‌ನಿಂದ","ಬೆಂಗಳೂರಿಗೆ"],"heroSub":"ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರು. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್.","breadcrumbRouteName":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ","aboutText":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ NH44 ಮಾರ್ಗದ ಉದ್ದಕ್ಕೂ 570 ಕಿ.ಮೀ ದೂರವಿದ್ದು, ರಸ್ತೆ ಮೂಲಕ ಸಾಮಾನ್ಯವಾಗಿ 10-12 ಗಂಟೆಗಳಲ್ಲಿ ಕ್ರಮಿಸಬಹುದು. ಇದು ಹೈದರಾಬಾದ್‌ನ ಫಾರ್ಮಾ, ಐಟಿ ಮತ್ತು ಕೈಗಾರಿಕಾ ಕೇಂದ್ರಗಳನ್ನು ಕರ್ನಾಟಕದ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಮತ್ತು ತಂತ್ರಜ್ಞಾನ ಉತ್ಪಾದನಾ ಕೇಂದ್ರದೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಪ್ರಮುಖ ಸರಕು ಮಾರ್ಗವಾಗಿದೆ — ಔಷಧ ಉತ್ಪನ್ನಗಳು, ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್, ಜವಳಿ ಮತ್ತು ಯಂತ್ರೋಪಕರಣ ಸಾಗಣೆಗೆ ಸಾಮಾನ್ಯವಾಗಿ ಬಳಸಲಾಗುತ್ತದೆ.","footerSeoText":"Vahak ಎಂಬುದು ಭಾರತದಾದ್ಯಂತ ಸಾಗಣೆದಾರರನ್ನು ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಆನ್‌ಲೈನ್ LCV ಬುಕಿಂಗ್ ಮಾರುಕಟ್ಟೆಯಾಗಿದೆ. ಹೈದರಾಬಾದ್-ಬೆಂಗಳೂರು ಮಾರ್ಗದಲ್ಲಿ, ವ್ಯವಹಾರಗಳು ಭಾಗಶಃ ಮತ್ತು ಪೂರ್ಣ ಲೋಡ್ LCV ಸಾಗಣೆಗಾಗಿ Tata Ace, Tempo, Tata 407 ಮತ್ತು ಪಿಕಪ್ ವಾಹನಗಳನ್ನು ಬುಕ್ ಮಾಡಲು Vahak ಅನ್ನು ಬಳಸುತ್ತವೆ, ಪ್ರತಿ ಬುಕಿಂಗ್‌ನಲ್ಲಿ ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಸರಕು ವಿಮೆಯೊಂದಿಗೆ.","faqs":[{"question":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ ಅದೇ ದಿನ LCV ಲಭ್ಯವಿದೆಯೇ?","answer":"ಹೌದು, ಸಾಮಾನ್ಯವಾಗಿ ಅದೇ ದಿನ ಪಿಕಪ್ ಲಭ್ಯವಿದೆ. ಈ ಮಾರ್ಗದಲ್ಲಿ ಹೆಚ್ಚಿನ ಬುಕಿಂಗ್‌ಗಳಿಗೆ 10 ನಿಮಿಷಗಳಲ್ಲಿ ಸಾಗಣೆದಾರರು ದೃಢಪಡುತ್ತಾರೆ.","defaultOpen":true},{"question":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ LCV ವೆಚ್ಚ ಎಷ್ಟು?","answer":"ಬೆಲೆಗಳು ಲೋಡ್ ತೂಕ, LCV ಗಾತ್ರ ಮತ್ತು ಋತುವಿನ ಪ್ರಕಾರ ಬದಲಾಗುತ್ತವೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ. ನಿಮ್ಮ ಲೋಡ್‌ಗೆ ನಿರ್ದಿಷ್ಟ ಉಲ್ಲೇಖಕ್ಕಾಗಿ ಮೇಲಿನ ಬೆಲೆ ಅಂದಾಜು ಪರಿಕರವನ್ನು ಬಳಸಿ."},{"question":"ಸಾಗಣೆ ಸಮಯದಲ್ಲಿ ನನ್ನ ಸರಕು ವಿಮೆ ಮಾಡಲ್ಪಟ್ಟಿದೆಯೇ?","answer":"ಹೌದು, ಸಾಗಣೆ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಸರಕುಗಳನ್ನು ರಕ್ಷಿಸಲು ಈ ಮಾರ್ಗದಲ್ಲಿ ಸರಕು ವಿಮೆ ಲಭ್ಯವಿದೆ."},{"question":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಬೆಂಗಳೂರಿಗೆ 1 ಟನ್ ಲೋಡ್‌ಗೆ ಯಾವ ಗಾತ್ರದ LCV ಬೇಕು?","answer":"1 ಟನ್ ಲೋಡ್ ಸಾಮಾನ್ಯವಾಗಿ Tata Ace ಅಥವಾ Tata 407 ನಂತಹ ಪ್ರಮಾಣಿತ LCV ಗೆ ಸೂಕ್ತವಾಗಿದೆ. ಬುಕಿಂಗ್ ಮಾಡುವಾಗ ನಿಮ್ಮ ಲೋಡ್ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ ಮತ್ತು Vahak ಸೂಕ್ತ ಗಾತ್ರವನ್ನು ಸೂಚಿಸುತ್ತದೆ."},{"question":"ನಾನು ನಾಳೆಗೆ ಪಿಕಪ್ ವೇಳಾಪಟ್ಟಿ ಮಾಡಬಹುದೇ?","answer":"ಹೌದು, ಅದೇ ದಿನ ಮಾತ್ರವಲ್ಲದೆ ಯಾವುದೇ ಭವಿಷ್ಯದ ದಿನಾಂಕಕ್ಕೆ ಪಿಕಪ್ ವೇಳಾಪಟ್ಟಿ ಮಾಡಬಹುದು. ಲೋಡ್ ಪೋಸ್ಟ್ ಮಾಡುವಾಗ ನಿಮ್ಮ ಆದ್ಯತೆಯ ಪಿಕಪ್ ಸಮಯವನ್ನು ಹೊಂದಿಸಿ."},{"question":"LCV ಗೆ ಗರಿಷ್ಠ ಪೇಲೋಡ್ ಎಷ್ಟು?","answer":"ಈ ಮಾರ್ಗದಲ್ಲಿ ಹೆಚ್ಚಿನ LCV ಗಳು 3.5 ಟನ್‌ವರೆಗೆ ಸಾಗಿಸುತ್ತವೆ. ನಿಮ್ಮ ಲೋಡ್ ತೂಕದ ಆಧಾರದ ಮೇಲೆ Vahak ಸೂಕ್ತ ವಾಹನ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸುತ್ತದೆ."}],"popularRoutes":[{"label":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಚೆನ್ನೈ"},{"label":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈ"},{"label":"ಹೈದರಾಬಾದ್‌ನಿಂದ ಪುಣೆ"}],"vehicleTypes":[{"label":"ಟಾಟಾ ಏಸ್"},{"label":"ಟೆಂಪೋ"},{"label":"ಟಾಟಾ 407"},{"label":"ಪಿಕಪ್"}]},"bangalore-to-chennai":{"seo":{"title":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ LCV ಬುಕ್ ಮಾಡಿ | Vahak","description":"ನಿಮಿಷಗಳಲ್ಲಿ ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ ಪರಿಶೀಲಿತ LCV ಬುಕ್ ಮಾಡಿ. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಸರಕು ವಿಮೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ. ಈ ಮಾರ್ಗದಲ್ಲಿ 500+ ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರು."},"pickupCity":"ಬೆಂಗಳೂರು","dropCity":"ಚೆನ್ನೈ","heroHeadline2Lines":["ಬೆಂಗಳೂರಿನಿಂದ","ಚೆನ್ನೈಗೆ"],"heroSub":"ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರು. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್.","breadcrumbRouteName":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ","aboutText":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ NH48 ಮಾರ್ಗದ ಉದ್ದಕ್ಕೂ 350 ಕಿ.ಮೀ ದೂರವಿದ್ದು, ರಸ್ತೆ ಮೂಲಕ ಸಾಮಾನ್ಯವಾಗಿ 6-7 ಗಂಟೆಗಳಲ್ಲಿ ಕ್ರಮಿಸಬಹುದು. ಇದು ಕರ್ನಾಟಕದ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಮತ್ತು ತಂತ್ರಜ್ಞಾನ ಉತ್ಪಾದನಾ ಕೇಂದ್ರವನ್ನು ಚೆನ್ನೈನ ಆಟೋಮೋಟಿವ್ ಮತ್ತು ಆಟೋ-ಆನ್ಸಿಲರಿ ಕೇಂದ್ರದೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುತ್ತದೆ — ಇದನ್ನು ಸಾಮಾನ್ಯವಾಗಿ ಆಟೋ ಪಾರ್ಟ್ಸ್, ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್, ಐಟಿ ಹಾರ್ಡ್‌ವೇರ್, ಚರ್ಮದ ಸಾಮಾಗ್ರಿ ಮತ್ತು ಜವಳಿ ಸಾಗಣೆಗೆ ಬಳಸಲಾಗುತ್ತದೆ.","footerSeoText":"Vahak ಎಂಬುದು ಭಾರತದಾದ್ಯಂತ ಸಾಗಣೆದಾರರನ್ನು ಪರಿಶೀಲಿತ ಸಾಗಣೆದಾರರೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುವ ಆನ್‌ಲೈನ್ LCV ಬುಕಿಂಗ್ ಮಾರುಕಟ್ಟೆಯಾಗಿದೆ. ಬೆಂಗಳೂರು-ಚೆನ್ನೈ ಮಾರ್ಗದಲ್ಲಿ, ವ್ಯವಹಾರಗಳು ಭಾಗಶಃ ಮತ್ತು ಪೂರ್ಣ ಲೋಡ್ LCV ಸಾಗಣೆಗಾಗಿ Tata Ace, Tempo, Tata 407 ಮತ್ತು ಪಿಕಪ್ ವಾಹನಗಳನ್ನು ಬುಕ್ ಮಾಡಲು Vahak ಅನ್ನು ಬಳಸುತ್ತವೆ, ಪ್ರತಿ ಬುಕಿಂಗ್‌ನಲ್ಲಿ ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಸರಕು ವಿಮೆಯೊಂದಿಗೆ.","faqs":[{"question":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ ಅದೇ ದಿನ LCV ಲಭ್ಯವಿದೆಯೇ?","answer":"ಹೌದು, ಸಾಮಾನ್ಯವಾಗಿ ಅದೇ ದಿನ ಪಿಕಪ್ ಲಭ್ಯವಿದೆ. ಈ ಮಾರ್ಗದಲ್ಲಿ ಹೆಚ್ಚಿನ ಬುಕಿಂಗ್‌ಗಳಿಗೆ 10 ನಿಮಿಷಗಳಲ್ಲಿ ಸಾಗಣೆದಾರರು ದೃಢಪಡುತ್ತಾರೆ.","defaultOpen":true},{"question":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ LCV ವೆಚ್ಚ ಎಷ್ಟು?","answer":"ಬೆಲೆಗಳು ಲೋಡ್ ತೂಕ, LCV ಗಾತ್ರ ಮತ್ತು ಋತುವಿನ ಪ್ರಕಾರ ಬದಲಾಗುತ್ತವೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ. ನಿಮ್ಮ ಲೋಡ್‌ಗೆ ನಿರ್ದಿಷ್ಟ ಉಲ್ಲೇಖಕ್ಕಾಗಿ ಮೇಲಿನ ಬೆಲೆ ಅಂದಾಜು ಪರಿಕರವನ್ನು ಬಳಸಿ."},{"question":"ಸಾಗಣೆ ಸಮಯದಲ್ಲಿ ನನ್ನ ಸರಕು ವಿಮೆ ಮಾಡಲ್ಪಟ್ಟಿದೆಯೇ?","answer":"ಹೌದು, ಸಾಗಣೆ ಸಮಯದಲ್ಲಿ ನಿಮ್ಮ ಸರಕುಗಳನ್ನು ರಕ್ಷಿಸಲು ಈ ಮಾರ್ಗದಲ್ಲಿ ಸರಕು ವಿಮೆ ಲಭ್ಯವಿದೆ."},{"question":"ಬೆಂಗಳೂರಿನಿಂದ ಚೆನ್ನೈಗೆ 1 ಟನ್ ಲೋಡ್‌ಗೆ ಯಾವ ಗಾತ್ರದ LCV ಬೇಕು?","answer":"1 ಟನ್ ಲೋಡ್ ಸಾಮಾನ್ಯವಾಗಿ Tata Ace ಅಥವಾ Tata 407 ನಂತಹ ಪ್ರಮಾಣಿತ LCV ಗೆ ಸೂಕ್ತವಾಗಿದೆ. ಬುಕಿಂಗ್ ಮಾಡುವಾಗ ನಿಮ್ಮ ಲೋಡ್ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ ಮತ್ತು Vahak ಸೂಕ್ತ ಗಾತ್ರವನ್ನು ಸೂಚಿಸುತ್ತದೆ."},{"question":"ನಾನು ನಾಳೆಗೆ ಪಿಕಪ್ ವೇಳಾಪಟ್ಟಿ ಮಾಡಬಹುದೇ?","answer":"ಹೌದು, ಅದೇ ದಿನ ಮಾತ್ರವಲ್ಲದೆ ಯಾವುದೇ ಭವಿಷ್ಯದ ದಿನಾಂಕಕ್ಕೆ ಪಿಕಪ್ ವೇಳಾಪಟ್ಟಿ ಮಾಡಬಹುದು. ಲೋಡ್ ಪೋಸ್ಟ್ ಮಾಡುವಾಗ ನಿಮ್ಮ ಆದ್ಯತೆಯ ಪಿಕಪ್ ಸಮಯವನ್ನು ಹೊಂದಿಸಿ."},{"question":"LCV ಗೆ ಗರಿಷ್ಠ ಪೇಲೋಡ್ ಎಷ್ಟು?","answer":"ಈ ಮಾರ್ಗದಲ್ಲಿ ಹೆಚ್ಚಿನ LCV ಗಳು 3.5 ಟನ್‌ವರೆಗೆ ಸಾಗಿಸುತ್ತವೆ. ನಿಮ್ಮ ಲೋಡ್ ತೂಕದ ಆಧಾರದ ಮೇಲೆ Vahak ಸೂಕ್ತ ವಾಹನ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸುತ್ತದೆ."}],"popularRoutes":[{"label":"ಬೆಂಗಳೂರಿನಿಂದ ಹೈದರಾಬಾದ್"},{"label":"ಚೆನ್ನೈನಿಂದ ಹೈದರಾಬಾದ್"},{"label":"ಬೆಂಗಳೂರಿನಿಂದ ಪುಣೆ"}],"vehicleTypes":[{"label":"ಟಾಟಾ ಏಸ್"},{"label":"ಟೆಂಪೋ"},{"label":"ಟಾಟಾ 407"},{"label":"ಪಿಕಪ್"}]}},"cA":{"bangalore":{"seo":{"title":"ಬೆಂಗಳೂರಿನಲ್ಲಿ LCV ಬುಕ್ ಮಾಡಿ | Vahak","description":"ಕೆಲವು ನಿಮಿಷಗಳಲ್ಲಿ ಬೆಂಗಳೂರಿನಲ್ಲಿ ಪ್ರಮಾಣೀಕೃತ LCV ಬುಕ್ ಮಾಡಿ. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್, ಕಾರ್ಗೋ ವಿಮೆ, ಯಾವುದೇ ಗುಪ್ತ ಶುಲ್ಕಗಳಿಲ್ಲ."},"pickupCity":"ಬೆಂಗಳೂರು","dropPlaceholder":"ಡ್ರಾಪ್ ಸ್ಥಳ ನಮೂದಿಸಿ","heroHeadline2Lines":["ಬೆಂಗಳೂರು"],"heroSub":"ಪ್ರಮಾಣೀಕೃತ ಸಾರಿಗೆದಾರರು. ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್.","breadcrumbCityName":"ಬೆಂಗಳೂರು","trustStrip":"ಬೆಂಗಳೂರಿನಲ್ಲಿ 8,000+ ಪ್ರಮಾಣೀಕೃತ ಸಾರಿಗೆದಾರರು","aboutTitle":"ಬೆಂಗಳೂರು ಸಾರಿಗೆ ಬಗ್ಗೆ","aboutText":"ಬೆಂಗಳೂರು, ಭಾರತದ IT ಮತ್ತು ಸ್ಟಾರ್ಟಪ್ ರಾಜಧಾನಿ, ಸಾಫ್ಟ್‌ವೇರ್, ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಉತ್ಪಾದನೆ, ಬಯೋಟೆಕ್ನಾಲಜಿ ಮತ್ತು ಏರೋಸ್ಪೇಸ್ ಕ್ಷೇತ್ರಗಳಲ್ಲಿ ಸರಕು ಸಾಗಣೆಯ ಬೇಡಿಕೆಯನ್ನು ಹೆಚ್ಚಿಸುತ್ತದೆ. ಪೀಣ್ಯ ಮತ್ತು ಎಲೆಕ್ಟ್ರಾನಿಕ್ ಸಿಟಿಯಂತಹ ಕೇಂದ್ರಗಳ ಮೂಲಕ ದೊಡ್ಡ ಪ್ರಮಾಣದ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಮತ್ತು ಕೈಗಾರಿಕಾ ಘಟಕಗಳ ಸಾಗಣೆ ಪ್ರತಿದಿನ NH44 ಮತ್ತು NH75 ನಂತಹ ಫ್ರೇಟ್ ಕಾರಿಡಾರ್‌ಗಳಿಗೆ ಸಂಪರ್ಕಿಸುತ್ತದೆ.","tags":["IT ಮತ್ತು ಸಾಫ್ಟ್‌ವೇರ್","ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಉತ್ಪಾದನೆ","ಬಯೋಟೆಕ್ನಾಲಜಿ","ಏರೋಸ್ಪೇಸ್","ಸ್ಟಾರ್ಟಪ್‌ಗಳು"],"proofStats":[{"value":"8,000+","label":"ಬೆಂಗಳೂರಿನಲ್ಲಿ ಪ್ರಮಾಣೀಕೃತ ಸಾರಿಗೆದಾರರು"},{"value":"10 ನಿಮಿಷ","label":"LCV ಬುಕ್ ಮಾಡುವ ಸಮಯ"}],"localResources":{"title":"ಸ್ಥಳೀಯ ಮಾಹಿತಿ","dhabas":[{"name":"ಹೋಟೆಲ್ ಕಾರ್ತಿಕ್","location":"NH75, ಕುಣಿಗಲ್"}],"contacts":[{"label":"ಪೊಲೀಸ್","number":"100"},{"label":"ಆಂಬ್ಯುಲೆನ್ಸ್","number":"108"},{"label":"ಬೆಂಗಳೂರು ಟ್ರಾಫಿಕ್ ಕಂಟ್ರೋಲ್ ರೂಮ್","number":"1073"},{"label":"ರಾಷ್ಟ್ರೀಯ ಹೆದ್ದಾರಿ ಸಹಾಯವಾಣಿ","number":"1033"}],"moreToggle":"ಪೆಟ್ರೋಲ್ ಬಂಕ್‌ಗಳು, ಸರ್ವಿಸ್ ಸ್ಟೇಷನ್‌ಗಳು, ಆಸ್ಪತ್ರೆಗಳನ್ನು ವೀಕ್ಷಿಸಿ","note":"ತೋರಿಸಿರುವ ತುರ್ತು ಸಂಖ್ಯೆಗಳು ಪ್ರಮಾಣಿತ ರಾಜ್ಯ/ರಾಷ್ಟ್ರೀಯ ಸಹಾಯವಾಣಿಗಳಾಗಿವೆ — ಪ್ರಕಟಿಸುವ ಮೊದಲು ಅಧಿಕೃತ ಮೂಲದಿಂದ ಪರಿಶೀಲಿಸಿ."},"faqs":[{"question":"ಬೆಂಗಳೂರು ನಗರ ಮಿತಿಯೊಳಗೆ ಟ್ರಕ್ ಪ್ರವೇಶ ನಿರ್ಬಂಧಗಳಿವೆಯೇ?","answer":"ಕೆಲವು ಒಳನಗರ ರಸ್ತೆಗಳು ಗರಿಷ್ಠ ಸಮಯದಲ್ಲಿ ಭಾರೀ ವಾಹನಗಳ ಸಂಚಾರವನ್ನು ನಿರ್ಬಂಧಿಸುತ್ತವೆ. Vahak ಸಾರಿಗೆದಾರರು ಈ ನಿಯಮಗಳ ಪ್ರಕಾರ ಪಿಕಪ್ ಮತ್ತು ಡ್ರಾಪ್ ಸಮಯವನ್ನು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಯೋಜಿಸುತ್ತಾರೆ.","defaultOpen":true},{"question":"ಬೆಂಗಳೂರಿನಲ್ಲಿ LCV ಬೆಲೆಯನ್ನು ಹೇಗೆ ನಿರ್ಧರಿಸಲಾಗುತ್ತದೆ?","answer":"ಬೆಲೆಯು ಅಂತರ, ಲೋಡ್ ತೂಕ, ವಾಹನದ ಪ್ರಕಾರ ಮತ್ತು ನಿಮ್ಮ ಮಾರ್ಗದಲ್ಲಿನ ಪ್ರಸ್ತುತ ಬೇಡಿಕೆಯನ್ನು ಅವಲಂಬಿಸಿರುತ್ತದೆ. ನೀವು ನಿಮ್ಮ ಲೋಡ್ ಅನ್ನು ಉಚಿತವಾಗಿ ಪೋಸ್ಟ್ ಮಾಡಬಹುದು ಮತ್ತು ಪ್ರಮಾಣೀಕೃತ ಸಾರಿಗೆದಾರರ ಬಿಡ್‌ಗಳನ್ನು ಹೋಲಿಸಬಹುದು."},{"question":"ನನ್ನ ಬುಕಿಂಗ್‌ಗೆ GST ಇನ್‌ವಾಯ್ಸ್ ಸಿಗುತ್ತದೆಯೇ?","answer":"ಹೌದು, Vahak ಮೂಲಕ ಮಾಡಿದ ಪ್ರತಿ ಬುಕಿಂಗ್‌ಗೆ GST ಇನ್‌ವಾಯ್ಸ್ ನೀಡಲಾಗುತ್ತದೆ, ಇದು ನಿಮ್ಮ ಲೋಡ್ ದೃಢೀಕರಿಸಿದ ನಂತರ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಲ್ಪಡುತ್ತದೆ."},{"question":"ನನ್ನ ಲೋಡ್ ಸಮಯಕ್ಕೆ ಪಿಕಪ್ ಆಗದಿದ್ದರೆ ಏನಾಗುತ್ತದೆ?","answer":"Vahak ನ ಬೆಂಬಲ ತಂಡವು ಪ್ರತಿ ಸಕ್ರಿಯ ಬುಕಿಂಗ್ ಅನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡುತ್ತದೆ ಮತ್ತು ಪಿಕಪ್ ವಿಳಂಬವಾದರೆ ನಿಮ್ಮ ಲೋಡ್ ಅನ್ನು ಇನ್ನೊಬ್ಬ ಪ್ರಮಾಣೀಕೃತ ಸಾರಿಗೆದಾರರಿಗೆ ಮರುನಿಯೋಜಿಸಲು ಮಧ್ಯಪ್ರವೇಶಿಸುತ್ತದೆ."}],"popularRoutesLabel":"ಬೆಂಗಳೂರಿನಿಂದ ಜನಪ್ರಿಯ ಮಾರ್ಗಗಳು","popularRoutes":[{"label":"ಬೆಂಗಳೂರು ರಿಂದ ಹೈದರಾಬಾದ್","href":"/lcv-booking/bangalore-to-hyderabad"},{"label":"ಬೆಂಗಳೂರು ರಿಂದ ಚೆನ್ನೈ","href":"/lcv-booking/bangalore-to-chennai"}],"vehicleTypesLabel":"ವಾಹನ ಪ್ರಕಾರದ ಮೂಲಕ ಬುಕ್ ಮಾಡಿ","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak ಒಂದು ಆನ್‌ಲೈನ್ LCV ಬುಕಿಂಗ್ ಮಾರುಕಟ್ಟೆಯಾಗಿದ್ದು, ಇದು ಶಿಪ್ಪರ್‌ಗಳನ್ನು ಭಾರತದಾದ್ಯಂತ ಪ್ರಮಾಣೀಕೃತ ಸಾರಿಗೆದಾರರೊಂದಿಗೆ ಸಂಪರ್ಕಿಸುತ್ತದೆ. ಬೆಂಗಳೂರಿನಲ್ಲಿ, ವ್ಯವಹಾರಗಳು Vahak ಬಳಸಿ ಪಾರ್ಟ್-ಲೋಡ್ ಮತ್ತು ಫುಲ್-ಲೋಡ್ LCV ಸಾಗಣೆಗಾಗಿ Tata Ace, Tempo, Tata 407 ಮತ್ತು Pickup ವಾಹನಗಳನ್ನು ಬುಕ್ ಮಾಡುತ್ತಾರೆ, ಪ್ರತಿ ಬುಕಿಂಗ್‌ನಲ್ಲಿ ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್ ಮತ್ತು ಕಾರ್ಗೋ ವಿಮೆಯೊಂದಿಗೆ.","footerGroups":[{"label":"ಬೆಂಗಳೂರಿನಿಂದ ಜನಪ್ರಿಯ ಮಾರ್ಗಗಳು","links":[{"label":"ಬೆಂಗಳೂರು ರಿಂದ ಹೈದರಾಬಾದ್ LCV","href":"/lcv-booking/bangalore-to-hyderabad"},{"label":"ಬೆಂಗಳೂರು ರಿಂದ ಚೆನ್ನೈ LCV","href":"/lcv-booking/bangalore-to-chennai"}],"moreLink":{"label":"ಎಲ್ಲಾ ಮಾರ್ಗಗಳನ್ನು ವೀಕ್ಷಿಸಿ →","href":"/lcv-booking"}},{"label":"ಇತರ ನಗರಗಳಲ್ಲಿ LCV ಬುಕ್ ಮಾಡಿ","links":[{"label":"ಮುಂಬೈ","href":"/city/mumbai"},{"label":"ದೆಹಲಿ","href":"/city/delhi"},{"label":"ಪುಣೆ","href":"/city/pune"},{"label":"ಹೈದರಾಬಾದ್","href":"/city/hyderabad"}],"moreLink":{"label":"ಎಲ್ಲಾ ನಗರಗಳನ್ನು ವೀಕ್ಷಿಸಿ →","href":"/"}},{"label":"ವಾಹನ ಪ್ರಕಾರಗಳು","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"ಕಂಪನಿ","links":[{"label":"ನಮ್ಮ ಬಗ್ಗೆ","href":"/about-us"},{"label":"ವೃತ್ತಿಜೀವನ","href":"/careers"},{"label":"ಸಂಪರ್ಕಿಸಿ","href":"/contact-us"}]},{"label":"ಕಾನೂನು","links":[{"label":"ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು","href":"/terms-and-conditions"},{"label":"ಗೌಪ್ಯತಾ ನೀತಿ","href":"/privacy-policy"},{"label":"ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 42086:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"अहमदाबाद ते मुंबई LCV","bangalore-to-chennai":"बंगळूर ते चेन्नई LCV","bangalore-to-hyderabad":"बंगळूर ते हैदराबाद LCV","chennai-to-bangalore":"चेन्नई ते बंगळूर LCV","chennai-to-hyderabad":"चेन्नई ते हैदराबाद LCV","hyderabad-to-bangalore":"हैदराबाद ते बंगळूर LCV","hyderabad-to-chennai":"हैदराबाद ते चेन्नई LCV","delhi-to-jaipur":"दिल्ली ते जयपूर LCV","delhi-to-kolkata":"दिल्ली ते कोलकाता LCV","delhi-to-mumbai":"दिल्ली ते मुंबई LCV","jaipur-to-delhi":"जयपूर ते दिल्ली LCV","kolkata-to-delhi":"कोलकाता ते दिल्ली LCV","mumbai-to-ahmedabad":"मुंबई ते अहमदाबाद LCV","mumbai-to-delhi":"मुंबई ते दिल्ली LCV","mumbai-to-pune":"मुंबई ते पुणे LCV","pune-to-mumbai":"पुणे ते मुंबई LCV"}},"_j":{"mumbai-to-pune":{"seo":{"title":"मुंबई ते पुणे LCV बुक करा | Vahak","description":"काही मिनिटांत मुंबई ते पुणे प्रमाणित LCV बुक करा. लाइव्ह ट्रॅकिंग, कार्गो विमा, कोणतेही लपलेले शुल्क नाही. या मार्गावर 500+ प्रमाणित वाहतूकदार."},"pickupCity":"मुंबई","dropCity":"पुणे","heroHeadline2Lines":["मुंबई","ते पुणे"],"heroSub":"प्रमाणित वाहतूकदार. लाइव्ह ट्रॅकिंग.","breadcrumbRouteName":"मुंबई ते पुणे","aboutText":"मुंबई ते पुणे हा मुंबई-पुणे एक्सप्रेसवे (NH48) वरील 150 किमीचा मार्ग आहे, जो रस्त्याने साधारणपणे 3-4 तासांत पार केला जातो. महाराष्ट्रातील सर्वात व्यस्त मालवाहतूक मार्गांपैकी हा एक आहे, जो मुंबईचे व्यावसायिक आणि FMCG केंद्र पुण्याच्या ऑटोमोटिव्ह, ऑटो-अँसिलरी आणि IT उत्पादन केंद्राशी जोडतो — याचा वापर सामान्यतः ऑटो पार्ट्स, FMCG, फार्मा आणि इलेक्ट्रॉनिक्स शिपमेंटसाठी केला जातो.","footerSeoText":"Vahak हे संपूर्ण भारतातील शिपर्सना प्रमाणित वाहतूकदारांशी जोडणारे ऑनलाइन LCV बुकिंग मार्केटप्लेस आहे. मुंबई-पुणे मार्गावर, व्यवसाय पार्ट-लोड आणि फुल-लोड LCV वाहतुकीसाठी Tata Ace, Tempo, Tata 407 आणि पिकअप वाहने बुक करण्यासाठी Vahak वापरतात, प्रत्येक बुकिंगवर लाइव्ह ट्रॅकिंग आणि कार्गो विम्यासह.","faqs":[{"question":"मुंबई ते पुणे त्याच दिवशी LCV उपलब्ध आहे का?","answer":"होय, साधारणपणे त्याच दिवशी पिकअप उपलब्ध आहे. या मार्गावर बहुतांश बुकिंगसाठी 10 मिनिटांत वाहतूकदार निश्चित होतो.","defaultOpen":true},{"question":"मुंबई ते पुणे LCV चा खर्च किती आहे?","answer":"किंमती लोडचे वजन, LCV चा आकार आणि हंगामानुसार बदलतात, कोणतेही लपलेले शुल्क नाही. तुमच्या लोडसाठी विशिष्ट अंदाजासाठी वरील किंमत अंदाज साधन वापरा."},{"question":"वाहतुकीदरम्यान माझ्या मालाचा विमा आहे का?","answer":"होय, वाहतुकीदरम्यान तुमच्या मालाचे संरक्षण करण्यासाठी या मार्गावर कार्गो विमा उपलब्ध आहे."},{"question":"मुंबई ते पुणे 1 टन लोडसाठी कोणत्या आकाराचा LCV हवा?","answer":"1 टन लोड साधारणपणे Tata Ace किंवा Tata 407 सारख्या मानक LCV मध्ये बसतो. बुकिंग करताना तुमच्या लोडचे तपशील प्रविष्ट करा आणि Vahak योग्य आकार सुचवेल."},{"question":"मी उद्यासाठी पिकअप शेड्यूल करू शकतो का?","answer":"होय, तुम्ही फक्त त्याच दिवशीच नाही तर कोणत्याही भविष्यातील तारखेसाठी पिकअप शेड्यूल करू शकता. लोड पोस्ट करताना तुमची पसंतीची पिकअप वेळ सेट करा."},{"question":"LCV साठी कमाल पेलोड किती आहे?","answer":"या मार्गावर बहुतांश LCV 3.5 टनांपर्यंत वाहून नेऊ शकतात. तुमच्या लोडच्या वजनावर आधारित Vahak योग्य वाहन आकाराशी जुळवेल."}],"popularRoutes":[{"label":"मुंबई ते अहमदाबाद"},{"label":"पुणे ते नाशिक"},{"label":"मुंबई ते नाशिक"}],"vehicleTypes":[{"label":"टाटा एस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"pune-to-mumbai":{"seo":{"title":"पुणे ते मुंबई LCV बुक करा | Vahak","description":"काही मिनिटांत पुणे ते मुंबई प्रमाणित LCV बुक करा. लाइव्ह ट्रॅकिंग, कार्गो विमा, कोणतेही लपलेले शुल्क नाही. या मार्गावर 500+ प्रमाणित वाहतूकदार."},"pickupCity":"पुणे","dropCity":"मुंबई","heroHeadline2Lines":["पुणे","ते मुंबई"],"heroSub":"प्रमाणित वाहतूकदार. लाइव्ह ट्रॅकिंग.","breadcrumbRouteName":"पुणे ते मुंबई","aboutText":"पुणे ते मुंबई हा मुंबई-पुणे एक्सप्रेसवे (NH48) वरील 150 किमीचा मार्ग आहे, जो रस्त्याने साधारणपणे 3-4 तासांत पार केला जातो. महाराष्ट्रातील सर्वात व्यस्त मालवाहतूक मार्गांपैकी हा एक आहे, जो पुण्याचे ऑटोमोटिव्ह, ऑटो-अँसिलरी आणि IT उत्पादन केंद्र मुंबईच्या व्यावसायिक आणि FMCG केंद्राशी जोडतो — याचा वापर सामान्यतः ऑटो पार्ट्स, FMCG, फार्मा आणि इलेक्ट्रॉनिक्स शिपमेंटसाठी केला जातो.","footerSeoText":"Vahak हे संपूर्ण भारतातील शिपर्सना प्रमाणित वाहतूकदारांशी जोडणारे ऑनलाइन LCV बुकिंग मार्केटप्लेस आहे. पुणे-मुंबई मार्गावर, व्यवसाय पार्ट-लोड आणि फुल-लोड LCV वाहतुकीसाठी Tata Ace, Tempo, Tata 407 आणि पिकअप वाहने बुक करण्यासाठी Vahak वापरतात, प्रत्येक बुकिंगवर लाइव्ह ट्रॅकिंग आणि कार्गो विम्यासह.","faqs":[{"question":"पुणे ते मुंबई त्याच दिवशी LCV उपलब्ध आहे का?","answer":"होय, साधारणपणे त्याच दिवशी पिकअप उपलब्ध आहे. या मार्गावर बहुतांश बुकिंगसाठी 10 मिनिटांत वाहतूकदार निश्चित होतो.","defaultOpen":true},{"question":"पुणे ते मुंबई LCV चा खर्च किती आहे?","answer":"किंमती लोडचे वजन, LCV चा आकार आणि हंगामानुसार बदलतात, कोणतेही लपलेले शुल्क नाही. तुमच्या लोडसाठी विशिष्ट अंदाजासाठी वरील किंमत अंदाज साधन वापरा."},{"question":"वाहतुकीदरम्यान माझ्या मालाचा विमा आहे का?","answer":"होय, वाहतुकीदरम्यान तुमच्या मालाचे संरक्षण करण्यासाठी या मार्गावर कार्गो विमा उपलब्ध आहे."},{"question":"पुणे ते मुंबई 1 टन लोडसाठी कोणत्या आकाराचा LCV हवा?","answer":"1 टन लोड साधारणपणे Tata Ace किंवा Tata 407 सारख्या मानक LCV मध्ये बसतो. बुकिंग करताना तुमच्या लोडचे तपशील प्रविष्ट करा आणि Vahak योग्य आकार सुचवेल."},{"question":"मी उद्यासाठी पिकअप शेड्यूल करू शकतो का?","answer":"होय, तुम्ही फक्त त्याच दिवशीच नाही तर कोणत्याही भविष्यातील तारखेसाठी पिकअप शेड्यूल करू शकता. लोड पोस्ट करताना तुमची पसंतीची पिकअप वेळ सेट करा."},{"question":"LCV साठी कमाल पेलोड किती आहे?","answer":"या मार्गावर बहुतांश LCV 3.5 टनांपर्यंत वाहून नेऊ शकतात. तुमच्या लोडच्या वजनावर आधारित Vahak योग्य वाहन आकाराशी जुळवेल."}],"popularRoutes":[{"label":"पुणे ते नाशिक"},{"label":"मुंबई ते अहमदाबाद"},{"label":"मुंबई ते नाशिक"}],"vehicleTypes":[{"label":"टाटा एस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"mumbai-to-delhi":{"seo":{"title":"मुंबई ते दिल्ली LCV बुक करा | Vahak","description":"काही मिनिटांत मुंबई ते दिल्ली प्रमाणित LCV बुक करा. लाइव्ह ट्रॅकिंग, कार्गो विमा, कोणतेही लपलेले शुल्क नाही. या मार्गावर 500+ प्रमाणित वाहतूकदार."},"pickupCity":"मुंबई","dropCity":"दिल्ली","heroHeadline2Lines":["मुंबई","ते दिल्ली"],"heroSub":"प्रमाणित वाहतूकदार. लाइव्ह ट्रॅकिंग.","breadcrumbRouteName":"मुंबई ते दिल्ली","aboutText":"मुंबई ते दिल्ली हा NH48 मार्गावरील 1,400 किमीचा मार्ग आहे, जो LCV शिपमेंटसाठी रस्त्याने साधारणपणे 24-28 तासांत पार केला जातो. हा भारतातील सर्वात व्यस्त लांब पल्ल्याच्या मालवाहतूक मार्गांपैकी एक आहे, जो मुंबईचे व्यावसायिक आणि आर्थिक केंद्र दिल्ली NCR च्या औद्योगिक आणि व्यापारी केंद्राशी जोडतो — याचा वापर सामान्यतः FMCG, कापड, इलेक्ट्रॉनिक्स आणि यंत्रसामग्री शिपमेंटसाठी केला जातो.","footerSeoText":"Vahak हे संपूर्ण भारतातील शिपर्सना प्रमाणित वाहतूकदारांशी जोडणारे ऑनलाइन LCV बुकिंग मार्केटप्लेस आहे. मुंबई-दिल्ली मार्गावर, व्यवसाय पार्ट-लोड आणि फुल-लोड LCV वाहतुकीसाठी Tata Ace, Tempo, Tata 407 आणि पिकअप वाहने बुक करण्यासाठी Vahak वापरतात, प्रत्येक बुकिंगवर लाइव्ह ट्रॅकिंग आणि कार्गो विम्यासह.","faqs":[{"question":"मुंबई ते दिल्ली त्याच दिवशी LCV उपलब्ध आहे का?","answer":"होय, साधारणपणे त्याच दिवशी पिकअप उपलब्ध आहे. या मार्गावर बहुतांश बुकिंगसाठी 10 मिनिटांत वाहतूकदार निश्चित होतो.","defaultOpen":true},{"question":"मुंबई ते दिल्ली LCV चा खर्च किती आहे?","answer":"किंमती लोडचे वजन, LCV चा आकार आणि हंगामानुसार बदलतात, कोणतेही लपलेले शुल्क नाही. तुमच्या लोडसाठी विशिष्ट अंदाजासाठी वरील किंमत अंदाज साधन वापरा."},{"question":"वाहतुकीदरम्यान माझ्या मालाचा विमा आहे का?","answer":"होय, वाहतुकीदरम्यान तुमच्या मालाचे संरक्षण करण्यासाठी या मार्गावर कार्गो विमा उपलब्ध आहे."},{"question":"मुंबई ते दिल्ली 1 टन लोडसाठी कोणत्या आकाराचा LCV हवा?","answer":"1 टन लोड साधारणपणे Tata Ace किंवा Tata 407 सारख्या मानक LCV मध्ये बसतो. बुकिंग करताना तुमच्या लोडचे तपशील प्रविष्ट करा आणि Vahak योग्य आकार सुचवेल."},{"question":"मी उद्यासाठी पिकअप शेड्यूल करू शकतो का?","answer":"होय, तुम्ही फक्त त्याच दिवशीच नाही तर कोणत्याही भविष्यातील तारखेसाठी पिकअप शेड्यूल करू शकता. लोड पोस्ट करताना तुमची पसंतीची पिकअप वेळ सेट करा."},{"question":"LCV साठी कमाल पेलोड किती आहे?","answer":"या मार्गावर बहुतांश LCV 3.5 टनांपर्यंत वाहून नेऊ शकतात. तुमच्या लोडच्या वजनावर आधारित Vahak योग्य वाहन आकाराशी जुळवेल."}],"popularRoutes":[{"label":"मुंबई ते अहमदाबाद"},{"label":"दिल्ली ते जयपूर"},{"label":"मुंबई ते पुणे"}],"vehicleTypes":[{"label":"टाटा एस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]},"mumbai-to-ahmedabad":{"seo":{"title":"मुंबई ते अहमदाबाद LCV बुक करा | Vahak","description":"काही मिनिटांत मुंबई ते अहमदाबाद प्रमाणित LCV बुक करा. लाइव्ह ट्रॅकिंग, कार्गो विमा, कोणतेही लपलेले शुल्क नाही. या मार्गावर 500+ प्रमाणित वाहतूकदार."},"pickupCity":"मुंबई","dropCity":"अहमदाबाद","heroHeadline2Lines":["मुंबई","ते अहमदाबाद"],"heroSub":"प्रमाणित वाहतूकदार. लाइव्ह ट्रॅकिंग.","breadcrumbRouteName":"मुंबई ते अहमदाबाद","aboutText":"मुंबई ते अहमदाबाद हा NH48 मार्गावरील 530 किमीचा मार्ग आहे, जो रस्त्याने साधारणपणे 9-10 तासांत पार केला जातो. हा मुंबईचे व्यावसायिक, बंदर आणि FMCG केंद्र गुजरातच्या कापड, रसायन आणि फार्मा उत्पादन केंद्राशी जोडतो — याचा वापर सामान्यतः कापड, रसायने, फार्मा आणि FMCG शिपमेंटसाठी केला जातो.","footerSeoText":"Vahak हे संपूर्ण भारतातील शिपर्सना प्रमाणित वाहतूकदारांशी जोडणारे ऑनलाइन LCV बुकिंग मार्केटप्लेस आहे. मुंबई-अहमदाबाद मार्गावर, व्यवसाय पार्ट-लोड आणि फुल-लोड LCV वाहतुकीसाठी Tata Ace, Tempo, Tata 407 आणि पिकअप वाहने बुक करण्यासाठी Vahak वापरतात, प्रत्येक बुकिंगवर लाइव्ह ट्रॅकिंग आणि कार्गो विम्यासह.","faqs":[{"question":"मुंबई ते अहमदाबाद त्याच दिवशी LCV उपलब्ध आहे का?","answer":"होय, साधारणपणे त्याच दिवशी पिकअप उपलब्ध आहे. या मार्गावर बहुतांश बुकिंगसाठी 10 मिनिटांत वाहतूकदार निश्चित होतो.","defaultOpen":true},{"question":"मुंबई ते अहमदाबाद LCV चा खर्च किती आहे?","answer":"किंमती लोडचे वजन, LCV चा आकार आणि हंगामानुसार बदलतात, कोणतेही लपलेले शुल्क नाही. तुमच्या लोडसाठी विशिष्ट अंदाजासाठी वरील किंमत अंदाज साधन वापरा."},{"question":"वाहतुकीदरम्यान माझ्या मालाचा विमा आहे का?","answer":"होय, वाहतुकीदरम्यान तुमच्या मालाचे संरक्षण करण्यासाठी या मार्गावर कार्गो विमा उपलब्ध आहे."},{"question":"मुंबई ते अहमदाबाद 1 टन लोडसाठी कोणत्या आकाराचा LCV हवा?","answer":"1 टन लोड साधारणपणे Tata Ace किंवा Tata 407 सारख्या मानक LCV मध्ये बसतो. बुकिंग करताना तुमच्या लोडचे तपशील प्रविष्ट करा आणि Vahak योग्य आकार सुचवेल."},{"question":"मी उद्यासाठी पिकअप शेड्यूल करू शकतो का?","answer":"होय, तुम्ही फक्त त्याच दिवशीच नाही तर कोणत्याही भविष्यातील तारखेसाठी पिकअप शेड्यूल करू शकता. लोड पोस्ट करताना तुमची पसंतीची पिकअप वेळ सेट करा."},{"question":"LCV साठी कमाल पेलोड किती आहे?","answer":"या मार्गावर बहुतांश LCV 3.5 टनांपर्यंत वाहून नेऊ शकतात. तुमच्या लोडच्या वजनावर आधारित Vahak योग्य वाहन आकाराशी जुळवेल."}],"popularRoutes":[{"label":"मुंबई ते पुणे"},{"label":"अहमदाबाद ते सुरत"},{"label":"मुंबई ते दिल्ली"}],"vehicleTypes":[{"label":"टाटा एस"},{"label":"टेम्पो"},{"label":"टाटा 407"},{"label":"पिकअप"}]}},"cA":{"mumbai":{"seo":{"title":"मुंबईत LCV बुक करा | Vahak","description":"काही मिनिटांत मुंबईत प्रमाणित LCV बुक करा. लाइव्ह ट्रॅकिंग, कार्गो विमा, कोणतेही लपलेले शुल्क नाही. मुंबईत 12,000+ प्रमाणित वाहतूकदार."},"pickupCity":"मुंबई","dropPlaceholder":"ड्रॉप लोकेशन प्रविष्ट करा","heroHeadline2Lines":["मुंबई"],"heroSub":"प्रमाणित वाहतूकदार. लाइव्ह ट्रॅकिंग.","breadcrumbCityName":"मुंबई","trustStrip":"मुंबईत 12,000+ प्रमाणित वाहतूकदार","aboutTitle":"मुंबई वाहतुकीबद्दल","aboutText":"मुंबई, भारताची आर्थिक राजधानी, वित्त, IT, मनोरंजन, दागिने आणि ऑटोमोबाइल क्षेत्रांमध्ये मालवाहतुकीची मागणी वाढवते. दररोज मोठ्या प्रमाणात ई-कॉमर्स आणि कापड शिपमेंट्स शहरातून NH48 आणि NH66 सारख्या प्रमुख फ्रेट कॉरिडॉरशी जोडत बाहेर जातात.","tags":["वित्तीय सेवा","IT आणि सेवा","मनोरंजन","दागिने","ऑटोमोबाइल"],"proofStats":[{"value":"12,000+","label":"मुंबईत प्रमाणित वाहतूकदार"},{"value":"10 मिनिटे","label":"LCV बुक करण्याची वेळ"}],"localResources":{"title":"स्थानिक माहिती","dhabas":[{"name":"प्रभू का ढाबा","location":"NH-3, इगतपुरी"},{"name":"सिद्धू पंजाबी ढाबा","location":"जुना मुंबई-पुणे महामार्ग"}],"contacts":[{"label":"पोलीस","number":"100"},{"label":"रुग्णवाहिका","number":"108"},{"label":"मुंबई वाहतूक पोलीस","number":"103"},{"label":"महाराष्ट्र RTO","number":"1800-233-4780"},{"label":"राष्ट्रीय महामार्ग हेल्पलाइन","number":"1033"}],"moreToggle":"पेट्रोल पंप, सर्व्हिस स्टेशन, रुग्णालये पहा","note":"दाखवलेले आपत्कालीन क्रमांक मानक राज्य/राष्ट्रीय हेल्पलाइन आहेत — प्रकाशित करण्यापूर्वी अधिकृत स्त्रोताकडून पडताळणी करा."},"faqs":[{"question":"मुंबईत ट्रक प्रवेशाच्या वेळेवर निर्बंध आहेत का?","answer":"शहराच्या हद्दीत काही मार्गांवर जड वाहनांसाठी वेळेचे निर्बंध आहेत. Vahak वाहतूकदार या नियमांनुसार पिकअप आणि ड्रॉपची वेळ आपोआप ठरवतात.","defaultOpen":true},{"question":"मुंबईत LCV किंमत कशी ठरवली जाते?","answer":"किंमत अंतर, लोडचे वजन, वाहनाचा प्रकार आणि तुमच्या मार्गावरील सध्याच्या मागणीवर अवलंबून असते. तुम्ही तुमचा लोड मोफत पोस्ट करू शकता आणि प्रमाणित वाहतूकदारांच्या बोलींची तुलना करू शकता."},{"question":"मला माझ्या बुकिंगसाठी GST इनव्हॉइस मिळेल का?","answer":"होय, Vahak द्वारे केलेल्या प्रत्येक बुकिंगसाठी GST इनव्हॉइस दिले जाते, जे तुमचा लोड कन्फर्म झाल्यावर आपोआप तयार होते."},{"question":"माझा लोड वेळेवर उचलला नाही तर काय होते?","answer":"Vahak ची सपोर्ट टीम प्रत्येक सक्रिय बुकिंगवर लक्ष ठेवते आणि पिकअपला उशीर झाल्यास तुमचा लोड दुसऱ्या प्रमाणित वाहतूकदाराला पुन्हा नियुक्त करते."}],"popularRoutesLabel":"मुंबईतून लोकप्रिय मार्ग","popularRoutes":[{"label":"मुंबई ते पुणे","href":"/lcv-booking/mumbai-to-pune"},{"label":"मुंबई ते दिल्ली","href":"/lcv-booking/mumbai-to-delhi"},{"label":"मुंबई ते अहमदाबाद","href":"/lcv-booking/mumbai-to-ahmedabad"}],"vehicleTypesLabel":"वाहनाच्या प्रकारानुसार बुक करा","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak हे एक ऑनलाइन LCV बुकिंग मार्केटप्लेस आहे जे शिपर्सना संपूर्ण भारतातील प्रमाणित वाहतूकदारांशी जोडते. मुंबईत, व्यवसाय Vahak वापरून पार्ट-लोड आणि फुल-लोड LCV शिपमेंटसाठी Tata Ace, Tempo, Tata 407 आणि Pickup वाहने बुक करतात, प्रत्येक बुकिंगवर लाइव्ह ट्रॅकिंग आणि कार्गो विम्यासह.","footerGroups":[{"label":"मुंबईतून लोकप्रिय मार्ग","links":[{"label":"मुंबई ते पुणे LCV","href":"/lcv-booking/mumbai-to-pune"},{"label":"मुंबई ते दिल्ली LCV","href":"/lcv-booking/mumbai-to-delhi"},{"label":"मुंबई ते अहमदाबाद LCV","href":"/lcv-booking/mumbai-to-ahmedabad"}],"moreLink":{"label":"सर्व मार्ग पहा →","href":"/lcv-booking"}},{"label":"इतर शहरांमध्ये LCV बुक करा","links":[{"label":"दिल्ली","href":"/city/delhi"},{"label":"बंगळुरू","href":"/city/bangalore"},{"label":"पुणे","href":"/city/pune"},{"label":"हैदराबाद","href":"/city/hyderabad"}],"moreLink":{"label":"सर्व शहरे पहा →","href":"/"}},{"label":"वाहन प्रकार","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"कंपनी","links":[{"label":"आमच्याबद्दल","href":"/about-us"},{"label":"करिअर","href":"/careers"},{"label":"संपर्क करा","href":"/contact-us"}]},{"label":"कायदेशीर","links":[{"label":"अटी व शर्ती","href":"/terms-and-conditions"},{"label":"गोपनीयता धोरण","href":"/privacy-policy"},{"label":"वारंवार विचारले जाणारे प्रश्न","href":"/frequently-asked-questions"}]}]},"pune":{"seo":{"title":"पुण्यात LCV बुक करा | Vahak","description":"काही मिनिटांत पुण्यात प्रमाणित LCV बुक करा. लाइव्ह ट्रॅकिंग, कार्गो विमा, कोणतेही लपलेले शुल्क नाही."},"pickupCity":"पुणे","dropPlaceholder":"ड्रॉप लोकेशन प्रविष्ट करा","heroHeadline2Lines":["पुणे"],"heroSub":"प्रमाणित वाहतूकदार. लाइव्ह ट्रॅकिंग.","breadcrumbCityName":"पुणे","trustStrip":"पुण्यात 7,000+ प्रमाणित वाहतूकदार","aboutTitle":"पुणे वाहतुकीबद्दल","aboutText":"पुणे, भारताचे वाहन आणि IT उत्पादन केंद्र, वाहन उद्योग, IT सेवा आणि अभियांत्रिकी क्षेत्रांमध्ये मालवाहतुकीची मागणी वाढवते. हिंजवडी आणि चाकण सारख्या केंद्रांमधून दररोज मोठ्या प्रमाणात वाहन सुटे भाग आणि औद्योगिक वस्तूंची वाहतूक NH48 आणि NH60 सारख्या फ्रेट कॉरिडॉरशी जोडलेली असते.","tags":["वाहन उत्पादन","IT सेवा","अभियांत्रिकी वस्तू"],"proofStats":[{"value":"7,000+","label":"पुण्यात प्रमाणित वाहतूकदार"},{"value":"10 मिनिटे","label":"LCV बुक करण्याची वेळ"}],"localResources":{"title":"स्थानिक माहिती","dhabas":[{"name":"NH37 ढाबा","location":"पुणे विद्यापीठाजवळ, महाराष्ट्र"}],"contacts":[{"label":"पोलीस","number":"100"},{"label":"रुग्णवाहिका","number":"108"},{"label":"पुणे पोलीस नियंत्रण कक्ष","number":"020-2612 6296"},{"label":"राष्ट्रीय महामार्ग हेल्पलाइन","number":"1033"}],"moreToggle":"पेट्रोल पंप, सर्व्हिस स्टेशन, रुग्णालये पहा","note":"दाखवलेले आपत्कालीन क्रमांक मानक राज्य/राष्ट्रीय हेल्पलाइन आहेत — प्रकाशित करण्यापूर्वी अधिकृत स्त्रोताकडून पडताळणी करा."},"faqs":[{"question":"पुणे शहराच्या हद्दीत ट्रक प्रवेशावर निर्बंध आहेत का?","answer":"शहराच्या हद्दीत काही रस्त्यांवर गर्दीच्या वेळेत जड वाहनांच्या हालचालीवर निर्बंध असतात. Vahak वाहतूकदार या नियमांनुसार पिकअप आणि ड्रॉपची वेळ आपोआप ठरवतात.","defaultOpen":true},{"question":"पुण्यात LCV किंमत कशी ठरवली जाते?","answer":"किंमत अंतर, लोडचे वजन, वाहनाचा प्रकार आणि तुमच्या मार्गावरील सध्याच्या मागणीवर अवलंबून असते. तुम्ही तुमचा लोड मोफत पोस्ट करू शकता आणि प्रमाणित वाहतूकदारांच्या बोलींची तुलना करू शकता."},{"question":"मला माझ्या बुकिंगसाठी GST इनव्हॉइस मिळेल का?","answer":"होय, Vahak द्वारे केलेल्या प्रत्येक बुकिंगसाठी GST इनव्हॉइस दिले जाते, जे तुमचा लोड कन्फर्म झाल्यावर आपोआप तयार होते."},{"question":"माझा लोड वेळेवर उचलला नाही तर काय होते?","answer":"Vahak ची सपोर्ट टीम प्रत्येक सक्रिय बुकिंगवर लक्ष ठेवते आणि पिकअपला उशीर झाल्यास तुमचा लोड दुसऱ्या प्रमाणित वाहतूकदाराला पुन्हा नियुक्त करते."}],"popularRoutesLabel":"पुण्याहून लोकप्रिय मार्ग","popularRoutes":[{"label":"पुणे ते मुंबई","href":"/lcv-booking/pune-to-mumbai"}],"vehicleTypesLabel":"वाहनाच्या प्रकारानुसार बुक करा","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak हे एक ऑनलाइन LCV बुकिंग मार्केटप्लेस आहे जे शिपर्सना संपूर्ण भारतातील प्रमाणित वाहतूकदारांशी जोडते. पुण्यात, व्यवसाय Vahak वापरून पार्ट-लोड आणि फुल-लोड LCV शिपमेंटसाठी Tata Ace, Tempo, Tata 407 आणि Pickup वाहने बुक करतात, प्रत्येक बुकिंगवर लाइव्ह ट्रॅकिंग आणि कार्गो विम्यासह.","footerGroups":[{"label":"पुण्याहून लोकप्रिय मार्ग","links":[{"label":"पुणे ते मुंबई LCV","href":"/lcv-booking/pune-to-mumbai"}],"moreLink":{"label":"सर्व मार्ग पहा →","href":"/lcv-booking"}},{"label":"इतर शहरांमध्ये LCV बुक करा","links":[{"label":"मुंबई","href":"/city/mumbai"},{"label":"दिल्ली","href":"/city/delhi"},{"label":"बंगळुरू","href":"/city/bangalore"},{"label":"जयपूर","href":"/city/jaipur"}],"moreLink":{"label":"सर्व शहरे पहा →","href":"/"}},{"label":"वाहन प्रकार","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"कंपनी","links":[{"label":"आमच्याबद्दल","href":"/about-us"},{"label":"करिअर","href":"/careers"},{"label":"संपर्क करा","href":"/contact-us"}]},{"label":"कायदेशीर","links":[{"label":"अटी व शर्ती","href":"/terms-and-conditions"},{"label":"गोपनीयता धोरण","href":"/privacy-policy"},{"label":"वारंवार विचारले जाणारे प्रश्न","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 27285:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"அகமதாபாத் முதல் மும்பை LCV","bangalore-to-chennai":"பெங்களூர் முதல் சென்னை LCV","bangalore-to-hyderabad":"பெங்களூர் முதல் ஹைதராபாத் LCV","chennai-to-bangalore":"சென்னையிலிருந்து பெங்களூரு LCV","chennai-to-hyderabad":"சென்னை முதல் ஹைதராபாத் LCV","hyderabad-to-bangalore":"ஹைதராபாத் முதல் பெங்களூர் LCV","hyderabad-to-chennai":"ஹைதராபாத் முதல் சென்னை LCV","delhi-to-jaipur":"டெல்லி முதல் ஜெய்ப்பூர் LCV","delhi-to-kolkata":"டெல்லி முதல் கொல்கத்தா LCV","delhi-to-mumbai":"டெல்லி முதல் மும்பை LCV","jaipur-to-delhi":"ஜெய்ப்பூர் முதல் டெல்லி LCV","kolkata-to-delhi":"கொல்கத்தா முதல் டெல்லி LCV","mumbai-to-ahmedabad":"மும்பை முதல் அகமதாபாத் LCV","mumbai-to-delhi":"மும்பை முதல் டெல்லி LCV","mumbai-to-pune":"மும்பை முதல் புனே LCV","pune-to-mumbai":"புனே முதல் மும்பை LCV"}},"_j":{"chennai-to-hyderabad":{"seo":{"title":"சென்னையிலிருந்து ஹைதராபாத்திற்கு LCV முன்பதிவு செய்யுங்கள் | Vahak","description":"நிமிடங்களில் சென்னையிலிருந்து ஹைதராபாத்திற்கு சரிபார்க்கப்பட்ட LCV முன்பதிவு செய்யுங்கள். நேரடி கண்காணிப்பு, சரக்கு காப்பீடு, மறைமுக கட்டணங்கள் இல்லை. இந்த வழியில் 500+ சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள்."},"pickupCity":"சென்னை","dropCity":"ஹைதராபாத்","heroHeadline2Lines":["சென்னையிலிருந்து","ஹைதராபாத்திற்கு"],"heroSub":"சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள். நேரடி கண்காணிப்பு.","breadcrumbRouteName":"சென்னையிலிருந்து ஹைதராபாத்","aboutText":"சென்னையிலிருந்து ஹைதராபாத் NH16 வழியாக 625 கி.மீ தூரம் கொண்ட பாதையாகும், இது சாலை வழியாக பொதுவாக 10-11 மணி நேரத்தில் கடக்கப்படுகிறது. இது சென்னையின் வாகனத் தொழில் மற்றும் தோல் உற்பத்தி மையத்தை ஹைதராபாத்தின் மருந்து, IT மற்றும் தொழில்துறை மையங்களுடன் இணைக்கிறது — இது பொதுவாக வாகன பாகங்கள், தோல் பொருட்கள், மருந்துகள், மின்னணு பொருட்கள் மற்றும் ஜவுளி அனுப்புதலுக்காக பயன்படுத்தப்படுகிறது.","footerSeoText":"Vahak என்பது இந்தியா முழுவதும் உள்ள ஷிப்பர்களை சரிபார்க்கப்பட்ட போக்குவரத்தாளர்களுடன் இணைக்கும் ஆன்லைன் LCV முன்பதிவு சந்தையாகும். சென்னை-ஹைதராபாத் வழியில், வணிகங்கள் பகுதி-சுமை மற்றும் முழு-சுமை LCV அனுப்புதலுக்காக Tata Ace, Tempo, Tata 407 மற்றும் பிக்அப் வாகனங்களை முன்பதிவு செய்ய Vahak-ஐ பயன்படுத்துகின்றன, ஒவ்வொரு முன்பதிவிலும் நேரடி கண்காணிப்பு மற்றும் சரக்கு காப்பீட்டுடன்.","faqs":[{"question":"சென்னையிலிருந்து ஹைதராபாத்திற்கு அதே நாளில் LCV கிடைக்குமா?","answer":"ஆம், பொதுவாக அதே நாளில் பிக்அப் கிடைக்கும். இந்த வழியில் பெரும்பாலான முன்பதிவுகளுக்கு 10 நிமிடங்களுக்குள் போக்குவரத்தாளர் உறுதிப்படுத்தப்படுவார்.","defaultOpen":true},{"question":"சென்னையிலிருந்து ஹைதராபாத்திற்கு LCV செலவு எவ்வளவு?","answer":"விலைகள் சுமை எடை, LCV அளவு மற்றும் பருவத்தைப் பொறுத்து மாறுபடும், மறைமுக கட்டணங்கள் இல்லை. உங்கள் சுமைக்கான குறிப்பிட்ட மதிப்பீட்டிற்கு மேலே உள்ள விலை மதிப்பீட்டு கருவியைப் பயன்படுத்தவும்."},{"question":"போக்குவரத்தின் போது எனது சரக்கு காப்பீடு செய்யப்பட்டுள்ளதா?","answer":"ஆம், போக்குவரத்தின் போது உங்கள் சரக்குகளைப் பாதுகாக்க இந்த வழியில் சரக்கு காப்பீடு கிடைக்கிறது."},{"question":"சென்னையிலிருந்து ஹைதராபாத்திற்கு 1 டன் சுமைக்கு என்ன அளவு LCV தேவை?","answer":"1 டன் சுமை பொதுவாக Tata Ace அல்லது Tata 407 போன்ற நிலையான LCV-க்குப் பொருந்தும். முன்பதிவு செய்யும் போது உங்கள் சுமை விவரங்களை உள்ளிடவும், Vahak சரியான அளவை பரிந்துரைக்கும்."},{"question":"நாளைக்கு பிக்அப்பை திட்டமிட முடியுமா?","answer":"ஆம், அதே நாளில் மட்டுமல்ல, எதிர்கால தேதியிலும் பிக்அப்பை திட்டமிடலாம். சுமையை பதிவிடும்போது உங்களுக்கு விருப்பமான பிக்அப் நேரத்தை அமைக்கவும்."},{"question":"LCV-க்கான அதிகபட்ச சுமை எவ்வளவு?","answer":"இந்த வழியில் பெரும்பாலான LCV கள் 3.5 டன் வரை சுமக்க முடியும். உங்கள் சுமை எடையின் அடிப்படையில் Vahak சரியான வாகன அளவுடன் பொருத்தும்."}],"popularRoutes":[{"label":"சென்னையிலிருந்து பெங்களூரு"},{"label":"பெங்களூருவிலிருந்து ஹைதராபாத்"},{"label":"ஹைதராபாத்திலிருந்து புனே"}],"vehicleTypes":[{"label":"டாடா ஏஸ்"},{"label":"டெம்போ"},{"label":"டாடா 407"},{"label":"பிக்அப்"}]},"chennai-to-bangalore":{"seo":{"title":"சென்னையிலிருந்து பெங்களூருவிற்கு LCV முன்பதிவு செய்யுங்கள் | Vahak","description":"நிமிடங்களில் சென்னையிலிருந்து பெங்களூருவிற்கு சரிபார்க்கப்பட்ட LCV முன்பதிவு செய்யுங்கள். நேரடி கண்காணிப்பு, சரக்கு காப்பீடு, மறைமுக கட்டணங்கள் இல்லை. இந்த வழியில் 500+ சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள்."},"pickupCity":"சென்னை","dropCity":"பெங்களூரு","heroHeadline2Lines":["சென்னையிலிருந்து","பெங்களூருவிற்கு"],"heroSub":"சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள். நேரடி கண்காணிப்பு.","breadcrumbRouteName":"சென்னையிலிருந்து பெங்களூரு","aboutText":"சென்னையிலிருந்து பெங்களூரு NH48 வழியாக 350 கி.மீ தூரம் கொண்ட பாதையாகும், இது சாலை வழியாக பொதுவாக 6-7 மணி நேரத்தில் கடக்கப்படுகிறது. இது சென்னையின் வாகனத் தொழில் மற்றும் துணைத் தொழில் மையத்தை கர்நாடகாவின் மின்னணு மற்றும் தொழில்நுட்ப உற்பத்தி மையத்துடன் இணைக்கிறது — இது பொதுவாக வாகன பாகங்கள், மின்னணு பொருட்கள், IT வன்பொருள், தோல் பொருட்கள் மற்றும் ஜவுளி அனுப்புதலுக்காக பயன்படுத்தப்படுகிறது.","footerSeoText":"Vahak என்பது இந்தியா முழுவதும் உள்ள ஷிப்பர்களை சரிபார்க்கப்பட்ட போக்குவரத்தாளர்களுடன் இணைக்கும் ஆன்லைன் LCV முன்பதிவு சந்தையாகும். சென்னை-பெங்களூரு வழியில், வணிகங்கள் பகுதி-சுமை மற்றும் முழு-சுமை LCV அனுப்புதலுக்காக Tata Ace, Tempo, Tata 407 மற்றும் பிக்அப் வாகனங்களை முன்பதிவு செய்ய Vahak-ஐ பயன்படுத்துகின்றன, ஒவ்வொரு முன்பதிவிலும் நேரடி கண்காணிப்பு மற்றும் சரக்கு காப்பீட்டுடன்.","faqs":[{"question":"சென்னையிலிருந்து பெங்களூருவிற்கு அதே நாளில் LCV கிடைக்குமா?","answer":"ஆம், பொதுவாக அதே நாளில் பிக்அப் கிடைக்கும். இந்த வழியில் பெரும்பாலான முன்பதிவுகளுக்கு 10 நிமிடங்களுக்குள் போக்குவரத்தாளர் உறுதிப்படுத்தப்படுவார்.","defaultOpen":true},{"question":"சென்னையிலிருந்து பெங்களூருவிற்கு LCV செலவு எவ்வளவு?","answer":"விலைகள் சுமை எடை, LCV அளவு மற்றும் பருவத்தைப் பொறுத்து மாறுபடும், மறைமுக கட்டணங்கள் இல்லை. உங்கள் சுமைக்கான குறிப்பிட்ட மதிப்பீட்டிற்கு மேலே உள்ள விலை மதிப்பீட்டு கருவியைப் பயன்படுத்தவும்."},{"question":"போக்குவரத்தின் போது எனது சரக்கு காப்பீடு செய்யப்பட்டுள்ளதா?","answer":"ஆம், போக்குவரத்தின் போது உங்கள் சரக்குகளைப் பாதுகாக்க இந்த வழியில் சரக்கு காப்பீடு கிடைக்கிறது."},{"question":"சென்னையிலிருந்து பெங்களூருவிற்கு 1 டன் சுமைக்கு என்ன அளவு LCV தேவை?","answer":"1 டன் சுமை பொதுவாக Tata Ace அல்லது Tata 407 போன்ற நிலையான LCV-க்குப் பொருந்தும். முன்பதிவு செய்யும் போது உங்கள் சுமை விவரங்களை உள்ளிடவும், Vahak சரியான அளவை பரிந்துரைக்கும்."},{"question":"நாளைக்கு பிக்அப்பை திட்டமிட முடியுமா?","answer":"ஆம், அதே நாளில் மட்டுமல்ல, எதிர்கால தேதியிலும் பிக்அப்பை திட்டமிடலாம். சுமையை பதிவிடும்போது உங்களுக்கு விருப்பமான பிக்அப் நேரத்தை அமைக்கவும்."},{"question":"LCV-க்கான அதிகபட்ச சுமை எவ்வளவு?","answer":"இந்த வழியில் பெரும்பாலான LCV கள் 3.5 டன் வரை சுமக்க முடியும். உங்கள் சுமை எடையின் அடிப்படையில் Vahak சரியான வாகன அளவுடன் பொருத்தும்."}],"popularRoutes":[{"label":"சென்னையிலிருந்து ஹைதராபாத்"},{"label":"பெங்களூருவிலிருந்து ஹைதராபாத்"},{"label":"பெங்களூருவிலிருந்து புனே"}],"vehicleTypes":[{"label":"டாடா ஏஸ்"},{"label":"டெம்போ"},{"label":"டாடா 407"},{"label":"பிக்அப்"}]}},"cA":{"chennai":{"seo":{"title":"சென்னையில் LCV முன்பதிவு செய்யுங்கள் | Vahak","description":"நிமிடங்களில் சென்னையில் சரிபார்க்கப்பட்ட LCV முன்பதிவு செய்யுங்கள். நேரடி கண்காணிப்பு, சரக்கு காப்பீடு, மறைமுக கட்டணங்கள் இல்லை."},"pickupCity":"சென்னை","dropPlaceholder":"இறக்கும் இடத்தை உள்ளிடவும்","heroHeadline2Lines":["சென்னை"],"heroSub":"சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள். நேரடி கண்காணிப்பு.","breadcrumbCityName":"சென்னை","trustStrip":"சென்னையில் 8,000+ சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள்","aboutTitle":"சென்னை போக்குவரத்து பற்றி","aboutText":"சென்னை, இந்தியாவின் வாகன உற்பத்தி மையம், வாகனத் துறை, IT சேவைகள், தோல் மற்றும் துறைமுக தளவாடத் துறைகளில் சரக்கு தேவையை அதிகரிக்கிறது. ஸ்ரீபெரும்புதூர் மற்றும் அம்பத்தூர் போன்ற மையங்கள் வழியாக தினமும் அதிக அளவு வாகன பாகங்கள் மற்றும் நெசவு பொருட்களின் அனுப்புகைகள் NH48 மற்றும் NH16 போன்ற சரக்கு பாதைகளுடன் இணைகின்றன.","tags":["வாகன உற்பத்தி","IT சேவைகள்","தோல்","துறைமுகம் மற்றும் கப்பல் போக்குவரத்து"],"proofStats":[{"value":"8,000+","label":"சென்னையில் சரிபார்க்கப்பட்ட போக்குவரத்தாளர்கள்"},{"value":"10 நிமிடங்கள்","label":"LCV முன்பதிவு செய்ய ஆகும் நேரம்"}],"localResources":{"title":"உள்ளூர் தகவல்","dhabas":[{"name":"ஸ்ரீ கிருஷ்ணா இன்","location":"NH44, சூளகிரி, தமிழ்நாடு"}],"contacts":[{"label":"காவல் துறை","number":"100"},{"label":"ஆம்புலன்ஸ்","number":"108"},{"label":"பெருநகர சென்னை போக்குவரத்து உதவி எண்","number":"9003130103"},{"label":"தேசிய நெடுஞ்சாலை உதவி எண்","number":"1033"}],"moreToggle":"பெட்ரோல் பங்க்கள், சர்வீஸ் ஸ்டேஷன்கள், மருத்துவமனைகளைப் பார்க்கவும்","note":"காட்டப்பட்டுள்ள அவசர எண்கள் நிலை/தேசிய நிலையான உதவி எண்கள் — வெளியிடுவதற்கு முன் ஒரு அதிகாரப்பூர்வ ஆதாரத்திலிருந்து சரிபார்க்கவும்."},"faqs":[{"question":"சென்னை நகர எல்லைக்குள் லாரி நுழைவதற்கு கட்டுப்பாடுகள் உள்ளனவா?","answer":"சில உள்நகர சாலைகளில் நெரிசல் நேரங்களில் கனரக வாகனங்களின் நடமாட்டம் கட்டுப்படுத்தப்படுகிறது. Vahak போக்குவரத்தாளர்கள் இந்த விதிகளுக்கு ஏற்ப ஏற்றுதல் மற்றும் இறக்குதல் நேரத்தை தானாகவே திட்டமிடுகிறார்கள்.","defaultOpen":true},{"question":"சென்னையில் LCV விலை எவ்வாறு தீர்மானிக்கப்படுகிறது?","answer":"விலை தூரம், சுமை எடை, வாகன வகை மற்றும் உங்கள் பாதையில் உள்ள தற்போதைய தேவையைப் பொறுத்தது. நீங்கள் உங்கள் சுமையை இலவசமாக பதிவிடலாம் மற்றும் சரிபார்க்கப்பட்ட போக்குவரத்தாளர்களின் ஏலங்களை ஒப்பிடலாம்."},{"question":"எனது முன்பதிவுக்கு GST விலைப்பட்டியல் கிடைக்குமா?","answer":"ஆம், Vahak மூலம் செய்யப்படும் ஒவ்வொரு முன்பதிவுக்கும் GST விலைப்பட்டியல் வழங்கப்படுகிறது, இது உங்கள் சுமை உறுதிப்படுத்தப்பட்டவுடன் தானாகவே உருவாக்கப்படும்."},{"question":"எனது சுமை சரியான நேரத்தில் ஏற்றப்படவில்லை என்றால் என்ன நடக்கும்?","answer":"Vahak இன் ஆதரவுக் குழு ஒவ்வொரு செயலில் உள்ள முன்பதிவையும் கண்காணிக்கிறது, ஏற்றுதல் தாமதமானால் உங்கள் சுமையை மற்றொரு சரிபார்க்கப்பட்ட போக்குவரத்தாளருக்கு மீண்டும் ஒதுக்க தலையிடுகிறது."}],"popularRoutesLabel":"சென்னையிலிருந்து பிரபலமான பாதைகள்","popularRoutes":[{"label":"சென்னை முதல் பெங்களூரு","href":"/lcv-booking/chennai-to-bangalore"},{"label":"சென்னை முதல் ஹைதராபாத்","href":"/lcv-booking/chennai-to-hyderabad"}],"vehicleTypesLabel":"வாகன வகை மூலம் முன்பதிவு செய்யுங்கள்","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak என்பது இந்தியா முழுவதும் உள்ள சரிபார்க்கப்பட்ட போக்குவரத்தாளர்களுடன் ஏற்றுநர்களை இணைக்கும் ஆன்லைன் LCV முன்பதிவு சந்தை. சென்னையில், வணிகங்கள் Vahak ஐப் பயன்படுத்தி பகுதி-சுமை மற்றும் முழு-சுமை LCV அனுப்புகைகளுக்காக Tata Ace, Tempo, Tata 407 மற்றும் Pickup வாகனங்களை முன்பதிவு செய்கின்றன, ஒவ்வொரு முன்பதிவிலும் நேரடி கண்காணிப்பு மற்றும் சரக்கு காப்பீட்டுடன்.","footerGroups":[{"label":"சென்னையிலிருந்து பிரபலமான பாதைகள்","links":[{"label":"சென்னை முதல் பெங்களூரு LCV","href":"/lcv-booking/chennai-to-bangalore"},{"label":"சென்னை முதல் ஹைதராபாத் LCV","href":"/lcv-booking/chennai-to-hyderabad"}],"moreLink":{"label":"அனைத்து பாதைகளையும் காண்க →","href":"/lcv-booking"}},{"label":"மற்ற நகரங்களில் LCV முன்பதிவு செய்யுங்கள்","links":[{"label":"மும்பை","href":"/city/mumbai"},{"label":"டெல்லி","href":"/city/delhi"},{"label":"பெங்களூரு","href":"/city/bangalore"},{"label":"ஹைதராபாத்","href":"/city/hyderabad"}],"moreLink":{"label":"அனைத்து நகரங்களையும் காண்க →","href":"/"}},{"label":"வாகன வகைகள்","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"நிறுவனம்","links":[{"label":"எங்களைப் பற்றி","href":"/about-us"},{"label":"வேலைவாய்ப்புகள்","href":"/careers"},{"label":"எங்களை தொடர்பு கொள்ளுங்கள்","href":"/contact-us"}]},{"label":"சட்டப்பூர்வ","links":[{"label":"விதிமுறைகள் மற்றும் நிபந்தனைகள்","href":"/terms-and-conditions"},{"label":"தனியுரிமைக் கொள்கை","href":"/privacy-policy"},{"label":"அடிக்கடி கேட்கப்படும் கேள்விகள்","href":"/frequently-asked-questions"}]}]}}}');

/***/ }),

/***/ 48737:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Mv":{"TA":{"ahmedabad-to-mumbai":"అహ్మదాబాద్ నుండి ముంబై LCV","bangalore-to-chennai":"బెంగళూరు నుండి చెన్నై LCV","bangalore-to-hyderabad":"బెంగళూరు నుండి హైదరాబాద్ LCV","chennai-to-bangalore":"చెన్నై నుండి బెంగళూరు LCV","chennai-to-hyderabad":"చెన్నై నుండి హైదరాబాద్ LCV","hyderabad-to-bangalore":"హైదరాబాద్ నుండి బెంగళూరు LCV","hyderabad-to-chennai":"హైదరాబాద్ నుండి చెన్నై LCV","delhi-to-jaipur":"ఢిల్లీ నుండి జైపూర్ LCV","delhi-to-kolkata":"ఢిల్లీ నుండి కోల్కతా LCV","delhi-to-mumbai":"ఢిల్లీ నుండి ముంబై LCV","jaipur-to-delhi":"జైపూర్ నుండి ఢిల్లీ LCV","kolkata-to-delhi":"కోల్కతా నుండి ఢిల్లీ LCV","mumbai-to-ahmedabad":"ముంబై నుండి అహ్మదాబాద్ LCV","mumbai-to-delhi":"ముంబై నుండి ఢిల్లీ LCV","mumbai-to-pune":"ముంబై నుండి పూణే LCV","pune-to-mumbai":"పూణే నుండి ముంబై LCV"}},"_j":{"hyderabad-to-bangalore":{"seo":{"title":"హైదరాబాద్ నుండి బెంగళూరుకు LCV బుక్ చేయండి | Vahak","description":"నిమిషాల్లో హైదరాబాద్ నుండి బెంగళూరుకు వెరిఫైడ్ LCV బుక్ చేయండి. లైవ్ ట్రాకింగ్, కార్గో ఇన్సూరెన్స్, ఎలాంటి రహస్య ఛార్జీలు లేవు. ఈ మార్గంలో 500+ వెరిఫైడ్ ట్రాన్స్‌పోర్టర్లు."},"pickupCity":"హైదరాబాద్","dropCity":"బెంగళూరు","heroHeadline2Lines":["హైదరాబాద్ నుండి","బెంగళూరుకు"],"heroSub":"వెరిఫైడ్ ట్రాన్స్‌పోర్టర్లు. లైవ్ ట్రాకింగ్.","breadcrumbRouteName":"హైదరాబాద్ నుండి బెంగళూరుకు","aboutText":"హైదరాబాద్ నుండి బెంగళూరు NH44 మార్గంలో 570 కి.మీ దూరం ఉంటుంది, రోడ్డు మార్గంలో సాధారణంగా 10-12 గంటల్లో చేరుకోవచ్చు. ఇది హైదరాబాద్‌లోని ఫార్మా, ఐటీ మరియు పారిశ్రామిక కేంద్రాలను కర్ణాటకలోని ఎలక్ట్రానిక్స్ మరియు టెక్ తయారీ కేంద్రంతో కలిపే ప్రధాన సరుకు రవాణా మార్గం — ఫార్మా ఉత్పత్తులు, ఎలక్ట్రానిక్స్, టెక్స్‌టైల్స్ మరియు యంత్రాల రవాణాకు సాధారణంగా ఉపయోగిస్తారు.","footerSeoText":"Vahak అనేది భారతదేశవ్యాప్తంగా షిప్పర్లను వెరిఫైడ్ ట్రాన్స్‌పోర్టర్లతో కలిపే ఆన్‌లైన్ LCV బుకింగ్ మార్కెట్‌ప్లేస్. హైదరాబాద్-బెంగళూరు మార్గంలో, వ్యాపారాలు పార్ట్-లోడ్ మరియు ఫుల్-లోడ్ LCV రవాణా కోసం Tata Ace, Tempo, Tata 407 మరియు పికప్ వాహనాలను బుక్ చేయడానికి Vahak ను ఉపయోగిస్తాయి, ప్రతి బుకింగ్‌లో లైవ్ ట్రాకింగ్ మరియు కార్గో ఇన్సూరెన్స్‌తో.","faqs":[{"question":"హైదరాబాద్ నుండి బెంగళూరుకు అదే రోజు LCV అందుబాటులో ఉందా?","answer":"అవును, సాధారణంగా అదే రోజు పికప్ అందుబాటులో ఉంటుంది. ఈ మార్గంలో చాలా బుకింగ్‌లకు 10 నిమిషాల్లో ట్రాన్స్‌పోర్టర్ నిర్ధారించబడతారు.","defaultOpen":true},{"question":"హైదరాబాద్ నుండి బెంగళూరుకు LCV ఖర్చు ఎంత?","answer":"ధరలు లోడ్ బరువు, LCV పరిమాణం మరియు సీజన్‌ను బట్టి మారుతాయి, ఎలాంటి రహస్య ఛార్జీలు లేవు. మీ లోడ్‌కు ప్రత్యేకమైన కోటేషన్ కోసం పైన ఉన్న ధర అంచనా సాధనాన్ని ఉపయోగించండి."},{"question":"రవాణా సమయంలో నా సరుకుకు ఇన్సూరెన్స్ ఉందా?","answer":"అవును, రవాణా సమయంలో మీ సరుకును రక్షించడానికి ఈ మార్గంలో కార్గో ఇన్సూరెన్స్ అందుబాటులో ఉంది."},{"question":"హైదరాబాద్ నుండి బెంగళూరుకు 1 టన్ను లోడ్‌కు ఏ సైజు LCV కావాలి?","answer":"1 టన్ను లోడ్ సాధారణంగా Tata Ace లేదా Tata 407 వంటి ప్రామాణిక LCV కి సరిపోతుంది. బుక్ చేసేటప్పుడు మీ లోడ్ వివరాలను నమోదు చేయండి, Vahak సరైన సైజును సూచిస్తుంది."},{"question":"నేను రేపటికి పికప్ షెడ్యూల్ చేయవచ్చా?","answer":"అవును, అదే రోజు మాత్రమే కాకుండా ఏ భవిష్యత్ తేదీకైనా పికప్ షెడ్యూల్ చేయవచ్చు. లోడ్ పోస్ట్ చేసేటప్పుడు మీకు నచ్చిన పికప్ సమయాన్ని సెట్ చేయండి."},{"question":"LCV కి గరిష్ట పేలోడ్ ఎంత?","answer":"ఈ మార్గంలో చాలా LCV లు 3.5 టన్నుల వరకు మోయగలవు. మీ లోడ్ బరువు ఆధారంగా Vahak సరైన వాహన సైజును సరిపోల్చుతుంది."}],"popularRoutes":[{"label":"హైదరాబాద్ నుండి చెన్నై"},{"label":"బెంగళూరు నుండి చెన్నై"},{"label":"హైదరాబాద్ నుండి పుణె"}],"vehicleTypes":[{"label":"టాటా ఏస్"},{"label":"టెంపో"},{"label":"టాటా 407"},{"label":"పికప్"}]},"hyderabad-to-chennai":{"seo":{"title":"హైదరాబాద్ నుండి చెన్నైకు LCV బుక్ చేయండి | Vahak","description":"నిమిషాల్లో హైదరాబాద్ నుండి చెన్నైకు వెరిఫైడ్ LCV బుక్ చేయండి. లైవ్ ట్రాకింగ్, కార్గో ఇన్సూరెన్స్, ఎలాంటి రహస్య ఛార్జీలు లేవు. ఈ మార్గంలో 500+ వెరిఫైడ్ ట్రాన్స్‌పోర్టర్లు."},"pickupCity":"హైదరాబాద్","dropCity":"చెన్నై","heroHeadline2Lines":["హైదరాబాద్ నుండి","చెన్నైకు"],"heroSub":"వెరిఫైడ్ ట్రాన్స్‌పోర్టర్లు. లైవ్ ట్రాకింగ్.","breadcrumbRouteName":"హైదరాబాద్ నుండి చెన్నై","aboutText":"హైదరాబాద్ నుండి చెన్నై NH16 మార్గంలో 625 కి.మీ దూరం ఉంటుంది, రోడ్డు మార్గంలో సాధారణంగా 10-11 గంటల్లో చేరుకోవచ్చు. ఇది హైదరాబాద్‌లోని ఫార్మా, ఐటీ మరియు పారిశ్రామిక కేంద్రాలను చెన్నైలోని ఆటోమోటివ్ మరియు లెదర్ తయారీ కేంద్రంతో కలిపే ప్రధాన సరుకు రవాణా మార్గం — ఫార్మా, ఎలక్ట్రానిక్స్, ఆటో పార్ట్స్, లెదర్ వస్తువులు మరియు టెక్స్‌టైల్స్ రవాణాకు సాధారణంగా ఉపయోగిస్తారు.","footerSeoText":"Vahak అనేది భారతదేశవ్యాప్తంగా షిప్పర్లను వెరిఫైడ్ ట్రాన్స్‌పోర్టర్లతో కలిపే ఆన్‌లైన్ LCV బుకింగ్ మార్కెట్‌ప్లేస్. హైదరాబాద్-చెన్నై మార్గంలో, వ్యాపారాలు పార్ట్-లోడ్ మరియు ఫుల్-లోడ్ LCV రవాణా కోసం Tata Ace, Tempo, Tata 407 మరియు పికప్ వాహనాలను బుక్ చేయడానికి Vahak ను ఉపయోగిస్తాయి, ప్రతి బుకింగ్‌లో లైవ్ ట్రాకింగ్ మరియు కార్గో ఇన్సూరెన్స్‌తో.","faqs":[{"question":"హైదరాబాద్ నుండి చెన్నైకు అదే రోజు LCV అందుబాటులో ఉందా?","answer":"అవును, సాధారణంగా అదే రోజు పికప్ అందుబాటులో ఉంటుంది. ఈ మార్గంలో చాలా బుకింగ్‌లకు 10 నిమిషాల్లో ట్రాన్స్‌పోర్టర్ నిర్ధారించబడతారు.","defaultOpen":true},{"question":"హైదరాబాద్ నుండి చెన్నైకు LCV ఖర్చు ఎంత?","answer":"ధరలు లోడ్ బరువు, LCV పరిమాణం మరియు సీజన్‌ను బట్టి మారుతాయి, ఎలాంటి రహస్య ఛార్జీలు లేవు. మీ లోడ్‌కు ప్రత్యేకమైన కోటేషన్ కోసం పైన ఉన్న ధర అంచనా సాధనాన్ని ఉపయోగించండి."},{"question":"రవాణా సమయంలో నా సరుకుకు ఇన్సూరెన్స్ ఉందా?","answer":"అవును, రవాణా సమయంలో మీ సరుకును రక్షించడానికి ఈ మార్గంలో కార్గో ఇన్సూరెన్స్ అందుబాటులో ఉంది."},{"question":"హైదరాబాద్ నుండి చెన్నైకు 1 టన్ను లోడ్‌కు ఏ సైజు LCV కావాలి?","answer":"1 టన్ను లోడ్ సాధారణంగా Tata Ace లేదా Tata 407 వంటి ప్రామాణిక LCV కి సరిపోతుంది. బుక్ చేసేటప్పుడు మీ లోడ్ వివరాలను నమోదు చేయండి, Vahak సరైన సైజును సూచిస్తుంది."},{"question":"నేను రేపటికి పికప్ షెడ్యూల్ చేయవచ్చా?","answer":"అవును, అదే రోజు మాత్రమే కాకుండా ఏ భవిష్యత్ తేదీకైనా పికప్ షెడ్యూల్ చేయవచ్చు. లోడ్ పోస్ట్ చేసేటప్పుడు మీకు నచ్చిన పికప్ సమయాన్ని సెట్ చేయండి."},{"question":"LCV కి గరిష్ట పేలోడ్ ఎంత?","answer":"ఈ మార్గంలో చాలా LCV లు 3.5 టన్నుల వరకు మోయగలవు. మీ లోడ్ బరువు ఆధారంగా Vahak సరైన వాహన సైజును సరిపోల్చుతుంది."}],"popularRoutes":[{"label":"హైదరాబాద్ నుండి బెంగళూరు"},{"label":"చెన్నై నుండి బెంగళూరు"},{"label":"హైదరాబాద్ నుండి పుణె"}],"vehicleTypes":[{"label":"టాటా ఏస్"},{"label":"టెంపో"},{"label":"టాటా 407"},{"label":"పికప్"}]}},"cA":{"hyderabad":{"seo":{"title":"హైదరాబాద్‌లో LCV బుక్ చేయండి | Vahak","description":"నిమిషాల్లో హైదరాబాద్‌లో ధృవీకరించబడిన LCV బుక్ చేయండి. లైవ్ ట్రాకింగ్, కార్గో బీమా, ఎలాంటి దాచిన ఛార్జీలు లేవు."},"pickupCity":"హైదరాబాద్","dropPlaceholder":"డ్రాప్ లొకేషన్ నమోదు చేయండి","heroHeadline2Lines":["హైదరాబాద్"],"heroSub":"ధృవీకరించబడిన ట్రాన్స్‌పోర్టర్లు. లైవ్ ట్రాకింగ్.","breadcrumbCityName":"హైదరాబాద్","trustStrip":"హైదరాబాద్‌లో 9,000+ ధృవీకరించబడిన ట్రాన్స్‌పోర్టర్లు","aboutTitle":"హైదరాబాద్ రవాణా గురించి","aboutText":"హైదరాబాద్, భారతదేశపు ఫార్మా మరియు IT హబ్, ఫార్మాస్యూటికల్స్, IT సేవలు, ఏరోస్పేస్ మరియు చలనచిత్ర నిర్మాణ రంగాలలో సరుకు రవాణా డిమాండ్‌ను పెంచుతుంది. హైటెక్ సిటీ మరియు జీనోమ్ వ్యాలీ వంటి కేంద్రాల ద్వారా రోజూ పెద్ద మొత్తంలో ఫార్మా మరియు ఎలక్ట్రానిక్స్ షిప్‌మెంట్లు NH44 మరియు NH65 వంటి ఫ్రైట్ కారిడార్లతో అనుసంధానమవుతాయి.","tags":["ఫార్మాస్యూటికల్స్","IT సేవలు","ఏరోస్పేస్ మరియు రక్షణ","చలనచిత్ర నిర్మాణం"],"proofStats":[{"value":"9,000+","label":"హైదరాబాద్‌లో ధృవీకరించబడిన ట్రాన్స్‌పోర్టర్లు"},{"value":"10 నిమిషాలు","label":"LCV బుక్ చేయడానికి సమయం"}],"localResources":{"title":"స్థానిక సమాచారం","dhabas":[{"name":"7 ఫుడ్ కోర్ట్","location":"NH65, నల్గొండ, తెలంగాణ"}],"contacts":[{"label":"పోలీసు","number":"100"},{"label":"అంబులెన్స్","number":"108"},{"label":"హైదరాబాద్ ట్రాఫిక్ హెల్ప్‌లైన్","number":"9010203626"},{"label":"తెలంగాణ రవాణా శాఖ","number":"1800-425-1110"},{"label":"జాతీయ రహదారి హెల్ప్‌లైన్","number":"1033"}],"moreToggle":"పెట్రోల్ బంకులు, సర్వీస్ స్టేషన్లు, ఆసుపత్రులు చూడండి","note":"చూపిన అత్యవసర నంబర్లు ప్రామాణిక రాష్ట్ర/జాతీయ హెల్ప్‌లైన్లు — ప్రచురించే ముందు అధికారిక మూలం నుండి ధృవీకరించండి."},"faqs":[{"question":"హైదరాబాద్ నగర పరిమితుల్లో ట్రక్కు ప్రవేశంపై ఆంక్షలు ఉన్నాయా?","answer":"కొన్ని లోపలి నగర రహదారుల్లో పీక్ అవర్స్‌లో భారీ వాహనాల రాకపోకలపై ఆంక్షలు ఉంటాయి. Vahak ట్రాన్స్‌పోర్టర్లు ఈ నియమాల ప్రకారం పికప్ మరియు డ్రాప్ సమయాన్ని ఆటోమేటిక్‌గా ప్లాన్ చేస్తారు.","defaultOpen":true},{"question":"హైదరాబాద్‌లో LCV ధర ఎలా నిర్ణయించబడుతుంది?","answer":"ధర దూరం, లోడ్ బరువు, వాహన రకం మరియు మీ మార్గంలో ప్రస్తుత డిమాండ్‌పై ఆధారపడి ఉంటుంది. మీరు మీ లోడ్‌ను ఉచితంగా పోస్ట్ చేయవచ్చు మరియు ధృవీకరించబడిన ట్రాన్స్‌పోర్టర్ల బిడ్‌లను పోల్చవచ్చు."},{"question":"నా బుకింగ్ కోసం నాకు GST ఇన్వాయిస్ లభిస్తుందా?","answer":"అవును, Vahak ద్వారా చేసిన ప్రతి బుకింగ్‌కు GST ఇన్వాయిస్ అందించబడుతుంది, ఇది మీ లోడ్ నిర్ధారించిన వెంటనే స్వయంచాలకంగా రూపొందించబడుతుంది."},{"question":"నా లోడ్ సమయానికి పికప్ కాకపోతే ఏమి జరుగుతుంది?","answer":"Vahak సపోర్ట్ టీమ్ ప్రతి యాక్టివ్ బుకింగ్‌ను పర్యవేక్షిస్తుంది మరియు పికప్ ఆలస్యమైతే మీ లోడ్‌ను మరొక ధృవీకరించబడిన ట్రాన్స్‌పోర్టర్‌కు తిరిగి కేటాయించడానికి జోక్యం చేసుకుంటుంది."}],"popularRoutesLabel":"హైదరాబాద్ నుండి ప్రసిద్ధ మార్గాలు","popularRoutes":[{"label":"హైదరాబాద్ నుండి బెంగళూరు","href":"/lcv-booking/hyderabad-to-bangalore"},{"label":"హైదరాబాద్ నుండి చెన్నై","href":"/lcv-booking/hyderabad-to-chennai"}],"vehicleTypesLabel":"వాహన రకం ప్రకారం బుక్ చేయండి","vehicleTypes":[{"label":"Tata Ace"},{"label":"Tempo"},{"label":"Tata 407"},{"label":"Pickup"}],"footerSeoText":"Vahak అనేది భారతదేశం అంతటా ధృవీకరించబడిన ట్రాన్స్‌పోర్టర్లతో షిప్పర్లను కలిపే ఆన్‌లైన్ LCV బుకింగ్ మార్కెట్‌ప్లేస్. హైదరాబాద్‌లో, వ్యాపారాలు Vahak ఉపయోగించి పార్ట్-లోడ్ మరియు ఫుల్-లోడ్ LCV షిప్‌మెంట్ల కోసం Tata Ace, Tempo, Tata 407 మరియు Pickup వాహనాలను బుక్ చేస్తారు, ప్రతి బుకింగ్‌లో లైవ్ ట్రాకింగ్ మరియు కార్గో బీమాతో.","footerGroups":[{"label":"హైదరాబాద్ నుండి ప్రసిద్ధ మార్గాలు","links":[{"label":"హైదరాబాద్ నుండి బెంగళూరు LCV","href":"/lcv-booking/hyderabad-to-bangalore"},{"label":"హైదరాబాద్ నుండి చెన్నై LCV","href":"/lcv-booking/hyderabad-to-chennai"}],"moreLink":{"label":"అన్ని మార్గాలను చూడండి →","href":"/lcv-booking"}},{"label":"ఇతర నగరాల్లో LCV బుక్ చేయండి","links":[{"label":"ముంబై","href":"/city/mumbai"},{"label":"ఢిల్లీ","href":"/city/delhi"},{"label":"బెంగళూరు","href":"/city/bangalore"},{"label":"కోల్‌కతా","href":"/city/kolkata"}],"moreLink":{"label":"అన్ని నగరాలను చూడండి →","href":"/"}},{"label":"వాహన రకాలు","textItems":["Tata Ace","Tempo","Tata 407","Pickup"]},{"label":"కంపెనీ","links":[{"label":"మా గురించి","href":"/about-us"},{"label":"కెరీర్‌లు","href":"/careers"},{"label":"సంప్రదించండి","href":"/contact-us"}]},{"label":"చట్టపరమైన","links":[{"label":"నిబంధనలు మరియు షరతులు","href":"/terms-and-conditions"},{"label":"గోప్యతా విధానం","href":"/privacy-policy"},{"label":"తరచుగా అడిగే ప్రశ్నలు","href":"/frequently-asked-questions"}]}]}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ /* webpack/runtime/startup prefetch */
/******/ !function() {
/******/ 	__webpack_require__.O(0, [2888], function() {
/******/ 		__webpack_require__.E(5606);
/******/ 	}, 5);
/******/ }();
/******/ 
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);